import Nb from "./mockListe.esm.js";
import Tb from "./mockDetaljert.esm.js";
import * as fe from "react";
import JA, { createContext as Qn, forwardRef as At, useContext as t0, useLayoutEffect as Jh, useState as Jt, useEffect as Wt, useRef as An, useCallback as Wh, useMemo as Pb, Fragment as Zh } from "react";
import * as zb from "react-dom";
import jb, { createPortal as Vb } from "react-dom";
function Ob(e, A) {
  for (var t = 0; t < A.length; t++) {
    const r = A[t];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const n in r)
        if (n !== "default" && !(n in e)) {
          const i = Object.getOwnPropertyDescriptor(r, n);
          i && Object.defineProperty(e, n, i.get ? i : {
            enumerable: !0,
            get: () => r[n]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ht(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Jb(e) {
  if (e.__esModule) return e;
  var A = e.default;
  if (typeof A == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(A, arguments, this.constructor) : A.apply(this, arguments);
    };
    t.prototype = A.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), t;
}
var tf, XQ;
function Wb() {
  return XQ || (XQ = 1, tf = function(e, A) {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    for (var t = String(e), r = "", n = A ? !!A.extended : !1, i = A ? !!A.globstar : !1, a = !1, o = A && typeof A.flags == "string" ? A.flags : "", s, l = 0, u = t.length; l < u; l++)
      switch (s = t[l], s) {
        case "/":
        case "$":
        case "^":
        case "+":
        case ".":
        case "(":
        case ")":
        case "=":
        case "!":
        case "|":
          r += "\\" + s;
          break;
        case "?":
          if (n) {
            r += ".";
            break;
          }
        case "[":
        case "]":
          if (n) {
            r += s;
            break;
          }
        case "{":
          if (n) {
            a = !0, r += "(";
            break;
          }
        case "}":
          if (n) {
            a = !1, r += ")";
            break;
          }
        case ",":
          if (a) {
            r += "|";
            break;
          }
          r += "\\" + s;
          break;
        case "*":
          for (var g = t[l - 1], d = 1; t[l + 1] === "*"; )
            d++, l++;
          var h = t[l + 1];
          if (!i)
            r += ".*";
          else {
            var C = d > 1 && (g === "/" || g === void 0) && (h === "/" || h === void 0);
            C ? (r += "((?:[^/]*(?:/|$))*)", l++) : r += "([^/]*)";
          }
          break;
        default:
          r += s;
      }
    return (!o || !~o.indexOf("g")) && (r = "^" + r + "$"), new RegExp(r, o);
  }), tf;
}
var Zb = Wb();
const Kb = /* @__PURE__ */ Ht(Zb);
function _b(e, A) {
  if (e instanceof RegExp) return { keys: !1, pattern: e };
  var t, r, n, i, a = [], o = "", s = e.split("/");
  for (s[0] || s.shift(); n = s.shift(); )
    t = n[0], t === "*" ? (a.push(t), o += n[1] === "?" ? "(?:/(.*))?" : "/(.*)") : t === ":" ? (r = n.indexOf("?", 1), i = n.indexOf(".", 1), a.push(n.substring(1, ~r ? r : ~i ? i : n.length)), o += ~r && !~i ? "(?:/([^/]+?))?" : "/([^/]+?)", ~i && (o += (~r ? "?" : "") + "\\" + n.substring(i))) : o += "/" + n;
  return {
    keys: a,
    pattern: new RegExp("^" + o + "/?$", "i")
  };
}
var Rs = {}, Gs = {}, qQ;
function Xb() {
  if (qQ) return Gs;
  qQ = 1, Object.defineProperty(Gs, "__esModule", { value: !0 }), Gs.Type = void 0;
  const e = /* @__PURE__ */ new Set(["boolean", "number", "null", "string", "undefined"]), A = /* @__PURE__ */ new Set(["array", "function", "object", "symbol"]), t = /* @__PURE__ */ new Set(["boolean", "function", "number", "string", "symbol"]), r = /* @__PURE__ */ new Set([Boolean, Number, String]);
  let n = class Tt {
    constructor(a) {
      this.name = Tt.of(a), this.isValueType = Tt.isValueType(a), this.isReferenceType = Tt.isReferenceType(a), this.isArray = Tt.isArray(a), this.isBoolean = Tt.isBoolean(a), this.isFunction = Tt.isFunction(a), this.isNull = Tt.isNull(a), this.isNumber = Tt.isNumber(a), this.isObject = Tt.isObject(a), this.isString = Tt.isString(a), this.isSymbol = Tt.isSymbol(a), this.isUndefined = Tt.isUndefined(a);
    }
    static of(a) {
      if (a === null)
        return "null";
      if (a === void 0)
        return "undefined";
      const o = typeof a;
      if (t.has(o))
        return o;
      if (o === "object")
        return Array.isArray(a) ? "array" : r.has(a.constructor) ? a.constructor.name.toLowerCase() : o;
      throw new Error("Failed due to an unknown type.");
    }
    static from(a) {
      return new Tt(a);
    }
    static isValueType(a) {
      return e.has(Tt.of(a));
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    static isReferenceType(a) {
      return A.has(Tt.of(a));
    }
    static isArray(a) {
      return Tt.of(a) === "array";
    }
    static isBoolean(a) {
      return Tt.of(a) === "boolean";
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    static isFunction(a) {
      return Tt.of(a) === "function";
    }
    static isNull(a) {
      return Tt.of(a) === "null";
    }
    static isNumber(a) {
      return Tt.of(a) === "number";
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    static isObject(a) {
      return Tt.of(a) === "object";
    }
    static isString(a) {
      return Tt.of(a) === "string";
    }
    static isSymbol(a) {
      return Tt.of(a) === "symbol";
    }
    static isUndefined(a) {
      return Tt.of(a) === "undefined";
    }
  };
  return Gs.Type = n, Gs;
}
var $Q;
function qb() {
  if ($Q) return Rs;
  $Q = 1, Object.defineProperty(Rs, "__esModule", { value: !0 }), Rs.isSubsetOf = void 0;
  const e = Xb(), A = /* @__PURE__ */ new Set(["array", "object", "function", "null"]), t = function(r, n, i = []) {
    const a = e.Type.of(r), o = e.Type.of(n);
    if (!A.has(a))
      throw new Error(`Type '${a}' is not supported.`);
    if (!A.has(o))
      throw new Error(`Type '${o}' is not supported.`);
    if (e.Type.isFunction(r)) {
      if (!e.Type.isFunction(n))
        throw new Error(`Types '${a}' and '${o}' do not match.`);
      return r.toString() === n.toString();
    }
    if (e.Type.isArray(r)) {
      if (!e.Type.isArray(n))
        throw new Error(`Types '${a}' and '${o}' do not match.`);
      if (r.length > n.length)
        return !1;
      for (const s of r) {
        const l = e.Type.of(s);
        let u;
        switch (l) {
          case "array":
          case "object":
          case "function": {
            if (i.includes(s))
              continue;
            i.push(s), u = n.some((g) => {
              try {
                return t(s, g, i);
              } catch {
                return !1;
              }
            });
            break;
          }
          default:
            u = n.includes(s);
        }
        if (!u)
          return !1;
      }
      return !0;
    }
    if (e.Type.isObject(r)) {
      if (!e.Type.isObject(n) || e.Type.isArray(n))
        throw new Error(`Types '${a}' and '${o}' do not match.`);
      if (Object.keys(r).length > Object.keys(n).length)
        return !1;
      for (const [s, l] of Object.entries(r)) {
        const u = n[s];
        switch (e.Type.of(l)) {
          case "array":
          case "object":
          case "function": {
            if (i.includes(l))
              continue;
            i.push(l);
            try {
              if (!t(l, u, i))
                return !1;
            } catch {
              return !1;
            }
            break;
          }
          default:
            if (l !== u)
              return !1;
        }
      }
      return !0;
    }
    if (e.Type.isNull(r)) {
      if (!e.Type.isNull(n))
        throw new Error(`Types '${a}' and '${o}' do not match.`);
      return !0;
    }
    throw new Error("Invalid operation.");
  };
  return Rs.isSubsetOf = t, t.structural = function(r, n, i = []) {
    if (!e.Type.isObject(r))
      throw new Error(`Type '${e.Type.of(r)}' is not supported.`);
    if (!e.Type.isObject(n))
      throw new Error(`Type '${e.Type.of(n)}' is not supported.`);
    for (const [a, o] of Object.entries(r)) {
      if (n[a] === void 0)
        return !1;
      const s = e.Type.of(o), l = n[a];
      if (s === "object") {
        if (i.includes(o))
          continue;
        i.push(o);
        try {
          if (!t.structural(o, l, i))
            return !1;
        } catch {
          return !1;
        }
      }
    }
    return !0;
  }, Rs;
}
var $b = qb(), A1 = Object.prototype.hasOwnProperty;
function e1(e, A, t) {
  for (t of e.keys())
    if (Yo(t, A)) return t;
}
function Yo(e, A) {
  var t, r, n;
  if (e === A) return !0;
  if (e && A && (t = e.constructor) === A.constructor) {
    if (t === Date) return e.getTime() === A.getTime();
    if (t === RegExp) return e.toString() === A.toString();
    if (t === Array) {
      if ((r = e.length) === A.length)
        for (; r-- && Yo(e[r], A[r]); ) ;
      return r === -1;
    }
    if (t === Set) {
      if (e.size !== A.size)
        return !1;
      for (r of e)
        if (n = r, n && typeof n == "object" && (n = e1(A, n), !n) || !A.has(n)) return !1;
      return !0;
    }
    if (t === Map) {
      if (e.size !== A.size)
        return !1;
      for (r of e)
        if (n = r[0], n && typeof n == "object" && (n = e1(A, n), !n) || !Yo(r[1], A.get(n)))
          return !1;
      return !0;
    }
    if (t === ArrayBuffer)
      e = new Uint8Array(e), A = new Uint8Array(A);
    else if (t === DataView) {
      if ((r = e.byteLength) === A.byteLength)
        for (; r-- && e.getInt8(r) === A.getInt8(r); ) ;
      return r === -1;
    }
    if (ArrayBuffer.isView(e)) {
      if ((r = e.byteLength) === A.byteLength)
        for (; r-- && e[r] === A[r]; ) ;
      return r === -1;
    }
    if (!t || typeof e == "object") {
      r = 0;
      for (t in e)
        if (A1.call(e, t) && ++r && !A1.call(A, t) || !(t in A) || !Yo(e[t], A[t])) return !1;
      return Object.keys(A).length === r;
    }
  }
  return e !== e && A !== A;
}
const Dg = new RegExp("^[a-z]+://|^data:", "i"), A3 = new RegExp("^//", "i");
function e3(e) {
  const A = new URL(e, Dg.test(e) ? void 0 : "http://dummy");
  return !!(A.username || A.password);
}
function Nc(e, A) {
  if (e instanceof URL)
    return e.href;
  const t = String(e).valueOf();
  if (Dg.test(t))
    return new URL(t).href;
  if (A3.test(t))
    return new URL(t, "http://dummy").href.replace(/^[a-z]+:/, "");
  if ("location" in globalThis)
    return t.startsWith("/") ? `${globalThis.location.origin}${t}` : `${globalThis.location.href}/${t}`;
  if (A) {
    const r = new URL(t, "http://dummy");
    return r.pathname + r.search;
  } else
    throw new Error("Relative urls are not support by default in node.js tests. Either use a utility such as jsdom to define globalThis.location or set `fetchMock.config.allowRelativeUrls = true`");
}
function UD(e, A) {
  const t = [];
  if (typeof e == "string" || e instanceof String || e instanceof URL) {
    const r = Nc(e, !0), n = A ? { ...A } : {};
    return n.headers && (n.headers = ll(n.headers)), n.method = n.method ? n.method.toLowerCase() : "get", {
      args: [e, A],
      url: r,
      queryParams: new URLSearchParams(YD(r)),
      options: n,
      signal: n.signal,
      pendingPromises: t
    };
  }
  throw typeof e == "object" ? new TypeError("fetch-mock: Unrecognised Request object. Read the Config and Installation sections of the docs") : new TypeError("fetch-mock: Invalid arguments passed to fetch");
}
async function t3(e, A) {
  const t = [], r = {
    method: e.method
  };
  try {
    r.body = await e.clone().text();
  } catch {
  }
  e.headers && (r.headers = ll(e.headers));
  const n = Nc(e.url, !0);
  return {
    args: [e, A],
    url: n,
    queryParams: new URLSearchParams(YD(n)),
    options: Object.assign(r, A || {}),
    request: e,
    signal: A && A.signal || e.signal,
    pendingPromises: t
  };
}
function Xs(e) {
  return (Dg.test(e) ? new URL(e) : new URL(e, "http://dummy")).pathname;
}
function YD(e) {
  const A = Dg.test(e) ? new URL(e) : new URL(e, "http://dummy");
  return A.search ? A.search.substr(1) : "";
}
function ll(e) {
  let A;
  return e instanceof Headers ? A = [...e.entries()] : Array.isArray(e) ? A = e : A = Object.entries(e), Object.fromEntries(A.map(([t, r]) => [t.toLowerCase(), String(r).valueOf()]));
}
const HD = (e) => e instanceof RegExp || typeof e == "string" || typeof e == "object" && "href" in e, r3 = (e) => typeof e == "function", bu = {
  begin: (e) => ({ url: A }) => A.startsWith(e),
  end: (e) => ({ url: A }) => A.endsWith(e),
  include: (e) => ({ url: A }) => A.includes(e),
  glob: (e) => {
    const A = Kb(e);
    return ({ url: t }) => A.test(t);
  },
  express: (e) => {
    const A = _b(e);
    return (t) => {
      const r = A.pattern.exec(Xs(t.url));
      return r ? (r.shift(), t.expressParams = A.keys.reduce((n, i, a) => r[a] ? Object.assign(n, { [i]: r[a] }) : n, {}), !0) : (t.expressParams = {}, !1);
    };
  },
  path: (e) => {
    const A = Xs(e);
    return ({ url: t }) => {
      const r = Xs(t);
      return r === e || r === A;
    };
  }
}, n3 = ({ headers: e }) => {
  if (!e)
    return;
  const A = ll(e);
  return ({ options: { headers: t = {} } }) => {
    const r = ll(t);
    return Object.keys(A).every((n) => r[n] === A[n]);
  };
}, i3 = ({ missingHeaders: e }) => {
  if (!e)
    return;
  const A = e.map((t) => t.toLowerCase());
  return ({ options: { headers: t = {} } }) => {
    const r = ll(t);
    return A.every((n) => !(n in r));
  };
}, a3 = ({ method: e }) => {
  if (e)
    return ({ options: { method: A } = {} }) => {
      const t = A ? A.toLowerCase() : "get";
      return e === t;
    };
}, o3 = ({ query: e }) => {
  if (!e)
    return;
  const A = new URLSearchParams();
  for (const [r, n] of Object.entries(e))
    if (Array.isArray(n))
      for (const i of n)
        A.append(r, typeof i == "object" || typeof i > "u" ? "" : i.toString());
    else
      A.append(r, typeof n == "object" || typeof n > "u" ? "" : n.toString());
  const t = Array.from(A.keys());
  return ({ queryParams: r }) => t.every((n) => {
    const i = A.getAll(n).sort(), a = r.getAll(n).sort();
    return i.length !== a.length ? !1 : Array.isArray(e[n]) ? i.every((o, s) => o === a[s]) : Yo(a, i);
  });
}, s3 = ({ params: e, url: A }) => {
  if (!e)
    return;
  if (!(typeof A == "string" && /express:/.test(A)))
    throw new Error("fetch-mock: matching on params is only possible when using an express: matcher");
  const t = Object.keys(e);
  return ({ expressParams: r = {} }) => t.every((n) => r[n] === e[n]);
}, l3 = (e) => {
  const { body: A } = e;
  if (A)
    return ({ options: { body: t, method: r = "get" } }) => {
      if (["get", "head", "delete"].includes(r.toLowerCase()))
        return !1;
      let n;
      try {
        typeof t == "string" && (n = JSON.parse(t));
      } catch {
      }
      return n && (e.matchPartialBody ? $b.isSubsetOf(A, n) : Yo(A, n));
    };
}, u3 = ({ matcherFunction: e }) => e, t1 = (e) => ({ url: A }) => e.test(A), r1 = (e, A, t) => {
  const r = Nc(A, e.allowRelativeUrls);
  return e.url === A && (e.url = r), ({ url: n }) => t && r.indexOf("?") ? Xs(n) === Xs(r) : Nc(n, !0) === r;
}, c3 = (e) => {
  const { url: A, query: t } = e;
  if (A === "*")
    return () => !0;
  if (A instanceof RegExp)
    return t1(A);
  if (A instanceof URL && A.href)
    return r1(e, A.href, t);
  if (typeof A == "string") {
    for (const r in bu)
      if (A.indexOf(`${r}:`) === 0) {
        const n = A.replace(new RegExp(`^${r}:`), "");
        return bu[r](n);
      }
    return r1(e, A, t);
  }
  if (typeof A == "object") {
    const r = Object.entries(A).map(([n, i]) => {
      if (n === "regexp")
        return t1(i);
      if (n in bu)
        return bu[n](i);
      throw new Error(`unrecognised url matching pattern: ${n}`);
    });
    return (n) => r.every((i) => i(n));
  }
}, g3 = [
  { name: "url", matcher: c3 },
  { name: "query", matcher: o3 },
  { name: "method", matcher: a3 },
  { name: "headers", matcher: n3 },
  { name: "missingHeaders", matcher: i3 },
  { name: "params", matcher: s3 },
  { name: "body", matcher: l3, usesBody: !0 },
  { name: "matcherFunction", matcher: u3 }
], B3 = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  451: "Unavailable For Legal Reasons",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
var xs = function(e, A, t, r) {
  if (t === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof A == "function" ? e !== A || !r : !A.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? r : t === "a" ? r.call(e) : r ? r.value : A.get(e);
}, Da, Bc, SD, ND, TD, PD, zD;
function f3(e) {
  return e instanceof Blob || e instanceof ArrayBuffer || ArrayBuffer.isView(e) || e instanceof DataView || e instanceof FormData || e instanceof ReadableStream || e instanceof URLSearchParams || e instanceof String || typeof e == "string" || e === null;
}
function d3(e) {
  if (e === 0 || !e)
    return 200;
  if (typeof e == "number" && parseInt(String(e), 10) !== e && e >= 200 || e < 600)
    return e;
  throw new TypeError(`fetch-mock: Invalid status ${e} passed on response object.
To respond with a JSON object that has status as a property assign the object to body
e.g. {"body": {"status: "registered"}}`);
}
class Va {
  constructor(A) {
    Da.add(this), this.config = A, xs(this, Da, "m", ND).call(this), xs(this, Da, "m", SD).call(this), xs(this, Da, "m", TD).call(this), xs(this, Da, "m", PD).call(this), xs(this, Da, "m", zD).call(this);
  }
  reset() {
  }
  constructResponse(A) {
    const t = this.constructResponseOptions(A), r = this.constructResponseBody(A, t);
    return {
      response: new this.config.Response(r, t),
      responseOptions: t,
      responseInput: A
    };
  }
  constructResponseOptions(A) {
    const t = A.options || {};
    return t.status = d3(A.status), t.statusText = B3[t.status], t.headers = new this.config.Headers(A.headers), t;
  }
  constructResponseBody(A, t) {
    let r = A.body;
    if (!f3(r))
      if (typeof r > "u")
        r = null;
      else if (typeof r == "object")
        r = JSON.stringify(r), t.headers.has("Content-Type") || t.headers.set("Content-Type", "application/json");
      else
        throw new TypeError("Invalid body provided to construct response");
    if (this.config.includeContentLength && !t.headers.has("Content-Length") && !(r instanceof ReadableStream) && !(r instanceof FormData)) {
      let i = 0;
      r instanceof Blob ? i = r.size : r instanceof ArrayBuffer || ArrayBuffer.isView(r) || r instanceof DataView ? i = r.byteLength : r instanceof URLSearchParams ? i = r.toString().length : (typeof r == "string" || r instanceof String) && (i = r.length), t.headers.set("Content-Length", i.toString());
    }
    return r;
  }
  static defineMatcher(A) {
    Bc.registeredMatchers.push(A);
  }
}
Bc = Va, Da = /* @__PURE__ */ new WeakSet(), SD = function() {
  if (["matched", "unmatched"].includes(this.config.name))
    throw new Error(`fetch-mock: Routes cannot use the reserved name \`${this.config.name}\``);
  if (!("response" in this.config))
    throw new Error("fetch-mock: Each route must define a response");
  if (!Bc.registeredMatchers.some(({ name: A }) => A in this.config))
    throw new Error("fetch-mock: Each route must specify some criteria for matching calls to fetch. To match all calls use '*'");
}, ND = function() {
  this.config.method && (this.config.method = this.config.method.toLowerCase());
}, TD = function() {
  const A = Bc.registeredMatchers.filter(({ name: t }) => t in this.config).map(({ matcher: t, usesBody: r }) => ({
    matcher: t(this.config),
    usesBody: r
  }));
  this.config.usesBody = A.some(({ usesBody: t }) => t), this.matcher = (t) => A.every(({ matcher: r }) => r(t));
}, PD = function() {
  if (!this.config.repeat)
    return;
  const A = this.matcher;
  let t = this.config.repeat;
  this.matcher = (r) => {
    if (t && A(r))
      return t--, !0;
  }, this.reset = () => {
    t = this.config.repeat;
  };
}, zD = function() {
  if (this.config.delay) {
    const { response: A } = this.config;
    this.config.response = () => new Promise((t) => setTimeout(() => t(A), this.config.delay));
  }
};
Va.registeredMatchers = [];
g3.forEach(Va.defineMatcher);
const n1 = [
  "body",
  "headers",
  "throws",
  "status",
  "redirectUrl"
];
function h3(e) {
  return typeof e == "string" ? { name: e } : e;
}
function C3(e) {
  return typeof e.then == "function";
}
function E3(e) {
  return typeof e == "number" ? {
    status: e
  } : typeof e == "string" || Q3(e) ? {
    body: e
  } : e;
}
function Q3(e) {
  return n1.some((A) => A in e) ? !Object.keys(e).every((A) => n1.includes(A)) : !0;
}
function w3({ url: e, options: { headers: A, method: t, body: r } }) {
  if (A && Object.entries(A).forEach(([n]) => {
    if (/\s/.test(n))
      throw new TypeError("Invalid name");
  }), e3(e))
    throw new TypeError(`Request cannot be constructed from a URL that includes credentials: ${e}`);
  if (["get", "head"].includes(t) && r)
    throw new TypeError("Request with GET/HEAD method cannot have body.");
}
const I3 = async (e) => {
  let A = e.route.config.response;
  for (; ; )
    if (typeof A == "function")
      A = A(e);
    else if (C3(A))
      A = await A;
    else
      return A;
};
class D3 {
  constructor(A, { routes: t, fallbackRoute: r } = {}) {
    this.config = A, this.routes = t || [], this.fallbackRoute = r;
  }
  needsToReadBody(A) {
    return !!(A && this.routes.some((t) => t.config.usesBody));
  }
  execute(A) {
    return w3(A), new Promise(async (t, r) => {
      const { url: n, options: i, request: a, pendingPromises: o } = A;
      if (A.signal) {
        const u = () => {
          var h;
          const g = new DOMException("The operation was aborted.", "AbortError"), d = (a == null ? void 0 : a.body) || (i == null ? void 0 : i.body);
          d instanceof ReadableStream && d.cancel(g), (h = A == null ? void 0 : A.response) != null && h.body && A.response.body.cancel(g), r(g);
        };
        A.signal.aborted && u(), A.signal.addEventListener("abort", u);
      }
      this.needsToReadBody(a) && (i.body = await i.body);
      const l = (this.fallbackRoute ? [...this.routes, this.fallbackRoute] : this.routes).find((u) => u.matcher(A));
      if (l)
        try {
          A.route = l;
          const { response: u, responseOptions: g, responseInput: d } = await this.generateResponse(A), h = this.createObservableResponse(u, g, d, n, o);
          A.response = u, t(h);
        } catch (u) {
          r(u);
        }
      else
        r(new Error(`fetch-mock: No response or fallback rule to cover ${i && i.method || "GET"} to ${n}`));
    });
  }
  async generateResponse(A) {
    const t = await I3(A);
    if (t instanceof Response)
      return {
        response: t,
        responseOptions: {},
        responseInput: {}
      };
    const r = E3(t);
    if (r.throws)
      throw r.throws;
    return A.route.constructResponse(r);
  }
  createObservableResponse(A, t, r, n, i) {
    return new Proxy(A, {
      get: (a, o) => {
        if (r.redirectUrl) {
          if (o === "url")
            return r.redirectUrl;
          if (o === "redirected")
            return !0;
        } else {
          if (o === "url")
            return n;
          if (o === "redirected")
            return !1;
        }
        if (r.status === 0) {
          if (o === "status")
            return 0;
          if (o === "statusText")
            return "";
        }
        return typeof A[o] == "function" ? new Proxy(A[o], {
          apply: (s, l, u) => {
            const g = s.apply(A, u);
            return g.then && i.push(g.catch(() => {
            })), g;
          }
        }) : a[o];
      }
    });
  }
  addRoute(A, t, r) {
    const n = {};
    HD(A) ? n.url = A : r3(A) ? n.matcherFunction = A : Object.assign(n, A), typeof t < "u" && (n.response = t), r && Object.assign(n, typeof r == "string" ? h3(r) : r);
    const i = new Va({
      ...this.config,
      ...n
    });
    if (i.config.name && this.routes.some(({ config: { name: a } }) => i.config.name === a))
      throw new Error("fetch-mock: Adding route with same name as existing route.");
    this.routes.push(i);
  }
  setFallback(A) {
    this.fallbackRoute && console.warn("calling fetchMock.catch() twice - are you sure you want to overwrite the previous fallback response"), this.fallbackRoute = new Va({
      matcherFunction: () => !0,
      response: A || "ok",
      ...this.config
    }), this.fallbackRoute.config.isFallback = !0;
  }
  removeRoutes({ names: A, includeSticky: t, includeFallback: r } = {}) {
    r = r ?? !0, this.routes = this.routes.filter(({ config: { sticky: n, name: i } }) => n && !t ? !0 : A ? !A.includes(i) : !1), r && delete this.fallbackRoute;
  }
}
const m3 = (e) => typeof e == "string" && /^[\da-zA-Z-]+$/.test(e) && !["matched", "unmatched"].includes(e), M3 = (e) => typeof e == "boolean" || ["matched", "unmatched"].includes(e);
class p3 {
  constructor(A, t) {
    this.callLogs = [], this.config = A, this.router = t;
  }
  recordCall(A) {
    this.callLogs.push(A);
  }
  clear() {
    this.callLogs.forEach(({ route: A }) => {
      A && A.reset();
    }), this.callLogs = [];
  }
  async flush(A) {
    const t = this.callLogs.flatMap((r) => r.pendingPromises);
    await Promise.allSettled(t), A && (await Promise.resolve(), await this.flush());
  }
  calls(A, t) {
    let r = [...this.callLogs];
    if (typeof A > "u" && !t)
      return r;
    if (M3(A)) {
      if ([!0, "matched"].includes(A) ? r = r.filter(({ route: i }) => !i.config.isFallback) : [!1, "unmatched"].includes(A) && (r = r.filter(({ route: i }) => !!i.config.isFallback)), !t)
        return r;
    } else if (m3(A)) {
      if (r = r.filter(({ route: { config: { name: i } } }) => i === A), !t)
        return r;
    } else
      HD(A) ? t = { url: A, ...t || {} } : t = { ...A, ...t || {} };
    const { matcher: n } = new Va({
      response: "ok",
      ...t
    });
    return r = r.filter(({ url: i, options: a }) => n(UD(i, a))), r;
  }
  called(A, t) {
    return !!this.calls(A, t).length;
  }
  lastCall(A, t) {
    return this.calls(A, t).pop();
  }
  done(A) {
    let t = this.router.routes;
    return A && (A = Array.isArray(A) ? A : [A], t = this.router.routes.filter(({ config: { name: r } }) => A.includes(r))), t.map((r) => {
      const n = this.callLogs.filter(({ route: o }) => o === r);
      if (!n.length)
        return console.warn(`Warning: ${r.config.name} not called`), !1;
      const i = r.config.repeat;
      if (!i)
        return !0;
      const a = n.length;
      return i > a ? (console.warn(`Warning: ${r.config.name} only called ${a} times, but ${i} expected`), !1) : !0;
    }).every((r) => r);
  }
}
const v3 = {
  includeContentLength: !0,
  matchPartialBody: !1,
  Request: globalThis.Request,
  Response: globalThis.Response,
  Headers: globalThis.Headers,
  fetch: globalThis.fetch
}, Xr = (e) => {
  function A(t, r, n) {
    return this.route(t, r, Object.assign(n || {}, e));
  }
  return A;
}, i1 = (e) => function(A, t) {
  return this.route("*", A, Object.assign(t || {}, e));
};
class Kh {
  constructor(A, t) {
    this.sticky = Xr({ sticky: !0 }), this.once = Xr({ repeat: 1 }), this.any = i1({}), this.anyOnce = i1({ repeat: 1 }), this.get = Xr({ method: "get" }), this.getOnce = Xr({ method: "get", repeat: 1 }), this.post = Xr({ method: "post" }), this.postOnce = Xr({ method: "post", repeat: 1 }), this.put = Xr({ method: "put" }), this.putOnce = Xr({ method: "put", repeat: 1 }), this.delete = Xr({ method: "delete" }), this.deleteOnce = Xr({ method: "delete", repeat: 1 }), this.head = Xr({ method: "head" }), this.headOnce = Xr({ method: "head", repeat: 1 }), this.patch = Xr({ method: "patch" }), this.patchOnce = Xr({ method: "patch", repeat: 1 }), this.config = A, this.router = new D3(this.config, {
      routes: t ? [...t.routes] : [],
      fallbackRoute: t ? t.fallbackRoute : null
    }), this.callHistory = new p3(this.config, this.router), this.fetchHandler = this.fetchHandler.bind(this), Object.assign(this.fetchHandler, { fetchMock: this });
  }
  createInstance() {
    return new Kh({ ...this.config }, this.router);
  }
  async fetchHandler(A, t) {
    let r;
    A instanceof this.config.Request ? r = await t3(A, t) : r = UD(A, t), this.callHistory.recordCall(r);
    const n = this.router.execute(r);
    return r.pendingPromises.push(n), n;
  }
  route(A, t, r) {
    return this.router.addRoute(A, t, r), this;
  }
  catch(A) {
    return this.router.setFallback(A), this;
  }
  defineMatcher(A) {
    Va.defineMatcher(A);
  }
  removeRoutes(A) {
    return this.router.removeRoutes(A), this;
  }
  clearHistory() {
    return this.callHistory.clear(), this;
  }
  mockGlobal() {
    return globalThis.fetch = this.fetchHandler, this;
  }
  unmockGlobal() {
    return globalThis.fetch = this.config.fetch, this;
  }
  hardReset(A) {
    return this.clearHistory(), this.removeRoutes(A), this.unmockGlobal(), this;
  }
  spy(A, t) {
    return A ? this.route(A, ({ args: r }) => this.config.fetch(...r), t) : this.catch(({ args: r }) => this.config.fetch(...r)), this;
  }
  spyGlobal() {
    return this.mockGlobal(), this.spy();
  }
}
const a1 = new Kh({
  ...v3
});
class kr {
}
Object.defineProperty(kr, "settEnv", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: (e) => {
    switch (e) {
      case "LOCAL":
        kr.apiUrl = "http://localhost:8096/person/arbeidsforhold-api", kr.loginUrl = "http://localhost:5000";
        break;
      case "DEV":
        kr.apiUrl = "https://www.ansatt.dev.nav.no/tms-arbeidsforhold-api", kr.loginUrl = "https://login.ekstern.dev.nav.no/oauth2/login";
        break;
      case "PROD":
        kr.apiUrl = "https://www.nav.no/tms-arbeidsforhold-api", kr.loginUrl = "https://login.nav.no/oauth2/login";
        break;
    }
  }
});
const o1 = (e, A) => new Promise((t) => {
  setTimeout(t, Math.random() * (A - e) + e);
}), y3 = () => {
  a1.get(`${kr.apiUrl}/arbeidsforhold`, o1(250, 1250).then(() => Nb)), a1.get(`begin:${kr.apiUrl}/arbeidsforholdinnslag`, o1(250, 1250).then(() => Tb));
};
var Fu = { exports: {} }, ks = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s1;
function b3() {
  if (s1) return ks;
  s1 = 1;
  var e = JA, A = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, s, l) {
    var u, g = {}, d = null, h = null;
    l !== void 0 && (d = "" + l), s.key !== void 0 && (d = "" + s.key), s.ref !== void 0 && (h = s.ref);
    for (u in s) r.call(s, u) && !i.hasOwnProperty(u) && (g[u] = s[u]);
    if (o && o.defaultProps) for (u in s = o.defaultProps, s) g[u] === void 0 && (g[u] = s[u]);
    return { $$typeof: A, type: o, key: d, ref: h, props: g, _owner: n.current };
  }
  return ks.Fragment = t, ks.jsx = a, ks.jsxs = a, ks;
}
var Us = {}, l1;
function F3() {
  if (l1) return Us;
  l1 = 1;
  var e = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && function() {
    var A = JA, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), E = Symbol.iterator, I = "@@iterator";
    function b(q) {
      if (q === null || typeof q != "object")
        return null;
      var bA = E && q[E] || q[I];
      return typeof bA == "function" ? bA : null;
    }
    var y = A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(q) {
      {
        for (var bA = arguments.length, $A = new Array(bA > 1 ? bA - 1 : 0), Ee = 1; Ee < bA; Ee++)
          $A[Ee - 1] = arguments[Ee];
        Q("error", q, $A);
      }
    }
    function Q(q, bA, $A) {
      {
        var Ee = y.ReactDebugCurrentFrame, Ve = Ee.getStackAddendum();
        Ve !== "" && (bA += "%s", $A = $A.concat([Ve]));
        var _e = $A.map(function(ve) {
          return String(ve);
        });
        _e.unshift("Warning: " + bA), Function.prototype.apply.call(console[q], console, _e);
      }
    }
    var w = !1, Y = !1, k = !1, L = !1, S = !1, P;
    P = Symbol.for("react.module.reference");
    function Z(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === n || q === a || S || q === i || q === u || q === g || L || q === C || w || Y || k || typeof q == "object" && q !== null && (q.$$typeof === h || q.$$typeof === d || q.$$typeof === o || q.$$typeof === s || q.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === P || q.getModuleId !== void 0));
    }
    function M(q, bA, $A) {
      var Ee = q.displayName;
      if (Ee)
        return Ee;
      var Ve = bA.displayName || bA.name || "";
      return Ve !== "" ? $A + "(" + Ve + ")" : $A;
    }
    function R(q) {
      return q.displayName || "Context";
    }
    function G(q) {
      if (q == null)
        return null;
      if (typeof q.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof q == "function")
        return q.displayName || q.name || null;
      if (typeof q == "string")
        return q;
      switch (q) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case s:
            var bA = q;
            return R(bA) + ".Consumer";
          case o:
            var $A = q;
            return R($A._context) + ".Provider";
          case l:
            return M(q, q.render, "ForwardRef");
          case d:
            var Ee = q.displayName || null;
            return Ee !== null ? Ee : G(q.type) || "Memo";
          case h: {
            var Ve = q, _e = Ve._payload, ve = Ve._init;
            try {
              return G(ve(_e));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, z = 0, T, O, K, AA, X, iA, oA;
    function fA() {
    }
    fA.__reactDisabledLog = !0;
    function wA() {
      {
        if (z === 0) {
          T = console.log, O = console.info, K = console.warn, AA = console.error, X = console.group, iA = console.groupCollapsed, oA = console.groupEnd;
          var q = {
            configurable: !0,
            enumerable: !0,
            value: fA,
            writable: !0
          };
          Object.defineProperties(console, {
            info: q,
            log: q,
            warn: q,
            error: q,
            group: q,
            groupCollapsed: q,
            groupEnd: q
          });
        }
        z++;
      }
    }
    function DA() {
      {
        if (z--, z === 0) {
          var q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, q, {
              value: T
            }),
            info: N({}, q, {
              value: O
            }),
            warn: N({}, q, {
              value: K
            }),
            error: N({}, q, {
              value: AA
            }),
            group: N({}, q, {
              value: X
            }),
            groupCollapsed: N({}, q, {
              value: iA
            }),
            groupEnd: N({}, q, {
              value: oA
            })
          });
        }
        z < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var HA = y.ReactCurrentDispatcher, sA;
    function lA(q, bA, $A) {
      {
        if (sA === void 0)
          try {
            throw Error();
          } catch (Ve) {
            var Ee = Ve.stack.trim().match(/\n( *(at )?)/);
            sA = Ee && Ee[1] || "";
          }
        return `
` + sA + q;
      }
    }
    var tA = !1, nA;
    {
      var GA = typeof WeakMap == "function" ? WeakMap : Map;
      nA = new GA();
    }
    function ZA(q, bA) {
      if (!q || tA)
        return "";
      {
        var $A = nA.get(q);
        if ($A !== void 0)
          return $A;
      }
      var Ee;
      tA = !0;
      var Ve = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _e;
      _e = HA.current, HA.current = null, wA();
      try {
        if (bA) {
          var ve = function() {
            throw Error();
          };
          if (Object.defineProperty(ve.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ve, []);
            } catch (Oe) {
              Ee = Oe;
            }
            Reflect.construct(q, [], ve);
          } else {
            try {
              ve.call();
            } catch (Oe) {
              Ee = Oe;
            }
            q.call(ve.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Oe) {
            Ee = Oe;
          }
          q();
        }
      } catch (Oe) {
        if (Oe && Ee && typeof Oe.stack == "string") {
          for (var Fe = Oe.stack.split(`
`), Ct = Ee.stack.split(`
`), et = Fe.length - 1, pA = Ct.length - 1; et >= 1 && pA >= 0 && Fe[et] !== Ct[pA]; )
            pA--;
          for (; et >= 1 && pA >= 0; et--, pA--)
            if (Fe[et] !== Ct[pA]) {
              if (et !== 1 || pA !== 1)
                do
                  if (et--, pA--, pA < 0 || Fe[et] !== Ct[pA]) {
                    var VA = `
` + Fe[et].replace(" at new ", " at ");
                    return q.displayName && VA.includes("<anonymous>") && (VA = VA.replace("<anonymous>", q.displayName)), typeof q == "function" && nA.set(q, VA), VA;
                  }
                while (et >= 1 && pA >= 0);
              break;
            }
        }
      } finally {
        tA = !1, HA.current = _e, DA(), Error.prepareStackTrace = Ve;
      }
      var YA = q ? q.displayName || q.name : "", ze = YA ? lA(YA) : "";
      return typeof q == "function" && nA.set(q, ze), ze;
    }
    function de(q, bA, $A) {
      return ZA(q, !1);
    }
    function _A(q) {
      var bA = q.prototype;
      return !!(bA && bA.isReactComponent);
    }
    function Ce(q, bA, $A) {
      if (q == null)
        return "";
      if (typeof q == "function")
        return ZA(q, _A(q));
      if (typeof q == "string")
        return lA(q);
      switch (q) {
        case u:
          return lA("Suspense");
        case g:
          return lA("SuspenseList");
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case l:
            return de(q.render);
          case d:
            return Ce(q.type, bA, $A);
          case h: {
            var Ee = q, Ve = Ee._payload, _e = Ee._init;
            try {
              return Ce(_e(Ve), bA, $A);
            } catch {
            }
          }
        }
      return "";
    }
    var WA = Object.prototype.hasOwnProperty, gA = {}, ie = y.ReactDebugCurrentFrame;
    function Qe(q) {
      if (q) {
        var bA = q._owner, $A = Ce(q.type, q._source, bA ? bA.type : null);
        ie.setExtraStackFrame($A);
      } else
        ie.setExtraStackFrame(null);
    }
    function OA(q, bA, $A, Ee, Ve) {
      {
        var _e = Function.call.bind(WA);
        for (var ve in q)
          if (_e(q, ve)) {
            var Fe = void 0;
            try {
              if (typeof q[ve] != "function") {
                var Ct = Error((Ee || "React class") + ": " + $A + " type `" + ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof q[ve] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ct.name = "Invariant Violation", Ct;
              }
              Fe = q[ve](bA, ve, Ee, $A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (et) {
              Fe = et;
            }
            Fe && !(Fe instanceof Error) && (Qe(Ve), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ee || "React class", $A, ve, typeof Fe), Qe(null)), Fe instanceof Error && !(Fe.message in gA) && (gA[Fe.message] = !0, Qe(Ve), p("Failed %s type: %s", $A, Fe.message), Qe(null));
          }
      }
    }
    var we = Array.isArray;
    function se(q) {
      return we(q);
    }
    function ue(q) {
      {
        var bA = typeof Symbol == "function" && Symbol.toStringTag, $A = bA && q[Symbol.toStringTag] || q.constructor.name || "Object";
        return $A;
      }
    }
    function ge(q) {
      try {
        return Pe(q), !1;
      } catch {
        return !0;
      }
    }
    function Pe(q) {
      return "" + q;
    }
    function le(q) {
      if (ge(q))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(q)), Pe(q);
    }
    var pe = y.ReactCurrentOwner, Ze = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, W, yA;
    yA = {};
    function xA(q) {
      if (WA.call(q, "ref")) {
        var bA = Object.getOwnPropertyDescriptor(q, "ref").get;
        if (bA && bA.isReactWarning)
          return !1;
      }
      return q.ref !== void 0;
    }
    function SA(q) {
      if (WA.call(q, "key")) {
        var bA = Object.getOwnPropertyDescriptor(q, "key").get;
        if (bA && bA.isReactWarning)
          return !1;
      }
      return q.key !== void 0;
    }
    function eA(q, bA) {
      if (typeof q.ref == "string" && pe.current && bA && pe.current.stateNode !== bA) {
        var $A = G(pe.current.type);
        yA[$A] || (p('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(pe.current.type), q.ref), yA[$A] = !0);
      }
    }
    function mA(q, bA) {
      {
        var $A = function() {
          je || (je = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", bA));
        };
        $A.isReactWarning = !0, Object.defineProperty(q, "key", {
          get: $A,
          configurable: !0
        });
      }
    }
    function H(q, bA) {
      {
        var $A = function() {
          W || (W = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", bA));
        };
        $A.isReactWarning = !0, Object.defineProperty(q, "ref", {
          get: $A,
          configurable: !0
        });
      }
    }
    var UA = function(q, bA, $A, Ee, Ve, _e, ve) {
      var Fe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: q,
        key: bA,
        ref: $A,
        props: ve,
        // Record the component responsible for creating this element.
        _owner: _e
      };
      return Fe._store = {}, Object.defineProperty(Fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.defineProperty(Fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ve
      }), Object.freeze && (Object.freeze(Fe.props), Object.freeze(Fe)), Fe;
    };
    function ae(q, bA, $A, Ee, Ve) {
      {
        var _e, ve = {}, Fe = null, Ct = null;
        $A !== void 0 && (le($A), Fe = "" + $A), SA(bA) && (le(bA.key), Fe = "" + bA.key), xA(bA) && (Ct = bA.ref, eA(bA, Ve));
        for (_e in bA)
          WA.call(bA, _e) && !Ze.hasOwnProperty(_e) && (ve[_e] = bA[_e]);
        if (q && q.defaultProps) {
          var et = q.defaultProps;
          for (_e in et)
            ve[_e] === void 0 && (ve[_e] = et[_e]);
        }
        if (Fe || Ct) {
          var pA = typeof q == "function" ? q.displayName || q.name || "Unknown" : q;
          Fe && mA(ve, pA), Ct && H(ve, pA);
        }
        return UA(q, Fe, Ct, Ve, Ee, pe.current, ve);
      }
    }
    var D = y.ReactCurrentOwner, CA = y.ReactDebugCurrentFrame;
    function IA(q) {
      if (q) {
        var bA = q._owner, $A = Ce(q.type, q._source, bA ? bA.type : null);
        CA.setExtraStackFrame($A);
      } else
        CA.setExtraStackFrame(null);
    }
    var V;
    V = !1;
    function $(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function dA() {
      {
        if (D.current) {
          var q = G(D.current.type);
          if (q)
            return `

Check the render method of \`` + q + "`.";
        }
        return "";
      }
    }
    function ce(q) {
      return "";
    }
    var NA = {};
    function XA(q) {
      {
        var bA = dA();
        if (!bA) {
          var $A = typeof q == "string" ? q : q.displayName || q.name;
          $A && (bA = `

Check the top-level render call using <` + $A + ">.");
        }
        return bA;
      }
    }
    function ke(q, bA) {
      {
        if (!q._store || q._store.validated || q.key != null)
          return;
        q._store.validated = !0;
        var $A = XA(bA);
        if (NA[$A])
          return;
        NA[$A] = !0;
        var Ee = "";
        q && q._owner && q._owner !== D.current && (Ee = " It was passed a child from " + G(q._owner.type) + "."), IA(q), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $A, Ee), IA(null);
      }
    }
    function Ne(q, bA) {
      {
        if (typeof q != "object")
          return;
        if (se(q))
          for (var $A = 0; $A < q.length; $A++) {
            var Ee = q[$A];
            $(Ee) && ke(Ee, bA);
          }
        else if ($(q))
          q._store && (q._store.validated = !0);
        else if (q) {
          var Ve = b(q);
          if (typeof Ve == "function" && Ve !== q.entries)
            for (var _e = Ve.call(q), ve; !(ve = _e.next()).done; )
              $(ve.value) && ke(ve.value, bA);
        }
      }
    }
    function Ie(q) {
      {
        var bA = q.type;
        if (bA == null || typeof bA == "string")
          return;
        var $A;
        if (typeof bA == "function")
          $A = bA.propTypes;
        else if (typeof bA == "object" && (bA.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        bA.$$typeof === d))
          $A = bA.propTypes;
        else
          return;
        if ($A) {
          var Ee = G(bA);
          OA($A, q.props, "prop", Ee, q);
        } else if (bA.PropTypes !== void 0 && !V) {
          V = !0;
          var Ve = G(bA);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ve || "Unknown");
        }
        typeof bA.getDefaultProps == "function" && !bA.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function be(q) {
      {
        for (var bA = Object.keys(q.props), $A = 0; $A < bA.length; $A++) {
          var Ee = bA[$A];
          if (Ee !== "children" && Ee !== "key") {
            IA(q), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ee), IA(null);
            break;
          }
        }
        q.ref !== null && (IA(q), p("Invalid attribute `ref` supplied to `React.Fragment`."), IA(null));
      }
    }
    var Ye = {};
    function ye(q, bA, $A, Ee, Ve, _e) {
      {
        var ve = Z(q);
        if (!ve) {
          var Fe = "";
          (q === void 0 || typeof q == "object" && q !== null && Object.keys(q).length === 0) && (Fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ct = ce();
          Ct ? Fe += Ct : Fe += dA();
          var et;
          q === null ? et = "null" : se(q) ? et = "array" : q !== void 0 && q.$$typeof === t ? (et = "<" + (G(q.type) || "Unknown") + " />", Fe = " Did you accidentally export a JSX literal instead of a component?") : et = typeof q, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", et, Fe);
        }
        var pA = ae(q, bA, $A, Ve, _e);
        if (pA == null)
          return pA;
        if (ve) {
          var VA = bA.children;
          if (VA !== void 0)
            if (Ee)
              if (se(VA)) {
                for (var YA = 0; YA < VA.length; YA++)
                  Ne(VA[YA], q);
                Object.freeze && Object.freeze(VA);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ne(VA, q);
        }
        if (WA.call(bA, "key")) {
          var ze = G(q), Oe = Object.keys(bA).filter(function(Ar) {
            return Ar !== "key";
          }), lt = Oe.length > 0 ? "{key: someKey, " + Oe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ye[ze + lt]) {
            var St = Oe.length > 0 ? "{" + Oe.join(": ..., ") + ": ...}" : "{}";
            p(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, lt, ze, St, ze), Ye[ze + lt] = !0;
          }
        }
        return q === n ? be(pA) : Ie(pA), pA;
      }
    }
    function st(q, bA, $A) {
      return ye(q, bA, $A, !0);
    }
    function Ut(q, bA, $A) {
      return ye(q, bA, $A, !1);
    }
    var gt = Ut, Ke = st;
    Us.Fragment = n, Us.jsx = gt, Us.jsxs = Ke;
  }(), Us;
}
var u1;
function L3() {
  if (u1) return Fu.exports;
  u1 = 1;
  var e = {};
  return e.NODE_ENV === "production" ? Fu.exports = b3() : Fu.exports = F3(), Fu.exports;
}
var x = L3();
function jD(e) {
  var A, t, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (A = 0; A < n; A++) e[A] && (t = jD(e[A])) && (r && (r += " "), r += t);
  } else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function ct() {
  for (var e, A, t = 0, r = "", n = arguments.length; t < n; t++) (e = arguments[t]) && (A = jD(e)) && (r && (r += " "), r += A);
  return r;
}
function mg(e) {
  return (A) => {
    e.forEach((t) => {
      typeof t == "function" ? t(A) : t != null && (t.current = A);
    });
  };
}
function Rl(...e) {
  return JA.useCallback(mg(e), e);
}
function R3(e, A) {
  const t = Object.assign({}, A);
  for (const r in A) {
    const n = e[r], i = A[r];
    /^on[A-Z]/.test(r) ? n && i ? t[r] = (...o) => {
      i(...o), n(...o);
    } : n && (t[r] = n) : r === "style" ? t[r] = Object.assign(Object.assign({}, n), i) : r === "className" && (t[r] = [n, i].filter(Boolean).join(" "));
  }
  return Object.assign(Object.assign({}, e), t);
}
var G3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const _h = fe.forwardRef((e, A) => {
  var t;
  const { children: r } = e, n = G3(e, ["children"]);
  if (fe.isValidElement(r)) {
    const i = Object.prototype.propertyIsEnumerable.call(r.props, "ref") ? r.props.ref : r.ref;
    return fe.cloneElement(r, Object.assign(Object.assign({}, R3(n, r.props)), { ref: A ? mg([A, i]) : i }));
  }
  if (fe.Children.count(r) > 1) {
    const i = new Error("Aksel: Components using 'asChild' expects to recieve a single React element child.");
    throw i.name = "SlotError", (t = Error.captureStackTrace) === null || t === void 0 || t.call(Error, i, _h), i;
  }
  return null;
});
var x3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
function k3(e, A) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${A}`;
}
function Gl(e = {}) {
  const { name: A, hookName: t = "useContext", providerName: r = "Provider", errorMessage: n, defaultValue: i } = e, a = Qn(i), o = At((l, u) => {
    var { children: g } = l, d = x3(l, ["children"]);
    const h = JA.useMemo(() => d, Object.values(d));
    return JA.createElement(a.Provider, { value: u ? Object.assign(Object.assign({}, h), { ref: u }) : h }, g);
  });
  function s(l = !0) {
    var u;
    const g = t0(a);
    if (!g && l) {
      const d = new Error(n ?? k3(t, r));
      throw d.name = "ContextError", (u = Error.captureStackTrace) === null || u === void 0 || u.call(Error, d, s), d;
    }
    return g;
  }
  return a.displayName = A, [o, s];
}
const [U3, Xh] = Gl({
  hookName: "useTheme",
  name: "ThemeProvider",
  providerName: "ThemeProvider"
});
At((e, A) => {
  var t;
  const r = Xh(!1), { children: n, className: i, asChild: a = !1, theme: o = (t = r == null ? void 0 : r.theme) !== null && t !== void 0 ? t : "light", hasBackground: s = !0 } = e, u = s ?? (r === void 0 && e.theme !== void 0), g = a ? _h : "div";
  return JA.createElement(
    U3,
    { theme: o },
    JA.createElement(g, { ref: A, className: ct("navds-theme", i, o), "data-background": u }, n)
  );
});
const is = (e) => ct({
  "navds-typo--spacing": e.spacing,
  "navds-typo--truncate": e.truncate,
  "navds-typo--semibold": e.weight === "semibold",
  [`navds-typo--align-${e.align}`]: e.align,
  [`navds-typo--color-${e.textColor}`]: e.textColor,
  "navds-typo--visually-hidden": e.visuallyHidden,
  "navds-typo--uppercase": e.uppercase
});
var Y3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const H3 = At((e, A) => {
  var { className: t, size: r = "medium", as: n = "p", spacing: i, truncate: a, weight: o = "regular", align: s, visuallyHidden: l, textColor: u } = e, g = Y3(e, ["className", "size", "as", "spacing", "truncate", "weight", "align", "visuallyHidden", "textColor"]);
  return JA.createElement(n, Object.assign({}, g, { ref: A, className: ct(t, "navds-body-long", `navds-body-long--${r}`, is({
    spacing: i,
    truncate: a,
    weight: o,
    align: s,
    visuallyHidden: l,
    textColor: u
  })) }));
});
var S3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const Zn = At((e, A) => {
  var { className: t, size: r = "medium", as: n = "p", spacing: i, truncate: a, weight: o = "regular", align: s, visuallyHidden: l, textColor: u } = e, g = S3(e, ["className", "size", "as", "spacing", "truncate", "weight", "align", "visuallyHidden", "textColor"]);
  return JA.createElement(n, Object.assign({}, g, { ref: A, className: ct(t, "navds-body-short", `navds-body-short--${r}`, is({
    spacing: i,
    truncate: a,
    weight: o,
    align: s,
    visuallyHidden: l,
    textColor: u
  })) }));
});
var N3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const T3 = At((e, A) => {
  var { className: t, size: r = "medium", spacing: n, uppercase: i, as: a = "p", truncate: o, weight: s = "regular", align: l, visuallyHidden: u, textColor: g } = e, d = N3(e, ["className", "size", "spacing", "uppercase", "as", "truncate", "weight", "align", "visuallyHidden", "textColor"]);
  return JA.createElement(a, Object.assign({}, d, { ref: A, className: ct(t, "navds-detail", is({
    spacing: n,
    truncate: o,
    weight: s,
    align: l,
    visuallyHidden: u,
    textColor: g,
    uppercase: i
  }), {
    "navds-detail--small": r === "small"
  }) }));
});
var P3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const z3 = At((e, A) => {
  var { children: t, className: r, size: n, spacing: i, as: a = "p", showIcon: o = !1 } = e, s = P3(e, ["children", "className", "size", "spacing", "as", "showIcon"]);
  return JA.createElement(
    a,
    Object.assign({}, s, { ref: A, className: ct("navds-error-message", "navds-label", r, is({
      spacing: i
    }), {
      "navds-label--small": n === "small",
      "navds-error-message--show-icon": o
    }) }),
    o && JA.createElement(
      "svg",
      { viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: !1, "aria-hidden": !0 },
      JA.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.49209 11.534L8.11398 2.7594C8.48895 2.04752 9.50833 2.04743 9.88343 2.75924L14.5073 11.5339C14.8582 12.1998 14.3753 13 13.6226 13H4.37685C3.6242 13 3.14132 12.1999 3.49209 11.534ZM9.74855 10.495C9.74855 10.9092 9.41276 11.245 8.99855 11.245C8.58433 11.245 8.24855 10.9092 8.24855 10.495C8.24855 10.0808 8.58433 9.74497 8.99855 9.74497C9.41276 9.74497 9.74855 10.0808 9.74855 10.495ZM9.49988 5.49997C9.49988 5.22383 9.27602 4.99997 8.99988 4.99997C8.72373 4.99997 8.49988 5.22383 8.49988 5.49997V7.99997C8.49988 8.27611 8.72373 8.49997 8.99988 8.49997C9.27602 8.49997 9.49988 8.27611 9.49988 7.99997V5.49997Z", fill: "currentColor" })
    ),
    t
  );
});
var j3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const Lr = At((e, A) => {
  var { level: t = "1", size: r, className: n, as: i, spacing: a, align: o, visuallyHidden: s, textColor: l } = e, u = j3(e, ["level", "size", "className", "as", "spacing", "align", "visuallyHidden", "textColor"]);
  const g = i ?? `h${t}`;
  return JA.createElement(g, Object.assign({}, u, { ref: A, className: ct(n, "navds-heading", `navds-heading--${r}`, is({
    spacing: a,
    align: o,
    visuallyHidden: s,
    textColor: l
  })) }));
});
var V3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
At((e, A) => {
  var { className: t, spacing: r, as: n = "p" } = e, i = V3(e, ["className", "spacing", "as"]);
  return JA.createElement(n, Object.assign({}, i, { ref: A, className: ct(t, "navds-ingress", {
    "navds-typo--spacing": !!r
  }) }));
});
var O3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const VD = At((e, A) => {
  var { className: t, size: r = "medium", as: n = "label", spacing: i, visuallyHidden: a, textColor: o } = e, s = O3(e, ["className", "size", "as", "spacing", "visuallyHidden", "textColor"]);
  return JA.createElement(n, Object.assign({}, s, { ref: A, className: ct(t, "navds-label", is({
    spacing: i,
    visuallyHidden: a,
    textColor: o
  }), {
    "navds-label--small": r === "small"
  }) }));
});
function J3(e, A = 166, t = !1) {
  let r;
  function n(...i) {
    const a = () => {
      r = void 0, e.apply(this, i);
    };
    !r && t && a(), clearTimeout(r), r = setTimeout(a, A);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function Oa(e, A) {
  const t = Object.entries(e).filter(([r]) => !A.includes(r));
  return Object.fromEntries(t);
}
const Tc = globalThis != null && globalThis.document ? Jh : () => {
};
let c1 = 0;
function W3(e) {
  const [A, t] = Jt(e), r = e || A;
  return Wt(() => {
    A == null && (c1 += 1, t(`aksel-id-${c1}`));
  }, [A]), r;
}
const g1 = JA.useId;
function Ja(e) {
  var A;
  return g1 !== void 0 ? g1().replace(/(:)/g, "") : (A = W3(e)) !== null && A !== void 0 ? A : "";
}
function ul(e, A = []) {
  const t = An(e);
  return Wt(() => {
    t.current = e;
  }), Wh((...r) => {
    var n;
    return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
  }, A);
}
function Z3({ value: e, defaultValue: A, onChange: t }) {
  const r = ul(t), [n, i] = Jt(A), a = e !== void 0, o = a ? e : n, s = ul((l) => {
    const g = typeof l == "function" ? l(o) : l;
    a || i(g), r(g);
  }, [a, r, o]);
  return [o, s];
}
let B1 = 0;
function K3(e) {
  const [A, t] = Jt(e), r = e || A;
  return Wt(() => {
    A == null && (B1 += 1, t(`aksel-icon-${B1}`));
  }, [A]), r;
}
const f1 = JA.useId;
function r0(e) {
  var A;
  return f1 !== void 0 ? f1().replace(/(:)/g, "") : (A = K3(e)) !== null && A !== void 0 ? A : "";
}
var _3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const X3 = At((e, A) => {
  var { title: t, titleId: r } = e, n = _3(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75m4.954-12.475a.813.813 0 0 0-1.24-1.05l-5.389 6.368L7.7 11.967a.812.812 0 0 0-1.15 1.15l3.25 3.25a.81.81 0 0 0 1.195-.05z", clipRule: "evenodd" })
  );
});
var q3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const Mg = At((e, A) => {
  var { title: t, titleId: r } = e, n = q3(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.97 9.47a.75.75 0 0 1 1.06 0L12 14.44l4.97-4.97a.75.75 0 1 1 1.06 1.06l-5.5 5.5a.75.75 0 0 1-1.06 0l-5.5-5.5a.75.75 0 0 1 0-1.06", clipRule: "evenodd" })
  );
});
var $3 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const AF = At((e, A) => {
  var { title: t, titleId: r } = e, n = $3(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.53 5.97a.75.75 0 0 1 0 1.06L9.56 12l4.97 4.97a.75.75 0 1 1-1.06 1.06l-5.5-5.5a.75.75 0 0 1 0-1.06l5.5-5.5a.75.75 0 0 1 1.06 0", clipRule: "evenodd" })
  );
});
var eF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const tF = At((e, A) => {
  var { title: t, titleId: r } = e, n = eF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.47 5.97a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 0 1 0 1.06l-5.5 5.5a.75.75 0 1 1-1.06-1.06L14.44 12 9.47 7.03a.75.75 0 0 1 0-1.06", clipRule: "evenodd" })
  );
});
var rF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const pg = At((e, A) => {
  var { title: t, titleId: r } = e, n = rF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.47 7.97a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06L12 9.56l-4.97 4.97a.75.75 0 0 1-1.06-1.06z", clipRule: "evenodd" })
  );
});
var nF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const iF = At((e, A) => {
  var { title: t, titleId: r } = e, n = nF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .656.387l9.527 17.25A.75.75 0 0 1 21.526 21H2.474a.75.75 0 0 1-.657-1.113l9.526-17.25A.75.75 0 0 1 12 2.25M12 8.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m-1 7.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0", clipRule: "evenodd" })
  );
});
var aF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const oF = At((e, A) => {
  var { title: t, titleId: r } = e, n = aF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.25 4A.75.75 0 0 1 4 3.25h16a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75zM11 7.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1.25 3a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 .75.75v4.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-4h-.75a.75.75 0 0 1-.75-.75", clipRule: "evenodd" })
  );
});
var sF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const OD = At((e, A) => {
  var { title: t, titleId: r } = e, n = sF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2.25A4.75 4.75 0 0 0 7.25 7v2.25H7A1.75 1.75 0 0 0 5.25 11v9c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75v-9A1.75 1.75 0 0 0 17 9.25h-.25V7A4.75 4.75 0 0 0 12 2.25m3.25 7V7a3.25 3.25 0 0 0-6.5 0v2.25zM12 13a1.5 1.5 0 0 0-.75 2.8V17a.75.75 0 0 0 1.5 0v-1.2A1.5 1.5 0 0 0 12 13", clipRule: "evenodd" })
  );
});
var lF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const qh = At((e, A) => {
  var { title: t, titleId: r } = e, n = lF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 2.25a.75.75 0 0 0-.75.75v4.25H4A1.75 1.75 0 0 0 2.25 9v9c0 .414.336.75.75.75h3.25V21c0 .414.336.75.75.75h10a.75.75 0 0 0 .75-.75v-2.25H21a.75.75 0 0 0 .75-.75V9A1.75 1.75 0 0 0 20 7.25h-2.25V3a.75.75 0 0 0-.75-.75zM3.75 9A.25.25 0 0 1 4 8.75h16a.25.25 0 0 1 .25.25v8.25h-2.5V12a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75v5.25h-2.5zm12.5-1.75v-3.5h-8.5v3.5zm-8.5 5.5v7.5h8.5v-7.5zM9.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75", clipRule: "evenodd" })
  );
});
var uF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const JD = At((e, A) => {
  var { title: t, titleId: r } = e, n = uF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", d: "M6.53 5.47a.75.75 0 0 0-1.06 1.06L10.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06L12 13.06l5.47 5.47a.75.75 0 1 0 1.06-1.06L13.06 12l5.47-5.47a.75.75 0 0 0-1.06-1.06L12 10.94z" })
  );
});
var cF = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const gF = At((e, A) => {
  var { title: t, titleId: r } = e, n = cF(e, ["title", "titleId"]);
  let i = r0();
  return i = t ? r || "title-" + i : void 0, fe.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: A, "aria-labelledby": i }, n),
    t ? fe.createElement("title", { id: i }, t) : null,
    fe.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.742 2.47a.75.75 0 0 1 .53-.22h7.456a.75.75 0 0 1 .53.22l5.272 5.272c.141.14.22.331.22.53v7.456a.75.75 0 0 1-.22.53l-5.272 5.272a.75.75 0 0 1-.53.22H8.272a.75.75 0 0 1-.53-.22L2.47 16.258a.75.75 0 0 1-.22-.53V8.272a.75.75 0 0 1 .22-.53zm1.288 5.5a.75.75 0 0 0-1.06 1.06L10.94 12l-2.97 2.97a.75.75 0 1 0 1.06 1.06L12 13.06l2.97 2.97a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0-1.06-1.06L12 10.94z", clipRule: "evenodd" })
  );
});
function Ni(e, A, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return A == null ? void 0 : A(n);
  };
}
const [BF, $h] = Gl({
  name: "ModalContext",
  errorMessage: "<Modal.Header> must be used within a <Modal>"
});
function rf(e) {
  return (A = {}) => {
    const t = A.width ? String(A.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function Ys(e) {
  return (A, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let n;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, o = t != null && t.width ? String(t.width) : a;
      n = e.formattingValues[o] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, o = t != null && t.width ? String(t.width) : e.defaultWidth;
      n = e.values[o] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(A) : A;
    return n[i];
  };
}
function Hs(e) {
  return (A, t = {}) => {
    const r = t.width, n = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = A.match(n);
    if (!i)
      return null;
    const a = i[0], o = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(o) ? dF(o, (g) => g.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      fF(o, (g) => g.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(s) : s, l = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(l)
    ) : l;
    const u = A.slice(a.length);
    return { value: l, rest: u };
  };
}
function fF(e, A) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && A(e[t]))
      return t;
}
function dF(e, A) {
  for (let t = 0; t < e.length; t++)
    if (A(e[t]))
      return t;
}
function hF(e) {
  return (A, t = {}) => {
    const r = A.match(e.matchPattern);
    if (!r) return null;
    const n = r[0], i = A.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const o = A.slice(n.length);
    return { value: a, rest: o };
  };
}
const CF = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, EF = (e, A, t) => {
  let r;
  const n = CF[e];
  return typeof n == "string" ? r = n : A === 1 ? r = n.one : r = n.other.replace("{{count}}", String(A)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "om " + r : r + " siden" : r;
}, QF = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, wF = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, IF = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, DF = {
  date: rf({
    formats: QF,
    defaultWidth: "full"
  }),
  time: rf({
    formats: wF,
    defaultWidth: "full"
  }),
  dateTime: rf({
    formats: IF,
    defaultWidth: "full"
  })
}, mF = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, MF = (e, A, t, r) => mF[e], pF = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, vF = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, yF = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, bF = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, FF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, LF = (e, A) => Number(e) + ".", RF = {
  ordinalNumber: LF,
  era: Ys({
    values: pF,
    defaultWidth: "wide"
  }),
  quarter: Ys({
    values: vF,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ys({
    values: yF,
    defaultWidth: "wide"
  }),
  day: Ys({
    values: bF,
    defaultWidth: "wide"
  }),
  dayPeriod: Ys({
    values: FF,
    defaultWidth: "wide"
  })
}, GF = /^(\d+)\.?/i, xF = /\d+/i, kF = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, UF = {
  any: [/^f/i, /^e/i]
}, YF = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, HF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, SF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, NF = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, TF = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, PF = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, zF = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, jF = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, VF = {
  ordinalNumber: hF({
    matchPattern: GF,
    parsePattern: xF,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Hs({
    matchPatterns: kF,
    defaultMatchWidth: "wide",
    parsePatterns: UF,
    defaultParseWidth: "any"
  }),
  quarter: Hs({
    matchPatterns: YF,
    defaultMatchWidth: "wide",
    parsePatterns: HF,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Hs({
    matchPatterns: SF,
    defaultMatchWidth: "wide",
    parsePatterns: NF,
    defaultParseWidth: "any"
  }),
  day: Hs({
    matchPatterns: TF,
    defaultMatchWidth: "wide",
    parsePatterns: PF,
    defaultParseWidth: "any"
  }),
  dayPeriod: Hs({
    matchPatterns: zF,
    defaultMatchWidth: "any",
    parsePatterns: jF,
    defaultParseWidth: "any"
  })
}, OF = {
  code: "nb",
  formatDistance: EF,
  formatLong: DF,
  formatRelative: MF,
  localize: RF,
  match: VF,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, JF = {
  global: {
    dateLocale: OF,
    showMore: "Vis mer",
    showLess: "Vis mindre",
    readOnly: "Skrivebeskyttet",
    close: "Lukk"
  },
  Alert: {
    closeAlert: "Lukk varsel",
    closeMessage: "Lukk melding",
    error: "Feil",
    info: "Informasjon",
    success: "Suksess",
    warning: "Advarsel"
  },
  Chips: {
    Removable: {
      /** Will be appended to the accessible name for the button. */
      labelSuffix: "slett"
    }
  },
  Combobox: {
    /** The input value will be appended to the end of this text, e.g. `Legg til "input value"`. */
    addOption: "Legg til",
    /** Loader title */
    loading: "Søker…",
    maxSelected: "{selected} av maks {limit} er valgt."
  },
  CopyButton: {
    title: "Kopier",
    activeText: "Kopiert!"
  },
  DatePicker: {
    chooseDate: "Velg dato",
    chooseDates: "Velg datoer",
    chooseDateRange: "Velg start- og sluttdato",
    chooseMonth: "Velg måned",
    week: "Uke",
    weekNumber: "Uke {week}",
    selectWeekNumber: "Velg uke {week}",
    month: "Måned",
    goToNextMonth: "Gå til neste måned",
    goToPreviousMonth: "Gå til forrige måned",
    year: "År",
    goToNextYear: "Gå til neste år",
    goToPreviousYear: "Gå til forrige år",
    openDatePicker: "Åpne datovelger",
    openMonthPicker: "Åpne månedsvelger",
    closeDatePicker: "Lukk datovelger",
    closeMonthPicker: "Lukk månedsvelger"
  },
  ErrorSummary: {
    heading: "Du må rette disse feilene før du kan fortsette:"
  },
  FileUpload: {
    dropzone: {
      button: "Velg fil",
      buttonMultiple: "Velg filer",
      dragAndDrop: "Dra og slipp filen her",
      dragAndDropMultiple: "Dra og slipp filer her",
      drop: "Slipp",
      or: "eller",
      disabled: "Filopplasting er deaktivert",
      disabledFilelimit: "Du kan ikke laste opp flere filer"
    },
    item: {
      retryButtonTitle: "Prøv å laste opp filen på nytt",
      deleteButtonTitle: "Slett filen",
      uploading: "Laster opp…",
      downloading: "Laster ned…"
    }
  },
  FormProgress: {
    step: "Steg {activeStep} av {totalSteps}",
    showAllSteps: "Vis alle steg",
    hideAllSteps: "Skjul alle steg"
  },
  FormSummary: {
    editAnswer: "Endre svar"
  },
  GuidePanel: {
    illustrationLabel: "Illustrasjon av veileder"
  },
  HelpText: {
    title: "Mer informasjon"
  },
  Loader: {
    title: "Venter…"
  },
  Pagination: {
    previous: "Forrige",
    next: "Neste"
  },
  ProgressBar: {
    progress: "{current} av {max}",
    progressUnknown: "Fremdrift kan ikke beregnes, antatt tid er {seconds} sekunder."
  },
  Search: {
    clear: "Tøm feltet",
    search: "Søk"
  },
  Textarea: {
    /** Screen readers only */
    maxLength: "Tekstområde med plass til {maxLength} tegn.",
    charsTooMany: "{chars} tegn for mye",
    charsLeft: "{chars} tegn igjen"
  },
  Timeline: {
    dateFormat: "dd.MM.yyyy",
    dayFormat: "dd.MM",
    monthFormat: "MMM yy",
    yearFormat: "yyyy",
    Row: {
      noPeriods: "Ingen perioder",
      period: "{start} til {end}"
    },
    Period: {
      success: "Suksess",
      warning: "Advarsel",
      danger: "Fare",
      info: "Info",
      neutral: "Nøytral",
      period: "{status} fra {start} til {end}"
    },
    Pin: {
      pin: "Pin: {date}"
    },
    Zoom: {
      zoom: "Zoom tidslinjen {start} til {end}",
      reset: "Tilbakestill tidsperspektiv"
    }
  }
}, WF = Qn({
  locale: JF
}), WD = () => t0(WF);
function d1(e) {
  return e.sort((A, t) => {
    const r = A.compareDocumentPosition(t);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
const ZF = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function h1(e, A, t) {
  let r = e + 1;
  return t && r >= A && (r = 0), r;
}
function C1(e, A, t) {
  let r = e - 1;
  return t && r < 0 && (r = A), r;
}
const nf = (e) => e;
class KF {
  constructor() {
    this.descendants = /* @__PURE__ */ new Map(), this.register = (A) => {
      if (A != null)
        return ZF(A) ? this.registerNode(A) : (t) => {
          this.registerNode(t, A);
        };
    }, this.unregister = (A) => {
      this.descendants.delete(A);
      const t = d1(Array.from(this.descendants.keys()));
      this.assignIndex(t);
    }, this.destroy = () => {
      this.descendants.clear();
    }, this.assignIndex = (A) => {
      this.descendants.forEach((t) => {
        const r = A.indexOf(t.node);
        t.index = r, t.node.dataset.index = t.index.toString();
      });
    }, this.count = () => this.descendants.size, this.enabledCount = () => this.enabledValues().length, this.values = () => Array.from(this.descendants.values()).sort((t, r) => t.index - r.index), this.enabledValues = () => this.values().filter((A) => !A.disabled), this.item = (A) => {
      if (this.count() !== 0)
        return this.values()[A];
    }, this.enabledItem = (A) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[A];
    }, this.first = () => this.item(0), this.firstEnabled = () => this.enabledItem(0), this.last = () => this.item(this.descendants.size - 1), this.lastEnabled = () => {
      const A = this.enabledValues().length - 1;
      return this.enabledItem(A);
    }, this.indexOf = (A) => {
      var t, r;
      return A && (r = (t = this.descendants.get(A)) === null || t === void 0 ? void 0 : t.index) !== null && r !== void 0 ? r : -1;
    }, this.enabledIndexOf = (A) => A == null ? -1 : this.enabledValues().findIndex((t) => t.node.isSameNode(A)), this.next = (A, t = !0) => {
      const r = h1(A, this.count(), t);
      return this.item(r);
    }, this.nextEnabled = (A, t = !0) => {
      const r = this.item(A);
      if (!r)
        return;
      const n = this.enabledIndexOf(r.node), i = h1(n, this.enabledCount(), t);
      return this.enabledItem(i);
    }, this.prev = (A, t = !0) => {
      const r = C1(A, this.count() - 1, t);
      return this.item(r);
    }, this.prevEnabled = (A, t = !0) => {
      const r = this.item(A);
      if (!r)
        return;
      const n = this.enabledIndexOf(r.node), i = C1(n, this.enabledCount() - 1, t);
      return this.enabledItem(i);
    }, this.registerNode = (A, t) => {
      if (!A)
        return;
      const r = this.descendants.get(A);
      if (r) {
        this.descendants.set(A, Object.assign({ index: r.index, node: A }, t));
        return;
      }
      const n = Array.from(this.descendants.keys()).concat(A), i = d1(n);
      t != null && t.disabled && (t.disabled = !!t.disabled);
      const a = Object.assign({ node: A, index: -1 }, t);
      this.descendants.set(A, a), this.assignIndex(i);
    };
  }
}
function ZD() {
  const [e, A] = Gl({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  }), t = nf((i) => JA.createElement(e, Object.assign({}, i.value), i.children));
  function r(i) {
    const a = A(), [o, s] = Jt(-1), l = An(null);
    Tc(() => () => {
      l.current && a.unregister(l.current);
    }, []), Tc(() => {
      if (!l.current)
        return;
      const g = Number(l.current.dataset.index);
      o !== g && !Number.isNaN(g) && s(g);
    });
    const u = nf(i ? a.register(i) : a.register);
    return {
      descendants: a,
      index: o,
      enabledIndex: a.enabledIndexOf(l.current),
      register: mg([u, l])
    };
  }
  function n() {
    return An(new KF()).current;
  }
  return [
    // context provider
    t,
    // call this when you need to read from context
    A,
    // descendants state information, to be called and passed to `ContextProvider`
    n,
    // descendant index information
    r
  ];
}
function _F(e, A = globalThis == null ? void 0 : globalThis.document) {
  const t = ul(e);
  Wt(() => {
    const r = (n) => {
      n.key === "Escape" && t(n);
    };
    return A.addEventListener("keydown", r, !0), () => A.removeEventListener("keydown", r, !0);
  }, [t, A]);
}
const KD = {
  FOCUS_OUTSIDE: "AKSEL_FOCUS_OUTSIDE",
  POINTER_DOWN_OUTSIDE: "AKSEL_POINTER_DOWN_OUTSIDE"
};
function _D(e, A, t, { discrete: r } = { discrete: !1 }) {
  if (!A)
    return;
  const n = t.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  n.addEventListener(e, A, { once: !0 }), r && n ? jb.flushSync(() => n.dispatchEvent(i)) : n.dispatchEvent(i);
}
function XF(e, A = globalThis == null ? void 0 : globalThis.document) {
  const t = ul(e), r = An(!1);
  return Wt(() => {
    const n = (i) => {
      if (i.target && !r.current) {
        const a = { originalEvent: i };
        _D(KD.FOCUS_OUTSIDE, t, a);
      }
    };
    return A.addEventListener("focusin", n), () => A.removeEventListener("focusin", n);
  }, [A, t]), {
    onFocusCapture: () => {
      r.current = !0;
    },
    onBlurCapture: () => {
      r.current = !1;
    }
  };
}
function qF(e, A = globalThis == null ? void 0 : globalThis.document) {
  const t = ul(e), r = An(!1), n = An(() => {
  });
  return Wt(() => {
    const i = (o) => {
      function s() {
        _D(KD.POINTER_DOWN_OUTSIDE, t, { originalEvent: o }, { discrete: !0 });
      }
      o.target && !r.current ? o.pointerType === "touch" ? (A.removeEventListener("click", n.current), n.current = s, A.addEventListener("click", n.current, {
        once: !0
      })) : s() : A.removeEventListener("click", n.current), r.current = !1;
    }, a = window.setTimeout(() => {
      A.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), A.removeEventListener("pointerdown", i), A.removeEventListener("click", n.current);
    };
  }, [A, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => {
      r.current = !0;
    }
  };
}
var $F = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const [A8, e8, t8, r8] = ZD();
let wo = 0, E1;
const n8 = At((e, A) => e8(!1) ? JA.createElement(Q1, Object.assign({ ref: A }, e)) : JA.createElement(
  i8,
  null,
  JA.createElement(Q1, Object.assign({ ref: A }, e))
)), i8 = ({ children: e }) => {
  const A = t8();
  return JA.createElement(A8, { value: A }, e);
}, Q1 = At((e, A) => {
  var t, { children: r, asChild: n, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: l, safeZone: u, disableOutsidePointerEvents: g = !1, enabled: d = !0 } = e, h = $F(e, ["children", "asChild", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss", "safeZone", "disableOutsidePointerEvents", "enabled"]);
  const [, C] = Jt({}), { register: E, index: I, descendants: b } = r8({
    disableOutsidePointerEvents: g,
    disabled: !d,
    forceUpdate: () => C({})
  }), [y, p] = Jt(null), Q = Rl(p, E, A), w = (t = y == null ? void 0 : y.ownerDocument) !== null && t !== void 0 ? t : globalThis == null ? void 0 : globalThis.document, Y = An(!1), k = An(!1), L = (() => {
    let R = -1;
    return b.enabledValues().forEach((N, z) => {
      N.disableOutsidePointerEvents && (R = z);
    }), {
      /**
       * Makes sure we stop events at the highest layer with pointer events disabled.
       * If not checked, we risk closing every layer when clicking outside the layer.
       */
      isPointerEventsEnabled: I >= R,
      /**
       * If we find a node with `disableOutsidePointerEvents` we want to disable pointer events on the body.
       */
      isBodyPointerEventsDisabled: wo > 0,
      pointerStyle: I >= R && wo > 0 ? "auto" : void 0
    };
  })();
  function S(R) {
    var G, N;
    if (!(u != null && u.anchor) && !(u != null && u.dismissable) || !d)
      return;
    R.defaultPrevented || (Y.current = !0, R.detail.originalEvent.type === "pointerdown" && (k.current = !0));
    const z = R.target;
    R.detail.originalEvent.type === "pointerdown" ? (!((G = u == null ? void 0 : u.anchor) === null || G === void 0) && G.contains(z) || z === (u == null ? void 0 : u.anchor)) && R.preventDefault() : !(z instanceof HTMLElement && ![u == null ? void 0 : u.anchor, u == null ? void 0 : u.dismissable].some((O) => O == null ? void 0 : O.contains(z)) && !z.contains((N = u == null ? void 0 : u.dismissable) !== null && N !== void 0 ? N : null)) && R.preventDefault(), R.detail.originalEvent.type === "focusin" && k.current && R.preventDefault(), k.current = !1, Y.current = !1;
  }
  const P = qF((R) => {
    !L.isPointerEventsEnabled || !d || (a == null || a(R), s == null || s(R), u && S(R), !R.defaultPrevented && l && l());
  }, w), Z = XF((R) => {
    d && (o == null || o(R), s == null || s(R), u && S(R), !R.defaultPrevented && l && l());
  }, w);
  _F((R) => {
    !d || !(I === b.enabledCount() - 1) || (i == null || i(R), !R.defaultPrevented && l && (R.preventDefault(), l()));
  }, w), Wt(() => {
    if (!(!y || !d || !g))
      return wo === 0 && (E1 = w.body.style.pointerEvents, w.body.style.pointerEvents = "none"), wo++, () => {
        wo === 1 && (w.body.style.pointerEvents = E1), wo--;
      };
  }, [
    y,
    w,
    g,
    b,
    d
  ]), Wt(() => () => b.values().forEach((R) => R.forceUpdate()), [b, y]);
  const M = n ? _h : "div";
  return JA.createElement(M, Object.assign({ ref: Q }, h, { onFocusCapture: Z.onFocusCapture, onBlurCapture: Z.onBlurCapture, onPointerDownCapture: P.onPointerDownCapture, style: Object.assign({ pointerEvents: L.pointerStyle }, h.style) }), r);
}), th = Math.min, a8 = Math.max, o8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, s8 = {
  start: "end",
  end: "start"
};
function rh(e, A, t) {
  return a8(e, th(A, t));
}
function xl(e, A) {
  return typeof e == "function" ? e(A) : e;
}
function Wa(e) {
  return e.split("-")[0];
}
function kl(e) {
  return e.split("-")[1];
}
function XD(e) {
  return e === "x" ? "y" : "x";
}
function AC(e) {
  return e === "y" ? "height" : "width";
}
function Wo(e) {
  return ["top", "bottom"].includes(Wa(e)) ? "y" : "x";
}
function eC(e) {
  return XD(Wo(e));
}
function l8(e, A, t) {
  t === void 0 && (t = !1);
  const r = kl(e), n = eC(e), i = AC(n);
  let a = n === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return A.reference[i] > A.floating[i] && (a = Pc(a)), [a, Pc(a)];
}
function u8(e) {
  const A = Pc(e);
  return [nh(e), A, nh(A)];
}
function nh(e) {
  return e.replace(/start|end/g, (A) => s8[A]);
}
function c8(e, A, t) {
  const r = ["left", "right"], n = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? A ? n : r : A ? r : n;
    case "left":
    case "right":
      return A ? i : a;
    default:
      return [];
  }
}
function g8(e, A, t, r) {
  const n = kl(e);
  let i = c8(Wa(e), t === "start", r);
  return n && (i = i.map((a) => a + "-" + n), A && (i = i.concat(i.map(nh)))), i;
}
function Pc(e) {
  return e.replace(/left|right|bottom|top/g, (A) => o8[A]);
}
function B8(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function qD(e) {
  return typeof e != "number" ? B8(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function zc(e) {
  const {
    x: A,
    y: t,
    width: r,
    height: n
  } = e;
  return {
    width: r,
    height: n,
    top: t,
    left: A,
    right: A + r,
    bottom: t + n,
    x: A,
    y: t
  };
}
function w1(e, A, t) {
  let {
    reference: r,
    floating: n
  } = e;
  const i = Wo(A), a = eC(A), o = AC(a), s = Wa(A), l = i === "y", u = r.x + r.width / 2 - n.width / 2, g = r.y + r.height / 2 - n.height / 2, d = r[o] / 2 - n[o] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: u,
        y: r.y - n.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: g
      };
      break;
    case "left":
      h = {
        x: r.x - n.width,
        y: g
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (kl(A)) {
    case "start":
      h[a] -= d * (t && l ? -1 : 1);
      break;
    case "end":
      h[a] += d * (t && l ? -1 : 1);
      break;
  }
  return h;
}
const f8 = async (e, A, t) => {
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: a
  } = t, o = i.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(A));
  let l = await a.getElementRects({
    reference: e,
    floating: A,
    strategy: n
  }), {
    x: u,
    y: g
  } = w1(l, r, s), d = r, h = {}, C = 0;
  for (let E = 0; E < o.length; E++) {
    const {
      name: I,
      fn: b
    } = o[E], {
      x: y,
      y: p,
      data: Q,
      reset: w
    } = await b({
      x: u,
      y: g,
      initialPlacement: r,
      placement: d,
      strategy: n,
      middlewareData: h,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: A
      }
    });
    u = y ?? u, g = p ?? g, h = {
      ...h,
      [I]: {
        ...h[I],
        ...Q
      }
    }, w && C <= 50 && (C++, typeof w == "object" && (w.placement && (d = w.placement), w.rects && (l = w.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: A,
      strategy: n
    }) : w.rects), {
      x: u,
      y: g
    } = w1(l, d, s)), E = -1);
  }
  return {
    x: u,
    y: g,
    placement: d,
    strategy: n,
    middlewareData: h
  };
};
async function $D(e, A) {
  var t;
  A === void 0 && (A = {});
  const {
    x: r,
    y: n,
    platform: i,
    rects: a,
    elements: o,
    strategy: s
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: g = "floating",
    altBoundary: d = !1,
    padding: h = 0
  } = xl(A, e), C = qD(h), I = o[d ? g === "floating" ? "reference" : "floating" : g], b = zc(await i.getClippingRect({
    element: (t = await (i.isElement == null ? void 0 : i.isElement(I))) == null || t ? I : I.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: s
  })), y = g === "floating" ? {
    x: r,
    y: n,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, p = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), Q = await (i.isElement == null ? void 0 : i.isElement(p)) ? await (i.getScale == null ? void 0 : i.getScale(p)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = zc(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: y,
    offsetParent: p,
    strategy: s
  }) : y);
  return {
    top: (b.top - w.top + C.top) / Q.y,
    bottom: (w.bottom - b.bottom + C.bottom) / Q.y,
    left: (b.left - w.left + C.left) / Q.x,
    right: (w.right - b.right + C.right) / Q.x
  };
}
const d8 = (e) => ({
  name: "arrow",
  options: e,
  async fn(A) {
    const {
      x: t,
      y: r,
      placement: n,
      rects: i,
      platform: a,
      elements: o,
      middlewareData: s
    } = A, {
      element: l,
      padding: u = 0
    } = xl(e, A) || {};
    if (l == null)
      return {};
    const g = qD(u), d = {
      x: t,
      y: r
    }, h = eC(n), C = AC(h), E = await a.getDimensions(l), I = h === "y", b = I ? "top" : "left", y = I ? "bottom" : "right", p = I ? "clientHeight" : "clientWidth", Q = i.reference[C] + i.reference[h] - d[h] - i.floating[C], w = d[h] - i.reference[h], Y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let k = Y ? Y[p] : 0;
    (!k || !await (a.isElement == null ? void 0 : a.isElement(Y))) && (k = o.floating[p] || i.floating[C]);
    const L = Q / 2 - w / 2, S = k / 2 - E[C] / 2 - 1, P = th(g[b], S), Z = th(g[y], S), M = P, R = k - E[C] - Z, G = k / 2 - E[C] / 2 + L, N = rh(M, G, R), z = !s.arrow && kl(n) != null && G !== N && i.reference[C] / 2 - (G < M ? P : Z) - E[C] / 2 < 0, T = z ? G < M ? G - M : G - R : 0;
    return {
      [h]: d[h] + T,
      data: {
        [h]: N,
        centerOffset: G - N - T,
        ...z && {
          alignmentOffset: T
        }
      },
      reset: z
    };
  }
}), h8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(A) {
      var t, r;
      const {
        placement: n,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: s,
        elements: l
      } = A, {
        mainAxis: u = !0,
        crossAxis: g = !0,
        fallbackPlacements: d,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: E = !0,
        ...I
      } = xl(e, A);
      if ((t = i.arrow) != null && t.alignmentOffset)
        return {};
      const b = Wa(n), y = Wo(o), p = Wa(o) === o, Q = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), w = d || (p || !E ? [Pc(o)] : u8(o)), Y = C !== "none";
      !d && Y && w.push(...g8(o, E, C, Q));
      const k = [o, ...w], L = await $D(A, I), S = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && S.push(L[b]), g) {
        const G = l8(n, a, Q);
        S.push(L[G[0]], L[G[1]]);
      }
      if (P = [...P, {
        placement: n,
        overflows: S
      }], !S.every((G) => G <= 0)) {
        var Z, M;
        const G = (((Z = i.flip) == null ? void 0 : Z.index) || 0) + 1, N = k[G];
        if (N)
          return {
            data: {
              index: G,
              overflows: P
            },
            reset: {
              placement: N
            }
          };
        let z = (M = P.filter((T) => T.overflows[0] <= 0).sort((T, O) => T.overflows[1] - O.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!z)
          switch (h) {
            case "bestFit": {
              var R;
              const T = (R = P.filter((O) => {
                if (Y) {
                  const K = Wo(O.placement);
                  return K === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  K === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((K) => K > 0).reduce((K, AA) => K + AA, 0)]).sort((O, K) => O[1] - K[1])[0]) == null ? void 0 : R[0];
              T && (z = T);
              break;
            }
            case "initialPlacement":
              z = o;
              break;
          }
        if (n !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
};
async function C8(e, A) {
  const {
    placement: t,
    platform: r,
    elements: n
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(n.floating)), a = Wa(t), o = kl(t), s = Wo(t) === "y", l = ["left", "top"].includes(a) ? -1 : 1, u = i && s ? -1 : 1, g = xl(A, e);
  let {
    mainAxis: d,
    crossAxis: h,
    alignmentAxis: C
  } = typeof g == "number" ? {
    mainAxis: g,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: g.mainAxis || 0,
    crossAxis: g.crossAxis || 0,
    alignmentAxis: g.alignmentAxis
  };
  return o && typeof C == "number" && (h = o === "end" ? C * -1 : C), s ? {
    x: h * u,
    y: d * l
  } : {
    x: d * l,
    y: h * u
  };
}
const E8 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(A) {
      var t, r;
      const {
        x: n,
        y: i,
        placement: a,
        middlewareData: o
      } = A, s = await C8(A, e);
      return a === ((t = o.offset) == null ? void 0 : t.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: n + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, Q8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(A) {
      const {
        x: t,
        y: r,
        placement: n
      } = A, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: o = {
          fn: (I) => {
            let {
              x: b,
              y
            } = I;
            return {
              x: b,
              y
            };
          }
        },
        ...s
      } = xl(e, A), l = {
        x: t,
        y: r
      }, u = await $D(A, s), g = Wo(Wa(n)), d = XD(g);
      let h = l[d], C = l[g];
      if (i) {
        const I = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", y = h + u[I], p = h - u[b];
        h = rh(y, h, p);
      }
      if (a) {
        const I = g === "y" ? "top" : "left", b = g === "y" ? "bottom" : "right", y = C + u[I], p = C - u[b];
        C = rh(y, C, p);
      }
      const E = o.fn({
        ...A,
        [d]: h,
        [g]: C
      });
      return {
        ...E,
        data: {
          x: E.x - t,
          y: E.y - r,
          enabled: {
            [d]: i,
            [g]: a
          }
        }
      };
    }
  };
}, ih = Math.min, Ho = Math.max, jc = Math.round, Lu = Math.floor, Oi = (e) => ({
  x: e,
  y: e
});
function vg() {
  return typeof window < "u";
}
function as(e) {
  return A4(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Cn(e) {
  var A;
  return (e == null || (A = e.ownerDocument) == null ? void 0 : A.defaultView) || window;
}
function H0(e) {
  var A;
  return (A = (A4(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : A.documentElement;
}
function A4(e) {
  return vg() ? e instanceof Node || e instanceof Cn(e).Node : !1;
}
function Kn(e) {
  return vg() ? e instanceof Element || e instanceof Cn(e).Element : !1;
}
function F0(e) {
  return vg() ? e instanceof HTMLElement || e instanceof Cn(e).HTMLElement : !1;
}
function I1(e) {
  return !vg() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Cn(e).ShadowRoot;
}
function Ul(e) {
  const {
    overflow: A,
    overflowX: t,
    overflowY: r,
    display: n
  } = _n(e);
  return /auto|scroll|overlay|hidden|clip/.test(A + r + t) && !["inline", "contents"].includes(n);
}
function w8(e) {
  return ["table", "td", "th"].includes(as(e));
}
function yg(e) {
  return [":popover-open", ":modal"].some((A) => {
    try {
      return e.matches(A);
    } catch {
      return !1;
    }
  });
}
function tC(e) {
  const A = rC(), t = Kn(e) ? _n(e) : e;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !A && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !A && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function I8(e) {
  let A = Ji(e);
  for (; F0(A) && !Zo(A); ) {
    if (tC(A))
      return A;
    if (yg(A))
      return null;
    A = Ji(A);
  }
  return null;
}
function rC() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Zo(e) {
  return ["html", "body", "#document"].includes(as(e));
}
function _n(e) {
  return Cn(e).getComputedStyle(e);
}
function bg(e) {
  return Kn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ji(e) {
  if (as(e) === "html")
    return e;
  const A = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    I1(e) && e.host || // Fallback.
    H0(e)
  );
  return I1(A) ? A.host : A;
}
function e4(e) {
  const A = Ji(e);
  return Zo(A) ? e.ownerDocument ? e.ownerDocument.body : e.body : F0(A) && Ul(A) ? A : e4(A);
}
function cl(e, A, t) {
  var r;
  A === void 0 && (A = []), t === void 0 && (t = !0);
  const n = e4(e), i = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Cn(n);
  if (i) {
    const o = ah(a);
    return A.concat(a, a.visualViewport || [], Ul(n) ? n : [], o && t ? cl(o) : []);
  }
  return A.concat(n, cl(n, [], t));
}
function ah(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function t4(e) {
  const A = _n(e);
  let t = parseFloat(A.width) || 0, r = parseFloat(A.height) || 0;
  const n = F0(e), i = n ? e.offsetWidth : t, a = n ? e.offsetHeight : r, o = jc(t) !== i || jc(r) !== a;
  return o && (t = i, r = a), {
    width: t,
    height: r,
    $: o
  };
}
function nC(e) {
  return Kn(e) ? e : e.contextElement;
}
function So(e) {
  const A = nC(e);
  if (!F0(A))
    return Oi(1);
  const t = A.getBoundingClientRect(), {
    width: r,
    height: n,
    $: i
  } = t4(A);
  let a = (i ? jc(t.width) : t.width) / r, o = (i ? jc(t.height) : t.height) / n;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const D8 = /* @__PURE__ */ Oi(0);
function r4(e) {
  const A = Cn(e);
  return !rC() || !A.visualViewport ? D8 : {
    x: A.visualViewport.offsetLeft,
    y: A.visualViewport.offsetTop
  };
}
function m8(e, A, t) {
  return A === void 0 && (A = !1), !t || A && t !== Cn(e) ? !1 : A;
}
function Za(e, A, t, r) {
  A === void 0 && (A = !1), t === void 0 && (t = !1);
  const n = e.getBoundingClientRect(), i = nC(e);
  let a = Oi(1);
  A && (r ? Kn(r) && (a = So(r)) : a = So(e));
  const o = m8(i, t, r) ? r4(i) : Oi(0);
  let s = (n.left + o.x) / a.x, l = (n.top + o.y) / a.y, u = n.width / a.x, g = n.height / a.y;
  if (i) {
    const d = Cn(i), h = r && Kn(r) ? Cn(r) : r;
    let C = d, E = ah(C);
    for (; E && r && h !== C; ) {
      const I = So(E), b = E.getBoundingClientRect(), y = _n(E), p = b.left + (E.clientLeft + parseFloat(y.paddingLeft)) * I.x, Q = b.top + (E.clientTop + parseFloat(y.paddingTop)) * I.y;
      s *= I.x, l *= I.y, u *= I.x, g *= I.y, s += p, l += Q, C = Cn(E), E = ah(C);
    }
  }
  return zc({
    width: u,
    height: g,
    x: s,
    y: l
  });
}
function M8(e) {
  let {
    elements: A,
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const i = n === "fixed", a = H0(r), o = A ? yg(A.floating) : !1;
  if (r === a || o && i)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Oi(1);
  const u = Oi(0), g = F0(r);
  if ((g || !g && !i) && ((as(r) !== "body" || Ul(a)) && (s = bg(r)), F0(r))) {
    const d = Za(r);
    l = So(r), u.x = d.x + r.clientLeft, u.y = d.y + r.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - s.scrollLeft * l.x + u.x,
    y: t.y * l.y - s.scrollTop * l.y + u.y
  };
}
function p8(e) {
  return Array.from(e.getClientRects());
}
function oh(e, A) {
  const t = bg(e).scrollLeft;
  return A ? A.left + t : Za(H0(e)).left + t;
}
function v8(e) {
  const A = H0(e), t = bg(e), r = e.ownerDocument.body, n = Ho(A.scrollWidth, A.clientWidth, r.scrollWidth, r.clientWidth), i = Ho(A.scrollHeight, A.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -t.scrollLeft + oh(e);
  const o = -t.scrollTop;
  return _n(r).direction === "rtl" && (a += Ho(A.clientWidth, r.clientWidth) - n), {
    width: n,
    height: i,
    x: a,
    y: o
  };
}
function y8(e, A) {
  const t = Cn(e), r = H0(e), n = t.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, o = 0, s = 0;
  if (n) {
    i = n.width, a = n.height;
    const l = rC();
    (!l || l && A === "fixed") && (o = n.offsetLeft, s = n.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function b8(e, A) {
  const t = Za(e, !0, A === "fixed"), r = t.top + e.clientTop, n = t.left + e.clientLeft, i = F0(e) ? So(e) : Oi(1), a = e.clientWidth * i.x, o = e.clientHeight * i.y, s = n * i.x, l = r * i.y;
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function D1(e, A, t) {
  let r;
  if (A === "viewport")
    r = y8(e, t);
  else if (A === "document")
    r = v8(H0(e));
  else if (Kn(A))
    r = b8(A, t);
  else {
    const n = r4(e);
    r = {
      ...A,
      x: A.x - n.x,
      y: A.y - n.y
    };
  }
  return zc(r);
}
function n4(e, A) {
  const t = Ji(e);
  return t === A || !Kn(t) || Zo(t) ? !1 : _n(t).position === "fixed" || n4(t, A);
}
function F8(e, A) {
  const t = A.get(e);
  if (t)
    return t;
  let r = cl(e, [], !1).filter((o) => Kn(o) && as(o) !== "body"), n = null;
  const i = _n(e).position === "fixed";
  let a = i ? Ji(e) : e;
  for (; Kn(a) && !Zo(a); ) {
    const o = _n(a), s = tC(a);
    !s && o.position === "fixed" && (n = null), (i ? !s && !n : !s && o.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || Ul(a) && !s && n4(e, a)) ? r = r.filter((u) => u !== a) : n = o, a = Ji(a);
  }
  return A.set(e, r), r;
}
function L8(e) {
  let {
    element: A,
    boundary: t,
    rootBoundary: r,
    strategy: n
  } = e;
  const a = [...t === "clippingAncestors" ? yg(A) ? [] : F8(A, this._c) : [].concat(t), r], o = a[0], s = a.reduce((l, u) => {
    const g = D1(A, u, n);
    return l.top = Ho(g.top, l.top), l.right = ih(g.right, l.right), l.bottom = ih(g.bottom, l.bottom), l.left = Ho(g.left, l.left), l;
  }, D1(A, o, n));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function R8(e) {
  const {
    width: A,
    height: t
  } = t4(e);
  return {
    width: A,
    height: t
  };
}
function G8(e, A, t) {
  const r = F0(A), n = H0(A), i = t === "fixed", a = Za(e, !0, i, A);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Oi(0);
  if (r || !r && !i)
    if ((as(A) !== "body" || Ul(n)) && (o = bg(A)), r) {
      const h = Za(A, !0, i, A);
      s.x = h.x + A.clientLeft, s.y = h.y + A.clientTop;
    } else n && (s.x = oh(n));
  let l = 0, u = 0;
  if (n && !r && !i) {
    const h = n.getBoundingClientRect();
    u = h.top + o.scrollTop, l = h.left + o.scrollLeft - // RTL <body> scrollbar.
    oh(n, h);
  }
  const g = a.left + o.scrollLeft - s.x - l, d = a.top + o.scrollTop - s.y - u;
  return {
    x: g,
    y: d,
    width: a.width,
    height: a.height
  };
}
function af(e) {
  return _n(e).position === "static";
}
function m1(e, A) {
  if (!F0(e) || _n(e).position === "fixed")
    return null;
  if (A)
    return A(e);
  let t = e.offsetParent;
  return H0(e) === t && (t = t.ownerDocument.body), t;
}
function i4(e, A) {
  const t = Cn(e);
  if (yg(e))
    return t;
  if (!F0(e)) {
    let n = Ji(e);
    for (; n && !Zo(n); ) {
      if (Kn(n) && !af(n))
        return n;
      n = Ji(n);
    }
    return t;
  }
  let r = m1(e, A);
  for (; r && w8(r) && af(r); )
    r = m1(r, A);
  return r && Zo(r) && af(r) && !tC(r) ? t : r || I8(e) || t;
}
const x8 = async function(e) {
  const A = this.getOffsetParent || i4, t = this.getDimensions, r = await t(e.floating);
  return {
    reference: G8(e.reference, await A(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function k8(e) {
  return _n(e).direction === "rtl";
}
const U8 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: M8,
  getDocumentElement: H0,
  getClippingRect: L8,
  getOffsetParent: i4,
  getElementRects: x8,
  getClientRects: p8,
  getDimensions: R8,
  getScale: So,
  isElement: Kn,
  isRTL: k8
};
function Y8(e, A) {
  let t = null, r;
  const n = H0(e);
  function i() {
    var o;
    clearTimeout(r), (o = t) == null || o.disconnect(), t = null;
  }
  function a(o, s) {
    o === void 0 && (o = !1), s === void 0 && (s = 1), i();
    const {
      left: l,
      top: u,
      width: g,
      height: d
    } = e.getBoundingClientRect();
    if (o || A(), !g || !d)
      return;
    const h = Lu(u), C = Lu(n.clientWidth - (l + g)), E = Lu(n.clientHeight - (u + d)), I = Lu(l), y = {
      rootMargin: -h + "px " + -C + "px " + -E + "px " + -I + "px",
      threshold: Ho(0, ih(1, s)) || 1
    };
    let p = !0;
    function Q(w) {
      const Y = w[0].intersectionRatio;
      if (Y !== s) {
        if (!p)
          return a();
        Y ? a(!1, Y) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      p = !1;
    }
    try {
      t = new IntersectionObserver(Q, {
        ...y,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(Q, y);
    }
    t.observe(e);
  }
  return a(!0), i;
}
function H8(e, A, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = r, l = nC(e), u = n || i ? [...l ? cl(l) : [], ...cl(A)] : [];
  u.forEach((b) => {
    n && b.addEventListener("scroll", t, {
      passive: !0
    }), i && b.addEventListener("resize", t);
  });
  const g = l && o ? Y8(l, t) : null;
  let d = -1, h = null;
  a && (h = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === l && h && (h.unobserve(A), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var p;
      (p = h) == null || p.observe(A);
    })), t();
  }), l && !s && h.observe(l), h.observe(A));
  let C, E = s ? Za(e) : null;
  s && I();
  function I() {
    const b = Za(e);
    E && (b.x !== E.x || b.y !== E.y || b.width !== E.width || b.height !== E.height) && t(), E = b, C = requestAnimationFrame(I);
  }
  return t(), () => {
    var b;
    u.forEach((y) => {
      n && y.removeEventListener("scroll", t), i && y.removeEventListener("resize", t);
    }), g == null || g(), (b = h) == null || b.disconnect(), h = null, s && cancelAnimationFrame(C);
  };
}
const S8 = E8, N8 = Q8, T8 = h8, M1 = d8, P8 = (e, A, t) => {
  const r = /* @__PURE__ */ new Map(), n = {
    platform: U8,
    ...t
  }, i = {
    ...n.platform,
    _c: r
  };
  return f8(e, A, {
    ...n,
    platform: i
  });
};
var fc = typeof document < "u" ? Jh : Wt;
function Vc(e, A) {
  if (e === A)
    return !0;
  if (typeof e != typeof A)
    return !1;
  if (typeof e == "function" && e.toString() === A.toString())
    return !0;
  let t, r, n;
  if (e && A && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== A.length) return !1;
      for (r = t; r-- !== 0; )
        if (!Vc(e[r], A[r]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), t = n.length, t !== Object.keys(A).length)
      return !1;
    for (r = t; r-- !== 0; )
      if (!{}.hasOwnProperty.call(A, n[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      const i = n[r];
      if (!(i === "_owner" && e.$$typeof) && !Vc(e[i], A[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && A !== A;
}
function a4(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function p1(e, A) {
  const t = a4(e);
  return Math.round(A * t) / t;
}
function of(e) {
  const A = fe.useRef(e);
  return fc(() => {
    A.current = e;
  }), A;
}
function z8(e) {
  e === void 0 && (e = {});
  const {
    placement: A = "bottom",
    strategy: t = "absolute",
    middleware: r = [],
    platform: n,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: o = !0,
    whileElementsMounted: s,
    open: l
  } = e, [u, g] = fe.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: A,
    middlewareData: {},
    isPositioned: !1
  }), [d, h] = fe.useState(r);
  Vc(d, r) || h(r);
  const [C, E] = fe.useState(null), [I, b] = fe.useState(null), y = fe.useCallback((O) => {
    O !== Y.current && (Y.current = O, E(O));
  }, []), p = fe.useCallback((O) => {
    O !== k.current && (k.current = O, b(O));
  }, []), Q = i || C, w = a || I, Y = fe.useRef(null), k = fe.useRef(null), L = fe.useRef(u), S = s != null, P = of(s), Z = of(n), M = of(l), R = fe.useCallback(() => {
    if (!Y.current || !k.current)
      return;
    const O = {
      placement: A,
      strategy: t,
      middleware: d
    };
    Z.current && (O.platform = Z.current), P8(Y.current, k.current, O).then((K) => {
      const AA = {
        ...K,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: M.current !== !1
      };
      G.current && !Vc(L.current, AA) && (L.current = AA, zb.flushSync(() => {
        g(AA);
      }));
    });
  }, [d, A, t, Z, M]);
  fc(() => {
    l === !1 && L.current.isPositioned && (L.current.isPositioned = !1, g((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [l]);
  const G = fe.useRef(!1);
  fc(() => (G.current = !0, () => {
    G.current = !1;
  }), []), fc(() => {
    if (Q && (Y.current = Q), w && (k.current = w), Q && w) {
      if (P.current)
        return P.current(Q, w, R);
      R();
    }
  }, [Q, w, R, P, S]);
  const N = fe.useMemo(() => ({
    reference: Y,
    floating: k,
    setReference: y,
    setFloating: p
  }), [y, p]), z = fe.useMemo(() => ({
    reference: Q,
    floating: w
  }), [Q, w]), T = fe.useMemo(() => {
    const O = {
      position: t,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return O;
    const K = p1(z.floating, u.x), AA = p1(z.floating, u.y);
    return o ? {
      ...O,
      transform: "translate(" + K + "px, " + AA + "px)",
      ...a4(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: K,
      top: AA
    };
  }, [t, o, z.floating, u.x, u.y]);
  return fe.useMemo(() => ({
    ...u,
    update: R,
    refs: N,
    elements: z,
    floatingStyles: T
  }), [u, R, N, z, T]);
}
const j8 = (e) => {
  function A(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: r,
        padding: n
      } = typeof e == "function" ? e(t) : e;
      return r && A(r) ? r.current != null ? M1({
        element: r.current,
        padding: n
      }).fn(t) : {} : r ? M1({
        element: r,
        padding: n
      }).fn(t) : {};
    }
  };
}, V8 = (e, A) => ({
  ...S8(e),
  options: [e, A]
}), O8 = (e, A) => ({
  ...N8(e),
  options: [e, A]
}), J8 = (e, A) => ({
  ...T8(e),
  options: [e, A]
}), W8 = (e, A) => ({
  ...j8(e),
  options: [e, A]
}), v1 = /(\w+)/g;
function Z8(e, A) {
  const t = Array.isArray(e) ? e : K8(e);
  for (const r of A) {
    if (!r)
      continue;
    let n = r;
    for (let i = 0; i < t.length; i++) {
      const a = n[t[i]];
      a !== void 0 && (n = a);
    }
    if (typeof n == "string")
      return n;
  }
  throw new Error(`Error translating key. Keypath '${e}' does not resolve to a string.`);
}
function K8(e) {
  const A = [];
  let t = v1.exec(e);
  for (; t; ) {
    const [, r, n] = t;
    A.push(r || n), t = v1.exec(e);
  }
  return A;
}
const _8 = /{[^}]*}/g;
function Yl(e, ...A) {
  const t = WD(), r = t.translations || [], n = [
    ...A,
    ...Array.isArray(r) ? r.map((a) => a[e]) : [r[e]],
    t.locale[e]
  ];
  return (a, o) => {
    const s = Z8(a, n);
    return o ? s.replace(_8, (l) => {
      const u = l.substring(1, l.length - 1);
      if (o[u] === void 0) {
        const g = JSON.stringify(o);
        throw new Error(`Error translating key '${a}'. No replacement syntax ({}) found for key '${u}'. The following replacements were passed: '${g}'`);
      }
      return o[u];
    }) : s;
  };
}
var X8 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const iC = At((e, A) => {
  var { className: t, size: r = "medium", title: n, transparent: i = !1, variant: a = "neutral", id: o } = e, s = X8(e, ["className", "size", "title", "transparent", "variant", "id"]);
  const l = Ja(), u = Yl("Loader");
  return JA.createElement(
    "svg",
    Object.assign({ "aria-labelledby": o ?? `loader-${l}`, ref: A, className: ct("navds-loader", t, `navds-loader--${r}`, `navds-loader--${a}`, {
      "navds-loader--transparent": i
    }), focusable: "false", viewBox: "0 0 50 50", preserveAspectRatio: "xMidYMid" }, Oa(s, ["children"])),
    JA.createElement("title", { id: o ?? `loader-${l}` }, n || u("title")),
    JA.createElement("circle", { className: "navds-loader__background", xmlns: "http://www.w3.org/2000/svg", cx: "25", cy: "25", r: "20", fill: "none" }),
    JA.createElement("circle", { className: "navds-loader__foreground", cx: "25", cy: "25", r: "20", fill: "none", strokeDasharray: "50 155" })
  );
});
var q8 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const o4 = At((e, A) => {
  var { as: t = "button", variant: r = "primary", className: n, children: i, size: a = "medium", loading: o = !1, disabled: s, icon: l, iconPosition: u = "left", onKeyUp: g } = e, d = q8(e, ["as", "variant", "className", "children", "size", "loading", "disabled", "icon", "iconPosition", "onKeyUp"]);
  const h = s || o ? Oa(d, ["href"]) : d, C = (E) => {
    E.key === " " && !s && !o && E.currentTarget.click();
  };
  return JA.createElement(
    t,
    Object.assign({}, t !== "button" ? { role: "button" } : {}, h, { ref: A, onKeyUp: Ni(g, C), className: ct(n, "navds-button", `navds-button--${r}`, `navds-button--${a}`, {
      "navds-button--loading": o,
      "navds-button--icon-only": !!l && !i,
      "navds-button--disabled": s ?? o
    }), disabled: s ?? o ? !0 : void 0 }),
    l && u === "left" && JA.createElement("span", { className: "navds-button__icon" }, l),
    o && JA.createElement(iC, { size: a }),
    i && JA.createElement(VD, { as: "span", size: a === "medium" ? "medium" : "small" }, i),
    l && u === "right" && JA.createElement("span", { className: "navds-button__icon" }, l)
  );
});
var $8 = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const AL = {
  error: gF,
  warning: iF,
  info: oF,
  success: X3
}, s4 = At((e, A) => {
  var { children: t, className: r, variant: n, size: i = "medium", fullWidth: a = !1, contentMaxWidth: o = !0, inline: s = !1, closeButton: l = !1, onClose: u } = e, g = $8(e, ["children", "className", "variant", "size", "fullWidth", "contentMaxWidth", "inline", "closeButton", "onClose"]);
  const d = Yl("Alert"), h = AL[n];
  return JA.createElement(
    "div",
    Object.assign({}, g, { ref: A, className: ct(r, "navds-alert", `navds-alert--${n}`, `navds-alert--${i}`, {
      "navds-alert--full-width": a,
      "navds-alert--inline": s,
      "navds-alert--close-button": l
    }) }),
    JA.createElement(h, { title: d(n), className: "navds-alert__icon" }),
    JA.createElement(H3, { as: "div", size: i, className: ct("navds-alert__wrapper", o && "navds-alert__wrapper--maxwidth") }, t),
    l && !s && JA.createElement(
      "div",
      { className: "navds-alert__button-wrapper" },
      JA.createElement(o4, { className: "navds-alert__button", size: "small", variant: "tertiary-neutral", onClick: u, type: "button", icon: JA.createElement(JD, { title: ["error", "warning"].includes(n) ? d("closeAlert") : d("closeMessage") }) })
    )
  );
});
var qs = function() {
  return qs = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (A[i] = t[i]);
    }
    return A;
  }, qs.apply(this, arguments);
};
var eL = Qn(void 0);
function tL() {
  var e = t0(eL);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
Qn(void 0);
At(function(e, A) {
  var t = tL(), r = t.classNames, n = t.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var a = i.join(" "), o = qs(qs({}, n.button_reset), n.button);
  return e.style && Object.assign(o, e.style), x.jsx("button", qs({}, e, { ref: A, type: "button", className: a, style: o }));
});
Qn(void 0);
Qn(void 0);
var L0;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(L0 || (L0 = {}));
L0.Selected;
L0.Disabled;
L0.Hidden;
L0.Today;
L0.RangeEnd;
L0.RangeMiddle;
L0.RangeStart;
L0.Outside;
Qn(void 0);
Qn(void 0);
Qn(void 0);
const l4 = Qn(null);
Qn({
  hasDropdown: !1,
  year: /* @__PURE__ */ new Date(),
  toYear: () => null,
  disabled: [],
  onSelect: () => null
});
Gl();
const rL = () => JA.createElement(OD, { "aria-hidden": !0, className: "navds-form-field__readonly-icon" }), u4 = () => JA.createElement(OD, { title: Yl("global")("readOnly"), className: "navds-form-field__readonly-icon" }), Oc = Qn(null);
var nL = {};
const c4 = (e, A) => {
  var t, r, n;
  const { size: i, error: a, errorId: o } = e, s = t0(Oc), l = Ja(), u = (t = e.id) !== null && t !== void 0 ? t : `${A}-${l}`, g = o ?? `${A}-error-${l}`, d = `${A}-description-${l}`, h = (s == null ? void 0 : s.disabled) || e.disabled, C = ((s == null ? void 0 : s.readOnly) || e.readOnly) && !h || void 0, E = !h && !C && !!(a || s != null && s.error), I = !h && !C && !!a && typeof a != "boolean", b = Object.assign({}, E ? { "aria-invalid": !0 } : {});
  return e != null && e.required && nL.NODE_ENV !== "production" && (console.warn("Aksel: Use of 'required' in form-elements is heavily discuouraged. Docs about why here:"), console.warn("https://aksel.nav.no/god-praksis/artikler/obligatoriske-og-valgfrie-skjemafelter#h3bfe00453471")), {
    showErrorMsg: I,
    hasError: E,
    errorId: g,
    inputDescriptionId: d,
    size: (r = i ?? (s == null ? void 0 : s.size)) !== null && r !== void 0 ? r : "medium",
    readOnly: C,
    inputProps: Object.assign(Object.assign({ id: u }, b), { "aria-describedby": ct(e["aria-describedby"], {
      [d]: !!(e != null && e.description) && typeof (e == null ? void 0 : e.description) == "string",
      [g]: I,
      [(n = s == null ? void 0 : s.errorId) !== null && n !== void 0 ? n : ""]: E && !!(s != null && s.error)
    }) || void 0, disabled: h })
  };
};
function iL(e) {
  var A;
  return (e == null || (A = e.ownerDocument) == null ? void 0 : A.defaultView) || window;
}
function vo(e) {
  return e instanceof Element || e instanceof iL(e).Element;
}
var aC = {}, Jc = typeof document < "u" ? Jh : Wt;
let sf = !1, aL = 0;
const y1 = () => "floating-ui-" + aL++;
function oL() {
  const [e, A] = fe.useState(() => sf ? y1() : void 0);
  return Jc(() => {
    e == null && A(y1());
  }, []), fe.useEffect(() => {
    sf || (sf = !0);
  }, []), e;
}
const sL = fe.useId, g4 = sL || oL;
function lL() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(A, t) {
      var r;
      (r = e.get(A)) == null || r.forEach((n) => n(t));
    },
    on(A, t) {
      e.set(A, [...e.get(A) || [], t]);
    },
    off(A, t) {
      var r;
      e.set(A, ((r = e.get(A)) == null ? void 0 : r.filter((n) => n !== t)) || []);
    }
  };
}
const uL = /* @__PURE__ */ fe.createContext(null), cL = () => fe.useContext(uL);
function gL(e) {
  return "data-floating-ui-" + e;
}
const BL = /* @__PURE__ */ fe.createContext(null);
function fL(e) {
  let {
    id: A,
    root: t
  } = e === void 0 ? {} : e;
  const [r, n] = fe.useState(null), i = g4(), a = dL(), o = fe.useMemo(() => ({
    id: A,
    root: t,
    portalContext: a,
    uniqueId: i
  }), [A, t, a, i]), s = fe.useRef();
  return Jc(() => () => {
    r == null || r.remove();
  }, [r, o]), Jc(() => {
    if (s.current === o) return;
    s.current = o;
    const {
      id: l,
      root: u,
      portalContext: g,
      uniqueId: d
    } = o, h = l ? document.getElementById(l) : null, C = gL("portal");
    if (h) {
      const E = document.createElement("div");
      E.id = d, E.setAttribute(C, ""), h.appendChild(E), n(E);
    } else {
      let E = u || (g == null ? void 0 : g.portalNode);
      E && !vo(E) && (E = E.current), E = E || document.body;
      let I = null;
      l && (I = document.createElement("div"), I.id = l, E.appendChild(I));
      const b = document.createElement("div");
      b.id = d, b.setAttribute(C, ""), E = I || E, E.appendChild(b), n(b);
    }
  }, [o]), r;
}
const dL = () => fe.useContext(BL), hL = fe.useInsertionEffect, CL = hL || ((e) => e());
function EL(e) {
  const A = fe.useRef(() => {
    if (aC.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return CL(() => {
    A.current = e;
  }), fe.useCallback(function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return A.current == null ? void 0 : A.current(...r);
  }, []);
}
let sh;
aC.NODE_ENV !== "production" && (sh = /* @__PURE__ */ new Set());
function QL(e) {
  var A;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: r,
    nodeId: n
  } = e;
  if (aC.NODE_ENV !== "production") {
    var i;
    const k = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((i = e.elements) != null && i.reference && !vo(e.elements.reference)) {
      var a;
      if (!((a = sh) != null && a.has(k))) {
        var o;
        (o = sh) == null || o.add(k), console.error(k);
      }
    }
  }
  const [s, l] = fe.useState(null), u = ((A = e.elements) == null ? void 0 : A.reference) || s, g = z8(e), d = cL(), h = EL((k, L) => {
    k && (E.current.openEvent = L), r == null || r(k, L);
  }), C = fe.useRef(null), E = fe.useRef({}), I = fe.useState(() => lL())[0], b = g4(), y = fe.useCallback((k) => {
    const L = vo(k) ? {
      getBoundingClientRect: () => k.getBoundingClientRect(),
      contextElement: k
    } : k;
    g.refs.setReference(L);
  }, [g.refs]), p = fe.useCallback((k) => {
    (vo(k) || k === null) && (C.current = k, l(k)), (vo(g.refs.reference.current) || g.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    k !== null && !vo(k)) && g.refs.setReference(k);
  }, [g.refs]), Q = fe.useMemo(() => ({
    ...g.refs,
    setReference: p,
    setPositionReference: y,
    domReference: C
  }), [g.refs, p, y]), w = fe.useMemo(() => ({
    ...g.elements,
    domReference: u
  }), [g.elements, u]), Y = fe.useMemo(() => ({
    ...g,
    refs: Q,
    elements: w,
    dataRef: E,
    nodeId: n,
    floatingId: b,
    events: I,
    open: t,
    onOpenChange: h
  }), [g, n, b, I, t, h, Q, w]);
  return Jc(() => {
    const k = d == null ? void 0 : d.nodesRef.current.find((L) => L.id === n);
    k && (k.context = Y);
  }), fe.useMemo(() => ({
    ...g,
    context: Y,
    refs: Q,
    elements: w
  }), [g, Q, w, Y]);
}
var wL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const IL = At((e, A) => {
  var { className: t } = e, r = wL(e, ["className"]);
  return JA.createElement("div", Object.assign({}, r, { ref: A, className: ct("navds-modal__body", t) }));
});
var DL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const mL = At((e, A) => {
  var { className: t } = e, r = DL(e, ["className"]);
  return JA.createElement("div", Object.assign({}, r, { ref: A, className: ct("navds-modal__footer", t) }));
});
var ML = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const B4 = At((e, A) => {
  var { children: t, className: r, closeButton: n = !0 } = e, i = ML(e, ["children", "className", "closeButton"]);
  const a = $h(), o = Yl("global");
  return JA.createElement(
    "div",
    Object.assign({}, i, { ref: A, className: ct("navds-modal__header", r) }),
    a.closeHandler && n && JA.createElement(o4, { type: "button", className: "navds-modal__button", size: "small", variant: "tertiary-neutral", onKeyDown: (s) => {
      ["Enter", " "].includes(s.key) && s.repeat && s.preventDefault();
    }, onClick: a.closeHandler, icon: JA.createElement(JD, { title: o("close") }) }),
    t
  );
}), b1 = ({ clientX: e, clientY: A }, { left: t, top: r, right: n, bottom: i }) => !(e < t || A < r || e > n || A > i);
function pL(e, A, t) {
  if (!(A && A.closeButton === !1))
    return t ? () => {
      var r;
      return t() !== !1 && ((r = e.current) === null || r === void 0 ? void 0 : r.close());
    } : () => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.close();
    };
}
const Ru = "navds-modal__document-body";
function vL(e, A, t) {
  JA.useEffect(() => {
    if (t || !e.current || !A)
      return;
    e.current.open && document.body.classList.add(Ru);
    const r = new MutationObserver(() => {
      var n;
      !((n = e.current) === null || n === void 0) && n.open ? document.body.classList.add(Ru) : document.body.classList.remove(Ru);
    });
    return r.observe(e.current, {
      attributes: !0,
      attributeFilter: ["open"]
    }), () => {
      r.disconnect(), document.body.classList.remove(Ru);
    };
  }, [e, A, t]);
}
const Lo = typeof window < "u" && (window.HTMLDialogElement === void 0 || navigator.userAgent.includes("jsdom"));
function f4(e, A) {
  var t = "on" + A.type.toLowerCase();
  return typeof e[t] == "function" && e[t](A), e.dispatchEvent(A);
}
function $s(e) {
  for (; e; ) {
    if (e.localName === "dialog")
      return (
        /** @type {HTMLDialogElement} */
        e
      );
    e.parentElement ? e = e.parentElement : e.parentNode ? e = e.parentNode.host : e = null;
  }
  return null;
}
function d4(e) {
  for (; e && e.shadowRoot && e.shadowRoot.activeElement; )
    e = e.shadowRoot.activeElement;
  e && e.blur && e !== document.body && e.blur();
}
function yL(e, A) {
  for (var t = 0; t < e.length; ++t)
    if (e[t] === A)
      return !0;
  return !1;
}
function lf(e) {
  return !e || !e.hasAttribute("method") ? !1 : e.getAttribute("method").toLowerCase() === "dialog";
}
function h4(e) {
  var A = ["button", "input", "keygen", "select", "textarea"], t = A.map(function(a) {
    return a + ":not([disabled])";
  });
  t.push('[tabindex]:not([disabled]):not([tabindex=""])');
  var r = e.querySelector(t.join(", "));
  if (!r && "attachShadow" in Element.prototype)
    for (var n = e.querySelectorAll("*"), i = 0; i < n.length && !(n[i].tagName && n[i].shadowRoot && (r = h4(n[i].shadowRoot), r)); i++)
      ;
  return r;
}
function F1(e) {
  return e.isConnected || document.body.contains(e);
}
function C4(e) {
  if (e.submitter)
    return e.submitter;
  var A = e.target;
  if (!(A instanceof HTMLFormElement))
    return null;
  var t = mt.formSubmitter;
  if (!t) {
    var r = e.target, n = "getRootNode" in r && r.getRootNode() || document;
    t = n.activeElement;
  }
  return !t || t.form !== A ? null : t;
}
function bL(e) {
  if (!e.defaultPrevented) {
    var A = (
      /** @type {!HTMLFormElement} */
      e.target
    ), t = mt.imagemapUseValue, r = C4(e);
    t === null && r && (t = r.value);
    var n = $s(A);
    if (n) {
      var i = r && r.getAttribute("formmethod") || A.getAttribute("method");
      i === "dialog" && (e.preventDefault(), t != null ? n.close(t) : n.close());
    }
  }
}
function E4(e) {
  if (this.dialog_ = e, this.replacedStyleTop_ = !1, this.openAsModal_ = !1, e.hasAttribute("role") || e.setAttribute("role", "dialog"), e.show = this.show.bind(this), e.showModal = this.showModal.bind(this), e.close = this.close.bind(this), e.addEventListener("submit", bL, !1), "returnValue" in e || (e.returnValue = ""), "MutationObserver" in window) {
    var A = new MutationObserver(this.maybeHideModal.bind(this));
    A.observe(e, { attributes: !0, attributeFilter: ["open"] });
  } else {
    var t = !1, r = (function() {
      t ? this.downgradeModal() : this.maybeHideModal(), t = !1;
    }).bind(this), n, i = function(a) {
      if (a.target === e) {
        var o = "DOMNodeRemoved";
        t |= a.type.substr(0, o.length) === o, window.clearTimeout(n), n = window.setTimeout(r, 0);
      }
    };
    ["DOMAttrModified", "DOMNodeRemoved", "DOMNodeRemovedFromDocument"].forEach(function(a) {
      e.addEventListener(a, i);
    });
  }
  Object.defineProperty(e, "open", {
    set: this.setOpen.bind(this),
    get: e.hasAttribute.bind(e, "open")
  }), this.backdrop_ = document.createElement("div"), this.backdrop_.className = "backdrop", this.backdrop_.addEventListener("mouseup", this.backdropMouseEvent_.bind(this)), this.backdrop_.addEventListener("mousedown", this.backdropMouseEvent_.bind(this)), this.backdrop_.addEventListener("click", this.backdropMouseEvent_.bind(this));
}
E4.prototype = /** @type {HTMLDialogElement.prototype} */
{
  get dialog() {
    return this.dialog_;
  },
  /**
   * Maybe remove this dialog from the modal top layer. This is called when
   * a modal dialog may no longer be tenable, e.g., when the dialog is no
   * longer open or is no longer part of the DOM.
   */
  maybeHideModal: function() {
    this.dialog_.hasAttribute("open") && F1(this.dialog_) || this.downgradeModal();
  },
  /**
   * Remove this dialog from the modal top layer, leaving it as a non-modal.
   */
  downgradeModal: function() {
    this.openAsModal_ && (this.openAsModal_ = !1, this.dialog_.style.zIndex = "", this.replacedStyleTop_ && (this.dialog_.style.top = "", this.replacedStyleTop_ = !1), this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_), mt.dm.removeDialog(this));
  },
  /**
   * @param {boolean} value whether to open or close this dialog
   */
  setOpen: function(e) {
    e ? this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "") : (this.dialog_.removeAttribute("open"), this.maybeHideModal());
  },
  /**
   * Handles mouse events ('mouseup', 'mousedown', 'click') on the fake .backdrop element, redirecting them as if
   * they were on the dialog itself.
   *
   * @param {!Event} e to redirect
   */
  backdropMouseEvent_: function(e) {
    if (this.dialog_.hasAttribute("tabindex"))
      this.dialog_.focus();
    else {
      var A = document.createElement("div");
      this.dialog_.insertBefore(A, this.dialog_.firstChild), A.tabIndex = -1, A.focus(), this.dialog_.removeChild(A);
    }
    var t = document.createEvent("MouseEvents");
    t.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), this.dialog_.dispatchEvent(t), e.stopPropagation();
  },
  /**
   * Focuses on the first focusable element within the dialog. This will always blur the current
   * focus, even if nothing within the dialog is found.
   */
  focus_: function() {
    var e = this.dialog_.querySelector("[autofocus]:not([disabled])");
    !e && this.dialog_.tabIndex >= 0 && (e = this.dialog_), e || (e = h4(this.dialog_)), d4(document.activeElement), e && e.focus();
  },
  /**
   * Sets the zIndex for the backdrop and dialog.
   *
   * @param {number} dialogZ
   * @param {number} backdropZ
   */
  updateZIndex: function(e, A) {
    if (e < A)
      throw new Error("dialogZ should never be < backdropZ");
    this.dialog_.style.zIndex = e, this.backdrop_.style.zIndex = A;
  },
  /**
   * Shows the dialog. If the dialog is already open, this does nothing.
   */
  show: function() {
    this.dialog_.open || (this.setOpen(!0), this.focus_());
  },
  /**
   * Show this dialog modally.
   */
  showModal: function() {
    if (this.dialog_.hasAttribute("open"))
      throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");
    if (!F1(this.dialog_))
      throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
    if (!mt.dm.pushDialog(this))
      throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");
    this.setOpen(!0), this.openAsModal_ = !0, mt.needsCentering(this.dialog_) ? (mt.reposition(this.dialog_), this.replacedStyleTop_ = !0) : this.replacedStyleTop_ = !1, this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling), this.focus_();
  },
  /**
   * Closes this HTMLDialogElement. This is optional vs clearing the open
   * attribute, however this fires a 'close' event.
   *
   * @param {string=} opt_returnValue to use as the returnValue
   */
  close: function(e) {
    if (!this.dialog_.hasAttribute("open"))
      throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");
    this.setOpen(!1), e !== void 0 && (this.dialog_.returnValue = e);
    var A = new window.CustomEvent("close", {
      bubbles: !1,
      cancelable: !1
    });
    f4(this.dialog_, A);
  }
};
var mt = {};
mt.reposition = function(e) {
  var A = document.body.scrollTop || document.documentElement.scrollTop, t = A + (window.innerHeight - e.offsetHeight) / 2;
  e.style.top = Math.max(A, t) + "px";
};
mt.isInlinePositionSetByStylesheet = function(e) {
  for (var A = 0; A < document.styleSheets.length; ++A) {
    var t = document.styleSheets[A], r = null;
    try {
      r = t.cssRules;
    } catch {
    }
    if (r)
      for (var n = 0; n < r.length; ++n) {
        var i = r[n], a = null;
        try {
          a = document.querySelectorAll(i.selectorText);
        } catch {
        }
        if (!(!a || !yL(a, e))) {
          var o = i.style.getPropertyValue("top"), s = i.style.getPropertyValue("bottom");
          if (o && o !== "auto" || s && s !== "auto")
            return !0;
        }
      }
  }
  return !1;
};
mt.needsCentering = function(e) {
  var A = window.getComputedStyle(e);
  return A.position !== "absolute" || e.style.top !== "auto" && e.style.top !== "" || e.style.bottom !== "auto" && e.style.bottom !== "" ? !1 : !mt.isInlinePositionSetByStylesheet(e);
};
mt.forceRegisterDialog = function(e) {
  if (e.showModal && console.warn("This browser already supports <dialog>, the polyfill may not work correctly", e), e.localName !== "dialog")
    throw new Error("Failed to register dialog: The element is not a dialog.");
  new E4(
    /** @type {!HTMLDialogElement} */
    e
  );
};
mt.registerDialog = function(e) {
  e.showModal || mt.forceRegisterDialog(e);
};
mt.DialogManager = function() {
  this.pendingDialogStack = [];
  var e = this.checkDOM_.bind(this);
  this.overlay = document.createElement("div"), this.overlay.className = "_dialog_overlay", this.overlay.addEventListener("click", (function(A) {
    this.forwardTab_ = void 0, A.stopPropagation(), e([]);
  }).bind(this)), this.handleKey_ = this.handleKey_.bind(this), this.handleFocus_ = this.handleFocus_.bind(this), this.zIndexLow_ = 1e5, this.zIndexHigh_ = 100150, this.forwardTab_ = void 0, "MutationObserver" in window && (this.mo_ = new MutationObserver(function(A) {
    var t = [];
    A.forEach(function(r) {
      for (var n = 0, i; i = r.removedNodes[n]; ++n)
        i instanceof Element && (i.localName === "dialog" && t.push(i), t = t.concat(i.querySelectorAll("dialog")));
    }), t.length && e(t);
  }));
};
mt.DialogManager.prototype.blockDocument = function() {
  document.documentElement.addEventListener("focus", this.handleFocus_, !0), document.addEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.observe(document, { childList: !0, subtree: !0 });
};
mt.DialogManager.prototype.unblockDocument = function() {
  document.documentElement.removeEventListener("focus", this.handleFocus_, !0), document.removeEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.disconnect();
};
mt.DialogManager.prototype.updateStacking = function() {
  for (var e = this.zIndexHigh_, A = 0, t; t = this.pendingDialogStack[A]; ++A)
    t.updateZIndex(--e, --e), A === 0 && (this.overlay.style.zIndex = --e);
  var r = this.pendingDialogStack[0];
  if (r) {
    var n = r.dialog.parentNode || document.body;
    n.appendChild(this.overlay);
  } else this.overlay.parentNode && this.overlay.parentNode.removeChild(this.overlay);
};
mt.DialogManager.prototype.containedByTopDialog_ = function(e) {
  for (; e = $s(e); ) {
    for (var A = 0, t; t = this.pendingDialogStack[A]; ++A)
      if (t.dialog === e)
        return A === 0;
    e = e.parentElement;
  }
  return !1;
};
mt.DialogManager.prototype.handleFocus_ = function(e) {
  var A = e.composedPath ? e.composedPath()[0] : e.target;
  if (!this.containedByTopDialog_(A) && document.activeElement !== document.documentElement && (e.preventDefault(), e.stopPropagation(), d4(
    /** @type {Element} */
    A
  ), this.forwardTab_ !== void 0)) {
    var t = this.pendingDialogStack[0], r = t.dialog, n = r.compareDocumentPosition(A);
    return n & Node.DOCUMENT_POSITION_PRECEDING && (this.forwardTab_ ? t.focus_() : A !== document.documentElement && document.documentElement.focus()), !1;
  }
};
mt.DialogManager.prototype.handleKey_ = function(e) {
  if (this.forwardTab_ = void 0, e.keyCode === 27) {
    e.preventDefault(), e.stopPropagation();
    var A = new window.CustomEvent("cancel", {
      bubbles: !1,
      cancelable: !0
    }), t = this.pendingDialogStack[0];
    t && f4(t.dialog, A) && t.dialog.close();
  } else e.keyCode === 9 && (this.forwardTab_ = !e.shiftKey);
};
mt.DialogManager.prototype.checkDOM_ = function(e) {
  var A = this.pendingDialogStack.slice();
  A.forEach(function(t) {
    e.indexOf(t.dialog) !== -1 ? t.downgradeModal() : t.maybeHideModal();
  });
};
mt.DialogManager.prototype.pushDialog = function(e) {
  var A = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
  return this.pendingDialogStack.length >= A ? !1 : (this.pendingDialogStack.unshift(e) === 1 && this.blockDocument(), this.updateStacking(), !0);
};
mt.DialogManager.prototype.removeDialog = function(e) {
  var A = this.pendingDialogStack.indexOf(e);
  A !== -1 && (this.pendingDialogStack.splice(A, 1), this.pendingDialogStack.length === 0 && this.unblockDocument(), this.updateStacking());
};
Lo && (mt.dm = new mt.DialogManager(), mt.formSubmitter = null, mt.imagemapUseValue = null);
if (Lo) {
  var L1 = document.createElement("form");
  if (L1.setAttribute("method", "dialog"), L1.method !== "dialog") {
    var Io = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");
    if (Io) {
      var FL = Io.get;
      Io.get = function() {
        return lf(this) ? "dialog" : FL.call(this);
      };
      var LL = Io.set;
      Io.set = function(e) {
        return typeof e == "string" && e.toLowerCase() === "dialog" ? this.setAttribute("method", e) : LL.call(this, e);
      }, Object.defineProperty(HTMLFormElement.prototype, "method", Io);
    }
  }
  document.addEventListener("click", function(e) {
    if (mt.formSubmitter = null, mt.imagemapUseValue = null, !e.defaultPrevented) {
      var A = (
        /** @type {Element} */
        e.target
      );
      if ("composedPath" in e) {
        var t = e.composedPath();
        A = t.shift() || A;
      }
      if (!(!A || !lf(A.form))) {
        var r = A.type === "submit" && ["button", "input"].indexOf(A.localName) > -1;
        if (!r) {
          if (!(A.localName === "input" && A.type === "image"))
            return;
          mt.imagemapUseValue = e.offsetX + "," + e.offsetY;
        }
        var n = $s(A);
        n && (mt.formSubmitter = A);
      }
    }
  }, !1), document.addEventListener("submit", function(e) {
    var A = e.target, t = $s(A);
    if (!t) {
      var r = C4(e), n = r && r.getAttribute("formmethod") || A.getAttribute("method");
      n === "dialog" && e.preventDefault();
    }
  });
  var RL = HTMLFormElement.prototype.submit, GL = function() {
    if (!lf(this))
      return RL.call(this);
    var e = $s(this);
    e && e.close();
  };
  HTMLFormElement.prototype.submit = GL;
}
var xL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const R1 = "navds-modal--polyfilled", No = At((e, A) => {
  var t, r, { header: n, children: i, open: a, onBeforeClose: o, onCancel: s, closeOnBackdropClick: l, width: u, placement: g, portal: d, className: h, "aria-labelledby": C, style: E, onClick: I, onMouseDown: b } = e, y = xL(e, ["header", "children", "open", "onBeforeClose", "onCancel", "closeOnBackdropClick", "width", "placement", "portal", "className", "aria-labelledby", "style", "onClick", "onMouseDown"]);
  const p = An(null), Q = Rl(p, A), w = Ja(), Y = (t = WD()) === null || t === void 0 ? void 0 : t.rootElement, k = fL({ root: Y }), L = t0(l4), S = $h(!1) !== void 0;
  S && !L && console.error("Modals should not be nested"), Wt(() => {
    Lo && p.current && k && (mt.registerDialog(p.current), p.current.classList.add(R1)), p.current && k && (p.current.autofocus = !0);
  }, [k]), Wt(() => {
    p.current && k && a !== void 0 && (a && !p.current.open ? p.current.showModal() : !a && p.current.open && p.current.close());
  }, [k, a]), vL(p, k, S);
  const P = typeof u == "string" && ["small", "medium"].includes(u), Z = ct("navds-modal", h, {
    [R1]: Lo,
    "navds-modal--autowidth": !u,
    [`navds-modal--${u}`]: P,
    "navds-modal--top": g === "top" && !Lo
  }), M = Object.assign(Object.assign({}, E), P ? {} : { width: u }), R = An({
    clientX: 0,
    clientY: 0
  }), G = (AA) => {
    R.current = AA;
  }, N = l && !Lo, z = (AA) => {
    if (AA.target !== p.current)
      return;
    const X = p.current.getBoundingClientRect();
    b1(R.current, X) || b1(AA, X) || o !== void 0 && o() === !1 || p.current.close();
  }, T = (AA) => {
    o && o() === !1 && AA.preventDefault();
  }, O = !C && !y["aria-label"] && n ? w : C, K = (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    JA.createElement(
      "dialog",
      Object.assign({}, y, { ref: Q, className: Z, style: M, onCancel: Ni(s, T), onClick: N ? Ni(I, z) : I, onMouseDown: N ? Ni(b, G) : b, "aria-labelledby": O }),
      JA.createElement(
        BF,
        { closeHandler: pL(p, n, o), ref: p },
        n && JA.createElement(
          B4,
          null,
          n.label && JA.createElement(T3, { className: "navds-modal__label" }, n.label),
          JA.createElement(
            Lr,
            { size: (r = n.size) !== null && r !== void 0 ? r : "medium", level: "1", id: w },
            n.icon && JA.createElement("span", { className: "navds-modal__header-icon" }, n.icon),
            n.heading
          )
        ),
        i
      )
    )
  );
  return d ? k ? Vb(K, k) : null : K;
});
No.Header = B4;
No.Body = IL;
No.Footer = mL;
var kL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const UL = At((e, A) => {
  var { className: t } = e, r = kL(e, ["className"]);
  return JA.createElement("div", Object.assign({}, r, { ref: A, className: ct("navds-popover__content", t) }));
});
var YL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const lh = At((e, A) => {
  var { className: t, children: r, anchorEl: n, arrow: i = !0, open: a, onClose: o, placement: s = "top", offset: l, strategy: u, flip: g = !0 } = e, d = YL(e, ["className", "children", "anchorEl", "arrow", "open", "onClose", "placement", "offset", "strategy", "flip"]);
  const h = An(null), C = $h(!1) !== void 0, E = t0(l4) !== null, I = u ?? (C ? "fixed" : "absolute"), b = E ? !1 : g, y = Xh(!1), { update: p, refs: Q, placement: w, middlewareData: { arrow: { x: Y, y: k } = {} }, floatingStyles: L } = QL({
    strategy: I,
    placement: s,
    open: a,
    middleware: [
      V8(l ?? (y ? 8 : i ? 16 : 4)),
      b && J8({ padding: 5, fallbackPlacements: ["bottom", "top"] }),
      O8({ padding: 12 }),
      W8({ element: h, padding: 8 })
    ]
  });
  Tc(() => {
    Q.setReference(n);
  }, [n]);
  const S = Rl(Q.setFloating, A);
  Tc(() => {
    if (!Q.reference.current || !Q.floating.current || !a)
      return;
    const Z = H8(Q.reference.current, Q.floating.current, p);
    return () => Z();
  }, [Q.floating, Q.reference, p, a, n]);
  const P = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[w.split("-")[0]];
  return JA.createElement(
    n8,
    { asChild: !0, safeZone: {
      anchor: n,
      dismissable: Q.floating.current
    }, onDismiss: () => a && (o == null ? void 0 : o()), enabled: a },
    JA.createElement(
      "div",
      Object.assign({ ref: S }, d, { className: ct("navds-popover", t, {
        "navds-popover--hidden": !a || !n
      }), style: Object.assign(Object.assign({}, d.style), L), "data-placement": w, "aria-hidden": !a || !n }),
      r,
      i && !y && JA.createElement("div", { ref: (Z) => {
        h.current = Z;
      }, style: Object.assign(Object.assign(Object.assign({}, Y != null ? { left: Y } : {}), k != null ? { top: k } : {}), P ? { [P]: "-0.5rem" } : {}), className: "navds-popover__arrow" })
    )
  );
});
lh.Content = UL;
const G1 = ({ title: e, filled: A = !1 }) => {
  let t = Ja();
  return t = e ? `title-${t}` : void 0, JA.createElement(
    "svg",
    { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: !1, role: "img", "aria-labelledby": t, className: ct("navds-help-text__icon", {
      "navds-help-text__icon--filled": A
    }) },
    e ? JA.createElement("title", { id: t }, e) : null,
    JA.createElement("circle", { cx: "12", cy: "12", r: "11", strokeWidth: "1.5", stroke: "currentColor", fill: A ? "currentColor" : "transparent" }),
    JA.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.75 9C9.75 7.75736 10.7574 6.75 12 6.75H12.1716C13.3195 6.75 14.25 7.68054 14.25 8.82843C14.25 9.37966 14.031 9.90832 13.6412 10.2981L12.6412 11.2981C11.7504 12.1889 11.25 13.3971 11.25 14.6569C11.25 15.0711 11.5858 15.4069 12 15.4069C12.4142 15.4069 12.75 15.0711 12.75 14.6569C12.75 13.7949 13.0924 12.9682 13.7019 12.3588L14.7019 11.3588C15.373 10.6877 15.75 9.77748 15.75 8.82843C15.75 6.85212 14.1479 5.25 12.1716 5.25H12C9.92893 5.25 8.25 6.92893 8.25 9V9.5C8.25 9.91421 8.58579 10.25 9 10.25C9.41421 10.25 9.75 9.91421 9.75 9.5V9ZM12 16.5C11.4477 16.5 11 16.9477 11 17.5C11 18.0523 11.4477 18.5 12 18.5C12.5523 18.5 13 18.0523 13 17.5C13 16.9477 12.5523 16.5 12 16.5Z", fill: A ? "var(--ax-text-accent-contrast, var(--a-surface-default))" : "currentColor" })
  );
};
var HL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const SL = At((e, A) => {
  var { className: t, children: r, placement: n, strategy: i = "absolute", title: a, onClick: o, wrapperClassName: s } = e, l = HL(e, ["className", "children", "placement", "strategy", "title", "onClick", "wrapperClassName"]);
  const u = An(null), g = Rl(u, A), [d, h] = Jt(!1), C = Xh(!1), E = Yl("HelpText"), I = a || E("title");
  return JA.createElement(
    "div",
    { className: ct("navds-help-text", s) },
    JA.createElement(
      "button",
      Object.assign({}, l, { ref: g, onClick: Ni(o, () => h((b) => !b)), className: ct(t, "navds-help-text__button"), type: "button", "aria-expanded": d }),
      JA.createElement(G1, { title: I }),
      JA.createElement(G1, { filled: !0, title: I })
    ),
    JA.createElement(
      lh,
      { onClose: () => h(!1), className: "navds-help-text__popover", open: d, anchorEl: u.current, placement: n, strategy: i, offset: C ? 8 : 12, arrow: !C },
      JA.createElement(lh.Content, { className: "navds-body-short" }, r)
    )
  );
}), [NL, TL, PL, zL] = ZD(), [jL, Fg] = Gl({
  name: "TabsContext",
  hookName: "useTabsContext",
  providerName: "TabsProvider",
  errorMessage: "Tabs.List, Tabs.Tag and Tabs.Panel needs to be wrapped within <Tabs>"
});
function VL({ value: e, disabled: A = !1, onFocus: t, onClick: r }, n) {
  const { id: i, setSelectedValue: a, selectionFollowsFocus: o, focusedValue: s, setFocusedValue: l, selectedValue: u, makeTabId: g, makeTabPanelId: d } = Fg(), { register: h } = zL({
    disabled: A,
    value: e
  }), C = e === u, E = () => {
    l(e), o && a(e);
  };
  return {
    ref: mg([h, n]),
    isSelected: C,
    isFocused: s === e,
    id: g(i, e),
    controlsId: d(i, e),
    onClick: Ni(r, () => a(e)),
    onFocus: A ? void 0 : Ni(t, E)
  };
}
var OL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const JL = At((e, A) => {
  var t, r, { className: n, as: i = "button", label: a, icon: o, value: s, onClick: l, onFocus: u, disabled: g, id: d } = e, h = OL(e, ["className", "as", "label", "icon", "value", "onClick", "onFocus", "disabled", "id"]);
  const C = VL({ value: s, onClick: l, onFocus: u, disabled: g }, A), E = Fg();
  return !a && !o ? (console.error("<Tabs.Tab/> needs label and/or icon"), null) : JA.createElement(
    i,
    Object.assign({ ref: C.ref }, h, { className: ct("navds-tabs__tab", `navds-tabs__tab--${(t = E == null ? void 0 : E.size) !== null && t !== void 0 ? t : "medium"}`, `navds-tabs__tab-icon--${E == null ? void 0 : E.iconPosition}`, n, {
      "navds-tabs__tab--icon-only": o && !a,
      "navds-tabs__tab--fill": E.fill
    }), role: "tab", type: "button", "aria-selected": C.isSelected, "data-state": C.isSelected ? "active" : "inactive", tabIndex: C.isFocused ? 0 : -1, "aria-controls": (r = h["aria-controls"]) !== null && r !== void 0 ? r : C.controlsId, id: d ?? C.id, onFocus: C.onFocus, onClick: C.onClick }),
    JA.createElement(
      Zn,
      { as: "span", className: "navds-tabs__tab-inner", size: E == null ? void 0 : E.size },
      JA.createElement("span", { "aria-hidden": !!a }, o),
      JA.createElement("span", null, a)
    )
  );
});
function x1({ hidden: e, onClick: A, dir: t }) {
  return JA.createElement("div", { className: ct("navds-tabs__scroll-button", {
    "navds-tabs__scroll-button--hidden": e
  }), onClick: A, "aria-hidden": !0 }, t === "left" ? JA.createElement(AF, null) : JA.createElement(tF, null));
}
function WL(e) {
  const [A, t] = Jt({
    start: !1,
    end: !1
  }), r = Pb(() => J3(() => {
    if (!(e != null && e.current))
      return;
    const { scrollWidth: n, clientWidth: i } = e.current, a = e.current.scrollLeft, o = a > 1, s = a < n - i - 1;
    t((l) => o === l.start && s === l.end ? l : { start: o, end: s });
  }), [e]);
  return Wt(() => {
    var n, i, a;
    const o = () => r(), s = (a = (i = (n = e.current) === null || n === void 0 ? void 0 : n.ownerDocument) !== null && i !== void 0 ? i : document) !== null && a !== void 0 ? a : window;
    s.addEventListener("resize", o);
    let l;
    return typeof ResizeObserver < "u" && e.current && (l = new ResizeObserver(o), l.observe(e.current)), () => {
      s.removeEventListener("resize", o), l == null || l.disconnect(), r.clear();
    };
  }, [e, r]), Wt(() => {
    r();
  }), {
    update: r,
    start: A.start,
    end: A.end,
    show: A.end || A.start,
    scrollLeft: () => {
      e.current && (e.current.scrollLeft -= 100);
    },
    scrollRight: () => {
      e.current && (e.current.scrollLeft += 100);
    }
  };
}
function ZL() {
  const { focusedValue: e, loop: A, selectedValue: t, setFocusedValue: r } = Fg(), n = TL();
  return { onKeyDown: Wh((a) => {
    const o = n.values().findIndex((E) => E.value === e), d = {
      ArrowLeft: () => {
        var E;
        const I = n.prevEnabled(o, A);
        (E = I == null ? void 0 : I.node) === null || E === void 0 || E.focus();
      },
      ArrowRight: () => {
        var E;
        const I = n.nextEnabled(o, A);
        (E = I == null ? void 0 : I.node) === null || E === void 0 || E.focus();
      },
      Home: () => {
        var E;
        const I = n.firstEnabled();
        (E = I == null ? void 0 : I.node) === null || E === void 0 || E.focus();
      },
      End: () => {
        var E;
        const I = n.lastEnabled();
        (E = I == null ? void 0 : I.node) === null || E === void 0 || E.focus();
      }
    }, h = a.shiftKey || a.ctrlKey || a.altKey || a.metaKey, C = d[a.key];
    C && !h ? (a.preventDefault(), C(a)) : a.key === "Tab" && t && setTimeout(() => r(t));
  }, [n, e, A, t, r]) };
}
var KL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const _L = At((e, A) => {
  var { className: t, onKeyDown: r } = e, n = KL(e, ["className", "onKeyDown"]);
  const { onKeyDown: i } = ZL(), a = An(null), o = Rl(a, A), s = WL(a);
  return JA.createElement(
    "div",
    { className: "navds-tabs__tablist-wrapper" },
    s.show && JA.createElement(x1, { dir: "left", hidden: !s.start, onClick: s.scrollLeft }),
    JA.createElement("div", Object.assign({ ref: o }, n, { onScroll: s.update, className: ct("navds-tabs__tablist", t), role: "tablist", "aria-orientation": "horizontal", onKeyDown: Ni(r, i) })),
    s.show && JA.createElement(x1, { dir: "right", hidden: !s.end, onClick: s.scrollRight })
  );
});
function XL({ value: e }) {
  const { id: A, selectedValue: t, makeTabId: r, makeTabPanelId: n } = Fg();
  return {
    labelledbyId: r(A, e),
    hidden: t !== e,
    id: n(A, e)
  };
}
var qL = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const $L = At((e, A) => {
  var t, { className: r, value: n, children: i, lazy: a = !0, id: o } = e, s = qL(e, ["className", "value", "children", "lazy", "id"]);
  const l = XL({ value: n });
  return JA.createElement("div", Object.assign({ ref: A }, s, { className: ct("navds-tabs__tabpanel", r), role: "tabpanel", tabIndex: 0, "aria-labelledby": (t = s["aria-labelledby"]) !== null && t !== void 0 ? t : l.labelledbyId, id: o ?? l.id, hidden: l.hidden, "data-state": l.hidden ? "inactive" : "active" }), a && l.hidden ? null : i);
});
function AR({ onChange: e, value: A, defaultValue: t = "", id: r }) {
  const [n, i] = Jt(t), [a, o] = Z3({
    defaultValue: t,
    value: A,
    onChange: e
  });
  Wt(() => {
    A != null && i(A);
  }, [A]);
  const s = Ja();
  return {
    id: `tabs-${r ?? s}`,
    selectedValue: a,
    setSelectedValue: o,
    focusedValue: n,
    setFocusedValue: i,
    makeTabId: eR,
    makeTabPanelId: tR
  };
}
function eR(e, A) {
  return `${e}--tab-${A}`;
}
function tR(e, A) {
  return `${e}--tabpanel-${A}`;
}
var rR = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const va = At((e, A) => {
  var { className: t, children: r, size: n = "medium", defaultValue: i = "", value: a, onChange: o, id: s, selectionFollowsFocus: l = !1, loop: u = !0, iconPosition: g = "left", fill: d = !1 } = e, h = rR(e, ["className", "children", "size", "defaultValue", "value", "onChange", "id", "selectionFollowsFocus", "loop", "iconPosition", "fill"]);
  const C = PL(), E = AR({ defaultValue: i, value: a, onChange: o, id: s }), I = Object.assign(Object.assign({}, E), {
    selectionFollowsFocus: l,
    loop: u,
    size: n,
    iconPosition: g,
    fill: d
  });
  return JA.createElement(
    NL,
    { value: C },
    JA.createElement(
      jL,
      Object.assign({}, I),
      JA.createElement("div", Object.assign({ ref: A }, h, { id: s, className: ct("navds-tabs", t, `navds-tabs--${n}`) }), r)
    )
  );
});
va.Tab = JL;
va.List = _L;
va.Panel = $L;
const nR = (e) => {
  const A = c4(e, "fieldset"), { inputProps: t } = A;
  return Object.assign(Object.assign({}, A), { inputProps: {
    "aria-invalid": t["aria-invalid"],
    "aria-describedby": t["aria-describedby"]
  } });
};
var iR = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const aR = At((e, A) => {
  var t, r, n;
  const { inputProps: i, errorId: a, showErrorMsg: o, hasError: s, size: l, readOnly: u, inputDescriptionId: g } = nR(e), d = t0(Oc), { children: h, className: C, errorPropagation: E = !0, legend: I, description: b, hideLegend: y, nativeReadOnly: p = !0 } = e, Q = iR(e, ["children", "className", "errorPropagation", "legend", "description", "hideLegend", "nativeReadOnly"]);
  return JA.createElement(
    Oc.Provider,
    { value: {
      error: E ? (t = e.error) !== null && t !== void 0 ? t : d == null ? void 0 : d.error : void 0,
      errorId: ct({
        [a]: o,
        [(r = d == null ? void 0 : d.errorId) !== null && r !== void 0 ? r : ""]: !!(d != null && d.error)
      }),
      size: l,
      disabled: (n = e.disabled) !== null && n !== void 0 ? n : !1,
      readOnly: u
    } },
    JA.createElement(
      "fieldset",
      Object.assign({}, Oa(Q, ["errorId", "error", "size", "readOnly"]), Oa(i, ["aria-describedby", "aria-invalid"]), { ref: A, className: ct(C, "navds-fieldset", `navds-fieldset--${l}`, {
        "navds-fieldset--error": s,
        "navds-fieldset--readonly": u
      }) }),
      JA.createElement(
        VD,
        { size: l, as: "legend", className: ct("navds-fieldset__legend", {
          "navds-sr-only": !!y
        }) },
        u && (p ? JA.createElement(rL, null) : JA.createElement(u4, null)),
        I
      ),
      !!b && JA.createElement(Zn, { className: ct("navds-fieldset__description", {
        "navds-sr-only": !!y
      }), id: g, size: l ?? "medium", as: "div" }, e.description),
      h,
      JA.createElement("div", { id: a, "aria-relevant": "additions removals", "aria-live": "polite", className: "navds-fieldset__error" }, o && JA.createElement(z3, { size: l, showIcon: !0 }, e.error))
    )
  );
});
var oR = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const Q4 = Qn(null);
At((e, A) => {
  var t, r, { value: n, defaultValue: i, onChange: a = () => {
  }, children: o, className: s } = e, l = oR(e, ["value", "defaultValue", "onChange", "children", "className"]);
  const u = t0(Oc), [g, d] = Jt(i ?? []), h = (C) => {
    const E = n ?? g, I = E.includes(C) ? E.filter((b) => b !== C) : [...E, C];
    n === void 0 && d(I), a(I);
  };
  return JA.createElement(
    aR,
    Object.assign({}, l, { ref: A, className: ct(s, "navds-checkbox-group", `navds-checkbox-group--${(r = (t = l.size) !== null && t !== void 0 ? t : u == null ? void 0 : u.size) !== null && r !== void 0 ? r : "medium"}`), nativeReadOnly: !1 }),
    JA.createElement(
      Q4.Provider,
      { value: {
        value: n,
        defaultValue: i,
        toggleValue: h
      } },
      JA.createElement("div", { className: "navds-checkboxes" }, o)
    )
  );
});
var sR = function(e, A) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
};
const lR = (e) => {
  const A = t0(Q4), t = c4(Oa(e, ["description", "children"]), "checkbox"), { inputProps: r, readOnly: n } = t, i = sR(t, ["inputProps", "readOnly"]);
  return A && (e.checked && console.warn("`checked` is unsupported on <Checkbox> elements within a <CheckboxGroup>. Please set a `value` or `defaultValue` on <CheckboxGroup> instead."), e.value === void 0 && console.warn("A <Checkbox> element within a <CheckboxGroup> requires a `value` property.")), Object.assign(Object.assign({}, i), { readOnly: n, nested: !!A, inputProps: Object.assign(Object.assign({}, r), { checked: A != null && A.value ? A.value.includes(e.value) : e.checked, defaultChecked: A != null && A.defaultValue ? A.defaultValue.includes(e.value) : e.defaultChecked, onChange: (a) => {
    var o;
    n || ((o = e.onChange) === null || o === void 0 || o.call(e, a), A == null || A.toggleValue(e.value));
  }, onClick: (a) => {
    var o;
    if (n) {
      a.preventDefault();
      return;
    }
    (o = e == null ? void 0 : e.onClick) === null || o === void 0 || o.call(e, a);
  } }) });
}, Ss = At((e, A) => {
  const { inputProps: t, hasError: r, size: n, readOnly: i, nested: a } = lR(e), o = Ja(), s = Ja();
  return JA.createElement(
    "div",
    { className: ct(e.className, "navds-checkbox", `navds-checkbox--${n}`, {
      "navds-checkbox--error": r,
      "navds-checkbox--disabled": t.disabled,
      "navds-checkbox--readonly": i
    }) },
    JA.createElement("input", Object.assign({}, Oa(e, [
      "children",
      "size",
      "error",
      "description",
      "hideLabel",
      "indeterminate",
      "errorId",
      "readOnly"
    ]), Oa(t, ["aria-invalid"]), { type: "checkbox", className: "navds-checkbox__input", ref: (l) => {
      var u;
      l && (l.indeterminate = (u = e.indeterminate) !== null && u !== void 0 ? u : !1), typeof A == "function" ? A(l) : A != null && (A.current = l);
    }, "aria-labelledby": ct(o, !!e["aria-labelledby"] && e["aria-labelledby"], {
      [s]: e.description
    }) })),
    JA.createElement(
      "label",
      { htmlFor: t.id, className: "navds-checkbox__label" },
      JA.createElement(
        "span",
        { className: "navds-checkbox__icon" },
        JA.createElement(
          "svg",
          { xmlns: "http://www.w3.org/2000/svg", width: "0.8125rem", height: "0.625rem", viewBox: "0 0 13 10", fill: "none", focusable: !1, role: "img", "aria-hidden": !0 },
          JA.createElement("path", { d: "M4.03524 6.41478L10.4752 0.404669C11.0792 -0.160351 12.029 -0.130672 12.5955 0.47478C13.162 1.08027 13.1296 2.03007 12.5245 2.59621L5.02111 9.59934C4.74099 9.85904 4.37559 10 4.00025 10C3.60651 10 3.22717 9.84621 2.93914 9.56111L0.439143 7.06111C-0.146381 6.47558 -0.146381 5.52542 0.439143 4.93989C1.02467 4.35437 1.97483 4.35437 2.56036 4.93989L4.03524 6.41478Z", fill: "currentColor" })
        )
      ),
      JA.createElement(
        "span",
        { className: ct("navds-checkbox__content", {
          "navds-sr-only": e.hideLabel
        }) },
        JA.createElement(
          Zn,
          { as: "span", id: o, size: n, className: "navds-checkbox__label-text", "aria-hidden": !0 },
          !a && i && JA.createElement(u4, null),
          e.children
        ),
        e.description && JA.createElement(Zn, { as: "span", id: s, size: n, className: "navds-form-field__subdescription navds-checkbox__description", "aria-hidden": !0 }, e.description)
      )
    )
  );
}), uR = {
  antalltimer: "Antall timer",
  ansettelsesform: "Ansettelsesform",
  ansettelsesperiode: "Ansettelsesperiode",
  apne: "Åpne",
  arbeidsavtale: "Arbeidsavtale",
  arbeidsforhold: "Arbeidsforhold",
  arbeidsforholdid: "Arbeidsforhold ID",
  arbeidstidsordning: "Arbeidstidsordning",
  endretstillingsprosent: "Endret stillingsprosent",
  fartsomraade: "Fartsområde",
  generelleopplysninger: "Generelle opplysninger",
  httperror: "Oisann, noe gikk galt ved henting av data!",
  hovedenhet: "Hovedenhet",
  hvisfeil1: "Oversikten viser arbeidsforholdene slik det er rapportert av arbeidsgiver.",
  hvisfeil2: "Hvis det er feil i et arbeidsforhold, kan arbeidsgiveren endre gjennom a-meldingen.",
  ingenarbeidsforhold: "Du har ingen registrerte arbeidsforhold.",
  land: "Land",
  lonnsendring: "Lønnsendring",
  lukke: "Lukk",
  organisasjonsnummer: "Organisasjonsnummer",
  opptjeningsperiode: "Opptjeningsperiode",
  navaerendejobb: "Nåværende jobb",
  periode: "Periode",
  prosent: " Prosent",
  rapporteringsperiode: "Rapporteringsperiode",
  side: "Side",
  sistbekreftet: "Sist bekreftet av arbeidsgiver",
  sistelonnsendring: "Siste lønnsendring",
  skipsregister: "Skipsregister",
  skipstype: "Skipstype",
  skrivut: "Skriv ut",
  sluttaarsak: "Sluttårsak",
  stillingsprosent: "Stillingsprosent",
  tabs: {
    arbeidiutlandet: "Arbeid i utlandet",
    historikk: "Historikk",
    permisjonpermittering: "Permisjon/Permittering",
    timerfortimelonnet: "Timer for timelønnet"
  },
  timerifullstilling: "Timer i full stilling",
  timerperuke: "Timer/uke",
  tilleggsopplysninger: "Velg hvilke tilleggsopplysninger du vil skrive ut",
  type: "Type",
  typearbeidsforhold: "Type arbeidsforhold",
  utskriftsvalg: "Utskriftsvalg",
  visfaerrearbeidsforhold: "Vis færre arbeidsforhold",
  visflerearbeidsforhold: "Vis flere arbeidsforhold",
  yrke: "Yrke",
  pdfFooter1: "Oversikten viser arbeidsforholdene slik de er rapportert til Arbeidsgiver- og arbeidstakerregisteret",
  pdfFooter2: (e) => `Arbeids- og velferdsetaten // Utskrift fra ${e}`,
  ERKONK: "Arbeidsgiveren har gått konkurs. Nav har satt samme sluttdato som konkursåpningsdato i Konkursregisteret.",
  EROPPH: "Foretaket er opphørt i Enhetsregisteret. Nav har satt samme sluttdato som datoen foretaket opphørte i Enhetsregisteret.",
  ERVIRK: "Foretaket er overdratt til en annen juridisk enhet. Nav har satt  samme sluttdato som datoen da foretaket ble overdratt i Enhetsregisteret.",
  IBARBG: "Arbeidsgiveren har ikke bekreftet arbeidsforholdet. Nav har derfor satt sluttdato til siste dato i den kalendermåneden arbeidsgiveren din sist bekreftet arbeidsforholdet.",
  IBKAOR: "Sluttdato satt av Nav. Arbeidsforholdet er ikke bekreftet gjennom a-ordningen. Sluttdato er satt til 31.12.2014"
}, cR = {
  antalltimer: "Number of hours",
  ansettelsesform: "Form of employment",
  ansettelsesperiode: "Employment period",
  apne: "Open",
  arbeidsavtale: "Employment",
  arbeidsforhold: "Employment",
  arbeidsforholdid: "Employment ID",
  arbeidstidsordning: "Working scheme",
  endretstillingsprosent: "Changed position percentage",
  fartsomraade: "Area",
  generelleopplysninger: "General information",
  httperror: "Wops, something went wrong when retrieving data!",
  hovedenhet: "Parent company",
  hvisfeil1: "The overview displays employments reported after 01.01.2015.",
  hvisfeil2: "If something is wrong with the registered information, contact your employer.",
  ingenarbeidsforhold: "You have no registered employments.",
  land: "Country",
  lonnsendring: "Salary changed",
  lukke: "Close",
  organisasjonsnummer: "Organization number",
  opptjeningsperiode: "Worked in period",
  navaerendejobb: "Current employment",
  periode: "Period",
  prosent: " Percentage",
  rapporteringsperiode: "Reported in period",
  side: "Page",
  sistbekreftet: "Last confirmed by employer",
  sistelonnsendring: "Last salary change",
  skipsregister: "Ship registry",
  skipstype: "Ship type",
  skrivut: "Print",
  sluttaarsak: "Reason for employment termination",
  stillingsprosent: "Employment percent",
  tabs: {
    arbeidiutlandet: "Work abroad",
    historikk: "History",
    permisjonpermittering: "Leave/Layoff",
    timerfortimelonnet: "Working hours"
  },
  timerifullstilling: "Hours in full position",
  timerperuke: "Hours/week",
  tilleggsopplysninger: "Select what additional information you want to print",
  type: "Type",
  typearbeidsforhold: "Type of employment",
  utskriftsvalg: "Print selection",
  visfaerrearbeidsforhold: "Show fewer",
  visflerearbeidsforhold: "Show more",
  yrke: "Profession",
  pdfFooter1: "The data is reported by employers to the State register of employers and employees",
  pdfFooter2: (e) => `Arbeids- og velferdsetaten // Printed ${e}`,
  ERKONK: "End date set by Nav. The employer has gone bankrupt. End date is the same date as the bankruptcy date reported to Konkursregisteret.",
  EROPPH: "End date set by Nav. The employer has ceased to exist in Enhetsregisteret. The end date is set to the date the company ceased to exist.",
  ERVIRK: "End date set by Nav. The company has been transferred to another legal entity. The end date is set to the date of transfer.",
  IBARBG: "End date set by Nav. The employment has not been confirmed. End date is the last date of the calendar month in which the employment is confirmed.",
  IBKAOR: "End date set by Nav. The employment has not been confirmed through A-ordningen. End date is set for 31.12.2014"
}, gR = {
  antalltimer: "Antal timar",
  ansettelsesform: "Tillsettingsform",
  ansettelsesperiode: "Tilsettingsperiode",
  apne: "Opne",
  arbeidsavtale: "Arbeidsavtale",
  arbeidsforhold: "Arbeidsforhold",
  arbeidsforholdid: "Arbeidsforhold ID",
  arbeidstidsordning: "Arbeidstidsordning",
  endretstillingsprosent: "Endra stillingsprosent",
  fartsomraade: "Fartsområde",
  generelleopplysninger: "Generelle opplysningar",
  httperror: "Oi, noko gjekk galt ved henting av data!",
  hovedenhet: "Hovudeining",
  hvisfeil1: "Oversikta viser arbeidsforholda slik dei er rapportert av arbeidsgivar.",
  hvisfeil2: "Dersom det er feil i et arbeidsforhold, kan arbeidsgivaren endre gjennom a-meldinga.",
  ingenarbeidsforhold: "Du har ingen registrerte arbeidsforhold.",
  land: "Land",
  lonnsendring: "Lønsendring",
  lukke: "Lukk",
  organisasjonsnummer: "Organisasjonsnummer",
  opptjeningsperiode: "Oppteningsperiode",
  navaerendejobb: "Noverande jobb",
  periode: "Periode",
  prosent: " Prosent",
  rapporteringsperiode: "Rapporteringsperiode",
  side: "Side",
  sistbekreftet: "Sist bekrefta av arbeidsgivar",
  sistelonnsendring: "Siste lønsendring",
  skipsregister: "Skipsregister",
  skipstype: "Skipstype",
  skrivut: "Skriv ut",
  sluttaarsak: "Sluttårsak",
  stillingsprosent: "Stillingsprosent",
  tabs: {
    arbeidiutlandet: "Arbeid i utlandet",
    historikk: "Historikk",
    permisjonpermittering: "Permisjon/Permittering",
    timerfortimelonnet: "Timar for timeløna"
  },
  timerifullstilling: "Timar i full stilling",
  timerperuke: "Timar/veke",
  tilleggsopplysninger: "Vel kva tilleggsopplysningar du vil skrive ut",
  type: "Type",
  typearbeidsforhold: "Type arbeidsforhold",
  utskriftsvalg: "Utskriftsval",
  visfaerrearbeidsforhold: "Vis færre arbeidsforhold",
  visflerearbeidsforhold: "Vis fleire arbeidsforhold",
  yrke: "Yrke",
  pdfFooter1: "Oversikta viser arbeidsforholda slik dei er rapportert til Arbeidsgivar- og arbeidstakarregisteret",
  pdfFooter2: (e) => `Arbeids- og velferdsetaten // Utskrift frå ${e}`,
  ERKONK: "Arbeidsgivaren har gått konkurs. Nav har satt same sluttdato som konkursopningsdato i Konkursregisteret.",
  EROPPH: "Føretaket er opphøyrt i Enhetsregisteret. Nav har satt same sluttdato som datoen føretaket opphøyrte i Enhetsregisteret.",
  ERVIRK: "Føretaket er overdratt til ei anna juridisk eining. Nav har satt  same sluttdato som datoen då føretaket ble overdratt i Enhetsregisteret.",
  IBARBG: "Arbeidsgivaren har ikkje stadfesta arbeidsforholdet. Nav har derfor satt sluttdato til siste dato i den kalendermånaden arbeidsgivaren din sist stadfesta arbeidsforholdet.",
  IBKAOR: "Sluttdato satt av Nav. Arbeidsforholdet er ikkje stadfesta gjennom a-ordningen. Sluttdato er satt til 31.12.2014"
}, re = {
  nb: uR,
  en: cR,
  nn: gR
}, k1 = JA.createContext("nb"), Pt = () => ({ locale: t0(k1), LocaleProvider: k1.Provider }), w4 = (e) => {
  const { error: A } = e, { locale: t } = Pt();
  return A ? /* @__PURE__ */ x.jsx("div", { className: "error__container", children: /* @__PURE__ */ x.jsxs(s4, { role: "alert", variant: "error", children: [
    re[t].httperror,
    /* @__PURE__ */ x.jsx("br", {}),
    A.code && /* @__PURE__ */ x.jsx("span", { children: `${A.code}: ` }),
    A.text && /* @__PURE__ */ x.jsx("span", { children: `${A.text}` })
  ] }) }) : null;
}, { frontendlogger: uf } = window, BR = (e, A) => {
  const t = `Feil ved henting av data: ${e} - ${A.status} ${A.statusText}`, r = "personopplysninger.apiclient.error", n = {}, i = {
    status: A.status,
    statusText: A.statusText,
    url: e
  };
  uf && (uf.error(t), uf.event(r, i, n));
}, fR = (e) => e.json(), dR = () => new Promise(() => window.location.assign(`${kr.loginUrl}?redirect=${window.location.href}`)), hR = (e) => e.status === 401 || e.status === 403 || e.status === 0 && !e.ok ? dR() : e, CR = (e, A, t) => A.ok ? A : (BR(e, A), t({
  code: A.status,
  text: A.statusText
})), I4 = (e, A) => new Promise((t, r) => fetch(e, {
  method: "GET",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    ...A
  },
  credentials: "include"
}).then(hR).then((n) => CR(e, n, r)).then(fR).then(t).catch(r)), ER = (e) => {
  const A = `${kr.apiUrl}/arbeidsforhold/forenklet/alle`;
  return I4(e ?? A);
}, QR = (e, A) => {
  const t = `${kr.apiUrl}/arbeidsforhold/{id}`, r = (A ?? t).replace("{id}", e.toString());
  return I4(r);
}, D4 = () => /* @__PURE__ */ x.jsx("div", { className: "spinner__wrapper", children: /* @__PURE__ */ x.jsx(iC, { size: "xlarge" }) });
var dc = { exports: {} }, wR = dc.exports, U1;
function oC() {
  return U1 || (U1 = 1, function(e, A) {
    (function(t, r) {
      e.exports = r();
    })(wR, function() {
      var t = 1e3, r = 6e4, n = 36e5, i = "millisecond", a = "second", o = "minute", s = "hour", l = "day", u = "week", g = "month", d = "quarter", h = "year", C = "date", E = "Invalid Date", I = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(G) {
        var N = ["th", "st", "nd", "rd"], z = G % 100;
        return "[" + G + (N[(z - 20) % 10] || N[z] || N[0]) + "]";
      } }, p = function(G, N, z) {
        var T = String(G);
        return !T || T.length >= N ? G : "" + Array(N + 1 - T.length).join(z) + G;
      }, Q = { s: p, z: function(G) {
        var N = -G.utcOffset(), z = Math.abs(N), T = Math.floor(z / 60), O = z % 60;
        return (N <= 0 ? "+" : "-") + p(T, 2, "0") + ":" + p(O, 2, "0");
      }, m: function G(N, z) {
        if (N.date() < z.date()) return -G(z, N);
        var T = 12 * (z.year() - N.year()) + (z.month() - N.month()), O = N.clone().add(T, g), K = z - O < 0, AA = N.clone().add(T + (K ? -1 : 1), g);
        return +(-(T + (z - O) / (K ? O - AA : AA - O)) || 0);
      }, a: function(G) {
        return G < 0 ? Math.ceil(G) || 0 : Math.floor(G);
      }, p: function(G) {
        return { M: g, y: h, w: u, d: l, D: C, h: s, m: o, s: a, ms: i, Q: d }[G] || String(G || "").toLowerCase().replace(/s$/, "");
      }, u: function(G) {
        return G === void 0;
      } }, w = "en", Y = {};
      Y[w] = y;
      var k = "$isDayjsObject", L = function(G) {
        return G instanceof M || !(!G || !G[k]);
      }, S = function G(N, z, T) {
        var O;
        if (!N) return w;
        if (typeof N == "string") {
          var K = N.toLowerCase();
          Y[K] && (O = K), z && (Y[K] = z, O = K);
          var AA = N.split("-");
          if (!O && AA.length > 1) return G(AA[0]);
        } else {
          var X = N.name;
          Y[X] = N, O = X;
        }
        return !T && O && (w = O), O || !T && w;
      }, P = function(G, N) {
        if (L(G)) return G.clone();
        var z = typeof N == "object" ? N : {};
        return z.date = G, z.args = arguments, new M(z);
      }, Z = Q;
      Z.l = S, Z.i = L, Z.w = function(G, N) {
        return P(G, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
      };
      var M = function() {
        function G(z) {
          this.$L = S(z.locale, null, !0), this.parse(z), this.$x = this.$x || z.x || {}, this[k] = !0;
        }
        var N = G.prototype;
        return N.parse = function(z) {
          this.$d = function(T) {
            var O = T.date, K = T.utc;
            if (O === null) return /* @__PURE__ */ new Date(NaN);
            if (Z.u(O)) return /* @__PURE__ */ new Date();
            if (O instanceof Date) return new Date(O);
            if (typeof O == "string" && !/Z$/i.test(O)) {
              var AA = O.match(I);
              if (AA) {
                var X = AA[2] - 1 || 0, iA = (AA[7] || "0").substring(0, 3);
                return K ? new Date(Date.UTC(AA[1], X, AA[3] || 1, AA[4] || 0, AA[5] || 0, AA[6] || 0, iA)) : new Date(AA[1], X, AA[3] || 1, AA[4] || 0, AA[5] || 0, AA[6] || 0, iA);
              }
            }
            return new Date(O);
          }(z), this.init();
        }, N.init = function() {
          var z = this.$d;
          this.$y = z.getFullYear(), this.$M = z.getMonth(), this.$D = z.getDate(), this.$W = z.getDay(), this.$H = z.getHours(), this.$m = z.getMinutes(), this.$s = z.getSeconds(), this.$ms = z.getMilliseconds();
        }, N.$utils = function() {
          return Z;
        }, N.isValid = function() {
          return this.$d.toString() !== E;
        }, N.isSame = function(z, T) {
          var O = P(z);
          return this.startOf(T) <= O && O <= this.endOf(T);
        }, N.isAfter = function(z, T) {
          return P(z) < this.startOf(T);
        }, N.isBefore = function(z, T) {
          return this.endOf(T) < P(z);
        }, N.$g = function(z, T, O) {
          return Z.u(z) ? this[T] : this.set(O, z);
        }, N.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, N.valueOf = function() {
          return this.$d.getTime();
        }, N.startOf = function(z, T) {
          var O = this, K = !!Z.u(T) || T, AA = Z.p(z), X = function(lA, tA) {
            var nA = Z.w(O.$u ? Date.UTC(O.$y, tA, lA) : new Date(O.$y, tA, lA), O);
            return K ? nA : nA.endOf(l);
          }, iA = function(lA, tA) {
            return Z.w(O.toDate()[lA].apply(O.toDate("s"), (K ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(tA)), O);
          }, oA = this.$W, fA = this.$M, wA = this.$D, DA = "set" + (this.$u ? "UTC" : "");
          switch (AA) {
            case h:
              return K ? X(1, 0) : X(31, 11);
            case g:
              return K ? X(1, fA) : X(0, fA + 1);
            case u:
              var HA = this.$locale().weekStart || 0, sA = (oA < HA ? oA + 7 : oA) - HA;
              return X(K ? wA - sA : wA + (6 - sA), fA);
            case l:
            case C:
              return iA(DA + "Hours", 0);
            case s:
              return iA(DA + "Minutes", 1);
            case o:
              return iA(DA + "Seconds", 2);
            case a:
              return iA(DA + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, N.endOf = function(z) {
          return this.startOf(z, !1);
        }, N.$set = function(z, T) {
          var O, K = Z.p(z), AA = "set" + (this.$u ? "UTC" : ""), X = (O = {}, O[l] = AA + "Date", O[C] = AA + "Date", O[g] = AA + "Month", O[h] = AA + "FullYear", O[s] = AA + "Hours", O[o] = AA + "Minutes", O[a] = AA + "Seconds", O[i] = AA + "Milliseconds", O)[K], iA = K === l ? this.$D + (T - this.$W) : T;
          if (K === g || K === h) {
            var oA = this.clone().set(C, 1);
            oA.$d[X](iA), oA.init(), this.$d = oA.set(C, Math.min(this.$D, oA.daysInMonth())).$d;
          } else X && this.$d[X](iA);
          return this.init(), this;
        }, N.set = function(z, T) {
          return this.clone().$set(z, T);
        }, N.get = function(z) {
          return this[Z.p(z)]();
        }, N.add = function(z, T) {
          var O, K = this;
          z = Number(z);
          var AA = Z.p(T), X = function(fA) {
            var wA = P(K);
            return Z.w(wA.date(wA.date() + Math.round(fA * z)), K);
          };
          if (AA === g) return this.set(g, this.$M + z);
          if (AA === h) return this.set(h, this.$y + z);
          if (AA === l) return X(1);
          if (AA === u) return X(7);
          var iA = (O = {}, O[o] = r, O[s] = n, O[a] = t, O)[AA] || 1, oA = this.$d.getTime() + z * iA;
          return Z.w(oA, this);
        }, N.subtract = function(z, T) {
          return this.add(-1 * z, T);
        }, N.format = function(z) {
          var T = this, O = this.$locale();
          if (!this.isValid()) return O.invalidDate || E;
          var K = z || "YYYY-MM-DDTHH:mm:ssZ", AA = Z.z(this), X = this.$H, iA = this.$m, oA = this.$M, fA = O.weekdays, wA = O.months, DA = O.meridiem, HA = function(tA, nA, GA, ZA) {
            return tA && (tA[nA] || tA(T, K)) || GA[nA].slice(0, ZA);
          }, sA = function(tA) {
            return Z.s(X % 12 || 12, tA, "0");
          }, lA = DA || function(tA, nA, GA) {
            var ZA = tA < 12 ? "AM" : "PM";
            return GA ? ZA.toLowerCase() : ZA;
          };
          return K.replace(b, function(tA, nA) {
            return nA || function(GA) {
              switch (GA) {
                case "YY":
                  return String(T.$y).slice(-2);
                case "YYYY":
                  return Z.s(T.$y, 4, "0");
                case "M":
                  return oA + 1;
                case "MM":
                  return Z.s(oA + 1, 2, "0");
                case "MMM":
                  return HA(O.monthsShort, oA, wA, 3);
                case "MMMM":
                  return HA(wA, oA);
                case "D":
                  return T.$D;
                case "DD":
                  return Z.s(T.$D, 2, "0");
                case "d":
                  return String(T.$W);
                case "dd":
                  return HA(O.weekdaysMin, T.$W, fA, 2);
                case "ddd":
                  return HA(O.weekdaysShort, T.$W, fA, 3);
                case "dddd":
                  return fA[T.$W];
                case "H":
                  return String(X);
                case "HH":
                  return Z.s(X, 2, "0");
                case "h":
                  return sA(1);
                case "hh":
                  return sA(2);
                case "a":
                  return lA(X, iA, !0);
                case "A":
                  return lA(X, iA, !1);
                case "m":
                  return String(iA);
                case "mm":
                  return Z.s(iA, 2, "0");
                case "s":
                  return String(T.$s);
                case "ss":
                  return Z.s(T.$s, 2, "0");
                case "SSS":
                  return Z.s(T.$ms, 3, "0");
                case "Z":
                  return AA;
              }
              return null;
            }(tA) || AA.replace(":", "");
          });
        }, N.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, N.diff = function(z, T, O) {
          var K, AA = this, X = Z.p(T), iA = P(z), oA = (iA.utcOffset() - this.utcOffset()) * r, fA = this - iA, wA = function() {
            return Z.m(AA, iA);
          };
          switch (X) {
            case h:
              K = wA() / 12;
              break;
            case g:
              K = wA();
              break;
            case d:
              K = wA() / 3;
              break;
            case u:
              K = (fA - oA) / 6048e5;
              break;
            case l:
              K = (fA - oA) / 864e5;
              break;
            case s:
              K = fA / n;
              break;
            case o:
              K = fA / r;
              break;
            case a:
              K = fA / t;
              break;
            default:
              K = fA;
          }
          return O ? K : Z.a(K);
        }, N.daysInMonth = function() {
          return this.endOf(g).$D;
        }, N.$locale = function() {
          return Y[this.$L];
        }, N.locale = function(z, T) {
          if (!z) return this.$L;
          var O = this.clone(), K = S(z, T, !0);
          return K && (O.$L = K), O;
        }, N.clone = function() {
          return Z.w(this.$d, this);
        }, N.toDate = function() {
          return new Date(this.valueOf());
        }, N.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, N.toISOString = function() {
          return this.$d.toISOString();
        }, N.toString = function() {
          return this.$d.toUTCString();
        }, G;
      }(), R = M.prototype;
      return P.prototype = R, [["$ms", i], ["$s", a], ["$m", o], ["$H", s], ["$W", l], ["$M", g], ["$y", h], ["$D", C]].forEach(function(G) {
        R[G[1]] = function(N) {
          return this.$g(N, G[0], G[1]);
        };
      }), P.extend = function(G, N) {
        return G.$i || (G(N, M, P), G.$i = !0), P;
      }, P.locale = S, P.isDayjs = L, P.unix = function(G) {
        return P(1e3 * G);
      }, P.en = Y[w], P.Ls = Y, P.p = {}, P;
    });
  }(dc)), dc.exports;
}
var IR = oC();
const Wi = /* @__PURE__ */ Ht(IR), m4 = (e, A) => e && A ? Wi(A).diff(Wi(e)) : !e && A ? -1 : e && !A ? 1 : 0, ai = (e, A) => e && A ? m4(e.periodeFra, A.periodeFra) : 0, sC = (e, A) => e && A ? m4(e.periodeTil, A.periodeTil) : 0, Y1 = JA.createContext(!1), lC = () => ({ isPdf: t0(Y1), IsPdfProvider: Y1.Provider });
function Yr() {
  return Yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var A = 1; A < arguments.length; A++) {
      var t = arguments[A];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Yr.apply(null, arguments);
}
const M4 = "G", oi = "SVG", Me = "VIEW", Ue = "TEXT", Lg = "LINK", os = "PAGE", Rg = "NOTE", uC = "PATH", cC = "RECT", gC = "LINE", DR = "STOP", BC = "DEFS", Xi = "IMAGE", fC = "TSPAN", Gg = "CANVAS", dC = "CIRCLE", hC = "ELLIPSE", CC = "POLYGON", xg = "DOCUMENT", EC = "POLYLINE", mR = "CLIP_PATH", qi = "TEXT_INSTANCE", p4 = "LINEAR_GRADIENT", v4 = "RADIAL_GRADIENT", MR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Canvas: Gg,
  Circle: dC,
  ClipPath: mR,
  Defs: BC,
  Document: xg,
  Ellipse: hC,
  G: M4,
  Image: Xi,
  Line: gC,
  LinearGradient: p4,
  Link: Lg,
  Note: Rg,
  Page: os,
  Path: uC,
  Polygon: CC,
  Polyline: EC,
  RadialGradient: v4,
  Rect: cC,
  Stop: DR,
  Svg: oi,
  Text: Ue,
  TextInstance: qi,
  Tspan: fC,
  View: Me
}, Symbol.toStringTag, { value: "Module" }));
var Gu = { exports: {} }, xu = { exports: {} }, H1;
function pR() {
  return H1 || (H1 = 1, typeof Object.create == "function" ? xu.exports = function(A, t) {
    t && (A.super_ = t, A.prototype = Object.create(t.prototype, {
      constructor: {
        value: A,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : xu.exports = function(A, t) {
    if (t) {
      A.super_ = t;
      var r = function() {
      };
      r.prototype = t.prototype, A.prototype = new r(), A.prototype.constructor = A;
    }
  }), xu.exports;
}
var ku = { exports: {} }, S1;
function vR() {
  if (S1) return ku.exports;
  S1 = 1;
  var e = typeof Reflect == "object" ? Reflect : null, A = e && typeof e.apply == "function" ? e.apply : function(w, Y, k) {
    return Function.prototype.apply.call(w, Y, k);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function(w) {
    return Object.getOwnPropertyNames(w).concat(Object.getOwnPropertySymbols(w));
  } : t = function(w) {
    return Object.getOwnPropertyNames(w);
  };
  function r(Q) {
    console && console.warn && console.warn(Q);
  }
  var n = Number.isNaN || function(w) {
    return w !== w;
  };
  function i() {
    i.init.call(this);
  }
  ku.exports = i, ku.exports.once = b, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var a = 10;
  function o(Q) {
    if (typeof Q != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof Q);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(Q) {
      if (typeof Q != "number" || Q < 0 || n(Q))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + Q + ".");
      a = Q;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(w) {
    if (typeof w != "number" || w < 0 || n(w))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + w + ".");
    return this._maxListeners = w, this;
  };
  function s(Q) {
    return Q._maxListeners === void 0 ? i.defaultMaxListeners : Q._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return s(this);
  }, i.prototype.emit = function(w) {
    for (var Y = [], k = 1; k < arguments.length; k++) Y.push(arguments[k]);
    var L = w === "error", S = this._events;
    if (S !== void 0)
      L = L && S.error === void 0;
    else if (!L)
      return !1;
    if (L) {
      var P;
      if (Y.length > 0 && (P = Y[0]), P instanceof Error)
        throw P;
      var Z = new Error("Unhandled error." + (P ? " (" + P.message + ")" : ""));
      throw Z.context = P, Z;
    }
    var M = S[w];
    if (M === void 0)
      return !1;
    if (typeof M == "function")
      A(M, this, Y);
    else
      for (var R = M.length, G = C(M, R), k = 0; k < R; ++k)
        A(G[k], this, Y);
    return !0;
  };
  function l(Q, w, Y, k) {
    var L, S, P;
    if (o(Y), S = Q._events, S === void 0 ? (S = Q._events = /* @__PURE__ */ Object.create(null), Q._eventsCount = 0) : (S.newListener !== void 0 && (Q.emit(
      "newListener",
      w,
      Y.listener ? Y.listener : Y
    ), S = Q._events), P = S[w]), P === void 0)
      P = S[w] = Y, ++Q._eventsCount;
    else if (typeof P == "function" ? P = S[w] = k ? [Y, P] : [P, Y] : k ? P.unshift(Y) : P.push(Y), L = s(Q), L > 0 && P.length > L && !P.warned) {
      P.warned = !0;
      var Z = new Error("Possible EventEmitter memory leak detected. " + P.length + " " + String(w) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Z.name = "MaxListenersExceededWarning", Z.emitter = Q, Z.type = w, Z.count = P.length, r(Z);
    }
    return Q;
  }
  i.prototype.addListener = function(w, Y) {
    return l(this, w, Y, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(w, Y) {
    return l(this, w, Y, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function g(Q, w, Y) {
    var k = { fired: !1, wrapFn: void 0, target: Q, type: w, listener: Y }, L = u.bind(k);
    return L.listener = Y, k.wrapFn = L, L;
  }
  i.prototype.once = function(w, Y) {
    return o(Y), this.on(w, g(this, w, Y)), this;
  }, i.prototype.prependOnceListener = function(w, Y) {
    return o(Y), this.prependListener(w, g(this, w, Y)), this;
  }, i.prototype.removeListener = function(w, Y) {
    var k, L, S, P, Z;
    if (o(Y), L = this._events, L === void 0)
      return this;
    if (k = L[w], k === void 0)
      return this;
    if (k === Y || k.listener === Y)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete L[w], L.removeListener && this.emit("removeListener", w, k.listener || Y));
    else if (typeof k != "function") {
      for (S = -1, P = k.length - 1; P >= 0; P--)
        if (k[P] === Y || k[P].listener === Y) {
          Z = k[P].listener, S = P;
          break;
        }
      if (S < 0)
        return this;
      S === 0 ? k.shift() : E(k, S), k.length === 1 && (L[w] = k[0]), L.removeListener !== void 0 && this.emit("removeListener", w, Z || Y);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(w) {
    var Y, k, L;
    if (k = this._events, k === void 0)
      return this;
    if (k.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : k[w] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete k[w]), this;
    if (arguments.length === 0) {
      var S = Object.keys(k), P;
      for (L = 0; L < S.length; ++L)
        P = S[L], P !== "removeListener" && this.removeAllListeners(P);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (Y = k[w], typeof Y == "function")
      this.removeListener(w, Y);
    else if (Y !== void 0)
      for (L = Y.length - 1; L >= 0; L--)
        this.removeListener(w, Y[L]);
    return this;
  };
  function d(Q, w, Y) {
    var k = Q._events;
    if (k === void 0)
      return [];
    var L = k[w];
    return L === void 0 ? [] : typeof L == "function" ? Y ? [L.listener || L] : [L] : Y ? I(L) : C(L, L.length);
  }
  i.prototype.listeners = function(w) {
    return d(this, w, !0);
  }, i.prototype.rawListeners = function(w) {
    return d(this, w, !1);
  }, i.listenerCount = function(Q, w) {
    return typeof Q.listenerCount == "function" ? Q.listenerCount(w) : h.call(Q, w);
  }, i.prototype.listenerCount = h;
  function h(Q) {
    var w = this._events;
    if (w !== void 0) {
      var Y = w[Q];
      if (typeof Y == "function")
        return 1;
      if (Y !== void 0)
        return Y.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function C(Q, w) {
    for (var Y = new Array(w), k = 0; k < w; ++k)
      Y[k] = Q[k];
    return Y;
  }
  function E(Q, w) {
    for (; w + 1 < Q.length; w++)
      Q[w] = Q[w + 1];
    Q.pop();
  }
  function I(Q) {
    for (var w = new Array(Q.length), Y = 0; Y < w.length; ++Y)
      w[Y] = Q[Y].listener || Q[Y];
    return w;
  }
  function b(Q, w) {
    return new Promise(function(Y, k) {
      function L(P) {
        Q.removeListener(w, S), k(P);
      }
      function S() {
        typeof Q.removeListener == "function" && Q.removeListener("error", L), Y([].slice.call(arguments));
      }
      p(Q, w, S, { once: !0 }), w !== "error" && y(Q, L, { once: !0 });
    });
  }
  function y(Q, w, Y) {
    typeof Q.on == "function" && p(Q, "error", w, Y);
  }
  function p(Q, w, Y, k) {
    if (typeof Q.on == "function")
      k.once ? Q.once(w, Y) : Q.on(w, Y);
    else if (typeof Q.addEventListener == "function")
      Q.addEventListener(w, function L(S) {
        k.once && Q.removeEventListener(w, L), Y(S);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof Q);
  }
  return ku.exports;
}
var N1;
function yR() {
  if (N1) return Gu.exports;
  N1 = 1;
  var e = pR(), A = vR().EventEmitter;
  Gu.exports = t, Gu.exports.default = t;
  function t(s) {
    if (!(this instanceof t))
      return new t(s);
    A.call(this), s = s || {}, this.concurrency = s.concurrency || 1 / 0, this.timeout = s.timeout || 0, this.autostart = s.autostart || !1, this.results = s.results || null, this.pending = 0, this.session = 0, this.running = !1, this.jobs = [], this.timers = {};
  }
  e(t, A);
  var r = [
    "pop",
    "shift",
    "indexOf",
    "lastIndexOf"
  ];
  r.forEach(function(s) {
    t.prototype[s] = function() {
      return Array.prototype[s].apply(this.jobs, arguments);
    };
  }), t.prototype.slice = function(s, l) {
    return this.jobs = this.jobs.slice(s, l), this;
  }, t.prototype.reverse = function() {
    return this.jobs.reverse(), this;
  };
  var n = [
    "push",
    "unshift",
    "splice"
  ];
  n.forEach(function(s) {
    t.prototype[s] = function() {
      var l = Array.prototype[s].apply(this.jobs, arguments);
      return this.autostart && this.start(), l;
    };
  }), Object.defineProperty(t.prototype, "length", {
    get: function() {
      return this.pending + this.jobs.length;
    }
  }), t.prototype.start = function(s) {
    if (s && a.call(this, s), this.running = !0, this.pending >= this.concurrency)
      return;
    if (this.jobs.length === 0) {
      this.pending === 0 && o.call(this);
      return;
    }
    var l = this, u = this.jobs.shift(), g = !0, d = this.session, h = null, C = !1, E = null, I = u.hasOwnProperty("timeout") ? u.timeout : this.timeout;
    function b(p, Q) {
      g && l.session === d && (g = !1, l.pending--, h !== null && (delete l.timers[h], clearTimeout(h)), p ? l.emit("error", p, u) : C === !1 && (E !== null && (l.results[E] = Array.prototype.slice.call(arguments, 1)), l.emit("success", Q, u)), l.session === d && (l.pending === 0 && l.jobs.length === 0 ? o.call(l) : l.running && l.start()));
    }
    I && (h = setTimeout(function() {
      C = !0, l.listeners("timeout").length > 0 ? l.emit("timeout", b, u) : b();
    }, I), this.timers[h] = h), this.results && (E = this.results.length, this.results[E] = null), this.pending++, l.emit("start", u);
    var y = u(b);
    y && y.then && typeof y.then == "function" && y.then(function(p) {
      return b(null, p);
    }).catch(function(p) {
      return b(p || !0);
    }), this.running && this.jobs.length > 0 && this.start();
  }, t.prototype.stop = function() {
    this.running = !1;
  }, t.prototype.end = function(s) {
    i.call(this), this.jobs.length = 0, this.pending = 0, o.call(this, s);
  };
  function i() {
    for (var s in this.timers) {
      var l = this.timers[s];
      delete this.timers[s], clearTimeout(l);
    }
  }
  function a(s) {
    var l = this;
    this.on("error", u), this.on("end", g);
    function u(d) {
      l.end(d);
    }
    function g(d) {
      l.removeListener("error", u), l.removeListener("end", g), s(d, this.results);
    }
  }
  function o(s) {
    this.session++, this.running = !1, this.emit("end", s);
  }
  return Gu.exports;
}
var bR = yR();
const FR = /* @__PURE__ */ Ht(bR);
function Wc(e) {
  "@babel/helpers - typeof";
  return Wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, Wc(e);
}
function wr() {
  wr = function() {
    return A;
  };
  var e, A = {}, t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(z, T, O) {
    z[T] = O.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, a = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function l(z, T, O) {
    return Object.defineProperty(z, T, {
      value: O,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), z[T];
  }
  try {
    l({}, "");
  } catch {
    l = function(O, K, AA) {
      return O[K] = AA;
    };
  }
  function u(z, T, O, K) {
    var AA = T && T.prototype instanceof b ? T : b, X = Object.create(AA.prototype), iA = new G(K || []);
    return n(X, "_invoke", {
      value: P(z, O, iA)
    }), X;
  }
  function g(z, T, O) {
    try {
      return {
        type: "normal",
        arg: z.call(T, O)
      };
    } catch (K) {
      return {
        type: "throw",
        arg: K
      };
    }
  }
  A.wrap = u;
  var d = "suspendedStart", h = "suspendedYield", C = "executing", E = "completed", I = {};
  function b() {
  }
  function y() {
  }
  function p() {
  }
  var Q = {};
  l(Q, a, function() {
    return this;
  });
  var w = Object.getPrototypeOf, Y = w && w(w(N([])));
  Y && Y !== t && r.call(Y, a) && (Q = Y);
  var k = p.prototype = b.prototype = Object.create(Q);
  function L(z) {
    ["next", "throw", "return"].forEach(function(T) {
      l(z, T, function(O) {
        return this._invoke(T, O);
      });
    });
  }
  function S(z, T) {
    function O(AA, X, iA, oA) {
      var fA = g(z[AA], z, X);
      if (fA.type !== "throw") {
        var wA = fA.arg, DA = wA.value;
        return DA && Wc(DA) == "object" && r.call(DA, "__await") ? T.resolve(DA.__await).then(function(HA) {
          O("next", HA, iA, oA);
        }, function(HA) {
          O("throw", HA, iA, oA);
        }) : T.resolve(DA).then(function(HA) {
          wA.value = HA, iA(wA);
        }, function(HA) {
          return O("throw", HA, iA, oA);
        });
      }
      oA(fA.arg);
    }
    var K;
    n(this, "_invoke", {
      value: function(X, iA) {
        function oA() {
          return new T(function(fA, wA) {
            O(X, iA, fA, wA);
          });
        }
        return K = K ? K.then(oA, oA) : oA();
      }
    });
  }
  function P(z, T, O) {
    var K = d;
    return function(AA, X) {
      if (K === C) throw Error("Generator is already running");
      if (K === E) {
        if (AA === "throw") throw X;
        return {
          value: e,
          done: !0
        };
      }
      for (O.method = AA, O.arg = X; ; ) {
        var iA = O.delegate;
        if (iA) {
          var oA = Z(iA, O);
          if (oA) {
            if (oA === I) continue;
            return oA;
          }
        }
        if (O.method === "next") O.sent = O._sent = O.arg;
        else if (O.method === "throw") {
          if (K === d) throw K = E, O.arg;
          O.dispatchException(O.arg);
        } else O.method === "return" && O.abrupt("return", O.arg);
        K = C;
        var fA = g(z, T, O);
        if (fA.type === "normal") {
          if (K = O.done ? E : h, fA.arg === I) continue;
          return {
            value: fA.arg,
            done: O.done
          };
        }
        fA.type === "throw" && (K = E, O.method = "throw", O.arg = fA.arg);
      }
    };
  }
  function Z(z, T) {
    var O = T.method, K = z.iterator[O];
    if (K === e) return T.delegate = null, O === "throw" && z.iterator.return && (T.method = "return", T.arg = e, Z(z, T), T.method === "throw") || O !== "return" && (T.method = "throw", T.arg = new TypeError("The iterator does not provide a '" + O + "' method")), I;
    var AA = g(K, z.iterator, T.arg);
    if (AA.type === "throw") return T.method = "throw", T.arg = AA.arg, T.delegate = null, I;
    var X = AA.arg;
    return X ? X.done ? (T[z.resultName] = X.value, T.next = z.nextLoc, T.method !== "return" && (T.method = "next", T.arg = e), T.delegate = null, I) : X : (T.method = "throw", T.arg = new TypeError("iterator result is not an object"), T.delegate = null, I);
  }
  function M(z) {
    var T = {
      tryLoc: z[0]
    };
    1 in z && (T.catchLoc = z[1]), 2 in z && (T.finallyLoc = z[2], T.afterLoc = z[3]), this.tryEntries.push(T);
  }
  function R(z) {
    var T = z.completion || {};
    T.type = "normal", delete T.arg, z.completion = T;
  }
  function G(z) {
    this.tryEntries = [{
      tryLoc: "root"
    }], z.forEach(M, this), this.reset(!0);
  }
  function N(z) {
    if (z || z === "") {
      var T = z[a];
      if (T) return T.call(z);
      if (typeof z.next == "function") return z;
      if (!isNaN(z.length)) {
        var O = -1, K = function AA() {
          for (; ++O < z.length; ) if (r.call(z, O)) return AA.value = z[O], AA.done = !1, AA;
          return AA.value = e, AA.done = !0, AA;
        };
        return K.next = K;
      }
    }
    throw new TypeError(Wc(z) + " is not iterable");
  }
  return y.prototype = p, n(k, "constructor", {
    value: p,
    configurable: !0
  }), n(p, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = l(p, s, "GeneratorFunction"), A.isGeneratorFunction = function(z) {
    var T = typeof z == "function" && z.constructor;
    return !!T && (T === y || (T.displayName || T.name) === "GeneratorFunction");
  }, A.mark = function(z) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(z, p) : (z.__proto__ = p, l(z, s, "GeneratorFunction")), z.prototype = Object.create(k), z;
  }, A.awrap = function(z) {
    return {
      __await: z
    };
  }, L(S.prototype), l(S.prototype, o, function() {
    return this;
  }), A.AsyncIterator = S, A.async = function(z, T, O, K, AA) {
    AA === void 0 && (AA = Promise);
    var X = new S(u(z, T, O, K), AA);
    return A.isGeneratorFunction(T) ? X : X.next().then(function(iA) {
      return iA.done ? iA.value : X.next();
    });
  }, L(k), l(k, s, "Generator"), l(k, a, function() {
    return this;
  }), l(k, "toString", function() {
    return "[object Generator]";
  }), A.keys = function(z) {
    var T = Object(z), O = [];
    for (var K in T) O.push(K);
    return O.reverse(), function AA() {
      for (; O.length; ) {
        var X = O.pop();
        if (X in T) return AA.value = X, AA.done = !1, AA;
      }
      return AA.done = !0, AA;
    };
  }, A.values = N, G.prototype = {
    constructor: G,
    reset: function(T) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !T) for (var O in this) O.charAt(0) === "t" && r.call(this, O) && !isNaN(+O.slice(1)) && (this[O] = e);
    },
    stop: function() {
      this.done = !0;
      var T = this.tryEntries[0].completion;
      if (T.type === "throw") throw T.arg;
      return this.rval;
    },
    dispatchException: function(T) {
      if (this.done) throw T;
      var O = this;
      function K(wA, DA) {
        return iA.type = "throw", iA.arg = T, O.next = wA, DA && (O.method = "next", O.arg = e), !!DA;
      }
      for (var AA = this.tryEntries.length - 1; AA >= 0; --AA) {
        var X = this.tryEntries[AA], iA = X.completion;
        if (X.tryLoc === "root") return K("end");
        if (X.tryLoc <= this.prev) {
          var oA = r.call(X, "catchLoc"), fA = r.call(X, "finallyLoc");
          if (oA && fA) {
            if (this.prev < X.catchLoc) return K(X.catchLoc, !0);
            if (this.prev < X.finallyLoc) return K(X.finallyLoc);
          } else if (oA) {
            if (this.prev < X.catchLoc) return K(X.catchLoc, !0);
          } else {
            if (!fA) throw Error("try statement without catch or finally");
            if (this.prev < X.finallyLoc) return K(X.finallyLoc);
          }
        }
      }
    },
    abrupt: function(T, O) {
      for (var K = this.tryEntries.length - 1; K >= 0; --K) {
        var AA = this.tryEntries[K];
        if (AA.tryLoc <= this.prev && r.call(AA, "finallyLoc") && this.prev < AA.finallyLoc) {
          var X = AA;
          break;
        }
      }
      X && (T === "break" || T === "continue") && X.tryLoc <= O && O <= X.finallyLoc && (X = null);
      var iA = X ? X.completion : {};
      return iA.type = T, iA.arg = O, X ? (this.method = "next", this.next = X.finallyLoc, I) : this.complete(iA);
    },
    complete: function(T, O) {
      if (T.type === "throw") throw T.arg;
      return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && O && (this.next = O), I;
    },
    finish: function(T) {
      for (var O = this.tryEntries.length - 1; O >= 0; --O) {
        var K = this.tryEntries[O];
        if (K.finallyLoc === T) return this.complete(K.completion, K.afterLoc), R(K), I;
      }
    },
    catch: function(T) {
      for (var O = this.tryEntries.length - 1; O >= 0; --O) {
        var K = this.tryEntries[O];
        if (K.tryLoc === T) {
          var AA = K.completion;
          if (AA.type === "throw") {
            var X = AA.arg;
            R(K);
          }
          return X;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(T, O, K) {
      return this.delegate = {
        iterator: N(T),
        resultName: O,
        nextLoc: K
      }, this.method === "next" && (this.arg = e), I;
    }
  }, A;
}
function T1(e, A, t, r, n, i, a) {
  try {
    var o = e[i](a), s = o.value;
  } catch (l) {
    return void t(l);
  }
  o.done ? A(s) : Promise.resolve(s).then(r, n);
}
function Ui(e) {
  return function() {
    var A = this, t = arguments;
    return new Promise(function(r, n) {
      var i = e.apply(A, t);
      function a(s) {
        T1(i, r, n, a, o, "next", s);
      }
      function o(s) {
        T1(i, r, n, a, o, "throw", s);
      }
      a(void 0);
    });
  };
}
var Os = { exports: {} }, LR = Os.exports, P1;
function RR() {
  return P1 || (P1 = 1, function(e, A) {
    var t = typeof self < "u" ? self : LR, r = function() {
      function i() {
        this.fetch = !1, this.DOMException = t.DOMException;
      }
      return i.prototype = t, new i();
    }();
    (function(i) {
      (function(a) {
        var o = {
          searchParams: "URLSearchParams" in i,
          iterable: "Symbol" in i && "iterator" in Symbol,
          blob: "FileReader" in i && "Blob" in i && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in i,
          arrayBuffer: "ArrayBuffer" in i
        };
        function s(G) {
          return G && DataView.prototype.isPrototypeOf(G);
        }
        if (o.arrayBuffer)
          var l = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], u = ArrayBuffer.isView || function(G) {
            return G && l.indexOf(Object.prototype.toString.call(G)) > -1;
          };
        function g(G) {
          if (typeof G != "string" && (G = String(G)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(G))
            throw new TypeError("Invalid character in header field name");
          return G.toLowerCase();
        }
        function d(G) {
          return typeof G != "string" && (G = String(G)), G;
        }
        function h(G) {
          var N = {
            next: function() {
              var z = G.shift();
              return { done: z === void 0, value: z };
            }
          };
          return o.iterable && (N[Symbol.iterator] = function() {
            return N;
          }), N;
        }
        function C(G) {
          this.map = {}, G instanceof C ? G.forEach(function(N, z) {
            this.append(z, N);
          }, this) : Array.isArray(G) ? G.forEach(function(N) {
            this.append(N[0], N[1]);
          }, this) : G && Object.getOwnPropertyNames(G).forEach(function(N) {
            this.append(N, G[N]);
          }, this);
        }
        C.prototype.append = function(G, N) {
          G = g(G), N = d(N);
          var z = this.map[G];
          this.map[G] = z ? z + ", " + N : N;
        }, C.prototype.delete = function(G) {
          delete this.map[g(G)];
        }, C.prototype.get = function(G) {
          return G = g(G), this.has(G) ? this.map[G] : null;
        }, C.prototype.has = function(G) {
          return this.map.hasOwnProperty(g(G));
        }, C.prototype.set = function(G, N) {
          this.map[g(G)] = d(N);
        }, C.prototype.forEach = function(G, N) {
          for (var z in this.map)
            this.map.hasOwnProperty(z) && G.call(N, this.map[z], z, this);
        }, C.prototype.keys = function() {
          var G = [];
          return this.forEach(function(N, z) {
            G.push(z);
          }), h(G);
        }, C.prototype.values = function() {
          var G = [];
          return this.forEach(function(N) {
            G.push(N);
          }), h(G);
        }, C.prototype.entries = function() {
          var G = [];
          return this.forEach(function(N, z) {
            G.push([z, N]);
          }), h(G);
        }, o.iterable && (C.prototype[Symbol.iterator] = C.prototype.entries);
        function E(G) {
          if (G.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          G.bodyUsed = !0;
        }
        function I(G) {
          return new Promise(function(N, z) {
            G.onload = function() {
              N(G.result);
            }, G.onerror = function() {
              z(G.error);
            };
          });
        }
        function b(G) {
          var N = new FileReader(), z = I(N);
          return N.readAsArrayBuffer(G), z;
        }
        function y(G) {
          var N = new FileReader(), z = I(N);
          return N.readAsText(G), z;
        }
        function p(G) {
          for (var N = new Uint8Array(G), z = new Array(N.length), T = 0; T < N.length; T++)
            z[T] = String.fromCharCode(N[T]);
          return z.join("");
        }
        function Q(G) {
          if (G.slice)
            return G.slice(0);
          var N = new Uint8Array(G.byteLength);
          return N.set(new Uint8Array(G)), N.buffer;
        }
        function w() {
          return this.bodyUsed = !1, this._initBody = function(G) {
            this._bodyInit = G, G ? typeof G == "string" ? this._bodyText = G : o.blob && Blob.prototype.isPrototypeOf(G) ? this._bodyBlob = G : o.formData && FormData.prototype.isPrototypeOf(G) ? this._bodyFormData = G : o.searchParams && URLSearchParams.prototype.isPrototypeOf(G) ? this._bodyText = G.toString() : o.arrayBuffer && o.blob && s(G) ? (this._bodyArrayBuffer = Q(G.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : o.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(G) || u(G)) ? this._bodyArrayBuffer = Q(G) : this._bodyText = G = Object.prototype.toString.call(G) : this._bodyText = "", this.headers.get("content-type") || (typeof G == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : o.searchParams && URLSearchParams.prototype.isPrototypeOf(G) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, o.blob && (this.blob = function() {
            var G = E(this);
            if (G)
              return G;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            return this._bodyArrayBuffer ? E(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(b);
          }), this.text = function() {
            var G = E(this);
            if (G)
              return G;
            if (this._bodyBlob)
              return y(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(p(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, o.formData && (this.formData = function() {
            return this.text().then(S);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var Y = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function k(G) {
          var N = G.toUpperCase();
          return Y.indexOf(N) > -1 ? N : G;
        }
        function L(G, N) {
          N = N || {};
          var z = N.body;
          if (G instanceof L) {
            if (G.bodyUsed)
              throw new TypeError("Already read");
            this.url = G.url, this.credentials = G.credentials, N.headers || (this.headers = new C(G.headers)), this.method = G.method, this.mode = G.mode, this.signal = G.signal, !z && G._bodyInit != null && (z = G._bodyInit, G.bodyUsed = !0);
          } else
            this.url = String(G);
          if (this.credentials = N.credentials || this.credentials || "same-origin", (N.headers || !this.headers) && (this.headers = new C(N.headers)), this.method = k(N.method || this.method || "GET"), this.mode = N.mode || this.mode || null, this.signal = N.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && z)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(z);
        }
        L.prototype.clone = function() {
          return new L(this, { body: this._bodyInit });
        };
        function S(G) {
          var N = new FormData();
          return G.trim().split("&").forEach(function(z) {
            if (z) {
              var T = z.split("="), O = T.shift().replace(/\+/g, " "), K = T.join("=").replace(/\+/g, " ");
              N.append(decodeURIComponent(O), decodeURIComponent(K));
            }
          }), N;
        }
        function P(G) {
          var N = new C(), z = G.replace(/\r?\n[\t ]+/g, " ");
          return z.split(/\r?\n/).forEach(function(T) {
            var O = T.split(":"), K = O.shift().trim();
            if (K) {
              var AA = O.join(":").trim();
              N.append(K, AA);
            }
          }), N;
        }
        w.call(L.prototype);
        function Z(G, N) {
          N || (N = {}), this.type = "default", this.status = N.status === void 0 ? 200 : N.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in N ? N.statusText : "OK", this.headers = new C(N.headers), this.url = N.url || "", this._initBody(G);
        }
        w.call(Z.prototype), Z.prototype.clone = function() {
          return new Z(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new C(this.headers),
            url: this.url
          });
        }, Z.error = function() {
          var G = new Z(null, { status: 0, statusText: "" });
          return G.type = "error", G;
        };
        var M = [301, 302, 303, 307, 308];
        Z.redirect = function(G, N) {
          if (M.indexOf(N) === -1)
            throw new RangeError("Invalid status code");
          return new Z(null, { status: N, headers: { location: G } });
        }, a.DOMException = i.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(N, z) {
            this.message = N, this.name = z;
            var T = Error(N);
            this.stack = T.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function R(G, N) {
          return new Promise(function(z, T) {
            var O = new L(G, N);
            if (O.signal && O.signal.aborted)
              return T(new a.DOMException("Aborted", "AbortError"));
            var K = new XMLHttpRequest();
            function AA() {
              K.abort();
            }
            K.onload = function() {
              var X = {
                status: K.status,
                statusText: K.statusText,
                headers: P(K.getAllResponseHeaders() || "")
              };
              X.url = "responseURL" in K ? K.responseURL : X.headers.get("X-Request-URL");
              var iA = "response" in K ? K.response : K.responseText;
              z(new Z(iA, X));
            }, K.onerror = function() {
              T(new TypeError("Network request failed"));
            }, K.ontimeout = function() {
              T(new TypeError("Network request failed"));
            }, K.onabort = function() {
              T(new a.DOMException("Aborted", "AbortError"));
            }, K.open(O.method, O.url, !0), O.credentials === "include" ? K.withCredentials = !0 : O.credentials === "omit" && (K.withCredentials = !1), "responseType" in K && o.blob && (K.responseType = "blob"), O.headers.forEach(function(X, iA) {
              K.setRequestHeader(iA, X);
            }), O.signal && (O.signal.addEventListener("abort", AA), K.onreadystatechange = function() {
              K.readyState === 4 && O.signal.removeEventListener("abort", AA);
            }), K.send(typeof O._bodyInit > "u" ? null : O._bodyInit);
          });
        }
        return R.polyfill = !0, i.fetch || (i.fetch = R, i.Headers = C, i.Request = L, i.Response = Z), a.Headers = C, a.Request = L, a.Response = Z, a.fetch = R, Object.defineProperty(a, "__esModule", { value: !0 }), a;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var n = r;
    A = n.fetch, A.default = n.fetch, A.fetch = n.fetch, A.Headers = n.Headers, A.Request = n.Request, A.Response = n.Response, e.exports = A;
  }(Os, Os.exports)), Os.exports;
}
var GR = RR();
const y4 = /* @__PURE__ */ Ht(GR), xR = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
class Dr {
  constructor(A) {
    this.buffer = A, this.view = new DataView(A.buffer, A.byteOffset, A.byteLength), this.pos = 0, this.length = this.buffer.length;
  }
  readString(A, t = "ascii") {
    t = xR[t] || t;
    let r = this.readBuffer(A);
    try {
      return new TextDecoder(t).decode(r);
    } catch {
      return r;
    }
  }
  readBuffer(A) {
    return this.buffer.slice(this.pos, this.pos += A);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
}
Dr.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let e of Object.getOwnPropertyNames(DataView.prototype))
  if (e.slice(0, 3) === "get") {
    let A = e.slice(3).replace("Ui", "UI");
    A === "Float32" ? A = "Float" : A === "Float64" && (A = "Double");
    let t = Dr.TYPES[A];
    Dr.prototype["read" + A + (t === 1 ? "" : "BE")] = function() {
      const r = this.view[e](this.pos, !1);
      return this.pos += t, r;
    }, t !== 1 && (Dr.prototype["read" + A + "LE"] = function() {
      const r = this.view[e](this.pos, !0);
      return this.pos += t, r;
    });
  }
const kR = new TextEncoder(), z1 = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
class Zc {
  constructor(A) {
    this.buffer = A, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
  }
  writeBuffer(A) {
    this.buffer.set(A, this.pos), this.pos += A.length;
  }
  writeString(A, t = "ascii") {
    let r;
    switch (t) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        r = j1(A, z1);
        break;
      case "utf16be":
      case "utf16-be":
        r = j1(A, !z1);
        break;
      case "utf8":
        r = kR.encode(A);
        break;
      case "ascii":
        r = UR(A);
        break;
      default:
        throw new Error(`Unsupported encoding: ${t}`);
    }
    this.writeBuffer(r);
  }
  writeUInt24BE(A) {
    this.buffer[this.pos++] = A >>> 16 & 255, this.buffer[this.pos++] = A >>> 8 & 255, this.buffer[this.pos++] = A & 255;
  }
  writeUInt24LE(A) {
    this.buffer[this.pos++] = A & 255, this.buffer[this.pos++] = A >>> 8 & 255, this.buffer[this.pos++] = A >>> 16 & 255;
  }
  writeInt24BE(A) {
    A >= 0 ? this.writeUInt24BE(A) : this.writeUInt24BE(A + 16777215 + 1);
  }
  writeInt24LE(A) {
    A >= 0 ? this.writeUInt24LE(A) : this.writeUInt24LE(A + 16777215 + 1);
  }
  fill(A, t) {
    if (t < this.buffer.length)
      this.buffer.fill(A, this.pos, this.pos + t), this.pos += t;
    else {
      const r = new Uint8Array(t);
      r.fill(A), this.writeBuffer(r);
    }
  }
}
function j1(e, A) {
  let t = new Uint16Array(e.length);
  for (let r = 0; r < e.length; r++) {
    let n = e.charCodeAt(r);
    A && (n = n >> 8 | (n & 255) << 8), t[r] = n;
  }
  return new Uint8Array(t.buffer);
}
function UR(e) {
  let A = new Uint8Array(e.length);
  for (let t = 0; t < e.length; t++)
    A[t] = e.charCodeAt(t);
  return A;
}
for (let e of Object.getOwnPropertyNames(DataView.prototype))
  if (e.slice(0, 3) === "set") {
    let A = e.slice(3).replace("Ui", "UI");
    A === "Float32" ? A = "Float" : A === "Float64" && (A = "Double");
    let t = Dr.TYPES[A];
    Zc.prototype["write" + A + (t === 1 ? "" : "BE")] = function(r) {
      this.view[e](this.pos, r, !1), this.pos += t;
    }, t !== 1 && (Zc.prototype["write" + A + "LE"] = function(r) {
      this.view[e](this.pos, r, !0), this.pos += t;
    });
  }
class si {
  fromBuffer(A) {
    let t = new Dr(A);
    return this.decode(t);
  }
  toBuffer(A) {
    let t = this.size(A), r = new Uint8Array(t), n = new Zc(r);
    return this.encode(n, A), r;
  }
}
class pt extends si {
  constructor(A, t = "BE") {
    super(), this.type = A, this.endian = t, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
  }
  size() {
    return Dr.TYPES[this.type];
  }
  decode(A) {
    return A[`read${this.fn}`]();
  }
  encode(A, t) {
    return A[`write${this.fn}`](t);
  }
}
const Ae = new pt("UInt8"), gr = new pt("UInt16", "BE"), v = gr, YR = new pt("UInt16", "LE"), HR = new pt("UInt24", "BE"), Ti = HR;
new pt("UInt24", "LE");
const b4 = new pt("UInt32", "BE"), BA = b4, SR = new pt("UInt32", "LE"), sr = new pt("Int8"), NR = new pt("Int16", "BE"), zA = NR;
new pt("Int16", "LE");
new pt("Int24", "BE");
new pt("Int24", "LE");
const TR = new pt("Int32", "BE"), ya = TR;
new pt("Int32", "LE");
new pt("Float", "BE");
new pt("Float", "LE");
new pt("Double", "BE");
new pt("Double", "LE");
class Ao extends pt {
  constructor(A, t, r = A >> 1) {
    super(`Int${A}`, t), this._point = 1 << r;
  }
  decode(A) {
    return super.decode(A) / this._point;
  }
  encode(A, t) {
    return super.encode(A, t * this._point | 0);
  }
}
const PR = new Ao(16, "BE"), zR = PR;
new Ao(16, "LE");
const jR = new Ao(32, "BE"), qt = jR;
new Ao(32, "LE");
function R0(e, A, t) {
  let r;
  if (typeof e == "number" ? r = e : typeof e == "function" ? r = e.call(t, t) : t && typeof e == "string" ? r = t[e] : A && e instanceof pt && (r = e.decode(A)), isNaN(r))
    throw new Error("Not a fixed size");
  return r;
}
class QC {
  constructor(A = {}) {
    this.enumerable = !0, this.configurable = !0;
    for (let t in A) {
      const r = A[t];
      this[t] = r;
    }
  }
}
class uA extends si {
  constructor(A, t, r = "count") {
    super(), this.type = A, this.length = t, this.lengthType = r;
  }
  decode(A, t) {
    let r;
    const { pos: n } = A, i = [];
    let a = t;
    if (this.length != null && (r = R0(this.length, A, t)), this.length instanceof pt && (Object.defineProperties(i, {
      parent: { value: t },
      _startOffset: { value: n },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: r }
    }), a = i), r == null || this.lengthType === "bytes") {
      const o = r != null ? A.pos + r : t != null && t._length ? t._startOffset + t._length : A.length;
      for (; A.pos < o; )
        i.push(this.type.decode(A, a));
    } else
      for (let o = 0, s = r; o < s; o++)
        i.push(this.type.decode(A, a));
    return i;
  }
  size(A, t, r = !0) {
    if (!A)
      return this.type.size(null, t) * R0(this.length, null, t);
    let n = 0;
    this.length instanceof pt && (n += this.length.size(), t = { parent: t, pointerSize: 0 });
    for (let i of A)
      n += this.type.size(i, t);
    return t && r && this.length instanceof pt && (n += t.pointerSize), n;
  }
  encode(A, t, r) {
    let n = r;
    this.length instanceof pt && (n = {
      pointers: [],
      startOffset: A.pos,
      parent: r
    }, n.pointerOffset = A.pos + this.size(t, n, !1), this.length.encode(A, t.length));
    for (let i of t)
      this.type.encode(A, i, n);
    if (this.length instanceof pt) {
      let i = 0;
      for (; i < n.pointers.length; ) {
        const a = n.pointers[i++];
        a.type.encode(A, a.val, a.parent);
      }
    }
  }
}
class Gt extends uA {
  decode(A, t) {
    const { pos: r } = A, n = R0(this.length, A, t);
    this.length instanceof pt && (t = {
      parent: t,
      _startOffset: r,
      _currentOffset: 0,
      _length: n
    });
    const i = new cf(this.type, n, A, t);
    return A.pos += n * this.type.size(null, t), i;
  }
  size(A, t) {
    return A instanceof cf && (A = A.toArray()), super.size(A, t);
  }
  encode(A, t, r) {
    return t instanceof cf && (t = t.toArray()), super.encode(A, t, r);
  }
}
class cf {
  constructor(A, t, r, n) {
    this.type = A, this.length = t, this.stream = r, this.ctx = n, this.base = this.stream.pos, this.items = [];
  }
  get(A) {
    if (!(A < 0 || A >= this.length)) {
      if (this.items[A] == null) {
        const { pos: t } = this.stream;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * A, this.items[A] = this.type.decode(this.stream, this.ctx), this.stream.pos = t;
      }
      return this.items[A];
    }
  }
  toArray() {
    const A = [];
    for (let t = 0, r = this.length; t < r; t++)
      A.push(this.get(t));
    return A;
  }
}
class Xn extends si {
  constructor(A, t = []) {
    super(), this.type = A, this.flags = t;
  }
  decode(A) {
    const t = this.type.decode(A), r = {};
    for (let n = 0; n < this.flags.length; n++) {
      const i = this.flags[n];
      i != null && (r[i] = !!(t & 1 << n));
    }
    return r;
  }
  size() {
    return this.type.size();
  }
  encode(A, t) {
    let r = 0;
    for (let n = 0; n < this.flags.length; n++) {
      const i = this.flags[n];
      i != null && t[i] && (r |= 1 << n);
    }
    return this.type.encode(A, r);
  }
}
class mr extends si {
  constructor(A) {
    super(), this.length = A;
  }
  decode(A, t) {
    const r = R0(this.length, A, t);
    return A.readBuffer(r);
  }
  size(A, t) {
    if (!A)
      return R0(this.length, null, t);
    let r = A.length;
    return this.length instanceof pt && (r += this.length.size()), r;
  }
  encode(A, t, r) {
    return this.length instanceof pt && this.length.encode(A, t.length), A.writeBuffer(t);
  }
}
class Kc extends si {
  constructor(A, t = !0) {
    super(), this.type = A, this.condition = t;
  }
  decode(A, t) {
    let { condition: r } = this;
    if (typeof r == "function" && (r = r.call(t, t)), r)
      return this.type.decode(A, t);
  }
  size(A, t) {
    let { condition: r } = this;
    return typeof r == "function" && (r = r.call(t, t)), r ? this.type.size(A, t) : 0;
  }
  encode(A, t, r) {
    let { condition: n } = this;
    if (typeof n == "function" && (n = n.call(r, r)), n)
      return this.type.encode(A, t, r);
  }
}
class Nt extends si {
  constructor(A, t = 1) {
    super(), this.type = A, this.count = t;
  }
  decode(A, t) {
    A.pos += this.size(null, t);
  }
  size(A, t) {
    const r = R0(this.count, null, t);
    return this.type.size() * r;
  }
  encode(A, t, r) {
    return A.fill(0, this.size(t, r));
  }
}
class Dt extends si {
  constructor(A, t = "ascii") {
    super(), this.length = A, this.encoding = t;
  }
  decode(A, t) {
    let r, n, { encoding: i } = this;
    typeof i == "function" && (i = i.call(t, t) || "ascii");
    let a = gf(i);
    if (this.length != null)
      r = R0(this.length, A, t);
    else {
      let s;
      for ({ buffer: s, length: r, pos: n } = A; n < r - a + 1 && (s[n] !== 0 || a === 2 && s[n + 1] !== 0); )
        n += a;
      r = n - A.pos;
    }
    const o = A.readString(r, i);
    return this.length == null && A.pos < A.length && (A.pos += a), o;
  }
  size(A, t) {
    if (A == null)
      return R0(this.length, null, t);
    let { encoding: r } = this;
    typeof r == "function" && (r = r.call(t != null ? t.val : void 0, t != null ? t.val : void 0) || "ascii"), r === "utf16be" && (r = "utf16le");
    let n = V1(A, r);
    return this.length instanceof pt && (n += this.length.size()), this.length == null && (n += gf(r)), n;
  }
  encode(A, t, r) {
    let { encoding: n } = this;
    if (typeof n == "function" && (n = n.call(r != null ? r.val : void 0, r != null ? r.val : void 0) || "ascii"), this.length instanceof pt && this.length.encode(A, V1(t, n)), A.writeString(t, n), this.length == null)
      return gf(n) == 2 ? A.writeUInt16LE(0) : A.writeUInt8(0);
  }
}
function gf(e) {
  switch (e) {
    case "ascii":
    case "utf8":
      return 1;
    case "utf16le":
    case "utf16-le":
    case "utf-16be":
    case "utf-16le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return 2;
    default:
      return 1;
  }
}
function V1(e, A) {
  switch (A) {
    case "ascii":
      return e.length;
    case "utf8":
      let t = 0;
      for (let r = 0; r < e.length; r++) {
        let n = e.charCodeAt(r);
        if (n >= 55296 && n <= 56319 && r < e.length - 1) {
          let i = e.charCodeAt(++r);
          (i & 64512) === 56320 ? n = ((n & 1023) << 10) + (i & 1023) + 65536 : r--;
        }
        n & 4294967168 ? n & 4294965248 ? n & 4294901760 ? n & 4292870144 || (t += 4) : t += 3 : t += 2 : t++;
      }
      return t;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return e.length * 2;
    default:
      throw new Error("Unknown encoding " + A);
  }
}
class QA extends si {
  constructor(A = {}) {
    super(), this.fields = A;
  }
  decode(A, t, r = 0) {
    const n = this._setup(A, t, r);
    return this._parseFields(A, n, this.fields), this.process != null && this.process.call(n, A), n;
  }
  _setup(A, t, r) {
    const n = {};
    return Object.defineProperties(n, {
      parent: { value: t },
      _startOffset: { value: A.pos },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: r }
    }), n;
  }
  _parseFields(A, t, r) {
    for (let i in r) {
      var n;
      const a = r[i];
      typeof a == "function" ? n = a.call(t, t) : n = a.decode(A, t), n !== void 0 && (n instanceof QC ? Object.defineProperty(t, i, n) : t[i] = n), t._currentOffset = A.pos - t._startOffset;
    }
  }
  size(A, t, r = !0) {
    A == null && (A = {});
    const n = {
      parent: t,
      val: A,
      pointerSize: 0
    };
    this.preEncode != null && this.preEncode.call(A);
    let i = 0;
    for (let a in this.fields) {
      const o = this.fields[a];
      o.size != null && (i += o.size(A[a], n));
    }
    return r && (i += n.pointerSize), i;
  }
  encode(A, t, r) {
    let n;
    this.preEncode != null && this.preEncode.call(t, A);
    const i = {
      pointers: [],
      startOffset: A.pos,
      parent: r,
      val: t,
      pointerSize: 0
    };
    i.pointerOffset = A.pos + this.size(t, i, !1);
    for (let o in this.fields)
      n = this.fields[o], n.encode != null && n.encode(A, t[o], i);
    let a = 0;
    for (; a < i.pointers.length; ) {
      const o = i.pointers[a++];
      o.type.encode(A, o.val, o.parent);
    }
  }
}
const VR = (e, A) => A.reduce((t, r) => t && t[r], e);
class $e extends QA {
  constructor(A, t = {}) {
    super(), this.type = A, this.versions = t, typeof A == "string" && (this.versionPath = A.split("."));
  }
  decode(A, t, r = 0) {
    const n = this._setup(A, t, r);
    typeof this.type == "string" ? n.version = VR(t, this.versionPath) : n.version = this.type.decode(A), this.versions.header && this._parseFields(A, n, this.versions.header);
    const i = this.versions[n.version];
    if (i == null)
      throw new Error(`Unknown version ${n.version}`);
    return i instanceof $e ? i.decode(A, t) : (this._parseFields(A, n, i), this.process != null && this.process.call(n, A), n);
  }
  size(A, t, r = !0) {
    let n, i;
    if (!A)
      throw new Error("Not a fixed size");
    this.preEncode != null && this.preEncode.call(A);
    const a = {
      parent: t,
      val: A,
      pointerSize: 0
    };
    let o = 0;
    if (typeof this.type != "string" && (o += this.type.size(A.version, a)), this.versions.header)
      for (n in this.versions.header)
        i = this.versions.header[n], i.size != null && (o += i.size(A[n], a));
    const s = this.versions[A.version];
    if (s == null)
      throw new Error(`Unknown version ${A.version}`);
    for (n in s)
      i = s[n], i.size != null && (o += i.size(A[n], a));
    return r && (o += a.pointerSize), o;
  }
  encode(A, t, r) {
    let n, i;
    this.preEncode != null && this.preEncode.call(t, A);
    const a = {
      pointers: [],
      startOffset: A.pos,
      parent: r,
      val: t,
      pointerSize: 0
    };
    if (a.pointerOffset = A.pos + this.size(t, a, !1), typeof this.type != "string" && this.type.encode(A, t.version), this.versions.header)
      for (n in this.versions.header)
        i = this.versions.header[n], i.encode != null && i.encode(A, t[n], a);
    const o = this.versions[t.version];
    for (n in o)
      i = o[n], i.encode != null && i.encode(A, t[n], a);
    let s = 0;
    for (; s < a.pointers.length; ) {
      const l = a.pointers[s++];
      l.type.encode(A, l.val, l.parent);
    }
  }
}
class cA extends si {
  constructor(A, t, r = {}) {
    if (super(), this.offsetType = A, this.type = t, this.options = r, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
      if (typeof this.options.relativeTo != "function")
        throw new Error("relativeTo option must be a function");
      this.relativeToGetter = r.relativeTo;
    }
  }
  decode(A, t) {
    const r = this.offsetType.decode(A, t);
    if (r === this.options.nullValue && this.options.allowNull)
      return null;
    let n;
    switch (this.options.type) {
      case "local":
        n = t._startOffset;
        break;
      case "immediate":
        n = A.pos - this.offsetType.size();
        break;
      case "parent":
        n = t.parent._startOffset;
        break;
      default:
        for (var i = t; i.parent; )
          i = i.parent;
        n = i._startOffset || 0;
    }
    this.options.relativeTo && (n += this.relativeToGetter(t));
    const a = r + n;
    if (this.type != null) {
      let o = null;
      const s = () => {
        if (o != null)
          return o;
        const { pos: l } = A;
        return A.pos = a, o = this.type.decode(A, t), A.pos = l, o;
      };
      return this.options.lazy ? new QC({
        get: s
      }) : s();
    } else
      return a;
  }
  size(A, t) {
    const r = t;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        t = t.parent;
        break;
      default:
        for (; t.parent; )
          t = t.parent;
    }
    let { type: n } = this;
    if (n == null) {
      if (!(A instanceof uh))
        throw new Error("Must be a VoidPointer");
      ({ type: n } = A), A = A.value;
    }
    if (A && t) {
      let i = n.size(A, r);
      t.pointerSize += i;
    }
    return this.offsetType.size();
  }
  encode(A, t, r) {
    let n;
    const i = r;
    if (t == null) {
      this.offsetType.encode(A, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        n = r.startOffset;
        break;
      case "immediate":
        n = A.pos + this.offsetType.size(t, i);
        break;
      case "parent":
        r = r.parent, n = r.startOffset;
        break;
      default:
        for (n = 0; r.parent; )
          r = r.parent;
    }
    this.options.relativeTo && (n += this.relativeToGetter(i.val)), this.offsetType.encode(A, r.pointerOffset - n);
    let { type: a } = this;
    if (a == null) {
      if (!(t instanceof uh))
        throw new Error("Must be a VoidPointer");
      ({ type: a } = t), t = t.value;
    }
    return r.pointers.push({
      type: a,
      val: t,
      parent: i
    }), r.pointerOffset += a.size(t, i);
  }
}
class uh {
  constructor(A, t) {
    this.type = A, this.value = t;
  }
}
function rn(e, A, t) {
  return A in e ? Object.defineProperty(e, A, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[A] = t, e;
}
function pr(e, A, t, r) {
  var n = arguments.length, i = n < 3 ? A : r === null ? r = Object.getOwnPropertyDescriptor(A, t) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(e, A, t, r);
  else for (var o = e.length - 1; o >= 0; o--) (a = e[o]) && (i = (n < 3 ? a(i) : n > 3 ? a(A, t, i) : a(A, t)) || i);
  return n > 3 && i && Object.defineProperty(A, t, i), i;
}
var Bf, O1;
function OR() {
  return O1 || (O1 = 1, Bf = function e(A, t) {
    if (A === t) return !0;
    if (A && t && typeof A == "object" && typeof t == "object") {
      if (A.constructor !== t.constructor) return !1;
      var r, n, i;
      if (Array.isArray(A)) {
        if (r = A.length, r != t.length) return !1;
        for (n = r; n-- !== 0; )
          if (!e(A[n], t[n])) return !1;
        return !0;
      }
      if (A.constructor === RegExp) return A.source === t.source && A.flags === t.flags;
      if (A.valueOf !== Object.prototype.valueOf) return A.valueOf() === t.valueOf();
      if (A.toString !== Object.prototype.toString) return A.toString() === t.toString();
      if (i = Object.keys(A), r = i.length, r !== Object.keys(t).length) return !1;
      for (n = r; n-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(t, i[n])) return !1;
      for (n = r; n-- !== 0; ) {
        var a = i[n];
        if (!e(A[a], t[a])) return !1;
      }
      return !0;
    }
    return A !== A && t !== t;
  }), Bf;
}
var JR = OR();
const J1 = /* @__PURE__ */ Ht(JR);
var Ns = {}, W1;
function F4() {
  if (W1) return Ns;
  W1 = 1, Ns.byteLength = o, Ns.toByteArray = l, Ns.fromByteArray = d;
  for (var e = [], A = [], t = typeof Uint8Array < "u" ? Uint8Array : Array, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, i = r.length; n < i; ++n)
    e[n] = r[n], A[r.charCodeAt(n)] = n;
  A[45] = 62, A[95] = 63;
  function a(h) {
    var C = h.length;
    if (C % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var E = h.indexOf("=");
    E === -1 && (E = C);
    var I = E === C ? 0 : 4 - E % 4;
    return [E, I];
  }
  function o(h) {
    var C = a(h), E = C[0], I = C[1];
    return (E + I) * 3 / 4 - I;
  }
  function s(h, C, E) {
    return (C + E) * 3 / 4 - E;
  }
  function l(h) {
    var C, E = a(h), I = E[0], b = E[1], y = new t(s(h, I, b)), p = 0, Q = b > 0 ? I - 4 : I, w;
    for (w = 0; w < Q; w += 4)
      C = A[h.charCodeAt(w)] << 18 | A[h.charCodeAt(w + 1)] << 12 | A[h.charCodeAt(w + 2)] << 6 | A[h.charCodeAt(w + 3)], y[p++] = C >> 16 & 255, y[p++] = C >> 8 & 255, y[p++] = C & 255;
    return b === 2 && (C = A[h.charCodeAt(w)] << 2 | A[h.charCodeAt(w + 1)] >> 4, y[p++] = C & 255), b === 1 && (C = A[h.charCodeAt(w)] << 10 | A[h.charCodeAt(w + 1)] << 4 | A[h.charCodeAt(w + 2)] >> 2, y[p++] = C >> 8 & 255, y[p++] = C & 255), y;
  }
  function u(h) {
    return e[h >> 18 & 63] + e[h >> 12 & 63] + e[h >> 6 & 63] + e[h & 63];
  }
  function g(h, C, E) {
    for (var I, b = [], y = C; y < E; y += 3)
      I = (h[y] << 16 & 16711680) + (h[y + 1] << 8 & 65280) + (h[y + 2] & 255), b.push(u(I));
    return b.join("");
  }
  function d(h) {
    for (var C, E = h.length, I = E % 3, b = [], y = 16383, p = 0, Q = E - I; p < Q; p += y)
      b.push(g(h, p, p + y > Q ? Q : p + y));
    return I === 1 ? (C = h[E - 1], b.push(
      e[C >> 2] + e[C << 4 & 63] + "=="
    )) : I === 2 && (C = (h[E - 2] << 8) + h[E - 1], b.push(
      e[C >> 10] + e[C >> 4 & 63] + e[C << 2 & 63] + "="
    )), b.join("");
  }
  return Ns;
}
var WR = F4();
const ZR = /* @__PURE__ */ Ht(WR);
var ff, Z1;
function L4() {
  if (Z1) return ff;
  Z1 = 1;
  var e = 0, A = -3;
  function t() {
    this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
  }
  function r(L, S) {
    this.source = L, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = S, this.destLen = 0, this.ltree = new t(), this.dtree = new t();
  }
  var n = new t(), i = new t(), a = new Uint8Array(30), o = new Uint16Array(30), s = new Uint8Array(30), l = new Uint16Array(30), u = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
  ]), g = new t(), d = new Uint8Array(320);
  function h(L, S, P, Z) {
    var M, R;
    for (M = 0; M < P; ++M) L[M] = 0;
    for (M = 0; M < 30 - P; ++M) L[M + P] = M / P | 0;
    for (R = Z, M = 0; M < 30; ++M)
      S[M] = R, R += 1 << L[M];
  }
  function C(L, S) {
    var P;
    for (P = 0; P < 7; ++P) L.table[P] = 0;
    for (L.table[7] = 24, L.table[8] = 152, L.table[9] = 112, P = 0; P < 24; ++P) L.trans[P] = 256 + P;
    for (P = 0; P < 144; ++P) L.trans[24 + P] = P;
    for (P = 0; P < 8; ++P) L.trans[168 + P] = 280 + P;
    for (P = 0; P < 112; ++P) L.trans[176 + P] = 144 + P;
    for (P = 0; P < 5; ++P) S.table[P] = 0;
    for (S.table[5] = 32, P = 0; P < 32; ++P) S.trans[P] = P;
  }
  var E = new Uint16Array(16);
  function I(L, S, P, Z) {
    var M, R;
    for (M = 0; M < 16; ++M) L.table[M] = 0;
    for (M = 0; M < Z; ++M) L.table[S[P + M]]++;
    for (L.table[0] = 0, R = 0, M = 0; M < 16; ++M)
      E[M] = R, R += L.table[M];
    for (M = 0; M < Z; ++M)
      S[P + M] && (L.trans[E[S[P + M]]++] = M);
  }
  function b(L) {
    L.bitcount-- || (L.tag = L.source[L.sourceIndex++], L.bitcount = 7);
    var S = L.tag & 1;
    return L.tag >>>= 1, S;
  }
  function y(L, S, P) {
    if (!S)
      return P;
    for (; L.bitcount < 24; )
      L.tag |= L.source[L.sourceIndex++] << L.bitcount, L.bitcount += 8;
    var Z = L.tag & 65535 >>> 16 - S;
    return L.tag >>>= S, L.bitcount -= S, Z + P;
  }
  function p(L, S) {
    for (; L.bitcount < 24; )
      L.tag |= L.source[L.sourceIndex++] << L.bitcount, L.bitcount += 8;
    var P = 0, Z = 0, M = 0, R = L.tag;
    do
      Z = 2 * Z + (R & 1), R >>>= 1, ++M, P += S.table[M], Z -= S.table[M];
    while (Z >= 0);
    return L.tag = R, L.bitcount -= M, S.trans[P + Z];
  }
  function Q(L, S, P) {
    var Z, M, R, G, N, z;
    for (Z = y(L, 5, 257), M = y(L, 5, 1), R = y(L, 4, 4), G = 0; G < 19; ++G) d[G] = 0;
    for (G = 0; G < R; ++G) {
      var T = y(L, 3, 0);
      d[u[G]] = T;
    }
    for (I(g, d, 0, 19), N = 0; N < Z + M; ) {
      var O = p(L, g);
      switch (O) {
        case 16:
          var K = d[N - 1];
          for (z = y(L, 2, 3); z; --z)
            d[N++] = K;
          break;
        case 17:
          for (z = y(L, 3, 3); z; --z)
            d[N++] = 0;
          break;
        case 18:
          for (z = y(L, 7, 11); z; --z)
            d[N++] = 0;
          break;
        default:
          d[N++] = O;
          break;
      }
    }
    I(S, d, 0, Z), I(P, d, Z, M);
  }
  function w(L, S, P) {
    for (; ; ) {
      var Z = p(L, S);
      if (Z === 256)
        return e;
      if (Z < 256)
        L.dest[L.destLen++] = Z;
      else {
        var M, R, G, N;
        for (Z -= 257, M = y(L, a[Z], o[Z]), R = p(L, P), G = L.destLen - y(L, s[R], l[R]), N = G; N < G + M; ++N)
          L.dest[L.destLen++] = L.dest[N];
      }
    }
  }
  function Y(L) {
    for (var S, P, Z; L.bitcount > 8; )
      L.sourceIndex--, L.bitcount -= 8;
    if (S = L.source[L.sourceIndex + 1], S = 256 * S + L.source[L.sourceIndex], P = L.source[L.sourceIndex + 3], P = 256 * P + L.source[L.sourceIndex + 2], S !== (~P & 65535))
      return A;
    for (L.sourceIndex += 4, Z = S; Z; --Z)
      L.dest[L.destLen++] = L.source[L.sourceIndex++];
    return L.bitcount = 0, e;
  }
  function k(L, S) {
    var P = new r(L, S), Z, M, R;
    do {
      switch (Z = b(P), M = y(P, 2, 0), M) {
        case 0:
          R = Y(P);
          break;
        case 1:
          R = w(P, n, i);
          break;
        case 2:
          Q(P, P.ltree, P.dtree), R = w(P, P.ltree, P.dtree);
          break;
        default:
          R = A;
      }
      if (R !== e)
        throw new Error("Data error");
    } while (!Z);
    return P.destLen < P.dest.length ? typeof P.dest.slice == "function" ? P.dest.slice(0, P.destLen) : P.dest.subarray(0, P.destLen) : P.dest;
  }
  return C(n, i), h(a, o, 4, 3), h(s, l, 2, 1), a[28] = 0, o[28] = 258, ff = k, ff;
}
var df, K1;
function KR() {
  if (K1) return df;
  K1 = 1;
  const e = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, A = (n, i, a) => {
    let o = n[i];
    n[i] = n[a], n[a] = o;
  }, t = (n) => {
    const i = n.length;
    for (let a = 0; a < i; a += 4)
      A(n, a, a + 3), A(n, a + 1, a + 2);
  };
  return df = {
    swap32LE: (n) => {
      e && t(n);
    }
  }, df;
}
var hf, _1;
function _R() {
  if (_1) return hf;
  _1 = 1;
  const e = L4(), { swap32LE: A } = KR(), t = 11, r = 5, n = t - r, i = 65536 >> t, o = (1 << n) - 1, s = 2, u = (1 << r) - 1, g = 65536 >> r, d = 1024 >> r, I = g + d + 32, b = 1 << s;
  class y {
    constructor(Q) {
      const w = typeof Q.readUInt32BE == "function" && typeof Q.slice == "function";
      if (w || Q instanceof Uint8Array) {
        let Y;
        if (w)
          this.highStart = Q.readUInt32LE(0), this.errorValue = Q.readUInt32LE(4), Y = Q.readUInt32LE(8), Q = Q.slice(12);
        else {
          const k = new DataView(Q.buffer);
          this.highStart = k.getUint32(0, !0), this.errorValue = k.getUint32(4, !0), Y = k.getUint32(8, !0), Q = Q.subarray(12);
        }
        Q = e(Q, new Uint8Array(Y)), Q = e(Q, new Uint8Array(Y)), A(Q), this.data = new Uint32Array(Q.buffer);
      } else
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = Q);
    }
    get(Q) {
      let w;
      return Q < 0 || Q > 1114111 ? this.errorValue : Q < 55296 || Q > 56319 && Q <= 65535 ? (w = (this.data[Q >> r] << s) + (Q & u), this.data[w]) : Q <= 65535 ? (w = (this.data[g + (Q - 55296 >> r)] << s) + (Q & u), this.data[w]) : Q < this.highStart ? (w = this.data[I - i + (Q >> t)], w = this.data[w + (Q >> r & o)], w = (w << s) + (Q & u), this.data[w]) : this.data[this.data.length - b];
    }
  }
  return hf = y, hf;
}
var XR = _R();
const kg = /* @__PURE__ */ Ht(XR);
function $i(e) {
  return e && e.__esModule ? e.default : e;
}
var li = {};
li = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const Hl = new kg(ZR.toByteArray("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")), qR = Math.log2 || ((e) => Math.log(e) / Math.LN2), Ug = (e) => qR(e) + 1 | 0, $R = Ug((/* @__PURE__ */ $i(li)).categories.length - 1), R4 = Ug((/* @__PURE__ */ $i(li)).combiningClasses.length - 1), wC = Ug((/* @__PURE__ */ $i(li)).scripts.length - 1), Yg = Ug((/* @__PURE__ */ $i(li)).eaw.length - 1), Sl = 10, AG = R4 + wC + Yg + Sl, eG = wC + Yg + Sl, tG = Yg + Sl, rG = Sl, nG = (1 << $R) - 1, iG = (1 << R4) - 1, aG = (1 << wC) - 1, oG = (1 << Yg) - 1, sG = (1 << Sl) - 1;
function kn(e) {
  const A = Hl.get(e);
  return (/* @__PURE__ */ $i(li)).categories[A >> AG & nG];
}
function G4(e) {
  const A = Hl.get(e);
  return (/* @__PURE__ */ $i(li)).combiningClasses[A >> eG & iG];
}
function IC(e) {
  const A = Hl.get(e);
  return (/* @__PURE__ */ $i(li)).scripts[A >> tG & aG];
}
function lG(e) {
  const A = Hl.get(e);
  return (/* @__PURE__ */ $i(li)).eaw[A >> rG & oG];
}
function uG(e) {
  let A = Hl.get(e), t = A & sG;
  if (t === 0) return null;
  if (t <= 50) return t - 1;
  if (t < 480) {
    const r = (t >> 4) - 12, n = (t & 15) + 1;
    return r / n;
  } else if (t < 768) {
    A = (t >> 5) - 14;
    let r = (t & 31) + 2;
    for (; r > 0; )
      A *= 10, r--;
    return A;
  } else {
    A = (t >> 2) - 191;
    let r = (t & 3) + 1;
    for (; r > 0; )
      A *= 60, r--;
    return A;
  }
}
function cG(e) {
  const A = kn(e);
  return A === "Lu" || A === "Ll" || A === "Lt" || A === "Lm" || A === "Lo" || A === "Nl";
}
function ch(e) {
  return kn(e) === "Nd";
}
function gG(e) {
  const A = kn(e);
  return A === "Pc" || A === "Pd" || A === "Pe" || A === "Pf" || A === "Pi" || A === "Po" || A === "Ps";
}
function BG(e) {
  return kn(e) === "Ll";
}
function fG(e) {
  return kn(e) === "Lu";
}
function dG(e) {
  return kn(e) === "Lt";
}
function hG(e) {
  const A = kn(e);
  return A === "Zs" || A === "Zl" || A === "Zp";
}
function CG(e) {
  const A = kn(e);
  return A === "Nd" || A === "No" || A === "Nl" || A === "Lu" || A === "Ll" || A === "Lt" || A === "Lm" || A === "Lo" || A === "Me" || A === "Mc";
}
function DC(e) {
  const A = kn(e);
  return A === "Mn" || A === "Me" || A === "Mc";
}
var EG = {
  getCategory: kn,
  getCombiningClass: G4,
  getScript: IC,
  getEastAsianWidth: lG,
  getNumericValue: uG,
  isAlphabetic: cG,
  isDigit: ch,
  isPunctuation: gG,
  isLowerCase: BG,
  isUpperCase: fG,
  isTitleCase: dG,
  isWhiteSpace: hG,
  isBaseForm: CG,
  isMark: DC
}, Cf, X1;
function QG() {
  if (X1) return Cf;
  X1 = 1;
  var e = 1, A = 0;
  class t {
    constructor(n) {
      this.stateTable = n.stateTable, this.accepting = n.accepting, this.tags = n.tags;
    }
    /**
     * Returns an iterable object that yields pattern matches over the input sequence.
     * Matches are of the form [startIndex, endIndex, tags].
     */
    match(n) {
      var i = this;
      return {
        *[Symbol.iterator]() {
          for (var a = e, o = null, s = null, l = null, u = 0; u < n.length; u++) {
            var g = n[u];
            l = a, a = i.stateTable[a][g], a === A && (o != null && s != null && s >= o && (yield [o, s, i.tags[l]]), a = i.stateTable[e][g], o = null), a !== A && o == null && (o = u), i.accepting[a] && (s = u), a === A && (a = e);
          }
          o != null && s != null && s >= o && (yield [o, s, i.tags[a]]);
        }
      };
    }
    /**
     * For each match over the input sequence, action functions matching
     * the tag definitions in the input pattern are called with the startIndex,
     * endIndex, and sub-match sequence.
     */
    apply(n, i) {
      for (var [a, o, s] of this.match(n))
        for (var l of s)
          typeof i[l] == "function" && i[l](a, o, n.slice(a, o + 1));
    }
  }
  return Cf = t, Cf;
}
var wG = QG();
const x4 = /* @__PURE__ */ Ht(wG);
var Ef = { exports: {} }, q1;
function IG() {
  return q1 || (q1 = 1, function(e) {
    var A = function() {
      function t(d, h) {
        return h != null && d instanceof h;
      }
      var r;
      try {
        r = Map;
      } catch {
        r = function() {
        };
      }
      var n;
      try {
        n = Set;
      } catch {
        n = function() {
        };
      }
      var i;
      try {
        i = Promise;
      } catch {
        i = function() {
        };
      }
      function a(d, h, C, E, I) {
        typeof h == "object" && (C = h.depth, E = h.prototype, I = h.includeNonEnumerable, h = h.circular);
        var b = [], y = [], p = typeof Buffer < "u";
        typeof h > "u" && (h = !0), typeof C > "u" && (C = 1 / 0);
        function Q(w, Y) {
          if (w === null)
            return null;
          if (Y === 0)
            return w;
          var k, L;
          if (typeof w != "object")
            return w;
          if (t(w, r))
            k = new r();
          else if (t(w, n))
            k = new n();
          else if (t(w, i))
            k = new i(function(T, O) {
              w.then(function(K) {
                T(Q(K, Y - 1));
              }, function(K) {
                O(Q(K, Y - 1));
              });
            });
          else if (a.__isArray(w))
            k = [];
          else if (a.__isRegExp(w))
            k = new RegExp(w.source, g(w)), w.lastIndex && (k.lastIndex = w.lastIndex);
          else if (a.__isDate(w))
            k = new Date(w.getTime());
          else {
            if (p && Buffer.isBuffer(w))
              return Buffer.allocUnsafe ? k = Buffer.allocUnsafe(w.length) : k = new Buffer(w.length), w.copy(k), k;
            t(w, Error) ? k = Object.create(w) : typeof E > "u" ? (L = Object.getPrototypeOf(w), k = Object.create(L)) : (k = Object.create(E), L = E);
          }
          if (h) {
            var S = b.indexOf(w);
            if (S != -1)
              return y[S];
            b.push(w), y.push(k);
          }
          t(w, r) && w.forEach(function(T, O) {
            var K = Q(O, Y - 1), AA = Q(T, Y - 1);
            k.set(K, AA);
          }), t(w, n) && w.forEach(function(T) {
            var O = Q(T, Y - 1);
            k.add(O);
          });
          for (var P in w) {
            var Z;
            L && (Z = Object.getOwnPropertyDescriptor(L, P)), !(Z && Z.set == null) && (k[P] = Q(w[P], Y - 1));
          }
          if (Object.getOwnPropertySymbols)
            for (var M = Object.getOwnPropertySymbols(w), P = 0; P < M.length; P++) {
              var R = M[P], G = Object.getOwnPropertyDescriptor(w, R);
              G && !G.enumerable && !I || (k[R] = Q(w[R], Y - 1), G.enumerable || Object.defineProperty(k, R, {
                enumerable: !1
              }));
            }
          if (I)
            for (var N = Object.getOwnPropertyNames(w), P = 0; P < N.length; P++) {
              var z = N[P], G = Object.getOwnPropertyDescriptor(w, z);
              G && G.enumerable || (k[z] = Q(w[z], Y - 1), Object.defineProperty(k, z, {
                enumerable: !1
              }));
            }
          return k;
        }
        return Q(d, C);
      }
      a.clonePrototype = function(h) {
        if (h === null)
          return null;
        var C = function() {
        };
        return C.prototype = h, new C();
      };
      function o(d) {
        return Object.prototype.toString.call(d);
      }
      a.__objToStr = o;
      function s(d) {
        return typeof d == "object" && o(d) === "[object Date]";
      }
      a.__isDate = s;
      function l(d) {
        return typeof d == "object" && o(d) === "[object Array]";
      }
      a.__isArray = l;
      function u(d) {
        return typeof d == "object" && o(d) === "[object RegExp]";
      }
      a.__isRegExp = u;
      function g(d) {
        var h = "";
        return d.global && (h += "g"), d.ignoreCase && (h += "i"), d.multiline && (h += "m"), h;
      }
      return a.__getRegExpFlags = g, a;
    }();
    e.exports && (e.exports = A);
  }(Ef)), Ef.exports;
}
var DG = IG();
const Qf = /* @__PURE__ */ Ht(DG);
var mG = L4();
const MG = /* @__PURE__ */ Ht(mG);
var Ts = {}, Uu = {}, $1;
function Aw() {
  if ($1) return Uu;
  $1 = 1;
  function e(t) {
    this.buffer = t, this.pos = 0;
  }
  e.prototype.read = function(t, r, n) {
    this.pos + n > this.buffer.length && (n = this.buffer.length - this.pos);
    for (var i = 0; i < n; i++)
      t[r + i] = this.buffer[this.pos + i];
    return this.pos += n, n;
  }, Uu.BrotliInput = e;
  function A(t) {
    this.buffer = t, this.pos = 0;
  }
  return A.prototype.write = function(t, r) {
    if (this.pos + r > this.buffer.length)
      throw new Error("Output buffer is not large enough");
    return this.buffer.set(t.subarray(0, r), this.pos), this.pos += r, r;
  }, Uu.BrotliOutput = A, Uu;
}
var wf, ew;
function pG() {
  if (ew) return wf;
  ew = 1;
  var e = 4096, A = 2 * e + 32, t = 2 * e - 1, r = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
  ]);
  function n(i) {
    this.buf_ = new Uint8Array(A), this.input_ = i, this.reset();
  }
  return n.READ_SIZE = e, n.IBUF_MASK = t, n.prototype.reset = function() {
    this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
    for (var i = 0; i < 4; i++)
      this.val_ |= this.buf_[this.pos_] << 8 * i, ++this.pos_;
    return this.bit_end_pos_ > 0;
  }, n.prototype.readMoreInput = function() {
    if (!(this.bit_end_pos_ > 256))
      if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_)
          throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
      } else {
        var i = this.buf_ptr_, a = this.input_.read(this.buf_, i, e);
        if (a < 0)
          throw new Error("Unexpected end of input");
        if (a < e) {
          this.eos_ = 1;
          for (var o = 0; o < 32; o++)
            this.buf_[i + a + o] = 0;
        }
        if (i === 0) {
          for (var o = 0; o < 32; o++)
            this.buf_[(e << 1) + o] = this.buf_[o];
          this.buf_ptr_ = e;
        } else
          this.buf_ptr_ = 0;
        this.bit_end_pos_ += a << 3;
      }
  }, n.prototype.fillBitWindow = function() {
    for (; this.bit_pos_ >= 8; )
      this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & t] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
  }, n.prototype.readBits = function(i) {
    32 - this.bit_pos_ < i && this.fillBitWindow();
    var a = this.val_ >>> this.bit_pos_ & r[i];
    return this.bit_pos_ += i, a;
  }, wf = n, wf;
}
var Ii = {}, If = {}, Df, tw;
function vG() {
  return tw || (tw = 1, Df = "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"), Df;
}
var rw;
function yG() {
  if (rw) return If;
  rw = 1;
  var e = F4();
  return If.init = function() {
    var A = U4().BrotliDecompressBuffer, t = e.toByteArray(vG());
    return A(t);
  }, If;
}
var nw;
function k4() {
  if (nw) return Ii;
  nw = 1;
  var e = yG();
  return Ii.init = function() {
    Ii.dictionary = e.init();
  }, Ii.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
  ]), Ii.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
  ]), Ii.minDictionaryWordLength = 4, Ii.maxDictionaryWordLength = 24, Ii;
}
var Yu = {}, iw;
function aw() {
  if (iw) return Yu;
  iw = 1;
  function e(i, a) {
    this.bits = i, this.value = a;
  }
  Yu.HuffmanCode = e;
  var A = 15;
  function t(i, a) {
    for (var o = 1 << a - 1; i & o; )
      o >>= 1;
    return (i & o - 1) + o;
  }
  function r(i, a, o, s, l) {
    do
      s -= o, i[a + s] = new e(l.bits, l.value);
    while (s > 0);
  }
  function n(i, a, o) {
    for (var s = 1 << a - o; a < A && (s -= i[a], !(s <= 0)); )
      ++a, s <<= 1;
    return a - o;
  }
  return Yu.BrotliBuildHuffmanTable = function(i, a, o, s, l) {
    var u = a, g, d, h, C, E, I, b, y, p, Q, w, Y = new Int32Array(A + 1), k = new Int32Array(A + 1);
    for (w = new Int32Array(l), h = 0; h < l; h++)
      Y[s[h]]++;
    for (k[1] = 0, d = 1; d < A; d++)
      k[d + 1] = k[d] + Y[d];
    for (h = 0; h < l; h++)
      s[h] !== 0 && (w[k[s[h]]++] = h);
    if (y = o, p = 1 << y, Q = p, k[A] === 1) {
      for (C = 0; C < Q; ++C)
        i[a + C] = new e(0, w[0] & 65535);
      return Q;
    }
    for (C = 0, h = 0, d = 1, E = 2; d <= o; ++d, E <<= 1)
      for (; Y[d] > 0; --Y[d])
        g = new e(d & 255, w[h++] & 65535), r(i, a + C, E, p, g), C = t(C, d);
    for (b = Q - 1, I = -1, d = o + 1, E = 2; d <= A; ++d, E <<= 1)
      for (; Y[d] > 0; --Y[d])
        (C & b) !== I && (a += p, y = n(Y, d, o), p = 1 << y, Q += p, I = C & b, i[u + I] = new e(y + o & 255, a - u - I & 65535)), g = new e(d - o & 255, w[h++] & 65535), r(i, a + (C >> o), E, p, g), C = t(C, d);
    return Q;
  }, Yu;
}
var Hu = {}, ow;
function bG() {
  return ow || (ow = 1, Hu.lookup = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */
    /* ASCII range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */
    /* ASCII range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
    0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ]), Hu.lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */
    1024,
    1536,
    /* CONTEXT_MSB6 */
    1280,
    1536,
    /* CONTEXT_UTF8 */
    0,
    256,
    /* CONTEXT_SIGNED */
    768,
    512
  ])), Hu;
}
var Ea = {}, sw;
function FG() {
  if (sw) return Ea;
  sw = 1;
  function e(A, t) {
    this.offset = A, this.nbits = t;
  }
  return Ea.kBlockLengthPrefixCode = [
    new e(1, 2),
    new e(5, 2),
    new e(9, 2),
    new e(13, 2),
    new e(17, 3),
    new e(25, 3),
    new e(33, 3),
    new e(41, 3),
    new e(49, 4),
    new e(65, 4),
    new e(81, 4),
    new e(97, 4),
    new e(113, 5),
    new e(145, 5),
    new e(177, 5),
    new e(209, 5),
    new e(241, 6),
    new e(305, 6),
    new e(369, 7),
    new e(497, 8),
    new e(753, 9),
    new e(1265, 10),
    new e(2289, 11),
    new e(4337, 12),
    new e(8433, 13),
    new e(16625, 24)
  ], Ea.kInsertLengthPrefixCode = [
    new e(0, 0),
    new e(1, 0),
    new e(2, 0),
    new e(3, 0),
    new e(4, 0),
    new e(5, 0),
    new e(6, 1),
    new e(8, 1),
    new e(10, 2),
    new e(14, 2),
    new e(18, 3),
    new e(26, 3),
    new e(34, 4),
    new e(50, 4),
    new e(66, 5),
    new e(98, 5),
    new e(130, 6),
    new e(194, 7),
    new e(322, 8),
    new e(578, 9),
    new e(1090, 10),
    new e(2114, 12),
    new e(6210, 14),
    new e(22594, 24)
  ], Ea.kCopyLengthPrefixCode = [
    new e(2, 0),
    new e(3, 0),
    new e(4, 0),
    new e(5, 0),
    new e(6, 0),
    new e(7, 0),
    new e(8, 0),
    new e(9, 0),
    new e(10, 1),
    new e(12, 1),
    new e(14, 2),
    new e(18, 2),
    new e(22, 3),
    new e(30, 3),
    new e(38, 4),
    new e(54, 4),
    new e(70, 5),
    new e(102, 5),
    new e(134, 6),
    new e(198, 7),
    new e(326, 8),
    new e(582, 9),
    new e(1094, 10),
    new e(2118, 24)
  ], Ea.kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
  ], Ea.kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
  ], Ea;
}
var Ps = {}, lw;
function LG() {
  if (lw) return Ps;
  lw = 1;
  var e = k4(), A = 0, t = 1, r = 2, n = 3, i = 4, a = 5, o = 6, s = 7, l = 8, u = 9, g = 10, d = 11, h = 12, C = 13, E = 14, I = 15, b = 16, y = 17, p = 18, Q = 20;
  function w(L, S, P) {
    this.prefix = new Uint8Array(L.length), this.transform = S, this.suffix = new Uint8Array(P.length);
    for (var Z = 0; Z < L.length; Z++)
      this.prefix[Z] = L.charCodeAt(Z);
    for (var Z = 0; Z < P.length; Z++)
      this.suffix[Z] = P.charCodeAt(Z);
  }
  var Y = [
    new w("", A, ""),
    new w("", A, " "),
    new w(" ", A, " "),
    new w("", h, ""),
    new w("", g, " "),
    new w("", A, " the "),
    new w(" ", A, ""),
    new w("s ", A, " "),
    new w("", A, " of "),
    new w("", g, ""),
    new w("", A, " and "),
    new w("", C, ""),
    new w("", t, ""),
    new w(", ", A, " "),
    new w("", A, ", "),
    new w(" ", g, " "),
    new w("", A, " in "),
    new w("", A, " to "),
    new w("e ", A, " "),
    new w("", A, '"'),
    new w("", A, "."),
    new w("", A, '">'),
    new w("", A, `
`),
    new w("", n, ""),
    new w("", A, "]"),
    new w("", A, " for "),
    new w("", E, ""),
    new w("", r, ""),
    new w("", A, " a "),
    new w("", A, " that "),
    new w(" ", g, ""),
    new w("", A, ". "),
    new w(".", A, ""),
    new w(" ", A, ", "),
    new w("", I, ""),
    new w("", A, " with "),
    new w("", A, "'"),
    new w("", A, " from "),
    new w("", A, " by "),
    new w("", b, ""),
    new w("", y, ""),
    new w(" the ", A, ""),
    new w("", i, ""),
    new w("", A, ". The "),
    new w("", d, ""),
    new w("", A, " on "),
    new w("", A, " as "),
    new w("", A, " is "),
    new w("", s, ""),
    new w("", t, "ing "),
    new w("", A, `
	`),
    new w("", A, ":"),
    new w(" ", A, ". "),
    new w("", A, "ed "),
    new w("", Q, ""),
    new w("", p, ""),
    new w("", o, ""),
    new w("", A, "("),
    new w("", g, ", "),
    new w("", l, ""),
    new w("", A, " at "),
    new w("", A, "ly "),
    new w(" the ", A, " of "),
    new w("", a, ""),
    new w("", u, ""),
    new w(" ", g, ", "),
    new w("", g, '"'),
    new w(".", A, "("),
    new w("", d, " "),
    new w("", g, '">'),
    new w("", A, '="'),
    new w(" ", A, "."),
    new w(".com/", A, ""),
    new w(" the ", A, " of the "),
    new w("", g, "'"),
    new w("", A, ". This "),
    new w("", A, ","),
    new w(".", A, " "),
    new w("", g, "("),
    new w("", g, "."),
    new w("", A, " not "),
    new w(" ", A, '="'),
    new w("", A, "er "),
    new w(" ", d, " "),
    new w("", A, "al "),
    new w(" ", d, ""),
    new w("", A, "='"),
    new w("", d, '"'),
    new w("", g, ". "),
    new w(" ", A, "("),
    new w("", A, "ful "),
    new w(" ", g, ". "),
    new w("", A, "ive "),
    new w("", A, "less "),
    new w("", d, "'"),
    new w("", A, "est "),
    new w(" ", g, "."),
    new w("", d, '">'),
    new w(" ", A, "='"),
    new w("", g, ","),
    new w("", A, "ize "),
    new w("", d, "."),
    new w("Â ", A, ""),
    new w(" ", A, ","),
    new w("", g, '="'),
    new w("", d, '="'),
    new w("", A, "ous "),
    new w("", d, ", "),
    new w("", g, "='"),
    new w(" ", g, ","),
    new w(" ", d, '="'),
    new w(" ", d, ", "),
    new w("", d, ","),
    new w("", d, "("),
    new w("", d, ". "),
    new w(" ", d, "."),
    new w("", d, "='"),
    new w(" ", d, ". "),
    new w(" ", g, '="'),
    new w(" ", d, "='"),
    new w(" ", g, "='")
  ];
  Ps.kTransforms = Y, Ps.kNumTransforms = Y.length;
  function k(L, S) {
    return L[S] < 192 ? (L[S] >= 97 && L[S] <= 122 && (L[S] ^= 32), 1) : L[S] < 224 ? (L[S + 1] ^= 32, 2) : (L[S + 2] ^= 5, 3);
  }
  return Ps.transformDictionaryWord = function(L, S, P, Z, M) {
    var R = Y[M].prefix, G = Y[M].suffix, N = Y[M].transform, z = N < h ? 0 : N - (h - 1), T = 0, O = S, K;
    z > Z && (z = Z);
    for (var AA = 0; AA < R.length; )
      L[S++] = R[AA++];
    for (P += z, Z -= z, N <= u && (Z -= N), T = 0; T < Z; T++)
      L[S++] = e.dictionary[P + T];
    if (K = S - Z, N === g)
      k(L, K);
    else if (N === d)
      for (; Z > 0; ) {
        var X = k(L, K);
        K += X, Z -= X;
      }
    for (var iA = 0; iA < G.length; )
      L[S++] = G[iA++];
    return S - O;
  }, Ps;
}
var uw;
function U4() {
  if (uw) return Ts;
  uw = 1;
  var e = Aw().BrotliInput, A = Aw().BrotliOutput, t = pG(), r = k4(), n = aw().HuffmanCode, i = aw().BrotliBuildHuffmanTable, a = bG(), o = FG(), s = LG(), l = 8, u = 16, g = 256, d = 704, h = 26, C = 6, E = 2, I = 8, b = 255, y = 1080, p = 18, Q = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
  ]), w = 16, Y = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
  ]), k = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
  ]), L = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
  ]);
  function S(sA) {
    var lA;
    return sA.readBits(1) === 0 ? 16 : (lA = sA.readBits(3), lA > 0 ? 17 + lA : (lA = sA.readBits(3), lA > 0 ? 8 + lA : 17));
  }
  function P(sA) {
    if (sA.readBits(1)) {
      var lA = sA.readBits(3);
      return lA === 0 ? 1 : sA.readBits(lA) + (1 << lA);
    }
    return 0;
  }
  function Z() {
    this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
  }
  function M(sA) {
    var lA = new Z(), tA, nA, GA;
    if (lA.input_end = sA.readBits(1), lA.input_end && sA.readBits(1))
      return lA;
    if (tA = sA.readBits(2) + 4, tA === 7) {
      if (lA.is_metadata = !0, sA.readBits(1) !== 0)
        throw new Error("Invalid reserved bit");
      if (nA = sA.readBits(2), nA === 0)
        return lA;
      for (GA = 0; GA < nA; GA++) {
        var ZA = sA.readBits(8);
        if (GA + 1 === nA && nA > 1 && ZA === 0)
          throw new Error("Invalid size byte");
        lA.meta_block_length |= ZA << GA * 8;
      }
    } else
      for (GA = 0; GA < tA; ++GA) {
        var de = sA.readBits(4);
        if (GA + 1 === tA && tA > 4 && de === 0)
          throw new Error("Invalid size nibble");
        lA.meta_block_length |= de << GA * 4;
      }
    return ++lA.meta_block_length, !lA.input_end && !lA.is_metadata && (lA.is_uncompressed = sA.readBits(1)), lA;
  }
  function R(sA, lA, tA) {
    var nA;
    return tA.fillBitWindow(), lA += tA.val_ >>> tA.bit_pos_ & b, nA = sA[lA].bits - I, nA > 0 && (tA.bit_pos_ += I, lA += sA[lA].value, lA += tA.val_ >>> tA.bit_pos_ & (1 << nA) - 1), tA.bit_pos_ += sA[lA].bits, sA[lA].value;
  }
  function G(sA, lA, tA, nA) {
    for (var GA = 0, ZA = l, de = 0, _A = 0, Ce = 32768, WA = [], gA = 0; gA < 32; gA++)
      WA.push(new n(0, 0));
    for (i(WA, 0, 5, sA, p); GA < lA && Ce > 0; ) {
      var ie = 0, Qe;
      if (nA.readMoreInput(), nA.fillBitWindow(), ie += nA.val_ >>> nA.bit_pos_ & 31, nA.bit_pos_ += WA[ie].bits, Qe = WA[ie].value & 255, Qe < u)
        de = 0, tA[GA++] = Qe, Qe !== 0 && (ZA = Qe, Ce -= 32768 >> Qe);
      else {
        var OA = Qe - 14, we, se, ue = 0;
        if (Qe === u && (ue = ZA), _A !== ue && (de = 0, _A = ue), we = de, de > 0 && (de -= 2, de <<= OA), de += nA.readBits(OA) + 3, se = de - we, GA + se > lA)
          throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
        for (var ge = 0; ge < se; ge++)
          tA[GA + ge] = _A;
        GA += se, _A !== 0 && (Ce -= se << 15 - _A);
      }
    }
    if (Ce !== 0)
      throw new Error("[ReadHuffmanCodeLengths] space = " + Ce);
    for (; GA < lA; GA++)
      tA[GA] = 0;
  }
  function N(sA, lA, tA, nA) {
    var GA = 0, ZA, de = new Uint8Array(sA);
    if (nA.readMoreInput(), ZA = nA.readBits(2), ZA === 1) {
      for (var _A, Ce = sA - 1, WA = 0, gA = new Int32Array(4), ie = nA.readBits(2) + 1; Ce; )
        Ce >>= 1, ++WA;
      for (_A = 0; _A < ie; ++_A)
        gA[_A] = nA.readBits(WA) % sA, de[gA[_A]] = 2;
      switch (de[gA[0]] = 1, ie) {
        case 1:
          break;
        case 3:
          if (gA[0] === gA[1] || gA[0] === gA[2] || gA[1] === gA[2])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          break;
        case 2:
          if (gA[0] === gA[1])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          de[gA[1]] = 1;
          break;
        case 4:
          if (gA[0] === gA[1] || gA[0] === gA[2] || gA[0] === gA[3] || gA[1] === gA[2] || gA[1] === gA[3] || gA[2] === gA[3])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          nA.readBits(1) ? (de[gA[2]] = 3, de[gA[3]] = 3) : de[gA[0]] = 2;
          break;
      }
    } else {
      var _A, Qe = new Uint8Array(p), OA = 32, we = 0, se = [
        new n(2, 0),
        new n(2, 4),
        new n(2, 3),
        new n(3, 2),
        new n(2, 0),
        new n(2, 4),
        new n(2, 3),
        new n(4, 1),
        new n(2, 0),
        new n(2, 4),
        new n(2, 3),
        new n(3, 2),
        new n(2, 0),
        new n(2, 4),
        new n(2, 3),
        new n(4, 5)
      ];
      for (_A = ZA; _A < p && OA > 0; ++_A) {
        var ue = Q[_A], ge = 0, Pe;
        nA.fillBitWindow(), ge += nA.val_ >>> nA.bit_pos_ & 15, nA.bit_pos_ += se[ge].bits, Pe = se[ge].value, Qe[ue] = Pe, Pe !== 0 && (OA -= 32 >> Pe, ++we);
      }
      if (!(we === 1 || OA === 0))
        throw new Error("[ReadHuffmanCode] invalid num_codes or space");
      G(Qe, sA, de, nA);
    }
    if (GA = i(lA, tA, I, de, sA), GA === 0)
      throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return GA;
  }
  function z(sA, lA, tA) {
    var nA, GA;
    return nA = R(sA, lA, tA), GA = o.kBlockLengthPrefixCode[nA].nbits, o.kBlockLengthPrefixCode[nA].offset + tA.readBits(GA);
  }
  function T(sA, lA, tA) {
    var nA;
    return sA < w ? (tA += Y[sA], tA &= 3, nA = lA[tA] + k[sA]) : nA = sA - w + 1, nA;
  }
  function O(sA, lA) {
    for (var tA = sA[lA], nA = lA; nA; --nA) sA[nA] = sA[nA - 1];
    sA[0] = tA;
  }
  function K(sA, lA) {
    var tA = new Uint8Array(256), nA;
    for (nA = 0; nA < 256; ++nA)
      tA[nA] = nA;
    for (nA = 0; nA < lA; ++nA) {
      var GA = sA[nA];
      sA[nA] = tA[GA], GA && O(tA, GA);
    }
  }
  function AA(sA, lA) {
    this.alphabet_size = sA, this.num_htrees = lA, this.codes = new Array(lA + lA * L[sA + 31 >>> 5]), this.htrees = new Uint32Array(lA);
  }
  AA.prototype.decode = function(sA) {
    var lA, tA, nA = 0;
    for (lA = 0; lA < this.num_htrees; ++lA)
      this.htrees[lA] = nA, tA = N(this.alphabet_size, this.codes, nA, sA), nA += tA;
  };
  function X(sA, lA) {
    var tA = { num_htrees: null, context_map: null }, nA, GA = 0, ZA, de;
    lA.readMoreInput();
    var _A = tA.num_htrees = P(lA) + 1, Ce = tA.context_map = new Uint8Array(sA);
    if (_A <= 1)
      return tA;
    for (nA = lA.readBits(1), nA && (GA = lA.readBits(4) + 1), ZA = [], de = 0; de < y; de++)
      ZA[de] = new n(0, 0);
    for (N(_A + GA, ZA, 0, lA), de = 0; de < sA; ) {
      var WA;
      if (lA.readMoreInput(), WA = R(ZA, 0, lA), WA === 0)
        Ce[de] = 0, ++de;
      else if (WA <= GA)
        for (var gA = 1 + (1 << WA) + lA.readBits(WA); --gA; ) {
          if (de >= sA)
            throw new Error("[DecodeContextMap] i >= context_map_size");
          Ce[de] = 0, ++de;
        }
      else
        Ce[de] = WA - GA, ++de;
    }
    return lA.readBits(1) && K(Ce, sA), tA;
  }
  function iA(sA, lA, tA, nA, GA, ZA, de) {
    var _A = tA * 2, Ce = tA, WA = R(lA, tA * y, de), gA;
    WA === 0 ? gA = GA[_A + (ZA[Ce] & 1)] : WA === 1 ? gA = GA[_A + (ZA[Ce] - 1 & 1)] + 1 : gA = WA - 2, gA >= sA && (gA -= sA), nA[tA] = gA, GA[_A + (ZA[Ce] & 1)] = gA, ++ZA[Ce];
  }
  function oA(sA, lA, tA, nA, GA, ZA) {
    var de = GA + 1, _A = tA & GA, Ce = ZA.pos_ & t.IBUF_MASK, WA;
    if (lA < 8 || ZA.bit_pos_ + (lA << 3) < ZA.bit_end_pos_) {
      for (; lA-- > 0; )
        ZA.readMoreInput(), nA[_A++] = ZA.readBits(8), _A === de && (sA.write(nA, de), _A = 0);
      return;
    }
    if (ZA.bit_end_pos_ < 32)
      throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    for (; ZA.bit_pos_ < 32; )
      nA[_A] = ZA.val_ >>> ZA.bit_pos_, ZA.bit_pos_ += 8, ++_A, --lA;
    if (WA = ZA.bit_end_pos_ - ZA.bit_pos_ >> 3, Ce + WA > t.IBUF_MASK) {
      for (var gA = t.IBUF_MASK + 1 - Ce, ie = 0; ie < gA; ie++)
        nA[_A + ie] = ZA.buf_[Ce + ie];
      WA -= gA, _A += gA, lA -= gA, Ce = 0;
    }
    for (var ie = 0; ie < WA; ie++)
      nA[_A + ie] = ZA.buf_[Ce + ie];
    if (_A += WA, lA -= WA, _A >= de) {
      sA.write(nA, de), _A -= de;
      for (var ie = 0; ie < _A; ie++)
        nA[ie] = nA[de + ie];
    }
    for (; _A + lA >= de; ) {
      if (WA = de - _A, ZA.input_.read(nA, _A, WA) < WA)
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      sA.write(nA, de), lA -= WA, _A = 0;
    }
    if (ZA.input_.read(nA, _A, lA) < lA)
      throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    ZA.reset();
  }
  function fA(sA) {
    var lA = sA.bit_pos_ + 7 & -8, tA = sA.readBits(lA - sA.bit_pos_);
    return tA == 0;
  }
  function wA(sA) {
    var lA = new e(sA), tA = new t(lA);
    S(tA);
    var nA = M(tA);
    return nA.meta_block_length;
  }
  Ts.BrotliDecompressedSize = wA;
  function DA(sA, lA) {
    var tA = new e(sA);
    lA == null && (lA = wA(sA));
    var nA = new Uint8Array(lA), GA = new A(nA);
    return HA(tA, GA), GA.pos < GA.buffer.length && (GA.buffer = GA.buffer.subarray(0, GA.pos)), GA.buffer;
  }
  Ts.BrotliDecompressBuffer = DA;
  function HA(sA, lA) {
    var tA, nA = 0, GA = 0, ZA = 0, de, _A = 0, Ce, WA, gA, ie, Qe = [16, 15, 11, 4], OA = 0, we = 0, se = 0, ue = [new AA(0, 0), new AA(0, 0), new AA(0, 0)], ge, Pe, le, pe = 128 + t.READ_SIZE;
    le = new t(sA), ZA = S(le), de = (1 << ZA) - 16, Ce = 1 << ZA, WA = Ce - 1, gA = new Uint8Array(Ce + pe + r.maxDictionaryWordLength), ie = Ce, ge = [], Pe = [];
    for (var Ze = 0; Ze < 3 * y; Ze++)
      ge[Ze] = new n(0, 0), Pe[Ze] = new n(0, 0);
    for (; !GA; ) {
      var je = 0, W, yA = [1 << 28, 1 << 28, 1 << 28], xA = [0], SA = [1, 1, 1], eA = [0, 1, 0, 1, 0, 1], mA = [0], H, UA, ae, D, CA = null, IA = null, V, $ = null, dA, ce = 0, NA = null, XA = 0, ke = 0, Ne = null, Ie = 0, be = 0, Ye = 0, ye, st;
      for (tA = 0; tA < 3; ++tA)
        ue[tA].codes = null, ue[tA].htrees = null;
      le.readMoreInput();
      var Ut = M(le);
      if (je = Ut.meta_block_length, nA + je > lA.buffer.length) {
        var gt = new Uint8Array(nA + je);
        gt.set(lA.buffer), lA.buffer = gt;
      }
      if (GA = Ut.input_end, W = Ut.is_uncompressed, Ut.is_metadata) {
        for (fA(le); je > 0; --je)
          le.readMoreInput(), le.readBits(8);
        continue;
      }
      if (je !== 0) {
        if (W) {
          le.bit_pos_ = le.bit_pos_ + 7 & -8, oA(
            lA,
            je,
            nA,
            gA,
            WA,
            le
          ), nA += je;
          continue;
        }
        for (tA = 0; tA < 3; ++tA)
          SA[tA] = P(le) + 1, SA[tA] >= 2 && (N(SA[tA] + 2, ge, tA * y, le), N(h, Pe, tA * y, le), yA[tA] = z(Pe, tA * y, le), mA[tA] = 1);
        for (le.readMoreInput(), H = le.readBits(2), UA = w + (le.readBits(4) << H), ae = (1 << H) - 1, D = UA + (48 << H), IA = new Uint8Array(SA[0]), tA = 0; tA < SA[0]; ++tA)
          le.readMoreInput(), IA[tA] = le.readBits(2) << 1;
        var Ke = X(SA[0] << C, le);
        V = Ke.num_htrees, CA = Ke.context_map;
        var q = X(SA[2] << E, le);
        for (dA = q.num_htrees, $ = q.context_map, ue[0] = new AA(g, V), ue[1] = new AA(d, SA[1]), ue[2] = new AA(D, dA), tA = 0; tA < 3; ++tA)
          ue[tA].decode(le);
        for (NA = 0, Ne = 0, ye = IA[xA[0]], be = a.lookupOffsets[ye], Ye = a.lookupOffsets[ye + 1], st = ue[1].htrees[0]; je > 0; ) {
          var bA, $A, Ee, Ve, _e, ve, Fe, Ct, et, pA, VA;
          for (le.readMoreInput(), yA[1] === 0 && (iA(
            SA[1],
            ge,
            1,
            xA,
            eA,
            mA,
            le
          ), yA[1] = z(Pe, y, le), st = ue[1].htrees[xA[1]]), --yA[1], bA = R(ue[1].codes, st, le), $A = bA >> 6, $A >= 2 ? ($A -= 2, Fe = -1) : Fe = 0, Ee = o.kInsertRangeLut[$A] + (bA >> 3 & 7), Ve = o.kCopyRangeLut[$A] + (bA & 7), _e = o.kInsertLengthPrefixCode[Ee].offset + le.readBits(o.kInsertLengthPrefixCode[Ee].nbits), ve = o.kCopyLengthPrefixCode[Ve].offset + le.readBits(o.kCopyLengthPrefixCode[Ve].nbits), we = gA[nA - 1 & WA], se = gA[nA - 2 & WA], pA = 0; pA < _e; ++pA)
            le.readMoreInput(), yA[0] === 0 && (iA(
              SA[0],
              ge,
              0,
              xA,
              eA,
              mA,
              le
            ), yA[0] = z(Pe, 0, le), ce = xA[0] << C, NA = ce, ye = IA[xA[0]], be = a.lookupOffsets[ye], Ye = a.lookupOffsets[ye + 1]), et = a.lookup[be + we] | a.lookup[Ye + se], XA = CA[NA + et], --yA[0], se = we, we = R(ue[0].codes, ue[0].htrees[XA], le), gA[nA & WA] = we, (nA & WA) === WA && lA.write(gA, Ce), ++nA;
          if (je -= _e, je <= 0) break;
          if (Fe < 0) {
            var et;
            if (le.readMoreInput(), yA[2] === 0 && (iA(
              SA[2],
              ge,
              2,
              xA,
              eA,
              mA,
              le
            ), yA[2] = z(Pe, 2 * y, le), ke = xA[2] << E, Ne = ke), --yA[2], et = (ve > 4 ? 3 : ve - 2) & 255, Ie = $[Ne + et], Fe = R(ue[2].codes, ue[2].htrees[Ie], le), Fe >= UA) {
              var YA, ze, Oe;
              Fe -= UA, ze = Fe & ae, Fe >>= H, YA = (Fe >> 1) + 1, Oe = (2 + (Fe & 1) << YA) - 4, Fe = UA + (Oe + le.readBits(YA) << H) + ze;
            }
          }
          if (Ct = T(Fe, Qe, OA), Ct < 0)
            throw new Error("[BrotliDecompress] invalid distance");
          if (nA < de && _A !== de ? _A = nA : _A = de, VA = nA & WA, Ct > _A)
            if (ve >= r.minDictionaryWordLength && ve <= r.maxDictionaryWordLength) {
              var Oe = r.offsetsByLength[ve], lt = Ct - _A - 1, St = r.sizeBitsByLength[ve], Ar = (1 << St) - 1, bt = lt & Ar, ir = lt >> St;
              if (Oe += bt * ve, ir < s.kNumTransforms) {
                var Gr = s.transformDictionaryWord(gA, VA, Oe, ve, ir);
                if (VA += Gr, nA += Gr, je -= Gr, VA >= ie) {
                  lA.write(gA, Ce);
                  for (var Pr = 0; Pr < VA - ie; Pr++)
                    gA[Pr] = gA[ie + Pr];
                }
              } else
                throw new Error("Invalid backward reference. pos: " + nA + " distance: " + Ct + " len: " + ve + " bytes left: " + je);
            } else
              throw new Error("Invalid backward reference. pos: " + nA + " distance: " + Ct + " len: " + ve + " bytes left: " + je);
          else {
            if (Fe > 0 && (Qe[OA & 3] = Ct, ++OA), ve > je)
              throw new Error("Invalid backward reference. pos: " + nA + " distance: " + Ct + " len: " + ve + " bytes left: " + je);
            for (pA = 0; pA < ve; ++pA)
              gA[nA & WA] = gA[nA - Ct & WA], (nA & WA) === WA && lA.write(gA, Ce), ++nA, --je;
          }
          we = gA[nA - 1 & WA], se = gA[nA - 2 & WA];
        }
        nA &= 1073741823;
      }
    }
    lA.write(gA, nA & WA);
  }
  return Ts.BrotliDecompress = HA, r.init(), Ts;
}
var mf, cw;
function RG() {
  return cw || (cw = 1, mf = U4().BrotliDecompressBuffer), mf;
}
var GG = RG();
const xG = /* @__PURE__ */ Ht(GG);
function Nl(e, A, t, r) {
  Object.defineProperty(e, A, { get: t, set: r, enumerable: !0, configurable: !0 });
}
function Hg(e) {
  return e && e.__esModule ? e.default : e;
}
var Tl = {};
Nl(Tl, "logErrors", () => kG);
Nl(Tl, "registerFormat", () => ss);
Nl(Tl, "create", () => gl);
Nl(Tl, "defaultLanguage", () => _c);
Nl(Tl, "setDefaultLanguage", () => UG);
let kG = !1, gh = [];
function ss(e) {
  gh.push(e);
}
function gl(e, A) {
  for (let t = 0; t < gh.length; t++) {
    let r = gh[t];
    if (r.probe(e)) {
      let n = new r(new Dr(e));
      return A ? n.getFont(A) : n;
    }
  }
  throw new Error("Unknown font format");
}
let _c = "en";
function UG(e = "en") {
  _c = e;
}
function vr(e, A, t) {
  if (t.get) {
    let r = t.get;
    t.get = function() {
      let n = r.call(this);
      return Object.defineProperty(this, A, {
        value: n
      }), n;
    };
  } else if (typeof t.value == "function") {
    let r = t.value;
    return {
      get() {
        let n = /* @__PURE__ */ new Map();
        function i(...a) {
          let o = a.length > 0 ? a[0] : "value";
          if (n.has(o)) return n.get(o);
          let s = r.apply(this, a);
          return n.set(o, s), s;
        }
        return Object.defineProperty(this, A, {
          value: i
        }), i;
      }
    };
  }
}
let YG = new QA({
  firstCode: v,
  entryCount: v,
  idDelta: zA,
  idRangeOffset: v
}), Mf = new QA({
  startCharCode: BA,
  endCharCode: BA,
  glyphID: BA
}), HG = new QA({
  startUnicodeValue: Ti,
  additionalCount: Ae
}), SG = new QA({
  unicodeValue: Ti,
  glyphID: v
}), NG = new uA(HG, BA), TG = new uA(SG, BA), PG = new QA({
  varSelector: Ti,
  defaultUVS: new cA(BA, NG, {
    type: "parent"
  }),
  nonDefaultUVS: new cA(BA, TG, {
    type: "parent"
  })
}), zG = new $e(v, {
  0: {
    length: v,
    language: v,
    codeMap: new Gt(Ae, 256)
  },
  2: {
    length: v,
    language: v,
    subHeaderKeys: new uA(v, 256),
    subHeaderCount: (e) => Math.max.apply(Math, e.subHeaderKeys),
    subHeaders: new Gt(YG, "subHeaderCount"),
    glyphIndexArray: new Gt(v, "subHeaderCount")
  },
  4: {
    length: v,
    language: v,
    segCountX2: v,
    segCount: (e) => e.segCountX2 >> 1,
    searchRange: v,
    entrySelector: v,
    rangeShift: v,
    endCode: new Gt(v, "segCount"),
    reservedPad: new Nt(v),
    startCode: new Gt(v, "segCount"),
    idDelta: new Gt(zA, "segCount"),
    idRangeOffset: new Gt(v, "segCount"),
    glyphIndexArray: new Gt(v, (e) => (e.length - e._currentOffset) / 2)
  },
  6: {
    length: v,
    language: v,
    firstCode: v,
    entryCount: v,
    glyphIndices: new Gt(v, "entryCount")
  },
  8: {
    reserved: new Nt(v),
    length: BA,
    language: v,
    is32: new Gt(Ae, 8192),
    nGroups: BA,
    groups: new Gt(Mf, "nGroups")
  },
  10: {
    reserved: new Nt(v),
    length: BA,
    language: BA,
    firstCode: BA,
    entryCount: BA,
    glyphIndices: new Gt(v, "numChars")
  },
  12: {
    reserved: new Nt(v),
    length: BA,
    language: BA,
    nGroups: BA,
    groups: new Gt(Mf, "nGroups")
  },
  13: {
    reserved: new Nt(v),
    length: BA,
    language: BA,
    nGroups: BA,
    groups: new Gt(Mf, "nGroups")
  },
  14: {
    length: BA,
    numRecords: BA,
    varSelectors: new Gt(PG, "numRecords")
  }
}), jG = new QA({
  platformID: v,
  encodingID: v,
  table: new cA(BA, zG, {
    type: "parent",
    lazy: !0
  })
});
var VG = new QA({
  version: v,
  numSubtables: v,
  tables: new uA(jG, "numSubtables")
}), OG = new QA({
  version: ya,
  revision: ya,
  checkSumAdjustment: BA,
  magicNumber: BA,
  flags: v,
  unitsPerEm: v,
  created: new uA(ya, 2),
  modified: new uA(ya, 2),
  xMin: zA,
  yMin: zA,
  xMax: zA,
  yMax: zA,
  macStyle: new Xn(v, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: v,
  fontDirectionHint: zA,
  indexToLocFormat: zA,
  glyphDataFormat: zA
  // 0 for current format
}), JG = new QA({
  version: ya,
  ascent: zA,
  descent: zA,
  lineGap: zA,
  advanceWidthMax: v,
  minLeftSideBearing: zA,
  minRightSideBearing: zA,
  xMaxExtent: zA,
  caretSlopeRise: zA,
  caretSlopeRun: zA,
  caretOffset: zA,
  reserved: new Nt(zA, 4),
  metricDataFormat: zA,
  numberOfMetrics: v
  // Number of advance widths in 'hmtx' table
});
let WG = new QA({
  advance: v,
  bearing: zA
});
var ZG = new QA({
  metrics: new Gt(WG, (e) => e.parent.hhea.numberOfMetrics),
  bearings: new Gt(zA, (e) => e.parent.maxp.numGlyphs - e.parent.hhea.numberOfMetrics)
}), KG = new QA({
  version: ya,
  numGlyphs: v,
  maxPoints: v,
  maxContours: v,
  maxComponentPoints: v,
  maxComponentContours: v,
  maxZones: v,
  maxTwilightPoints: v,
  maxStorage: v,
  maxFunctionDefs: v,
  maxInstructionDefs: v,
  maxStackElements: v,
  maxSizeOfInstructions: v,
  maxComponentElements: v,
  maxComponentDepth: v
  // Maximum levels of recursion; 1 for simple components
});
function Y4(e, A, t = 0) {
  return e === 1 && gw[t] ? gw[t] : $G[e][A];
}
const _G = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]), XG = {
  "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
  "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
  "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
  "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
  "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
  "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, pf = /* @__PURE__ */ new Map();
function qG(e) {
  let A = pf.get(e);
  if (A) return A;
  let t = XG[e];
  if (t) {
    let r = /* @__PURE__ */ new Map();
    for (let n = 0; n < t.length; n++) r.set(t.charCodeAt(n), 128 + n);
    return pf.set(e, r), r;
  }
  if (_G.has(e)) {
    let r = new TextDecoder(e), n = new Uint8Array(128);
    for (let o = 0; o < 128; o++) n[o] = 128 + o;
    let i = /* @__PURE__ */ new Map(), a = r.decode(n);
    for (let o = 0; o < 128; o++) i.set(a.charCodeAt(o), 128 + o);
    return pf.set(e, i), i;
  }
}
const $G = [
  // unicode
  [
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "gbk",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii",
    null,
    "iso-8859-1"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf-16be",
    "shift-jis",
    "gb18030",
    "big5",
    "euc-kr",
    "johab",
    null,
    null,
    null,
    "utf-16be"
  ]
], gw = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
}, Ax = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
let Bw = new QA({
  platformID: v,
  encodingID: v,
  languageID: v,
  nameID: v,
  length: v,
  string: new cA(v, new Dt("length", (e) => Y4(e.platformID, e.encodingID, e.languageID)), {
    type: "parent",
    relativeTo: (e) => e.parent.stringOffset,
    allowNull: !1
  })
}), ex = new QA({
  length: v,
  tag: new cA(v, new Dt("length", "utf16be"), {
    type: "parent",
    relativeTo: (e) => e.stringOffset
  })
});
var Xc = new $e(v, {
  0: {
    count: v,
    stringOffset: v,
    records: new uA(Bw, "count")
  },
  1: {
    count: v,
    stringOffset: v,
    records: new uA(Bw, "count"),
    langTagCount: v,
    langTags: new uA(ex, "langTagCount")
  }
}), tx = Xc;
const Bh = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
Xc.process = function(e) {
  var A = {};
  for (let t of this.records) {
    let r = Ax[t.platformID][t.languageID];
    r == null && this.langTags != null && t.languageID >= 32768 && (r = this.langTags[t.languageID - 32768].tag), r == null && (r = t.platformID + "-" + t.languageID);
    let n = t.nameID >= 256 ? "fontFeatures" : Bh[t.nameID] || t.nameID;
    A[n] == null && (A[n] = {});
    let i = A[n];
    t.nameID >= 256 && (i = i[t.nameID] || (i[t.nameID] = {})), (typeof t.string == "string" || typeof i[r] != "string") && (i[r] = t.string);
  }
  this.records = A;
};
Xc.preEncode = function() {
  if (Array.isArray(this.records)) return;
  this.version = 0;
  let e = [];
  for (let A in this.records) {
    let t = this.records[A];
    A !== "fontFeatures" && (e.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: Bh.indexOf(A),
      length: t.en.length * 2,
      string: t.en
    }), A === "postscriptName" && e.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: Bh.indexOf(A),
      length: t.en.length,
      string: t.en
    }));
  }
  this.records = e, this.count = e.length, this.stringOffset = Xc.size(this, null, !1);
};
var H4 = new $e(v, {
  header: {
    xAvgCharWidth: zA,
    usWeightClass: v,
    usWidthClass: v,
    fsType: new Xn(v, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: zA,
    ySubscriptYSize: zA,
    ySubscriptXOffset: zA,
    ySubscriptYOffset: zA,
    ySuperscriptXSize: zA,
    ySuperscriptYSize: zA,
    ySuperscriptXOffset: zA,
    ySuperscriptYOffset: zA,
    yStrikeoutSize: zA,
    yStrikeoutPosition: zA,
    sFamilyClass: zA,
    panose: new uA(Ae, 10),
    ulCharRange: new uA(BA, 4),
    vendorID: new Dt(4),
    fsSelection: new Xn(v, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: v,
    usLastCharIndex: v
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: zA,
    typoDescender: zA,
    typoLineGap: zA,
    winAscent: v,
    winDescent: v,
    codePageRange: new uA(BA, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: zA,
    typoDescender: zA,
    typoLineGap: zA,
    winAscent: v,
    winDescent: v,
    codePageRange: new uA(BA, 2),
    xHeight: zA,
    capHeight: zA,
    defaultChar: v,
    breakChar: v,
    maxContent: v
  },
  5: {
    typoAscender: zA,
    typoDescender: zA,
    typoLineGap: zA,
    winAscent: v,
    winDescent: v,
    codePageRange: new uA(BA, 2),
    xHeight: zA,
    capHeight: zA,
    defaultChar: v,
    breakChar: v,
    maxContent: v,
    usLowerOpticalPointSize: v,
    usUpperOpticalPointSize: v
  }
});
let vf = H4.versions;
vf[3] = vf[4] = vf[2];
var rx = H4, nx = new $e(qt, {
  header: {
    italicAngle: qt,
    underlinePosition: zA,
    underlineThickness: zA,
    isFixedPitch: BA,
    minMemType42: BA,
    maxMemType42: BA,
    minMemType1: BA,
    maxMemType1: BA
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: v,
    glyphNameIndex: new uA(v, "numberOfGlyphs"),
    names: new uA(new Dt(Ae))
  },
  2.5: {
    numberOfGlyphs: v,
    offsets: new uA(Ae, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new uA(BA, (e) => e.parent.maxp.numGlyphs)
  }
}), ix = new QA({
  controlValues: new uA(zA)
}), ax = new QA({
  instructions: new uA(Ae)
});
let mC = new $e("head.indexToLocFormat", {
  0: {
    offsets: new uA(v)
  },
  1: {
    offsets: new uA(BA)
  }
});
mC.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let e = 0; e < this.offsets.length; e++) this.offsets[e] <<= 1;
    this._processed = !0;
  }
};
mC.preEncode = function() {
  if (this.version === 0 && this._processed !== !1) {
    for (let e = 0; e < this.offsets.length; e++) this.offsets[e] >>>= 1;
    this._processed = !1;
  }
};
var ox = mC, sx = new QA({
  controlValueProgram: new uA(Ae)
}), lx = new uA(new mr());
class Q0 {
  getCFFVersion(A) {
    for (; A && !A.hdrSize; ) A = A.parent;
    return A ? A.version : -1;
  }
  decode(A, t) {
    let n = this.getCFFVersion(t) >= 2 ? A.readUInt32BE() : A.readUInt16BE();
    if (n === 0) return [];
    let i = A.readUInt8(), a;
    if (i === 1) a = Ae;
    else if (i === 2) a = v;
    else if (i === 3) a = Ti;
    else if (i === 4) a = BA;
    else throw new Error(`Bad offset size in CFFIndex: ${i} ${A.pos}`);
    let o = [], s = A.pos + (n + 1) * i - 1, l = a.decode(A);
    for (let u = 0; u < n; u++) {
      let g = a.decode(A);
      if (this.type != null) {
        let d = A.pos;
        A.pos = s + l, t.length = g - l, o.push(this.type.decode(A, t)), A.pos = d;
      } else o.push({
        offset: s + l,
        length: g - l
      });
      l = g;
    }
    return A.pos = s + l, o;
  }
  size(A, t) {
    let r = 2;
    if (A.length === 0) return r;
    let n = this.type || new mr(), i = 1;
    for (let o = 0; o < A.length; o++) {
      let s = A[o];
      i += n.size(s, t);
    }
    let a;
    if (i <= 255) a = Ae;
    else if (i <= 65535) a = v;
    else if (i <= 16777215) a = Ti;
    else if (i <= 4294967295) a = BA;
    else throw new Error("Bad offset in CFFIndex");
    return r += 1 + a.size() * (A.length + 1), r += i - 1, r;
  }
  encode(A, t, r) {
    if (A.writeUInt16BE(t.length), t.length === 0) return;
    let n = this.type || new mr(), i = [], a = 1;
    for (let s of t) {
      let l = n.size(s, r);
      i.push(l), a += l;
    }
    let o;
    if (a <= 255) o = Ae;
    else if (a <= 65535) o = v;
    else if (a <= 16777215) o = Ti;
    else if (a <= 4294967295) o = BA;
    else throw new Error("Bad offset in CFFIndex");
    A.writeUInt8(o.size()), a = 1, o.encode(A, a);
    for (let s of i)
      a += s, o.encode(A, a);
    for (let s of t) n.encode(A, s, r);
  }
  constructor(A) {
    this.type = A;
  }
}
const zs = 15, fw = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
], dw = {
  ".": 10,
  E: 11,
  "E-": 12,
  "-": 14
};
class yf {
  static decode(A, t) {
    if (32 <= t && t <= 246) return t - 139;
    if (247 <= t && t <= 250) return (t - 247) * 256 + A.readUInt8() + 108;
    if (251 <= t && t <= 254) return -(t - 251) * 256 - A.readUInt8() - 108;
    if (t === 28) return A.readInt16BE();
    if (t === 29) return A.readInt32BE();
    if (t === 30) {
      let r = "";
      for (; ; ) {
        let n = A.readUInt8(), i = n >> 4;
        if (i === zs) break;
        r += fw[i];
        let a = n & 15;
        if (a === zs) break;
        r += fw[a];
      }
      return parseFloat(r);
    }
    return null;
  }
  static size(A) {
    if (A.forceLarge && (A = 32768), (A | 0) !== A) {
      let t = "" + A;
      return 1 + Math.ceil((t.length + 1) / 2);
    } else return -107 <= A && A <= 107 ? 1 : 108 <= A && A <= 1131 || -1131 <= A && A <= -108 ? 2 : -32768 <= A && A <= 32767 ? 3 : 5;
  }
  static encode(A, t) {
    let r = Number(t);
    if (t.forceLarge)
      return A.writeUInt8(29), A.writeInt32BE(r);
    if ((r | 0) !== r) {
      A.writeUInt8(30);
      let i = "" + r;
      for (let a = 0; a < i.length; a += 2) {
        let o = i[a], s = dw[o] || +o;
        if (a === i.length - 1) var n = zs;
        else {
          let l = i[a + 1];
          var n = dw[l] || +l;
        }
        A.writeUInt8(s << 4 | n & 15);
      }
      if (n !== zs) return A.writeUInt8(zs << 4);
    } else return -107 <= r && r <= 107 ? A.writeUInt8(r + 139) : 108 <= r && r <= 1131 ? (r -= 108, A.writeUInt8((r >> 8) + 247), A.writeUInt8(r & 255)) : -1131 <= r && r <= -108 ? (r = -r - 108, A.writeUInt8((r >> 8) + 251), A.writeUInt8(r & 255)) : -32768 <= r && r <= 32767 ? (A.writeUInt8(28), A.writeInt16BE(r)) : (A.writeUInt8(29), A.writeInt32BE(r));
  }
}
class Sg {
  decodeOperands(A, t, r, n) {
    if (Array.isArray(A)) return n.map((i, a) => this.decodeOperands(A[a], t, r, [
      i
    ]));
    if (A.decode != null) return A.decode(t, r, n);
    switch (A) {
      case "number":
      case "offset":
      case "sid":
        return n[0];
      case "boolean":
        return !!n[0];
      default:
        return n;
    }
  }
  encodeOperands(A, t, r, n) {
    return Array.isArray(A) ? n.map((i, a) => this.encodeOperands(A[a], t, r, i)[0]) : A.encode != null ? A.encode(t, n, r) : typeof n == "number" ? [
      n
    ] : typeof n == "boolean" ? [
      +n
    ] : Array.isArray(n) ? n : [
      n
    ];
  }
  decode(A, t) {
    let r = A.pos + t.length, n = {}, i = [];
    Object.defineProperties(n, {
      parent: {
        value: t
      },
      _startOffset: {
        value: A.pos
      }
    });
    for (let a in this.fields) {
      let o = this.fields[a];
      n[o[1]] = o[3];
    }
    for (; A.pos < r; ) {
      let a = A.readUInt8();
      if (a < 28) {
        a === 12 && (a = a << 8 | A.readUInt8());
        let o = this.fields[a];
        if (!o) throw new Error(`Unknown operator ${a}`);
        let s = this.decodeOperands(o[2], A, n, i);
        s != null && (s instanceof QC ? Object.defineProperty(n, o[1], s) : n[o[1]] = s), i = [];
      } else i.push(yf.decode(A, a));
    }
    return n;
  }
  size(A, t, r = !0) {
    let n = {
      parent: t,
      val: A,
      pointerSize: 0,
      startOffset: t.startOffset || 0
    }, i = 0;
    for (let a in this.fields) {
      let o = this.fields[a], s = A[o[1]];
      if (s == null || J1(s, o[3])) continue;
      let l = this.encodeOperands(o[2], null, n, s);
      for (let g of l) i += yf.size(g);
      let u = Array.isArray(o[0]) ? o[0] : [
        o[0]
      ];
      i += u.length;
    }
    return r && (i += n.pointerSize), i;
  }
  encode(A, t, r) {
    let n = {
      pointers: [],
      startOffset: A.pos,
      parent: r,
      val: t,
      pointerSize: 0
    };
    n.pointerOffset = A.pos + this.size(t, n, !1);
    for (let a of this.ops) {
      let o = t[a[1]];
      if (o == null || J1(o, a[3])) continue;
      let s = this.encodeOperands(a[2], A, n, o);
      for (let u of s) yf.encode(A, u);
      let l = Array.isArray(a[0]) ? a[0] : [
        a[0]
      ];
      for (let u of l) A.writeUInt8(u);
    }
    let i = 0;
    for (; i < n.pointers.length; ) {
      let a = n.pointers[i++];
      a.type.encode(A, a.val, a.parent);
    }
  }
  constructor(A = []) {
    this.ops = A, this.fields = {};
    for (let t of A) {
      let r = Array.isArray(t[0]) ? t[0][0] << 8 | t[0][1] : t[0];
      this.fields[r] = t;
    }
  }
}
class jn extends cA {
  decode(A, t, r) {
    return this.offsetType = {
      decode: () => r[0]
    }, super.decode(A, t, r);
  }
  encode(A, t, r) {
    if (!A)
      return this.offsetType = {
        size: () => 0
      }, this.size(t, r), [
        new hw(0)
      ];
    let n = null;
    return this.offsetType = {
      encode: (i, a) => n = a
    }, super.encode(A, t, r), [
      new hw(n)
    ];
  }
  constructor(A, t = {}) {
    t.type == null && (t.type = "global"), super(null, A, t);
  }
}
class hw {
  valueOf() {
    return this.val;
  }
  constructor(A) {
    this.val = A, this.forceLarge = !0;
  }
}
class ux {
  static decode(A, t, r) {
    let n = r.pop();
    for (; r.length > n; ) r.pop();
  }
}
var fh = new Sg([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    !1
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    ux,
    null
  ],
  [
    19,
    "Subrs",
    new jn(new Q0(), {
      type: "local"
    }),
    null
  ]
]), hc = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
let S4 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], cx = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], N4 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
], gx = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], Bx = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
], T4 = new QA({
  reserved: new Nt(v),
  reqFeatureIndex: v,
  featureCount: v,
  featureIndexes: new uA(v, "featureCount")
}), fx = new QA({
  tag: new Dt(4),
  langSys: new cA(v, T4, {
    type: "parent"
  })
}), dx = new QA({
  defaultLangSys: new cA(v, T4),
  count: v,
  langSysRecords: new uA(fx, "count")
}), hx = new QA({
  tag: new Dt(4),
  script: new cA(v, dx, {
    type: "parent"
  })
}), P4 = new uA(hx, v), Cx = new QA({
  version: v,
  nameID: v
}), z4 = new QA({
  featureParams: new cA(v, Cx),
  lookupCount: v,
  lookupListIndexes: new uA(v, "lookupCount")
}), Ex = new QA({
  tag: new Dt(4),
  feature: new cA(v, z4, {
    type: "parent"
  })
}), j4 = new uA(Ex, v), Qx = new QA({
  markAttachmentType: Ae,
  flags: new Xn(Ae, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function qc(e) {
  let A = new QA({
    lookupType: v,
    flags: Qx,
    subTableCount: v,
    subTables: new uA(new cA(v, e), "subTableCount"),
    markFilteringSet: new Kc(v, (t) => t.flags.flags.useMarkFilteringSet)
  });
  return new Gt(new cA(v, A), v);
}
let wx = new QA({
  start: v,
  end: v,
  startCoverageIndex: v
}), vt = new $e(v, {
  1: {
    glyphCount: v,
    glyphs: new uA(v, "glyphCount")
  },
  2: {
    rangeCount: v,
    rangeRecords: new uA(wx, "rangeCount")
  }
}), Ix = new QA({
  start: v,
  end: v,
  class: v
}), Pi = new $e(v, {
  1: {
    startGlyph: v,
    glyphCount: v,
    classValueArray: new uA(v, "glyphCount")
  },
  2: {
    classRangeCount: v,
    classRangeRecord: new uA(Ix, "classRangeCount")
  }
}), Yi = new QA({
  a: v,
  b: v,
  deltaFormat: v
}), Pl = new QA({
  sequenceIndex: v,
  lookupListIndex: v
}), Dx = new QA({
  glyphCount: v,
  lookupCount: v,
  input: new uA(v, (e) => e.glyphCount - 1),
  lookupRecords: new uA(Pl, "lookupCount")
}), mx = new uA(new cA(v, Dx), v), Mx = new QA({
  glyphCount: v,
  lookupCount: v,
  classes: new uA(v, (e) => e.glyphCount - 1),
  lookupRecords: new uA(Pl, "lookupCount")
}), px = new uA(new cA(v, Mx), v), V4 = new $e(v, {
  1: {
    coverage: new cA(v, vt),
    ruleSetCount: v,
    ruleSets: new uA(new cA(v, mx), "ruleSetCount")
  },
  2: {
    coverage: new cA(v, vt),
    classDef: new cA(v, Pi),
    classSetCnt: v,
    classSet: new uA(new cA(v, px), "classSetCnt")
  },
  3: {
    glyphCount: v,
    lookupCount: v,
    coverages: new uA(new cA(v, vt), "glyphCount"),
    lookupRecords: new uA(Pl, "lookupCount")
  }
}), vx = new QA({
  backtrackGlyphCount: v,
  backtrack: new uA(v, "backtrackGlyphCount"),
  inputGlyphCount: v,
  input: new uA(v, (e) => e.inputGlyphCount - 1),
  lookaheadGlyphCount: v,
  lookahead: new uA(v, "lookaheadGlyphCount"),
  lookupCount: v,
  lookupRecords: new uA(Pl, "lookupCount")
}), Cw = new uA(new cA(v, vx), v), O4 = new $e(v, {
  1: {
    coverage: new cA(v, vt),
    chainCount: v,
    chainRuleSets: new uA(new cA(v, Cw), "chainCount")
  },
  2: {
    coverage: new cA(v, vt),
    backtrackClassDef: new cA(v, Pi),
    inputClassDef: new cA(v, Pi),
    lookaheadClassDef: new cA(v, Pi),
    chainCount: v,
    chainClassSet: new uA(new cA(v, Cw), "chainCount")
  },
  3: {
    backtrackGlyphCount: v,
    backtrackCoverage: new uA(new cA(v, vt), "backtrackGlyphCount"),
    inputGlyphCount: v,
    inputCoverage: new uA(new cA(v, vt), "inputGlyphCount"),
    lookaheadGlyphCount: v,
    lookaheadCoverage: new uA(new cA(v, vt), "lookaheadGlyphCount"),
    lookupCount: v,
    lookupRecords: new uA(Pl, "lookupCount")
  }
}), Al = new Ao(16, "BE", 14), yx = new QA({
  startCoord: Al,
  peakCoord: Al,
  endCoord: Al
}), bx = new QA({
  axisCount: v,
  regionCount: v,
  variationRegions: new uA(new uA(yx, "axisCount"), "regionCount")
}), Fx = new QA({
  shortDeltas: new uA(zA, (e) => e.parent.shortDeltaCount),
  regionDeltas: new uA(sr, (e) => e.parent.regionIndexCount - e.parent.shortDeltaCount),
  deltas: (e) => e.shortDeltas.concat(e.regionDeltas)
}), Lx = new QA({
  itemCount: v,
  shortDeltaCount: v,
  regionIndexCount: v,
  regionIndexes: new uA(v, "regionIndexCount"),
  deltaSets: new uA(Fx, "itemCount")
}), Ng = new QA({
  format: v,
  variationRegionList: new cA(BA, bx),
  variationDataCount: v,
  itemVariationData: new uA(new cA(BA, Lx), "variationDataCount")
}), Rx = new $e(v, {
  1: {
    axisIndex: v,
    axisIndex: v,
    filterRangeMinValue: Al,
    filterRangeMaxValue: Al
  }
}), Gx = new QA({
  conditionCount: v,
  conditionTable: new uA(new cA(BA, Rx), "conditionCount")
}), xx = new QA({
  featureIndex: v,
  alternateFeatureTable: new cA(BA, z4, {
    type: "parent"
  })
}), kx = new QA({
  version: qt,
  substitutionCount: v,
  substitutions: new uA(xx, "substitutionCount")
}), Ux = new QA({
  conditionSet: new cA(BA, Gx, {
    type: "parent"
  }),
  featureTableSubstitution: new cA(BA, kx, {
    type: "parent"
  })
}), J4 = new QA({
  majorVersion: v,
  minorVersion: v,
  featureVariationRecordCount: BA,
  featureVariationRecords: new uA(Ux, "featureVariationRecordCount")
});
class W4 {
  decode(A, t, r) {
    return this.predefinedOps[r[0]] ? this.predefinedOps[r[0]] : this.type.decode(A, t, r);
  }
  size(A, t) {
    return this.type.size(A, t);
  }
  encode(A, t, r) {
    let n = this.predefinedOps.indexOf(t);
    return n !== -1 ? n : this.type.encode(A, t, r);
  }
  constructor(A, t) {
    this.predefinedOps = A, this.type = t;
  }
}
class Yx extends pt {
  decode(A) {
    return Ae.decode(A) & 127;
  }
  constructor() {
    super("UInt8");
  }
}
let Z4 = new QA({
  first: v,
  nLeft: Ae
}), Hx = new QA({
  first: v,
  nLeft: v
}), Sx = new $e(new Yx(), {
  0: {
    nCodes: Ae,
    codes: new uA(Ae, "nCodes")
  },
  1: {
    nRanges: Ae,
    ranges: new uA(Z4, "nRanges")
  }
}), Nx = new W4([
  S4,
  cx
], new jn(Sx, {
  lazy: !0
}));
class Ew extends uA {
  decode(A, t) {
    let r = R0(this.length, A, t), n = 0, i = [];
    for (; n < r; ) {
      let a = this.type.decode(A, t);
      a.offset = n, n += a.nLeft + 1, i.push(a);
    }
    return i;
  }
}
let Tx = new $e(Ae, {
  0: {
    glyphs: new uA(v, (e) => e.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new Ew(Z4, (e) => e.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new Ew(Hx, (e) => e.parent.CharStrings.length - 1)
  }
}), Px = new W4([
  N4,
  gx,
  Bx
], new jn(Tx, {
  lazy: !0
})), zx = new QA({
  first: v,
  fd: Ae
}), jx = new QA({
  first: BA,
  fd: v
}), K4 = new $e(Ae, {
  0: {
    fds: new uA(Ae, (e) => e.parent.CharStrings.length)
  },
  3: {
    nRanges: v,
    ranges: new uA(zx, "nRanges"),
    sentinel: v
  },
  4: {
    nRanges: BA,
    ranges: new uA(jx, "nRanges"),
    sentinel: BA
  }
}), bf = new jn(fh);
class _4 {
  decode(A, t, r) {
    return t.length = r[0], bf.decode(A, t, [
      r[1]
    ]);
  }
  size(A, t) {
    return [
      fh.size(A, t, !1),
      bf.size(A, t)[0]
    ];
  }
  encode(A, t, r) {
    return [
      fh.size(t, r, !1),
      bf.encode(A, t, r)[0]
    ];
  }
}
let X4 = new Sg([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new _4(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]), Vx = new Sg([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    !1
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    Px,
    N4
  ],
  [
    16,
    "Encoding",
    Nx,
    S4
  ],
  [
    17,
    "CharStrings",
    new jn(new Q0()),
    null
  ],
  [
    18,
    "Private",
    new _4(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new jn(K4),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new jn(new Q0(X4)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]), Ox = new QA({
  length: v,
  itemVariationStore: Ng
}), Jx = new Sg([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new jn(new Q0()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new jn(K4),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new jn(new Q0(X4)),
    null
  ],
  [
    24,
    "vstore",
    new jn(Ox),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]), Wx = new $e(zR, {
  1: {
    hdrSize: Ae,
    offSize: Ae,
    nameIndex: new Q0(new Dt("length")),
    topDictIndex: new Q0(Vx),
    stringIndex: new Q0(new Dt("length")),
    globalSubrIndex: new Q0()
  },
  2: {
    hdrSize: Ae,
    length: v,
    topDict: Jx,
    globalSubrIndex: new Q0()
  }
});
var q4 = Wx;
class MC {
  static decode(A) {
    return new MC(A);
  }
  decode() {
    this.stream.pos;
    let A = q4.decode(this.stream);
    for (let t in A) {
      let r = A[t];
      this[t] = r;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    return this.isCIDFont = this.topDict.ROS != null, this;
  }
  string(A) {
    return this.version >= 2 ? null : A < hc.length ? hc[A] : this.stringIndex[A - hc.length];
  }
  get postscriptName() {
    return this.version < 2 ? this.nameIndex[0] : null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(A) {
    return this.stream.pos = this.topDict.CharStrings[A].offset, this.stream.readBuffer(this.topDict.CharStrings[A].length);
  }
  getGlyphName(A) {
    if (this.version >= 2 || this.isCIDFont) return null;
    let { charset: t } = this.topDict;
    if (Array.isArray(t)) return t[A];
    if (A === 0) return ".notdef";
    switch (A -= 1, t.version) {
      case 0:
        return this.string(t.glyphs[A]);
      case 1:
      case 2:
        for (let r = 0; r < t.ranges.length; r++) {
          let n = t.ranges[r];
          if (n.offset <= A && A <= n.offset + n.nLeft) return this.string(n.first + (A - n.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(A) {
    if (!this.topDict.FDSelect) return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[A];
      case 3:
      case 4:
        let { ranges: t } = this.topDict.FDSelect, r = 0, n = t.length - 1;
        for (; r <= n; ) {
          let i = r + n >> 1;
          if (A < t[i].first) n = i - 1;
          else if (i < n && A >= t[i + 1].first) r = i + 1;
          else return t[i].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(A) {
    if (this.topDict.FDSelect) {
      let t = this.fdForGlyph(A);
      return this.topDict.FDArray[t] ? this.topDict.FDArray[t].Private : null;
    }
    return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
  }
  constructor(A) {
    this.stream = A, this.decode();
  }
}
var $4 = MC;
let Zx = new QA({
  glyphIndex: v,
  vertOriginY: zA
});
var Kx = new QA({
  majorVersion: v,
  minorVersion: v,
  defaultVertOriginY: zA,
  numVertOriginYMetrics: v,
  metrics: new uA(Zx, "numVertOriginYMetrics")
});
let Ro = new QA({
  height: Ae,
  width: Ae,
  horiBearingX: sr,
  horiBearingY: sr,
  horiAdvance: Ae,
  vertBearingX: sr,
  vertBearingY: sr,
  vertAdvance: Ae
}), Su = new QA({
  height: Ae,
  width: Ae,
  bearingX: sr,
  bearingY: sr,
  advance: Ae
}), Qw = new QA({
  glyph: v,
  xOffset: sr,
  yOffset: sr
});
class ww {
}
class Ff {
}
new $e("version", {
  1: {
    metrics: Su,
    data: ww
  },
  2: {
    metrics: Su,
    data: Ff
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: Ff
  },
  6: {
    metrics: Ro,
    data: ww
  },
  7: {
    metrics: Ro,
    data: Ff
  },
  8: {
    metrics: Su,
    pad: new Nt(Ae),
    numComponents: v,
    components: new uA(Qw, "numComponents")
  },
  9: {
    metrics: Ro,
    pad: new Nt(Ae),
    numComponents: v,
    components: new uA(Qw, "numComponents")
  },
  17: {
    metrics: Su,
    dataLen: BA,
    data: new mr("dataLen")
  },
  18: {
    metrics: Ro,
    dataLen: BA,
    data: new mr("dataLen")
  },
  19: {
    dataLen: BA,
    data: new mr("dataLen")
  }
});
let Iw = new QA({
  ascender: sr,
  descender: sr,
  widthMax: Ae,
  caretSlopeNumerator: sr,
  caretSlopeDenominator: sr,
  caretOffset: sr,
  minOriginSB: sr,
  minAdvanceSB: sr,
  maxBeforeBL: sr,
  minAfterBL: sr,
  pad: new Nt(sr, 2)
}), _x = new QA({
  glyphCode: v,
  offset: v
}), Xx = new $e(v, {
  header: {
    imageFormat: v,
    imageDataOffset: BA
  },
  1: {
    offsetArray: new uA(BA, (e) => e.parent.lastGlyphIndex - e.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: BA,
    bigMetrics: Ro
  },
  3: {
    offsetArray: new uA(v, (e) => e.parent.lastGlyphIndex - e.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: BA,
    glyphArray: new uA(_x, (e) => e.numGlyphs + 1)
  },
  5: {
    imageSize: BA,
    bigMetrics: Ro,
    numGlyphs: BA,
    glyphCodeArray: new uA(v, "numGlyphs")
  }
}), qx = new QA({
  firstGlyphIndex: v,
  lastGlyphIndex: v,
  subtable: new cA(BA, Xx)
}), $x = new QA({
  indexSubTableArray: new cA(BA, new uA(qx, 1), {
    type: "parent"
  }),
  indexTablesSize: BA,
  numberOfIndexSubTables: BA,
  colorRef: BA,
  hori: Iw,
  vert: Iw,
  startGlyphIndex: v,
  endGlyphIndex: v,
  ppemX: Ae,
  ppemY: Ae,
  bitDepth: Ae,
  flags: new Xn(Ae, [
    "horizontal",
    "vertical"
  ])
});
var Ak = new QA({
  version: BA,
  numSizes: BA,
  sizes: new uA($x, "numSizes")
});
let ek = new QA({
  ppem: v,
  resolution: v,
  imageOffsets: new uA(new cA(BA, "void"), (e) => e.parent.parent.maxp.numGlyphs + 1)
});
var tk = new QA({
  version: v,
  flags: new Xn(v, [
    "renderOutlines"
  ]),
  numImgTables: BA,
  imageTables: new uA(new cA(BA, ek), "numImgTables")
});
let rk = new QA({
  gid: v,
  paletteIndex: v
  // Index value to use in the appropriate palette. This value must
}), nk = new QA({
  gid: v,
  // and is not rendered for color.
  firstLayerIndex: v,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: v
});
var ik = new QA({
  version: v,
  numBaseGlyphRecords: v,
  baseGlyphRecord: new cA(BA, new uA(nk, "numBaseGlyphRecords")),
  layerRecords: new cA(BA, new uA(rk, "numLayerRecords"), {
    lazy: !0
  }),
  numLayerRecords: v
});
let ak = new QA({
  blue: Ae,
  green: Ae,
  red: Ae,
  alpha: Ae
});
var ok = new $e(v, {
  header: {
    numPaletteEntries: v,
    numPalettes: v,
    numColorRecords: v,
    colorRecords: new cA(BA, new uA(ak, "numColorRecords")),
    colorRecordIndices: new uA(v, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new cA(BA, new uA(BA, "numPalettes")),
    offsetPaletteLabelArray: new cA(BA, new uA(v, "numPalettes")),
    offsetPaletteEntryLabelArray: new cA(BA, new uA(v, "numPaletteEntries"))
  }
});
let Bl = new $e(v, {
  1: {
    coordinate: zA
    // X or Y value, in design units
  },
  2: {
    coordinate: zA,
    referenceGlyph: v,
    baseCoordPoint: v
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: zA,
    deviceTable: new cA(v, Yi)
    // Device table for X or Y value
  }
}), sk = new QA({
  defaultIndex: v,
  baseCoordCount: v,
  baseCoords: new uA(new cA(v, Bl), "baseCoordCount")
}), lk = new QA({
  tag: new Dt(4),
  minCoord: new cA(v, Bl, {
    type: "parent"
  }),
  maxCoord: new cA(v, Bl, {
    type: "parent"
  })
  // May be NULL
}), Am = new QA({
  minCoord: new cA(v, Bl),
  maxCoord: new cA(v, Bl),
  featMinMaxCount: v,
  featMinMaxRecords: new uA(lk, "featMinMaxCount")
  // In alphabetical order
}), uk = new QA({
  tag: new Dt(4),
  minMax: new cA(v, Am, {
    type: "parent"
  })
}), ck = new QA({
  baseValues: new cA(v, sk),
  defaultMinMax: new cA(v, Am),
  baseLangSysCount: v,
  baseLangSysRecords: new uA(uk, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
}), gk = new QA({
  tag: new Dt(4),
  script: new cA(v, ck, {
    type: "parent"
  })
}), Bk = new uA(gk, v), fk = new uA(new Dt(4), v), Dw = new QA({
  baseTagList: new cA(v, fk),
  baseScriptList: new cA(v, Bk)
});
var dk = new $e(BA, {
  header: {
    horizAxis: new cA(v, Dw),
    vertAxis: new cA(v, Dw)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new cA(BA, Ng)
  }
});
let hk = new uA(v, v), Ck = new QA({
  coverage: new cA(v, vt),
  glyphCount: v,
  attachPoints: new uA(new cA(v, hk), "glyphCount")
}), Ek = new $e(v, {
  1: {
    coordinate: zA
  },
  2: {
    caretValuePoint: v
  },
  3: {
    coordinate: zA,
    deviceTable: new cA(v, Yi)
  }
}), Qk = new uA(new cA(v, Ek), v), wk = new QA({
  coverage: new cA(v, vt),
  ligGlyphCount: v,
  ligGlyphs: new uA(new cA(v, Qk), "ligGlyphCount")
}), mw = new QA({
  markSetTableFormat: v,
  markSetCount: v,
  coverage: new uA(new cA(BA, vt), "markSetCount")
});
var Ik = new $e(BA, {
  header: {
    glyphClassDef: new cA(v, Pi),
    attachList: new cA(v, Ck),
    ligCaretList: new cA(v, wk),
    markAttachClassDef: new cA(v, Pi)
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new cA(v, mw)
  },
  65539: {
    markGlyphSetsDef: new cA(v, mw),
    itemVariationStore: new cA(BA, Ng)
  }
});
let Do = new Xn(v, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]), Dk = {
  xPlacement: zA,
  yPlacement: zA,
  xAdvance: zA,
  yAdvance: zA,
  xPlaDevice: new cA(v, Yi, {
    type: "global",
    relativeTo: (e) => e.rel
  }),
  yPlaDevice: new cA(v, Yi, {
    type: "global",
    relativeTo: (e) => e.rel
  }),
  xAdvDevice: new cA(v, Yi, {
    type: "global",
    relativeTo: (e) => e.rel
  }),
  yAdvDevice: new cA(v, Yi, {
    type: "global",
    relativeTo: (e) => e.rel
  })
};
class Ko {
  buildStruct(A) {
    let t = A;
    for (; !t[this.key] && t.parent; ) t = t.parent;
    if (!t[this.key]) return;
    let r = {};
    r.rel = () => t._startOffset;
    let n = t[this.key];
    for (let i in n) n[i] && (r[i] = Dk[i]);
    return new QA(r);
  }
  size(A, t) {
    return this.buildStruct(t).size(A, t);
  }
  decode(A, t) {
    let r = this.buildStruct(t).decode(A, t);
    return delete r.rel, r;
  }
  constructor(A = "valueFormat") {
    this.key = A;
  }
}
let mk = new QA({
  secondGlyph: v,
  value1: new Ko("valueFormat1"),
  value2: new Ko("valueFormat2")
}), Mk = new uA(mk, v), pk = new QA({
  value1: new Ko("valueFormat1"),
  value2: new Ko("valueFormat2")
}), fl = new $e(v, {
  1: {
    xCoordinate: zA,
    yCoordinate: zA
  },
  2: {
    xCoordinate: zA,
    yCoordinate: zA,
    anchorPoint: v
  },
  3: {
    xCoordinate: zA,
    yCoordinate: zA,
    xDeviceTable: new cA(v, Yi),
    yDeviceTable: new cA(v, Yi)
  }
}), vk = new QA({
  entryAnchor: new cA(v, fl, {
    type: "parent"
  }),
  exitAnchor: new cA(v, fl, {
    type: "parent"
  })
}), yk = new QA({
  class: v,
  markAnchor: new cA(v, fl, {
    type: "parent"
  })
}), Lf = new uA(yk, v), bk = new uA(new cA(v, fl), (e) => e.parent.classCount), Mw = new uA(bk, v), Fk = new uA(new cA(v, fl), (e) => e.parent.parent.classCount), Lk = new uA(Fk, v), Rk = new uA(new cA(v, Lk), v), dl = new $e("lookupType", {
  1: new $e(v, {
    1: {
      coverage: new cA(v, vt),
      valueFormat: Do,
      value: new Ko()
    },
    2: {
      coverage: new cA(v, vt),
      valueFormat: Do,
      valueCount: v,
      values: new Gt(new Ko(), "valueCount")
    }
  }),
  2: new $e(v, {
    1: {
      coverage: new cA(v, vt),
      valueFormat1: Do,
      valueFormat2: Do,
      pairSetCount: v,
      pairSets: new Gt(new cA(v, Mk), "pairSetCount")
    },
    2: {
      coverage: new cA(v, vt),
      valueFormat1: Do,
      valueFormat2: Do,
      classDef1: new cA(v, Pi),
      classDef2: new cA(v, Pi),
      class1Count: v,
      class2Count: v,
      classRecords: new Gt(new Gt(pk, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: v,
    coverage: new cA(v, vt),
    entryExitCount: v,
    entryExitRecords: new uA(vk, "entryExitCount")
  },
  4: {
    format: v,
    markCoverage: new cA(v, vt),
    baseCoverage: new cA(v, vt),
    classCount: v,
    markArray: new cA(v, Lf),
    baseArray: new cA(v, Mw)
  },
  5: {
    format: v,
    markCoverage: new cA(v, vt),
    ligatureCoverage: new cA(v, vt),
    classCount: v,
    markArray: new cA(v, Lf),
    ligatureArray: new cA(v, Rk)
  },
  6: {
    format: v,
    mark1Coverage: new cA(v, vt),
    mark2Coverage: new cA(v, vt),
    classCount: v,
    mark1Array: new cA(v, Lf),
    mark2Array: new cA(v, Mw)
  },
  7: V4,
  8: O4,
  9: {
    posFormat: v,
    lookupType: v,
    extension: new cA(BA, null)
  }
});
dl.versions[9].extension.type = dl;
var Gk = new $e(BA, {
  header: {
    scriptList: new cA(v, P4),
    featureList: new cA(v, j4),
    lookupList: new cA(v, new qc(dl))
  },
  65536: {},
  65537: {
    featureVariations: new cA(BA, J4)
  }
});
let em = new uA(v, v), xk = em, kk = new QA({
  glyph: v,
  compCount: v,
  components: new uA(v, (e) => e.compCount - 1)
}), Uk = new uA(new cA(v, kk), v), dh = new $e("lookupType", {
  1: new $e(v, {
    1: {
      coverage: new cA(v, vt),
      deltaGlyphID: zA
    },
    2: {
      coverage: new cA(v, vt),
      glyphCount: v,
      substitute: new Gt(v, "glyphCount")
    }
  }),
  2: {
    substFormat: v,
    coverage: new cA(v, vt),
    count: v,
    sequences: new Gt(new cA(v, em), "count")
  },
  3: {
    substFormat: v,
    coverage: new cA(v, vt),
    count: v,
    alternateSet: new Gt(new cA(v, xk), "count")
  },
  4: {
    substFormat: v,
    coverage: new cA(v, vt),
    count: v,
    ligatureSets: new Gt(new cA(v, Uk), "count")
  },
  5: V4,
  6: O4,
  7: {
    substFormat: v,
    lookupType: v,
    extension: new cA(BA, null)
  },
  8: {
    substFormat: v,
    coverage: new cA(v, vt),
    backtrackCoverage: new uA(new cA(v, vt), "backtrackGlyphCount"),
    lookaheadGlyphCount: v,
    lookaheadCoverage: new uA(new cA(v, vt), "lookaheadGlyphCount"),
    glyphCount: v,
    substitutes: new uA(v, "glyphCount")
  }
});
dh.versions[7].extension.type = dh;
var Yk = new $e(BA, {
  header: {
    scriptList: new cA(v, P4),
    featureList: new cA(v, j4),
    lookupList: new cA(v, new qc(dh))
  },
  65536: {},
  65537: {
    featureVariations: new cA(BA, J4)
  }
});
let Di = new uA(v, v), Hk = new QA({
  shrinkageEnableGSUB: new cA(v, Di),
  shrinkageDisableGSUB: new cA(v, Di),
  shrinkageEnableGPOS: new cA(v, Di),
  shrinkageDisableGPOS: new cA(v, Di),
  shrinkageJstfMax: new cA(v, new qc(dl)),
  extensionEnableGSUB: new cA(v, Di),
  extensionDisableGSUB: new cA(v, Di),
  extensionEnableGPOS: new cA(v, Di),
  extensionDisableGPOS: new cA(v, Di),
  extensionJstfMax: new cA(v, new qc(dl))
}), tm = new uA(new cA(v, Hk), v), Sk = new QA({
  tag: new Dt(4),
  jstfLangSys: new cA(v, tm)
}), Nk = new QA({
  extenderGlyphs: new cA(v, new uA(v, v)),
  defaultLangSys: new cA(v, tm),
  langSysCount: v,
  langSysRecords: new uA(Sk, "langSysCount")
}), Tk = new QA({
  tag: new Dt(4),
  script: new cA(v, Nk, {
    type: "parent"
  })
});
var Pk = new QA({
  version: BA,
  scriptCount: v,
  scriptList: new uA(Tk, "scriptCount")
});
class zk {
  decode(A, t) {
    switch (this.size(0, t)) {
      case 1:
        return A.readUInt8();
      case 2:
        return A.readUInt16BE();
      case 3:
        return A.readUInt24BE();
      case 4:
        return A.readUInt32BE();
    }
  }
  size(A, t) {
    return R0(this._size, null, t);
  }
  constructor(A) {
    this._size = A;
  }
}
let jk = new QA({
  entry: new zk((e) => ((e.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (e) => e.entry >> (e.parent.entryFormat & 15) + 1,
  innerIndex: (e) => e.entry & (1 << (e.parent.entryFormat & 15) + 1) - 1
}), Rf = new QA({
  entryFormat: v,
  mapCount: v,
  mapData: new uA(jk, "mapCount")
});
var Vk = new QA({
  majorVersion: v,
  minorVersion: v,
  itemVariationStore: new cA(BA, Ng),
  advanceWidthMapping: new cA(BA, Rf),
  LSBMapping: new cA(BA, Rf),
  RSBMapping: new cA(BA, Rf)
});
let Ok = new QA({
  format: BA,
  length: BA,
  offset: BA
}), Jk = new QA({
  reserved: new Nt(v, 2),
  cbSignature: BA,
  signature: new mr("cbSignature")
});
var Wk = new QA({
  ulVersion: BA,
  usNumSigs: v,
  usFlag: v,
  signatures: new uA(Ok, "usNumSigs"),
  signatureBlocks: new uA(Jk, "usNumSigs")
});
let Zk = new QA({
  rangeMaxPPEM: v,
  rangeGaspBehavior: new Xn(v, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var Kk = new QA({
  version: v,
  numRanges: v,
  gaspRanges: new uA(Zk, "numRanges")
  // Sorted by ppem
});
let _k = new QA({
  pixelSize: Ae,
  maximumWidth: Ae,
  widths: new uA(Ae, (e) => e.parent.parent.maxp.numGlyphs)
});
var Xk = new QA({
  version: v,
  numRecords: zA,
  sizeDeviceRecord: ya,
  records: new uA(_k, "numRecords")
});
let qk = new QA({
  left: v,
  right: v,
  value: zA
}), pw = new QA({
  firstGlyph: v,
  nGlyphs: v,
  offsets: new uA(v, "nGlyphs"),
  max: (e) => e.offsets.length && Math.max.apply(Math, e.offsets)
}), $k = new QA({
  off: (e) => e._startOffset - e.parent.parent._startOffset,
  len: (e) => ((e.parent.leftTable.max - e.off) / e.parent.rowWidth + 1) * (e.parent.rowWidth / 2),
  values: new Gt(zA, "len")
}), vw = new $e("format", {
  0: {
    nPairs: v,
    searchRange: v,
    entrySelector: v,
    rangeShift: v,
    pairs: new uA(qk, "nPairs")
  },
  2: {
    rowWidth: v,
    leftTable: new cA(v, pw, {
      type: "parent"
    }),
    rightTable: new cA(v, pw, {
      type: "parent"
    }),
    array: new cA(v, $k, {
      type: "parent"
    })
  },
  3: {
    glyphCount: v,
    kernValueCount: Ae,
    leftClassCount: Ae,
    rightClassCount: Ae,
    flags: Ae,
    kernValue: new uA(zA, "kernValueCount"),
    leftClass: new uA(Ae, "glyphCount"),
    rightClass: new uA(Ae, "glyphCount"),
    kernIndex: new uA(Ae, (e) => e.leftClassCount * e.rightClassCount)
  }
}), yw = new $e("version", {
  0: {
    subVersion: v,
    length: v,
    format: Ae,
    coverage: new Xn(Ae, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: vw,
    padding: new Nt(Ae, (e) => e.length - e._currentOffset)
  },
  1: {
    length: BA,
    coverage: new Xn(Ae, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: Ae,
    tupleIndex: v,
    subtable: vw,
    padding: new Nt(Ae, (e) => e.length - e._currentOffset)
  }
});
var AU = new $e(v, {
  0: {
    nTables: v,
    tables: new uA(yw, "nTables")
  },
  1: {
    reserved: new Nt(v),
    nTables: BA,
    tables: new uA(yw, "nTables")
  }
}), eU = new QA({
  version: v,
  numGlyphs: v,
  yPels: new uA(Ae, "numGlyphs")
}), tU = new QA({
  version: v,
  fontNumber: BA,
  pitch: v,
  xHeight: v,
  style: v,
  typeFamily: v,
  capHeight: v,
  symbolSet: v,
  typeface: new Dt(16),
  characterComplement: new Dt(8),
  fileName: new Dt(6),
  strokeWeight: new Dt(1),
  widthType: new Dt(1),
  serifStyle: Ae,
  reserved: new Nt(Ae)
});
let rU = new QA({
  bCharSet: Ae,
  xRatio: Ae,
  yStartRatio: Ae,
  yEndRatio: Ae
  // Ending y-Ratio value
}), nU = new QA({
  yPelHeight: v,
  yMax: zA,
  yMin: zA
  // Minimum value (in pels) for this yPelHeight
}), iU = new QA({
  recs: v,
  startsz: Ae,
  endsz: Ae,
  entries: new uA(nU, "recs")
  // The VDMX records
});
var aU = new QA({
  version: v,
  numRecs: v,
  numRatios: v,
  ratioRanges: new uA(rU, "numRatios"),
  offsets: new uA(v, "numRatios"),
  groups: new uA(iU, "numRecs")
  // The actual VDMX groupings
}), oU = new QA({
  version: v,
  ascent: zA,
  descent: zA,
  lineGap: zA,
  advanceHeightMax: zA,
  minTopSideBearing: zA,
  minBottomSideBearing: zA,
  yMaxExtent: zA,
  caretSlopeRise: zA,
  caretSlopeRun: zA,
  caretOffset: zA,
  reserved: new Nt(zA, 4),
  metricDataFormat: zA,
  numberOfMetrics: v
  // Number of advance heights in the Vertical Metrics table
});
let sU = new QA({
  advance: v,
  bearing: zA
  // The top sidebearing of the glyph
});
var lU = new QA({
  metrics: new Gt(sU, (e) => e.parent.vhea.numberOfMetrics),
  bearings: new Gt(zA, (e) => e.parent.maxp.numGlyphs - e.parent.vhea.numberOfMetrics)
});
let bw = new Ao(16, "BE", 14), uU = new QA({
  fromCoord: bw,
  toCoord: bw
}), cU = new QA({
  pairCount: v,
  correspondence: new uA(uU, "pairCount")
});
var gU = new QA({
  version: qt,
  axisCount: BA,
  segment: new uA(cU, "axisCount")
});
class BU {
  getItem(A) {
    if (this._items[A] == null) {
      let t = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * A, this._items[A] = this.type.decode(this.stream, this.parent), this.stream.pos = t;
    }
    return this._items[A];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(A, t, r) {
    this.type = A, this.stream = t, this.parent = r, this.base = this.stream.pos, this._items = [];
  }
}
class p0 extends uA {
  decode(A, t) {
    return new BU(this.type, A, t);
  }
  constructor(A) {
    super(A, 0);
  }
}
let Zi = function(e = v) {
  class A {
    decode(o, s) {
      return s = s.parent.parent, this.type.decode(o, s);
    }
    size(o, s) {
      return s = s.parent.parent, this.type.size(o, s);
    }
    encode(o, s, l) {
      return l = l.parent.parent, this.type.encode(o, s, l);
    }
    constructor(o) {
      this.type = o;
    }
  }
  e = new A(e);
  let t = new QA({
    unitSize: v,
    nUnits: v,
    searchRange: v,
    entrySelector: v,
    rangeShift: v
  }), r = new QA({
    lastGlyph: v,
    firstGlyph: v,
    value: e
  }), n = new QA({
    lastGlyph: v,
    firstGlyph: v,
    values: new cA(v, new uA(e, (a) => a.lastGlyph - a.firstGlyph + 1), {
      type: "parent"
    })
  }), i = new QA({
    glyph: v,
    value: e
  });
  return new $e(v, {
    0: {
      values: new p0(e)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: t,
      segments: new uA(r, (a) => a.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: t,
      segments: new uA(n, (a) => a.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: t,
      segments: new uA(i, (a) => a.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: v,
      count: v,
      values: new uA(e, "count")
    }
  });
};
function Nu(e = {}, A = v) {
  let t = Object.assign({
    newState: v,
    flags: v
  }, e), r = new QA(t), n = new p0(new uA(v, (a) => a.nClasses));
  return new QA({
    nClasses: BA,
    classTable: new cA(BA, new Zi(A)),
    stateArray: new cA(BA, n),
    entryTable: new cA(BA, new p0(r))
  });
}
function fU(e = {}, A = v) {
  let t = new QA({
    version() {
      return 8;
    },
    firstGlyph: v,
    values: new uA(Ae, v)
  }), r = Object.assign({
    newStateOffset: v,
    // convert offset to stateArray index
    newState: (o) => (o.newStateOffset - (o.parent.stateArray.base - o.parent._startOffset)) / o.parent.nClasses,
    flags: v
  }, e), n = new QA(r), i = new p0(new uA(Ae, (o) => o.nClasses));
  return new QA({
    nClasses: v,
    classTable: new cA(v, t),
    stateArray: new cA(v, i),
    entryTable: new cA(v, new p0(n))
  });
}
let dU = new $e("format", {
  0: {
    deltas: new uA(zA, 32)
  },
  1: {
    deltas: new uA(zA, 32),
    mappingData: new Zi(v)
  },
  2: {
    standardGlyph: v,
    controlPoints: new uA(v, 32)
  },
  3: {
    standardGlyph: v,
    controlPoints: new uA(v, 32),
    mappingData: new Zi(v)
  }
});
var hU = new QA({
  version: qt,
  format: v,
  defaultBaseline: v,
  subtable: dU
});
let CU = new QA({
  setting: v,
  nameIndex: zA,
  name: (e) => e.parent.parent.parent.name.records.fontFeatures[e.nameIndex]
}), EU = new QA({
  feature: v,
  nSettings: v,
  settingTable: new cA(BA, new uA(CU, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new Xn(Ae, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: Ae,
  nameIndex: zA,
  name: (e) => e.parent.parent.name.records.fontFeatures[e.nameIndex]
});
var QU = new QA({
  version: qt,
  featureNameCount: v,
  reserved1: new Nt(v),
  reserved2: new Nt(BA),
  featureNames: new uA(EU, "featureNameCount")
});
let wU = new QA({
  axisTag: new Dt(4),
  minValue: qt,
  defaultValue: qt,
  maxValue: qt,
  flags: v,
  nameID: v,
  name: (e) => e.parent.parent.name.records.fontFeatures[e.nameID]
}), IU = new QA({
  nameID: v,
  name: (e) => e.parent.parent.name.records.fontFeatures[e.nameID],
  flags: v,
  coord: new uA(qt, (e) => e.parent.axisCount),
  postscriptNameID: new Kc(v, (e) => e.parent.instanceSize - e._currentOffset > 0)
});
var DU = new QA({
  version: qt,
  offsetToData: v,
  countSizePairs: v,
  axisCount: v,
  axisSize: v,
  instanceCount: v,
  instanceSize: v,
  axis: new uA(wU, "axisCount"),
  instance: new uA(IU, "instanceCount")
});
let mU = new Ao(16, "BE", 14);
class MU {
  static decode(A, t) {
    return t.flags ? A.readUInt32BE() : A.readUInt16BE() * 2;
  }
}
let pU = new QA({
  version: v,
  reserved: new Nt(v),
  axisCount: v,
  globalCoordCount: v,
  globalCoords: new cA(BA, new uA(new uA(mU, "axisCount"), "globalCoordCount")),
  glyphCount: v,
  flags: v,
  offsetToData: BA,
  offsets: new uA(new cA(MU, "void", {
    relativeTo: (e) => e.offsetToData,
    allowNull: !1
  }), (e) => e.glyphCount + 1)
});
var vU = pU;
let yU = new QA({
  length: v,
  coverage: v,
  subFeatureFlags: BA,
  stateTable: new fU()
}), bU = new QA({
  justClass: BA,
  beforeGrowLimit: qt,
  beforeShrinkLimit: qt,
  afterGrowLimit: qt,
  afterShrinkLimit: qt,
  growFlags: v,
  shrinkFlags: v
}), FU = new uA(bU, BA), LU = new $e("actionType", {
  0: {
    lowerLimit: qt,
    upperLimit: qt,
    order: v,
    glyphs: new uA(v, v)
  },
  1: {
    addGlyph: v
  },
  2: {
    substThreshold: qt,
    addGlyph: v,
    substGlyph: v
  },
  3: {},
  4: {
    variationAxis: BA,
    minimumLimit: qt,
    noStretchValue: qt,
    maximumLimit: qt
  },
  5: {
    flags: v,
    glyph: v
  }
}), RU = new QA({
  actionClass: v,
  actionType: v,
  actionLength: BA,
  actionData: LU,
  padding: new Nt(Ae, (e) => e.actionLength - e._currentOffset)
}), GU = new uA(RU, BA), xU = new QA({
  lookupTable: new Zi(new cA(v, GU))
}), Fw = new QA({
  classTable: new cA(v, yU, {
    type: "parent"
  }),
  wdcOffset: v,
  postCompensationTable: new cA(v, xU, {
    type: "parent"
  }),
  widthDeltaClusters: new Zi(new cA(v, FU, {
    type: "parent",
    relativeTo: (e) => e.wdcOffset
  }))
});
var kU = new QA({
  version: BA,
  format: v,
  horizontal: new cA(v, Fw),
  vertical: new cA(v, Fw)
});
let UU = {
  action: v
}, YU = {
  markIndex: v,
  currentIndex: v
}, HU = {
  currentInsertIndex: v,
  markedInsertIndex: v
}, SU = new QA({
  items: new p0(new cA(BA, new Zi()))
}), NU = new $e("type", {
  0: {
    stateTable: new Nu()
  },
  1: {
    stateTable: new Nu(YU),
    substitutionTable: new cA(BA, SU)
  },
  2: {
    stateTable: new Nu(UU),
    ligatureActions: new cA(BA, new p0(BA)),
    components: new cA(BA, new p0(v)),
    ligatureList: new cA(BA, new p0(v))
  },
  4: {
    lookupTable: new Zi()
  },
  5: {
    stateTable: new Nu(HU),
    insertionActions: new cA(BA, new p0(v))
  }
}), TU = new QA({
  length: BA,
  coverage: Ti,
  type: Ae,
  subFeatureFlags: BA,
  table: NU,
  padding: new Nt(Ae, (e) => e.length - e._currentOffset)
}), PU = new QA({
  featureType: v,
  featureSetting: v,
  enableFlags: BA,
  disableFlags: BA
}), zU = new QA({
  defaultFlags: BA,
  chainLength: BA,
  nFeatureEntries: BA,
  nSubtables: BA,
  features: new uA(PU, "nFeatureEntries"),
  subtables: new uA(TU, "nSubtables")
});
var jU = new QA({
  version: v,
  unused: new Nt(v),
  nChains: BA,
  chains: new uA(zU, "nChains")
});
let VU = new QA({
  left: zA,
  top: zA,
  right: zA,
  bottom: zA
});
var OU = new QA({
  version: qt,
  format: v,
  lookupTable: new Zi(VU)
});
let We = {};
var $c = We;
We.cmap = VG;
We.head = OG;
We.hhea = JG;
We.hmtx = ZG;
We.maxp = KG;
We.name = tx;
We["OS/2"] = rx;
We.post = nx;
We.fpgm = ax;
We.loca = ox;
We.prep = sx;
We["cvt "] = ix;
We.glyf = lx;
We["CFF "] = $4;
We.CFF2 = $4;
We.VORG = Kx;
We.EBLC = Ak;
We.CBLC = We.EBLC;
We.sbix = tk;
We.COLR = ik;
We.CPAL = ok;
We.BASE = dk;
We.GDEF = Ik;
We.GPOS = Gk;
We.GSUB = Yk;
We.JSTF = Pk;
We.HVAR = Vk;
We.DSIG = Wk;
We.gasp = Kk;
We.hdmx = Xk;
We.kern = AU;
We.LTSH = eU;
We.PCLT = tU;
We.VDMX = aU;
We.vhea = oU;
We.vmtx = lU;
We.avar = gU;
We.bsln = hU;
We.feat = QU;
We.fvar = DU;
We.gvar = vU;
We.just = kU;
We.morx = jU;
We.opbd = OU;
let JU = new QA({
  tag: new Dt(4),
  checkSum: BA,
  offset: new cA(BA, "void", {
    type: "global"
  }),
  length: BA
}), pC = new QA({
  tag: new Dt(4),
  numTables: v,
  searchRange: v,
  entrySelector: v,
  rangeShift: v,
  tables: new uA(JU, "numTables")
});
pC.process = function() {
  let e = {};
  for (let A of this.tables) e[A.tag] = A;
  this.tables = e;
};
pC.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let t = [];
    for (let r in this.tables) {
      let n = this.tables[r];
      n && t.push({
        tag: r,
        checkSum: 0,
        offset: new uh($c[r], n),
        length: $c[r].size(n)
      });
    }
    this.tables = t;
  }
  this.tag = "true", this.numTables = this.tables.length;
  let e = Math.floor(Math.log(this.numTables) / Math.LN2), A = Math.pow(2, e);
  this.searchRange = A * 16, this.entrySelector = Math.log(A) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var rm = pC;
function Cc(e, A) {
  let t = 0, r = e.length - 1;
  for (; t <= r; ) {
    let n = t + r >> 1, i = A(e[n]);
    if (i < 0) r = n - 1;
    else if (i > 0) t = n + 1;
    else return n;
  }
  return -1;
}
function yo(e, A) {
  let t = [];
  for (; e < A; ) t.push(e++);
  return t;
}
const Tg = new TextDecoder("ascii"), Lw = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Js = new Uint8Array(256);
for (let e = 0; e < Lw.length; e++) Js[Lw.charCodeAt(e)] = e;
function vC(e) {
  let A = e.length * 0.75;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  let t = new Uint8Array(A), r = 0;
  for (let n = 0, i = e.length; n < i; n += 4) {
    let a = Js[e.charCodeAt(n)], o = Js[e.charCodeAt(n + 1)], s = Js[e.charCodeAt(n + 2)], l = Js[e.charCodeAt(n + 3)];
    t[r++] = a << 2 | o >> 4, t[r++] = (o & 15) << 4 | s >> 2, t[r++] = (s & 3) << 6 | l & 63;
  }
  return t;
}
class yC {
  findSubtable(A, t) {
    for (let [r, n] of t) for (let i of A.tables)
      if (i.platformID === r && i.encodingID === n) return i.table;
    return null;
  }
  lookup(A, t) {
    if (this.encoding) A = this.encoding.get(A) || A;
    else if (t) {
      let n = this.getVariationSelector(A, t);
      if (n) return n;
    }
    let r = this.cmap;
    switch (r.version) {
      case 0:
        return r.codeMap.get(A) || 0;
      case 4: {
        let n = 0, i = r.segCount - 1;
        for (; n <= i; ) {
          let a = n + i >> 1;
          if (A < r.startCode.get(a)) i = a - 1;
          else if (A > r.endCode.get(a)) n = a + 1;
          else {
            let o = r.idRangeOffset.get(a), s;
            if (o === 0) s = A + r.idDelta.get(a);
            else {
              let l = o / 2 + (A - r.startCode.get(a)) - (r.segCount - a);
              s = r.glyphIndexArray.get(l) || 0, s !== 0 && (s += r.idDelta.get(a));
            }
            return s & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return r.glyphIndices.get(A - r.firstCode) || 0;
      case 12:
      case 13: {
        let n = 0, i = r.nGroups - 1;
        for (; n <= i; ) {
          let a = n + i >> 1, o = r.groups.get(a);
          if (A < o.startCharCode) i = a - 1;
          else if (A > o.endCharCode) n = a + 1;
          else
            return r.version === 12 ? o.glyphID + (A - o.startCharCode) : o.glyphID;
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${r.version}`);
    }
  }
  getVariationSelector(A, t) {
    if (!this.uvs) return 0;
    let r = this.uvs.varSelectors.toArray(), n = Cc(r, (a) => t - a.varSelector), i = r[n];
    return n !== -1 && i.defaultUVS && (n = Cc(i.defaultUVS, (a) => A < a.startUnicodeValue ? -1 : A > a.startUnicodeValue + a.additionalCount ? 1 : 0)), n !== -1 && i.nonDefaultUVS && (n = Cc(i.nonDefaultUVS, (a) => A - a.unicodeValue), n !== -1) ? i.nonDefaultUVS[n].glyphID : 0;
  }
  getCharacterSet() {
    let A = this.cmap;
    switch (A.version) {
      case 0:
        return yo(0, A.codeMap.length);
      case 4: {
        let t = [], r = A.endCode.toArray();
        for (let n = 0; n < r.length; n++) {
          let i = r[n] + 1, a = A.startCode.get(n);
          t.push(...yo(a, i));
        }
        return t;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return yo(A.firstCode, A.firstCode + A.glyphIndices.length);
      case 12:
      case 13: {
        let t = [];
        for (let r of A.groups.toArray()) t.push(...yo(r.startCharCode, r.endCharCode + 1));
        return t;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${A.version}`);
    }
  }
  codePointsForGlyph(A) {
    let t = this.cmap;
    switch (t.version) {
      case 0: {
        let n = [];
        for (let i = 0; i < 256; i++) t.codeMap.get(i) === A && n.push(i);
        return n;
      }
      case 4: {
        let n = [];
        for (let i = 0; i < t.segCount; i++) {
          let a = t.endCode.get(i), o = t.startCode.get(i), s = t.idRangeOffset.get(i), l = t.idDelta.get(i);
          for (var r = o; r <= a; r++) {
            let u = 0;
            if (s === 0) u = r + l;
            else {
              let g = s / 2 + (r - o) - (t.segCount - i);
              u = t.glyphIndexArray.get(g) || 0, u !== 0 && (u += l);
            }
            u === A && n.push(r);
          }
        }
        return n;
      }
      case 12: {
        let n = [];
        for (let i of t.groups.toArray()) A >= i.glyphID && A <= i.glyphID + (i.endCharCode - i.startCharCode) && n.push(i.startCharCode + (A - i.glyphID));
        return n;
      }
      case 13: {
        let n = [];
        for (let i of t.groups.toArray()) A === i.glyphID && n.push(...yo(i.startCharCode, i.endCharCode + 1));
        return n;
      }
      default:
        throw new Error(`Unknown cmap format ${t.version}`);
    }
  }
  constructor(A) {
    if (this.encoding = null, this.cmap = this.findSubtable(A, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]), !this.cmap) for (let t of A.tables) {
      let r = Y4(t.platformID, t.encodingID, t.table.language - 1), n = qG(r);
      n && (this.cmap = t.table, this.encoding = n);
    }
    if (!this.cmap) throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(A, [
      [
        0,
        5
      ]
    ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
  }
}
pr([
  vr
], yC.prototype, "getCharacterSet", null);
pr([
  vr
], yC.prototype, "codePointsForGlyph", null);
class WU {
  process(A, t) {
    for (let r = 0; r < A.length - 1; r++) {
      let n = A[r].id, i = A[r + 1].id;
      t[r].xAdvance += this.getKerning(n, i);
    }
  }
  getKerning(A, t) {
    let r = 0;
    for (let n of this.kern.tables) {
      if (n.coverage.crossStream) continue;
      switch (n.version) {
        case 0:
          if (!n.coverage.horizontal) continue;
          break;
        case 1:
          if (n.coverage.vertical || n.coverage.variation) continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${n.version}`);
      }
      let i = 0, a = n.subtable;
      switch (n.format) {
        case 0:
          let o = Cc(a.pairs, function(g) {
            return A - g.left || t - g.right;
          });
          o >= 0 && (i = a.pairs[o].value);
          break;
        case 2:
          let s = 0, l = 0;
          A >= a.leftTable.firstGlyph && A < a.leftTable.firstGlyph + a.leftTable.nGlyphs ? s = a.leftTable.offsets[A - a.leftTable.firstGlyph] : s = a.array.off, t >= a.rightTable.firstGlyph && t < a.rightTable.firstGlyph + a.rightTable.nGlyphs && (l = a.rightTable.offsets[t - a.rightTable.firstGlyph]);
          let u = (s + l - a.array.off) / 2;
          i = a.array.values.get(u);
          break;
        case 3:
          if (A >= a.glyphCount || t >= a.glyphCount) return 0;
          i = a.kernValue[a.kernIndex[a.leftClass[A] * a.rightClassCount + a.rightClass[t]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${n.format}`);
      }
      n.coverage.override ? r = i : r += i;
    }
    return r;
  }
  constructor(A) {
    this.kern = A.kern;
  }
}
class ZU {
  positionGlyphs(A, t) {
    let r = 0, n = 0;
    for (let i = 0; i < A.length; i++)
      A[i].isMark ? n = i : (r !== n && this.positionCluster(A, t, r, n), r = n = i);
    return r !== n && this.positionCluster(A, t, r, n), t;
  }
  positionCluster(A, t, r, n) {
    let i = A[r], a = i.cbox.copy();
    i.codePoints.length > 1 && (a.minX += (i.codePoints.length - 1) * a.width / i.codePoints.length);
    let o = -t[r].xAdvance, s = 0, l = this.font.unitsPerEm / 16;
    for (let u = r + 1; u <= n; u++) {
      let g = A[u], d = g.cbox, h = t[u], C = this.getCombiningClass(g.codePoints[0]);
      if (C !== "Not_Reordered") {
        switch (h.xOffset = h.yOffset = 0, C) {
          case "Double_Above":
          case "Double_Below":
            h.xOffset += a.minX - d.width / 2 - d.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            h.xOffset += a.minX - d.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            h.xOffset += a.maxX - d.width - d.minX;
            break;
          default:
            h.xOffset += a.minX + (a.width - d.width) / 2 - d.minX;
        }
        switch (C) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            (C === "Attached_Below_Left" || C === "Attached_Below") && (a.minY += l), h.yOffset = -a.minY - d.maxY, a.minY += d.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            (C === "Attached_Above" || C === "Attached_Above_Right") && (a.maxY += l), h.yOffset = a.maxY - d.minY, a.maxY += d.height;
            break;
        }
        h.xAdvance = h.yAdvance = 0, h.xOffset += o, h.yOffset += s;
      } else
        o -= h.xAdvance, s -= h.yAdvance;
    }
  }
  getCombiningClass(A) {
    let t = G4(A);
    if ((A & -256) === 3584) {
      if (t === "Not_Reordered") switch (A) {
        case 3633:
        case 3636:
        case 3637:
        case 3638:
        case 3639:
        case 3655:
        case 3660:
        case 3645:
        case 3662:
          return "Above_Right";
        case 3761:
        case 3764:
        case 3765:
        case 3766:
        case 3767:
        case 3771:
        case 3788:
        case 3789:
          return "Above";
        case 3772:
          return "Below";
      }
      else if (A === 3642) return "Below_Right";
    }
    switch (t) {
      // Hebrew
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      // Arabic and Syriac
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      // Thai
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      // Lao
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      // Tibetan
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return t;
  }
  constructor(A) {
    this.font = A;
  }
}
class Ki {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(A, t) {
    Math.abs(A) !== 1 / 0 && (A < this.minX && (this.minX = A), A > this.maxX && (this.maxX = A)), Math.abs(t) !== 1 / 0 && (t < this.minY && (this.minY = t), t > this.maxY && (this.maxY = t));
  }
  copy() {
    return new Ki(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(A = 1 / 0, t = 1 / 0, r = -1 / 0, n = -1 / 0) {
    this.minX = A, this.minY = t, this.maxX = r, this.maxY = n;
  }
}
const _o = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
}, hh = {};
for (let e in _o) {
  let A = _o[e];
  if (Array.isArray(A)) for (let t of A) hh[t] = e;
  else hh[A] = e;
}
function KU(e) {
  return hh[e];
}
function _U(e) {
  let A = e.length, t = 0;
  for (; t < A; ) {
    let r = e.charCodeAt(t++);
    if (55296 <= r && r <= 56319 && t < A) {
      let i = e.charCodeAt(t);
      56320 <= i && i <= 57343 && (t++, r = ((r & 1023) << 10) + (i & 1023) + 65536);
    }
    let n = IC(r);
    if (n !== "Common" && n !== "Inherited" && n !== "Unknown") return _o[n];
  }
  return _o.Unknown;
}
function XU(e) {
  for (let A = 0; A < e.length; A++) {
    let t = e[A], r = IC(t);
    if (r !== "Common" && r !== "Inherited" && r !== "Unknown") return _o[r];
  }
  return _o.Unknown;
}
const qU = {
  arab: !0,
  hebr: !0,
  syrc: !0,
  thaa: !0,
  cprt: !0,
  khar: !0,
  phnx: !0,
  "nko ": !0,
  lydi: !0,
  avst: !0,
  armi: !0,
  phli: !0,
  prti: !0,
  sarb: !0,
  orkh: !0,
  samr: !0,
  mand: !0,
  merc: !0,
  mero: !0,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: !0,
  mend: !0,
  nbat: !0,
  narb: !0,
  palm: !0,
  phlp: !0
  // Psalter Pahlavi
};
function nm(e) {
  return qU[e] ? "rtl" : "ltr";
}
class $U {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let A = 0;
    for (let t of this.positions) A += t.xAdvance;
    return A;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let A = 0;
    for (let t of this.positions) A += t.yAdvance;
    return A;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let A = new Ki(), t = 0, r = 0;
    for (let n = 0; n < this.glyphs.length; n++) {
      let i = this.glyphs[n], a = this.positions[n], o = i.bbox;
      A.addPoint(o.minX + t + a.xOffset, o.minY + r + a.yOffset), A.addPoint(o.maxX + t + a.xOffset, o.maxY + r + a.yOffset), t += a.xAdvance, r += a.yAdvance;
    }
    return A;
  }
  constructor(A, t, r, n, i) {
    if (this.glyphs = A, this.positions = null, this.script = r, this.language = n || null, this.direction = i || nm(r), this.features = {}, Array.isArray(t)) for (let a of t) this.features[a] = !0;
    else typeof t == "object" && (this.features = t);
  }
}
class AY {
  constructor(A = 0, t = 0, r = 0, n = 0) {
    this.xAdvance = A, this.yAdvance = t, this.xOffset = r, this.yOffset = n;
  }
}
const ba = {
  allTypographicFeatures: {
    code: 0,
    exclusive: !1,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: !1,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: !0,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: !0
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: !1,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: !1,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: !0,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: !1,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: !0,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: !0,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: !0,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: !1,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: !1,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: !1,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: !0,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: !0,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: !0,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: !0,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: !0,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: !0,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: !0,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: !0,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: !0,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: !0,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: !0,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: !1,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: !1,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: !0,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: !0,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: !0,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: !1,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: !1,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: !1,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: !1,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: !1,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: !0,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: !0,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: !0
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: !0,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
}, oe = (e, A) => [
  ba[e].code,
  ba[e][A]
], Ag = {
  rlig: oe("ligatures", "requiredLigatures"),
  clig: oe("ligatures", "contextualLigatures"),
  dlig: oe("ligatures", "rareLigatures"),
  hlig: oe("ligatures", "historicalLigatures"),
  liga: oe("ligatures", "commonLigatures"),
  hist: oe("ligatures", "historicalLigatures"),
  smcp: oe("lowerCase", "lowerCaseSmallCaps"),
  pcap: oe("lowerCase", "lowerCasePetiteCaps"),
  frac: oe("fractions", "diagonalFractions"),
  dnom: oe("fractions", "diagonalFractions"),
  numr: oe("fractions", "diagonalFractions"),
  afrc: oe("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: oe("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: oe("unicodeDecomposition", "canonicalComposition"),
  cpct: oe("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: oe("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: oe("contextualAlternates", "swashAlternates"),
  cswh: oe("contextualAlternates", "contextualSwashAlternates"),
  curs: oe("cursiveConnection", "cursive"),
  c2pc: oe("upperCase", "upperCasePetiteCaps"),
  c2sc: oe("upperCase", "upperCaseSmallCaps"),
  init: oe("smartSwash", "wordInitialSwashes"),
  fin2: oe("smartSwash", "wordFinalSwashes"),
  medi: oe("smartSwash", "nonFinalSwashes"),
  med2: oe("smartSwash", "nonFinalSwashes"),
  fin3: oe("smartSwash", "wordFinalSwashes"),
  fina: oe("smartSwash", "wordFinalSwashes"),
  pkna: oe("kanaSpacing", "proportionalKana"),
  half: oe("textSpacing", "halfWidthText"),
  halt: oe("textSpacing", "altHalfWidthText"),
  hkna: oe("alternateKana", "alternateHorizKana"),
  vkna: oe("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: oe("italicCJKRoman", "CJKItalicRoman"),
  lnum: oe("numberCase", "upperCaseNumbers"),
  onum: oe("numberCase", "lowerCaseNumbers"),
  mgrk: oe("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: oe("contextualAlternates", "contextualAlternates"),
  vrt2: oe("verticalSubstitution", "substituteVerticalForms"),
  vert: oe("verticalSubstitution", "substituteVerticalForms"),
  tnum: oe("numberSpacing", "monospacedNumbers"),
  pnum: oe("numberSpacing", "proportionalNumbers"),
  sups: oe("verticalPosition", "superiors"),
  subs: oe("verticalPosition", "inferiors"),
  ordn: oe("verticalPosition", "ordinals"),
  pwid: oe("textSpacing", "proportionalText"),
  hwid: oe("textSpacing", "halfWidthText"),
  qwid: oe("textSpacing", "quarterWidthText"),
  twid: oe("textSpacing", "thirdWidthText"),
  fwid: oe("textSpacing", "proportionalText"),
  palt: oe("textSpacing", "altProportionalText"),
  trad: oe("characterShape", "traditionalCharacters"),
  smpl: oe("characterShape", "simplifiedCharacters"),
  jp78: oe("characterShape", "JIS1978Characters"),
  jp83: oe("characterShape", "JIS1983Characters"),
  jp90: oe("characterShape", "JIS1990Characters"),
  jp04: oe("characterShape", "JIS2004Characters"),
  expt: oe("characterShape", "expertCharacters"),
  hojo: oe("characterShape", "hojoCharacters"),
  nlck: oe("characterShape", "NLCCharacters"),
  tnam: oe("characterShape", "traditionalNamesCharacters"),
  ruby: oe("rubyKana", "rubyKana"),
  titl: oe("styleOptions", "titlingCaps"),
  zero: oe("typographicExtras", "slashedZero"),
  ss01: oe("stylisticAlternatives", "stylisticAltOne"),
  ss02: oe("stylisticAlternatives", "stylisticAltTwo"),
  ss03: oe("stylisticAlternatives", "stylisticAltThree"),
  ss04: oe("stylisticAlternatives", "stylisticAltFour"),
  ss05: oe("stylisticAlternatives", "stylisticAltFive"),
  ss06: oe("stylisticAlternatives", "stylisticAltSix"),
  ss07: oe("stylisticAlternatives", "stylisticAltSeven"),
  ss08: oe("stylisticAlternatives", "stylisticAltEight"),
  ss09: oe("stylisticAlternatives", "stylisticAltNine"),
  ss10: oe("stylisticAlternatives", "stylisticAltTen"),
  ss11: oe("stylisticAlternatives", "stylisticAltEleven"),
  ss12: oe("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: oe("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: oe("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: oe("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: oe("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: oe("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: oe("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: oe("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: oe("stylisticAlternatives", "stylisticAltTwenty")
};
for (let e = 1; e <= 99; e++) Ag[`cv${`00${e}`.slice(-2)}`] = [
  ba.characterAlternatives.code,
  e
];
let Fa = {};
for (let e in Ag) {
  let A = Ag[e];
  Fa[A[0]] == null && (Fa[A[0]] = {}), Fa[A[0]][A[1]] = e;
}
function eY(e) {
  let A = {};
  for (let t in e) {
    let r;
    (r = Ag[t]) && (A[r[0]] == null && (A[r[0]] = {}), A[r[0]][r[1]] = e[t]);
  }
  return A;
}
function Rw(e) {
  let [A, t] = e;
  if (isNaN(A)) var r = ba[A] && ba[A].code;
  else var r = A;
  if (isNaN(t)) var n = ba[A] && ba[A][t];
  else var n = t;
  return [
    r,
    n
  ];
}
function tY(e) {
  let A = {};
  if (Array.isArray(e)) for (let t = 0; t < e.length; t++) {
    let r, n = Rw(e[t]);
    (r = Fa[n[0]] && Fa[n[0]][n[1]]) && (A[r] = !0);
  }
  else if (typeof e == "object") for (let t in e) {
    let r = e[t];
    for (let n in r) {
      let i, a = Rw([
        t,
        n
      ]);
      r[n] && (i = Fa[a[0]] && Fa[a[0]][a[1]]) && (A[i] = !0);
    }
  }
  return Object.keys(A);
}
class el {
  lookup(A) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(A);
      case 2:
      case 4: {
        let n = 0, i = this.table.binarySearchHeader.nUnits - 1;
        for (; n <= i; ) {
          var t = n + i >> 1, r = this.table.segments[t];
          if (r.firstGlyph === 65535) return null;
          if (A < r.firstGlyph) i = t - 1;
          else if (A > r.lastGlyph) n = t + 1;
          else
            return this.table.version === 2 ? r.value : r.values[A - r.firstGlyph];
        }
        return null;
      }
      case 6: {
        let n = 0, i = this.table.binarySearchHeader.nUnits - 1;
        for (; n <= i; ) {
          var t = n + i >> 1, r = this.table.segments[t];
          if (r.glyph === 65535) return null;
          if (A < r.glyph) i = t - 1;
          else if (A > r.glyph) n = t + 1;
          else return r.value;
        }
        return null;
      }
      case 8:
        return this.table.values[A - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(A) {
    let t = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let r of this.table.segments) if (this.table.version === 2 && r.value === A) t.push(...yo(r.firstGlyph, r.lastGlyph + 1));
        else
          for (let n = 0; n < r.values.length; n++) r.values[n] === A && t.push(r.firstGlyph + n);
        break;
      case 6:
        for (let r of this.table.segments) r.value === A && t.push(r.glyph);
        break;
      case 8:
        for (let r = 0; r < this.table.values.length; r++) this.table.values[r] === A && t.push(this.table.firstGlyph + r);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return t;
  }
  constructor(A) {
    this.table = A;
  }
}
pr([
  vr
], el.prototype, "glyphsForValue", null);
const rY = 0, Gw = 0, xw = 1, kw = 2, nY = 16384;
class iY {
  process(A, t, r) {
    let n = rY, i = t ? A.length - 1 : 0, a = t ? -1 : 1;
    for (; a === 1 && i <= A.length || a === -1 && i >= -1; ) {
      let o = null, s = xw, l = !0;
      i === A.length || i === -1 ? s = Gw : (o = A[i], o.id === 65535 ? s = kw : (s = this.lookupTable.lookup(o.id), s == null && (s = xw)));
      let g = this.stateTable.stateArray.getItem(n)[s], d = this.stateTable.entryTable.getItem(g);
      s !== Gw && s !== kw && (r(o, d, i), l = !(d.flags & nY)), n = d.newState, l && (i += a);
    }
    return A;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(A, t = 0, r = /* @__PURE__ */ new Set()) {
    if (r.has(t)) return;
    r.add(t);
    let { nClasses: n, stateArray: i, entryTable: a } = this.stateTable, o = i.getItem(t);
    for (let s = 4; s < n; s++) {
      let l = o[s], u = a.getItem(l);
      for (let g of this.lookupTable.glyphsForValue(s))
        A.enter && A.enter(g, u), u.newState !== 0 && this.traverse(A, u.newState, r), A.exit && A.exit(g, u);
    }
  }
  constructor(A) {
    this.stateTable = A, this.lookupTable = new el(A.classTable);
  }
}
const aY = 32768, oY = 8192, sY = 15, Uw = 32768, lY = 32768, uY = 8192, cY = 2147483648, gY = 1073741824, BY = 1073741823, Yw = 4194304, fY = 2048, dY = 1024, hY = 992, CY = 31;
class im {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(A, t = {}) {
    for (let n of this.morx.chains) {
      let i = n.defaultFlags;
      for (let a of n.features) {
        let o;
        (o = t[a.featureType]) && (o[a.featureSetting] ? (i &= a.disableFlags, i |= a.enableFlags) : o[a.featureSetting] === !1 && (i |= ~a.disableFlags, i &= ~a.enableFlags));
      }
      for (let a of n.subtables) a.subFeatureFlags & i && this.processSubtable(a, A);
    }
    let r = A.length - 1;
    for (; r >= 0; )
      A[r].id === 65535 && A.splice(r, 1), r--;
    return A;
  }
  processSubtable(A, t) {
    if (this.subtable = A, this.glyphs = t, this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
    let r = this.getStateMachine(A), n = this.getProcessor(), i = !!(this.subtable.coverage & Yw);
    return r.process(this.glyphs, i, n);
  }
  getStateMachine(A) {
    return new iY(A.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(A, t, r) {
    t.flags & aY && (this.firstGlyph = r), t.flags & oY && (this.lastGlyph = r), EY(this.glyphs, t.flags & sY, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(A, t, r) {
    let n = this.subtable.table.substitutionTable.items;
    if (t.markIndex !== 65535) {
      let a = n.getItem(t.markIndex), o = new el(a);
      A = this.glyphs[this.markedGlyph];
      var i = o.lookup(A.id);
      i && (this.glyphs[this.markedGlyph] = this.font.getGlyph(i, A.codePoints));
    }
    if (t.currentIndex !== 65535) {
      let a = n.getItem(t.currentIndex), o = new el(a);
      A = this.glyphs[r];
      var i = o.lookup(A.id);
      i && (this.glyphs[r] = this.font.getGlyph(i, A.codePoints));
    }
    t.flags & Uw && (this.markedGlyph = r);
  }
  processLigature(A, t, r) {
    if (t.flags & lY && this.ligatureStack.push(r), t.flags & uY) {
      let n = this.subtable.table.ligatureActions, i = this.subtable.table.components, a = this.subtable.table.ligatureList, o = t.action, s = !1, l = 0, u = [], g = [];
      for (; !s; ) {
        let d = this.ligatureStack.pop();
        u.unshift(...this.glyphs[d].codePoints);
        let h = n.getItem(o++);
        s = !!(h & cY);
        let C = !!(h & gY), E = (h & BY) << 2 >> 2;
        E += this.glyphs[d].id;
        let I = i.getItem(E);
        if (l += I, s || C) {
          let b = a.getItem(l);
          this.glyphs[d] = this.font.getGlyph(b, u), g.push(d), l = 0, u = [];
        } else this.glyphs[d] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...g);
    }
  }
  processNoncontextualSubstitutions(A, t, r) {
    let n = new el(A.table.lookupTable);
    for (r = 0; r < t.length; r++) {
      let i = t[r];
      if (i.id !== 65535) {
        let a = n.lookup(i.id);
        a && (t[r] = this.font.getGlyph(a, i.codePoints));
      }
    }
  }
  _insertGlyphs(A, t, r, n) {
    let i = [];
    for (; r--; ) {
      let a = this.subtable.table.insertionActions.getItem(t++);
      i.push(this.font.getGlyph(a));
    }
    n || A++, this.glyphs.splice(A, 0, ...i);
  }
  processGlyphInsertion(A, t, r) {
    if (t.flags & Uw && (this.markedIndex = r), t.markedInsertIndex !== 65535) {
      let n = (t.flags & CY) >>> 5, i = !!(t.flags & dY);
      this._insertGlyphs(this.markedIndex, t.markedInsertIndex, n, i);
    }
    if (t.currentInsertIndex !== 65535) {
      let n = (t.flags & hY) >>> 5, i = !!(t.flags & fY);
      this._insertGlyphs(r, t.currentInsertIndex, n, i);
    }
  }
  getSupportedFeatures() {
    let A = [];
    for (let t of this.morx.chains) for (let r of t.features) A.push([
      r.featureType,
      r.featureSetting
    ]);
    return A;
  }
  generateInputs(A) {
    return this.inputCache || this.generateInputCache(), this.inputCache[A] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let A of this.morx.chains) {
      let t = A.defaultFlags;
      for (let r of A.subtables) r.subFeatureFlags & t && this.generateInputsForSubtable(r);
    }
  }
  generateInputsForSubtable(A) {
    if (A.type !== 2) return;
    if (!!(A.coverage & Yw)) throw new Error("Reverse subtable, not supported.");
    this.subtable = A, this.ligatureStack = [];
    let r = this.getStateMachine(A), n = this.getProcessor(), i = [], a = [];
    this.glyphs = [], r.traverse({
      enter: (o, s) => {
        let l = this.glyphs;
        a.push({
          glyphs: l.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let u = this.font.getGlyph(o);
        i.push(u), l.push(i[i.length - 1]), n(l[l.length - 1], s, l.length - 1);
        let g = 0, d = 0;
        for (let h = 0; h < l.length && g <= 1; h++) l[h].id !== 65535 && (g++, d = l[h].id);
        if (g === 1) {
          let h = i.map((E) => E.id), C = this.inputCache[d];
          C ? C.push(h) : this.inputCache[d] = [
            h
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = a.pop()), i.pop();
      }
    });
  }
  constructor(A) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = A, this.morx = A.morx, this.inputCache = null;
  }
}
pr([
  vr
], im.prototype, "getStateMachine", null);
function xr(e, A, t, r = !1, n = !1) {
  let i = e.splice(t[0] - (t[1] - 1), t[1]);
  n && i.reverse();
  let a = e.splice(A[0], A[1], ...i);
  return r && a.reverse(), e.splice(t[0] - (A[1] - 1), 0, ...a), e;
}
function EY(e, A, t, r) {
  switch (A) {
    case 0:
      return e;
    case 1:
      return xr(e, [
        t,
        1
      ], [
        r,
        0
      ]);
    case 2:
      return xr(e, [
        t,
        0
      ], [
        r,
        1
      ]);
    case 3:
      return xr(e, [
        t,
        1
      ], [
        r,
        1
      ]);
    case 4:
      return xr(e, [
        t,
        2
      ], [
        r,
        0
      ]);
    case 5:
      return xr(e, [
        t,
        2
      ], [
        r,
        0
      ], !0, !1);
    case 6:
      return xr(e, [
        t,
        0
      ], [
        r,
        2
      ]);
    case 7:
      return xr(e, [
        t,
        0
      ], [
        r,
        2
      ], !1, !0);
    case 8:
      return xr(e, [
        t,
        1
      ], [
        r,
        2
      ]);
    case 9:
      return xr(e, [
        t,
        1
      ], [
        r,
        2
      ], !1, !0);
    case 10:
      return xr(e, [
        t,
        2
      ], [
        r,
        1
      ]);
    case 11:
      return xr(e, [
        t,
        2
      ], [
        r,
        1
      ], !0, !1);
    case 12:
      return xr(e, [
        t,
        2
      ], [
        r,
        2
      ]);
    case 13:
      return xr(e, [
        t,
        2
      ], [
        r,
        2
      ], !0, !1);
    case 14:
      return xr(e, [
        t,
        2
      ], [
        r,
        2
      ], !1, !0);
    case 15:
      return xr(e, [
        t,
        2
      ], [
        r,
        2
      ], !0, !0);
    default:
      throw new Error(`Unknown verb: ${A}`);
  }
}
class QY {
  substitute(A) {
    A.direction === "rtl" && A.glyphs.reverse(), this.morxProcessor.process(A.glyphs, eY(A.features));
  }
  getAvailableFeatures(A, t) {
    return tY(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(A) {
    let t = this.morxProcessor.generateInputs(A), r = /* @__PURE__ */ new Set();
    for (let n of t) this._addStrings(n, 0, r, "");
    return r;
  }
  _addStrings(A, t, r, n) {
    let i = this.font._cmapProcessor.codePointsForGlyph(A[t]);
    for (let a of i) {
      let o = n + String.fromCodePoint(a);
      t < A.length - 1 ? this._addStrings(A, t + 1, r, o) : r.add(o);
    }
  }
  constructor(A) {
    this.font = A, this.morxProcessor = new im(A), this.fallbackPosition = !1;
  }
}
class wY {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(A, t) {
    let r = this.stages.length - 1, n = this.stages[r];
    for (let i of A) this.allFeatures[i] == null && (n.push(i), this.allFeatures[i] = r, t && (this.globalFeatures[i] = !0));
  }
  /**
  * Add features to the last stage
  */
  add(A, t = !0) {
    if (this.stages.length === 0 && this.stages.push([]), typeof A == "string" && (A = [
      A
    ]), Array.isArray(A)) this._addFeatures(A, t);
    else if (typeof A == "object")
      this._addFeatures(A.global || [], !0), this._addFeatures(A.local || [], !1);
    else throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(A, t) {
    typeof A == "function" ? this.stages.push(A, []) : (this.stages.push([]), this.add(A, t));
  }
  setFeatureOverrides(A) {
    if (Array.isArray(A)) this.add(A);
    else if (typeof A == "object") {
      for (let t in A)
        if (A[t]) this.add(t);
        else if (this.allFeatures[t] != null) {
          let r = this.stages[this.allFeatures[t]];
          r.splice(r.indexOf(t), 1), delete this.allFeatures[t], delete this.globalFeatures[t];
        }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(A) {
    for (let t of A) for (let r in this.globalFeatures) t.features[r] = !0;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(A, t, r) {
    for (let n of this.stages)
      typeof n == "function" ? r || n(this.font, t, this) : n.length > 0 && A.applyFeatures(n, t, r);
  }
  constructor(A, t, r) {
    this.font = A, this.script = t, this.direction = r, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
  }
}
const IY = [
  "rvrn"
], DY = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
], mY = [
  "frac",
  "numr",
  "dnom"
], MY = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
], pY = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
class _i {
  static plan(A, t, r) {
    this.planPreprocessing(A), this.planFeatures(A), this.planPostprocessing(A, r), A.assignGlobalFeatures(t), this.assignFeatures(A, t);
  }
  static planPreprocessing(A) {
    A.add({
      global: [
        ...IY,
        ...pY[A.direction]
      ],
      local: mY
    });
  }
  static planFeatures(A) {
  }
  static planPostprocessing(A, t) {
    A.add([
      ...DY,
      ...MY
    ]), A.setFeatureOverrides(t);
  }
  static assignFeatures(A, t) {
    for (let r = 0; r < t.length; r++) {
      let n = t[r];
      if (n.codePoints[0] === 8260) {
        let i = r, a = r + 1;
        for (; i > 0 && ch(t[i - 1].codePoints[0]); )
          t[i - 1].features.numr = !0, t[i - 1].features.frac = !0, i--;
        for (; a < t.length && ch(t[a].codePoints[0]); )
          t[a].features.dnom = !0, t[a].features.frac = !0, a++;
        n.features.frac = !0, r = a - 1;
      }
    }
  }
}
rn(_i, "zeroMarkWidths", "AFTER_GPOS");
const vY = new kg(vC("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==")), Hw = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
], Ch = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  "DALATH RISH": 5,
  Transparent: 6
}, Yt = "isol", mi = "fina", Gf = "fin2", yY = "fin3", Tu = "medi", Pu = "med2", zu = "init", ft = null, bY = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      Yt,
      1
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      Yt,
      1
    ],
    [
      ft,
      Yt,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      Yt,
      1
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      Gf,
      5
    ],
    [
      ft,
      Yt,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      zu,
      mi,
      1
    ],
    [
      zu,
      mi,
      3
    ],
    [
      zu,
      mi,
      4
    ],
    [
      zu,
      mi,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      Tu,
      mi,
      1
    ],
    [
      Tu,
      mi,
      3
    ],
    [
      Tu,
      mi,
      4
    ],
    [
      Tu,
      mi,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      Pu,
      Yt,
      1
    ],
    [
      Pu,
      Yt,
      2
    ],
    [
      Pu,
      Gf,
      5
    ],
    [
      Pu,
      Yt,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      Yt,
      Yt,
      1
    ],
    [
      Yt,
      Yt,
      2
    ],
    [
      Yt,
      Gf,
      5
    ],
    [
      Yt,
      Yt,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      ft,
      ft,
      0
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      Yt,
      1
    ],
    [
      ft,
      Yt,
      2
    ],
    [
      ft,
      yY,
      5
    ],
    [
      ft,
      Yt,
      6
    ]
  ]
];
class Mi extends _i {
  static planFeatures(A) {
    A.add([
      "ccmp",
      "locl"
    ]);
    for (let t = 0; t < Hw.length; t++) {
      let r = Hw[t];
      A.addStage(r, !1);
    }
    A.addStage("mset");
  }
  static assignFeatures(A, t) {
    super.assignFeatures(A, t);
    let r = -1, n = 0, i = [];
    for (let o = 0; o < t.length; o++) {
      let s, l;
      var a = t[o];
      let u = FY(a.codePoints[0]);
      if (u === Ch.Transparent) {
        i[o] = ft;
        continue;
      }
      [l, s, n] = bY[n][u], l !== ft && r !== -1 && (i[r] = l), i[o] = s, r = o;
    }
    for (let o = 0; o < t.length; o++) {
      let s;
      var a = t[o];
      (s = i[o]) && (a.features[s] = !0);
    }
  }
}
function FY(e) {
  let A = vY.get(e);
  if (A) return A - 1;
  let t = kn(e);
  return t === "Mn" || t === "Me" || t === "Cf" ? Ch.Transparent : Ch.Non_Joining;
}
class LY {
  reset(A = {}, t = 0) {
    this.options = A, this.flags = A.flags || {}, this.markAttachmentType = A.markAttachmentType || 0, this.index = t;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(A) {
    return this.flags.ignoreMarks && A.isMark || this.flags.ignoreBaseGlyphs && A.isBase || this.flags.ignoreLigatures && A.isLigature || this.markAttachmentType && A.isMark && A.markAttachmentType !== this.markAttachmentType;
  }
  move(A) {
    for (this.index += A; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); ) this.index += A;
    return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(A = 1) {
    let t = this.index, r = this.increment(A);
    return this.index = t, r;
  }
  peekIndex(A = 1) {
    let t = this.index;
    this.increment(A);
    let r = this.index;
    return this.index = t, r;
  }
  increment(A = 1) {
    let t = A < 0 ? -1 : 1;
    for (A = Math.abs(A); A--; ) this.move(t);
    return this.glyphs[this.index];
  }
  constructor(A, t) {
    this.glyphs = A, this.reset(t);
  }
}
const RY = [
  "DFLT",
  "dflt",
  "latn"
];
class eg {
  findScript(A) {
    if (this.table.scriptList == null) return null;
    Array.isArray(A) || (A = [
      A
    ]);
    for (let t of A) for (let r of this.table.scriptList)
      if (r.tag === t) return r;
    return null;
  }
  selectScript(A, t, r) {
    let n = !1, i;
    if (!this.script || A !== this.scriptTag) {
      if (i = this.findScript(A), i || (i = this.findScript(RY)), !i) return this.scriptTag;
      this.scriptTag = i.tag, this.script = i.script, this.language = null, this.languageTag = null, n = !0;
    }
    if ((!r || r !== this.direction) && (this.direction = r || nm(A)), t && t.length < 4 && (t += " ".repeat(4 - t.length)), !t || t !== this.languageTag) {
      this.language = null;
      for (let a of this.script.langSysRecords) if (a.tag === t) {
        this.language = a.langSys, this.languageTag = a.tag;
        break;
      }
      this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), n = !0;
    }
    if (n && (this.features = {}, this.language))
      for (let a of this.language.featureIndexes) {
        let o = this.table.featureList[a], s = this.substituteFeatureForVariations(a);
        this.features[o.tag] = s || o.feature;
      }
    return this.scriptTag;
  }
  lookupsForFeatures(A = [], t) {
    let r = [];
    for (let n of A) {
      let i = this.features[n];
      if (i)
        for (let a of i.lookupListIndexes)
          t && t.indexOf(a) !== -1 || r.push({
            feature: n,
            index: a,
            lookup: this.table.lookupList.get(a)
          });
    }
    return r.sort((n, i) => n.index - i.index), r;
  }
  substituteFeatureForVariations(A) {
    if (this.variationsIndex === -1) return null;
    let r = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
    for (let n of r)
      if (n.featureIndex === A) return n.alternateFeatureTable;
    return null;
  }
  findVariationsIndex(A) {
    let t = this.table.featureVariations;
    if (!t) return -1;
    let r = t.featureVariationRecords;
    for (let n = 0; n < r.length; n++) {
      let i = r[n].conditionSet.conditionTable;
      if (this.variationConditionsMatch(i, A)) return n;
    }
    return -1;
  }
  variationConditionsMatch(A, t) {
    return A.every((r) => {
      let n = r.axisIndex < t.length ? t[r.axisIndex] : 0;
      return r.filterRangeMinValue <= n && n <= r.filterRangeMaxValue;
    });
  }
  applyFeatures(A, t, r) {
    let n = this.lookupsForFeatures(A);
    this.applyLookups(n, t, r);
  }
  applyLookups(A, t, r) {
    this.glyphs = t, this.positions = r, this.glyphIterator = new LY(t);
    for (let { feature: n, lookup: i } of A)
      for (this.currentFeature = n, this.glyphIterator.reset(i.flags); this.glyphIterator.index < t.length; ) {
        if (!(n in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let a of i.subTables)
          if (this.applyLookup(i.lookupType, a)) break;
        this.glyphIterator.next();
      }
  }
  applyLookup(A, t) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(A) {
    let t = this.glyphIterator.options, r = this.glyphIterator.index;
    for (let n of A) {
      this.glyphIterator.reset(t, r), this.glyphIterator.increment(n.sequenceIndex);
      let i = this.table.lookupList.get(n.lookupListIndex);
      this.glyphIterator.reset(i.flags, this.glyphIterator.index);
      for (let a of i.subTables)
        if (this.applyLookup(i.lookupType, a)) break;
    }
    return this.glyphIterator.reset(t, r), !0;
  }
  coverageIndex(A, t) {
    switch (t == null && (t = this.glyphIterator.cur.id), A.version) {
      case 1:
        return A.glyphs.indexOf(t);
      case 2:
        for (let r of A.rangeRecords)
          if (r.start <= t && t <= r.end) return r.startCoverageIndex + t - r.start;
        break;
    }
    return -1;
  }
  match(A, t, r, n) {
    let i = this.glyphIterator.index, a = this.glyphIterator.increment(A), o = 0;
    for (; o < t.length && a && r(t[o], a); )
      n && n.push(this.glyphIterator.index), o++, a = this.glyphIterator.next();
    return this.glyphIterator.index = i, o < t.length ? !1 : n || !0;
  }
  sequenceMatches(A, t) {
    return this.match(A, t, (r, n) => r === n.id);
  }
  sequenceMatchIndices(A, t) {
    return this.match(A, t, (r, n) => this.currentFeature in n.features ? r === n.id : !1, []);
  }
  coverageSequenceMatches(A, t) {
    return this.match(A, t, (r, n) => this.coverageIndex(r, n.id) >= 0);
  }
  getClassID(A, t) {
    switch (t.version) {
      case 1:
        let r = A - t.startGlyph;
        if (r >= 0 && r < t.classValueArray.length) return t.classValueArray[r];
        break;
      case 2:
        for (let n of t.classRangeRecord)
          if (n.start <= A && A <= n.end) return n.class;
        break;
    }
    return 0;
  }
  classSequenceMatches(A, t, r) {
    return this.match(A, t, (n, i) => n === this.getClassID(i.id, r));
  }
  applyContext(A) {
    let t, r;
    switch (A.version) {
      case 1:
        if (t = this.coverageIndex(A.coverage), t === -1) return !1;
        r = A.ruleSets[t];
        for (let n of r)
          if (this.sequenceMatches(1, n.input)) return this.applyLookupList(n.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(A.coverage) === -1 || (t = this.getClassID(this.glyphIterator.cur.id, A.classDef), t === -1)) return !1;
        r = A.classSet[t];
        for (let n of r)
          if (this.classSequenceMatches(1, n.classes, A.classDef)) return this.applyLookupList(n.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(0, A.coverages)) return this.applyLookupList(A.lookupRecords);
        break;
    }
    return !1;
  }
  applyChainingContext(A) {
    let t;
    switch (A.version) {
      case 1:
        if (t = this.coverageIndex(A.coverage), t === -1) return !1;
        let r = A.chainRuleSets[t];
        for (let i of r)
          if (this.sequenceMatches(-i.backtrack.length, i.backtrack) && this.sequenceMatches(1, i.input) && this.sequenceMatches(1 + i.input.length, i.lookahead)) return this.applyLookupList(i.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(A.coverage) === -1) return !1;
        t = this.getClassID(this.glyphIterator.cur.id, A.inputClassDef);
        let n = A.chainClassSet[t];
        if (!n) return !1;
        for (let i of n)
          if (this.classSequenceMatches(-i.backtrack.length, i.backtrack, A.backtrackClassDef) && this.classSequenceMatches(1, i.input, A.inputClassDef) && this.classSequenceMatches(1 + i.input.length, i.lookahead, A.lookaheadClassDef)) return this.applyLookupList(i.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(-A.backtrackGlyphCount, A.backtrackCoverage) && this.coverageSequenceMatches(0, A.inputCoverage) && this.coverageSequenceMatches(A.inputGlyphCount, A.lookaheadCoverage)) return this.applyLookupList(A.lookupRecords);
        break;
    }
    return !1;
  }
  constructor(A, t) {
    this.font = A, this.table = t, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = A._variationProcessor ? this.findVariationsIndex(A._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
  }
}
class qn {
  get id() {
    return this._id;
  }
  set id(A) {
    this._id = A, this.substituted = !0;
    let t = this._font.GDEF;
    if (t && t.glyphClassDef) {
      let r = eg.prototype.getClassID(A, t.glyphClassDef);
      this.isBase = r === 1, this.isLigature = r === 2, this.isMark = r === 3, this.markAttachmentType = t.markAttachClassDef ? eg.prototype.getClassID(A, t.markAttachClassDef) : 0;
    } else
      this.isMark = this.codePoints.length > 0 && this.codePoints.every(DC), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
  }
  copy() {
    return new qn(this._font, this.id, this.codePoints, this.features);
  }
  constructor(A, t, r = [], n) {
    if (this._font = A, this.codePoints = r, this.id = t, this.features = {}, Array.isArray(n)) for (let i = 0; i < n.length; i++) {
      let a = n[i];
      this.features[a] = !0;
    }
    else typeof n == "object" && Object.assign(this.features, n);
    this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
  }
}
class am extends _i {
  static planFeatures(A) {
    A.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], !1);
  }
  static assignFeatures(A, t) {
    let r = 0, n = 0;
    for (; n < t.length; ) {
      let i, o = t[n].codePoints[0], s = ig(o);
      switch ([i, r] = KY[r][s], i) {
        case K0:
          A.font.hasGlyphForCodePoint(o) || (n = lm(t, n, A.font));
          break;
        case Eh:
          n = _Y(t, n, A.font);
          break;
        case Qh:
          qY(t, n, A.font);
          break;
        case wh:
          n = $Y(t, n, A.font);
          break;
      }
      n++;
    }
  }
}
rn(am, "zeroMarkWidths", "NONE");
const Xo = 44032, om = 55204, GY = om - Xo + 1, Pg = 4352, zg = 4449, Na = 4519, xY = 19, tg = 21, hl = 28, kY = Pg + xY - 1, UY = zg + tg - 1, YY = Na + hl - 1, Sw = 9676, HY = (e) => 4352 <= e && e <= 4447 || 43360 <= e && e <= 43388, SY = (e) => 4448 <= e && e <= 4519 || 55216 <= e && e <= 55238, NY = (e) => 4520 <= e && e <= 4607 || 55243 <= e && e <= 55291, TY = (e) => 12334 <= e && e <= 12335, PY = (e) => Xo <= e && e <= om, zY = (e) => e - Xo < GY && (e - Xo) % hl === 0, jY = (e) => Pg <= e && e <= kY, VY = (e) => zg <= e && e <= UY, OY = (e) => 1 <= e && e <= YY, JY = 0, WY = 1, rg = 2, bC = 3, ng = 4, sm = 5, ZY = 6;
function ig(e) {
  return HY(e) ? WY : SY(e) ? rg : NY(e) ? bC : zY(e) ? ng : PY(e) ? sm : TY(e) ? ZY : JY;
}
const qr = 0, K0 = 1, Eh = 2, Qh = 4, wh = 5, KY = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      qr,
      0
    ],
    [
      qr,
      1
    ],
    [
      qr,
      0
    ],
    [
      qr,
      0
    ],
    [
      K0,
      2
    ],
    [
      K0,
      3
    ],
    [
      wh,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      qr,
      0
    ],
    [
      qr,
      1
    ],
    [
      Eh,
      2
    ],
    [
      qr,
      0
    ],
    [
      K0,
      2
    ],
    [
      K0,
      3
    ],
    [
      wh,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      qr,
      0
    ],
    [
      qr,
      1
    ],
    [
      qr,
      0
    ],
    [
      Eh,
      3
    ],
    [
      K0,
      2
    ],
    [
      K0,
      3
    ],
    [
      Qh,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      qr,
      0
    ],
    [
      qr,
      1
    ],
    [
      qr,
      0
    ],
    [
      qr,
      0
    ],
    [
      K0,
      2
    ],
    [
      K0,
      3
    ],
    [
      Qh,
      0
    ]
  ]
];
function tl(e, A, t) {
  return new qn(e, e.glyphForCodePoint(A).id, [
    A
  ], t);
}
function lm(e, A, t) {
  let r = e[A], i = r.codePoints[0] - Xo, a = Na + i % hl;
  i = i / hl | 0;
  let o = Pg + i / tg | 0, s = zg + i % tg;
  if (!t.hasGlyphForCodePoint(o) || !t.hasGlyphForCodePoint(s) || a !== Na && !t.hasGlyphForCodePoint(a)) return A;
  let l = tl(t, o, r.features);
  l.features.ljmo = !0;
  let u = tl(t, s, r.features);
  u.features.vjmo = !0;
  let g = [
    l,
    u
  ];
  if (a > Na) {
    let d = tl(t, a, r.features);
    d.features.tjmo = !0, g.push(d);
  }
  return e.splice(A, 1, ...g), A + g.length - 1;
}
function _Y(e, A, t) {
  let r = e[A], n = e[A].codePoints[0], i = ig(n), a = e[A - 1].codePoints[0], o = ig(a), s, l, u, g;
  if (o === ng && i === bC)
    s = a, g = r;
  else {
    i === rg ? (l = e[A - 1], u = r) : (l = e[A - 2], u = e[A - 1], g = r);
    let h = l.codePoints[0], C = u.codePoints[0];
    jY(h) && VY(C) && (s = Xo + ((h - Pg) * tg + (C - zg)) * hl);
  }
  let d = g && g.codePoints[0] || Na;
  if (s != null && (d === Na || OY(d))) {
    let h = s + (d - Na);
    if (t.hasGlyphForCodePoint(h)) {
      let C = o === rg ? 3 : 2;
      return e.splice(A - C + 1, C, tl(t, h, r.features)), A - C + 1;
    }
  }
  return l && (l.features.ljmo = !0), u && (u.features.vjmo = !0), g && (g.features.tjmo = !0), o === ng ? (lm(e, A - 1, t), A + 1) : A;
}
function XY(e) {
  switch (ig(e)) {
    case ng:
    case sm:
      return 1;
    case rg:
      return 2;
    case bC:
      return 3;
  }
}
function qY(e, A, t) {
  let r = e[A], n = e[A].codePoints[0];
  if (t.glyphForCodePoint(n).advanceWidth === 0) return;
  let i = e[A - 1].codePoints[0], a = XY(i);
  return e.splice(A, 1), e.splice(A - a, 0, r);
}
function $Y(e, A, t) {
  let r = e[A], n = e[A].codePoints[0];
  if (t.hasGlyphForCodePoint(Sw)) {
    let i = tl(t, Sw, r.features), a = t.glyphForCodePoint(n).advanceWidth === 0 ? A : A + 1;
    e.splice(a, 0, i), A++;
  }
  return A;
}
var um = {};
um = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var jg = {};
jg = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","null","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","M","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const it = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  SM: 256,
  VD: 512,
  A: 1024,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072,
  Symbol: 262144
  // Avagraha, etc that take marks (SM,A,VD).
}, He = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Above_C: 64,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
}, AH = it.C | it.Ra | it.CM | it.V | it.Placeholder | it.Dotted_Circle, cm = it.ZWJ | it.ZWNJ, rl = it.H | it.Coeng, Nw = {
  Default: {
    hasOldSpec: !1,
    virama: 0,
    basePos: "Last",
    rephPos: He.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: !0,
    virama: 2381,
    basePos: "Last",
    rephPos: He.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: !0,
    virama: 2509,
    basePos: "Last",
    rephPos: He.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: !0,
    virama: 2637,
    basePos: "Last",
    rephPos: He.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: !0,
    virama: 2765,
    basePos: "Last",
    rephPos: He.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: !0,
    virama: 2893,
    basePos: "Last",
    rephPos: He.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: !0,
    virama: 3021,
    basePos: "Last",
    rephPos: He.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: !0,
    virama: 3149,
    basePos: "Last",
    rephPos: He.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: !0,
    virama: 3277,
    basePos: "Last",
    rephPos: He.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: !0,
    virama: 3405,
    basePos: "Last",
    rephPos: He.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: !1,
    virama: 6098,
    basePos: "First",
    rephPos: He.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
}, eH = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
}, { decompositions: tH } = /* @__PURE__ */ Hg(jg), gm = new kg(vC("AAARAAAAAABg2AAAAWYPmfDtnXuMXFUdx+/uzs7M7szudAtECGJRIMRQbUAithQWkGAKiVhNpFVRRAmIQVCDkDYICGotIA9BTCz8IeUviv7BQ2PBtBIRLBBQIWAUsKg1BKxRAqIgfs/cc+aeOXPej3tnZX7JJ/dxzj3nd36/8753Z5fUsuxgsAwcAU4Gp4BPgM+Cd4P3RjieDs4GXwLrHJ5bDy4DG8A14LvgZrAZbAF3gns0z18ALgY/B78C94NHwBPgabAE/AX8DbwM5sF/QX0yD5vFcU/wVnAgWAoOAyvAceBE8CGwBpwGzgJfAF8BXwXfAFeC68EmsBlsAXeCreA+8CB4DDwF/gh2gd3gFfAGmKxn2QzYC+wHDgRLweFgJTgWrKrnuq/GcQ04jV6fheN54EJwEbgcXAG+Q8O/j+Mt4DZwB9haz8t9Hz3a8iCN/xiOvwRP0evH6fE68AzOH+Ke2eWYhw3PcGnuxvkr4A3QaGRZB7wFLAEHg2XgiEZ/fHKcp/ceBh/A+cngFPCpRm6vM3E8l8a5gN67GMdvgqsbeX2ap9yI601gM7gN3AG20mfuo8cdOP6GpvdUg9oKxz839GV90RDO2/glxN1B790NXsN1rZll7WYRdw+c70uvTwIHNAfTO0RyL5TDmnnbc3lmRQI9UnM0dD5eovfz4FpJ/BNpXNYWV+N6Lfg0hY97JK1vn+Pur9DoQur2F7m436bHDUK8C5t5/8vruo4+97WmXG+GLmzEiBF+PDwEOowYMWLEiBEjRoxYeBw5BDqIPEfXut9yWN+vVNxfrnnmWqR/PdgENoMt4E5wD9gOHgCPgifBs2BXM99b2o3jP8F/wMRUlrXAHNgHvH0q3895J46HguXgWHAGLctmLv9VuL96qnp7jxgxYsSbCbJvuRZ97/tqxT59VVRtixEjRsThBG7OSt5zzoPT0M+cBc4T5noXOs79TqLHeZrHUeCSqeJ96gacXy2kecNU8V6Hh7yXuQlhtw7B/PO1RTkr52Aj8JNFZjYg3gOKuC/g/v6Ls2wNuAY8urg//PcIb+6RZXuDNeCS6SzbBrJWlh0DLiFHco8ed9IjzzvaWfa9sZzTcf6D9mCcnbg3PlNcH4fzS8F2MDaLdQG4dLZIJxbbaZqv4ri8k58f3+mPs66T6/TTzqDeI0aMGDGiHP5dcR8ce/xxYcWi6vOfr725uRzcjnngXVOD61Hync+9uL+Nmyfej/NHpvL56A5Jeuz7uyfo+pqcPz2Vf1NH0ttJ03pekt8SmuY/EPYy9zzbN319ym/9TL6ZIt9MHCXRdxJtoAkWTRdz472n87D9cTwYLJvuz++I6WIePo/zE8AHp4v8WLyP0nufnM6/+zoDx8+DL08P6r9+urheRtO+jD6/cdrsx3mqu8w+xH4PScKIXa5D2jeCm8Et4DbwI/BjcC/4BXgI/Bb8DuwEu8Bu8Ap4A9RaRZptnO8J9gUHgEPAoWA5OLY1qMO90GEV7q+mYWtxPBWcIYnL4p+DsPNbxfVFOP86uAr8DNc34HgTDb8Vx9sVaRFI/LtagzYjnCqpb908EX87eBA8Bh4Hf2jle/9/wvGFVv787rrZZy8h7qtgDOuFOmiBuXYRvg/O9wMHgXeB97SLspk4sq0OI/q9v13+ek+sh3zYSRp9jrYorw9ll1/GRzR+KotYZSHf8laVP2lvpA/8OGdPMk59hqtXZ+L8nHbxvWwqO65ryu+fT3VZz+l4dET7L0R072ljsMyzTpaJqQxsbL8M9WajY789DO85XMp/Dcp3Qztdn+9qf/a97ZWK8PXc3G+TpC/nv8Mncy7ZvICF302P5O+aNiOtLdTXd+D4Q7DVwfcvWvx9zTEJ/o5iG3R8YAjGNFseha5PGuZKz7b7xxXbOrXMcu5eJSo//rXdH/73Enz6L1q/X+fyIu8wZGtNBmkjkzNZNgP2AvuBg2bysKUzduXn/66JtNeN4PCZvO0/x7Ujdn4VnYOvRJzjZ/I+9sQZeftX2Tc1RPcPz/Tf4/si0g+t5Mq+kfZjZL34Mc5ul3PPnE7TOxvHK2qDaZ+L++db2HyYqMo/qVnb/P8uH8/rmnFxR0k6DCu/rjj/RxT7KGUSWgbd+LMQuEgYB1zsk2qtvJD8v5AhdfdttbEunSxbcJD9Zf7chqp1Hlbe7FK1/aPVTfp7FgtC1yGGiSncFK/DhZvi+epZta0WWjlsfDZMyPRdSPrryqSSKnXx1bkq/Ye9TlRpk7Lrjq1UrfdC9X+MtKqwP6+3a/4pJFUZF0pZZpv91MYjMBaRRXbxpho5zQmUY3F+Pt4o7rvQrBXPdm00TaE24uMadaM2meLSI7iu071t3er3b6ZLi8JEde3qw+6zGv+ycF5kaRBh/m1T/7Yl/mMyTuMwadP4xL9ifjJpNwbvDZRJ8G8vnqV/Wf12aa/kyOdl69+BspTsXzGueE6E+JfZnvmXIfNPW+FfXkjb1YmqPNpnLP3b61fHCj/X5tzGANf2y3yqvC7Jv7btV4TVbdammI9l/g0dS5lNxLrk2j9r8xjjxhBQnygg0lgg/bOrfyct+udJi/Yrk0lFnxC7f+5kRbsNmcexfrubt0X/rGvLqrGSnYv3ZPHEe8r7lvMvUfi2LOu/2dg8LrRtQt2yfcv8r5IU70VkIs6nbebUXf0M/o7Znl39Sdoz+X1oEb5N8ffF67qhPfPP6eoUbxf+GRf/6sRnvaSdmw+Bf1VxmbD+2sa//DU7t/Gv2PfKpKdrBP92Ojk+IvqX16ks/2qxbL8EZnc2HqsgYuqPuzZV+I3RbujbDm+T0PmWCVO/5jqftp1zy+wSA6s0JWtp2z5e1oZV+yMsjB3ZXolsv0Ulrv01v3/iKrF94Qtbt9siCnmeb6fjjf59KnLk1xaEbvtvFnFirGvEOqmycQrbm/IMsXd3P28uh4nM3swXRER717OiX8kc7K2qqyn2p3maFGU/aruP5VCv+PraoTYU8yUmmbDwcYo6pusnM486xdoga4dkPCb1pK7Sfc6ebvkd4qeAtQcd/N63bB3lU3dlUnUf38VyvqCqK7JxlNSd7lydrDlm+/uqHiRvl30Nrp/n9zpkZRjoJ3V1diyP05rIYXHYs+w+D5+WMS8b5gZtKcuX0KT5d/WwtB97VnyvY6rjMukI56HI0rFJPwt8PjT/1OXzSbcMeEmdh294qvKK4rNu7j4n3LNZg8TKXwafv025U+XvKjHsT8Q7/7LGaJt9lAh7Asz3uv0XEX6t0duDoWN/93wmh92XpUHmCKb9GALbG+rZP3AfNbQPKKv/jpF/bP0JXfuW1QYk7dhljcyvk5mw+933Hpo1g26PQ2ZP6zVmTJt47P25jncD9vPwGS+q9QS/V6RaY8j8K8LmvUr9HfYCpH5OWL9lZY+Sv6pesHCJHbtrf9k6etZvf0G1L0ja4cAe1UT/s3zdCe3/Q5/n372wMc97/E1Qh0Tbmfwh3m/V9On72tNnrCF1sJkVe1EyXMdBa7+lHMsk44zMF6St9e2djNnbm8ybpHkq+gbbemMaH0UZmD8obKGrk7r+nt+3bE7o83YZp/vqOKdv6PzJNN6mTJsI/51XR7i2ZrGA5B6zFwnjzxmqPjaGfW3tZNrz1eljq29mOOqeCfF/irRt87PNw0uXSVAvrmOMNT569MptsYaV0sic/wbY13e8hPrb9K2ySUJ0j6G/Lu0U4qpTrR23jMp6m5hU+YTaWCeh9aIsm/rqUHV4bFv42kgnZdfH1PUj1D7DVH9d8khRN1zFRl/+/TW//qxL1uH83+mk3H+SvRtS2TDU90nX2TpM6/1xzZpZtoYdK763dqlz0f6uNeFehcs+H/nbGP77MpX06n/ofpzP+tVmTUvRtVuX/cjS67OE5kRBrxyJ+w/dPo7r+9cO1160e3gqu0S2uW7PjN/L6ns/UfMf10Lai87frJ+3KndAfc8yTf1M3T4s6qm4/yh7/2GSkG8UMw//DvRLgbYZSEOxr0LCWvRdjfh9XGzfqN4NivfZd7rsmFp08zmbssrKJEuTfVMZopdpbuwSrhNv3/N2s+0PDG3KNB6RMrFvJHv6B85HXObAoWsd3zm3i+6uZYytv+5+pohbpo6+tpZJFfmGlrcMf4c8b1Pe2OUIsaXJrinCTfaxtZOt+NYnU3hIfQlN20Z/1+dt7JaqLsbIzycNWZmrlNg2Dc2/LJ1T+T6WrrYSml4Ku7ik7yIx2opJD51vU9UfVRmrqL8u/olZj0PyCLV5irxcdKoi/6rKb8qTrHsnhW9jyZH/nSpeWDzxd9769uQ016lgUuf2pAfKPhu2FpfZL2Yb9snLNl/fNIepXaUsj4vNXCXUZ75px8ojNP8UPvAta2g6fb+F1ckZuneshv1vGXXDeyRRrN/bBPS1Jul+l+7zW86R7Wv63WXyDpt/RxraRjvC+TC3O61/Sqj/prag8x372yQivn+XwudrI2X2E2KdtJEov52e0L+uv4FO3p/rvssgsL8F4d/z9PzlWS94m8fqS3361Fi+6qaVYHwi9Yz4iH2fobIj+45cpz/TUaarr/4+z+vaWtVtyAX2d1LG8W9C3f+F1mnf36/k4w3YPrLv+XBVXCJs3cr+n4MKJuLv/fN9GhNdXVP5pJMN9vFi3rpv3/r8Ywg3SYp66zNOsO8QGcxPpnmRS/1mvmJjju3v7absI2xspQrvs1dNbjOj/wP7h1RlZyKGy8occ408UL8En4v6xfC/K3z52XzJd62T8vuZGGsxo/6O46ntmNqqFb/jps2/hHV4rPKH0svT4pstU7t2tZ9u/ZdqbJL1MwP6O86Fyt4jYaIrGz9mjEt8lFL4PtVE6votG2P6fpdf/GZRse7s3bf4BtSl/DIbKMctx++Z+8o6K6z9FPOwKsRmXiaNl7C+6NYRpjlbqG1j72f49qsuY4brd/amb4ZVc8TQ+sSH985LrEe8iPWJnfPrJRbWbb+dwn4x6o+r/aS2S7w3qWt//LnYz2ntE0vH1uDcyKatx1rH+EiMPEN1SZG/iz6+9o01Rob6O7Q+xLZ1jHobK61U+pWVvo2EpuWqzzD6Poa+pvhli0wn8Zq/72Mzm2d90o5VN1x9ZKuzbTgvqWwUIin8FSpl1CXXvFRxU0iozVPYJDRtF3uFphn6XAyJUUdD7SjTJ8v6n9fVbVObkKWp001lc9VRlqdOf5v0ZM+bymdbfp1NfG0bq27Y5JMyfxeJkU6o/inKH8O2Zfgidb6h/g3VJ7QcVbWL0Pxt6rlrPqa4KfQ25a2zl4/E8GdM/4fK/wA=")), rH = new x4(/* @__PURE__ */ Hg(um));
class rr extends _i {
  static planFeatures(A) {
    A.addStage(nH), A.addStage([
      "locl",
      "ccmp"
    ]), A.addStage(aH), A.addStage("nukt"), A.addStage("akhn"), A.addStage("rphf", !1), A.addStage("rkrf"), A.addStage("pref", !1), A.addStage("blwf", !1), A.addStage("abvf", !1), A.addStage("half", !1), A.addStage("pstf", !1), A.addStage("vatu"), A.addStage("cjct"), A.addStage("cfar", !1), A.addStage(oH), A.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    }), A.unicodeScript = KU(A.script), A.indicConfig = Nw[A.unicodeScript] || Nw.Default, A.isOldSpec = A.indicConfig.hasOldSpec && A.script[A.script.length - 1] !== "2";
  }
  static assignFeatures(A, t) {
    for (let r = t.length - 1; r >= 0; r--) {
      let n = t[r].codePoints[0], i = eH[n] || tH[n];
      if (i) {
        let a = i.map((o) => {
          let s = A.font.glyphForCodePoint(o);
          return new qn(A.font, s.id, [
            o
          ], t[r].features);
        });
        t.splice(r, 1, ...a);
      }
    }
  }
}
rn(rr, "zeroMarkWidths", "NONE");
function Ih(e) {
  return gm.get(e.codePoints[0]) >> 8;
}
function Bm(e) {
  return 1 << (gm.get(e.codePoints[0]) & 255);
}
class Ec {
  constructor(A, t, r, n) {
    this.category = A, this.position = t, this.syllableType = r, this.syllable = n;
  }
}
function nH(e, A) {
  let t = 0, r = 0;
  for (let [n, i, a] of rH.match(A.map(Ih))) {
    if (n > r) {
      ++t;
      for (let o = r; o < n; o++) A[o].shaperInfo = new Ec(it.X, He.End, "non_indic_cluster", t);
    }
    ++t;
    for (let o = n; o <= i; o++) A[o].shaperInfo = new Ec(1 << Ih(A[o]), Bm(A[o]), a[0], t);
    r = i + 1;
  }
  if (r < A.length) {
    ++t;
    for (let n = r; n < A.length; n++) A[n].shaperInfo = new Ec(it.X, He.End, "non_indic_cluster", t);
  }
}
function ma(e) {
  return e.shaperInfo.category & AH;
}
function E0(e) {
  return e.shaperInfo.category & cm;
}
function J0(e) {
  return e.shaperInfo.category & rl;
}
function _0(e, A) {
  for (let r of e) r.features = {
    [A]: !0
  };
  return e[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
    A
  ], e), e.length === 1;
}
function iH(e, A, t) {
  let r = [
    t,
    A,
    t
  ];
  return _0(r.slice(0, 2), "blwf") || _0(r.slice(1, 3), "blwf") ? He.Below_C : _0(r.slice(0, 2), "pstf") || _0(r.slice(1, 3), "pstf") || _0(r.slice(0, 2), "pref") || _0(r.slice(1, 3), "pref") ? He.Post_C : He.Base_C;
}
function aH(e, A, t) {
  let r = t.indicConfig, n = e._layoutEngine.engine.GSUBProcessor.features, i = e.glyphForCodePoint(9676).id, a = e.glyphForCodePoint(r.virama).id;
  if (a) {
    let o = new qn(e, a, [
      r.virama
    ]);
    for (let s = 0; s < A.length; s++) A[s].shaperInfo.position === He.Base_C && (A[s].shaperInfo.position = iH(e, A[s].copy(), o));
  }
  for (let o = 0, s = ag(A, 0); o < A.length; o = s, s = ag(A, o)) {
    let { category: l, syllableType: u } = A[o].shaperInfo;
    if (u === "symbol_cluster" || u === "non_indic_cluster") continue;
    if (u === "broken_cluster" && i) {
      let p = new qn(e, i, [
        9676
      ]);
      p.shaperInfo = new Ec(1 << Ih(p), Bm(p), A[o].shaperInfo.syllableType, A[o].shaperInfo.syllable);
      let Q = o;
      for (; Q < s && A[Q].shaperInfo.category === it.Repha; ) Q++;
      A.splice(Q++, 0, p), s++;
    }
    let g = s, d = o, h = !1;
    if (r.rephPos !== He.Ra_To_Become_Reph && n.rphf && o + 3 <= s && (r.rephMode === "Implicit" && !E0(A[o + 2]) || r.rephMode === "Explicit" && A[o + 2].shaperInfo.category === it.ZWJ)) {
      let p = [
        A[o].copy(),
        A[o + 1].copy(),
        A[o + 2].copy()
      ];
      if (_0(p.slice(0, 2), "rphf") || r.rephMode === "Explicit" && _0(p, "rphf")) {
        for (d += 2; d < s && E0(A[d]); ) d++;
        g = o, h = !0;
      }
    } else if (r.rephMode === "Log_Repha" && A[o].shaperInfo.category === it.Repha) {
      for (d++; d < s && E0(A[d]); ) d++;
      g = o, h = !0;
    }
    switch (r.basePos) {
      case "Last": {
        let p = s, Q = !1;
        do {
          let w = A[--p].shaperInfo;
          if (ma(A[p])) {
            if (w.position !== He.Below_C && (w.position !== He.Post_C || Q)) {
              g = p;
              break;
            }
            w.position === He.Below_C && (Q = !0), g = p;
          } else if (o < p && w.category === it.ZWJ && A[p - 1].shaperInfo.category === it.H) break;
        } while (p > d);
        break;
      }
      case "First":
        g = o;
        for (let p = g + 1; p < s; p++) ma(A[p]) && (A[p].shaperInfo.position = He.Below_C);
    }
    h && g === o && d - g <= 2 && (h = !1);
    for (let p = o; p < g; p++) {
      let Q = A[p].shaperInfo;
      Q.position = Math.min(He.Pre_C, Q.position);
    }
    g < s && (A[g].shaperInfo.position = He.Base_C);
    for (let p = g + 1; p < s; p++) if (A[p].shaperInfo.category === it.M) {
      for (let Q = p + 1; Q < s; Q++) if (ma(A[Q])) {
        A[Q].shaperInfo.position = He.Final_C;
        break;
      }
      break;
    }
    if (h && (A[o].shaperInfo.position = He.Ra_To_Become_Reph), t.isOldSpec) {
      let p = t.unicodeScript !== "Malayalam";
      for (let Q = g + 1; Q < s; Q++) if (A[Q].shaperInfo.category === it.H) {
        let w;
        for (w = s - 1; w > Q && !(ma(A[w]) || p && A[w].shaperInfo.category === it.H); w--)
          ;
        if (A[w].shaperInfo.category !== it.H && w > Q) {
          let Y = A[Q];
          A.splice(Q, 0, ...A.splice(Q + 1, w - Q)), A[w] = Y;
        }
        break;
      }
    }
    let C = He.Start;
    for (let p = o; p < s; p++) {
      let Q = A[p].shaperInfo;
      if (Q.category & (cm | it.N | it.RS | it.CM | rl & Q.category)) {
        if (Q.position = C, Q.category === it.H && Q.position === He.Pre_M) {
          for (let w = p; w > o; w--) if (A[w - 1].shaperInfo.position !== He.Pre_M) {
            Q.position = A[w - 1].shaperInfo.position;
            break;
          }
        }
      } else Q.position !== He.SMVD && (C = Q.position);
    }
    let E = g;
    for (let p = g + 1; p < s; p++)
      if (ma(A[p])) {
        for (let Q = E + 1; Q < p; Q++) A[Q].shaperInfo.position < He.SMVD && (A[Q].shaperInfo.position = A[p].shaperInfo.position);
        E = p;
      } else A[p].shaperInfo.category === it.M && (E = p);
    let I = A.slice(o, s);
    I.sort((p, Q) => p.shaperInfo.position - Q.shaperInfo.position), A.splice(o, I.length, ...I);
    for (let p = o; p < s; p++) if (A[p].shaperInfo.position === He.Base_C) {
      g = p;
      break;
    }
    for (let p = o; p < s && A[p].shaperInfo.position === He.Ra_To_Become_Reph; p++) A[p].features.rphf = !0;
    let b = !t.isOldSpec && r.blwfMode === "Pre_And_Post";
    for (let p = o; p < g; p++)
      A[p].features.half = !0, b && (A[p].features.blwf = !0);
    for (let p = g + 1; p < s; p++)
      A[p].features.abvf = !0, A[p].features.pstf = !0, A[p].features.blwf = !0;
    if (t.isOldSpec && t.unicodeScript === "Devanagari")
      for (let p = o; p + 1 < g; p++) A[p].shaperInfo.category === it.Ra && A[p + 1].shaperInfo.category === it.H && (p + 1 === g || A[p + 2].shaperInfo.category === it.ZWJ) && (A[p].features.blwf = !0, A[p + 1].features.blwf = !0);
    let y = 2;
    if (n.pref && g + y < s)
      for (let p = g + 1; p + y - 1 < s; p++) {
        let Q = [
          A[p].copy(),
          A[p + 1].copy()
        ];
        if (_0(Q, "pref")) {
          for (let w = 0; w < y; w++) A[p++].features.pref = !0;
          if (n.cfar) for (; p < s; p++) A[p].features.cfar = !0;
          break;
        }
      }
    for (let p = o + 1; p < s; p++) if (E0(A[p])) {
      let Q = A[p].shaperInfo.category === it.ZWNJ, w = p;
      do
        w--, Q && delete A[w].features.half;
      while (w > o && !ma(A[w]));
    }
  }
}
function oH(e, A, t) {
  let r = t.indicConfig, n = e._layoutEngine.engine.GSUBProcessor.features;
  for (let i = 0, a = ag(A, 0); i < A.length; i = a, a = ag(A, i)) {
    let o = !!n.pref, s = i;
    for (; s < a; s++) if (A[s].shaperInfo.position >= He.Base_C) {
      if (o && s + 1 < a) {
        for (let l = s + 1; l < a; l++) if (A[l].features.pref) {
          if (!(A[l].substituted && A[l].isLigated && !A[l].isMultiplied)) {
            for (s = l; s < a && J0(A[s]); ) s++;
            A[s].shaperInfo.position = He.BASE_C, o = !1;
          }
          break;
        }
      }
      if (t.unicodeScript === "Malayalam") for (let l = s + 1; l < a; l++) {
        for (; l < a && E0(A[l]); ) l++;
        if (l === a || !J0(A[l])) break;
        for (l++; l < a && E0(A[l]); ) l++;
        l < a && ma(A[l]) && A[l].shaperInfo.position === He.Below_C && (s = l, A[s].shaperInfo.position = He.Base_C);
      }
      i < s && A[s].shaperInfo.position > He.Base_C && s--;
      break;
    }
    if (s === a && i < s && A[s - 1].shaperInfo.category === it.ZWJ && s--, s < a) for (; i < s && A[s].shaperInfo.category & (it.N | rl); ) s--;
    if (i + 1 < a && i < s) {
      let l = s === a ? s - 2 : s - 1;
      if (t.unicodeScript !== "Malayalam" && t.unicodeScript !== "Tamil") {
        for (; l > i && !(A[l].shaperInfo.category & (it.M | rl)); ) l--;
        J0(A[l]) && A[l].shaperInfo.position !== He.Pre_M ? l + 1 < a && E0(A[l + 1]) && l++ : l = i;
      }
      if (i < l && A[l].shaperInfo.position !== He.Pre_M) {
        for (let u = l; u > i; u--) if (A[u - 1].shaperInfo.position === He.Pre_M) {
          let g = u - 1;
          g < s && s <= l && s--;
          let d = A[g];
          A.splice(g, 0, ...A.splice(g + 1, l - g)), A[l] = d, l--;
        }
      }
    }
    if (i + 1 < a && A[i].shaperInfo.position === He.Ra_To_Become_Reph && A[i].shaperInfo.category === it.Repha !== (A[i].isLigated && !A[i].isMultiplied)) {
      let l, u = r.rephPos, g = !1;
      if (u !== He.After_Post) {
        for (l = i + 1; l < s && !J0(A[l]); ) l++;
        if (l < s && J0(A[l]) && (l + 1 < s && E0(A[l + 1]) && l++, g = !0), !g && u === He.After_Main) {
          for (l = s; l + 1 < a && A[l + 1].shaperInfo.position <= He.After_Main; ) l++;
          g = l < a;
        }
        if (!g && u === He.After_Sub) {
          for (l = s; l + 1 < a && !(A[l + 1].shaperInfo.position & (He.Post_C | He.After_Post | He.SMVD)); ) l++;
          g = l < a;
        }
      }
      if (!g) {
        for (l = i + 1; l < s && !J0(A[l]); ) l++;
        l < s && J0(A[l]) && (l + 1 < s && E0(A[l + 1]) && l++, g = !0);
      }
      if (!g) {
        for (l = a - 1; l > i && A[l].shaperInfo.position === He.SMVD; ) l--;
        if (J0(A[l]))
          for (let h = s + 1; h < l; h++) A[h].shaperInfo.category === it.M && l--;
      }
      let d = A[i];
      A.splice(i, 0, ...A.splice(i + 1, l - i)), A[l] = d, i < s && s <= l && s--;
    }
    if (o && s + 1 < a) {
      for (let l = s + 1; l < a; l++) if (A[l].features.pref) {
        if (A[l].isLigated && !A[l].isMultiplied) {
          let u = s;
          if (t.unicodeScript !== "Malayalam" && t.unicodeScript !== "Tamil") {
            for (; u > i && !(A[u - 1].shaperInfo.category & (it.M | rl)); ) u--;
            if (u > i && A[u - 1].shaperInfo.category === it.M) {
              let h = l;
              for (let C = s + 1; C < h; C++) if (A[C].shaperInfo.category === it.M) {
                u--;
                break;
              }
            }
          }
          u > i && J0(A[u - 1]) && u < a && E0(A[u]) && u++;
          let g = l, d = A[g];
          A.splice(u + 1, 0, ...A.splice(u, g - u)), A[u] = d, u <= s && s < g && s++;
        }
        break;
      }
    }
    A[i].shaperInfo.position === He.Pre_M && (!i || !/Cf|Mn/.test(kn(A[i - 1].codePoints[0]))) && (A[i].features.init = !0);
  }
}
function ag(e, A) {
  if (A >= e.length) return A;
  let t = e[A].shaperInfo.syllable;
  for (; ++A < e.length && e[A].shaperInfo.syllable === t; ) ;
  return A;
}
const { categories: sH, decompositions: Tw } = /* @__PURE__ */ Hg(jg), lH = new kg(vC("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")), uH = new x4(/* @__PURE__ */ Hg(jg));
class rt extends _i {
  static planFeatures(A) {
    A.addStage(gH), A.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]), A.addStage(zw), A.addStage([
      "rphf"
    ], !1), A.addStage(BH), A.addStage(zw), A.addStage([
      "pref"
    ]), A.addStage(fH), A.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]), A.addStage(dH), A.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(A, t) {
    for (let r = t.length - 1; r >= 0; r--) {
      let n = t[r].codePoints[0];
      if (Tw[n]) {
        let i = Tw[n].map((a) => {
          let o = A.font.glyphForCodePoint(a);
          return new qn(A.font, o.id, [
            a
          ], t[r].features);
        });
        t.splice(r, 1, ...i);
      }
    }
  }
}
rn(rt, "zeroMarkWidths", "BEFORE_GPOS");
function Pw(e) {
  return lH.get(e.codePoints[0]);
}
class cH {
  constructor(A, t, r) {
    this.category = A, this.syllableType = t, this.syllable = r;
  }
}
function gH(e, A) {
  let t = 0;
  for (let [r, n, i] of uH.match(A.map(Pw))) {
    ++t;
    for (let o = r; o <= n; o++) A[o].shaperInfo = new cH(sH[Pw(A[o])], i[0], t);
    let a = A[r].shaperInfo.category === "R" ? 1 : Math.min(3, n - r);
    for (let o = r; o < r + a; o++) A[o].features.rphf = !0;
  }
}
function zw(e, A) {
  for (let t of A) t.substituted = !1;
}
function BH(e, A) {
  for (let t of A) t.substituted && t.features.rphf && (t.shaperInfo.category = "R");
}
function fH(e, A) {
  for (let t of A) t.substituted && (t.shaperInfo.category = "VPre");
}
function dH(e, A) {
  let t = e.glyphForCodePoint(9676).id;
  for (let r = 0, n = jw(A, 0); r < A.length; r = n, n = jw(A, r)) {
    let i, a, o = A[r].shaperInfo, s = o.syllableType;
    if (!(s !== "virama_terminated_cluster" && s !== "standard_cluster" && s !== "broken_cluster")) {
      if (s === "broken_cluster" && t) {
        let l = new qn(e, t, [
          9676
        ]);
        for (l.shaperInfo = o, i = r; i < n && A[i].shaperInfo.category === "R"; i++) ;
        A.splice(++i, 0, l), n++;
      }
      if (o.category === "R" && n - r > 1) {
        for (i = r + 1; i < n; i++)
          if (o = A[i].shaperInfo, Vw(o) || ju(A[i])) {
            ju(A[i]) && i--, A.splice(r, 0, ...A.splice(r + 1, i - r), A[i]);
            break;
          }
      }
      for (i = r, a = n; i < n; i++)
        o = A[i].shaperInfo, Vw(o) || ju(A[i]) ? a = ju(A[i]) ? i + 1 : i : (o.category === "VPre" || o.category === "VMPre") && a < i && A.splice(a, 1, A[i], ...A.splice(a, i - a));
    }
  }
}
function jw(e, A) {
  if (A >= e.length) return A;
  let t = e[A].shaperInfo.syllable;
  for (; ++A < e.length && e[A].shaperInfo.syllable === t; ) ;
  return A;
}
function ju(e) {
  return e.shaperInfo.category === "H" && !e.isLigated;
}
function Vw(e) {
  return e.category === "B" || e.category === "GB";
}
const hH = {
  arab: Mi,
  mong: Mi,
  syrc: Mi,
  "nko ": Mi,
  phag: Mi,
  mand: Mi,
  mani: Mi,
  phlp: Mi,
  hang: am,
  bng2: rr,
  beng: rr,
  dev2: rr,
  deva: rr,
  gjr2: rr,
  gujr: rr,
  guru: rr,
  gur2: rr,
  knda: rr,
  knd2: rr,
  mlm2: rr,
  mlym: rr,
  ory2: rr,
  orya: rr,
  taml: rr,
  tml2: rr,
  telu: rr,
  tel2: rr,
  khmr: rr,
  bali: rt,
  batk: rt,
  brah: rt,
  bugi: rt,
  buhd: rt,
  cakm: rt,
  cham: rt,
  dupl: rt,
  egyp: rt,
  gran: rt,
  hano: rt,
  java: rt,
  kthi: rt,
  kali: rt,
  khar: rt,
  khoj: rt,
  sind: rt,
  lepc: rt,
  limb: rt,
  mahj: rt,
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: rt,
  modi: rt,
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: rt,
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: rt,
  saur: rt,
  shrd: rt,
  sidd: rt,
  sinh: rr,
  sund: rt,
  sylo: rt,
  tglg: rt,
  tagb: rt,
  tale: rt,
  lana: rt,
  tavt: rt,
  takr: rt,
  tibt: rt,
  tfng: rt,
  tirh: rt,
  latn: _i,
  DFLT: _i
};
function CH(e) {
  Array.isArray(e) || (e = [
    e
  ]);
  for (let A of e) {
    let t = hH[A];
    if (t) return t;
  }
  return _i;
}
class EH extends eg {
  applyLookup(A, t) {
    switch (A) {
      case 1: {
        let n = this.coverageIndex(t.coverage);
        if (n === -1) return !1;
        let i = this.glyphIterator.cur;
        switch (t.version) {
          case 1:
            i.id = i.id + t.deltaGlyphID & 65535;
            break;
          case 2:
            i.id = t.substitute.get(n);
            break;
        }
        return !0;
      }
      case 2: {
        let n = this.coverageIndex(t.coverage);
        if (n !== -1) {
          let i = t.sequences.get(n);
          if (i.length === 0)
            return this.glyphs.splice(this.glyphIterator.index, 1), !0;
          this.glyphIterator.cur.id = i[0], this.glyphIterator.cur.ligatureComponent = 0;
          let a = this.glyphIterator.cur.features, o = this.glyphIterator.cur, s = i.slice(1).map((l, u) => {
            let g = new qn(this.font, l, void 0, a);
            return g.shaperInfo = o.shaperInfo, g.isLigated = o.isLigated, g.ligatureComponent = u + 1, g.substituted = !0, g.isMultiplied = !0, g;
          });
          return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...s), !0;
        }
        return !1;
      }
      case 3: {
        let n = this.coverageIndex(t.coverage);
        if (n !== -1) {
          let i = 0;
          return this.glyphIterator.cur.id = t.alternateSet.get(n)[i], !0;
        }
        return !1;
      }
      case 4: {
        let n = this.coverageIndex(t.coverage);
        if (n === -1) return !1;
        for (let i of t.ligatureSets.get(n)) {
          let a = this.sequenceMatchIndices(1, i.components);
          if (!a) continue;
          let o = this.glyphIterator.cur, s = o.codePoints.slice();
          for (let E of a) s.push(...this.glyphs[E].codePoints);
          let l = new qn(this.font, i.glyph, s, o.features);
          l.shaperInfo = o.shaperInfo, l.isLigated = !0, l.substituted = !0;
          let u = o.isMark;
          for (let E = 0; E < a.length && u; E++) u = this.glyphs[a[E]].isMark;
          l.ligatureID = u ? null : this.ligatureID++;
          let g = o.ligatureID, d = o.codePoints.length, h = d, C = this.glyphIterator.index + 1;
          for (let E of a) {
            if (u) C = E;
            else for (; C < E; ) {
              var r = h - d + Math.min(this.glyphs[C].ligatureComponent || 1, d);
              this.glyphs[C].ligatureID = l.ligatureID, this.glyphs[C].ligatureComponent = r, C++;
            }
            g = this.glyphs[C].ligatureID, d = this.glyphs[C].codePoints.length, h += d, C++;
          }
          if (g && !u) for (let E = C; E < this.glyphs.length && this.glyphs[E].ligatureID === g; E++) {
            var r = h - d + Math.min(this.glyphs[E].ligatureComponent || 1, d);
            this.glyphs[E].ligatureComponent = r;
          }
          for (let E = a.length - 1; E >= 0; E--) this.glyphs.splice(a[E], 1);
          return this.glyphs[this.glyphIterator.index] = l, !0;
        }
        return !1;
      }
      case 5:
        return this.applyContext(t);
      case 6:
        return this.applyChainingContext(t);
      case 7:
        return this.applyLookup(t.lookupType, t.extension);
      default:
        throw new Error(`GSUB lookupType ${A} is not supported`);
    }
  }
}
class QH extends eg {
  applyPositionValue(A, t) {
    let r = this.positions[this.glyphIterator.peekIndex(A)];
    t.xAdvance != null && (r.xAdvance += t.xAdvance), t.yAdvance != null && (r.yAdvance += t.yAdvance), t.xPlacement != null && (r.xOffset += t.xPlacement), t.yPlacement != null && (r.yOffset += t.yPlacement);
    let n = this.font._variationProcessor, i = this.font.GDEF && this.font.GDEF.itemVariationStore;
    n && i && (t.xPlaDevice && (r.xOffset += n.getDelta(i, t.xPlaDevice.a, t.xPlaDevice.b)), t.yPlaDevice && (r.yOffset += n.getDelta(i, t.yPlaDevice.a, t.yPlaDevice.b)), t.xAdvDevice && (r.xAdvance += n.getDelta(i, t.xAdvDevice.a, t.xAdvDevice.b)), t.yAdvDevice && (r.yAdvance += n.getDelta(i, t.yAdvDevice.a, t.yAdvDevice.b)));
  }
  applyLookup(A, t) {
    switch (A) {
      case 1: {
        let n = this.coverageIndex(t.coverage);
        if (n === -1) return !1;
        switch (t.version) {
          case 1:
            this.applyPositionValue(0, t.value);
            break;
          case 2:
            this.applyPositionValue(0, t.values.get(n));
            break;
        }
        return !0;
      }
      case 2: {
        let n = this.glyphIterator.peek();
        if (!n) return !1;
        let i = this.coverageIndex(t.coverage);
        if (i === -1) return !1;
        switch (t.version) {
          case 1:
            let a = t.pairSets.get(i);
            for (let l of a) if (l.secondGlyph === n.id)
              return this.applyPositionValue(0, l.value1), this.applyPositionValue(1, l.value2), !0;
            return !1;
          case 2:
            let o = this.getClassID(this.glyphIterator.cur.id, t.classDef1), s = this.getClassID(n.id, t.classDef2);
            if (o === -1 || s === -1) return !1;
            var r = t.classRecords.get(o).get(s);
            return this.applyPositionValue(0, r.value1), this.applyPositionValue(1, r.value2), !0;
        }
      }
      case 3: {
        let n = this.glyphIterator.peekIndex(), i = this.glyphs[n];
        if (!i) return !1;
        let a = t.entryExitRecords[this.coverageIndex(t.coverage)];
        if (!a || !a.exitAnchor) return !1;
        let o = t.entryExitRecords[this.coverageIndex(t.coverage, i.id)];
        if (!o || !o.entryAnchor) return !1;
        let s = this.getAnchor(o.entryAnchor), l = this.getAnchor(a.exitAnchor), u = this.positions[this.glyphIterator.index], g = this.positions[n], d;
        switch (this.direction) {
          case "ltr":
            u.xAdvance = l.x + u.xOffset, d = s.x + g.xOffset, g.xAdvance -= d, g.xOffset -= d;
            break;
          case "rtl":
            d = l.x + u.xOffset, u.xAdvance -= d, u.xOffset -= d, g.xAdvance = s.x + g.xOffset;
            break;
        }
        return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = n, u.yOffset = s.y - l.y) : (i.cursiveAttachment = this.glyphIterator.index, u.yOffset = l.y - s.y), !0;
      }
      case 4: {
        let n = this.coverageIndex(t.markCoverage);
        if (n === -1) return !1;
        let i = this.glyphIterator.index;
        for (; --i >= 0 && (this.glyphs[i].isMark || this.glyphs[i].ligatureComponent > 0); ) ;
        if (i < 0) return !1;
        let a = this.coverageIndex(t.baseCoverage, this.glyphs[i].id);
        if (a === -1) return !1;
        let o = t.markArray[n], s = t.baseArray[a][o.class];
        return this.applyAnchor(o, s, i), !0;
      }
      case 5: {
        let n = this.coverageIndex(t.markCoverage);
        if (n === -1) return !1;
        let i = this.glyphIterator.index;
        for (; --i >= 0 && this.glyphs[i].isMark; ) ;
        if (i < 0) return !1;
        let a = this.coverageIndex(t.ligatureCoverage, this.glyphs[i].id);
        if (a === -1) return !1;
        let o = t.ligatureArray[a], s = this.glyphIterator.cur, l = this.glyphs[i], u = l.ligatureID && l.ligatureID === s.ligatureID && s.ligatureComponent > 0 ? Math.min(s.ligatureComponent, l.codePoints.length) - 1 : l.codePoints.length - 1, g = t.markArray[n], d = o[u][g.class];
        return this.applyAnchor(g, d, i), !0;
      }
      case 6: {
        let n = this.coverageIndex(t.mark1Coverage);
        if (n === -1) return !1;
        let i = this.glyphIterator.peekIndex(-1), a = this.glyphs[i];
        if (!a || !a.isMark) return !1;
        let o = this.glyphIterator.cur, s = !1;
        if (o.ligatureID === a.ligatureID ? o.ligatureID ? o.ligatureComponent === a.ligatureComponent && (s = !0) : s = !0 : (o.ligatureID && !o.ligatureComponent || a.ligatureID && !a.ligatureComponent) && (s = !0), !s) return !1;
        let l = this.coverageIndex(t.mark2Coverage, a.id);
        if (l === -1) return !1;
        let u = t.mark1Array[n], g = t.mark2Array[l][u.class];
        return this.applyAnchor(u, g, i), !0;
      }
      case 7:
        return this.applyContext(t);
      case 8:
        return this.applyChainingContext(t);
      case 9:
        return this.applyLookup(t.lookupType, t.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${A}`);
    }
  }
  applyAnchor(A, t, r) {
    let n = this.getAnchor(t), i = this.getAnchor(A.markAnchor);
    this.positions[r];
    let a = this.positions[this.glyphIterator.index];
    a.xOffset = n.x - i.x, a.yOffset = n.y - i.y, this.glyphIterator.cur.markAttachment = r;
  }
  getAnchor(A) {
    let t = A.xCoordinate, r = A.yCoordinate, n = this.font._variationProcessor, i = this.font.GDEF && this.font.GDEF.itemVariationStore;
    return n && i && (A.xDeviceTable && (t += n.getDelta(i, A.xDeviceTable.a, A.xDeviceTable.b)), A.yDeviceTable && (r += n.getDelta(i, A.yDeviceTable.a, A.yDeviceTable.b))), {
      x: t,
      y: r
    };
  }
  applyFeatures(A, t, r) {
    super.applyFeatures(A, t, r);
    for (var n = 0; n < this.glyphs.length; n++) this.fixCursiveAttachment(n);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(A) {
    let t = this.glyphs[A];
    if (t.cursiveAttachment != null) {
      let r = t.cursiveAttachment;
      t.cursiveAttachment = null, this.fixCursiveAttachment(r), this.positions[A].yOffset += this.positions[r].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let A = 0; A < this.glyphs.length; A++) {
      let t = this.glyphs[A];
      if (t.markAttachment != null) {
        let r = t.markAttachment;
        if (this.positions[A].xOffset += this.positions[r].xOffset, this.positions[A].yOffset += this.positions[r].yOffset, this.direction === "ltr") for (let n = r; n < A; n++)
          this.positions[A].xOffset -= this.positions[n].xAdvance, this.positions[A].yOffset -= this.positions[n].yAdvance;
        else for (let n = r + 1; n < A + 1; n++)
          this.positions[A].xOffset += this.positions[n].xAdvance, this.positions[A].yOffset += this.positions[n].yAdvance;
      }
    }
  }
}
class wH {
  setup(A) {
    this.glyphInfos = A.glyphs.map((r) => new qn(this.font, r.id, [
      ...r.codePoints
    ]));
    let t = null;
    this.GPOSProcessor && (t = this.GPOSProcessor.selectScript(A.script, A.language, A.direction)), this.GSUBProcessor && (t = this.GSUBProcessor.selectScript(A.script, A.language, A.direction)), this.shaper = CH(t), this.plan = new wY(this.font, t, A.direction), this.shaper.plan(this.plan, this.glyphInfos, A.features);
    for (let r in this.plan.allFeatures) A.features[r] = !0;
  }
  substitute(A) {
    this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), A.glyphs = this.glyphInfos.map((t) => this.font.getGlyph(t.id, t.codePoints)));
  }
  position(A) {
    return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(A.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, A.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(A.positions), A.direction === "rtl" && (A.glyphs.reverse(), A.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(A) {
    for (let t = 0; t < this.glyphInfos.length; t++) this.glyphInfos[t].isMark && (A[t].xAdvance = 0, A[t].yAdvance = 0);
  }
  cleanup() {
    this.glyphInfos = null, this.plan = null, this.shaper = null;
  }
  getAvailableFeatures(A, t) {
    let r = [];
    return this.GSUBProcessor && (this.GSUBProcessor.selectScript(A, t), r.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(A, t), r.push(...Object.keys(this.GPOSProcessor.features))), r;
  }
  constructor(A) {
    this.font = A, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, A.GSUB && (this.GSUBProcessor = new EH(A, A.GSUB)), A.GPOS && (this.GPOSProcessor = new QH(A, A.GPOS));
  }
}
class IH {
  layout(A, t, r, n, i) {
    if (typeof t == "string" && (i = n, n = r, r = t, t = []), typeof A == "string") {
      r == null && (r = _U(A));
      var a = this.font.glyphsForString(A);
    } else {
      if (r == null) {
        let l = [];
        for (let u of A) l.push(...u.codePoints);
        r = XU(l);
      }
      var a = A;
    }
    let o = new $U(a, t, r, n, i);
    return a.length === 0 ? (o.positions = [], o) : (this.engine && this.engine.setup && this.engine.setup(o), this.substitute(o), this.position(o), this.hideDefaultIgnorables(o.glyphs, o.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), o);
  }
  substitute(A) {
    this.engine && this.engine.substitute && this.engine.substitute(A);
  }
  position(A) {
    A.positions = A.glyphs.map((r) => new AY(r.advanceWidth));
    let t = null;
    this.engine && this.engine.position && (t = this.engine.position(A)), !t && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new ZU(this.font)), this.unicodeLayoutEngine.positionGlyphs(A.glyphs, A.positions)), (!t || !t.kern) && A.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new WU(this.font)), this.kernProcessor.process(A.glyphs, A.positions), A.features.kern = !0);
  }
  hideDefaultIgnorables(A, t) {
    let r = this.font.glyphForCodePoint(32);
    for (let n = 0; n < A.length; n++) this.isDefaultIgnorable(A[n].codePoints[0]) && (A[n] = r, t[n].xAdvance = 0, t[n].yAdvance = 0);
  }
  isDefaultIgnorable(A) {
    let t = A >> 16;
    if (t === 0)
      switch (A >> 8) {
        case 0:
          return A === 173;
        case 3:
          return A === 847;
        case 6:
          return A === 1564;
        case 23:
          return 6068 <= A && A <= 6069;
        case 24:
          return 6155 <= A && A <= 6158;
        case 32:
          return 8203 <= A && A <= 8207 || 8234 <= A && A <= 8238 || 8288 <= A && A <= 8303;
        case 254:
          return 65024 <= A && A <= 65039 || A === 65279;
        case 255:
          return 65520 <= A && A <= 65528;
        default:
          return !1;
      }
    else
      switch (t) {
        case 1:
          return 113824 <= A && A <= 113827 || 119155 <= A && A <= 119162;
        case 14:
          return 917504 <= A && A <= 921599;
        default:
          return !1;
      }
  }
  getAvailableFeatures(A, t) {
    let r = [];
    return this.engine && r.push(...this.engine.getAvailableFeatures(A, t)), this.font.kern && r.indexOf("kern") === -1 && r.push("kern"), r;
  }
  stringsForGlyph(A) {
    let t = /* @__PURE__ */ new Set(), r = this.font._cmapProcessor.codePointsForGlyph(A);
    for (let n of r) t.add(String.fromCodePoint(n));
    if (this.engine && this.engine.stringsForGlyph) for (let n of this.engine.stringsForGlyph(A)) t.add(n);
    return Array.from(t);
  }
  constructor(A) {
    this.font = A, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new QY(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new wH(this.font));
  }
}
const DH = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
class ls {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (A) => {
      this.commands.forEach((t) => A[t.command].apply(A, t.args));
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    return this.commands.map((t) => {
      let r = t.args.map((n) => Math.round(n * 100) / 100);
      return `${DH[t.command]}${r.join(" ")}`;
    }).join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let A = new Ki();
      for (let t of this.commands) for (let r = 0; r < t.args.length; r += 2) A.addPoint(t.args[r], t.args[r + 1]);
      this._cbox = Object.freeze(A);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox) return this._bbox;
    let A = new Ki(), t = 0, r = 0, n = (y) => Math.pow(1 - y, 3) * h[b] + 3 * Math.pow(1 - y, 2) * y * C[b] + 3 * (1 - y) * Math.pow(y, 2) * E[b] + Math.pow(y, 3) * I[b];
    for (let y of this.commands) switch (y.command) {
      case "moveTo":
      case "lineTo":
        let [p, Q] = y.args;
        A.addPoint(p, Q), t = p, r = Q;
        break;
      case "quadraticCurveTo":
      case "bezierCurveTo":
        if (y.command === "quadraticCurveTo")
          var [i, a, g, d] = y.args, o = t + 2 / 3 * (i - t), s = r + 2 / 3 * (a - r), l = g + 2 / 3 * (i - g), u = d + 2 / 3 * (a - d);
        else var [o, s, l, u, g, d] = y.args;
        A.addPoint(g, d);
        for (var h = [
          t,
          r
        ], C = [
          o,
          s
        ], E = [
          l,
          u
        ], I = [
          g,
          d
        ], b = 0; b <= 1; b++) {
          let w = 6 * h[b] - 12 * C[b] + 6 * E[b], Y = -3 * h[b] + 9 * C[b] - 9 * E[b] + 3 * I[b];
          if (y = 3 * C[b] - 3 * h[b], Y === 0) {
            if (w === 0) continue;
            let P = -y / w;
            0 < P && P < 1 && (b === 0 ? A.addPoint(n(P), A.maxY) : b === 1 && A.addPoint(A.maxX, n(P)));
            continue;
          }
          let k = Math.pow(w, 2) - 4 * y * Y;
          if (k < 0) continue;
          let L = (-w + Math.sqrt(k)) / (2 * Y);
          0 < L && L < 1 && (b === 0 ? A.addPoint(n(L), A.maxY) : b === 1 && A.addPoint(A.maxX, n(L)));
          let S = (-w - Math.sqrt(k)) / (2 * Y);
          0 < S && S < 1 && (b === 0 ? A.addPoint(n(S), A.maxY) : b === 1 && A.addPoint(A.maxX, n(S)));
        }
        t = g, r = d;
        break;
    }
    return this._bbox = Object.freeze(A);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(A) {
    let t = new ls();
    for (let r of this.commands) {
      let n = [];
      for (let i = 0; i < r.args.length; i += 2) {
        let [a, o] = A(r.args[i], r.args[i + 1]);
        n.push(a, o);
      }
      t[r.command](...n);
    }
    return t;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(A, t, r, n, i, a) {
    return this.mapPoints((o, s) => {
      const l = A * o + r * s + i, u = t * o + n * s + a;
      return [
        l,
        u
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(A, t) {
    return this.transform(1, 0, 0, 1, A, t);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(A) {
    let t = Math.cos(A), r = Math.sin(A);
    return this.transform(t, r, -r, t, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(A, t = A) {
    return this.transform(A, 0, 0, t, 0, 0);
  }
  constructor() {
    this.commands = [], this._bbox = null, this._cbox = null;
  }
}
for (let e of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
]) ls.prototype[e] = function(...A) {
  return this._bbox = this._cbox = null, this.commands.push({
    command: e,
    args: A
  }), this;
};
var js = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
class G0 {
  _getPath() {
    return new ls();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(A) {
    if (this.id < A.metrics.length) return A.metrics.get(this.id);
    let t = A.metrics.get(A.metrics.length - 1);
    return {
      advance: t ? t.advance : 0,
      bearing: A.bearings.get(this.id - A.metrics.length) || 0
    };
  }
  _getMetrics(A) {
    if (this._metrics) return this._metrics;
    let { advance: t, bearing: r } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx) var { advance: n, bearing: i } = this._getTableMetrics(this._font.vmtx);
    else {
      let a;
      if ((typeof A > "u" || A === null) && ({ cbox: A } = this), (a = this._font["OS/2"]) && a.version > 0)
        var n = Math.abs(a.typoAscender - a.typoDescender), i = a.typoAscender - A.maxY;
      else {
        let { hhea: o } = this._font;
        var n = Math.abs(o.ascent - o.descent), i = o.ascent - A.maxY;
      }
    }
    return this._font._variationProcessor && this._font.HVAR && (t += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
      advanceWidth: t,
      advanceHeight: n,
      leftBearing: r,
      topBearing: i
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(A) {
    let t = 1 / this._font.unitsPerEm * A;
    return this.path.scale(t);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post: A } = this._font;
    if (!A) return null;
    switch (A.version) {
      case 1:
        return js[this.id];
      case 2:
        let t = A.glyphNameIndex[this.id];
        return t < js.length ? js[t] : A.names[t - js.length];
      case 2.5:
        return js[this.id + A.offsets[this.id]];
      case 4:
        return String.fromCharCode(A.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(A, t) {
    A.save();
    let r = 1 / this._font.head.unitsPerEm * t;
    A.scale(r, r), this.path.toFunction()(A), A.fill(), A.restore();
  }
  constructor(A, t, r) {
    this.id = A, this.codePoints = t, this._font = r, this.isMark = this.codePoints.length > 0 && this.codePoints.every(DC), this.isLigature = this.codePoints.length > 1;
  }
}
pr([
  vr
], G0.prototype, "cbox", null);
pr([
  vr
], G0.prototype, "bbox", null);
pr([
  vr
], G0.prototype, "path", null);
pr([
  vr
], G0.prototype, "advanceWidth", null);
pr([
  vr
], G0.prototype, "advanceHeight", null);
pr([
  vr
], G0.prototype, "name", null);
let Ow = new QA({
  numberOfContours: zA,
  xMin: zA,
  yMin: zA,
  xMax: zA,
  yMax: zA
});
const mH = 1, MH = 2, pH = 4, vH = 8, yH = 16, bH = 32, FH = 1, LH = 8, Jw = 32, RH = 64, GH = 128, xH = 256;
class zn {
  copy() {
    return new zn(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(A, t, r = 0, n = 0) {
    this.onCurve = A, this.endContour = t, this.x = r, this.y = n;
  }
}
class kH {
  constructor(A, t, r) {
    this.glyphID = A, this.dx = t, this.dy = r, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
  }
}
class Vg extends G0 {
  // Parses just the glyph header and returns the bounding box
  _getCBox(A) {
    if (this._font._variationProcessor && !A) return this.path.cbox;
    let t = this._font._getTableStream("glyf");
    t.pos += this._font.loca.offsets[this.id];
    let r = Ow.decode(t), n = new Ki(r.xMin, r.yMin, r.xMax, r.yMax);
    return Object.freeze(n);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(A, t, r, n) {
    if (r) {
      var i = A.readUInt8();
      n || (i = -i), i += t;
    } else if (n) var i = t;
    else var i = t + A.readInt16BE();
    return i;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let A = this._font.loca.offsets[this.id], t = this._font.loca.offsets[this.id + 1];
    if (A === t) return null;
    let r = this._font._getTableStream("glyf");
    r.pos += A;
    let n = r.pos, i = Ow.decode(r);
    return i.numberOfContours > 0 ? this._decodeSimple(i, r) : i.numberOfContours < 0 && this._decodeComposite(i, r, n), i;
  }
  _decodeSimple(A, t) {
    A.points = [];
    let r = new uA(v, A.numberOfContours).decode(t);
    A.instructions = new uA(Ae, v).decode(t);
    let n = [], i = r[r.length - 1] + 1;
    for (; n.length < i; ) {
      var a = t.readUInt8();
      if (n.push(a), a & vH) {
        let u = t.readUInt8();
        for (let g = 0; g < u; g++) n.push(a);
      }
    }
    for (var o = 0; o < n.length; o++) {
      var a = n[o];
      let g = new zn(!!(a & mH), r.indexOf(o) >= 0, 0, 0);
      A.points.push(g);
    }
    let s = 0;
    for (var o = 0; o < n.length; o++) {
      var a = n[o];
      A.points[o].x = s = this._parseGlyphCoord(t, s, a & MH, a & yH);
    }
    let l = 0;
    for (var o = 0; o < n.length; o++) {
      var a = n[o];
      A.points[o].y = l = this._parseGlyphCoord(t, l, a & pH, a & bH);
    }
    if (this._font._variationProcessor) {
      let u = A.points.slice();
      u.push(...this._getPhantomPoints(A)), this._font._variationProcessor.transformPoints(this.id, u), A.phantomPoints = u.slice(-4);
    }
  }
  _decodeComposite(A, t, r = 0) {
    A.components = [];
    let n = !1, i = Jw;
    for (; i & Jw; ) {
      i = t.readUInt16BE();
      let l = t.pos - r, u = t.readUInt16BE();
      if (n || (n = (i & xH) !== 0), i & FH)
        var a = t.readInt16BE(), o = t.readInt16BE();
      else
        var a = t.readInt8(), o = t.readInt8();
      var s = new kH(u, a, o);
      s.pos = l, i & LH ? s.scaleX = s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824 : i & RH ? (s.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824) : i & GH && (s.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scale01 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scale10 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824), A.components.push(s);
    }
    if (this._font._variationProcessor) {
      let l = [];
      for (let u = 0; u < A.components.length; u++) {
        var s = A.components[u];
        l.push(new zn(!0, !0, s.dx, s.dy));
      }
      l.push(...this._getPhantomPoints(A)), this._font._variationProcessor.transformPoints(this.id, l), A.phantomPoints = l.splice(-4, 4);
      for (let u = 0; u < l.length; u++) {
        let g = l[u];
        A.components[u].dx = g.x, A.components[u].dy = g.y;
      }
    }
    return n;
  }
  _getPhantomPoints(A) {
    let t = this._getCBox(!0);
    this._metrics == null && (this._metrics = G0.prototype._getMetrics.call(this, t));
    let { advanceWidth: r, advanceHeight: n, leftBearing: i, topBearing: a } = this._metrics;
    return [
      new zn(!1, !0, A.xMin - i, 0),
      new zn(!1, !0, A.xMin - i + r, 0),
      new zn(!1, !0, 0, A.yMax + a),
      new zn(!1, !0, 0, A.yMax + a + n)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let A = this._decode();
    if (!A) return [];
    let t = [];
    if (A.numberOfContours < 0)
      for (let a of A.components) {
        let o = this._font.getGlyph(a.glyphID)._getContours();
        for (let s = 0; s < o.length; s++) {
          let l = o[s];
          for (let u = 0; u < l.length; u++) {
            let g = l[u], d = g.x * a.scaleX + g.y * a.scale01 + a.dx, h = g.y * a.scaleY + g.x * a.scale10 + a.dy;
            t.push(new zn(g.onCurve, g.endContour, d, h));
          }
        }
      }
    else t = A.points || [];
    A.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = A.phantomPoints[1].x - A.phantomPoints[0].x, this._metrics.advanceHeight = A.phantomPoints[3].y - A.phantomPoints[2].y, this._metrics.leftBearing = A.xMin - A.phantomPoints[0].x, this._metrics.topBearing = A.phantomPoints[2].y - A.yMax);
    let r = [], n = [];
    for (let a = 0; a < t.length; a++) {
      var i = t[a];
      n.push(i), i.endContour && (r.push(n), n = []);
    }
    return r;
  }
  _getMetrics() {
    if (this._metrics) return this._metrics;
    let A = this._getCBox(!0);
    return super._getMetrics(A), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let A = this._getContours(), t = new ls();
    for (let n = 0; n < A.length; n++) {
      let i = A[n], a = i[0], o = i[i.length - 1], s = 0;
      if (a.onCurve) {
        var r = null;
        s = 1;
      } else {
        o.onCurve ? a = o : a = new zn(!1, !1, (a.x + o.x) / 2, (a.y + o.y) / 2);
        var r = a;
      }
      t.moveTo(a.x, a.y);
      for (let l = s; l < i.length; l++) {
        let u = i[l], g = l === 0 ? a : i[l - 1];
        if (g.onCurve && u.onCurve) t.lineTo(u.x, u.y);
        else if (g.onCurve && !u.onCurve) var r = u;
        else if (!g.onCurve && !u.onCurve) {
          let h = (g.x + u.x) / 2, C = (g.y + u.y) / 2;
          t.quadraticCurveTo(g.x, g.y, h, C);
          var r = u;
        } else if (!g.onCurve && u.onCurve) {
          t.quadraticCurveTo(r.x, r.y, u.x, u.y);
          var r = null;
        } else throw new Error("Unknown TTF path state");
      }
      r && t.quadraticCurveTo(r.x, r.y, a.x, a.y), t.closePath();
    }
    return t;
  }
  constructor(...A) {
    super(...A), rn(this, "type", "TTF");
  }
}
class UH extends G0 {
  _getName() {
    return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
  }
  bias(A) {
    return A.length < 1240 ? 107 : A.length < 33900 ? 1131 : 32768;
  }
  _getPath() {
    let A = this._font.CFF2 || this._font["CFF "], { stream: t } = A, r = A.topDict.CharStrings[this.id], n = r.offset + r.length;
    t.pos = r.offset;
    let i = new ls(), a = [], o = [], s = null, l = 0, u = 0, g = 0, d, h, C = !1;
    this._usedGsubrs = d = {}, this._usedSubrs = h = {};
    let E = A.globalSubrIndex || [], I = this.bias(E), b = A.privateDictForGlyph(this.id) || {}, y = b.Subrs || [], p = this.bias(y), Q = A.topDict.vstore && A.topDict.vstore.itemVariationStore, w = b.vsindex, Y = this._font._variationProcessor;
    function k() {
      s == null && (s = a.shift() + b.nominalWidthX);
    }
    function L() {
      return a.length % 2 !== 0 && k(), l += a.length >> 1, a.length = 0;
    }
    function S(Z, M) {
      C && i.closePath(), i.moveTo(Z, M), C = !0;
    }
    let P = function() {
      for (; t.pos < n; ) {
        let R = t.readUInt8();
        if (R < 32) {
          let G, N, z, T, O, K, AA, X, iA, oA, fA, wA, DA, HA, sA, lA;
          switch (R) {
            case 1:
            case 3:
            case 18:
            case 23:
              L();
              break;
            case 4:
              a.length > 1 && k(), g += a.shift(), S(u, g);
              break;
            case 5:
              for (; a.length >= 2; )
                u += a.shift(), g += a.shift(), i.lineTo(u, g);
              break;
            case 6:
            case 7:
              for (z = R === 6; a.length >= 1; )
                z ? u += a.shift() : g += a.shift(), i.lineTo(u, g), z = !z;
              break;
            case 8:
              for (; a.length > 0; )
                T = u + a.shift(), O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), u = K + a.shift(), g = AA + a.shift(), i.bezierCurveTo(T, O, K, AA, u, g);
              break;
            case 10:
              if (G = a.pop() + p, N = y[G], N) {
                h[G] = !0;
                let tA = t.pos, nA = n;
                t.pos = N.offset, n = N.offset + N.length, P(), t.pos = tA, n = nA;
              }
              break;
            case 11:
              if (A.version >= 2) break;
              return;
            case 14:
              if (A.version >= 2) break;
              a.length > 0 && k(), C && (i.closePath(), C = !1);
              break;
            case 15:
              if (A.version < 2) throw new Error("vsindex operator not supported in CFF v1");
              w = a.pop();
              break;
            case 16: {
              if (A.version < 2) throw new Error("blend operator not supported in CFF v1");
              if (!Y) throw new Error("blend operator in non-variation font");
              let tA = Y.getBlendVector(Q, w), nA = a.pop(), GA = nA * tA.length, ZA = a.length - GA, de = ZA - nA;
              for (let _A = 0; _A < nA; _A++) {
                let Ce = a[de + _A];
                for (let WA = 0; WA < tA.length; WA++) Ce += tA[WA] * a[ZA++];
                a[de + _A] = Ce;
              }
              for (; GA--; ) a.pop();
              break;
            }
            case 19:
            case 20:
              L(), t.pos += l + 7 >> 3;
              break;
            case 21:
              a.length > 2 && k(), u += a.shift(), g += a.shift(), S(u, g);
              break;
            case 22:
              a.length > 1 && k(), u += a.shift(), S(u, g);
              break;
            case 24:
              for (; a.length >= 8; )
                T = u + a.shift(), O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), u = K + a.shift(), g = AA + a.shift(), i.bezierCurveTo(T, O, K, AA, u, g);
              u += a.shift(), g += a.shift(), i.lineTo(u, g);
              break;
            case 25:
              for (; a.length >= 8; )
                u += a.shift(), g += a.shift(), i.lineTo(u, g);
              T = u + a.shift(), O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), u = K + a.shift(), g = AA + a.shift(), i.bezierCurveTo(T, O, K, AA, u, g);
              break;
            case 26:
              for (a.length % 2 && (u += a.shift()); a.length >= 4; )
                T = u, O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), u = K, g = AA + a.shift(), i.bezierCurveTo(T, O, K, AA, u, g);
              break;
            case 27:
              for (a.length % 2 && (g += a.shift()); a.length >= 4; )
                T = u + a.shift(), O = g, K = T + a.shift(), AA = O + a.shift(), u = K + a.shift(), g = AA, i.bezierCurveTo(T, O, K, AA, u, g);
              break;
            case 28:
              a.push(t.readInt16BE());
              break;
            case 29:
              if (G = a.pop() + I, N = E[G], N) {
                d[G] = !0;
                let tA = t.pos, nA = n;
                t.pos = N.offset, n = N.offset + N.length, P(), t.pos = tA, n = nA;
              }
              break;
            case 30:
            case 31:
              for (z = R === 31; a.length >= 4; )
                z ? (T = u + a.shift(), O = g, K = T + a.shift(), AA = O + a.shift(), g = AA + a.shift(), u = K + (a.length === 1 ? a.shift() : 0)) : (T = u, O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), u = K + a.shift(), g = AA + (a.length === 1 ? a.shift() : 0)), i.bezierCurveTo(T, O, K, AA, u, g), z = !z;
              break;
            case 12:
              switch (R = t.readUInt8(), R) {
                case 3:
                  let tA = a.pop(), nA = a.pop();
                  a.push(tA && nA ? 1 : 0);
                  break;
                case 4:
                  tA = a.pop(), nA = a.pop(), a.push(tA || nA ? 1 : 0);
                  break;
                case 5:
                  tA = a.pop(), a.push(tA ? 0 : 1);
                  break;
                case 9:
                  tA = a.pop(), a.push(Math.abs(tA));
                  break;
                case 10:
                  tA = a.pop(), nA = a.pop(), a.push(tA + nA);
                  break;
                case 11:
                  tA = a.pop(), nA = a.pop(), a.push(tA - nA);
                  break;
                case 12:
                  tA = a.pop(), nA = a.pop(), a.push(tA / nA);
                  break;
                case 14:
                  tA = a.pop(), a.push(-tA);
                  break;
                case 15:
                  tA = a.pop(), nA = a.pop(), a.push(tA === nA ? 1 : 0);
                  break;
                case 18:
                  a.pop();
                  break;
                case 20:
                  let GA = a.pop(), ZA = a.pop();
                  o[ZA] = GA;
                  break;
                case 21:
                  ZA = a.pop(), a.push(o[ZA] || 0);
                  break;
                case 22:
                  let de = a.pop(), _A = a.pop(), Ce = a.pop(), WA = a.pop();
                  a.push(Ce <= WA ? de : _A);
                  break;
                case 23:
                  a.push(Math.random());
                  break;
                case 24:
                  tA = a.pop(), nA = a.pop(), a.push(tA * nA);
                  break;
                case 26:
                  tA = a.pop(), a.push(Math.sqrt(tA));
                  break;
                case 27:
                  tA = a.pop(), a.push(tA, tA);
                  break;
                case 28:
                  tA = a.pop(), nA = a.pop(), a.push(nA, tA);
                  break;
                case 29:
                  ZA = a.pop(), ZA < 0 ? ZA = 0 : ZA > a.length - 1 && (ZA = a.length - 1), a.push(a[ZA]);
                  break;
                case 30:
                  let gA = a.pop(), ie = a.pop();
                  if (ie >= 0) for (; ie > 0; ) {
                    var Z = a[gA - 1];
                    for (let we = gA - 2; we >= 0; we--) a[we + 1] = a[we];
                    a[0] = Z, ie--;
                  }
                  else for (; ie < 0; ) {
                    var Z = a[0];
                    for (let se = 0; se <= gA; se++) a[se] = a[se + 1];
                    a[gA - 1] = Z, ie++;
                  }
                  break;
                case 34:
                  T = u + a.shift(), O = g, K = T + a.shift(), AA = O + a.shift(), X = K + a.shift(), iA = AA, oA = X + a.shift(), fA = iA, wA = oA + a.shift(), DA = fA, HA = wA + a.shift(), sA = DA, u = HA, g = sA, i.bezierCurveTo(T, O, K, AA, X, iA), i.bezierCurveTo(oA, fA, wA, DA, HA, sA);
                  break;
                case 35:
                  lA = [];
                  for (let we = 0; we <= 5; we++)
                    u += a.shift(), g += a.shift(), lA.push(u, g);
                  i.bezierCurveTo(...lA.slice(0, 6)), i.bezierCurveTo(...lA.slice(6)), a.shift();
                  break;
                case 36:
                  T = u + a.shift(), O = g + a.shift(), K = T + a.shift(), AA = O + a.shift(), X = K + a.shift(), iA = AA, oA = X + a.shift(), fA = iA, wA = oA + a.shift(), DA = fA + a.shift(), HA = wA + a.shift(), sA = DA, u = HA, g = sA, i.bezierCurveTo(T, O, K, AA, X, iA), i.bezierCurveTo(oA, fA, wA, DA, HA, sA);
                  break;
                case 37:
                  let Qe = u, OA = g;
                  lA = [];
                  for (let we = 0; we <= 4; we++)
                    u += a.shift(), g += a.shift(), lA.push(u, g);
                  Math.abs(u - Qe) > Math.abs(g - OA) ? (u += a.shift(), g = OA) : (u = Qe, g += a.shift()), lA.push(u, g), i.bezierCurveTo(...lA.slice(0, 6)), i.bezierCurveTo(...lA.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${R}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${R}`);
          }
        } else if (R < 247) a.push(R - 139);
        else if (R < 251) {
          var M = t.readUInt8();
          a.push((R - 247) * 256 + M + 108);
        } else if (R < 255) {
          var M = t.readUInt8();
          a.push(-(R - 251) * 256 - M - 108);
        } else a.push(t.readInt32BE() / 65536);
      }
    };
    return P(), C && i.closePath(), i;
  }
  constructor(...A) {
    super(...A), rn(this, "type", "CFF");
  }
}
let YH = new QA({
  originX: v,
  originY: v,
  type: new Dt(4),
  data: new mr((e) => e.parent.buflen - e._currentOffset)
});
class HH extends Vg {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(A) {
    for (let a = 0; a < this._font.sbix.imageTables.length; a++) {
      var t = this._font.sbix.imageTables[a];
      if (t.ppem >= A) break;
    }
    let r = t.imageOffsets, n = r[this.id], i = r[this.id + 1];
    return n === i ? null : (this._font.stream.pos = n, YH.decode(this._font.stream, {
      buflen: i - n
    }));
  }
  render(A, t) {
    let r = this.getImageForSize(t);
    if (r != null) {
      let n = t / this._font.unitsPerEm;
      A.image(r.data, {
        height: t,
        x: r.originX,
        y: (this.bbox.minY - r.originY) * n
      });
    }
    this._font.sbix.flags.renderOutlines && super.render(A, t);
  }
  constructor(...A) {
    super(...A), rn(this, "type", "SBIX");
  }
}
class Ww {
  constructor(A, t) {
    this.glyph = A, this.color = t;
  }
}
class SH extends G0 {
  _getBBox() {
    let A = new Ki();
    for (let t = 0; t < this.layers.length; t++) {
      let n = this.layers[t].glyph.bbox;
      A.addPoint(n.minX, n.minY), A.addPoint(n.maxX, n.maxY);
    }
    return A;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let A = this._font.CPAL, t = this._font.COLR, r = 0, n = t.baseGlyphRecord.length - 1;
    for (; r <= n; ) {
      let u = r + n >> 1;
      var i = t.baseGlyphRecord[u];
      if (this.id < i.gid) n = u - 1;
      else if (this.id > i.gid) r = u + 1;
      else {
        var a = i;
        break;
      }
    }
    if (a == null) {
      var o = this._font._getBaseGlyph(this.id), s = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new Ww(o, s)
      ];
    }
    let l = [];
    for (let u = a.firstLayerIndex; u < a.firstLayerIndex + a.numLayers; u++) {
      var i = t.layerRecords[u], s = A.colorRecords[i.paletteIndex], o = this._font._getBaseGlyph(i.gid);
      l.push(new Ww(o, s));
    }
    return l;
  }
  render(A, t) {
    for (let { glyph: r, color: n } of this.layers)
      A.fillColor([
        n.red,
        n.green,
        n.blue
      ], n.alpha / 255 * 100), r.render(A, t);
  }
  constructor(...A) {
    super(...A), rn(this, "type", "COLR");
  }
}
const NH = 32768, TH = 4095, PH = 32768, Zw = 16384, zH = 8192, Kw = 4095, _w = 128, Xw = 127, jH = 128, VH = 64, OH = 63;
class JH {
  normalizeCoords(A) {
    let t = [];
    for (var r = 0; r < this.font.fvar.axis.length; r++) {
      let n = this.font.fvar.axis[r];
      A[r] < n.defaultValue ? t.push((A[r] - n.defaultValue + Number.EPSILON) / (n.defaultValue - n.minValue + Number.EPSILON)) : t.push((A[r] - n.defaultValue + Number.EPSILON) / (n.maxValue - n.defaultValue + Number.EPSILON));
    }
    if (this.font.avar) for (var r = 0; r < this.font.avar.segment.length; r++) {
      let i = this.font.avar.segment[r];
      for (let a = 0; a < i.correspondence.length; a++) {
        let o = i.correspondence[a];
        if (a >= 1 && t[r] < o.fromCoord) {
          let s = i.correspondence[a - 1];
          t[r] = ((t[r] - s.fromCoord) * (o.toCoord - s.toCoord) + Number.EPSILON) / (o.fromCoord - s.fromCoord + Number.EPSILON) + s.toCoord;
          break;
        }
      }
    }
    return t;
  }
  transformPoints(A, t) {
    if (!this.font.fvar || !this.font.gvar) return;
    let { gvar: r } = this.font;
    if (A >= r.glyphCount) return;
    let n = r.offsets[A];
    if (n === r.offsets[A + 1]) return;
    let { stream: i } = this.font;
    if (i.pos = n, i.pos >= i.length) return;
    let a = i.readUInt16BE(), o = n + i.readUInt16BE();
    if (a & NH) {
      var s = i.pos;
      i.pos = o;
      var l = this.decodePoints();
      o = i.pos, i.pos = s;
    }
    let u = t.map((I) => I.copy());
    a &= TH;
    for (let I = 0; I < a; I++) {
      let b = i.readUInt16BE(), y = i.readUInt16BE();
      if (y & PH) {
        var g = [];
        for (let L = 0; L < r.axisCount; L++) g.push(i.readInt16BE() / 16384);
      } else {
        if ((y & Kw) >= r.globalCoordCount) throw new Error("Invalid gvar table");
        var g = r.globalCoords[y & Kw];
      }
      if (y & Zw) {
        var d = [];
        for (let L = 0; L < r.axisCount; L++) d.push(i.readInt16BE() / 16384);
        var h = [];
        for (let L = 0; L < r.axisCount; L++) h.push(i.readInt16BE() / 16384);
      }
      let p = this.tupleFactor(y, g, d, h);
      if (p === 0) {
        o += b;
        continue;
      }
      var s = i.pos;
      if (i.pos = o, y & zH) var C = this.decodePoints();
      else var C = l;
      let w = C.length === 0 ? t.length : C.length, Y = this.decodeDeltas(w), k = this.decodeDeltas(w);
      if (C.length === 0) for (let L = 0; L < t.length; L++) {
        var E = t[L];
        E.x += Math.round(Y[L] * p), E.y += Math.round(k[L] * p);
      }
      else {
        let L = u.map((P) => P.copy()), S = t.map(() => !1);
        for (let P = 0; P < C.length; P++) {
          let Z = C[P];
          if (Z < t.length) {
            let M = L[Z];
            S[Z] = !0, M.x += Y[P] * p, M.y += k[P] * p;
          }
        }
        this.interpolateMissingDeltas(L, u, S);
        for (let P = 0; P < t.length; P++) {
          let Z = L[P].x - u[P].x, M = L[P].y - u[P].y;
          t[P].x = Math.round(t[P].x + Z), t[P].y = Math.round(t[P].y + M);
        }
      }
      o += b, i.pos = s;
    }
  }
  decodePoints() {
    let A = this.font.stream, t = A.readUInt8();
    t & _w && (t = (t & Xw) << 8 | A.readUInt8());
    let r = new Uint16Array(t), n = 0, i = 0;
    for (; n < t; ) {
      let a = A.readUInt8(), o = (a & Xw) + 1, s = a & _w ? A.readUInt16 : A.readUInt8;
      for (let l = 0; l < o && n < t; l++)
        i += s.call(A), r[n++] = i;
    }
    return r;
  }
  decodeDeltas(A) {
    let t = this.font.stream, r = 0, n = new Int16Array(A);
    for (; r < A; ) {
      let i = t.readUInt8(), a = (i & OH) + 1;
      if (i & jH) r += a;
      else {
        let o = i & VH ? t.readInt16BE : t.readInt8;
        for (let s = 0; s < a && r < A; s++) n[r++] = o.call(t);
      }
    }
    return n;
  }
  tupleFactor(A, t, r, n) {
    let i = this.normalizedCoords, { gvar: a } = this.font, o = 1;
    for (let s = 0; s < a.axisCount; s++)
      if (t[s] !== 0) {
        if (i[s] === 0) return 0;
        if (A & Zw) {
          if (i[s] < r[s] || i[s] > n[s]) return 0;
          i[s] < t[s] ? o = o * (i[s] - r[s] + Number.EPSILON) / (t[s] - r[s] + Number.EPSILON) : o = o * (n[s] - i[s] + Number.EPSILON) / (n[s] - t[s] + Number.EPSILON);
        } else {
          if (i[s] < Math.min(0, t[s]) || i[s] > Math.max(0, t[s])) return 0;
          o = (o * i[s] + Number.EPSILON) / (t[s] + Number.EPSILON);
        }
      }
    return o;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(A, t, r) {
    if (A.length === 0) return;
    let n = 0;
    for (; n < A.length; ) {
      let i = n, a = n, o = A[a];
      for (; !o.endContour; ) o = A[++a];
      for (; n <= a && !r[n]; ) n++;
      if (n > a) continue;
      let s = n, l = n;
      for (n++; n <= a; )
        r[n] && (this.deltaInterpolate(l + 1, n - 1, l, n, t, A), l = n), n++;
      l === s ? this.deltaShift(i, a, l, t, A) : (this.deltaInterpolate(l + 1, a, l, s, t, A), s > 0 && this.deltaInterpolate(i, s - 1, l, s, t, A)), n = a + 1;
    }
  }
  deltaInterpolate(A, t, r, n, i, a) {
    if (A > t) return;
    let o = [
      "x",
      "y"
    ];
    for (let l = 0; l < o.length; l++) {
      let u = o[l];
      if (i[r][u] > i[n][u]) {
        var s = r;
        r = n, n = s;
      }
      let g = i[r][u], d = i[n][u], h = a[r][u], C = a[n][u];
      if (g !== d || h === C) {
        let E = g === d ? 0 : (C - h) / (d - g);
        for (let I = A; I <= t; I++) {
          let b = i[I][u];
          b <= g ? b += h - g : b >= d ? b += C - d : b = h + (b - g) * E, a[I][u] = b;
        }
      }
    }
  }
  deltaShift(A, t, r, n, i) {
    let a = i[r].x - n[r].x, o = i[r].y - n[r].y;
    if (!(a === 0 && o === 0))
      for (let s = A; s <= t; s++) s !== r && (i[s].x += a, i[s].y += o);
  }
  getAdvanceAdjustment(A, t) {
    let r, n;
    if (t.advanceWidthMapping) {
      let i = A;
      i >= t.advanceWidthMapping.mapCount && (i = t.advanceWidthMapping.mapCount - 1), t.advanceWidthMapping.entryFormat, { outerIndex: r, innerIndex: n } = t.advanceWidthMapping.mapData[i];
    } else
      r = 0, n = A;
    return this.getDelta(t.itemVariationStore, r, n);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(A, t, r) {
    if (t >= A.itemVariationData.length) return 0;
    let n = A.itemVariationData[t];
    if (r >= n.deltaSets.length) return 0;
    let i = n.deltaSets[r], a = this.getBlendVector(A, t), o = 0;
    for (let s = 0; s < n.regionIndexCount; s++) o += i.deltas[s] * a[s];
    return o;
  }
  getBlendVector(A, t) {
    let r = A.itemVariationData[t];
    if (this.blendVectors.has(r)) return this.blendVectors.get(r);
    let n = this.normalizedCoords, i = [];
    for (let a = 0; a < r.regionIndexCount; a++) {
      let o = 1, s = r.regionIndexes[a], l = A.variationRegionList.variationRegions[s];
      for (let u = 0; u < l.length; u++) {
        let g = l[u], d;
        g.startCoord > g.peakCoord || g.peakCoord > g.endCoord || g.startCoord < 0 && g.endCoord > 0 && g.peakCoord !== 0 || g.peakCoord === 0 ? d = 1 : n[u] < g.startCoord || n[u] > g.endCoord ? d = 0 : n[u] === g.peakCoord ? d = 1 : n[u] < g.peakCoord ? d = (n[u] - g.startCoord + Number.EPSILON) / (g.peakCoord - g.startCoord + Number.EPSILON) : d = (g.endCoord - n[u] + Number.EPSILON) / (g.endCoord - g.peakCoord + Number.EPSILON), o *= d;
      }
      i[a] = o;
    }
    return this.blendVectors.set(r, i), i;
  }
  constructor(A, t) {
    this.font = A, this.normalizedCoords = this.normalizeCoords(t), this.blendVectors = /* @__PURE__ */ new Map();
  }
}
Promise.resolve();
class fm {
  includeGlyph(A) {
    return typeof A == "object" && (A = A.id), this.mapping[A] == null && (this.glyphs.push(A), this.mapping[A] = this.glyphs.length - 1), this.mapping[A];
  }
  constructor(A) {
    this.font = A, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
  }
}
const WH = 1, ZH = 2, KH = 4, _H = 8, XH = 16, qH = 32;
class qw {
  static size(A) {
    return A >= 0 && A <= 255 ? 1 : 2;
  }
  static encode(A, t) {
    t >= 0 && t <= 255 ? A.writeUInt8(t) : A.writeInt16BE(t);
  }
}
let $w = new QA({
  numberOfContours: zA,
  xMin: zA,
  yMin: zA,
  xMax: zA,
  yMax: zA,
  endPtsOfContours: new uA(v, "numberOfContours"),
  instructions: new uA(Ae, v),
  flags: new uA(Ae, 0),
  xPoints: new uA(qw, 0),
  yPoints: new uA(qw, 0)
});
class $H {
  encodeSimple(A, t = []) {
    let r = [], n = [], i = [], a = [], o = 0, s = 0, l = 0, u = 0, g = 0;
    for (let b = 0; b < A.commands.length; b++) {
      let y = A.commands[b];
      for (let p = 0; p < y.args.length; p += 2) {
        let Q = y.args[p], w = y.args[p + 1], Y = 0;
        if (y.command === "quadraticCurveTo" && p === 2) {
          let k = A.commands[b + 1];
          if (k && k.command === "quadraticCurveTo") {
            let L = (s + k.args[0]) / 2, S = (l + k.args[1]) / 2;
            if (Q === L && w === S) continue;
          }
        }
        y.command === "quadraticCurveTo" && p === 0 || (Y |= WH), Y = this._encodePoint(Q, s, n, Y, ZH, XH), Y = this._encodePoint(w, l, i, Y, KH, qH), Y === u && o < 255 ? (a[a.length - 1] |= _H, o++) : (o > 0 && (a.push(o), o = 0), a.push(Y), u = Y), s = Q, l = w, g++;
      }
      y.command === "closePath" && r.push(g - 1);
    }
    A.commands.length > 1 && A.commands[A.commands.length - 1].command !== "closePath" && r.push(g - 1);
    let d = A.bbox, h = {
      numberOfContours: r.length,
      xMin: d.minX,
      yMin: d.minY,
      xMax: d.maxX,
      yMax: d.maxY,
      endPtsOfContours: r,
      instructions: t,
      flags: a,
      xPoints: n,
      yPoints: i
    }, C = $w.size(h), E = 4 - C % 4, I = new Zc(C + E);
    return $w.encode(I, h), E !== 0 && I.fill(0, E), I.buffer;
  }
  _encodePoint(A, t, r, n, i, a) {
    let o = A - t;
    return A === t ? n |= a : (-255 <= o && o <= 255 && (n |= i, o < 0 ? o = -o : n |= a), r.push(o)), n;
  }
}
class AS extends fm {
  _addGlyph(A) {
    let t = this.font.getGlyph(A), r = t._decode(), n = this.font.loca.offsets[A], i = this.font.loca.offsets[A + 1], a = this.font._getTableStream("glyf");
    a.pos += n;
    let o = a.readBuffer(i - n);
    if (r && r.numberOfContours < 0) {
      o = new Uint8Array(o);
      let s = new DataView(o.buffer);
      for (let l of r.components)
        A = this.includeGlyph(l.glyphID), s.setUint16(l.pos, A);
    } else r && this.font._variationProcessor && (o = this.glyphEncoder.encodeSimple(t.path, r.instructions));
    return this.glyf.push(o), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
      advance: t.advanceWidth,
      bearing: t._getMetrics().leftBearing
    }), this.offset += o.length, this.glyf.length - 1;
  }
  encode() {
    this.glyf = [], this.offset = 0, this.loca = {
      offsets: [],
      version: this.font.loca.version
    }, this.hmtx = {
      metrics: [],
      bearings: []
    };
    let A = 0;
    for (; A < this.glyphs.length; ) this._addGlyph(this.glyphs[A++]);
    let t = Qf(this.font.maxp);
    t.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
    let r = Qf(this.font.head);
    r.indexToLocFormat = this.loca.version;
    let n = Qf(this.font.hhea);
    return n.numberOfMetrics = this.hmtx.metrics.length, rm.toBuffer({
      tables: {
        head: r,
        hhea: n,
        loca: this.loca,
        maxp: t,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(A) {
    super(A), this.glyphEncoder = new $H();
  }
}
class eS extends fm {
  subsetCharstrings() {
    this.charstrings = [];
    let A = {};
    for (let t of this.glyphs) {
      this.charstrings.push(this.cff.getCharString(t));
      let r = this.font.getGlyph(t);
      r.path;
      for (let n in r._usedGsubrs) A[n] = !0;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, A);
  }
  subsetSubrs(A, t) {
    let r = [];
    for (let n = 0; n < A.length; n++) {
      let i = A[n];
      t[n] ? (this.cff.stream.pos = i.offset, r.push(this.cff.stream.readBuffer(i.length))) : r.push(new Uint8Array([
        11
      ]));
    }
    return r;
  }
  subsetFontdict(A) {
    A.FDArray = [], A.FDSelect = {
      version: 0,
      fds: []
    };
    let t = {}, r = [], n = {};
    for (let i of this.glyphs) {
      let a = this.cff.fdForGlyph(i);
      if (a == null) continue;
      t[a] || (A.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[a])), r.push({}), n[a] = A.FDArray.length - 1), t[a] = !0, A.FDSelect.fds.push(n[a]);
      let o = this.font.getGlyph(i);
      o.path;
      for (let s in o._usedSubrs) r[n[a]][s] = !0;
    }
    for (let i = 0; i < A.FDArray.length; i++) {
      let a = A.FDArray[i];
      delete a.FontName, a.Private && a.Private.Subrs && (a.Private = Object.assign({}, a.Private), a.Private.Subrs = this.subsetSubrs(a.Private.Subrs, r[i]));
    }
  }
  createCIDFontdict(A) {
    let t = {};
    for (let n of this.glyphs) {
      let i = this.font.getGlyph(n);
      i.path;
      for (let a in i._usedSubrs) t[a] = !0;
    }
    let r = Object.assign({}, this.cff.topDict.Private);
    return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (r.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, t)), A.FDArray = [
      {
        Private: r
      }
    ], A.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(A) {
    return A ? (this.strings || (this.strings = []), this.strings.push(A), hc.length + this.strings.length - 1) : null;
  }
  encode() {
    this.subsetCharstrings();
    let A = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    }, t = Object.assign({}, this.cff.topDict);
    t.Private = null, t.charset = A, t.Encoding = null, t.CharStrings = this.charstrings;
    for (let n of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ]) t[n] = this.addString(this.cff.string(t[n]));
    t.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ], t.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(t) : this.createCIDFontdict(t);
    let r = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        t
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return q4.toBuffer(r);
  }
  constructor(A) {
    if (super(A), this.cff = this.font["CFF "], !this.cff) throw new Error("Not a CFF Font");
  }
}
class Rr {
  static probe(A) {
    let t = Tg.decode(A.slice(0, 4));
    return t === "true" || t === "OTTO" || t === "\0\0\0";
  }
  setDefaultLanguage(A = null) {
    this.defaultLanguage = A;
  }
  _getTable(A) {
    if (!(A.tag in this._tables)) try {
      this._tables[A.tag] = this._decodeTable(A);
    } catch {
    }
    return this._tables[A.tag];
  }
  _getTableStream(A) {
    let t = this.directory.tables[A];
    return t ? (this.stream.pos = t.offset, this.stream) : null;
  }
  _decodeDirectory() {
    return this.directory = rm.decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(A) {
    let t = this.stream.pos, r = this._getTableStream(A.tag), n = $c[A.tag].decode(r, this, A.length);
    return this.stream.pos = t, n;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(A, t = this.defaultLanguage || _c) {
    let r = this.name && this.name.records[A];
    return r && (r[t] || r[this.defaultLanguage] || r[_c] || r.en || r[Object.keys(r)[0]]) || null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let A = this["OS/2"];
    return A ? A.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let A = this["OS/2"];
    return A ? A.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new Ki(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new yC(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(A) {
    return !!this._cmapProcessor.lookup(A);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(A) {
    return this.getGlyph(this._cmapProcessor.lookup(A), [
      A
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(A) {
    let t = [], r = A.length, n = 0, i = -1, a = -1;
    for (; n <= r; ) {
      let o = 0, s = 0;
      if (n < r) {
        if (o = A.charCodeAt(n++), 55296 <= o && o <= 56319 && n < r) {
          let l = A.charCodeAt(n);
          56320 <= l && l <= 57343 && (n++, o = ((o & 1023) << 10) + (l & 1023) + 65536);
        }
        s = 65024 <= o && o <= 65039 || 917760 <= o && o <= 917999 ? 1 : 0;
      } else n++;
      a === 0 && s === 1 ? t.push(this.getGlyph(this._cmapProcessor.lookup(i, o), [
        i,
        o
      ])) : a === 0 && s === 0 && t.push(this.glyphForCodePoint(i)), i = o, a = s;
    }
    return t;
  }
  get _layoutEngine() {
    return new IH(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(A, t, r, n, i) {
    return this._layoutEngine.layout(A, t, r, n, i);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(A) {
    return this._layoutEngine.stringsForGlyph(A);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(A, t) {
    return this._layoutEngine.getAvailableFeatures(A, t);
  }
  _getBaseGlyph(A, t = []) {
    return this._glyphs[A] || (this.directory.tables.glyf ? this._glyphs[A] = new Vg(A, t, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[A] = new UH(A, t, this))), this._glyphs[A] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(A, t = []) {
    return this._glyphs[A] || (this.directory.tables.sbix ? this._glyphs[A] = new HH(A, t, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[A] = new SH(A, t, this) : this._getBaseGlyph(A, t)), this._glyphs[A] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    return this.directory.tables["CFF "] ? new eS(this) : new AS(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let A = {};
    if (!this.fvar) return A;
    for (let t of this.fvar.axis) A[t.axisTag.trim()] = {
      name: t.name.en,
      min: t.minValue,
      default: t.defaultValue,
      max: t.maxValue
    };
    return A;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let A = {};
    if (!this.fvar) return A;
    for (let t of this.fvar.instance) {
      let r = {};
      for (let n = 0; n < this.fvar.axis.length; n++) {
        let i = this.fvar.axis[n];
        r[i.axisTag.trim()] = t.coord[n];
      }
      A[t.name.en] = r;
    }
    return A;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(A) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof A == "string" && (A = this.namedVariations[A]), typeof A != "object") throw new Error("Variation settings must be either a variation name or settings object.");
    let t = this.fvar.axis.map((i, a) => {
      let o = i.axisTag.trim();
      return o in A ? Math.max(i.minValue, Math.min(i.maxValue, A[o])) : i.defaultValue;
    }), r = new Dr(this.stream.buffer);
    r.pos = this._directoryPos;
    let n = new Rr(r, t);
    return n._tables = this._tables, n;
  }
  get _variationProcessor() {
    if (!this.fvar) return null;
    let A = this.variationCoords;
    return !A && !this.CFF2 ? null : (A || (A = this.fvar.axis.map((t) => t.defaultValue)), new JH(this, A));
  }
  // Standardized format plugin API
  getFont(A) {
    return this.getVariation(A);
  }
  constructor(A, t = null) {
    rn(this, "type", "TTF"), this.defaultLanguage = null, this.stream = A, this.variationCoords = t, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
    for (let r in this.directory.tables) {
      let n = this.directory.tables[r];
      $c[r] && n.length > 0 && Object.defineProperty(this, r, {
        get: this._getTable.bind(this, n)
      });
    }
  }
}
pr([
  vr
], Rr.prototype, "bbox", null);
pr([
  vr
], Rr.prototype, "_cmapProcessor", null);
pr([
  vr
], Rr.prototype, "characterSet", null);
pr([
  vr
], Rr.prototype, "_layoutEngine", null);
pr([
  vr
], Rr.prototype, "variationAxes", null);
pr([
  vr
], Rr.prototype, "namedVariations", null);
pr([
  vr
], Rr.prototype, "_variationProcessor", null);
let tS = new QA({
  tag: new Dt(4),
  offset: new cA(BA, "void", {
    type: "global"
  }),
  compLength: BA,
  length: BA,
  origChecksum: BA
}), dm = new QA({
  tag: new Dt(4),
  flavor: BA,
  length: BA,
  numTables: v,
  reserved: new Nt(v),
  totalSfntSize: BA,
  majorVersion: v,
  minorVersion: v,
  metaOffset: BA,
  metaLength: BA,
  metaOrigLength: BA,
  privOffset: BA,
  privLength: BA,
  tables: new uA(tS, "numTables")
});
dm.process = function() {
  let e = {};
  for (let A of this.tables) e[A.tag] = A;
  this.tables = e;
};
var rS = dm;
class nS extends Rr {
  static probe(A) {
    return Tg.decode(A.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = rS.decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(A) {
    let t = this.directory.tables[A];
    if (t)
      if (this.stream.pos = t.offset, t.compLength < t.length) {
        this.stream.pos += 2;
        let r = new Uint8Array(t.length), n = MG(this.stream.readBuffer(t.compLength - 2), r);
        return new Dr(n);
      } else return this.stream;
    return null;
  }
  constructor(...A) {
    super(...A), rn(this, "type", "WOFF");
  }
}
class iS extends Vg {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...A) {
    super(...A), rn(this, "type", "WOFF2");
  }
}
const AI = {
  decode(e) {
    let A = 0, t = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let r = 0; r < t.length; r++) {
      let n = e.readUInt8();
      if (A & 3758096384) throw new Error("Overflow");
      if (A = A << 7 | n & 127, !(n & 128)) return A;
    }
    throw new Error("Bad base 128 number");
  }
};
let aS = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
], oS = new QA({
  flags: Ae,
  customTag: new Kc(new Dt(4), (e) => (e.flags & 63) === 63),
  tag: (e) => e.customTag || aS[e.flags & 63],
  length: AI,
  transformVersion: (e) => e.flags >>> 6 & 3,
  transformed: (e) => e.tag === "glyf" || e.tag === "loca" ? e.transformVersion === 0 : e.transformVersion !== 0,
  transformLength: new Kc(AI, (e) => e.transformed)
}), hm = new QA({
  tag: new Dt(4),
  flavor: BA,
  length: BA,
  numTables: v,
  reserved: new Nt(v),
  totalSfntSize: BA,
  totalCompressedSize: BA,
  majorVersion: v,
  minorVersion: v,
  metaOffset: BA,
  metaLength: BA,
  metaOrigLength: BA,
  privOffset: BA,
  privLength: BA,
  tables: new uA(oS, "numTables")
});
hm.process = function() {
  let e = {};
  for (let A = 0; A < this.tables.length; A++) {
    let t = this.tables[A];
    e[t.tag] = t;
  }
  return this.tables = e;
};
var sS = hm;
class lS extends Rr {
  static probe(A) {
    return Tg.decode(A.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = sS.decode(this.stream), this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let A = this.stream.readBuffer(this.directory.totalCompressedSize), t = 0;
      for (let n in this.directory.tables) {
        let i = this.directory.tables[n];
        i.offset = t, t += i.transformLength != null ? i.transformLength : i.length;
      }
      let r = xG(A, t);
      if (!r) throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new Dr(r), this._decompressed = !0;
    }
  }
  _decodeTable(A) {
    return this._decompress(), super._decodeTable(A);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(A, t = []) {
    if (!this._glyphs[A])
      return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[A] = new iS(A, t, this)) : super._getBaseGlyph(A, t);
  }
  _transformGlyfTable() {
    this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
    let A = uS.decode(this.stream), t = [];
    for (let n = 0; n < A.numGlyphs; n++) {
      let i = {}, a = A.nContours.readInt16BE();
      if (i.numberOfContours = a, a > 0) {
        let o = [], s = 0;
        for (let l = 0; l < a; l++) {
          let u = xf(A.nPoints);
          s += u, o.push(s);
        }
        i.points = fS(A.flags, A.glyphs, s);
        for (let l = 0; l < a; l++) i.points[o[l] - 1].endContour = !0;
        var r = xf(A.glyphs);
      } else if (a < 0 && Vg.prototype._decodeComposite.call({
        _font: this
      }, i, A.composites))
        var r = xf(A.glyphs);
      t.push(i);
    }
    this._transformedGlyphs = t;
  }
  constructor(...A) {
    super(...A), rn(this, "type", "WOFF2");
  }
}
class Qa {
  decode(A, t) {
    return new Dr(this._buf.decode(A, t));
  }
  constructor(A) {
    this.length = A, this._buf = new mr(A);
  }
}
let uS = new QA({
  version: BA,
  numGlyphs: v,
  indexFormat: v,
  nContourStreamSize: BA,
  nPointsStreamSize: BA,
  flagStreamSize: BA,
  glyphStreamSize: BA,
  compositeStreamSize: BA,
  bboxStreamSize: BA,
  instructionStreamSize: BA,
  nContours: new Qa("nContourStreamSize"),
  nPoints: new Qa("nPointsStreamSize"),
  flags: new Qa("flagStreamSize"),
  glyphs: new Qa("glyphStreamSize"),
  composites: new Qa("compositeStreamSize"),
  bboxes: new Qa("bboxStreamSize"),
  instructions: new Qa("instructionStreamSize")
});
const cS = 253, gS = 254, BS = 255, eI = 253;
function xf(e) {
  let A = e.readUInt8();
  return A === cS ? e.readUInt16BE() : A === BS ? e.readUInt8() + eI : A === gS ? e.readUInt8() + eI * 2 : A;
}
function d0(e, A) {
  return e & 1 ? A : -A;
}
function fS(e, A, t) {
  let r, n = r = 0, i = [];
  for (let s = 0; s < t; s++) {
    let l = 0, u = 0, g = e.readUInt8(), d = !(g >> 7);
    if (g &= 127, g < 10)
      l = 0, u = d0(g, ((g & 14) << 7) + A.readUInt8());
    else if (g < 20)
      l = d0(g, ((g - 10 & 14) << 7) + A.readUInt8()), u = 0;
    else if (g < 84) {
      var a = g - 20, o = A.readUInt8();
      l = d0(g, 1 + (a & 48) + (o >> 4)), u = d0(g >> 1, 1 + ((a & 12) << 2) + (o & 15));
    } else if (g < 120) {
      var a = g - 84;
      l = d0(g, 1 + (a / 12 << 8) + A.readUInt8()), u = d0(g >> 1, 1 + (a % 12 >> 2 << 8) + A.readUInt8());
    } else if (g < 124) {
      var o = A.readUInt8();
      let C = A.readUInt8();
      l = d0(g, (o << 4) + (C >> 4)), u = d0(g >> 1, ((C & 15) << 8) + A.readUInt8());
    } else
      l = d0(g, A.readUInt16BE()), u = d0(g >> 1, A.readUInt16BE());
    n += l, r += u, i.push(new zn(d, !1, n, r));
  }
  return i;
}
let dS = new $e(BA, {
  65536: {
    numFonts: BA,
    offsets: new uA(BA, "numFonts")
  },
  131072: {
    numFonts: BA,
    offsets: new uA(BA, "numFonts"),
    dsigTag: BA,
    dsigLength: BA,
    dsigOffset: BA
  }
});
class hS {
  static probe(A) {
    return Tg.decode(A.slice(0, 4)) === "ttcf";
  }
  getFont(A) {
    for (let t of this.header.offsets) {
      let r = new Dr(this.stream.buffer);
      r.pos = t;
      let n = new Rr(r);
      if (n.postscriptName === A || n.postscriptName instanceof Uint8Array && A instanceof Uint8Array && n.postscriptName.every((i, a) => A[a] === i)) return n;
    }
    return null;
  }
  get fonts() {
    let A = [];
    for (let t of this.header.offsets) {
      let r = new Dr(this.stream.buffer);
      r.pos = t, A.push(new Rr(r));
    }
    return A;
  }
  constructor(A) {
    if (rn(this, "type", "TTC"), this.stream = A, A.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
    this.header = dS.decode(A);
  }
}
let CS = new Dt(Ae);
new QA({
  len: BA,
  buf: new mr("len")
});
let ES = new QA({
  id: v,
  nameOffset: zA,
  attr: Ae,
  dataOffset: Ti,
  handle: BA
}), QS = new QA({
  name: new Dt(4),
  maxTypeIndex: v,
  refList: new cA(v, new uA(ES, (e) => e.maxTypeIndex + 1), {
    type: "parent"
  })
}), wS = new QA({
  length: v,
  types: new uA(QS, (e) => e.length + 1)
}), IS = new QA({
  reserved: new Nt(Ae, 24),
  typeList: new cA(v, wS),
  nameListOffset: new cA(v, "void")
}), tI = new QA({
  dataOffset: BA,
  map: new cA(BA, IS),
  dataLength: BA,
  mapLength: BA
});
class DS {
  static probe(A) {
    let t = new Dr(A);
    try {
      var r = tI.decode(t);
    } catch {
      return !1;
    }
    for (let n of r.map.typeList.types)
      if (n.name === "sfnt") return !0;
    return !1;
  }
  getFont(A) {
    if (!this.sfnt) return null;
    for (let t of this.sfnt.refList) {
      let r = this.header.dataOffset + t.dataOffset + 4, n = new Dr(this.stream.buffer.slice(r)), i = new Rr(n);
      if (i.postscriptName === A || i.postscriptName instanceof Uint8Array && A instanceof Uint8Array && i.postscriptName.every((a, o) => A[o] === a)) return i;
    }
    return null;
  }
  get fonts() {
    let A = [];
    for (let t of this.sfnt.refList) {
      let r = this.header.dataOffset + t.dataOffset + 4, n = new Dr(this.stream.buffer.slice(r));
      A.push(new Rr(n));
    }
    return A;
  }
  constructor(A) {
    rn(this, "type", "DFont"), this.stream = A, this.header = tI.decode(this.stream);
    for (let t of this.header.map.typeList.types) {
      for (let r of t.refList) r.nameOffset >= 0 ? (this.stream.pos = r.nameOffset + this.header.map.nameListOffset, r.name = CS.decode(this.stream)) : r.name = null;
      t.name === "sfnt" && (this.sfnt = t);
    }
  }
}
ss(Rr);
ss(nS);
ss(lS);
ss(hS);
ss(DS);
const mS = {
  thin: 100,
  hairline: 100,
  ultralight: 200,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  demibold: 600,
  bold: 700,
  ultrabold: 800,
  extrabold: 800,
  heavy: 900,
  black: 900
}, MS = async (e, A) => {
  const r = await (await y4(e, A)).arrayBuffer();
  return new Uint8Array(r);
}, pS = (e) => {
  const A = e.split(",")[0], t = A.substring(0, 5) === "data:", r = A.split(";")[1] === "base64";
  return t && r;
}, vS = (e) => typeof e == "string" ? mS[e] : e, rI = (e, A) => e.fontWeight - A.fontWeight;
class yS {
  constructor(A, t, r, n, i) {
    this.src = A, this.fontFamily = t, this.fontStyle = r || "normal", this.fontWeight = n || 400, this.data = null, this.options = i, this.loadResultPromise = null;
  }
  async _load() {
    const {
      postscriptName: A
    } = this.options;
    if (pS(this.src)) {
      const t = this.src.split(",")[1], r = new Uint8Array(atob(t).split("").map((n) => n.charCodeAt(0)));
      this.data = gl(r, A);
    } else {
      const {
        headers: t,
        body: r,
        method: n = "GET"
      } = this.options, i = await MS(this.src, {
        method: n,
        body: r,
        headers: t
      });
      this.data = gl(i, A);
    }
  }
  async load() {
    return this.loadResultPromise === null && (this.loadResultPromise = this._load()), this.loadResultPromise;
  }
}
let bS = class Cm {
  static create(A) {
    return new Cm(A);
  }
  constructor(A) {
    this.family = A, this.sources = [];
  }
  register(A) {
    let {
      src: t,
      fontWeight: r,
      fontStyle: n,
      ...i
    } = A;
    const a = vS(r);
    this.sources.push(new yS(t, this.family, n, a, i));
  }
  resolve(A) {
    const {
      fontWeight: t = 400,
      fontStyle: r = "normal"
    } = A, n = this.sources.filter((l) => l.fontStyle === r), i = n.find((l) => l.fontWeight === t);
    if (i) return i;
    let a;
    if (t >= 400 && t <= 500) {
      const l = n.filter((d) => d.fontWeight <= t), u = n.filter((d) => d.fontWeight > 500);
      a = n.filter((d) => d.fontWeight >= t && d.fontWeight < 500)[0] || l[l.length - 1] || u[0];
    }
    const o = n.filter((l) => l.fontWeight < t).sort(rI), s = n.filter((l) => l.fontWeight > t).sort(rI);
    if (t < 400 && (a = o[o.length - 1] || s[0]), t > 500 && (a = s[0] || o[o.length - 1]), !a)
      throw new Error("Could not resolve font for " + this.family + ", fontWeight " + t);
    return a;
  }
};
var nI = ["Courier", "Courier-Bold", "Courier-Oblique", "Courier-BoldOblique", "Helvetica", "Helvetica-Bold", "Helvetica-Oblique", "Helvetica-BoldOblique", "Times-Roman", "Times-Bold", "Times-Italic", "Times-BoldItalic"];
function FS() {
  let e = {}, A = null, t = null;
  this.register = (r) => {
    const {
      family: n
    } = r;
    if (e[n] || (e[n] = bS.create(n)), r.fonts)
      for (let i = 0; i < r.fonts.length; i += 1)
        e[n].register({
          family: n,
          ...r.fonts[i]
        });
    else
      e[n].register(r);
  }, this.registerEmojiSource = (r) => {
    let {
      url: n,
      format: i = "png",
      builder: a,
      withVariationSelectors: o = !1
    } = r;
    A = {
      url: n,
      format: i,
      builder: a,
      withVariationSelectors: o
    };
  }, this.registerHyphenationCallback = (r) => {
    t = r;
  }, this.getFont = (r) => {
    const {
      fontFamily: n
    } = r;
    if (nI.includes(n)) return null;
    if (!e[n])
      throw new Error("Font family not registered: " + n + ". Please register it calling Font.register() method.");
    return e[n].resolve(r);
  }, this.load = async (r) => {
    const {
      fontFamily: n
    } = r, i = typeof n == "string" ? [n] : [...n || []], a = [];
    for (let o = i.length, s = 0; s < o; s += 1) {
      const l = i[s];
      if (nI.includes(l)) return;
      const g = this.getFont({
        ...r,
        fontFamily: l
      });
      a.push(g.load());
    }
    await Promise.all(a);
  }, this.reset = () => {
    const r = Object.keys(e);
    for (let n = 0; n < r.length; n += 1) {
      const i = r[n];
      e[i].data = null;
    }
  }, this.clear = () => {
    e = {};
  }, this.getRegisteredFonts = () => e, this.getEmojiSource = () => A, this.getHyphenationCallback = () => t, this.getRegisteredFontFamilies = () => Object.keys(e);
}
var LS = function(A, t, r) {
  var n;
  if (Math.abs(A) > r.length) return r;
  var i = r.length + A;
  return Object.assign([], r, (n = {}, n[i] = t(r[i]), n));
}, Em = function(A) {
  return Array.prototype.slice.call(A, 0).reverse();
}, RS = function() {
  for (var A = arguments.length, t = new Array(A), r = 0; r < A; r++)
    t[r] = arguments[r];
  return /* @__PURE__ */ function() {
    var n = Ui(/* @__PURE__ */ wr().mark(function i(a) {
      var o, s, l, u, g, d, h, C = arguments;
      return wr().wrap(function(I) {
        for (; ; ) switch (I.prev = I.next) {
          case 0:
            for (o = a, s = Em(t), l = C.length, u = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
              u[g - 1] = C[g];
            d = 0;
          case 4:
            if (!(d < s.length)) {
              I.next = 12;
              break;
            }
            return h = s[d], I.next = 8, h.apply(void 0, [o].concat(u));
          case 8:
            o = I.sent;
          case 9:
            d += 1, I.next = 4;
            break;
          case 12:
            return I.abrupt("return", o);
          case 13:
          case "end":
            return I.stop();
        }
      }, i);
    }));
    return function(i) {
      return n.apply(this, arguments);
    };
  }();
}, GS = function(A) {
  return A && A.replace(/(^|\s)\S/g, function(t) {
    return t.toUpperCase();
  });
}, Og = function(A) {
  return Array.isArray(A) ? A : [A];
}, en = function() {
  for (var A = arguments.length, t = new Array(A), r = 0; r < A; r++)
    t[r] = arguments[r];
  return function(n) {
    for (var i = n, a = Em(t), o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
      s[l - 1] = arguments[l];
    for (var u = 0; u < a.length; u += 1) {
      var g = a[u];
      i = g.apply(void 0, [i].concat(s));
    }
    return i;
  };
}, xS = function(A) {
  return A.slice(0, A.length - 1);
}, Jg = function e(A, t) {
  for (var r = t instanceof Array ? [] : {}, n = Object.keys(t), i = 0; i < n.length; i += 1) {
    var a = n[i], o = A[a], s = typeof o;
    s === "function" ? r[a] = o(t[a]) : o && s === "object" ? r[a] = e(o, t[a]) : r[a] = t[a];
  }
  return r;
}, yt = function(A) {
  return A == null;
}, kf = function(A, t, r) {
  if (yt(A)) return r;
  for (var n = Og(t), i = A, a = 0; a < n.length; a += 1) {
    if (yt(i)) return;
    i = i[n[a]];
  }
  return yt(i) ? r : i;
}, ni = function(A) {
  return A === "" ? "" : A[A.length - 1];
}, Qm = function(A, t) {
  var r = Object.entries(A);
  return r.reduce(function(n, i, a) {
    var o = i[0], s = i[1];
    return n[o] = t(s, o, a), n;
  }, {});
}, kS = function(A) {
  return /((-)?\d+\.?\d*)%/g.exec("" + A);
}, Br = function(A) {
  var t = kS(A);
  if (t) {
    var r = parseFloat(t[1]), n = r / 100;
    return {
      percent: n,
      value: r
    };
  }
  return null;
}, Dh = function(A, t) {
  var r = Og(A), n = Object.assign({}, t);
  return r.forEach(function(i) {
    delete n[i];
  }), n;
}, FC = function(A, t) {
  for (var r = {}, n = 0; n < A.length; n += 1) {
    var i = A[n];
    i in t && (r[i] = t[i]);
  }
  return r;
}, wm = function(A, t) {
  t === void 0 && (t = 0);
  for (var r = new Array(t), n = 0; n < t; n += 1)
    r[n] = A;
  return r;
}, LC = function(A) {
  return A && A.charAt(0).toUpperCase() + A.slice(1);
}, Uf, iI;
function US() {
  if (iI) return Uf;
  iI = 1, Uf = e;
  function e(A) {
    var t = 0, r = 0, n = 0, i = 0;
    return A.map(function(a) {
      a = a.slice();
      var o = a[0], s = o.toUpperCase();
      if (o != s)
        switch (a[0] = s, o) {
          case "a":
            a[6] += n, a[7] += i;
            break;
          case "v":
            a[1] += i;
            break;
          case "h":
            a[1] += n;
            break;
          default:
            for (var l = 1; l < a.length; )
              a[l++] += n, a[l++] += i;
        }
      switch (s) {
        case "Z":
          n = t, i = r;
          break;
        case "H":
          n = a[1];
          break;
        case "V":
          i = a[1];
          break;
        case "M":
          n = t = a[1], i = r = a[2];
          break;
        default:
          n = a[a.length - 2], i = a[a.length - 1];
      }
      return a;
    });
  }
  return Uf;
}
var YS = US();
const HS = /* @__PURE__ */ Ht(YS);
var Yf, aI;
function SS() {
  if (aI) return Yf;
  aI = 1, Yf = t;
  var e = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, A = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
  function t(i) {
    var a = [];
    return i.replace(A, function(o, s, l) {
      var u = s.toLowerCase();
      for (l = n(l), u == "m" && l.length > 2 && (a.push([s].concat(l.splice(0, 2))), u = "l", s = s == "m" ? "l" : "L"); ; ) {
        if (l.length == e[u])
          return l.unshift(s), a.push(l);
        if (l.length < e[u]) throw new Error("malformed path data");
        a.push([s].concat(l.splice(0, e[u])));
      }
    }), a;
  }
  var r = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
  function n(i) {
    var a = i.match(r);
    return a ? a.map(Number) : [];
  }
  return Yf;
}
var NS = SS();
const TS = /* @__PURE__ */ Ht(NS);
var PS = /* @__PURE__ */ function() {
  function e(A, t) {
    var r = [], n = !0, i = !1, a = void 0;
    try {
      for (var o = A[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (l) {
      i = !0, a = l;
    } finally {
      try {
        !n && o.return && o.return();
      } finally {
        if (i) throw a;
      }
    }
    return r;
  }
  return function(A, t) {
    if (Array.isArray(A))
      return A;
    if (Symbol.iterator in Object(A))
      return e(A, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), nl = Math.PI * 2, Hf = function(A, t, r, n, i, a, o) {
  var s = A.x, l = A.y;
  s *= t, l *= r;
  var u = n * s - i * l, g = i * s + n * l;
  return {
    x: u + a,
    y: g + o
  };
}, zS = function(A, t) {
  var r = t === 1.5707963267948966 ? 0.551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), n = Math.cos(A), i = Math.sin(A), a = Math.cos(A + t), o = Math.sin(A + t);
  return [{
    x: n - i * r,
    y: i + n * r
  }, {
    x: a + o * r,
    y: o - a * r
  }, {
    x: a,
    y: o
  }];
}, oI = function(A, t, r, n) {
  var i = A * n - t * r < 0 ? -1 : 1, a = A * r + t * n;
  return a > 1 && (a = 1), a < -1 && (a = -1), i * Math.acos(a);
}, jS = function(A, t, r, n, i, a, o, s, l, u, g, d) {
  var h = Math.pow(i, 2), C = Math.pow(a, 2), E = Math.pow(g, 2), I = Math.pow(d, 2), b = h * C - h * I - C * E;
  b < 0 && (b = 0), b /= h * I + C * E, b = Math.sqrt(b) * (o === s ? -1 : 1);
  var y = b * i / a * d, p = b * -a / i * g, Q = u * y - l * p + (A + r) / 2, w = l * y + u * p + (t + n) / 2, Y = (g - y) / i, k = (d - p) / a, L = (-g - y) / i, S = (-d - p) / a, P = oI(1, 0, Y, k), Z = oI(Y, k, L, S);
  return s === 0 && Z > 0 && (Z -= nl), s === 1 && Z < 0 && (Z += nl), [Q, w, P, Z];
}, VS = function(A) {
  var t = A.px, r = A.py, n = A.cx, i = A.cy, a = A.rx, o = A.ry, s = A.xAxisRotation, l = s === void 0 ? 0 : s, u = A.largeArcFlag, g = u === void 0 ? 0 : u, d = A.sweepFlag, h = d === void 0 ? 0 : d, C = [];
  if (a === 0 || o === 0)
    return [];
  var E = Math.sin(l * nl / 360), I = Math.cos(l * nl / 360), b = I * (t - n) / 2 + E * (r - i) / 2, y = -E * (t - n) / 2 + I * (r - i) / 2;
  if (b === 0 && y === 0)
    return [];
  a = Math.abs(a), o = Math.abs(o);
  var p = Math.pow(b, 2) / Math.pow(a, 2) + Math.pow(y, 2) / Math.pow(o, 2);
  p > 1 && (a *= Math.sqrt(p), o *= Math.sqrt(p));
  var Q = jS(t, r, n, i, a, o, g, h, E, I, b, y), w = PS(Q, 4), Y = w[0], k = w[1], L = w[2], S = w[3], P = Math.abs(S) / (nl / 4);
  Math.abs(1 - P) < 1e-7 && (P = 1);
  var Z = Math.max(Math.ceil(P), 1);
  S /= Z;
  for (var M = 0; M < Z; M++)
    C.push(zS(L, S)), L += S;
  return C.map(function(R) {
    var G = Hf(R[0], a, o, I, E, Y, k), N = G.x, z = G.y, T = Hf(R[1], a, o, I, E, Y, k), O = T.x, K = T.y, AA = Hf(R[2], a, o, I, E, Y, k), X = AA.x, iA = AA.y;
    return { x1: N, y1: z, x2: O, y2: K, x: X, y: iA };
  });
};
function OS(e) {
  for (var A, t = [], r = 0, n = 0, i = 0, a = 0, o = null, s = null, l = 0, u = 0, g = 0, d = e.length; g < d; g++) {
    var h = e[g], C = h[0];
    switch (C) {
      case "M":
        i = h[1], a = h[2];
        break;
      case "A":
        var E = VS({
          px: l,
          py: u,
          cx: h[6],
          cy: h[7],
          rx: h[1],
          ry: h[2],
          xAxisRotation: h[3],
          largeArcFlag: h[4],
          sweepFlag: h[5]
        });
        if (!E.length) continue;
        for (var I = 0, b; I < E.length; I++)
          b = E[I], h = ["C", b.x1, b.y1, b.x2, b.y2, b.x, b.y], I < E.length - 1 && t.push(h);
        break;
      case "S":
        var y = l, p = u;
        (A == "C" || A == "S") && (y += y - r, p += p - n), h = ["C", y, p, h[1], h[2], h[3], h[4]];
        break;
      case "T":
        A == "Q" || A == "T" ? (o = l * 2 - o, s = u * 2 - s) : (o = l, s = u), h = sI(l, u, o, s, h[1], h[2]);
        break;
      case "Q":
        o = h[1], s = h[2], h = sI(l, u, h[1], h[2], h[3], h[4]);
        break;
      case "L":
        h = Vu(l, u, h[1], h[2]);
        break;
      case "H":
        h = Vu(l, u, h[1], u);
        break;
      case "V":
        h = Vu(l, u, l, h[1]);
        break;
      case "Z":
        h = Vu(l, u, i, a);
        break;
    }
    A = C, l = h[h.length - 2], u = h[h.length - 1], h.length > 4 ? (r = h[h.length - 4], n = h[h.length - 3]) : (r = l, n = u), t.push(h);
  }
  return t;
}
function Vu(e, A, t, r) {
  return ["C", e, A, t, r, t, r];
}
function sI(e, A, t, r, n, i) {
  return [
    "C",
    e / 3 + 2 / 3 * t,
    A / 3 + 2 / 3 * r,
    n / 3 + 2 / 3 * t,
    i / 3 + 2 / 3 * r,
    n,
    i
  ];
}
var Sf = { exports: {} }, Nf, lI;
function JS() {
  return lI || (lI = 1, Nf = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), Nf;
}
var Tf = { exports: {} }, Pf, uI;
function WS() {
  return uI || (uI = 1, Pf = function(A) {
    return !A || typeof A == "string" ? !1 : A instanceof Array || Array.isArray(A) || A.length >= 0 && (A.splice instanceof Function || Object.getOwnPropertyDescriptor(A, A.length - 1) && A.constructor.name !== "String");
  }), Pf;
}
var cI;
function ZS() {
  if (cI) return Tf.exports;
  cI = 1;
  var e = WS(), A = Array.prototype.concat, t = Array.prototype.slice, r = Tf.exports = function(i) {
    for (var a = [], o = 0, s = i.length; o < s; o++) {
      var l = i[o];
      e(l) ? a = A.call(a, t.call(l)) : a.push(l);
    }
    return a;
  };
  return r.wrap = function(n) {
    return function() {
      return n(r(arguments));
    };
  }, Tf.exports;
}
var gI;
function KS() {
  if (gI) return Sf.exports;
  gI = 1;
  var e = JS(), A = ZS(), t = Object.hasOwnProperty, r = /* @__PURE__ */ Object.create(null);
  for (var n in e)
    t.call(e, n) && (r[e[n]] = n);
  var i = Sf.exports = {
    to: {},
    get: {}
  };
  i.get = function(s) {
    var l = s.substring(0, 3).toLowerCase(), u, g;
    switch (l) {
      case "hsl":
        u = i.get.hsl(s), g = "hsl";
        break;
      case "hwb":
        u = i.get.hwb(s), g = "hwb";
        break;
      default:
        u = i.get.rgb(s), g = "rgb";
        break;
    }
    return u ? { model: g, value: u } : null;
  }, i.get.rgb = function(s) {
    if (!s)
      return null;
    var l = /^#([a-f0-9]{3,4})$/i, u = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, g = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, d = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, h = /^(\w+)$/, C = [0, 0, 0, 1], E, I, b;
    if (E = s.match(u)) {
      for (b = E[2], E = E[1], I = 0; I < 3; I++) {
        var y = I * 2;
        C[I] = parseInt(E.slice(y, y + 2), 16);
      }
      b && (C[3] = parseInt(b, 16) / 255);
    } else if (E = s.match(l)) {
      for (E = E[1], b = E[3], I = 0; I < 3; I++)
        C[I] = parseInt(E[I] + E[I], 16);
      b && (C[3] = parseInt(b + b, 16) / 255);
    } else if (E = s.match(g)) {
      for (I = 0; I < 3; I++)
        C[I] = parseInt(E[I + 1], 0);
      E[4] && (E[5] ? C[3] = parseFloat(E[4]) * 0.01 : C[3] = parseFloat(E[4]));
    } else if (E = s.match(d)) {
      for (I = 0; I < 3; I++)
        C[I] = Math.round(parseFloat(E[I + 1]) * 2.55);
      E[4] && (E[5] ? C[3] = parseFloat(E[4]) * 0.01 : C[3] = parseFloat(E[4]));
    } else return (E = s.match(h)) ? E[1] === "transparent" ? [0, 0, 0, 0] : t.call(e, E[1]) ? (C = e[E[1]], C[3] = 1, C) : null : null;
    for (I = 0; I < 3; I++)
      C[I] = a(C[I], 0, 255);
    return C[3] = a(C[3], 0, 1), C;
  }, i.get.hsl = function(s) {
    if (!s)
      return null;
    var l = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, u = s.match(l);
    if (u) {
      var g = parseFloat(u[4]), d = (parseFloat(u[1]) % 360 + 360) % 360, h = a(parseFloat(u[2]), 0, 100), C = a(parseFloat(u[3]), 0, 100), E = a(isNaN(g) ? 1 : g, 0, 1);
      return [d, h, C, E];
    }
    return null;
  }, i.get.hwb = function(s) {
    if (!s)
      return null;
    var l = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, u = s.match(l);
    if (u) {
      var g = parseFloat(u[4]), d = (parseFloat(u[1]) % 360 + 360) % 360, h = a(parseFloat(u[2]), 0, 100), C = a(parseFloat(u[3]), 0, 100), E = a(isNaN(g) ? 1 : g, 0, 1);
      return [d, h, C, E];
    }
    return null;
  }, i.to.hex = function() {
    var s = A(arguments);
    return "#" + o(s[0]) + o(s[1]) + o(s[2]) + (s[3] < 1 ? o(Math.round(s[3] * 255)) : "");
  }, i.to.rgb = function() {
    var s = A(arguments);
    return s.length < 4 || s[3] === 1 ? "rgb(" + Math.round(s[0]) + ", " + Math.round(s[1]) + ", " + Math.round(s[2]) + ")" : "rgba(" + Math.round(s[0]) + ", " + Math.round(s[1]) + ", " + Math.round(s[2]) + ", " + s[3] + ")";
  }, i.to.rgb.percent = function() {
    var s = A(arguments), l = Math.round(s[0] / 255 * 100), u = Math.round(s[1] / 255 * 100), g = Math.round(s[2] / 255 * 100);
    return s.length < 4 || s[3] === 1 ? "rgb(" + l + "%, " + u + "%, " + g + "%)" : "rgba(" + l + "%, " + u + "%, " + g + "%, " + s[3] + ")";
  }, i.to.hsl = function() {
    var s = A(arguments);
    return s.length < 4 || s[3] === 1 ? "hsl(" + s[0] + ", " + s[1] + "%, " + s[2] + "%)" : "hsla(" + s[0] + ", " + s[1] + "%, " + s[2] + "%, " + s[3] + ")";
  }, i.to.hwb = function() {
    var s = A(arguments), l = "";
    return s.length >= 4 && s[3] !== 1 && (l = ", " + s[3]), "hwb(" + s[0] + ", " + s[1] + "%, " + s[2] + "%" + l + ")";
  }, i.to.keyword = function(s) {
    return r[s.slice(0, 3)];
  };
  function a(s, l, u) {
    return Math.min(Math.max(l, s), u);
  }
  function o(s) {
    var l = Math.round(s).toString(16).toUpperCase();
    return l.length < 2 ? "0" + l : l;
  }
  return Sf.exports;
}
var _S = KS();
const Cl = /* @__PURE__ */ Ht(_S), XS = (e, A) => {
  var t;
  ((t = A.props) === null || t === void 0 ? void 0 : t.d) && e.path(A.props.d);
}, BI = 4 * ((Math.sqrt(2) - 1) / 3), qS = (e, A) => {
  var t, r, n, i, a, o;
  const s = ((t = A.props) === null || t === void 0 ? void 0 : t.x) || 0, l = ((r = A.props) === null || r === void 0 ? void 0 : r.y) || 0, u = ((n = A.props) === null || n === void 0 ? void 0 : n.rx) || 0, g = ((i = A.props) === null || i === void 0 ? void 0 : i.ry) || 0, d = ((a = A.props) === null || a === void 0 ? void 0 : a.width) || 0, h = ((o = A.props) === null || o === void 0 ? void 0 : o.height) || 0;
  if (!(!d || !h)) {
    if (u && g) {
      const C = u * BI, E = g * BI;
      e.moveTo(s + u, l), e.lineTo(s - u + d, l), e.bezierCurveTo(s - u + d + C, l, s + d, l + g - E, s + d, l + g), e.lineTo(s + d, l + h - g), e.bezierCurveTo(s + d, l + h - g + E, s - u + d + C, l + h, s - u + d, l + h), e.lineTo(s + u, l + h), e.bezierCurveTo(s + u - C, l + h, s, l + h - g + E, s, l + h - g), e.lineTo(s, l + g), e.bezierCurveTo(s, l + g - E, s + u - C, l, s + u, l);
    } else
      e.moveTo(s, l), e.lineTo(s + d, l), e.lineTo(s + d, l + h), e.lineTo(s, l + h);
    e.closePath();
  }
}, $S = (e, A) => {
  const {
    x1: t,
    x2: r,
    y1: n,
    y2: i
  } = A.props || {};
  e.moveTo(t, n), e.lineTo(r, i);
}, AN = () => {
}, fI = 4 * ((Math.sqrt(2) - 1) / 3), Im = function(e, A, t, r, n) {
  A === void 0 && (A = 0), t === void 0 && (t = 0);
  const i = A - r, a = t - n, o = r * fI, s = n * fI, l = i + r * 2, u = a + n * 2, g = i + r, d = a + n;
  e.moveTo(i, d), e.bezierCurveTo(i, d - s, g - o, a, g, a), e.bezierCurveTo(g + o, a, l, d - s, l, d), e.bezierCurveTo(l, d + s, g + o, u, g, u), e.bezierCurveTo(g - o, u, i, d + s, i, d), e.closePath();
}, eN = (e, A) => {
  const {
    cx: t,
    cy: r,
    rx: n,
    ry: i
  } = A.props || {};
  Im(e, t, r, n, i);
}, tN = (e, A) => {
  var t, r, n;
  const i = (t = A.props) === null || t === void 0 ? void 0 : t.cx, a = (r = A.props) === null || r === void 0 ? void 0 : r.cy, o = (n = A.props) === null || n === void 0 ? void 0 : n.r;
  Im(e, i, a, o, o);
}, Dm = function(e, A, t, r, n, i) {
  i === void 0 && (i = {});
  const a = 1e3 / e._fontSize, s = 1e3 / (e._font.font.unitsPerEm || 1e3), l = e._font.encodeGlyphs(A), u = t.map((g, d) => ({
    xAdvance: g.xAdvance * a,
    yAdvance: g.yAdvance * a,
    xOffset: g.xOffset,
    yOffset: g.yOffset,
    advanceWidth: A[d].advanceWidth * s
  }));
  return e._glyphs(l, u, r, n, i);
}, rN = (e, A) => {
  const t = A.xAdvance, {
    font: r,
    fontSize: n,
    color: i,
    opacity: a
  } = A.attributes;
  if (e.fillColor(i), e.fillOpacity(a), r.sbix || r.COLR && r.CPAL) {
    e.save(), e.translate(0, -A.ascent);
    for (let o = 0; o < A.glyphs.length; o += 1) {
      const s = A.positions[o], l = A.glyphs[o];
      e.save(), e.translate(s.xOffset, s.yOffset), l.render(e, n), e.restore(), e.translate(s.xAdvance, s.yAdvance);
    }
    e.restore();
  } else {
    e.font(typeof r.name == "string" ? r.name : r, n);
    try {
      Dm(e, A.glyphs, A.positions, 0, 0);
    } catch (o) {
      console.log(o);
    }
  }
  e.translate(t, 0);
}, nN = (e, A, t, r) => {
  var n, i, a, o, s;
  e.save();
  const l = ((n = A.box) === null || n === void 0 ? void 0 : n.x) || 0, u = ((i = A.box) === null || i === void 0 ? void 0 : i.y) || 0, g = (a = A.runs[0]) === null || a === void 0 ? void 0 : a.attributes.font, d = ((o = A.runs[0]) === null || o === void 0 || (s = o.attributes) === null || s === void 0 ? void 0 : s.scale) || 1, h = A.xAdvance, C = g.ascent * d, E = g.xHeight * d, I = g.descent * d, b = g.capHeight * d;
  let y = l, p = u;
  switch (t) {
    case "middle":
      y = l - h / 2;
      break;
    case "end":
      y = l - h;
      break;
    default:
      y = l;
      break;
  }
  switch (r) {
    case "middle":
    case "central":
      p = u + b / 2;
      break;
    case "hanging":
      p = u + b;
      break;
    case "mathematical":
      p = u + E;
      break;
    case "text-after-edge":
      p = u + I;
      break;
    case "text-before-edge":
      p = u + C;
      break;
    default:
      p = u;
      break;
  }
  e.translate(y, p), A.runs.forEach((Q) => rN(e, Q)), e.restore();
}, iN = (e, A) => {
  A.children.forEach((t) => nN(e, t.lines[0], t.props.textAnchor, t.props.dominantBaseline));
}, aN = (e) => {
  const A = [];
  for (let t = 0; t < e.length; t += 2)
    A.push([e[t], e[t + 1]]);
  return A;
}, mm = (e) => {
  let A = (e || "").trim().replace(/,/g, " ").replace(/(\d)-(\d)/g, "$1 -$2").split(/\s+/);
  A.length % 2 !== 0 && (A = A.slice(0, -1));
  const t = A.map(parseFloat);
  return aN(t);
}, oN = (e, A) => {
  A.length > 0 && (e.moveTo(A[0][0], A[0][1]), A.slice(1).forEach((t) => e.lineTo(t[0], t[1])));
}, Mm = (e, A) => {
  const t = mm(A.props.points || "");
  oN(e, t);
}, sN = (e, A) => {
  Mm(e, A), e.closePath();
}, lN = (e, A) => {
  if (!A.image.data) return;
  const {
    x: t,
    y: r
  } = A.props, {
    width: n,
    height: i,
    opacity: a
  } = A.style, o = A.box.paddingLeft || 0, s = A.box.paddingLeft || 0;
  if (n === 0 || i === 0) {
    console.warn("Image with src '" + A.props.href + "' skipped due to invalid dimensions");
    return;
  }
  e.save(), e.fillOpacity(a || 1).image(A.image.data, t + s, r + o, {
    width: n,
    height: i
  }), e.restore();
}, Ou = 4 * ((Math.sqrt(2) - 1) / 3), Wg = (e, A) => {
  if (!A.style) return;
  const {
    top: t,
    left: r,
    width: n,
    height: i
  } = A.box, {
    borderTopLeftRadius: a = 0,
    borderTopRightRadius: o = 0,
    borderBottomRightRadius: s = 0,
    borderBottomLeftRadius: l = 0
  } = A.style, u = Math.min(o, 0.5 * n, 0.5 * i), g = u * (1 - Ou);
  e.moveTo(r + u, t), e.lineTo(r + n - u, t), e.bezierCurveTo(r + n - g, t, r + n, t + g, r + n, t + u);
  const d = Math.min(s, 0.5 * n, 0.5 * i), h = d * (1 - Ou);
  e.lineTo(r + n, t + i - d), e.bezierCurveTo(r + n, t + i - h, r + n - h, t + i, r + n - d, t + i);
  const C = Math.min(l, 0.5 * n, 0.5 * i), E = C * (1 - Ou);
  e.lineTo(r + C, t + i), e.bezierCurveTo(r + E, t + i, r, t + i - E, r, t + i - C);
  const I = Math.min(a, 0.5 * n, 0.5 * i), b = I * (1 - Ou);
  e.lineTo(r, t + I), e.bezierCurveTo(r, t + b, r + b, t, r + I, t), e.closePath(), e.clip();
}, uN = (e, A, t) => {
  const {
    operation: r,
    value: n
  } = A;
  switch (r) {
    case "scale": {
      const [i, a] = n;
      e.scale(i, a, {
        origin: t
      });
      break;
    }
    case "rotate": {
      const [i] = n;
      e.rotate(i, {
        origin: t
      });
      break;
    }
    case "translate": {
      const [i, a = 0] = n;
      e.translate(i, a, {
        origin: t
      });
      break;
    }
    case "skew": {
      const [i, a] = n;
      e.skew(i, a, {
        origin: t
      });
      break;
    }
    case "matrix": {
      e.transform(...n);
      break;
    }
    default:
      console.error("Transform operation: '" + r + "' doesn't supported");
  }
}, pm = (e, A) => {
  var t, r;
  if (!A.origin) return;
  const n = [A.origin.left, A.origin.top];
  (((t = A.style) === null || t === void 0 ? void 0 : t.transform) || ((r = A.props) === null || r === void 0 ? void 0 : r.transform) || []).forEach((a) => {
    uN(e, a, n);
  });
}, cN = (e) => {
  var A;
  const t = OS(HS(TS(((A = e.props) === null || A === void 0 ? void 0 : A.d) || "")));
  if (!t.length) return [0, 0, 0, 0];
  const r = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
  for (let n = 0, i = t.length; n < i; n += 1) {
    const a = t[n].slice(1);
    for (let o = 0; o < a.length; o += 2)
      a[o + 0] < r[0] && (r[0] = a[o + 0]), a[o + 1] < r[1] && (r[1] = a[o + 1]), a[o + 0] > r[2] && (r[2] = a[o + 0]), a[o + 1] > r[3] && (r[3] = a[o + 1]);
  }
  return r;
}, gN = (e) => {
  var A, t, r;
  const n = ((A = e.props) === null || A === void 0 ? void 0 : A.r) || 0, i = ((t = e.props) === null || t === void 0 ? void 0 : t.cx) || 0, a = ((r = e.props) === null || r === void 0 ? void 0 : r.cy) || 0;
  return [i - n, a - n, i + n, a + n];
}, BN = (e) => {
  var A, t, r, n;
  const i = ((A = e.props) === null || A === void 0 ? void 0 : A.cx) || 0, a = ((t = e.props) === null || t === void 0 ? void 0 : t.cy) || 0, o = ((r = e.props) === null || r === void 0 ? void 0 : r.rx) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.ry) || 0;
  return [i - o, a - s, i + o, a + s];
}, fN = (e) => {
  var A, t, r, n;
  const i = ((A = e.props) === null || A === void 0 ? void 0 : A.x1) || 0, a = ((t = e.props) === null || t === void 0 ? void 0 : t.y1) || 0, o = ((r = e.props) === null || r === void 0 ? void 0 : r.x2) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.y2) || 0;
  return [Math.min(i, o), Math.min(a, s), Math.max(i, o), Math.max(a, s)];
}, dN = (e) => {
  var A, t, r, n;
  const i = ((A = e.props) === null || A === void 0 ? void 0 : A.x) || 0, a = ((t = e.props) === null || t === void 0 ? void 0 : t.y) || 0, o = ((r = e.props) === null || r === void 0 ? void 0 : r.width) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.height) || 0;
  return [i, a, i + o, a + s];
}, dI = (e) => Math.max(-1 / 0, ...e), hI = (e) => Math.min(1 / 0, ...e), CI = (e) => {
  var A;
  const t = mm(((A = e.props) === null || A === void 0 ? void 0 : A.points) || []), r = t.map((i) => i[0]), n = t.map((i) => i[1]);
  return [hI(r), hI(n), dI(r), dI(n)];
}, hN = {
  [cC]: dN,
  [gC]: fN,
  [uC]: cN,
  [dC]: gN,
  [hC]: BN,
  [CC]: CI,
  [EC]: CI
}, vm = (e) => {
  const A = hN[e.type];
  return A ? A(e) : [0, 0, 0, 0];
}, CN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.strokeWidth) || 0;
  r && e.lineWidth(r);
}, EN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.stroke) || null;
  r && e.strokeColor(r);
}, QN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.opacity) || null;
  yt(r) || e.opacity(r);
}, wN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.fillOpacity) || null;
  yt(r) || e.fillOpacity(r);
}, IN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.strokeOpacity) || null;
  yt(r) || e.strokeOpacity(r);
}, DN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.strokeLinejoin) || null;
  r && e.lineJoin(r);
}, mN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.strokeLinecap) || null;
  r && e.lineCap(r);
}, MN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.strokeDasharray) || null;
  r && e.dash(r.split(",").map(Number));
}, pN = (e) => {
  var A, t;
  return ((A = e.props) === null || A === void 0 || (t = A.fill) === null || t === void 0 ? void 0 : t.type) === p4;
}, vN = (e) => {
  var A, t;
  return ((A = e.props) === null || A === void 0 || (t = A.fill) === null || t === void 0 ? void 0 : t.type) === v4;
}, yN = (e, A) => {
  var t;
  const r = vm(A), n = ((t = A.props) === null || t === void 0 ? void 0 : t.fill) || null, i = n.props.x1 || 0, a = n.props.y1 || 0, o = n.props.x2 || 1, s = n.props.y2 || 0, l = r[2] - r[0], u = r[3] - r[1], g = r[0], d = r[1], h = l * i + g, C = u * a + d, E = l * o + g, I = u * s + d, b = e.linearGradient(h, C, E, I);
  n.children.forEach((y) => {
    b.stop(y.props.offset, y.props.stopColor, y.props.stopOpacity);
  }), e.fill(b);
}, bN = (e, A) => {
  var t;
  const r = vm(A), n = ((t = A.props) === null || t === void 0 ? void 0 : t.fill) || null, i = n.props.cx || 0.5, a = n.props.cy || 0.5, o = n.props.fx || i, s = n.props.fy || a, l = n.props.r || 0.5, u = r[2] - r[0], g = r[3] - r[1], d = r[0], h = r[1], C = l * u, E = u * i + d, I = g * a + h, b = u * o + d, y = g * s + h, p = e.radialGradient(b, y, 0, E, I, C);
  n.children.forEach((Q) => {
    p.stop(Q.props.offset, Q.props.stopColor, Q.props.stopOpacity);
  }), e.fill(p);
}, FN = (e, A) => {
  var t;
  const r = ((t = A.props) === null || t === void 0 ? void 0 : t.fill) || null;
  r && e.fillColor(r);
}, LN = (e, A) => pN(A) ? yN(e, A) : vN(A) ? bN(e, A) : FN(e, A), RN = (e, A) => {
  const t = A.props || {};
  t.fill && t.stroke ? e.fillAndStroke(t.fillRule) : t.fill ? e.fill(t.fillRule) : t.stroke ? e.stroke() : (e.save(), e.opacity(0), e.fill(null), e.restore());
}, EI = () => {
}, GN = {
  [fC]: EI,
  [qi]: EI,
  [uC]: XS,
  [cC]: qS,
  [gC]: $S,
  [M4]: AN,
  [Ue]: iN,
  [dC]: tN,
  [Xi]: lN,
  [hC]: eN,
  [CC]: sN,
  [EC]: Mm
}, ym = (e, A) => {
  const t = GN[A.type];
  t ? t(e, A) : console.warn("SVG node of type " + A.type + " is not currently supported");
}, xN = (e, A) => {
  mN(e, A), MN(e, A), DN(e, A), CN(e, A), EN(e, A), LN(e, A), IN(e, A), wN(e, A), QN(e, A), pm(e, A), ym(e, A), RN(e, A);
}, kN = (e, A) => {
  var t;
  const r = (t = A.props) === null || t === void 0 ? void 0 : t.clipPath;
  r && ((r.children || []).forEach((i) => ym(e, i)), e.clip());
}, bm = (e, A) => {
  (A.children || []).forEach((r) => {
    e.save(), kN(e, r), xN(e, r), bm(e, r), e.restore();
  });
}, UN = (e, A) => {
  const {
    width: t,
    height: r
  } = A.box, {
    viewBox: n,
    preserveAspectRatio: i = {}
  } = A.props, {
    meetOrSlice: a = "meet",
    align: o = "xMidYMid"
  } = i;
  if (n == null || t == null || r == null) return;
  const s = (n == null ? void 0 : n.minX) || 0, l = (n == null ? void 0 : n.minY) || 0, u = (n == null ? void 0 : n.maxX) || t, g = (n == null ? void 0 : n.maxY) || r, d = u / g, h = t / r, C = t / u, E = r / g;
  if (o === "none") {
    e.scale(C, E), e.translate(-s, -l);
    return;
  }
  if (d < h && a === "meet" || d >= h && a === "slice")
    switch (e.scale(E, E), o) {
      case "xMinYMin":
      case "xMinYMid":
      case "xMinYMax":
        e.translate(-s, -l);
        break;
      case "xMidYMin":
      case "xMidYMid":
      case "xMidYMax":
        e.translate(-s - (u - t * g / r) / 2, -l);
        break;
      default:
        e.translate(-s - (u - t * g / r), -l);
    }
  else
    switch (e.scale(C, C), o) {
      case "xMinYMin":
      case "xMidYMin":
      case "xMaxYMin":
        e.translate(-s, -l);
        break;
      case "xMinYMid":
      case "xMidYMid":
      case "xMaxYMid":
        e.translate(-s, -l - (g - r * u / t) / 2);
        break;
      default:
        e.translate(-s, -l - (g - r * u / t));
    }
}, YN = (e, A) => {
  const {
    top: t,
    left: r
  } = A.box, n = A.box.paddingLeft || 0, i = A.box.paddingTop || 0;
  e.translate(r + n, t + i);
}, HN = (e, A) => {
  e.save(), Wg(e, A), YN(e, A), UN(e, A), bm(e, A), e.restore();
}, SN = {
  value: [0, 0, 0],
  opacity: 1
}, RC = (e) => {
  const A = Cl.get(e);
  if (!A) return SN;
  const t = Cl.to.hex(A.value.slice(0, 3)), r = A.value[3];
  return {
    value: t,
    opacity: r
  };
}, NN = /^#.+/, TN = (e) => e.match(NN), PN = (e, A) => {
  const {
    xOffset: t = 0,
    yOffset: r = 0,
    width: n,
    height: i,
    image: a
  } = A;
  e.translate(-n + t, -i + r), e.image(a, 0, 0, {
    fit: [n, i],
    align: "center",
    valign: "bottom"
  });
}, zN = (e, A) => {
  e.save();
  const {
    font: t
  } = A.attributes, r = t.glyphForCodePoint(32), n = t.glyphForCodePoint(65532);
  let i = 0;
  for (let a = 0; a < A.glyphs.length; a += 1) {
    const o = A.positions[a], s = A.glyphs[a];
    i += o.xAdvance || 0, s.id === n.id && A.attributes.attachment && (e.translate(i, o.yOffset || 0), PN(e, A.attributes.attachment), A.glyphs[a] = r, i = 0);
  }
  e.restore();
}, jN = (e, A, t) => {
  const {
    font: r,
    fontSize: n,
    link: i
  } = A.attributes, a = RC(A.attributes.color), o = yt(A.attributes.opacity) ? a.opacity : A.attributes.opacity, {
    height: s,
    descent: l,
    xAdvance: u
  } = A;
  if (t.outlineRuns && e.rect(0, -s, u, s).stroke(), e.fillColor(a.value), e.fillOpacity(o), i && (TN(i) ? e.goTo(0, -s - l, u, s, i.slice(1)) : e.link(0, -s - l, u, s, i)), zN(e, A), r.sbix || r.COLR && r.CPAL) {
    e.save(), e.translate(0, -A.ascent);
    for (let g = 0; g < A.glyphs.length; g += 1) {
      const d = A.positions[g], h = A.glyphs[g];
      e.save(), e.translate(d.xOffset, d.yOffset), h.render(e, n), e.restore(), e.translate(d.xAdvance, d.yAdvance);
    }
    e.restore();
  } else {
    e.font(typeof r.name == "string" ? r.name : r, n);
    try {
      Dm(e, A.glyphs, A.positions, 0, 0);
    } catch (g) {
      console.log(g);
    }
  }
  e.translate(u, 0);
}, VN = (e, A, t) => {
  const r = RC(t);
  e.save(), e.fillOpacity(r.opacity), e.rect(A.x, A.y, A.width, A.height), e.fill(r.value), e.restore();
}, ON = (e, A) => {
  if (e.save(), e.lineWidth(A.rect.height), e.strokeOpacity(A.opacity), /dashed/.test(A.style) ? e.dash(3 * A.rect.height) : /dotted/.test(A.style) && e.dash(A.rect.height), /wavy/.test(A.style)) {
    const t = Math.max(2, A.rect.height);
    let r = 1.1 * t;
    const n = Math.floor(A.rect.width / (2 * r)), a = (A.rect.width - n * 2 * r) / n / 2;
    r += a;
    const o = A.rect.y + t, s = A.rect.y - t;
    let {
      x: l
    } = A.rect;
    e.moveTo(A.rect.x, A.rect.y);
    for (let u = 0; u < n; u += 1)
      e.bezierCurveTo(l + r, o, l + r, s, l + 2 * r, A.rect.y), l += 2 * r;
  } else
    e.moveTo(A.rect.x, A.rect.y), e.lineTo(A.rect.x + A.rect.width, A.rect.y), /double/.test(A.style) && (e.moveTo(A.rect.x, A.rect.y + A.rect.height * 2), e.lineTo(A.rect.x + A.rect.width, A.rect.y + A.rect.height * 2));
  e.stroke(A.color), e.restore();
}, JN = (e, A, t) => {
  const r = A.ascent;
  t.outlineLines && e.rect(A.box.x, A.box.y, A.box.width, A.box.height).stroke(), e.save(), e.translate(A.box.x, A.box.y + r);
  for (let n = 0; n < A.runs.length; n += 1) {
    const i = A.runs[n], a = n === A.runs.length - 1;
    if (i.attributes.backgroundColor) {
      const o = a ? A.overflowRight : 0, s = {
        x: 0,
        y: -r,
        height: A.box.height,
        width: i.xAdvance - o
      };
      VN(e, s, i.attributes.backgroundColor);
    }
    jN(e, i, t);
  }
  e.restore(), e.save(), e.translate(A.box.x, A.box.y);
  for (let n = 0; n < A.decorationLines.length; n += 1) {
    const i = A.decorationLines[n];
    ON(e, i);
  }
  e.restore();
}, WN = (e, A, t) => {
  A.forEach((r) => {
    JN(e, r, t);
  });
}, ZN = (e, A) => {
  var t, r;
  const {
    top: n,
    left: i
  } = A.box, a = [A.lines], o = ((t = A.box) === null || t === void 0 ? void 0 : t.paddingTop) || 0, s = ((r = A.box) === null || r === void 0 ? void 0 : r.paddingLeft) || 0, l = A.lines[0] ? A.lines[0].box.y : 0, u = A.alignOffset || 0;
  e.save(), e.translate(i + s - u, n + o - l), a.forEach((g) => {
    WN(e, g, {});
  }), e.restore();
}, KN = (e, A) => {
  var t;
  const {
    width: r,
    height: n
  } = A.box, a = (((t = A.props) === null || t === void 0 ? void 0 : t.dpi) || 72) / 72;
  e.addPage({
    size: [r, n],
    margin: 0,
    userUnit: a
  });
}, _N = (e, A) => {
  var t, r, n;
  const {
    top: i,
    left: a
  } = A.box, o = (A == null || (t = A.children) === null || t === void 0 ? void 0 : t[0].value) || "", s = ((r = A.style) === null || r === void 0 ? void 0 : r.backgroundColor) || null, l = ((n = A.style) === null || n === void 0 ? void 0 : n.borderWidth) || null;
  e.note(a, i, 0, 0, o, {
    color: s,
    borderWidth: l
  });
}, v0 = (e) => !Number.isNaN(parseFloat(e)) && Number.isFinite(e), Fm = (e, A, t, r, n, i) => {
  const a = e / A, o = t / r, s = Br(n), l = Br(i), u = s ? s.percent : 0.5, g = l ? l.percent : 0.5;
  if (a > o) {
    const I = A, b = I * o, y = v0(i) ? i : 0, p = v0(n) ? n : (e - b) * u;
    return {
      width: b,
      height: I,
      xOffset: p,
      yOffset: y
    };
  }
  const d = e, h = d / o, C = v0(n) ? n : 0, E = v0(i) ? i : (A - h) * g;
  return {
    width: d,
    height: h,
    yOffset: E,
    xOffset: C
  };
}, Lm = (e, A, t, r, n, i) => {
  const a = t, o = r, s = Br(n), l = Br(i), u = s ? s.percent : 0.5, g = l ? l.percent : 0.5, d = v0(n) ? n : (e - a) * u, h = v0(i) ? i : (A - o) * g;
  return {
    width: a,
    height: o,
    xOffset: d,
    yOffset: h
  };
}, XN = (e, A, t, r, n, i) => {
  const a = t / r, o = e / A, s = Br(n), l = Br(i), u = s ? s.percent : 0.5, g = l ? l.percent : 0.5;
  if (o > a) {
    const I = e, b = I / a, y = v0(n) ? n : 0, p = v0(i) ? i : (A - b) * g;
    return {
      width: I,
      height: b,
      yOffset: p,
      xOffset: y
    };
  }
  const d = A, h = d * a, C = v0(n) ? n : (e - h) * u, E = v0(i) ? i : 0;
  return {
    width: h,
    height: d,
    xOffset: C,
    yOffset: E
  };
}, qN = (e, A, t, r, n, i) => {
  const a = Fm(e, A, t, r, n, i), o = Lm(e, A, t, r, n, i);
  return a.width < o.width ? a : o;
}, $N = (e, A, t, r) => ({
  width: e,
  height: A,
  xOffset: Br(t) ? 0 : t || 0,
  yOffset: Br(r) ? 0 : r || 0
}), AT = function(e, A, t, r, n, i, a) {
  switch (e === void 0 && (e = "fill"), e) {
    case "contain":
      return Fm(A, t, r, n, i, a);
    case "cover":
      return XN(A, t, r, n, i, a);
    case "none":
      return Lm(A, t, r, n, i, a);
    case "scale-down":
      return qN(A, t, r, n, i, a);
    default:
      return $N(A, t, i, a);
  }
}, eT = function(e, A, t) {
  var r, n, i, a;
  t === void 0 && (t = {});
  const {
    left: o,
    top: s
  } = A.box, l = (r = A.style) === null || r === void 0 ? void 0 : r.opacity, u = (n = A.style) === null || n === void 0 ? void 0 : n.objectFit, g = (i = A.style) === null || i === void 0 ? void 0 : i.objectPositionX, d = (a = A.style) === null || a === void 0 ? void 0 : a.objectPositionY, h = A.box.paddingTop || 0, C = A.box.paddingRight || 0, E = A.box.paddingBottom || 0, I = A.box.paddingLeft || 0, b = t.imageCache || /* @__PURE__ */ new Map(), {
    width: y,
    height: p,
    xOffset: Q,
    yOffset: w
  } = AT(u, A.box.width - I - C, A.box.height - h - E, A.image.width, A.image.height, g, d);
  if (A.image.data)
    if (y !== 0 && p !== 0) {
      const Y = A.image.key, k = b.get(Y) || e.embedImage(A.image.data);
      Y && b.set(Y, k);
      const L = yt(l) ? 1 : l;
      e.fillOpacity(L).image(k, o + I + Q, s + h + w, {
        width: y,
        height: p
      });
    } else
      console.warn("Image with src '" + JSON.stringify(A.props.src) + "' skipped due to invalid dimensions");
}, tT = (e, A, t) => {
  e.save(), Wg(e, A), eT(e, A, t), e.restore();
}, rT = "#a1c6e7", nT = "#c4deb9", iT = "#f8cca1", aT = (e, A) => {
  const {
    left: t,
    top: r,
    width: n,
    height: i,
    paddingLeft: a = 0,
    paddingTop: o = 0,
    paddingRight: s = 0,
    paddingBottom: l = 0,
    borderLeftWidth: u = 0,
    borderTopWidth: g = 0,
    borderRightWidth: d = 0,
    borderBottomWidth: h = 0
  } = A.box;
  e.fillColor(rT).opacity(0.5).rect(t + a + u, r + o + g, n - a - s - d - u, i - o - l - g - h).fill();
}, oT = (e, A) => {
  const {
    left: t,
    top: r,
    width: n,
    height: i,
    paddingLeft: a = 0,
    paddingTop: o = 0,
    paddingRight: s = 0,
    paddingBottom: l = 0,
    borderLeftWidth: u = 0,
    borderTopWidth: g = 0,
    borderRightWidth: d = 0,
    borderBottomWidth: h = 0
  } = A.box;
  e.fillColor(nT).opacity(0.5), e.rect(t + a + u, r + g, n - s - a - u - d, o).fill(), e.rect(t + u, r + g, a, i - g - h).fill(), e.rect(t + n - s - d, r + g, s, i - g - h).fill(), e.rect(t + a + u, r + i - l - h, n - s - a - u - d, l).fill();
}, Rm = (e) => {
  const A = e.marginLeft === "auto" ? 0 : e.marginLeft, t = e.marginTop === "auto" ? 0 : e.marginTop, r = e.marginRight === "auto" ? 0 : e.marginRight, n = e.marginBottom === "auto" ? 0 : e.marginBottom;
  return {
    marginLeft: A,
    marginTop: t,
    marginRight: r,
    marginBottom: n
  };
}, sT = (e, A) => {
  const {
    left: t,
    top: r,
    width: n,
    height: i
  } = A.box, {
    marginLeft: a = 0,
    marginTop: o = 0,
    marginRight: s = 0,
    marginBottom: l = 0
  } = Rm(A.box);
  e.fillColor(iT).opacity(0.5), e.rect(t, r - o, n, o).fill(), e.rect(t - a, r - o, a, i + o + l).fill(), e.rect(t + n, r - o, s, i + o + l).fill(), e.rect(t, r + i, n, l).fill();
}, lT = (e, A) => {
  const {
    left: t,
    top: r,
    width: n,
    height: i
  } = A.box, {
    marginLeft: a = 0,
    marginTop: o = 0,
    marginRight: s = 0,
    marginBottom: l = 0
  } = Rm(A.box), u = Math.round(n + a + s), g = Math.round(i + o + l);
  e.fontSize(6).opacity(1).fillColor("black").text(u + " x " + g, t - a, Math.max(r - o - 4, 1));
}, uT = (e, A) => {
  A.origin && e.circle(A.origin.left, A.origin.top, 3).fill("red").circle(A.origin.left, A.origin.top, 5).stroke("red");
}, cT = (e, A) => {
  var t;
  (t = A.props) !== null && t !== void 0 && t.debug && (e.save(), aT(e, A), oT(e, A), sT(e, A), lT(e, A), uT(e, A), e.restore());
}, gT = ["dash", "clip", "save", "path", "fill", "font", "text", "rect", "scale", "moveTo", "lineTo", "stroke", "rotate", "circle", "lineCap", "opacity", "ellipse", "polygon", "restore", "lineJoin", "fontSize", "fillColor", "lineWidth", "translate", "miterLimit", "strokeColor", "fillOpacity", "roundedRect", "fillAndStroke", "strokeOpacity", "bezierCurveTo", "quadraticCurveTo", "linearGradient", "radialGradient"], BT = (e) => {
  const A = gT.reduce((t, r) => ({
    ...t,
    [r]: function() {
      return e[r](...arguments), A;
    }
  }), {});
  return A;
}, fT = (e, A) => {
  const {
    top: t,
    left: r,
    width: n,
    height: i
  } = A.box, a = A.box.paddingTop || 0, o = A.box.paddingLeft || 0, s = A.box.paddingRight || 0, l = A.box.paddingBottom || 0, u = n - o - s, g = i - a - l;
  (!u || !g) && console.warn("Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it."), e.save().translate(r + o, t + a), A.props.paint && A.props.paint(BT(e), u, g), e.restore();
}, It = 4 * ((Math.sqrt(2) - 1) / 3), dT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderTopWidth: l,
    borderRightWidth: u,
    borderLeftWidth: g
  } = t;
  e.moveTo(a + n, i), e.lineTo(a + o - r, i);
  const d = r * (1 - It);
  e.bezierCurveTo(a + o - d, i, a + o, i + d, a + o, i + r);
  const h = i + Math.max(l, r);
  e.lineTo(a + o, h), e.lineTo(a + o - u, h);
  const C = Math.max(r - u, 0), E = Math.max(r - l, 0), I = C * (1 - It), b = E * (1 - It);
  e.bezierCurveTo(a + o - u, i + l + b, a + o - u - I, i + l, a + o - u - C, i + l), e.lineTo(a + Math.max(n, g), i + l);
  const y = Math.max(n - g, 0), p = Math.max(n - l, 0), Q = y * (1 - It), w = p * (1 - It), Y = i + Math.max(l, n);
  e.bezierCurveTo(a + g + Q, i + l, a + g, i + l + w, a + g, Y), e.lineTo(a, Y), e.lineTo(a, i + n);
  const k = n * (1 - It);
  if (e.bezierCurveTo(a, i + k, a + k, i, a + n, i), e.closePath(), e.clip(), u) {
    const L = -l / u;
    e.moveTo(a + o / 2, L * (-o / 2) + i), e.lineTo(a + o, i), e.lineTo(a, i), e.lineTo(a, i + s), e.closePath(), e.clip();
  }
  if (g) {
    const L = -l / g;
    e.moveTo(a + o / 2, L * (-o / 2) + i), e.lineTo(a, i), e.lineTo(a + o, i), e.lineTo(a + o, i + s), e.closePath(), e.clip();
  }
}, hT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o
  } = A, {
    borderTopColor: s,
    borderTopWidth: l,
    borderTopStyle: u,
    borderRightWidth: g,
    borderLeftWidth: d
  } = t, h = n * (1 - It), C = r * (1 - It);
  e.moveTo(a, i + Math.max(n, l)), e.bezierCurveTo(a, i + h, a + h, i, a + n, i), e.lineTo(a + o - r, i), e.bezierCurveTo(a + o - C, i, a + o, i + C, a + o, i + r), e.strokeColor(s), e.lineWidth(Math.max(g, l, d) * 2), u === "dashed" ? e.dash(l * 2, {
    space: l * 1.2
  }) : u === "dotted" && e.dash(l, {
    space: l * 1.2
  }), e.stroke(), e.undash();
}, CT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderTopWidth: l,
    borderRightWidth: u,
    borderBottomWidth: g
  } = t;
  e.moveTo(a + o, i + r), e.lineTo(a + o, i + s - n);
  const d = n * (1 - It);
  e.bezierCurveTo(a + o, i + s - d, a + o - d, i + s, a + o - n, i + s);
  const h = a + o - Math.max(u, n);
  e.lineTo(h, i + s), e.lineTo(h, i + s - g);
  const C = Math.max(n - u, 0), E = Math.max(n - g, 0), I = C * (1 - It), b = E * (1 - It);
  e.bezierCurveTo(a + o - u - I, i + s - g, a + o - u, i + s - g - b, a + o - u, i + s - Math.max(n, g)), e.lineTo(a + o - u, i + Math.max(r, l));
  const y = Math.max(r - u, 0), p = Math.max(r - l, 0), Q = y * (1 - It), w = p * (1 - It), Y = a + o - Math.max(r, u);
  e.bezierCurveTo(a + o - u, i + l + w, a + o - u - Q, i + l, Y, i + l), e.lineTo(Y, i), e.lineTo(a + o - r, i);
  const k = r * (1 - It);
  if (e.bezierCurveTo(a + o - k, i, a + o, i + k, a + o, i + r), e.closePath(), e.clip(), l) {
    const L = -l / u;
    e.moveTo(a + o / 2, L * (-o / 2) + i), e.lineTo(a + o, i), e.lineTo(a + o, i + s), e.lineTo(a, i + s), e.closePath(), e.clip();
  }
  if (g) {
    const L = g / u;
    e.moveTo(a + o / 2, L * (-o / 2) + i + s), e.lineTo(a + o, i + s), e.lineTo(a + o, i), e.lineTo(a, i), e.closePath(), e.clip();
  }
}, ET = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderRightColor: l,
    borderRightStyle: u,
    borderRightWidth: g,
    borderTopWidth: d,
    borderBottomWidth: h
  } = t, C = n * (1 - It), E = r * (1 - It);
  e.moveTo(a + o - r, i), e.bezierCurveTo(a + o - E, i, a + o, i + E, a + o, i + r), e.lineTo(a + o, i + s - n), e.bezierCurveTo(a + o, i + s - C, a + o - C, i + s, a + o - n, i + s), e.strokeColor(l), e.lineWidth(Math.max(g, d, h) * 2), u === "dashed" ? e.dash(g * 2, {
    space: g * 1.2
  }) : u === "dotted" && e.dash(g, {
    space: g * 1.2
  }), e.stroke(), e.undash();
}, QT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderBottomWidth: l,
    borderRightWidth: u,
    borderLeftWidth: g
  } = t;
  e.moveTo(a + o - n, i + s), e.lineTo(a + r, i + s);
  const d = r * (1 - It);
  e.bezierCurveTo(a + d, i + s, a, i + s - d, a, i + s - r);
  const h = i + s - Math.max(l, r);
  e.lineTo(a, h), e.lineTo(a + g, h);
  const C = Math.max(r - g, 0), E = Math.max(r - l, 0), I = C * (1 - It), b = E * (1 - It);
  e.bezierCurveTo(a + g, i + s - l - b, a + g + I, i + s - l, a + g + C, i + s - l), e.lineTo(a + o - Math.max(n, u), i + s - l);
  const y = Math.max(n - u, 0), p = Math.max(n - l, 0), Q = y * (1 - It), w = p * (1 - It), Y = i + s - Math.max(l, n);
  e.bezierCurveTo(a + o - u - Q, i + s - l, a + o - u, i + s - l - w, a + o - u, Y), e.lineTo(a + o, Y), e.lineTo(a + o, i + s - n);
  const k = n * (1 - It);
  if (e.bezierCurveTo(a + o, i + s - k, a + o - k, i + s, a + o - n, i + s), e.closePath(), e.clip(), u) {
    const L = l / u;
    e.moveTo(a + o / 2, L * (-o / 2) + i + s), e.lineTo(a + o, i + s), e.lineTo(a, i + s), e.lineTo(a, i), e.closePath(), e.clip();
  }
  if (g) {
    const L = -l / g;
    e.moveTo(a + o / 2, L * (o / 2) + i + s), e.lineTo(a, i + s), e.lineTo(a + o, i + s), e.lineTo(a + o, i), e.closePath(), e.clip();
  }
}, wT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderBottomColor: l,
    borderBottomStyle: u,
    borderBottomWidth: g,
    borderRightWidth: d,
    borderLeftWidth: h
  } = t, C = r * (1 - It), E = n * (1 - It);
  e.moveTo(a + o, i + s - n), e.bezierCurveTo(a + o, i + s - E, a + o - E, i + s, a + o - n, i + s), e.lineTo(a + r, i + s), e.bezierCurveTo(a + C, i + s, a, i + s - C, a, i + s - r), e.strokeColor(l), e.lineWidth(Math.max(g, d, h) * 2), u === "dashed" ? e.dash(g * 2, {
    space: g * 1.2
  }) : u === "dotted" && e.dash(g, {
    space: g * 1.2
  }), e.stroke(), e.undash();
}, IT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    width: o,
    height: s
  } = A, {
    borderTopWidth: l,
    borderLeftWidth: u,
    borderBottomWidth: g
  } = t;
  e.moveTo(a, i + s - r), e.lineTo(a, i + n);
  const d = n * (1 - It);
  e.bezierCurveTo(a, i + d, a + d, i, a + n, i);
  const h = a + Math.max(u, n);
  e.lineTo(h, i), e.lineTo(h, i + l);
  const C = Math.max(n - u, 0), E = Math.max(n - l, 0), I = C * (1 - It), b = E * (1 - It);
  e.bezierCurveTo(a + u + I, i + l, a + u, i + l + b, a + u, i + Math.max(n, l)), e.lineTo(a + u, i + s - Math.max(r, g));
  const y = Math.max(r - u, 0), p = Math.max(r - g, 0), Q = y * (1 - It), w = p * (1 - It), Y = a + Math.max(r, u);
  e.bezierCurveTo(a + u, i + s - g - w, a + u + Q, i + s - g, Y, i + s - g), e.lineTo(Y, i + s), e.lineTo(a + r, i + s);
  const k = r * (1 - It);
  if (e.bezierCurveTo(a + k, i + s, a, i + s - k, a, i + s - r), e.closePath(), e.clip(), g) {
    const L = -g / u;
    e.moveTo(a + o / 2, L * (o / 2) + i + s), e.lineTo(a, i + s), e.lineTo(a, i), e.lineTo(a + o, i), e.closePath(), e.clip();
  }
  if (g) {
    const L = -l / u;
    e.moveTo(a + o / 2, L * (-o / 2) + i), e.lineTo(a, i), e.lineTo(a, i + s), e.lineTo(a + o, i + s), e.closePath(), e.clip();
  }
}, DT = (e, A, t, r, n) => {
  const {
    top: i,
    left: a,
    height: o
  } = A, {
    borderLeftColor: s,
    borderLeftStyle: l,
    borderLeftWidth: u,
    borderTopWidth: g,
    borderBottomWidth: d
  } = t, h = r * (1 - It), C = n * (1 - It);
  e.moveTo(a + r, i + o), e.bezierCurveTo(a + h, i + o, a, i + o - h, a, i + o - r), e.lineTo(a, i + n), e.bezierCurveTo(a, i + C, a + C, i, a + n, i), e.strokeColor(s), e.lineWidth(Math.max(u, g, d) * 2), l === "dashed" ? e.dash(u * 2, {
    space: u * 1.2
  }) : l === "dotted" && e.dash(u, {
    space: u * 1.2
  }), e.stroke(), e.undash();
}, mT = (e) => e.box && (e.box.borderTopWidth || e.box.borderRightWidth || e.box.borderBottomWidth || e.box.borderLeftWidth), MT = (e, A) => {
  if (!mT(A)) return;
  const {
    width: t,
    height: r,
    borderTopWidth: n,
    borderLeftWidth: i,
    borderRightWidth: a,
    borderBottomWidth: o
  } = A.box, {
    opacity: s,
    borderTopLeftRadius: l = 0,
    borderTopRightRadius: u = 0,
    borderBottomLeftRadius: g = 0,
    borderBottomRightRadius: d = 0,
    borderTopColor: h = "black",
    borderTopStyle: C = "solid",
    borderLeftColor: E = "black",
    borderLeftStyle: I = "solid",
    borderRightColor: b = "black",
    borderRightStyle: y = "solid",
    borderBottomColor: p = "black",
    borderBottomStyle: Q = "solid"
  } = A.style, w = {
    borderTopColor: h,
    borderTopWidth: n,
    borderTopStyle: C,
    borderLeftColor: E,
    borderLeftWidth: i,
    borderLeftStyle: I,
    borderRightColor: b,
    borderRightWidth: a,
    borderRightStyle: y,
    borderBottomColor: p,
    borderBottomWidth: o,
    borderBottomStyle: Q,
    borderTopLeftRadius: l,
    borderTopRightRadius: u,
    borderBottomLeftRadius: g,
    borderBottomRightRadius: d
  }, Y = Math.min(u, 0.5 * t, 0.5 * r), k = Math.min(l, 0.5 * t, 0.5 * r), L = Math.min(d, 0.5 * t, 0.5 * r), S = Math.min(g, 0.5 * t, 0.5 * r);
  e.save(), e.strokeOpacity(s), n && (e.save(), dT(e, A.box, w, Y, k), hT(e, A.box, w, Y, k), e.restore()), a && (e.save(), CT(e, A.box, w, Y, L), ET(e, A.box, w, Y, L), e.restore()), o && (e.save(), QT(e, A.box, w, S, L), wT(e, A.box, w, S, L), e.restore()), i && (e.save(), IT(e, A.box, w, S, k), DT(e, A.box, w, S, k), e.restore()), e.restore();
}, pT = (e, A) => {
  var t;
  const {
    top: r,
    left: n,
    width: i,
    height: a
  } = A.box, o = RC(A.style.backgroundColor), s = yt((t = A.style) === null || t === void 0 ? void 0 : t.opacity) ? 1 : A.style.opacity, l = Math.min(o.opacity, s);
  e.fillOpacity(l).fillColor(o.value).rect(n, r, i, a).fill();
}, vT = (e, A) => {
  var t;
  !!A.box && !!((t = A.style) !== null && t !== void 0 && t.backgroundColor) && (e.save(), Wg(e, A), pT(e, A), e.restore());
}, yT = (e) => /^#.+/.test(e), bT = (e, A) => {
  const t = A.props || {}, {
    top: r,
    left: n,
    width: i,
    height: a
  } = A.box, o = t.src || t.href;
  if (o) {
    const s = yT(o), l = s ? "goTo" : "link", u = s ? o.slice(1) : o;
    e[l](n, r, i, a, u);
  }
}, FT = (e, A) => {
  var t;
  (t = A.props) !== null && t !== void 0 && t.id && e.addNamedDestination(A.props.id, "XYZ", null, A.box.top, null);
}, LT = (e) => e.type !== Ue && e.type !== oi, RT = (e, A, t) => {
  e.save(), A.box && e.translate(A.box.left, A.box.top);
  const r = A.children || [], n = (i) => Gm(e, i, t);
  r.forEach(n), e.restore();
}, GT = {
  [Ue]: ZN,
  [Rg]: _N,
  [Xi]: tT,
  [Gg]: fT,
  [oi]: HN,
  [Lg]: bT
}, Gm = (e, A, t) => {
  var r;
  const n = ((r = A.style) === null || r === void 0 ? void 0 : r.overflow) === "hidden", i = LT(A);
  A.type === os && KN(e, A), e.save(), n && Wg(e, A), pm(e, A), vT(e, A), MT(e, A);
  const a = GT[A.type];
  a && a(e, A, t), i && RT(e, A, t), FT(e, A), cT(e, A), e.restore();
}, xT = (e) => (A, t) => {
  t && (e.info[A] = t);
}, kT = (e, A) => {
  var t, r;
  const n = xT(e), i = A.props || {}, a = i.title || null, o = i.author || null, s = i.subject || null, l = i.keywords || null, u = (t = i.creator) != null ? t : "react-pdf", g = (r = i.producer) != null ? r : "react-pdf", d = i.creationDate || /* @__PURE__ */ new Date(), h = i.modificationDate || null;
  n("Title", a), n("Author", o), n("Subject", s), n("Keywords", l), n("Creator", u), n("Producer", g), n("CreationDate", d), n("ModificationDate", h);
}, xm = (e, A, t, r) => {
  var n;
  const i = (n = A.props) === null || n === void 0 ? void 0 : n.bookmark;
  if (i) {
    const {
      title: a,
      parent: o,
      expanded: s,
      zoom: l,
      fit: u
    } = i, g = r[o] || e.outline, d = i.top || A.box.top, h = i.left || A.box.left, C = g.addItem(a, {
      pageNumber: t,
      expanded: s,
      top: d,
      left: h,
      zoom: l,
      fit: u
    });
    r[i.ref] = C;
  }
  A.children && A.children.forEach((a) => xm(e, a, t, r));
}, UT = (e, A) => {
  const t = {};
  (A.children || []).forEach((n, i) => {
    xm(e, n, i, t);
  });
}, YT = (e, A) => {
  const t = A.children || [], r = {
    imageCache: /* @__PURE__ */ new Map()
  };
  return kT(e, A), t.forEach((n) => Gm(e, n, r)), UT(e, A), e.end(), e;
};
var zf, QI;
function HT() {
  if (QI) return zf;
  QI = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return zf = e, zf;
}
var ST = HT();
const NT = /* @__PURE__ */ Ht(ST);
var Pn = {}, jf = {}, wI;
function Zg() {
  return wI || (wI = 1, function(e) {
    var A = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function t(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var o = a.shift();
        if (o) {
          if (typeof o != "object")
            throw new TypeError(o + "must be non-object");
          for (var s in o)
            t(o, s) && (i[s] = o[s]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, o, s, l) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(o, o + s), l);
          return;
        }
        for (var u = 0; u < s; u++)
          i[l + u] = a[o + u];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, o, s, l, u, g;
        for (s = 0, a = 0, o = i.length; a < o; a++)
          s += i[a].length;
        for (g = new Uint8Array(s), l = 0, a = 0, o = i.length; a < o; a++)
          u = i[a], g.set(u, l), l += u.length;
        return g;
      }
    }, n = {
      arraySet: function(i, a, o, s, l) {
        for (var u = 0; u < s; u++)
          i[l + u] = a[o + u];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, n));
    }, e.setTyped(A);
  }(jf)), jf;
}
var wa = {}, II;
function TT() {
  if (II) return wa;
  II = 1;
  var e = Zg(), A = 4, t = 0, r = 1, n = 2;
  function i(W) {
    for (var yA = W.length; --yA >= 0; )
      W[yA] = 0;
  }
  var a = 0, o = 1, s = 2, l = 3, u = 258, g = 29, d = 256, h = d + 1 + g, C = 30, E = 19, I = 2 * h + 1, b = 15, y = 16, p = 7, Q = 256, w = 16, Y = 17, k = 18, L = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), S = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), P = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), Z = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], M = 512, R = new Array((h + 2) * 2);
  i(R);
  var G = new Array(C * 2);
  i(G);
  var N = new Array(M);
  i(N);
  var z = new Array(u - l + 1);
  i(z);
  var T = new Array(g);
  i(T);
  var O = new Array(C);
  i(O);
  function K(W, yA, xA, SA, eA) {
    this.static_tree = W, this.extra_bits = yA, this.extra_base = xA, this.elems = SA, this.max_length = eA, this.has_stree = W && W.length;
  }
  var AA, X, iA;
  function oA(W, yA) {
    this.dyn_tree = W, this.max_code = 0, this.stat_desc = yA;
  }
  function fA(W) {
    return W < 256 ? N[W] : N[256 + (W >>> 7)];
  }
  function wA(W, yA) {
    W.pending_buf[W.pending++] = yA & 255, W.pending_buf[W.pending++] = yA >>> 8 & 255;
  }
  function DA(W, yA, xA) {
    W.bi_valid > y - xA ? (W.bi_buf |= yA << W.bi_valid & 65535, wA(W, W.bi_buf), W.bi_buf = yA >> y - W.bi_valid, W.bi_valid += xA - y) : (W.bi_buf |= yA << W.bi_valid & 65535, W.bi_valid += xA);
  }
  function HA(W, yA, xA) {
    DA(
      W,
      xA[yA * 2],
      xA[yA * 2 + 1]
      /*.Len*/
    );
  }
  function sA(W, yA) {
    var xA = 0;
    do
      xA |= W & 1, W >>>= 1, xA <<= 1;
    while (--yA > 0);
    return xA >>> 1;
  }
  function lA(W) {
    W.bi_valid === 16 ? (wA(W, W.bi_buf), W.bi_buf = 0, W.bi_valid = 0) : W.bi_valid >= 8 && (W.pending_buf[W.pending++] = W.bi_buf & 255, W.bi_buf >>= 8, W.bi_valid -= 8);
  }
  function tA(W, yA) {
    var xA = yA.dyn_tree, SA = yA.max_code, eA = yA.stat_desc.static_tree, mA = yA.stat_desc.has_stree, H = yA.stat_desc.extra_bits, UA = yA.stat_desc.extra_base, ae = yA.stat_desc.max_length, D, CA, IA, V, $, dA, ce = 0;
    for (V = 0; V <= b; V++)
      W.bl_count[V] = 0;
    for (xA[W.heap[W.heap_max] * 2 + 1] = 0, D = W.heap_max + 1; D < I; D++)
      CA = W.heap[D], V = xA[xA[CA * 2 + 1] * 2 + 1] + 1, V > ae && (V = ae, ce++), xA[CA * 2 + 1] = V, !(CA > SA) && (W.bl_count[V]++, $ = 0, CA >= UA && ($ = H[CA - UA]), dA = xA[CA * 2], W.opt_len += dA * (V + $), mA && (W.static_len += dA * (eA[CA * 2 + 1] + $)));
    if (ce !== 0) {
      do {
        for (V = ae - 1; W.bl_count[V] === 0; )
          V--;
        W.bl_count[V]--, W.bl_count[V + 1] += 2, W.bl_count[ae]--, ce -= 2;
      } while (ce > 0);
      for (V = ae; V !== 0; V--)
        for (CA = W.bl_count[V]; CA !== 0; )
          IA = W.heap[--D], !(IA > SA) && (xA[IA * 2 + 1] !== V && (W.opt_len += (V - xA[IA * 2 + 1]) * xA[IA * 2], xA[IA * 2 + 1] = V), CA--);
    }
  }
  function nA(W, yA, xA) {
    var SA = new Array(b + 1), eA = 0, mA, H;
    for (mA = 1; mA <= b; mA++)
      SA[mA] = eA = eA + xA[mA - 1] << 1;
    for (H = 0; H <= yA; H++) {
      var UA = W[H * 2 + 1];
      UA !== 0 && (W[H * 2] = sA(SA[UA]++, UA));
    }
  }
  function GA() {
    var W, yA, xA, SA, eA, mA = new Array(b + 1);
    for (xA = 0, SA = 0; SA < g - 1; SA++)
      for (T[SA] = xA, W = 0; W < 1 << L[SA]; W++)
        z[xA++] = SA;
    for (z[xA - 1] = SA, eA = 0, SA = 0; SA < 16; SA++)
      for (O[SA] = eA, W = 0; W < 1 << S[SA]; W++)
        N[eA++] = SA;
    for (eA >>= 7; SA < C; SA++)
      for (O[SA] = eA << 7, W = 0; W < 1 << S[SA] - 7; W++)
        N[256 + eA++] = SA;
    for (yA = 0; yA <= b; yA++)
      mA[yA] = 0;
    for (W = 0; W <= 143; )
      R[W * 2 + 1] = 8, W++, mA[8]++;
    for (; W <= 255; )
      R[W * 2 + 1] = 9, W++, mA[9]++;
    for (; W <= 279; )
      R[W * 2 + 1] = 7, W++, mA[7]++;
    for (; W <= 287; )
      R[W * 2 + 1] = 8, W++, mA[8]++;
    for (nA(R, h + 1, mA), W = 0; W < C; W++)
      G[W * 2 + 1] = 5, G[W * 2] = sA(W, 5);
    AA = new K(R, L, d + 1, h, b), X = new K(G, S, 0, C, b), iA = new K(new Array(0), P, 0, E, p);
  }
  function ZA(W) {
    var yA;
    for (yA = 0; yA < h; yA++)
      W.dyn_ltree[yA * 2] = 0;
    for (yA = 0; yA < C; yA++)
      W.dyn_dtree[yA * 2] = 0;
    for (yA = 0; yA < E; yA++)
      W.bl_tree[yA * 2] = 0;
    W.dyn_ltree[Q * 2] = 1, W.opt_len = W.static_len = 0, W.last_lit = W.matches = 0;
  }
  function de(W) {
    W.bi_valid > 8 ? wA(W, W.bi_buf) : W.bi_valid > 0 && (W.pending_buf[W.pending++] = W.bi_buf), W.bi_buf = 0, W.bi_valid = 0;
  }
  function _A(W, yA, xA, SA) {
    de(W), wA(W, xA), wA(W, ~xA), e.arraySet(W.pending_buf, W.window, yA, xA, W.pending), W.pending += xA;
  }
  function Ce(W, yA, xA, SA) {
    var eA = yA * 2, mA = xA * 2;
    return W[eA] < W[mA] || W[eA] === W[mA] && SA[yA] <= SA[xA];
  }
  function WA(W, yA, xA) {
    for (var SA = W.heap[xA], eA = xA << 1; eA <= W.heap_len && (eA < W.heap_len && Ce(yA, W.heap[eA + 1], W.heap[eA], W.depth) && eA++, !Ce(yA, SA, W.heap[eA], W.depth)); )
      W.heap[xA] = W.heap[eA], xA = eA, eA <<= 1;
    W.heap[xA] = SA;
  }
  function gA(W, yA, xA) {
    var SA, eA, mA = 0, H, UA;
    if (W.last_lit !== 0)
      do
        SA = W.pending_buf[W.d_buf + mA * 2] << 8 | W.pending_buf[W.d_buf + mA * 2 + 1], eA = W.pending_buf[W.l_buf + mA], mA++, SA === 0 ? HA(W, eA, yA) : (H = z[eA], HA(W, H + d + 1, yA), UA = L[H], UA !== 0 && (eA -= T[H], DA(W, eA, UA)), SA--, H = fA(SA), HA(W, H, xA), UA = S[H], UA !== 0 && (SA -= O[H], DA(W, SA, UA)));
      while (mA < W.last_lit);
    HA(W, Q, yA);
  }
  function ie(W, yA) {
    var xA = yA.dyn_tree, SA = yA.stat_desc.static_tree, eA = yA.stat_desc.has_stree, mA = yA.stat_desc.elems, H, UA, ae = -1, D;
    for (W.heap_len = 0, W.heap_max = I, H = 0; H < mA; H++)
      xA[H * 2] !== 0 ? (W.heap[++W.heap_len] = ae = H, W.depth[H] = 0) : xA[H * 2 + 1] = 0;
    for (; W.heap_len < 2; )
      D = W.heap[++W.heap_len] = ae < 2 ? ++ae : 0, xA[D * 2] = 1, W.depth[D] = 0, W.opt_len--, eA && (W.static_len -= SA[D * 2 + 1]);
    for (yA.max_code = ae, H = W.heap_len >> 1; H >= 1; H--)
      WA(W, xA, H);
    D = mA;
    do
      H = W.heap[
        1
        /*SMALLEST*/
      ], W.heap[
        1
        /*SMALLEST*/
      ] = W.heap[W.heap_len--], WA(
        W,
        xA,
        1
        /*SMALLEST*/
      ), UA = W.heap[
        1
        /*SMALLEST*/
      ], W.heap[--W.heap_max] = H, W.heap[--W.heap_max] = UA, xA[D * 2] = xA[H * 2] + xA[UA * 2], W.depth[D] = (W.depth[H] >= W.depth[UA] ? W.depth[H] : W.depth[UA]) + 1, xA[H * 2 + 1] = xA[UA * 2 + 1] = D, W.heap[
        1
        /*SMALLEST*/
      ] = D++, WA(
        W,
        xA,
        1
        /*SMALLEST*/
      );
    while (W.heap_len >= 2);
    W.heap[--W.heap_max] = W.heap[
      1
      /*SMALLEST*/
    ], tA(W, yA), nA(xA, ae, W.bl_count);
  }
  function Qe(W, yA, xA) {
    var SA, eA = -1, mA, H = yA[0 * 2 + 1], UA = 0, ae = 7, D = 4;
    for (H === 0 && (ae = 138, D = 3), yA[(xA + 1) * 2 + 1] = 65535, SA = 0; SA <= xA; SA++)
      mA = H, H = yA[(SA + 1) * 2 + 1], !(++UA < ae && mA === H) && (UA < D ? W.bl_tree[mA * 2] += UA : mA !== 0 ? (mA !== eA && W.bl_tree[mA * 2]++, W.bl_tree[w * 2]++) : UA <= 10 ? W.bl_tree[Y * 2]++ : W.bl_tree[k * 2]++, UA = 0, eA = mA, H === 0 ? (ae = 138, D = 3) : mA === H ? (ae = 6, D = 3) : (ae = 7, D = 4));
  }
  function OA(W, yA, xA) {
    var SA, eA = -1, mA, H = yA[0 * 2 + 1], UA = 0, ae = 7, D = 4;
    for (H === 0 && (ae = 138, D = 3), SA = 0; SA <= xA; SA++)
      if (mA = H, H = yA[(SA + 1) * 2 + 1], !(++UA < ae && mA === H)) {
        if (UA < D)
          do
            HA(W, mA, W.bl_tree);
          while (--UA !== 0);
        else mA !== 0 ? (mA !== eA && (HA(W, mA, W.bl_tree), UA--), HA(W, w, W.bl_tree), DA(W, UA - 3, 2)) : UA <= 10 ? (HA(W, Y, W.bl_tree), DA(W, UA - 3, 3)) : (HA(W, k, W.bl_tree), DA(W, UA - 11, 7));
        UA = 0, eA = mA, H === 0 ? (ae = 138, D = 3) : mA === H ? (ae = 6, D = 3) : (ae = 7, D = 4);
      }
  }
  function we(W) {
    var yA;
    for (Qe(W, W.dyn_ltree, W.l_desc.max_code), Qe(W, W.dyn_dtree, W.d_desc.max_code), ie(W, W.bl_desc), yA = E - 1; yA >= 3 && W.bl_tree[Z[yA] * 2 + 1] === 0; yA--)
      ;
    return W.opt_len += 3 * (yA + 1) + 5 + 5 + 4, yA;
  }
  function se(W, yA, xA, SA) {
    var eA;
    for (DA(W, yA - 257, 5), DA(W, xA - 1, 5), DA(W, SA - 4, 4), eA = 0; eA < SA; eA++)
      DA(W, W.bl_tree[Z[eA] * 2 + 1], 3);
    OA(W, W.dyn_ltree, yA - 1), OA(W, W.dyn_dtree, xA - 1);
  }
  function ue(W) {
    var yA = 4093624447, xA;
    for (xA = 0; xA <= 31; xA++, yA >>>= 1)
      if (yA & 1 && W.dyn_ltree[xA * 2] !== 0)
        return t;
    if (W.dyn_ltree[9 * 2] !== 0 || W.dyn_ltree[10 * 2] !== 0 || W.dyn_ltree[13 * 2] !== 0)
      return r;
    for (xA = 32; xA < d; xA++)
      if (W.dyn_ltree[xA * 2] !== 0)
        return r;
    return t;
  }
  var ge = !1;
  function Pe(W) {
    ge || (GA(), ge = !0), W.l_desc = new oA(W.dyn_ltree, AA), W.d_desc = new oA(W.dyn_dtree, X), W.bl_desc = new oA(W.bl_tree, iA), W.bi_buf = 0, W.bi_valid = 0, ZA(W);
  }
  function le(W, yA, xA, SA) {
    DA(W, (a << 1) + (SA ? 1 : 0), 3), _A(W, yA, xA);
  }
  function pe(W) {
    DA(W, o << 1, 3), HA(W, Q, R), lA(W);
  }
  function Ze(W, yA, xA, SA) {
    var eA, mA, H = 0;
    W.level > 0 ? (W.strm.data_type === n && (W.strm.data_type = ue(W)), ie(W, W.l_desc), ie(W, W.d_desc), H = we(W), eA = W.opt_len + 3 + 7 >>> 3, mA = W.static_len + 3 + 7 >>> 3, mA <= eA && (eA = mA)) : eA = mA = xA + 5, xA + 4 <= eA && yA !== -1 ? le(W, yA, xA, SA) : W.strategy === A || mA === eA ? (DA(W, (o << 1) + (SA ? 1 : 0), 3), gA(W, R, G)) : (DA(W, (s << 1) + (SA ? 1 : 0), 3), se(W, W.l_desc.max_code + 1, W.d_desc.max_code + 1, H + 1), gA(W, W.dyn_ltree, W.dyn_dtree)), ZA(W), SA && de(W);
  }
  function je(W, yA, xA) {
    return W.pending_buf[W.d_buf + W.last_lit * 2] = yA >>> 8 & 255, W.pending_buf[W.d_buf + W.last_lit * 2 + 1] = yA & 255, W.pending_buf[W.l_buf + W.last_lit] = xA & 255, W.last_lit++, yA === 0 ? W.dyn_ltree[xA * 2]++ : (W.matches++, yA--, W.dyn_ltree[(z[xA] + d + 1) * 2]++, W.dyn_dtree[fA(yA) * 2]++), W.last_lit === W.lit_bufsize - 1;
  }
  return wa._tr_init = Pe, wa._tr_stored_block = le, wa._tr_flush_block = Ze, wa._tr_tally = je, wa._tr_align = pe, wa;
}
var Vf, DI;
function km() {
  if (DI) return Vf;
  DI = 1;
  function e(A, t, r, n) {
    for (var i = A & 65535 | 0, a = A >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
      o = r > 2e3 ? 2e3 : r, r -= o;
      do
        i = i + t[n++] | 0, a = a + i | 0;
      while (--o);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Vf = e, Vf;
}
var Of, mI;
function Um() {
  if (mI) return Of;
  mI = 1;
  function e() {
    for (var r, n = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      n[i] = r;
    }
    return n;
  }
  var A = e();
  function t(r, n, i, a) {
    var o = A, s = a + i;
    r ^= -1;
    for (var l = a; l < s; l++)
      r = r >>> 8 ^ o[(r ^ n[l]) & 255];
    return r ^ -1;
  }
  return Of = t, Of;
}
var Jf, MI;
function PT() {
  return MI || (MI = 1, Jf = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Jf;
}
var pI;
function zT() {
  if (pI) return Pn;
  pI = 1;
  var e = Zg(), A = TT(), t = km(), r = Um(), n = PT(), i = 0, a = 1, o = 3, s = 4, l = 5, u = 0, g = 1, d = -2, h = -3, C = -5, E = -1, I = 1, b = 2, y = 3, p = 4, Q = 0, w = 2, Y = 8, k = 9, L = 15, S = 8, P = 29, Z = 256, M = Z + 1 + P, R = 30, G = 19, N = 2 * M + 1, z = 15, T = 3, O = 258, K = O + T + 1, AA = 32, X = 42, iA = 69, oA = 73, fA = 91, wA = 103, DA = 113, HA = 666, sA = 1, lA = 2, tA = 3, nA = 4, GA = 3;
  function ZA(D, CA) {
    return D.msg = n[CA], CA;
  }
  function de(D) {
    return (D << 1) - (D > 4 ? 9 : 0);
  }
  function _A(D) {
    for (var CA = D.length; --CA >= 0; )
      D[CA] = 0;
  }
  function Ce(D) {
    var CA = D.state, IA = CA.pending;
    IA > D.avail_out && (IA = D.avail_out), IA !== 0 && (e.arraySet(D.output, CA.pending_buf, CA.pending_out, IA, D.next_out), D.next_out += IA, CA.pending_out += IA, D.total_out += IA, D.avail_out -= IA, CA.pending -= IA, CA.pending === 0 && (CA.pending_out = 0));
  }
  function WA(D, CA) {
    A._tr_flush_block(D, D.block_start >= 0 ? D.block_start : -1, D.strstart - D.block_start, CA), D.block_start = D.strstart, Ce(D.strm);
  }
  function gA(D, CA) {
    D.pending_buf[D.pending++] = CA;
  }
  function ie(D, CA) {
    D.pending_buf[D.pending++] = CA >>> 8 & 255, D.pending_buf[D.pending++] = CA & 255;
  }
  function Qe(D, CA, IA, V) {
    var $ = D.avail_in;
    return $ > V && ($ = V), $ === 0 ? 0 : (D.avail_in -= $, e.arraySet(CA, D.input, D.next_in, $, IA), D.state.wrap === 1 ? D.adler = t(D.adler, CA, $, IA) : D.state.wrap === 2 && (D.adler = r(D.adler, CA, $, IA)), D.next_in += $, D.total_in += $, $);
  }
  function OA(D, CA) {
    var IA = D.max_chain_length, V = D.strstart, $, dA, ce = D.prev_length, NA = D.nice_match, XA = D.strstart > D.w_size - K ? D.strstart - (D.w_size - K) : 0, ke = D.window, Ne = D.w_mask, Ie = D.prev, be = D.strstart + O, Ye = ke[V + ce - 1], ye = ke[V + ce];
    D.prev_length >= D.good_match && (IA >>= 2), NA > D.lookahead && (NA = D.lookahead);
    do
      if ($ = CA, !(ke[$ + ce] !== ye || ke[$ + ce - 1] !== Ye || ke[$] !== ke[V] || ke[++$] !== ke[V + 1])) {
        V += 2, $++;
        do
          ;
        while (ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && ke[++V] === ke[++$] && V < be);
        if (dA = O - (be - V), V = be - O, dA > ce) {
          if (D.match_start = CA, ce = dA, dA >= NA)
            break;
          Ye = ke[V + ce - 1], ye = ke[V + ce];
        }
      }
    while ((CA = Ie[CA & Ne]) > XA && --IA !== 0);
    return ce <= D.lookahead ? ce : D.lookahead;
  }
  function we(D) {
    var CA = D.w_size, IA, V, $, dA, ce;
    do {
      if (dA = D.window_size - D.lookahead - D.strstart, D.strstart >= CA + (CA - K)) {
        e.arraySet(D.window, D.window, CA, CA, 0), D.match_start -= CA, D.strstart -= CA, D.block_start -= CA, V = D.hash_size, IA = V;
        do
          $ = D.head[--IA], D.head[IA] = $ >= CA ? $ - CA : 0;
        while (--V);
        V = CA, IA = V;
        do
          $ = D.prev[--IA], D.prev[IA] = $ >= CA ? $ - CA : 0;
        while (--V);
        dA += CA;
      }
      if (D.strm.avail_in === 0)
        break;
      if (V = Qe(D.strm, D.window, D.strstart + D.lookahead, dA), D.lookahead += V, D.lookahead + D.insert >= T)
        for (ce = D.strstart - D.insert, D.ins_h = D.window[ce], D.ins_h = (D.ins_h << D.hash_shift ^ D.window[ce + 1]) & D.hash_mask; D.insert && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[ce + T - 1]) & D.hash_mask, D.prev[ce & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = ce, ce++, D.insert--, !(D.lookahead + D.insert < T)); )
          ;
    } while (D.lookahead < K && D.strm.avail_in !== 0);
  }
  function se(D, CA) {
    var IA = 65535;
    for (IA > D.pending_buf_size - 5 && (IA = D.pending_buf_size - 5); ; ) {
      if (D.lookahead <= 1) {
        if (we(D), D.lookahead === 0 && CA === i)
          return sA;
        if (D.lookahead === 0)
          break;
      }
      D.strstart += D.lookahead, D.lookahead = 0;
      var V = D.block_start + IA;
      if ((D.strstart === 0 || D.strstart >= V) && (D.lookahead = D.strstart - V, D.strstart = V, WA(D, !1), D.strm.avail_out === 0) || D.strstart - D.block_start >= D.w_size - K && (WA(D, !1), D.strm.avail_out === 0))
        return sA;
    }
    return D.insert = 0, CA === s ? (WA(D, !0), D.strm.avail_out === 0 ? tA : nA) : (D.strstart > D.block_start && (WA(D, !1), D.strm.avail_out === 0), sA);
  }
  function ue(D, CA) {
    for (var IA, V; ; ) {
      if (D.lookahead < K) {
        if (we(D), D.lookahead < K && CA === i)
          return sA;
        if (D.lookahead === 0)
          break;
      }
      if (IA = 0, D.lookahead >= T && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + T - 1]) & D.hash_mask, IA = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart), IA !== 0 && D.strstart - IA <= D.w_size - K && (D.match_length = OA(D, IA)), D.match_length >= T)
        if (V = A._tr_tally(D, D.strstart - D.match_start, D.match_length - T), D.lookahead -= D.match_length, D.match_length <= D.max_lazy_match && D.lookahead >= T) {
          D.match_length--;
          do
            D.strstart++, D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + T - 1]) & D.hash_mask, IA = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart;
          while (--D.match_length !== 0);
          D.strstart++;
        } else
          D.strstart += D.match_length, D.match_length = 0, D.ins_h = D.window[D.strstart], D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + 1]) & D.hash_mask;
      else
        V = A._tr_tally(D, 0, D.window[D.strstart]), D.lookahead--, D.strstart++;
      if (V && (WA(D, !1), D.strm.avail_out === 0))
        return sA;
    }
    return D.insert = D.strstart < T - 1 ? D.strstart : T - 1, CA === s ? (WA(D, !0), D.strm.avail_out === 0 ? tA : nA) : D.last_lit && (WA(D, !1), D.strm.avail_out === 0) ? sA : lA;
  }
  function ge(D, CA) {
    for (var IA, V, $; ; ) {
      if (D.lookahead < K) {
        if (we(D), D.lookahead < K && CA === i)
          return sA;
        if (D.lookahead === 0)
          break;
      }
      if (IA = 0, D.lookahead >= T && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + T - 1]) & D.hash_mask, IA = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart), D.prev_length = D.match_length, D.prev_match = D.match_start, D.match_length = T - 1, IA !== 0 && D.prev_length < D.max_lazy_match && D.strstart - IA <= D.w_size - K && (D.match_length = OA(D, IA), D.match_length <= 5 && (D.strategy === I || D.match_length === T && D.strstart - D.match_start > 4096) && (D.match_length = T - 1)), D.prev_length >= T && D.match_length <= D.prev_length) {
        $ = D.strstart + D.lookahead - T, V = A._tr_tally(D, D.strstart - 1 - D.prev_match, D.prev_length - T), D.lookahead -= D.prev_length - 1, D.prev_length -= 2;
        do
          ++D.strstart <= $ && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + T - 1]) & D.hash_mask, IA = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart);
        while (--D.prev_length !== 0);
        if (D.match_available = 0, D.match_length = T - 1, D.strstart++, V && (WA(D, !1), D.strm.avail_out === 0))
          return sA;
      } else if (D.match_available) {
        if (V = A._tr_tally(D, 0, D.window[D.strstart - 1]), V && WA(D, !1), D.strstart++, D.lookahead--, D.strm.avail_out === 0)
          return sA;
      } else
        D.match_available = 1, D.strstart++, D.lookahead--;
    }
    return D.match_available && (V = A._tr_tally(D, 0, D.window[D.strstart - 1]), D.match_available = 0), D.insert = D.strstart < T - 1 ? D.strstart : T - 1, CA === s ? (WA(D, !0), D.strm.avail_out === 0 ? tA : nA) : D.last_lit && (WA(D, !1), D.strm.avail_out === 0) ? sA : lA;
  }
  function Pe(D, CA) {
    for (var IA, V, $, dA, ce = D.window; ; ) {
      if (D.lookahead <= O) {
        if (we(D), D.lookahead <= O && CA === i)
          return sA;
        if (D.lookahead === 0)
          break;
      }
      if (D.match_length = 0, D.lookahead >= T && D.strstart > 0 && ($ = D.strstart - 1, V = ce[$], V === ce[++$] && V === ce[++$] && V === ce[++$])) {
        dA = D.strstart + O;
        do
          ;
        while (V === ce[++$] && V === ce[++$] && V === ce[++$] && V === ce[++$] && V === ce[++$] && V === ce[++$] && V === ce[++$] && V === ce[++$] && $ < dA);
        D.match_length = O - (dA - $), D.match_length > D.lookahead && (D.match_length = D.lookahead);
      }
      if (D.match_length >= T ? (IA = A._tr_tally(D, 1, D.match_length - T), D.lookahead -= D.match_length, D.strstart += D.match_length, D.match_length = 0) : (IA = A._tr_tally(D, 0, D.window[D.strstart]), D.lookahead--, D.strstart++), IA && (WA(D, !1), D.strm.avail_out === 0))
        return sA;
    }
    return D.insert = 0, CA === s ? (WA(D, !0), D.strm.avail_out === 0 ? tA : nA) : D.last_lit && (WA(D, !1), D.strm.avail_out === 0) ? sA : lA;
  }
  function le(D, CA) {
    for (var IA; ; ) {
      if (D.lookahead === 0 && (we(D), D.lookahead === 0)) {
        if (CA === i)
          return sA;
        break;
      }
      if (D.match_length = 0, IA = A._tr_tally(D, 0, D.window[D.strstart]), D.lookahead--, D.strstart++, IA && (WA(D, !1), D.strm.avail_out === 0))
        return sA;
    }
    return D.insert = 0, CA === s ? (WA(D, !0), D.strm.avail_out === 0 ? tA : nA) : D.last_lit && (WA(D, !1), D.strm.avail_out === 0) ? sA : lA;
  }
  function pe(D, CA, IA, V, $) {
    this.good_length = D, this.max_lazy = CA, this.nice_length = IA, this.max_chain = V, this.func = $;
  }
  var Ze;
  Ze = [
    /*      good lazy nice chain */
    new pe(0, 0, 0, 0, se),
    /* 0 store only */
    new pe(4, 4, 8, 4, ue),
    /* 1 max speed, no lazy matches */
    new pe(4, 5, 16, 8, ue),
    /* 2 */
    new pe(4, 6, 32, 32, ue),
    /* 3 */
    new pe(4, 4, 16, 16, ge),
    /* 4 lazy matches */
    new pe(8, 16, 32, 32, ge),
    /* 5 */
    new pe(8, 16, 128, 128, ge),
    /* 6 */
    new pe(8, 32, 128, 256, ge),
    /* 7 */
    new pe(32, 128, 258, 1024, ge),
    /* 8 */
    new pe(32, 258, 258, 4096, ge)
    /* 9 max compression */
  ];
  function je(D) {
    D.window_size = 2 * D.w_size, _A(D.head), D.max_lazy_match = Ze[D.level].max_lazy, D.good_match = Ze[D.level].good_length, D.nice_match = Ze[D.level].nice_length, D.max_chain_length = Ze[D.level].max_chain, D.strstart = 0, D.block_start = 0, D.lookahead = 0, D.insert = 0, D.match_length = D.prev_length = T - 1, D.match_available = 0, D.ins_h = 0;
  }
  function W() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Y, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(N * 2), this.dyn_dtree = new e.Buf16((2 * R + 1) * 2), this.bl_tree = new e.Buf16((2 * G + 1) * 2), _A(this.dyn_ltree), _A(this.dyn_dtree), _A(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(z + 1), this.heap = new e.Buf16(2 * M + 1), _A(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * M + 1), _A(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function yA(D) {
    var CA;
    return !D || !D.state ? ZA(D, d) : (D.total_in = D.total_out = 0, D.data_type = w, CA = D.state, CA.pending = 0, CA.pending_out = 0, CA.wrap < 0 && (CA.wrap = -CA.wrap), CA.status = CA.wrap ? X : DA, D.adler = CA.wrap === 2 ? 0 : 1, CA.last_flush = i, A._tr_init(CA), u);
  }
  function xA(D) {
    var CA = yA(D);
    return CA === u && je(D.state), CA;
  }
  function SA(D, CA) {
    return !D || !D.state || D.state.wrap !== 2 ? d : (D.state.gzhead = CA, u);
  }
  function eA(D, CA, IA, V, $, dA) {
    if (!D)
      return d;
    var ce = 1;
    if (CA === E && (CA = 6), V < 0 ? (ce = 0, V = -V) : V > 15 && (ce = 2, V -= 16), $ < 1 || $ > k || IA !== Y || V < 8 || V > 15 || CA < 0 || CA > 9 || dA < 0 || dA > p)
      return ZA(D, d);
    V === 8 && (V = 9);
    var NA = new W();
    return D.state = NA, NA.strm = D, NA.wrap = ce, NA.gzhead = null, NA.w_bits = V, NA.w_size = 1 << NA.w_bits, NA.w_mask = NA.w_size - 1, NA.hash_bits = $ + 7, NA.hash_size = 1 << NA.hash_bits, NA.hash_mask = NA.hash_size - 1, NA.hash_shift = ~~((NA.hash_bits + T - 1) / T), NA.window = new e.Buf8(NA.w_size * 2), NA.head = new e.Buf16(NA.hash_size), NA.prev = new e.Buf16(NA.w_size), NA.lit_bufsize = 1 << $ + 6, NA.pending_buf_size = NA.lit_bufsize * 4, NA.pending_buf = new e.Buf8(NA.pending_buf_size), NA.d_buf = 1 * NA.lit_bufsize, NA.l_buf = 3 * NA.lit_bufsize, NA.level = CA, NA.strategy = dA, NA.method = IA, xA(D);
  }
  function mA(D, CA) {
    return eA(D, CA, Y, L, S, Q);
  }
  function H(D, CA) {
    var IA, V, $, dA;
    if (!D || !D.state || CA > l || CA < 0)
      return D ? ZA(D, d) : d;
    if (V = D.state, !D.output || !D.input && D.avail_in !== 0 || V.status === HA && CA !== s)
      return ZA(D, D.avail_out === 0 ? C : d);
    if (V.strm = D, IA = V.last_flush, V.last_flush = CA, V.status === X)
      if (V.wrap === 2)
        D.adler = 0, gA(V, 31), gA(V, 139), gA(V, 8), V.gzhead ? (gA(
          V,
          (V.gzhead.text ? 1 : 0) + (V.gzhead.hcrc ? 2 : 0) + (V.gzhead.extra ? 4 : 0) + (V.gzhead.name ? 8 : 0) + (V.gzhead.comment ? 16 : 0)
        ), gA(V, V.gzhead.time & 255), gA(V, V.gzhead.time >> 8 & 255), gA(V, V.gzhead.time >> 16 & 255), gA(V, V.gzhead.time >> 24 & 255), gA(V, V.level === 9 ? 2 : V.strategy >= b || V.level < 2 ? 4 : 0), gA(V, V.gzhead.os & 255), V.gzhead.extra && V.gzhead.extra.length && (gA(V, V.gzhead.extra.length & 255), gA(V, V.gzhead.extra.length >> 8 & 255)), V.gzhead.hcrc && (D.adler = r(D.adler, V.pending_buf, V.pending, 0)), V.gzindex = 0, V.status = iA) : (gA(V, 0), gA(V, 0), gA(V, 0), gA(V, 0), gA(V, 0), gA(V, V.level === 9 ? 2 : V.strategy >= b || V.level < 2 ? 4 : 0), gA(V, GA), V.status = DA);
      else {
        var ce = Y + (V.w_bits - 8 << 4) << 8, NA = -1;
        V.strategy >= b || V.level < 2 ? NA = 0 : V.level < 6 ? NA = 1 : V.level === 6 ? NA = 2 : NA = 3, ce |= NA << 6, V.strstart !== 0 && (ce |= AA), ce += 31 - ce % 31, V.status = DA, ie(V, ce), V.strstart !== 0 && (ie(V, D.adler >>> 16), ie(V, D.adler & 65535)), D.adler = 1;
      }
    if (V.status === iA)
      if (V.gzhead.extra) {
        for ($ = V.pending; V.gzindex < (V.gzhead.extra.length & 65535) && !(V.pending === V.pending_buf_size && (V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), Ce(D), $ = V.pending, V.pending === V.pending_buf_size)); )
          gA(V, V.gzhead.extra[V.gzindex] & 255), V.gzindex++;
        V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), V.gzindex === V.gzhead.extra.length && (V.gzindex = 0, V.status = oA);
      } else
        V.status = oA;
    if (V.status === oA)
      if (V.gzhead.name) {
        $ = V.pending;
        do {
          if (V.pending === V.pending_buf_size && (V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), Ce(D), $ = V.pending, V.pending === V.pending_buf_size)) {
            dA = 1;
            break;
          }
          V.gzindex < V.gzhead.name.length ? dA = V.gzhead.name.charCodeAt(V.gzindex++) & 255 : dA = 0, gA(V, dA);
        } while (dA !== 0);
        V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), dA === 0 && (V.gzindex = 0, V.status = fA);
      } else
        V.status = fA;
    if (V.status === fA)
      if (V.gzhead.comment) {
        $ = V.pending;
        do {
          if (V.pending === V.pending_buf_size && (V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), Ce(D), $ = V.pending, V.pending === V.pending_buf_size)) {
            dA = 1;
            break;
          }
          V.gzindex < V.gzhead.comment.length ? dA = V.gzhead.comment.charCodeAt(V.gzindex++) & 255 : dA = 0, gA(V, dA);
        } while (dA !== 0);
        V.gzhead.hcrc && V.pending > $ && (D.adler = r(D.adler, V.pending_buf, V.pending - $, $)), dA === 0 && (V.status = wA);
      } else
        V.status = wA;
    if (V.status === wA && (V.gzhead.hcrc ? (V.pending + 2 > V.pending_buf_size && Ce(D), V.pending + 2 <= V.pending_buf_size && (gA(V, D.adler & 255), gA(V, D.adler >> 8 & 255), D.adler = 0, V.status = DA)) : V.status = DA), V.pending !== 0) {
      if (Ce(D), D.avail_out === 0)
        return V.last_flush = -1, u;
    } else if (D.avail_in === 0 && de(CA) <= de(IA) && CA !== s)
      return ZA(D, C);
    if (V.status === HA && D.avail_in !== 0)
      return ZA(D, C);
    if (D.avail_in !== 0 || V.lookahead !== 0 || CA !== i && V.status !== HA) {
      var XA = V.strategy === b ? le(V, CA) : V.strategy === y ? Pe(V, CA) : Ze[V.level].func(V, CA);
      if ((XA === tA || XA === nA) && (V.status = HA), XA === sA || XA === tA)
        return D.avail_out === 0 && (V.last_flush = -1), u;
      if (XA === lA && (CA === a ? A._tr_align(V) : CA !== l && (A._tr_stored_block(V, 0, 0, !1), CA === o && (_A(V.head), V.lookahead === 0 && (V.strstart = 0, V.block_start = 0, V.insert = 0))), Ce(D), D.avail_out === 0))
        return V.last_flush = -1, u;
    }
    return CA !== s ? u : V.wrap <= 0 ? g : (V.wrap === 2 ? (gA(V, D.adler & 255), gA(V, D.adler >> 8 & 255), gA(V, D.adler >> 16 & 255), gA(V, D.adler >> 24 & 255), gA(V, D.total_in & 255), gA(V, D.total_in >> 8 & 255), gA(V, D.total_in >> 16 & 255), gA(V, D.total_in >> 24 & 255)) : (ie(V, D.adler >>> 16), ie(V, D.adler & 65535)), Ce(D), V.wrap > 0 && (V.wrap = -V.wrap), V.pending !== 0 ? u : g);
  }
  function UA(D) {
    var CA;
    return !D || !D.state ? d : (CA = D.state.status, CA !== X && CA !== iA && CA !== oA && CA !== fA && CA !== wA && CA !== DA && CA !== HA ? ZA(D, d) : (D.state = null, CA === DA ? ZA(D, h) : u));
  }
  function ae(D, CA) {
    var IA = CA.length, V, $, dA, ce, NA, XA, ke, Ne;
    if (!D || !D.state || (V = D.state, ce = V.wrap, ce === 2 || ce === 1 && V.status !== X || V.lookahead))
      return d;
    for (ce === 1 && (D.adler = t(D.adler, CA, IA, 0)), V.wrap = 0, IA >= V.w_size && (ce === 0 && (_A(V.head), V.strstart = 0, V.block_start = 0, V.insert = 0), Ne = new e.Buf8(V.w_size), e.arraySet(Ne, CA, IA - V.w_size, V.w_size, 0), CA = Ne, IA = V.w_size), NA = D.avail_in, XA = D.next_in, ke = D.input, D.avail_in = IA, D.next_in = 0, D.input = CA, we(V); V.lookahead >= T; ) {
      $ = V.strstart, dA = V.lookahead - (T - 1);
      do
        V.ins_h = (V.ins_h << V.hash_shift ^ V.window[$ + T - 1]) & V.hash_mask, V.prev[$ & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = $, $++;
      while (--dA);
      V.strstart = $, V.lookahead = T - 1, we(V);
    }
    return V.strstart += V.lookahead, V.block_start = V.strstart, V.insert = V.lookahead, V.lookahead = 0, V.match_length = V.prev_length = T - 1, V.match_available = 0, D.next_in = XA, D.input = ke, D.avail_in = NA, V.wrap = ce, u;
  }
  return Pn.deflateInit = mA, Pn.deflateInit2 = eA, Pn.deflateReset = xA, Pn.deflateResetKeep = yA, Pn.deflateSetHeader = SA, Pn.deflate = H, Pn.deflateEnd = UA, Pn.deflateSetDictionary = ae, Pn.deflateInfo = "pako deflate (from Nodeca project)", Pn;
}
var jT = zT();
const VT = /* @__PURE__ */ Ht(jT);
var yn = {}, Wf, vI;
function OT() {
  if (vI) return Wf;
  vI = 1;
  var e = 30, A = 12;
  return Wf = function(r, n) {
    var i, a, o, s, l, u, g, d, h, C, E, I, b, y, p, Q, w, Y, k, L, S, P, Z, M, R;
    i = r.state, a = r.next_in, M = r.input, o = a + (r.avail_in - 5), s = r.next_out, R = r.output, l = s - (n - r.avail_out), u = s + (r.avail_out - 257), g = i.dmax, d = i.wsize, h = i.whave, C = i.wnext, E = i.window, I = i.hold, b = i.bits, y = i.lencode, p = i.distcode, Q = (1 << i.lenbits) - 1, w = (1 << i.distbits) - 1;
    A:
      do {
        b < 15 && (I += M[a++] << b, b += 8, I += M[a++] << b, b += 8), Y = y[I & Q];
        e:
          for (; ; ) {
            if (k = Y >>> 24, I >>>= k, b -= k, k = Y >>> 16 & 255, k === 0)
              R[s++] = Y & 65535;
            else if (k & 16) {
              L = Y & 65535, k &= 15, k && (b < k && (I += M[a++] << b, b += 8), L += I & (1 << k) - 1, I >>>= k, b -= k), b < 15 && (I += M[a++] << b, b += 8, I += M[a++] << b, b += 8), Y = p[I & w];
              t:
                for (; ; ) {
                  if (k = Y >>> 24, I >>>= k, b -= k, k = Y >>> 16 & 255, k & 16) {
                    if (S = Y & 65535, k &= 15, b < k && (I += M[a++] << b, b += 8, b < k && (I += M[a++] << b, b += 8)), S += I & (1 << k) - 1, S > g) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break A;
                    }
                    if (I >>>= k, b -= k, k = s - l, S > k) {
                      if (k = S - k, k > h && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break A;
                      }
                      if (P = 0, Z = E, C === 0) {
                        if (P += d - k, k < L) {
                          L -= k;
                          do
                            R[s++] = E[P++];
                          while (--k);
                          P = s - S, Z = R;
                        }
                      } else if (C < k) {
                        if (P += d + C - k, k -= C, k < L) {
                          L -= k;
                          do
                            R[s++] = E[P++];
                          while (--k);
                          if (P = 0, C < L) {
                            k = C, L -= k;
                            do
                              R[s++] = E[P++];
                            while (--k);
                            P = s - S, Z = R;
                          }
                        }
                      } else if (P += C - k, k < L) {
                        L -= k;
                        do
                          R[s++] = E[P++];
                        while (--k);
                        P = s - S, Z = R;
                      }
                      for (; L > 2; )
                        R[s++] = Z[P++], R[s++] = Z[P++], R[s++] = Z[P++], L -= 3;
                      L && (R[s++] = Z[P++], L > 1 && (R[s++] = Z[P++]));
                    } else {
                      P = s - S;
                      do
                        R[s++] = R[P++], R[s++] = R[P++], R[s++] = R[P++], L -= 3;
                      while (L > 2);
                      L && (R[s++] = R[P++], L > 1 && (R[s++] = R[P++]));
                    }
                  } else if (k & 64) {
                    r.msg = "invalid distance code", i.mode = e;
                    break A;
                  } else {
                    Y = p[(Y & 65535) + (I & (1 << k) - 1)];
                    continue t;
                  }
                  break;
                }
            } else if (k & 64)
              if (k & 32) {
                i.mode = A;
                break A;
              } else {
                r.msg = "invalid literal/length code", i.mode = e;
                break A;
              }
            else {
              Y = y[(Y & 65535) + (I & (1 << k) - 1)];
              continue e;
            }
            break;
          }
      } while (a < o && s < u);
    L = b >> 3, a -= L, b -= L << 3, I &= (1 << b) - 1, r.next_in = a, r.next_out = s, r.avail_in = a < o ? 5 + (o - a) : 5 - (a - o), r.avail_out = s < u ? 257 + (u - s) : 257 - (s - u), i.hold = I, i.bits = b;
  }, Wf;
}
var Zf, yI;
function JT() {
  if (yI) return Zf;
  yI = 1;
  var e = Zg(), A = 15, t = 852, r = 592, n = 0, i = 1, a = 2, o = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], s = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], l = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], u = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Zf = function(d, h, C, E, I, b, y, p) {
    var Q = p.bits, w = 0, Y = 0, k = 0, L = 0, S = 0, P = 0, Z = 0, M = 0, R = 0, G = 0, N, z, T, O, K, AA = null, X = 0, iA, oA = new e.Buf16(A + 1), fA = new e.Buf16(A + 1), wA = null, DA = 0, HA, sA, lA;
    for (w = 0; w <= A; w++)
      oA[w] = 0;
    for (Y = 0; Y < E; Y++)
      oA[h[C + Y]]++;
    for (S = Q, L = A; L >= 1 && oA[L] === 0; L--)
      ;
    if (S > L && (S = L), L === 0)
      return I[b++] = 1 << 24 | 64 << 16 | 0, I[b++] = 1 << 24 | 64 << 16 | 0, p.bits = 1, 0;
    for (k = 1; k < L && oA[k] === 0; k++)
      ;
    for (S < k && (S = k), M = 1, w = 1; w <= A; w++)
      if (M <<= 1, M -= oA[w], M < 0)
        return -1;
    if (M > 0 && (d === n || L !== 1))
      return -1;
    for (fA[1] = 0, w = 1; w < A; w++)
      fA[w + 1] = fA[w] + oA[w];
    for (Y = 0; Y < E; Y++)
      h[C + Y] !== 0 && (y[fA[h[C + Y]]++] = Y);
    if (d === n ? (AA = wA = y, iA = 19) : d === i ? (AA = o, X -= 257, wA = s, DA -= 257, iA = 256) : (AA = l, wA = u, iA = -1), G = 0, Y = 0, w = k, K = b, P = S, Z = 0, T = -1, R = 1 << S, O = R - 1, d === i && R > t || d === a && R > r)
      return 1;
    for (; ; ) {
      HA = w - Z, y[Y] < iA ? (sA = 0, lA = y[Y]) : y[Y] > iA ? (sA = wA[DA + y[Y]], lA = AA[X + y[Y]]) : (sA = 96, lA = 0), N = 1 << w - Z, z = 1 << P, k = z;
      do
        z -= N, I[K + (G >> Z) + z] = HA << 24 | sA << 16 | lA | 0;
      while (z !== 0);
      for (N = 1 << w - 1; G & N; )
        N >>= 1;
      if (N !== 0 ? (G &= N - 1, G += N) : G = 0, Y++, --oA[w] === 0) {
        if (w === L)
          break;
        w = h[C + y[Y]];
      }
      if (w > S && (G & O) !== T) {
        for (Z === 0 && (Z = S), K += k, P = w - Z, M = 1 << P; P + Z < L && (M -= oA[P + Z], !(M <= 0)); )
          P++, M <<= 1;
        if (R += 1 << P, d === i && R > t || d === a && R > r)
          return 1;
        T = G & O, I[T] = S << 24 | P << 16 | K - b | 0;
      }
    }
    return G !== 0 && (I[K + G] = w - Z << 24 | 64 << 16 | 0), p.bits = S, 0;
  }, Zf;
}
var bI;
function WT() {
  if (bI) return yn;
  bI = 1;
  var e = Zg(), A = km(), t = Um(), r = OT(), n = JT(), i = 0, a = 1, o = 2, s = 4, l = 5, u = 6, g = 0, d = 1, h = 2, C = -2, E = -3, I = -4, b = -5, y = 8, p = 1, Q = 2, w = 3, Y = 4, k = 5, L = 6, S = 7, P = 8, Z = 9, M = 10, R = 11, G = 12, N = 13, z = 14, T = 15, O = 16, K = 17, AA = 18, X = 19, iA = 20, oA = 21, fA = 22, wA = 23, DA = 24, HA = 25, sA = 26, lA = 27, tA = 28, nA = 29, GA = 30, ZA = 31, de = 32, _A = 852, Ce = 592, WA = 15, gA = WA;
  function ie(eA) {
    return (eA >>> 24 & 255) + (eA >>> 8 & 65280) + ((eA & 65280) << 8) + ((eA & 255) << 24);
  }
  function Qe() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function OA(eA) {
    var mA;
    return !eA || !eA.state ? C : (mA = eA.state, eA.total_in = eA.total_out = mA.total = 0, eA.msg = "", mA.wrap && (eA.adler = mA.wrap & 1), mA.mode = p, mA.last = 0, mA.havedict = 0, mA.dmax = 32768, mA.head = null, mA.hold = 0, mA.bits = 0, mA.lencode = mA.lendyn = new e.Buf32(_A), mA.distcode = mA.distdyn = new e.Buf32(Ce), mA.sane = 1, mA.back = -1, g);
  }
  function we(eA) {
    var mA;
    return !eA || !eA.state ? C : (mA = eA.state, mA.wsize = 0, mA.whave = 0, mA.wnext = 0, OA(eA));
  }
  function se(eA, mA) {
    var H, UA;
    return !eA || !eA.state || (UA = eA.state, mA < 0 ? (H = 0, mA = -mA) : (H = (mA >> 4) + 1, mA < 48 && (mA &= 15)), mA && (mA < 8 || mA > 15)) ? C : (UA.window !== null && UA.wbits !== mA && (UA.window = null), UA.wrap = H, UA.wbits = mA, we(eA));
  }
  function ue(eA, mA) {
    var H, UA;
    return eA ? (UA = new Qe(), eA.state = UA, UA.window = null, H = se(eA, mA), H !== g && (eA.state = null), H) : C;
  }
  function ge(eA) {
    return ue(eA, gA);
  }
  var Pe = !0, le, pe;
  function Ze(eA) {
    if (Pe) {
      var mA;
      for (le = new e.Buf32(512), pe = new e.Buf32(32), mA = 0; mA < 144; )
        eA.lens[mA++] = 8;
      for (; mA < 256; )
        eA.lens[mA++] = 9;
      for (; mA < 280; )
        eA.lens[mA++] = 7;
      for (; mA < 288; )
        eA.lens[mA++] = 8;
      for (n(a, eA.lens, 0, 288, le, 0, eA.work, { bits: 9 }), mA = 0; mA < 32; )
        eA.lens[mA++] = 5;
      n(o, eA.lens, 0, 32, pe, 0, eA.work, { bits: 5 }), Pe = !1;
    }
    eA.lencode = le, eA.lenbits = 9, eA.distcode = pe, eA.distbits = 5;
  }
  function je(eA, mA, H, UA) {
    var ae, D = eA.state;
    return D.window === null && (D.wsize = 1 << D.wbits, D.wnext = 0, D.whave = 0, D.window = new e.Buf8(D.wsize)), UA >= D.wsize ? (e.arraySet(D.window, mA, H - D.wsize, D.wsize, 0), D.wnext = 0, D.whave = D.wsize) : (ae = D.wsize - D.wnext, ae > UA && (ae = UA), e.arraySet(D.window, mA, H - UA, ae, D.wnext), UA -= ae, UA ? (e.arraySet(D.window, mA, H - UA, UA, 0), D.wnext = UA, D.whave = D.wsize) : (D.wnext += ae, D.wnext === D.wsize && (D.wnext = 0), D.whave < D.wsize && (D.whave += ae))), 0;
  }
  function W(eA, mA) {
    var H, UA, ae, D, CA, IA, V, $, dA, ce, NA, XA, ke, Ne, Ie = 0, be, Ye, ye, st, Ut, gt, Ke, q, bA = new e.Buf8(4), $A, Ee, Ve = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!eA || !eA.state || !eA.output || !eA.input && eA.avail_in !== 0)
      return C;
    H = eA.state, H.mode === G && (H.mode = N), CA = eA.next_out, ae = eA.output, V = eA.avail_out, D = eA.next_in, UA = eA.input, IA = eA.avail_in, $ = H.hold, dA = H.bits, ce = IA, NA = V, q = g;
    A:
      for (; ; )
        switch (H.mode) {
          case p:
            if (H.wrap === 0) {
              H.mode = N;
              break;
            }
            for (; dA < 16; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (H.wrap & 2 && $ === 35615) {
              H.check = 0, bA[0] = $ & 255, bA[1] = $ >>> 8 & 255, H.check = t(H.check, bA, 2, 0), $ = 0, dA = 0, H.mode = Q;
              break;
            }
            if (H.flags = 0, H.head && (H.head.done = !1), !(H.wrap & 1) || /* check if zlib header allowed */
            ((($ & 255) << 8) + ($ >> 8)) % 31) {
              eA.msg = "incorrect header check", H.mode = GA;
              break;
            }
            if (($ & 15) !== y) {
              eA.msg = "unknown compression method", H.mode = GA;
              break;
            }
            if ($ >>>= 4, dA -= 4, Ke = ($ & 15) + 8, H.wbits === 0)
              H.wbits = Ke;
            else if (Ke > H.wbits) {
              eA.msg = "invalid window size", H.mode = GA;
              break;
            }
            H.dmax = 1 << Ke, eA.adler = H.check = 1, H.mode = $ & 512 ? M : G, $ = 0, dA = 0;
            break;
          case Q:
            for (; dA < 16; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (H.flags = $, (H.flags & 255) !== y) {
              eA.msg = "unknown compression method", H.mode = GA;
              break;
            }
            if (H.flags & 57344) {
              eA.msg = "unknown header flags set", H.mode = GA;
              break;
            }
            H.head && (H.head.text = $ >> 8 & 1), H.flags & 512 && (bA[0] = $ & 255, bA[1] = $ >>> 8 & 255, H.check = t(H.check, bA, 2, 0)), $ = 0, dA = 0, H.mode = w;
          /* falls through */
          case w:
            for (; dA < 32; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            H.head && (H.head.time = $), H.flags & 512 && (bA[0] = $ & 255, bA[1] = $ >>> 8 & 255, bA[2] = $ >>> 16 & 255, bA[3] = $ >>> 24 & 255, H.check = t(H.check, bA, 4, 0)), $ = 0, dA = 0, H.mode = Y;
          /* falls through */
          case Y:
            for (; dA < 16; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            H.head && (H.head.xflags = $ & 255, H.head.os = $ >> 8), H.flags & 512 && (bA[0] = $ & 255, bA[1] = $ >>> 8 & 255, H.check = t(H.check, bA, 2, 0)), $ = 0, dA = 0, H.mode = k;
          /* falls through */
          case k:
            if (H.flags & 1024) {
              for (; dA < 16; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              H.length = $, H.head && (H.head.extra_len = $), H.flags & 512 && (bA[0] = $ & 255, bA[1] = $ >>> 8 & 255, H.check = t(H.check, bA, 2, 0)), $ = 0, dA = 0;
            } else H.head && (H.head.extra = null);
            H.mode = L;
          /* falls through */
          case L:
            if (H.flags & 1024 && (XA = H.length, XA > IA && (XA = IA), XA && (H.head && (Ke = H.head.extra_len - H.length, H.head.extra || (H.head.extra = new Array(H.head.extra_len)), e.arraySet(
              H.head.extra,
              UA,
              D,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              XA,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              Ke
            )), H.flags & 512 && (H.check = t(H.check, UA, XA, D)), IA -= XA, D += XA, H.length -= XA), H.length))
              break A;
            H.length = 0, H.mode = S;
          /* falls through */
          case S:
            if (H.flags & 2048) {
              if (IA === 0)
                break A;
              XA = 0;
              do
                Ke = UA[D + XA++], H.head && Ke && H.length < 65536 && (H.head.name += String.fromCharCode(Ke));
              while (Ke && XA < IA);
              if (H.flags & 512 && (H.check = t(H.check, UA, XA, D)), IA -= XA, D += XA, Ke)
                break A;
            } else H.head && (H.head.name = null);
            H.length = 0, H.mode = P;
          /* falls through */
          case P:
            if (H.flags & 4096) {
              if (IA === 0)
                break A;
              XA = 0;
              do
                Ke = UA[D + XA++], H.head && Ke && H.length < 65536 && (H.head.comment += String.fromCharCode(Ke));
              while (Ke && XA < IA);
              if (H.flags & 512 && (H.check = t(H.check, UA, XA, D)), IA -= XA, D += XA, Ke)
                break A;
            } else H.head && (H.head.comment = null);
            H.mode = Z;
          /* falls through */
          case Z:
            if (H.flags & 512) {
              for (; dA < 16; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              if ($ !== (H.check & 65535)) {
                eA.msg = "header crc mismatch", H.mode = GA;
                break;
              }
              $ = 0, dA = 0;
            }
            H.head && (H.head.hcrc = H.flags >> 9 & 1, H.head.done = !0), eA.adler = H.check = 0, H.mode = G;
            break;
          case M:
            for (; dA < 32; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            eA.adler = H.check = ie($), $ = 0, dA = 0, H.mode = R;
          /* falls through */
          case R:
            if (H.havedict === 0)
              return eA.next_out = CA, eA.avail_out = V, eA.next_in = D, eA.avail_in = IA, H.hold = $, H.bits = dA, h;
            eA.adler = H.check = 1, H.mode = G;
          /* falls through */
          case G:
            if (mA === l || mA === u)
              break A;
          /* falls through */
          case N:
            if (H.last) {
              $ >>>= dA & 7, dA -= dA & 7, H.mode = lA;
              break;
            }
            for (; dA < 3; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            switch (H.last = $ & 1, $ >>>= 1, dA -= 1, $ & 3) {
              case 0:
                H.mode = z;
                break;
              case 1:
                if (Ze(H), H.mode = iA, mA === u) {
                  $ >>>= 2, dA -= 2;
                  break A;
                }
                break;
              case 2:
                H.mode = K;
                break;
              case 3:
                eA.msg = "invalid block type", H.mode = GA;
            }
            $ >>>= 2, dA -= 2;
            break;
          case z:
            for ($ >>>= dA & 7, dA -= dA & 7; dA < 32; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (($ & 65535) !== ($ >>> 16 ^ 65535)) {
              eA.msg = "invalid stored block lengths", H.mode = GA;
              break;
            }
            if (H.length = $ & 65535, $ = 0, dA = 0, H.mode = T, mA === u)
              break A;
          /* falls through */
          case T:
            H.mode = O;
          /* falls through */
          case O:
            if (XA = H.length, XA) {
              if (XA > IA && (XA = IA), XA > V && (XA = V), XA === 0)
                break A;
              e.arraySet(ae, UA, D, XA, CA), IA -= XA, D += XA, V -= XA, CA += XA, H.length -= XA;
              break;
            }
            H.mode = G;
            break;
          case K:
            for (; dA < 14; ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (H.nlen = ($ & 31) + 257, $ >>>= 5, dA -= 5, H.ndist = ($ & 31) + 1, $ >>>= 5, dA -= 5, H.ncode = ($ & 15) + 4, $ >>>= 4, dA -= 4, H.nlen > 286 || H.ndist > 30) {
              eA.msg = "too many length or distance symbols", H.mode = GA;
              break;
            }
            H.have = 0, H.mode = AA;
          /* falls through */
          case AA:
            for (; H.have < H.ncode; ) {
              for (; dA < 3; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              H.lens[Ve[H.have++]] = $ & 7, $ >>>= 3, dA -= 3;
            }
            for (; H.have < 19; )
              H.lens[Ve[H.have++]] = 0;
            if (H.lencode = H.lendyn, H.lenbits = 7, $A = { bits: H.lenbits }, q = n(i, H.lens, 0, 19, H.lencode, 0, H.work, $A), H.lenbits = $A.bits, q) {
              eA.msg = "invalid code lengths set", H.mode = GA;
              break;
            }
            H.have = 0, H.mode = X;
          /* falls through */
          case X:
            for (; H.have < H.nlen + H.ndist; ) {
              for (; Ie = H.lencode[$ & (1 << H.lenbits) - 1], be = Ie >>> 24, Ye = Ie >>> 16 & 255, ye = Ie & 65535, !(be <= dA); ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              if (ye < 16)
                $ >>>= be, dA -= be, H.lens[H.have++] = ye;
              else {
                if (ye === 16) {
                  for (Ee = be + 2; dA < Ee; ) {
                    if (IA === 0)
                      break A;
                    IA--, $ += UA[D++] << dA, dA += 8;
                  }
                  if ($ >>>= be, dA -= be, H.have === 0) {
                    eA.msg = "invalid bit length repeat", H.mode = GA;
                    break;
                  }
                  Ke = H.lens[H.have - 1], XA = 3 + ($ & 3), $ >>>= 2, dA -= 2;
                } else if (ye === 17) {
                  for (Ee = be + 3; dA < Ee; ) {
                    if (IA === 0)
                      break A;
                    IA--, $ += UA[D++] << dA, dA += 8;
                  }
                  $ >>>= be, dA -= be, Ke = 0, XA = 3 + ($ & 7), $ >>>= 3, dA -= 3;
                } else {
                  for (Ee = be + 7; dA < Ee; ) {
                    if (IA === 0)
                      break A;
                    IA--, $ += UA[D++] << dA, dA += 8;
                  }
                  $ >>>= be, dA -= be, Ke = 0, XA = 11 + ($ & 127), $ >>>= 7, dA -= 7;
                }
                if (H.have + XA > H.nlen + H.ndist) {
                  eA.msg = "invalid bit length repeat", H.mode = GA;
                  break;
                }
                for (; XA--; )
                  H.lens[H.have++] = Ke;
              }
            }
            if (H.mode === GA)
              break;
            if (H.lens[256] === 0) {
              eA.msg = "invalid code -- missing end-of-block", H.mode = GA;
              break;
            }
            if (H.lenbits = 9, $A = { bits: H.lenbits }, q = n(a, H.lens, 0, H.nlen, H.lencode, 0, H.work, $A), H.lenbits = $A.bits, q) {
              eA.msg = "invalid literal/lengths set", H.mode = GA;
              break;
            }
            if (H.distbits = 6, H.distcode = H.distdyn, $A = { bits: H.distbits }, q = n(o, H.lens, H.nlen, H.ndist, H.distcode, 0, H.work, $A), H.distbits = $A.bits, q) {
              eA.msg = "invalid distances set", H.mode = GA;
              break;
            }
            if (H.mode = iA, mA === u)
              break A;
          /* falls through */
          case iA:
            H.mode = oA;
          /* falls through */
          case oA:
            if (IA >= 6 && V >= 258) {
              eA.next_out = CA, eA.avail_out = V, eA.next_in = D, eA.avail_in = IA, H.hold = $, H.bits = dA, r(eA, NA), CA = eA.next_out, ae = eA.output, V = eA.avail_out, D = eA.next_in, UA = eA.input, IA = eA.avail_in, $ = H.hold, dA = H.bits, H.mode === G && (H.back = -1);
              break;
            }
            for (H.back = 0; Ie = H.lencode[$ & (1 << H.lenbits) - 1], be = Ie >>> 24, Ye = Ie >>> 16 & 255, ye = Ie & 65535, !(be <= dA); ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (Ye && !(Ye & 240)) {
              for (st = be, Ut = Ye, gt = ye; Ie = H.lencode[gt + (($ & (1 << st + Ut) - 1) >> st)], be = Ie >>> 24, Ye = Ie >>> 16 & 255, ye = Ie & 65535, !(st + be <= dA); ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              $ >>>= st, dA -= st, H.back += st;
            }
            if ($ >>>= be, dA -= be, H.back += be, H.length = ye, Ye === 0) {
              H.mode = sA;
              break;
            }
            if (Ye & 32) {
              H.back = -1, H.mode = G;
              break;
            }
            if (Ye & 64) {
              eA.msg = "invalid literal/length code", H.mode = GA;
              break;
            }
            H.extra = Ye & 15, H.mode = fA;
          /* falls through */
          case fA:
            if (H.extra) {
              for (Ee = H.extra; dA < Ee; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              H.length += $ & (1 << H.extra) - 1, $ >>>= H.extra, dA -= H.extra, H.back += H.extra;
            }
            H.was = H.length, H.mode = wA;
          /* falls through */
          case wA:
            for (; Ie = H.distcode[$ & (1 << H.distbits) - 1], be = Ie >>> 24, Ye = Ie >>> 16 & 255, ye = Ie & 65535, !(be <= dA); ) {
              if (IA === 0)
                break A;
              IA--, $ += UA[D++] << dA, dA += 8;
            }
            if (!(Ye & 240)) {
              for (st = be, Ut = Ye, gt = ye; Ie = H.distcode[gt + (($ & (1 << st + Ut) - 1) >> st)], be = Ie >>> 24, Ye = Ie >>> 16 & 255, ye = Ie & 65535, !(st + be <= dA); ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              $ >>>= st, dA -= st, H.back += st;
            }
            if ($ >>>= be, dA -= be, H.back += be, Ye & 64) {
              eA.msg = "invalid distance code", H.mode = GA;
              break;
            }
            H.offset = ye, H.extra = Ye & 15, H.mode = DA;
          /* falls through */
          case DA:
            if (H.extra) {
              for (Ee = H.extra; dA < Ee; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              H.offset += $ & (1 << H.extra) - 1, $ >>>= H.extra, dA -= H.extra, H.back += H.extra;
            }
            if (H.offset > H.dmax) {
              eA.msg = "invalid distance too far back", H.mode = GA;
              break;
            }
            H.mode = HA;
          /* falls through */
          case HA:
            if (V === 0)
              break A;
            if (XA = NA - V, H.offset > XA) {
              if (XA = H.offset - XA, XA > H.whave && H.sane) {
                eA.msg = "invalid distance too far back", H.mode = GA;
                break;
              }
              XA > H.wnext ? (XA -= H.wnext, ke = H.wsize - XA) : ke = H.wnext - XA, XA > H.length && (XA = H.length), Ne = H.window;
            } else
              Ne = ae, ke = CA - H.offset, XA = H.length;
            XA > V && (XA = V), V -= XA, H.length -= XA;
            do
              ae[CA++] = Ne[ke++];
            while (--XA);
            H.length === 0 && (H.mode = oA);
            break;
          case sA:
            if (V === 0)
              break A;
            ae[CA++] = H.length, V--, H.mode = oA;
            break;
          case lA:
            if (H.wrap) {
              for (; dA < 32; ) {
                if (IA === 0)
                  break A;
                IA--, $ |= UA[D++] << dA, dA += 8;
              }
              if (NA -= V, eA.total_out += NA, H.total += NA, NA && (eA.adler = H.check = /*UPDATE(state.check, put - _out, _out);*/
              H.flags ? t(H.check, ae, NA, CA - NA) : A(H.check, ae, NA, CA - NA)), NA = V, (H.flags ? $ : ie($)) !== H.check) {
                eA.msg = "incorrect data check", H.mode = GA;
                break;
              }
              $ = 0, dA = 0;
            }
            H.mode = tA;
          /* falls through */
          case tA:
            if (H.wrap && H.flags) {
              for (; dA < 32; ) {
                if (IA === 0)
                  break A;
                IA--, $ += UA[D++] << dA, dA += 8;
              }
              if ($ !== (H.total & 4294967295)) {
                eA.msg = "incorrect length check", H.mode = GA;
                break;
              }
              $ = 0, dA = 0;
            }
            H.mode = nA;
          /* falls through */
          case nA:
            q = d;
            break A;
          case GA:
            q = E;
            break A;
          case ZA:
            return I;
          case de:
          /* falls through */
          default:
            return C;
        }
    return eA.next_out = CA, eA.avail_out = V, eA.next_in = D, eA.avail_in = IA, H.hold = $, H.bits = dA, (H.wsize || NA !== eA.avail_out && H.mode < GA && (H.mode < lA || mA !== s)) && je(eA, eA.output, eA.next_out, NA - eA.avail_out), ce -= eA.avail_in, NA -= eA.avail_out, eA.total_in += ce, eA.total_out += NA, H.total += NA, H.wrap && NA && (eA.adler = H.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    H.flags ? t(H.check, ae, NA, eA.next_out - NA) : A(H.check, ae, NA, eA.next_out - NA)), eA.data_type = H.bits + (H.last ? 64 : 0) + (H.mode === G ? 128 : 0) + (H.mode === iA || H.mode === T ? 256 : 0), (ce === 0 && NA === 0 || mA === s) && q === g && (q = b), q;
  }
  function yA(eA) {
    if (!eA || !eA.state)
      return C;
    var mA = eA.state;
    return mA.window && (mA.window = null), eA.state = null, g;
  }
  function xA(eA, mA) {
    var H;
    return !eA || !eA.state || (H = eA.state, !(H.wrap & 2)) ? C : (H.head = mA, mA.done = !1, g);
  }
  function SA(eA, mA) {
    var H = mA.length, UA, ae, D;
    return !eA || !eA.state || (UA = eA.state, UA.wrap !== 0 && UA.mode !== R) ? C : UA.mode === R && (ae = 1, ae = A(ae, mA, H, 0), ae !== UA.check) ? E : (D = je(eA, mA, H, H), D ? (UA.mode = ZA, I) : (UA.havedict = 1, g));
  }
  return yn.inflateReset = we, yn.inflateReset2 = se, yn.inflateResetKeep = OA, yn.inflateInit = ge, yn.inflateInit2 = ue, yn.inflate = W, yn.inflateEnd = yA, yn.inflateGetHeader = xA, yn.inflateSetDictionary = SA, yn.inflateInfo = "pako inflate (from Nodeca project)", yn;
}
var ZT = WT();
const KT = /* @__PURE__ */ Ht(ZT);
var Kf, FI;
function _T() {
  return FI || (FI = 1, Kf = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Kf;
}
var XT = _T();
const qT = /* @__PURE__ */ Ht(XT);
var Qc = { exports: {} };
function $T(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var wc = { exports: {} };
const A6 = {}, e6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A6
}, Symbol.toStringTag, { value: "Module" })), t6 = /* @__PURE__ */ Jb(e6);
var r6 = wc.exports, LI;
function Ym() {
  return LI || (LI = 1, function(e, A) {
    (function(t, r) {
      e.exports = r();
    })(r6, function() {
      var t = t || function(r, n) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof _s < "u" && _s.crypto && (i = _s.crypto), !i && typeof $T == "function")
          try {
            i = t6;
          } catch {
          }
        var a = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, o = Object.create || /* @__PURE__ */ function() {
          function y() {
          }
          return function(p) {
            var Q;
            return y.prototype = p, Q = new y(), y.prototype = null, Q;
          };
        }(), s = {}, l = s.lib = {}, u = l.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(y) {
              var p = o(this);
              return y && p.mixIn(y), (!p.hasOwnProperty("init") || this.init === p.init) && (p.init = function() {
                p.$super.init.apply(this, arguments);
              }), p.init.prototype = p, p.$super = this, p;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var y = this.extend();
              return y.init.apply(y, arguments), y;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(y) {
              for (var p in y)
                y.hasOwnProperty(p) && (this[p] = y[p]);
              y.hasOwnProperty("toString") && (this.toString = y.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), g = l.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(y, p) {
            y = this.words = y || [], p != n ? this.sigBytes = p : this.sigBytes = y.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(y) {
            return (y || h).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(y) {
            var p = this.words, Q = y.words, w = this.sigBytes, Y = y.sigBytes;
            if (this.clamp(), w % 4)
              for (var k = 0; k < Y; k++) {
                var L = Q[k >>> 2] >>> 24 - k % 4 * 8 & 255;
                p[w + k >>> 2] |= L << 24 - (w + k) % 4 * 8;
              }
            else
              for (var S = 0; S < Y; S += 4)
                p[w + S >>> 2] = Q[S >>> 2];
            return this.sigBytes += Y, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var y = this.words, p = this.sigBytes;
            y[p >>> 2] &= 4294967295 << 32 - p % 4 * 8, y.length = r.ceil(p / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var y = u.clone.call(this);
            return y.words = this.words.slice(0), y;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(y) {
            for (var p = [], Q = 0; Q < y; Q += 4)
              p.push(a());
            return new g.init(p, y);
          }
        }), d = s.enc = {}, h = d.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(y) {
            for (var p = y.words, Q = y.sigBytes, w = [], Y = 0; Y < Q; Y++) {
              var k = p[Y >>> 2] >>> 24 - Y % 4 * 8 & 255;
              w.push((k >>> 4).toString(16)), w.push((k & 15).toString(16));
            }
            return w.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(y) {
            for (var p = y.length, Q = [], w = 0; w < p; w += 2)
              Q[w >>> 3] |= parseInt(y.substr(w, 2), 16) << 24 - w % 8 * 4;
            return new g.init(Q, p / 2);
          }
        }, C = d.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(y) {
            for (var p = y.words, Q = y.sigBytes, w = [], Y = 0; Y < Q; Y++) {
              var k = p[Y >>> 2] >>> 24 - Y % 4 * 8 & 255;
              w.push(String.fromCharCode(k));
            }
            return w.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(y) {
            for (var p = y.length, Q = [], w = 0; w < p; w++)
              Q[w >>> 2] |= (y.charCodeAt(w) & 255) << 24 - w % 4 * 8;
            return new g.init(Q, p);
          }
        }, E = d.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(y) {
            try {
              return decodeURIComponent(escape(C.stringify(y)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(y) {
            return C.parse(unescape(encodeURIComponent(y)));
          }
        }, I = l.BufferedBlockAlgorithm = u.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new g.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(y) {
            typeof y == "string" && (y = E.parse(y)), this._data.concat(y), this._nDataBytes += y.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(y) {
            var p, Q = this._data, w = Q.words, Y = Q.sigBytes, k = this.blockSize, L = k * 4, S = Y / L;
            y ? S = r.ceil(S) : S = r.max((S | 0) - this._minBufferSize, 0);
            var P = S * k, Z = r.min(P * 4, Y);
            if (P) {
              for (var M = 0; M < P; M += k)
                this._doProcessBlock(w, M);
              p = w.splice(0, P), Q.sigBytes -= Z;
            }
            return new g.init(p, Z);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var y = u.clone.call(this);
            return y._data = this._data.clone(), y;
          },
          _minBufferSize: 0
        });
        l.Hasher = I.extend({
          /**
           * Configuration options.
           */
          cfg: u.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(y) {
            this.cfg = this.cfg.extend(y), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            I.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(y) {
            return this._append(y), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(y) {
            y && this._append(y);
            var p = this._doFinalize();
            return p;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(y) {
            return function(p, Q) {
              return new y.init(Q).finalize(p);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(y) {
            return function(p, Q) {
              return new b.HMAC.init(y, Q).finalize(p);
            };
          }
        });
        var b = s.algo = {};
        return s;
      }(Math);
      return t;
    });
  }(wc)), wc.exports;
}
var n6 = Qc.exports, RI;
function i6() {
  return RI || (RI = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Ym());
    })(n6, function(t) {
      return function(r) {
        var n = t, i = n.lib, a = i.WordArray, o = i.Hasher, s = n.algo, l = [];
        (function() {
          for (var E = 0; E < 64; E++)
            l[E] = r.abs(r.sin(E + 1)) * 4294967296 | 0;
        })();
        var u = s.MD5 = o.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(E, I) {
            for (var b = 0; b < 16; b++) {
              var y = I + b, p = E[y];
              E[y] = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360;
            }
            var Q = this._hash.words, w = E[I + 0], Y = E[I + 1], k = E[I + 2], L = E[I + 3], S = E[I + 4], P = E[I + 5], Z = E[I + 6], M = E[I + 7], R = E[I + 8], G = E[I + 9], N = E[I + 10], z = E[I + 11], T = E[I + 12], O = E[I + 13], K = E[I + 14], AA = E[I + 15], X = Q[0], iA = Q[1], oA = Q[2], fA = Q[3];
            X = g(X, iA, oA, fA, w, 7, l[0]), fA = g(fA, X, iA, oA, Y, 12, l[1]), oA = g(oA, fA, X, iA, k, 17, l[2]), iA = g(iA, oA, fA, X, L, 22, l[3]), X = g(X, iA, oA, fA, S, 7, l[4]), fA = g(fA, X, iA, oA, P, 12, l[5]), oA = g(oA, fA, X, iA, Z, 17, l[6]), iA = g(iA, oA, fA, X, M, 22, l[7]), X = g(X, iA, oA, fA, R, 7, l[8]), fA = g(fA, X, iA, oA, G, 12, l[9]), oA = g(oA, fA, X, iA, N, 17, l[10]), iA = g(iA, oA, fA, X, z, 22, l[11]), X = g(X, iA, oA, fA, T, 7, l[12]), fA = g(fA, X, iA, oA, O, 12, l[13]), oA = g(oA, fA, X, iA, K, 17, l[14]), iA = g(iA, oA, fA, X, AA, 22, l[15]), X = d(X, iA, oA, fA, Y, 5, l[16]), fA = d(fA, X, iA, oA, Z, 9, l[17]), oA = d(oA, fA, X, iA, z, 14, l[18]), iA = d(iA, oA, fA, X, w, 20, l[19]), X = d(X, iA, oA, fA, P, 5, l[20]), fA = d(fA, X, iA, oA, N, 9, l[21]), oA = d(oA, fA, X, iA, AA, 14, l[22]), iA = d(iA, oA, fA, X, S, 20, l[23]), X = d(X, iA, oA, fA, G, 5, l[24]), fA = d(fA, X, iA, oA, K, 9, l[25]), oA = d(oA, fA, X, iA, L, 14, l[26]), iA = d(iA, oA, fA, X, R, 20, l[27]), X = d(X, iA, oA, fA, O, 5, l[28]), fA = d(fA, X, iA, oA, k, 9, l[29]), oA = d(oA, fA, X, iA, M, 14, l[30]), iA = d(iA, oA, fA, X, T, 20, l[31]), X = h(X, iA, oA, fA, P, 4, l[32]), fA = h(fA, X, iA, oA, R, 11, l[33]), oA = h(oA, fA, X, iA, z, 16, l[34]), iA = h(iA, oA, fA, X, K, 23, l[35]), X = h(X, iA, oA, fA, Y, 4, l[36]), fA = h(fA, X, iA, oA, S, 11, l[37]), oA = h(oA, fA, X, iA, M, 16, l[38]), iA = h(iA, oA, fA, X, N, 23, l[39]), X = h(X, iA, oA, fA, O, 4, l[40]), fA = h(fA, X, iA, oA, w, 11, l[41]), oA = h(oA, fA, X, iA, L, 16, l[42]), iA = h(iA, oA, fA, X, Z, 23, l[43]), X = h(X, iA, oA, fA, G, 4, l[44]), fA = h(fA, X, iA, oA, T, 11, l[45]), oA = h(oA, fA, X, iA, AA, 16, l[46]), iA = h(iA, oA, fA, X, k, 23, l[47]), X = C(X, iA, oA, fA, w, 6, l[48]), fA = C(fA, X, iA, oA, M, 10, l[49]), oA = C(oA, fA, X, iA, K, 15, l[50]), iA = C(iA, oA, fA, X, P, 21, l[51]), X = C(X, iA, oA, fA, T, 6, l[52]), fA = C(fA, X, iA, oA, L, 10, l[53]), oA = C(oA, fA, X, iA, N, 15, l[54]), iA = C(iA, oA, fA, X, Y, 21, l[55]), X = C(X, iA, oA, fA, R, 6, l[56]), fA = C(fA, X, iA, oA, AA, 10, l[57]), oA = C(oA, fA, X, iA, Z, 15, l[58]), iA = C(iA, oA, fA, X, O, 21, l[59]), X = C(X, iA, oA, fA, S, 6, l[60]), fA = C(fA, X, iA, oA, z, 10, l[61]), oA = C(oA, fA, X, iA, k, 15, l[62]), iA = C(iA, oA, fA, X, G, 21, l[63]), Q[0] = Q[0] + X | 0, Q[1] = Q[1] + iA | 0, Q[2] = Q[2] + oA | 0, Q[3] = Q[3] + fA | 0;
          },
          _doFinalize: function() {
            var E = this._data, I = E.words, b = this._nDataBytes * 8, y = E.sigBytes * 8;
            I[y >>> 5] |= 128 << 24 - y % 32;
            var p = r.floor(b / 4294967296), Q = b;
            I[(y + 64 >>> 9 << 4) + 15] = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360, I[(y + 64 >>> 9 << 4) + 14] = (Q << 8 | Q >>> 24) & 16711935 | (Q << 24 | Q >>> 8) & 4278255360, E.sigBytes = (I.length + 1) * 4, this._process();
            for (var w = this._hash, Y = w.words, k = 0; k < 4; k++) {
              var L = Y[k];
              Y[k] = (L << 8 | L >>> 24) & 16711935 | (L << 24 | L >>> 8) & 4278255360;
            }
            return w;
          },
          clone: function() {
            var E = o.clone.call(this);
            return E._hash = this._hash.clone(), E;
          }
        });
        function g(E, I, b, y, p, Q, w) {
          var Y = E + (I & b | ~I & y) + p + w;
          return (Y << Q | Y >>> 32 - Q) + I;
        }
        function d(E, I, b, y, p, Q, w) {
          var Y = E + (I & y | b & ~y) + p + w;
          return (Y << Q | Y >>> 32 - Q) + I;
        }
        function h(E, I, b, y, p, Q, w) {
          var Y = E + (I ^ b ^ y) + p + w;
          return (Y << Q | Y >>> 32 - Q) + I;
        }
        function C(E, I, b, y, p, Q, w) {
          var Y = E + (b ^ (I | ~y)) + p + w;
          return (Y << Q | Y >>> 32 - Q) + I;
        }
        n.MD5 = o._createHelper(u), n.HmacMD5 = o._createHmacHelper(u);
      }(Math), t.MD5;
    });
  }(Qc)), Qc.exports;
}
var a6 = i6();
const Hm = /* @__PURE__ */ Ht(a6), o6 = new QA({
  identifier: new mr(1),
  value: new mr(1)
}), s6 = {
  name: () => "DAC",
  length: gr,
  tables: new uA(o6, (e) => e.length / 2)
}, Sm = (e, A) => e[A], GI = (e, A) => e[A] << 8 | e[A + 1], xI = (e, A) => e[A] | e[A + 1] << 8, Ic = (e, A) => e[A] << 24 | e[A + 1] << 16 | e[A + 2] << 8 | e[A + 3], Dc = (e, A) => e[A] | e[A + 1] << 8 | e[A + 2] << 16 | e[A + 3] << 24, kI = (e) => Array.from(
  e,
  (A) => A.toString(16).padStart(2, "0")
).join(""), l6 = new TextDecoder("utf-8"), u6 = (e) => l6.decode(e), c6 = (e) => {
  const A = e.reduce((n, i) => n + i.length, 0), t = new Uint8Array(A);
  let r = 0;
  return e.forEach((n) => {
    t.set(n, r), r += n.length;
  }), t;
}, g6 = (e, A) => Ic(e, A) | 0, B6 = (e, A) => Dc(e, A) | 0;
class f6 {
  decode(A, t) {
    const r = {};
    let n = A.buffer.slice(
      A.pos,
      A.pos + t.length - 2
    );
    for (; n.length > 0; ) {
      let i = 1;
      const a = [], o = Sm(n, 0), s = n.slice(i, i + 16);
      i += 16;
      for (const l of s)
        a.push(n.slice(i, i + l)), i += l;
      n = n.slice(i), r[o] = c6(a);
    }
    return A.pos += t.length - 2, r;
  }
}
const d6 = {
  name: () => "DHT",
  length: gr,
  tables: new f6()
}, h6 = {
  name: () => "DQT",
  length: gr,
  tables: new uA(
    new QA({
      identifier: new mr(1),
      data: new mr(64)
    }),
    (e) => (e.length - 2) / 65
  )
}, C6 = {
  name: () => "DRI",
  length: gr,
  restartInterval: gr
}, E6 = {
  name: () => "EOI",
  afterEOI: new Nt(Ae, 1 / 0)
}, _f = {
  ifd: {
    "010e": "imageDescription",
    "010f": "make",
    "011a": "xResolution",
    "011b": "yResolution",
    "011c": "planarConfiguration",
    "012d": "transferFunction",
    "013b": "artist",
    "013e": "whitePoint",
    "013f": "primaryChromaticities",
    "0100": "imageWidth",
    "0101": "imageHeight",
    "0102": "bitsPerSample",
    "0103": "compression",
    "0106": "photometricInterpretation",
    "0110": "model",
    "0111": "stripOffsets",
    "0112": "orientation",
    "0115": "samplesPerPixel",
    "0116": "rowsPerStrip",
    "0117": "stripByteCounts",
    "0128": "resolutionUnit",
    "0131": "software",
    "0132": "dateTime",
    "0201": "jpegInterchangeFormat",
    "0202": "jpegInterchangeFormatLength",
    "0211": "ycbCrCoefficients",
    "0212": "ycbCrSubSampling",
    "0213": "ycbCrPositioning",
    "0214": "referenceBlackWhite",
    "829a": "exposureTime",
    "829d": "fNumber",
    "920a": "focalLength",
    "927c": "makerNote",
    8298: "copyright",
    8769: "exifIFDPointer",
    8822: "exposureProgram",
    8824: "spectralSensitivity",
    8825: "gpsInfoIFDPointer",
    8827: "photographicSensitivity",
    8828: "oecf",
    8830: "sensitivityType",
    8831: "standardOutputSensitivity",
    8832: "recommendedExposureIndex",
    8833: "isoSpeed",
    8834: "isoSpeedLatitudeyyy",
    8835: "isoSpeedLatitudezzz",
    9e3: "exifVersion",
    9003: "dateTimeOriginal",
    9004: "dateTimeDigitized",
    9101: "componentsConfiguration",
    9102: "compressedBitsPerPixel",
    9201: "shutterSpeedValue",
    9202: "apertureValue",
    9203: "brightnessValue",
    9204: "exposureBiasValue",
    9205: "maxApertureValue",
    9206: "subjectDistance",
    9207: "meteringMode",
    9208: "lightSource",
    9209: "flash",
    9214: "subjectArea",
    9286: "userComment",
    9290: "subSecTime",
    9291: "subSecTimeOriginal",
    9292: "subSecTimeDigitized",
    a000: "flashpixVersion",
    a001: "colorSpace",
    a002: "pixelXDimension",
    a003: "pixelYDimension",
    a004: "relatedSoundFile",
    a005: "interoperabilityIFDPointer",
    a20b: "flashEnergy",
    a20c: "spatialFrequencyResponse",
    a20e: "focalPlaneXResolution",
    a20f: "focalPlaneYResolution",
    a40a: "sharpness",
    a40b: "deviceSettingDescription",
    a40c: "subjectDistanceRange",
    a210: "focalPlaneResolutionUnit",
    a214: "subjectLocation",
    a215: "exposureIndex",
    a217: "sensingMethod",
    a300: "fileSource",
    a301: "sceneType",
    a302: "cfaPattern",
    a401: "customRendered",
    a402: "exposureMode",
    a403: "whiteBalance",
    a404: "digitalZoomRatio",
    a405: "focalLengthIn35mmFilm",
    a406: "sceneCaptureType",
    a407: "gainControl",
    a408: "contrast",
    a409: "saturation",
    a420: "imageUniqueID",
    a430: "cameraOwnerName",
    a431: "bodySerialNumber",
    a432: "lensSpecification",
    a433: "lensMake",
    a434: "lensModel",
    a435: "lensSerialNumber",
    a500: "gamma"
  },
  gps: {
    "0000": "gpsVersionID",
    "0001": "gpsLatitudeRef",
    "0002": "gpsLatitude",
    "0003": "gpsLongitudeRef",
    "0004": "gpsLongitude",
    "0005": "gpsAltitudeRef",
    "0006": "gpsAltitude",
    "0007": "gpsTimeStamp",
    "0008": "gpsSatellites",
    "0009": "gpsStatus",
    "000a": "gpsMeasureMode",
    "000b": "gpsDOP",
    "000c": "gpsSpeedRef",
    "000d": "gpsSpeed",
    "000e": "gpsTrackRef",
    "000f": "gpsTrack",
    "0010": "gpsImgDirectionRef",
    "0011": "gpsImgDirection",
    "0012": "gpsMapDatum",
    "0013": "gpsDestLatitudeRef",
    "0014": "gpsDestLatitude",
    "0015": "gpsDestLongitudeRef",
    "0016": "gpsDestLongitude",
    "0017": "gpsDestBearingRef",
    "0018": "gpsDestBearing",
    "0019": "gpsDestDistanceRef",
    "001a": "gpsDestDistance",
    "001b": "gpsProcessingMethod",
    "001c": "gpsAreaInformation",
    "001d": "gpsDateStamp",
    "001e": "gpsDifferential",
    "001f": "gpsHPositioningError"
  }
};
class Q6 {
  constructor(A) {
    this.bigEndian = A, this.bytes = [0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8];
  }
  _getTagValue(A, t, r) {
    switch (t) {
      case 2:
        return A.toString("ascii").replace(/\0+$/, "");
      case 129:
        return A.toString("utf8").replace(/\0+$/, "");
      case 7:
        return "0x" + A.toString("hex");
      default:
        return this._getTagValueForNumericalData(A, t, r);
    }
  }
  _getTagValueForNumericalData(A, t, r) {
    const n = [], i = this.bytes[t];
    for (let a = 0; a < r; a += 1)
      n.push(this._getSingleTagValueForNumericalData(A, t, a * i));
    return n.length === 1 ? n[0] : n;
  }
  _getSingleTagValueForNumericalData(A, t, r) {
    const n = (o) => this.bigEndian ? GI(A, o) : xI(A, o), i = (o) => this.bigEndian ? Ic(A, o) : Dc(A, o), a = (o) => this.bigEndian ? g6(A, o) : B6(A, o);
    switch (t) {
      case 1:
        return Sm(A, r);
      case 3:
        return n(r);
      case 4:
        return i(r);
      case 5:
        return i(r) / i(r + 4);
      case 9:
        return a(r);
      case 10:
        return a(r) / a(r + 4);
    }
  }
  _decodeIDFEntries(A, t, r, n = !1) {
    let i = 2 + r;
    const a = {}, o = (u) => this.bigEndian ? GI(A, u) : xI(A, u), s = (u) => this.bigEndian ? Ic(A, u) : Dc(A, u), l = o(r);
    for (let u = 0; u < l; u++) {
      const g = A.slice(i, i + 2), d = o(i + 2), h = s(i + 4), C = this.bytes[d], E = h * C;
      let I = A.slice(i + 8, i + 12);
      if (E > 4) {
        const Q = this.bigEndian ? Ic(I, 0) : Dc(I, 0);
        I = A.slice(Q, Q + E);
      }
      const b = this._getTagValue(I, d, h), y = this.bigEndian ? kI(g) : kI(g.reverse()), p = t[y];
      a[p] = b, i += 12;
    }
    return a;
  }
  decode(A, t) {
    const r = A.buffer.slice(A.pos - 8), n = t.offsetToFirstIFD;
    if (n > r.length)
      return A.pos += t.parent.length - 16, {};
    const i = this._decodeIDFEntries(r, _f.ifd, n), { exifIFDPointer: a, gpsInfoIFDPointer: o } = i;
    if (a && (i.subExif = this._decodeIDFEntries(
      r,
      _f.ifd,
      a
    )), o) {
      const s = o;
      i.gpsInfo = this._decodeIDFEntries(r, _f.gps, s, !0);
    }
    return A.pos += t.parent.length - 16, i;
  }
}
const w6 = (e) => {
  const A = e ? gr : YR, t = e ? b4 : SR;
  return new QA({
    fortyTwo: A,
    offsetToFirstIFD: t,
    entries: new Q6(e)
  });
};
class I6 {
  decode(A, t) {
    const n = u6(
      A.buffer.slice(A.pos, A.pos + 2)
    ) === "MM";
    return A.pos += 2, w6(n).decode(A, t).entries;
  }
}
const D6 = {
  name: () => "EXIF",
  length: gr,
  identifier: new Dt(6),
  entries: new I6()
}, m6 = {
  name: () => "JFIF",
  length: gr,
  identifier: new Dt(5),
  version: gr,
  units: Ae,
  xDensity: gr,
  yDensity: gr,
  thumbnailWidth: Ae,
  thumbnailHeight: Ae
};
class M6 {
  decode(A) {
    const t = A.buffer.slice(A.pos);
    let r = 0, n = t.indexOf(255);
    for (; n !== -1; ) {
      r = n;
      const i = t[r + 1], a = i >= 208 && i <= 215;
      if (i !== 0 && !a) break;
      n = t.indexOf(255, n + 1);
    }
    return A.pos += r, t.slice(0, r);
  }
}
const p6 = new QA({
  scanComponentSelector: Ae,
  entropyCodingTable: new mr(1)
}), v6 = {
  name: () => "SOS",
  length: gr,
  numberOfImageComponents: Ae,
  componentSpecifications: new uA(
    p6,
    (e) => e.numberOfImageComponents
  ),
  startOfSpectral: Ae,
  endOfSpectral: Ae,
  successiveApproximationBit: new mr(1),
  data: new M6()
}, y6 = new QA({
  id: Ae,
  samplingFactors: Ae,
  quantizationTableId: Ae
}), Bn = {
  name: () => "SOF",
  length: gr,
  precision: Ae,
  height: gr,
  width: gr,
  numberOfComponents: Ae,
  components: new uA(
    y6,
    (e) => e.numberOfComponents
  )
}, b6 = {
  name: () => "SOI"
}, F6 = {
  length: gr,
  buf: new mr((e) => e.length - 2)
}, L6 = Array(63).fill(0).reduce((e, A, t) => ({ ...e, [t + 65472]: F6 }), {}), R6 = new $e(gr, {
  ...L6,
  65472: Bn,
  65473: Bn,
  65474: Bn,
  65475: Bn,
  65476: d6,
  65477: Bn,
  65478: Bn,
  65479: Bn,
  65481: Bn,
  65482: Bn,
  65483: Bn,
  65484: s6,
  65485: Bn,
  65486: Bn,
  65487: Bn,
  65496: b6,
  65497: E6,
  65498: v6,
  65499: h6,
  65501: C6,
  65504: m6,
  65505: D6
}), G6 = new uA(R6), x6 = (e) => G6.fromBuffer(e).map(({ version: t, ...r }) => ({ type: t, ...r })), Nm = { decode: x6 };
var Ka = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, w0 = [], bn = [], k6 = typeof Uint8Array < "u" ? Uint8Array : Array, GC = !1;
function Tm() {
  GC = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", A = 0, t = e.length; A < t; ++A)
    w0[A] = e[A], bn[e.charCodeAt(A)] = A;
  bn[45] = 62, bn[95] = 63;
}
function U6(e) {
  GC || Tm();
  var A, t, r, n, i, a, o = e.length;
  if (o % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  i = e[o - 2] === "=" ? 2 : e[o - 1] === "=" ? 1 : 0, a = new k6(o * 3 / 4 - i), r = i > 0 ? o - 4 : o;
  var s = 0;
  for (A = 0, t = 0; A < r; A += 4, t += 3)
    n = bn[e.charCodeAt(A)] << 18 | bn[e.charCodeAt(A + 1)] << 12 | bn[e.charCodeAt(A + 2)] << 6 | bn[e.charCodeAt(A + 3)], a[s++] = n >> 16 & 255, a[s++] = n >> 8 & 255, a[s++] = n & 255;
  return i === 2 ? (n = bn[e.charCodeAt(A)] << 2 | bn[e.charCodeAt(A + 1)] >> 4, a[s++] = n & 255) : i === 1 && (n = bn[e.charCodeAt(A)] << 10 | bn[e.charCodeAt(A + 1)] << 4 | bn[e.charCodeAt(A + 2)] >> 2, a[s++] = n >> 8 & 255, a[s++] = n & 255), a;
}
function Y6(e) {
  return w0[e >> 18 & 63] + w0[e >> 12 & 63] + w0[e >> 6 & 63] + w0[e & 63];
}
function H6(e, A, t) {
  for (var r, n = [], i = A; i < t; i += 3)
    r = (e[i] << 16) + (e[i + 1] << 8) + e[i + 2], n.push(Y6(r));
  return n.join("");
}
function UI(e) {
  GC || Tm();
  for (var A, t = e.length, r = t % 3, n = "", i = [], a = 16383, o = 0, s = t - r; o < s; o += a)
    i.push(H6(e, o, o + a > s ? s : o + a));
  return r === 1 ? (A = e[t - 1], n += w0[A >> 2], n += w0[A << 4 & 63], n += "==") : r === 2 && (A = (e[t - 2] << 8) + e[t - 1], n += w0[A >> 10], n += w0[A >> 4 & 63], n += w0[A << 2 & 63], n += "="), i.push(n), i.join("");
}
function Kg(e, A, t, r, n) {
  var i, a, o = n * 8 - r - 1, s = (1 << o) - 1, l = s >> 1, u = -7, g = t ? n - 1 : 0, d = t ? -1 : 1, h = e[A + g];
  for (g += d, i = h & (1 << -u) - 1, h >>= -u, u += o; u > 0; i = i * 256 + e[A + g], g += d, u -= 8)
    ;
  for (a = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; a = a * 256 + e[A + g], g += d, u -= 8)
    ;
  if (i === 0)
    i = 1 - l;
  else {
    if (i === s)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), i = i - l;
  }
  return (h ? -1 : 1) * a * Math.pow(2, i - r);
}
function Pm(e, A, t, r, n, i) {
  var a, o, s, l = i * 8 - n - 1, u = (1 << l) - 1, g = u >> 1, d = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : i - 1, C = r ? 1 : -1, E = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
  for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (o = isNaN(A) ? 1 : 0, a = u) : (a = Math.floor(Math.log(A) / Math.LN2), A * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), a + g >= 1 ? A += d / s : A += d * Math.pow(2, 1 - g), A * s >= 2 && (a++, s /= 2), a + g >= u ? (o = 0, a = u) : a + g >= 1 ? (o = (A * s - 1) * Math.pow(2, n), a = a + g) : (o = A * Math.pow(2, g - 1) * Math.pow(2, n), a = 0)); n >= 8; e[t + h] = o & 255, h += C, o /= 256, n -= 8)
    ;
  for (a = a << n | o, l += n; l > 0; e[t + h] = a & 255, h += C, a /= 256, l -= 8)
    ;
  e[t + h - C] |= E * 128;
}
var S6 = {}.toString, zm = Array.isArray || function(e) {
  return S6.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var jm = 50;
kA.TYPED_ARRAY_SUPPORT = Ka.TYPED_ARRAY_SUPPORT !== void 0 ? Ka.TYPED_ARRAY_SUPPORT : !0;
var N6 = og();
function og() {
  return kA.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function q0(e, A) {
  if (og() < A)
    throw new RangeError("Invalid typed array length");
  return kA.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(A), e.__proto__ = kA.prototype) : (e === null && (e = new kA(A)), e.length = A), e;
}
function kA(e, A, t) {
  if (!kA.TYPED_ARRAY_SUPPORT && !(this instanceof kA))
    return new kA(e, A, t);
  if (typeof e == "number") {
    if (typeof A == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return xC(this, e);
  }
  return Vm(this, e, A, t);
}
kA.poolSize = 8192;
kA._augment = function(e) {
  return e.__proto__ = kA.prototype, e;
};
function Vm(e, A, t, r) {
  if (typeof A == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && A instanceof ArrayBuffer ? z6(e, A, t, r) : typeof A == "string" ? P6(e, A, t) : j6(e, A);
}
kA.from = function(e, A, t) {
  return Vm(null, e, A, t);
};
kA.TYPED_ARRAY_SUPPORT && (kA.prototype.__proto__ = Uint8Array.prototype, kA.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && kA[Symbol.species]);
function Om(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function T6(e, A, t, r) {
  return Om(A), A <= 0 ? q0(e, A) : t !== void 0 ? typeof r == "string" ? q0(e, A).fill(t, r) : q0(e, A).fill(t) : q0(e, A);
}
kA.alloc = function(e, A, t) {
  return T6(null, e, A, t);
};
function xC(e, A) {
  if (Om(A), e = q0(e, A < 0 ? 0 : kC(A) | 0), !kA.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < A; ++t)
      e[t] = 0;
  return e;
}
kA.allocUnsafe = function(e) {
  return xC(null, e);
};
kA.allocUnsafeSlow = function(e) {
  return xC(null, e);
};
function P6(e, A, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !kA.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = Jm(A, t) | 0;
  e = q0(e, r);
  var n = e.write(A, t);
  return n !== r && (e = e.slice(0, n)), e;
}
function mh(e, A) {
  var t = A.length < 0 ? 0 : kC(A.length) | 0;
  e = q0(e, t);
  for (var r = 0; r < t; r += 1)
    e[r] = A[r] & 255;
  return e;
}
function z6(e, A, t, r) {
  if (A.byteLength, t < 0 || A.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (A.byteLength < t + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && r === void 0 ? A = new Uint8Array(A) : r === void 0 ? A = new Uint8Array(A, t) : A = new Uint8Array(A, t, r), kA.TYPED_ARRAY_SUPPORT ? (e = A, e.__proto__ = kA.prototype) : e = mh(e, A), e;
}
function j6(e, A) {
  if (x0(A)) {
    var t = kC(A.length) | 0;
    return e = q0(e, t), e.length === 0 || A.copy(e, 0, 0, t), e;
  }
  if (A) {
    if (typeof ArrayBuffer < "u" && A.buffer instanceof ArrayBuffer || "length" in A)
      return typeof A.length != "number" || l9(A.length) ? q0(e, 0) : mh(e, A);
    if (A.type === "Buffer" && zm(A.data))
      return mh(e, A.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function kC(e) {
  if (e >= og())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + og().toString(16) + " bytes");
  return e | 0;
}
function V6(e) {
  return +e != e && (e = 0), kA.alloc(+e);
}
kA.isBuffer = Ra;
function x0(e) {
  return !!(e != null && e._isBuffer);
}
kA.compare = function(A, t) {
  if (!x0(A) || !x0(t))
    throw new TypeError("Arguments must be Buffers");
  if (A === t) return 0;
  for (var r = A.length, n = t.length, i = 0, a = Math.min(r, n); i < a; ++i)
    if (A[i] !== t[i]) {
      r = A[i], n = t[i];
      break;
    }
  return r < n ? -1 : n < r ? 1 : 0;
};
kA.isEncoding = function(A) {
  switch (String(A).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
kA.concat = function(A, t) {
  if (!zm(A))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (A.length === 0)
    return kA.alloc(0);
  var r;
  if (t === void 0)
    for (t = 0, r = 0; r < A.length; ++r)
      t += A[r].length;
  var n = kA.allocUnsafe(t), i = 0;
  for (r = 0; r < A.length; ++r) {
    var a = A[r];
    if (!x0(a))
      throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(n, i), i += a.length;
  }
  return n;
};
function Jm(e, A) {
  if (x0(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var t = e.length;
  if (t === 0) return 0;
  for (var r = !1; ; )
    switch (A) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return sg(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return $m(e).length;
      default:
        if (r) return sg(e).length;
        A = ("" + A).toLowerCase(), r = !0;
    }
}
kA.byteLength = Jm;
function O6(e, A, t) {
  var r = !1;
  if ((A === void 0 || A < 0) && (A = 0), A > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, A >>>= 0, t <= A))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return e9(this, A, t);
      case "utf8":
      case "utf-8":
        return Km(this, A, t);
      case "ascii":
        return $6(this, A, t);
      case "latin1":
      case "binary":
        return A9(this, A, t);
      case "base64":
        return X6(this, A, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t9(this, A, t);
      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
}
kA.prototype._isBuffer = !0;
function La(e, A, t) {
  var r = e[A];
  e[A] = e[t], e[t] = r;
}
kA.prototype.swap16 = function() {
  var A = this.length;
  if (A % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < A; t += 2)
    La(this, t, t + 1);
  return this;
};
kA.prototype.swap32 = function() {
  var A = this.length;
  if (A % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < A; t += 4)
    La(this, t, t + 3), La(this, t + 1, t + 2);
  return this;
};
kA.prototype.swap64 = function() {
  var A = this.length;
  if (A % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < A; t += 8)
    La(this, t, t + 7), La(this, t + 1, t + 6), La(this, t + 2, t + 5), La(this, t + 3, t + 4);
  return this;
};
kA.prototype.toString = function() {
  var A = this.length | 0;
  return A === 0 ? "" : arguments.length === 0 ? Km(this, 0, A) : O6.apply(this, arguments);
};
kA.prototype.equals = function(A) {
  if (!x0(A)) throw new TypeError("Argument must be a Buffer");
  return this === A ? !0 : kA.compare(this, A) === 0;
};
kA.prototype.inspect = function() {
  var A = "", t = jm;
  return this.length > 0 && (A = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (A += " ... ")), "<Buffer " + A + ">";
};
kA.prototype.compare = function(A, t, r, n, i) {
  if (!x0(A))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), r === void 0 && (r = A ? A.length : 0), n === void 0 && (n = 0), i === void 0 && (i = this.length), t < 0 || r > A.length || n < 0 || i > this.length)
    throw new RangeError("out of range index");
  if (n >= i && t >= r)
    return 0;
  if (n >= i)
    return -1;
  if (t >= r)
    return 1;
  if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === A) return 0;
  for (var a = i - n, o = r - t, s = Math.min(a, o), l = this.slice(n, i), u = A.slice(t, r), g = 0; g < s; ++g)
    if (l[g] !== u[g]) {
      a = l[g], o = u[g];
      break;
    }
  return a < o ? -1 : o < a ? 1 : 0;
};
function Wm(e, A, t, r, n) {
  if (e.length === 0) return -1;
  if (typeof t == "string" ? (r = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = n ? 0 : e.length - 1), t < 0 && (t = e.length + t), t >= e.length) {
    if (n) return -1;
    t = e.length - 1;
  } else if (t < 0)
    if (n) t = 0;
    else return -1;
  if (typeof A == "string" && (A = kA.from(A, r)), x0(A))
    return A.length === 0 ? -1 : YI(e, A, t, r, n);
  if (typeof A == "number")
    return A = A & 255, kA.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? n ? Uint8Array.prototype.indexOf.call(e, A, t) : Uint8Array.prototype.lastIndexOf.call(e, A, t) : YI(e, [A], t, r, n);
  throw new TypeError("val must be string, number or Buffer");
}
function YI(e, A, t, r, n) {
  var i = 1, a = e.length, o = A.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (e.length < 2 || A.length < 2)
      return -1;
    i = 2, a /= 2, o /= 2, t /= 2;
  }
  function s(h, C) {
    return i === 1 ? h[C] : h.readUInt16BE(C * i);
  }
  var l;
  if (n) {
    var u = -1;
    for (l = t; l < a; l++)
      if (s(e, l) === s(A, u === -1 ? 0 : l - u)) {
        if (u === -1 && (u = l), l - u + 1 === o) return u * i;
      } else
        u !== -1 && (l -= l - u), u = -1;
  } else
    for (t + o > a && (t = a - o), l = t; l >= 0; l--) {
      for (var g = !0, d = 0; d < o; d++)
        if (s(e, l + d) !== s(A, d)) {
          g = !1;
          break;
        }
      if (g) return l;
    }
  return -1;
}
kA.prototype.includes = function(A, t, r) {
  return this.indexOf(A, t, r) !== -1;
};
kA.prototype.indexOf = function(A, t, r) {
  return Wm(this, A, t, r, !0);
};
kA.prototype.lastIndexOf = function(A, t, r) {
  return Wm(this, A, t, r, !1);
};
function J6(e, A, t, r) {
  t = Number(t) || 0;
  var n = e.length - t;
  r ? (r = Number(r), r > n && (r = n)) : r = n;
  var i = A.length;
  if (i % 2 !== 0) throw new TypeError("Invalid hex string");
  r > i / 2 && (r = i / 2);
  for (var a = 0; a < r; ++a) {
    var o = parseInt(A.substr(a * 2, 2), 16);
    if (isNaN(o)) return a;
    e[t + a] = o;
  }
  return a;
}
function W6(e, A, t, r) {
  return qg(sg(A, e.length - t), e, t, r);
}
function Zm(e, A, t, r) {
  return qg(o9(A), e, t, r);
}
function Z6(e, A, t, r) {
  return Zm(e, A, t, r);
}
function K6(e, A, t, r) {
  return qg($m(A), e, t, r);
}
function _6(e, A, t, r) {
  return qg(s9(A, e.length - t), e, t, r);
}
kA.prototype.write = function(A, t, r, n) {
  if (t === void 0)
    n = "utf8", r = this.length, t = 0;
  else if (r === void 0 && typeof t == "string")
    n = t, r = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(r) ? (r = r | 0, n === void 0 && (n = "utf8")) : (n = r, r = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var i = this.length - t;
  if ((r === void 0 || r > i) && (r = i), A.length > 0 && (r < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  n || (n = "utf8");
  for (var a = !1; ; )
    switch (n) {
      case "hex":
        return J6(this, A, t, r);
      case "utf8":
      case "utf-8":
        return W6(this, A, t, r);
      case "ascii":
        return Zm(this, A, t, r);
      case "latin1":
      case "binary":
        return Z6(this, A, t, r);
      case "base64":
        return K6(this, A, t, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return _6(this, A, t, r);
      default:
        if (a) throw new TypeError("Unknown encoding: " + n);
        n = ("" + n).toLowerCase(), a = !0;
    }
};
kA.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function X6(e, A, t) {
  return A === 0 && t === e.length ? UI(e) : UI(e.slice(A, t));
}
function Km(e, A, t) {
  t = Math.min(e.length, t);
  for (var r = [], n = A; n < t; ) {
    var i = e[n], a = null, o = i > 239 ? 4 : i > 223 ? 3 : i > 191 ? 2 : 1;
    if (n + o <= t) {
      var s, l, u, g;
      switch (o) {
        case 1:
          i < 128 && (a = i);
          break;
        case 2:
          s = e[n + 1], (s & 192) === 128 && (g = (i & 31) << 6 | s & 63, g > 127 && (a = g));
          break;
        case 3:
          s = e[n + 1], l = e[n + 2], (s & 192) === 128 && (l & 192) === 128 && (g = (i & 15) << 12 | (s & 63) << 6 | l & 63, g > 2047 && (g < 55296 || g > 57343) && (a = g));
          break;
        case 4:
          s = e[n + 1], l = e[n + 2], u = e[n + 3], (s & 192) === 128 && (l & 192) === 128 && (u & 192) === 128 && (g = (i & 15) << 18 | (s & 63) << 12 | (l & 63) << 6 | u & 63, g > 65535 && g < 1114112 && (a = g));
      }
    }
    a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r.push(a), n += o;
  }
  return q6(r);
}
var HI = 4096;
function q6(e) {
  var A = e.length;
  if (A <= HI)
    return String.fromCharCode.apply(String, e);
  for (var t = "", r = 0; r < A; )
    t += String.fromCharCode.apply(
      String,
      e.slice(r, r += HI)
    );
  return t;
}
function $6(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n] & 127);
  return r;
}
function A9(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n]);
  return r;
}
function e9(e, A, t) {
  var r = e.length;
  (!A || A < 0) && (A = 0), (!t || t < 0 || t > r) && (t = r);
  for (var n = "", i = A; i < t; ++i)
    n += a9(e[i]);
  return n;
}
function t9(e, A, t) {
  for (var r = e.slice(A, t), n = "", i = 0; i < r.length; i += 2)
    n += String.fromCharCode(r[i] + r[i + 1] * 256);
  return n;
}
kA.prototype.slice = function(A, t) {
  var r = this.length;
  A = ~~A, t = t === void 0 ? r : ~~t, A < 0 ? (A += r, A < 0 && (A = 0)) : A > r && (A = r), t < 0 ? (t += r, t < 0 && (t = 0)) : t > r && (t = r), t < A && (t = A);
  var n;
  if (kA.TYPED_ARRAY_SUPPORT)
    n = this.subarray(A, t), n.__proto__ = kA.prototype;
  else {
    var i = t - A;
    n = new kA(i, void 0);
    for (var a = 0; a < i; ++a)
      n[a] = this[a + A];
  }
  return n;
};
function fr(e, A, t) {
  if (e % 1 !== 0 || e < 0) throw new RangeError("offset is not uint");
  if (e + A > t) throw new RangeError("Trying to access beyond buffer length");
}
kA.prototype.readUIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || fr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return n;
};
kA.prototype.readUIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || fr(A, t, this.length);
  for (var n = this[A + --t], i = 1; t > 0 && (i *= 256); )
    n += this[A + --t] * i;
  return n;
};
kA.prototype.readUInt8 = function(A, t) {
  return t || fr(A, 1, this.length), this[A];
};
kA.prototype.readUInt16LE = function(A, t) {
  return t || fr(A, 2, this.length), this[A] | this[A + 1] << 8;
};
kA.prototype.readUInt16BE = function(A, t) {
  return t || fr(A, 2, this.length), this[A] << 8 | this[A + 1];
};
kA.prototype.readUInt32LE = function(A, t) {
  return t || fr(A, 4, this.length), (this[A] | this[A + 1] << 8 | this[A + 2] << 16) + this[A + 3] * 16777216;
};
kA.prototype.readUInt32BE = function(A, t) {
  return t || fr(A, 4, this.length), this[A] * 16777216 + (this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3]);
};
kA.prototype.readIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || fr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return i *= 128, n >= i && (n -= Math.pow(2, 8 * t)), n;
};
kA.prototype.readIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || fr(A, t, this.length);
  for (var n = t, i = 1, a = this[A + --n]; n > 0 && (i *= 256); )
    a += this[A + --n] * i;
  return i *= 128, a >= i && (a -= Math.pow(2, 8 * t)), a;
};
kA.prototype.readInt8 = function(A, t) {
  return t || fr(A, 1, this.length), this[A] & 128 ? (255 - this[A] + 1) * -1 : this[A];
};
kA.prototype.readInt16LE = function(A, t) {
  t || fr(A, 2, this.length);
  var r = this[A] | this[A + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
kA.prototype.readInt16BE = function(A, t) {
  t || fr(A, 2, this.length);
  var r = this[A + 1] | this[A] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
kA.prototype.readInt32LE = function(A, t) {
  return t || fr(A, 4, this.length), this[A] | this[A + 1] << 8 | this[A + 2] << 16 | this[A + 3] << 24;
};
kA.prototype.readInt32BE = function(A, t) {
  return t || fr(A, 4, this.length), this[A] << 24 | this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3];
};
kA.prototype.readFloatLE = function(A, t) {
  return t || fr(A, 4, this.length), Kg(this, A, !0, 23, 4);
};
kA.prototype.readFloatBE = function(A, t) {
  return t || fr(A, 4, this.length), Kg(this, A, !1, 23, 4);
};
kA.prototype.readDoubleLE = function(A, t) {
  return t || fr(A, 8, this.length), Kg(this, A, !0, 52, 8);
};
kA.prototype.readDoubleBE = function(A, t) {
  return t || fr(A, 8, this.length), Kg(this, A, !1, 52, 8);
};
function nn(e, A, t, r, n, i) {
  if (!x0(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (A > n || A < i) throw new RangeError('"value" argument is out of bounds');
  if (t + r > e.length) throw new RangeError("Index out of range");
}
kA.prototype.writeUIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    nn(this, A, t, r, i, 0);
  }
  var a = 1, o = 0;
  for (this[t] = A & 255; ++o < r && (a *= 256); )
    this[t + o] = A / a & 255;
  return t + r;
};
kA.prototype.writeUIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    nn(this, A, t, r, i, 0);
  }
  var a = r - 1, o = 1;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    this[t + a] = A / o & 255;
  return t + r;
};
kA.prototype.writeUInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 1, 255, 0), kA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), this[t] = A & 255, t + 1;
};
function _g(e, A, t, r) {
  A < 0 && (A = 65535 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 2); n < i; ++n)
    e[t + n] = (A & 255 << 8 * (r ? n : 1 - n)) >>> (r ? n : 1 - n) * 8;
}
kA.prototype.writeUInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 2, 65535, 0), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : _g(this, A, t, !0), t + 2;
};
kA.prototype.writeUInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 2, 65535, 0), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : _g(this, A, t, !1), t + 2;
};
function Xg(e, A, t, r) {
  A < 0 && (A = 4294967295 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 4); n < i; ++n)
    e[t + n] = A >>> (r ? n : 3 - n) * 8 & 255;
}
kA.prototype.writeUInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 4, 4294967295, 0), kA.TYPED_ARRAY_SUPPORT ? (this[t + 3] = A >>> 24, this[t + 2] = A >>> 16, this[t + 1] = A >>> 8, this[t] = A & 255) : Xg(this, A, t, !0), t + 4;
};
kA.prototype.writeUInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 4, 4294967295, 0), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : Xg(this, A, t, !1), t + 4;
};
kA.prototype.writeIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    nn(this, A, t, r, i - 1, -i);
  }
  var a = 0, o = 1, s = 0;
  for (this[t] = A & 255; ++a < r && (o *= 256); )
    A < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
kA.prototype.writeIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    nn(this, A, t, r, i - 1, -i);
  }
  var a = r - 1, o = 1, s = 0;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    A < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
kA.prototype.writeInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 1, 127, -128), kA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), A < 0 && (A = 255 + A + 1), this[t] = A & 255, t + 1;
};
kA.prototype.writeInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 2, 32767, -32768), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : _g(this, A, t, !0), t + 2;
};
kA.prototype.writeInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 2, 32767, -32768), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : _g(this, A, t, !1), t + 2;
};
kA.prototype.writeInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 4, 2147483647, -2147483648), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8, this[t + 2] = A >>> 16, this[t + 3] = A >>> 24) : Xg(this, A, t, !0), t + 4;
};
kA.prototype.writeInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || nn(this, A, t, 4, 2147483647, -2147483648), A < 0 && (A = 4294967295 + A + 1), kA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : Xg(this, A, t, !1), t + 4;
};
function _m(e, A, t, r, n, i) {
  if (t + r > e.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function Xm(e, A, t, r, n) {
  return n || _m(e, A, t, 4), Pm(e, A, t, r, 23, 4), t + 4;
}
kA.prototype.writeFloatLE = function(A, t, r) {
  return Xm(this, A, t, !0, r);
};
kA.prototype.writeFloatBE = function(A, t, r) {
  return Xm(this, A, t, !1, r);
};
function qm(e, A, t, r, n) {
  return n || _m(e, A, t, 8), Pm(e, A, t, r, 52, 8), t + 8;
}
kA.prototype.writeDoubleLE = function(A, t, r) {
  return qm(this, A, t, !0, r);
};
kA.prototype.writeDoubleBE = function(A, t, r) {
  return qm(this, A, t, !1, r);
};
kA.prototype.copy = function(A, t, r, n) {
  if (r || (r = 0), !n && n !== 0 && (n = this.length), t >= A.length && (t = A.length), t || (t = 0), n > 0 && n < r && (n = r), n === r || A.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
  if (n < 0) throw new RangeError("sourceEnd out of bounds");
  n > this.length && (n = this.length), A.length - t < n - r && (n = A.length - t + r);
  var i = n - r, a;
  if (this === A && r < t && t < n)
    for (a = i - 1; a >= 0; --a)
      A[a + t] = this[a + r];
  else if (i < 1e3 || !kA.TYPED_ARRAY_SUPPORT)
    for (a = 0; a < i; ++a)
      A[a + t] = this[a + r];
  else
    Uint8Array.prototype.set.call(
      A,
      this.subarray(r, r + i),
      t
    );
  return i;
};
kA.prototype.fill = function(A, t, r, n) {
  if (typeof A == "string") {
    if (typeof t == "string" ? (n = t, t = 0, r = this.length) : typeof r == "string" && (n = r, r = this.length), A.length === 1) {
      var i = A.charCodeAt(0);
      i < 256 && (A = i);
    }
    if (n !== void 0 && typeof n != "string")
      throw new TypeError("encoding must be a string");
    if (typeof n == "string" && !kA.isEncoding(n))
      throw new TypeError("Unknown encoding: " + n);
  } else typeof A == "number" && (A = A & 255);
  if (t < 0 || this.length < t || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= t)
    return this;
  t = t >>> 0, r = r === void 0 ? this.length : r >>> 0, A || (A = 0);
  var a;
  if (typeof A == "number")
    for (a = t; a < r; ++a)
      this[a] = A;
  else {
    var o = x0(A) ? A : sg(new kA(A, n).toString()), s = o.length;
    for (a = 0; a < r - t; ++a)
      this[a + t] = o[a % s];
  }
  return this;
};
var r9 = /[^+\/0-9A-Za-z-_]/g;
function n9(e) {
  if (e = i9(e).replace(r9, ""), e.length < 2) return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function i9(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function a9(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function sg(e, A) {
  A = A || 1 / 0;
  for (var t, r = e.length, n = null, i = [], a = 0; a < r; ++a) {
    if (t = e.charCodeAt(a), t > 55295 && t < 57344) {
      if (!n) {
        if (t > 56319) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        } else if (a + 1 === r) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        }
        n = t;
        continue;
      }
      if (t < 56320) {
        (A -= 3) > -1 && i.push(239, 191, 189), n = t;
        continue;
      }
      t = (n - 55296 << 10 | t - 56320) + 65536;
    } else n && (A -= 3) > -1 && i.push(239, 191, 189);
    if (n = null, t < 128) {
      if ((A -= 1) < 0) break;
      i.push(t);
    } else if (t < 2048) {
      if ((A -= 2) < 0) break;
      i.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((A -= 3) < 0) break;
      i.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((A -= 4) < 0) break;
      i.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return i;
}
function o9(e) {
  for (var A = [], t = 0; t < e.length; ++t)
    A.push(e.charCodeAt(t) & 255);
  return A;
}
function s9(e, A) {
  for (var t, r, n, i = [], a = 0; a < e.length && !((A -= 2) < 0); ++a)
    t = e.charCodeAt(a), r = t >> 8, n = t % 256, i.push(n), i.push(r);
  return i;
}
function $m(e) {
  return U6(n9(e));
}
function qg(e, A, t, r) {
  for (var n = 0; n < r && !(n + t >= A.length || n >= e.length); ++n)
    A[n + t] = e[n];
  return n;
}
function l9(e) {
  return e !== e;
}
function Ra(e) {
  return e != null && (!!e._isBuffer || AM(e) || u9(e));
}
function AM(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function u9(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && AM(e.slice(0, 0));
}
var c9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Buffer: kA,
  INSPECT_MAX_BYTES: jm,
  SlowBuffer: V6,
  isBuffer: Ra,
  kMaxLength: N6
});
function eM() {
  throw new Error("setTimeout has not been defined");
}
function tM() {
  throw new Error("clearTimeout has not been defined");
}
var vi = eM, yi = tM;
typeof Ka.setTimeout == "function" && (vi = setTimeout);
typeof Ka.clearTimeout == "function" && (yi = clearTimeout);
function rM(e) {
  if (vi === setTimeout)
    return setTimeout(e, 0);
  if ((vi === eM || !vi) && setTimeout)
    return vi = setTimeout, setTimeout(e, 0);
  try {
    return vi(e, 0);
  } catch {
    try {
      return vi.call(null, e, 0);
    } catch {
      return vi.call(this, e, 0);
    }
  }
}
function g9(e) {
  if (yi === clearTimeout)
    return clearTimeout(e);
  if ((yi === tM || !yi) && clearTimeout)
    return yi = clearTimeout, clearTimeout(e);
  try {
    return yi(e);
  } catch {
    try {
      return yi.call(null, e);
    } catch {
      return yi.call(this, e);
    }
  }
}
var $0 = [], To = !1, Ga, mc = -1;
function B9() {
  !To || !Ga || (To = !1, Ga.length ? $0 = Ga.concat($0) : mc = -1, $0.length && nM());
}
function nM() {
  if (!To) {
    var e = rM(B9);
    To = !0;
    for (var A = $0.length; A; ) {
      for (Ga = $0, $0 = []; ++mc < A; )
        Ga && Ga[mc].run();
      mc = -1, A = $0.length;
    }
    Ga = null, To = !1, g9(e);
  }
}
function wn(e) {
  var A = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      A[t - 1] = arguments[t];
  $0.push(new iM(e, A)), $0.length === 1 && !To && rM(nM);
}
function iM(e, A) {
  this.fun = e, this.array = A;
}
iM.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var f9 = "browser", d9 = "browser", h9 = !0, C9 = {}, E9 = [], Q9 = "", w9 = {}, I9 = {}, D9 = {};
function eo() {
}
var m9 = eo, M9 = eo, p9 = eo, v9 = eo, y9 = eo, b9 = eo, F9 = eo;
function L9(e) {
  throw new Error("process.binding is not supported");
}
function R9() {
  return "/";
}
function G9(e) {
  throw new Error("process.chdir is not supported");
}
function x9() {
  return 0;
}
var bo = Ka.performance || {}, k9 = bo.now || bo.mozNow || bo.msNow || bo.oNow || bo.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function U9(e) {
  var A = k9.call(bo) * 1e-3, t = Math.floor(A), r = Math.floor(A % 1 * 1e9);
  return e && (t = t - e[0], r = r - e[1], r < 0 && (t--, r += 1e9)), [t, r];
}
var Y9 = /* @__PURE__ */ new Date();
function H9() {
  var e = /* @__PURE__ */ new Date(), A = e - Y9;
  return A / 1e3;
}
var Vn = {
  nextTick: wn,
  title: f9,
  browser: h9,
  env: C9,
  argv: E9,
  version: Q9,
  versions: w9,
  on: m9,
  addListener: M9,
  once: p9,
  off: v9,
  removeListener: y9,
  removeAllListeners: b9,
  emit: F9,
  binding: L9,
  cwd: R9,
  chdir: G9,
  umask: x9,
  hrtime: U9,
  platform: d9,
  release: I9,
  config: D9,
  uptime: H9
};
function S9(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $g(e) {
  if (e.__esModule) return e;
  var A = e.default;
  if (typeof A == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(A, arguments, this.constructor) : A.apply(this, arguments);
    };
    t.prototype = A.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), t;
}
var aM = {}, SI = /* @__PURE__ */ $g(c9), N9;
function zi() {
}
zi.prototype = /* @__PURE__ */ Object.create(null);
function ht() {
  ht.init.call(this);
}
ht.EventEmitter = ht;
ht.usingDomains = !1;
ht.prototype.domain = void 0;
ht.prototype._events = void 0;
ht.prototype._maxListeners = void 0;
ht.defaultMaxListeners = 10;
ht.init = function() {
  this.domain = null, ht.usingDomains && N9.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new zi(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ht.prototype.setMaxListeners = function(A) {
  if (typeof A != "number" || A < 0 || isNaN(A))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = A, this;
};
function oM(e) {
  return e._maxListeners === void 0 ? ht.defaultMaxListeners : e._maxListeners;
}
ht.prototype.getMaxListeners = function() {
  return oM(this);
};
function T9(e, A, t) {
  if (A)
    e.call(t);
  else
    for (var r = e.length, n = zl(e, r), i = 0; i < r; ++i)
      n[i].call(t);
}
function P9(e, A, t, r) {
  if (A)
    e.call(t, r);
  else
    for (var n = e.length, i = zl(e, n), a = 0; a < n; ++a)
      i[a].call(t, r);
}
function z9(e, A, t, r, n) {
  if (A)
    e.call(t, r, n);
  else
    for (var i = e.length, a = zl(e, i), o = 0; o < i; ++o)
      a[o].call(t, r, n);
}
function j9(e, A, t, r, n, i) {
  if (A)
    e.call(t, r, n, i);
  else
    for (var a = e.length, o = zl(e, a), s = 0; s < a; ++s)
      o[s].call(t, r, n, i);
}
function V9(e, A, t, r) {
  if (A)
    e.apply(t, r);
  else
    for (var n = e.length, i = zl(e, n), a = 0; a < n; ++a)
      i[a].apply(t, r);
}
ht.prototype.emit = function(A) {
  var t, r, n, i, a, o, s, l = A === "error";
  if (o = this._events, o)
    l = l && o.error == null;
  else if (!l)
    return !1;
  if (s = this.domain, l) {
    if (t = arguments[1], s)
      t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t);
    else {
      if (t instanceof Error)
        throw t;
      var u = new Error('Uncaught, unspecified "error" event. (' + t + ")");
      throw u.context = t, u;
    }
    return !1;
  }
  if (r = o[A], !r)
    return !1;
  var g = typeof r == "function";
  switch (n = arguments.length, n) {
    // fast cases
    case 1:
      T9(r, g, this);
      break;
    case 2:
      P9(r, g, this, arguments[1]);
      break;
    case 3:
      z9(r, g, this, arguments[1], arguments[2]);
      break;
    case 4:
      j9(r, g, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      for (i = new Array(n - 1), a = 1; a < n; a++)
        i[a - 1] = arguments[a];
      V9(r, g, this, i);
  }
  return !0;
};
function sM(e, A, t, r) {
  var n, i, a;
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = e._events, i ? (i.newListener && (e.emit(
    "newListener",
    A,
    t.listener ? t.listener : t
  ), i = e._events), a = i[A]) : (i = e._events = new zi(), e._eventsCount = 0), !a)
    a = i[A] = t, ++e._eventsCount;
  else if (typeof a == "function" ? a = i[A] = r ? [t, a] : [a, t] : r ? a.unshift(t) : a.push(t), !a.warned && (n = oM(e), n && n > 0 && a.length > n)) {
    a.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + A + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = A, o.count = a.length, O9(o);
  }
  return e;
}
function O9(e) {
  typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
ht.prototype.addListener = function(A, t) {
  return sM(this, A, t, !1);
};
ht.prototype.on = ht.prototype.addListener;
ht.prototype.prependListener = function(A, t) {
  return sM(this, A, t, !0);
};
function lM(e, A, t) {
  var r = !1;
  function n() {
    e.removeListener(A, n), r || (r = !0, t.apply(e, arguments));
  }
  return n.listener = t, n;
}
ht.prototype.once = function(A, t) {
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(A, lM(this, A, t)), this;
};
ht.prototype.prependOnceListener = function(A, t) {
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(A, lM(this, A, t)), this;
};
ht.prototype.removeListener = function(A, t) {
  var r, n, i, a, o;
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  if (n = this._events, !n)
    return this;
  if (r = n[A], !r)
    return this;
  if (r === t || r.listener && r.listener === t)
    --this._eventsCount === 0 ? this._events = new zi() : (delete n[A], n.removeListener && this.emit("removeListener", A, r.listener || t));
  else if (typeof r != "function") {
    for (i = -1, a = r.length; a-- > 0; )
      if (r[a] === t || r[a].listener && r[a].listener === t) {
        o = r[a].listener, i = a;
        break;
      }
    if (i < 0)
      return this;
    if (r.length === 1) {
      if (r[0] = void 0, --this._eventsCount === 0)
        return this._events = new zi(), this;
      delete n[A];
    } else
      J9(r, i);
    n.removeListener && this.emit("removeListener", A, o || t);
  }
  return this;
};
ht.prototype.off = function(e, A) {
  return this.removeListener(e, A);
};
ht.prototype.removeAllListeners = function(A) {
  var t, r;
  if (r = this._events, !r)
    return this;
  if (!r.removeListener)
    return arguments.length === 0 ? (this._events = new zi(), this._eventsCount = 0) : r[A] && (--this._eventsCount === 0 ? this._events = new zi() : delete r[A]), this;
  if (arguments.length === 0) {
    for (var n = Object.keys(r), i = 0, a; i < n.length; ++i)
      a = n[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = new zi(), this._eventsCount = 0, this;
  }
  if (t = r[A], typeof t == "function")
    this.removeListener(A, t);
  else if (t)
    do
      this.removeListener(A, t[t.length - 1]);
    while (t[0]);
  return this;
};
ht.prototype.listeners = function(A) {
  var t, r, n = this._events;
  return n ? (t = n[A], t ? typeof t == "function" ? r = [t.listener || t] : r = W9(t) : r = []) : r = [], r;
};
ht.listenerCount = function(e, A) {
  return typeof e.listenerCount == "function" ? e.listenerCount(A) : uM.call(e, A);
};
ht.prototype.listenerCount = uM;
function uM(e) {
  var A = this._events;
  if (A) {
    var t = A[e];
    if (typeof t == "function")
      return 1;
    if (t)
      return t.length;
  }
  return 0;
}
ht.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function J9(e, A) {
  for (var t = A, r = t + 1, n = e.length; r < n; t += 1, r += 1)
    e[t] = e[r];
  e.pop();
}
function zl(e, A) {
  for (var t = new Array(A); A--; )
    t[A] = e[A];
  return t;
}
function W9(e) {
  for (var A = new Array(e.length), t = 0; t < A.length; ++t)
    A[t] = e[t].listener || e[t];
  return A;
}
var Mh;
typeof Object.create == "function" ? Mh = function(A, t) {
  A.super_ = t, A.prototype = Object.create(t.prototype, {
    constructor: {
      value: A,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : Mh = function(A, t) {
  A.super_ = t;
  var r = function() {
  };
  r.prototype = t.prototype, A.prototype = new r(), A.prototype.constructor = A;
};
var ui = Mh, cM = Object.getOwnPropertyDescriptors || function(A) {
  for (var t = Object.keys(A), r = {}, n = 0; n < t.length; n++)
    r[t[n]] = Object.getOwnPropertyDescriptor(A, t[n]);
  return r;
}, Z9 = /%[sdj%]/g;
function AB(e) {
  if (!Vl(e)) {
    for (var A = [], t = 0; t < arguments.length; t++)
      A.push(On(arguments[t]));
    return A.join(" ");
  }
  for (var t = 1, r = arguments, n = r.length, i = String(e).replace(Z9, function(o) {
    if (o === "%%") return "%";
    if (t >= n) return o;
    switch (o) {
      case "%s":
        return String(r[t++]);
      case "%d":
        return Number(r[t++]);
      case "%j":
        try {
          return JSON.stringify(r[t++]);
        } catch {
          return "[Circular]";
        }
      default:
        return o;
    }
  }), a = r[t]; t < n; a = r[++t])
    jl(a) || !to(a) ? i += " " + a : i += " " + On(a);
  return i;
}
function eB(e, A) {
  if (y0(Ka.process))
    return function() {
      return eB(e, A).apply(this, arguments);
    };
  if (Vn.noDeprecation === !0)
    return e;
  var t = !1;
  function r() {
    if (!t) {
      if (Vn.throwDeprecation)
        throw new Error(A);
      Vn.traceDeprecation ? console.trace(A) : console.error(A), t = !0;
    }
    return e.apply(this, arguments);
  }
  return r;
}
var Ju = {}, Xf;
function UC(e) {
  if (y0(Xf) && (Xf = Vn.env.NODE_DEBUG || ""), e = e.toUpperCase(), !Ju[e])
    if (new RegExp("\\b" + e + "\\b", "i").test(Xf)) {
      var A = 0;
      Ju[e] = function() {
        var t = AB.apply(null, arguments);
        console.error("%s %d: %s", e, A, t);
      };
    } else
      Ju[e] = function() {
      };
  return Ju[e];
}
function On(e, A) {
  var t = {
    seen: [],
    stylize: _9
  };
  return arguments.length >= 3 && (t.depth = arguments[2]), arguments.length >= 4 && (t.colors = arguments[3]), tB(A) ? t.showHidden = A : A && NC(t, A), y0(t.showHidden) && (t.showHidden = !1), y0(t.depth) && (t.depth = 2), y0(t.colors) && (t.colors = !1), y0(t.customInspect) && (t.customInspect = !0), t.colors && (t.stylize = K9), lg(t, e, t.depth);
}
On.colors = {
  bold: [1, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  white: [37, 39],
  grey: [90, 39],
  black: [30, 39],
  blue: [34, 39],
  cyan: [36, 39],
  green: [32, 39],
  magenta: [35, 39],
  red: [31, 39],
  yellow: [33, 39]
};
On.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  // "name": intentionally not styling
  regexp: "red"
};
function K9(e, A) {
  var t = On.styles[A];
  return t ? "\x1B[" + On.colors[t][0] + "m" + e + "\x1B[" + On.colors[t][1] + "m" : e;
}
function _9(e, A) {
  return e;
}
function X9(e) {
  var A = {};
  return e.forEach(function(t, r) {
    A[t] = !0;
  }), A;
}
function lg(e, A, t) {
  if (e.customInspect && A && Pa(A.inspect) && // Filter out the util module, it's inspect function is special
  A.inspect !== On && // Also filter out any prototype objects using the circular check.
  !(A.constructor && A.constructor.prototype === A)) {
    var r = A.inspect(t, e);
    return Vl(r) || (r = lg(e, r, t)), r;
  }
  var n = q9(e, A);
  if (n)
    return n;
  var i = Object.keys(A), a = X9(i);
  if (e.showHidden && (i = Object.getOwnPropertyNames(A)), Po(A) && (i.indexOf("message") >= 0 || i.indexOf("description") >= 0))
    return qf(A);
  if (i.length === 0) {
    if (Pa(A)) {
      var o = A.name ? ": " + A.name : "";
      return e.stylize("[Function" + o + "]", "special");
    }
    if (Ta(A))
      return e.stylize(RegExp.prototype.toString.call(A), "regexp");
    if (qo(A))
      return e.stylize(Date.prototype.toString.call(A), "date");
    if (Po(A))
      return qf(A);
  }
  var s = "", l = !1, u = ["{", "}"];
  if (YC(A) && (l = !0, u = ["[", "]"]), Pa(A)) {
    var g = A.name ? ": " + A.name : "";
    s = " [Function" + g + "]";
  }
  if (Ta(A) && (s = " " + RegExp.prototype.toString.call(A)), qo(A) && (s = " " + Date.prototype.toUTCString.call(A)), Po(A) && (s = " " + qf(A)), i.length === 0 && (!l || A.length == 0))
    return u[0] + s + u[1];
  if (t < 0)
    return Ta(A) ? e.stylize(RegExp.prototype.toString.call(A), "regexp") : e.stylize("[Object]", "special");
  e.seen.push(A);
  var d;
  return l ? d = $9(e, A, t, a, i) : d = i.map(function(h) {
    return ph(e, A, t, a, h, l);
  }), e.seen.pop(), A7(d, s, u);
}
function q9(e, A) {
  if (y0(A))
    return e.stylize("undefined", "undefined");
  if (Vl(A)) {
    var t = "'" + JSON.stringify(A).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
    return e.stylize(t, "string");
  }
  if (HC(A))
    return e.stylize("" + A, "number");
  if (tB(A))
    return e.stylize("" + A, "boolean");
  if (jl(A))
    return e.stylize("null", "null");
}
function qf(e) {
  return "[" + Error.prototype.toString.call(e) + "]";
}
function $9(e, A, t, r, n) {
  for (var i = [], a = 0, o = A.length; a < o; ++a)
    hM(A, String(a)) ? i.push(ph(
      e,
      A,
      t,
      r,
      String(a),
      !0
    )) : i.push("");
  return n.forEach(function(s) {
    s.match(/^\d+$/) || i.push(ph(
      e,
      A,
      t,
      r,
      s,
      !0
    ));
  }), i;
}
function ph(e, A, t, r, n, i) {
  var a, o, s;
  if (s = Object.getOwnPropertyDescriptor(A, n) || { value: A[n] }, s.get ? s.set ? o = e.stylize("[Getter/Setter]", "special") : o = e.stylize("[Getter]", "special") : s.set && (o = e.stylize("[Setter]", "special")), hM(r, n) || (a = "[" + n + "]"), o || (e.seen.indexOf(s.value) < 0 ? (jl(t) ? o = lg(e, s.value, null) : o = lg(e, s.value, t - 1), o.indexOf(`
`) > -1 && (i ? o = o.split(`
`).map(function(l) {
    return "  " + l;
  }).join(`
`).substr(2) : o = `
` + o.split(`
`).map(function(l) {
    return "   " + l;
  }).join(`
`))) : o = e.stylize("[Circular]", "special")), y0(a)) {
    if (i && n.match(/^\d+$/))
      return o;
    a = JSON.stringify("" + n), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
  }
  return a + ": " + o;
}
function A7(e, A, t) {
  var r = e.reduce(function(n, i) {
    return i.indexOf(`
`) >= 0, n + i.replace(/\u001b\[\d\d?m/g, "").length + 1;
  }, 0);
  return r > 60 ? t[0] + (A === "" ? "" : A + `
 `) + " " + e.join(`,
  `) + " " + t[1] : t[0] + A + " " + e.join(", ") + " " + t[1];
}
function YC(e) {
  return Array.isArray(e);
}
function tB(e) {
  return typeof e == "boolean";
}
function jl(e) {
  return e === null;
}
function gM(e) {
  return e == null;
}
function HC(e) {
  return typeof e == "number";
}
function Vl(e) {
  return typeof e == "string";
}
function BM(e) {
  return typeof e == "symbol";
}
function y0(e) {
  return e === void 0;
}
function Ta(e) {
  return to(e) && SC(e) === "[object RegExp]";
}
function to(e) {
  return typeof e == "object" && e !== null;
}
function qo(e) {
  return to(e) && SC(e) === "[object Date]";
}
function Po(e) {
  return to(e) && (SC(e) === "[object Error]" || e instanceof Error);
}
function Pa(e) {
  return typeof e == "function";
}
function ug(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
  typeof e > "u";
}
function fM(e) {
  return kA.isBuffer(e);
}
function SC(e) {
  return Object.prototype.toString.call(e);
}
function $f(e) {
  return e < 10 ? "0" + e.toString(10) : e.toString(10);
}
var e7 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function t7() {
  var e = /* @__PURE__ */ new Date(), A = [
    $f(e.getHours()),
    $f(e.getMinutes()),
    $f(e.getSeconds())
  ].join(":");
  return [e.getDate(), e7[e.getMonth()], A].join(" ");
}
function dM() {
  console.log("%s - %s", t7(), AB.apply(null, arguments));
}
function NC(e, A) {
  if (!A || !to(A)) return e;
  for (var t = Object.keys(A), r = t.length; r--; )
    e[t[r]] = A[t[r]];
  return e;
}
function hM(e, A) {
  return Object.prototype.hasOwnProperty.call(e, A);
}
var Ma = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function TC(e) {
  if (typeof e != "function")
    throw new TypeError('The "original" argument must be of type Function');
  if (Ma && e[Ma]) {
    var A = e[Ma];
    if (typeof A != "function")
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    return Object.defineProperty(A, Ma, {
      value: A,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), A;
  }
  function A() {
    for (var t, r, n = new Promise(function(o, s) {
      t = o, r = s;
    }), i = [], a = 0; a < arguments.length; a++)
      i.push(arguments[a]);
    i.push(function(o, s) {
      o ? r(o) : t(s);
    });
    try {
      e.apply(this, i);
    } catch (o) {
      r(o);
    }
    return n;
  }
  return Object.setPrototypeOf(A, Object.getPrototypeOf(e)), Ma && Object.defineProperty(A, Ma, {
    value: A,
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), Object.defineProperties(
    A,
    cM(e)
  );
}
TC.custom = Ma;
function r7(e, A) {
  if (!e) {
    var t = new Error("Promise was rejected with a falsy value");
    t.reason = e, e = t;
  }
  return A(e);
}
function CM(e) {
  if (typeof e != "function")
    throw new TypeError('The "original" argument must be of type Function');
  function A() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t.push(arguments[r]);
    var n = t.pop();
    if (typeof n != "function")
      throw new TypeError("The last argument must be of type Function");
    var i = this, a = function() {
      return n.apply(i, arguments);
    };
    e.apply(this, t).then(
      function(o) {
        Vn.nextTick(a.bind(null, null, o));
      },
      function(o) {
        Vn.nextTick(r7.bind(null, o, a));
      }
    );
  }
  return Object.setPrototypeOf(A, Object.getPrototypeOf(e)), Object.defineProperties(A, cM(e)), A;
}
var n7 = {
  inherits: ui,
  _extend: NC,
  log: dM,
  isBuffer: fM,
  isPrimitive: ug,
  isFunction: Pa,
  isError: Po,
  isDate: qo,
  isObject: to,
  isRegExp: Ta,
  isUndefined: y0,
  isSymbol: BM,
  isString: Vl,
  isNumber: HC,
  isNullOrUndefined: gM,
  isNull: jl,
  isBoolean: tB,
  isArray: YC,
  inspect: On,
  deprecate: eB,
  format: AB,
  debuglog: UC,
  promisify: TC,
  callbackify: CM
}, i7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _extend: NC,
  callbackify: CM,
  debuglog: UC,
  default: n7,
  deprecate: eB,
  format: AB,
  inherits: ui,
  inspect: On,
  isArray: YC,
  isBoolean: tB,
  isBuffer: fM,
  isDate: qo,
  isError: Po,
  isFunction: Pa,
  isNull: jl,
  isNullOrUndefined: gM,
  isNumber: HC,
  isObject: to,
  isPrimitive: ug,
  isRegExp: Ta,
  isString: Vl,
  isSymbol: BM,
  isUndefined: y0,
  log: dM,
  promisify: TC
});
function ro() {
  this.head = null, this.tail = null, this.length = 0;
}
ro.prototype.push = function(e) {
  var A = { data: e, next: null };
  this.length > 0 ? this.tail.next = A : this.head = A, this.tail = A, ++this.length;
};
ro.prototype.unshift = function(e) {
  var A = { data: e, next: this.head };
  this.length === 0 && (this.tail = A), this.head = A, ++this.length;
};
ro.prototype.shift = function() {
  if (this.length !== 0) {
    var e = this.head.data;
    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
  }
};
ro.prototype.clear = function() {
  this.head = this.tail = null, this.length = 0;
};
ro.prototype.join = function(e) {
  if (this.length === 0) return "";
  for (var A = this.head, t = "" + A.data; A = A.next; )
    t += e + A.data;
  return t;
};
ro.prototype.concat = function(e) {
  if (this.length === 0) return kA.alloc(0);
  if (this.length === 1) return this.head.data;
  for (var A = kA.allocUnsafe(e >>> 0), t = this.head, r = 0; t; )
    t.data.copy(A, r), r += t.data.length, t = t.next;
  return A;
};
var a7 = kA.isEncoding || function(e) {
  switch (e && e.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function o7(e) {
  if (e && !a7(e))
    throw new Error("Unknown encoding: " + e);
}
function Ol(e) {
  switch (this.encoding = (e || "utf8").toLowerCase().replace(/[-_]/, ""), o7(e), this.encoding) {
    case "utf8":
      this.surrogateSize = 3;
      break;
    case "ucs2":
    case "utf16le":
      this.surrogateSize = 2, this.detectIncompleteChar = l7;
      break;
    case "base64":
      this.surrogateSize = 3, this.detectIncompleteChar = u7;
      break;
    default:
      this.write = s7;
      return;
  }
  this.charBuffer = new kA(6), this.charReceived = 0, this.charLength = 0;
}
Ol.prototype.write = function(e) {
  for (var A = ""; this.charLength; ) {
    var t = e.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : e.length;
    if (e.copy(this.charBuffer, this.charReceived, 0, t), this.charReceived += t, this.charReceived < this.charLength)
      return "";
    e = e.slice(t, e.length), A = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
    var n = A.charCodeAt(A.length - 1);
    if (n >= 55296 && n <= 56319) {
      this.charLength += this.surrogateSize, A = "";
      continue;
    }
    if (this.charReceived = this.charLength = 0, e.length === 0)
      return A;
    break;
  }
  this.detectIncompleteChar(e);
  var r = e.length;
  this.charLength && (e.copy(this.charBuffer, 0, e.length - this.charReceived, r), r -= this.charReceived), A += e.toString(this.encoding, 0, r);
  var r = A.length - 1, n = A.charCodeAt(r);
  if (n >= 55296 && n <= 56319) {
    var i = this.surrogateSize;
    return this.charLength += i, this.charReceived += i, this.charBuffer.copy(this.charBuffer, i, 0, i), e.copy(this.charBuffer, 0, 0, i), A.substring(0, r);
  }
  return A;
};
Ol.prototype.detectIncompleteChar = function(e) {
  for (var A = e.length >= 3 ? 3 : e.length; A > 0; A--) {
    var t = e[e.length - A];
    if (A == 1 && t >> 5 == 6) {
      this.charLength = 2;
      break;
    }
    if (A <= 2 && t >> 4 == 14) {
      this.charLength = 3;
      break;
    }
    if (A <= 3 && t >> 3 == 30) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = A;
};
Ol.prototype.end = function(e) {
  var A = "";
  if (e && e.length && (A = this.write(e)), this.charReceived) {
    var t = this.charReceived, r = this.charBuffer, n = this.encoding;
    A += r.slice(0, t).toString(n);
  }
  return A;
};
function s7(e) {
  return e.toString(this.encoding);
}
function l7(e) {
  this.charReceived = e.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function u7(e) {
  this.charReceived = e.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
_t.ReadableState = EM;
var xt = UC("stream");
ui(_t, ht);
function c7(e, A, t) {
  if (typeof e.prependListener == "function")
    return e.prependListener(A, t);
  !e._events || !e._events[A] ? e.on(A, t) : Array.isArray(e._events[A]) ? e._events[A].unshift(t) : e._events[A] = [t, e._events[A]];
}
function g7(e, A) {
  return e.listeners(A).length;
}
function EM(e, A) {
  e = e || {}, this.objectMode = !!e.objectMode, A instanceof En && (this.objectMode = this.objectMode || !!e.readableObjectMode);
  var t = e.highWaterMark, r = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = t || t === 0 ? t : r, this.highWaterMark = ~~this.highWaterMark, this.buffer = new ro(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (this.decoder = new Ol(e.encoding), this.encoding = e.encoding);
}
function _t(e) {
  if (!(this instanceof _t)) return new _t(e);
  this._readableState = new EM(e, this), this.readable = !0, e && typeof e.read == "function" && (this._read = e.read), ht.call(this);
}
_t.prototype.push = function(e, A) {
  var t = this._readableState;
  return !t.objectMode && typeof e == "string" && (A = A || t.defaultEncoding, A !== t.encoding && (e = kA.from(e, A), A = "")), QM(this, t, e, A, !1);
};
_t.prototype.unshift = function(e) {
  var A = this._readableState;
  return QM(this, A, e, "", !0);
};
_t.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
function QM(e, A, t, r, n) {
  var i = d7(A, t);
  if (i)
    e.emit("error", i);
  else if (t === null)
    A.reading = !1, h7(e, A);
  else if (A.objectMode || t && t.length > 0)
    if (A.ended && !n) {
      var a = new Error("stream.push() after EOF");
      e.emit("error", a);
    } else if (A.endEmitted && n) {
      var o = new Error("stream.unshift() after end event");
      e.emit("error", o);
    } else {
      var s;
      A.decoder && !n && !r && (t = A.decoder.write(t), s = !A.objectMode && t.length === 0), n || (A.reading = !1), s || (A.flowing && A.length === 0 && !A.sync ? (e.emit("data", t), e.read(0)) : (A.length += A.objectMode ? 1 : t.length, n ? A.buffer.unshift(t) : A.buffer.push(t), A.needReadable && rB(e))), C7(e, A);
    }
  else n || (A.reading = !1);
  return B7(A);
}
function B7(e) {
  return !e.ended && (e.needReadable || e.length < e.highWaterMark || e.length === 0);
}
_t.prototype.setEncoding = function(e) {
  return this._readableState.decoder = new Ol(e), this._readableState.encoding = e, this;
};
var NI = 8388608;
function f7(e) {
  return e >= NI ? e = NI : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
}
function TI(e, A) {
  return e <= 0 || A.length === 0 && A.ended ? 0 : A.objectMode ? 1 : e !== e ? A.flowing && A.length ? A.buffer.head.data.length : A.length : (e > A.highWaterMark && (A.highWaterMark = f7(e)), e <= A.length ? e : A.ended ? A.length : (A.needReadable = !0, 0));
}
_t.prototype.read = function(e) {
  xt("read", e), e = parseInt(e, 10);
  var A = this._readableState, t = e;
  if (e !== 0 && (A.emittedReadable = !1), e === 0 && A.needReadable && (A.length >= A.highWaterMark || A.ended))
    return xt("read: emitReadable", A.length, A.ended), A.length === 0 && A.ended ? Ad(this) : rB(this), null;
  if (e = TI(e, A), e === 0 && A.ended)
    return A.length === 0 && Ad(this), null;
  var r = A.needReadable;
  xt("need readable", r), (A.length === 0 || A.length - e < A.highWaterMark) && (r = !0, xt("length less than watermark", r)), A.ended || A.reading ? (r = !1, xt("reading or ended", r)) : r && (xt("do read"), A.reading = !0, A.sync = !0, A.length === 0 && (A.needReadable = !0), this._read(A.highWaterMark), A.sync = !1, A.reading || (e = TI(t, A)));
  var n;
  return e > 0 ? n = wM(e, A) : n = null, n === null ? (A.needReadable = !0, e = 0) : A.length -= e, A.length === 0 && (A.ended || (A.needReadable = !0), t !== e && A.ended && Ad(this)), n !== null && this.emit("data", n), n;
};
function d7(e, A) {
  var t = null;
  return !kA.isBuffer(A) && typeof A != "string" && A !== null && A !== void 0 && !e.objectMode && (t = new TypeError("Invalid non-string/buffer chunk")), t;
}
function h7(e, A) {
  if (!A.ended) {
    if (A.decoder) {
      var t = A.decoder.end();
      t && t.length && (A.buffer.push(t), A.length += A.objectMode ? 1 : t.length);
    }
    A.ended = !0, rB(e);
  }
}
function rB(e) {
  var A = e._readableState;
  A.needReadable = !1, A.emittedReadable || (xt("emitReadable", A.flowing), A.emittedReadable = !0, A.sync ? wn(PI, e) : PI(e));
}
function PI(e) {
  xt("emit readable"), e.emit("readable"), PC(e);
}
function C7(e, A) {
  A.readingMore || (A.readingMore = !0, wn(E7, e, A));
}
function E7(e, A) {
  for (var t = A.length; !A.reading && !A.flowing && !A.ended && A.length < A.highWaterMark && (xt("maybeReadMore read 0"), e.read(0), t !== A.length); )
    t = A.length;
  A.readingMore = !1;
}
_t.prototype._read = function(e) {
  this.emit("error", new Error("not implemented"));
};
_t.prototype.pipe = function(e, A) {
  var t = this, r = this._readableState;
  switch (r.pipesCount) {
    case 0:
      r.pipes = e;
      break;
    case 1:
      r.pipes = [r.pipes, e];
      break;
    default:
      r.pipes.push(e);
      break;
  }
  r.pipesCount += 1, xt("pipe count=%d opts=%j", r.pipesCount, A);
  var n = !A || A.end !== !1, i = n ? o : u;
  r.endEmitted ? wn(i) : t.once("end", i), e.on("unpipe", a);
  function a(b) {
    xt("onunpipe"), b === t && u();
  }
  function o() {
    xt("onend"), e.end();
  }
  var s = Q7(t);
  e.on("drain", s);
  var l = !1;
  function u() {
    xt("cleanup"), e.removeListener("close", C), e.removeListener("finish", E), e.removeListener("drain", s), e.removeListener("error", h), e.removeListener("unpipe", a), t.removeListener("end", o), t.removeListener("end", u), t.removeListener("data", d), l = !0, r.awaitDrain && (!e._writableState || e._writableState.needDrain) && s();
  }
  var g = !1;
  t.on("data", d);
  function d(b) {
    xt("ondata"), g = !1;
    var y = e.write(b);
    y === !1 && !g && ((r.pipesCount === 1 && r.pipes === e || r.pipesCount > 1 && IM(r.pipes, e) !== -1) && !l && (xt("false write response, pause", t._readableState.awaitDrain), t._readableState.awaitDrain++, g = !0), t.pause());
  }
  function h(b) {
    xt("onerror", b), I(), e.removeListener("error", h), g7(e, "error") === 0 && e.emit("error", b);
  }
  c7(e, "error", h);
  function C() {
    e.removeListener("finish", E), I();
  }
  e.once("close", C);
  function E() {
    xt("onfinish"), e.removeListener("close", C), I();
  }
  e.once("finish", E);
  function I() {
    xt("unpipe"), t.unpipe(e);
  }
  return e.emit("pipe", t), r.flowing || (xt("pipe resume"), t.resume()), e;
};
function Q7(e) {
  return function() {
    var A = e._readableState;
    xt("pipeOnDrain", A.awaitDrain), A.awaitDrain && A.awaitDrain--, A.awaitDrain === 0 && e.listeners("data").length && (A.flowing = !0, PC(e));
  };
}
_t.prototype.unpipe = function(e) {
  var A = this._readableState;
  if (A.pipesCount === 0) return this;
  if (A.pipesCount === 1)
    return e && e !== A.pipes ? this : (e || (e = A.pipes), A.pipes = null, A.pipesCount = 0, A.flowing = !1, e && e.emit("unpipe", this), this);
  if (!e) {
    var t = A.pipes, r = A.pipesCount;
    A.pipes = null, A.pipesCount = 0, A.flowing = !1;
    for (var n = 0; n < r; n++)
      t[n].emit("unpipe", this);
    return this;
  }
  var i = IM(A.pipes, e);
  return i === -1 ? this : (A.pipes.splice(i, 1), A.pipesCount -= 1, A.pipesCount === 1 && (A.pipes = A.pipes[0]), e.emit("unpipe", this), this);
};
_t.prototype.on = function(e, A) {
  var t = ht.prototype.on.call(this, e, A);
  if (e === "data")
    this._readableState.flowing !== !1 && this.resume();
  else if (e === "readable") {
    var r = this._readableState;
    !r.endEmitted && !r.readableListening && (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && rB(this) : wn(w7, this));
  }
  return t;
};
_t.prototype.addListener = _t.prototype.on;
function w7(e) {
  xt("readable nexttick read 0"), e.read(0);
}
_t.prototype.resume = function() {
  var e = this._readableState;
  return e.flowing || (xt("resume"), e.flowing = !0, I7(this, e)), this;
};
function I7(e, A) {
  A.resumeScheduled || (A.resumeScheduled = !0, wn(D7, e, A));
}
function D7(e, A) {
  A.reading || (xt("resume read 0"), e.read(0)), A.resumeScheduled = !1, A.awaitDrain = 0, e.emit("resume"), PC(e), A.flowing && !A.reading && e.read(0);
}
_t.prototype.pause = function() {
  return xt("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (xt("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
};
function PC(e) {
  var A = e._readableState;
  for (xt("flow", A.flowing); A.flowing && e.read() !== null; )
    ;
}
_t.prototype.wrap = function(e) {
  var A = this._readableState, t = !1, r = this;
  e.on("end", function() {
    if (xt("wrapped end"), A.decoder && !A.ended) {
      var a = A.decoder.end();
      a && a.length && r.push(a);
    }
    r.push(null);
  }), e.on("data", function(a) {
    if (xt("wrapped data"), A.decoder && (a = A.decoder.write(a)), !(A.objectMode && a == null) && !(!A.objectMode && (!a || !a.length))) {
      var o = r.push(a);
      o || (t = !0, e.pause());
    }
  });
  for (var n in e)
    this[n] === void 0 && typeof e[n] == "function" && (this[n] = /* @__PURE__ */ function(a) {
      return function() {
        return e[a].apply(e, arguments);
      };
    }(n));
  var i = ["error", "close", "destroy", "pause", "resume"];
  return y7(i, function(a) {
    e.on(a, r.emit.bind(r, a));
  }), r._read = function(a) {
    xt("wrapped _read", a), t && (t = !1, e.resume());
  }, r;
};
_t._fromList = wM;
function wM(e, A) {
  if (A.length === 0) return null;
  var t;
  return A.objectMode ? t = A.buffer.shift() : !e || e >= A.length ? (A.decoder ? t = A.buffer.join("") : A.buffer.length === 1 ? t = A.buffer.head.data : t = A.buffer.concat(A.length), A.buffer.clear()) : t = m7(e, A.buffer, A.decoder), t;
}
function m7(e, A, t) {
  var r;
  return e < A.head.data.length ? (r = A.head.data.slice(0, e), A.head.data = A.head.data.slice(e)) : e === A.head.data.length ? r = A.shift() : r = t ? M7(e, A) : p7(e, A), r;
}
function M7(e, A) {
  var t = A.head, r = 1, n = t.data;
  for (e -= n.length; t = t.next; ) {
    var i = t.data, a = e > i.length ? i.length : e;
    if (a === i.length ? n += i : n += i.slice(0, e), e -= a, e === 0) {
      a === i.length ? (++r, t.next ? A.head = t.next : A.head = A.tail = null) : (A.head = t, t.data = i.slice(a));
      break;
    }
    ++r;
  }
  return A.length -= r, n;
}
function p7(e, A) {
  var t = kA.allocUnsafe(e), r = A.head, n = 1;
  for (r.data.copy(t), e -= r.data.length; r = r.next; ) {
    var i = r.data, a = e > i.length ? i.length : e;
    if (i.copy(t, t.length - e, 0, a), e -= a, e === 0) {
      a === i.length ? (++n, r.next ? A.head = r.next : A.head = A.tail = null) : (A.head = r, r.data = i.slice(a));
      break;
    }
    ++n;
  }
  return A.length -= n, t;
}
function Ad(e) {
  var A = e._readableState;
  if (A.length > 0) throw new Error('"endReadable()" called on non-empty stream');
  A.endEmitted || (A.ended = !0, wn(v7, A, e));
}
function v7(e, A) {
  !e.endEmitted && e.length === 0 && (e.endEmitted = !0, A.readable = !1, A.emit("end"));
}
function y7(e, A) {
  for (var t = 0, r = e.length; t < r; t++)
    A(e[t], t);
}
function IM(e, A) {
  for (var t = 0, r = e.length; t < r; t++)
    if (e[t] === A) return t;
  return -1;
}
Mr.WritableState = zC;
ui(Mr, ht);
function b7() {
}
function F7(e, A, t) {
  this.chunk = e, this.encoding = A, this.callback = t, this.next = null;
}
function zC(e, A) {
  Object.defineProperty(this, "buffer", {
    get: eB(function() {
      return this.getBuffer();
    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
  }), e = e || {}, this.objectMode = !!e.objectMode, A instanceof En && (this.objectMode = this.objectMode || !!e.writableObjectMode);
  var t = e.highWaterMark, r = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = t || t === 0 ? t : r, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
  var n = e.decodeStrings === !1;
  this.decodeStrings = !n, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(i) {
    Y7(A, i);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new pM(this);
}
zC.prototype.getBuffer = function() {
  for (var A = this.bufferedRequest, t = []; A; )
    t.push(A), A = A.next;
  return t;
};
function Mr(e) {
  if (!(this instanceof Mr) && !(this instanceof En)) return new Mr(e);
  this._writableState = new zC(e, this), this.writable = !0, e && (typeof e.write == "function" && (this._write = e.write), typeof e.writev == "function" && (this._writev = e.writev)), ht.call(this);
}
Mr.prototype.pipe = function() {
  this.emit("error", new Error("Cannot pipe, not readable"));
};
function L7(e, A) {
  var t = new Error("write after end");
  e.emit("error", t), wn(A, t);
}
function R7(e, A, t, r) {
  var n = !0, i = !1;
  return t === null ? i = new TypeError("May not write null values to stream") : !kA.isBuffer(t) && typeof t != "string" && t !== void 0 && !A.objectMode && (i = new TypeError("Invalid non-string/buffer chunk")), i && (e.emit("error", i), wn(r, i), n = !1), n;
}
Mr.prototype.write = function(e, A, t) {
  var r = this._writableState, n = !1;
  return typeof A == "function" && (t = A, A = null), kA.isBuffer(e) ? A = "buffer" : A || (A = r.defaultEncoding), typeof t != "function" && (t = b7), r.ended ? L7(this, t) : R7(this, r, e, t) && (r.pendingcb++, n = x7(this, r, e, A, t)), n;
};
Mr.prototype.cork = function() {
  var e = this._writableState;
  e.corked++;
};
Mr.prototype.uncork = function() {
  var e = this._writableState;
  e.corked && (e.corked--, !e.writing && !e.corked && !e.finished && !e.bufferProcessing && e.bufferedRequest && DM(this, e));
};
Mr.prototype.setDefaultEncoding = function(A) {
  if (typeof A == "string" && (A = A.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((A + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + A);
  return this._writableState.defaultEncoding = A, this;
};
function G7(e, A, t) {
  return !e.objectMode && e.decodeStrings !== !1 && typeof A == "string" && (A = kA.from(A, t)), A;
}
function x7(e, A, t, r, n) {
  t = G7(A, t, r), kA.isBuffer(t) && (r = "buffer");
  var i = A.objectMode ? 1 : t.length;
  A.length += i;
  var a = A.length < A.highWaterMark;
  if (a || (A.needDrain = !0), A.writing || A.corked) {
    var o = A.lastBufferedRequest;
    A.lastBufferedRequest = new F7(t, r, n), o ? o.next = A.lastBufferedRequest : A.bufferedRequest = A.lastBufferedRequest, A.bufferedRequestCount += 1;
  } else
    vh(e, A, !1, i, t, r, n);
  return a;
}
function vh(e, A, t, r, n, i, a) {
  A.writelen = r, A.writecb = a, A.writing = !0, A.sync = !0, t ? e._writev(n, A.onwrite) : e._write(n, i, A.onwrite), A.sync = !1;
}
function k7(e, A, t, r, n) {
  --A.pendingcb, t ? wn(n, r) : n(r), e._writableState.errorEmitted = !0, e.emit("error", r);
}
function U7(e) {
  e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
}
function Y7(e, A) {
  var t = e._writableState, r = t.sync, n = t.writecb;
  if (U7(t), A) k7(e, t, r, A, n);
  else {
    var i = mM(t);
    !i && !t.corked && !t.bufferProcessing && t.bufferedRequest && DM(e, t), r ? wn(zI, e, t, i, n) : zI(e, t, i, n);
  }
}
function zI(e, A, t, r) {
  t || H7(e, A), A.pendingcb--, r(), MM(e, A);
}
function H7(e, A) {
  A.length === 0 && A.needDrain && (A.needDrain = !1, e.emit("drain"));
}
function DM(e, A) {
  A.bufferProcessing = !0;
  var t = A.bufferedRequest;
  if (e._writev && t && t.next) {
    var r = A.bufferedRequestCount, n = new Array(r), i = A.corkedRequestsFree;
    i.entry = t;
    for (var a = 0; t; )
      n[a] = t, t = t.next, a += 1;
    vh(e, A, !0, A.length, n, "", i.finish), A.pendingcb++, A.lastBufferedRequest = null, i.next ? (A.corkedRequestsFree = i.next, i.next = null) : A.corkedRequestsFree = new pM(A);
  } else {
    for (; t; ) {
      var o = t.chunk, s = t.encoding, l = t.callback, u = A.objectMode ? 1 : o.length;
      if (vh(e, A, !1, u, o, s, l), t = t.next, A.writing)
        break;
    }
    t === null && (A.lastBufferedRequest = null);
  }
  A.bufferedRequestCount = 0, A.bufferedRequest = t, A.bufferProcessing = !1;
}
Mr.prototype._write = function(e, A, t) {
  t(new Error("not implemented"));
};
Mr.prototype._writev = null;
Mr.prototype.end = function(e, A, t) {
  var r = this._writableState;
  typeof e == "function" ? (t = e, e = null, A = null) : typeof A == "function" && (t = A, A = null), e != null && this.write(e, A), r.corked && (r.corked = 1, this.uncork()), !r.ending && !r.finished && S7(this, r, t);
};
function mM(e) {
  return e.ending && e.length === 0 && e.bufferedRequest === null && !e.finished && !e.writing;
}
function jI(e, A) {
  A.prefinished || (A.prefinished = !0, e.emit("prefinish"));
}
function MM(e, A) {
  var t = mM(A);
  return t && (A.pendingcb === 0 ? (jI(e, A), A.finished = !0, e.emit("finish")) : jI(e, A)), t;
}
function S7(e, A, t) {
  A.ending = !0, MM(e, A), t && (A.finished ? wn(t) : e.once("finish", t)), A.ended = !0, e.writable = !1;
}
function pM(e) {
  var A = this;
  this.next = null, this.entry = null, this.finish = function(t) {
    var r = A.entry;
    for (A.entry = null; r; ) {
      var n = r.callback;
      e.pendingcb--, n(t), r = r.next;
    }
    e.corkedRequestsFree ? e.corkedRequestsFree.next = A : e.corkedRequestsFree = A;
  };
}
ui(En, _t);
var VI = Object.keys(Mr.prototype);
for (var ed = 0; ed < VI.length; ed++) {
  var td = VI[ed];
  En.prototype[td] || (En.prototype[td] = Mr.prototype[td]);
}
function En(e) {
  if (!(this instanceof En)) return new En(e);
  _t.call(this, e), Mr.call(this, e), e && e.readable === !1 && (this.readable = !1), e && e.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, e && e.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", N7);
}
function N7() {
  this.allowHalfOpen || this._writableState.ended || wn(T7, this);
}
function T7(e) {
  e.end();
}
ui($n, En);
function P7(e) {
  this.afterTransform = function(A, t) {
    return z7(e, A, t);
  }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
}
function z7(e, A, t) {
  var r = e._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (!n) return e.emit("error", new Error("no writecb in Transform class"));
  r.writechunk = null, r.writecb = null, t != null && e.push(t), n(A);
  var i = e._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && e._read(i.highWaterMark);
}
function $n(e) {
  if (!(this instanceof $n)) return new $n(e);
  En.call(this, e), this._transformState = new P7(this);
  var A = this;
  this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.once("prefinish", function() {
    typeof this._flush == "function" ? this._flush(function(t) {
      OI(A, t);
    }) : OI(A);
  });
}
$n.prototype.push = function(e, A) {
  return this._transformState.needTransform = !1, En.prototype.push.call(this, e, A);
};
$n.prototype._transform = function(e, A, t) {
  throw new Error("Not implemented");
};
$n.prototype._write = function(e, A, t) {
  var r = this._transformState;
  if (r.writecb = t, r.writechunk = e, r.writeencoding = A, !r.transforming) {
    var n = this._readableState;
    (r.needTransform || n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
  }
};
$n.prototype._read = function(e) {
  var A = this._transformState;
  A.writechunk !== null && A.writecb && !A.transforming ? (A.transforming = !0, this._transform(A.writechunk, A.writeencoding, A.afterTransform)) : A.needTransform = !0;
};
function OI(e, A) {
  if (A) return e.emit("error", A);
  var t = e._writableState, r = e._transformState;
  if (t.length) throw new Error("Calling transform done when ws.length != 0");
  if (r.transforming) throw new Error("Calling transform done when still transforming");
  return e.push(null);
}
ui($o, $n);
function $o(e) {
  if (!(this instanceof $o)) return new $o(e);
  $n.call(this, e);
}
$o.prototype._transform = function(e, A, t) {
  t(null, e);
};
ui(A0, ht);
A0.Readable = _t;
A0.Writable = Mr;
A0.Duplex = En;
A0.Transform = $n;
A0.PassThrough = $o;
A0.Stream = A0;
function A0() {
  ht.call(this);
}
A0.prototype.pipe = function(e, A) {
  var t = this;
  function r(u) {
    e.writable && e.write(u) === !1 && t.pause && t.pause();
  }
  t.on("data", r);
  function n() {
    t.readable && t.resume && t.resume();
  }
  e.on("drain", n), !e._isStdio && (!A || A.end !== !1) && (t.on("end", a), t.on("close", o));
  var i = !1;
  function a() {
    i || (i = !0, e.end());
  }
  function o() {
    i || (i = !0, typeof e.destroy == "function" && e.destroy());
  }
  function s(u) {
    if (l(), ht.listenerCount(this, "error") === 0)
      throw u;
  }
  t.on("error", s), e.on("error", s);
  function l() {
    t.removeListener("data", r), e.removeListener("drain", n), t.removeListener("end", a), t.removeListener("close", o), t.removeListener("error", s), e.removeListener("error", s), t.removeListener("end", l), t.removeListener("close", l), e.removeListener("close", l);
  }
  return t.on("end", l), t.on("close", l), e.on("close", l), e.emit("pipe", t), e;
};
var j7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Duplex: En,
  PassThrough: $o,
  Readable: _t,
  Stream: A0,
  Transform: $n,
  Writable: Mr,
  default: A0
}), V7 = /* @__PURE__ */ $g(j7), vM = {};
function JI(e, A) {
  if (e === A)
    return 0;
  for (var t = e.length, r = A.length, n = 0, i = Math.min(t, r); n < i; ++n)
    if (e[n] !== A[n]) {
      t = e[n], r = A[n];
      break;
    }
  return t < r ? -1 : r < t ? 1 : 0;
}
var O7 = Object.prototype.hasOwnProperty, WI = Object.keys || function(e) {
  var A = [];
  for (var t in e)
    O7.call(e, t) && A.push(t);
  return A;
}, ZI = Array.prototype.slice, rd;
function yM() {
  return typeof rd < "u" ? rd : rd = function() {
    return (function() {
    }).name === "foo";
  }();
}
function KI(e) {
  return Object.prototype.toString.call(e);
}
function _I(e) {
  return Ra(e) || typeof Ka.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e ? !!(e instanceof DataView || e.buffer && e.buffer instanceof ArrayBuffer) : !1;
}
function Nr(e, A) {
  e || Hr(e, !0, A, "==", El);
}
var J7 = /\s*function\s+([^\(\s]*)\s*/;
function bM(e) {
  if (Pa(e)) {
    if (yM())
      return e.name;
    var A = e.toString(), t = A.match(J7);
    return t && t[1];
  }
}
Nr.AssertionError = nB;
function nB(e) {
  this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = W7(this), this.generatedMessage = !0);
  var A = e.stackStartFunction || Hr;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, A);
  else {
    var t = new Error();
    if (t.stack) {
      var r = t.stack, n = bM(A), i = r.indexOf(`
` + n);
      if (i >= 0) {
        var a = r.indexOf(`
`, i + 1);
        r = r.substring(a + 1);
      }
      this.stack = r;
    }
  }
}
ui(nB, Error);
function XI(e, A) {
  return typeof e == "string" ? e.length < A ? e : e.slice(0, A) : e;
}
function qI(e) {
  if (yM() || !Pa(e))
    return On(e);
  var A = bM(e), t = A ? ": " + A : "";
  return "[Function" + t + "]";
}
function W7(e) {
  return XI(qI(e.actual), 128) + " " + e.operator + " " + XI(qI(e.expected), 128);
}
function Hr(e, A, t, r, n) {
  throw new nB({
    message: t,
    actual: e,
    expected: A,
    operator: r,
    stackStartFunction: n
  });
}
Nr.fail = Hr;
function El(e, A) {
  e || Hr(e, !0, A, "==", El);
}
Nr.ok = El;
Nr.equal = jC;
function jC(e, A, t) {
  e != A && Hr(e, A, t, "==", jC);
}
Nr.notEqual = VC;
function VC(e, A, t) {
  e == A && Hr(e, A, t, "!=", VC);
}
Nr.deepEqual = OC;
function OC(e, A, t) {
  As(e, A, !1) || Hr(e, A, t, "deepEqual", OC);
}
Nr.deepStrictEqual = JC;
function JC(e, A, t) {
  As(e, A, !0) || Hr(e, A, t, "deepStrictEqual", JC);
}
function As(e, A, t, r) {
  if (e === A)
    return !0;
  if (Ra(e) && Ra(A))
    return JI(e, A) === 0;
  if (qo(e) && qo(A))
    return e.getTime() === A.getTime();
  if (Ta(e) && Ta(A))
    return e.source === A.source && e.global === A.global && e.multiline === A.multiline && e.lastIndex === A.lastIndex && e.ignoreCase === A.ignoreCase;
  if ((e === null || typeof e != "object") && (A === null || typeof A != "object"))
    return t ? e === A : e == A;
  if (_I(e) && _I(A) && KI(e) === KI(A) && !(e instanceof Float32Array || e instanceof Float64Array))
    return JI(
      new Uint8Array(e.buffer),
      new Uint8Array(A.buffer)
    ) === 0;
  if (Ra(e) !== Ra(A))
    return !1;
  r = r || { actual: [], expected: [] };
  var n = r.actual.indexOf(e);
  return n !== -1 && n === r.expected.indexOf(A) ? !0 : (r.actual.push(e), r.expected.push(A), Z7(e, A, t, r));
}
function $I(e) {
  return Object.prototype.toString.call(e) == "[object Arguments]";
}
function Z7(e, A, t, r) {
  if (e == null || A === null || A === void 0)
    return !1;
  if (ug(e) || ug(A))
    return e === A;
  if (t && Object.getPrototypeOf(e) !== Object.getPrototypeOf(A))
    return !1;
  var n = $I(e), i = $I(A);
  if (n && !i || !n && i)
    return !1;
  if (n)
    return e = ZI.call(e), A = ZI.call(A), As(e, A, t);
  var a = WI(e), o = WI(A), s, l;
  if (a.length !== o.length)
    return !1;
  for (a.sort(), o.sort(), l = a.length - 1; l >= 0; l--)
    if (a[l] !== o[l])
      return !1;
  for (l = a.length - 1; l >= 0; l--)
    if (s = a[l], !As(e[s], A[s], t, r))
      return !1;
  return !0;
}
Nr.notDeepEqual = WC;
function WC(e, A, t) {
  As(e, A, !1) && Hr(e, A, t, "notDeepEqual", WC);
}
Nr.notDeepStrictEqual = ZC;
function ZC(e, A, t) {
  As(e, A, !0) && Hr(e, A, t, "notDeepStrictEqual", ZC);
}
Nr.strictEqual = KC;
function KC(e, A, t) {
  e !== A && Hr(e, A, t, "===", KC);
}
Nr.notStrictEqual = _C;
function _C(e, A, t) {
  e === A && Hr(e, A, t, "!==", _C);
}
function A5(e, A) {
  if (!e || !A)
    return !1;
  if (Object.prototype.toString.call(A) == "[object RegExp]")
    return A.test(e);
  try {
    if (e instanceof A)
      return !0;
  } catch {
  }
  return Error.isPrototypeOf(A) ? !1 : A.call({}, e) === !0;
}
function K7(e) {
  var A;
  try {
    e();
  } catch (t) {
    A = t;
  }
  return A;
}
function FM(e, A, t, r) {
  var n;
  if (typeof A != "function")
    throw new TypeError('"block" argument must be a function');
  typeof t == "string" && (r = t, t = null), n = K7(A), r = (t && t.name ? " (" + t.name + ")." : ".") + (r ? " " + r : "."), e && !n && Hr(n, t, "Missing expected exception" + r);
  var i = typeof r == "string", a = !e && Po(n), o = !e && n && !t;
  if ((a && i && A5(n, t) || o) && Hr(n, t, "Got unwanted exception" + r), e && n && t && !A5(n, t) || !e && n)
    throw n;
}
Nr.throws = LM;
function LM(e, A, t) {
  FM(!0, e, A, t);
}
Nr.doesNotThrow = RM;
function RM(e, A, t) {
  FM(!1, e, A, t);
}
Nr.ifError = GM;
function GM(e) {
  if (e) throw e;
}
var _7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AssertionError: nB,
  assert: El,
  deepEqual: OC,
  deepStrictEqual: JC,
  default: Nr,
  doesNotThrow: RM,
  equal: jC,
  fail: Hr,
  ifError: GM,
  notDeepEqual: WC,
  notDeepStrictEqual: ZC,
  notEqual: VC,
  notStrictEqual: _C,
  ok: El,
  strictEqual: KC,
  throws: LM
}), xM = /* @__PURE__ */ $g(_7);
function X7() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var q7 = X7, S0 = {}, Jl = {};
(function(e) {
  var A = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function t(i, a) {
    return Object.prototype.hasOwnProperty.call(i, a);
  }
  e.assign = function(i) {
    for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
      var o = a.shift();
      if (o) {
        if (typeof o != "object")
          throw new TypeError(o + "must be non-object");
        for (var s in o)
          t(o, s) && (i[s] = o[s]);
      }
    }
    return i;
  }, e.shrinkBuf = function(i, a) {
    return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
  };
  var r = {
    arraySet: function(a, o, s, l, u) {
      if (o.subarray && a.subarray) {
        a.set(o.subarray(s, s + l), u);
        return;
      }
      for (var g = 0; g < l; g++)
        a[u + g] = o[s + g];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      var o, s, l, u, g, d;
      for (l = 0, o = 0, s = a.length; o < s; o++)
        l += a[o].length;
      for (d = new Uint8Array(l), u = 0, o = 0, s = a.length; o < s; o++)
        g = a[o], d.set(g, u), u += g.length;
      return d;
    }
  }, n = {
    arraySet: function(a, o, s, l, u) {
      for (var g = 0; g < l; g++)
        a[u + g] = o[s + g];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      return [].concat.apply([], a);
    }
  };
  e.setTyped = function(i) {
    i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, n));
  }, e.setTyped(A);
})(Jl);
var us = {}, $7 = Jl, AP = 4, e5 = 0, t5 = 1, eP = 2;
function cs(e) {
  for (var A = e.length; --A >= 0; )
    e[A] = 0;
}
var tP = 0, kM = 1, rP = 2, nP = 3, iP = 258, XC = 29, Wl = 256, Ql = Wl + 1 + XC, zo = 30, qC = 19, UM = 2 * Ql + 1, xa = 15, nd = 16, aP = 7, $C = 256, YM = 16, HM = 17, SM = 18, yh = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), Mc = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), oP = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), NM = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], sP = 512, X0 = new Array((Ql + 2) * 2);
cs(X0);
var il = new Array(zo * 2);
cs(il);
var wl = new Array(sP);
cs(wl);
var Il = new Array(iP - nP + 1);
cs(Il);
var AE = new Array(XC);
cs(AE);
var cg = new Array(zo);
cs(cg);
function id(e, A, t, r, n) {
  this.static_tree = e, this.extra_bits = A, this.extra_base = t, this.elems = r, this.max_length = n, this.has_stree = e && e.length;
}
var TM, PM, zM;
function ad(e, A) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = A;
}
function jM(e) {
  return e < 256 ? wl[e] : wl[256 + (e >>> 7)];
}
function Dl(e, A) {
  e.pending_buf[e.pending++] = A & 255, e.pending_buf[e.pending++] = A >>> 8 & 255;
}
function $r(e, A, t) {
  e.bi_valid > nd - t ? (e.bi_buf |= A << e.bi_valid & 65535, Dl(e, e.bi_buf), e.bi_buf = A >> nd - e.bi_valid, e.bi_valid += t - nd) : (e.bi_buf |= A << e.bi_valid & 65535, e.bi_valid += t);
}
function I0(e, A, t) {
  $r(
    e,
    t[A * 2],
    t[A * 2 + 1]
    /*.Len*/
  );
}
function VM(e, A) {
  var t = 0;
  do
    t |= e & 1, e >>>= 1, t <<= 1;
  while (--A > 0);
  return t >>> 1;
}
function lP(e) {
  e.bi_valid === 16 ? (Dl(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}
function uP(e, A) {
  var t = A.dyn_tree, r = A.max_code, n = A.stat_desc.static_tree, i = A.stat_desc.has_stree, a = A.stat_desc.extra_bits, o = A.stat_desc.extra_base, s = A.stat_desc.max_length, l, u, g, d, h, C, E = 0;
  for (d = 0; d <= xa; d++)
    e.bl_count[d] = 0;
  for (t[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < UM; l++)
    u = e.heap[l], d = t[t[u * 2 + 1] * 2 + 1] + 1, d > s && (d = s, E++), t[u * 2 + 1] = d, !(u > r) && (e.bl_count[d]++, h = 0, u >= o && (h = a[u - o]), C = t[u * 2], e.opt_len += C * (d + h), i && (e.static_len += C * (n[u * 2 + 1] + h)));
  if (E !== 0) {
    do {
      for (d = s - 1; e.bl_count[d] === 0; )
        d--;
      e.bl_count[d]--, e.bl_count[d + 1] += 2, e.bl_count[s]--, E -= 2;
    } while (E > 0);
    for (d = s; d !== 0; d--)
      for (u = e.bl_count[d]; u !== 0; )
        g = e.heap[--l], !(g > r) && (t[g * 2 + 1] !== d && (e.opt_len += (d - t[g * 2 + 1]) * t[g * 2], t[g * 2 + 1] = d), u--);
  }
}
function OM(e, A, t) {
  var r = new Array(xa + 1), n = 0, i, a;
  for (i = 1; i <= xa; i++)
    r[i] = n = n + t[i - 1] << 1;
  for (a = 0; a <= A; a++) {
    var o = e[a * 2 + 1];
    o !== 0 && (e[a * 2] = VM(r[o]++, o));
  }
}
function cP() {
  var e, A, t, r, n, i = new Array(xa + 1);
  for (t = 0, r = 0; r < XC - 1; r++)
    for (AE[r] = t, e = 0; e < 1 << yh[r]; e++)
      Il[t++] = r;
  for (Il[t - 1] = r, n = 0, r = 0; r < 16; r++)
    for (cg[r] = n, e = 0; e < 1 << Mc[r]; e++)
      wl[n++] = r;
  for (n >>= 7; r < zo; r++)
    for (cg[r] = n << 7, e = 0; e < 1 << Mc[r] - 7; e++)
      wl[256 + n++] = r;
  for (A = 0; A <= xa; A++)
    i[A] = 0;
  for (e = 0; e <= 143; )
    X0[e * 2 + 1] = 8, e++, i[8]++;
  for (; e <= 255; )
    X0[e * 2 + 1] = 9, e++, i[9]++;
  for (; e <= 279; )
    X0[e * 2 + 1] = 7, e++, i[7]++;
  for (; e <= 287; )
    X0[e * 2 + 1] = 8, e++, i[8]++;
  for (OM(X0, Ql + 1, i), e = 0; e < zo; e++)
    il[e * 2 + 1] = 5, il[e * 2] = VM(e, 5);
  TM = new id(X0, yh, Wl + 1, Ql, xa), PM = new id(il, Mc, 0, zo, xa), zM = new id(new Array(0), oP, 0, qC, aP);
}
function JM(e) {
  var A;
  for (A = 0; A < Ql; A++)
    e.dyn_ltree[A * 2] = 0;
  for (A = 0; A < zo; A++)
    e.dyn_dtree[A * 2] = 0;
  for (A = 0; A < qC; A++)
    e.bl_tree[A * 2] = 0;
  e.dyn_ltree[$C * 2] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
}
function WM(e) {
  e.bi_valid > 8 ? Dl(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}
function gP(e, A, t, r) {
  WM(e), Dl(e, t), Dl(e, ~t), $7.arraySet(e.pending_buf, e.window, A, t, e.pending), e.pending += t;
}
function r5(e, A, t, r) {
  var n = A * 2, i = t * 2;
  return e[n] < e[i] || e[n] === e[i] && r[A] <= r[t];
}
function od(e, A, t) {
  for (var r = e.heap[t], n = t << 1; n <= e.heap_len && (n < e.heap_len && r5(A, e.heap[n + 1], e.heap[n], e.depth) && n++, !r5(A, r, e.heap[n], e.depth)); )
    e.heap[t] = e.heap[n], t = n, n <<= 1;
  e.heap[t] = r;
}
function n5(e, A, t) {
  var r, n, i = 0, a, o;
  if (e.last_lit !== 0)
    do
      r = e.pending_buf[e.d_buf + i * 2] << 8 | e.pending_buf[e.d_buf + i * 2 + 1], n = e.pending_buf[e.l_buf + i], i++, r === 0 ? I0(e, n, A) : (a = Il[n], I0(e, a + Wl + 1, A), o = yh[a], o !== 0 && (n -= AE[a], $r(e, n, o)), r--, a = jM(r), I0(e, a, t), o = Mc[a], o !== 0 && (r -= cg[a], $r(e, r, o)));
    while (i < e.last_lit);
  I0(e, $C, A);
}
function bh(e, A) {
  var t = A.dyn_tree, r = A.stat_desc.static_tree, n = A.stat_desc.has_stree, i = A.stat_desc.elems, a, o, s = -1, l;
  for (e.heap_len = 0, e.heap_max = UM, a = 0; a < i; a++)
    t[a * 2] !== 0 ? (e.heap[++e.heap_len] = s = a, e.depth[a] = 0) : t[a * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    l = e.heap[++e.heap_len] = s < 2 ? ++s : 0, t[l * 2] = 1, e.depth[l] = 0, e.opt_len--, n && (e.static_len -= r[l * 2 + 1]);
  for (A.max_code = s, a = e.heap_len >> 1; a >= 1; a--)
    od(e, t, a);
  l = i;
  do
    a = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], od(
      e,
      t,
      1
      /*SMALLEST*/
    ), o = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = a, e.heap[--e.heap_max] = o, t[l * 2] = t[a * 2] + t[o * 2], e.depth[l] = (e.depth[a] >= e.depth[o] ? e.depth[a] : e.depth[o]) + 1, t[a * 2 + 1] = t[o * 2 + 1] = l, e.heap[
      1
      /*SMALLEST*/
    ] = l++, od(
      e,
      t,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], uP(e, A), OM(t, s, e.bl_count);
}
function i5(e, A, t) {
  var r, n = -1, i, a = A[0 * 2 + 1], o = 0, s = 7, l = 4;
  for (a === 0 && (s = 138, l = 3), A[(t + 1) * 2 + 1] = 65535, r = 0; r <= t; r++)
    i = a, a = A[(r + 1) * 2 + 1], !(++o < s && i === a) && (o < l ? e.bl_tree[i * 2] += o : i !== 0 ? (i !== n && e.bl_tree[i * 2]++, e.bl_tree[YM * 2]++) : o <= 10 ? e.bl_tree[HM * 2]++ : e.bl_tree[SM * 2]++, o = 0, n = i, a === 0 ? (s = 138, l = 3) : i === a ? (s = 6, l = 3) : (s = 7, l = 4));
}
function a5(e, A, t) {
  var r, n = -1, i, a = A[0 * 2 + 1], o = 0, s = 7, l = 4;
  for (a === 0 && (s = 138, l = 3), r = 0; r <= t; r++)
    if (i = a, a = A[(r + 1) * 2 + 1], !(++o < s && i === a)) {
      if (o < l)
        do
          I0(e, i, e.bl_tree);
        while (--o !== 0);
      else i !== 0 ? (i !== n && (I0(e, i, e.bl_tree), o--), I0(e, YM, e.bl_tree), $r(e, o - 3, 2)) : o <= 10 ? (I0(e, HM, e.bl_tree), $r(e, o - 3, 3)) : (I0(e, SM, e.bl_tree), $r(e, o - 11, 7));
      o = 0, n = i, a === 0 ? (s = 138, l = 3) : i === a ? (s = 6, l = 3) : (s = 7, l = 4);
    }
}
function BP(e) {
  var A;
  for (i5(e, e.dyn_ltree, e.l_desc.max_code), i5(e, e.dyn_dtree, e.d_desc.max_code), bh(e, e.bl_desc), A = qC - 1; A >= 3 && e.bl_tree[NM[A] * 2 + 1] === 0; A--)
    ;
  return e.opt_len += 3 * (A + 1) + 5 + 5 + 4, A;
}
function fP(e, A, t, r) {
  var n;
  for ($r(e, A - 257, 5), $r(e, t - 1, 5), $r(e, r - 4, 4), n = 0; n < r; n++)
    $r(e, e.bl_tree[NM[n] * 2 + 1], 3);
  a5(e, e.dyn_ltree, A - 1), a5(e, e.dyn_dtree, t - 1);
}
function dP(e) {
  var A = 4093624447, t;
  for (t = 0; t <= 31; t++, A >>>= 1)
    if (A & 1 && e.dyn_ltree[t * 2] !== 0)
      return e5;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return t5;
  for (t = 32; t < Wl; t++)
    if (e.dyn_ltree[t * 2] !== 0)
      return t5;
  return e5;
}
var o5 = !1;
function hP(e) {
  o5 || (cP(), o5 = !0), e.l_desc = new ad(e.dyn_ltree, TM), e.d_desc = new ad(e.dyn_dtree, PM), e.bl_desc = new ad(e.bl_tree, zM), e.bi_buf = 0, e.bi_valid = 0, JM(e);
}
function ZM(e, A, t, r) {
  $r(e, (tP << 1) + (r ? 1 : 0), 3), gP(e, A, t);
}
function CP(e) {
  $r(e, kM << 1, 3), I0(e, $C, X0), lP(e);
}
function EP(e, A, t, r) {
  var n, i, a = 0;
  e.level > 0 ? (e.strm.data_type === eP && (e.strm.data_type = dP(e)), bh(e, e.l_desc), bh(e, e.d_desc), a = BP(e), n = e.opt_len + 3 + 7 >>> 3, i = e.static_len + 3 + 7 >>> 3, i <= n && (n = i)) : n = i = t + 5, t + 4 <= n && A !== -1 ? ZM(e, A, t, r) : e.strategy === AP || i === n ? ($r(e, (kM << 1) + (r ? 1 : 0), 3), n5(e, X0, il)) : ($r(e, (rP << 1) + (r ? 1 : 0), 3), fP(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), n5(e, e.dyn_ltree, e.dyn_dtree)), JM(e), r && WM(e);
}
function QP(e, A, t) {
  return e.pending_buf[e.d_buf + e.last_lit * 2] = A >>> 8 & 255, e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = A & 255, e.pending_buf[e.l_buf + e.last_lit] = t & 255, e.last_lit++, A === 0 ? e.dyn_ltree[t * 2]++ : (e.matches++, A--, e.dyn_ltree[(Il[t] + Wl + 1) * 2]++, e.dyn_dtree[jM(A) * 2]++), e.last_lit === e.lit_bufsize - 1;
}
us._tr_init = hP;
us._tr_stored_block = ZM;
us._tr_flush_block = EP;
us._tr_tally = QP;
us._tr_align = CP;
function wP(e, A, t, r) {
  for (var n = e & 65535 | 0, i = e >>> 16 & 65535 | 0, a = 0; t !== 0; ) {
    a = t > 2e3 ? 2e3 : t, t -= a;
    do
      n = n + A[r++] | 0, i = i + n | 0;
    while (--a);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
}
var KM = wP;
function IP() {
  for (var e, A = [], t = 0; t < 256; t++) {
    e = t;
    for (var r = 0; r < 8; r++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    A[t] = e;
  }
  return A;
}
var DP = IP();
function mP(e, A, t, r) {
  var n = DP, i = r + t;
  e ^= -1;
  for (var a = r; a < i; a++)
    e = e >>> 8 ^ n[(e ^ A[a]) & 255];
  return e ^ -1;
}
var _M = mP, MP = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, Ur = Jl, Rn = us, XM = KM, bi = _M, pP = MP, no = 0, vP = 1, yP = 3, ji = 4, s5 = 5, D0 = 0, l5 = 1, Gn = -2, bP = -3, sd = -5, FP = -1, LP = 1, Wu = 2, RP = 3, GP = 4, xP = 0, kP = 2, iB = 8, UP = 9, YP = 15, HP = 8, SP = 29, NP = 256, Fh = NP + 1 + SP, TP = 30, PP = 19, zP = 2 * Fh + 1, jP = 15, dt = 3, Hi = 258, Jn = Hi + dt + 1, VP = 32, aB = 42, Lh = 69, pc = 73, vc = 91, yc = 103, ka = 113, Ws = 666, lr = 1, Zl = 2, _a = 3, gs = 4, OP = 3;
function Si(e, A) {
  return e.msg = pP[A], A;
}
function u5(e) {
  return (e << 1) - (e > 4 ? 9 : 0);
}
function xi(e) {
  for (var A = e.length; --A >= 0; )
    e[A] = 0;
}
function Fi(e) {
  var A = e.state, t = A.pending;
  t > e.avail_out && (t = e.avail_out), t !== 0 && (Ur.arraySet(e.output, A.pending_buf, A.pending_out, t, e.next_out), e.next_out += t, A.pending_out += t, e.total_out += t, e.avail_out -= t, A.pending -= t, A.pending === 0 && (A.pending_out = 0));
}
function Ir(e, A) {
  Rn._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, A), e.block_start = e.strstart, Fi(e.strm);
}
function wt(e, A) {
  e.pending_buf[e.pending++] = A;
}
function Vs(e, A) {
  e.pending_buf[e.pending++] = A >>> 8 & 255, e.pending_buf[e.pending++] = A & 255;
}
function JP(e, A, t, r) {
  var n = e.avail_in;
  return n > r && (n = r), n === 0 ? 0 : (e.avail_in -= n, Ur.arraySet(A, e.input, e.next_in, n, t), e.state.wrap === 1 ? e.adler = XM(e.adler, A, n, t) : e.state.wrap === 2 && (e.adler = bi(e.adler, A, n, t)), e.next_in += n, e.total_in += n, n);
}
function qM(e, A) {
  var t = e.max_chain_length, r = e.strstart, n, i, a = e.prev_length, o = e.nice_match, s = e.strstart > e.w_size - Jn ? e.strstart - (e.w_size - Jn) : 0, l = e.window, u = e.w_mask, g = e.prev, d = e.strstart + Hi, h = l[r + a - 1], C = l[r + a];
  e.prev_length >= e.good_match && (t >>= 2), o > e.lookahead && (o = e.lookahead);
  do
    if (n = A, !(l[n + a] !== C || l[n + a - 1] !== h || l[n] !== l[r] || l[++n] !== l[r + 1])) {
      r += 2, n++;
      do
        ;
      while (l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && l[++r] === l[++n] && r < d);
      if (i = Hi - (d - r), r = d - Hi, i > a) {
        if (e.match_start = A, a = i, i >= o)
          break;
        h = l[r + a - 1], C = l[r + a];
      }
    }
  while ((A = g[A & u]) > s && --t !== 0);
  return a <= e.lookahead ? a : e.lookahead;
}
function Xa(e) {
  var A = e.w_size, t, r, n, i, a;
  do {
    if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= A + (A - Jn)) {
      Ur.arraySet(e.window, e.window, A, A, 0), e.match_start -= A, e.strstart -= A, e.block_start -= A, r = e.hash_size, t = r;
      do
        n = e.head[--t], e.head[t] = n >= A ? n - A : 0;
      while (--r);
      r = A, t = r;
      do
        n = e.prev[--t], e.prev[t] = n >= A ? n - A : 0;
      while (--r);
      i += A;
    }
    if (e.strm.avail_in === 0)
      break;
    if (r = JP(e.strm, e.window, e.strstart + e.lookahead, i), e.lookahead += r, e.lookahead + e.insert >= dt)
      for (a = e.strstart - e.insert, e.ins_h = e.window[a], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + dt - 1]) & e.hash_mask, e.prev[a & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = a, a++, e.insert--, !(e.lookahead + e.insert < dt)); )
        ;
  } while (e.lookahead < Jn && e.strm.avail_in !== 0);
}
function WP(e, A) {
  var t = 65535;
  for (t > e.pending_buf_size - 5 && (t = e.pending_buf_size - 5); ; ) {
    if (e.lookahead <= 1) {
      if (Xa(e), e.lookahead === 0 && A === no)
        return lr;
      if (e.lookahead === 0)
        break;
    }
    e.strstart += e.lookahead, e.lookahead = 0;
    var r = e.block_start + t;
    if ((e.strstart === 0 || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, Ir(e, !1), e.strm.avail_out === 0) || e.strstart - e.block_start >= e.w_size - Jn && (Ir(e, !1), e.strm.avail_out === 0))
      return lr;
  }
  return e.insert = 0, A === ji ? (Ir(e, !0), e.strm.avail_out === 0 ? _a : gs) : (e.strstart > e.block_start && (Ir(e, !1), e.strm.avail_out === 0), lr);
}
function ld(e, A) {
  for (var t, r; ; ) {
    if (e.lookahead < Jn) {
      if (Xa(e), e.lookahead < Jn && A === no)
        return lr;
      if (e.lookahead === 0)
        break;
    }
    if (t = 0, e.lookahead >= dt && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + dt - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), t !== 0 && e.strstart - t <= e.w_size - Jn && (e.match_length = qM(e, t)), e.match_length >= dt)
      if (r = Rn._tr_tally(e, e.strstart - e.match_start, e.match_length - dt), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= dt) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + dt - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
    else
      r = Rn._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (r && (Ir(e, !1), e.strm.avail_out === 0))
      return lr;
  }
  return e.insert = e.strstart < dt - 1 ? e.strstart : dt - 1, A === ji ? (Ir(e, !0), e.strm.avail_out === 0 ? _a : gs) : e.last_lit && (Ir(e, !1), e.strm.avail_out === 0) ? lr : Zl;
}
function mo(e, A) {
  for (var t, r, n; ; ) {
    if (e.lookahead < Jn) {
      if (Xa(e), e.lookahead < Jn && A === no)
        return lr;
      if (e.lookahead === 0)
        break;
    }
    if (t = 0, e.lookahead >= dt && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + dt - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = dt - 1, t !== 0 && e.prev_length < e.max_lazy_match && e.strstart - t <= e.w_size - Jn && (e.match_length = qM(e, t), e.match_length <= 5 && (e.strategy === LP || e.match_length === dt && e.strstart - e.match_start > 4096) && (e.match_length = dt - 1)), e.prev_length >= dt && e.match_length <= e.prev_length) {
      n = e.strstart + e.lookahead - dt, r = Rn._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - dt), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= n && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + dt - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = dt - 1, e.strstart++, r && (Ir(e, !1), e.strm.avail_out === 0))
        return lr;
    } else if (e.match_available) {
      if (r = Rn._tr_tally(e, 0, e.window[e.strstart - 1]), r && Ir(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return lr;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (r = Rn._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < dt - 1 ? e.strstart : dt - 1, A === ji ? (Ir(e, !0), e.strm.avail_out === 0 ? _a : gs) : e.last_lit && (Ir(e, !1), e.strm.avail_out === 0) ? lr : Zl;
}
function ZP(e, A) {
  for (var t, r, n, i, a = e.window; ; ) {
    if (e.lookahead <= Hi) {
      if (Xa(e), e.lookahead <= Hi && A === no)
        return lr;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= dt && e.strstart > 0 && (n = e.strstart - 1, r = a[n], r === a[++n] && r === a[++n] && r === a[++n])) {
      i = e.strstart + Hi;
      do
        ;
      while (r === a[++n] && r === a[++n] && r === a[++n] && r === a[++n] && r === a[++n] && r === a[++n] && r === a[++n] && r === a[++n] && n < i);
      e.match_length = Hi - (i - n), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= dt ? (t = Rn._tr_tally(e, 1, e.match_length - dt), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (t = Rn._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), t && (Ir(e, !1), e.strm.avail_out === 0))
      return lr;
  }
  return e.insert = 0, A === ji ? (Ir(e, !0), e.strm.avail_out === 0 ? _a : gs) : e.last_lit && (Ir(e, !1), e.strm.avail_out === 0) ? lr : Zl;
}
function KP(e, A) {
  for (var t; ; ) {
    if (e.lookahead === 0 && (Xa(e), e.lookahead === 0)) {
      if (A === no)
        return lr;
      break;
    }
    if (e.match_length = 0, t = Rn._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, t && (Ir(e, !1), e.strm.avail_out === 0))
      return lr;
  }
  return e.insert = 0, A === ji ? (Ir(e, !0), e.strm.avail_out === 0 ? _a : gs) : e.last_lit && (Ir(e, !1), e.strm.avail_out === 0) ? lr : Zl;
}
function h0(e, A, t, r, n) {
  this.good_length = e, this.max_lazy = A, this.nice_length = t, this.max_chain = r, this.func = n;
}
var Go;
Go = [
  /*      good lazy nice chain */
  new h0(0, 0, 0, 0, WP),
  /* 0 store only */
  new h0(4, 4, 8, 4, ld),
  /* 1 max speed, no lazy matches */
  new h0(4, 5, 16, 8, ld),
  /* 2 */
  new h0(4, 6, 32, 32, ld),
  /* 3 */
  new h0(4, 4, 16, 16, mo),
  /* 4 lazy matches */
  new h0(8, 16, 32, 32, mo),
  /* 5 */
  new h0(8, 16, 128, 128, mo),
  /* 6 */
  new h0(8, 32, 128, 256, mo),
  /* 7 */
  new h0(32, 128, 258, 1024, mo),
  /* 8 */
  new h0(32, 258, 258, 4096, mo)
  /* 9 max compression */
];
function _P(e) {
  e.window_size = 2 * e.w_size, xi(e.head), e.max_lazy_match = Go[e.level].max_lazy, e.good_match = Go[e.level].good_length, e.nice_match = Go[e.level].nice_length, e.max_chain_length = Go[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = dt - 1, e.match_available = 0, e.ins_h = 0;
}
function XP() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = iB, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Ur.Buf16(zP * 2), this.dyn_dtree = new Ur.Buf16((2 * TP + 1) * 2), this.bl_tree = new Ur.Buf16((2 * PP + 1) * 2), xi(this.dyn_ltree), xi(this.dyn_dtree), xi(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Ur.Buf16(jP + 1), this.heap = new Ur.Buf16(2 * Fh + 1), xi(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Ur.Buf16(2 * Fh + 1), xi(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function $M(e) {
  var A;
  return !e || !e.state ? Si(e, Gn) : (e.total_in = e.total_out = 0, e.data_type = kP, A = e.state, A.pending = 0, A.pending_out = 0, A.wrap < 0 && (A.wrap = -A.wrap), A.status = A.wrap ? aB : ka, e.adler = A.wrap === 2 ? 0 : 1, A.last_flush = no, Rn._tr_init(A), D0);
}
function Ap(e) {
  var A = $M(e);
  return A === D0 && _P(e.state), A;
}
function qP(e, A) {
  return !e || !e.state || e.state.wrap !== 2 ? Gn : (e.state.gzhead = A, D0);
}
function ep(e, A, t, r, n, i) {
  if (!e)
    return Gn;
  var a = 1;
  if (A === FP && (A = 6), r < 0 ? (a = 0, r = -r) : r > 15 && (a = 2, r -= 16), n < 1 || n > UP || t !== iB || r < 8 || r > 15 || A < 0 || A > 9 || i < 0 || i > GP)
    return Si(e, Gn);
  r === 8 && (r = 9);
  var o = new XP();
  return e.state = o, o.strm = e, o.wrap = a, o.gzhead = null, o.w_bits = r, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = n + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + dt - 1) / dt), o.window = new Ur.Buf8(o.w_size * 2), o.head = new Ur.Buf16(o.hash_size), o.prev = new Ur.Buf16(o.w_size), o.lit_bufsize = 1 << n + 6, o.pending_buf_size = o.lit_bufsize * 4, o.pending_buf = new Ur.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = A, o.strategy = i, o.method = t, Ap(e);
}
function $P(e, A) {
  return ep(e, A, iB, YP, HP, xP);
}
function Az(e, A) {
  var t, r, n, i;
  if (!e || !e.state || A > s5 || A < 0)
    return e ? Si(e, Gn) : Gn;
  if (r = e.state, !e.output || !e.input && e.avail_in !== 0 || r.status === Ws && A !== ji)
    return Si(e, e.avail_out === 0 ? sd : Gn);
  if (r.strm = e, t = r.last_flush, r.last_flush = A, r.status === aB)
    if (r.wrap === 2)
      e.adler = 0, wt(r, 31), wt(r, 139), wt(r, 8), r.gzhead ? (wt(r, (r.gzhead.text ? 1 : 0) + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)), wt(r, r.gzhead.time & 255), wt(r, r.gzhead.time >> 8 & 255), wt(r, r.gzhead.time >> 16 & 255), wt(r, r.gzhead.time >> 24 & 255), wt(r, r.level === 9 ? 2 : r.strategy >= Wu || r.level < 2 ? 4 : 0), wt(r, r.gzhead.os & 255), r.gzhead.extra && r.gzhead.extra.length && (wt(r, r.gzhead.extra.length & 255), wt(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (e.adler = bi(e.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = Lh) : (wt(r, 0), wt(r, 0), wt(r, 0), wt(r, 0), wt(r, 0), wt(r, r.level === 9 ? 2 : r.strategy >= Wu || r.level < 2 ? 4 : 0), wt(r, OP), r.status = ka);
    else {
      var a = iB + (r.w_bits - 8 << 4) << 8, o = -1;
      r.strategy >= Wu || r.level < 2 ? o = 0 : r.level < 6 ? o = 1 : r.level === 6 ? o = 2 : o = 3, a |= o << 6, r.strstart !== 0 && (a |= VP), a += 31 - a % 31, r.status = ka, Vs(r, a), r.strstart !== 0 && (Vs(r, e.adler >>> 16), Vs(r, e.adler & 65535)), e.adler = 1;
    }
  if (r.status === Lh)
    if (r.gzhead.extra) {
      for (n = r.pending; r.gzindex < (r.gzhead.extra.length & 65535) && !(r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), Fi(e), n = r.pending, r.pending === r.pending_buf_size)); )
        wt(r, r.gzhead.extra[r.gzindex] & 255), r.gzindex++;
      r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), r.gzindex === r.gzhead.extra.length && (r.gzindex = 0, r.status = pc);
    } else
      r.status = pc;
  if (r.status === pc)
    if (r.gzhead.name) {
      n = r.pending;
      do {
        if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), Fi(e), n = r.pending, r.pending === r.pending_buf_size)) {
          i = 1;
          break;
        }
        r.gzindex < r.gzhead.name.length ? i = r.gzhead.name.charCodeAt(r.gzindex++) & 255 : i = 0, wt(r, i);
      } while (i !== 0);
      r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), i === 0 && (r.gzindex = 0, r.status = vc);
    } else
      r.status = vc;
  if (r.status === vc)
    if (r.gzhead.comment) {
      n = r.pending;
      do {
        if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), Fi(e), n = r.pending, r.pending === r.pending_buf_size)) {
          i = 1;
          break;
        }
        r.gzindex < r.gzhead.comment.length ? i = r.gzhead.comment.charCodeAt(r.gzindex++) & 255 : i = 0, wt(r, i);
      } while (i !== 0);
      r.gzhead.hcrc && r.pending > n && (e.adler = bi(e.adler, r.pending_buf, r.pending - n, n)), i === 0 && (r.status = yc);
    } else
      r.status = yc;
  if (r.status === yc && (r.gzhead.hcrc ? (r.pending + 2 > r.pending_buf_size && Fi(e), r.pending + 2 <= r.pending_buf_size && (wt(r, e.adler & 255), wt(r, e.adler >> 8 & 255), e.adler = 0, r.status = ka)) : r.status = ka), r.pending !== 0) {
    if (Fi(e), e.avail_out === 0)
      return r.last_flush = -1, D0;
  } else if (e.avail_in === 0 && u5(A) <= u5(t) && A !== ji)
    return Si(e, sd);
  if (r.status === Ws && e.avail_in !== 0)
    return Si(e, sd);
  if (e.avail_in !== 0 || r.lookahead !== 0 || A !== no && r.status !== Ws) {
    var s = r.strategy === Wu ? KP(r, A) : r.strategy === RP ? ZP(r, A) : Go[r.level].func(r, A);
    if ((s === _a || s === gs) && (r.status = Ws), s === lr || s === _a)
      return e.avail_out === 0 && (r.last_flush = -1), D0;
    if (s === Zl && (A === vP ? Rn._tr_align(r) : A !== s5 && (Rn._tr_stored_block(r, 0, 0, !1), A === yP && (xi(r.head), r.lookahead === 0 && (r.strstart = 0, r.block_start = 0, r.insert = 0))), Fi(e), e.avail_out === 0))
      return r.last_flush = -1, D0;
  }
  return A !== ji ? D0 : r.wrap <= 0 ? l5 : (r.wrap === 2 ? (wt(r, e.adler & 255), wt(r, e.adler >> 8 & 255), wt(r, e.adler >> 16 & 255), wt(r, e.adler >> 24 & 255), wt(r, e.total_in & 255), wt(r, e.total_in >> 8 & 255), wt(r, e.total_in >> 16 & 255), wt(r, e.total_in >> 24 & 255)) : (Vs(r, e.adler >>> 16), Vs(r, e.adler & 65535)), Fi(e), r.wrap > 0 && (r.wrap = -r.wrap), r.pending !== 0 ? D0 : l5);
}
function ez(e) {
  var A;
  return !e || !e.state ? Gn : (A = e.state.status, A !== aB && A !== Lh && A !== pc && A !== vc && A !== yc && A !== ka && A !== Ws ? Si(e, Gn) : (e.state = null, A === ka ? Si(e, bP) : D0));
}
function tz(e, A) {
  var t = A.length, r, n, i, a, o, s, l, u;
  if (!e || !e.state || (r = e.state, a = r.wrap, a === 2 || a === 1 && r.status !== aB || r.lookahead))
    return Gn;
  for (a === 1 && (e.adler = XM(e.adler, A, t, 0)), r.wrap = 0, t >= r.w_size && (a === 0 && (xi(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new Ur.Buf8(r.w_size), Ur.arraySet(u, A, t - r.w_size, r.w_size, 0), A = u, t = r.w_size), o = e.avail_in, s = e.next_in, l = e.input, e.avail_in = t, e.next_in = 0, e.input = A, Xa(r); r.lookahead >= dt; ) {
    n = r.strstart, i = r.lookahead - (dt - 1);
    do
      r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + dt - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
    while (--i);
    r.strstart = n, r.lookahead = dt - 1, Xa(r);
  }
  return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = dt - 1, r.match_available = 0, e.next_in = s, e.input = l, e.avail_in = o, r.wrap = a, D0;
}
S0.deflateInit = $P;
S0.deflateInit2 = ep;
S0.deflateReset = Ap;
S0.deflateResetKeep = $M;
S0.deflateSetHeader = qP;
S0.deflate = Az;
S0.deflateEnd = ez;
S0.deflateSetDictionary = tz;
S0.deflateInfo = "pako deflate (from Nodeca project)";
var n0 = {}, Zu = 30, rz = 12, nz = function(A, t) {
  var r, n, i, a, o, s, l, u, g, d, h, C, E, I, b, y, p, Q, w, Y, k, L, S, P, Z;
  r = A.state, n = A.next_in, P = A.input, i = n + (A.avail_in - 5), a = A.next_out, Z = A.output, o = a - (t - A.avail_out), s = a + (A.avail_out - 257), l = r.dmax, u = r.wsize, g = r.whave, d = r.wnext, h = r.window, C = r.hold, E = r.bits, I = r.lencode, b = r.distcode, y = (1 << r.lenbits) - 1, p = (1 << r.distbits) - 1;
  A: do {
    E < 15 && (C += P[n++] << E, E += 8, C += P[n++] << E, E += 8), Q = I[C & y];
    e: for (; ; ) {
      if (w = Q >>> 24, C >>>= w, E -= w, w = Q >>> 16 & 255, w === 0)
        Z[a++] = Q & 65535;
      else if (w & 16) {
        Y = Q & 65535, w &= 15, w && (E < w && (C += P[n++] << E, E += 8), Y += C & (1 << w) - 1, C >>>= w, E -= w), E < 15 && (C += P[n++] << E, E += 8, C += P[n++] << E, E += 8), Q = b[C & p];
        t: for (; ; ) {
          if (w = Q >>> 24, C >>>= w, E -= w, w = Q >>> 16 & 255, w & 16) {
            if (k = Q & 65535, w &= 15, E < w && (C += P[n++] << E, E += 8, E < w && (C += P[n++] << E, E += 8)), k += C & (1 << w) - 1, k > l) {
              A.msg = "invalid distance too far back", r.mode = Zu;
              break A;
            }
            if (C >>>= w, E -= w, w = a - o, k > w) {
              if (w = k - w, w > g && r.sane) {
                A.msg = "invalid distance too far back", r.mode = Zu;
                break A;
              }
              if (L = 0, S = h, d === 0) {
                if (L += u - w, w < Y) {
                  Y -= w;
                  do
                    Z[a++] = h[L++];
                  while (--w);
                  L = a - k, S = Z;
                }
              } else if (d < w) {
                if (L += u + d - w, w -= d, w < Y) {
                  Y -= w;
                  do
                    Z[a++] = h[L++];
                  while (--w);
                  if (L = 0, d < Y) {
                    w = d, Y -= w;
                    do
                      Z[a++] = h[L++];
                    while (--w);
                    L = a - k, S = Z;
                  }
                }
              } else if (L += d - w, w < Y) {
                Y -= w;
                do
                  Z[a++] = h[L++];
                while (--w);
                L = a - k, S = Z;
              }
              for (; Y > 2; )
                Z[a++] = S[L++], Z[a++] = S[L++], Z[a++] = S[L++], Y -= 3;
              Y && (Z[a++] = S[L++], Y > 1 && (Z[a++] = S[L++]));
            } else {
              L = a - k;
              do
                Z[a++] = Z[L++], Z[a++] = Z[L++], Z[a++] = Z[L++], Y -= 3;
              while (Y > 2);
              Y && (Z[a++] = Z[L++], Y > 1 && (Z[a++] = Z[L++]));
            }
          } else if (w & 64) {
            A.msg = "invalid distance code", r.mode = Zu;
            break A;
          } else {
            Q = b[(Q & 65535) + (C & (1 << w) - 1)];
            continue t;
          }
          break;
        }
      } else if (w & 64)
        if (w & 32) {
          r.mode = rz;
          break A;
        } else {
          A.msg = "invalid literal/length code", r.mode = Zu;
          break A;
        }
      else {
        Q = I[(Q & 65535) + (C & (1 << w) - 1)];
        continue e;
      }
      break;
    }
  } while (n < i && a < s);
  Y = E >> 3, n -= Y, E -= Y << 3, C &= (1 << E) - 1, A.next_in = n, A.next_out = a, A.avail_in = n < i ? 5 + (i - n) : 5 - (n - i), A.avail_out = a < s ? 257 + (s - a) : 257 - (a - s), r.hold = C, r.bits = E;
}, c5 = Jl, Mo = 15, g5 = 852, B5 = 592, f5 = 0, ud = 1, d5 = 2, iz = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], az = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], oz = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], sz = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], lz = function(A, t, r, n, i, a, o, s) {
  var l = s.bits, u = 0, g = 0, d = 0, h = 0, C = 0, E = 0, I = 0, b = 0, y = 0, p = 0, Q, w, Y, k, L, S = null, P = 0, Z, M = new c5.Buf16(Mo + 1), R = new c5.Buf16(Mo + 1), G = null, N = 0, z, T, O;
  for (u = 0; u <= Mo; u++)
    M[u] = 0;
  for (g = 0; g < n; g++)
    M[t[r + g]]++;
  for (C = l, h = Mo; h >= 1 && M[h] === 0; h--)
    ;
  if (C > h && (C = h), h === 0)
    return i[a++] = 1 << 24 | 64 << 16 | 0, i[a++] = 1 << 24 | 64 << 16 | 0, s.bits = 1, 0;
  for (d = 1; d < h && M[d] === 0; d++)
    ;
  for (C < d && (C = d), b = 1, u = 1; u <= Mo; u++)
    if (b <<= 1, b -= M[u], b < 0)
      return -1;
  if (b > 0 && (A === f5 || h !== 1))
    return -1;
  for (R[1] = 0, u = 1; u < Mo; u++)
    R[u + 1] = R[u] + M[u];
  for (g = 0; g < n; g++)
    t[r + g] !== 0 && (o[R[t[r + g]]++] = g);
  if (A === f5 ? (S = G = o, Z = 19) : A === ud ? (S = iz, P -= 257, G = az, N -= 257, Z = 256) : (S = oz, G = sz, Z = -1), p = 0, g = 0, u = d, L = a, E = C, I = 0, Y = -1, y = 1 << C, k = y - 1, A === ud && y > g5 || A === d5 && y > B5)
    return 1;
  for (; ; ) {
    z = u - I, o[g] < Z ? (T = 0, O = o[g]) : o[g] > Z ? (T = G[N + o[g]], O = S[P + o[g]]) : (T = 96, O = 0), Q = 1 << u - I, w = 1 << E, d = w;
    do
      w -= Q, i[L + (p >> I) + w] = z << 24 | T << 16 | O | 0;
    while (w !== 0);
    for (Q = 1 << u - 1; p & Q; )
      Q >>= 1;
    if (Q !== 0 ? (p &= Q - 1, p += Q) : p = 0, g++, --M[u] === 0) {
      if (u === h)
        break;
      u = t[r + o[g]];
    }
    if (u > C && (p & k) !== Y) {
      for (I === 0 && (I = C), L += d, E = u - I, b = 1 << E; E + I < h && (b -= M[E + I], !(b <= 0)); )
        E++, b <<= 1;
      if (y += 1 << E, A === ud && y > g5 || A === d5 && y > B5)
        return 1;
      Y = p & k, i[Y] = C << 24 | E << 16 | L - a | 0;
    }
  }
  return p !== 0 && (i[L + p] = u - I << 24 | 64 << 16 | 0), s.bits = C, 0;
}, hn = Jl, Rh = KM, C0 = _M, uz = nz, al = lz, cz = 0, tp = 1, rp = 2, h5 = 4, gz = 5, Ku = 6, qa = 0, Bz = 1, fz = 2, xn = -2, np = -3, ip = -4, dz = -5, C5 = 8, ap = 1, E5 = 2, Q5 = 3, w5 = 4, I5 = 5, D5 = 6, m5 = 7, M5 = 8, p5 = 9, v5 = 10, gg = 11, W0 = 12, cd = 13, y5 = 14, gd = 15, b5 = 16, F5 = 17, L5 = 18, R5 = 19, _u = 20, Xu = 21, G5 = 22, x5 = 23, k5 = 24, U5 = 25, Y5 = 26, Bd = 27, H5 = 28, S5 = 29, Vt = 30, op = 31, hz = 32, Cz = 852, Ez = 592, Qz = 15, wz = Qz;
function N5(e) {
  return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
}
function Iz() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new hn.Buf16(320), this.work = new hn.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function sp(e) {
  var A;
  return !e || !e.state ? xn : (A = e.state, e.total_in = e.total_out = A.total = 0, e.msg = "", A.wrap && (e.adler = A.wrap & 1), A.mode = ap, A.last = 0, A.havedict = 0, A.dmax = 32768, A.head = null, A.hold = 0, A.bits = 0, A.lencode = A.lendyn = new hn.Buf32(Cz), A.distcode = A.distdyn = new hn.Buf32(Ez), A.sane = 1, A.back = -1, qa);
}
function lp(e) {
  var A;
  return !e || !e.state ? xn : (A = e.state, A.wsize = 0, A.whave = 0, A.wnext = 0, sp(e));
}
function up(e, A) {
  var t, r;
  return !e || !e.state || (r = e.state, A < 0 ? (t = 0, A = -A) : (t = (A >> 4) + 1, A < 48 && (A &= 15)), A && (A < 8 || A > 15)) ? xn : (r.window !== null && r.wbits !== A && (r.window = null), r.wrap = t, r.wbits = A, lp(e));
}
function cp(e, A) {
  var t, r;
  return e ? (r = new Iz(), e.state = r, r.window = null, t = up(e, A), t !== qa && (e.state = null), t) : xn;
}
function Dz(e) {
  return cp(e, wz);
}
var T5 = !0, fd, dd;
function mz(e) {
  if (T5) {
    var A;
    for (fd = new hn.Buf32(512), dd = new hn.Buf32(32), A = 0; A < 144; )
      e.lens[A++] = 8;
    for (; A < 256; )
      e.lens[A++] = 9;
    for (; A < 280; )
      e.lens[A++] = 7;
    for (; A < 288; )
      e.lens[A++] = 8;
    for (al(tp, e.lens, 0, 288, fd, 0, e.work, {
      bits: 9
    }), A = 0; A < 32; )
      e.lens[A++] = 5;
    al(rp, e.lens, 0, 32, dd, 0, e.work, {
      bits: 5
    }), T5 = !1;
  }
  e.lencode = fd, e.lenbits = 9, e.distcode = dd, e.distbits = 5;
}
function gp(e, A, t, r) {
  var n, i = e.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new hn.Buf8(i.wsize)), r >= i.wsize ? (hn.arraySet(i.window, A, t - i.wsize, i.wsize, 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > r && (n = r), hn.arraySet(i.window, A, t - r, n, i.wnext), r -= n, r ? (hn.arraySet(i.window, A, t - r, r, 0), i.wnext = r, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}
function Mz(e, A) {
  var t, r, n, i, a, o, s, l, u, g, d, h, C, E, I = 0, b, y, p, Q, w, Y, k, L, S = new hn.Buf8(4), P, Z, M = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!e || !e.state || !e.output || !e.input && e.avail_in !== 0)
    return xn;
  t = e.state, t.mode === W0 && (t.mode = cd), a = e.next_out, n = e.output, s = e.avail_out, i = e.next_in, r = e.input, o = e.avail_in, l = t.hold, u = t.bits, g = o, d = s, L = qa;
  A:
    for (; ; )
      switch (t.mode) {
        case ap:
          if (t.wrap === 0) {
            t.mode = cd;
            break;
          }
          for (; u < 16; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if (t.wrap & 2 && l === 35615) {
            t.check = 0, S[0] = l & 255, S[1] = l >>> 8 & 255, t.check = C0(t.check, S, 2, 0), l = 0, u = 0, t.mode = E5;
            break;
          }
          if (t.flags = 0, t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            e.msg = "incorrect header check", t.mode = Vt;
            break;
          }
          if ((l & 15) !== C5) {
            e.msg = "unknown compression method", t.mode = Vt;
            break;
          }
          if (l >>>= 4, u -= 4, k = (l & 15) + 8, t.wbits === 0)
            t.wbits = k;
          else if (k > t.wbits) {
            e.msg = "invalid window size", t.mode = Vt;
            break;
          }
          t.dmax = 1 << k, e.adler = t.check = 1, t.mode = l & 512 ? v5 : W0, l = 0, u = 0;
          break;
        case E5:
          for (; u < 16; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if (t.flags = l, (t.flags & 255) !== C5) {
            e.msg = "unknown compression method", t.mode = Vt;
            break;
          }
          if (t.flags & 57344) {
            e.msg = "unknown header flags set", t.mode = Vt;
            break;
          }
          t.head && (t.head.text = l >> 8 & 1), t.flags & 512 && (S[0] = l & 255, S[1] = l >>> 8 & 255, t.check = C0(t.check, S, 2, 0)), l = 0, u = 0, t.mode = Q5;
        /* falls through */
        case Q5:
          for (; u < 32; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          t.head && (t.head.time = l), t.flags & 512 && (S[0] = l & 255, S[1] = l >>> 8 & 255, S[2] = l >>> 16 & 255, S[3] = l >>> 24 & 255, t.check = C0(t.check, S, 4, 0)), l = 0, u = 0, t.mode = w5;
        /* falls through */
        case w5:
          for (; u < 16; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          t.head && (t.head.xflags = l & 255, t.head.os = l >> 8), t.flags & 512 && (S[0] = l & 255, S[1] = l >>> 8 & 255, t.check = C0(t.check, S, 2, 0)), l = 0, u = 0, t.mode = I5;
        /* falls through */
        case I5:
          if (t.flags & 1024) {
            for (; u < 16; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            t.length = l, t.head && (t.head.extra_len = l), t.flags & 512 && (S[0] = l & 255, S[1] = l >>> 8 & 255, t.check = C0(t.check, S, 2, 0)), l = 0, u = 0;
          } else t.head && (t.head.extra = null);
          t.mode = D5;
        /* falls through */
        case D5:
          if (t.flags & 1024 && (h = t.length, h > o && (h = o), h && (t.head && (k = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Array(t.head.extra_len)), hn.arraySet(
            t.head.extra,
            r,
            i,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            h,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            k
          )), t.flags & 512 && (t.check = C0(t.check, r, h, i)), o -= h, i += h, t.length -= h), t.length))
            break A;
          t.length = 0, t.mode = m5;
        /* falls through */
        case m5:
          if (t.flags & 2048) {
            if (o === 0)
              break A;
            h = 0;
            do
              k = r[i + h++], t.head && k && t.length < 65536 && (t.head.name += String.fromCharCode(k));
            while (k && h < o);
            if (t.flags & 512 && (t.check = C0(t.check, r, h, i)), o -= h, i += h, k)
              break A;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = M5;
        /* falls through */
        case M5:
          if (t.flags & 4096) {
            if (o === 0)
              break A;
            h = 0;
            do
              k = r[i + h++], t.head && k && t.length < 65536 && (t.head.comment += String.fromCharCode(k));
            while (k && h < o);
            if (t.flags & 512 && (t.check = C0(t.check, r, h, i)), o -= h, i += h, k)
              break A;
          } else t.head && (t.head.comment = null);
          t.mode = p5;
        /* falls through */
        case p5:
          if (t.flags & 512) {
            for (; u < 16; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            if (l !== (t.check & 65535)) {
              e.msg = "header crc mismatch", t.mode = Vt;
              break;
            }
            l = 0, u = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = W0;
          break;
        case v5:
          for (; u < 32; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          e.adler = t.check = N5(l), l = 0, u = 0, t.mode = gg;
        /* falls through */
        case gg:
          if (t.havedict === 0)
            return e.next_out = a, e.avail_out = s, e.next_in = i, e.avail_in = o, t.hold = l, t.bits = u, fz;
          e.adler = t.check = 1, t.mode = W0;
        /* falls through */
        case W0:
          if (A === gz || A === Ku)
            break A;
        /* falls through */
        case cd:
          if (t.last) {
            l >>>= u & 7, u -= u & 7, t.mode = Bd;
            break;
          }
          for (; u < 3; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          switch (t.last = l & 1, l >>>= 1, u -= 1, l & 3) {
            case 0:
              t.mode = y5;
              break;
            case 1:
              if (mz(t), t.mode = _u, A === Ku) {
                l >>>= 2, u -= 2;
                break A;
              }
              break;
            case 2:
              t.mode = F5;
              break;
            case 3:
              e.msg = "invalid block type", t.mode = Vt;
          }
          l >>>= 2, u -= 2;
          break;
        case y5:
          for (l >>>= u & 7, u -= u & 7; u < 32; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", t.mode = Vt;
            break;
          }
          if (t.length = l & 65535, l = 0, u = 0, t.mode = gd, A === Ku)
            break A;
        /* falls through */
        case gd:
          t.mode = b5;
        /* falls through */
        case b5:
          if (h = t.length, h) {
            if (h > o && (h = o), h > s && (h = s), h === 0)
              break A;
            hn.arraySet(n, r, i, h, a), o -= h, i += h, s -= h, a += h, t.length -= h;
            break;
          }
          t.mode = W0;
          break;
        case F5:
          for (; u < 14; ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if (t.nlen = (l & 31) + 257, l >>>= 5, u -= 5, t.ndist = (l & 31) + 1, l >>>= 5, u -= 5, t.ncode = (l & 15) + 4, l >>>= 4, u -= 4, t.nlen > 286 || t.ndist > 30) {
            e.msg = "too many length or distance symbols", t.mode = Vt;
            break;
          }
          t.have = 0, t.mode = L5;
        /* falls through */
        case L5:
          for (; t.have < t.ncode; ) {
            for (; u < 3; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            t.lens[M[t.have++]] = l & 7, l >>>= 3, u -= 3;
          }
          for (; t.have < 19; )
            t.lens[M[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, P = {
            bits: t.lenbits
          }, L = al(cz, t.lens, 0, 19, t.lencode, 0, t.work, P), t.lenbits = P.bits, L) {
            e.msg = "invalid code lengths set", t.mode = Vt;
            break;
          }
          t.have = 0, t.mode = R5;
        /* falls through */
        case R5:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; I = t.lencode[l & (1 << t.lenbits) - 1], b = I >>> 24, y = I >>> 16 & 255, p = I & 65535, !(b <= u); ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            if (p < 16)
              l >>>= b, u -= b, t.lens[t.have++] = p;
            else {
              if (p === 16) {
                for (Z = b + 2; u < Z; ) {
                  if (o === 0)
                    break A;
                  o--, l += r[i++] << u, u += 8;
                }
                if (l >>>= b, u -= b, t.have === 0) {
                  e.msg = "invalid bit length repeat", t.mode = Vt;
                  break;
                }
                k = t.lens[t.have - 1], h = 3 + (l & 3), l >>>= 2, u -= 2;
              } else if (p === 17) {
                for (Z = b + 3; u < Z; ) {
                  if (o === 0)
                    break A;
                  o--, l += r[i++] << u, u += 8;
                }
                l >>>= b, u -= b, k = 0, h = 3 + (l & 7), l >>>= 3, u -= 3;
              } else {
                for (Z = b + 7; u < Z; ) {
                  if (o === 0)
                    break A;
                  o--, l += r[i++] << u, u += 8;
                }
                l >>>= b, u -= b, k = 0, h = 11 + (l & 127), l >>>= 7, u -= 7;
              }
              if (t.have + h > t.nlen + t.ndist) {
                e.msg = "invalid bit length repeat", t.mode = Vt;
                break;
              }
              for (; h--; )
                t.lens[t.have++] = k;
            }
          }
          if (t.mode === Vt)
            break;
          if (t.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", t.mode = Vt;
            break;
          }
          if (t.lenbits = 9, P = {
            bits: t.lenbits
          }, L = al(tp, t.lens, 0, t.nlen, t.lencode, 0, t.work, P), t.lenbits = P.bits, L) {
            e.msg = "invalid literal/lengths set", t.mode = Vt;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, P = {
            bits: t.distbits
          }, L = al(rp, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, P), t.distbits = P.bits, L) {
            e.msg = "invalid distances set", t.mode = Vt;
            break;
          }
          if (t.mode = _u, A === Ku)
            break A;
        /* falls through */
        case _u:
          t.mode = Xu;
        /* falls through */
        case Xu:
          if (o >= 6 && s >= 258) {
            e.next_out = a, e.avail_out = s, e.next_in = i, e.avail_in = o, t.hold = l, t.bits = u, uz(e, d), a = e.next_out, n = e.output, s = e.avail_out, i = e.next_in, r = e.input, o = e.avail_in, l = t.hold, u = t.bits, t.mode === W0 && (t.back = -1);
            break;
          }
          for (t.back = 0; I = t.lencode[l & (1 << t.lenbits) - 1], b = I >>> 24, y = I >>> 16 & 255, p = I & 65535, !(b <= u); ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if (y && !(y & 240)) {
            for (Q = b, w = y, Y = p; I = t.lencode[Y + ((l & (1 << Q + w) - 1) >> Q)], b = I >>> 24, y = I >>> 16 & 255, p = I & 65535, !(Q + b <= u); ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            l >>>= Q, u -= Q, t.back += Q;
          }
          if (l >>>= b, u -= b, t.back += b, t.length = p, y === 0) {
            t.mode = Y5;
            break;
          }
          if (y & 32) {
            t.back = -1, t.mode = W0;
            break;
          }
          if (y & 64) {
            e.msg = "invalid literal/length code", t.mode = Vt;
            break;
          }
          t.extra = y & 15, t.mode = G5;
        /* falls through */
        case G5:
          if (t.extra) {
            for (Z = t.extra; u < Z; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            t.length += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = x5;
        /* falls through */
        case x5:
          for (; I = t.distcode[l & (1 << t.distbits) - 1], b = I >>> 24, y = I >>> 16 & 255, p = I & 65535, !(b <= u); ) {
            if (o === 0)
              break A;
            o--, l += r[i++] << u, u += 8;
          }
          if (!(y & 240)) {
            for (Q = b, w = y, Y = p; I = t.distcode[Y + ((l & (1 << Q + w) - 1) >> Q)], b = I >>> 24, y = I >>> 16 & 255, p = I & 65535, !(Q + b <= u); ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            l >>>= Q, u -= Q, t.back += Q;
          }
          if (l >>>= b, u -= b, t.back += b, y & 64) {
            e.msg = "invalid distance code", t.mode = Vt;
            break;
          }
          t.offset = p, t.extra = y & 15, t.mode = k5;
        /* falls through */
        case k5:
          if (t.extra) {
            for (Z = t.extra; u < Z; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            t.offset += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            e.msg = "invalid distance too far back", t.mode = Vt;
            break;
          }
          t.mode = U5;
        /* falls through */
        case U5:
          if (s === 0)
            break A;
          if (h = d - s, t.offset > h) {
            if (h = t.offset - h, h > t.whave && t.sane) {
              e.msg = "invalid distance too far back", t.mode = Vt;
              break;
            }
            h > t.wnext ? (h -= t.wnext, C = t.wsize - h) : C = t.wnext - h, h > t.length && (h = t.length), E = t.window;
          } else
            E = n, C = a - t.offset, h = t.length;
          h > s && (h = s), s -= h, t.length -= h;
          do
            n[a++] = E[C++];
          while (--h);
          t.length === 0 && (t.mode = Xu);
          break;
        case Y5:
          if (s === 0)
            break A;
          n[a++] = t.length, s--, t.mode = Xu;
          break;
        case Bd:
          if (t.wrap) {
            for (; u < 32; ) {
              if (o === 0)
                break A;
              o--, l |= r[i++] << u, u += 8;
            }
            if (d -= s, e.total_out += d, t.total += d, d && (e.adler = t.check = /*UPDATE(state.check, put - _out, _out);*/
            t.flags ? C0(t.check, n, d, a - d) : Rh(t.check, n, d, a - d)), d = s, (t.flags ? l : N5(l)) !== t.check) {
              e.msg = "incorrect data check", t.mode = Vt;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = H5;
        /* falls through */
        case H5:
          if (t.wrap && t.flags) {
            for (; u < 32; ) {
              if (o === 0)
                break A;
              o--, l += r[i++] << u, u += 8;
            }
            if (l !== (t.total & 4294967295)) {
              e.msg = "incorrect length check", t.mode = Vt;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = S5;
        /* falls through */
        case S5:
          L = Bz;
          break A;
        case Vt:
          L = np;
          break A;
        case op:
          return ip;
        case hz:
        /* falls through */
        default:
          return xn;
      }
  return e.next_out = a, e.avail_out = s, e.next_in = i, e.avail_in = o, t.hold = l, t.bits = u, (t.wsize || d !== e.avail_out && t.mode < Vt && (t.mode < Bd || A !== h5)) && gp(e, e.output, e.next_out, d - e.avail_out), g -= e.avail_in, d -= e.avail_out, e.total_in += g, e.total_out += d, t.total += d, t.wrap && d && (e.adler = t.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  t.flags ? C0(t.check, n, d, e.next_out - d) : Rh(t.check, n, d, e.next_out - d)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === W0 ? 128 : 0) + (t.mode === _u || t.mode === gd ? 256 : 0), (g === 0 && d === 0 || A === h5) && L === qa && (L = dz), L;
}
function pz(e) {
  if (!e || !e.state)
    return xn;
  var A = e.state;
  return A.window && (A.window = null), e.state = null, qa;
}
function vz(e, A) {
  var t;
  return !e || !e.state || (t = e.state, !(t.wrap & 2)) ? xn : (t.head = A, A.done = !1, qa);
}
function yz(e, A) {
  var t = A.length, r, n, i;
  return !e || !e.state || (r = e.state, r.wrap !== 0 && r.mode !== gg) ? xn : r.mode === gg && (n = 1, n = Rh(n, A, t, 0), n !== r.check) ? np : (i = gp(e, A, t, t), i ? (r.mode = op, ip) : (r.havedict = 1, qa));
}
n0.inflateReset = lp;
n0.inflateReset2 = up;
n0.inflateResetKeep = sp;
n0.inflateInit = Dz;
n0.inflateInit2 = cp;
n0.inflate = Mz;
n0.inflateEnd = pz;
n0.inflateGetHeader = vz;
n0.inflateSetDictionary = yz;
n0.inflateInfo = "pako inflate (from Nodeca project)";
var bz = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
(function(e) {
  var A = xM, t = q7, r = S0, n = n0, i = bz;
  for (var a in i)
    e[a] = i[a];
  e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7;
  var o = 31, s = 139;
  function l(u) {
    if (typeof u != "number" || u < e.DEFLATE || u > e.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = u, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  l.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, A(this.init_done, "close before init"), A(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? r.deflateEnd(this.strm) : (this.mode === e.INFLATE || this.mode === e.GUNZIP || this.mode === e.INFLATERAW || this.mode === e.UNZIP) && n.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null;
  }, l.prototype.write = function(u, g, d, h, C, E, I) {
    return this._write(!0, u, g, d, h, C, E, I);
  }, l.prototype.writeSync = function(u, g, d, h, C, E, I) {
    return this._write(!1, u, g, d, h, C, E, I);
  }, l.prototype._write = function(u, g, d, h, C, E, I, b) {
    if (A.equal(arguments.length, 8), A(this.init_done, "write before init"), A(this.mode !== e.NONE, "already finalized"), A.equal(!1, this.write_in_progress, "write already in progress"), A.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, A.equal(!1, g === void 0, "must provide flush value"), this.write_in_progress = !0, g !== e.Z_NO_FLUSH && g !== e.Z_PARTIAL_FLUSH && g !== e.Z_SYNC_FLUSH && g !== e.Z_FULL_FLUSH && g !== e.Z_FINISH && g !== e.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (d == null && (d = kA.alloc(0), C = 0, h = 0), this.strm.avail_in = C, this.strm.input = d, this.strm.next_in = h, this.strm.avail_out = b, this.strm.output = E, this.strm.next_out = I, this.flush = g, !u)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var y = this;
    return Vn.nextTick(function() {
      y._process(), y._after();
    }), this;
  }, l.prototype._afterSync = function() {
    var u = this.strm.avail_out, g = this.strm.avail_in;
    return this.write_in_progress = !1, [g, u];
  }, l.prototype._process = function() {
    var u = null;
    switch (this.mode) {
      case e.DEFLATE:
      case e.GZIP:
      case e.DEFLATERAW:
        this.err = r.deflate(this.strm, this.flush);
        break;
      case e.UNZIP:
        switch (this.strm.avail_in > 0 && (u = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (u === null)
              break;
            if (this.strm.input[u] === o) {
              if (this.gzip_id_bytes_read = 1, u++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = e.INFLATE;
              break;
            }
          // fallthrough
          case 1:
            if (u === null)
              break;
            this.strm.input[u] === s ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      // fallthrough
      case e.INFLATE:
      case e.GUNZIP:
      case e.INFLATERAW:
        for (this.err = n.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = n.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = n.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = n.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, l.prototype._checkError = function() {
    switch (this.err) {
      case e.Z_OK:
      case e.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === e.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case e.Z_STREAM_END:
        break;
      case e.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, l.prototype._after = function() {
    if (this._checkError()) {
      var u = this.strm.avail_out, g = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(g, u), this.pending_close && this.close();
    }
  }, l.prototype._error = function(u) {
    this.strm.msg && (u = this.strm.msg), this.onerror(
      u,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, l.prototype.init = function(u, g, d, h, C) {
    A(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), A(u >= 8 && u <= 15, "invalid windowBits"), A(g >= -1 && g <= 9, "invalid compression level"), A(d >= 1 && d <= 9, "invalid memlevel"), A(h === e.Z_FILTERED || h === e.Z_HUFFMAN_ONLY || h === e.Z_RLE || h === e.Z_FIXED || h === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(g, u, d, h, C), this._setDictionary();
  }, l.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, l.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, l.prototype._init = function(u, g, d, h, C) {
    switch (this.level = u, this.windowBits = g, this.memLevel = d, this.strategy = h, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, (this.mode === e.GZIP || this.mode === e.GUNZIP) && (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), (this.mode === e.DEFLATERAW || this.mode === e.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new t(), this.mode) {
      case e.DEFLATE:
      case e.GZIP:
      case e.DEFLATERAW:
        this.err = r.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case e.INFLATE:
      case e.GUNZIP:
      case e.INFLATERAW:
      case e.UNZIP:
        this.err = n.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== e.Z_OK && this._error("Init error"), this.dictionary = C, this.write_in_progress = !1, this.init_done = !0;
  }, l.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = e.Z_OK, this.mode) {
        case e.DEFLATE:
        case e.DEFLATERAW:
          this.err = r.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== e.Z_OK && this._error("Failed to set dictionary");
    }
  }, l.prototype._reset = function() {
    switch (this.err = e.Z_OK, this.mode) {
      case e.DEFLATE:
      case e.DEFLATERAW:
      case e.GZIP:
        this.err = r.deflateReset(this.strm);
        break;
      case e.INFLATE:
      case e.INFLATERAW:
      case e.GUNZIP:
        this.err = n.inflateReset(this.strm);
        break;
    }
    this.err !== e.Z_OK && this._error("Failed to reset stream");
  }, e.Zlib = l;
})(vM);
var Fz = /* @__PURE__ */ $g(i7);
(function(e) {
  var A = SI.Buffer, t = V7.Transform, r = vM, n = Fz, i = xM.ok, a = SI.kMaxLength, o = "Cannot create final Buffer. It would be larger than 0x" + a.toString(16) + " bytes";
  r.Z_MIN_WINDOWBITS = 8, r.Z_MAX_WINDOWBITS = 15, r.Z_DEFAULT_WINDOWBITS = 15, r.Z_MIN_CHUNK = 64, r.Z_MAX_CHUNK = 1 / 0, r.Z_DEFAULT_CHUNK = 16 * 1024, r.Z_MIN_MEMLEVEL = 1, r.Z_MAX_MEMLEVEL = 9, r.Z_DEFAULT_MEMLEVEL = 8, r.Z_MIN_LEVEL = -1, r.Z_MAX_LEVEL = 9, r.Z_DEFAULT_LEVEL = r.Z_DEFAULT_COMPRESSION;
  for (var s = Object.keys(r), l = 0; l < s.length; l++) {
    var u = s[l];
    u.match(/^Z/) && Object.defineProperty(e, u, {
      enumerable: !0,
      value: r[u],
      writable: !1
    });
  }
  for (var g = {
    Z_OK: r.Z_OK,
    Z_STREAM_END: r.Z_STREAM_END,
    Z_NEED_DICT: r.Z_NEED_DICT,
    Z_ERRNO: r.Z_ERRNO,
    Z_STREAM_ERROR: r.Z_STREAM_ERROR,
    Z_DATA_ERROR: r.Z_DATA_ERROR,
    Z_MEM_ERROR: r.Z_MEM_ERROR,
    Z_BUF_ERROR: r.Z_BUF_ERROR,
    Z_VERSION_ERROR: r.Z_VERSION_ERROR
  }, d = Object.keys(g), h = 0; h < d.length; h++) {
    var C = d[h];
    g[g[C]] = C;
  }
  Object.defineProperty(e, "codes", {
    enumerable: !0,
    value: Object.freeze(g),
    writable: !1
  }), e.Deflate = b, e.Inflate = y, e.Gzip = p, e.Gunzip = Q, e.DeflateRaw = w, e.InflateRaw = Y, e.Unzip = k, e.createDeflate = function(M) {
    return new b(M);
  }, e.createInflate = function(M) {
    return new y(M);
  }, e.createDeflateRaw = function(M) {
    return new w(M);
  }, e.createInflateRaw = function(M) {
    return new Y(M);
  }, e.createGzip = function(M) {
    return new p(M);
  }, e.createGunzip = function(M) {
    return new Q(M);
  }, e.createUnzip = function(M) {
    return new k(M);
  }, e.deflate = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new b(R), M, G);
  }, e.deflateSync = function(M, R) {
    return I(new b(R), M);
  }, e.gzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new p(R), M, G);
  }, e.gzipSync = function(M, R) {
    return I(new p(R), M);
  }, e.deflateRaw = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new w(R), M, G);
  }, e.deflateRawSync = function(M, R) {
    return I(new w(R), M);
  }, e.unzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new k(R), M, G);
  }, e.unzipSync = function(M, R) {
    return I(new k(R), M);
  }, e.inflate = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new y(R), M, G);
  }, e.inflateSync = function(M, R) {
    return I(new y(R), M);
  }, e.gunzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new Q(R), M, G);
  }, e.gunzipSync = function(M, R) {
    return I(new Q(R), M);
  }, e.inflateRaw = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new Y(R), M, G);
  }, e.inflateRawSync = function(M, R) {
    return I(new Y(R), M);
  };
  function E(M, R, G) {
    var N = [], z = 0;
    M.on("error", O), M.on("end", K), M.end(R), T();
    function T() {
      for (var AA; (AA = M.read()) !== null; )
        N.push(AA), z += AA.length;
      M.once("readable", T);
    }
    function O(AA) {
      M.removeListener("end", K), M.removeListener("readable", T), G(AA);
    }
    function K() {
      var AA, X = null;
      z >= a ? X = new RangeError(o) : AA = A.concat(N, z), N = [], M.close(), G(X, AA);
    }
  }
  function I(M, R) {
    if (typeof R == "string" && (R = A.from(R)), !A.isBuffer(R)) throw new TypeError("Not a string or buffer");
    var G = M._finishFlushFlag;
    return M._processChunk(R, G);
  }
  function b(M) {
    if (!(this instanceof b)) return new b(M);
    S.call(this, M, r.DEFLATE);
  }
  function y(M) {
    if (!(this instanceof y)) return new y(M);
    S.call(this, M, r.INFLATE);
  }
  function p(M) {
    if (!(this instanceof p)) return new p(M);
    S.call(this, M, r.GZIP);
  }
  function Q(M) {
    if (!(this instanceof Q)) return new Q(M);
    S.call(this, M, r.GUNZIP);
  }
  function w(M) {
    if (!(this instanceof w)) return new w(M);
    S.call(this, M, r.DEFLATERAW);
  }
  function Y(M) {
    if (!(this instanceof Y)) return new Y(M);
    S.call(this, M, r.INFLATERAW);
  }
  function k(M) {
    if (!(this instanceof k)) return new k(M);
    S.call(this, M, r.UNZIP);
  }
  function L(M) {
    return M === r.Z_NO_FLUSH || M === r.Z_PARTIAL_FLUSH || M === r.Z_SYNC_FLUSH || M === r.Z_FULL_FLUSH || M === r.Z_FINISH || M === r.Z_BLOCK;
  }
  function S(M, R) {
    var G = this;
    if (this._opts = M = M || {}, this._chunkSize = M.chunkSize || e.Z_DEFAULT_CHUNK, t.call(this, M), M.flush && !L(M.flush))
      throw new Error("Invalid flush flag: " + M.flush);
    if (M.finishFlush && !L(M.finishFlush))
      throw new Error("Invalid flush flag: " + M.finishFlush);
    if (this._flushFlag = M.flush || r.Z_NO_FLUSH, this._finishFlushFlag = typeof M.finishFlush < "u" ? M.finishFlush : r.Z_FINISH, M.chunkSize && (M.chunkSize < e.Z_MIN_CHUNK || M.chunkSize > e.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + M.chunkSize);
    if (M.windowBits && (M.windowBits < e.Z_MIN_WINDOWBITS || M.windowBits > e.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + M.windowBits);
    if (M.level && (M.level < e.Z_MIN_LEVEL || M.level > e.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + M.level);
    if (M.memLevel && (M.memLevel < e.Z_MIN_MEMLEVEL || M.memLevel > e.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + M.memLevel);
    if (M.strategy && M.strategy != e.Z_FILTERED && M.strategy != e.Z_HUFFMAN_ONLY && M.strategy != e.Z_RLE && M.strategy != e.Z_FIXED && M.strategy != e.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + M.strategy);
    if (M.dictionary && !A.isBuffer(M.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new r.Zlib(R);
    var N = this;
    this._hadError = !1, this._handle.onerror = function(O, K) {
      P(N), N._hadError = !0;
      var AA = new Error(O);
      AA.errno = K, AA.code = e.codes[K], N.emit("error", AA);
    };
    var z = e.Z_DEFAULT_COMPRESSION;
    typeof M.level == "number" && (z = M.level);
    var T = e.Z_DEFAULT_STRATEGY;
    typeof M.strategy == "number" && (T = M.strategy), this._handle.init(M.windowBits || e.Z_DEFAULT_WINDOWBITS, z, M.memLevel || e.Z_DEFAULT_MEMLEVEL, T, M.dictionary), this._buffer = A.allocUnsafe(this._chunkSize), this._offset = 0, this._level = z, this._strategy = T, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !G._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  n.inherits(S, t), S.prototype.params = function(M, R, G) {
    if (M < e.Z_MIN_LEVEL || M > e.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + M);
    if (R != e.Z_FILTERED && R != e.Z_HUFFMAN_ONLY && R != e.Z_RLE && R != e.Z_FIXED && R != e.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + R);
    if (this._level !== M || this._strategy !== R) {
      var N = this;
      this.flush(r.Z_SYNC_FLUSH, function() {
        i(N._handle, "zlib binding closed"), N._handle.params(M, R), N._hadError || (N._level = M, N._strategy = R, G && G());
      });
    } else
      Vn.nextTick(G);
  }, S.prototype.reset = function() {
    return i(this._handle, "zlib binding closed"), this._handle.reset();
  }, S.prototype._flush = function(M) {
    this._transform(A.alloc(0), "", M);
  }, S.prototype.flush = function(M, R) {
    var G = this, N = this._writableState;
    (typeof M == "function" || M === void 0 && !R) && (R = M, M = r.Z_FULL_FLUSH), N.ended ? R && Vn.nextTick(R) : N.ending ? R && this.once("end", R) : N.needDrain ? R && this.once("drain", function() {
      return G.flush(M, R);
    }) : (this._flushFlag = M, this.write(A.alloc(0), "", R));
  }, S.prototype.close = function(M) {
    P(this, M), Vn.nextTick(Z, this);
  };
  function P(M, R) {
    R && Vn.nextTick(R), M._handle && (M._handle.close(), M._handle = null);
  }
  function Z(M) {
    M.emit("close");
  }
  S.prototype._transform = function(M, R, G) {
    var N, z = this._writableState, T = z.ending || z.ended, O = T && (!M || z.length === M.length);
    if (M !== null && !A.isBuffer(M)) return G(new Error("invalid input"));
    if (!this._handle) return G(new Error("zlib binding closed"));
    O ? N = this._finishFlushFlag : (N = this._flushFlag, M.length >= z.length && (this._flushFlag = this._opts.flush || r.Z_NO_FLUSH)), this._processChunk(M, N, G);
  }, S.prototype._processChunk = function(M, R, G) {
    var N = M && M.length, z = this._chunkSize - this._offset, T = 0, O = this, K = typeof G == "function";
    if (!K) {
      var AA = [], X = 0, iA;
      this.on("error", function(HA) {
        iA = HA;
      }), i(this._handle, "zlib binding closed");
      do
        var oA = this._handle.writeSync(
          R,
          M,
          // in
          T,
          // in_off
          N,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          z
        );
      while (!this._hadError && DA(oA[0], oA[1]));
      if (this._hadError)
        throw iA;
      if (X >= a)
        throw P(this), new RangeError(o);
      var fA = A.concat(AA, X);
      return P(this), fA;
    }
    i(this._handle, "zlib binding closed");
    var wA = this._handle.write(
      R,
      M,
      // in
      T,
      // in_off
      N,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      z
    );
    wA.buffer = M, wA.callback = DA;
    function DA(HA, sA) {
      if (this && (this.buffer = null, this.callback = null), !O._hadError) {
        var lA = z - sA;
        if (i(lA >= 0, "have should not go down"), lA > 0) {
          var tA = O._buffer.slice(O._offset, O._offset + lA);
          O._offset += lA, K ? O.push(tA) : (AA.push(tA), X += tA.length);
        }
        if ((sA === 0 || O._offset >= O._chunkSize) && (z = O._chunkSize, O._offset = 0, O._buffer = A.allocUnsafe(O._chunkSize)), sA === 0) {
          if (T += N - HA, N = HA, !K) return !0;
          var nA = O._handle.write(R, M, T, N, O._buffer, O._offset, O._chunkSize);
          nA.callback = DA, nA.buffer = M;
          return;
        }
        if (!K) return !1;
        G();
      }
    }
  }, n.inherits(b, S), n.inherits(y, S), n.inherits(p, S), n.inherits(Q, S), n.inherits(w, S), n.inherits(Y, S), n.inherits(k, S);
})(aM);
var Lz = /* @__PURE__ */ S9(aM), ml = /* @__PURE__ */ function() {
  e.decode = function(r, n) {
    throw new Error("PNG.decode not available in browser build");
  }, e.load = function(r) {
    throw new Error("PNG.load not available in browser build");
  };
  function e(t) {
    var r;
    for (this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {}; ; ) {
      var n = this.readUInt32(), i = "";
      for (r = 0; r < 4; r++)
        i += String.fromCharCode(this.data[this.pos++]);
      switch (i) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "PLTE":
          this.palette = this.read(n);
          break;
        case "IDAT":
          for (r = 0; r < n; r++)
            this.imgData.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              this.transparency.indexed = this.read(n);
              var a = 255 - this.transparency.indexed.length;
              if (a > 0)
                for (r = 0; r < a; r++)
                  this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(n)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(n);
              break;
          }
          break;
        case "tEXt":
          var o = this.read(n), s = o.indexOf(0), l = String.fromCharCode.apply(String, o.slice(0, s));
          this.text[l] = String.fromCharCode.apply(String, o.slice(s + 1));
          break;
        case "IEND":
          switch (this.colorType) {
            case 0:
            case 3:
            case 4:
              this.colors = 1;
              break;
            case 2:
            case 6:
              this.colors = 3;
              break;
          }
          this.hasAlphaChannel = [4, 6].includes(this.colorType);
          var u = this.colors + (this.hasAlphaChannel ? 1 : 0);
          switch (this.pixelBitlength = this.bits * u, this.colors) {
            case 1:
              this.colorSpace = "DeviceGray";
              break;
            case 3:
              this.colorSpace = "DeviceRGB";
              break;
          }
          this.imgData = kA.from(this.imgData);
          return;
        default:
          this.pos += n;
      }
      if (this.pos += 4, this.pos > this.data.length)
        throw new Error("Incomplete or corrupt PNG file");
    }
  }
  var A = e.prototype;
  return A.read = function(r) {
    for (var n = new Array(r), i = 0; i < r; i++)
      n[i] = this.data[this.pos++];
    return n;
  }, A.readUInt32 = function() {
    var r = this.data[this.pos++] << 24, n = this.data[this.pos++] << 16, i = this.data[this.pos++] << 8, a = this.data[this.pos++];
    return r | n | i | a;
  }, A.readUInt16 = function() {
    var r = this.data[this.pos++] << 8, n = this.data[this.pos++];
    return r | n;
  }, A.decodePixels = function(r) {
    var n = this;
    return Lz.inflate(this.imgData, function(i, a) {
      if (i) throw i;
      var o = 0, s = n.width, l = n.height, u = n.pixelBitlength / 8, g = kA.alloc(s * l * u);
      function d(h, C, E, I, b) {
        b === void 0 && (b = !1);
        for (var y = Math.ceil((s - h) / E), p = Math.ceil((l - C) / I), Q = u * y, w = b ? g : kA.alloc(Q * p), Y = 0, k = 0; Y < p && o < a.length; ) {
          var L, S, P, Z, M;
          switch (a[o++]) {
            case 0:
              for (P = 0; P < Q; P++)
                w[k++] = a[o++];
              break;
            case 1:
              for (P = 0; P < Q; P++)
                L = a[o++], Z = P < u ? 0 : w[k - u], w[k++] = (L + Z) % 256;
              break;
            case 2:
              for (P = 0; P < Q; P++)
                L = a[o++], S = (P - P % u) / u, M = Y && w[(Y - 1) * Q + S * u + P % u], w[k++] = (M + L) % 256;
              break;
            case 3:
              for (P = 0; P < Q; P++)
                L = a[o++], S = (P - P % u) / u, Z = P < u ? 0 : w[k - u], M = Y && w[(Y - 1) * Q + S * u + P % u], w[k++] = (L + Math.floor((Z + M) / 2)) % 256;
              break;
            case 4:
              for (P = 0; P < Q; P++) {
                var R, G;
                L = a[o++], S = (P - P % u) / u, Z = P < u ? 0 : w[k - u], Y === 0 ? M = G = 0 : (M = w[(Y - 1) * Q + S * u + P % u], G = S && w[(Y - 1) * Q + (S - 1) * u + P % u]);
                var N = Z + M - G, z = Math.abs(N - Z), T = Math.abs(N - M), O = Math.abs(N - G);
                z <= T && z <= O ? R = Z : T <= O ? R = M : R = G, w[k++] = (L + R) % 256;
              }
              break;
            default:
              throw new Error("Invalid filter algorithm: " + a[o - 1]);
          }
          if (!b) {
            var K = ((C + Y * I) * s + h) * u, AA = Y * Q;
            for (P = 0; P < y; P++) {
              for (var X = 0; X < u; X++) g[K++] = w[AA++];
              K += (E - 1) * u;
            }
          }
          Y++;
        }
      }
      return n.interlaceMethod === 1 ? (d(0, 0, 8, 8), d(4, 0, 8, 8), d(0, 4, 4, 8), d(2, 0, 4, 4), d(0, 2, 2, 4), d(1, 0, 2, 2), d(0, 1, 1, 2)) : d(0, 0, 1, 1, !0), r(g);
    });
  }, A.decodePalette = function() {
    for (var r = this.palette, n = r.length, i = this.transparency.indexed || [], a = kA.alloc(i.length + n), o = 0, s = 0, l = 0; l < n; l += 3) {
      var u;
      a[o++] = r[l], a[o++] = r[l + 1], a[o++] = r[l + 2], a[o++] = (u = i[s++]) != null ? u : 255;
    }
    return a;
  }, A.copyToImageData = function(r, n) {
    var i, a, o = this.colors, s = null, l = this.hasAlphaChannel;
    this.palette.length && (s = this._decodedPalette || (this._decodedPalette = this.decodePalette()), o = 4, l = !0);
    var u = r.data || r, g = u.length, d = s || n, h = i = 0;
    if (o === 1)
      for (; h < g; ) {
        a = s ? n[h / 4] * 4 : i;
        var C = d[a++];
        u[h++] = C, u[h++] = C, u[h++] = C, u[h++] = l ? d[a++] : 255, i = a;
      }
    else
      for (; h < g; )
        a = s ? n[h / 4] * 4 : i, u[h++] = d[a++], u[h++] = d[a++], u[h++] = d[a++], u[h++] = l ? d[a++] : 255, i = a;
  }, A.decode = function(r) {
    var n = this, i = kA.alloc(this.width * this.height * 4);
    return this.decodePixels(function(a) {
      return n.copyToImageData(i, a), r(i);
    });
  }, e;
}(), Rz = Ym(), $a = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, m0 = [], Fn = [], Gz = typeof Uint8Array < "u" ? Uint8Array : Array, eE = !1;
function Bp() {
  eE = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", A = 0, t = e.length; A < t; ++A)
    m0[A] = e[A], Fn[e.charCodeAt(A)] = A;
  Fn[45] = 62, Fn[95] = 63;
}
function xz(e) {
  eE || Bp();
  var A, t, r, n, i, a, o = e.length;
  if (o % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  i = e[o - 2] === "=" ? 2 : e[o - 1] === "=" ? 1 : 0, a = new Gz(o * 3 / 4 - i), r = i > 0 ? o - 4 : o;
  var s = 0;
  for (A = 0, t = 0; A < r; A += 4, t += 3)
    n = Fn[e.charCodeAt(A)] << 18 | Fn[e.charCodeAt(A + 1)] << 12 | Fn[e.charCodeAt(A + 2)] << 6 | Fn[e.charCodeAt(A + 3)], a[s++] = n >> 16 & 255, a[s++] = n >> 8 & 255, a[s++] = n & 255;
  return i === 2 ? (n = Fn[e.charCodeAt(A)] << 2 | Fn[e.charCodeAt(A + 1)] >> 4, a[s++] = n & 255) : i === 1 && (n = Fn[e.charCodeAt(A)] << 10 | Fn[e.charCodeAt(A + 1)] << 4 | Fn[e.charCodeAt(A + 2)] >> 2, a[s++] = n >> 8 & 255, a[s++] = n & 255), a;
}
function kz(e) {
  return m0[e >> 18 & 63] + m0[e >> 12 & 63] + m0[e >> 6 & 63] + m0[e & 63];
}
function Uz(e, A, t) {
  for (var r, n = [], i = A; i < t; i += 3)
    r = (e[i] << 16) + (e[i + 1] << 8) + e[i + 2], n.push(kz(r));
  return n.join("");
}
function P5(e) {
  eE || Bp();
  for (var A, t = e.length, r = t % 3, n = "", i = [], a = 16383, o = 0, s = t - r; o < s; o += a)
    i.push(Uz(e, o, o + a > s ? s : o + a));
  return r === 1 ? (A = e[t - 1], n += m0[A >> 2], n += m0[A << 4 & 63], n += "==") : r === 2 && (A = (e[t - 2] << 8) + e[t - 1], n += m0[A >> 10], n += m0[A >> 4 & 63], n += m0[A << 2 & 63], n += "="), i.push(n), i.join("");
}
function oB(e, A, t, r, n) {
  var i, a, o = n * 8 - r - 1, s = (1 << o) - 1, l = s >> 1, u = -7, g = t ? n - 1 : 0, d = t ? -1 : 1, h = e[A + g];
  for (g += d, i = h & (1 << -u) - 1, h >>= -u, u += o; u > 0; i = i * 256 + e[A + g], g += d, u -= 8)
    ;
  for (a = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; a = a * 256 + e[A + g], g += d, u -= 8)
    ;
  if (i === 0)
    i = 1 - l;
  else {
    if (i === s)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), i = i - l;
  }
  return (h ? -1 : 1) * a * Math.pow(2, i - r);
}
function fp(e, A, t, r, n, i) {
  var a, o, s, l = i * 8 - n - 1, u = (1 << l) - 1, g = u >> 1, d = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : i - 1, C = r ? 1 : -1, E = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
  for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (o = isNaN(A) ? 1 : 0, a = u) : (a = Math.floor(Math.log(A) / Math.LN2), A * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), a + g >= 1 ? A += d / s : A += d * Math.pow(2, 1 - g), A * s >= 2 && (a++, s /= 2), a + g >= u ? (o = 0, a = u) : a + g >= 1 ? (o = (A * s - 1) * Math.pow(2, n), a = a + g) : (o = A * Math.pow(2, g - 1) * Math.pow(2, n), a = 0)); n >= 8; e[t + h] = o & 255, h += C, o /= 256, n -= 8)
    ;
  for (a = a << n | o, l += n; l > 0; e[t + h] = a & 255, h += C, a /= 256, l -= 8)
    ;
  e[t + h - C] |= E * 128;
}
var Yz = {}.toString, dp = Array.isArray || function(e) {
  return Yz.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var hp = 50;
LA.TYPED_ARRAY_SUPPORT = $a.TYPED_ARRAY_SUPPORT !== void 0 ? $a.TYPED_ARRAY_SUPPORT : !0;
var Hz = Bg();
function Bg() {
  return LA.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Ai(e, A) {
  if (Bg() < A)
    throw new RangeError("Invalid typed array length");
  return LA.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(A), e.__proto__ = LA.prototype) : (e === null && (e = new LA(A)), e.length = A), e;
}
function LA(e, A, t) {
  if (!LA.TYPED_ARRAY_SUPPORT && !(this instanceof LA))
    return new LA(e, A, t);
  if (typeof e == "number") {
    if (typeof A == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return tE(this, e);
  }
  return Cp(this, e, A, t);
}
LA.poolSize = 8192;
LA._augment = function(e) {
  return e.__proto__ = LA.prototype, e;
};
function Cp(e, A, t, r) {
  if (typeof A == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && A instanceof ArrayBuffer ? Tz(e, A, t, r) : typeof A == "string" ? Nz(e, A, t) : Pz(e, A);
}
LA.from = function(e, A, t) {
  return Cp(null, e, A, t);
};
LA.TYPED_ARRAY_SUPPORT && (LA.prototype.__proto__ = Uint8Array.prototype, LA.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && LA[Symbol.species]);
function Ep(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function Sz(e, A, t, r) {
  return Ep(A), A <= 0 ? Ai(e, A) : t !== void 0 ? typeof r == "string" ? Ai(e, A).fill(t, r) : Ai(e, A).fill(t) : Ai(e, A);
}
LA.alloc = function(e, A, t) {
  return Sz(null, e, A, t);
};
function tE(e, A) {
  if (Ep(A), e = Ai(e, A < 0 ? 0 : rE(A) | 0), !LA.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < A; ++t)
      e[t] = 0;
  return e;
}
LA.allocUnsafe = function(e) {
  return tE(null, e);
};
LA.allocUnsafeSlow = function(e) {
  return tE(null, e);
};
function Nz(e, A, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !LA.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = Qp(A, t) | 0;
  e = Ai(e, r);
  var n = e.write(A, t);
  return n !== r && (e = e.slice(0, n)), e;
}
function Gh(e, A) {
  var t = A.length < 0 ? 0 : rE(A.length) | 0;
  e = Ai(e, t);
  for (var r = 0; r < t; r += 1)
    e[r] = A[r] & 255;
  return e;
}
function Tz(e, A, t, r) {
  if (A.byteLength, t < 0 || A.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (A.byteLength < t + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && r === void 0 ? A = new Uint8Array(A) : r === void 0 ? A = new Uint8Array(A, t) : A = new Uint8Array(A, t, r), LA.TYPED_ARRAY_SUPPORT ? (e = A, e.__proto__ = LA.prototype) : e = Gh(e, A), e;
}
function Pz(e, A) {
  if (k0(A)) {
    var t = rE(A.length) | 0;
    return e = Ai(e, t), e.length === 0 || A.copy(e, 0, 0, t), e;
  }
  if (A) {
    if (typeof ArrayBuffer < "u" && A.buffer instanceof ArrayBuffer || "length" in A)
      return typeof A.length != "number" || oj(A.length) ? Ai(e, 0) : Gh(e, A);
    if (A.type === "Buffer" && dp(A.data))
      return Gh(e, A.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function rE(e) {
  if (e >= Bg())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Bg().toString(16) + " bytes");
  return e | 0;
}
function zz(e) {
  return +e != e && (e = 0), LA.alloc(+e);
}
LA.isBuffer = Ya;
function k0(e) {
  return !!(e != null && e._isBuffer);
}
LA.compare = function(A, t) {
  if (!k0(A) || !k0(t))
    throw new TypeError("Arguments must be Buffers");
  if (A === t) return 0;
  for (var r = A.length, n = t.length, i = 0, a = Math.min(r, n); i < a; ++i)
    if (A[i] !== t[i]) {
      r = A[i], n = t[i];
      break;
    }
  return r < n ? -1 : n < r ? 1 : 0;
};
LA.isEncoding = function(A) {
  switch (String(A).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
LA.concat = function(A, t) {
  if (!dp(A))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (A.length === 0)
    return LA.alloc(0);
  var r;
  if (t === void 0)
    for (t = 0, r = 0; r < A.length; ++r)
      t += A[r].length;
  var n = LA.allocUnsafe(t), i = 0;
  for (r = 0; r < A.length; ++r) {
    var a = A[r];
    if (!k0(a))
      throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(n, i), i += a.length;
  }
  return n;
};
function Qp(e, A) {
  if (k0(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var t = e.length;
  if (t === 0) return 0;
  for (var r = !1; ; )
    switch (A) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return fg(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return vp(e).length;
      default:
        if (r) return fg(e).length;
        A = ("" + A).toLowerCase(), r = !0;
    }
}
LA.byteLength = Qp;
function jz(e, A, t) {
  var r = !1;
  if ((A === void 0 || A < 0) && (A = 0), A > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, A >>>= 0, t <= A))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return $z(this, A, t);
      case "utf8":
      case "utf-8":
        return Dp(this, A, t);
      case "ascii":
        return Xz(this, A, t);
      case "latin1":
      case "binary":
        return qz(this, A, t);
      case "base64":
        return Kz(this, A, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Aj(this, A, t);
      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
}
LA.prototype._isBuffer = !0;
function Ua(e, A, t) {
  var r = e[A];
  e[A] = e[t], e[t] = r;
}
LA.prototype.swap16 = function() {
  var A = this.length;
  if (A % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < A; t += 2)
    Ua(this, t, t + 1);
  return this;
};
LA.prototype.swap32 = function() {
  var A = this.length;
  if (A % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < A; t += 4)
    Ua(this, t, t + 3), Ua(this, t + 1, t + 2);
  return this;
};
LA.prototype.swap64 = function() {
  var A = this.length;
  if (A % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < A; t += 8)
    Ua(this, t, t + 7), Ua(this, t + 1, t + 6), Ua(this, t + 2, t + 5), Ua(this, t + 3, t + 4);
  return this;
};
LA.prototype.toString = function() {
  var A = this.length | 0;
  return A === 0 ? "" : arguments.length === 0 ? Dp(this, 0, A) : jz.apply(this, arguments);
};
LA.prototype.equals = function(A) {
  if (!k0(A)) throw new TypeError("Argument must be a Buffer");
  return this === A ? !0 : LA.compare(this, A) === 0;
};
LA.prototype.inspect = function() {
  var A = "", t = hp;
  return this.length > 0 && (A = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (A += " ... ")), "<Buffer " + A + ">";
};
LA.prototype.compare = function(A, t, r, n, i) {
  if (!k0(A))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), r === void 0 && (r = A ? A.length : 0), n === void 0 && (n = 0), i === void 0 && (i = this.length), t < 0 || r > A.length || n < 0 || i > this.length)
    throw new RangeError("out of range index");
  if (n >= i && t >= r)
    return 0;
  if (n >= i)
    return -1;
  if (t >= r)
    return 1;
  if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === A) return 0;
  for (var a = i - n, o = r - t, s = Math.min(a, o), l = this.slice(n, i), u = A.slice(t, r), g = 0; g < s; ++g)
    if (l[g] !== u[g]) {
      a = l[g], o = u[g];
      break;
    }
  return a < o ? -1 : o < a ? 1 : 0;
};
function wp(e, A, t, r, n) {
  if (e.length === 0) return -1;
  if (typeof t == "string" ? (r = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = n ? 0 : e.length - 1), t < 0 && (t = e.length + t), t >= e.length) {
    if (n) return -1;
    t = e.length - 1;
  } else if (t < 0)
    if (n) t = 0;
    else return -1;
  if (typeof A == "string" && (A = LA.from(A, r)), k0(A))
    return A.length === 0 ? -1 : z5(e, A, t, r, n);
  if (typeof A == "number")
    return A = A & 255, LA.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? n ? Uint8Array.prototype.indexOf.call(e, A, t) : Uint8Array.prototype.lastIndexOf.call(e, A, t) : z5(e, [A], t, r, n);
  throw new TypeError("val must be string, number or Buffer");
}
function z5(e, A, t, r, n) {
  var i = 1, a = e.length, o = A.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (e.length < 2 || A.length < 2)
      return -1;
    i = 2, a /= 2, o /= 2, t /= 2;
  }
  function s(h, C) {
    return i === 1 ? h[C] : h.readUInt16BE(C * i);
  }
  var l;
  if (n) {
    var u = -1;
    for (l = t; l < a; l++)
      if (s(e, l) === s(A, u === -1 ? 0 : l - u)) {
        if (u === -1 && (u = l), l - u + 1 === o) return u * i;
      } else
        u !== -1 && (l -= l - u), u = -1;
  } else
    for (t + o > a && (t = a - o), l = t; l >= 0; l--) {
      for (var g = !0, d = 0; d < o; d++)
        if (s(e, l + d) !== s(A, d)) {
          g = !1;
          break;
        }
      if (g) return l;
    }
  return -1;
}
LA.prototype.includes = function(A, t, r) {
  return this.indexOf(A, t, r) !== -1;
};
LA.prototype.indexOf = function(A, t, r) {
  return wp(this, A, t, r, !0);
};
LA.prototype.lastIndexOf = function(A, t, r) {
  return wp(this, A, t, r, !1);
};
function Vz(e, A, t, r) {
  t = Number(t) || 0;
  var n = e.length - t;
  r ? (r = Number(r), r > n && (r = n)) : r = n;
  var i = A.length;
  if (i % 2 !== 0) throw new TypeError("Invalid hex string");
  r > i / 2 && (r = i / 2);
  for (var a = 0; a < r; ++a) {
    var o = parseInt(A.substr(a * 2, 2), 16);
    if (isNaN(o)) return a;
    e[t + a] = o;
  }
  return a;
}
function Oz(e, A, t, r) {
  return uB(fg(A, e.length - t), e, t, r);
}
function Ip(e, A, t, r) {
  return uB(ij(A), e, t, r);
}
function Jz(e, A, t, r) {
  return Ip(e, A, t, r);
}
function Wz(e, A, t, r) {
  return uB(vp(A), e, t, r);
}
function Zz(e, A, t, r) {
  return uB(aj(A, e.length - t), e, t, r);
}
LA.prototype.write = function(A, t, r, n) {
  if (t === void 0)
    n = "utf8", r = this.length, t = 0;
  else if (r === void 0 && typeof t == "string")
    n = t, r = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(r) ? (r = r | 0, n === void 0 && (n = "utf8")) : (n = r, r = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var i = this.length - t;
  if ((r === void 0 || r > i) && (r = i), A.length > 0 && (r < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  n || (n = "utf8");
  for (var a = !1; ; )
    switch (n) {
      case "hex":
        return Vz(this, A, t, r);
      case "utf8":
      case "utf-8":
        return Oz(this, A, t, r);
      case "ascii":
        return Ip(this, A, t, r);
      case "latin1":
      case "binary":
        return Jz(this, A, t, r);
      case "base64":
        return Wz(this, A, t, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Zz(this, A, t, r);
      default:
        if (a) throw new TypeError("Unknown encoding: " + n);
        n = ("" + n).toLowerCase(), a = !0;
    }
};
LA.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function Kz(e, A, t) {
  return A === 0 && t === e.length ? P5(e) : P5(e.slice(A, t));
}
function Dp(e, A, t) {
  t = Math.min(e.length, t);
  for (var r = [], n = A; n < t; ) {
    var i = e[n], a = null, o = i > 239 ? 4 : i > 223 ? 3 : i > 191 ? 2 : 1;
    if (n + o <= t) {
      var s, l, u, g;
      switch (o) {
        case 1:
          i < 128 && (a = i);
          break;
        case 2:
          s = e[n + 1], (s & 192) === 128 && (g = (i & 31) << 6 | s & 63, g > 127 && (a = g));
          break;
        case 3:
          s = e[n + 1], l = e[n + 2], (s & 192) === 128 && (l & 192) === 128 && (g = (i & 15) << 12 | (s & 63) << 6 | l & 63, g > 2047 && (g < 55296 || g > 57343) && (a = g));
          break;
        case 4:
          s = e[n + 1], l = e[n + 2], u = e[n + 3], (s & 192) === 128 && (l & 192) === 128 && (u & 192) === 128 && (g = (i & 15) << 18 | (s & 63) << 12 | (l & 63) << 6 | u & 63, g > 65535 && g < 1114112 && (a = g));
      }
    }
    a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r.push(a), n += o;
  }
  return _z(r);
}
var j5 = 4096;
function _z(e) {
  var A = e.length;
  if (A <= j5)
    return String.fromCharCode.apply(String, e);
  for (var t = "", r = 0; r < A; )
    t += String.fromCharCode.apply(
      String,
      e.slice(r, r += j5)
    );
  return t;
}
function Xz(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n] & 127);
  return r;
}
function qz(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n]);
  return r;
}
function $z(e, A, t) {
  var r = e.length;
  (!A || A < 0) && (A = 0), (!t || t < 0 || t > r) && (t = r);
  for (var n = "", i = A; i < t; ++i)
    n += nj(e[i]);
  return n;
}
function Aj(e, A, t) {
  for (var r = e.slice(A, t), n = "", i = 0; i < r.length; i += 2)
    n += String.fromCharCode(r[i] + r[i + 1] * 256);
  return n;
}
LA.prototype.slice = function(A, t) {
  var r = this.length;
  A = ~~A, t = t === void 0 ? r : ~~t, A < 0 ? (A += r, A < 0 && (A = 0)) : A > r && (A = r), t < 0 ? (t += r, t < 0 && (t = 0)) : t > r && (t = r), t < A && (t = A);
  var n;
  if (LA.TYPED_ARRAY_SUPPORT)
    n = this.subarray(A, t), n.__proto__ = LA.prototype;
  else {
    var i = t - A;
    n = new LA(i, void 0);
    for (var a = 0; a < i; ++a)
      n[a] = this[a + A];
  }
  return n;
};
function dr(e, A, t) {
  if (e % 1 !== 0 || e < 0) throw new RangeError("offset is not uint");
  if (e + A > t) throw new RangeError("Trying to access beyond buffer length");
}
LA.prototype.readUIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || dr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return n;
};
LA.prototype.readUIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || dr(A, t, this.length);
  for (var n = this[A + --t], i = 1; t > 0 && (i *= 256); )
    n += this[A + --t] * i;
  return n;
};
LA.prototype.readUInt8 = function(A, t) {
  return t || dr(A, 1, this.length), this[A];
};
LA.prototype.readUInt16LE = function(A, t) {
  return t || dr(A, 2, this.length), this[A] | this[A + 1] << 8;
};
LA.prototype.readUInt16BE = function(A, t) {
  return t || dr(A, 2, this.length), this[A] << 8 | this[A + 1];
};
LA.prototype.readUInt32LE = function(A, t) {
  return t || dr(A, 4, this.length), (this[A] | this[A + 1] << 8 | this[A + 2] << 16) + this[A + 3] * 16777216;
};
LA.prototype.readUInt32BE = function(A, t) {
  return t || dr(A, 4, this.length), this[A] * 16777216 + (this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3]);
};
LA.prototype.readIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || dr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return i *= 128, n >= i && (n -= Math.pow(2, 8 * t)), n;
};
LA.prototype.readIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || dr(A, t, this.length);
  for (var n = t, i = 1, a = this[A + --n]; n > 0 && (i *= 256); )
    a += this[A + --n] * i;
  return i *= 128, a >= i && (a -= Math.pow(2, 8 * t)), a;
};
LA.prototype.readInt8 = function(A, t) {
  return t || dr(A, 1, this.length), this[A] & 128 ? (255 - this[A] + 1) * -1 : this[A];
};
LA.prototype.readInt16LE = function(A, t) {
  t || dr(A, 2, this.length);
  var r = this[A] | this[A + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
LA.prototype.readInt16BE = function(A, t) {
  t || dr(A, 2, this.length);
  var r = this[A + 1] | this[A] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
LA.prototype.readInt32LE = function(A, t) {
  return t || dr(A, 4, this.length), this[A] | this[A + 1] << 8 | this[A + 2] << 16 | this[A + 3] << 24;
};
LA.prototype.readInt32BE = function(A, t) {
  return t || dr(A, 4, this.length), this[A] << 24 | this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3];
};
LA.prototype.readFloatLE = function(A, t) {
  return t || dr(A, 4, this.length), oB(this, A, !0, 23, 4);
};
LA.prototype.readFloatBE = function(A, t) {
  return t || dr(A, 4, this.length), oB(this, A, !1, 23, 4);
};
LA.prototype.readDoubleLE = function(A, t) {
  return t || dr(A, 8, this.length), oB(this, A, !0, 52, 8);
};
LA.prototype.readDoubleBE = function(A, t) {
  return t || dr(A, 8, this.length), oB(this, A, !1, 52, 8);
};
function an(e, A, t, r, n, i) {
  if (!k0(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (A > n || A < i) throw new RangeError('"value" argument is out of bounds');
  if (t + r > e.length) throw new RangeError("Index out of range");
}
LA.prototype.writeUIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    an(this, A, t, r, i, 0);
  }
  var a = 1, o = 0;
  for (this[t] = A & 255; ++o < r && (a *= 256); )
    this[t + o] = A / a & 255;
  return t + r;
};
LA.prototype.writeUIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    an(this, A, t, r, i, 0);
  }
  var a = r - 1, o = 1;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    this[t + a] = A / o & 255;
  return t + r;
};
LA.prototype.writeUInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 1, 255, 0), LA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), this[t] = A & 255, t + 1;
};
function sB(e, A, t, r) {
  A < 0 && (A = 65535 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 2); n < i; ++n)
    e[t + n] = (A & 255 << 8 * (r ? n : 1 - n)) >>> (r ? n : 1 - n) * 8;
}
LA.prototype.writeUInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 2, 65535, 0), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : sB(this, A, t, !0), t + 2;
};
LA.prototype.writeUInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 2, 65535, 0), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : sB(this, A, t, !1), t + 2;
};
function lB(e, A, t, r) {
  A < 0 && (A = 4294967295 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 4); n < i; ++n)
    e[t + n] = A >>> (r ? n : 3 - n) * 8 & 255;
}
LA.prototype.writeUInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 4, 4294967295, 0), LA.TYPED_ARRAY_SUPPORT ? (this[t + 3] = A >>> 24, this[t + 2] = A >>> 16, this[t + 1] = A >>> 8, this[t] = A & 255) : lB(this, A, t, !0), t + 4;
};
LA.prototype.writeUInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 4, 4294967295, 0), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : lB(this, A, t, !1), t + 4;
};
LA.prototype.writeIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    an(this, A, t, r, i - 1, -i);
  }
  var a = 0, o = 1, s = 0;
  for (this[t] = A & 255; ++a < r && (o *= 256); )
    A < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
LA.prototype.writeIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    an(this, A, t, r, i - 1, -i);
  }
  var a = r - 1, o = 1, s = 0;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    A < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
LA.prototype.writeInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 1, 127, -128), LA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), A < 0 && (A = 255 + A + 1), this[t] = A & 255, t + 1;
};
LA.prototype.writeInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 2, 32767, -32768), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : sB(this, A, t, !0), t + 2;
};
LA.prototype.writeInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 2, 32767, -32768), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : sB(this, A, t, !1), t + 2;
};
LA.prototype.writeInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 4, 2147483647, -2147483648), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8, this[t + 2] = A >>> 16, this[t + 3] = A >>> 24) : lB(this, A, t, !0), t + 4;
};
LA.prototype.writeInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || an(this, A, t, 4, 2147483647, -2147483648), A < 0 && (A = 4294967295 + A + 1), LA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : lB(this, A, t, !1), t + 4;
};
function mp(e, A, t, r, n, i) {
  if (t + r > e.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function Mp(e, A, t, r, n) {
  return n || mp(e, A, t, 4), fp(e, A, t, r, 23, 4), t + 4;
}
LA.prototype.writeFloatLE = function(A, t, r) {
  return Mp(this, A, t, !0, r);
};
LA.prototype.writeFloatBE = function(A, t, r) {
  return Mp(this, A, t, !1, r);
};
function pp(e, A, t, r, n) {
  return n || mp(e, A, t, 8), fp(e, A, t, r, 52, 8), t + 8;
}
LA.prototype.writeDoubleLE = function(A, t, r) {
  return pp(this, A, t, !0, r);
};
LA.prototype.writeDoubleBE = function(A, t, r) {
  return pp(this, A, t, !1, r);
};
LA.prototype.copy = function(A, t, r, n) {
  if (r || (r = 0), !n && n !== 0 && (n = this.length), t >= A.length && (t = A.length), t || (t = 0), n > 0 && n < r && (n = r), n === r || A.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
  if (n < 0) throw new RangeError("sourceEnd out of bounds");
  n > this.length && (n = this.length), A.length - t < n - r && (n = A.length - t + r);
  var i = n - r, a;
  if (this === A && r < t && t < n)
    for (a = i - 1; a >= 0; --a)
      A[a + t] = this[a + r];
  else if (i < 1e3 || !LA.TYPED_ARRAY_SUPPORT)
    for (a = 0; a < i; ++a)
      A[a + t] = this[a + r];
  else
    Uint8Array.prototype.set.call(
      A,
      this.subarray(r, r + i),
      t
    );
  return i;
};
LA.prototype.fill = function(A, t, r, n) {
  if (typeof A == "string") {
    if (typeof t == "string" ? (n = t, t = 0, r = this.length) : typeof r == "string" && (n = r, r = this.length), A.length === 1) {
      var i = A.charCodeAt(0);
      i < 256 && (A = i);
    }
    if (n !== void 0 && typeof n != "string")
      throw new TypeError("encoding must be a string");
    if (typeof n == "string" && !LA.isEncoding(n))
      throw new TypeError("Unknown encoding: " + n);
  } else typeof A == "number" && (A = A & 255);
  if (t < 0 || this.length < t || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= t)
    return this;
  t = t >>> 0, r = r === void 0 ? this.length : r >>> 0, A || (A = 0);
  var a;
  if (typeof A == "number")
    for (a = t; a < r; ++a)
      this[a] = A;
  else {
    var o = k0(A) ? A : fg(new LA(A, n).toString()), s = o.length;
    for (a = 0; a < r - t; ++a)
      this[a + t] = o[a % s];
  }
  return this;
};
var ej = /[^+\/0-9A-Za-z-_]/g;
function tj(e) {
  if (e = rj(e).replace(ej, ""), e.length < 2) return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function rj(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function nj(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function fg(e, A) {
  A = A || 1 / 0;
  for (var t, r = e.length, n = null, i = [], a = 0; a < r; ++a) {
    if (t = e.charCodeAt(a), t > 55295 && t < 57344) {
      if (!n) {
        if (t > 56319) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        } else if (a + 1 === r) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        }
        n = t;
        continue;
      }
      if (t < 56320) {
        (A -= 3) > -1 && i.push(239, 191, 189), n = t;
        continue;
      }
      t = (n - 55296 << 10 | t - 56320) + 65536;
    } else n && (A -= 3) > -1 && i.push(239, 191, 189);
    if (n = null, t < 128) {
      if ((A -= 1) < 0) break;
      i.push(t);
    } else if (t < 2048) {
      if ((A -= 2) < 0) break;
      i.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((A -= 3) < 0) break;
      i.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((A -= 4) < 0) break;
      i.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return i;
}
function ij(e) {
  for (var A = [], t = 0; t < e.length; ++t)
    A.push(e.charCodeAt(t) & 255);
  return A;
}
function aj(e, A) {
  for (var t, r, n, i = [], a = 0; a < e.length && !((A -= 2) < 0); ++a)
    t = e.charCodeAt(a), r = t >> 8, n = t % 256, i.push(n), i.push(r);
  return i;
}
function vp(e) {
  return xz(tj(e));
}
function uB(e, A, t, r) {
  for (var n = 0; n < r && !(n + t >= A.length || n >= e.length); ++n)
    A[n + t] = e[n];
  return n;
}
function oj(e) {
  return e !== e;
}
function Ya(e) {
  return e != null && (!!e._isBuffer || yp(e) || sj(e));
}
function yp(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function sj(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && yp(e.slice(0, 0));
}
var lj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Buffer: LA,
  INSPECT_MAX_BYTES: hp,
  SlowBuffer: zz,
  isBuffer: Ya,
  kMaxLength: Hz
}), dg = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Bs(e) {
  if (e.__esModule) return e;
  var A = e.default;
  if (typeof A == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(A, arguments, this.constructor) : A.apply(this, arguments);
    };
    t.prototype = A.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), t;
}
var xh = { exports: {} }, fs = {};
function Fp() {
  throw new Error("setTimeout has not been defined");
}
function Lp() {
  throw new Error("clearTimeout has not been defined");
}
var Li = Fp, Ri = Lp;
typeof $a.setTimeout == "function" && (Li = setTimeout);
typeof $a.clearTimeout == "function" && (Ri = clearTimeout);
function Rp(e) {
  if (Li === setTimeout)
    return setTimeout(e, 0);
  if ((Li === Fp || !Li) && setTimeout)
    return Li = setTimeout, setTimeout(e, 0);
  try {
    return Li(e, 0);
  } catch {
    try {
      return Li.call(null, e, 0);
    } catch {
      return Li.call(this, e, 0);
    }
  }
}
function uj(e) {
  if (Ri === clearTimeout)
    return clearTimeout(e);
  if ((Ri === Lp || !Ri) && clearTimeout)
    return Ri = clearTimeout, clearTimeout(e);
  try {
    return Ri(e);
  } catch {
    try {
      return Ri.call(null, e);
    } catch {
      return Ri.call(this, e);
    }
  }
}
var ei = [], jo = !1, Ha, bc = -1;
function cj() {
  !jo || !Ha || (jo = !1, Ha.length ? ei = Ha.concat(ei) : bc = -1, ei.length && Gp());
}
function Gp() {
  if (!jo) {
    var e = Rp(cj);
    jo = !0;
    for (var A = ei.length; A; ) {
      for (Ha = ei, ei = []; ++bc < A; )
        Ha && Ha[bc].run();
      bc = -1, A = ei.length;
    }
    Ha = null, jo = !1, uj(e);
  }
}
function gj(e) {
  var A = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      A[t - 1] = arguments[t];
  ei.push(new xp(e, A)), ei.length === 1 && !jo && Rp(Gp);
}
function xp(e, A) {
  this.fun = e, this.array = A;
}
xp.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var Bj = "browser", fj = "browser", dj = !0, hj = {}, Cj = [], Ej = "", Qj = {}, wj = {}, Ij = {};
function io() {
}
var Dj = io, mj = io, Mj = io, pj = io, vj = io, yj = io, bj = io;
function Fj(e) {
  throw new Error("process.binding is not supported");
}
function Lj() {
  return "/";
}
function Rj(e) {
  throw new Error("process.chdir is not supported");
}
function Gj() {
  return 0;
}
var Fo = $a.performance || {}, xj = Fo.now || Fo.mozNow || Fo.msNow || Fo.oNow || Fo.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function kj(e) {
  var A = xj.call(Fo) * 1e-3, t = Math.floor(A), r = Math.floor(A % 1 * 1e9);
  return e && (t = t - e[0], r = r - e[1], r < 0 && (t--, r += 1e9)), [t, r];
}
var Uj = /* @__PURE__ */ new Date();
function Yj() {
  var e = /* @__PURE__ */ new Date(), A = e - Uj;
  return A / 1e3;
}
var ot = {
  nextTick: gj,
  title: Bj,
  browser: dj,
  env: hj,
  argv: Cj,
  version: Ej,
  versions: Qj,
  on: Dj,
  addListener: mj,
  once: Mj,
  off: pj,
  removeListener: vj,
  removeAllListeners: yj,
  emit: bj,
  binding: Fj,
  cwd: Lj,
  chdir: Rj,
  umask: Gj,
  hrtime: kj,
  platform: fj,
  release: wj,
  config: Ij,
  uptime: Yj
}, Hj;
function Vi() {
}
Vi.prototype = /* @__PURE__ */ Object.create(null);
function kt() {
  kt.init.call(this);
}
kt.EventEmitter = kt;
kt.usingDomains = !1;
kt.prototype.domain = void 0;
kt.prototype._events = void 0;
kt.prototype._maxListeners = void 0;
kt.defaultMaxListeners = 10;
kt.init = function() {
  this.domain = null, kt.usingDomains && Hj.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new Vi(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
kt.prototype.setMaxListeners = function(A) {
  if (typeof A != "number" || A < 0 || isNaN(A))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = A, this;
};
function kp(e) {
  return e._maxListeners === void 0 ? kt.defaultMaxListeners : e._maxListeners;
}
kt.prototype.getMaxListeners = function() {
  return kp(this);
};
function Sj(e, A, t) {
  if (A)
    e.call(t);
  else
    for (var r = e.length, n = Kl(e, r), i = 0; i < r; ++i)
      n[i].call(t);
}
function Nj(e, A, t, r) {
  if (A)
    e.call(t, r);
  else
    for (var n = e.length, i = Kl(e, n), a = 0; a < n; ++a)
      i[a].call(t, r);
}
function Tj(e, A, t, r, n) {
  if (A)
    e.call(t, r, n);
  else
    for (var i = e.length, a = Kl(e, i), o = 0; o < i; ++o)
      a[o].call(t, r, n);
}
function Pj(e, A, t, r, n, i) {
  if (A)
    e.call(t, r, n, i);
  else
    for (var a = e.length, o = Kl(e, a), s = 0; s < a; ++s)
      o[s].call(t, r, n, i);
}
function zj(e, A, t, r) {
  if (A)
    e.apply(t, r);
  else
    for (var n = e.length, i = Kl(e, n), a = 0; a < n; ++a)
      i[a].apply(t, r);
}
kt.prototype.emit = function(A) {
  var t, r, n, i, a, o, s, l = A === "error";
  if (o = this._events, o)
    l = l && o.error == null;
  else if (!l)
    return !1;
  if (s = this.domain, l) {
    if (t = arguments[1], s)
      t || (t = new Error('Uncaught, unspecified "error" event')), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t);
    else {
      if (t instanceof Error)
        throw t;
      var u = new Error('Uncaught, unspecified "error" event. (' + t + ")");
      throw u.context = t, u;
    }
    return !1;
  }
  if (r = o[A], !r)
    return !1;
  var g = typeof r == "function";
  switch (n = arguments.length, n) {
    // fast cases
    case 1:
      Sj(r, g, this);
      break;
    case 2:
      Nj(r, g, this, arguments[1]);
      break;
    case 3:
      Tj(r, g, this, arguments[1], arguments[2]);
      break;
    case 4:
      Pj(r, g, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      for (i = new Array(n - 1), a = 1; a < n; a++)
        i[a - 1] = arguments[a];
      zj(r, g, this, i);
  }
  return !0;
};
function Up(e, A, t, r) {
  var n, i, a;
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = e._events, i ? (i.newListener && (e.emit(
    "newListener",
    A,
    t.listener ? t.listener : t
  ), i = e._events), a = i[A]) : (i = e._events = new Vi(), e._eventsCount = 0), !a)
    a = i[A] = t, ++e._eventsCount;
  else if (typeof a == "function" ? a = i[A] = r ? [t, a] : [a, t] : r ? a.unshift(t) : a.push(t), !a.warned && (n = kp(e), n && n > 0 && a.length > n)) {
    a.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + A + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = A, o.count = a.length, jj(o);
  }
  return e;
}
function jj(e) {
  typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
kt.prototype.addListener = function(A, t) {
  return Up(this, A, t, !1);
};
kt.prototype.on = kt.prototype.addListener;
kt.prototype.prependListener = function(A, t) {
  return Up(this, A, t, !0);
};
function Yp(e, A, t) {
  var r = !1;
  function n() {
    e.removeListener(A, n), r || (r = !0, t.apply(e, arguments));
  }
  return n.listener = t, n;
}
kt.prototype.once = function(A, t) {
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(A, Yp(this, A, t)), this;
};
kt.prototype.prependOnceListener = function(A, t) {
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(A, Yp(this, A, t)), this;
};
kt.prototype.removeListener = function(A, t) {
  var r, n, i, a, o;
  if (typeof t != "function")
    throw new TypeError('"listener" argument must be a function');
  if (n = this._events, !n)
    return this;
  if (r = n[A], !r)
    return this;
  if (r === t || r.listener && r.listener === t)
    --this._eventsCount === 0 ? this._events = new Vi() : (delete n[A], n.removeListener && this.emit("removeListener", A, r.listener || t));
  else if (typeof r != "function") {
    for (i = -1, a = r.length; a-- > 0; )
      if (r[a] === t || r[a].listener && r[a].listener === t) {
        o = r[a].listener, i = a;
        break;
      }
    if (i < 0)
      return this;
    if (r.length === 1) {
      if (r[0] = void 0, --this._eventsCount === 0)
        return this._events = new Vi(), this;
      delete n[A];
    } else
      Vj(r, i);
    n.removeListener && this.emit("removeListener", A, o || t);
  }
  return this;
};
kt.prototype.off = function(e, A) {
  return this.removeListener(e, A);
};
kt.prototype.removeAllListeners = function(A) {
  var t, r;
  if (r = this._events, !r)
    return this;
  if (!r.removeListener)
    return arguments.length === 0 ? (this._events = new Vi(), this._eventsCount = 0) : r[A] && (--this._eventsCount === 0 ? this._events = new Vi() : delete r[A]), this;
  if (arguments.length === 0) {
    for (var n = Object.keys(r), i = 0, a; i < n.length; ++i)
      a = n[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = new Vi(), this._eventsCount = 0, this;
  }
  if (t = r[A], typeof t == "function")
    this.removeListener(A, t);
  else if (t)
    do
      this.removeListener(A, t[t.length - 1]);
    while (t[0]);
  return this;
};
kt.prototype.listeners = function(A) {
  var t, r, n = this._events;
  return n ? (t = n[A], t ? typeof t == "function" ? r = [t.listener || t] : r = Oj(t) : r = []) : r = [], r;
};
kt.listenerCount = function(e, A) {
  return typeof e.listenerCount == "function" ? e.listenerCount(A) : Hp.call(e, A);
};
kt.prototype.listenerCount = Hp;
function Hp(e) {
  var A = this._events;
  if (A) {
    var t = A[e];
    if (typeof t == "function")
      return 1;
    if (t)
      return t.length;
  }
  return 0;
}
kt.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function Vj(e, A) {
  for (var t = A, r = t + 1, n = e.length; r < n; t += 1, r += 1)
    e[t] = e[r];
  e.pop();
}
function Kl(e, A) {
  for (var t = new Array(A); A--; )
    t[A] = e[A];
  return t;
}
function Oj(e) {
  for (var A = new Array(e.length), t = 0; t < A.length; ++t)
    A[t] = e[t].listener || e[t];
  return A;
}
var Jj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  EventEmitter: kt,
  default: kt
}), Sp = /* @__PURE__ */ Bs(Jj), Np = Sp.EventEmitter, Ml = /* @__PURE__ */ Bs(lj), kh;
typeof Object.create == "function" ? kh = function(A, t) {
  A.super_ = t, A.prototype = Object.create(t.prototype, {
    constructor: {
      value: A,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : kh = function(A, t) {
  A.super_ = t;
  var r = function() {
  };
  r.prototype = t.prototype, A.prototype = new r(), A.prototype.constructor = A;
};
var nE = kh, Tp = Object.getOwnPropertyDescriptors || function(A) {
  for (var t = Object.keys(A), r = {}, n = 0; n < t.length; n++)
    r[t[n]] = Object.getOwnPropertyDescriptor(A, t[n]);
  return r;
}, Wj = /%[sdj%]/g;
function cB(e) {
  if (!Xl(e)) {
    for (var A = [], t = 0; t < arguments.length; t++)
      A.push(Wn(arguments[t]));
    return A.join(" ");
  }
  for (var t = 1, r = arguments, n = r.length, i = String(e).replace(Wj, function(o) {
    if (o === "%%") return "%";
    if (t >= n) return o;
    switch (o) {
      case "%s":
        return String(r[t++]);
      case "%d":
        return Number(r[t++]);
      case "%j":
        try {
          return JSON.stringify(r[t++]);
        } catch {
          return "[Circular]";
        }
      default:
        return o;
    }
  }), a = r[t]; t < n; a = r[++t])
    _l(a) || !ao(a) ? i += " " + a : i += " " + Wn(a);
  return i;
}
function iE(e, A) {
  if (b0($a.process))
    return function() {
      return iE(e, A).apply(this, arguments);
    };
  if (ot.noDeprecation === !0)
    return e;
  var t = !1;
  function r() {
    if (!t) {
      if (ot.throwDeprecation)
        throw new Error(A);
      ot.traceDeprecation ? console.trace(A) : console.error(A), t = !0;
    }
    return e.apply(this, arguments);
  }
  return r;
}
var qu = {}, hd;
function Pp(e) {
  if (b0(hd) && (hd = ot.env.NODE_DEBUG || ""), e = e.toUpperCase(), !qu[e])
    if (new RegExp("\\b" + e + "\\b", "i").test(hd)) {
      var A = 0;
      qu[e] = function() {
        var t = cB.apply(null, arguments);
        console.error("%s %d: %s", e, A, t);
      };
    } else
      qu[e] = function() {
      };
  return qu[e];
}
function Wn(e, A) {
  var t = {
    seen: [],
    stylize: Kj
  };
  return arguments.length >= 3 && (t.depth = arguments[2]), arguments.length >= 4 && (t.colors = arguments[3]), gB(A) ? t.showHidden = A : A && lE(t, A), b0(t.showHidden) && (t.showHidden = !1), b0(t.depth) && (t.depth = 2), b0(t.colors) && (t.colors = !1), b0(t.customInspect) && (t.customInspect = !0), t.colors && (t.stylize = Zj), hg(t, e, t.depth);
}
Wn.colors = {
  bold: [1, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  white: [37, 39],
  grey: [90, 39],
  black: [30, 39],
  blue: [34, 39],
  cyan: [36, 39],
  green: [32, 39],
  magenta: [35, 39],
  red: [31, 39],
  yellow: [33, 39]
};
Wn.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  // "name": intentionally not styling
  regexp: "red"
};
function Zj(e, A) {
  var t = Wn.styles[A];
  return t ? "\x1B[" + Wn.colors[t][0] + "m" + e + "\x1B[" + Wn.colors[t][1] + "m" : e;
}
function Kj(e, A) {
  return e;
}
function _j(e) {
  var A = {};
  return e.forEach(function(t, r) {
    A[t] = !0;
  }), A;
}
function hg(e, A, t) {
  if (e.customInspect && A && ja(A.inspect) && // Filter out the util module, it's inspect function is special
  A.inspect !== Wn && // Also filter out any prototype objects using the circular check.
  !(A.constructor && A.constructor.prototype === A)) {
    var r = A.inspect(t, e);
    return Xl(r) || (r = hg(e, r, t)), r;
  }
  var n = Xj(e, A);
  if (n)
    return n;
  var i = Object.keys(A), a = _j(i);
  if (e.showHidden && (i = Object.getOwnPropertyNames(A)), Vo(A) && (i.indexOf("message") >= 0 || i.indexOf("description") >= 0))
    return Cd(A);
  if (i.length === 0) {
    if (ja(A)) {
      var o = A.name ? ": " + A.name : "";
      return e.stylize("[Function" + o + "]", "special");
    }
    if (za(A))
      return e.stylize(RegExp.prototype.toString.call(A), "regexp");
    if (es(A))
      return e.stylize(Date.prototype.toString.call(A), "date");
    if (Vo(A))
      return Cd(A);
  }
  var s = "", l = !1, u = ["{", "}"];
  if (aE(A) && (l = !0, u = ["[", "]"]), ja(A)) {
    var g = A.name ? ": " + A.name : "";
    s = " [Function" + g + "]";
  }
  if (za(A) && (s = " " + RegExp.prototype.toString.call(A)), es(A) && (s = " " + Date.prototype.toUTCString.call(A)), Vo(A) && (s = " " + Cd(A)), i.length === 0 && (!l || A.length == 0))
    return u[0] + s + u[1];
  if (t < 0)
    return za(A) ? e.stylize(RegExp.prototype.toString.call(A), "regexp") : e.stylize("[Object]", "special");
  e.seen.push(A);
  var d;
  return l ? d = qj(e, A, t, a, i) : d = i.map(function(h) {
    return Uh(e, A, t, a, h, l);
  }), e.seen.pop(), $j(d, s, u);
}
function Xj(e, A) {
  if (b0(A))
    return e.stylize("undefined", "undefined");
  if (Xl(A)) {
    var t = "'" + JSON.stringify(A).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
    return e.stylize(t, "string");
  }
  if (oE(A))
    return e.stylize("" + A, "number");
  if (gB(A))
    return e.stylize("" + A, "boolean");
  if (_l(A))
    return e.stylize("null", "null");
}
function Cd(e) {
  return "[" + Error.prototype.toString.call(e) + "]";
}
function qj(e, A, t, r, n) {
  for (var i = [], a = 0, o = A.length; a < o; ++a)
    Jp(A, String(a)) ? i.push(Uh(
      e,
      A,
      t,
      r,
      String(a),
      !0
    )) : i.push("");
  return n.forEach(function(s) {
    s.match(/^\d+$/) || i.push(Uh(
      e,
      A,
      t,
      r,
      s,
      !0
    ));
  }), i;
}
function Uh(e, A, t, r, n, i) {
  var a, o, s;
  if (s = Object.getOwnPropertyDescriptor(A, n) || { value: A[n] }, s.get ? s.set ? o = e.stylize("[Getter/Setter]", "special") : o = e.stylize("[Getter]", "special") : s.set && (o = e.stylize("[Setter]", "special")), Jp(r, n) || (a = "[" + n + "]"), o || (e.seen.indexOf(s.value) < 0 ? (_l(t) ? o = hg(e, s.value, null) : o = hg(e, s.value, t - 1), o.indexOf(`
`) > -1 && (i ? o = o.split(`
`).map(function(l) {
    return "  " + l;
  }).join(`
`).substr(2) : o = `
` + o.split(`
`).map(function(l) {
    return "   " + l;
  }).join(`
`))) : o = e.stylize("[Circular]", "special")), b0(a)) {
    if (i && n.match(/^\d+$/))
      return o;
    a = JSON.stringify("" + n), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
  }
  return a + ": " + o;
}
function $j(e, A, t) {
  var r = e.reduce(function(n, i) {
    return i.indexOf(`
`) >= 0, n + i.replace(/\u001b\[\d\d?m/g, "").length + 1;
  }, 0);
  return r > 60 ? t[0] + (A === "" ? "" : A + `
 `) + " " + e.join(`,
  `) + " " + t[1] : t[0] + A + " " + e.join(", ") + " " + t[1];
}
function aE(e) {
  return Array.isArray(e);
}
function gB(e) {
  return typeof e == "boolean";
}
function _l(e) {
  return e === null;
}
function zp(e) {
  return e == null;
}
function oE(e) {
  return typeof e == "number";
}
function Xl(e) {
  return typeof e == "string";
}
function jp(e) {
  return typeof e == "symbol";
}
function b0(e) {
  return e === void 0;
}
function za(e) {
  return ao(e) && sE(e) === "[object RegExp]";
}
function ao(e) {
  return typeof e == "object" && e !== null;
}
function es(e) {
  return ao(e) && sE(e) === "[object Date]";
}
function Vo(e) {
  return ao(e) && (sE(e) === "[object Error]" || e instanceof Error);
}
function ja(e) {
  return typeof e == "function";
}
function Cg(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
  typeof e > "u";
}
function Vp(e) {
  return LA.isBuffer(e);
}
function sE(e) {
  return Object.prototype.toString.call(e);
}
function Ed(e) {
  return e < 10 ? "0" + e.toString(10) : e.toString(10);
}
var AV = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function eV() {
  var e = /* @__PURE__ */ new Date(), A = [
    Ed(e.getHours()),
    Ed(e.getMinutes()),
    Ed(e.getSeconds())
  ].join(":");
  return [e.getDate(), AV[e.getMonth()], A].join(" ");
}
function Op() {
  console.log("%s - %s", eV(), cB.apply(null, arguments));
}
function lE(e, A) {
  if (!A || !ao(A)) return e;
  for (var t = Object.keys(A), r = t.length; r--; )
    e[t[r]] = A[t[r]];
  return e;
}
function Jp(e, A) {
  return Object.prototype.hasOwnProperty.call(e, A);
}
var pa = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function uE(e) {
  if (typeof e != "function")
    throw new TypeError('The "original" argument must be of type Function');
  if (pa && e[pa]) {
    var A = e[pa];
    if (typeof A != "function")
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    return Object.defineProperty(A, pa, {
      value: A,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), A;
  }
  function A() {
    for (var t, r, n = new Promise(function(o, s) {
      t = o, r = s;
    }), i = [], a = 0; a < arguments.length; a++)
      i.push(arguments[a]);
    i.push(function(o, s) {
      o ? r(o) : t(s);
    });
    try {
      e.apply(this, i);
    } catch (o) {
      r(o);
    }
    return n;
  }
  return Object.setPrototypeOf(A, Object.getPrototypeOf(e)), pa && Object.defineProperty(A, pa, {
    value: A,
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), Object.defineProperties(
    A,
    Tp(e)
  );
}
uE.custom = pa;
function tV(e, A) {
  if (!e) {
    var t = new Error("Promise was rejected with a falsy value");
    t.reason = e, e = t;
  }
  return A(e);
}
function Wp(e) {
  if (typeof e != "function")
    throw new TypeError('The "original" argument must be of type Function');
  function A() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t.push(arguments[r]);
    var n = t.pop();
    if (typeof n != "function")
      throw new TypeError("The last argument must be of type Function");
    var i = this, a = function() {
      return n.apply(i, arguments);
    };
    e.apply(this, t).then(
      function(o) {
        ot.nextTick(a.bind(null, null, o));
      },
      function(o) {
        ot.nextTick(tV.bind(null, o, a));
      }
    );
  }
  return Object.setPrototypeOf(A, Object.getPrototypeOf(e)), Object.defineProperties(A, Tp(e)), A;
}
var rV = {
  inherits: nE,
  _extend: lE,
  log: Op,
  isBuffer: Vp,
  isPrimitive: Cg,
  isFunction: ja,
  isError: Vo,
  isDate: es,
  isObject: ao,
  isRegExp: za,
  isUndefined: b0,
  isSymbol: jp,
  isString: Xl,
  isNumber: oE,
  isNullOrUndefined: zp,
  isNull: _l,
  isBoolean: gB,
  isArray: aE,
  inspect: Wn,
  deprecate: iE,
  format: cB,
  debuglog: Pp,
  promisify: uE,
  callbackify: Wp
}, nV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _extend: lE,
  callbackify: Wp,
  debuglog: Pp,
  default: rV,
  deprecate: iE,
  format: cB,
  inherits: nE,
  inspect: Wn,
  isArray: aE,
  isBoolean: gB,
  isBuffer: Vp,
  isDate: es,
  isError: Vo,
  isFunction: ja,
  isNull: _l,
  isNullOrUndefined: zp,
  isNumber: oE,
  isObject: ao,
  isPrimitive: Cg,
  isRegExp: za,
  isString: Xl,
  isSymbol: jp,
  isUndefined: b0,
  log: Op,
  promisify: uE
}), cE = /* @__PURE__ */ Bs(nV), Qd, V5;
function iV() {
  if (V5) return Qd;
  V5 = 1;
  function e(d, h) {
    var C = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var E = Object.getOwnPropertySymbols(d);
      h && (E = E.filter(function(I) {
        return Object.getOwnPropertyDescriptor(d, I).enumerable;
      })), C.push.apply(C, E);
    }
    return C;
  }
  function A(d) {
    for (var h = 1; h < arguments.length; h++) {
      var C = arguments[h] != null ? arguments[h] : {};
      h % 2 ? e(Object(C), !0).forEach(function(E) {
        t(d, E, C[E]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(C)) : e(Object(C)).forEach(function(E) {
        Object.defineProperty(d, E, Object.getOwnPropertyDescriptor(C, E));
      });
    }
    return d;
  }
  function t(d, h, C) {
    return h in d ? Object.defineProperty(d, h, {
      value: C,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : d[h] = C, d;
  }
  function r(d, h) {
    if (!(d instanceof h))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(d, h) {
    for (var C = 0; C < h.length; C++) {
      var E = h[C];
      E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(d, E.key, E);
    }
  }
  function i(d, h, C) {
    return h && n(d.prototype, h), d;
  }
  var a = Ml, o = a.Buffer, s = cE, l = s.inspect, u = l && l.custom || "inspect";
  function g(d, h, C) {
    o.prototype.copy.call(d, h, C);
  }
  return Qd = /* @__PURE__ */ function() {
    function d() {
      r(this, d), this.head = null, this.tail = null, this.length = 0;
    }
    return i(d, [{
      key: "push",
      value: function(C) {
        var E = {
          data: C,
          next: null
        };
        this.length > 0 ? this.tail.next = E : this.head = E, this.tail = E, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(C) {
        var E = {
          data: C,
          next: this.head
        };
        this.length === 0 && (this.tail = E), this.head = E, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var C = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, C;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(C) {
        if (this.length === 0) return "";
        for (var E = this.head, I = "" + E.data; E = E.next; )
          I += C + E.data;
        return I;
      }
    }, {
      key: "concat",
      value: function(C) {
        if (this.length === 0) return o.alloc(0);
        for (var E = o.allocUnsafe(C >>> 0), I = this.head, b = 0; I; )
          g(I.data, E, b), b += I.data.length, I = I.next;
        return E;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(C, E) {
        var I;
        return C < this.head.data.length ? (I = this.head.data.slice(0, C), this.head.data = this.head.data.slice(C)) : C === this.head.data.length ? I = this.shift() : I = E ? this._getString(C) : this._getBuffer(C), I;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(C) {
        var E = this.head, I = 1, b = E.data;
        for (C -= b.length; E = E.next; ) {
          var y = E.data, p = C > y.length ? y.length : C;
          if (p === y.length ? b += y : b += y.slice(0, C), C -= p, C === 0) {
            p === y.length ? (++I, E.next ? this.head = E.next : this.head = this.tail = null) : (this.head = E, E.data = y.slice(p));
            break;
          }
          ++I;
        }
        return this.length -= I, b;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(C) {
        var E = o.allocUnsafe(C), I = this.head, b = 1;
        for (I.data.copy(E), C -= I.data.length; I = I.next; ) {
          var y = I.data, p = C > y.length ? y.length : C;
          if (y.copy(E, E.length - C, 0, p), C -= p, C === 0) {
            p === y.length ? (++b, I.next ? this.head = I.next : this.head = this.tail = null) : (this.head = I, I.data = y.slice(p));
            break;
          }
          ++b;
        }
        return this.length -= b, E;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: u,
      value: function(C, E) {
        return l(this, A({}, E, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), d;
  }(), Qd;
}
function aV(e, A) {
  var t = this, r = this._readableState && this._readableState.destroyed, n = this._writableState && this._writableState.destroyed;
  return r || n ? (A ? A(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, ot.nextTick(Yh, this, e)) : ot.nextTick(Yh, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(i) {
    !A && i ? t._writableState ? t._writableState.errorEmitted ? ot.nextTick(Fc, t) : (t._writableState.errorEmitted = !0, ot.nextTick(O5, t, i)) : ot.nextTick(O5, t, i) : A ? (ot.nextTick(Fc, t), A(i)) : ot.nextTick(Fc, t);
  }), this);
}
function O5(e, A) {
  Yh(e, A), Fc(e);
}
function Fc(e) {
  e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
}
function oV() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function Yh(e, A) {
  e.emit("error", A);
}
function sV(e, A) {
  var t = e._readableState, r = e._writableState;
  t && t.autoDestroy || r && r.autoDestroy ? e.destroy(A) : e.emit("error", A);
}
var Zp = {
  destroy: aV,
  undestroy: oV,
  errorOrDestroy: sV
}, oo = {};
function lV(e, A) {
  e.prototype = Object.create(A.prototype), e.prototype.constructor = e, e.__proto__ = A;
}
var Kp = {};
function Un(e, A, t) {
  t || (t = Error);
  function r(i, a, o) {
    return typeof A == "string" ? A : A(i, a, o);
  }
  var n = /* @__PURE__ */ function(i) {
    lV(a, i);
    function a(o, s, l) {
      return i.call(this, r(o, s, l)) || this;
    }
    return a;
  }(t);
  n.prototype.name = t.name, n.prototype.code = e, Kp[e] = n;
}
function J5(e, A) {
  if (Array.isArray(e)) {
    var t = e.length;
    return e = e.map(function(r) {
      return String(r);
    }), t > 2 ? "one of ".concat(A, " ").concat(e.slice(0, t - 1).join(", "), ", or ") + e[t - 1] : t === 2 ? "one of ".concat(A, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(A, " ").concat(e[0]);
  } else
    return "of ".concat(A, " ").concat(String(e));
}
function uV(e, A, t) {
  return e.substr(0, A.length) === A;
}
function cV(e, A, t) {
  return (t === void 0 || t > e.length) && (t = e.length), e.substring(t - A.length, t) === A;
}
function gV(e, A, t) {
  return typeof t != "number" && (t = 0), t + A.length > e.length ? !1 : e.indexOf(A, t) !== -1;
}
Un("ERR_INVALID_OPT_VALUE", function(e, A) {
  return 'The value "' + A + '" is invalid for option "' + e + '"';
}, TypeError);
Un("ERR_INVALID_ARG_TYPE", function(e, A, t) {
  var r;
  typeof A == "string" && uV(A, "not ") ? (r = "must not be", A = A.replace(/^not /, "")) : r = "must be";
  var n;
  if (cV(e, " argument"))
    n = "The ".concat(e, " ").concat(r, " ").concat(J5(A, "type"));
  else {
    var i = gV(e, ".") ? "property" : "argument";
    n = 'The "'.concat(e, '" ').concat(i, " ").concat(r, " ").concat(J5(A, "type"));
  }
  return n += ". Received type ".concat(typeof t), n;
}, TypeError);
Un("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
Un("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
  return "The " + e + " method is not implemented";
});
Un("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
Un("ERR_STREAM_DESTROYED", function(e) {
  return "Cannot call " + e + " after a stream was destroyed";
});
Un("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
Un("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
Un("ERR_STREAM_WRITE_AFTER_END", "write after end");
Un("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
Un("ERR_UNKNOWN_ENCODING", function(e) {
  return "Unknown encoding: " + e;
}, TypeError);
Un("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
oo.codes = Kp;
var BV = oo.codes.ERR_INVALID_OPT_VALUE;
function fV(e, A, t) {
  return e.highWaterMark != null ? e.highWaterMark : A ? e[t] : null;
}
function dV(e, A, t, r) {
  var n = fV(A, r, t);
  if (n != null) {
    if (!(isFinite(n) && Math.floor(n) === n) || n < 0) {
      var i = r ? t : "highWaterMark";
      throw new BV(i, n);
    }
    return Math.floor(n);
  }
  return e.objectMode ? 16 : 16 * 1024;
}
var _p = {
  getHighWaterMark: dV
}, Hh;
typeof Object.create == "function" ? Hh = function(A, t) {
  A.super_ = t, A.prototype = Object.create(t.prototype, {
    constructor: {
      value: A,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : Hh = function(A, t) {
  A.super_ = t;
  var r = function() {
  };
  r.prototype = t.prototype, A.prototype = new r(), A.prototype.constructor = A;
};
var hV = Hh, CV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hV
}), ql = /* @__PURE__ */ Bs(CV), EV = LA.isEncoding || function(e) {
  switch (e && e.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function QV(e) {
  if (e && !EV(e))
    throw new Error("Unknown encoding: " + e);
}
function BB(e) {
  switch (this.encoding = (e || "utf8").toLowerCase().replace(/[-_]/, ""), QV(e), this.encoding) {
    case "utf8":
      this.surrogateSize = 3;
      break;
    case "ucs2":
    case "utf16le":
      this.surrogateSize = 2, this.detectIncompleteChar = IV;
      break;
    case "base64":
      this.surrogateSize = 3, this.detectIncompleteChar = DV;
      break;
    default:
      this.write = wV;
      return;
  }
  this.charBuffer = new LA(6), this.charReceived = 0, this.charLength = 0;
}
BB.prototype.write = function(e) {
  for (var A = ""; this.charLength; ) {
    var t = e.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : e.length;
    if (e.copy(this.charBuffer, this.charReceived, 0, t), this.charReceived += t, this.charReceived < this.charLength)
      return "";
    e = e.slice(t, e.length), A = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
    var n = A.charCodeAt(A.length - 1);
    if (n >= 55296 && n <= 56319) {
      this.charLength += this.surrogateSize, A = "";
      continue;
    }
    if (this.charReceived = this.charLength = 0, e.length === 0)
      return A;
    break;
  }
  this.detectIncompleteChar(e);
  var r = e.length;
  this.charLength && (e.copy(this.charBuffer, 0, e.length - this.charReceived, r), r -= this.charReceived), A += e.toString(this.encoding, 0, r);
  var r = A.length - 1, n = A.charCodeAt(r);
  if (n >= 55296 && n <= 56319) {
    var i = this.surrogateSize;
    return this.charLength += i, this.charReceived += i, this.charBuffer.copy(this.charBuffer, i, 0, i), e.copy(this.charBuffer, 0, 0, i), A.substring(0, r);
  }
  return A;
};
BB.prototype.detectIncompleteChar = function(e) {
  for (var A = e.length >= 3 ? 3 : e.length; A > 0; A--) {
    var t = e[e.length - A];
    if (A == 1 && t >> 5 == 6) {
      this.charLength = 2;
      break;
    }
    if (A <= 2 && t >> 4 == 14) {
      this.charLength = 3;
      break;
    }
    if (A <= 3 && t >> 3 == 30) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = A;
};
BB.prototype.end = function(e) {
  var A = "";
  if (e && e.length && (A = this.write(e)), this.charReceived) {
    var t = this.charReceived, r = this.charBuffer, n = this.encoding;
    A += r.slice(0, t).toString(n);
  }
  return A;
};
function wV(e) {
  return e.toString(this.encoding);
}
function IV(e) {
  this.charReceived = e.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function DV(e) {
  this.charReceived = e.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
var mV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  StringDecoder: BB
}), Xp = /* @__PURE__ */ Bs(mV), W5 = oo.codes.ERR_STREAM_PREMATURE_CLOSE;
function MV(e) {
  var A = !1;
  return function() {
    if (!A) {
      A = !0;
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
        r[n] = arguments[n];
      e.apply(this, r);
    }
  };
}
function pV() {
}
function vV(e) {
  return e.setHeader && typeof e.abort == "function";
}
function qp(e, A, t) {
  if (typeof A == "function") return qp(e, null, A);
  A || (A = {}), t = MV(t || pV);
  var r = A.readable || A.readable !== !1 && e.readable, n = A.writable || A.writable !== !1 && e.writable, i = function() {
    e.writable || o();
  }, a = e._writableState && e._writableState.finished, o = function() {
    n = !1, a = !0, r || t.call(e);
  }, s = e._readableState && e._readableState.endEmitted, l = function() {
    r = !1, s = !0, n || t.call(e);
  }, u = function(C) {
    t.call(e, C);
  }, g = function() {
    var C;
    if (r && !s)
      return (!e._readableState || !e._readableState.ended) && (C = new W5()), t.call(e, C);
    if (n && !a)
      return (!e._writableState || !e._writableState.ended) && (C = new W5()), t.call(e, C);
  }, d = function() {
    e.req.on("finish", o);
  };
  return vV(e) ? (e.on("complete", o), e.on("abort", g), e.req ? d() : e.on("request", d)) : n && !e._writableState && (e.on("end", i), e.on("close", i)), e.on("end", l), e.on("finish", o), A.error !== !1 && e.on("error", u), e.on("close", g), function() {
    e.removeListener("complete", o), e.removeListener("abort", g), e.removeListener("request", d), e.req && e.req.removeListener("finish", o), e.removeListener("end", i), e.removeListener("close", i), e.removeListener("finish", o), e.removeListener("end", l), e.removeListener("error", u), e.removeListener("close", g);
  };
}
var gE = qp, wd, Z5;
function yV() {
  if (Z5) return wd;
  Z5 = 1;
  var e;
  function A(b, y, p) {
    return y in b ? Object.defineProperty(b, y, {
      value: p,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : b[y] = p, b;
  }
  var t = gE, r = Symbol("lastResolve"), n = Symbol("lastReject"), i = Symbol("error"), a = Symbol("ended"), o = Symbol("lastPromise"), s = Symbol("handlePromise"), l = Symbol("stream");
  function u(b, y) {
    return {
      value: b,
      done: y
    };
  }
  function g(b) {
    var y = b[r];
    if (y !== null) {
      var p = b[l].read();
      p !== null && (b[o] = null, b[r] = null, b[n] = null, y(u(p, !1)));
    }
  }
  function d(b) {
    ot.nextTick(g, b);
  }
  function h(b, y) {
    return function(p, Q) {
      b.then(function() {
        if (y[a]) {
          p(u(void 0, !0));
          return;
        }
        y[s](p, Q);
      }, Q);
    };
  }
  var C = Object.getPrototypeOf(function() {
  }), E = Object.setPrototypeOf((e = {
    get stream() {
      return this[l];
    },
    next: function() {
      var y = this, p = this[i];
      if (p !== null)
        return Promise.reject(p);
      if (this[a])
        return Promise.resolve(u(void 0, !0));
      if (this[l].destroyed)
        return new Promise(function(k, L) {
          ot.nextTick(function() {
            y[i] ? L(y[i]) : k(u(void 0, !0));
          });
        });
      var Q = this[o], w;
      if (Q)
        w = new Promise(h(Q, this));
      else {
        var Y = this[l].read();
        if (Y !== null)
          return Promise.resolve(u(Y, !1));
        w = new Promise(this[s]);
      }
      return this[o] = w, w;
    }
  }, A(e, Symbol.asyncIterator, function() {
    return this;
  }), A(e, "return", function() {
    var y = this;
    return new Promise(function(p, Q) {
      y[l].destroy(null, function(w) {
        if (w) {
          Q(w);
          return;
        }
        p(u(void 0, !0));
      });
    });
  }), e), C), I = function(y) {
    var p, Q = Object.create(E, (p = {}, A(p, l, {
      value: y,
      writable: !0
    }), A(p, r, {
      value: null,
      writable: !0
    }), A(p, n, {
      value: null,
      writable: !0
    }), A(p, i, {
      value: null,
      writable: !0
    }), A(p, a, {
      value: y._readableState.endEmitted,
      writable: !0
    }), A(p, s, {
      value: function(Y, k) {
        var L = Q[l].read();
        L ? (Q[o] = null, Q[r] = null, Q[n] = null, Y(u(L, !1))) : (Q[r] = Y, Q[n] = k);
      },
      writable: !0
    }), p));
    return Q[o] = null, t(y, function(w) {
      if (w && w.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Y = Q[n];
        Y !== null && (Q[o] = null, Q[r] = null, Q[n] = null, Y(w)), Q[i] = w;
        return;
      }
      var k = Q[r];
      k !== null && (Q[o] = null, Q[r] = null, Q[n] = null, k(u(void 0, !0))), Q[a] = !0;
    }), y.on("readable", d.bind(null, Q)), Q;
  };
  return wd = I, wd;
}
var Id, K5;
function bV() {
  return K5 || (K5 = 1, Id = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Id;
}
const BE = fs;
BE.Readable = Qt;
Qt.ReadableState = Av;
Sp.EventEmitter;
var $p = function(A, t) {
  return A.listeners(t).length;
}, $l = Np, fB = Ml.Buffer, FV = dg.Uint8Array || function() {
};
function LV(e) {
  return fB.from(e);
}
function RV(e) {
  return fB.isBuffer(e) || e instanceof FV;
}
var Dd = cE, at;
Dd && Dd.debuglog ? at = Dd.debuglog("stream") : at = function() {
};
var GV = iV(), fE = Zp, xV = _p, kV = xV.getHighWaterMark, dB = oo.codes, UV = dB.ERR_INVALID_ARG_TYPE, YV = dB.ERR_STREAM_PUSH_AFTER_EOF, HV = dB.ERR_METHOD_NOT_IMPLEMENTED, SV = dB.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Oo, md, Md;
ql(Qt, $l);
var ol = fE.errorOrDestroy, pd = ["error", "close", "destroy", "pause", "resume"];
function NV(e, A, t) {
  if (typeof e.prependListener == "function") return e.prependListener(A, t);
  !e._events || !e._events[A] ? e.on(A, t) : Array.isArray(e._events[A]) ? e._events[A].unshift(t) : e._events[A] = [t, e._events[A]];
}
function Av(e, A, t) {
  e = e || {}, typeof t != "boolean" && (t = A instanceof BE.Duplex), this.objectMode = !!e.objectMode, t && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = kV(this, e, "readableHighWaterMark", t), this.buffer = new GV(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (Oo || (Oo = Xp.StringDecoder), this.decoder = new Oo(e.encoding), this.encoding = e.encoding);
}
function Qt(e) {
  if (!(this instanceof Qt)) return new Qt(e);
  var A = this instanceof BE.Duplex;
  this._readableState = new Av(e, this, A), this.readable = !0, e && (typeof e.read == "function" && (this._read = e.read), typeof e.destroy == "function" && (this._destroy = e.destroy)), $l.call(this);
}
Object.defineProperty(Qt.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 ? !1 : this._readableState.destroyed;
  },
  set: function(A) {
    this._readableState && (this._readableState.destroyed = A);
  }
});
Qt.prototype.destroy = fE.destroy;
Qt.prototype._undestroy = fE.undestroy;
Qt.prototype._destroy = function(e, A) {
  A(e);
};
Qt.prototype.push = function(e, A) {
  var t = this._readableState, r;
  return t.objectMode ? r = !0 : typeof e == "string" && (A = A || t.defaultEncoding, A !== t.encoding && (e = fB.from(e, A), A = ""), r = !0), ev(this, e, A, !1, r);
};
Qt.prototype.unshift = function(e) {
  return ev(this, e, null, !0, !1);
};
function ev(e, A, t, r, n) {
  at("readableAddChunk", A);
  var i = e._readableState;
  if (A === null)
    i.reading = !1, zV(e, i);
  else {
    var a;
    if (n || (a = TV(i, A)), a)
      ol(e, a);
    else if (i.objectMode || A && A.length > 0)
      if (typeof A != "string" && !i.objectMode && Object.getPrototypeOf(A) !== fB.prototype && (A = LV(A)), r)
        i.endEmitted ? ol(e, new SV()) : vd(e, i, A, !0);
      else if (i.ended)
        ol(e, new YV());
      else {
        if (i.destroyed)
          return !1;
        i.reading = !1, i.decoder && !t ? (A = i.decoder.write(A), i.objectMode || A.length !== 0 ? vd(e, i, A, !1) : Sh(e, i)) : vd(e, i, A, !1);
      }
    else r || (i.reading = !1, Sh(e, i));
  }
  return !i.ended && (i.length < i.highWaterMark || i.length === 0);
}
function vd(e, A, t, r) {
  A.flowing && A.length === 0 && !A.sync ? (A.awaitDrain = 0, e.emit("data", t)) : (A.length += A.objectMode ? 1 : t.length, r ? A.buffer.unshift(t) : A.buffer.push(t), A.needReadable && hB(e)), Sh(e, A);
}
function TV(e, A) {
  var t;
  return !RV(A) && typeof A != "string" && A !== void 0 && !e.objectMode && (t = new UV("chunk", ["string", "Buffer", "Uint8Array"], A)), t;
}
Qt.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
Qt.prototype.setEncoding = function(e) {
  Oo || (Oo = Xp.StringDecoder);
  var A = new Oo(e);
  this._readableState.decoder = A, this._readableState.encoding = this._readableState.decoder.encoding;
  for (var t = this._readableState.buffer.head, r = ""; t !== null; )
    r += A.write(t.data), t = t.next;
  return this._readableState.buffer.clear(), r !== "" && this._readableState.buffer.push(r), this._readableState.length = r.length, this;
};
var _5 = 1073741824;
function PV(e) {
  return e >= _5 ? e = _5 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
}
function X5(e, A) {
  return e <= 0 || A.length === 0 && A.ended ? 0 : A.objectMode ? 1 : e !== e ? A.flowing && A.length ? A.buffer.head.data.length : A.length : (e > A.highWaterMark && (A.highWaterMark = PV(e)), e <= A.length ? e : A.ended ? A.length : (A.needReadable = !0, 0));
}
Qt.prototype.read = function(e) {
  at("read", e), e = parseInt(e, 10);
  var A = this._readableState, t = e;
  if (e !== 0 && (A.emittedReadable = !1), e === 0 && A.needReadable && ((A.highWaterMark !== 0 ? A.length >= A.highWaterMark : A.length > 0) || A.ended))
    return at("read: emitReadable", A.length, A.ended), A.length === 0 && A.ended ? yd(this) : hB(this), null;
  if (e = X5(e, A), e === 0 && A.ended)
    return A.length === 0 && yd(this), null;
  var r = A.needReadable;
  at("need readable", r), (A.length === 0 || A.length - e < A.highWaterMark) && (r = !0, at("length less than watermark", r)), A.ended || A.reading ? (r = !1, at("reading or ended", r)) : r && (at("do read"), A.reading = !0, A.sync = !0, A.length === 0 && (A.needReadable = !0), this._read(A.highWaterMark), A.sync = !1, A.reading || (e = X5(t, A)));
  var n;
  return e > 0 ? n = nv(e, A) : n = null, n === null ? (A.needReadable = A.length <= A.highWaterMark, e = 0) : (A.length -= e, A.awaitDrain = 0), A.length === 0 && (A.ended || (A.needReadable = !0), t !== e && A.ended && yd(this)), n !== null && this.emit("data", n), n;
};
function zV(e, A) {
  if (at("onEofChunk"), !A.ended) {
    if (A.decoder) {
      var t = A.decoder.end();
      t && t.length && (A.buffer.push(t), A.length += A.objectMode ? 1 : t.length);
    }
    A.ended = !0, A.sync ? hB(e) : (A.needReadable = !1, A.emittedReadable || (A.emittedReadable = !0, tv(e)));
  }
}
function hB(e) {
  var A = e._readableState;
  at("emitReadable", A.needReadable, A.emittedReadable), A.needReadable = !1, A.emittedReadable || (at("emitReadable", A.flowing), A.emittedReadable = !0, ot.nextTick(tv, e));
}
function tv(e) {
  var A = e._readableState;
  at("emitReadable_", A.destroyed, A.length, A.ended), !A.destroyed && (A.length || A.ended) && (e.emit("readable"), A.emittedReadable = !1), A.needReadable = !A.flowing && !A.ended && A.length <= A.highWaterMark, dE(e);
}
function Sh(e, A) {
  A.readingMore || (A.readingMore = !0, ot.nextTick(jV, e, A));
}
function jV(e, A) {
  for (; !A.reading && !A.ended && (A.length < A.highWaterMark || A.flowing && A.length === 0); ) {
    var t = A.length;
    if (at("maybeReadMore read 0"), e.read(0), t === A.length)
      break;
  }
  A.readingMore = !1;
}
Qt.prototype._read = function(e) {
  ol(this, new HV("_read()"));
};
Qt.prototype.pipe = function(e, A) {
  var t = this, r = this._readableState;
  switch (r.pipesCount) {
    case 0:
      r.pipes = e;
      break;
    case 1:
      r.pipes = [r.pipes, e];
      break;
    default:
      r.pipes.push(e);
      break;
  }
  r.pipesCount += 1, at("pipe count=%d opts=%j", r.pipesCount, A);
  var n = (!A || A.end !== !1) && e !== ot.stdout && e !== ot.stderr, i = n ? o : E;
  r.endEmitted ? ot.nextTick(i) : t.once("end", i), e.on("unpipe", a);
  function a(I, b) {
    at("onunpipe"), I === t && b && b.hasUnpiped === !1 && (b.hasUnpiped = !0, u());
  }
  function o() {
    at("onend"), e.end();
  }
  var s = VV(t);
  e.on("drain", s);
  var l = !1;
  function u() {
    at("cleanup"), e.removeListener("close", h), e.removeListener("finish", C), e.removeListener("drain", s), e.removeListener("error", d), e.removeListener("unpipe", a), t.removeListener("end", o), t.removeListener("end", E), t.removeListener("data", g), l = !0, r.awaitDrain && (!e._writableState || e._writableState.needDrain) && s();
  }
  t.on("data", g);
  function g(I) {
    at("ondata");
    var b = e.write(I);
    at("dest.write", b), b === !1 && ((r.pipesCount === 1 && r.pipes === e || r.pipesCount > 1 && iv(r.pipes, e) !== -1) && !l && (at("false write response, pause", r.awaitDrain), r.awaitDrain++), t.pause());
  }
  function d(I) {
    at("onerror", I), E(), e.removeListener("error", d), $p(e, "error") === 0 && ol(e, I);
  }
  NV(e, "error", d);
  function h() {
    e.removeListener("finish", C), E();
  }
  e.once("close", h);
  function C() {
    at("onfinish"), e.removeListener("close", h), E();
  }
  e.once("finish", C);
  function E() {
    at("unpipe"), t.unpipe(e);
  }
  return e.emit("pipe", t), r.flowing || (at("pipe resume"), t.resume()), e;
};
function VV(e) {
  return function() {
    var t = e._readableState;
    at("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, t.awaitDrain === 0 && $p(e, "data") && (t.flowing = !0, dE(e));
  };
}
Qt.prototype.unpipe = function(e) {
  var A = this._readableState, t = {
    hasUnpiped: !1
  };
  if (A.pipesCount === 0) return this;
  if (A.pipesCount === 1)
    return e && e !== A.pipes ? this : (e || (e = A.pipes), A.pipes = null, A.pipesCount = 0, A.flowing = !1, e && e.emit("unpipe", this, t), this);
  if (!e) {
    var r = A.pipes, n = A.pipesCount;
    A.pipes = null, A.pipesCount = 0, A.flowing = !1;
    for (var i = 0; i < n; i++)
      r[i].emit("unpipe", this, {
        hasUnpiped: !1
      });
    return this;
  }
  var a = iv(A.pipes, e);
  return a === -1 ? this : (A.pipes.splice(a, 1), A.pipesCount -= 1, A.pipesCount === 1 && (A.pipes = A.pipes[0]), e.emit("unpipe", this, t), this);
};
Qt.prototype.on = function(e, A) {
  var t = $l.prototype.on.call(this, e, A), r = this._readableState;
  return e === "data" ? (r.readableListening = this.listenerCount("readable") > 0, r.flowing !== !1 && this.resume()) : e === "readable" && !r.endEmitted && !r.readableListening && (r.readableListening = r.needReadable = !0, r.flowing = !1, r.emittedReadable = !1, at("on readable", r.length, r.reading), r.length ? hB(this) : r.reading || ot.nextTick(OV, this)), t;
};
Qt.prototype.addListener = Qt.prototype.on;
Qt.prototype.removeListener = function(e, A) {
  var t = $l.prototype.removeListener.call(this, e, A);
  return e === "readable" && ot.nextTick(rv, this), t;
};
Qt.prototype.removeAllListeners = function(e) {
  var A = $l.prototype.removeAllListeners.apply(this, arguments);
  return (e === "readable" || e === void 0) && ot.nextTick(rv, this), A;
};
function rv(e) {
  var A = e._readableState;
  A.readableListening = e.listenerCount("readable") > 0, A.resumeScheduled && !A.paused ? A.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
}
function OV(e) {
  at("readable nexttick read 0"), e.read(0);
}
Qt.prototype.resume = function() {
  var e = this._readableState;
  return e.flowing || (at("resume"), e.flowing = !e.readableListening, JV(this, e)), e.paused = !1, this;
};
function JV(e, A) {
  A.resumeScheduled || (A.resumeScheduled = !0, ot.nextTick(WV, e, A));
}
function WV(e, A) {
  at("resume", A.reading), A.reading || e.read(0), A.resumeScheduled = !1, e.emit("resume"), dE(e), A.flowing && !A.reading && e.read(0);
}
Qt.prototype.pause = function() {
  return at("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (at("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
};
function dE(e) {
  var A = e._readableState;
  for (at("flow", A.flowing); A.flowing && e.read() !== null; )
    ;
}
Qt.prototype.wrap = function(e) {
  var A = this, t = this._readableState, r = !1;
  e.on("end", function() {
    if (at("wrapped end"), t.decoder && !t.ended) {
      var a = t.decoder.end();
      a && a.length && A.push(a);
    }
    A.push(null);
  }), e.on("data", function(a) {
    if (at("wrapped data"), t.decoder && (a = t.decoder.write(a)), !(t.objectMode && a == null) && !(!t.objectMode && (!a || !a.length))) {
      var o = A.push(a);
      o || (r = !0, e.pause());
    }
  });
  for (var n in e)
    this[n] === void 0 && typeof e[n] == "function" && (this[n] = /* @__PURE__ */ function(o) {
      return function() {
        return e[o].apply(e, arguments);
      };
    }(n));
  for (var i = 0; i < pd.length; i++)
    e.on(pd[i], this.emit.bind(this, pd[i]));
  return this._read = function(a) {
    at("wrapped _read", a), r && (r = !1, e.resume());
  }, this;
};
typeof Symbol == "function" && (Qt.prototype[Symbol.asyncIterator] = function() {
  return md === void 0 && (md = yV()), md(this);
});
Object.defineProperty(Qt.prototype, "readableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Qt.prototype, "readableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Qt.prototype, "readableFlowing", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.flowing;
  },
  set: function(A) {
    this._readableState && (this._readableState.flowing = A);
  }
});
Qt._fromList = nv;
Object.defineProperty(Qt.prototype, "readableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.length;
  }
});
function nv(e, A) {
  if (A.length === 0) return null;
  var t;
  return A.objectMode ? t = A.buffer.shift() : !e || e >= A.length ? (A.decoder ? t = A.buffer.join("") : A.buffer.length === 1 ? t = A.buffer.first() : t = A.buffer.concat(A.length), A.buffer.clear()) : t = A.buffer.consume(e, A.decoder), t;
}
function yd(e) {
  var A = e._readableState;
  at("endReadable", A.endEmitted), A.endEmitted || (A.ended = !0, ot.nextTick(ZV, A, e));
}
function ZV(e, A) {
  if (at("endReadableNT", e.endEmitted, e.length), !e.endEmitted && e.length === 0 && (e.endEmitted = !0, A.readable = !1, A.emit("end"), e.autoDestroy)) {
    var t = A._writableState;
    (!t || t.autoDestroy && t.finished) && A.destroy();
  }
}
typeof Symbol == "function" && (Qt.from = function(e, A) {
  return Md === void 0 && (Md = bV()), Md(Qt, e, A);
});
function iv(e, A) {
  for (var t = 0, r = e.length; t < r; t++)
    if (e[t] === A) return t;
  return -1;
}
var KV = _V;
function _V(e, A) {
  if (bd("noDeprecation"))
    return e;
  var t = !1;
  function r() {
    if (!t) {
      if (bd("throwDeprecation"))
        throw new Error(A);
      bd("traceDeprecation") ? console.trace(A) : console.warn(A), t = !0;
    }
    return e.apply(this, arguments);
  }
  return r;
}
function bd(e) {
  try {
    if (!dg.localStorage) return !1;
  } catch {
    return !1;
  }
  var A = dg.localStorage[e];
  return A == null ? !1 : String(A).toLowerCase() === "true";
}
const hE = fs;
hE.Writable = $t;
function av(e) {
  var A = this;
  this.next = null, this.entry = null, this.finish = function() {
    mO(A, e);
  };
}
$t.WritableState = Au;
var XV = {
  deprecate: KV
}, ov = Np, CB = Ml.Buffer, qV = dg.Uint8Array || function() {
};
function $V(e) {
  return CB.from(e);
}
function AO(e) {
  return CB.isBuffer(e) || e instanceof qV;
}
var CE = Zp, eO = _p, tO = eO.getHighWaterMark, Aa = oo.codes, rO = Aa.ERR_INVALID_ARG_TYPE, nO = Aa.ERR_METHOD_NOT_IMPLEMENTED, iO = Aa.ERR_MULTIPLE_CALLBACK, aO = Aa.ERR_STREAM_CANNOT_PIPE, oO = Aa.ERR_STREAM_DESTROYED, sO = Aa.ERR_STREAM_NULL_VALUES, lO = Aa.ERR_STREAM_WRITE_AFTER_END, uO = Aa.ERR_UNKNOWN_ENCODING, ts = CE.errorOrDestroy;
ql($t, ov);
function cO() {
}
function Au(e, A, t) {
  e = e || {}, typeof t != "boolean" && (t = A instanceof hE.Duplex), this.objectMode = !!e.objectMode, t && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = tO(this, e, "writableHighWaterMark", t), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
  var r = e.decodeStrings === !1;
  this.decodeStrings = !r, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(n) {
    EO(A, n);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new av(this);
}
Au.prototype.getBuffer = function() {
  for (var A = this.bufferedRequest, t = []; A; )
    t.push(A), A = A.next;
  return t;
};
(function() {
  try {
    Object.defineProperty(Au.prototype, "buffer", {
      get: XV.deprecate(function() {
        return this.getBuffer();
      }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
    });
  } catch {
  }
})();
var Lc;
typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Lc = Function.prototype[Symbol.hasInstance], Object.defineProperty($t, Symbol.hasInstance, {
  value: function(A) {
    return Lc.call(this, A) ? !0 : this !== $t ? !1 : A && A._writableState instanceof Au;
  }
})) : Lc = function(A) {
  return A instanceof this;
};
function $t(e) {
  var A = this instanceof hE.Duplex;
  if (!A && !Lc.call($t, this)) return new $t(e);
  this._writableState = new Au(e, this, A), this.writable = !0, e && (typeof e.write == "function" && (this._write = e.write), typeof e.writev == "function" && (this._writev = e.writev), typeof e.destroy == "function" && (this._destroy = e.destroy), typeof e.final == "function" && (this._final = e.final)), ov.call(this);
}
$t.prototype.pipe = function() {
  ts(this, new aO());
};
function gO(e, A) {
  var t = new lO();
  ts(e, t), ot.nextTick(A, t);
}
function BO(e, A, t, r) {
  var n;
  return t === null ? n = new sO() : typeof t != "string" && !A.objectMode && (n = new rO("chunk", ["string", "Buffer"], t)), n ? (ts(e, n), ot.nextTick(r, n), !1) : !0;
}
$t.prototype.write = function(e, A, t) {
  var r = this._writableState, n = !1, i = !r.objectMode && AO(e);
  return i && !CB.isBuffer(e) && (e = $V(e)), typeof A == "function" && (t = A, A = null), i ? A = "buffer" : A || (A = r.defaultEncoding), typeof t != "function" && (t = cO), r.ending ? gO(this, t) : (i || BO(this, r, e, t)) && (r.pendingcb++, n = dO(this, r, i, e, A, t)), n;
};
$t.prototype.cork = function() {
  this._writableState.corked++;
};
$t.prototype.uncork = function() {
  var e = this._writableState;
  e.corked && (e.corked--, !e.writing && !e.corked && !e.bufferProcessing && e.bufferedRequest && sv(this, e));
};
$t.prototype.setDefaultEncoding = function(A) {
  if (typeof A == "string" && (A = A.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((A + "").toLowerCase()) > -1)) throw new uO(A);
  return this._writableState.defaultEncoding = A, this;
};
Object.defineProperty($t.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function fO(e, A, t) {
  return !e.objectMode && e.decodeStrings !== !1 && typeof A == "string" && (A = CB.from(A, t)), A;
}
Object.defineProperty($t.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
function dO(e, A, t, r, n, i) {
  if (!t) {
    var a = fO(A, r, n);
    r !== a && (t = !0, n = "buffer", r = a);
  }
  var o = A.objectMode ? 1 : r.length;
  A.length += o;
  var s = A.length < A.highWaterMark;
  if (s || (A.needDrain = !0), A.writing || A.corked) {
    var l = A.lastBufferedRequest;
    A.lastBufferedRequest = {
      chunk: r,
      encoding: n,
      isBuf: t,
      callback: i,
      next: null
    }, l ? l.next = A.lastBufferedRequest : A.bufferedRequest = A.lastBufferedRequest, A.bufferedRequestCount += 1;
  } else
    Nh(e, A, !1, o, r, n, i);
  return s;
}
function Nh(e, A, t, r, n, i, a) {
  A.writelen = r, A.writecb = a, A.writing = !0, A.sync = !0, A.destroyed ? A.onwrite(new oO("write")) : t ? e._writev(n, A.onwrite) : e._write(n, i, A.onwrite), A.sync = !1;
}
function hO(e, A, t, r, n) {
  --A.pendingcb, t ? (ot.nextTick(n, r), ot.nextTick(pl, e, A), e._writableState.errorEmitted = !0, ts(e, r)) : (n(r), e._writableState.errorEmitted = !0, ts(e, r), pl(e, A));
}
function CO(e) {
  e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
}
function EO(e, A) {
  var t = e._writableState, r = t.sync, n = t.writecb;
  if (typeof n != "function") throw new iO();
  if (CO(t), A) hO(e, t, r, A, n);
  else {
    var i = lv(t) || e.destroyed;
    !i && !t.corked && !t.bufferProcessing && t.bufferedRequest && sv(e, t), r ? ot.nextTick(q5, e, t, i, n) : q5(e, t, i, n);
  }
}
function q5(e, A, t, r) {
  t || QO(e, A), A.pendingcb--, r(), pl(e, A);
}
function QO(e, A) {
  A.length === 0 && A.needDrain && (A.needDrain = !1, e.emit("drain"));
}
function sv(e, A) {
  A.bufferProcessing = !0;
  var t = A.bufferedRequest;
  if (e._writev && t && t.next) {
    var r = A.bufferedRequestCount, n = new Array(r), i = A.corkedRequestsFree;
    i.entry = t;
    for (var a = 0, o = !0; t; )
      n[a] = t, t.isBuf || (o = !1), t = t.next, a += 1;
    n.allBuffers = o, Nh(e, A, !0, A.length, n, "", i.finish), A.pendingcb++, A.lastBufferedRequest = null, i.next ? (A.corkedRequestsFree = i.next, i.next = null) : A.corkedRequestsFree = new av(A), A.bufferedRequestCount = 0;
  } else {
    for (; t; ) {
      var s = t.chunk, l = t.encoding, u = t.callback, g = A.objectMode ? 1 : s.length;
      if (Nh(e, A, !1, g, s, l, u), t = t.next, A.bufferedRequestCount--, A.writing)
        break;
    }
    t === null && (A.lastBufferedRequest = null);
  }
  A.bufferedRequest = t, A.bufferProcessing = !1;
}
$t.prototype._write = function(e, A, t) {
  t(new nO("_write()"));
};
$t.prototype._writev = null;
$t.prototype.end = function(e, A, t) {
  var r = this._writableState;
  return typeof e == "function" ? (t = e, e = null, A = null) : typeof A == "function" && (t = A, A = null), e != null && this.write(e, A), r.corked && (r.corked = 1, this.uncork()), r.ending || DO(this, r, t), this;
};
Object.defineProperty($t.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function lv(e) {
  return e.ending && e.length === 0 && e.bufferedRequest === null && !e.finished && !e.writing;
}
function wO(e, A) {
  e._final(function(t) {
    A.pendingcb--, t && ts(e, t), A.prefinished = !0, e.emit("prefinish"), pl(e, A);
  });
}
function IO(e, A) {
  !A.prefinished && !A.finalCalled && (typeof e._final == "function" && !A.destroyed ? (A.pendingcb++, A.finalCalled = !0, ot.nextTick(wO, e, A)) : (A.prefinished = !0, e.emit("prefinish")));
}
function pl(e, A) {
  var t = lv(A);
  if (t && (IO(e, A), A.pendingcb === 0 && (A.finished = !0, e.emit("finish"), A.autoDestroy))) {
    var r = e._readableState;
    (!r || r.autoDestroy && r.endEmitted) && e.destroy();
  }
  return t;
}
function DO(e, A, t) {
  A.ending = !0, pl(e, A), t && (A.finished ? ot.nextTick(t) : e.once("finish", t)), A.ended = !0, e.writable = !1;
}
function mO(e, A, t) {
  var r = e.entry;
  for (e.entry = null; r; ) {
    var n = r.callback;
    A.pendingcb--, n(t), r = r.next;
  }
  A.corkedRequestsFree.next = e;
}
Object.defineProperty($t.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState === void 0 ? !1 : this._writableState.destroyed;
  },
  set: function(A) {
    this._writableState && (this._writableState.destroyed = A);
  }
});
$t.prototype.destroy = CE.destroy;
$t.prototype._undestroy = CE.undestroy;
$t.prototype._destroy = function(e, A) {
  A(e);
};
var MO = Object.keys || function(e) {
  var A = [];
  for (var t in e)
    A.push(t);
  return A;
};
const rs = fs;
rs.Duplex = U0;
ql(U0, rs.Readable);
for (var $5 = MO(rs.Writable.prototype), Fd = 0; Fd < $5.length; Fd++) {
  var Ld = $5[Fd];
  U0.prototype[Ld] || (U0.prototype[Ld] = rs.Writable.prototype[Ld]);
}
function U0(e) {
  if (!(this instanceof U0)) return new U0(e);
  rs.Readable.call(this, e), rs.Writable.call(this, e), this.allowHalfOpen = !0, e && (e.readable === !1 && (this.readable = !1), e.writable === !1 && (this.writable = !1), e.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", pO)));
}
Object.defineProperty(U0.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(U0.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(U0.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function pO() {
  this._writableState.ended || ot.nextTick(vO, this);
}
function vO(e) {
  e.end();
}
Object.defineProperty(U0.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function(A) {
    this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = A, this._writableState.destroyed = A);
  }
});
const eu = fs;
eu.Transform = ii;
var EB = oo.codes, yO = EB.ERR_METHOD_NOT_IMPLEMENTED, bO = EB.ERR_MULTIPLE_CALLBACK, FO = EB.ERR_TRANSFORM_ALREADY_TRANSFORMING, LO = EB.ERR_TRANSFORM_WITH_LENGTH_0;
ql(ii, eu.Duplex);
function RO(e, A) {
  var t = this._transformState;
  t.transforming = !1;
  var r = t.writecb;
  if (r === null)
    return this.emit("error", new bO());
  t.writechunk = null, t.writecb = null, A != null && this.push(A), r(e);
  var n = this._readableState;
  n.reading = !1, (n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
}
function ii(e) {
  if (!(this instanceof ii)) return new ii(e);
  eu.Duplex.call(this, e), this._transformState = {
    afterTransform: RO.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", GO);
}
function GO() {
  var e = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(A, t) {
    A2(e, A, t);
  }) : A2(this, null, null);
}
ii.prototype.push = function(e, A) {
  return this._transformState.needTransform = !1, eu.Duplex.prototype.push.call(this, e, A);
};
ii.prototype._transform = function(e, A, t) {
  t(new yO("_transform()"));
};
ii.prototype._write = function(e, A, t) {
  var r = this._transformState;
  if (r.writecb = t, r.writechunk = e, r.writeencoding = A, !r.transforming) {
    var n = this._readableState;
    (r.needTransform || n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
  }
};
ii.prototype._read = function(e) {
  var A = this._transformState;
  A.writechunk !== null && !A.transforming ? (A.transforming = !0, this._transform(A.writechunk, A.writeencoding, A.afterTransform)) : A.needTransform = !0;
};
ii.prototype._destroy = function(e, A) {
  eu.Duplex.prototype._destroy.call(this, e, function(t) {
    A(t);
  });
};
function A2(e, A, t) {
  if (A) return e.emit("error", A);
  if (t != null && e.push(t), e._writableState.length) throw new LO();
  if (e._transformState.transforming) throw new FO();
  return e.push(null);
}
const uv = fs;
uv.PassThrough = vl;
ql(vl, uv.Transform);
function vl(e) {
  if (!(this instanceof vl)) return new vl(e);
  Transform.call(this, e);
}
vl.prototype._transform = function(e, A, t) {
  t(null, e);
};
var Rd;
function xO(e) {
  var A = !1;
  return function() {
    A || (A = !0, e.apply(void 0, arguments));
  };
}
var cv = oo.codes, kO = cv.ERR_MISSING_ARGS, UO = cv.ERR_STREAM_DESTROYED;
function e2(e) {
  if (e) throw e;
}
function YO(e) {
  return e.setHeader && typeof e.abort == "function";
}
function HO(e, A, t, r) {
  r = xO(r);
  var n = !1;
  e.on("close", function() {
    n = !0;
  }), Rd === void 0 && (Rd = gE), Rd(e, {
    readable: A,
    writable: t
  }, function(a) {
    if (a) return r(a);
    n = !0, r();
  });
  var i = !1;
  return function(a) {
    if (!n && !i) {
      if (i = !0, YO(e)) return e.abort();
      if (typeof e.destroy == "function") return e.destroy();
      r(a || new UO("pipe"));
    }
  };
}
function t2(e) {
  e();
}
function SO(e, A) {
  return e.pipe(A);
}
function NO(e) {
  return !e.length || typeof e[e.length - 1] != "function" ? e2 : e.pop();
}
function TO() {
  for (var e = arguments.length, A = new Array(e), t = 0; t < e; t++)
    A[t] = arguments[t];
  var r = NO(A);
  if (Array.isArray(A[0]) && (A = A[0]), A.length < 2)
    throw new kO("streams");
  var n, i = A.map(function(a, o) {
    var s = o < A.length - 1, l = o > 0;
    return HO(a, s, l, function(u) {
      n || (n = u), u && i.forEach(t2), !s && (i.forEach(t2), r(n));
    });
  });
  return A.reduce(SO);
}
var PO = TO;
(function(e, A) {
  const t = fs;
  A = e.exports = t.Readable, A.Stream = t.Readable, A.Readable = t.Readable, A.Writable = t.Writable, A.Duplex = t.Duplex, A.Transform = t.Transform, A.PassThrough = t.PassThrough, A.finished = gE, A.pipeline = PO;
})(xh, xh.exports);
var gv = xh.exports, Bv = /* @__PURE__ */ bp(gv), fv = {}, dv = {};
function r2(e, A) {
  if (e === A)
    return 0;
  for (var t = e.length, r = A.length, n = 0, i = Math.min(t, r); n < i; ++n)
    if (e[n] !== A[n]) {
      t = e[n], r = A[n];
      break;
    }
  return t < r ? -1 : r < t ? 1 : 0;
}
var zO = Object.prototype.hasOwnProperty, n2 = Object.keys || function(e) {
  var A = [];
  for (var t in e)
    zO.call(e, t) && A.push(t);
  return A;
}, i2 = Array.prototype.slice, Gd;
function hv() {
  return typeof Gd < "u" ? Gd : Gd = function() {
    return (function() {
    }).name === "foo";
  }();
}
function a2(e) {
  return Object.prototype.toString.call(e);
}
function o2(e) {
  return Ya(e) || typeof $a.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e ? !!(e instanceof DataView || e.buffer && e.buffer instanceof ArrayBuffer) : !1;
}
function Tr(e, A) {
  e || Sr(e, !0, A, "==", yl);
}
var jO = /\s*function\s+([^\(\s]*)\s*/;
function Cv(e) {
  if (ja(e)) {
    if (hv())
      return e.name;
    var A = e.toString(), t = A.match(jO);
    return t && t[1];
  }
}
Tr.AssertionError = QB;
function QB(e) {
  this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = VO(this), this.generatedMessage = !0);
  var A = e.stackStartFunction || Sr;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, A);
  else {
    var t = new Error();
    if (t.stack) {
      var r = t.stack, n = Cv(A), i = r.indexOf(`
` + n);
      if (i >= 0) {
        var a = r.indexOf(`
`, i + 1);
        r = r.substring(a + 1);
      }
      this.stack = r;
    }
  }
}
nE(QB, Error);
function s2(e, A) {
  return typeof e == "string" ? e.length < A ? e : e.slice(0, A) : e;
}
function l2(e) {
  if (hv() || !ja(e))
    return Wn(e);
  var A = Cv(e), t = A ? ": " + A : "";
  return "[Function" + t + "]";
}
function VO(e) {
  return s2(l2(e.actual), 128) + " " + e.operator + " " + s2(l2(e.expected), 128);
}
function Sr(e, A, t, r, n) {
  throw new QB({
    message: t,
    actual: e,
    expected: A,
    operator: r,
    stackStartFunction: n
  });
}
Tr.fail = Sr;
function yl(e, A) {
  e || Sr(e, !0, A, "==", yl);
}
Tr.ok = yl;
Tr.equal = EE;
function EE(e, A, t) {
  e != A && Sr(e, A, t, "==", EE);
}
Tr.notEqual = QE;
function QE(e, A, t) {
  e == A && Sr(e, A, t, "!=", QE);
}
Tr.deepEqual = wE;
function wE(e, A, t) {
  ns(e, A, !1) || Sr(e, A, t, "deepEqual", wE);
}
Tr.deepStrictEqual = IE;
function IE(e, A, t) {
  ns(e, A, !0) || Sr(e, A, t, "deepStrictEqual", IE);
}
function ns(e, A, t, r) {
  if (e === A)
    return !0;
  if (Ya(e) && Ya(A))
    return r2(e, A) === 0;
  if (es(e) && es(A))
    return e.getTime() === A.getTime();
  if (za(e) && za(A))
    return e.source === A.source && e.global === A.global && e.multiline === A.multiline && e.lastIndex === A.lastIndex && e.ignoreCase === A.ignoreCase;
  if ((e === null || typeof e != "object") && (A === null || typeof A != "object"))
    return t ? e === A : e == A;
  if (o2(e) && o2(A) && a2(e) === a2(A) && !(e instanceof Float32Array || e instanceof Float64Array))
    return r2(
      new Uint8Array(e.buffer),
      new Uint8Array(A.buffer)
    ) === 0;
  if (Ya(e) !== Ya(A))
    return !1;
  r = r || { actual: [], expected: [] };
  var n = r.actual.indexOf(e);
  return n !== -1 && n === r.expected.indexOf(A) ? !0 : (r.actual.push(e), r.expected.push(A), OO(e, A, t, r));
}
function u2(e) {
  return Object.prototype.toString.call(e) == "[object Arguments]";
}
function OO(e, A, t, r) {
  if (e == null || A === null || A === void 0)
    return !1;
  if (Cg(e) || Cg(A))
    return e === A;
  if (t && Object.getPrototypeOf(e) !== Object.getPrototypeOf(A))
    return !1;
  var n = u2(e), i = u2(A);
  if (n && !i || !n && i)
    return !1;
  if (n)
    return e = i2.call(e), A = i2.call(A), ns(e, A, t);
  var a = n2(e), o = n2(A), s, l;
  if (a.length !== o.length)
    return !1;
  for (a.sort(), o.sort(), l = a.length - 1; l >= 0; l--)
    if (a[l] !== o[l])
      return !1;
  for (l = a.length - 1; l >= 0; l--)
    if (s = a[l], !ns(e[s], A[s], t, r))
      return !1;
  return !0;
}
Tr.notDeepEqual = DE;
function DE(e, A, t) {
  ns(e, A, !1) && Sr(e, A, t, "notDeepEqual", DE);
}
Tr.notDeepStrictEqual = mE;
function mE(e, A, t) {
  ns(e, A, !0) && Sr(e, A, t, "notDeepStrictEqual", mE);
}
Tr.strictEqual = ME;
function ME(e, A, t) {
  e !== A && Sr(e, A, t, "===", ME);
}
Tr.notStrictEqual = pE;
function pE(e, A, t) {
  e === A && Sr(e, A, t, "!==", pE);
}
function c2(e, A) {
  if (!e || !A)
    return !1;
  if (Object.prototype.toString.call(A) == "[object RegExp]")
    return A.test(e);
  try {
    if (e instanceof A)
      return !0;
  } catch {
  }
  return Error.isPrototypeOf(A) ? !1 : A.call({}, e) === !0;
}
function JO(e) {
  var A;
  try {
    e();
  } catch (t) {
    A = t;
  }
  return A;
}
function Ev(e, A, t, r) {
  var n;
  if (typeof A != "function")
    throw new TypeError('"block" argument must be a function');
  typeof t == "string" && (r = t, t = null), n = JO(A), r = (t && t.name ? " (" + t.name + ")." : ".") + (r ? " " + r : "."), e && !n && Sr(n, t, "Missing expected exception" + r);
  var i = typeof r == "string", a = !e && Vo(n), o = !e && n && !t;
  if ((a && i && c2(n, t) || o) && Sr(n, t, "Got unwanted exception" + r), e && n && t && !c2(n, t) || !e && n)
    throw n;
}
Tr.throws = Qv;
function Qv(e, A, t) {
  Ev(!0, e, A, t);
}
Tr.doesNotThrow = wv;
function wv(e, A, t) {
  Ev(!1, e, A, t);
}
Tr.ifError = Iv;
function Iv(e) {
  if (e) throw e;
}
var WO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AssertionError: QB,
  assert: yl,
  deepEqual: wE,
  deepStrictEqual: IE,
  default: Tr,
  doesNotThrow: wv,
  equal: EE,
  fail: Sr,
  ifError: Iv,
  notDeepEqual: DE,
  notDeepStrictEqual: mE,
  notEqual: QE,
  notStrictEqual: pE,
  ok: yl,
  strictEqual: ME,
  throws: Qv
}), Dv = /* @__PURE__ */ Bs(WO);
(function(e) {
  var A = Dv, t = NT, r = VT, n = KT, i = qT;
  for (var a in i)
    e[a] = i[a];
  e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7;
  var o = 31, s = 139;
  function l(u) {
    if (typeof u != "number" || u < e.DEFLATE || u > e.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = u, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  l.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, A(this.init_done, "close before init"), A(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? r.deflateEnd(this.strm) : (this.mode === e.INFLATE || this.mode === e.GUNZIP || this.mode === e.INFLATERAW || this.mode === e.UNZIP) && n.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null;
  }, l.prototype.write = function(u, g, d, h, C, E, I) {
    return this._write(!0, u, g, d, h, C, E, I);
  }, l.prototype.writeSync = function(u, g, d, h, C, E, I) {
    return this._write(!1, u, g, d, h, C, E, I);
  }, l.prototype._write = function(u, g, d, h, C, E, I, b) {
    if (A.equal(arguments.length, 8), A(this.init_done, "write before init"), A(this.mode !== e.NONE, "already finalized"), A.equal(!1, this.write_in_progress, "write already in progress"), A.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, A.equal(!1, g === void 0, "must provide flush value"), this.write_in_progress = !0, g !== e.Z_NO_FLUSH && g !== e.Z_PARTIAL_FLUSH && g !== e.Z_SYNC_FLUSH && g !== e.Z_FULL_FLUSH && g !== e.Z_FINISH && g !== e.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (d == null && (d = LA.alloc(0), C = 0, h = 0), this.strm.avail_in = C, this.strm.input = d, this.strm.next_in = h, this.strm.avail_out = b, this.strm.output = E, this.strm.next_out = I, this.flush = g, !u)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var y = this;
    return ot.nextTick(function() {
      y._process(), y._after();
    }), this;
  }, l.prototype._afterSync = function() {
    var u = this.strm.avail_out, g = this.strm.avail_in;
    return this.write_in_progress = !1, [g, u];
  }, l.prototype._process = function() {
    var u = null;
    switch (this.mode) {
      case e.DEFLATE:
      case e.GZIP:
      case e.DEFLATERAW:
        this.err = r.deflate(this.strm, this.flush);
        break;
      case e.UNZIP:
        switch (this.strm.avail_in > 0 && (u = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (u === null)
              break;
            if (this.strm.input[u] === o) {
              if (this.gzip_id_bytes_read = 1, u++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = e.INFLATE;
              break;
            }
          // fallthrough
          case 1:
            if (u === null)
              break;
            this.strm.input[u] === s ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      // fallthrough
      case e.INFLATE:
      case e.GUNZIP:
      case e.INFLATERAW:
        for (this.err = n.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = n.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = n.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = n.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, l.prototype._checkError = function() {
    switch (this.err) {
      case e.Z_OK:
      case e.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === e.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case e.Z_STREAM_END:
        break;
      case e.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, l.prototype._after = function() {
    if (this._checkError()) {
      var u = this.strm.avail_out, g = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(g, u), this.pending_close && this.close();
    }
  }, l.prototype._error = function(u) {
    this.strm.msg && (u = this.strm.msg), this.onerror(
      u,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, l.prototype.init = function(u, g, d, h, C) {
    A(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), A(u >= 8 && u <= 15, "invalid windowBits"), A(g >= -1 && g <= 9, "invalid compression level"), A(d >= 1 && d <= 9, "invalid memlevel"), A(h === e.Z_FILTERED || h === e.Z_HUFFMAN_ONLY || h === e.Z_RLE || h === e.Z_FIXED || h === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(g, u, d, h, C), this._setDictionary();
  }, l.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, l.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, l.prototype._init = function(u, g, d, h, C) {
    switch (this.level = u, this.windowBits = g, this.memLevel = d, this.strategy = h, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, (this.mode === e.GZIP || this.mode === e.GUNZIP) && (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), (this.mode === e.DEFLATERAW || this.mode === e.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new t(), this.mode) {
      case e.DEFLATE:
      case e.GZIP:
      case e.DEFLATERAW:
        this.err = r.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case e.INFLATE:
      case e.GUNZIP:
      case e.INFLATERAW:
      case e.UNZIP:
        this.err = n.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== e.Z_OK && this._error("Init error"), this.dictionary = C, this.write_in_progress = !1, this.init_done = !0;
  }, l.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = e.Z_OK, this.mode) {
        case e.DEFLATE:
        case e.DEFLATERAW:
          this.err = r.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== e.Z_OK && this._error("Failed to set dictionary");
    }
  }, l.prototype._reset = function() {
    switch (this.err = e.Z_OK, this.mode) {
      case e.DEFLATE:
      case e.DEFLATERAW:
      case e.GZIP:
        this.err = r.deflateReset(this.strm);
        break;
      case e.INFLATE:
      case e.INFLATERAW:
      case e.GUNZIP:
        this.err = n.inflateReset(this.strm);
        break;
    }
    this.err !== e.Z_OK && this._error("Failed to reset stream");
  }, e.Zlib = l;
})(dv);
(function(e) {
  var A = Ml.Buffer, t = gv.Transform, r = dv, n = cE, i = Dv.ok, a = Ml.kMaxLength, o = "Cannot create final Buffer. It would be larger than 0x" + a.toString(16) + " bytes";
  r.Z_MIN_WINDOWBITS = 8, r.Z_MAX_WINDOWBITS = 15, r.Z_DEFAULT_WINDOWBITS = 15, r.Z_MIN_CHUNK = 64, r.Z_MAX_CHUNK = 1 / 0, r.Z_DEFAULT_CHUNK = 16 * 1024, r.Z_MIN_MEMLEVEL = 1, r.Z_MAX_MEMLEVEL = 9, r.Z_DEFAULT_MEMLEVEL = 8, r.Z_MIN_LEVEL = -1, r.Z_MAX_LEVEL = 9, r.Z_DEFAULT_LEVEL = r.Z_DEFAULT_COMPRESSION;
  for (var s = Object.keys(r), l = 0; l < s.length; l++) {
    var u = s[l];
    u.match(/^Z/) && Object.defineProperty(e, u, {
      enumerable: !0,
      value: r[u],
      writable: !1
    });
  }
  for (var g = {
    Z_OK: r.Z_OK,
    Z_STREAM_END: r.Z_STREAM_END,
    Z_NEED_DICT: r.Z_NEED_DICT,
    Z_ERRNO: r.Z_ERRNO,
    Z_STREAM_ERROR: r.Z_STREAM_ERROR,
    Z_DATA_ERROR: r.Z_DATA_ERROR,
    Z_MEM_ERROR: r.Z_MEM_ERROR,
    Z_BUF_ERROR: r.Z_BUF_ERROR,
    Z_VERSION_ERROR: r.Z_VERSION_ERROR
  }, d = Object.keys(g), h = 0; h < d.length; h++) {
    var C = d[h];
    g[g[C]] = C;
  }
  Object.defineProperty(e, "codes", {
    enumerable: !0,
    value: Object.freeze(g),
    writable: !1
  }), e.Deflate = b, e.Inflate = y, e.Gzip = p, e.Gunzip = Q, e.DeflateRaw = w, e.InflateRaw = Y, e.Unzip = k, e.createDeflate = function(M) {
    return new b(M);
  }, e.createInflate = function(M) {
    return new y(M);
  }, e.createDeflateRaw = function(M) {
    return new w(M);
  }, e.createInflateRaw = function(M) {
    return new Y(M);
  }, e.createGzip = function(M) {
    return new p(M);
  }, e.createGunzip = function(M) {
    return new Q(M);
  }, e.createUnzip = function(M) {
    return new k(M);
  }, e.deflate = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new b(R), M, G);
  }, e.deflateSync = function(M, R) {
    return I(new b(R), M);
  }, e.gzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new p(R), M, G);
  }, e.gzipSync = function(M, R) {
    return I(new p(R), M);
  }, e.deflateRaw = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new w(R), M, G);
  }, e.deflateRawSync = function(M, R) {
    return I(new w(R), M);
  }, e.unzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new k(R), M, G);
  }, e.unzipSync = function(M, R) {
    return I(new k(R), M);
  }, e.inflate = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new y(R), M, G);
  }, e.inflateSync = function(M, R) {
    return I(new y(R), M);
  }, e.gunzip = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new Q(R), M, G);
  }, e.gunzipSync = function(M, R) {
    return I(new Q(R), M);
  }, e.inflateRaw = function(M, R, G) {
    return typeof R == "function" && (G = R, R = {}), E(new Y(R), M, G);
  }, e.inflateRawSync = function(M, R) {
    return I(new Y(R), M);
  };
  function E(M, R, G) {
    var N = [], z = 0;
    M.on("error", O), M.on("end", K), M.end(R), T();
    function T() {
      for (var AA; (AA = M.read()) !== null; )
        N.push(AA), z += AA.length;
      M.once("readable", T);
    }
    function O(AA) {
      M.removeListener("end", K), M.removeListener("readable", T), G(AA);
    }
    function K() {
      var AA, X = null;
      z >= a ? X = new RangeError(o) : AA = A.concat(N, z), N = [], M.close(), G(X, AA);
    }
  }
  function I(M, R) {
    if (typeof R == "string" && (R = A.from(R)), !A.isBuffer(R)) throw new TypeError("Not a string or buffer");
    var G = M._finishFlushFlag;
    return M._processChunk(R, G);
  }
  function b(M) {
    if (!(this instanceof b)) return new b(M);
    S.call(this, M, r.DEFLATE);
  }
  function y(M) {
    if (!(this instanceof y)) return new y(M);
    S.call(this, M, r.INFLATE);
  }
  function p(M) {
    if (!(this instanceof p)) return new p(M);
    S.call(this, M, r.GZIP);
  }
  function Q(M) {
    if (!(this instanceof Q)) return new Q(M);
    S.call(this, M, r.GUNZIP);
  }
  function w(M) {
    if (!(this instanceof w)) return new w(M);
    S.call(this, M, r.DEFLATERAW);
  }
  function Y(M) {
    if (!(this instanceof Y)) return new Y(M);
    S.call(this, M, r.INFLATERAW);
  }
  function k(M) {
    if (!(this instanceof k)) return new k(M);
    S.call(this, M, r.UNZIP);
  }
  function L(M) {
    return M === r.Z_NO_FLUSH || M === r.Z_PARTIAL_FLUSH || M === r.Z_SYNC_FLUSH || M === r.Z_FULL_FLUSH || M === r.Z_FINISH || M === r.Z_BLOCK;
  }
  function S(M, R) {
    var G = this;
    if (this._opts = M = M || {}, this._chunkSize = M.chunkSize || e.Z_DEFAULT_CHUNK, t.call(this, M), M.flush && !L(M.flush))
      throw new Error("Invalid flush flag: " + M.flush);
    if (M.finishFlush && !L(M.finishFlush))
      throw new Error("Invalid flush flag: " + M.finishFlush);
    if (this._flushFlag = M.flush || r.Z_NO_FLUSH, this._finishFlushFlag = typeof M.finishFlush < "u" ? M.finishFlush : r.Z_FINISH, M.chunkSize && (M.chunkSize < e.Z_MIN_CHUNK || M.chunkSize > e.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + M.chunkSize);
    if (M.windowBits && (M.windowBits < e.Z_MIN_WINDOWBITS || M.windowBits > e.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + M.windowBits);
    if (M.level && (M.level < e.Z_MIN_LEVEL || M.level > e.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + M.level);
    if (M.memLevel && (M.memLevel < e.Z_MIN_MEMLEVEL || M.memLevel > e.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + M.memLevel);
    if (M.strategy && M.strategy != e.Z_FILTERED && M.strategy != e.Z_HUFFMAN_ONLY && M.strategy != e.Z_RLE && M.strategy != e.Z_FIXED && M.strategy != e.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + M.strategy);
    if (M.dictionary && !A.isBuffer(M.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new r.Zlib(R);
    var N = this;
    this._hadError = !1, this._handle.onerror = function(O, K) {
      P(N), N._hadError = !0;
      var AA = new Error(O);
      AA.errno = K, AA.code = e.codes[K], N.emit("error", AA);
    };
    var z = e.Z_DEFAULT_COMPRESSION;
    typeof M.level == "number" && (z = M.level);
    var T = e.Z_DEFAULT_STRATEGY;
    typeof M.strategy == "number" && (T = M.strategy), this._handle.init(M.windowBits || e.Z_DEFAULT_WINDOWBITS, z, M.memLevel || e.Z_DEFAULT_MEMLEVEL, T, M.dictionary), this._buffer = A.allocUnsafe(this._chunkSize), this._offset = 0, this._level = z, this._strategy = T, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !G._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  n.inherits(S, t), S.prototype.params = function(M, R, G) {
    if (M < e.Z_MIN_LEVEL || M > e.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + M);
    if (R != e.Z_FILTERED && R != e.Z_HUFFMAN_ONLY && R != e.Z_RLE && R != e.Z_FIXED && R != e.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + R);
    if (this._level !== M || this._strategy !== R) {
      var N = this;
      this.flush(r.Z_SYNC_FLUSH, function() {
        i(N._handle, "zlib binding closed"), N._handle.params(M, R), N._hadError || (N._level = M, N._strategy = R, G && G());
      });
    } else
      ot.nextTick(G);
  }, S.prototype.reset = function() {
    return i(this._handle, "zlib binding closed"), this._handle.reset();
  }, S.prototype._flush = function(M) {
    this._transform(A.alloc(0), "", M);
  }, S.prototype.flush = function(M, R) {
    var G = this, N = this._writableState;
    (typeof M == "function" || M === void 0 && !R) && (R = M, M = r.Z_FULL_FLUSH), N.ended ? R && ot.nextTick(R) : N.ending ? R && this.once("end", R) : N.needDrain ? R && this.once("drain", function() {
      return G.flush(M, R);
    }) : (this._flushFlag = M, this.write(A.alloc(0), "", R));
  }, S.prototype.close = function(M) {
    P(this, M), ot.nextTick(Z, this);
  };
  function P(M, R) {
    R && ot.nextTick(R), M._handle && (M._handle.close(), M._handle = null);
  }
  function Z(M) {
    M.emit("close");
  }
  S.prototype._transform = function(M, R, G) {
    var N, z = this._writableState, T = z.ending || z.ended, O = T && (!M || z.length === M.length);
    if (M !== null && !A.isBuffer(M)) return G(new Error("invalid input"));
    if (!this._handle) return G(new Error("zlib binding closed"));
    O ? N = this._finishFlushFlag : (N = this._flushFlag, M.length >= z.length && (this._flushFlag = this._opts.flush || r.Z_NO_FLUSH)), this._processChunk(M, N, G);
  }, S.prototype._processChunk = function(M, R, G) {
    var N = M && M.length, z = this._chunkSize - this._offset, T = 0, O = this, K = typeof G == "function";
    if (!K) {
      var AA = [], X = 0, iA;
      this.on("error", function(HA) {
        iA = HA;
      }), i(this._handle, "zlib binding closed");
      do
        var oA = this._handle.writeSync(
          R,
          M,
          // in
          T,
          // in_off
          N,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          z
        );
      while (!this._hadError && DA(oA[0], oA[1]));
      if (this._hadError)
        throw iA;
      if (X >= a)
        throw P(this), new RangeError(o);
      var fA = A.concat(AA, X);
      return P(this), fA;
    }
    i(this._handle, "zlib binding closed");
    var wA = this._handle.write(
      R,
      M,
      // in
      T,
      // in_off
      N,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      z
    );
    wA.buffer = M, wA.callback = DA;
    function DA(HA, sA) {
      if (this && (this.buffer = null, this.callback = null), !O._hadError) {
        var lA = z - sA;
        if (i(lA >= 0, "have should not go down"), lA > 0) {
          var tA = O._buffer.slice(O._offset, O._offset + lA);
          O._offset += lA, K ? O.push(tA) : (AA.push(tA), X += tA.length);
        }
        if ((sA === 0 || O._offset >= O._chunkSize) && (z = O._chunkSize, O._offset = 0, O._buffer = A.allocUnsafe(O._chunkSize)), sA === 0) {
          if (T += N - HA, N = HA, !K) return !0;
          var nA = O._handle.write(R, M, T, N, O._buffer, O._offset, O._chunkSize);
          nA.callback = DA, nA.buffer = M;
          return;
        }
        if (!K) return !1;
        G();
      }
    }
  }, n.inherits(b, S), n.inherits(y, S), n.inherits(p, S), n.inherits(Q, S), n.inherits(w, S), n.inherits(Y, S), n.inherits(k, S);
})(fv);
var Zs = /* @__PURE__ */ bp(fv);
class mv extends Bv.Writable {
  constructor(A, t, r) {
    super({
      decodeStrings: !1
    }), this.finalize = this.finalize.bind(this), this.document = A, this.id = t, r == null && (r = {}), this.data = r, this.gen = 0, this.deflate = null, this.compress = this.document.compress && !this.data.Filter, this.uncompressedLength = 0, this.chunks = [];
  }
  initDeflate() {
    return this.data.Filter = "FlateDecode", this.deflate = Zs.createDeflate(), this.deflate.on("data", (A) => (this.chunks.push(A), this.data.Length += A.length)), this.deflate.on("end", this.finalize);
  }
  _write(A, t, r) {
    return A instanceof Uint8Array || (A = LA.from(A + `
`, "binary")), this.uncompressedLength += A.length, this.data.Length == null && (this.data.Length = 0), this.compress ? (this.deflate || this.initDeflate(), this.deflate.write(A)) : (this.chunks.push(A), this.data.Length += A.length), r();
  }
  end() {
    return super.end(...arguments), this.deflate ? this.deflate.end() : this.finalize();
  }
  finalize() {
    if (this.offset = this.document._offset, this.document._write(this.id + " " + this.gen + " obj"), this.document._write(ri.convert(this.data)), this.chunks.length) {
      this.document._write("stream");
      for (let A of Array.from(this.chunks))
        this.document._write(A);
      this.chunks.length = 0, this.document._write(`
endstream`);
    }
    return this.document._write("endobj"), this.document._refEnd(this);
  }
  toString() {
    return this.id + " " + this.gen + " R";
  }
}
class Mv {
  constructor(A) {
    A === void 0 && (A = {}), this._items = {}, this.limits = typeof A.limits == "boolean" ? A.limits : !0;
  }
  add(A, t) {
    return this._items[A] = t;
  }
  get(A) {
    return this._items[A];
  }
  toString() {
    const A = Object.keys(this._items).sort((r, n) => this._compareKeys(r, n)), t = ["<<"];
    if (this.limits && A.length > 1) {
      const r = A[0], n = A[A.length - 1];
      t.push("  /Limits " + ri.convert([this._dataForKey(r), this._dataForKey(n)]));
    }
    t.push("  /" + this._keysName() + " [");
    for (let r of A)
      t.push("    " + ri.convert(this._dataForKey(r)) + " " + ri.convert(this._items[r]));
    return t.push("]"), t.push(">>"), t.join(`
`);
  }
  _compareKeys() {
    throw new Error("Must be implemented by subclasses");
  }
  _keysName() {
    throw new Error("Must be implemented by subclasses");
  }
  _dataForKey() {
    throw new Error("Must be implemented by subclasses");
  }
}
class Rc extends Mv {
  _compareKeys(A, t) {
    return A.localeCompare(t);
  }
  _keysName() {
    return "Names";
  }
  _dataForKey(A) {
    return new String(A);
  }
}
const ZO = /[\n\r\t\b\f\(\)\\]/g, KO = {
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t",
  "\b": "\\b",
  "\f": "\\f",
  "\\": "\\\\",
  "(": "\\(",
  ")": "\\)"
}, po = (e, A) => (Array(A + 1).join("0") + e).slice(-A), _O = function(e) {
  const A = e.length;
  if (A & 1)
    throw new Error("Buffer length must be even");
  for (let t = 0, r = A - 1; t < r; t += 2) {
    const n = e[t];
    e[t] = e[t + 1], e[t + 1] = n;
  }
  return e;
};
class sl {
  static convert(A) {
    if (typeof A == "string")
      return "/" + A;
    if (A instanceof String) {
      let t = A, r = !1;
      for (let n = 0, i = t.length; n < i; n++)
        if (t.charCodeAt(n) > 127) {
          r = !0;
          break;
        }
      return r && (t = _O(LA.from("\uFEFF" + t, "utf16le")).toString("binary")), t = t.replace(ZO, (n) => KO[n]), "(" + t + ")";
    }
    if (LA.isBuffer(A))
      return "<" + A.toString("hex") + ">";
    if (A instanceof mv || A instanceof Rc)
      return A.toString();
    if (A instanceof Date)
      return "(D:" + po(A.getUTCFullYear(), 4) + po(A.getUTCMonth() + 1, 2) + po(A.getUTCDate(), 2) + po(A.getUTCHours(), 2) + po(A.getUTCMinutes(), 2) + po(A.getUTCSeconds(), 2) + "Z)";
    if (Array.isArray(A))
      return "[" + Array.from(A).map((r) => sl.convert(r)).join(" ") + "]";
    if ({}.toString.call(A) === "[object Object]") {
      const t = ["<<"];
      for (let r in A) {
        const n = A[r];
        t.push("/" + r + " " + sl.convert(n));
      }
      return t.push(">>"), t.join(`
`);
    }
    return typeof A == "number" ? sl.number(A) : "" + A;
  }
  static number(A) {
    if (A > -1e21 && A < 1e21)
      return Math.round(A * 1e6) / 1e6;
    throw new Error("unsupported number: " + A);
  }
}
var ri = sl;
const XO = {
  top: 72,
  left: 72,
  bottom: 72,
  right: 72
}, qO = {
  "4A0": [4767.87, 6740.79],
  "2A0": [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756],
  FOLIO: [612, 936],
  LEGAL: [612, 1008],
  LETTER: [612, 792],
  TABLOID: [792, 1224]
};
class $O {
  constructor(A, t) {
    t === void 0 && (t = {}), this.document = A, this.size = t.size || "letter", this.layout = t.layout || "portrait", this.userUnit = t.userUnit || 1, typeof t.margin == "number" ? this.margins = {
      top: t.margin,
      left: t.margin,
      bottom: t.margin,
      right: t.margin
    } : this.margins = t.margins || XO;
    const r = Array.isArray(this.size) ? this.size : qO[this.size.toUpperCase()];
    this.width = r[this.layout === "portrait" ? 0 : 1], this.height = r[this.layout === "portrait" ? 1 : 0], this.content = this.document.ref(), this.resources = this.document.ref({
      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"]
    }), this.dictionary = this.document.ref({
      Type: "Page",
      Parent: this.document._root.data.Pages,
      MediaBox: [0, 0, this.width, this.height],
      Contents: this.content,
      Resources: this.resources,
      UserUnit: this.userUnit
    }), this.markings = [];
  }
  // Lazily create these objects
  get fonts() {
    const A = this.resources.data;
    return A.Font != null ? A.Font : A.Font = {};
  }
  get xobjects() {
    const A = this.resources.data;
    return A.XObject != null ? A.XObject : A.XObject = {};
  }
  get ext_gstates() {
    const A = this.resources.data;
    return A.ExtGState != null ? A.ExtGState : A.ExtGState = {};
  }
  get patterns() {
    const A = this.resources.data;
    return A.Pattern != null ? A.Pattern : A.Pattern = {};
  }
  get colorSpaces() {
    const A = this.resources.data;
    return A.ColorSpace || (A.ColorSpace = {});
  }
  get annotations() {
    const A = this.dictionary.data;
    return A.Annots != null ? A.Annots : A.Annots = [];
  }
  get structParentTreeKey() {
    const A = this.dictionary.data;
    return A.StructParents != null ? A.StructParents : A.StructParents = this.document.createStructParentTreeNextKey();
  }
  maxY() {
    return this.height - this.margins.bottom;
  }
  write(A) {
    return this.content.write(A);
  }
  end() {
    return this.dictionary.end(), this.resources.end(), this.content.end();
  }
}
const AJ = (e) => {
  const A = [];
  for (let t = 0; t < e.sigBytes; t++)
    A.push(e.words[Math.floor(t / 4)] >> 8 * (3 - t % 4) & 255);
  return LA.from(A);
};
class eJ {
  static generateFileID(A) {
    A === void 0 && (A = {});
    let t = A.CreationDate.getTime() + `
`;
    for (let r in A)
      A.hasOwnProperty(r) && (t += r + ": " + A[r].valueOf() + `
`);
    return AJ(Hm(t));
  }
}
const {
  number: tJ
} = ri;
let vE = class {
  constructor(A) {
    this.doc = A, this.stops = [], this.embedded = !1, this.transform = [1, 0, 0, 1, 0, 0];
  }
  stop(A, t, r) {
    if (r == null && (r = 1), t = this.doc._normalizeColor(t), this.stops.length === 0)
      if (t.length === 3)
        this._colorSpace = "DeviceRGB";
      else if (t.length === 4)
        this._colorSpace = "DeviceCMYK";
      else if (t.length === 1)
        this._colorSpace = "DeviceGray";
      else
        throw new Error("Unknown color space");
    else if (this._colorSpace === "DeviceRGB" && t.length !== 3 || this._colorSpace === "DeviceCMYK" && t.length !== 4 || this._colorSpace === "DeviceGray" && t.length !== 1)
      throw new Error("All gradient stops must use the same color space");
    return r = Math.max(0, Math.min(1, r)), this.stops.push([A, t, r]), this;
  }
  setTransform(A, t, r, n, i, a) {
    return this.transform = [A, t, r, n, i, a], this;
  }
  embed(A) {
    let t;
    const r = this.stops.length;
    if (r === 0)
      return;
    this.embedded = !0, this.matrix = A;
    const n = this.stops[r - 1];
    n[0] < 1 && this.stops.push([1, n[1], n[2]]);
    const i = [], a = [], o = [];
    for (let u = 0; u < r - 1; u++)
      a.push(0, 1), u + 2 !== r && i.push(this.stops[u + 1][0]), t = this.doc.ref({
        FunctionType: 2,
        Domain: [0, 1],
        C0: this.stops[u + 0][1],
        C1: this.stops[u + 1][1],
        N: 1
      }), o.push(t), t.end();
    r === 1 ? t = o[0] : (t = this.doc.ref({
      FunctionType: 3,
      // stitching function
      Domain: [0, 1],
      Functions: o,
      Bounds: i,
      Encode: a
    }), t.end()), this.id = "Sh" + ++this.doc._gradCount;
    const s = this.shader(t);
    s.end();
    const l = this.doc.ref({
      Type: "Pattern",
      PatternType: 2,
      Shading: s,
      Matrix: this.matrix.map(tJ)
    });
    if (l.end(), this.stops.some((u) => u[2] < 1)) {
      let u = this.opacityGradient();
      u._colorSpace = "DeviceGray";
      for (let E of this.stops)
        u.stop(E[0], [E[2]]);
      u = u.embed(this.matrix);
      const g = [0, 0, this.doc.page.width, this.doc.page.height], d = this.doc.ref({
        Type: "XObject",
        Subtype: "Form",
        FormType: 1,
        BBox: g,
        Group: {
          Type: "Group",
          S: "Transparency",
          CS: "DeviceGray"
        },
        Resources: {
          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
          Pattern: {
            Sh1: u
          }
        }
      });
      d.write("/Pattern cs /Sh1 scn"), d.end(g.join(" ") + " re f");
      const h = this.doc.ref({
        Type: "ExtGState",
        SMask: {
          Type: "Mask",
          S: "Luminosity",
          G: d
        }
      });
      h.end();
      const C = this.doc.ref({
        Type: "Pattern",
        PatternType: 1,
        PaintType: 1,
        TilingType: 2,
        BBox: g,
        XStep: g[2],
        YStep: g[3],
        Resources: {
          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
          Pattern: {
            Sh1: l
          },
          ExtGState: {
            Gs1: h
          }
        }
      });
      C.write("/Gs1 gs /Pattern cs /Sh1 scn"), C.end(g.join(" ") + " re f"), this.doc.page.patterns[this.id] = C;
    } else
      this.doc.page.patterns[this.id] = l;
    return l;
  }
  apply(A) {
    const [t, r, n, i, a, o] = this.doc._ctm, [s, l, u, g, d, h] = this.transform, C = [t * s + n * l, r * s + i * l, t * u + n * g, r * u + i * g, t * d + n * h + a, r * d + i * h + o];
    (!this.embedded || C.join(" ") !== this.matrix.join(" ")) && this.embed(C), this.doc._setColorSpace("Pattern", A);
    const E = A ? "SCN" : "scn";
    return this.doc.addContent("/" + this.id + " " + E);
  }
}, rJ = class pv extends vE {
  constructor(A, t, r, n, i) {
    super(A), this.x1 = t, this.y1 = r, this.x2 = n, this.y2 = i;
  }
  shader(A) {
    return this.doc.ref({
      ShadingType: 2,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.x2, this.y2],
      Function: A,
      Extend: [!0, !0]
    });
  }
  opacityGradient() {
    return new pv(this.doc, this.x1, this.y1, this.x2, this.y2);
  }
}, nJ = class vv extends vE {
  constructor(A, t, r, n, i, a, o) {
    super(A), this.doc = A, this.x1 = t, this.y1 = r, this.r1 = n, this.x2 = i, this.y2 = a, this.r2 = o;
  }
  shader(A) {
    return this.doc.ref({
      ShadingType: 3,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
      Function: A,
      Extend: [!0, !0]
    });
  }
  opacityGradient() {
    return new vv(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
  }
};
var iJ = {
  PDFGradient: vE,
  PDFLinearGradient: rJ,
  PDFRadialGradient: nJ
};
const aJ = ["DeviceCMYK", "DeviceRGB"];
let oJ = class {
  constructor(A, t, r, n, i) {
    this.doc = A, this.bBox = t, this.xStep = r, this.yStep = n, this.stream = i;
  }
  createPattern() {
    const A = this.doc.ref();
    A.end();
    const [t, r, n, i, a, o] = this.doc._ctm, [s, l, u, g, d, h] = [1, 0, 0, 1, 0, 0], C = [t * s + n * l, r * s + i * l, t * u + n * g, r * u + i * g, t * d + n * h + a, r * d + i * h + o], E = this.doc.ref({
      Type: "Pattern",
      PatternType: 1,
      // tiling
      PaintType: 2,
      // 1-colored, 2-uncolored
      TilingType: 2,
      // 2-no distortion
      BBox: this.bBox,
      XStep: this.xStep,
      YStep: this.yStep,
      Matrix: C.map((I) => +I.toFixed(5)),
      Resources: A
    });
    return E.end(this.stream), E;
  }
  embedPatternColorSpaces() {
    aJ.forEach((A) => {
      const t = this.getPatternColorSpaceId(A);
      if (this.doc.page.colorSpaces[t]) return;
      const r = this.doc.ref(["Pattern", A]);
      r.end(), this.doc.page.colorSpaces[t] = r;
    });
  }
  getPatternColorSpaceId(A) {
    return "CsP" + A;
  }
  embed() {
    this.id || (this.doc._patternCount = this.doc._patternCount + 1, this.id = "P" + this.doc._patternCount, this.pattern = this.createPattern()), this.doc.page.patterns[this.id] || (this.doc.page.patterns[this.id] = this.pattern);
  }
  apply(A, t) {
    this.embedPatternColorSpaces(), this.embed();
    const r = this.doc._normalizeColor(t);
    if (!r) throw Error("invalid pattern color. (value: " + t + ")");
    const n = this.getPatternColorSpaceId(this.doc._getColorSpace(r));
    this.doc._setColorSpace(n, A);
    const i = A ? "SCN" : "scn";
    return this.doc.addContent(r.join(" ") + " /" + this.id + " " + i);
  }
};
var sJ = {
  PDFTilingPattern: oJ
};
const {
  PDFGradient: lJ,
  PDFLinearGradient: uJ,
  PDFRadialGradient: cJ
} = iJ, {
  PDFTilingPattern: g2
} = sJ;
var gJ = {
  initColor() {
    return this._opacityRegistry = {}, this._opacityCount = 0, this._patternCount = 0, this._gradCount = 0;
  },
  _normalizeColor(e) {
    if (typeof e == "string")
      if (e.charAt(0) === "#") {
        e.length === 4 && (e = e.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
        const A = parseInt(e.slice(1), 16);
        e = [A >> 16, A >> 8 & 255, A & 255];
      } else B2[e] && (e = B2[e]);
    return Array.isArray(e) ? (e.length === 3 ? e = e.map((A) => A / 255) : e.length === 4 && (e = e.map((A) => A / 100)), e) : null;
  },
  _setColor(e, A) {
    return e instanceof lJ ? (e.apply(A), !0) : Array.isArray(e) && e[0] instanceof g2 ? (e[0].apply(A, e[1]), !0) : this._setColorCore(e, A);
  },
  _setColorCore(e, A) {
    if (e = this._normalizeColor(e), !e)
      return !1;
    const t = A ? "SCN" : "scn", r = this._getColorSpace(e);
    return this._setColorSpace(r, A), e = e.join(" "), this.addContent(e + " " + t), !0;
  },
  _setColorSpace(e, A) {
    const t = A ? "CS" : "cs";
    return this.addContent("/" + e + " " + t);
  },
  _getColorSpace(e) {
    return e.length === 4 ? "DeviceCMYK" : "DeviceRGB";
  },
  fillColor(e, A) {
    return this._setColor(e, !1) && this.fillOpacity(A), this._fillColor = [e, A], this;
  },
  strokeColor(e, A) {
    return this._setColor(e, !0) && this.strokeOpacity(A), this;
  },
  opacity(e) {
    return this._doOpacity(e, e), this;
  },
  fillOpacity(e) {
    return this._doOpacity(e, null), this;
  },
  strokeOpacity(e) {
    return this._doOpacity(null, e), this;
  },
  _doOpacity(e, A) {
    let t, r;
    if (e == null && A == null)
      return;
    e != null && (e = Math.max(0, Math.min(1, e))), A != null && (A = Math.max(0, Math.min(1, A)));
    const n = e + "_" + A;
    return this._opacityRegistry[n] ? [t, r] = this._opacityRegistry[n] : (t = {
      Type: "ExtGState"
    }, e != null && (t.ca = e), A != null && (t.CA = A), t = this.ref(t), t.end(), r = "Gs" + ++this._opacityCount, this._opacityRegistry[n] = [t, r]), this.page.ext_gstates[r] = t, this.addContent("/" + r + " gs");
  },
  linearGradient(e, A, t, r) {
    return new uJ(this, e, A, t, r);
  },
  radialGradient(e, A, t, r, n, i) {
    return new cJ(this, e, A, t, r, n, i);
  },
  pattern(e, A, t, r) {
    return new g2(this, e, A, t, r);
  }
}, B2 = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  grey: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
let Re, Ge, ut, Et, xo, ko;
Re = Ge = ut = Et = xo = ko = 0;
const yv = {
  M: 2,
  m: 2,
  Z: 0,
  z: 0,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7
}, BJ = (e) => e in yv, fJ = (e) => {
  const A = e.codePointAt(0);
  return A === 32 || A === 9 || A === 13 || A === 10;
}, dJ = (e) => {
  const A = e.codePointAt(0);
  return A == null ? !1 : 48 <= A && A <= 57;
}, xd = (e, A) => {
  let t = A, r = "", n = (
    /** @type {ReadNumberState} */
    "none"
  );
  for (; t < e.length; t += 1) {
    const a = e[t];
    if (a === "+" || a === "-") {
      if (n === "none") {
        n = "sign", r += a;
        continue;
      }
      if (n === "e") {
        n = "exponent_sign", r += a;
        continue;
      }
    }
    if (dJ(a)) {
      if (n === "none" || n === "sign" || n === "whole") {
        n = "whole", r += a;
        continue;
      }
      if (n === "decimal_point" || n === "decimal") {
        n = "decimal", r += a;
        continue;
      }
      if (n === "e" || n === "exponent_sign" || n === "exponent") {
        n = "exponent", r += a;
        continue;
      }
    }
    if (a === "." && (n === "none" || n === "sign" || n === "whole")) {
      n = "decimal_point", r += a;
      continue;
    }
    if ((a === "E" || a === "e") && (n === "whole" || n === "decimal_point" || n === "decimal")) {
      n = "e", r += a;
      continue;
    }
    break;
  }
  const i = Number.parseFloat(r);
  return Number.isNaN(i) ? [A, null] : [t - 1, i];
}, hJ = (e) => {
  const A = [];
  let t = null, r = (
    /** @type {number[]} */
    []
  ), n = 0, i = !1, a = !1;
  for (let o = 0; o < e.length; o += 1) {
    const s = e.charAt(o);
    if (fJ(s))
      continue;
    if (i && s === ",") {
      if (a)
        break;
      a = !0;
      continue;
    }
    if (BJ(s)) {
      if (a)
        return A;
      if (t == null) {
        if (s !== "M" && s !== "m")
          return A;
      } else if (r.length !== 0)
        return A;
      t = s, r = [], n = yv[t], i = !1, n === 0 && A.push({
        command: t,
        args: r
      });
      continue;
    }
    if (t == null)
      return A;
    let l = o, u = null;
    if (t === "A" || t === "a") {
      const g = r.length;
      (g === 0 || g === 1) && s !== "+" && s !== "-" && ([l, u] = xd(e, o)), (g === 2 || g === 5 || g === 6) && ([l, u] = xd(e, o)), (g === 3 || g === 4) && (s === "0" && (u = 0), s === "1" && (u = 1));
    } else
      [l, u] = xd(e, o);
    if (u == null)
      return A;
    r.push(u), i = !0, a = !1, o = l, r.length === n && (A.push({
      command: t,
      args: r
    }), t === "M" && (t = "L"), t === "m" && (t = "l"), r = []);
  }
  return A;
}, CJ = function(e, A) {
  Re = Ge = ut = Et = xo = ko = 0;
  for (let t = 0; t < e.length; t++) {
    const {
      command: r,
      args: n
    } = e[t];
    typeof f2[r] == "function" && f2[r](A, n);
  }
}, f2 = {
  M(e, A) {
    return Re = A[0], Ge = A[1], ut = Et = null, xo = Re, ko = Ge, e.moveTo(Re, Ge);
  },
  m(e, A) {
    return Re += A[0], Ge += A[1], ut = Et = null, xo = Re, ko = Ge, e.moveTo(Re, Ge);
  },
  C(e, A) {
    return Re = A[4], Ge = A[5], ut = A[2], Et = A[3], e.bezierCurveTo(...A);
  },
  c(e, A) {
    return e.bezierCurveTo(A[0] + Re, A[1] + Ge, A[2] + Re, A[3] + Ge, A[4] + Re, A[5] + Ge), ut = Re + A[2], Et = Ge + A[3], Re += A[4], Ge += A[5];
  },
  S(e, A) {
    return ut === null && (ut = Re, Et = Ge), e.bezierCurveTo(Re - (ut - Re), Ge - (Et - Ge), A[0], A[1], A[2], A[3]), ut = A[0], Et = A[1], Re = A[2], Ge = A[3];
  },
  s(e, A) {
    return ut === null && (ut = Re, Et = Ge), e.bezierCurveTo(Re - (ut - Re), Ge - (Et - Ge), Re + A[0], Ge + A[1], Re + A[2], Ge + A[3]), ut = Re + A[0], Et = Ge + A[1], Re += A[2], Ge += A[3];
  },
  Q(e, A) {
    return ut = A[0], Et = A[1], Re = A[2], Ge = A[3], e.quadraticCurveTo(A[0], A[1], Re, Ge);
  },
  q(e, A) {
    return e.quadraticCurveTo(A[0] + Re, A[1] + Ge, A[2] + Re, A[3] + Ge), ut = Re + A[0], Et = Ge + A[1], Re += A[2], Ge += A[3];
  },
  T(e, A) {
    return ut === null ? (ut = Re, Et = Ge) : (ut = Re - (ut - Re), Et = Ge - (Et - Ge)), e.quadraticCurveTo(ut, Et, A[0], A[1]), ut = Re - (ut - Re), Et = Ge - (Et - Ge), Re = A[0], Ge = A[1];
  },
  t(e, A) {
    return ut === null ? (ut = Re, Et = Ge) : (ut = Re - (ut - Re), Et = Ge - (Et - Ge)), e.quadraticCurveTo(ut, Et, Re + A[0], Ge + A[1]), Re += A[0], Ge += A[1];
  },
  A(e, A) {
    return d2(e, Re, Ge, A), Re = A[5], Ge = A[6];
  },
  a(e, A) {
    return A[5] += Re, A[6] += Ge, d2(e, Re, Ge, A), Re = A[5], Ge = A[6];
  },
  L(e, A) {
    return Re = A[0], Ge = A[1], ut = Et = null, e.lineTo(Re, Ge);
  },
  l(e, A) {
    return Re += A[0], Ge += A[1], ut = Et = null, e.lineTo(Re, Ge);
  },
  H(e, A) {
    return Re = A[0], ut = Et = null, e.lineTo(Re, Ge);
  },
  h(e, A) {
    return Re += A[0], ut = Et = null, e.lineTo(Re, Ge);
  },
  V(e, A) {
    return Ge = A[0], ut = Et = null, e.lineTo(Re, Ge);
  },
  v(e, A) {
    return Ge += A[0], ut = Et = null, e.lineTo(Re, Ge);
  },
  Z(e) {
    return e.closePath(), Re = xo, Ge = ko;
  },
  z(e) {
    return e.closePath(), Re = xo, Ge = ko;
  }
}, d2 = function(e, A, t, r) {
  const [n, i, a, o, s, l, u] = r, g = EJ(l, u, n, i, o, s, a, A, t);
  for (let d of g) {
    const h = QJ(...d);
    e.bezierCurveTo(...h);
  }
}, EJ = function(e, A, t, r, n, i, a, o, s) {
  const l = a * (Math.PI / 180), u = Math.sin(l), g = Math.cos(l);
  t = Math.abs(t), r = Math.abs(r), ut = g * (o - e) * 0.5 + u * (s - A) * 0.5, Et = g * (s - A) * 0.5 - u * (o - e) * 0.5;
  let d = ut * ut / (t * t) + Et * Et / (r * r);
  d > 1 && (d = Math.sqrt(d), t *= d, r *= d);
  const h = g / t, C = u / t, E = -u / r, I = g / r, b = h * o + C * s, y = E * o + I * s, p = h * e + C * A, Q = E * e + I * A;
  let Y = 1 / ((p - b) * (p - b) + (Q - y) * (Q - y)) - 0.25;
  Y < 0 && (Y = 0);
  let k = Math.sqrt(Y);
  i === n && (k = -k);
  const L = 0.5 * (b + p) - k * (Q - y), S = 0.5 * (y + Q) + k * (p - b), P = Math.atan2(y - S, b - L);
  let M = Math.atan2(Q - S, p - L) - P;
  M < 0 && i === 1 ? M += 2 * Math.PI : M > 0 && i === 0 && (M -= 2 * Math.PI);
  const R = Math.ceil(Math.abs(M / (Math.PI * 0.5 + 1e-3))), G = [];
  for (let N = 0; N < R; N++) {
    const z = P + N * M / R, T = P + (N + 1) * M / R;
    G[N] = [L, S, z, T, t, r, u, g];
  }
  return G;
}, QJ = function(e, A, t, r, n, i, a, o) {
  const s = o * n, l = -a * i, u = a * n, g = o * i, d = 0.5 * (r - t), h = 8 / 3 * Math.sin(d * 0.5) * Math.sin(d * 0.5) / Math.sin(d), C = e + Math.cos(t) - h * Math.sin(t), E = A + Math.sin(t) + h * Math.cos(t), I = e + Math.cos(r), b = A + Math.sin(r), y = I + h * Math.sin(r), p = b - h * Math.cos(r);
  return [s * C + l * E, u * C + g * E, s * y + l * p, u * y + g * p, s * I + l * b, u * I + g * b];
};
class wJ {
  static apply(A, t) {
    const r = hJ(t);
    CJ(r, A);
  }
}
const {
  number: Kt
} = ri, $u = 4 * ((Math.sqrt(2) - 1) / 3);
var IJ = {
  initVector() {
    return this._ctm = [1, 0, 0, 1, 0, 0], this._ctmStack = [];
  },
  save() {
    return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
  },
  restore() {
    return this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0], this.addContent("Q");
  },
  closePath() {
    return this.addContent("h");
  },
  lineWidth(e) {
    return this.addContent(Kt(e) + " w");
  },
  _CAP_STYLES: {
    BUTT: 0,
    ROUND: 1,
    SQUARE: 2
  },
  lineCap(e) {
    return typeof e == "string" && (e = this._CAP_STYLES[e.toUpperCase()]), this.addContent(e + " J");
  },
  _JOIN_STYLES: {
    MITER: 0,
    ROUND: 1,
    BEVEL: 2
  },
  lineJoin(e) {
    return typeof e == "string" && (e = this._JOIN_STYLES[e.toUpperCase()]), this.addContent(e + " j");
  },
  miterLimit(e) {
    return this.addContent(Kt(e) + " M");
  },
  dash(e, A) {
    A === void 0 && (A = {});
    const t = e;
    if (Array.isArray(e) || (e = [e, A.space || e]), !e.every((n) => Number.isFinite(n) && n >= 0))
      throw new Error("dash(" + JSON.stringify(t) + ", " + JSON.stringify(A) + ") invalid, lengths must be numeric and greater than or equal to zero");
    return e = e.map(Kt).join(" "), this.addContent("[" + e + "] " + Kt(A.phase || 0) + " d");
  },
  undash() {
    return this.addContent("[] 0 d");
  },
  moveTo(e, A) {
    return this.addContent(Kt(e) + " " + Kt(A) + " m");
  },
  lineTo(e, A) {
    return this.addContent(Kt(e) + " " + Kt(A) + " l");
  },
  bezierCurveTo(e, A, t, r, n, i) {
    return this.addContent(Kt(e) + " " + Kt(A) + " " + Kt(t) + " " + Kt(r) + " " + Kt(n) + " " + Kt(i) + " c");
  },
  quadraticCurveTo(e, A, t, r) {
    return this.addContent(Kt(e) + " " + Kt(A) + " " + Kt(t) + " " + Kt(r) + " v");
  },
  rect(e, A, t, r) {
    return this.addContent(Kt(e) + " " + Kt(A) + " " + Kt(t) + " " + Kt(r) + " re");
  },
  roundedRect(e, A, t, r, n) {
    n == null && (n = 0), n = Math.min(n, 0.5 * t, 0.5 * r);
    const i = n * (1 - $u);
    return this.moveTo(e + n, A), this.lineTo(e + t - n, A), this.bezierCurveTo(e + t - i, A, e + t, A + i, e + t, A + n), this.lineTo(e + t, A + r - n), this.bezierCurveTo(e + t, A + r - i, e + t - i, A + r, e + t - n, A + r), this.lineTo(e + n, A + r), this.bezierCurveTo(e + i, A + r, e, A + r - i, e, A + r - n), this.lineTo(e, A + n), this.bezierCurveTo(e, A + i, e + i, A, e + n, A), this.closePath();
  },
  ellipse(e, A, t, r) {
    r == null && (r = t), e -= t, A -= r;
    const n = t * $u, i = r * $u, a = e + t * 2, o = A + r * 2, s = e + t, l = A + r;
    return this.moveTo(e, l), this.bezierCurveTo(e, l - i, s - n, A, s, A), this.bezierCurveTo(s + n, A, a, l - i, a, l), this.bezierCurveTo(a, l + i, s + n, o, s, o), this.bezierCurveTo(s - n, o, e, l + i, e, l), this.closePath();
  },
  circle(e, A, t) {
    return this.ellipse(e, A, t);
  },
  arc(e, A, t, r, n, i) {
    i == null && (i = !1);
    const a = 2 * Math.PI, o = 0.5 * Math.PI;
    let s = n - r;
    Math.abs(s) > a ? s = a : s !== 0 && i !== s < 0 && (s = (i ? -1 : 1) * a + s);
    const l = Math.ceil(Math.abs(s) / o), u = s / l, g = u / o * $u * t;
    let d = r, h = -Math.sin(d) * g, C = Math.cos(d) * g, E = e + Math.cos(d) * t, I = A + Math.sin(d) * t;
    this.moveTo(E, I);
    for (let b = 0; b < l; b++) {
      const y = E + h, p = I + C;
      d += u, E = e + Math.cos(d) * t, I = A + Math.sin(d) * t, h = -Math.sin(d) * g, C = Math.cos(d) * g;
      const Q = E - h, w = I - C;
      this.bezierCurveTo(y, p, Q, w, E, I);
    }
    return this;
  },
  polygon() {
    for (var e = arguments.length, A = new Array(e), t = 0; t < e; t++)
      A[t] = arguments[t];
    this.moveTo(...A.shift() || []);
    for (let r of A)
      this.lineTo(...r || []);
    return this.closePath();
  },
  path(e) {
    return wJ.apply(this, e), this;
  },
  _windingRule(e) {
    return /even-?odd/.test(e) ? "*" : "";
  },
  fill(e, A) {
    return /(even-?odd)|(non-?zero)/.test(e) && (A = e, e = null), e && this.fillColor(e), this.addContent("f" + this._windingRule(A));
  },
  stroke(e) {
    return e && this.strokeColor(e), this.addContent("S");
  },
  fillAndStroke(e, A, t) {
    A == null && (A = e);
    const r = /(even-?odd)|(non-?zero)/;
    return r.test(e) && (t = e, e = null), r.test(A) && (t = A, A = e), e && (this.fillColor(e), this.strokeColor(A)), this.addContent("B" + this._windingRule(t));
  },
  clip(e) {
    return this.addContent("W" + this._windingRule(e) + " n");
  },
  transform(e, A, t, r, n, i) {
    if (e === 1 && A === 0 && t === 0 && r === 1 && n === 0 && i === 0)
      return this;
    const a = this._ctm, [o, s, l, u, g, d] = a;
    a[0] = o * e + l * A, a[1] = s * e + u * A, a[2] = o * t + l * r, a[3] = s * t + u * r, a[4] = o * n + l * i + g, a[5] = s * n + u * i + d;
    const h = [e, A, t, r, n, i].map((C) => Kt(C)).join(" ");
    return this.addContent(h + " cm");
  },
  translate(e, A) {
    return this.transform(1, 0, 0, 1, e, A);
  },
  rotate(e, A) {
    A === void 0 && (A = {});
    let t;
    const r = e * Math.PI / 180, n = Math.cos(r), i = Math.sin(r);
    let a = t = 0;
    if (A.origin != null) {
      [a, t] = A.origin;
      const o = a * n - t * i, s = a * i + t * n;
      a -= o, t -= s;
    }
    return this.transform(n, i, -i, n, a, t);
  },
  scale(e, A, t) {
    t === void 0 && (t = {});
    let r;
    A == null && (A = e), typeof A == "object" && (t = A, A = e);
    let n = r = 0;
    return t.origin != null && ([n, r] = t.origin, n -= e * n, r -= A * r), this.transform(e, 0, 0, A, n, r);
  }
}, DJ = {};
const mJ = (e, A, t) => {
  let r = [], n = A + 1;
  for (let i = e; i < n; i++)
    r.push(i);
  return r;
}, h2 = {
  402: 131,
  8211: 150,
  8212: 151,
  8216: 145,
  8217: 146,
  8218: 130,
  8220: 147,
  8221: 148,
  8222: 132,
  8224: 134,
  8225: 135,
  8226: 149,
  8230: 133,
  8364: 128,
  8240: 137,
  8249: 139,
  8250: 155,
  710: 136,
  8482: 153,
  338: 140,
  339: 156,
  732: 152,
  352: 138,
  353: 154,
  376: 159,
  381: 142,
  382: 158
}, C2 = `.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef

space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question

at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore

grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef

Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis

space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown

Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls

agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis`.split(/\s+/);
function MJ(e) {
  const A = {
    attributes: {},
    glyphWidths: {},
    kernPairs: {}
  };
  let t = "";
  for (let s of e.split(`
`)) {
    var r, n;
    if (r = s.match(/^Start(\w+)/)) {
      t = r[1];
      continue;
    } else if (r = s.match(/^End(\w+)/)) {
      t = "";
      continue;
    }
    switch (t) {
      case "FontMetrics":
        r = s.match(/(^\w+)\s+(.*)/);
        var i = r[1], a = r[2];
        (n = A.attributes[i]) ? (Array.isArray(n) || (n = A.attributes[i] = [n]), n.push(a)) : A.attributes[i] = a;
        break;
      case "CharMetrics":
        if (!/^CH?\s/.test(s))
          continue;
        var o = s.match(/\bN\s+(\.?\w+)\s*;/)[1];
        A.glyphWidths[o] = +s.match(/\bWX\s+(\d+)\s*;/)[1];
        break;
      case "KernPairs":
        r = s.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), r && (A.kernPairs[r[1] + r[2]] = parseInt(r[3]));
        break;
    }
  }
  return A;
}
class yE {
  static open(A) {
    throw new Error("AFMFont.open not available on browser build");
  }
  static fromJson(A) {
    return new yE(A);
  }
  constructor(A) {
    typeof A == "string" ? (this.contents = A, this.parse()) : (this.attributes = A.attributes, this.glyphWidths = A.glyphWidths, this.kernPairs = A.kernPairs), this.charWidths = mJ(0, 255).map((t) => this.glyphWidths[C2[t]]), this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map((t) => +t), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
  }
  parse() {
    const A = MJ(this.contents);
    this.attributes = A.attributes, this.glyphWidths = A.glyphWidths, this.kernPairs = A.kernPairs;
  }
  encodeText(A) {
    const t = [];
    for (let r = 0, n = A.length, i = 0 <= n; i ? r < n : r > n; i ? r++ : r--) {
      let a = A.charCodeAt(r);
      a = h2[a] || a, t.push(a.toString(16));
    }
    return t;
  }
  glyphsForString(A) {
    const t = [];
    for (let r = 0, n = A.length, i = 0 <= n; i ? r < n : r > n; i ? r++ : r--) {
      const a = A.charCodeAt(r);
      t.push(this.characterToGlyph(a));
    }
    return t;
  }
  characterToGlyph(A) {
    return C2[h2[A] || A] || ".notdef";
  }
  widthOfGlyph(A) {
    return this.glyphWidths[A] || 0;
  }
  getKernPair(A, t) {
    return this.kernPairs[A + t] || 0;
  }
  advancesForGlyphs(A) {
    const t = [];
    for (let r = 0; r < A.length; r++) {
      const n = A[r], i = A[r + 1];
      t.push(this.widthOfGlyph(n) + this.getKernPair(n, i));
    }
    return t;
  }
}
var pJ = [
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:43:52 1997",
      "UniqueID 43052",
      "VMusage 37169 48194"
    ],
    FontName: "Helvetica-Bold",
    FullName: "Helvetica Bold",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -228 1003 962 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:45:12 1997",
      "UniqueID 43053",
      "VMusage 14482 68586"
    ],
    FontName: "Helvetica-BoldOblique",
    FullName: "Helvetica Bold Oblique",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-174 -228 1114 962",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:44:31 1997",
      "UniqueID 43055",
      "VMusage 14960 69346"
    ],
    FontName: "Helvetica-Oblique",
    FullName: "Helvetica Oblique",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -225 1116 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:38:23 1997",
      "UniqueID 43054",
      "VMusage 37069 48094"
    ],
    FontName: "Helvetica",
    FullName: "Helvetica",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-166 -225 1000 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:52:56 1997",
      "UniqueID 43065",
      "VMusage 41636 52661"
    ],
    FontName: "Times-Bold",
    FullName: "Times Bold",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 935 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "676",
    XHeight: "461",
    Ascender: "683",
    Descender: "-217",
    StdHW: "44",
    StdVW: "139"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 13:04:06 1997",
      "UniqueID 43066",
      "VMusage 45874 56899"
    ],
    FontName: "Times-BoldItalic",
    FullName: "Times Bold Italic",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "-15",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-200 -218 996 921",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "669",
    XHeight: "462",
    Ascender: "683",
    Descender: "-217",
    StdHW: "42",
    StdVW: "121"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:56:55 1997",
      "UniqueID 43067",
      "VMusage 47727 58752"
    ],
    FontName: "Times-Italic",
    FullName: "Times Italic",
    FamilyName: "Times",
    Weight: "Medium",
    ItalicAngle: "-15.5",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-169 -217 1010 883 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "653",
    XHeight: "441",
    Ascender: "683",
    Descender: "-217",
    StdHW: "32",
    StdVW: "76"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:49:17 1997",
      "UniqueID 43068",
      "VMusage 43909 54934"
    ],
    FontName: "Times-Roman",
    FullName: "Times Roman",
    FamilyName: "Times",
    Weight: "Roman",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 898 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "662",
    XHeight: "450",
    Ascender: "683",
    Descender: "-217",
    StdHW: "28",
    StdVW: "84"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:00 1997",
      "UniqueID 43048",
      "VMusage 41139 52164"
    ],
    FontName: "Courier-Bold",
    FullName: "Courier Bold",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-113 -250 749 801 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:46 1997",
      "UniqueID 43049",
      "VMusage 17529 79244"
    ],
    FontName: "Courier-BoldOblique",
    FullName: "Courier Bold Oblique",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-57 -250 869 801",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:37:52 1997",
      "UniqueID 43051",
      "VMusage 16248 75829"
    ],
    FontName: "Courier-Oblique",
    FullName: "Courier Oblique",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-27 -250 849 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:27:09 1997",
      "UniqueID 43050",
      "VMusage 39754 50779"
    ],
    FontName: "Courier",
    FullName: "Courier",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-23 -250 715 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  }
], vJ = {
  space: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  exclam: [
    333,
    333,
    278,
    278,
    333,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedbl: [
    474,
    474,
    355,
    355,
    555,
    555,
    420,
    408,
    600,
    600,
    600,
    600
  ],
  numbersign: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dollar: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  percent: [
    889,
    889,
    889,
    889,
    1e3,
    833,
    833,
    833,
    600,
    600,
    600,
    600
  ],
  ampersand: [
    722,
    722,
    667,
    667,
    833,
    778,
    778,
    778,
    600,
    600,
    600,
    600
  ],
  quoteright: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  asterisk: [
    389,
    389,
    389,
    389,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  plus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  comma: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  hyphen: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  period: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  slash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  zero: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  one: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  two: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  three: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  four: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  five: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  six: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  seven: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eight: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  nine: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  colon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  semicolon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  less: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  equal: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  greater: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  question: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  at: [
    975,
    975,
    1015,
    1015,
    930,
    832,
    920,
    921,
    600,
    600,
    600,
    600
  ],
  A: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  B: [
    722,
    722,
    667,
    667,
    667,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  C: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  D: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  E: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  F: [
    611,
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  G: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  H: [
    722,
    722,
    722,
    722,
    778,
    778,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  I: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  J: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    389,
    600,
    600,
    600,
    600
  ],
  K: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  L: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  M: [
    833,
    833,
    833,
    833,
    944,
    889,
    833,
    889,
    600,
    600,
    600,
    600
  ],
  N: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  O: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  P: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Q: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  R: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  S: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  T: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  U: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  V: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  W: [
    944,
    944,
    944,
    944,
    1e3,
    889,
    833,
    944,
    600,
    600,
    600,
    600
  ],
  X: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Y: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Z: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  bracketleft: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  backslash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  bracketright: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  asciicircum: [
    584,
    584,
    469,
    469,
    581,
    570,
    422,
    469,
    600,
    600,
    600,
    600
  ],
  underscore: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quoteleft: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  a: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  b: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  c: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  d: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  e: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  f: [
    333,
    333,
    278,
    278,
    333,
    333,
    278,
    333,
    600,
    600,
    600,
    600
  ],
  g: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  h: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  i: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  j: [
    278,
    278,
    222,
    222,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  k: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  l: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  m: [
    889,
    889,
    833,
    833,
    833,
    778,
    722,
    778,
    600,
    600,
    600,
    600
  ],
  n: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  o: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  p: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  q: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  r: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  s: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  t: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  u: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  v: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  w: [
    778,
    778,
    722,
    722,
    722,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  x: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  y: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  z: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  braceleft: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  bar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  braceright: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  asciitilde: [
    584,
    584,
    584,
    584,
    520,
    570,
    541,
    541,
    600,
    600,
    600,
    600
  ],
  exclamdown: [
    333,
    333,
    333,
    333,
    333,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  cent: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  sterling: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  fraction: [
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    600,
    600,
    600,
    600
  ],
  yen: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  florin: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  section: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  currency: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quotesingle: [
    238,
    238,
    191,
    191,
    278,
    278,
    214,
    180,
    600,
    600,
    600,
    600
  ],
  quotedblleft: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotleft: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  guilsinglleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  guilsinglright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  fi: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  fl: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  endash: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dagger: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  daggerdbl: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  periodcentered: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  paragraph: [
    556,
    556,
    537,
    537,
    540,
    500,
    523,
    453,
    600,
    600,
    600,
    600
  ],
  bullet: [
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    600,
    600,
    600,
    600
  ],
  quotesinglbase: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedblbase: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  quotedblright: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotright: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ellipsis: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  perthousand: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    600,
    600,
    600,
    600
  ],
  questiondown: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  grave: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  acute: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  circumflex: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  tilde: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  macron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  breve: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dotaccent: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dieresis: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ring: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  cedilla: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  hungarumlaut: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ogonek: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  caron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  emdash: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  AE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    889,
    889,
    600,
    600,
    600,
    600
  ],
  ordfeminine: [
    370,
    370,
    370,
    370,
    300,
    266,
    276,
    276,
    600,
    600,
    600,
    600
  ],
  Lslash: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Oslash: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  OE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    944,
    889,
    600,
    600,
    600,
    600
  ],
  ordmasculine: [
    365,
    365,
    365,
    365,
    330,
    300,
    310,
    310,
    600,
    600,
    600,
    600
  ],
  ae: [
    889,
    889,
    889,
    889,
    722,
    722,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  dotlessi: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lslash: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  oslash: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  oe: [
    944,
    944,
    944,
    944,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  germandbls: [
    611,
    611,
    611,
    611,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Idieresis: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  eacute: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  abreve: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  uhungarumlaut: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ecaron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Ydieresis: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  divide: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Yacute: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Acircumflex: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  aacute: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ucircumflex: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  yacute: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  scommaaccent: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  ecircumflex: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uring: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Udieresis: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  aogonek: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Uacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uogonek: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Edieresis: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Dcroat: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  commaaccent: [
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  copyright: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Emacron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  ccaron: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  aring: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ncommaaccent: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  lacute: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  agrave: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Tcommaaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Cacute: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  atilde: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Edotaccent: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  scaron: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  scedilla: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  iacute: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lozenge: [
    494,
    494,
    471,
    471,
    494,
    494,
    471,
    471,
    600,
    600,
    600,
    600
  ],
  Rcaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Gcommaaccent: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  ucircumflex: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  acircumflex: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Amacron: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  rcaron: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  ccedilla: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Zdotaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Thorn: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Omacron: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Racute: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Sacute: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  dcaron: [
    743,
    743,
    643,
    643,
    672,
    608,
    544,
    588,
    600,
    600,
    600,
    600
  ],
  Umacron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uring: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Ograve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Agrave: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Abreve: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  multiply: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  uacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Tcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  partialdiff: [
    494,
    494,
    476,
    476,
    494,
    494,
    476,
    476,
    600,
    600,
    600,
    600
  ],
  ydieresis: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  Nacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  icircumflex: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ecircumflex: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  adieresis: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  edieresis: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  cacute: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  nacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  umacron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ncaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Iacute: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  plusminus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  brokenbar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  registered: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Gbreve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Idotaccent: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  summation: [
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600
  ],
  Egrave: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  racute: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  omacron: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Zacute: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Zcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  greaterequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  Eth: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ccedilla: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  lcommaaccent: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  tcaron: [
    389,
    389,
    317,
    317,
    416,
    366,
    300,
    326,
    600,
    600,
    600,
    600
  ],
  eogonek: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uogonek: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Aacute: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Adieresis: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  egrave: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  zacute: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  iogonek: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Oacute: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  oacute: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  amacron: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  sacute: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  idieresis: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ocircumflex: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ugrave: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Delta: [
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    600,
    600,
    600,
    600
  ],
  thorn: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  twosuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Odieresis: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  mu: [
    611,
    611,
    556,
    556,
    556,
    576,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  igrave: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  ohungarumlaut: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Eogonek: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  dcroat: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threequarters: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scedilla: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  lcaron: [
    400,
    400,
    299,
    299,
    394,
    382,
    300,
    344,
    600,
    600,
    600,
    600
  ],
  Kcommaaccent: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Lacute: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  trademark: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    980,
    980,
    600,
    600,
    600,
    600
  ],
  edotaccent: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Igrave: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Imacron: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Lcaron: [
    611,
    611,
    556,
    556,
    667,
    611,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  onehalf: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  lessequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  ocircumflex: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ntilde: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Uhungarumlaut: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Eacute: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  emacron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  gbreve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onequarter: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scaron: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Scommaaccent: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Ohungarumlaut: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  degree: [
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    600,
    600,
    600,
    600
  ],
  ograve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ccaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  ugrave: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  radical: [
    549,
    549,
    453,
    453,
    549,
    549,
    453,
    453,
    600,
    600,
    600,
    600
  ],
  Dcaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  rcommaaccent: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  Ntilde: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  otilde: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Rcommaaccent: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Lcommaaccent: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Atilde: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aogonek: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aring: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Otilde: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  zdotaccent: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  Ecaron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Iogonek: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  kcommaaccent: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  minus: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Icircumflex: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ncaron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  tcommaaccent: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  logicalnot: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  odieresis: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  udieresis: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  notequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  gcommaaccent: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eth: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  zcaron: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  ncommaaccent: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  imacron: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Euro: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ]
}, yJ = {
  AC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Au: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Audieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Augrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Av: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Ay: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Ayacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AacuteC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AacuteT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AacuteW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AacuteY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aacuteu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacutev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aacutew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aacutey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AbreveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AbreveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AbreveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AbreveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Abreveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abrevev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Abrevew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Abrevey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AcircumflexC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AcircumflexT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AcircumflexW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AcircumflexY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Acircumflexu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Acircumflexw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Acircumflexy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AdieresisC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AdieresisT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AdieresisW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AdieresisY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Adieresisu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Adieresisw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Adieresisy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AgraveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AgraveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AgraveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AgraveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Agraveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agravev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Agravew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Agravey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AmacronC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AmacronT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AmacronW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AmacronY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Amacronu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Amacronw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Amacrony: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AogonekC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AogonekT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AogonekW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AogonekY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aogoneku: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aogonekw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -52
  ],
  Aogoneky: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekyacute: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekydieresis: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  AringC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AringT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AringW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AringY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aringu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aringw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aringy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AtildeC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AtildeT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AtildeW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AtildeY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Atildeu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Atildew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Atildey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  BA: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAacute: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAbreve: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAcircumflex: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAdieresis: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAgrave: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAmacron: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAogonek: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAring: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAtilde: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  DA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcaronA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcaronW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcaronY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcaroncomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcaronperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcroatA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcroatW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcroatY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcroatcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcroatperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  FA: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAacute: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAbreve: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAgrave: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAmacron: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAogonek: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAring: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAtilde: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  Fa: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faacute: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fabreve: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Facircumflex: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fadieresis: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fagrave: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Famacron: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faogonek: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faring: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fatilde: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fcomma: [
    -100,
    -100,
    -150,
    -150,
    -92,
    -129,
    -135,
    -80
  ],
  Fperiod: [
    -100,
    -100,
    -150,
    -150,
    -110,
    -129,
    -135,
    -80
  ],
  JA: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAbreve: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAogonek: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAring: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  Jcomma: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    -25
  ],
  Jperiod: [
    -20,
    -20,
    -30,
    -30,
    -20,
    -10,
    -25
  ],
  Ju: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juacute: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Judieresis: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jugrave: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jumacron: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juogonek: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juring: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  KO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Ke: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Ko: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Komacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Ku: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuring: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Ky: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  KcommaaccentO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Kcommaaccente: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccento: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentomacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentu: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenturing: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenty: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  LT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Ly: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LacuteT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LacuteW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LacuteY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lacutequotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lacutequoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lacutey: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LcommaaccentT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LcommaaccentW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LcommaaccentY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lcommaaccentquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lcommaaccentquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lcommaaccenty: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LslashT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LslashW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LslashY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lslashquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lslashquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lslashy: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  OA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Operiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OacuteA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OacuteX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oacutecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oacuteperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OcircumflexX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocircumflexcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ocircumflexperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OdieresisX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Odieresiscomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Odieresisperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OgraveA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OgraveX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ogravecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ograveperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OhungarumlautX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ohungarumlautcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ohungarumlautperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OmacronA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OmacronX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Omacroncomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Omacronperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OslashA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OslashW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OslashX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OslashY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oslashcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oslashperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OtildeA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OtildeX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Otildecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Otildeperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  PA: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAacute: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAbreve: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAcircumflex: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAdieresis: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAgrave: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAmacron: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAogonek: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAring: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAtilde: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  Pa: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paacute: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pabreve: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pacircumflex: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Padieresis: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pagrave: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pamacron: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paogonek: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paring: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Patilde: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pcomma: [
    -120,
    -120,
    -180,
    -180,
    -92,
    -129,
    -135,
    -111
  ],
  Pe: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peacute: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecaron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecircumflex: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedieresis: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedotaccent: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pegrave: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pemacron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peogonek: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Po: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poacute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pocircumflex: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Podieresis: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pograve: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pohungarumlaut: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pomacron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poslash: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Potilde: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pperiod: [
    -120,
    -120,
    -180,
    -180,
    -110,
    -129,
    -135,
    -111
  ],
  QU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  Qcomma: [
    20,
    20
  ],
  Qperiod: [
    20,
    20,
    0,
    0,
    -20
  ],
  RO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RacuteW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RacuteY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcaronW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcaronY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcommaaccentW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcommaaccentY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  TA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Ta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Taogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Te: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Teacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -70
  ],
  Tedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Temacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Teogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Thyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  To: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Toacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Todieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Toslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Totilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Trcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Turing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Ty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcaronA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcarona: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaroncolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcaroncomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcarone: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaroneacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcaronedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaronedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcaronemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaroneogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronhyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcarono: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcaronr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcaronu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuring: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcarony: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcommaaccentA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcommaaccenta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcommaaccentcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcommaaccente: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenteacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcommaaccentedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcommaaccenteogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenthyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcommaaccento: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcommaaccentr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcommaaccentu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccenturing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcommaaccenty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  UA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UacuteA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uacutecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uacuteperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UcircumflexA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucircumflexcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ucircumflexperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UdieresisA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Udieresiscomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Udieresisperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UgraveA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ugravecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ugraveperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UhungarumlautA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uhungarumlautcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uhungarumlautperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UmacronA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Umacroncomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Umacronperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UogonekA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uogonekcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uogonekperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UringA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uringcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uringperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  VA: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAacute: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAbreve: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAgrave: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAmacron: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAogonek: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAring: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAtilde: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VG: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGbreve: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGcommaaccent: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VO: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOacute: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOdieresis: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOgrave: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOhungarumlaut: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOmacron: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOslash: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOtilde: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  Va: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vaacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vabreve: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vacircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vadieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vagrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vamacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vaogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Varing: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vatilde: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vcolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -65,
    -74
  ],
  Vcomma: [
    -120,
    -120,
    -125,
    -125,
    -129,
    -129,
    -129,
    -129
  ],
  Ve: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Veacute: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vecaron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vecircumflex: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vedieresis: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vedotaccent: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vegrave: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vemacron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Veogonek: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vhyphen: [
    -80,
    -80,
    -80,
    -80,
    -74,
    -70,
    -55,
    -100
  ],
  Vo: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Voacute: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vocircumflex: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vodieresis: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vograve: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vohungarumlaut: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vomacron: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Voslash: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Votilde: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vperiod: [
    -120,
    -120,
    -125,
    -125,
    -145,
    -129,
    -129,
    -129
  ],
  Vsemicolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -74,
    -74
  ],
  Vu: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vucircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vudieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vugrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuhungarumlaut: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vumacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuring: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  WA: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAacute: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAbreve: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAcircumflex: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAdieresis: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAgrave: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAmacron: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAogonek: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAring: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAtilde: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WO: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOacute: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOgrave: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOmacron: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOslash: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOtilde: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  Wa: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waacute: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wabreve: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wacircumflex: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wadieresis: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wagrave: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wamacron: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waogonek: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waring: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Watilde: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wcolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wcomma: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  We: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Weacute: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecaron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecircumflex: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wedieresis: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wedotaccent: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wegrave: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wemacron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Weogonek: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Whyphen: [
    -40,
    -40,
    -40,
    -40,
    -37,
    -50,
    -37,
    -65
  ],
  Wo: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woacute: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wocircumflex: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wodieresis: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wograve: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wohungarumlaut: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Womacron: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woslash: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wotilde: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wperiod: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  Wsemicolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wu: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuacute: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wucircumflex: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wudieresis: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wugrave: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuhungarumlaut: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wumacron: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuogonek: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuring: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wy: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wyacute: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wydieresis: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  YA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ya: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yatilde: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ycolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ycomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ye: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ysemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YacuteA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Yacutea: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacutearing: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacutecolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacutecomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Yacutee: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yacuteedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteomacron: [
    -100,
    -100,
    -70,
    -70,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Yacutesemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacuteu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YdieresisA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ydieresisa: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresiscolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresiscomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ydieresise: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiseacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Ydieresisedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresiseogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiso: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ydieresissemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresisu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  ag: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  av: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  ay: [
    -20,
    -20,
    -30,
    -30
  ],
  ayacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aacutey: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  abrevew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  abrevey: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  acircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  acircumflexy: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  adieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  adieresisy: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  agravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  agravey: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  amacrong: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacronv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  amacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  amacrony: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aogoneky: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aringg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aringw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aringy: [
    -20,
    -20,
    -30,
    -30
  ],
  aringyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aringydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  atildew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  atildey: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  bl: [
    -10,
    -10,
    -20,
    -20
  ],
  blacute: [
    -10,
    -10,
    -20,
    -20
  ],
  blcommaaccent: [
    -10,
    -10,
    -20,
    -20
  ],
  blslash: [
    -10,
    -10,
    -20,
    -20
  ],
  bu: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buacute: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  budieresis: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bugrave: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bumacron: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buogonek: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buring: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bv: [
    -20,
    -20,
    -20,
    -20,
    -15,
    0,
    0,
    -15
  ],
  by: [
    -20,
    -20,
    -20,
    -20
  ],
  byacute: [
    -20,
    -20,
    -20,
    -20
  ],
  bydieresis: [
    -20,
    -20,
    -20,
    -20
  ],
  ch: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ck: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ckcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cl: [
    -20,
    -20
  ],
  clacute: [
    -20,
    -20
  ],
  clcommaaccent: [
    -20,
    -20
  ],
  clslash: [
    -20,
    -20
  ],
  cy: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  cacutek: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutekcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutel: [
    -20,
    -20
  ],
  cacutelacute: [
    -20,
    -20
  ],
  cacutelcommaaccent: [
    -20,
    -20
  ],
  cacutelslash: [
    -20,
    -20
  ],
  cacutey: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccaronk: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronkcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronl: [
    -20,
    -20
  ],
  ccaronlacute: [
    -20,
    -20
  ],
  ccaronlcommaaccent: [
    -20,
    -20
  ],
  ccaronlslash: [
    -20,
    -20
  ],
  ccarony: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillah: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccedillak: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillakcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillal: [
    -20,
    -20
  ],
  ccedillalacute: [
    -20,
    -20
  ],
  ccedillalcommaaccent: [
    -20,
    -20
  ],
  ccedillalslash: [
    -20,
    -20
  ],
  ccedillay: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillayacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillaydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  colonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  commaquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -45,
    -95,
    -140,
    -70
  ],
  commaquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  commaspace: [
    -40,
    -40
  ],
  dd: [
    -10,
    -10
  ],
  ddcroat: [
    -10,
    -10
  ],
  dv: [
    -15,
    -15
  ],
  dw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dy: [
    -15,
    -15
  ],
  dyacute: [
    -15,
    -15
  ],
  dydieresis: [
    -15,
    -15
  ],
  dcroatd: [
    -10,
    -10
  ],
  dcroatdcroat: [
    -10,
    -10
  ],
  dcroatv: [
    -15,
    -15
  ],
  dcroatw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dcroaty: [
    -15,
    -15
  ],
  dcroatyacute: [
    -15,
    -15
  ],
  dcroatydieresis: [
    -15,
    -15
  ],
  ecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacutecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eacuteperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eacutev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eacutex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eacutey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecaronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecaronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecaronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecaronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecarony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecircumflexperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecircumflexv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecircumflexx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecircumflexy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresiscomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edieresisperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edieresisv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edieresisx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edieresisy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edotaccentperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edotaccentv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edotaccentw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edotaccentx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edotaccenty: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egravecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  egraveperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  egravev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  egravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  egravex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  egravey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  emacronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  emacronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  emacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  emacronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  emacrony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eogonekperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eogonekv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eogonekx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eogoneky: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  fcomma: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -10
  ],
  fe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  feacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fecaron: [
    -10,
    -10,
    -30,
    -30
  ],
  fecircumflex: [
    -10,
    -10,
    -30,
    -30
  ],
  fedieresis: [
    -10,
    -10,
    -30,
    -30
  ],
  fedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fegrave: [
    -10,
    -10,
    -30,
    -30
  ],
  femacron: [
    -10,
    -10,
    -30,
    -30
  ],
  feogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fo: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  foacute: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  focircumflex: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fodieresis: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  fograve: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fohungarumlaut: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fomacron: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  foslash: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fotilde: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fperiod: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -15
  ],
  fquotedblright: [
    30,
    30,
    60,
    60,
    50
  ],
  fquoteright: [
    30,
    30,
    50,
    50,
    55,
    55,
    92,
    55
  ],
  ge: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevee: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccente: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  hy: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hyacute: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hydieresis: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  ko: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  komacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccento: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentomacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  lw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ly: [
    -15,
    -15
  ],
  lyacute: [
    -15,
    -15
  ],
  lydieresis: [
    -15,
    -15
  ],
  lacutew: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lacutey: [
    -15,
    -15
  ],
  lacuteyacute: [
    -15,
    -15
  ],
  lacuteydieresis: [
    -15,
    -15
  ],
  lcommaaccentw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lcommaaccenty: [
    -15,
    -15
  ],
  lcommaaccentyacute: [
    -15,
    -15
  ],
  lcommaaccentydieresis: [
    -15,
    -15
  ],
  lslashw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lslashy: [
    -15,
    -15
  ],
  lslashyacute: [
    -15,
    -15
  ],
  lslashydieresis: [
    -15,
    -15
  ],
  mu: [
    -20,
    -20,
    -10,
    -10
  ],
  muacute: [
    -20,
    -20,
    -10,
    -10
  ],
  mucircumflex: [
    -20,
    -20,
    -10,
    -10
  ],
  mudieresis: [
    -20,
    -20,
    -10,
    -10
  ],
  mugrave: [
    -20,
    -20,
    -10,
    -10
  ],
  muhungarumlaut: [
    -20,
    -20,
    -10,
    -10
  ],
  mumacron: [
    -20,
    -20,
    -10,
    -10
  ],
  muogonek: [
    -20,
    -20,
    -10,
    -10
  ],
  muring: [
    -20,
    -20,
    -10,
    -10
  ],
  my: [
    -30,
    -30,
    -15,
    -15
  ],
  myacute: [
    -30,
    -30,
    -15,
    -15
  ],
  mydieresis: [
    -30,
    -30,
    -15,
    -15
  ],
  nu: [
    -10,
    -10,
    -10,
    -10
  ],
  nuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  numacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ny: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteu: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nacutev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  nacutey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncarony: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccenturing: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncommaaccenty: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeu: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ntildey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ov: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ow: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ox: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacutev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  oacutew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  oacutex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oacutey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ocircumflexw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ocircumflexx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ocircumflexy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  odieresisw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  odieresisx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  odieresisy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ogravev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ogravew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ogravex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ogravey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ohungarumlautw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ohungarumlautx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ohungarumlauty: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  omacronw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  omacronx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  omacrony: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oslashv: [
    -20,
    -20,
    -70,
    -70,
    -10,
    -15,
    -10,
    -15
  ],
  oslashw: [
    -15,
    -15,
    -70,
    -70,
    -10,
    -25,
    0,
    -25
  ],
  oslashx: [
    -30,
    -30,
    -85,
    -85,
    0,
    -10
  ],
  oslashy: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashyacute: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashydieresis: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  otildev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  otildew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  otildex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  otildey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  py: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pyacute: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pydieresis: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  periodquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodspace: [
    -40,
    -40,
    -60,
    -60
  ],
  quotedblrightspace: [
    -80,
    -80,
    -40,
    -40
  ],
  quoteleftquoteleft: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightd: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightdcroat: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightl: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlacute: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlcommaaccent: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlslash: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightquoteright: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightr: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightracute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcaron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcommaaccent: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterights: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightsacute: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscaron: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscedilla: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscommaaccent: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightspace: [
    -80,
    -80,
    -70,
    -70,
    -74,
    -74,
    -111,
    -74
  ],
  quoterightv: [
    -20,
    -20,
    0,
    0,
    -20,
    -15,
    -10,
    -50
  ],
  rc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  ro: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  romacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rs: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rt: [
    20,
    20,
    40,
    40
  ],
  rtcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rv: [
    10,
    10,
    30,
    30,
    -10
  ],
  ry: [
    10,
    10,
    30,
    30
  ],
  ryacute: [
    10,
    10,
    30,
    30
  ],
  rydieresis: [
    10,
    10,
    30,
    30
  ],
  racutec: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  racuted: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racutedcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racuteg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutehyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  racuteo: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  racuteq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutes: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutesacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutet: [
    20,
    20,
    40,
    40
  ],
  racutetcommaaccent: [
    20,
    20,
    40,
    40
  ],
  racutev: [
    10,
    10,
    30,
    30,
    -10
  ],
  racutey: [
    10,
    10,
    30,
    30
  ],
  racuteyacute: [
    10,
    10,
    30,
    30
  ],
  racuteydieresis: [
    10,
    10,
    30,
    30
  ],
  rcaronc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcarond: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarondcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarong: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcaronhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcarono: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcaronq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarons: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaront: [
    20,
    20,
    40,
    40
  ],
  rcarontcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcaronv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcarony: [
    10,
    10,
    30,
    30
  ],
  rcaronyacute: [
    10,
    10,
    30,
    30
  ],
  rcaronydieresis: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcommaaccentd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccenthyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcommaaccento: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcommaaccentq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccents: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentt: [
    20,
    20,
    40,
    40
  ],
  rcommaaccenttcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcommaaccentv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcommaaccenty: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentyacute: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentydieresis: [
    10,
    10,
    30,
    30
  ],
  sw: [
    -15,
    -15,
    -30,
    -30
  ],
  sacutew: [
    -15,
    -15,
    -30,
    -30
  ],
  scaronw: [
    -15,
    -15,
    -30,
    -30
  ],
  scedillaw: [
    -15,
    -15,
    -30,
    -30
  ],
  scommaaccentw: [
    -15,
    -15,
    -30,
    -30
  ],
  semicolonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  spaceT: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcaron: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcommaaccent: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceV: [
    -80,
    -80,
    -50,
    -50,
    -45,
    -70,
    -35,
    -50
  ],
  spaceW: [
    -80,
    -80,
    -40,
    -40,
    -30,
    -70,
    -40,
    -30
  ],
  spaceY: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYacute: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYdieresis: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spacequotedblleft: [
    -80,
    -80,
    -30,
    -30
  ],
  spacequoteleft: [
    -60,
    -60,
    -60,
    -60
  ],
  va: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaacute: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vabreve: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vacircumflex: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vadieresis: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vagrave: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vamacron: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaogonek: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  varing: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vatilde: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vcomma: [
    -80,
    -80,
    -80,
    -80,
    -55,
    -37,
    -74,
    -65
  ],
  vo: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voacute: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vocircumflex: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vodieresis: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vograve: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vohungarumlaut: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vomacron: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voslash: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  votilde: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vperiod: [
    -80,
    -80,
    -80,
    -80,
    -70,
    -37,
    -74,
    -65
  ],
  wcomma: [
    -40,
    -40,
    -60,
    -60,
    -55,
    -37,
    -74,
    -65
  ],
  wo: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woacute: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wocircumflex: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wodieresis: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wograve: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wohungarumlaut: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  womacron: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woslash: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wotilde: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wperiod: [
    -40,
    -40,
    -60,
    -60,
    -70,
    -37,
    -74,
    -65
  ],
  xe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecaron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecircumflex: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedieresis: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xegrave: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xemacron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  ya: [
    -30,
    -30,
    -20,
    -20
  ],
  yaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yaring: [
    -30,
    -30,
    -20,
    -20
  ],
  yatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ycomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ye: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  yacutea: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutearing: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutecomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  yacutee: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ydieresisa: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaring: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresiscomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ydieresise: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiso: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ze: [
    10,
    10,
    -15,
    -15
  ],
  zeacute: [
    10,
    10,
    -15,
    -15
  ],
  zecaron: [
    10,
    10,
    -15,
    -15
  ],
  zecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zegrave: [
    10,
    10,
    -15,
    -15
  ],
  zemacron: [
    10,
    10,
    -15,
    -15
  ],
  zeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zacutee: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeacute: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecaron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zacuteegrave: [
    10,
    10,
    -15,
    -15
  ],
  zacuteemacron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zcarone: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneacute: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecaron: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zcaronegrave: [
    10,
    10,
    -15,
    -15
  ],
  zcaronemacron: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneogonek: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccente: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteacute: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecaron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentegrave: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentemacron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteogonek: [
    10,
    10,
    -15,
    -15
  ],
  Bcomma: [
    0,
    0,
    -20,
    -20
  ],
  Bperiod: [
    0,
    0,
    -20,
    -20
  ],
  Ccomma: [
    0,
    0,
    -30,
    -30
  ],
  Cperiod: [
    0,
    0,
    -30,
    -30
  ],
  Cacutecomma: [
    0,
    0,
    -30,
    -30
  ],
  Cacuteperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccaroncomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccaronperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillacomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillaperiod: [
    0,
    0,
    -30,
    -30
  ],
  Fe: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecaron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedotaccent: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fegrave: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Femacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feogonek: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fo: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Focircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fodieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fograve: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fohungarumlaut: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fomacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foslash: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fotilde: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fr: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Fracute: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcaron: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcommaaccent: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Ja: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaacute: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jabreve: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jacircumflex: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jadieresis: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jagrave: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jamacron: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaogonek: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaring: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jatilde: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  LcaronT: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcaron: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcommaaccent: [
    0,
    0,
    -110,
    -110
  ],
  LcaronV: [
    0,
    0,
    -110,
    -110
  ],
  LcaronW: [
    0,
    0,
    -70,
    -70
  ],
  LcaronY: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYacute: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYdieresis: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquotedblright: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquoteright: [
    0,
    0,
    -160,
    -160,
    0,
    0,
    0,
    -92
  ],
  Lcarony: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronyacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronydieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Scomma: [
    0,
    0,
    -20,
    -20
  ],
  Speriod: [
    0,
    0,
    -20,
    -20
  ],
  Sacutecomma: [
    0,
    0,
    -20,
    -20
  ],
  Sacuteperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scaroncomma: [
    0,
    0,
    -20,
    -20
  ],
  Scaronperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scedillacomma: [
    0,
    0,
    -20,
    -20
  ],
  Scedillaperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentcomma: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentperiod: [
    0,
    0,
    -20,
    -20
  ],
  Trcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Yhyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacutehyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yacutei: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresishyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Ydieresisi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  bb: [
    0,
    0,
    -10,
    -10,
    -10,
    -10
  ],
  bcomma: [
    0,
    0,
    -40,
    -40
  ],
  bperiod: [
    0,
    0,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  ccomma: [
    0,
    0,
    -15,
    -15
  ],
  cacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  ccaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  ccedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  fa: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fabreve: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  facircumflex: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fadieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fagrave: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  famacron: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faogonek: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faring: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fatilde: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fdotlessi: [
    0,
    0,
    -28,
    -28,
    -35,
    -30,
    -60,
    -50
  ],
  gr: [
    0,
    0,
    -10,
    -10
  ],
  gracute: [
    0,
    0,
    -10,
    -10
  ],
  grcaron: [
    0,
    0,
    -10,
    -10
  ],
  grcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gbrever: [
    0,
    0,
    -10,
    -10
  ],
  gbreveracute: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercaron: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentr: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentracute: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcaron: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  ke: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccente: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  ocomma: [
    0,
    0,
    -40,
    -40
  ],
  operiod: [
    0,
    0,
    -40,
    -40
  ],
  oacutecomma: [
    0,
    0,
    -40,
    -40
  ],
  oacuteperiod: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexcomma: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexperiod: [
    0,
    0,
    -40,
    -40
  ],
  odieresiscomma: [
    0,
    0,
    -40,
    -40
  ],
  odieresisperiod: [
    0,
    0,
    -40,
    -40
  ],
  ogravecomma: [
    0,
    0,
    -40,
    -40
  ],
  ograveperiod: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautcomma: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautperiod: [
    0,
    0,
    -40,
    -40
  ],
  omacroncomma: [
    0,
    0,
    -40,
    -40
  ],
  omacronperiod: [
    0,
    0,
    -40,
    -40
  ],
  oslasha: [
    0,
    0,
    -55,
    -55
  ],
  oslashaacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashabreve: [
    0,
    0,
    -55,
    -55
  ],
  oslashacircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashadieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashagrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashamacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashaogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslasharing: [
    0,
    0,
    -55,
    -55
  ],
  oslashatilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashb: [
    0,
    0,
    -55,
    -55
  ],
  oslashc: [
    0,
    0,
    -55,
    -55
  ],
  oslashcacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashccaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashccedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashcomma: [
    0,
    0,
    -95,
    -95
  ],
  oslashd: [
    0,
    0,
    -55,
    -55
  ],
  oslashdcroat: [
    0,
    0,
    -55,
    -55
  ],
  oslashe: [
    0,
    0,
    -55,
    -55
  ],
  oslasheacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashecaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashecircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashedieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashedotaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashegrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashemacron: [
    0,
    0,
    -55,
    -55
  ],
  oslasheogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashf: [
    0,
    0,
    -55,
    -55
  ],
  oslashg: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgbreve: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgcommaaccent: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashh: [
    0,
    0,
    -55,
    -55
  ],
  oslashi: [
    0,
    0,
    -55,
    -55
  ],
  oslashiacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashicircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashidieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashigrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashimacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashiogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashj: [
    0,
    0,
    -55,
    -55
  ],
  oslashk: [
    0,
    0,
    -55,
    -55
  ],
  oslashkcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashl: [
    0,
    0,
    -55,
    -55
  ],
  oslashlacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashlcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashlslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashm: [
    0,
    0,
    -55,
    -55
  ],
  oslashn: [
    0,
    0,
    -55,
    -55
  ],
  oslashnacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashncaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashncommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashntilde: [
    0,
    0,
    -55,
    -55
  ],
  oslasho: [
    0,
    0,
    -55,
    -55
  ],
  oslashoacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashocircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashodieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashograve: [
    0,
    0,
    -55,
    -55
  ],
  oslashohungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashomacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashoslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashotilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashp: [
    0,
    0,
    -55,
    -55
  ],
  oslashperiod: [
    0,
    0,
    -95,
    -95
  ],
  oslashq: [
    0,
    0,
    -55,
    -55
  ],
  oslashr: [
    0,
    0,
    -55,
    -55
  ],
  oslashracute: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashs: [
    0,
    0,
    -55,
    -55
  ],
  oslashsacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashscaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashscedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashscommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslasht: [
    0,
    0,
    -55,
    -55
  ],
  oslashtcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashu: [
    0,
    0,
    -55,
    -55
  ],
  oslashuacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashucircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashudieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashugrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashuhungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashumacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashuogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashuring: [
    0,
    0,
    -55,
    -55
  ],
  oslashz: [
    0,
    0,
    -55,
    -55
  ],
  oslashzacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashzcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashzdotaccent: [
    0,
    0,
    -55,
    -55
  ],
  otildecomma: [
    0,
    0,
    -40,
    -40
  ],
  otildeperiod: [
    0,
    0,
    -40,
    -40
  ],
  pcomma: [
    0,
    0,
    -35,
    -35
  ],
  pperiod: [
    0,
    0,
    -35,
    -35
  ],
  ra: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  radieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ragrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ramacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ratilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcolon: [
    0,
    0,
    30,
    30
  ],
  ri: [
    0,
    0,
    15,
    15
  ],
  riacute: [
    0,
    0,
    15,
    15
  ],
  ricircumflex: [
    0,
    0,
    15,
    15
  ],
  ridieresis: [
    0,
    0,
    15,
    15
  ],
  rigrave: [
    0,
    0,
    15,
    15
  ],
  rimacron: [
    0,
    0,
    15,
    15
  ],
  riogonek: [
    0,
    0,
    15,
    15
  ],
  rk: [
    0,
    0,
    15,
    15
  ],
  rkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rl: [
    0,
    0,
    15,
    15
  ],
  rlacute: [
    0,
    0,
    15,
    15
  ],
  rlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rlslash: [
    0,
    0,
    15,
    15
  ],
  rm: [
    0,
    0,
    25,
    25
  ],
  rn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rsemicolon: [
    0,
    0,
    30,
    30
  ],
  ru: [
    0,
    0,
    15,
    15
  ],
  ruacute: [
    0,
    0,
    15,
    15
  ],
  rucircumflex: [
    0,
    0,
    15,
    15
  ],
  rudieresis: [
    0,
    0,
    15,
    15
  ],
  rugrave: [
    0,
    0,
    15,
    15
  ],
  ruhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rumacron: [
    0,
    0,
    15,
    15
  ],
  ruogonek: [
    0,
    0,
    15,
    15
  ],
  ruring: [
    0,
    0,
    15,
    15
  ],
  racutea: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutearing: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutecolon: [
    0,
    0,
    30,
    30
  ],
  racutei: [
    0,
    0,
    15,
    15
  ],
  racuteiacute: [
    0,
    0,
    15,
    15
  ],
  racuteicircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteidieresis: [
    0,
    0,
    15,
    15
  ],
  racuteigrave: [
    0,
    0,
    15,
    15
  ],
  racuteimacron: [
    0,
    0,
    15,
    15
  ],
  racuteiogonek: [
    0,
    0,
    15,
    15
  ],
  racutek: [
    0,
    0,
    15,
    15
  ],
  racutekcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutel: [
    0,
    0,
    15,
    15
  ],
  racutelacute: [
    0,
    0,
    15,
    15
  ],
  racutelcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutelslash: [
    0,
    0,
    15,
    15
  ],
  racutem: [
    0,
    0,
    25,
    25
  ],
  racuten: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutenacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutentilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutep: [
    0,
    0,
    30,
    30,
    -10
  ],
  racutesemicolon: [
    0,
    0,
    30,
    30
  ],
  racuteu: [
    0,
    0,
    15,
    15
  ],
  racuteuacute: [
    0,
    0,
    15,
    15
  ],
  racuteucircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteudieresis: [
    0,
    0,
    15,
    15
  ],
  racuteugrave: [
    0,
    0,
    15,
    15
  ],
  racuteuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  racuteumacron: [
    0,
    0,
    15,
    15
  ],
  racuteuogonek: [
    0,
    0,
    15,
    15
  ],
  racuteuring: [
    0,
    0,
    15,
    15
  ],
  rcarona: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaroncolon: [
    0,
    0,
    30,
    30
  ],
  rcaroni: [
    0,
    0,
    15,
    15
  ],
  rcaroniacute: [
    0,
    0,
    15,
    15
  ],
  rcaronicircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronidieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronigrave: [
    0,
    0,
    15,
    15
  ],
  rcaronimacron: [
    0,
    0,
    15,
    15
  ],
  rcaroniogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronk: [
    0,
    0,
    15,
    15
  ],
  rcaronkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronl: [
    0,
    0,
    15,
    15
  ],
  rcaronlacute: [
    0,
    0,
    15,
    15
  ],
  rcaronlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronlslash: [
    0,
    0,
    15,
    15
  ],
  rcaronm: [
    0,
    0,
    25,
    25
  ],
  rcaronn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcaronsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcaronu: [
    0,
    0,
    15,
    15
  ],
  rcaronuacute: [
    0,
    0,
    15,
    15
  ],
  rcaronucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronudieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronugrave: [
    0,
    0,
    15,
    15
  ],
  rcaronuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcaronumacron: [
    0,
    0,
    15,
    15
  ],
  rcaronuogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronuring: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenta: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentcolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccenti: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenticircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentidieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentigrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentimacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentk: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentl: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlslash: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentm: [
    0,
    0,
    25,
    25
  ],
  rcommaaccentn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcommaaccentsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccentu: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentudieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentugrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentumacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenturing: [
    0,
    0,
    15,
    15
  ],
  scomma: [
    0,
    0,
    -15,
    -15
  ],
  speriod: [
    0,
    0,
    -15,
    -15
  ],
  sacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  sacuteperiod: [
    0,
    0,
    -15,
    -15
  ],
  scaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  scaronperiod: [
    0,
    0,
    -15,
    -15
  ],
  scedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  scedillaperiod: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentcomma: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentperiod: [
    0,
    0,
    -15,
    -15
  ],
  ve: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veacute: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecaron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecircumflex: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedieresis: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedotaccent: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vegrave: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vemacron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veogonek: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  wa: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waacute: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wabreve: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wacircumflex: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wadieresis: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wagrave: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wamacron: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waogonek: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waring: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  watilde: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  we: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weacute: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecaron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedieresis: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedotaccent: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wegrave: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wemacron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weogonek: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  zo: [
    0,
    0,
    -15,
    -15
  ],
  zoacute: [
    0,
    0,
    -15,
    -15
  ],
  zocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zograve: [
    0,
    0,
    -15,
    -15
  ],
  zohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zomacron: [
    0,
    0,
    -15,
    -15
  ],
  zoslash: [
    0,
    0,
    -15,
    -15
  ],
  zotilde: [
    0,
    0,
    -15,
    -15
  ],
  zacuteo: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoacute: [
    0,
    0,
    -15,
    -15
  ],
  zacuteocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zacuteodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zacuteograve: [
    0,
    0,
    -15,
    -15
  ],
  zacuteohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zacuteomacron: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoslash: [
    0,
    0,
    -15,
    -15
  ],
  zacuteotilde: [
    0,
    0,
    -15,
    -15
  ],
  zcarono: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoacute: [
    0,
    0,
    -15,
    -15
  ],
  zcaronocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zcaronodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zcaronograve: [
    0,
    0,
    -15,
    -15
  ],
  zcaronohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zcaronomacron: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoslash: [
    0,
    0,
    -15,
    -15
  ],
  zcaronotilde: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccento: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoacute: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentograve: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentomacron: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoslash: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentotilde: [
    0,
    0,
    -15,
    -15
  ],
  Ap: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aacutep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aacutequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Abrevep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Abrevequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Acircumflexp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Acircumflexquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Adieresisp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Adieresisquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Agravep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Agravequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Amacronp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Amacronquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aogonekp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aogonekquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aringp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aringquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Atildep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Atildequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Je: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecaron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedotaccent: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jegrave: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jemacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeogonek: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jo: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jocircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jodieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jograve: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Johungarumlaut: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jomacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joslash: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jotilde: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  NA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  Ti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroni: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccenti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Vi: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Viacute: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Vicircumflex: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vidieresis: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vigrave: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vimacron: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Viogonek: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Wi: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  fi: [
    0,
    0,
    0,
    0,
    -25,
    0,
    -20,
    -20
  ],
  gperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gbreveperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gcommaaccentperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  iv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iacutev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  icircumflexv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  idieresisv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  igravev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  imacronv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iogonekv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  ky: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccenty: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  quotedblleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  re: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  regrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  remacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutee: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarone: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccente: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  spaceA: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAacute: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAbreve: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAcircumflex: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAdieresis: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAgrave: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAmacron: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAogonek: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAring: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAtilde: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  Fi: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiacute: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Ficircumflex: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fidieresis: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Figrave: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fimacron: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiogonek: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  eb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eacuteb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecaronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecircumflexb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edieresisb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edotaccentb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  egraveb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  emacronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eogonekb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ff: [
    0,
    0,
    0,
    0,
    0,
    -18,
    -18,
    -25
  ],
  quoterightt: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  quoterighttcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  Yicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  eg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egraveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  fiogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  gcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevecomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  og: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ograveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildeg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  fiacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  ga: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  garing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevea: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevearing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccenta: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaring: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ]
}, bJ = {
  attributes: pJ,
  glyphWidths: vJ,
  kernPairs: yJ
};
const FJ = (e) => [e.FontName, {
  attributes: e,
  glyphWidths: {},
  kernPairs: {}
}], LJ = (e) => {
  const {
    attributes: A,
    glyphWidths: t,
    kernPairs: r
  } = e, n = A.map(FJ);
  return Object.keys(t).forEach((i) => {
    t[i].forEach((a, o) => {
      a && (n[o][1].glyphWidths[i] = a);
    });
  }), Object.keys(r).forEach((i) => {
    r[i].forEach((a, o) => {
      a && (n[o][1].kernPairs[i] = a);
    });
  }), Object.fromEntries(n);
}, E2 = LJ(bJ), RJ = (e) => class extends e {
  constructor(t, r, n) {
    super(), this.document = t, this.name = r, this.id = n, this.font = yE.fromJson(E2[this.name]), this.ascender = this.font.ascender, this.descender = this.font.descender, this.bbox = this.font.bbox, this.lineGap = this.font.lineGap;
  }
  embed() {
    return this.dictionary.data = {
      Type: "Font",
      BaseFont: this.name,
      Subtype: "Type1",
      Encoding: "WinAnsiEncoding"
    }, this.dictionary.end();
  }
  encode(t) {
    const r = this.font.encodeText(t), n = this.font.glyphsForString("" + t), i = this.font.advancesForGlyphs(n), a = [];
    for (let o = 0; o < n.length; o++) {
      const s = n[o];
      a.push({
        xAdvance: i[o],
        yAdvance: 0,
        xOffset: 0,
        yOffset: 0,
        advanceWidth: this.font.widthOfGlyph(s)
      });
    }
    return [r, a];
  }
  encodeGlyphs(t) {
    const r = [];
    for (let n of Array.from(t))
      r.push(("00" + n.id.toString(16)).slice(-2));
    return r;
  }
  widthOfString(t, r) {
    const n = this.font.glyphsForString("" + t), i = this.font.advancesForGlyphs(n);
    let a = 0;
    for (let s of Array.from(i))
      a += s;
    const o = r / 1e3;
    return a * o;
  }
  static isStandardFont(t) {
    return t in E2;
  }
}, kd = function() {
  for (var e = arguments.length, A = new Array(e), t = 0; t < e; t++)
    A[t] = arguments[t];
  return Array.from(A).map((n) => ("0000" + n.toString(16)).slice(-4)).join("");
}, GJ = (e) => class extends e {
  constructor(t, r, n) {
    super(), this.document = t, this.font = r, this.id = n, this.subset = this.font.createSubset(), this.unicode = [[0]], this.widths = [this.font.getGlyph(0).advanceWidth], this.name = this.font.postscriptName, this.scale = 1e3 / this.font.unitsPerEm, this.ascender = this.font.ascent * this.scale, this.descender = this.font.descent * this.scale, this.xHeight = this.font.xHeight * this.scale, this.capHeight = this.font.capHeight * this.scale, this.lineGap = this.font.lineGap * this.scale, this.bbox = this.font.bbox, this.layoutCache = /* @__PURE__ */ Object.create(null);
  }
  layoutRun(t, r) {
    const n = this.font.layout(t, r, void 0, void 0, "ltr");
    for (let i = 0; i < n.positions.length; i++) {
      const a = n.positions[i];
      for (let o in a)
        a[o] *= this.scale;
      a.advanceWidth = n.glyphs[i].advanceWidth * this.scale;
    }
    return n;
  }
  layoutCached(t) {
    let r;
    if (r = this.layoutCache[t])
      return r;
    const n = this.layoutRun(t);
    return this.layoutCache[t] = n, n;
  }
  layout(t, r, n) {
    if (n == null && (n = !1), r)
      return this.layoutRun(t, r);
    const i = n ? null : [], a = n ? null : [];
    let o = 0, s = 0, l = 0;
    for (; l <= t.length; ) {
      let u;
      if (l === t.length && s < l || (u = t.charAt(l), [" ", "	"].includes(u))) {
        const g = this.layoutCached(t.slice(s, ++l));
        n || (i.push(...Array.from(g.glyphs || [])), a.push(...Array.from(g.positions || []))), o += g.advanceWidth, s = l;
      } else
        l++;
    }
    return {
      glyphs: i,
      positions: a,
      advanceWidth: o
    };
  }
  encode(t, r) {
    const {
      glyphs: n,
      positions: i
    } = this.layout(t, r), a = [];
    for (let o = 0; o < n.length; o++) {
      const s = n[o], l = this.subset.includeGlyph(s.id);
      a.push(("0000" + l.toString(16)).slice(-4)), this.widths[l] == null && (this.widths[l] = s.advanceWidth * this.scale), this.unicode[l] == null && (this.unicode[l] = s.codePoints);
    }
    return [a, i];
  }
  encodeGlyphs(t) {
    const r = [];
    for (let n = 0; n < t.length; n++) {
      const i = t[n], a = this.subset.includeGlyph(i.id);
      r.push(("0000" + a.toString(16)).slice(-4)), this.widths[a] == null && (this.widths[a] = i.advanceWidth * this.scale), this.unicode[a] == null && (this.unicode[a] = i.codePoints);
    }
    return r;
  }
  widthOfString(t, r, n) {
    const i = this.layout(t, n, !0).advanceWidth, a = r / 1e3;
    return i * a;
  }
  embed() {
    const t = this.subset.cff != null, r = this.document.ref();
    t && (r.data.Subtype = "CIDFontType0C"), r.end(this.subset.encode());
    const n = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : void 0) || 0) >> 8;
    let i = 0;
    this.font.post.isFixedPitch && (i |= 1), 1 <= n && n <= 7 && (i |= 2), i |= 4, n === 10 && (i |= 8), this.font.head.macStyle.italic && (i |= 64);
    const o = [0, 1, 2, 3, 4, 5].map(() => String.fromCharCode(Math.random() * 26 + 65)).join("") + "+" + this.font.postscriptName, {
      bbox: s
    } = this.font, l = this.document.ref({
      Type: "FontDescriptor",
      FontName: o,
      Flags: i,
      FontBBox: [s.minX * this.scale, s.minY * this.scale, s.maxX * this.scale, s.maxY * this.scale],
      ItalicAngle: this.font.italicAngle,
      Ascent: this.ascender,
      Descent: this.descender,
      CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
      XHeight: (this.font.xHeight || 0) * this.scale,
      StemV: 0
    });
    t ? l.data.FontFile3 = r : l.data.FontFile2 = r, l.end();
    const u = {
      Type: "Font",
      Subtype: "CIDFontType0",
      BaseFont: o,
      CIDSystemInfo: {
        Registry: new String("Adobe"),
        Ordering: new String("Identity"),
        Supplement: 0
      },
      FontDescriptor: l,
      W: [0, this.widths]
    };
    t || (u.Subtype = "CIDFontType2", u.CIDToGIDMap = "Identity");
    const g = this.document.ref(u);
    return g.end(), this.dictionary.data = {
      Type: "Font",
      Subtype: "Type0",
      BaseFont: o,
      Encoding: "Identity-H",
      DescendantFonts: [g],
      ToUnicode: this.toUnicodeCmap()
    }, this.dictionary.end();
  }
  // Maps the glyph ids encoded in the PDF back to unicode strings
  // Because of ligature substitutions and the like, there may be one or more
  // unicode characters represented by each glyph.
  toUnicodeCmap() {
    const t = this.document.ref();
    let r = [], n = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`;
    for (let [i, a] of this.unicode.entries()) {
      const o = [];
      r.length >= 100 && (n += `
` + r.length + ` beginbfchar
` + r.join(`
`) + `
endbfchar`, r = []);
      for (let s of a)
        s > 65535 && (s -= 65536, o.push(kd(s >>> 10 & 1023 | 55296)), s = 56320 | s & 1023), o.push(kd(s));
      r.push("<" + kd(i) + "><" + o.join(" ") + ">");
    }
    return r.length && (n += `
` + r.length + ` beginbfchar
` + r.join(`
`) + `
endbfchar
`), n += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`, t.end(n), t;
  }
};
class wB {
  static open(A, t, r, n) {
    let i;
    if (typeof t == "string") {
      if (Q2.isStandardFont(t))
        return new Q2(A, t, n);
      throw new Error("Can't open " + t + " in browser build");
    } else t instanceof Uint8Array ? i = gl(t, r) : t instanceof ArrayBuffer ? i = gl(new Uint8Array(t), r) : typeof t == "object" && (i = t);
    if (i == null)
      throw new Error("Not a supported font format or standard PDF font.");
    return new xJ(A, i, n);
  }
  encode() {
    throw new Error("Must be implemented by subclasses");
  }
  widthOfString() {
    throw new Error("Must be implemented by subclasses");
  }
  ref() {
    return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
  }
  finalize() {
    if (!(this.embedded || this.dictionary == null))
      return this.embed(), this.embedded = !0;
  }
  embed() {
    throw new Error("Must be implemented by subclasses");
  }
  lineHeight(A, t) {
    t == null && (t = !1);
    const r = t ? this.lineGap : 0;
    return (this.ascender + r - this.descender) / 1e3 * A;
  }
}
const Q2 = RJ(wB), xJ = GJ(wB);
var kJ = {
  initFonts() {
    return this._fontFamilies = {}, this._fontCount = 0, this._fontSize = 12, this._font = null, this._registeredFonts = {}, this.font("Helvetica");
  },
  font(e, A, t) {
    let r, n;
    if (typeof A == "number" && (t = A, A = null), typeof e == "string" && this._registeredFonts[e] ? (r = e, {
      src: e,
      family: A
    } = this._registeredFonts[e]) : (r = A || e, typeof r != "string" && (r = null)), t != null && this.fontSize(t), n = this._fontFamilies[r])
      return this._font = n, this;
    const i = "F" + ++this._fontCount;
    return this._font = wB.open(this, e, A, i), (n = this._fontFamilies[this._font.name]) ? (this._font = n, this) : (r && (this._fontFamilies[r] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
  },
  fontSize(e) {
    return this._fontSize = e, this;
  },
  currentLineHeight(e) {
    return e == null && (e = !1), this._font.lineHeight(this._fontSize, e);
  },
  registerFont(e, A, t) {
    return this._registeredFonts[e] = {
      src: A,
      family: t
    }, this;
  }
};
const {
  number: pi
} = ri;
var UJ = {
  initText() {
    return this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
  },
  _text(e, A, t, r, n) {
    r = this._initOptions(A, t, r), e = e == null ? "" : "" + e, r.wordSpacing && (e = e.replace(/\s{2,}/g, " "));
    const i = () => {
      r.structParent && r.structParent.add(this.struct(r.structType || "P", [this.markStructureContent(r.structType || "P")]));
    };
    for (let a of e.split(`
`))
      i(), n(a, r);
    return this;
  },
  text(e, A, t, r) {
    return this._text(e, A, t, r, this._line);
  },
  widthOfString(e, A) {
    return A === void 0 && (A = {}), this._font.widthOfString(e, this._fontSize, A.features) + (A.characterSpacing || 0) * (e.length - 1);
  },
  _initOptions(e, A, t) {
    e === void 0 && (e = {}), t === void 0 && (t = {}), typeof e == "object" && (t = e, e = null);
    const r = Object.assign({}, t);
    if (this._textOptions)
      for (let n in this._textOptions) {
        const i = this._textOptions[n];
        n !== "continued" && r[n] === void 0 && (r[n] = i);
      }
    return e != null && (this.x = e), A != null && (this.y = A), r.lineBreak !== !1 && (r.width == null && (r.width = this.page.width - this.x - this.page.margins.right), r.width = Math.max(r.width, 0)), r.columns || (r.columns = 0), r.columnGap == null && (r.columnGap = 18), r;
  },
  _line(e, A) {
    return A === void 0 && (A = {}), this._fragment(e, this.x, this.y, A), this.x += this.widthOfString(e);
  },
  _fragment(e, A, t, r) {
    if (e = ("" + e).replace(/\n/g, ""), e.length === 0) return;
    const [n, i] = this._font.encode(e, r.features), a = this._font.ascender / 1e3 * this._fontSize;
    this._glyphs(n, i, A, t + a, r);
  },
  _glyphs(e, A, t, r, n) {
    const i = [], a = this._fontSize / 1e3;
    let o, s = 0, l = !1;
    this.save(), this.transform(1, 0, 0, -1, 0, this.page.height), r = this.page.height - r, this.page.fonts[this._font.id] == null && (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent("1 0 0 1 " + pi(t) + " " + pi(r) + " Tm"), this.addContent("/" + this._font.id + " " + pi(this._fontSize) + " Tf");
    const u = n.fill && n.stroke ? 2 : n.stroke ? 1 : 0;
    u && this.addContent(u + " Tr");
    const g = (h) => {
      if (s < h) {
        const C = e.slice(s, h).join(""), E = A[h - 1].xAdvance - A[h - 1].advanceWidth;
        i.push("<" + C + "> " + pi(-E));
      }
      return s = h;
    }, d = (h) => {
      if (g(h), i.length > 0)
        return this.addContent("[" + i.join(" ") + "] TJ"), i.length = 0;
    };
    for (o = 0; o < A.length; o++) {
      const h = A[o];
      h.xOffset || h.yOffset ? (d(o), this.addContent("1 0 0 1 " + pi(t + h.xOffset * a) + " " + pi(r + h.yOffset * a) + " Tm"), d(o + 1), l = !0) : (l && (this.addContent("1 0 0 1 " + pi(t) + " " + pi(r) + " Tm"), l = !1), h.xAdvance - h.advanceWidth !== 0 && g(o + 1)), t += h.xAdvance * a;
    }
    return d(o), this.addContent("ET"), this.restore();
  }
};
const YJ = {
  1: "DeviceGray",
  3: "DeviceRGB",
  4: "DeviceCMYK"
};
let HJ = class {
  constructor(A, t) {
    if (this.data = A, this.label = t, this.orientation = 1, this.data.readUInt16BE(0) !== 65496)
      throw "SOI not found in JPEG";
    const r = Nm.decode(this.data);
    for (let n = 0; n < r.length; n += 1) {
      const i = r[n];
      i.name === "EXIF" && i.entries.orientation && (this.orientation = i.entries.orientation), i.name === "SOF" && (this.bits || (this.bits = i.precision), this.width || (this.width = i.width), this.height || (this.height = i.height), this.colorSpace || (this.colorSpace = YJ[i.numberOfComponents]));
    }
    this.obj = null;
  }
  embed(A) {
    if (!this.obj)
      return this.obj = A.ref({
        Type: "XObject",
        Subtype: "Image",
        BitsPerComponent: this.bits,
        Width: this.width,
        Height: this.height,
        ColorSpace: this.colorSpace,
        Filter: "DCTDecode"
      }), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [1, 0, 1, 0, 1, 0, 1, 0]), this.obj.end(this.data), this.data = null;
  }
};
class SJ {
  constructor(A, t) {
    this.label = t, this.image = new ml(A), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
  }
  embed(A) {
    let t = !1;
    if (this.document = A, this.obj)
      return;
    const r = this.image.hasAlphaChannel, n = this.image.interlaceMethod === 1;
    if (this.obj = this.document.ref({
      Type: "XObject",
      Subtype: "Image",
      BitsPerComponent: r ? 8 : this.image.bits,
      Width: this.width,
      Height: this.height,
      Filter: "FlateDecode"
    }), !r) {
      const i = this.document.ref({
        Predictor: n ? 1 : 15,
        Colors: this.image.colors,
        BitsPerComponent: this.image.bits,
        Columns: this.width
      });
      this.obj.data.DecodeParms = i, i.end();
    }
    if (this.image.palette.length === 0)
      this.obj.data.ColorSpace = this.image.colorSpace;
    else {
      const i = this.document.ref();
      i.end(LA.from(this.image.palette)), this.obj.data.ColorSpace = ["Indexed", "DeviceRGB", this.image.palette.length / 3 - 1, i];
    }
    if (this.image.transparency.grayscale != null) {
      const i = this.image.transparency.grayscale;
      this.obj.data.Mask = [i, i];
    } else if (this.image.transparency.rgb) {
      const {
        rgb: i
      } = this.image.transparency, a = [];
      for (let o of i)
        a.push(o, o);
      this.obj.data.Mask = a;
    } else {
      if (this.image.transparency.indexed)
        return t = !0, this.loadIndexedAlphaChannel();
      if (r)
        return t = !0, this.splitAlphaChannel();
    }
    if (n && !t)
      return this.decodeData();
    this.finalize();
  }
  finalize() {
    if (this.alphaChannel) {
      const A = this.document.ref({
        Type: "XObject",
        Subtype: "Image",
        Height: this.height,
        Width: this.width,
        BitsPerComponent: 8,
        Filter: "FlateDecode",
        ColorSpace: "DeviceGray",
        Decode: [0, 1]
      });
      A.end(this.alphaChannel), this.obj.data.SMask = A;
    }
    return this.obj.end(this.imgData), this.image = null, this.imgData = null;
  }
  splitAlphaChannel() {
    return this.image.decodePixels((A) => {
      let t, r;
      const n = this.image.colors, i = this.width * this.height, a = LA.alloc(i * n), o = LA.alloc(i);
      let s = r = t = 0;
      const l = A.length, u = this.image.bits === 16 ? 1 : 0;
      for (; s < l; ) {
        for (let g = 0; g < n; g++)
          a[r++] = A[s++], s += u;
        o[t++] = A[s++], s += u;
      }
      return this.imgData = Zs.deflateSync(a), this.alphaChannel = Zs.deflateSync(o), this.finalize();
    });
  }
  loadIndexedAlphaChannel() {
    const A = this.image.transparency.indexed;
    return this.image.decodePixels((t) => {
      const r = LA.alloc(this.width * this.height);
      let n = 0;
      for (let i = 0, a = t.length; i < a; i++)
        r[n++] = A[t[i]];
      return this.alphaChannel = Zs.deflateSync(r), this.finalize();
    });
  }
  decodeData() {
    this.image.decodePixels((A) => {
      this.imgData = Zs.deflateSync(A), this.finalize();
    });
  }
}
class NJ {
  static open(A, t) {
    let r;
    if (LA.isBuffer(A))
      r = A;
    else if (A instanceof ArrayBuffer)
      r = LA.from(new Uint8Array(A));
    else {
      let n;
      if (n = /^data:.+?;base64,(.*)$/.exec(A))
        r = LA.from(n[1], "base64");
      else if (r = DJ.readFileSync(A), !r)
        return;
    }
    if (r[0] === 255 && r[1] === 216)
      return new HJ(r, t);
    if (r[0] === 137 && r.toString("ascii", 1, 4) === "PNG")
      return new SJ(r, t);
    throw new Error("Unknown image format.");
  }
}
var TJ = {
  initImages() {
    return this._imageRegistry = {}, this._imageCount = 0;
  },
  embedImage(e) {
    let A;
    return typeof e == "string" && (A = this._imageRegistry[e]), A || (e.width && e.height ? A = e : A = this.openImage(e)), A.obj || A.embed(this), A;
  },
  image(e, A, t, r) {
    r === void 0 && (r = {});
    let n, i, a, o, s, l, u, g, d, h;
    typeof A == "object" && (r = A, A = null);
    const C = r.ignoreOrientation || r.ignoreOrientation !== !1 && this.options.ignoreOrientation;
    A = (l = A ?? r.x) != null ? l : this.x, t = (u = t ?? r.y) != null ? u : this.y, typeof e == "string" && (o = this._imageRegistry[e]), o || (e.width && e.height ? o = e : o = this.openImage(e)), o.obj || o.embed(this), this.page.xobjects[o.label] == null && (this.page.xobjects[o.label] = o.obj);
    let {
      width: E,
      height: I
    } = o;
    !C && o.orientation > 4 && ([E, I] = [I, E]);
    let b = r.width || E, y = r.height || I;
    if (r.width && !r.height) {
      const p = b / E;
      b = E * p, y = I * p;
    } else if (r.height && !r.width) {
      const p = y / I;
      b = E * p, y = I * p;
    } else r.scale ? (b = E * r.scale, y = I * r.scale) : r.fit ? ([a, n] = r.fit, i = a / n, s = E / I, s > i ? (b = a, y = a / s) : (y = n, b = n * s)) : r.cover && ([a, n] = r.cover, i = a / n, s = E / I, s > i ? (y = n, b = n * s) : (b = a, y = a / s));
    if ((r.fit || r.cover) && (r.align === "center" ? A = A + a / 2 - b / 2 : r.align === "right" && (A = A + a - b), r.valign === "center" ? t = t + n / 2 - y / 2 : r.valign === "bottom" && (t = t + n - y)), C)
      y = -y, t -= y, g = 0;
    else
      switch (o.orientation) {
        // No orientation (need to flip image, though, because of the default transform matrix on the document)
        default:
        case 1:
          y = -y, t -= y, g = 0;
          break;
        // Flip Horizontal
        case 2:
          b = -b, y = -y, A -= b, t -= y, g = 0;
          break;
        // Rotate 180 degrees
        case 3:
          d = A, h = t, y = -y, A -= b, g = 180;
          break;
        // Flip vertical
        case 4:
          break;
        // Flip horizontally and rotate 270 degrees CW
        case 5:
          d = A, h = t, [b, y] = [y, b], t -= y, g = 90;
          break;
        // Rotate 90 degrees CW
        case 6:
          d = A, h = t, [b, y] = [y, b], y = -y, g = 90;
          break;
        // Flip horizontally and rotate 90 degrees CW
        case 7:
          d = A, h = t, [b, y] = [y, b], y = -y, b = -b, A -= b, g = 90;
          break;
        // Rotate 270 degrees CW
        case 8:
          d = A, h = t, [b, y] = [y, b], y = -y, A -= b, t -= y, g = -90;
          break;
      }
    return this.y === t && (this.y += y), this.save(), g && this.rotate(g, {
      origin: [d, h]
    }), this.transform(b, 0, 0, y, A, t), this.addContent("/" + o.label + " Do"), this.restore(), this;
  },
  openImage(e) {
    let A;
    return typeof e == "string" && (A = this._imageRegistry[e]), A || (A = NJ.open(e, "I" + ++this._imageCount), typeof e == "string" && (this._imageRegistry[e] = A)), A;
  }
}, PJ = {
  annotate(e, A, t, r, n) {
    n.Type = "Annot", n.Rect = this._convertRect(e, A, t, r), n.Border = [0, 0, 0], n.Subtype === "Link" && typeof n.F > "u" && (n.F = 4), n.Subtype !== "Link" && n.C == null && (n.C = this._normalizeColor(n.color || [0, 0, 0])), delete n.color, typeof n.Dest == "string" && (n.Dest = new String(n.Dest));
    for (let a in n) {
      const o = n[a];
      n[a[0].toUpperCase() + a.slice(1)] = o;
    }
    const i = this.ref(n);
    return this.page.annotations.push(i), i.end(), this;
  },
  note(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Text", i.Contents = new String(n), i.Name = "Comment", i.color == null && (i.color = [243, 223, 92]), this.annotate(e, A, t, r, i);
  },
  goTo(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Link", i.A = this.ref({
      S: "GoTo",
      D: new String(n)
    }), i.A.end(), this.annotate(e, A, t, r, i);
  },
  link(e, A, t, r, n, i) {
    if (i === void 0 && (i = {}), i.Subtype = "Link", typeof n == "number") {
      const a = this._root.data.Pages.data;
      if (n >= 0 && n < a.Kids.length)
        i.A = this.ref({
          S: "GoTo",
          D: [a.Kids[n], "XYZ", null, null, null]
        }), i.A.end();
      else
        throw new Error("The document has no page " + n);
    } else
      i.A = this.ref({
        S: "URI",
        URI: new String(n)
      }), i.A.end();
    return this.annotate(e, A, t, r, i);
  },
  _markup(e, A, t, r, n) {
    n === void 0 && (n = {});
    const [i, a, o, s] = this._convertRect(e, A, t, r);
    return n.QuadPoints = [i, s, o, s, i, a, o, a], n.Contents = new String(), this.annotate(e, A, t, r, n);
  },
  highlight(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "Highlight", n.color == null && (n.color = [241, 238, 148]), this._markup(e, A, t, r, n);
  },
  underline(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "Underline", this._markup(e, A, t, r, n);
  },
  strike(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "StrikeOut", this._markup(e, A, t, r, n);
  },
  lineAnnotation(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "Line", n.Contents = new String(), n.L = [e, this.page.height - A, t, this.page.height - r], this.annotate(e, A, t, r, n);
  },
  rectAnnotation(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "Square", n.Contents = new String(), this.annotate(e, A, t, r, n);
  },
  ellipseAnnotation(e, A, t, r, n) {
    return n === void 0 && (n = {}), n.Subtype = "Circle", n.Contents = new String(), this.annotate(e, A, t, r, n);
  },
  textAnnotation(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "FreeText", i.Contents = new String(n), i.DA = new String(), this.annotate(e, A, t, r, i);
  },
  fileAnnotation(e, A, t, r, n, i) {
    n === void 0 && (n = {}), i === void 0 && (i = {});
    const a = this.file(n.src, Object.assign({
      hidden: !0
    }, n));
    return i.Subtype = "FileAttachment", i.FS = a, i.Contents ? i.Contents = new String(i.Contents) : a.data.Desc && (i.Contents = a.data.Desc), this.annotate(e, A, t, r, i);
  },
  _convertRect(e, A, t, r) {
    let n = A;
    A += r;
    let i = e + t;
    const [a, o, s, l, u, g] = this._ctm;
    return e = a * e + s * A + u, A = o * e + l * A + g, i = a * i + s * n + u, n = o * i + l * n + g, [e, A, i, n];
  }
};
class bE {
  constructor(A, t, r, n, i) {
    i === void 0 && (i = {
      expanded: !1
    }), this.document = A, this.options = i, this.outlineData = {}, n !== null && (this.outlineData.Dest = [n.dictionary, "Fit"]), t !== null && (this.outlineData.Parent = t), r !== null && (this.outlineData.Title = new String(r)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
  }
  addItem(A, t) {
    t === void 0 && (t = {
      expanded: !1
    });
    const r = new bE(this.document, this.dictionary, A, this.document.page, t);
    return this.children.push(r), r;
  }
  endOutline() {
    if (this.children.length > 0) {
      this.options.expanded && (this.outlineData.Count = this.children.length);
      const A = this.children[0], t = this.children[this.children.length - 1];
      this.outlineData.First = A.dictionary, this.outlineData.Last = t.dictionary;
      for (let r = 0, n = this.children.length; r < n; r++) {
        const i = this.children[r];
        r > 0 && (i.outlineData.Prev = this.children[r - 1].dictionary), r < this.children.length - 1 && (i.outlineData.Next = this.children[r + 1].dictionary), i.endOutline();
      }
    }
    return this.dictionary.end();
  }
}
var zJ = {
  initOutline() {
    return this.outline = new bE(this, null, null, null);
  },
  endOutline() {
    if (this.outline.endOutline(), this.outline.children.length > 0)
      return this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = "UseOutlines";
  }
};
class Gc {
  constructor(A, t) {
    this.refs = [{
      pageRef: A,
      mcid: t
    }];
  }
  push(A) {
    A.refs.forEach((t) => this.refs.push(t));
  }
}
class Gi {
  constructor(A, t, r, n) {
    r === void 0 && (r = {}), n === void 0 && (n = null), this.document = A, this._attached = !1, this._ended = !1, this._flushed = !1, this.dictionary = A.ref({
      // Type: "StructElem",
      S: t
    });
    const i = this.dictionary.data;
    (Array.isArray(r) || this._isValidChild(r)) && (n = r, r = {}), typeof r.title < "u" && (i.T = new String(r.title)), typeof r.lang < "u" && (i.Lang = new String(r.lang)), typeof r.alt < "u" && (i.Alt = new String(r.alt)), typeof r.expanded < "u" && (i.E = new String(r.expanded)), typeof r.actual < "u" && (i.ActualText = new String(r.actual)), this._children = [], n && (Array.isArray(n) || (n = [n]), n.forEach((a) => this.add(a)), this.end());
  }
  add(A) {
    if (this._ended)
      throw new Error("Cannot add child to already-ended structure element");
    if (!this._isValidChild(A))
      throw new Error("Invalid structure element child");
    return A instanceof Gi && (A.setParent(this.dictionary), this._attached && A.setAttached()), A instanceof Gc && this._addContentToParentTree(A), typeof A == "function" && this._attached && (A = this._contentForClosure(A)), this._children.push(A), this;
  }
  _addContentToParentTree(A) {
    A.refs.forEach((t) => {
      let {
        pageRef: r,
        mcid: n
      } = t;
      const i = this.document.getStructParentTree().get(r.data.StructParents);
      i[n] = this.dictionary;
    });
  }
  setParent(A) {
    if (this.dictionary.data.P)
      throw new Error("Structure element added to more than one parent");
    this.dictionary.data.P = A, this._flush();
  }
  setAttached() {
    this._attached || (this._children.forEach((A, t) => {
      A instanceof Gi && A.setAttached(), typeof A == "function" && (this._children[t] = this._contentForClosure(A));
    }), this._attached = !0, this._flush());
  }
  end() {
    this._ended || (this._children.filter((A) => A instanceof Gi).forEach((A) => A.end()), this._ended = !0, this._flush());
  }
  _isValidChild(A) {
    return A instanceof Gi || A instanceof Gc || typeof A == "function";
  }
  _contentForClosure(A) {
    const t = this.document.markStructureContent(this.dictionary.data.S);
    return A(), this.document.endMarkedContent(), this._addContentToParentTree(t), t;
  }
  _isFlushable() {
    return !this.dictionary.data.P || !this._ended ? !1 : this._children.every((A) => typeof A == "function" ? !1 : A instanceof Gi ? A._isFlushable() : !0);
  }
  _flush() {
    this._flushed || !this._isFlushable() || (this.dictionary.data.K = [], this._children.forEach((A) => this._flushChild(A)), this.dictionary.end(), this._children = [], this.dictionary.data.K = null, this._flushed = !0);
  }
  _flushChild(A) {
    A instanceof Gi && this.dictionary.data.K.push(A.dictionary), A instanceof Gc && A.refs.forEach((t) => {
      let {
        pageRef: r,
        mcid: n
      } = t;
      this.dictionary.data.Pg || (this.dictionary.data.Pg = r), this.dictionary.data.Pg === r ? this.dictionary.data.K.push(n) : this.dictionary.data.K.push({
        Type: "MCR",
        Pg: r,
        MCID: n
      });
    });
  }
}
class jJ extends Mv {
  _compareKeys(A, t) {
    return parseInt(A) - parseInt(t);
  }
  _keysName() {
    return "Nums";
  }
  _dataForKey(A) {
    return parseInt(A);
  }
}
var VJ = {
  initMarkings(e) {
    this.structChildren = [], e.tagged && (this.getMarkInfoDictionary().data.Marked = !0, this.getStructTreeRoot());
  },
  markContent(e, A) {
    if (A === void 0 && (A = null), e === "Artifact" || A && A.mcid) {
      let r = 0;
      for (this.page.markings.forEach((n) => {
        (r || n.structContent || n.tag === "Artifact") && r++;
      }); r--; )
        this.endMarkedContent();
    }
    if (!A)
      return this.page.markings.push({
        tag: e
      }), this.addContent("/" + e + " BMC"), this;
    this.page.markings.push({
      tag: e,
      options: A
    });
    const t = {};
    return typeof A.mcid < "u" && (t.MCID = A.mcid), e === "Artifact" && (typeof A.type == "string" && (t.Type = A.type), Array.isArray(A.bbox) && (t.BBox = [A.bbox[0], this.page.height - A.bbox[3], A.bbox[2], this.page.height - A.bbox[1]]), Array.isArray(A.attached) && A.attached.every((r) => typeof r == "string") && (t.Attached = A.attached)), e === "Span" && (A.lang && (t.Lang = new String(A.lang)), A.alt && (t.Alt = new String(A.alt)), A.expanded && (t.E = new String(A.expanded)), A.actual && (t.ActualText = new String(A.actual))), this.addContent("/" + e + " " + ri.convert(t) + " BDC"), this;
  },
  markStructureContent(e, A) {
    A === void 0 && (A = {});
    const t = this.getStructParentTree().get(this.page.structParentTreeKey), r = t.length;
    t.push(null), this.markContent(e, {
      ...A,
      mcid: r
    });
    const n = new Gc(this.page.dictionary, r);
    return this.page.markings.slice(-1)[0].structContent = n, n;
  },
  endMarkedContent() {
    return this.page.markings.pop(), this.addContent("EMC"), this;
  },
  struct(e, A, t) {
    return A === void 0 && (A = {}), t === void 0 && (t = null), new Gi(this, e, A, t);
  },
  addStructure(e) {
    const A = this.getStructTreeRoot();
    return e.setParent(A), e.setAttached(), this.structChildren.push(e), A.data.K || (A.data.K = []), A.data.K.push(e.dictionary), this;
  },
  initPageMarkings(e) {
    e.forEach((A) => {
      if (A.structContent) {
        const t = A.structContent, r = this.markStructureContent(A.tag, A.options);
        t.push(r), this.page.markings.slice(-1)[0].structContent = t;
      } else
        this.markContent(A.tag, A.options);
    });
  },
  endPageMarkings(e) {
    const A = e.markings;
    return A.forEach(() => e.write("EMC")), e.markings = [], A;
  },
  getMarkInfoDictionary() {
    return this._root.data.MarkInfo || (this._root.data.MarkInfo = this.ref({})), this._root.data.MarkInfo;
  },
  getStructTreeRoot() {
    return this._root.data.StructTreeRoot || (this._root.data.StructTreeRoot = this.ref({
      Type: "StructTreeRoot",
      ParentTree: new jJ(),
      ParentTreeNextKey: 0
    })), this._root.data.StructTreeRoot;
  },
  getStructParentTree() {
    return this.getStructTreeRoot().data.ParentTree;
  },
  createStructParentTreeNextKey() {
    this.getMarkInfoDictionary();
    const e = this.getStructTreeRoot(), A = e.data.ParentTreeNextKey++;
    return e.data.ParentTree.add(A, []), A;
  },
  endMarkings() {
    const e = this._root.data.StructTreeRoot;
    e && (e.end(), this.structChildren.forEach((A) => A.end())), this._root.data.MarkInfo && this._root.data.MarkInfo.end();
  }
};
const w2 = {
  readOnly: 1,
  required: 2,
  noExport: 4,
  multiline: 4096,
  password: 8192,
  toggleToOffButton: 16384,
  radioButton: 32768,
  pushButton: 65536,
  combo: 131072,
  edit: 262144,
  sort: 524288,
  multiSelect: 2097152,
  noSpell: 4194304
}, I2 = {
  left: 0,
  center: 1,
  right: 2
}, D2 = {
  value: "V",
  defaultValue: "DV"
}, m2 = {
  zip: "0",
  zipPlus4: "1",
  zip4: "1",
  phone: "2",
  ssn: "3"
}, M2 = {
  number: {
    nDec: 0,
    sepComma: !1,
    negStyle: "MinusBlack",
    currency: "",
    currencyPrepend: !0
  },
  percent: {
    nDec: 0,
    sepComma: !1
  }
};
var OJ = {
  /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */
  initForm() {
    if (!this._font)
      throw new Error("Must set a font before calling initForm method");
    this._acroform = {
      fonts: {},
      defaultFont: this._font.name
    }, this._acroform.fonts[this._font.id] = this._font.ref();
    let e = {
      Fields: [],
      NeedAppearances: !0,
      DA: new String("/" + this._font.id + " 0 Tf 0 g"),
      DR: {
        Font: {}
      }
    };
    e.DR.Font[this._font.id] = this._font.ref();
    const A = this.ref(e);
    return this._root.data.AcroForm = A, this;
  },
  /**
   * Called automatically by document.js
   */
  endAcroForm() {
    if (this._root.data.AcroForm) {
      if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont)
        throw new Error("No fonts specified for PDF form");
      let e = this._root.data.AcroForm.data.DR.Font;
      Object.keys(this._acroform.fonts).forEach((A) => {
        e[A] = this._acroform.fonts[A];
      }), this._root.data.AcroForm.data.Fields.forEach((A) => {
        this._endChild(A);
      }), this._root.data.AcroForm.end();
    }
    return this;
  },
  _endChild(e) {
    return Array.isArray(e.data.Kids) && (e.data.Kids.forEach((A) => {
      this._endChild(A);
    }), e.end()), this;
  },
  /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */
  formField(e, A) {
    A === void 0 && (A = {});
    let t = this._fieldDict(e, null, A), r = this.ref(t);
    return this._addToParent(r), r;
  },
  /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */
  formAnnotation(e, A, t, r, n, i, a) {
    a === void 0 && (a = {});
    let o = this._fieldDict(e, A, a);
    o.Subtype = "Widget", o.F === void 0 && (o.F = 4), this.annotate(t, r, n, i, o);
    let s = this.page.annotations[this.page.annotations.length - 1];
    return this._addToParent(s);
  },
  formText(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "text", A, t, r, n, i);
  },
  formPushButton(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "pushButton", A, t, r, n, i);
  },
  formCombo(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "combo", A, t, r, n, i);
  },
  formList(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "list", A, t, r, n, i);
  },
  formRadioButton(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "radioButton", A, t, r, n, i);
  },
  formCheckbox(e, A, t, r, n, i) {
    return i === void 0 && (i = {}), this.formAnnotation(e, "checkbox", A, t, r, n, i);
  },
  _addToParent(e) {
    let A = e.data.Parent;
    return A ? (A.data.Kids || (A.data.Kids = []), A.data.Kids.push(e)) : this._root.data.AcroForm.data.Fields.push(e), this;
  },
  _fieldDict(e, A, t) {
    if (t === void 0 && (t = {}), !this._acroform)
      throw new Error("Call document.initForms() method before adding form elements to document");
    let r = Object.assign({}, t);
    return A !== null && (r = this._resolveType(A, t)), r = this._resolveFlags(r), r = this._resolveJustify(r), r = this._resolveFont(r), r = this._resolveStrings(r), r = this._resolveColors(r), r = this._resolveFormat(r), r.T = new String(e), r.parent && (r.Parent = r.parent, delete r.parent), r;
  },
  _resolveType(e, A) {
    if (e === "text")
      A.FT = "Tx";
    else if (e === "pushButton")
      A.FT = "Btn", A.pushButton = !0;
    else if (e === "radioButton")
      A.FT = "Btn", A.radioButton = !0;
    else if (e === "checkbox")
      A.FT = "Btn";
    else if (e === "combo")
      A.FT = "Ch", A.combo = !0;
    else if (e === "list")
      A.FT = "Ch";
    else
      throw new Error("Invalid form annotation type '" + e + "'");
    return A;
  },
  _resolveFormat(e) {
    const A = e.format;
    if (A && A.type) {
      let t, r, n = "";
      if (m2[A.type] !== void 0)
        t = "AFSpecial_Keystroke", r = "AFSpecial_Format", n = m2[A.type];
      else {
        let i = A.type.charAt(0).toUpperCase() + A.type.slice(1);
        if (t = "AF" + i + "_Keystroke", r = "AF" + i + "_Format", A.type === "date")
          t += "Ex", n = String(A.param);
        else if (A.type === "time")
          n = String(A.param);
        else if (A.type === "number") {
          let a = Object.assign({}, M2.number, A);
          n = String([String(a.nDec), a.sepComma ? "0" : "1", '"' + a.negStyle + '"', "null", '"' + a.currency + '"', String(a.currencyPrepend)].join(","));
        } else if (A.type === "percent") {
          let a = Object.assign({}, M2.percent, A);
          n = String([String(a.nDec), a.sepComma ? "0" : "1"].join(","));
        }
      }
      e.AA = e.AA ? e.AA : {}, e.AA.K = {
        S: "JavaScript",
        JS: new String(t + "(" + n + ");")
      }, e.AA.F = {
        S: "JavaScript",
        JS: new String(r + "(" + n + ");")
      };
    }
    return delete e.format, e;
  },
  _resolveColors(e) {
    let A = this._normalizeColor(e.backgroundColor);
    return A && (e.MK || (e.MK = {}), e.MK.BG = A), A = this._normalizeColor(e.borderColor), A && (e.MK || (e.MK = {}), e.MK.BC = A), delete e.backgroundColor, delete e.borderColor, e;
  },
  _resolveFlags(e) {
    let A = 0;
    return Object.keys(e).forEach((t) => {
      w2[t] && (A |= w2[t], delete e[t]);
    }), A !== 0 && (e.Ff = e.Ff ? e.Ff : 0, e.Ff |= A), e;
  },
  _resolveJustify(e) {
    let A = 0;
    return e.align !== void 0 && (typeof I2[e.align] == "number" && (A = I2[e.align]), delete e.align), A !== 0 && (e.Q = A), e;
  },
  _resolveFont(e) {
    if (this._acroform.fonts[this._font.id] === null && (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
      e.DR = {
        Font: {}
      };
      const A = e.fontSize || 0;
      e.DR.Font[this._font.id] = this._font.ref(), e.DA = new String("/" + this._font.id + " " + A + " Tf 0 g");
    }
    return e;
  },
  _resolveStrings(e) {
    let A = [];
    function t(r) {
      if (Array.isArray(r))
        for (let n = 0; n < r.length; n++)
          typeof r[n] == "string" ? A.push(new String(r[n])) : A.push(r[n]);
    }
    return t(e.Opt), e.select && (t(e.select), delete e.select), A.length && (e.Opt = A), Object.keys(D2).forEach((r) => {
      e[r] !== void 0 && (e[D2[r]] = e[r], delete e[r]);
    }), ["V", "DV"].forEach((r) => {
      typeof e[r] == "string" && (e[r] = new String(e[r]));
    }), e.MK && e.MK.CA && (e.MK.CA = new String(e.MK.CA)), e.label && (e.MK = e.MK ? e.MK : {}, e.MK.CA = new String(e.label), delete e.label), e;
  }
}, JJ = {
  /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */
  file(e, A) {
    A === void 0 && (A = {}), A.name = A.name || e;
    const t = {
      Type: "EmbeddedFile",
      Params: {}
    };
    let r;
    if (!e)
      throw new Error("No src specified");
    if (LA.isBuffer(e))
      r = e;
    else if (e instanceof ArrayBuffer)
      r = LA.from(new Uint8Array(e));
    else {
      let l;
      if (l = /^data:(.*);base64,(.*)$/.exec(e))
        l[1] && (t.Subtype = l[1].replace("/", "#2F")), r = LA.from(l[2], "base64");
      else
        throw new Error("Could not find file " + e);
    }
    A.creationDate instanceof Date && (t.Params.CreationDate = A.creationDate), A.modifiedDate instanceof Date && (t.Params.ModDate = A.modifiedDate), A.type && (t.Subtype = A.type.replace("/", "#2F"));
    const n = Hm(Rz.lib.WordArray.create(new Uint8Array(r)));
    t.Params.CheckSum = new String(n), t.Params.Size = r.byteLength;
    let i;
    this._fileRegistry || (this._fileRegistry = {});
    let a = this._fileRegistry[A.name];
    a && WJ(t, a) ? i = a.ref : (i = this.ref(t), i.end(r), this._fileRegistry[A.name] = {
      ...t,
      ref: i
    });
    const o = {
      Type: "Filespec",
      F: new String(A.name),
      EF: {
        F: i
      },
      UF: new String(A.name)
    };
    A.description && (o.Desc = new String(A.description));
    const s = this.ref(o);
    return s.end(), A.hidden || this.addNamedEmbeddedFile(A.name, s), s;
  }
};
function WJ(e, A) {
  return e.Subtype === A.Subtype && e.Params.CheckSum.toString() === A.Params.CheckSum.toString() && e.Params.Size === A.Params.Size && e.Params.CreationDate === A.Params.CreationDate && e.Params.ModDate === A.Params.ModDate;
}
class ZJ {
  constructor() {
    this._metadata = `
        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
  }
  _closeTags() {
    this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
  }
  append(A, t) {
    t === void 0 && (t = !0), this._metadata = this._metadata.concat(A), t && (this._metadata = this._metadata.concat(`
`));
  }
  getXML() {
    return this._metadata;
  }
  getLength() {
    return this._metadata.length;
  }
  end() {
    this._closeTags(), this._metadata = this._metadata.trim();
  }
}
var KJ = {
  initMetadata() {
    this.metadata = new ZJ();
  },
  appendXML(e, A) {
    A === void 0 && (A = !0), this.metadata.append(e, A);
  },
  _addInfo() {
    this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>` + (this.info.CreationDate.toISOString().split(".")[0] + "Z") + `</xmp:CreateDate>
            <xmp:CreatorTool>` + this.info.Creator + `</xmp:CreatorTool>
        </rdf:Description>
        `), (this.info.Title || this.info.Author || this.info.Subject) && (this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `), this.info.Title && this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">` + this.info.Title + `</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `), this.info.Author && this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>` + this.info.Author + `</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `), this.info.Subject && this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">` + this.info.Subject + `</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `), this.appendXML(`
            </rdf:Description>
            `)), this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>` + this.info.Creator + "</pdf:Producer>", !1), this.info.Keywords && this.appendXML(`
            <pdf:Keywords>` + this.info.Keywords + "</pdf:Keywords>", !1), this.appendXML(`
        </rdf:Description>
        `);
  },
  endMetadata() {
    this._addInfo(), this.metadata.end(), this.version != 1.3 && (this.metadataRef = this.ref({
      length: this.metadata.getLength(),
      Type: "Metadata",
      Subtype: "XML"
    }), this.metadataRef.compress = !1, this.metadataRef.write(LA.from(this.metadata.getXML(), "utf-8")), this.metadataRef.end(), this._root.data.Metadata = this.metadataRef);
  }
};
const p2 = (e) => e[0].toUpperCase() + e.slice(1);
class bv extends Bv.Readable {
  constructor(A) {
    switch (A === void 0 && (A = {}), super(), this.options = A, A.pdfVersion) {
      case "1.4":
        this.version = 1.4;
        break;
      case "1.5":
        this.version = 1.5;
        break;
      case "1.6":
        this.version = 1.6;
        break;
      case "1.7":
      case "1.7ext3":
        this.version = 1.7;
        break;
      default:
        this.version = 1.3;
        break;
    }
    this.compress = this.options.compress != null ? this.options.compress : !0, this._pageBuffer = [], this._pageBufferStart = 0, this._offsets = [], this._waiting = 0, this._ended = !1, this._offset = 0;
    const t = this.ref({
      Type: "Pages",
      Count: 0,
      Kids: []
    }), r = this.ref({
      Dests: new Rc()
    });
    if (this._root = this.ref({
      Type: "Catalog",
      Pages: t,
      Names: r
    }), this.options.lang && (this._root.data.Lang = new String(this.options.lang)), this.options.pageLayout && (this._root.data.PageLayout = p2(this.options.pageLayout)), this.options.pageMode && (this._root.data.PageMode = p2(this.options.pageMode)), this.page = null, this.initColor(), this.initVector(), this.initFonts(), this.initText(), this.initImages(), this.initOutline(), this.info = {
      Producer: "PDFKit",
      Creator: "PDFKit",
      CreationDate: /* @__PURE__ */ new Date()
    }, this.options.info)
      for (let n in this.options.info) {
        const i = this.options.info[n];
        this.info[n] = i;
      }
    this.options.displayTitle && (this._root.data.ViewerPreferences = this.ref({
      DisplayDocTitle: !0
    })), this._id = eJ.generateFileID(this.info), this._write("%PDF-" + this.version), this._write("%ÿÿÿÿ"), this.options.autoFirstPage !== !1 && this.addPage();
  }
  addPage(A) {
    A == null && ({
      options: A
    } = this), this.options.bufferPages || this.flushPages(), this.page = new $O(this, A), this._pageBuffer.push(this.page);
    const t = this._root.data.Pages.data;
    return t.Kids.push(this.page.dictionary), t.Count++, this._ctm = [1, 0, 0, 1, 0, 0], this.transform(1, 0, 0, -1, 0, this.page.height), this;
  }
  flushPages() {
    const A = this._pageBuffer;
    this._pageBuffer = [], this._pageBufferStart += A.length;
    for (let t of Array.from(A))
      t.end();
  }
  addNamedDestination(A) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      r[n - 1] = arguments[n];
    r.length === 0 && (r = ["XYZ", null, null, null]), r[0] === "XYZ" && r[2] !== null && (r[2] = this.page.height - r[2]), r.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(A, r);
  }
  addNamedEmbeddedFile(A, t) {
    this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new Rc({
      limits: !1
    })), this._root.data.Names.data.EmbeddedFiles.add(A, t);
  }
  addNamedJavaScript(A, t) {
    this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new Rc());
    let r = {
      JS: new String(t),
      S: "JavaScript"
    };
    this._root.data.Names.data.JavaScript.add(A, r);
  }
  ref(A) {
    const t = new mv(this, this._offsets.length + 1, A);
    return this._offsets.push(null), this._waiting++, t;
  }
  _read() {
  }
  _write(A) {
    return LA.isBuffer(A) || (A = LA.from(A + `
`, "binary")), this.push(A), this._offset += A.length;
  }
  addContent(A) {
    return this.page.write(A), this;
  }
  _refEnd(A) {
    if (this._offsets[A.id - 1] = A.offset, --this._waiting === 0 && this._ended)
      return this._finalize(), this._ended = !1;
  }
  end() {
    this.flushPages(), this._info = this.ref();
    for (let A in this.info) {
      let t = this.info[A];
      typeof t == "string" && (t = new String(t));
      let r = this.ref(t);
      r.end(), this._info.data[A] = r;
    }
    this._info.end();
    for (let A in this._fontFamilies)
      this._fontFamilies[A].finalize();
    if (this.endOutline(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._waiting === 0)
      return this._finalize();
    this._ended = !0;
  }
  _finalize() {
    const A = this._offset;
    this._write("xref"), this._write("0 " + (this._offsets.length + 1)), this._write("0000000000 65535 f ");
    for (let r of Array.from(this._offsets))
      r = ("0000000000" + r).slice(-10), this._write(r + " 00000 n ");
    const t = {
      Size: this._offsets.length + 1,
      Root: this._root,
      Info: this._info,
      ID: [this._id, this._id]
    };
    return this._write("trailer"), this._write(ri.convert(t)), this._write("startxref"), this._write("" + A), this._write("%%EOF"), this.push(null);
  }
  toString() {
    return "[object PDFDocument]";
  }
  initColor() {
  }
  initVector() {
  }
  initFonts() {
  }
  initText() {
  }
  initImages() {
  }
  initOutline() {
  }
  /**
   * @param {number} m11
   * @param {number} m12
   * @param {number} m21
   * @param {number} m22
   * @param {number} dx
   * @param {number} dy
   */
  // eslint-disable-next-line no-unused-vars
  transform(A, t, r, n, i, a) {
  }
  endOutline() {
  }
  endAcroForm() {
  }
}
const i0 = (e) => {
  Object.assign(bv.prototype, e);
};
i0(KJ);
i0(gJ);
i0(IJ);
i0(kJ);
i0(UJ);
i0(TJ);
i0(PJ);
i0(zJ);
i0(VJ);
i0(OJ);
i0(JJ);
var Ud, v2;
function _J() {
  if (v2) return Ud;
  v2 = 1;
  var e = 40, A = 41, t = 39, r = 34, n = 92, i = 47, a = 44, o = 58, s = 42, l = 117, u = 85, g = 43, d = /^[a-f0-9?-]+$/i;
  return Ud = function(h) {
    for (var C = [], E = h, I, b, y, p, Q, w, Y, k, L = 0, S = E.charCodeAt(L), P = E.length, Z = [{ nodes: C }], M = 0, R, G = "", N = "", z = ""; L < P; )
      if (S <= 32) {
        I = L;
        do
          I += 1, S = E.charCodeAt(I);
        while (S <= 32);
        p = E.slice(L, I), y = C[C.length - 1], S === A && M ? z = p : y && y.type === "div" ? (y.after = p, y.sourceEndIndex += p.length) : S === a || S === o || S === i && E.charCodeAt(I + 1) !== s && (!R || R && R.type === "function" && R.value !== "calc") ? N = p : C.push({
          type: "space",
          sourceIndex: L,
          sourceEndIndex: I,
          value: p
        }), L = I;
      } else if (S === t || S === r) {
        I = L, b = S === t ? "'" : '"', p = {
          type: "string",
          sourceIndex: L,
          quote: b
        };
        do
          if (Q = !1, I = E.indexOf(b, I + 1), ~I)
            for (w = I; E.charCodeAt(w - 1) === n; )
              w -= 1, Q = !Q;
          else
            E += b, I = E.length - 1, p.unclosed = !0;
        while (Q);
        p.value = E.slice(L + 1, I), p.sourceEndIndex = p.unclosed ? I : I + 1, C.push(p), L = I + 1, S = E.charCodeAt(L);
      } else if (S === i && E.charCodeAt(L + 1) === s)
        I = E.indexOf("*/", L), p = {
          type: "comment",
          sourceIndex: L,
          sourceEndIndex: I + 2
        }, I === -1 && (p.unclosed = !0, I = E.length, p.sourceEndIndex = I), p.value = E.slice(L + 2, I), C.push(p), L = I + 2, S = E.charCodeAt(L);
      else if ((S === i || S === s) && R && R.type === "function" && R.value === "calc")
        p = E[L], C.push({
          type: "word",
          sourceIndex: L - N.length,
          sourceEndIndex: L + p.length,
          value: p
        }), L += 1, S = E.charCodeAt(L);
      else if (S === i || S === a || S === o)
        p = E[L], C.push({
          type: "div",
          sourceIndex: L - N.length,
          sourceEndIndex: L + p.length,
          value: p,
          before: N,
          after: ""
        }), N = "", L += 1, S = E.charCodeAt(L);
      else if (e === S) {
        I = L;
        do
          I += 1, S = E.charCodeAt(I);
        while (S <= 32);
        if (k = L, p = {
          type: "function",
          sourceIndex: L - G.length,
          value: G,
          before: E.slice(k + 1, I)
        }, L = I, G === "url" && S !== t && S !== r) {
          I -= 1;
          do
            if (Q = !1, I = E.indexOf(")", I + 1), ~I)
              for (w = I; E.charCodeAt(w - 1) === n; )
                w -= 1, Q = !Q;
            else
              E += ")", I = E.length - 1, p.unclosed = !0;
          while (Q);
          Y = I;
          do
            Y -= 1, S = E.charCodeAt(Y);
          while (S <= 32);
          k < Y ? (L !== Y + 1 ? p.nodes = [
            {
              type: "word",
              sourceIndex: L,
              sourceEndIndex: Y + 1,
              value: E.slice(L, Y + 1)
            }
          ] : p.nodes = [], p.unclosed && Y + 1 !== I ? (p.after = "", p.nodes.push({
            type: "space",
            sourceIndex: Y + 1,
            sourceEndIndex: I,
            value: E.slice(Y + 1, I)
          })) : (p.after = E.slice(Y + 1, I), p.sourceEndIndex = I)) : (p.after = "", p.nodes = []), L = I + 1, p.sourceEndIndex = p.unclosed ? I : L, S = E.charCodeAt(L), C.push(p);
        } else
          M += 1, p.after = "", p.sourceEndIndex = L + 1, C.push(p), Z.push(p), C = p.nodes = [], R = p;
        G = "";
      } else if (A === S && M)
        L += 1, S = E.charCodeAt(L), R.after = z, R.sourceEndIndex += z.length, z = "", M -= 1, Z[Z.length - 1].sourceEndIndex = L, Z.pop(), R = Z[M], C = R.nodes;
      else {
        I = L;
        do
          S === n && (I += 1), I += 1, S = E.charCodeAt(I);
        while (I < P && !(S <= 32 || S === t || S === r || S === a || S === o || S === i || S === e || S === s && R && R.type === "function" && R.value === "calc" || S === i && R.type === "function" && R.value === "calc" || S === A && M));
        p = E.slice(L, I), e === S ? G = p : (l === p.charCodeAt(0) || u === p.charCodeAt(0)) && g === p.charCodeAt(1) && d.test(p.slice(2)) ? C.push({
          type: "unicode-range",
          sourceIndex: L,
          sourceEndIndex: I,
          value: p
        }) : C.push({
          type: "word",
          sourceIndex: L,
          sourceEndIndex: I,
          value: p
        }), L = I;
      }
    for (L = Z.length - 1; L; L -= 1)
      Z[L].unclosed = !0, Z[L].sourceEndIndex = E.length;
    return Z[0].nodes;
  }, Ud;
}
var XJ = _J();
const qJ = /* @__PURE__ */ Ht(XJ);
var Yd, y2;
function $J() {
  if (y2) return Yd;
  y2 = 1;
  var e = 45, A = 43, t = 46, r = 101, n = 69;
  function i(a) {
    var o = a.charCodeAt(0), s;
    if (o === A || o === e) {
      if (s = a.charCodeAt(1), s >= 48 && s <= 57)
        return !0;
      var l = a.charCodeAt(2);
      return s === t && l >= 48 && l <= 57;
    }
    return o === t ? (s = a.charCodeAt(1), s >= 48 && s <= 57) : o >= 48 && o <= 57;
  }
  return Yd = function(a) {
    var o = 0, s = a.length, l, u, g;
    if (s === 0 || !i(a))
      return !1;
    for (l = a.charCodeAt(o), (l === A || l === e) && o++; o < s && (l = a.charCodeAt(o), !(l < 48 || l > 57)); )
      o += 1;
    if (l = a.charCodeAt(o), u = a.charCodeAt(o + 1), l === t && u >= 48 && u <= 57)
      for (o += 2; o < s && (l = a.charCodeAt(o), !(l < 48 || l > 57)); )
        o += 1;
    if (l = a.charCodeAt(o), u = a.charCodeAt(o + 1), g = a.charCodeAt(o + 2), (l === r || l === n) && (u >= 48 && u <= 57 || (u === A || u === e) && g >= 48 && g <= 57))
      for (o += u === A || u === e ? 3 : 2; o < s && (l = a.charCodeAt(o), !(l < 48 || l > 57)); )
        o += 1;
    return {
      number: a.slice(0, o),
      unit: a.slice(o)
    };
  }, Yd;
}
var AW = $J();
const eW = /* @__PURE__ */ Ht(AW);
var Hd, b2;
function tW() {
  if (b2) return Hd;
  b2 = 1;
  var e = function(A, t, r) {
    if (A == null)
      return [0, 0, 0];
    var n = (1 - Math.abs(2 * r - 1)) * t, i = A / 60, a = n * (1 - Math.abs(i % 2 - 1));
    i = Math.floor(i);
    var o, s, l;
    i === 0 ? (o = n, s = a, l = 0) : i === 1 ? (o = a, s = n, l = 0) : i === 2 ? (o = 0, s = n, l = a) : i === 3 ? (o = 0, s = a, l = n) : i === 4 ? (o = a, s = 0, l = n) : i === 5 && (o = n, s = 0, l = a);
    var u = r - n / 2;
    return o += u, s += u, l += u, [
      Math.abs(Math.round(o * 255)),
      Math.abs(Math.round(s * 255)),
      Math.abs(Math.round(l * 255))
    ];
  };
  return Hd = e, Hd;
}
var Sd, F2;
function rW() {
  if (F2) return Sd;
  F2 = 1;
  var e = tW();
  function A(i, a) {
    return i > a ? a : i;
  }
  function t(i, a) {
    return i < a ? a : i;
  }
  function r(i) {
    for (i = A(i, 1e7), i = t(i, -1e7); i < 0; )
      i += 360;
    for (; i > 359; )
      i -= 360;
    return i;
  }
  function n(i, a, o) {
    i = r(i), a = t(A(a, 100), 0), o = t(A(o, 100), 0), a /= 100, o /= 100;
    var s = e(i, a, o);
    return "#" + s.map(function(l) {
      return (256 + l).toString(16).substr(-2);
    }).join("");
  }
  return Sd = n, Sd;
}
var nW = rW();
const iW = /* @__PURE__ */ Ht(nW);
var Nd, L2;
function aW() {
  if (L2) return Nd;
  L2 = 1;
  function e(i) {
    this.value = i, this.match = function(a) {
      return this.value >= a.height;
    };
  }
  function A(i) {
    this.value = i, this.match = function(a) {
      return this.value < a.height;
    };
  }
  function t(i) {
    this.value = i, this.match = function(a) {
      return this.value >= a.width;
    };
  }
  function r(i) {
    this.value = i, this.match = function(a) {
      return this.value < a.width;
    };
  }
  function n(i) {
    this.value = i, this.match = function(a) {
      return this.value === a.orientation;
    };
  }
  return Nd = function(a, o) {
    switch (a) {
      case "max-height":
        return new e(o);
      case "min-height":
        return new A(o);
      case "max-width":
        return new t(o);
      case "min-width":
        return new r(o);
      case "orientation":
        return new n(o);
      default:
        throw new Error(o);
    }
  }, Nd;
}
var Td, R2;
function oW() {
  if (R2) return Td;
  R2 = 1;
  function e(t, r) {
    this.left = t, this.right = r, this.match = function(n) {
      return t.match(n) && r.match(n);
    };
  }
  function A(t, r) {
    this.left = t, this.right = r, this.match = function(n) {
      return t.match(n) || r.match(n);
    };
  }
  return Td = function(r, n, i) {
    switch (r) {
      case "and":
        return new e(n, i);
      case ",":
        return new A(n, i);
      default:
        throw new Error(value);
    }
  }, Td;
}
var Pd, G2;
function sW() {
  if (G2) return Pd;
  G2 = 1;
  var e = aW(), A = oW(), t = /[0-9]/, r = /[a-z|\-]/i, n = /\s/, i = /:/, a = /,/, o = /and$/, s = /@/;
  function l(g) {
    for (var d = 0, h = []; d < g.length; ) {
      var C = g[d];
      if (s.test(C))
        for (C = g[++d]; r.test(C) && C !== void 0; )
          C = g[++d];
      if (n.test(C) || C === ")" || C === "(") {
        d++;
        continue;
      }
      if (i.test(C) || a.test(C)) {
        d++, h.push({ type: "operator", value: C });
        continue;
      }
      if (t.test(C)) {
        for (var E = ""; t.test(C); )
          E += C, C = g[++d];
        h.push({ type: "number", value: E });
        continue;
      }
      if (r.test(C)) {
        for (var E = ""; r.test(C) && C !== void 0; )
          E += C, C = g[++d];
        o.test(E) ? h.push({ type: "operator", value: E }) : h.push({ type: "literal", value: E });
        continue;
      }
      throw new TypeError(
        "Tokenizer: I dont know what this character is: " + C
      );
    }
    return h;
  }
  function u(g) {
    for (var d = [], h = []; g.length > 0; ) {
      var C = g.shift();
      if (C.type === "number" || C.type === "literal") {
        d.push(C);
        continue;
      }
      if (C.type === "operator") {
        if (i.test(C.value)) {
          C = { type: "query", key: d.pop(), value: g.shift() }, d.push(C);
          continue;
        }
        for (; h.length > 0; )
          d.unshift(h.pop());
        h.push(C);
      }
    }
    for (; h.length > 0; )
      d.unshift(h.pop());
    function E() {
      var I = d.shift();
      if (I.type === "number")
        return parseInt(I.value);
      if (I.type === "literal")
        return I.value;
      if (I.type === "operator") {
        var b = E(), y = E();
        return A(I.value, b, y);
      }
      if (I.type === "query") {
        var b = I.key.value, y = I.value.value;
        return e(b, y);
      }
    }
    return E();
  }
  return Pd = {
    parse: function(g) {
      var d = l(g), h = u(d);
      return h;
    }
  }, Pd;
}
var zd, x2;
function lW() {
  if (x2) return zd;
  x2 = 1;
  var e = sW();
  return zd = function(A, t) {
    var r = {};
    return Object.keys(A).forEach(function(n) {
      e.parse(n).match(t) && Object.assign(r, A[n]);
    }), r;
  }, zd;
}
var uW = lW();
const cW = /* @__PURE__ */ Ht(uW), gW = [1, 1, 0], BW = [1, 1, "auto"], fW = (e, A) => {
  let t = gW, r = [];
  A === "auto" ? t = BW : r = ("" + A).split(" ");
  const n = r[0] || t[0], i = r[1] || t[1], a = r[2] || t[2];
  return {
    flexGrow: n,
    flexShrink: i,
    flexBasis: a
  };
}, dW = "px,in,mm,cm,pt,%,vw,vh", jd = (e, A) => {
  console.error(`
    @react-pdf/stylesheet parsing error:

    ` + e + ": " + A + `,
    ` + " ".repeat(e.length + 2) + `^
    Unsupported ` + e + ` value format
  `);
}, ea = function(e) {
  let {
    expandsTo: A,
    maxValues: t = 1,
    autoSupported: r = !1
  } = e === void 0 ? {} : e;
  return (n, i) => {
    const a = qJ("" + i), o = [];
    for (let l = 0; l < a.length; l++) {
      const u = a[l];
      if (u.type === "function" || u.type === "string" || u.type === "div")
        return jd(n, i), {};
      if (u.type === "word")
        if (u.value === "auto" && r)
          o.push(u.value);
        else {
          const g = eW(u.value);
          if (g && dW.includes(g.unit))
            o.push(u.value);
          else
            return jd(n, i), {};
        }
    }
    if (o.length > t)
      return jd(n, i), {};
    const s = o[0];
    if (A) {
      const l = o[1] || o[0], u = o[2] || o[0], g = o[3] || o[1] || o[0];
      return A({
        first: s,
        second: l,
        third: u,
        fourth: g
      });
    }
    return {
      [n]: s
    };
  };
}, hW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t,
      third: r,
      fourth: n
    } = e;
    return {
      marginTop: A,
      marginRight: t,
      marginBottom: r,
      marginLeft: n
    };
  },
  maxValues: 4,
  autoSupported: !0
}), CW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t
    } = e;
    return {
      marginTop: A,
      marginBottom: t
    };
  },
  maxValues: 2,
  autoSupported: !0
}), EW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t
    } = e;
    return {
      marginRight: A,
      marginLeft: t
    };
  },
  maxValues: 2,
  autoSupported: !0
}), Ac = ea({
  autoSupported: !0
}), QW = /(-?\d+(\.\d+)?(px|in|mm|cm|pt|vw|vh|px)?)\s(\S+)\s(.+)/, wW = (e) => e.match(QW) || [], Z0 = (e, A) => {
  const t = wW("" + A);
  if (t) {
    const r = t[5] || A, n = t[4] || A, i = t[1] || A;
    return e.match(/(Top|Right|Bottom|Left)$/) ? {
      [e + "Color"]: r,
      [e + "Style"]: n,
      [e + "Width"]: i
    } : e.match(/Color$/) ? {
      borderTopColor: r,
      borderRightColor: r,
      borderBottomColor: r,
      borderLeftColor: r
    } : e.match(/Style$/) ? {
      borderTopStyle: n,
      borderRightStyle: n,
      borderBottomStyle: n,
      borderLeftStyle: n
    } : e.match(/Width$/) ? {
      borderTopWidth: i,
      borderRightWidth: i,
      borderBottomWidth: i,
      borderLeftWidth: i
    } : e.match(/Radius$/) ? {
      borderTopLeftRadius: A,
      borderTopRightRadius: A,
      borderBottomRightRadius: A,
      borderBottomLeftRadius: A
    } : {
      borderTopColor: r,
      borderTopStyle: n,
      borderTopWidth: i,
      borderRightColor: r,
      borderRightStyle: n,
      borderRightWidth: i,
      borderBottomColor: r,
      borderBottomStyle: n,
      borderBottomWidth: i,
      borderLeftColor: r,
      borderLeftStyle: n,
      borderLeftWidth: i
    };
  }
  return A;
}, IW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t,
      third: r,
      fourth: n
    } = e;
    return {
      paddingTop: A,
      paddingRight: t,
      paddingBottom: r,
      paddingLeft: n
    };
  },
  maxValues: 4
}), DW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t
    } = e;
    return {
      paddingTop: A,
      paddingBottom: t
    };
  },
  maxValues: 2
}), mW = ea({
  expandsTo: (e) => {
    let {
      first: A,
      second: t
    } = e;
    return {
      paddingRight: A,
      paddingLeft: t
    };
  },
  maxValues: 2
}), ec = ea(), MW = (e, A) => {
  const t = ("" + A).split(" ");
  return {
    objectPositionX: (t == null ? void 0 : t[0]) || A,
    objectPositionY: (t == null ? void 0 : t[1]) || A
  };
}, k2 = {
  top: !0,
  bottom: !0
}, pW = (e, A) => k2[e] ? 1 : k2[A] ? -1 : 0, vW = (e) => !e || e.length === 0 ? ["center", "center"] : (e.length === 1 ? [e[0], "center"] : e).sort(pW), yW = (e, A) => {
  const t = ("" + A).split(" "), r = vW(t);
  return {
    transformOriginX: r[0],
    transformOriginY: r[1]
  };
}, bW = (e, A) => {
  const t = ("" + A).split(" ");
  return {
    rowGap: (t == null ? void 0 : t[0]) || A,
    columnGap: (t == null ? void 0 : t[1]) || A
  };
}, U2 = {
  flex: fW,
  gap: bW,
  margin: hW,
  marginHorizontal: EW,
  marginVertical: CW,
  marginTop: Ac,
  marginRight: Ac,
  marginBottom: Ac,
  marginLeft: Ac,
  padding: IW,
  paddingHorizontal: mW,
  paddingVertical: DW,
  paddingTop: ec,
  paddingRight: ec,
  paddingBottom: ec,
  paddingLeft: ec,
  border: Z0,
  borderTop: Z0,
  borderRight: Z0,
  borderBottom: Z0,
  borderLeft: Z0,
  borderColor: Z0,
  borderRadius: Z0,
  borderStyle: Z0,
  borderWidth: Z0,
  objectPosition: MW,
  transformOrigin: yW
}, FW = (e, A) => U2[e] ? U2[e](e, A) : {
  [e]: A
}, LW = (e) => {
  if (!e) return e;
  const A = Object.keys(e), t = {};
  for (let r = 0; r < A.length; r += 1) {
    const n = A[r], i = e[n], a = FW(n, i), o = Object.keys(a);
    for (let s = 0; s < o.length; s += 1) {
      const l = o[s], u = a[l];
      t[l] = u;
    }
  }
  return t;
}, RW = (e) => e.filter(Boolean), GW = (e) => e.reduce((A, t) => {
  const r = Array.isArray(t) ? FE(t) : t;
  return Object.keys(r).forEach((n) => {
    r[n] !== null && r[n] !== void 0 && (A[n] = r[n]);
  }), A;
}, {}), FE = en(GW, RW, Og), xW = (e) => {
  const A = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw|px)?$/g.exec(e);
  return A ? {
    value: parseFloat(A[1]),
    unit: A[2] || "pt"
  } : {
    value: e,
    unit: void 0
  };
}, kW = (e, A) => {
  const t = xW(A), r = 72, n = 1 / 25.4 * r, i = 1 / 2.54 * r;
  switch (t.unit) {
    case "in":
      return t.value * r;
    case "mm":
      return t.value * n;
    case "cm":
      return t.value * i;
    case "vh":
      return t.value * (e.height / 100);
    case "vw":
      return t.value * (e.width / 100);
    default:
      return t.value;
  }
}, UW = (e) => /rgba?/g.test(e), YW = (e) => /hsla?/g.test(e), HW = (e) => {
  const A = Cl.get.rgb(e);
  return Cl.to.hex(A);
}, SW = (e) => {
  const A = Cl.get.hsl(e).map(Math.round);
  return iW(...A).toUpperCase();
}, xc = (e) => UW(e) ? HW(e) : YW(e) ? SW(e) : e, NW = (e) => {
  const A = e.trim().split(/\) |\)/);
  if (A.length === 1)
    return [[A[0], !0]];
  const t = [];
  for (let r = 0; r < A.length; r += 1) {
    const n = A[r];
    if (n) {
      const [i, a] = n.split("("), o = a.indexOf(",") >= 0 ? "," : " ", s = a.split(o).map((l) => l.trim());
      t.push({
        operation: i,
        value: s
      });
    }
  }
  return t;
}, tc = (e) => {
  const A = /(-?\d*\.?\d*)(\w*)?/i, [, t, r] = A.exec(e), n = Number.parseFloat(t);
  return r === "rad" ? n * 180 / Math.PI : n;
}, TW = (e) => {
  let {
    operation: A,
    value: t
  } = e;
  switch (A) {
    case "scale": {
      const [r, n = r] = t.map((i) => Number.parseFloat(i));
      return {
        operation: "scale",
        value: [r, n]
      };
    }
    case "scaleX":
      return {
        operation: "scale",
        value: [Number.parseFloat(t), 1]
      };
    case "scaleY":
      return {
        operation: "scale",
        value: [1, Number.parseFloat(t)]
      };
    case "rotate":
      return {
        operation: "rotate",
        value: [tc(t)]
      };
    case "translate":
      return {
        operation: "translate",
        value: t.map((r) => Number.parseFloat(r))
      };
    case "translateX":
      return {
        operation: "translate",
        value: [Number.parseFloat(t), 0]
      };
    case "translateY":
      return {
        operation: "translate",
        value: [0, Number.parseFloat(t)]
      };
    case "skew":
      return {
        operation: "skew",
        value: t.map(tc)
      };
    case "skewX":
      return {
        operation: "skew",
        value: [tc(t), 0]
      };
    case "skewY":
      return {
        operation: "skew",
        value: [0, tc(t)]
      };
    default:
      return {
        operation: A,
        value: t.map((r) => Number.parseFloat(r))
      };
  }
}, PW = (e) => e.map((A) => TW(A)), Fv = (e) => typeof e != "string" ? e : PW(NW(e)), Vd = {
  thin: 100,
  hairline: 100,
  ultralight: 200,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  demibold: 600,
  bold: 700,
  ultrabold: 800,
  extrabold: 800,
  heavy: 900,
  black: 900
}, zW = (e) => {
  if (!e) return Vd.normal;
  if (typeof e == "number") return e;
  const A = e.toLowerCase();
  return Vd[A] ? Vd[A] : e;
}, jW = (e) => typeof e == "string" && /^-?\d*\.?\d*$/.test(e), LE = (e) => typeof e != "string" ? e : jW(e) ? parseFloat(e) : e, Lv = (e) => {
  switch (e) {
    case "top":
    case "left":
      return "0%";
    case "right":
    case "bottom":
      return "100%";
    case "center":
      return "50%";
    default:
      return null;
  }
}, Y2 = (e) => Lv(e) || LE(e), H2 = (e) => Lv(e) || LE(e), S2 = {
  transform: Fv,
  fontWeight: zW,
  objectPositionX: Y2,
  objectPositionY: Y2,
  transformOriginX: H2,
  transformOriginY: H2
}, VW = (e, A, t) => {
  const r = S2[e] ? S2[e](A) : A;
  return xc(kW(t, LE(r)));
}, OW = (e) => (A) => {
  if (!A) return A;
  const t = Object.keys(A), r = {};
  for (let n = 0; n < t.length; n += 1) {
    const i = t[n], a = A[i], o = VW(i, a, e);
    r[i] = o;
  }
  return r;
}, JW = (e, A) => Object.keys(A).reduce((t, r) => /@media/.test(r) ? {
  ...t,
  ...cW({
    [r]: A[r]
  }, e)
} : {
  ...t,
  [r]: A[r]
}, {}), WW = (e, A) => {
  const t = (r) => JW(e, r);
  return en(OW(e), LW, t, FE)(A);
};
function bl(e, A) {
  if (e == null) return {};
  var t = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (A.includes(r)) continue;
    t[r] = e[r];
  }
  return t;
}
function RE() {
  var e = function(A) {
    var t = {
      R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
      EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
      ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
      ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
      AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
      CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
      B: "a,3,f+2,2v,690",
      S: "9,2,k",
      WS: "c,k,4f4,1vk+a,u,1j,335",
      ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
      BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
      NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
      AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
      LRO: "6ct",
      RLO: "6cu",
      LRE: "6cq",
      RLE: "6cr",
      PDF: "6cs",
      LRI: "6ee",
      RLI: "6ef",
      FSI: "6eg",
      PDI: "6eh"
    }, r = {}, n = {};
    r.L = 1, n[1] = "L", Object.keys(t).forEach(function(gA, ie) {
      r[gA] = 1 << ie + 1, n[r[gA]] = gA;
    }), Object.freeze(r);
    var i = r.LRI | r.RLI | r.FSI, a = r.L | r.R | r.AL, o = r.B | r.S | r.WS | r.ON | r.FSI | r.LRI | r.RLI | r.PDI, s = r.BN | r.RLE | r.LRE | r.RLO | r.LRO | r.PDF, l = r.S | r.WS | r.B | i | r.PDI | s, u = null;
    function g() {
      if (!u) {
        u = /* @__PURE__ */ new Map();
        var gA = function(Qe) {
          if (t.hasOwnProperty(Qe)) {
            var OA = 0;
            t[Qe].split(",").forEach(function(we) {
              var se = we.split("+"), ue = se[0], ge = se[1];
              ue = parseInt(ue, 36), ge = ge ? parseInt(ge, 36) : 0, u.set(OA += ue, r[Qe]);
              for (var Pe = 0; Pe < ge; Pe++)
                u.set(++OA, r[Qe]);
            });
          }
        };
        for (var ie in t) gA(ie);
      }
    }
    function d(gA) {
      return g(), u.get(gA.codePointAt(0)) || r.L;
    }
    function h(gA) {
      return n[d(gA)];
    }
    var C = {
      pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
      canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
    };
    function E(gA, ie) {
      var Qe = 36, OA = 0, we = /* @__PURE__ */ new Map(), se = ie && /* @__PURE__ */ new Map(), ue;
      return gA.split(",").forEach(function ge(Pe) {
        if (Pe.indexOf("+") !== -1)
          for (var le = +Pe; le--; )
            ge(ue);
        else {
          ue = Pe;
          var pe = Pe.split(">"), Ze = pe[0], je = pe[1];
          Ze = String.fromCodePoint(OA += parseInt(Ze, Qe)), je = String.fromCodePoint(OA += parseInt(je, Qe)), we.set(Ze, je), ie && se.set(je, Ze);
        }
      }), { map: we, reverseMap: se };
    }
    var I, b, y;
    function p() {
      if (!I) {
        var gA = E(C.pairs, !0), ie = gA.map, Qe = gA.reverseMap;
        I = ie, b = Qe, y = E(C.canonical, !1).map;
      }
    }
    function Q(gA) {
      return p(), I.get(gA) || null;
    }
    function w(gA) {
      return p(), b.get(gA) || null;
    }
    function Y(gA) {
      return p(), y.get(gA) || null;
    }
    var k = r.L, L = r.R, S = r.EN, P = r.ES, Z = r.ET, M = r.AN, R = r.CS, G = r.B, N = r.S, z = r.ON, T = r.BN, O = r.NSM, K = r.AL, AA = r.LRO, X = r.RLO, iA = r.LRE, oA = r.RLE, fA = r.PDF, wA = r.LRI, DA = r.RLI, HA = r.FSI, sA = r.PDI;
    function lA(gA, ie) {
      for (var Qe = 125, OA = new Uint32Array(gA.length), we = 0; we < gA.length; we++)
        OA[we] = d(gA[we]);
      var se = /* @__PURE__ */ new Map();
      function ue(tr, Or) {
        var ur = OA[tr];
        OA[tr] = Or, se.set(ur, se.get(ur) - 1), ur & o && se.set(o, se.get(o) - 1), se.set(Or, (se.get(Or) || 0) + 1), Or & o && se.set(o, (se.get(o) || 0) + 1);
      }
      for (var ge = new Uint8Array(gA.length), Pe = /* @__PURE__ */ new Map(), le = [], pe = null, Ze = 0; Ze < gA.length; Ze++)
        pe || le.push(pe = {
          start: Ze,
          end: gA.length - 1,
          // 3.3.1 P2-P3: Determine the paragraph level
          level: ie === "rtl" ? 1 : ie === "ltr" ? 0 : sn(Ze, !1)
        }), OA[Ze] & G && (pe.end = Ze, pe = null);
      for (var je = oA | iA | X | AA | i | sA | fA | G, W = function(tr) {
        return tr + (tr & 1 ? 1 : 2);
      }, yA = function(tr) {
        return tr + (tr & 1 ? 2 : 1);
      }, xA = 0; xA < le.length; xA++) {
        pe = le[xA];
        var SA = [{
          _level: pe.level,
          _override: 0,
          //0=neutral, 1=L, 2=R
          _isolate: 0
          //bool
        }], eA = void 0, mA = 0, H = 0, UA = 0;
        se.clear();
        for (var ae = pe.start; ae <= pe.end; ae++) {
          var D = OA[ae];
          if (eA = SA[SA.length - 1], se.set(D, (se.get(D) || 0) + 1), D & o && se.set(o, (se.get(o) || 0) + 1), D & je)
            if (D & (oA | iA)) {
              ge[ae] = eA._level;
              var CA = (D === oA ? yA : W)(eA._level);
              CA <= Qe && !mA && !H ? SA.push({
                _level: CA,
                _override: 0,
                _isolate: 0
              }) : mA || H++;
            } else if (D & (X | AA)) {
              ge[ae] = eA._level;
              var IA = (D === X ? yA : W)(eA._level);
              IA <= Qe && !mA && !H ? SA.push({
                _level: IA,
                _override: D & X ? L : k,
                _isolate: 0
              }) : mA || H++;
            } else if (D & i) {
              D & HA && (D = sn(ae + 1, !0) === 1 ? DA : wA), ge[ae] = eA._level, eA._override && ue(ae, eA._override);
              var V = (D === DA ? yA : W)(eA._level);
              V <= Qe && mA === 0 && H === 0 ? (UA++, SA.push({
                _level: V,
                _override: 0,
                _isolate: 1,
                _isolInitIndex: ae
              })) : mA++;
            } else if (D & sA) {
              if (mA > 0)
                mA--;
              else if (UA > 0) {
                for (H = 0; !SA[SA.length - 1]._isolate; )
                  SA.pop();
                var $ = SA[SA.length - 1]._isolInitIndex;
                $ != null && (Pe.set($, ae), Pe.set(ae, $)), SA.pop(), UA--;
              }
              eA = SA[SA.length - 1], ge[ae] = eA._level, eA._override && ue(ae, eA._override);
            } else D & fA ? (mA === 0 && (H > 0 ? H-- : !eA._isolate && SA.length > 1 && (SA.pop(), eA = SA[SA.length - 1])), ge[ae] = eA._level) : D & G && (ge[ae] = pe.level);
          else
            ge[ae] = eA._level, eA._override && D !== T && ue(ae, eA._override);
        }
        for (var dA = [], ce = null, NA = pe.start; NA <= pe.end; NA++) {
          var XA = OA[NA];
          if (!(XA & s)) {
            var ke = ge[NA], Ne = XA & i, Ie = XA === sA;
            ce && ke === ce._level ? (ce._end = NA, ce._endsWithIsolInit = Ne) : dA.push(ce = {
              _start: NA,
              _end: NA,
              _level: ke,
              _startsWithPDI: Ie,
              _endsWithIsolInit: Ne
            });
          }
        }
        for (var be = [], Ye = 0; Ye < dA.length; Ye++) {
          var ye = dA[Ye];
          if (!ye._startsWithPDI || ye._startsWithPDI && !Pe.has(ye._start)) {
            for (var st = [ce = ye], Ut = void 0; ce && ce._endsWithIsolInit && (Ut = Pe.get(ce._end)) != null; )
              for (var gt = Ye + 1; gt < dA.length; gt++)
                if (dA[gt]._start === Ut) {
                  st.push(ce = dA[gt]);
                  break;
                }
            for (var Ke = [], q = 0; q < st.length; q++)
              for (var bA = st[q], $A = bA._start; $A <= bA._end; $A++)
                Ke.push($A);
            for (var Ee = ge[Ke[0]], Ve = pe.level, _e = Ke[0] - 1; _e >= 0; _e--)
              if (!(OA[_e] & s)) {
                Ve = ge[_e];
                break;
              }
            var ve = Ke[Ke.length - 1], Fe = ge[ve], Ct = pe.level;
            if (!(OA[ve] & i)) {
              for (var et = ve + 1; et <= pe.end; et++)
                if (!(OA[et] & s)) {
                  Ct = ge[et];
                  break;
                }
            }
            be.push({
              _seqIndices: Ke,
              _sosType: Math.max(Ve, Ee) % 2 ? L : k,
              _eosType: Math.max(Ct, Fe) % 2 ? L : k
            });
          }
        }
        for (var pA = 0; pA < be.length; pA++) {
          var VA = be[pA], YA = VA._seqIndices, ze = VA._sosType, Oe = VA._eosType, lt = ge[YA[0]] & 1 ? L : k;
          if (se.get(O))
            for (var St = 0; St < YA.length; St++) {
              var Ar = YA[St];
              if (OA[Ar] & O) {
                for (var bt = ze, ir = St - 1; ir >= 0; ir--)
                  if (!(OA[YA[ir]] & s)) {
                    bt = OA[YA[ir]];
                    break;
                  }
                ue(Ar, bt & (i | sA) ? z : bt);
              }
            }
          if (se.get(S))
            for (var Gr = 0; Gr < YA.length; Gr++) {
              var Pr = YA[Gr];
              if (OA[Pr] & S)
                for (var Yn = Gr - 1; Yn >= -1; Yn--) {
                  var jt = Yn === -1 ? ze : OA[YA[Yn]];
                  if (jt & a) {
                    jt === K && ue(Pr, M);
                    break;
                  }
                }
            }
          if (se.get(K))
            for (var In = 0; In < YA.length; In++) {
              var ci = YA[In];
              OA[ci] & K && ue(ci, L);
            }
          if (se.get(P) || se.get(R))
            for (var j = 1; j < YA.length - 1; j++) {
              var J = YA[j];
              if (OA[J] & (P | R)) {
                for (var rA = 0, aA = 0, EA = j - 1; EA >= 0 && (rA = OA[YA[EA]], !!(rA & s)); EA--)
                  ;
                for (var FA = j + 1; FA < YA.length && (aA = OA[YA[FA]], !!(aA & s)); FA++)
                  ;
                rA === aA && (OA[J] === P ? rA === S : rA & (S | M)) && ue(J, rA);
              }
            }
          if (se.get(S))
            for (var TA = 0; TA < YA.length; TA++) {
              var qA = YA[TA];
              if (OA[qA] & S) {
                for (var te = TA - 1; te >= 0 && OA[YA[te]] & (Z | s); te--)
                  ue(YA[te], S);
                for (TA++; TA < YA.length && OA[YA[TA]] & (Z | s | S); TA++)
                  OA[YA[TA]] !== S && ue(YA[TA], S);
              }
            }
          if (se.get(Z) || se.get(P) || se.get(R))
            for (var ee = 0; ee < YA.length; ee++) {
              var Be = YA[ee];
              if (OA[Be] & (Z | P | R)) {
                ue(Be, z);
                for (var De = ee - 1; De >= 0 && OA[YA[De]] & s; De--)
                  ue(YA[De], z);
                for (var Xe = ee + 1; Xe < YA.length && OA[YA[Xe]] & s; Xe++)
                  ue(YA[Xe], z);
              }
            }
          if (se.get(S))
            for (var Ft = 0, tt = ze; Ft < YA.length; Ft++) {
              var er = YA[Ft], ar = OA[er];
              ar & S ? tt === k && ue(er, k) : ar & a && (tt = ar);
            }
          if (se.get(o)) {
            var zr = L | S | M, yr = zr | k, o0 = [];
            {
              for (var br = [], Cr = 0; Cr < YA.length; Cr++)
                if (OA[YA[Cr]] & o) {
                  var jr = gA[YA[Cr]], ta = void 0;
                  if (Q(jr) !== null)
                    if (br.length < 63)
                      br.push({ char: jr, seqIndex: Cr });
                    else
                      break;
                  else if ((ta = w(jr)) !== null)
                    for (var N0 = br.length - 1; N0 >= 0; N0--) {
                      var Dn = br[N0].char;
                      if (Dn === ta || Dn === w(Y(jr)) || Q(Y(Dn)) === jr) {
                        o0.push([br[N0].seqIndex, Cr]), br.length = N0;
                        break;
                      }
                    }
                }
              o0.sort(function(tr, Or) {
                return tr[0] - Or[0];
              });
            }
            for (var gi = 0; gi < o0.length; gi++) {
              for (var Hn = o0[gi], ra = Hn[0], lo = Hn[1], hs = !1, Er = 0, uo = ra + 1; uo < lo; uo++) {
                var Cs = YA[uo];
                if (OA[Cs] & yr) {
                  hs = !0;
                  var Bi = OA[Cs] & zr ? L : k;
                  if (Bi === lt) {
                    Er = Bi;
                    break;
                  }
                }
              }
              if (hs && !Er) {
                Er = ze;
                for (var co = ra - 1; co >= 0; co--) {
                  var na = YA[co];
                  if (OA[na] & yr) {
                    var ia = OA[na] & zr ? L : k;
                    ia !== lt ? Er = ia : Er = lt;
                    break;
                  }
                }
              }
              if (Er) {
                if (OA[YA[ra]] = OA[YA[lo]] = Er, Er !== lt) {
                  for (var fi = ra + 1; fi < YA.length; fi++)
                    if (!(OA[YA[fi]] & s)) {
                      d(gA[YA[fi]]) & O && (OA[YA[fi]] = Er);
                      break;
                    }
                }
                if (Er !== lt) {
                  for (var di = lo + 1; di < YA.length; di++)
                    if (!(OA[YA[di]] & s)) {
                      d(gA[YA[di]]) & O && (OA[YA[di]] = Er);
                      break;
                    }
                }
              }
            }
            for (var Sn = 0; Sn < YA.length; Sn++)
              if (OA[YA[Sn]] & o) {
                for (var go = Sn, hi = Sn, T0 = ze, s0 = Sn - 1; s0 >= 0; s0--)
                  if (OA[YA[s0]] & s)
                    go = s0;
                  else {
                    T0 = OA[YA[s0]] & zr ? L : k;
                    break;
                  }
                for (var Es = Oe, mn = Sn + 1; mn < YA.length; mn++)
                  if (OA[YA[mn]] & (o | s))
                    hi = mn;
                  else {
                    Es = OA[YA[mn]] & zr ? L : k;
                    break;
                  }
                for (var aa = go; aa <= hi; aa++)
                  OA[YA[aa]] = T0 === Es ? T0 : lt;
                Sn = hi;
              }
          }
        }
        for (var or = pe.start; or <= pe.end; or++) {
          var Vr = ge[or], l0 = OA[or];
          if (Vr & 1 ? l0 & (k | S | M) && ge[or]++ : l0 & L ? ge[or]++ : l0 & (M | S) && (ge[or] += 2), l0 & s && (ge[or] = or === 0 ? pe.level : ge[or - 1]), or === pe.end || d(gA[or]) & (N | G))
            for (var Nn = or; Nn >= 0 && d(gA[Nn]) & l; Nn--)
              ge[Nn] = pe.level;
        }
      }
      return {
        levels: ge,
        paragraphs: le
      };
      function sn(tr, Or) {
        for (var ur = tr; ur < gA.length; ur++) {
          var Mt = OA[ur];
          if (Mt & (L | K))
            return 1;
          if (Mt & (G | k) || Or && Mt === sA)
            return 0;
          if (Mt & i) {
            var oa = Qs(ur);
            ur = oa === -1 ? gA.length : oa;
          }
        }
        return 0;
      }
      function Qs(tr) {
        for (var Or = 1, ur = tr + 1; ur < gA.length; ur++) {
          var Mt = OA[ur];
          if (Mt & G)
            break;
          if (Mt & sA) {
            if (--Or === 0)
              return ur;
          } else Mt & i && Or++;
        }
        return -1;
      }
    }
    var tA = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", nA;
    function GA() {
      if (!nA) {
        var gA = E(tA, !0), ie = gA.map, Qe = gA.reverseMap;
        Qe.forEach(function(OA, we) {
          ie.set(we, OA);
        }), nA = ie;
      }
    }
    function ZA(gA) {
      return GA(), nA.get(gA) || null;
    }
    function de(gA, ie, Qe, OA) {
      var we = gA.length;
      Qe = Math.max(0, Qe == null ? 0 : +Qe), OA = Math.min(we - 1, OA == null ? we - 1 : +OA);
      for (var se = /* @__PURE__ */ new Map(), ue = Qe; ue <= OA; ue++)
        if (ie[ue] & 1) {
          var ge = ZA(gA[ue]);
          ge !== null && se.set(ue, ge);
        }
      return se;
    }
    function _A(gA, ie, Qe, OA) {
      var we = gA.length;
      Qe = Math.max(0, Qe == null ? 0 : +Qe), OA = Math.min(we - 1, OA == null ? we - 1 : +OA);
      var se = [];
      return ie.paragraphs.forEach(function(ue) {
        var ge = Math.max(Qe, ue.start), Pe = Math.min(OA, ue.end);
        if (ge < Pe) {
          for (var le = ie.levels.slice(ge, Pe + 1), pe = Pe; pe >= ge && d(gA[pe]) & l; pe--)
            le[pe] = ue.level;
          for (var Ze = ue.level, je = 1 / 0, W = 0; W < le.length; W++) {
            var yA = le[W];
            yA > Ze && (Ze = yA), yA < je && (je = yA | 1);
          }
          for (var xA = Ze; xA >= je; xA--)
            for (var SA = 0; SA < le.length; SA++)
              if (le[SA] >= xA) {
                for (var eA = SA; SA + 1 < le.length && le[SA + 1] >= xA; )
                  SA++;
                SA > eA && se.push([eA + ge, SA + ge]);
              }
        }
      }), se;
    }
    function Ce(gA, ie, Qe, OA) {
      var we = WA(gA, ie, Qe, OA), se = [].concat(gA);
      return we.forEach(function(ue, ge) {
        se[ge] = (ie.levels[ue] & 1 ? ZA(gA[ue]) : null) || gA[ue];
      }), se.join("");
    }
    function WA(gA, ie, Qe, OA) {
      for (var we = _A(gA, ie, Qe, OA), se = [], ue = 0; ue < gA.length; ue++)
        se[ue] = ue;
      return we.forEach(function(ge) {
        for (var Pe = ge[0], le = ge[1], pe = se.slice(Pe, le + 1), Ze = pe.length; Ze--; )
          se[le - Ze] = pe[Ze];
      }), se;
    }
    return A.closingToOpeningBracket = w, A.getBidiCharType = d, A.getBidiCharTypeName = h, A.getCanonicalBracket = Y, A.getEmbeddingLevels = lA, A.getMirroredCharacter = ZA, A.getMirroredCharactersMap = de, A.getReorderSegments = _A, A.getReorderedIndices = WA, A.getReorderedString = Ce, A.openingToClosingBracket = Q, Object.defineProperty(A, "__esModule", { value: !0 }), A;
  }({});
  return e;
}
function N2(e, A) {
  (A == null || A > e.length) && (A = e.length);
  for (var t = 0, r = Array(A); t < A; t++) r[t] = e[t];
  return r;
}
function ZW(e, A) {
  if (e) {
    if (typeof e == "string") return N2(e, A);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? N2(e, A) : void 0;
  }
}
function T2(e, A) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ZW(e)) || A) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var kc = { exports: {} }, KW = kc.exports, P2;
function _W() {
  return P2 || (P2 = 1, function(e) {
    (function(A, t) {
      e.exports ? e.exports = t() : A.createHyphenator = t();
    })(KW, function() {
      function A(M) {
        var R = "", G = "", N = 0, z = M();
        return function(T) {
          for (; N < T.length; ) {
            R = T.charAt(N++), G = T.charAt(N);
            var O = z(R, G);
            if (O !== void 0)
              return O;
          }
        };
      }
      var t = RegExp.prototype.test.bind(
        /\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/
      );
      function r() {
        var M = !1;
        return function(R, G) {
          return M ? G[0] === ">" && (R(), M = !1) : G[0] === "<" && (!t(G[1]) || G[1] === "/") && (M = !0), M;
        };
      }
      function n(M) {
        var R = !1;
        return function(G, N) {
          return R ? !t(N[0]) && t(N[1]) && (G(), R = !1) : !t(N[0]) && N[1] === M && (R = !0), R;
        };
      }
      function i(M, R) {
        return function() {
          var G = "", N = "";
          function z() {
            G += N, N = "";
          }
          function T(O) {
            return G = "", N = "", O;
          }
          return function(O, K) {
            N += O;
            var AA = M.reduce(function(X, iA) {
              return X || iA(z, [O, K]);
            }, !1);
            if (!AA && (t(O) && !t(K) && z(), !t(O) && t(K))) {
              if (N.length >= R)
                return T([G, N]);
              z();
            }
            if (K === "")
              return (N.length < R || AA) && z(), T([G, N]);
          };
        };
      }
      function a(M) {
        var R = 0;
        function G() {
          return M[R++];
        }
        return G;
      }
      function o(M) {
        var R = 0, G = M;
        function N() {
          if (G = M.slice(R++), !(G.length < 3))
            return G;
        }
        function z() {
          return R === 2;
        }
        return [N, z];
      }
      function s(M, R, G, N, z) {
        for (var T = new Array(M.length + 1), O = ("." + M.toLocaleLowerCase() + ".").split(""), K, AA, X, iA, oA, fA, wA = -1, DA, HA, sA, lA, tA = T.length; tA--; ) T[tA] = 0;
        for (DA = o(O), HA = DA[0], sA = DA[1]; K = HA(); )
          for (wA++, sA() && wA--, X = G, lA = a(K); (AA = lA()) && (iA = X[AA]) !== void 0; ) {
            switch (X = {}, oA = -1, Object.prototype.toString.call(iA)) {
              case "[object Array]":
                X = iA[0], oA = iA[1];
                break;
              case "[object Object]":
                X = iA;
                break;
              case "[object Number]":
                oA = iA;
                break;
            }
            if (!(oA < 0)) {
              R[oA].splice || (R[oA] = R[oA].slice("")), fA = R[oA];
              for (var nA = 0; nA < fA.length; nA++)
                T[wA + nA] = Math.max(
                  fA[nA],
                  T[wA + nA]
                );
            }
          }
        T[0] = T[1] = T[T.length - 1] = T[T.length - 2] = 0;
        for (var GA = "", tA = 0; tA < T.length; tA++)
          GA += (T[tA] % 2 === 1 ? z : "") + M.charAt(tA);
        return GA;
      }
      function l(M, R, G, N, z, T, O, K, AA) {
        function X() {
          wA(iA);
        }
        var iA = "", oA, fA = A(
          i(
            (O ? [r()] : []).concat(
              n(T)
            ),
            K
          )
        ), wA = function() {
        };
        function DA() {
          for (var HA = /* @__PURE__ */ new Date(); (!AA || /* @__PURE__ */ new Date() - HA < 10) && (oA = fA(M)); ) {
            if (oA[1]) {
              var sA = oA[1].length ? "~" + oA[1] : "";
              N[sA] === void 0 && (N[sA] = s(
                oA[1],
                R,
                G,
                z,
                T
              )), oA[1] = N[sA];
            }
            iA += oA[0] + oA[1];
          }
          oA ? setTimeout(DA) : X();
        }
        return AA ? (setTimeout(DA), new Promise(function(HA) {
          wA = HA;
        })) : (DA(), iA);
      }
      var u = !1, g = !1, d = [], h = !0, C = "­", E = 5, I = "async", b = "debug", y = "exceptions", p = "html", Q = "hyphenChar", w = "minWordLength", Y = typeof _s == "object" ? _s : typeof window == "object" ? window : typeof self == "object" ? self : {};
      function k(M, R) {
        M = M || {};
        for (var G in R)
          M[G] = R[G];
        return M;
      }
      function L(M) {
        return M instanceof Array;
      }
      function S(M, R, G, N) {
        return R in M && (!N || N(M[R])) ? M[R] : G;
      }
      function P(M, R) {
        return M.reduce(function(G, N) {
          return G["~" + N.replace(/\-/g, "")] = N.replace(
            /\-/g,
            R
          ), G;
        }, {});
      }
      function Z(M, R) {
        R = R || {};
        var G = S(
          R,
          I,
          u
        ), N = {}, z = S(R, b, g), T = {}, O = S(
          R,
          Q,
          C
        ), K = M[0].split(","), AA = JSON.parse(M[1]), X = S(
          R,
          w,
          E
        ) >> 0, iA = S(R, p, h), oA = S(
          R,
          y,
          d,
          L
        ), fA = O + X;
        if (T[fA] = {}, M[2] && (T[fA] = P(
          M[2],
          O
        )), oA && oA.length && (T[fA] = k(
          T[fA],
          P(oA, O)
        )), N[fA] = k({}, T[fA]), G && !("Promise" in Y))
          throw new Error(
            "Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode"
          );
        return function(wA, DA) {
          DA = DA || {};
          var HA = S(DA, b, z), sA = S(
            DA,
            Q,
            O
          ), lA = S(DA, w, X) >> 0, tA = S(
            DA,
            y,
            d,
            L
          ), nA = sA + lA;
          return !T[nA] && M[2] && (T[nA] = P(
            M[2],
            sA
          ), N[nA] = k(N[nA], T[nA])), tA && tA.length && (T[nA] = k(
            T[nA],
            P(tA, sA)
          ), N[nA] = k(N[nA], T[nA])), l(
            wA,
            K,
            AA,
            N[nA],
            HA,
            sA,
            iA,
            lA,
            G
          );
        };
      }
      return Z;
    });
  }(kc)), kc.exports;
}
var XW = _W();
const qW = /* @__PURE__ */ Ht(XW);
var Uc = { exports: {} }, $W = Uc.exports, z2;
function AZ() {
  return z2 || (z2 = 1, function(e) {
    (function(A, t) {
      e.exports ? e.exports = t() : A.hyphenationPatternsEnUs = t();
    })($W, function() {
      return [
        "0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
        '{".":{"a":{"c":{"h":0},"d":{"d":{"e":{"r":1}}},"f":{"t":2},"l":{"t":3},"m":{"a":{"t":4}},"n":{"c":4,"g":0,"i":{"m":5},"t":[{"e":3,"i":{"s":6}},0]},"r":{"s":4,"t":{"i":{"e":1},"y":1}},"s":{"c":3,"p":2,"s":2,"t":{"e":{"r":7}}},"t":{"o":{"m":6}},"u":{"d":2},"v":{"i":1},"w":{"n":0}},"b":{"a":{"g":1,"n":{"a":4},"s":{"e":0}},"e":{"r":[{"a":4},0],"s":{"m":3,"t":{"o":4}}},"r":{"i":8},"u":{"t":{"t":{"i":0}}}},"c":{"a":{"m":{"p":{"e":0}},"n":{"c":5},"p":{"a":{"b":6}},"r":{"o":{"l":5}},"t":1},"e":{"l":{"a":1}},"h":[{"i":{"l":{"l":{"i":7}}}},1],"i":[{"t":{"r":5}},9],"o":{"e":3,"r":[{"n":{"e":{"r":5}}},1],"n":{"g":{"r":5}}}},"d":{"e":{"m":{"o":{"i":1}},"o":3,"r":{"a":3,"i":[{"v":{"a":4}},3]},"s":{"c":0}},"i":{"c":{"t":{"i":{"o":10}}}},"o":{"t":1},"u":{"c":1,"m":{"b":6}},"r":{"i":{"v":67}}},"e":{"a":{"r":{"t":{"h":7}},"s":{"i":11}},"b":1,"e":{"r":0},"g":9,"l":{"d":4,"e":{"m":3}},"n":{"a":{"m":12},"g":3,"s":3},"q":{"u":{"i":{"t":13}}},"r":{"r":{"i":1}},"s":3,"u":[{"l":{"e":{"r":1}}},3],"y":{"e":5},"t":{"h":{"y":{"l":162}}},"v":[{"e":{"r":{"s":{"i":{"b":158}}}}},9]},"f":{"e":{"s":11},"o":{"r":{"m":{"e":{"r":5}}}}},"g":{"a":[{"s":{"o":{"m":163}}},9],"e":[{"n":{"t":14},"o":{"g":4,"m":{"e":1},"t":164}},9],"i":{"a":4,"b":1},"o":{"r":1}},"h":{"a":{"n":{"d":{"i":6},"k":5}},"e":[{"r":{"o":{"i":6,"e":3}},"s":11,"t":11,"m":{"o":165},"p":{"a":166}},9],"i":{"b":3,"e":{"r":3}},"o":{"n":{"e":{"y":5},"o":11},"v":5}},"i":{"d":{"l":1,"o":{"l":12}},"m":{"m":3,"p":{"i":{"n":4}}},"n":[{"c":{"i":3},"e":8,"k":9,"s":3,"u":{"t":167}},2],"r":{"r":4},"s":{"i":1}},"j":{"u":{"r":3}},"l":{"a":{"c":{"y":1},"m":1,"t":{"e":{"r":5},"h":6}},"e":[{"g":{"e":5},"n":0,"p":5,"v":15,"i":{"c":{"e":{"s":170}}}},9],"i":{"g":[{"a":5},1],"n":9,"o":3,"t":1}},"m":{"a":{"g":{"a":16},"l":{"o":5},"n":{"a":5},"r":{"t":{"i":5}}},"e":[{"r":{"c":11},"t":{"e":{"r":4},"a":{"l":{"a":0}}},"g":{"a":{"l":171}}},9],"i":{"s":[{"t":{"i":6},"e":{"r":{"s":173}}},15],"m":{"i":{"c":172}}},"o":{"n":{"e":11},"r":{"o":3}},"u":{"t":{"a":[{"b":6},4]}}},"n":{"i":{"c":1},"e":{"o":{"f":174}},"o":{"e":{"t":{"h":15}},"n":{"e":{"m":175}}}},"o":{"d":[{"d":5},9],"f":{"t":{"e":4}},"r":{"a":{"t":{"o":4}},"c":3,"d":2,"t":3},"s":[{"t":{"l":1}},3],"t":{"h":11},"u":{"t":11}},"p":{"e":{"d":{"a":{"l":5}},"t":{"e":4,"i":{"t":4}}},"i":{"e":1,"o":{"n":5},"t":9},"r":{"e":{"m":11,"a":{"m":15}}},"o":{"l":{"y":{"s":137}},"s":{"t":{"a":{"m":137}}}}},"r":{"a":{"c":1,"n":{"t":0},"t":{"i":{"o":{"n":{"a":7}}}},"v":{"e":{"n":{"o":176}}}},"e":{"e":[{"c":173},8],"m":{"i":{"t":4}},"s":[{"t":{"a":{"t":4}}},8]},"i":{"g":1,"t":{"u":5}},"o":{"q":1,"s":{"t":5},"w":{"d":5}},"u":{"d":1}},"s":{"c":{"i":{"e":11}},"e":{"l":{"f":6,"l":6},"n":9,"r":{"i":{"e":4}},"m":{"i":[{"c":0,"d":177,"p":36,"r":36,"s":178,"v":36},6]}},"h":9,"i":[{"n":{"g":17}},9],"t":[{"a":{"b":{"l":5}}},1],"y":9,"p":{"h":{"i":{"n":179}},"i":{"n":{"o":137}}}},"t":{"a":[{"p":{"e":{"s":{"t":{"r":180}}}}},1],"e":[{"n":{"a":{"n":5}},"l":{"e":{"g":{"r":3}}}},1],"h":9,"i":[{"l":0,"m":{"o":16},"n":{"g":17,"k":5}},9],"o":{"n":{"a":0},"p":[{"i":5,"o":{"g":170}},1],"u":{"s":5},"q":9},"r":{"i":{"b":{"u":{"t":6}}}}},"u":{"n":{"a":[{"t":{"t":144}},2],"c":{"e":3},"d":{"e":{"r":7}},"e":[{"r":{"r":181}},2],"k":4,"o":4,"u":3},"p":3,"r":{"e":11},"s":{"a":4}},"v":{"e":{"n":{"d":{"e":0}},"r":{"a":4}},"i":{"c":{"a":{"r":151}}}},"w":{"i":{"l":{"i":5}},"e":{"b":{"l":131}}},"y":{"e":1},"k":{"i":{"l":{"n":{"i":168}}},"o":{"r":{"t":{"e":169}}}}},"a":{"b":{".":18,"a":{"l":19,"n":19},"e":[{"r":{"d":4}},8],"i":{"a":5,"t":{"a":{"b":13}}},"l":{"a":{"t":4}},"o":{"l":{"i":{"z":20,"c":19}}},"r":[{"o":{"g":4}},18],"u":{"l":3}},"c":{"a":{"r":[{"d":4,"o":4},21],"b":{"l":24}},"e":{"o":{"u":19},"r":2},"h":{"e":{"t":19}},"i":[{"e":23,"n":2,"o":23},22],"r":{"o":{"b":4}},"t":{"i":{"f":5}},"u":{"l":3,"m":1}},"d":[{"d":{"i":{"n":1}},"e":{"r":{".":4}},"i":[{"a":23,"c":{"a":3},"e":{"r":0},"o":23,"t":23,"u":19},25],"l":{"e":1},"o":{"w":3},"r":{"a":{"n":4}},"s":{"u":1},"u":[{"c":23,"m":4},18]},24],"e":{"r":[{"i":{"e":17}},1]},"f":[{"f":[{"i":{"s":{"h":170}}},0]},24],"g":{"a":{"b":21,"n":0},"e":{"l":{"l":4},"o":0,"u":18},"i":2,"l":26,"n":2,"o":[{"g":27,"n":{"i":3}},24],"u":{"e":{"r":19},"l":4},"y":21},"h":{"a":23,"e":23,"l":1,"o":23},"i":[{"a":19,"c":{".":23},"l":{"y":4},"n":[{"i":{"n":5},"o":5},28],"t":{"e":{"n":5}}},9],"j":29,"k":{"e":{"n":2}},"l":{"a":{"b":4,"d":3,"r":21},"d":{"i":18},"e":[{"n":{"d":3,"t":{"i":21}},"o":30},25],"i":[{"a":{".":1},"e":0},2],"l":{"e":{"v":4},"i":{"c":18}},"m":18,"o":{"g":{".":19}},"y":{".":21,"s":[{"t":31},18],"t":32,"z":27}},"m":{"a":[{"b":4,"g":3,"r":{"a":5},"s":{"c":4},"t":{"i":{"s":21},"o":33}},18],"e":{"r":{"a":4},"n":{"t":{"a":{"b":182}}}},"i":{"c":3,"f":4,"l":{"y":4},"n":[{"o":0},2]},"o":[{"n":19,"r":{"i":6}},24],"p":{"e":{"n":5}}},"n":[{"a":{"g":{"e":3},"l":{"y":[{"s":183},27]},"r":[{"c":3,"i":17},23],"t":{"i":23}},"d":[{"e":{"s":17},"i":{"s":3},"l":2,"o":{"w":1}},18],"e":{"e":19,"n":23,"s":{"t":{".":4}},"u":23},"g":[{"i":{"e":5},"l":2},25],"i":{"c":34,"e":{"s":23},"f":35,"m":{"e":1,"i":19},"n":{"e":19},"o":3,"p":23,"s":{"h":3},"t":3,"u":23},"k":{"l":{"i":1}},"n":{"i":{"z":32}},"o":[{"t":[{"h":7},4],"a":{"c":148}},0],"s":{"a":9,"c":{"o":1},"n":1,"p":[{"o":11},9],"t":1,"u":{"r":1},"g":{"r":5},"v":11},"t":{"a":{"l":36},"i":{"e":1,"d":137,"n":184,"r":{"e":137}},"o":18,"r":9,"w":1},"u":{"a":3,"l":3,"r":19}},24],"o":18,"p":{"a":{"r":17,"t":4},"e":{"r":{"o":4},"a":{"b":{"l":{"e":132}}}},"h":{"e":{"r":23},"i":18},"i":{"l":{"l":{"a":[{"r":4},21]}},"n":3,"t":{"a":3,"u":23}},"l":24,"o":{"c":6,"l":{"a":4},"r":{"i":6},"s":{"t":12}},"s":{"e":{"s":5}},"u":23},"q":{"u":{"e":6}},"r":[{"a":{"c":{"t":3},"d":{"e":19,"i":{"s":4}},"l":3,"m":{"e":{"t":{"e":19}}},"n":{"g":17},"p":11,"t":[{"i":{"o":19,"v":4}},1],"u":19,"v":38,"w":17},"b":{"a":{"l":36}},"c":{"h":{"a":{"n":1},"e":{"t":185}}},"d":{"i":{"n":{"e":4}},"r":1},"e":{"a":{"s":4},"e":23,"n":{"t":3},"s":{"s":19}},"f":{"i":1,"l":1},"i":[{"a":{"l":4,"n":3},"e":{"t":23},"m":1,"n":{"a":{"t":4}},"o":3,"z":9},2],"m":{"i":9},"o":{"d":20,"n":{"i":19},"o":23},"p":9,"q":3,"r":{"e":17,"a":{"n":{"g":{"e":9}}}},"s":{"a":1,"h":9}},37],"s":{".":18,"a":{"b":1,"n":{"t":3}},"h":{"i":17},"i":{"a":{".":19},"b":23,"c":23,"t":39},"k":{"i":11},"l":1,"o":{"c":21},"p":{"h":4},"s":{"h":1},"t":{"e":{"n":3},"r":2},"u":{"r":{"a":6}},"y":{"m":{"p":{"t":{"o":{"t":4}}}}}},"t":{"a":[{"b":{"l":3},"c":4,"l":{"o":3},"p":4},24],"e":{"c":[{"h":4},5],"g":{"o":3},"n":{".":3},"r":{"a":3,"n":[{"a":19},6]},"s":{"t":3},"v":4},"h":[{"e":{"m":5,"n":19,"r":{"o":{"s":186}}},"o":[{"m":5},1]},18],"i":{".":18,"a":19,"b":20,"c":2,"f":3,"o":{"n":{"a":{"r":7}}},"t":{"u":3}},"o":{"g":21,"m":[{"i":{"z":4}},24],"p":21,"s":21},"r":[{"o":{"p":4}},29],"s":{"k":1},"t":{"a":{"g":1},"e":[{"s":{".":170}},4],"h":1},"u":[{"a":4,"e":4,"l":3,"r":{"a":3}},24],"y":24},"u":{"b":1,"g":{"h":[{"t":{"l":17}},12],"u":3},"l":[{"i":{"f":13}},40],"n":{"d":5},"r":3,"s":{"i":{"b":4}},"t":{"e":{"n":5},"h":2}},"v":{"a":[{"g":3,"n":19},24],"e":{"n":{"o":0},"r":{"a":3,"n":4,"y":4}},"i":[{"e":{"r":0},"g":3,"o":{"u":3}},2],"o":{"c":4,"r":29}},"w":{"a":{"y":27},"i":3,"l":{"y":1},"s":0},"x":{"i":{"c":1,"d":1}},"y":{"a":{"l":4},"e":0,"s":0},"z":{"i":{"e":{"r":0}},"z":{"i":5}}},"b":{"a":{".":32,"d":{"g":{"e":{"r":5}}},"g":{"e":1},"l":{"a":15},"n":{"d":{"a":{"g":5}},"e":0,"i":11},"r":{"b":{"i":7},"i":{"a":17},"o":{"n":{"i":{"e":187}}}},"s":{"s":{"i":0}},"t":[{"h":{"y":2}},41],"z":1,"c":{"k":{"e":{"r":{".":84}}}}},"b":[{"e":[{"r":23},24],"i":{"n":{"a":0},"t":0}},42],"d":43,"e":{".":18,"a":{"k":17,"t":12},"d":[{"a":3,"e":3,"i":3},44],"g":{"i":3,"u":4},"l":[{"i":2,"o":3},41],"m":45,"n":{"i":{"g":4},"u":4},"s":[{"p":3,"t":{"r":4}},46],"t":[{"i":{"z":5},"r":4,"w":3},27],"w":3,"y":{"o":4},"v":{"i":{"e":9}}},"f":25,"h":47,"i":{"b":9,"d":[{"i":{"f":167}},1],"e":[{"n":4,"r":1},27],"f":48,"l":[{"i":{"z":3},"l":{"a":{"b":8}}},41],"n":{"a":{"r":49},"d":0,"e":{"t":4}},"o":{"g":{"r":3},"u":4,"m":5,"r":{"b":2,"h":15}},"t":[{"i":{"o":50,"v":{"e":188}},"r":3,"u":{"a":51},"z":19},9]},"j":29,"k":1,"l":[{"a":{"t":{"h":7},"n":{"d":189}},"e":{".":21,"n":17,"s":{"p":32}},"i":{"s":23,"n":{"d":189}},"o":[{"n":{"d":190}},21],"u":{"n":{"t":17}}},52],"m":43,"n":[{"e":{"g":5}},47],"o":{"d":[{"i":11},27],"e":1,"l":{"i":{"c":11}},"m":{"b":{"i":0}},"n":{"a":[{"t":5},0]},"o":27,"r":{".":32,"a":43,"d":5,"e":32,"i":32,"n":{"o":191}},"s":53,"t":{"a":19,"h":6,"o":1,"u":{"l":192}},"u":{"n":{"d":54}}},"p":18,"r":{"i":{"t":18},"o":{"t":{"h":54}},"u":{"s":{"q":17}}},"s":[{"o":{"r":17}},55],"t":[{"l":1,"o":21,"r":23},25],"u":{"f":{"f":{"e":{"r":0}}},"g":{"a":1},"l":{"i":3},"m":{"i":17},"n":[{"t":{"i":17}},1],"r":{"e":3},"s":{"i":{"e":[{"r":193,"s":193},5]},"s":{"e":17,"i":{"n":{"g":17}}},"t":32},"t":{"a":18,"i":{"o":27},"o":19,"e":{"d":{".":8}},"t":{"e":{"d":0}}}},"v":29,"w":56,"y":{".":32,"s":0}},"c":{"a":[{"b":{"i":{"n":11},"l":2},"c":{"h":17},"d":{"e":{"n":4,"m":194}},"g":46,"h":57,"l":{"a":{"t":3},"l":{"a":0,"i":{"n":6}},"o":18},"n":{"d":5,"e":0,"i":{"c":0,"s":5,"z":11},"t":{"y":0},"y":17},"p":{"e":{"r":4}},"r":{"o":{"m":5}},"s":{"t":{"e":{"r":6},"i":{"g":5}},"y":18},"t":{"h":1,"i":{"v":18},"a":{"s":195}},"v":{"a":{"l":5}}},41],"c":[{"h":{"a":6},"i":{"a":0},"o":{"m":{"p":{"a":10}},"n":17,"u":{"t":12}}},23],"e":{".":25,"d":{".":18,"e":{"n":18}},"i":27,"l":{".":32,"l":27},"n":[{"c":27,"e":58,"i":18,"t":27},41],"p":27,"r":{"a":{"m":4}},"s":{"a":18,"s":{"i":[{"b":59},27]},"t":5},"t":[{"a":60},0],"w":0},"h":[{".":18,"a":{"b":61,"n":{"i":{"c":32,"s":20}}},"e":[{"a":{"p":54},"d":18,"l":{"o":5},"m":{"i":27},"n":{"e":4},"r":{".":3,"s":3}},8],"i":{"n":[{"e":{".":32,"s":{"s":4}},"i":32},62],"o":32,"t":27,"z":8,"e":{"v":{"o":6}}},"o":63,"t":{"i":1},"s":{".":18,"h":{"u":11}}},25],"i":[{"a":[{"b":64,"r":5},27],"c":4,"e":{"r":18},"f":{"i":{"c":{".":32}}},"i":18,"l":{"a":1,"i":27},"m":25,"n":[{"a":[{"t":27},21],"e":{"m":11},"g":[{".":19},29],"o":32,"q":8},25],"o":{"n":17},"p":{"e":18,"h":3,"i":{"c":18}},"s":{"t":{"a":18,"i":18}},"t":[{"i":{"z":11}},42],"z":32,"g":{"a":{"r":152}}},41],"k":[{"i":3},2],"l":[{"a":{"r":[{"a":{"t":{"i":{"o":19}}},"e":32},18]},"e":{"m":0,"a":{"r":0}},"i":{"c":18,"m":17},"y":0},65],"n":19,"o":[{"a":{"g":4},"e":8,"g":[{"r":1},25],"i":[{"n":{"c":3}},0],"l":{"i":5,"o":[{"r":11},32]},"m":{"e":{"r":5}},"n":{"a":0,"e":21,"g":11,"t":5},"p":{"a":3,"i":{"c":11},"l":1,"h":{"o":{"n":196}}},"r":{"b":18,"o":{"n":12}},"s":{"e":0},"v":[{"e":17},15],"w":{"a":5},"z":{"e":5,"i":4},"u":{"s":{"t":{"i":84}}}},41],"q":29,"r":{"a":{"s":{"t":6},"t":{".":32,"i":{"c":32}}},"e":{"a":{"t":11},"d":32,"t":{"a":47},"v":0},"i":[{"f":5,"n":21,"s":17,"t":{"i":[{"e":11},32]}},8],"o":{"p":{"l":0,"o":6},"s":{"e":17},"c":{"o":{"d":197}},"e":{"c":{"o":148}}},"u":{"d":0}},"s":66,"t":[{"a":{"b":0,"n":{"g":4,"t":19}},"e":[{"r":23},24],"i":{"c":{"u":21},"m":{"i":12}},"u":{"r":0},"w":21,"r":{"o":{"m":{"e":{"c":198}}}}},42],"u":{"d":5,"f":21,"i":[{"t":{"y":4}},21],"l":{"i":32,"t":{"i":{"s":0},"u":27}},"m":{"a":9,"e":23,"i":1},"n":27,"p":{"i":3,"y":4},"r":{"a":{"b":67,"n":{"c":{"e":199}}},"i":{"a":4}},"s":[{"s":{"i":17}},41],"t":[{"i":{"e":1,"v":56},"r":18},68]},"y":41,"z":{"e":0}},"d":{"a":[{".":32,"b":70,"c":{"h":17},"f":18,"g":25,"m":71,"n":{"g":11},"r":{"d":6,"k":6,"y":18},"t":[{"i":{"v":18},"o":18,"a":{"b":137}},27],"v":[{"e":5},53],"y":32,"l":{"o":{"n":{"e":48}}}},69],"b":29,"c":19,"d":[{"a":{"b":20},"i":{"b":94}},72],"e":{".":25,"a":{"f":6,"l":{"s":{".":1}}},"b":{"i":{"t":5},"o":{"n":1}},"c":{"a":{"n":36},"i":{"l":1},"o":{"m":4},"l":{"a":{"r":200},"i":{"n":{"a":64}}}},"d":42,"e":{".":18},"i":{"f":4},"l":{"i":{"e":17,"q":16},"o":4},"m":[{".":32,"i":{"c":[{".":5},27],"l":4},"o":{"n":{"s":1},"r":7,"s":9}},21],"n":[{"a":{"r":1},"o":3,"t":{"i":{"f":7}},"u":3},41],"p":[{"a":3,"i":17,"u":9},2],"q":23,"r":{"h":21,"m":32,"n":{"i":{"z":6}},"s":5},"s":[{".":24,"c":2,"o":64,"t":{"i":11,"r":3},"u":1,"i":{"c":11}},8],"t":[{"o":9,"i":{"c":9}},2],"v":[{"i":{"l":11}},2],"y":18,"f":{"i":{"n":{"i":{"t":{"i":201}}}}}},"f":43,"g":{"a":21,"e":{"t":73},"i":2,"y":24},"h":74,"i":{".":32,"a":[{"b":5},75],"c":{"a":{"m":1,"i":{"d":15}},"e":21,"t":27},"d":27,"e":{"n":76},"f":[{"f":{"r":{"a":5}}},29],"g":{"e":3},"l":{"a":{"t":{"o":1}}},"n":[{"a":41,"e":{".":27},"i":[{"z":4},32]},29],"o":[{"g":5},41],"p":{"l":1},"r":[{"e":[{"n":9,"r":9},2],"t":{"i":6}},8],"s":[{"i":32,"t":77},15],"t":{"i":24},"v":78,"m":{"e":{"t":{"h":{"y":141}}}}},"j":29,"k":79,"l":{"a":56,"e":{".":27,"d":27,"s":{".":27,"s":18},"a":{"d":42}},"o":48,"u":56,"y":25,"i":{"e":202}},"m":29,"n":80,"o":[{".":27,"d":{"e":4},"e":32,"f":57,"g":21,"l":{"a":1,"i":17,"o":{"r":4}},"m":{"i":{"z":5}},"n":{"a":{"t":3},"i":17},"o":{"d":11},"p":{"p":0},"r":21,"s":27,"u":{"t":56},"v":1,"x":27,"w":{"o":{"r":{"d":203}}}},41],"p":29,"r":[{"a":{"g":{"o":{"n":6}},"i":18},"e":[{"a":{"r":6},"n":[{"a":{"l":204}},32]},0],"i":{"b":0,"l":17,"f":{"t":{"a":189}},"p":{"l":{"e":{"g":205}}}},"o":{"p":0,"w":18,"m":{"e":{"d":206}}},"u":{"p":{"l":{"i":32}}},"y":18},41],"s":[{"p":1,"w":21,"y":21},81],"t":{"h":24,"a":{"b":23}},"u":[{"a":[{"l":{".":9}},82],"c":[{"a":29,"e":{"r":5},"t":{".":18,"s":18}},9],"e":{"l":4},"g":1,"l":{"e":23},"m":{"b":{"e":0}},"n":1,"p":[{"e":1},18],"o":{"p":{"o":{"l":207}}}},41],"v":29,"w":29,"y":[{"n":32,"s":{"e":1,"p":5}},24]},"e":{"a":{"b":72,"c":{"t":23},"d":[{"i":{"e":5}},15],"g":{"e":[{"r":4},1]},"l":[{"e":{"r":5},"o":{"u":11}},1],"m":{"e":{"r":11}},"n":{"d":19,"i":{"e":{"s":111}}},"r":{"a":11,"c":0,"e":{"s":5},"i":{"c":0,"l":0},"k":5,"t":[{"e":12},8]},"s":{"p":4,"s":23,"t":12},"t":[{"e":{"n":5},"h":{"i":12},"i":{"f":19},"u":83},9],"v":[{"e":{"n":11},"i":5,"o":5},9]},"b":[{"e":{"l":{".":21,"s":21},"n":21},"i":{"t":21},"r":23},42],"c":{"a":{"d":21,"n":{"c":6}},"c":{"a":6},"e":[{"s":{"s":{"a":4}}},29],"i":[{"b":21,"f":{"i":{"c":{"a":{"t":4}},"e":4},"y":4},"m":3,"t":[{"e":19},0]},9],"l":{"a":{"m":21},"u":{"s":21}},"o":{"l":24,"m":{"m":21,"p":{"e":21}},"n":{"c":21},"r":[{"a":3,"o":5},24]},"r":[{"e":{"m":21}},29],"t":{"a":{"n":1},"e":1},"u":[{"l":[{"a":3},21]},29],"h":{"a":{"s":23}}},"d":{"a":37,"d":61,"e":{"r":34,"s":0},"i":[{"a":23,"b":3,"c":{"a":3},"m":3,"t":2,"z":5},18],"o":[{"l":21,"n":84},18],"r":{"i":21},"u":{"l":[{"o":4,"i":{"n":{"g":2}}},21]},"g":{"l":15}},"e":{"c":9,"d":{"i":11},"f":9,"l":{"i":11,"y":1},"m":9,"n":{"a":1},"p":85,"s":[{"t":17},86],"t":{"y":1},"x":19},"f":[{"e":{"r":{"e":83}},"f":41,"i":{"c":[{"i":32},21],"l":17,"n":{"e":23,"i":{"t":{"e":20}}},"t":27},"o":{"r":{"e":{"s":6}}},"u":{"s":{"e":{".":21}}}},29],"g":{"a":{"l":18},"e":{"r":17},"i":{"b":4,"c":1,"n":{"g":4},"t":87},"n":4,"o":{".":21,"s":21},"u":{"l":2,"r":19},"y":32},"h":[{"e":{"r":17}},72],"i":[{"c":19,"d":4,"g":[{"l":4},8],"m":{"b":23},"n":{"f":23,"g":29,"s":{"t":19}},"r":{"d":0},"t":{"e":11,"h":3,"y":19}},9],"j":[{"u":{"d":[{"i":4},21]}},29],"k":{"i":{"n":0},"l":{"a":1}},"l":{"a":[{".":21,"c":21,"n":{"d":17},"t":{"i":{"v":4}},"w":21,"x":{"a":36}},29],"e":{"a":23,"b":{"r":{"a":4}},"c":32,"d":21,"g":{"a":3},"n":19,"r":34,"s":29},"f":9,"i":[{"b":{"e":23},"c":{".":33,"a":3},"e":{"r":23},"g":{"i":{"b":4}},"m":19,"n":{"g":83},"o":23,"s":[{"h":4},24],"v":88,"t":{"i":{"s":208}}},9],"l":{"a":[{"b":1},18],"o":17},"o":{"c":19,"g":4,"p":{".":3},"a":29},"s":{"h":9},"t":{"a":1},"u":{"d":19,"g":4}},"m":{"a":{"c":21,"g":21,"n":[{"a":4},19]},"b":4,"e":[{"l":24,"t":21},29],"i":{"c":{"a":3},"e":0,"g":{"r":{"a":4}},"n":[{"e":4,"i":35},89],"s":[{"h":4,"s":19},21],"z":3},"n":{"i":{"z":32}},"o":{"g":0,"n":{"i":{"o":7}}},"p":{"i":3},"u":{"l":[{"a":4},21],"n":11},"y":23},"n":{"a":{"m":{"o":4},"n":{"t":21}},"c":{"h":{"e":{"r":17}}},"d":{"i":{"c":3,"x":2}},"e":{"a":19,"e":19,"m":3,"r":{"o":4},"s":{"i":4,"t":4},"t":{"r":3},"w":23},"i":{"c":{"s":4},"e":19,"l":19,"o":23,"s":{"h":3},"t":3,"u":19,"z":32},"n":18,"o":[{"g":0,"s":21,"v":3},18],"s":{"w":1},"t":{"a":{"g":{"e":5}},"h":{"e":{"s":18}}},"u":{"a":3,"f":4},"y":{".":23},"z":61},"o":{"f":19,"g":[{"r":{"a":{"p":3}}},9],"i":90,"l":23,"p":{"a":{"r":11}},"r":[{"e":3,"o":{"l":4}},29],"s":0,"t":[{"o":1},21],"u":{"t":19},"w":19},"p":{"a":[{"i":23,"n":{"c":4}},24],"e":{"l":19,"n":{"t":23},"t":{"i":{"t":{"i":{"o":4}}}}},"h":{"e":17},"l":{"i":21},"o":29,"r":{"e":{"c":[{"a":4},21],"d":21,"h":3},"o":[{"b":21},23]},"s":{"h":1},"t":{"i":{"b":13}},"u":{"t":[{"a":4},21]},"i":{"n":{"e":{"p":{"h":209}}}}},"q":[{"u":{"i":{"l":12,"s":91}}},29],"r":{"a":[{"b":0,"n":{"d":18},"r":3,"t":{"i":{".":18}}},2],"b":[{"l":1},25],"c":{"h":[{"e":1},3]},"e":{".":25,"a":{"l":23},"c":{"o":5},"i":{"n":11},"l":{".":4},"m":{"o":3},"n":{"a":4,"c":{"e":4},"e":18,"t":3},"q":0,"s":{"s":4,"t":3},"t":17},"h":2,"i":[{"a":[{"n":{".":210}},92],"c":{"k":32},"e":{"n":23,"r":0},"n":{"e":3},"o":29,"t":18,"u":1,"v":[{"a":21},0]},2],"m":93,"n":{"i":{"s":1,"t":18,"z":32},"o":3},"o":[{"b":4,"c":19,"r":0,"u":2},25],"s":[{"e":{"t":3}},2],"t":{"e":{"r":11},"l":18,"w":3},"u":[{"t":0},18],"w":{"a":{"u":32}}},"s":{"a":[{"g":{"e":{".":21,"s":21}}},72],"c":[{"a":[{"n":4},24],"r":23,"u":4},9],"e":[{"c":[{"r":4},24],"n":{"c":4},"r":{"t":{".":21,"s":21},"v":{"a":21}}},74],"h":[{"a":23,"e":{"n":5}},18],"i":[{"c":24,"d":[{"e":{"n":4}},24],"g":{"n":{"a":4}},"m":94,"n":95,"s":{"t":{"e":17}},"u":0},29],"k":{"i":{"n":19}},"m":{"i":1},"o":{"l":[{"u":3},24],"n":[{"a":4},24]},"p":[{"e":{"r":3},"i":{"r":{"a":4}},"r":{"e":1},"a":{"c":{"i":211}}},29],"s":[{"i":{"b":96}},25],"t":{"a":{"n":36},"i":{"g":3,"m":4},"o":[{"n":23},44],"r":[{"o":19,"u":{"c":10}},25]},"u":{"r":[{"r":4},24]},"w":1},"t":{"a":{"b":0},"e":{"n":{"d":17},"o":23},"h":{"o":{"d":54},"y":{"l":{"e":{"n":{"e":162}}}}},"i":{"c":2,"d":{"e":19},"n":[{"o":0},17],"r":19,"t":{"i":{"o":19,"v":4}}},"n":18,"o":{"n":{"a":4}},"r":{"a":23,"e":23,"i":{"c":3,"f":4},"o":{"g":3,"s":4}},"u":{"a":3},"y":{"m":4},"z":4},"u":[{"n":19,"p":23,"r":{"o":3},"s":0,"t":{"e":17,"i":{"l":6},"r":4},"c":{"l":{"i":{"d":212}}}},18],"v":{"a":{"p":97,"s":[{"t":4},24]},"e":{"a":19,"l":{"l":3,"o":12},"n":{"g":19,"i":17},"r":[{"b":19},2]},"i":[{"d":3,"l":0,"n":21,"v":0},29],"o":{"c":19},"u":19},"w":{"a":[{"g":21},29],"e":{"e":19},"h":23,"i":{"l":6,"n":{"g":3},"t":23}},"x":{"p":41},"y":{"c":32,"e":{".":32},"s":0}},"f":{"a":[{"b":{"l":3,"r":11},"c":{"e":1},"g":18,"i":{"n":17},"l":{"l":{"e":6}},"m":{"a":26,"i":{"s":5}},"r":[{"t":{"h":5}},32],"t":{"a":3,"h":{"e":3},"o":18},"u":{"l":{"t":7}}},41],"b":56,"d":18,"e":{".":18,"a":{"s":17,"t":{"h":54}},"b":[{"r":{"u":{"a":15}}},1],"c":{"a":18,"t":32},"d":25,"l":{"i":3},"m":{"o":1},"n":{"d":[{"e":6},8]},"r":[{"r":32,"m":{"i":{"o":213}}},15],"v":0},"f":[{"e":{"s":21},"i":{"e":21,"n":{".":19},"s":94},"l":{"y":21},"y":24},43],"h":18,"i":[{"a":3,"c":{".":48,"a":{"l":47,"n":23,"t":{"e":18}},"e":{"n":23,"r":3},"i":[{"a":32,"e":32},0],"s":18,"u":3,"h":27},"d":{"e":{"l":4}},"g":{"h":{"t":7}},"l":{"i":5,"l":{"i":{"n":6}},"y":18},"n":[{"a":32,"d":97,"e":9,"g":98,"n":0},25],"s":{"t":{"i":0}},"t":{"t":{"e":{"d":{".":5}}}}},41],"l":[{"e":{"s":{"s":19}},"i":{"n":17},"o":{"r":{"e":11},"w":{"e":{"r":{".":84}}}},"y":100,"a":{"g":{"e":{"l":214}}},"u":{"o":{"r":27}}},99],"m":18,"n":18,"o":[{"n":[{"d":{"e":0},"t":0},32],"r":[{"a":{"t":4,"y":5},"e":{"t":6},"i":0,"t":{"a":6}},9],"s":5},41],"p":56,"r":{"a":{"t":0},"e":{"a":19,"s":{"c":6}},"i":[{"l":17},8],"o":{"l":6}},"s":48,"t":[{"o":21,"y":24},25],"u":[{"e":{"l":4},"g":18,"m":{"i":{"n":1}},"n":{"e":4},"r":{"i":3},"s":{"i":17,"s":0},"t":{"a":18}},27],"y":41},"g":{"a":[{"f":0,"l":{".":32,"i":27,"o":3},"m":[{"e":{"t":4},"o":19},25],"n":{"i":{"s":5,"z":[{"a":6},3]},"o":18},"r":{"n":67},"s":{"s":17},"t":{"h":12,"i":{"v":18}},"z":18},41],"b":23,"d":1,"e":{".":25,"d":25,"e":{"z":17},"l":{"i":{"n":0,"s":4,"z":4},"y":18},"n":[{"a":{"t":1},"i":{"z":4},"o":18,"y":18,"c":{"y":{".":8}}},41],"o":[{"m":3,"d":215},41],"r":{"y":21},"s":{"i":32},"t":{"h":6,"o":18,"y":1,"i":{"c":{".":8}}},"v":1},"g":[{"e":[{"r":23},24],"l":{"u":6},"o":0},101],"h":{"i":{"n":3},"o":{"u":{"t":4}},"t":{"o":1,"w":{"e":15}}},"i":{".":32,"a":[{"r":5},102],"c":[{"i":{"a":32},"o":21},29],"e":{"n":6,"s":{".":32}},"l":0,"m":{"e":{"n":23}},"n":{".":68,"g":{"e":5},"s":103},"o":32,"r":[{"l":0},27],"s":{"l":23},"u":1,"v":32,"z":27},"l":[{"a":[{"d":{"i":6},"s":32},0],"e":[{"a":{"d":29}},41],"i":{"b":0,"g":23,"s":{"h":43}},"o":[{"r":11,"b":{"i":{"n":106}}},27]},9],"m":[{"y":21},29],"n":{"a":[{".":21,"c":69},1],"e":{"t":{"t":17,"i":{"s":{"m":137}}}},"i":[{"n":24,"o":21},29],"o":[{"n":21,"m":{"o":5},"r":{".":216,"e":{"s":{"p":24}}}},29]},"o":[{".":27,"b":5,"e":32,"g":104,"i":{"s":3},"n":[{"a":105,"d":{"o":7},"i":[{"z":{"a":217}},3]},8],"o":32,"r":{"i":{"z":4},"o":{"u":5}},"s":{".":32},"v":15},41],"p":23,"r":[{"a":{"d":{"a":18},"i":21,"n":84,"p":{"h":{".":32,"e":{"r":[{".":7},19]},"i":{"c":32},"y":18}},"y":18},"e":{"n":0,"s":{"s":{".":18}}},"i":{"t":18,"e":{"v":213}},"o":21,"u":{"f":17}},41],"s":[{"t":{"e":19}},9],"t":{"h":11},"u":{"a":[{"r":{"d":27}},1],"e":25,"i":{"t":106},"n":27,"s":27,"t":[{"a":{"n":29}},26]},"w":23,"y":[{"n":107,"r":{"a":4}},41]},"h":{"a":{"b":{"l":73},"c":{"h":17},"e":{"m":0,"t":0},"g":{"u":19},"l":{"a":[{"m":12},3]},"m":1,"n":{"c":{"i":0,"y":0},"d":{".":32},"g":[{"e":{"r":6},"o":6},0],"i":{"z":108},"k":0,"t":{"e":0}},"p":{"l":11,"t":5,"a":{"r":{"r":218}}},"r":{"a":{"n":3,"s":4},"d":[{"e":12},8],"l":{"e":0},"p":{"e":{"n":6}},"t":{"e":{"r":5}}},"s":{"s":5},"u":{"n":17},"z":[{"a":11},32],"i":{"r":{"s":137}},"t":{"c":{"h":213}}},"b":29,"e":{"a":{"d":41,"r":27},"c":{"a":{"n":1,"t":19}},"d":[{"o":13},21],"l":{"i":93,"l":{"i":{"s":0},"y":0},"o":19},"m":{"p":0},"n":[{"a":[{"t":5},17]},9],"o":{"r":5},"p":5,"r":{"a":[{"p":12},21],"b":{"a":0},"e":{"a":6},"n":23,"o":{"u":19},"y":23},"s":[{"p":64},29],"t":[{"e":{"d":0}},1],"u":0,"x":{"a":168}},"f":29,"h":29,"i":{"a":{"n":4},"c":{"o":1},"g":{"h":6},"l":109,"m":{"e":{"r":36}},"n":{"a":21},"o":{"n":{"e":17}},"p":[{"e":{"l":{"a":219}}},1],"r":{"l":0,"o":3,"p":0,"r":0},"s":{"e":{"l":11},"s":0},"t":{"h":{"e":{"r":6}},"e":{"s":{"i":{"d":12}}}},"v":9},"k":18,"l":[{"a":{"n":17},"o":[{"r":{"i":11}},24]},80],"m":[{"e":{"t":17}},43],"n":[{"a":{"u":{"z":12}}},42],"o":{"d":{"i":{"z":19},"s":19},"g":[{"e":17},1],"l":{"a":{"r":5},"e":110},"m":{"a":1,"e":12},"n":{"a":0,"y":4},"o":{"d":27,"n":17},"r":{"a":{"t":5},"i":{"s":4,"c":{".":187}},"t":{"e":12},"u":4},"s":{"e":[{"n":4},0],"p":15},"u":{"s":[{"e":54},41]},"v":{"e":{"l":5}}},"p":56,"r":[{"e":{"e":6},"o":{"n":{"i":{"z":5}},"p":{"o":11}}},26],"s":[{"h":21},101],"t":{"a":{"r":21},"e":{"n":2,"s":4,"o":{"u":216}},"y":21},"u":{"g":1,"m":{"i":{"n":1}},"n":{"k":{"e":5},"t":0},"s":{"t":14},"t":1},"w":[{"a":{"r":{"t":21}}},29],"y":{"p":{"e":3,"h":3,"o":{"t":{"h":{"a":137}}}},"s":9}},"i":{"a":[{"l":24,"m":[{"e":{"t":{"e":5}}},0],"n":[{"c":18,"i":11,"t":46},24],"p":{"e":4},"s":{"s":17},"t":{"i":{"v":21},"r":{"i":{"c":1}},"u":21}},42],"b":{"e":[{"r":{"a":3,"t":4}},0],"i":{"a":4,"n":3,"t":{".":4,"e":4}},"l":[{"i":3},29],"o":19,"r":[{"i":94},29],"u":{"n":19}},"c":{"a":{"m":18,"p":32,"r":[{".":21,"a":21},18],"s":6,"y":21},"c":{"u":17},"e":{"o":18},"h":18,"i":[{"d":19,"n":{"a":4},"p":[{"a":3},24]},25],"l":{"y":21},"o":{"c":94},"r":[{"a":32,"y":21},43],"t":{"e":1,"u":[{"a":111},84]},"u":{"l":{"a":3},"m":1,"o":4,"r":23}},"d":[{"a":{"i":21,"n":{"c":4}},"d":4,"e":{"a":{"l":11},"s":0},"i":[{"a":{"n":4,"r":0},"e":19,"o":[{"u":5,"s":1},3],"t":2,"u":4},24],"l":{"e":23},"o":{"m":21,"w":3},"r":21,"u":[{"o":4},24]},25],"e":[{"d":{"e":0},"g":{"a":113},"l":{"d":12},"n":{"a":67,"e":0,"n":19,"t":{"i":23}},"r":{".":29},"s":{"c":23,"t":29},"t":23},112],"f":{".":18,"e":{"r":{"o":4}},"f":{"e":{"n":5},"r":1},"i":{"c":{".":18},"e":23},"l":23,"t":18,"a":{"c":{"e":{"t":137}}}},"g":[{"a":{"b":5},"e":{"r":{"a":3}},"h":{"t":{"i":12}},"i":[{"b":23,"l":3,"n":3,"t":3},18],"l":28,"o":[{"r":3,"t":4},24],"r":{"e":19},"u":{"i":5,"r":2},"n":{"i":{"t":[{"e":{"r":213}},0]}}},25],"h":23,"i":114,"j":[{"k":21},23],"k":18,"l":{"a":[{"b":93,"d":{"e":21},"m":94,"r":{"a":5}},29],"e":{"g":23,"r":2,"v":17},"f":4,"i":[{"a":3,"b":9,"o":3,"s":{"t":1},"t":25,"z":9},2],"l":{"a":{"b":5}},"n":18,"o":{"q":3},"t":{"y":1},"u":{"r":4},"v":3},"m":{"a":{"g":[{"e":3},21],"r":{"y":5}},"e":{"n":{"t":{"a":{"r":10}}},"t":18},"i":[{"d":{"a":4},"l":{"e":5},"n":{"i":19},"t":18},2],"n":{"i":1},"o":{"n":23},"u":[{"l":{"a":3}},24],"p":{"e":{"d":{"a":201}}}},"n":{".":25,"a":{"u":83,"v":18},"c":{"e":{"l":36,"r":3}},"d":[{"l":{"i":{"n":{"g":4}}}},18],"e":[{"e":23,"r":{"a":{"r":17}},"s":{"s":19}},25],"g":{"a":18,"e":[{"n":4},18],"i":18,"l":{"i":{"n":{"g":4}}},"o":18,"u":18},"i":[{".":19,"a":21,"o":3,"s":2,"t":{"e":{".":19,"l":{"y":{".":19}}},"i":{"o":32},"y":3}},25],"k":18,"l":18,"n":25,"o":[{"c":90,"s":0,"t":21},42],"s":[{"e":3,"u":{"r":{"a":7}}},25],"t":{".":25,"h":112},"u":[{"s":19},2],"y":18,"f":{"r":{"a":{"s":220}}}},"o":[{".":18,"g":{"e":17,"r":9},"l":29,"m":1,"n":{"a":{"t":11},"e":{"r":{"y":0}},"i":11},"p":{"h":4},"r":{"i":11},"s":21,"t":{"h":4,"i":19,"o":1},"u":{"r":21}},25],"p":[{"e":0,"h":{"r":{"a":{"s":115}}},"i":[{"c":1},3],"r":{"e":96},"u":{"l":3}},25],"q":{"u":{"a":23,"e":{"f":4},"i":{"d":3,"t":116}}},"r":[{"a":[{"b":0,"c":21},29],"d":{"e":5},"e":{"d":{"e":0},"f":21,"l":117,"s":21},"g":{"i":4},"i":[{"d":{"e":5},"s":1,"t":{"u":11},"z":118},2],"m":{"i":{"n":1}},"o":{"g":0,"n":{".":32}},"u":{"l":4},"r":{"e":{"v":{"o":{"c":221}}}}},18],"s":{".":25,"a":{"g":4,"r":3,"s":6},"c":[{"h":3},119],"e":[{"r":3},18],"f":27,"h":{"a":{"n":4},"o":{"n":3,"p":5}},"i":{"b":3,"d":0,"s":19,"t":{"i":{"v":4}}},"k":26,"l":{"a":{"n":36}},"m":{"s":18},"o":[{"m":{"e":{"r":5}}},24],"p":[{"i":9,"y":1},2],"s":[{"a":{"l":1},"e":{"n":36,"s":1}},62],"t":{"a":{".":1},"e":2,"i":2,"l":{"y":0},"r":{"a":{"l":18}}},"u":[{"s":4},24]},"t":{"a":{".":18,"b":{"i":0},"g":21,"m":120,"n":23,"t":23},"e":[{"r":{"a":3,"i":19},"s":[{"i":{"m":{"a":29}}},1]},25],"h":[{"i":{"l":148}},25],"i":[{"a":18,"c":[{"a":3,"k":31},22],"g":3,"l":{"l":4},"m":24,"o":25,"s":[{"m":21},18],"n":{"e":{"r":{"a":{"r":158}}}}},29],"o":{"m":121,"n":18},"r":{"a":{"m":21},"y":4},"t":18,"u":{"a":{"t":3},"d":19,"l":3},"z":{".":18}},"u":29,"v":[{"e":{"l":{"l":3},"n":{".":3},"r":{".":83,"s":{".":21}}},"i":{"l":{".":4},"o":4,"t":2},"o":{"r":{"e":19,"o":35},"t":83}},25],"w":56,"x":{"o":1},"y":18,"z":{"a":{"r":18},"i":0,"o":{"n":{"t":32}}}},"j":{"a":[{"c":{"q":0},"p":[{"a":{"n":{"e":{"s":220}}}},1],"n":{"u":{"a":12}}},32],"e":[{"r":{"s":5,"e":{"m":222}},"s":{"t":{"i":{"e":18},"y":18}},"w":11},41],"o":{"p":1},"u":{"d":{"g":32}}},"k":{"a":{".":27,"b":23,"g":19,"i":{"s":17},"l":0},"b":29,"e":{"d":24,"e":41,"g":1,"l":{"i":[{"n":{"g":223}},4]},"n":{"d":73},"r":29,"s":[{"t":{".":23}},0],"t":{"y":1}},"f":23,"h":1,"i":[{".":32,"c":122,"l":{"l":21,"o":6},"m":21,"n":{".":21,"d":{"e":0},"e":{"s":{"s":19},"t":{"i":{"c":224}}},"g":0},"p":1,"s":[{"h":19},0]},29],"k":1,"l":[{"e":{"y":18},"y":18},29],"m":29,"n":{"e":{"s":19},"o":69},"o":{"r":4,"s":{"h":17},"u":23,"v":{"i":{"a":{"n":41}}}},"r":{"o":{"n":5}},"s":[{"c":21,"l":1,"y":21,"h":{"a":23}},101],"t":19,"w":29},"l":{"a":{"b":{"i":{"c":11},"o":21},"c":{"i":[{"e":225},17]},"d":{"e":21,"y":3},"g":{"n":0},"m":{"o":11},"n":{"d":[{"l":0},27],"e":{"t":5},"t":{"e":0}},"r":{"g":0,"i":11,"c":{"e":{"n":176}}},"s":{"e":0},"t":{"a":{"n":4},"e":{"l":{"i":18}},"i":{"v":18}},"v":[{"a":95},18],"i":{"n":{"e":{"s":{"s":226}}}}},"b":[{"i":{"n":17}},42],"c":[{"e":0,"i":23,"h":{"a":{"i":23},"i":{"l":{"d":227}}}},101],"d":[{"e":[{"r":{"e":1,"i":1}},24],"i":[{"s":4},0],"r":[{"i":21},23]},25],"e":{"a":[{"d":{"e":{"r":{".":183}}},"s":{"a":228}},9],"b":{"i":1},"f":{"t":6},"g":{".":32,"g":32,"e":{"n":{"d":{"r":{"e":230}}}}},"m":{"a":{"t":[{"i":{"c":5}},1]}},"n":{".":18,"c":27,"e":{".":32},"t":41,"o":{"i":{"d":78}}},"p":{"h":3,"r":1},"r":{"a":{"b":6},"e":0,"g":27,"i":68,"o":21},"s":[{"c":{"o":4},"q":32,"s":[{".":32},27]},8],"v":{"a":23,"e":{"r":{".":0,"a":0,"s":0}}},"y":[{"e":18},27],"c":{"t":{"a":{"b":229}}}},"f":[{"r":19},25],"g":[{"a":[{"r":12},19],"e":{"s":21},"o":11},80],"h":48,"i":{"a":{"g":1,"m":9,"r":{"i":{"z":6}},"s":1,"t":{"o":1}},"b":{"i":4},"c":{"i":{"o":32},"o":{"r":1},"s":18,"t":{".":18},"u":21,"y":23},"d":{"a":23,"e":{"r":5},"i":27},"f":{"e":{"r":11},"f":21,"l":1},"g":{"a":{"t":{"e":32}},"h":27,"r":{"a":1}},"k":27,"l":123,"m":{"b":{"l":0},"i":11,"o":1,"p":90},"n":{"a":21,"e":[{"a":11},124],"i":11,"k":{"e":{"r":6}}},"o":{"g":4},"q":125,"s":{"p":0},"t":[{".":24,"i":{"c":{"a":32,"s":108}},"h":{"o":{"g":204}}},29],"v":{"e":{"r":11}},"z":29},"j":18,"k":{"a":[{"l":23,"t":0},11]},"l":[{"a":{"w":21},"e":[{"a":19,"c":23,"g":23,"l":23,"n":73,"t":73},24],"i":[{"n":[{"a":19},126],"s":{"h":231}},9],"o":[{"q":{"u":{"i":10}},"u":{"t":4},"w":19},1],"f":{"l":2}},29],"m":[{"e":{"t":19},"i":{"n":{"g":3}},"o":{"d":21,"n":[{"e":{"l":{"l":232}}},17]}},25],"n":81,"o":{".":27,"b":{"a":{"l":5},"o":{"t":{"o":233}}},"c":{"i":1},"f":18,"g":{"i":{"c":27},"o":19,"u":27,"e":{"s":{".":9}}},"m":{"e":{"r":11}},"n":{"g":32,"i":[{"z":127},0]},"o":{"d":6},"p":{"e":{".":32},"i":11,"m":23},"r":{"a":[{"t":{"o":1}},17],"i":{"e":4},"o":{"u":5}},"s":{".":32,"e":{"t":5},"o":{"p":{"h":{"i":{"z":32},"y":32}}},"t":0},"t":{"a":1},"u":{"n":{"d":6},"t":25},"v":18,"a":{"d":{"e":{"d":{".":17},"r":{".":183}}}}},"p":[{"a":{"b":5},"h":{"a":23,"i":19},"i":{"n":{"g":4},"t":23},"l":21,"r":19},25],"r":43,"s":[{"c":21,"e":24,"i":{"e":21}},81],"t":[{"a":{"g":4,"n":{"e":7}},"e":[{"n":17,"r":{"a":36},"a":23},29],"h":{"i":[{"l":{"y":148}},11]},"i":{"e":{"s":{".":19}},"s":17},"r":29,"u":[{"r":{"a":12}},8]},18],"u":{"a":4,"b":{"r":3},"c":{"h":17,"i":3},"e":{"n":3,"p":15},"f":0,"i":{"d":4},"m":{"a":1,"i":32,"n":{".":19,"i":{"a":32}},"b":{"i":{"a":{".":235}}}},"o":[{"r":11},3],"p":18,"s":{"s":17,"t":{"e":11}},"t":41,"n":{"k":{"e":{"r":234}}}},"v":{"e":{"n":19,"t":128}},"w":42,"y":[{"a":18,"b":18,"m":{"e":4},"n":{"o":3},"s":[{"e":19,"t":{"y":{"r":4}}},58],"g":{"a":{"m":{"i":236}}}},41]},"m":{"a":[{"b":25,"c":{"a":9,"h":{"i":{"n":{"e":4}}},"l":1},"g":{"i":{"n":5},"n":32},"h":25,"i":{"d":6},"l":{"d":18,"i":{"g":3,"n":4},"l":{"i":0},"t":{"y":0},"a":{"p":222}},"n":{"i":{"a":32,"s":5,"z":11},".":24,"u":{"s":{"c":237}}},"p":[{"h":{"r":{"o":244}}},18],"r":{"i":{"n":{"e":{".":4}},"z":4},"l":{"y":0},"v":11,"g":{"i":{"n":238}}},"s":{"c":{"e":4},"e":0,"t":15},"t":{"e":32,"h":12,"i":{"s":3,"z":{"a":18}}}},41],"b":[{"a":{"t":129},"i":{"l":19,"n":{"g":83},"v":0}},43],"c":56,"e":{".":18,"d":[{".":18,"i":{"a":32,"e":3,"c":[{"i":{"n":152}},84],"o":{"c":239}},"y":108},25],"g":[{"r":{"a":{"n":240}}},9],"l":{"o":{"n":5},"t":0},"m":[{"o":130},9],"n":[{"a":[{"c":5},0],"d":{"e":0},"e":18,"i":0,"s":[{"u":7},17],"t":[{"e":0},27],".":24},41],"o":{"n":4},"r":{"s":{"a":19}},"s":[{"t":{"i":27}},25],"t":{"a":[{"l":11},1],"e":2,"h":{"i":4},"r":[{"i":{"c":32,"e":4},"y":3},21]},"v":1},"f":43,"h":25,"i":{".":32,"a":3,"d":{"a":[{"b":241},0],"g":0},"g":0,"l":{"i":{"a":27,"e":108,"t":{"a":27}},"l":[{"a":{"g":208},"i":{"l":{"i":59}}},21]},"n":{"a":0,"d":27,"e":{"e":19},"g":{"l":[{"i":5,"y":19},21]},"t":0,"u":[{"t":{"e":{"r":242,"s":{"t":242}}}},21],"i":{"s":{".":174}}},"o":{"t":17},"s":[{"e":{"r":{".":0}},"l":5,"t":{"i":0,"r":{"y":19}}},24],"t":{"h":18},"z":24},"k":18,"l":43,"m":[{"a":{"r":{"y":5},"b":243}},29],"n":[{"a":1,"i":{"n":21},"o":1},43],"o":[{"c":{"r":[{"a":{"t":[{"i":{"z":32}},245]}},18]},"d":131,"g":{"o":1},"i":{"s":[{"e":5},84]},"k":18,"l":{"e":{"s":{"t":4},"c":246}},"m":{"e":3},"n":{"e":{"t":5,"y":{"l":247}},"g":{"e":5},"i":{"a":12,"s":{"m":0,"t":0},"z":3},"o":{"l":36,"c":{"h":12},"e":{"n":171},"s":249},"y":{".":3}},"r":[{"a":{".":18},"o":{"n":{"i":{"s":248}}}},9],"s":[{"e":{"y":4},"p":3},8],"t":{"h":[{"e":{"t":250}},12]},"u":{"f":19,"s":[{"i":{"n":98}},27]},"v":9,"e":{"l":{"a":{"s":167}}}},41],"p":[{"a":{"r":{"a":[{"b":5},7],"i":6}},"e":{"t":23},"h":{"a":{"s":36}},"i":[{"a":0,"e":{"s":4},"n":34,"r":19,"s":4},24],"o":{"r":{"i":11},"s":{"i":{"t":{"e":6}}},"u":{"s":21},"v":6},"t":{"r":1},"y":24},43],"r":47,"s":[{"h":[{"a":{"c":{"k":251}}},21],"i":19},101],"t":18,"u":[{"l":{"a":{"r":49},"t":[{"i":[{"u":252},54]},32]},"m":27,"n":8,"p":18,"u":1,"d":{"r":{"o":9}}},41],"w":18},"n":{"a":[{"b":[{"u":21},81],"c":{".":18,"a":1,"t":19},"g":{"e":{"r":{".":5}}},"k":0,"l":{"i":[{"a":4},1],"t":18},"m":{"i":{"t":4}},"n":[{"c":{"i":36},"i":{"t":0},"k":17},24],"r":{"c":[{"h":{"s":{".":73}}},11],"e":18,"i":11,"l":0,"m":19},"s":[{"c":0,"t":{"i":5}},21],"t":[{"a":{"l":3},"o":{"m":{"i":{"z":6}}}},24],"u":[{"s":{"e":11},"t":27},24],"v":{"e":0}},41],"b":80,"c":{"a":{"r":6},"e":{"s":{".":21}},"h":{"a":23,"e":{"o":19,"s":{"t":253}},"i":{"l":19,"s":23}},"i":{"n":2,"t":1},"o":{"u":{"r":{"a":7}}},"r":29,"u":29},"d":{"a":{"i":21,"n":19},"e":[{"s":{"t":{".":4}}},29],"i":{"b":0,"f":79,"t":29,"z":23,"e":{"c":{"k":29}}},"u":{"c":19,"r":0},"w":{"e":9},"t":{"h":{"r":3}}},"e":{".":25,"a":{"r":23},"b":[{"u":11,"a":{"c":{"k":3}}},9],"c":[{"k":32},9],"d":25,"g":{"a":{"t":[{"i":{"v":5}},1]},"e":32},"l":{"a":1,"i":{"z":5}},"m":{"i":4,"o":1},"n":[{"e":18},41],"o":27,"p":{"o":1},"q":9,"r":[{"a":{"b":6,"r":21},"e":24,"i":132,"r":0},29],"s":[{".":25,"p":18,"t":25,"w":18,"k":{"i":119}},41],"t":{"i":{"c":27}},"v":[{"e":19},1],"w":1},"f":[{"i":{"n":{"i":{"t":{"e":{"s":226}}}}}},23],"g":{"a":{"b":21},"e":{"l":23,"n":{"e":[{"s":5},133]},"r":{"e":19,"i":23}},"h":{"a":4,"o":2},"i":{"b":23,"n":2,"t":19},"l":{"a":21},"o":{"v":17},"s":{"h":4,"p":{"r":2}},"u":[{"m":21},29],"y":24},"h":[{"a":[{"b":12},0],"e":0},80],"i":{"a":[{"n":[{".":114},3],"p":1},68],"b":{"a":3,"l":1},"d":[{"i":4},1],"e":{"r":1},"f":{"i":[{"c":{"a":{"t":4}}},9]},"g":{"r":19},"k":0,"m":[{"i":{"z":3}},29],"n":[{"e":{".":32},"g":0},29],"o":1,"s":{".":32,"t":{"a":0}},"t":[{"h":21,"i":{"o":27},"o":{"r":23},"r":3},24]},"j":29,"k":[{"e":{"r":{"o":19},"t":23},"i":{"n":3},"l":29,"r":{"u":{"p":3}}},44],"l":[{"e":{"s":{"s":19}}},43],"m":[{"e":[{"t":17},0]},19],"n":[{"e":0,"i":{"a":{"l":11},"v":0}},101],"o":{"b":{"l":[{"e":3},0]},"c":{"l":19,"e":{"r":{"o":{"s":254}}}},"d":66,"e":27,"g":[{"e":17},18],"i":{"s":{"i":6}},"l":{"i":134,"o":{"g":{"i":{"s":32}}}},"m":{"i":{"c":27,"z":108,"s":{"t":82}},"o":1,"y":3,"a":{"l":214},"e":{"n":{"o":194}}},"n":[{"a":{"g":0},"i":[{"z":19,"s":{"o":255}},5],"e":{"q":15}},1],"p":[{"o":{"l":{"i":135,"y":{".":256}}}},18],"r":{"a":{"b":5,"r":{"y":1}}},"s":{"c":18,"e":0,"t":5},"t":{"a":4},"u":[{"n":27},41],"v":{"e":{"l":136,"m":{"b":2}}},"w":{"l":12}},"p":[{"i":0,"r":{"e":{"c":17}}},72],"q":29,"r":[{"u":0},29],"s":[{"a":{"b":4,"t":{"i":36}},"c":[{"e":{"i":{"v":4}}},1],"e":[{"s":83},24],"i":{"d":137,"g":17},"l":24,"m":[{"o":{"o":1}},3],"o":{"c":21},"p":{"e":1,"i":19},"t":{"a":{"b":{"l":6}}}},81],"t":[{"a":{"b":0},"e":{"r":{"s":12}},"i":[{"b":19,"e":{"r":0},"f":8,"n":{"e":23,"g":83},"p":0},9],"r":{"o":{"l":{"l":{"i":7}}},"e":{"p":137}},"s":1,"u":{"m":{"e":11}}},29],"u":{"a":2,"d":1,"e":{"n":4},"f":{"f":{"e":0}},"i":{"n":23,"t":50},"m":[{"e":2,"i":19},21],"n":138,"o":23,"t":{"r":3}},"v":74,"w":72,"y":{"m":0,"p":0},"z":[{"a":23},18]},"o":{"a":[{"d":11,"l":{"e":{"s":108}},"r":{"d":12},"s":{"e":0,"t":{"e":6}},"t":{"i":5}},18],"b":{"a":{"b":35,"r":19},"e":{"l":0},"i":[{"n":[{"g":4},24]},29],"r":23,"u":{"l":3},"l":{"i":{"g":189}}},"c":{"e":29,"h":[{"e":{"t":23},"a":{"s":23}},0],"i":{"f":12,"l":21},"l":{"a":{"m":21}},"o":{"d":21},"r":{"a":{"c":3,"t":{"i":{"z":4}}},"e":12,"i":{"t":32}},"t":{"o":{"r":{"a":7}}},"u":{"l":{"a":3},"r":{"e":19}}},"d":{"d":{"e":{"d":4}},"i":{"c":3,"o":11,"t":{"i":{"c":137}}},"o":[{"r":12},139],"u":{"c":{"t":{".":4,"s":4}}},"e":{"l":{"l":{"i":12}}}},"e":{"l":21,"n":{"g":19},"r":[{"s":{"t":257}},23],"t":{"a":1},"v":23},"f":{"i":[{"t":{"e":4,"t":17}},24]},"g":{"a":{"r":121,"t":{"i":{"v":4},"o":21}},"e":[{"n":{"e":19},"o":19,"r":21},29],"i":{"e":23,"s":140,"t":3},"l":[{"y":79},21],"n":{"i":{"z":27}},"r":{"o":21},"u":{"i":5},"y":[{"n":25},41]},"h":[{"a":{"b":6}},74],"i":[{"c":{"e":{"s":11}},"d":{"e":{"r":3}},"f":{"f":17},"g":0,"l":{"e":{"t":4}},"n":{"g":23,"t":{"e":{"r":6}}},"s":{"m":19,"o":{"n":4},"t":{"e":{"n":6}}},"t":{"e":{"r":3}}},9],"j":19,"k":[{"e":{"n":23,"s":{"t":15}},"i":{"e":4}},25],"l":{"a":[{"n":21,"s":{"s":36}},29],"d":[{"e":15},9],"e":{"r":3,"s":{"c":23,"t":{"e":{"r":88}}},"t":23},"f":{"i":1},"i":[{"a":23,"c":{"e":23},"d":{".":4},"f":73,"l":19,"n":{"g":3},"o":19,"s":{".":19,"h":3},"t":{"e":19,"i":{"o":19}},"v":19,"g":{"o":{"p":{"o":258}}}},9],"l":{"i":{"e":17}},"o":{"g":{"i":{"z":4}},"r":0,"n":{"o":{"m":259}}},"p":{"l":4},"t":9,"u":{"b":3,"m":{"e":3},"n":3,"s":19},"v":9,"y":24},"m":{"a":{"h":4,"l":5,"t":{"i":{"z":4}}},"b":{"e":9,"l":1},"e":[{"n":{"a":3},"r":{"s":{"e":4}},"t":[{"r":{"y":4}},21],"c":{"h":{"a":260}}},24],"i":{"a":23,"c":{".":3,"a":3},"d":19,"n":[{"i":19},2]},"m":{"e":{"n":{"d":32}}},"o":{"g":{"e":0},"n":21},"p":{"i":3,"r":{"o":7}}},"n":[{"a":[{"c":1,"n":23},2],"c":[{"i":{"l":27}},2],"d":[{"o":4},25],"e":{"n":23,"s":{"t":4}},"g":{"u":1},"i":{"c":2,"o":23,"s":2,"u":19},"k":{"e":{"y":3}},"o":{"d":{"i":1},"m":{"y":3,"i":{"c":137}},"r":{"m":{"a":23}},"t":{"o":{"n":261}},"u":23},"s":[{"p":{"i":[{"r":{"a":10}},36]},"u":17},3],"t":{"e":{"n":36},"i":[{"f":7},93]},"u":{"m":4},"v":{"a":6}},24],"o":[{"d":{"e":5,"i":5},"k":1,"p":{"i":11},"r":{"d":23},"s":{"t":6}},9],"p":{"a":24,"e":{"d":5,"r":[{"a":[{"g":18},27]},2]},"h":[{"a":{"n":19},"e":{"r":19}},25],"i":{"n":{"g":3},"t":23,"s":{"m":{".":2}}},"o":{"n":19,"s":{"i":21}},"r":29,"u":2,"y":5},"q":29,"r":{"a":[{".":19,"g":83,"l":{"i":{"z":4}},"n":{"g":{"e":4}}},29],"e":{"a":[{"l":19},5],"i":3,"s":{"h":5,"t":{".":4}},"w":17},"g":{"u":1},"i":{"a":56,"c":{"a":3},"l":19,"n":2,"o":29,"t":{"y":3},"u":23},"m":{"i":9},"n":{"e":8},"o":{"f":19,"u":{"g":3}},"p":{"e":4},"r":{"h":27},"s":{"e":[{"n":5},1],"t":17},"t":{"h":{"i":3,"y":3,"o":{"n":{"i":{"t":262}}},"r":{"i":137}},"y":1,"i":{"v":{"e":{"l":{"y":4}}}}},"u":{"m":19},"y":29},"s":{"a":{"l":3},"c":[{"e":1,"o":{"p":[{"i":18},23]},"r":19},9],"i":{"e":95,"t":{"i":{"v":4},"o":3,"y":3},"u":0},"l":1,"o":24,"p":{"a":1,"o":1,"h":{"e":{"r":83}}},"t":{"a":[{"t":{"i":19}},9],"i":{"l":4,"t":4}}},"t":{"a":{"n":21},"e":{"l":{"e":{"g":36}},"r":{".":3,"s":4},"s":[{"t":{"e":{"r":263},"o":{"r":264}}},21]},"h":[{"e":{"s":{"i":5},"o":{"s":265}},"i":14},18],"i":{"c":{".":3,"a":4,"e":23},"f":23,"s":23},"o":{"s":5}},"u":[{"b":{"l":3,"a":{"d":{"o":116}}},"c":{"h":{"i":6}},"e":{"t":4},"l":1,"n":{"c":{"e":{"r":6}},"d":8},"v":4},9],"v":{"e":{"n":1,"r":{"n":{"e":17},"s":12,"t":1}},"i":{"s":23,"t":{"i":36},"a":{"n":{".":266}}},"o":{"l":60}},"w":{"d":{"e":{"r":3}},"e":{"l":3,"s":{"t":4}},"i":2,"n":{"i":5},"o":21},"y":{"a":2},"x":{"i":{"d":{"i":{"c":267}}}}},"p":{"a":[{"c":{"a":1,"e":1,"t":0},"d":21,"g":{"a":{"n":32,"t":23}},"i":[{"n":17},21],"l":[{"m":{"a":{"t":268}}},21],"n":{"a":0,"e":{"l":11},"t":{"y":0},"y":3},"p":[{"u":1},2],"r":{"a":{"b":{"l":6},"g":{"e":5,"r":{"a":269}},"l":{"e":228},"m":[{"e":12},36]},"d":{"i":5},"e":[{"l":5},27],"i":[{"s":0},28]},"t":{"e":[{"r":4},9],"h":{"i":{"c":32},"y":4},"r":{"i":{"c":1}}},"v":0,"y":27},41],"b":43,"d":1,"e":{".":18,"a":[{"r":{"l":17}},138],"c":9,"d":[{"e":27,"i":[{"a":36,"c":0},27]},37],"e":[{"d":0,"v":208},21],"k":0,"l":{"a":1,"i":{"e":17}},"n":{"a":{"n":1},"c":21,"t":{"h":0}},"o":{"n":4},"r":{"a":{".":21,"b":{"l":6},"g":21},"i":[{"s":{"t":6}},21],"m":{"a":{"l":0},"e":7},"n":21,"o":11,"t":{"i":11},"u":4,"v":15},"t":[{"e":{"n":4},"i":{"z":4}},9]},"f":18,"g":18,"h":{".":18,"a":{"r":{"i":6}},"e":{"n":{"o":11},"r":1,"s":{".":1}},"i":{"c":2,"e":32,"n":{"g":4},"s":{"t":{"i":32}},"z":27,"l":{"a":{"n":{"t":168},"t":{"e":{"l":270}}}}},"l":9,"o":{"b":27,"n":{"e":27,"i":32},"r":0},"s":18,"t":3,"u":32,"y":41},"i":{"a":[{"n":17},3],"c":{"i":{"e":1},"y":1,"a":{"d":271}},"d":[{"a":19,"e":3,"i":32},21],"e":{"c":27,"n":3},"g":{"r":{"a":{"p":1}}},"l":{"o":3},"n":[{".":21,"d":17,"o":21},9],"o":[{"n":17},141],"t":{"h":[{"a":4},23],"u":9}},"k":142,"l":[{"a":{"n":27,"s":{"t":6}},"i":{"a":11,"e":{"r":5},"g":18,"n":[{"a":{"r":5}},0],"c":{"a":{"b":208}}},"o":{"i":17},"u":{"m":[{"b":17},0]}},143],"m":43,"n":48,"o":{"c":1,"d":{".":32},"e":{"m":4,"t":144},"g":145,"i":{"n":[{"t":32,"c":{"a":12}},84]},"l":{"y":{"t":6,"e":137,"p":{"h":{"o":{"n":{"o":272}}}}},"e":{".":41}},"n":{"i":1},"p":1,"r":[{"y":1},124],"s":[{"s":15},41],"t":[{"a":1},21],"u":{"n":32}},"p":[{"a":{"r":{"a":5}},"e":[{"d":21,"l":19,"n":23,"r":23,"t":23},24],"o":{"s":{"i":{"t":{"e":5}}}}},43],"r":[{"a":{"y":{"e":17}},"e":{"c":{"i":32,"o":5},"e":{"m":11},"f":{"a":{"c":6}},"l":{"a":0},"r":11,"s":{"e":23,"s":27,"p":{"l":{"i":84}}},"t":{"e":{"n":5}},"v":11,"m":{"a":{"c":273}},"n":{"e":{"u":15}}},"i":{"e":53,"n":{"t":146},"s":[{"o":12},0]},"o":{"c":{"a":23,"e":{"s":{"s":8}},"i":{"t":{"y":{".":274}}}},"f":{"i":{"t":6}},"l":11,"s":{"e":12},"t":15,"g":{"e":208}}},9],"s":[{"e":[{"u":{"d":[{"o":{"d":276,"f":276}},275]}},24],"h":1,"i":{"b":21}},81],"t":[{"a":{"b":134},"e":24,"h":24,"i":{"m":11},"u":{"r":0},"w":21,"o":{"m":{"a":{"t":277}}},"r":{"o":{"l":278}}},42],"u":{"b":[{"e":{"s":{"c":181}}},11],"e":0,"f":0,"l":{"c":11},"m":1,"n":9,"r":{"r":0},"s":32,"t":[{"e":[{"r":11},32],"r":3,"t":{"e":{"d":0},"i":{"n":0}}},9]},"w":23},"q":{"u":[{"a":{"v":5,"i":{"n":{"t":{"e":279}}},"s":{"i":[{"r":281,"s":281},280]}},"e":{".":25,"r":27,"t":27},"i":{"n":{"t":{"e":{"s":{"s":282}}}},"v":{"a":{"r":14}}}},9]},"r":{"a":{"b":[{"i":3,"o":{"l":{"i":{"c":29},"o":{"i":236}}}},25],"c":{"h":{"e":17,"u":3},"l":19},"f":{"f":{"i":5},"t":0},"i":24,"l":{"o":1},"m":{"e":{"t":[{"r":{"i":{"z":283}}},11],"n":24},"i":24,"o":{"u":3}},"n":{"e":{"o":6},"g":{"e":0},"i":21,"o":4,"h":{"a":{"s":167}}},"p":{"e":{"r":11},"h":{"y":27}},"r":{"c":5,"e":[{"f":5},17],"i":{"l":18}},"s":24,"t":{"i":{"o":{"n":115}}},"u":{"t":0},"v":{"a":{"i":4},"e":{"l":11}},"z":{"i":{"e":4}},"d":{"i":{"g":127,"o":{"g":249}}},"o":{"r":2}},"b":[{"a":{"b":21,"g":21},"i":[{"f":0,"n":[{"e":19,"g":{".":4,"e":284}},24]},8],"o":1},29],"c":[{"e":[{"n":17},24],"h":{"a":23,"e":{"r":0}},"i":{"b":90,"t":1},"u":{"m":12}},29],"d":{"a":{"l":21},"i":[{"a":0,"e":{"r":0},"n":[{"g":3},17]},9]},"e":{".":25,"a":{"l":2,"n":3,"r":{"r":4},"v":32,"w":1},"b":{"r":{"a":{"t":19}}},"c":{"o":{"l":{"l":5},"m":{"p":{"e":5}}},"r":{"e":1},"i":{"p":{"r":285}},"t":{"a":{"n":{"g":286}}}},"d":[{"e":2,"i":{"s":3,"t":5}},37],"f":{"a":{"c":1},"e":[{"r":{".":4}},9],"i":3,"y":1},"g":{"i":{"s":11}},"i":{"t":4},"l":{"i":2,"u":4},"n":{"t":{"a":90,"e":0}},"o":2,"p":{"i":{"n":4},"o":{"s":{"i":1}},"u":2},"r":[{"i":21,"o":17,"u":4},147],"s":{".":21,"p":{"i":1},"s":{"i":{"b":6}},"t":[{"a":{"l":4},"r":3},8]},"t":{"e":{"r":1},"i":{"z":96},"r":{"i":[{"b":{"u":85}},3]}},"u":[{"t":{"i":4}},8],"v":[{"a":{"l":1},"e":{"l":11,"r":{".":30,"s":4,"t":4}},"i":{"l":4},"o":{"l":{"u":5}}},8],"w":{"h":1}},"f":[{"u":0,"y":21},29],"g":[{"e":{"r":3,"t":23},"i":{"c":23,"n":[{"g":3},0],"s":19,"t":19},"l":29,"o":{"n":0},"u":23},9],"h":[{".":18,"a":{"l":18}},1],"i":{"a":[{"b":0,"g":1,"l":{".":23}},3],"b":[{"a":11},21],"c":{"a":{"s":5},"e":21,"i":[{"d":32,"e":1},18],"o":21},"d":{"e":{"r":5}},"e":{"n":{"c":3,"t":3},"r":2,"t":4},"g":{"a":{"n":5},"i":32},"l":{"i":{"z":11}},"m":{"a":{"n":32},"i":5,"o":27,"p":{"e":0}},"n":{"a":[{".":32},24],"d":0,"e":0,"g":0},"o":2,"p":{"h":[{"e":6},32],"l":[{"i":{"c":5}},9]},"q":21,"s":[{".":21,"c":0,"h":23,"p":0},24],"t":{"a":{"b":116},"e":{"d":{".":19},"r":{".":5,"s":5}},"i":{"c":11},"u":[{"r":5},9]},"v":{"e":{"l":5,"t":11},"i":11,"o":{"l":287}}},"j":23,"k":{"e":{"t":23},"l":{"e":1,"i":{"n":1}},".":288,"h":{"o":2},"r":{"a":{"u":29}},"s":{".":288}},"l":[{"e":[{"d":24,"q":{"u":30}},0],"i":{"g":21,"s":[{"h":4},21]},"o":73},29],"m":[{"a":{"c":5},"e":[{"n":23,"r":{"s":4}},24],"i":{"n":{"g":[{".":21},3]},"o":21,"t":23},"y":21},29],"n":{"a":{"r":21},"e":{"l":23,"r":21,"t":19,"y":23},"i":{"c":19,"s":92,"t":23,"v":23},"o":[{"u":21},0],"u":23},"o":{"b":{"l":11,"o":{"t":289}},"c":[{"r":3},24],"e":[{"l":{"a":{"s":167}},"p":{"i":{"d":{"e":290}}}},1],"f":{"e":2,"i":{"l":4}},"k":[{"e":{"r":4}},8],"l":{"e":{".":32}},"m":{"e":{"t":{"e":5},"s":{"h":3}},"i":0,"p":0},"n":{"a":{"l":0},"e":0,"i":{"s":134},"t":{"a":0}},"o":{"m":41,"t":32},"p":{"e":{"l":3},"i":{"c":11}},"r":{"i":11,"o":4},"s":{"p":{"e":{"r":5}},"s":0},"t":{"h":{"e":1},"y":1,"r":{"o":{"n":2}}},"v":{"a":1,"e":{"l":5}},"x":5},"p":[{"e":{"a":21,"n":{"t":19},"r":{".":4},"t":23},"h":95,"i":{"n":{"g":3}},"o":23,"a":{"u":{"l":{"i":291}}}},29],"r":[{"e":{"c":0,"f":0,"o":21,"s":{"t":0}},"i":{"o":0,"v":0},"o":{"n":17,"s":17},"y":{"s":17}},72],"s":[{"a":[{"t":{"i":5}},29],"c":1,"e":[{"c":[{"r":0},23],"r":{".":4,"a":{"d":{"i":238}}},"s":3,"v":148},24],"h":[{"a":19},29],"i":[{"b":90},29],"o":{"n":12},"p":29,"w":19},44],"t":{"a":{"c":{"h":36},"g":21},"e":{"b":23,"n":{"d":17},"o":5},"i":[{"b":4,"d":0,"e":{"r":21},"g":23,"l":{"i":12,"l":17,"y":21},"s":{"t":21},"v":21},29],"r":{"i":23,"o":{"p":{"h":115}},"e":{"u":29}},"s":{"h":1},"h":{"o":{"u":29}}},"u":{"a":3,"e":{"l":93,"n":3},"g":{"l":1},"i":{"n":3},"m":{"p":{"l":11}},"n":[{"k":6,"t":{"y":0}},9],"s":{"c":19},"t":{"i":{"n":6}}},"v":{"e":[{"l":{"i":17},"n":23,"r":{".":4},"s":{"t":19},"y":23,"i":{"l":29}},1],"i":{"c":23,"v":0},"o":23},"w":29,"y":{"c":1,"n":{"g":{"e":32}},"t":3},"z":{"s":{"c":2}}},"s":{"a":[{"b":42,"c":{"k":32,"r":{"i":11},"t":23},"i":32,"l":{"a":{"r":36},"m":0,"o":4,"t":0,"e":{"s":{"c":54,"w":7}}},"n":{"c":27,"d":{"e":0}},"p":[{"a":{"r":{"i":{"l":292}}}},29],"t":{"a":4,"i":{"o":76},"u":11},"u":0,"v":{"o":{"r":4}},"w":32},9],"b":56,"c":{"a":{"n":{"t":149},"p":[{"e":{"r":267}},0],"v":6,"t":{"o":{"l":208}}},"e":{"d":21,"i":18,"s":21},"h":[{"o":21,"i":{"t":{"z":21}},"r":{"o":{"d":{"i":{"n":{"g":293}}}}}},8],"i":{"e":68,"n":{"d":150},"u":{"t":{"t":294}}},"l":{"e":6,"i":21},"o":{"f":17,"p":{"y":18},"u":{"r":{"a":7}}},"u":29,"r":{"a":{"p":{"e":{"r":{".":36}}}}},"y":{"t":{"h":247}}},"d":56,"e":{".":18,"a":[{"s":17,"w":5},1],"c":{"o":151,"t":27},"d":[{"e":95,"l":19},125],"g":[{"r":11},9],"i":32,"l":{"e":2,"f":32,"v":32},"m":{"e":[{"s":{"t":295}},18],"o":{"l":1},"a":{"p":{"h":287}},"i":{"t":{"i":{"c":296}}}},"n":{"a":{"t":5},"c":18,"d":0,"e":{"d":19},"g":5,"i":{"n":19},"t":{"d":18,"l":18}},"p":{"a":152,"t":{"e":{"m":{"b":11}}}},"r":{".":43,"l":21,"o":0,"v":{"o":18}},"s":[{"h":4,"t":5},72],"u":{"m":113},"v":[{"e":{"n":11}},32],"w":{"i":0},"x":32},"f":47,"g":48,"h":[{".":25,"e":{"r":2,"v":32},"i":{"n":2,"o":3,"p":27,"v":6},"o":[{"l":{"d":4},"n":12,"r":[{"t":7},17],"e":{"s":{"t":137}}},0],"w":18},24],"i":{"b":2,"c":{"c":19},"d":{"e":{".":27,"s":[{"t":6,"w":6},32],"d":{".":8}},"i":[{"z":4},32]},"g":{"n":{"a":18}},"l":{"e":0,"y":18},"n":[{"a":24,"e":{".":32},"g":23},42],"o":[{"n":[{"a":6},32]},41],"r":[{"a":5,"e":{"s":{"i":{"d":4}}}},9],"s":41,"t":{"i":{"o":27}},"u":32,"v":41,"z":32},"k":[{"e":[{"t":23},18],"i":{"n":{"e":4,"g":4}},"y":{"s":{"c":15}}},9],"l":[{"a":{"t":23},"e":24,"i":{"t":{"h":7}},"o":{"v":{"a":{"k":{"i":{"a":297}}}}}},74],"m":[{"a":[{"l":{"l":54},"n":12},23],"e":{"l":17,"n":19},"i":{"t":{"h":32}},"o":{"l":{"d":49}}},42],"n":72,"o":[{"c":{"e":1},"f":{"t":12},"l":{"a":{"b":1},"d":153,"i":{"c":3},"v":32,"u":{"t":{"e":9}}},"m":27,"n":{".":68,"a":17,"g":0},"p":[{"h":{"i":{"c":32,"z":19},"y":19}},21],"r":{"c":5,"d":5},"v":[{"i":4},18],"g":{"a":{"m":{"y":298}}}},41],"p":{"a":[{"i":32,"n":0,"c":{"e":299,"i":{"n":69}}},25],"e":{"n":{"d":17},"o":57,"r":25,"c":{"i":{"o":11}}},"h":{"e":[{"r":[{"o":213},27]},24],"o":6},"i":{"l":17,"n":{"g":4},"o":18,"c":{"i":{"l":208}}},"l":{"y":21},"o":{"n":21,"r":[{"t":{"s":{"c":300,"w":300}}},17],"t":18,"k":{"e":{"s":{"w":10}}}}},"q":{"u":{"a":{"l":{"l":36}},"i":{"t":{"o":88}}}},"r":29,"s":[{"a":[{"s":12,"c":{"h":{"u":301}}},29],"c":94,"e":{"l":23,"n":{"g":19},"s":{".":21},"t":19},"i":[{"e":[{"r":0},21],"l":{"y":4},"a":{"n":{".":210}},"g":{"n":{"a":{"b":302}}}},29],"l":[{"i":1},21],"n":21,"p":{"e":{"n":{"d":115}}},"t":9,"u":{"r":{"a":6}},"w":4,"h":{"a":{"t":3}}},25],"t":{".":25,"a":{"g":24,"l":24,"m":{"i":17,"p":69},"n":{"d":32,"t":{"s":{"h":{"i":303}}}},"p":90,"t":{".":32,"i":15},"r":{"t":{"l":{"i":12}}}},"e":{"d":21,"r":{"n":{"i":7},"o":19},"w":[{"a":6},8]},"h":{"e":23},"i":[{".":21,"a":19,"c":[{"k":32},29],"e":21,"f":23,"n":{"g":3},"r":32},9],"l":{"e":29},"o":{"c":{"k":32},"m":{"a":12},"n":{"e":32},"p":21,"r":{"e":27,"a":{"b":304}}},"r":[{"a":{"d":21,"t":{"u":32,"a":{"g":305}},"y":21},"i":{"d":21,"b":{"u":{"t":7}}},"y":18},1],"w":61,"y":[{"l":{"i":{"s":137}}},24],"b":4,"s":{"c":{"r":4}},"u":{"p":{"i":{"d":306}}}},"u":[{"a":{"l":2},"b":111,"g":151,"i":{"s":4,"t":12},"l":21,"m":[{"i":11},9],"n":9,"r":9,"p":{"e":{"r":{"e":307}}}},41],"v":18,"w":[{"o":18,"i":{"m":{"m":177}}},9],"y":[{"c":18,"l":27,"n":{"o":5,"c":41},"r":{"i":{"n":4}},"t":{"h":{"i":308}}},21]},"t":{"a":[{".":27,"b":[{"l":{"e":{"s":4}},"o":{"l":{"i":{"z":32,"s":{"m":309}}}}},25],"c":{"i":18},"d":{"o":4},"f":46,"i":{"l":{"o":5}},"l":[{"a":4,"e":{"n":5},"i":11,"k":[{"a":204},18],"l":{"i":{"s":0}},"o":{"g":4}},9],"m":{"o":4,"i":{"n":82}},"n":{"d":{"e":0},"t":{"a":54}},"p":{"e":{"r":4},"l":4,"a":{"t":{"h":310}}},"r":{"a":0,"c":18,"e":18,"i":{"z":3},"r":{"h":311}},"s":{"e":0,"y":4},"t":{"i":{"c":18},"u":{"r":1}},"u":{"n":17},"v":0,"w":25,"x":{"i":{"s":0}},"g":{"o":{"n":{".":3}}}},41],"b":42,"c":[{"h":[{"e":{"t":5},"c":15,"i":{"e":{"r":237}}},21],"r":29},18],"d":43,"e":{".":18,"a":{"d":{"i":17},"t":18,"c":{"h":{"e":{"r":{".":36}}}}},"c":{"e":17,"t":32},"d":[{"i":4},42],"e":41,"g":[{"e":{"r":4},"i":4},0],"l":{".":27,"i":17,"s":32,"e":{"g":84,"r":{"o":249}}},"m":{"a":[{"t":11},154]},"n":{"a":{"n":27},"c":27,"d":27,"e":{"s":18},"t":[{"a":{"g":0}},41]},"o":41,"p":[{"e":4},1],"r":{"c":11,"d":155,"i":[{"e":{"s":5},"s":11,"z":{"a":6},"c":{".":8}},41],"n":{"i":{"t":32}},"v":5,"g":{"e":{"i":312}}},"s":{".":18,"s":[{".":23,"e":{"s":313}},18]},"t":{"h":{"e":6}},"u":27,"x":27,"y":18},"f":42,"g":43,"h":{".":25,"a":{"n":17,"l":{"a":{"m":228}}},"e":[{"a":[{"s":3,"t":5},18],"i":{"s":11},"t":27},9],"i":{"c":{".":4,"a":4},"l":18,"n":{"k":32}},"l":18,"o":{"d":{"e":4,"i":{"c":32},"o":{"n":11}},"o":18,"r":{"i":{"t":6,"z":5}},"g":{"e":{"n":{"i":314}}},"k":{"e":{"r":175}}},"s":25,"y":{"l":{"a":{"n":228}},"s":{"c":11}}},"i":{"a":[{"b":1,"t":{"o":1},"n":{".":70}},41],"b":156,"c":{"k":18,"o":21,"u":157},"d":{"i":32},"e":{"n":27},"f":[{"y":4},8],"g":[{"u":32},25],"l":{"l":{"i":{"n":6}}},"m":[{"p":18,"u":{"l":5}},41],"n":[{"a":24,"e":{".":27},"i":27,"o":{"m":285}},42],"o":[{"c":4,"n":{"e":{"e":6}}},41],"q":32,"s":{"a":3,"e":27,"m":0,"o":4,"p":0,"t":{"i":{"c":{"a":32}}}},"t":{"l":3},"u":1,"v":[{"a":0},41],"z":[{"a":3,"e":{"n":3}},41]},"l":[{"a":[{"n":17},19],"e":{".":27,"d":27,"s":{".":27},"t":{".":19}},"o":19,"i":{"e":{"r":315}}},25],"m":[{"e":0},43],"n":81,"o":[{"b":3,"c":{"r":{"a":{"t":4}}},"d":{"o":18},"f":25,"g":{"r":9},"i":{"c":4},"m":{"a":9,"b":0,"y":3},"n":{"a":{"l":{"i":0},"t":3},"o":18,"y":18},"r":{"a":9,"i":{"e":3,"z":5}},"s":8,"u":{"r":32,"t":18},"w":{"a":{"r":3}},"l":{"o":{"g":{"y":84}}},"t":{"i":{"c":11}}},41],"p":43,"r":{"a":[{"b":11,"c":{"h":5,"i":[{"t":17},36],"t":{"e":17}},"s":17,"v":{"e":{"n":5,"s":158,"r":{"s":[{"a":{"b":317}},15]}}},"i":{"t":{"o":{"r":316}}}},41],"e":{"f":5,"m":[{"i":6},0],"a":{"c":{"h":{"e":318}}}},"i":{"a":[{"l":{".":1}},32],"c":{"e":{"s":5},"i":{"a":32},"s":18},"m":25,"v":0},"o":{"m":{"i":5},"n":{"i":6,"y":18},"p":{"h":{"e":5},"i":{"s":175},"o":{"l":{"e":{"s":320},"i":{"s":320,"t":321}}}},"s":{"p":11},"v":11,"l":{"e":{"u":{"m":319}}},"f":{"i":{"c":{".":17},"t":11}}},"u":{"i":5,"s":17}},"s":[{"c":[{"h":{"i":{"e":12}}},21],"h":0,"w":21},101],"t":[{"e":{"s":21},"o":19,"u":0,"r":{"i":{"b":{"u":{"t":322}}}}},66],"u":[{"a":[{"r":3},2],"b":{"i":1},"d":8,"e":18,"f":46,"i":76,"m":27,"n":{"i":{"s":1}},"p":{".":48},"r":{"e":27,"i":[{"s":11},32],"o":5,"y":4,"n":{"a":{"r":12}}},"s":27},41],"v":18,"w":[{"a":43,"i":{"s":17},"o":18,"h":29},1],"y":[{"a":18,"l":25,"p":{"e":12,"h":4,"a":{"l":64}}},41],"z":[{"e":1},18]},"u":{"a":{"b":18,"c":0,"n":{"a":4,"i":0},"r":{"a":{"n":{"t":5}},"d":8,"i":11,"t":11},"t":29,"v":0,"d":{"r":{"a":{"t":{"i":3,"u":15}}}}},"b":{"e":[{"l":21,"r":[{"o":21},23]},1],"i":[{"n":{"g":33}},72],"l":{"e":{".":23}}},"c":{"a":23,"i":{"b":0,"t":1},"l":{"e":12},"r":23,"u":23,"y":21},"d":{"d":4,"e":{"r":3,"s":{"t":4},"v":17},"i":{"c":29,"e":{"d":3,"s":3},"s":4,"t":19},"o":{"n":[{"y":232},21]},"s":{"i":1},"u":21},"e":{"n":{"e":21,"s":17,"t":{"e":0}},"r":{"i":{"l":0}},"a":{"m":15}},"f":{"a":27,"l":23},"g":{"h":{"e":{"n":11}},"i":{"n":4}},"i":[{"l":{"i":{"z":5}},"n":[{"g":29},1],"r":{"m":0},"t":{"a":17},"v":[{"e":{"r":{".":0}}},11]},156],"j":19,"k":18,"l":{"a":[{"b":5,"t":{"i":19}},29],"c":{"h":[{"e":32},17]},"d":{"e":{"r":3}},"e":[{"n":29},1],"g":{"i":1},"i":[{"a":19,"n":{"g":3},"s":{"h":4}},9],"l":{"a":{"r":1},"i":{"b":96,"s":1}},"m":61,"o":72,"s":[{"e":{"s":5}},18],"t":{"i":2,"r":{"a":54},"u":18},"u":[{"l":4},23],"v":4},"m":{"a":{"b":4},"b":{"i":1,"l":{"y":1}},"i":[{"n":{"g":83}},29],"o":{"r":{"o":6}},"p":9},"n":{"a":{"t":17},"e":[{"r":1},24],"i":[{"m":1,"n":24,"s":{"h":4},"v":11},29],"s":[{"w":1},93],"t":{"a":{"b":11},"e":{"r":{".":1},"s":1}},"u":0,"y":4,"z":4},"o":{"r":{"s":21},"s":19,"u":29},"p":{"e":[{"r":{"s":6}},29],"i":{"a":19,"n":{"g":3}},"l":23,"p":[{"o":{"r":{"t":10}}},3],"t":{"i":{"b":5},"u":17}},"r":{"a":[{".":18,"g":21,"s":21,"l":{".":216}},29],"b":{"e":1},"c":0,"d":2,"e":{"a":{"t":5}},"f":{"e":{"r":1},"r":1},"i":{"f":[{"i":{"c":0}},23],"n":2,"o":23,"t":29,"z":3,"a":{"l":{".":0}}},"l":[{"i":{"n":{"g":{".":5}}}},9],"n":{"o":1},"o":{"s":17},"p":{"e":1,"i":1},"s":{"e":{"r":5}},"t":{"e":{"s":4},"h":{"e":3},"i":[{"e":1},17]},"u":23},"s":[{"a":{"d":19,"n":19,"p":1},"c":[{"i":3},8],"e":{"a":5,"r":{".":9}},"i":{"a":19,"c":23},"l":{"i":{"n":1}},"p":2,"s":{"l":4},"t":{"e":{"r":{"e":4}},"r":2},"u":[{"r":17},24]},25],"t":{"a":{"b":0,"t":23},"e":{".":18,"l":18,"n":[{"i":17},18]},"i":[{"l":{"i":{"z":5}},"n":{"e":23,"g":3},"o":{"n":{"a":7}},"s":21,"z":31},101],"l":34,"o":{"f":4,"g":5,"m":{"a":{"t":{"i":{"c":5}}}},"n":19,"u":21},"s":0},"u":[{"m":1},23],"v":74,"x":{"u":11},"z":{"e":1}},"v":{"a":[{".":32,"b":159,"c":{"i":{"l":5},"u":11},"g":[{"e":1,"u":{"e":{"r":170}}},0],"l":{"i":{"e":4},"o":5,"u":15},"m":{"o":4},"n":{"i":{"z":4}},"p":{"i":4},"r":{"i":{"e":{"d":5}}},"t":[{"i":{"v":29}},27],"u":{"d":{"e":{"v":54}}}},41],"e":{".":18,"d":18,"g":11,"l":{".":23,"l":{"i":11},"o":1,"y":21},"n":{"o":{"m":11},"u":{"e":19}},"r":{"d":21,"e":{".":32,"l":[{"y":{".":41}},21],"n":[{"c":5},23],"s":21,"i":{"g":324}},"i":{"e":11},"m":{"i":{"n":36}},"s":{"e":27},"t":{"h":11}},"s":[{".":18,"t":{"e":0,"i":{"t":{"e":15}}}},99],"t":{"e":[{"r":11},1],"y":1}},"i":{"a":{"l":{"i":4},"n":32},"d":{"e":{".":32,"d":32,"n":47,"s":32},"i":32},"f":23,"g":{"n":4},"k":0,"l":[{"i":{"t":32,"z":127}},25],"n":[{"a":26,"c":24,"d":5,"g":18},29],"o":{"l":11,"r":73,"u":2},"p":1,"r":{"o":4},"s":{"i":{"t":11},"o":3,"u":3},"t":{"i":18,"r":11,"y":18},"v":[{"i":{"p":{"a":{"r":325}}}},27]},"o":{".":32,"i":[{"r":{"d":{"u":323}},"c":{"e":{"p":213}}},0],"k":27,"l":{"a":1,"e":19,"t":32,"v":27},"m":{"i":5},"r":{"a":{"b":5},"i":17,"y":1},"t":{"a":1,"e":{"e":18}}},"v":26,"y":21},"w":{"a":{"b":{"l":19},"c":25,"g":{"e":{"r":4},"o":5},"i":{"t":6},"l":{".":19},"m":0,"r":{"t":0},"s":{"t":[{"e":{"w":{"a":326}}},0]},"t":{"e":2},"v":{"e":{"r":4,"g":327}}},"b":29,"e":{"a":{"r":{"i":{"e":5}},"t":{"h":54}},"d":{"n":0},"e":{"t":12,"v":5,"k":{"n":137}},"l":{"l":0},"r":29,"s":{"t":12},"v":23},"h":{"i":0},"i":[{"l":[{"l":{"i":{"n":6}}},8],"n":{"d":{"e":0},"g":0},"r":0,"s":{"e":27},"t":{"h":12},"z":5,"d":{"e":{"s":{"p":6}}}},9],"k":21,"l":{"e":{"s":1},"i":{"n":3}},"n":{"o":21},"o":[{"m":15,"v":{"e":{"n":4}},"k":{"e":{"n":85}}},160],"p":19,"r":{"a":[{"p":{"a":{"r":{"o":12}}}},0],"i":[{"t":{"a":36,"e":{"r":{".":183}}}},0]},"s":{"h":23,"l":1,"p":{"e":1},"t":60},"t":18,"y":1,"c":23},"x":{"a":[{"c":{"e":5},"g":{"o":21},"m":11,"p":21,"s":5},29],"c":161,"e":[{"c":{"u":{"t":{"o":1}}},"d":24,"r":{"i":0,"o":4}},29],"h":[{"i":[{"l":6},8],"u":0},29],"i":[{"a":4,"c":4,"d":{"i":4},"m":{"e":21,"i":{"z":4}}},23],"o":[{"b":21},23],"p":[{"a":{"n":{"d":17}},"e":{"c":{"t":{"o":10}},"d":11}},23],"t":[{"i":23},74],"u":[{"a":3},29],"x":1,"q":[{"u":{"i":{"s":54}}},29]},"y":{"a":{"c":19,"r":110,"t":19},"b":29,"c":[{"e":[{"r":4},24],"h":[{"e":[{"d":264},0]},23],"o":{"m":17,"t":17}},29],"d":29,"e":{"e":19,"r":[{"f":21},29],"s":[{"t":{"e":{"r":{"y":328}}}},0],"t":1},"g":{"i":19},"h":47,"i":29,"l":{"a":23,"l":{"a":{"b":{"l":6}}},"o":23,"u":19},"m":{"b":{"o":{"l":7}},"e":[{"t":{"r":{"y":20}}},0],"p":{"a":12}},"n":{"c":{"h":{"r":3}},"d":4,"g":4,"i":{"c":4},"x":32},"o":[{"d":4,"g":33,"m":0,"n":{"e":{"t":4},"s":21},"s":21},72],"p":{"e":{"d":21,"r":6},"i":3,"o":[{"c":21},23],"t":{"a":9},"u":19},"r":{"a":{"m":5},"i":{"a":4},"o":23,"r":1},"s":{"c":1,"e":161,"i":{"c":{"a":3},"o":3,"s":27},"o":21,"s":0,"t":[{"a":3,"r":{"o":29}},2],"u":{"r":17}},"t":{"h":{"i":{"n":23}},"i":{"c":3}},"w":29},"z":{"a":[{"b":79,"r":8},2],"b":18,"e":[{"n":1,"p":1,"r":[{"o":3},29],"t":0},25],"i":[{"l":21,"s":21,"a":{"n":{".":23}}},42],"l":32,"m":18,"o":[{"m":1,"o":{"l":4},"p":{"h":{"r":329}}},41],"t":{"e":0},"z":[{"y":21,"w":231},101]}}',
        [
          "as-so-ciate",
          "as-so-ciates",
          "dec-li-na-tion",
          "oblig-a-tory",
          "phil-an-thropic",
          "present",
          "presents",
          "project",
          "projects",
          "reci-procity",
          "re-cog-ni-zance",
          "ref-or-ma-tion",
          "ret-ri-bu-tion",
          "ta-ble"
        ]
      ];
    });
  }(Uc)), Uc.exports;
}
var eZ = AZ();
const tZ = /* @__PURE__ */ Ht(eZ);
var rZ = function(A) {
  var t = 0, r = "", n = [];
  return A.forEach(function(i) {
    r += i.string, n.push(Yr({}, i, {
      start: t,
      end: t + i.string.length,
      attributes: i.attributes || {}
    })), t += i.string.length;
  }), {
    string: r,
    runs: n
  };
}, nZ = function(A) {
  return [A];
}, iZ = function(A, t) {
  return A === void 0 && (A = {}), t === void 0 && (t = {}), function(r) {
    for (var n, i, a = [], o = [], s = t.hyphenationCallback || ((n = (i = A).wordHyphenation) === null || n === void 0 ? void 0 : n.call(i, t)) || nZ, l = 0; l < r.runs.length; l += 1) {
      for (var u = "", g = r.runs[l], d = r.string.slice(g.start, g.end).split(/([ ]+)/g).filter(Boolean), h = 0; h < d.length; h += 1) {
        var C = d[h], E = s(C);
        a.push.apply(a, E), u += E.join("");
      }
      o.push(Yr({}, g, {
        string: u
      }));
    }
    return Yr({}, rZ(o), {
      syllables: a
    });
  };
}, aZ = function(A) {
  return Object.assign({}, A);
}, Rv = function(A, t) {
  var r = Object.assign({}, A, {
    height: t
  }), n = Object.assign({}, A, {
    y: A.y + t,
    height: A.height - t
  });
  return [r, n];
}, oZ = function(A, t) {
  var r = Rv(t, A), n = r[1];
  return n;
}, sZ = function(A) {
  return A.reduce(function(t, r) {
    return t + r.box.height;
  }, 0);
}, lZ = function(A) {
  var t, r = A.attributes || {}, n = r.fontSize || 12, i = (t = r.font) === null || t === void 0 ? void 0 : t.unitsPerEm;
  return i ? n / i : 0;
}, ds = function(A) {
  var t;
  return ((t = A.attributes) === null || t === void 0 ? void 0 : t.scale) || lZ(A);
}, j2 = function(A, t) {
  if (!t) return 0;
  var r = t.glyphIndices || [], n = r[A];
  return r.slice(0, A).filter(function(i) {
    return i === n;
  }).length;
}, GE = function(A) {
  var t;
  return ((t = A.attributes) === null || t === void 0 ? void 0 : t.font) || null;
}, V2 = function(A, t, r, n) {
  if (!n) return [];
  if (A === t) return [];
  if (A === 0 && t === n.codePoints.length) return [n];
  var i = n.codePoints.slice(A, t), a = String.fromCodePoint.apply(String, i);
  return r ? r.layout(a, void 0, void 0, void 0, "ltr").glyphs : [n];
}, Eg = function(A, t) {
  var r, n = t == null || (r = t.glyphIndices) === null || r === void 0 ? void 0 : r[A];
  return yt(n) ? A : n;
}, Gv = function(A) {
  var t = A[0];
  return A.map(function(r) {
    return r - t;
  });
}, Fl = function(A, t, r) {
  var n, i, a = ds(r), o = GE(r), s = Eg(A, r), l = Eg(t, r), u = (n = r.glyphs) === null || n === void 0 ? void 0 : n[s], g = (i = r.glyphs) === null || i === void 0 ? void 0 : i[l], d = j2(A, r), h = d > 0 ? V2(d, 1 / 0, o, u) : [], C = j2(t, r), E = V2(0, C, o, g), I = s + Math.min(1, d), b = (r.glyphs || []).slice(I, l), y = function(k) {
    return {
      xAdvance: k.advanceWidth * a
    };
  }, p = h.map(y), Q = (r.positions || []).slice(I, l), w = E.map(y);
  return Object.assign({}, r, {
    start: r.start + A,
    end: Math.min(r.end, r.start + t),
    glyphIndices: Gv((r.glyphIndices || []).slice(A, t)),
    glyphs: [h, b, E].flat(),
    positions: [p, Q, w].flat()
  });
}, Th = function(A, t) {
  return t ? t.findIndex(function(r) {
    return r.start <= A && A < r.end;
  }) : -1;
}, xv = function(A, t, r) {
  var n = Th(A, r), i = Math.max(Th(t - 1, r), n);
  return r.slice(n, i + 1);
}, uZ = function(A, t) {
  var r = t.start - A, n = t.end - A;
  return Object.assign({}, t, {
    start: r,
    end: n
  });
}, cZ = function(A, t, r) {
  var n = function(o) {
    return Fl(A - o.start, t - o.start, o);
  }, i = function(o) {
    return Fl(0, t - o.start, o);
  };
  return r.map(function(a, o) {
    var s = a, l = o === 0, u = !l && o === r.length - 1;
    return l && (s = n(a)), u && (s = i(a)), uZ(A, s);
  });
}, Jo = function(A, t, r) {
  if (r.string.length === 0) return r;
  var n = r.string.slice(A, t), i = xv(A, t, r.runs), a = cZ(A, t, i);
  return Object.assign({}, r, {
    string: n,
    runs: a
  });
}, gZ = function(A) {
  return A.search(/\S/g);
}, BZ = function(A) {
  var t = A.match(/\S/g);
  return t ? A.lastIndexOf(t[t.length - 1]) : -1;
}, fZ = function(A) {
  var t = gZ(A.string), r = BZ(A.string);
  return Jo(t, r + 1, A);
}, dZ = function() {
  return {
    start: 0,
    end: 0,
    glyphIndices: [],
    glyphs: [],
    positions: [],
    attributes: {}
  };
}, kv = function(A) {
  return typeof A == "number";
}, hZ = function(A, t) {
  var r = ni(t), n = yt(r) ? 0 : r + 1, i = Array(A).fill(n);
  return t.concat(i);
}, Uv = function(A, t) {
  return t && A ? t.glyphForCodePoint(A) : null;
}, CZ = function(A, t) {
  var r, n = ((r = A.codePoints) === null || r === void 0 ? void 0 : r.length) || 0, i = t.end + n, a = t.glyphs.concat(A), o = hZ(n, t.glyphIndices);
  if (!t.positions) return Object.assign({}, t, {
    end: i,
    glyphs: a,
    glyphIndices: o
  });
  var s = t.positions.concat({
    xAdvance: A.advanceWidth * ds(t)
  });
  return Object.assign({}, t, {
    end: i,
    glyphs: a,
    glyphIndices: o,
    positions: s
  });
}, Yv = function(A, t) {
  if (!A) return t;
  var r = GE(t), n = kv(A) ? Uv(A, r) : A;
  return CZ(n, t);
}, Hv = function(A) {
  return String.fromCodePoint.apply(String, A || []);
}, Sv = function(A, t) {
  var r = (A == null ? void 0 : A.codePoints) || [], n = Hv(r), i = t.string + n, a = t.runs.slice(0, -1), o = ni(t.runs) || dZ(), s = a.concat(Yv(A, o));
  return Object.assign({}, t, {
    string: i,
    runs: s
  });
}, Nv = 8230, EZ = String.fromCharCode(Nv), QZ = function(A) {
  if (!A.encode) return Nv;
  var t = A.encode(EZ), r = t[0];
  return parseInt(r[0], 16);
}, O2 = function(A) {
  var t, r, n, i = ((t = ni(A)) === null || t === void 0 ? void 0 : t.runs) || [], a = (r = ni(i)) === null || r === void 0 || (n = r.attributes) === null || n === void 0 ? void 0 : n.font;
  if (a) {
    var o, s = A.length - 1, l = QZ(a), u = a.glyphForCodePoint(l), g = Sv(u, fZ(A[s]));
    return Object.assign([], A, (o = {}, o[s] = g, o));
  }
  return A;
}, Tv = function(A, t) {
  var r = Object.assign({}, t.attributes);
  return delete r[A], Object.assign({}, t, {
    attributes: r
  });
}, IB = function(A) {
  var t, r, n, i, a = ((t = A.attributes) === null || t === void 0 || (r = t.attachment) === null || r === void 0 ? void 0 : r.height) || 0, o = ((n = A.attributes) === null || n === void 0 || (i = n.font) === null || i === void 0 ? void 0 : i.ascent) || 0;
  return Math.max(a, o * ds(A));
}, Pv = function(A) {
  var t, r, n = ((t = A.attributes) === null || t === void 0 || (r = t.font) === null || r === void 0 ? void 0 : r.descent) || 0;
  return ds(A) * n;
}, wZ = function(A) {
  var t, r;
  return (((t = A.attributes) === null || t === void 0 || (r = t.font) === null || r === void 0 ? void 0 : r.lineGap) || 0) * ds(A);
}, zv = function(A) {
  var t, r = (t = A.attributes) === null || t === void 0 ? void 0 : t.lineHeight;
  return r || wZ(A) + IB(A) - Pv(A);
}, jv = function(A) {
  var t = function(n, i) {
    return Math.max(n, zv(i));
  };
  return A.runs.reduce(t, 0);
}, IZ = function(A, t) {
  var r = Math.max(A.x, t.x), n = Math.min(A.x + A.width, t.x + t.width), i = Math.max(A.y, t.y), a = Math.min(A.y + A.height, t.y + t.height);
  return n >= r && a >= i;
}, DZ = ["excludeRects"], mZ = function(A, t) {
  if (!IZ(t, A)) return [A];
  var r = t.x, n = t.x + t.width, i = A.x, a = A.x + A.width, o = Object.assign({}, A, {
    width: r - i
  }), s = Object.assign({}, A, {
    x: n,
    width: a - n
  });
  return [o, s].filter(function(l) {
    return l.width > 0;
  });
}, MZ = function(A, t) {
  for (var r = [A], n = function() {
    var o = t[i];
    r = r.reduce(function(s, l) {
      var u = mZ(l, o);
      return s.concat(u);
    }, []);
  }, i = 0; i < t.length; i += 1)
    n();
  return r;
}, pZ = function(A, t) {
  var r = A.excludeRects, n = bl(A, DZ);
  if (!r) return [n];
  for (var i = [], a = Math.max.apply(Math, r.map(function(d) {
    return d.y + d.height;
  })), o = n; o.y < a; ) {
    var s = Rv(o, t), l = s[0], u = s[1], g = MZ(l, r);
    o = u, i.push.apply(i, g);
  }
  return [].concat(i, [o]);
}, vZ = "￼", yZ = function(A) {
  var t = !A.string.includes(vZ);
  if (!t) return A;
  var r = A.runs.map(function(n) {
    return Tv("attachment", n);
  });
  return Object.assign({}, A, {
    runs: r
  });
}, bZ = function(A, t, r) {
  var n = A.shift(), i = n.y;
  return t.map(function(a, o) {
    var s, l, u = o === 0 ? r : 0, g = ((s = a.runs) === null || s === void 0 || (l = s[0]) === null || l === void 0 ? void 0 : l.attributes) || {}, d = Math.max(jv(a), g.lineHeight);
    i + d > n.y + n.height && A.length > 0 && (n = A.shift(), i = n.y);
    var h = Object.assign({}, a);
    return delete h.syllables, h.box = {
      x: n.x + u,
      y: i,
      width: n.width - u,
      height: d
    }, i += d, yZ(h);
  });
}, FZ = function(A, t) {
  return function(r, n) {
    var i, a, o, s = jv(n), l = ((i = n.runs) === null || i === void 0 || (a = i[0]) === null || a === void 0 || (o = a.attributes) === null || o === void 0 ? void 0 : o.indent) || 0, u = pZ(r, s), g = u.map(function(h) {
      return h.width;
    });
    g[0] -= l;
    var d = A.linebreaker(t)(n, g);
    return bZ(u, d, l);
  };
}, LZ = function(A, t) {
  for (var r = [], n = 0, i = 0; i < t.length; i += 1) {
    var a = t[i];
    if (n += a.box.height, n < A)
      r.push(a);
    else
      break;
  }
  return r;
}, RZ = function(A, t, r) {
  return function(n) {
    for (var i = [], a = [].concat(n), o = FZ(A, t), s = yt(r.maxLines) ? 1 / 0 : r.maxLines, l = r.truncateMode === "ellipsis", u = s, g = aZ(r), d = a.shift(); u > 0 && d; ) {
      var h = o(g, d), C = h.slice(0, u), E = sZ(C), I = l && h.length !== C.length;
      if (u -= C.length, g.height >= E)
        i.push(I ? O2(C) : C), g = oZ(E, g), d = a.shift();
      else {
        i.push(O2(LZ(g.height, C)));
        break;
      }
    }
    return i;
  };
}, GZ = function(A) {
  var t = A.runs;
  return t.length === 0 ? 0 : t[0].start;
}, xZ = function(A) {
  var t = A.runs;
  return t.length === 0 ? 0 : ni(t).end;
}, Vv = function(A) {
  return xZ(A) - GZ(A);
}, J2 = RE(), kZ = function(A) {
  return A.reduce(function(t, r) {
    var n = r.end - r.start, i = wm(r.attributes.bidiLevel, n);
    return t.concat(i);
  }, []);
}, UZ = function(A, t) {
  for (var r = [], n = 0; n < A.length; n += 1)
    r[n] = n;
  return t.forEach(function(i) {
    for (var a = i[0], o = i[1], s = r.slice(a, o + 1), l = s.length - 1; l >= 0; l -= 1)
      r[o - l] = s[l];
  }), r;
}, W2 = function(A, t, r) {
  for (var n = 0; n < A.length; n += 1) {
    var i = A[n], a = i.glyphIndices[r - i.start];
    if (r >= i.start && r < i.end)
      return i[t][a];
  }
  throw new Error("index " + r + " out of range");
}, YZ = function(A) {
  var t, r = kZ(A.runs), n = (t = A.runs[0]) === null || t === void 0 ? void 0 : t.attributes.direction, i = n === "rtl" ? 1 : 0, a = Vv(A) - 1, o = [{
    start: 0,
    end: a,
    level: i
  }], s = {
    paragraphs: o,
    levels: r
  }, l = J2.getReorderSegments(A.string, s);
  if (l.length === 0) return A;
  var u = UZ(A.string, l), g = J2.getReorderedString(A.string, s), d = A.runs.map(function(h) {
    for (var C = u.slice(h.start, h.end), E = [], I = [], b = /* @__PURE__ */ new Set(), y = 0; y < C.length; y += 1) {
      var p = C[y], Q = W2(A.runs, "glyphs", p);
      b.has(Q.id) || (E.push(Q), I.push(W2(A.runs, "positions", p)), Q.isLigature && b.add(Q.id));
    }
    return Yr({}, h, {
      glyphs: E,
      positions: I
    });
  });
  return Yr({}, A, {
    runs: d,
    string: g
  });
}, HZ = function(A) {
  return A.map(YZ);
}, SZ = function() {
  return function(A) {
    return A.map(HZ);
  };
}, NZ = 123, TZ = function(A) {
  return A === void 0 && (A = []), A.reduce(function(t, r) {
    var n = (r == null ? void 0 : r.codePoints) || [NZ];
    if (t.length === 0) return n.map(function() {
      return 0;
    });
    var i = t[t.length - 1], a = n.map(function() {
      return i + 1;
    });
    return [].concat(t, a);
  }, []);
}, PZ = function(A) {
  var t;
  return ((t = A.attributes) === null || t === void 0 ? void 0 : t.characterSpacing) || 0;
}, zZ = function(A, t) {
  var r = ds(A), n = PZ(A);
  return t.map(function(i, a) {
    var o = a === t.length, s = o ? 0 : n;
    return Object.assign({}, i, {
      xAdvance: i.xAdvance * r + s,
      yAdvance: i.yAdvance * r,
      xOffset: i.xOffset * r,
      yOffset: i.yOffset * r
    });
  });
}, jZ = function(A) {
  return function(t) {
    var r = t.start, n = t.end, i = t.attributes, a = i === void 0 ? {} : i, o = a.font;
    if (!o) return Yr({}, t, {
      glyphs: [],
      glyphIndices: [],
      positions: []
    });
    var s = A.slice(r, n), l = o.layout(s, void 0, void 0, void 0, "ltr"), u = zZ(t, l.positions), g = TZ(l.glyphs);
    return Yr({}, t, {
      positions: u,
      glyphIndices: g,
      glyphs: l.glyphs
    });
  };
}, VZ = function() {
  return function(A) {
    var t = A.runs.map(jZ(A.string));
    return Object.assign({}, A, {
      runs: t
    });
  };
}, OZ = function(A) {
  var t, r, n;
  if (!A.positions) return A;
  var i = ((t = A.attributes) === null || t === void 0 || (r = t.font) === null || r === void 0 ? void 0 : r.unitsPerEm) || 0, a = (((n = A.attributes) === null || n === void 0 ? void 0 : n.yOffset) || 0) * i, o = A.positions.map(function(s) {
    return Object.assign({}, s, {
      yOffset: a
    });
  });
  return Object.assign({}, A, {
    positions: o
  });
}, JZ = function() {
  return function(A) {
    var t = A.runs.map(OZ);
    return Object.assign({}, A, {
      runs: t
    });
  };
}, WZ = function(A) {
  return A.sort(function(t, r) {
    return t.start - r.start || t.end - r.end;
  });
}, Z2 = function(A) {
  return A.start === A.end;
}, ZZ = function(A, t) {
  return A[1] - t[1] || A[3] - t[3];
}, KZ = function(A) {
  var t = A.reduce(function(r, n, i) {
    return r.concat([["start", n.start, n.attributes, i], ["end", n.end, n.attributes, i]]);
  }, []);
  return t.sort(ZZ);
}, _Z = function(A) {
  return A.reduce(function(t, r) {
    var n = Object.assign({}, t.attributes, r.attributes);
    return Object.assign({}, r, {
      attributes: n
    });
  }, {});
}, XZ = function(A) {
  var t = A.reduce(function(r, n) {
    return r[n.start] || (r[n.start] = []), r[n.start].push(n), r;
  }, []);
  return Object.values(t);
}, qZ = function(A) {
  return XZ(A).map(_Z);
}, $Z = function(A) {
  for (var t = [], r = KZ(A), n = -1, i = {}, a = [], o = 0; o < r.length; o += 1) {
    var s = r[o], l = s[0], u = s[1], g = s[2];
    if (n !== -1 && n < u && t.push({
      start: n,
      end: u,
      attributes: i
    }), l === "start")
      a.push(g), i = Object.assign({}, i, g);
    else {
      i = {};
      for (var d = 0; d < a.length; d += 1)
        a[d] === g ? a.splice(d--, 1) : i = Object.assign({}, i, a[d]);
    }
    n = u;
  }
  return t;
}, AK = function(A) {
  A === void 0 && (A = []);
  var t = qZ(A.filter(function(n) {
    return Z2(n);
  })), r = $Z(A.filter(function(n) {
    return !Z2(n);
  }));
  return WZ(t.concat(r));
}, Ov = function() {
  return {
    string: "",
    runs: []
  };
}, eK = function(A) {
  var t = A.runs.map(function(r) {
    return Tv("font", r);
  });
  return Object.assign({}, A, {
    runs: t
  });
}, tK = function(A, t) {
  return function(r) {
    if (yt(r)) return Ov();
    var n = r.string, i = A.fontSubstitution, a = A.scriptItemizer, o = A.bidi, s = eK(r), l = s.runs, u = a(t)(r), g = u.runs, d = i(t)(r), h = d.runs, C = o(t)(r), E = C.runs, I = E.concat(h).concat(g).concat(l);
    return {
      string: n,
      runs: AK(I)
    };
  };
}, rK = function() {
  return function(A) {
    for (var t = [], r = 0, n = A.string.indexOf(`
`) + 1; n > 0; )
      t.push(Jo(r, n, A)), r = n, n = A.string.indexOf(`
`, n) + 1;
    return r === 0 ? t.push(A) : r < A.string.length && t.push(Jo(r, Vv(A), A)), t;
  };
}, Jv = function(A) {
  return A.reduce(function(t, r) {
    return t + (r.xAdvance || 0);
  }, 0);
}, xE = function(A) {
  return Jv(A.positions || []);
}, kE = function(A) {
  var t = function(n, i) {
    return n + xE(i);
  };
  return A.runs.reduce(t, 0);
}, nK = 32, UE = function(A) {
  var t = (A == null ? void 0 : A.codePoints) || [];
  return t.includes(nK);
}, iK = function(A) {
  var t = A.glyphs || [], r = A.positions || [], n = t.findIndex(function(i) {
    return !UE(i);
  });
  return r.slice(0, n);
}, aK = function(A) {
  var t = iK(A);
  return t.reduce(function(r, n) {
    return r + (n.xAdvance || 0);
  }, 0);
}, oK = function(A) {
  var t = A.runs || [];
  return aK(t[0]);
}, K2 = function(A) {
  return [].concat(A).reverse();
}, sK = function(A) {
  var t = K2(A.glyphs || []), r = K2(A.positions || []), n = t.findIndex(function(i) {
    return !UE(i);
  });
  return r.slice(0, n);
}, lK = function(A) {
  var t = sK(A);
  return t.reduce(function(r, n) {
    return r + (n.xAdvance || 0);
  }, 0);
}, uK = function(A) {
  var t = A.runs || [];
  return lK(ni(t));
}, cK = function(A) {
  return Fl(0, A.end - A.start - 1, A);
}, gK = function(A) {
  var t = xS(A.string), r = LS(-1, cK, A.runs);
  return Object.assign({}, A, {
    string: t,
    runs: r
  });
}, BK = {
  center: 0.5,
  right: 1
}, fK = function(A) {
  return ni(A.string) === `
` ? gK(A) : A;
}, dK = function(A) {
  return oK(A) + (A.overflowLeft || 0);
}, hK = function(A) {
  return uK(A) + (A.overflowRight || 0);
}, CK = function(A) {
  var t = dK(A), r = hK(A), n = A.box.x - t, i = A.box.width + t + r, a = Object.assign({}, A.box, {
    x: n,
    width: i
  });
  return Object.assign({}, A, {
    box: a,
    overflowLeft: t,
    overflowRight: r
  });
}, EK = function(A, t, r) {
  return function(n) {
    var i = kE(n), a = BK[r] || 0, o = Math.max(0, n.box.width - i), s = r === "justify" || i > n.box.width, l = n.box.x + o * a, u = Object.assign({}, n.box, {
      x: l
    }), g = Object.assign({}, n, {
      box: u
    });
    return s ? A.justification(t)(g) : g;
  };
}, QK = function(A) {
  var t = 0, r = 0, n = 0, i = 0, a = A.runs.map(function(o) {
    var s = zv(o), l = IB(o), u = Pv(o), g = xE(o);
    return n = Math.max(n, s), t = Math.max(t, l), r = Math.max(r, u), i += g, Object.assign({}, o, {
      height: s,
      ascent: l,
      descent: u,
      xAdvance: g
    });
  });
  return Object.assign({}, A, {
    runs: a,
    height: n,
    ascent: t,
    descent: r,
    xAdvance: i
  });
}, wK = function(A, t) {
  return A === void 0 && (A = {}), function(r, n, i) {
    var a, o, s = n === i.length - 1, l = ((a = r.runs) === null || a === void 0 || (o = a[0]) === null || o === void 0 ? void 0 : o.attributes) || {}, u = s ? l.alignLastLine : l.align;
    return en(QK, A.textDecoration(t), EK(A, t, u), CK, fK)(r);
  };
}, IK = function(A, t) {
  return function(r) {
    var n = wK(A, t);
    return r.map(function(i) {
      return i.map(n);
    });
  };
}, DK = 65532, mK = function(A) {
  return A.codePoints.includes(DK);
}, MK = function(A) {
  var t;
  if (!A.positions) return A;
  var r = A.glyphs || [], n = ((t = A.attributes) === null || t === void 0 ? void 0 : t.attachment) || {}, i = A.positions.map(function(a, o) {
    var s = r[o];
    return n && n.width && mK(s) ? Object.assign({}, a, {
      xAdvance: n.width
    }) : Object.assign({}, a);
  });
  return Object.assign({}, A, {
    positions: i
  });
}, pK = function() {
  return function(A) {
    var t = A.runs.map(MK);
    return Object.assign({}, A, {
      runs: t
    });
  };
}, vK = function(A) {
  return {
    align: A.align || (A.direction === "rtl" ? "right" : "left"),
    alignLastLine: A.alignLastLine || (A.align === "justify" ? "left" : A.align || "left"),
    attachment: A.attachment || null,
    backgroundColor: A.backgroundColor || null,
    bullet: A.bullet || null,
    characterSpacing: A.characterSpacing || 0,
    color: A.color || "black",
    direction: A.direction || "ltr",
    features: A.features || [],
    fill: A.fill !== !1,
    font: A.font || null,
    fontSize: A.fontSize || 12,
    hangingPunctuation: A.hangingPunctuation || !1,
    hyphenationFactor: A.hyphenationFactor || 0,
    indent: A.indent || 0,
    justificationFactor: A.justificationFactor || 1,
    lineHeight: A.lineHeight || null,
    lineSpacing: A.lineSpacing || 0,
    link: A.link || null,
    marginLeft: A.marginLeft || A.margin || 0,
    marginRight: A.marginRight || A.margin || 0,
    opacity: A.opacity,
    paddingTop: A.paddingTop || A.padding || 0,
    paragraphSpacing: A.paragraphSpacing || 0,
    script: A.script || null,
    shrinkFactor: A.shrinkFactor || 0,
    strike: A.strike || !1,
    strikeColor: A.strikeColor || A.color || "black",
    strikeStyle: A.strikeStyle || "solid",
    stroke: A.stroke || !1,
    underline: A.underline || !1,
    underlineColor: A.underlineColor || A.color || "black",
    underlineStyle: A.underlineStyle || "solid",
    verticalAlign: A.verticalAlign || null,
    wordSpacing: A.wordSpacing || 0,
    yOffset: A.yOffset || 0
  };
}, yK = function(A) {
  var t = vK(A.attributes);
  return Object.assign({}, A, {
    attributes: t
  });
}, bK = function() {
  return function(A) {
    var t = A.string || "", r = (A.runs || []).map(yK);
    return {
      string: t,
      runs: r
    };
  };
}, FK = function() {
  return function(A) {
    return A.runs.forEach(function(t) {
      var r = t.attributes, n = r.verticalAlign;
      n === "sub" ? r.yOffset = -0.2 : n === "super" && (r.yOffset = 0.4);
    }), A;
  };
}, LK = RE(), RK = function(A) {
  return A.reduce(function(t, r) {
    var n = r.end - r.start, i = wm(r.attributes.bidiLevel, n);
    return t.concat(i);
  }, []);
}, GK = function() {
  return function(A) {
    var t = RK(A.runs), r = "";
    return A.string.split("").forEach(function(n, i) {
      var a = t[i] % 2 === 1, o = a ? LK.getMirroredCharacter(A.string.charAt(i)) : null;
      r += o || n;
    }), Yr({}, A, {
      string: r,
      levels: t
    });
  };
}, Wv = function(A) {
  return function(t, r, n) {
    n === void 0 && (n = {});
    var i = en(JZ(), pK(), FK(), iZ(A, n), VZ(), GK(), tK(A, n)), a = function(s) {
      return s.map(i);
    };
    return en(IK(A, n), SZ(), RZ(A, n, r), a, rK(), bK())(t);
  };
}, xK = RE(), Zv = function() {
  return function(A) {
    for (var t, r = A.string, n = (t = A.runs[0]) === null || t === void 0 ? void 0 : t.attributes.direction, i = xK.getEmbeddingLevels(r, n), a = i.levels, o = null, s = 0, l = 0, u = [], g = 0; g < a.length; g += 1) {
      var d = a[g];
      d !== o && (o !== null && u.push({
        start: s,
        end: l,
        attributes: {
          bidiLevel: o
        }
      }), s = l, o = d), l += 1;
    }
    return s < r.length && u.push({
      start: s,
      end: r.length,
      attributes: {
        bidiLevel: o
      }
    }), {
      string: r,
      runs: u
    };
  };
}, _2 = 1e4, kK = function(A, t, r) {
  for (var n = null, i = 1 / 0, a = {
    width: 0,
    stretch: 0,
    shrink: 0
  }, o = t[Math.min(r, t.length - 1)], s = function(I) {
    return a.width < o ? a.stretch - I.stretch > 0 ? (o - a.width) / a.stretch : _2 : a.width > o ? a.shrink - I.shrink > 0 ? (o - a.width) / a.shrink : _2 : 0;
  }, l = 0; l < A.length; l += 1) {
    var u = A[l];
    if (u.type === "box" ? a.width += u.width : u.type === "glue" && (a.width += u.width, a.stretch += u.stretch, a.shrink += u.shrink), a.width - a.shrink > o) {
      if (n === null) {
        for (var g = l === 0 ? l + 1 : l; g < A.length && (A[g].type === "glue" || A[g].type === "penalty"); )
          g++;
        n = g - 1;
      }
      break;
    }
    if (u.type === "penalty" || u.type === "glue") {
      var d = s(u), h = u.type === "penalty" ? u.penalty : 0, C = 100 * Math.pow(Math.abs(d), 3) + h;
      i >= C && (n = l, i = C);
    }
  }
  return a.width - a.shrink > o ? n : null;
}, UK = function(A, t) {
  for (var r = 0, n = 0, i = A, a = [{
    position: 0
  }]; i.length > 0; ) {
    var o = kK(i, t, n);
    o !== null ? (r += o, a.push({
      position: r
    }), i = i.slice(o + 1, i.length), r++, n++) : i = [];
  }
  return a;
}, YK = /* @__PURE__ */ function() {
  function e(t) {
    this.prev = null, this.next = null, this.data = t;
  }
  var A = e.prototype;
  return A.toString = function() {
    return this.data.toString();
  }, e;
}(), Yc = /* @__PURE__ */ function() {
  function e() {
    this.head = null, this.tail = null, this.listSize = 0, this.listLength = 0;
  }
  var A = e.prototype;
  return A.isLinked = function(r) {
    return !(r && r.prev === null && r.next === null && this.tail !== r && this.head !== r || this.isEmpty());
  }, A.size = function() {
    return this.listSize;
  }, A.isEmpty = function() {
    return this.listSize === 0;
  }, A.first = function() {
    return this.head;
  }, A.last = function() {
    return this.last;
  }, A.toString = function() {
    return this.toArray().toString();
  }, A.toArray = function() {
    for (var r = this.head, n = []; r !== null; )
      n.push(r), r = r.next;
    return n;
  }, A.forEach = function(r) {
    for (var n = this.head; n !== null; )
      r(n), n = n.next;
  }, A.contains = function(r) {
    var n = this.head;
    if (!this.isLinked(r))
      return !1;
    for (; n !== null; ) {
      if (n === r)
        return !0;
      n = n.next;
    }
    return !1;
  }, A.at = function(r) {
    var n = this.head, i = 0;
    if (r >= this.listLength || r < 0)
      return null;
    for (; n !== null; ) {
      if (r === i)
        return n;
      n = n.next, i += 1;
    }
    return null;
  }, A.insertAfter = function(r, n) {
    return this.isLinked(r) ? (n.prev = r, n.next = r.next, r.next === null ? this.tail = n : r.next.prev = n, r.next = n, this.listSize += 1, this) : this;
  }, A.insertBefore = function(r, n) {
    return this.isLinked(r) ? (n.prev = r.prev, n.next = r, r.prev === null ? this.head = n : r.prev.next = n, r.prev = n, this.listSize += 1, this) : this;
  }, A.push = function(r) {
    return this.head === null ? this.unshift(r) : this.insertAfter(this.tail, r), this;
  }, A.unshift = function(r) {
    return this.head === null ? (this.head = r, this.tail = r, r.prev = null, r.next = null, this.listSize += 1) : this.insertBefore(this.head, r), this;
  }, A.remove = function(r) {
    return this.isLinked(r) ? (r.prev === null ? this.head = r.next : r.prev.next = r.next, r.next === null ? this.tail = r.prev : r.next.prev = r.prev, this.listSize -= 1, this) : this;
  }, A.pop = function() {
    var r = this.tail;
    return this.tail.prev.next = null, this.tail = this.tail.prev, this.listSize -= 1, r.prev = null, r.next = null, r;
  }, A.shift = function() {
    var r = this.head;
    return this.head.next.prev = null, this.head = this.head.next, this.listSize -= 1, r.prev = null, r.next = null, r;
  }, e;
}();
Yc.Node = YK;
/**
 * @param {Object[]} nodes
 * @param {number[]} lines
 * @param {Object} settings
 * @preserve Knuth and Plass line breaking algorithm in JavaScript
 *
 * Licensed under the new BSD License.
 * Copyright 2009-2010, Bram Stein
 * All rights reserved.
 */
var dn = function e(A, t, r) {
  var n = {
    demerits: {
      line: r && r.demerits && r.demerits.line || 10,
      flagged: r && r.demerits && r.demerits.flagged || 100,
      fitness: r && r.demerits && r.demerits.fitness || 3e3
    },
    tolerance: r && r.tolerance || 3
  }, i = new Yc(), a = {
    width: 0,
    stretch: 0,
    shrink: 0
  }, o = t, s = [], l = {
    data: {
      demerits: 1 / 0
    }
  };
  function u(C, E, I, b, y, p, Q) {
    return {
      position: C,
      demerits: E,
      ratio: I,
      line: b,
      fitnessClass: y,
      totals: p || {
        width: 0,
        stretch: 0,
        shrink: 0
      },
      previous: Q
    };
  }
  function g(C, E, I, b) {
    var y = a.width - I.totals.width, p = 0, Q = 0, w = b < o.length ? o[b - 1] : o[o.length - 1];
    return A[E].type === "penalty" && (y += A[E].width), y < w ? (p = a.stretch - I.totals.stretch, p > 0 ? (w - y) / p : e.infinity) : y > w ? (Q = a.shrink - I.totals.shrink, Q > 0 ? (w - y) / Q : e.infinity) : 0;
  }
  function d(C) {
    for (var E = {
      width: a.width,
      stretch: a.stretch,
      shrink: a.shrink
    }, I = C; I < A.length; I += 1)
      if (A[I].type === "glue")
        E.width += A[I].width, E.stretch += A[I].stretch, E.shrink += A[I].shrink;
      else if (A[I].type === "box" || A[I].type === "penalty" && A[I].penalty === -e.infinity && I > C)
        break;
    return E;
  }
  function h(C, E, I) {
    for (var b = i.first(), y = null, p = 0, Q = 0, w = [], Y, k = 0, L, S = 0, P, Z, M; b !== null; ) {
      for (w = [{
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }]; b !== null && (y = b.next, k = b.data.line + 1, p = g(b.data.position, E, b.data, k), (p < -1 || C.type === "penalty" && C.penalty === -e.infinity) && i.remove(b), p >= -1 && p <= n.tolerance && (Y = 100 * Math.pow(Math.abs(p), 3), C.type === "penalty" && C.penalty >= 0 ? Q = Math.pow(n.demerits.line + Y, 2) + Math.pow(C.penalty, 2) : C.type === "penalty" && C.penalty !== -e.infinity ? Q = Math.pow(n.demerits.line + Y, 2) - Math.pow(C.penalty, 2) : Q = Math.pow(n.demerits.line + Y, 2), C.type === "penalty" && I[b.data.position].type === "penalty" && (Q += n.demerits.flagged * C.flagged * I[b.data.position].flagged), p < -0.5 ? S = 0 : p <= 0.5 ? S = 1 : p <= 1 ? S = 2 : S = 3, Math.abs(S - b.data.fitnessClass) > 1 && (Q += n.demerits.fitness), Q += b.data.demerits, Q < w[S].demerits && (w[S] = {
        active: b,
        demerits: Q,
        ratio: p
      })), b = y, !(b !== null && b.data.line >= k)); )
        ;
      for (L = d(E), P = 0; P < w.length; P += 1)
        Z = w[P], Z.demerits < 1 / 0 && (M = new Yc.Node(u(E, Z.demerits, Z.ratio, Z.active.data.line + 1, P, L, Z.active)), b !== null ? i.insertBefore(b, M) : i.push(M));
    }
  }
  if (i.push(new Yc.Node(u(0, 0, 0, 0, 0, void 0, null))), A.forEach(function(C, E, I) {
    C.type === "box" ? a.width += C.width : C.type === "glue" ? (E > 0 && I[E - 1].type === "box" && h(C, E, I), a.width += C.width, a.stretch += C.stretch, a.shrink += C.shrink) : C.type === "penalty" && C.penalty !== e.infinity && h(C, E, I);
  }), i.size() !== 0) {
    for (i.forEach(function(C) {
      C.data.demerits < l.data.demerits && (l = C);
    }); l !== null; )
      s.push({
        position: l.data.position,
        ratio: l.data.ratio
      }), l = l.data.previous;
    return s.reverse();
  }
  return [];
};
dn.infinity = 1e4;
dn.glue = function(e, A, t, r) {
  return {
    type: "glue",
    value: A,
    width: e,
    stretch: t,
    shrink: r
  };
};
dn.box = function(e, A, t) {
  return t === void 0 && (t = !1), {
    type: "box",
    width: e,
    value: A,
    hyphenated: t
  };
};
dn.penalty = function(e, A, t) {
  return {
    type: "penalty",
    width: e,
    penalty: A,
    flagged: t
  };
};
var HK = function(A, t) {
  var r = t.start + A, n = t.end + A;
  return Object.assign({}, t, {
    start: r,
    end: n
  });
}, SK = function(A) {
  return A.end - A.start;
}, NK = function(A, t) {
  var r = A.end + SK(t), n = (A.glyphs || []).concat(t.glyphs || []), i = (A.positions || []).concat(t.positions || []), a = Object.assign({}, A.attributes, t.attributes), o = A.glyphIndices || [], s = ni(o) || 0, l = (t.glyphIndices || []).map(function(g) {
    return g + s + 1;
  }), u = Gv(o.concat(l));
  return Object.assign({}, A, {
    end: r,
    glyphs: n,
    positions: i,
    attributes: a,
    glyphIndices: u
  });
}, TK = function(A, t, r) {
  if (!t) return r;
  var n = Fl(0, A, r), i = Fl(A, 1 / 0, r);
  return NK(Yv(t, n), i);
}, PK = function(A, t, r) {
  var n = GE(r), i = kv(t) ? Uv(t, n) : t;
  return TK(A, i, r);
}, zK = function(A, t) {
  return Th(A, t.runs);
}, jK = function(A, t, r) {
  var n = zK(A, r);
  if (n === -1) return Sv(t, r);
  var i = t.codePoints || [], a = r.string.slice(0, A) + Hv(i) + r.string.slice(A), o = r.runs.map(function(s, l) {
    return l === n ? PK(A - s.start, t, s) : l > n ? HK(i.length, s) : s;
  });
  return Object.assign({}, r, {
    string: a,
    runs: o
  });
}, VK = function(A, t, r) {
  var n = r.start || 0, i = Math.max(0, Eg(A - n, r)), a = Math.max(0, Eg(t - n, r)), o = (r.positions || []).slice(i, a);
  return Jv(o);
}, OK = function(A, t, r) {
  var n = xv(A, t, r.runs);
  return n.reduce(function(i, a) {
    return i + VK(A, t, a);
  }, 0);
}, JK = 45, WK = 5, ZK = 50, rc = {
  width: 3,
  stretch: 6,
  shrink: 9
}, KK = function(A, t, r) {
  var n = 0, i = null, a = r.reduce(function(o, s) {
    var l = t[s.position], u = t[s.position - 1];
    if (s.position === t.length - 1) return o;
    var g;
    return l.type === "penalty" ? (i = u.value.end, g = Jo(n, i, A), g = jK(g.length, JK, g)) : (i = l.value.end, g = Jo(n, i, A)), n = i, [].concat(o, [g]);
  }, []);
  return a.push(Jo(n, A.string.length, A)), a;
}, _K = function(A, t, r) {
  var n = t.align, i = 0, a = 5, o = A.syllables, s = r.hyphenationPenalty || (n === "justify" ? 100 : 600), l = o.reduce(function(u, g, d) {
    var h = OK(i, i + g.length, A);
    if (g.trim() === "") {
      var C = h * rc.width / rc.stretch, E = h * rc.width / rc.shrink, I = {
        start: i,
        end: i + g.length
      };
      u.push(dn.glue(h, I, C, E));
    } else {
      var b = o[d + 1] !== " ", y = {
        start: i,
        end: i + g.length
      };
      u.push(dn.box(h, y, b)), o[d + 1] && b && u.push(dn.penalty(a, s, 1));
    }
    return i += g.length, u;
  }, []);
  return l.push(dn.glue(0, null, dn.infinity, 0)), l.push(dn.penalty(0, -dn.infinity, 1)), l;
}, XK = function(A) {
  var t, r;
  return ((t = A.runs) === null || t === void 0 || (r = t[0]) === null || r === void 0 ? void 0 : r.attributes) || {};
}, Kv = function(A) {
  return function(t, r) {
    for (var n = A.tolerance || 4, i = XK(t), a = _K(t, i, A), o = dn(a, r, {
      tolerance: n
    }); o.length === 0 && n < ZK; )
      n += WK, o = dn(a, r, {
        tolerance: n
      });
    return (o.length === 0 || o.length === 1 && o[0].position === 0) && (o = UK(a, r)), KK(t, a, o.slice(1));
  };
}, _v = 1, Xv = 2, qK = {
  before: 0.5,
  after: 0.5,
  priority: _v,
  unconstrained: !1
}, $K = {
  before: 0.14453125,
  // 37/256
  after: 0.14453125,
  priority: Xv,
  unconstrained: !1
}, A_ = {
  before: -0.04296875,
  // -11/256
  after: -0.04296875,
  priority: _v,
  unconstrained: !1
}, e_ = {
  before: -0.04296875,
  after: -0.04296875,
  priority: Xv,
  unconstrained: !1
}, t_ = function(A, t) {
  var r = t.expandCharFactor || {}, n = t.shrinkCharFactor || {};
  return A === "GROW" ? Object.assign({}, $K, r) : Object.assign({}, e_, n);
}, r_ = function(A, t) {
  var r = t.expandWhitespaceFactor || {}, n = t.shrinkWhitespaceFactor || {};
  return A === "GROW" ? Object.assign({}, qK, r) : Object.assign({}, A_, n);
}, n_ = function(A, t) {
  return function(r) {
    for (var n = t_(A, t), i = r_(A, t), a = [], o = 0; o < r.length; o += 1) {
      var s = void 0, l = r[o];
      UE(l) ? (s = Object.assign({}, i), o === r.length - 1 && (s.before = 0, o > 0 && (a[o - 1].after = 0))) : l.isMark && o > 0 ? (s = Object.assign({}, a[o - 1]), s.before = 0, a[o - 1].after = 0) : s = Object.assign({}, n), a.push(s);
    }
    return a;
  };
}, i_ = function(A, t, r) {
  var n = A > 0 ? "GROW" : "SHRINK", i = n_(n, r), a = t.runs.reduce(function(o, s) {
    return o.concat(i(s.glyphs));
  }, []);
  return a[0].before = 0, a[a.length - 1].after = 0, a;
}, X2 = 0, Od = 3, a_ = function(A, t) {
  for (var r = 0, n = [], i = [], a = X2; a <= Od; a += 1)
    n[a] = i[a] = 0;
  for (var o = 0; o < t.length; o += 1) {
    var s = t[o], l = s.before + s.after;
    r += l, n[s.priority] += l, s.unconstrained && (i[s.priority] += l);
  }
  var u = -1, g = 0, d = A, h;
  for (h = X2; h <= Od; h += 1) {
    var C = n[h];
    if (C !== 0) {
      if (u === -1 && (u = h, g = C), Math.abs(d) <= Math.abs(C)) {
        n[h] = d / C, i[h] = 0, d = 0;
        break;
      }
      if (n[h] = 1, d -= C, i[h] !== 0) {
        i[h] = d / i[h], d = 0;
        break;
      }
    }
  }
  for (var E = h + 1; E <= Od; E += 1)
    n[E] = 0, i[E] = 0;
  d > 0 && u > -1 && (n[u] = (g + (A - r)) / g);
  for (var I = [], b = 0; b < t.length; b += 1) {
    var y = t[b], p = t[b + 1], Q = y.after * n[y.priority];
    p && (Q += p.before * n[p.priority]), y.unconstrained && (Q += y.after * i[y.priority], p && (Q += p.before * i[p.priority])), I.push(Q);
  }
  return I;
}, o_ = function(A, t) {
  for (var r = 0, n = T2(t.runs), i; !(i = n()).done; )
    for (var a = i.value, o = T2(a.positions), s; !(s = o()).done; ) {
      var l = s.value;
      l.xAdvance += A[r++];
    }
  return t;
}, qv = function(A) {
  return function(t) {
    var r = t.box.width - kE(t);
    if (r !== 0) {
      var n = i_(r, t, A), i = a_(r, n);
      return o_(i, t);
    }
  };
}, q2 = function(A) {
  var t = function(n, i) {
    return Math.max(n, IB(i));
  };
  return A.runs.reduce(t, 0);
}, s_ = 12, $v = function() {
  return function(A) {
    var t = A.overflowLeft || 0, r = A.overflowRight || 0, n = kE(A) - r;
    A.decorationLines = [];
    for (var i = 0; i < A.runs.length; i += 1) {
      var a = A.runs[i], o = Math.min(n - t, xE(a)), s = Math.max(0.5, Math.floor(a.attributes.fontSize / s_));
      if (a.attributes.underline) {
        var l = {
          x: t,
          y: q2(A) + s * 2,
          width: o,
          height: s
        }, u = {
          rect: l,
          opacity: a.attributes.opacity,
          color: a.attributes.underlineColor || "black",
          style: a.attributes.underlineStyle || "solid"
        };
        A.decorationLines.push(u);
      }
      if (a.attributes.strike) {
        var g = q2(A) - IB(a) / 3, d = {
          x: t,
          y: g,
          width: o,
          height: s
        }, h = {
          rect: d,
          opacity: a.attributes.opacity,
          color: a.attributes.strikeColor || "black",
          style: a.attributes.strikeStyle || "solid"
        };
        A.decorationLines.push(h);
      }
      t += o;
    }
    return A;
  };
}, l_ = ["Common", "Inherited", "Unknown"], Ay = function() {
  return function(A) {
    var t = A.string, r = "Unknown", n = 0, i = 0, a = [];
    if (!t) return Ov();
    for (var o = 0; o < t.length; o += 1) {
      var s = t[o], l = s.codePointAt(), u = EG.getScript(l);
      u !== r && !l_.includes(u) && (r !== "Unknown" && a.push({
        start: n,
        end: i,
        attributes: {
          script: r
        }
      }), n = i, r = u), i += s.length;
    }
    return n < t.length && a.push({
      start: n,
      end: t.length,
      attributes: {
        script: r
      }
    }), {
      string: t,
      runs: a
    };
  };
}, ey = "­", u_ = qW(tZ), c_ = function(A) {
  return A.split(ey);
}, nc = {}, g_ = function(A) {
  var t = A.includes(ey) ? A : u_(A);
  return c_(t);
}, ty = function() {
  return function(A) {
    var t = "_" + A;
    return yt(A) ? [] : (nc[t] || (nc[t] = g_(A)), nc[t]);
  };
}, Jd = {}, ic = {}, qe = {}, $2;
function ry() {
  if ($2) return qe;
  $2 = 1, Object.defineProperty(qe, "__esModule", {
    value: !0
  }), qe.default = qe.Wrap = qe.Unit = qe.PrintOptions = qe.PositionType = qe.Overflow = qe.NodeType = qe.MeasureMode = qe.LogLevel = qe.Justify = qe.Gutter = qe.FlexDirection = qe.ExperimentalFeature = qe.Errata = qe.Edge = qe.Display = qe.Direction = qe.Dimension = qe.Align = void 0;
  let e = /* @__PURE__ */ function(Q) {
    return Q[Q.Auto = 0] = "Auto", Q[Q.FlexStart = 1] = "FlexStart", Q[Q.Center = 2] = "Center", Q[Q.FlexEnd = 3] = "FlexEnd", Q[Q.Stretch = 4] = "Stretch", Q[Q.Baseline = 5] = "Baseline", Q[Q.SpaceBetween = 6] = "SpaceBetween", Q[Q.SpaceAround = 7] = "SpaceAround", Q;
  }({});
  qe.Align = e;
  let A = /* @__PURE__ */ function(Q) {
    return Q[Q.Width = 0] = "Width", Q[Q.Height = 1] = "Height", Q;
  }({});
  qe.Dimension = A;
  let t = /* @__PURE__ */ function(Q) {
    return Q[Q.Inherit = 0] = "Inherit", Q[Q.LTR = 1] = "LTR", Q[Q.RTL = 2] = "RTL", Q;
  }({});
  qe.Direction = t;
  let r = /* @__PURE__ */ function(Q) {
    return Q[Q.Flex = 0] = "Flex", Q[Q.None = 1] = "None", Q;
  }({});
  qe.Display = r;
  let n = /* @__PURE__ */ function(Q) {
    return Q[Q.Left = 0] = "Left", Q[Q.Top = 1] = "Top", Q[Q.Right = 2] = "Right", Q[Q.Bottom = 3] = "Bottom", Q[Q.Start = 4] = "Start", Q[Q.End = 5] = "End", Q[Q.Horizontal = 6] = "Horizontal", Q[Q.Vertical = 7] = "Vertical", Q[Q.All = 8] = "All", Q;
  }({});
  qe.Edge = n;
  let i = /* @__PURE__ */ function(Q) {
    return Q[Q.None = 0] = "None", Q[Q.StretchFlexBasis = 1] = "StretchFlexBasis", Q[Q.All = 2147483647] = "All", Q[Q.Classic = 2147483646] = "Classic", Q;
  }({});
  qe.Errata = i;
  let a = /* @__PURE__ */ function(Q) {
    return Q[Q.WebFlexBasis = 0] = "WebFlexBasis", Q[Q.AbsolutePercentageAgainstPaddingEdge = 1] = "AbsolutePercentageAgainstPaddingEdge", Q[Q.FixJNILocalRefOverflows = 2] = "FixJNILocalRefOverflows", Q;
  }({});
  qe.ExperimentalFeature = a;
  let o = /* @__PURE__ */ function(Q) {
    return Q[Q.Column = 0] = "Column", Q[Q.ColumnReverse = 1] = "ColumnReverse", Q[Q.Row = 2] = "Row", Q[Q.RowReverse = 3] = "RowReverse", Q;
  }({});
  qe.FlexDirection = o;
  let s = /* @__PURE__ */ function(Q) {
    return Q[Q.Column = 0] = "Column", Q[Q.Row = 1] = "Row", Q[Q.All = 2] = "All", Q;
  }({});
  qe.Gutter = s;
  let l = /* @__PURE__ */ function(Q) {
    return Q[Q.FlexStart = 0] = "FlexStart", Q[Q.Center = 1] = "Center", Q[Q.FlexEnd = 2] = "FlexEnd", Q[Q.SpaceBetween = 3] = "SpaceBetween", Q[Q.SpaceAround = 4] = "SpaceAround", Q[Q.SpaceEvenly = 5] = "SpaceEvenly", Q;
  }({});
  qe.Justify = l;
  let u = /* @__PURE__ */ function(Q) {
    return Q[Q.Error = 0] = "Error", Q[Q.Warn = 1] = "Warn", Q[Q.Info = 2] = "Info", Q[Q.Debug = 3] = "Debug", Q[Q.Verbose = 4] = "Verbose", Q[Q.Fatal = 5] = "Fatal", Q;
  }({});
  qe.LogLevel = u;
  let g = /* @__PURE__ */ function(Q) {
    return Q[Q.Undefined = 0] = "Undefined", Q[Q.Exactly = 1] = "Exactly", Q[Q.AtMost = 2] = "AtMost", Q;
  }({});
  qe.MeasureMode = g;
  let d = /* @__PURE__ */ function(Q) {
    return Q[Q.Default = 0] = "Default", Q[Q.Text = 1] = "Text", Q;
  }({});
  qe.NodeType = d;
  let h = /* @__PURE__ */ function(Q) {
    return Q[Q.Visible = 0] = "Visible", Q[Q.Hidden = 1] = "Hidden", Q[Q.Scroll = 2] = "Scroll", Q;
  }({});
  qe.Overflow = h;
  let C = /* @__PURE__ */ function(Q) {
    return Q[Q.Static = 0] = "Static", Q[Q.Relative = 1] = "Relative", Q[Q.Absolute = 2] = "Absolute", Q;
  }({});
  qe.PositionType = C;
  let E = /* @__PURE__ */ function(Q) {
    return Q[Q.Layout = 1] = "Layout", Q[Q.Style = 2] = "Style", Q[Q.Children = 4] = "Children", Q;
  }({});
  qe.PrintOptions = E;
  let I = /* @__PURE__ */ function(Q) {
    return Q[Q.Undefined = 0] = "Undefined", Q[Q.Point = 1] = "Point", Q[Q.Percent = 2] = "Percent", Q[Q.Auto = 3] = "Auto", Q;
  }({});
  qe.Unit = I;
  let b = /* @__PURE__ */ function(Q) {
    return Q[Q.NoWrap = 0] = "NoWrap", Q[Q.Wrap = 1] = "Wrap", Q[Q.WrapReverse = 2] = "WrapReverse", Q;
  }({});
  qe.Wrap = b;
  var p = {
    ALIGN_AUTO: e.Auto,
    ALIGN_FLEX_START: e.FlexStart,
    ALIGN_CENTER: e.Center,
    ALIGN_FLEX_END: e.FlexEnd,
    ALIGN_STRETCH: e.Stretch,
    ALIGN_BASELINE: e.Baseline,
    ALIGN_SPACE_BETWEEN: e.SpaceBetween,
    ALIGN_SPACE_AROUND: e.SpaceAround,
    DIMENSION_WIDTH: A.Width,
    DIMENSION_HEIGHT: A.Height,
    DIRECTION_INHERIT: t.Inherit,
    DIRECTION_LTR: t.LTR,
    DIRECTION_RTL: t.RTL,
    DISPLAY_FLEX: r.Flex,
    DISPLAY_NONE: r.None,
    EDGE_LEFT: n.Left,
    EDGE_TOP: n.Top,
    EDGE_RIGHT: n.Right,
    EDGE_BOTTOM: n.Bottom,
    EDGE_START: n.Start,
    EDGE_END: n.End,
    EDGE_HORIZONTAL: n.Horizontal,
    EDGE_VERTICAL: n.Vertical,
    EDGE_ALL: n.All,
    ERRATA_NONE: i.None,
    ERRATA_STRETCH_FLEX_BASIS: i.StretchFlexBasis,
    ERRATA_ALL: i.All,
    ERRATA_CLASSIC: i.Classic,
    EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: a.WebFlexBasis,
    EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE: a.AbsolutePercentageAgainstPaddingEdge,
    EXPERIMENTAL_FEATURE_FIX_JNILOCAL_REF_OVERFLOWS: a.FixJNILocalRefOverflows,
    FLEX_DIRECTION_COLUMN: o.Column,
    FLEX_DIRECTION_COLUMN_REVERSE: o.ColumnReverse,
    FLEX_DIRECTION_ROW: o.Row,
    FLEX_DIRECTION_ROW_REVERSE: o.RowReverse,
    GUTTER_COLUMN: s.Column,
    GUTTER_ROW: s.Row,
    GUTTER_ALL: s.All,
    JUSTIFY_FLEX_START: l.FlexStart,
    JUSTIFY_CENTER: l.Center,
    JUSTIFY_FLEX_END: l.FlexEnd,
    JUSTIFY_SPACE_BETWEEN: l.SpaceBetween,
    JUSTIFY_SPACE_AROUND: l.SpaceAround,
    JUSTIFY_SPACE_EVENLY: l.SpaceEvenly,
    LOG_LEVEL_ERROR: u.Error,
    LOG_LEVEL_WARN: u.Warn,
    LOG_LEVEL_INFO: u.Info,
    LOG_LEVEL_DEBUG: u.Debug,
    LOG_LEVEL_VERBOSE: u.Verbose,
    LOG_LEVEL_FATAL: u.Fatal,
    MEASURE_MODE_UNDEFINED: g.Undefined,
    MEASURE_MODE_EXACTLY: g.Exactly,
    MEASURE_MODE_AT_MOST: g.AtMost,
    NODE_TYPE_DEFAULT: d.Default,
    NODE_TYPE_TEXT: d.Text,
    OVERFLOW_VISIBLE: h.Visible,
    OVERFLOW_HIDDEN: h.Hidden,
    OVERFLOW_SCROLL: h.Scroll,
    POSITION_TYPE_STATIC: C.Static,
    POSITION_TYPE_RELATIVE: C.Relative,
    POSITION_TYPE_ABSOLUTE: C.Absolute,
    PRINT_OPTIONS_LAYOUT: E.Layout,
    PRINT_OPTIONS_STYLE: E.Style,
    PRINT_OPTIONS_CHILDREN: E.Children,
    UNIT_UNDEFINED: I.Undefined,
    UNIT_POINT: I.Point,
    UNIT_PERCENT: I.Percent,
    UNIT_AUTO: I.Auto,
    WRAP_NO_WRAP: b.NoWrap,
    WRAP_WRAP: b.Wrap,
    WRAP_WRAP_REVERSE: b.WrapReverse
  };
  return qe.default = p, qe;
}
var AD;
function B_() {
  if (AD) return ic;
  AD = 1, Object.defineProperty(ic, "__esModule", {
    value: !0
  }), ic.default = r;
  var e = t(ry());
  function A(n) {
    if (typeof WeakMap != "function") return null;
    var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (A = function(o) {
      return o ? a : i;
    })(n);
  }
  function t(n, i) {
    if (n && n.__esModule)
      return n;
    if (n === null || typeof n != "object" && typeof n != "function")
      return { default: n };
    var a = A(i);
    if (a && a.has(n))
      return a.get(n);
    var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var l in n)
      if (l !== "default" && Object.prototype.hasOwnProperty.call(n, l)) {
        var u = s ? Object.getOwnPropertyDescriptor(n, l) : null;
        u && (u.get || u.set) ? Object.defineProperty(o, l, u) : o[l] = n[l];
      }
    return o.default = n, a && a.set(n, o), o;
  }
  function r(n) {
    function i(s, l, u) {
      const g = s[l];
      s[l] = function() {
        for (var d = arguments.length, h = new Array(d), C = 0; C < d; C++)
          h[C] = arguments[C];
        return u.call(this, g, ...h);
      };
    }
    for (const s of ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]) {
      const l = {
        [e.Unit.Point]: n.Node.prototype[s],
        [e.Unit.Percent]: n.Node.prototype[`${s}Percent`],
        [e.Unit.Auto]: n.Node.prototype[`${s}Auto`]
      };
      i(n.Node.prototype, s, function(u) {
        for (var g = arguments.length, d = new Array(g > 1 ? g - 1 : 0), h = 1; h < g; h++)
          d[h - 1] = arguments[h];
        const C = d.pop();
        let E, I;
        if (C === "auto")
          E = e.Unit.Auto, I = void 0;
        else if (typeof C == "object")
          E = C.unit, I = C.valueOf();
        else if (E = typeof C == "string" && C.endsWith("%") ? e.Unit.Percent : e.Unit.Point, I = parseFloat(C), !Number.isNaN(C) && Number.isNaN(I))
          throw new Error(`Invalid value ${C} for ${s}`);
        if (!l[E]) throw new Error(`Failed to execute "${s}": Unsupported unit '${C}'`);
        return I !== void 0 ? l[E].call(this, ...d, I) : l[E].call(this, ...d);
      });
    }
    function a(s) {
      return n.MeasureCallback.implement({
        measure: function() {
          const {
            width: l,
            height: u
          } = s(...arguments);
          return {
            width: l ?? NaN,
            height: u ?? NaN
          };
        }
      });
    }
    i(n.Node.prototype, "setMeasureFunc", function(s, l) {
      return l ? s.call(this, a(l)) : this.unsetMeasureFunc();
    });
    function o(s) {
      return n.DirtiedCallback.implement({
        dirtied: s
      });
    }
    return i(n.Node.prototype, "setDirtiedFunc", function(s, l) {
      s.call(this, o(l));
    }), i(n.Config.prototype, "free", function() {
      n.Config.destroy(this);
    }), i(n.Node, "create", (s, l) => l ? n.Node.createWithConfig(l) : n.Node.createDefault()), i(n.Node.prototype, "free", function() {
      n.Node.destroy(this);
    }), i(n.Node.prototype, "freeRecursive", function() {
      for (let s = 0, l = this.getChildCount(); s < l; ++s)
        this.getChild(0).freeRecursive();
      this.free();
    }), i(n.Node.prototype, "calculateLayout", function(s) {
      let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : NaN, g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : e.Direction.LTR;
      return s.call(this, l, u, g);
    }), {
      Config: n.Config,
      Node: n.Node,
      ...e.default
    };
  }
  return ic;
}
var Wd = { exports: {} }, eD;
function f_() {
  return eD || (eD = 1, function(e, A) {
    var t = (() => {
      var r = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(n) {
        n = n || {};
        var i;
        i || (i = typeof n < "u" ? n : {});
        var a, o;
        i.ready = new Promise(function(j, J) {
          a = j, o = J;
        });
        var s = Object.assign({}, i), l = "";
        typeof document < "u" && document.currentScript && (l = document.currentScript.src), r && (l = r), l.indexOf("blob:") !== 0 ? l = l.substr(0, l.replace(/[?#].*/, "").lastIndexOf("/") + 1) : l = "";
        var u = i.print || console.log.bind(console), g = i.printErr || console.warn.bind(console);
        Object.assign(i, s), s = null;
        var d;
        i.wasmBinary && (d = i.wasmBinary), i.noExitRuntime, typeof WebAssembly != "object" && T("no native wasm support detected");
        var h, C = !1;
        function E(j, J, rA) {
          rA = J + rA;
          for (var aA = ""; !(J >= rA); ) {
            var EA = j[J++];
            if (!EA) break;
            if (EA & 128) {
              var FA = j[J++] & 63;
              if ((EA & 224) == 192) aA += String.fromCharCode((EA & 31) << 6 | FA);
              else {
                var TA = j[J++] & 63;
                EA = (EA & 240) == 224 ? (EA & 15) << 12 | FA << 6 | TA : (EA & 7) << 18 | FA << 12 | TA << 6 | j[J++] & 63, 65536 > EA ? aA += String.fromCharCode(EA) : (EA -= 65536, aA += String.fromCharCode(55296 | EA >> 10, 56320 | EA & 1023));
              }
            } else aA += String.fromCharCode(EA);
          }
          return aA;
        }
        var I, b, y, p, Q, w, Y, k, L;
        function S() {
          var j = h.buffer;
          I = j, i.HEAP8 = b = new Int8Array(j), i.HEAP16 = p = new Int16Array(j), i.HEAP32 = w = new Int32Array(j), i.HEAPU8 = y = new Uint8Array(j), i.HEAPU16 = Q = new Uint16Array(j), i.HEAPU32 = Y = new Uint32Array(j), i.HEAPF32 = k = new Float32Array(j), i.HEAPF64 = L = new Float64Array(j);
        }
        var P, Z = [], M = [], R = [];
        function G() {
          var j = i.preRun.shift();
          Z.unshift(j);
        }
        var N = 0, z = null;
        function T(j) {
          throw i.onAbort && i.onAbort(j), j = "Aborted(" + j + ")", g(j), C = !0, j = new WebAssembly.RuntimeError(j + ". Build with -sASSERTIONS for more info."), o(j), j;
        }
        function O(j) {
          return j.startsWith("data:application/octet-stream;base64,");
        }
        var K;
        if (K = "data:application/octet-stream;base64,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", !O(K)) {
          var AA = K;
          K = i.locateFile ? i.locateFile(AA, l) : l + AA;
        }
        function X() {
          var j = K;
          try {
            if (j == K && d) return new Uint8Array(d);
            if (O(j)) try {
              var J = ir(j.slice(37)), rA = new Uint8Array(J.length);
              for (j = 0; j < J.length; ++j) rA[j] = J.charCodeAt(j);
              var aA = rA;
            } catch {
              throw Error("Converting base64 string to bytes failed.");
            }
            else aA = void 0;
            var EA = aA;
            if (EA) return EA;
            throw "both async and sync fetching of the wasm failed";
          } catch (FA) {
            T(FA);
          }
        }
        function iA() {
          return d || typeof fetch != "function" ? Promise.resolve().then(function() {
            return X();
          }) : fetch(K, { credentials: "same-origin" }).then(function(j) {
            if (!j.ok) throw "failed to load wasm binary file at '" + K + "'";
            return j.arrayBuffer();
          }).catch(function() {
            return X();
          });
        }
        function oA(j) {
          for (; 0 < j.length; ) j.shift()(i);
        }
        function fA(j) {
          if (j === void 0) return "_unknown";
          j = j.replace(/[^a-zA-Z0-9_]/g, "$");
          var J = j.charCodeAt(0);
          return 48 <= J && 57 >= J ? "_" + j : j;
        }
        function wA(j, J) {
          return j = fA(j), function() {
            return J.apply(this, arguments);
          };
        }
        var DA = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }], HA = [];
        function sA(j) {
          var J = Error, rA = wA(j, function(aA) {
            this.name = j, this.message = aA, aA = Error(aA).stack, aA !== void 0 && (this.stack = this.toString() + `
` + aA.replace(/^Error(:[^\n]*)?\n/, ""));
          });
          return rA.prototype = Object.create(J.prototype), rA.prototype.constructor = rA, rA.prototype.toString = function() {
            return this.message === void 0 ? this.name : this.name + ": " + this.message;
          }, rA;
        }
        var lA = void 0;
        function tA(j) {
          throw new lA(j);
        }
        var nA = (j) => (j || tA("Cannot use deleted val. handle = " + j), DA[j].value), GA = (j) => {
          switch (j) {
            case void 0:
              return 1;
            case null:
              return 2;
            case !0:
              return 3;
            case !1:
              return 4;
            default:
              var J = HA.length ? HA.pop() : DA.length;
              return DA[J] = { fa: 1, value: j }, J;
          }
        }, ZA = void 0, de = void 0;
        function _A(j) {
          for (var J = ""; y[j]; ) J += de[y[j++]];
          return J;
        }
        var Ce = [];
        function WA() {
          for (; Ce.length; ) {
            var j = Ce.pop();
            j.L.Z = !1, j.delete();
          }
        }
        var gA = void 0, ie = {};
        function Qe(j, J) {
          for (J === void 0 && tA("ptr should not be undefined"); j.P; ) J = j.aa(J), j = j.P;
          return J;
        }
        var OA = {};
        function we(j) {
          j = Pr(j);
          var J = _A(j);
          return jt(j), J;
        }
        function se(j, J) {
          var rA = OA[j];
          return rA === void 0 && tA(J + " has unknown type " + we(j)), rA;
        }
        function ue() {
        }
        var ge = !1;
        function Pe(j) {
          --j.count.value, j.count.value === 0 && (j.S ? j.T.V(j.S) : j.O.M.V(j.N));
        }
        function le(j, J, rA) {
          return J === rA ? j : rA.P === void 0 ? null : (j = le(j, J, rA.P), j === null ? null : rA.ma(j));
        }
        var pe = {};
        function Ze(j, J) {
          return J = Qe(j, J), ie[J];
        }
        var je = void 0;
        function W(j) {
          throw new je(j);
        }
        function yA(j, J) {
          return J.O && J.N || W("makeClassHandle requires ptr and ptrType"), !!J.T != !!J.S && W("Both smartPtrType and smartPtr must be specified"), J.count = { value: 1 }, xA(Object.create(j, { L: { value: J } }));
        }
        function xA(j) {
          return typeof FinalizationRegistry > "u" ? (xA = (J) => J, j) : (ge = new FinalizationRegistry((J) => {
            Pe(J.L);
          }), xA = (J) => {
            var rA = J.L;
            return rA.S && ge.register(J, { L: rA }, J), J;
          }, ue = (J) => {
            ge.unregister(J);
          }, xA(j));
        }
        var SA = {};
        function eA(j) {
          for (; j.length; ) {
            var J = j.pop();
            j.pop()(J);
          }
        }
        function mA(j) {
          return this.fromWireType(w[j >> 2]);
        }
        var H = {}, UA = {};
        function ae(j, J, rA) {
          function aA(qA) {
            qA = rA(qA), qA.length !== j.length && W("Mismatched type converter count");
            for (var te = 0; te < j.length; ++te) CA(j[te], qA[te]);
          }
          j.forEach(function(qA) {
            UA[qA] = J;
          });
          var EA = Array(J.length), FA = [], TA = 0;
          J.forEach((qA, te) => {
            OA.hasOwnProperty(qA) ? EA[te] = OA[qA] : (FA.push(qA), H.hasOwnProperty(qA) || (H[qA] = []), H[qA].push(() => {
              EA[te] = OA[qA], ++TA, TA === FA.length && aA(EA);
            }));
          }), FA.length === 0 && aA(EA);
        }
        function D(j) {
          switch (j) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError("Unknown type size: " + j);
          }
        }
        function CA(j, J, rA = {}) {
          if (!("argPackAdvance" in J)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
          var aA = J.name;
          if (j || tA('type "' + aA + '" must have a positive integer typeid pointer'), OA.hasOwnProperty(j)) {
            if (rA.ta) return;
            tA("Cannot register type '" + aA + "' twice");
          }
          OA[j] = J, delete UA[j], H.hasOwnProperty(j) && (J = H[j], delete H[j], J.forEach((EA) => EA()));
        }
        function IA(j) {
          tA(j.L.O.M.name + " instance already deleted");
        }
        function V() {
        }
        function $(j, J, rA) {
          if (j[J].R === void 0) {
            var aA = j[J];
            j[J] = function() {
              return j[J].R.hasOwnProperty(arguments.length) || tA("Function '" + rA + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + j[J].R + ")!"), j[J].R[arguments.length].apply(this, arguments);
            }, j[J].R = [], j[J].R[aA.Y] = aA;
          }
        }
        function dA(j, J) {
          i.hasOwnProperty(j) ? (tA("Cannot register public name '" + j + "' twice"), $(i, j, j), i.hasOwnProperty(void 0) && tA("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), i[j].R[void 0] = J) : i[j] = J;
        }
        function ce(j, J, rA, aA, EA, FA, TA, qA) {
          this.name = j, this.constructor = J, this.W = rA, this.V = aA, this.P = EA, this.oa = FA, this.aa = TA, this.ma = qA, this.ia = [];
        }
        function NA(j, J, rA) {
          for (; J !== rA; ) J.aa || tA("Expected null or instance of " + rA.name + ", got an instance of " + J.name), j = J.aa(j), J = J.P;
          return j;
        }
        function XA(j, J) {
          return J === null ? (this.da && tA("null is not a valid " + this.name), 0) : (J.L || tA('Cannot pass "' + bA(J) + '" as a ' + this.name), J.L.N || tA("Cannot pass deleted object as a pointer of type " + this.name), NA(J.L.N, J.L.O.M, this.M));
        }
        function ke(j, J) {
          if (J === null) {
            if (this.da && tA("null is not a valid " + this.name), this.ca) {
              var rA = this.ea();
              return j !== null && j.push(this.V, rA), rA;
            }
            return 0;
          }
          if (J.L || tA('Cannot pass "' + bA(J) + '" as a ' + this.name), J.L.N || tA("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && J.L.O.ba && tA("Cannot convert argument of type " + (J.L.T ? J.L.T.name : J.L.O.name) + " to parameter type " + this.name), rA = NA(J.L.N, J.L.O.M, this.M), this.ca) switch (J.L.S === void 0 && tA("Passing raw pointer to smart pointer is illegal"), this.Aa) {
            case 0:
              J.L.T === this ? rA = J.L.S : tA("Cannot convert argument of type " + (J.L.T ? J.L.T.name : J.L.O.name) + " to parameter type " + this.name);
              break;
            case 1:
              rA = J.L.S;
              break;
            case 2:
              if (J.L.T === this) rA = J.L.S;
              else {
                var aA = J.clone();
                rA = this.wa(rA, GA(function() {
                  aA.delete();
                })), j !== null && j.push(this.V, rA);
              }
              break;
            default:
              tA("Unsupporting sharing policy");
          }
          return rA;
        }
        function Ne(j, J) {
          return J === null ? (this.da && tA("null is not a valid " + this.name), 0) : (J.L || tA('Cannot pass "' + bA(J) + '" as a ' + this.name), J.L.N || tA("Cannot pass deleted object as a pointer of type " + this.name), J.L.O.ba && tA("Cannot convert argument of type " + J.L.O.name + " to parameter type " + this.name), NA(J.L.N, J.L.O.M, this.M));
        }
        function Ie(j, J, rA, aA) {
          this.name = j, this.M = J, this.da = rA, this.ba = aA, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, J.P !== void 0 ? this.toWireType = ke : (this.toWireType = aA ? XA : Ne, this.U = null);
        }
        function be(j, J) {
          i.hasOwnProperty(j) || W("Replacing nonexistant public symbol"), i[j] = J, i[j].Y = void 0;
        }
        function Ye(j, J) {
          var rA = [];
          return function() {
            if (rA.length = 0, Object.assign(rA, arguments), j.includes("j")) {
              var aA = i["dynCall_" + j];
              aA = rA && rA.length ? aA.apply(null, [J].concat(rA)) : aA.call(null, J);
            } else aA = P.get(J).apply(null, rA);
            return aA;
          };
        }
        function ye(j, J) {
          j = _A(j);
          var rA = j.includes("j") ? Ye(j, J) : P.get(J);
          return typeof rA != "function" && tA("unknown function pointer with signature " + j + ": " + J), rA;
        }
        var st = void 0;
        function Ut(j, J) {
          function rA(FA) {
            EA[FA] || OA[FA] || (UA[FA] ? UA[FA].forEach(rA) : (aA.push(FA), EA[FA] = !0));
          }
          var aA = [], EA = {};
          throw J.forEach(rA), new st(j + ": " + aA.map(we).join([", "]));
        }
        function gt(j, J, rA, aA, EA) {
          var FA = J.length;
          2 > FA && tA("argTypes array size mismatch! Must at least get return value and 'this' types!");
          var TA = J[1] !== null && rA !== null, qA = !1;
          for (rA = 1; rA < J.length; ++rA) if (J[rA] !== null && J[rA].U === void 0) {
            qA = !0;
            break;
          }
          var te = J[0].name !== "void", ee = FA - 2, Be = Array(ee), De = [], Xe = [];
          return function() {
            if (arguments.length !== ee && tA("function " + j + " called with " + arguments.length + " arguments, expected " + ee + " args!"), Xe.length = 0, De.length = TA ? 2 : 1, De[0] = EA, TA) {
              var Ft = J[1].toWireType(Xe, this);
              De[1] = Ft;
            }
            for (var tt = 0; tt < ee; ++tt) Be[tt] = J[tt + 2].toWireType(Xe, arguments[tt]), De.push(Be[tt]);
            if (tt = aA.apply(null, De), qA) eA(Xe);
            else for (var er = TA ? 1 : 2; er < J.length; er++) {
              var ar = er === 1 ? Ft : Be[er - 2];
              J[er].U !== null && J[er].U(ar);
            }
            return Ft = te ? J[0].fromWireType(tt) : void 0, Ft;
          };
        }
        function Ke(j, J) {
          for (var rA = [], aA = 0; aA < j; aA++) rA.push(Y[J + 4 * aA >> 2]);
          return rA;
        }
        function q(j) {
          4 < j && --DA[j].fa === 0 && (DA[j] = void 0, HA.push(j));
        }
        function bA(j) {
          if (j === null) return "null";
          var J = typeof j;
          return J === "object" || J === "array" || J === "function" ? j.toString() : "" + j;
        }
        function $A(j, J) {
          switch (J) {
            case 2:
              return function(rA) {
                return this.fromWireType(k[rA >> 2]);
              };
            case 3:
              return function(rA) {
                return this.fromWireType(L[rA >> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + j);
          }
        }
        function Ee(j, J, rA) {
          switch (J) {
            case 0:
              return rA ? function(aA) {
                return b[aA];
              } : function(aA) {
                return y[aA];
              };
            case 1:
              return rA ? function(aA) {
                return p[aA >> 1];
              } : function(aA) {
                return Q[aA >> 1];
              };
            case 2:
              return rA ? function(aA) {
                return w[aA >> 2];
              } : function(aA) {
                return Y[aA >> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + j);
          }
        }
        function Ve(j, J) {
          for (var rA = "", aA = 0; !(aA >= J / 2); ++aA) {
            var EA = p[j + 2 * aA >> 1];
            if (EA == 0) break;
            rA += String.fromCharCode(EA);
          }
          return rA;
        }
        function _e(j, J, rA) {
          if (rA === void 0 && (rA = 2147483647), 2 > rA) return 0;
          rA -= 2;
          var aA = J;
          rA = rA < 2 * j.length ? rA / 2 : j.length;
          for (var EA = 0; EA < rA; ++EA) p[J >> 1] = j.charCodeAt(EA), J += 2;
          return p[J >> 1] = 0, J - aA;
        }
        function ve(j) {
          return 2 * j.length;
        }
        function Fe(j, J) {
          for (var rA = 0, aA = ""; !(rA >= J / 4); ) {
            var EA = w[j + 4 * rA >> 2];
            if (EA == 0) break;
            ++rA, 65536 <= EA ? (EA -= 65536, aA += String.fromCharCode(55296 | EA >> 10, 56320 | EA & 1023)) : aA += String.fromCharCode(EA);
          }
          return aA;
        }
        function Ct(j, J, rA) {
          if (rA === void 0 && (rA = 2147483647), 4 > rA) return 0;
          var aA = J;
          rA = aA + rA - 4;
          for (var EA = 0; EA < j.length; ++EA) {
            var FA = j.charCodeAt(EA);
            if (55296 <= FA && 57343 >= FA) {
              var TA = j.charCodeAt(++EA);
              FA = 65536 + ((FA & 1023) << 10) | TA & 1023;
            }
            if (w[J >> 2] = FA, J += 4, J + 4 > rA) break;
          }
          return w[J >> 2] = 0, J - aA;
        }
        function et(j) {
          for (var J = 0, rA = 0; rA < j.length; ++rA) {
            var aA = j.charCodeAt(rA);
            55296 <= aA && 57343 >= aA && ++rA, J += 4;
          }
          return J;
        }
        var pA = {};
        function VA(j) {
          var J = pA[j];
          return J === void 0 ? _A(j) : J;
        }
        var YA = [];
        function ze(j) {
          var J = YA.length;
          return YA.push(j), J;
        }
        function Oe(j, J) {
          for (var rA = Array(j), aA = 0; aA < j; ++aA) rA[aA] = se(Y[J + 4 * aA >> 2], "parameter " + aA);
          return rA;
        }
        var lt = [], St = [null, [], []];
        lA = i.BindingError = sA("BindingError"), i.count_emval_handles = function() {
          for (var j = 0, J = 5; J < DA.length; ++J) DA[J] !== void 0 && ++j;
          return j;
        }, i.get_first_emval = function() {
          for (var j = 5; j < DA.length; ++j) if (DA[j] !== void 0) return DA[j];
          return null;
        }, ZA = i.PureVirtualError = sA("PureVirtualError");
        for (var Ar = Array(256), bt = 0; 256 > bt; ++bt) Ar[bt] = String.fromCharCode(bt);
        de = Ar, i.getInheritedInstanceCount = function() {
          return Object.keys(ie).length;
        }, i.getLiveInheritedInstances = function() {
          var j = [], J;
          for (J in ie) ie.hasOwnProperty(J) && j.push(ie[J]);
          return j;
        }, i.flushPendingDeletes = WA, i.setDelayFunction = function(j) {
          gA = j, Ce.length && gA && gA(WA);
        }, je = i.InternalError = sA("InternalError"), V.prototype.isAliasOf = function(j) {
          if (!(this instanceof V && j instanceof V)) return !1;
          var J = this.L.O.M, rA = this.L.N, aA = j.L.O.M;
          for (j = j.L.N; J.P; ) rA = J.aa(rA), J = J.P;
          for (; aA.P; ) j = aA.aa(j), aA = aA.P;
          return J === aA && rA === j;
        }, V.prototype.clone = function() {
          if (this.L.N || IA(this), this.L.$) return this.L.count.value += 1, this;
          var j = xA, J = Object, rA = J.create, aA = Object.getPrototypeOf(this), EA = this.L;
          return j = j(rA.call(J, aA, { L: { value: { count: EA.count, Z: EA.Z, $: EA.$, N: EA.N, O: EA.O, S: EA.S, T: EA.T } } })), j.L.count.value += 1, j.L.Z = !1, j;
        }, V.prototype.delete = function() {
          this.L.N || IA(this), this.L.Z && !this.L.$ && tA("Object already scheduled for deletion"), ue(this), Pe(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
        }, V.prototype.isDeleted = function() {
          return !this.L.N;
        }, V.prototype.deleteLater = function() {
          return this.L.N || IA(this), this.L.Z && !this.L.$ && tA("Object already scheduled for deletion"), Ce.push(this), Ce.length === 1 && gA && gA(WA), this.L.Z = !0, this;
        }, Ie.prototype.pa = function(j) {
          return this.ja && (j = this.ja(j)), j;
        }, Ie.prototype.ga = function(j) {
          this.V && this.V(j);
        }, Ie.prototype.argPackAdvance = 8, Ie.prototype.readValueFromPointer = mA, Ie.prototype.deleteObject = function(j) {
          j !== null && j.delete();
        }, Ie.prototype.fromWireType = function(j) {
          function J() {
            return this.ca ? yA(this.M.W, { O: this.va, N: rA, T: this, S: j }) : yA(this.M.W, { O: this, N: j });
          }
          var rA = this.pa(j);
          if (!rA) return this.ga(j), null;
          var aA = Ze(this.M, rA);
          if (aA !== void 0)
            return aA.L.count.value === 0 ? (aA.L.N = rA, aA.L.S = j, aA.clone()) : (aA = aA.clone(), this.ga(j), aA);
          if (aA = this.M.oa(rA), aA = pe[aA], !aA) return J.call(this);
          aA = this.ba ? aA.ka : aA.pointerType;
          var EA = le(rA, this.M, aA.M);
          return EA === null ? J.call(this) : this.ca ? yA(aA.M.W, { O: aA, N: EA, T: this, S: j }) : yA(aA.M.W, { O: aA, N: EA });
        }, st = i.UnboundTypeError = sA("UnboundTypeError");
        var ir = typeof atob == "function" ? atob : function(j) {
          var J = "", rA = 0;
          j = j.replace(/[^A-Za-z0-9\+\/=]/g, "");
          do {
            var aA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(j.charAt(rA++)), EA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(j.charAt(rA++)), FA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(j.charAt(rA++)), TA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(j.charAt(rA++));
            aA = aA << 2 | EA >> 4, EA = (EA & 15) << 4 | FA >> 2;
            var qA = (FA & 3) << 6 | TA;
            J += String.fromCharCode(aA), FA !== 64 && (J += String.fromCharCode(EA)), TA !== 64 && (J += String.fromCharCode(qA));
          } while (rA < j.length);
          return J;
        }, Gr = {
          p: function(j, J, rA) {
            j = _A(j), J = se(J, "wrapper"), rA = nA(rA);
            var aA = [].slice, EA = J.M, FA = EA.W, TA = EA.P.W, qA = EA.P.constructor;
            j = wA(j, function() {
              EA.P.ia.forEach((function(ee) {
                if (this[ee] === TA[ee]) throw new ZA("Pure virtual function " + ee + " must be implemented in JavaScript");
              }).bind(this)), Object.defineProperty(this, "__parent", { value: FA }), this.__construct.apply(this, aA.call(arguments));
            }), FA.__construct = function() {
              this === FA && tA("Pass correct 'this' to __construct");
              var ee = qA.implement.apply(void 0, [this].concat(aA.call(arguments)));
              ue(ee);
              var Be = ee.L;
              ee.notifyOnDestruction(), Be.$ = !0, Object.defineProperties(this, { L: { value: Be } }), xA(this), ee = Be.N, ee = Qe(EA, ee), ie.hasOwnProperty(ee) ? tA("Tried to register registered instance: " + ee) : ie[ee] = this;
            }, FA.__destruct = function() {
              this === FA && tA("Pass correct 'this' to __destruct"), ue(this);
              var ee = this.L.N;
              ee = Qe(EA, ee), ie.hasOwnProperty(ee) ? delete ie[ee] : tA("Tried to unregister unregistered instance: " + ee);
            }, j.prototype = Object.create(FA);
            for (var te in rA) j.prototype[te] = rA[te];
            return GA(j);
          },
          j: function(j) {
            var J = SA[j];
            delete SA[j];
            var rA = J.ea, aA = J.V, EA = J.ha, FA = EA.map((TA) => TA.sa).concat(EA.map((TA) => TA.ya));
            ae([j], FA, (TA) => {
              var qA = {};
              return EA.forEach((te, ee) => {
                var Be = TA[ee], De = te.qa, Xe = te.ra, Ft = TA[ee + EA.length], tt = te.xa, er = te.za;
                qA[te.na] = { read: (ar) => Be.fromWireType(De(Xe, ar)), write: (ar, zr) => {
                  var yr = [];
                  tt(er, ar, Ft.toWireType(yr, zr)), eA(yr);
                } };
              }), [{ name: J.name, fromWireType: function(te) {
                var ee = {}, Be;
                for (Be in qA) ee[Be] = qA[Be].read(te);
                return aA(te), ee;
              }, toWireType: function(te, ee) {
                for (var Be in qA) if (!(Be in ee)) throw new TypeError('Missing field:  "' + Be + '"');
                var De = rA();
                for (Be in qA) qA[Be].write(De, ee[Be]);
                return te !== null && te.push(aA, De), De;
              }, argPackAdvance: 8, readValueFromPointer: mA, U: aA }];
            });
          },
          v: function() {
          },
          B: function(j, J, rA, aA, EA) {
            var FA = D(rA);
            J = _A(J), CA(j, { name: J, fromWireType: function(TA) {
              return !!TA;
            }, toWireType: function(TA, qA) {
              return qA ? aA : EA;
            }, argPackAdvance: 8, readValueFromPointer: function(TA) {
              if (rA === 1) var qA = b;
              else if (rA === 2) qA = p;
              else if (rA === 4) qA = w;
              else throw new TypeError("Unknown boolean type size: " + J);
              return this.fromWireType(qA[TA >> FA]);
            }, U: null });
          },
          f: function(j, J, rA, aA, EA, FA, TA, qA, te, ee, Be, De, Xe) {
            Be = _A(Be), FA = ye(EA, FA), qA && (qA = ye(TA, qA)), ee && (ee = ye(te, ee)), Xe = ye(De, Xe);
            var Ft = fA(Be);
            dA(Ft, function() {
              Ut("Cannot construct " + Be + " due to unbound types", [aA]);
            }), ae([j, J, rA], aA ? [aA] : [], function(tt) {
              if (tt = tt[0], aA)
                var er = tt.M, ar = er.W;
              else ar = V.prototype;
              tt = wA(Ft, function() {
                if (Object.getPrototypeOf(this) !== zr) throw new lA("Use 'new' to construct " + Be);
                if (yr.X === void 0) throw new lA(Be + " has no accessible constructor");
                var br = yr.X[arguments.length];
                if (br === void 0) throw new lA("Tried to invoke ctor of " + Be + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(yr.X).toString() + ") parameters instead!");
                return br.apply(this, arguments);
              });
              var zr = Object.create(ar, { constructor: { value: tt } });
              tt.prototype = zr;
              var yr = new ce(Be, tt, zr, Xe, er, FA, qA, ee);
              er = new Ie(Be, yr, !0, !1), ar = new Ie(Be + "*", yr, !1, !1);
              var o0 = new Ie(Be + " const*", yr, !1, !0);
              return pe[j] = { pointerType: ar, ka: o0 }, be(Ft, tt), [er, ar, o0];
            });
          },
          c: function(j, J, rA, aA, EA, FA, TA) {
            var qA = Ke(rA, aA);
            J = _A(J), FA = ye(EA, FA), ae([], [j], function(te) {
              function ee() {
                Ut("Cannot call " + Be + " due to unbound types", qA);
              }
              te = te[0];
              var Be = te.name + "." + J;
              J.startsWith("@@") && (J = Symbol[J.substring(2)]);
              var De = te.M.constructor;
              return De[J] === void 0 ? (ee.Y = rA - 1, De[J] = ee) : ($(De, J, Be), De[J].R[rA - 1] = ee), ae([], qA, function(Xe) {
                return Xe = gt(Be, [Xe[0], null].concat(Xe.slice(1)), null, FA, TA), De[J].R === void 0 ? (Xe.Y = rA - 1, De[J] = Xe) : De[J].R[rA - 1] = Xe, [];
              }), [];
            });
          },
          o: function(j, J, rA, aA, EA, FA) {
            0 < J || T();
            var TA = Ke(J, rA);
            EA = ye(aA, EA), ae([], [j], function(qA) {
              qA = qA[0];
              var te = "constructor " + qA.name;
              if (qA.M.X === void 0 && (qA.M.X = []), qA.M.X[J - 1] !== void 0) throw new lA("Cannot register multiple constructors with identical number of parameters (" + (J - 1) + ") for class '" + qA.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
              return qA.M.X[J - 1] = () => {
                Ut("Cannot construct " + qA.name + " due to unbound types", TA);
              }, ae([], TA, function(ee) {
                return ee.splice(1, 0, null), qA.M.X[J - 1] = gt(te, ee, null, EA, FA), [];
              }), [];
            });
          },
          a: function(j, J, rA, aA, EA, FA, TA, qA) {
            var te = Ke(rA, aA);
            J = _A(J), FA = ye(EA, FA), ae([], [j], function(ee) {
              function Be() {
                Ut("Cannot call " + De + " due to unbound types", te);
              }
              ee = ee[0];
              var De = ee.name + "." + J;
              J.startsWith("@@") && (J = Symbol[J.substring(2)]), qA && ee.M.ia.push(J);
              var Xe = ee.M.W, Ft = Xe[J];
              return Ft === void 0 || Ft.R === void 0 && Ft.className !== ee.name && Ft.Y === rA - 2 ? (Be.Y = rA - 2, Be.className = ee.name, Xe[J] = Be) : ($(Xe, J, De), Xe[J].R[rA - 2] = Be), ae([], te, function(tt) {
                return tt = gt(De, tt, ee, FA, TA), Xe[J].R === void 0 ? (tt.Y = rA - 2, Xe[J] = tt) : Xe[J].R[rA - 2] = tt, [];
              }), [];
            });
          },
          A: function(j, J) {
            J = _A(J), CA(j, { name: J, fromWireType: function(rA) {
              var aA = nA(rA);
              return q(rA), aA;
            }, toWireType: function(rA, aA) {
              return GA(aA);
            }, argPackAdvance: 8, readValueFromPointer: mA, U: null });
          },
          m: function(j, J, rA) {
            rA = D(rA), J = _A(J), CA(j, {
              name: J,
              fromWireType: function(aA) {
                return aA;
              },
              toWireType: function(aA, EA) {
                return EA;
              },
              argPackAdvance: 8,
              readValueFromPointer: $A(J, rA),
              U: null
            });
          },
          d: function(j, J, rA, aA, EA) {
            J = _A(J), EA === -1 && (EA = 4294967295), EA = D(rA);
            var FA = (qA) => qA;
            if (aA === 0) {
              var TA = 32 - 8 * rA;
              FA = (qA) => qA << TA >>> TA;
            }
            rA = J.includes("unsigned") ? function(qA, te) {
              return te >>> 0;
            } : function(qA, te) {
              return te;
            }, CA(j, { name: J, fromWireType: FA, toWireType: rA, argPackAdvance: 8, readValueFromPointer: Ee(J, EA, aA !== 0), U: null });
          },
          b: function(j, J, rA) {
            function aA(FA) {
              FA >>= 2;
              var TA = Y;
              return new EA(I, TA[FA + 1], TA[FA]);
            }
            var EA = [
              Int8Array,
              Uint8Array,
              Int16Array,
              Uint16Array,
              Int32Array,
              Uint32Array,
              Float32Array,
              Float64Array
            ][J];
            rA = _A(rA), CA(j, { name: rA, fromWireType: aA, argPackAdvance: 8, readValueFromPointer: aA }, { ta: !0 });
          },
          n: function(j, J) {
            J = _A(J);
            var rA = J === "std::string";
            CA(j, { name: J, fromWireType: function(aA) {
              var EA = Y[aA >> 2], FA = aA + 4;
              if (rA) for (var TA = FA, qA = 0; qA <= EA; ++qA) {
                var te = FA + qA;
                if (qA == EA || y[te] == 0) {
                  if (TA = TA ? E(y, TA, te - TA) : "", ee === void 0) var ee = TA;
                  else ee += "\0", ee += TA;
                  TA = te + 1;
                }
              }
              else {
                for (ee = Array(EA), qA = 0; qA < EA; ++qA) ee[qA] = String.fromCharCode(y[FA + qA]);
                ee = ee.join("");
              }
              return jt(aA), ee;
            }, toWireType: function(aA, EA) {
              EA instanceof ArrayBuffer && (EA = new Uint8Array(EA));
              var FA, TA = typeof EA == "string";
              if (TA || EA instanceof Uint8Array || EA instanceof Uint8ClampedArray || EA instanceof Int8Array || tA("Cannot pass non-string to std::string"), rA && TA) {
                var qA = 0;
                for (FA = 0; FA < EA.length; ++FA) {
                  var te = EA.charCodeAt(FA);
                  127 >= te ? qA++ : 2047 >= te ? qA += 2 : 55296 <= te && 57343 >= te ? (qA += 4, ++FA) : qA += 3;
                }
                FA = qA;
              } else FA = EA.length;
              if (qA = Yn(4 + FA + 1), te = qA + 4, Y[qA >> 2] = FA, rA && TA) {
                if (TA = te, te = FA + 1, FA = y, 0 < te) {
                  te = TA + te - 1;
                  for (var ee = 0; ee < EA.length; ++ee) {
                    var Be = EA.charCodeAt(ee);
                    if (55296 <= Be && 57343 >= Be) {
                      var De = EA.charCodeAt(++ee);
                      Be = 65536 + ((Be & 1023) << 10) | De & 1023;
                    }
                    if (127 >= Be) {
                      if (TA >= te) break;
                      FA[TA++] = Be;
                    } else {
                      if (2047 >= Be) {
                        if (TA + 1 >= te) break;
                        FA[TA++] = 192 | Be >> 6;
                      } else {
                        if (65535 >= Be) {
                          if (TA + 2 >= te) break;
                          FA[TA++] = 224 | Be >> 12;
                        } else {
                          if (TA + 3 >= te) break;
                          FA[TA++] = 240 | Be >> 18, FA[TA++] = 128 | Be >> 12 & 63;
                        }
                        FA[TA++] = 128 | Be >> 6 & 63;
                      }
                      FA[TA++] = 128 | Be & 63;
                    }
                  }
                  FA[TA] = 0;
                }
              } else if (TA) for (TA = 0; TA < FA; ++TA) ee = EA.charCodeAt(TA), 255 < ee && (jt(te), tA("String has UTF-16 code units that do not fit in 8 bits")), y[te + TA] = ee;
              else for (TA = 0; TA < FA; ++TA) y[te + TA] = EA[TA];
              return aA !== null && aA.push(jt, qA), qA;
            }, argPackAdvance: 8, readValueFromPointer: mA, U: function(aA) {
              jt(aA);
            } });
          },
          i: function(j, J, rA) {
            if (rA = _A(rA), J === 2)
              var aA = Ve, EA = _e, FA = ve, TA = () => Q, qA = 1;
            else J === 4 && (aA = Fe, EA = Ct, FA = et, TA = () => Y, qA = 2);
            CA(j, {
              name: rA,
              fromWireType: function(te) {
                for (var ee = Y[te >> 2], Be = TA(), De, Xe = te + 4, Ft = 0; Ft <= ee; ++Ft) {
                  var tt = te + 4 + Ft * J;
                  (Ft == ee || Be[tt >> qA] == 0) && (Xe = aA(Xe, tt - Xe), De === void 0 ? De = Xe : (De += "\0", De += Xe), Xe = tt + J);
                }
                return jt(te), De;
              },
              toWireType: function(te, ee) {
                typeof ee != "string" && tA("Cannot pass non-string to C++ string type " + rA);
                var Be = FA(ee), De = Yn(4 + Be + J);
                return Y[De >> 2] = Be >> qA, EA(ee, De + 4, Be + J), te !== null && te.push(jt, De), De;
              },
              argPackAdvance: 8,
              readValueFromPointer: mA,
              U: function(te) {
                jt(te);
              }
            });
          },
          k: function(j, J, rA, aA, EA, FA) {
            SA[j] = { name: _A(J), ea: ye(rA, aA), V: ye(EA, FA), ha: [] };
          },
          h: function(j, J, rA, aA, EA, FA, TA, qA, te, ee) {
            SA[j].ha.push({ na: _A(J), sa: rA, qa: ye(aA, EA), ra: FA, ya: TA, xa: ye(qA, te), za: ee });
          },
          C: function(j, J) {
            J = _A(J), CA(j, { ua: !0, name: J, argPackAdvance: 0, fromWireType: function() {
            }, toWireType: function() {
            } });
          },
          s: function(j, J, rA, aA, EA) {
            j = YA[j], J = nA(J), rA = VA(rA);
            var FA = [];
            return Y[aA >> 2] = GA(FA), j(J, rA, FA, EA);
          },
          t: function(j, J, rA, aA) {
            j = YA[j], J = nA(J), rA = VA(rA), j(J, rA, null, aA);
          },
          g: q,
          l: function(j, J) {
            var rA = Oe(j, J), aA = rA[0];
            J = aA.name + "_$" + rA.slice(1).map(function(TA) {
              return TA.name;
            }).join("_") + "$";
            var EA = lt[J];
            if (EA !== void 0) return EA;
            var FA = Array(j - 1);
            return EA = ze((TA, qA, te, ee) => {
              for (var Be = 0, De = 0; De < j - 1; ++De) FA[De] = rA[De + 1].readValueFromPointer(ee + Be), Be += rA[De + 1].argPackAdvance;
              for (TA = TA[qA].apply(TA, FA), De = 0; De < j - 1; ++De) rA[De + 1].la && rA[De + 1].la(FA[De]);
              if (!aA.ua) return aA.toWireType(te, TA);
            }), lt[J] = EA;
          },
          q: function(j) {
            4 < j && (DA[j].fa += 1);
          },
          r: function(j) {
            var J = nA(j);
            eA(J), q(j);
          },
          e: function() {
            T("");
          },
          x: function(j, J, rA) {
            y.copyWithin(j, J, J + rA);
          },
          w: function(j) {
            var J = y.length;
            if (j >>>= 0, 2147483648 < j) return !1;
            for (var rA = 1; 4 >= rA; rA *= 2) {
              var aA = J * (1 + 0.2 / rA);
              aA = Math.min(aA, j + 100663296);
              var EA = Math;
              aA = Math.max(j, aA), EA = EA.min.call(EA, 2147483648, aA + (65536 - aA % 65536) % 65536);
              A: {
                try {
                  h.grow(EA - I.byteLength + 65535 >>> 16), S();
                  var FA = 1;
                  break A;
                } catch {
                }
                FA = void 0;
              }
              if (FA) return !0;
            }
            return !1;
          },
          z: function() {
            return 52;
          },
          u: function() {
            return 70;
          },
          y: function(j, J, rA, aA) {
            for (var EA = 0, FA = 0; FA < rA; FA++) {
              var TA = Y[J >> 2], qA = Y[J + 4 >> 2];
              J += 8;
              for (var te = 0; te < qA; te++) {
                var ee = y[TA + te], Be = St[j];
                ee === 0 || ee === 10 ? ((j === 1 ? u : g)(E(Be, 0)), Be.length = 0) : Be.push(ee);
              }
              EA += qA;
            }
            return Y[aA >> 2] = EA, 0;
          }
        };
        (function() {
          function j(EA) {
            i.asm = EA.exports, h = i.asm.D, S(), P = i.asm.I, M.unshift(i.asm.E), N--, i.monitorRunDependencies && i.monitorRunDependencies(N), N == 0 && z && (EA = z, z = null, EA());
          }
          function J(EA) {
            j(EA.instance);
          }
          function rA(EA) {
            return iA().then(function(FA) {
              return WebAssembly.instantiate(FA, aA);
            }).then(function(FA) {
              return FA;
            }).then(EA, function(FA) {
              g("failed to asynchronously prepare wasm: " + FA), T(FA);
            });
          }
          var aA = { a: Gr };
          if (N++, i.monitorRunDependencies && i.monitorRunDependencies(N), i.instantiateWasm) try {
            return i.instantiateWasm(
              aA,
              j
            );
          } catch (EA) {
            g("Module.instantiateWasm callback failed with error: " + EA), o(EA);
          }
          return function() {
            return d || typeof WebAssembly.instantiateStreaming != "function" || O(K) || typeof fetch != "function" ? rA(J) : fetch(K, { credentials: "same-origin" }).then(function(EA) {
              return WebAssembly.instantiateStreaming(EA, aA).then(J, function(FA) {
                return g("wasm streaming compile failed: " + FA), g("falling back to ArrayBuffer instantiation"), rA(J);
              });
            });
          }().catch(o), {};
        })(), i.___wasm_call_ctors = function() {
          return (i.___wasm_call_ctors = i.asm.E).apply(null, arguments);
        };
        var Pr = i.___getTypeName = function() {
          return (Pr = i.___getTypeName = i.asm.F).apply(null, arguments);
        };
        i.__embind_initialize_bindings = function() {
          return (i.__embind_initialize_bindings = i.asm.G).apply(null, arguments);
        };
        var Yn = i._malloc = function() {
          return (Yn = i._malloc = i.asm.H).apply(null, arguments);
        }, jt = i._free = function() {
          return (jt = i._free = i.asm.J).apply(null, arguments);
        };
        i.dynCall_jiji = function() {
          return (i.dynCall_jiji = i.asm.K).apply(null, arguments);
        };
        var In;
        z = function j() {
          In || ci(), In || (z = j);
        };
        function ci() {
          function j() {
            if (!In && (In = !0, i.calledRun = !0, !C)) {
              if (oA(M), a(i), i.onRuntimeInitialized && i.onRuntimeInitialized(), i.postRun) for (typeof i.postRun == "function" && (i.postRun = [i.postRun]); i.postRun.length; ) {
                var J = i.postRun.shift();
                R.unshift(J);
              }
              oA(R);
            }
          }
          if (!(0 < N)) {
            if (i.preRun) for (typeof i.preRun == "function" && (i.preRun = [i.preRun]); i.preRun.length; ) G();
            oA(Z), 0 < N || (i.setStatus ? (i.setStatus("Running..."), setTimeout(function() {
              setTimeout(function() {
                i.setStatus("");
              }, 1), j();
            }, 1)) : j());
          }
        }
        if (i.preInit) for (typeof i.preInit == "function" && (i.preInit = [i.preInit]); 0 < i.preInit.length; ) i.preInit.pop()();
        return ci(), n.ready;
      };
    })();
    e.exports = t;
  }(Wd)), Wd.exports;
}
var tD;
function d_() {
  return tD || (tD = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var A = {
      loadYoga: !0
    };
    e.loadYoga = a;
    var t = n(B_()), r = ry();
    Object.keys(r).forEach(function(o) {
      o === "default" || o === "__esModule" || Object.prototype.hasOwnProperty.call(A, o) || o in e && e[o] === r[o] || Object.defineProperty(e, o, {
        enumerable: !0,
        get: function() {
          return r[o];
        }
      });
    });
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    const i = f_();
    async function a() {
      return (0, t.default)(await i());
    }
  }(Jd)), Jd;
}
var he = d_();
const h_ = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC2\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
var rD = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, M0 = [], Ln = [], C_ = typeof Uint8Array < "u" ? Uint8Array : Array, YE = !1;
function ny() {
  YE = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", A = 0, t = e.length; A < t; ++A)
    M0[A] = e[A], Ln[e.charCodeAt(A)] = A;
  Ln[45] = 62, Ln[95] = 63;
}
function E_(e) {
  YE || ny();
  var A, t, r, n, i, a, o = e.length;
  if (o % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  i = e[o - 2] === "=" ? 2 : e[o - 1] === "=" ? 1 : 0, a = new C_(o * 3 / 4 - i), r = i > 0 ? o - 4 : o;
  var s = 0;
  for (A = 0, t = 0; A < r; A += 4, t += 3)
    n = Ln[e.charCodeAt(A)] << 18 | Ln[e.charCodeAt(A + 1)] << 12 | Ln[e.charCodeAt(A + 2)] << 6 | Ln[e.charCodeAt(A + 3)], a[s++] = n >> 16 & 255, a[s++] = n >> 8 & 255, a[s++] = n & 255;
  return i === 2 ? (n = Ln[e.charCodeAt(A)] << 2 | Ln[e.charCodeAt(A + 1)] >> 4, a[s++] = n & 255) : i === 1 && (n = Ln[e.charCodeAt(A)] << 10 | Ln[e.charCodeAt(A + 1)] << 4 | Ln[e.charCodeAt(A + 2)] >> 2, a[s++] = n >> 8 & 255, a[s++] = n & 255), a;
}
function Q_(e) {
  return M0[e >> 18 & 63] + M0[e >> 12 & 63] + M0[e >> 6 & 63] + M0[e & 63];
}
function w_(e, A, t) {
  for (var r, n = [], i = A; i < t; i += 3)
    r = (e[i] << 16) + (e[i + 1] << 8) + e[i + 2], n.push(Q_(r));
  return n.join("");
}
function nD(e) {
  YE || ny();
  for (var A, t = e.length, r = t % 3, n = "", i = [], a = 16383, o = 0, s = t - r; o < s; o += a)
    i.push(w_(e, o, o + a > s ? s : o + a));
  return r === 1 ? (A = e[t - 1], n += M0[A >> 2], n += M0[A << 4 & 63], n += "==") : r === 2 && (A = (e[t - 2] << 8) + e[t - 1], n += M0[A >> 10], n += M0[A >> 4 & 63], n += M0[A << 2 & 63], n += "="), i.push(n), i.join("");
}
function DB(e, A, t, r, n) {
  var i, a, o = n * 8 - r - 1, s = (1 << o) - 1, l = s >> 1, u = -7, g = t ? n - 1 : 0, d = t ? -1 : 1, h = e[A + g];
  for (g += d, i = h & (1 << -u) - 1, h >>= -u, u += o; u > 0; i = i * 256 + e[A + g], g += d, u -= 8)
    ;
  for (a = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; a = a * 256 + e[A + g], g += d, u -= 8)
    ;
  if (i === 0)
    i = 1 - l;
  else {
    if (i === s)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), i = i - l;
  }
  return (h ? -1 : 1) * a * Math.pow(2, i - r);
}
function iy(e, A, t, r, n, i) {
  var a, o, s, l = i * 8 - n - 1, u = (1 << l) - 1, g = u >> 1, d = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : i - 1, C = r ? 1 : -1, E = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
  for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (o = isNaN(A) ? 1 : 0, a = u) : (a = Math.floor(Math.log(A) / Math.LN2), A * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), a + g >= 1 ? A += d / s : A += d * Math.pow(2, 1 - g), A * s >= 2 && (a++, s /= 2), a + g >= u ? (o = 0, a = u) : a + g >= 1 ? (o = (A * s - 1) * Math.pow(2, n), a = a + g) : (o = A * Math.pow(2, g - 1) * Math.pow(2, n), a = 0)); n >= 8; e[t + h] = o & 255, h += C, o /= 256, n -= 8)
    ;
  for (a = a << n | o, l += n; l > 0; e[t + h] = a & 255, h += C, a /= 256, l -= 8)
    ;
  e[t + h - C] |= E * 128;
}
var I_ = {}.toString, ay = Array.isArray || function(e) {
  return I_.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var D_ = 50;
jA.TYPED_ARRAY_SUPPORT = rD.TYPED_ARRAY_SUPPORT !== void 0 ? rD.TYPED_ARRAY_SUPPORT : !0;
Qg();
function Qg() {
  return jA.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function ti(e, A) {
  if (Qg() < A)
    throw new RangeError("Invalid typed array length");
  return jA.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(A), e.__proto__ = jA.prototype) : (e === null && (e = new jA(A)), e.length = A), e;
}
function jA(e, A, t) {
  if (!jA.TYPED_ARRAY_SUPPORT && !(this instanceof jA))
    return new jA(e, A, t);
  if (typeof e == "number") {
    if (typeof A == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return HE(this, e);
  }
  return oy(this, e, A, t);
}
jA.poolSize = 8192;
jA._augment = function(e) {
  return e.__proto__ = jA.prototype, e;
};
function oy(e, A, t, r) {
  if (typeof A == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && A instanceof ArrayBuffer ? p_(e, A, t, r) : typeof A == "string" ? M_(e, A, t) : v_(e, A);
}
jA.from = function(e, A, t) {
  return oy(null, e, A, t);
};
jA.TYPED_ARRAY_SUPPORT && (jA.prototype.__proto__ = Uint8Array.prototype, jA.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && jA[Symbol.species]);
function sy(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function m_(e, A, t, r) {
  return sy(A), A <= 0 ? ti(e, A) : t !== void 0 ? typeof r == "string" ? ti(e, A).fill(t, r) : ti(e, A).fill(t) : ti(e, A);
}
jA.alloc = function(e, A, t) {
  return m_(null, e, A, t);
};
function HE(e, A) {
  if (sy(A), e = ti(e, A < 0 ? 0 : SE(A) | 0), !jA.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < A; ++t)
      e[t] = 0;
  return e;
}
jA.allocUnsafe = function(e) {
  return HE(null, e);
};
jA.allocUnsafeSlow = function(e) {
  return HE(null, e);
};
function M_(e, A, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !jA.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = ly(A, t) | 0;
  e = ti(e, r);
  var n = e.write(A, t);
  return n !== r && (e = e.slice(0, n)), e;
}
function Ph(e, A) {
  var t = A.length < 0 ? 0 : SE(A.length) | 0;
  e = ti(e, t);
  for (var r = 0; r < t; r += 1)
    e[r] = A[r] & 255;
  return e;
}
function p_(e, A, t, r) {
  if (A.byteLength, t < 0 || A.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (A.byteLength < t + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && r === void 0 ? A = new Uint8Array(A) : r === void 0 ? A = new Uint8Array(A, t) : A = new Uint8Array(A, t, r), jA.TYPED_ARRAY_SUPPORT ? (e = A, e.__proto__ = jA.prototype) : e = Ph(e, A), e;
}
function v_(e, A) {
  if (Y0(A)) {
    var t = SE(A.length) | 0;
    return e = ti(e, t), e.length === 0 || A.copy(e, 0, 0, t), e;
  }
  if (A) {
    if (typeof ArrayBuffer < "u" && A.buffer instanceof ArrayBuffer || "length" in A)
      return typeof A.length != "number" || O_(A.length) ? ti(e, 0) : Ph(e, A);
    if (A.type === "Buffer" && ay(A.data))
      return Ph(e, A.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function SE(e) {
  if (e >= Qg())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Qg().toString(16) + " bytes");
  return e | 0;
}
jA.isBuffer = J_;
function Y0(e) {
  return !!(e != null && e._isBuffer);
}
jA.compare = function(A, t) {
  if (!Y0(A) || !Y0(t))
    throw new TypeError("Arguments must be Buffers");
  if (A === t) return 0;
  for (var r = A.length, n = t.length, i = 0, a = Math.min(r, n); i < a; ++i)
    if (A[i] !== t[i]) {
      r = A[i], n = t[i];
      break;
    }
  return r < n ? -1 : n < r ? 1 : 0;
};
jA.isEncoding = function(A) {
  switch (String(A).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
jA.concat = function(A, t) {
  if (!ay(A))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (A.length === 0)
    return jA.alloc(0);
  var r;
  if (t === void 0)
    for (t = 0, r = 0; r < A.length; ++r)
      t += A[r].length;
  var n = jA.allocUnsafe(t), i = 0;
  for (r = 0; r < A.length; ++r) {
    var a = A[r];
    if (!Y0(a))
      throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(n, i), i += a.length;
  }
  return n;
};
function ly(e, A) {
  if (Y0(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var t = e.length;
  if (t === 0) return 0;
  for (var r = !1; ; )
    switch (A) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return wg(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return hy(e).length;
      default:
        if (r) return wg(e).length;
        A = ("" + A).toLowerCase(), r = !0;
    }
}
jA.byteLength = ly;
function y_(e, A, t) {
  var r = !1;
  if ((A === void 0 || A < 0) && (A = 0), A > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, A >>>= 0, t <= A))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return H_(this, A, t);
      case "utf8":
      case "utf-8":
        return gy(this, A, t);
      case "ascii":
        return U_(this, A, t);
      case "latin1":
      case "binary":
        return Y_(this, A, t);
      case "base64":
        return x_(this, A, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return S_(this, A, t);
      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
}
jA.prototype._isBuffer = !0;
function Sa(e, A, t) {
  var r = e[A];
  e[A] = e[t], e[t] = r;
}
jA.prototype.swap16 = function() {
  var A = this.length;
  if (A % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < A; t += 2)
    Sa(this, t, t + 1);
  return this;
};
jA.prototype.swap32 = function() {
  var A = this.length;
  if (A % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < A; t += 4)
    Sa(this, t, t + 3), Sa(this, t + 1, t + 2);
  return this;
};
jA.prototype.swap64 = function() {
  var A = this.length;
  if (A % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < A; t += 8)
    Sa(this, t, t + 7), Sa(this, t + 1, t + 6), Sa(this, t + 2, t + 5), Sa(this, t + 3, t + 4);
  return this;
};
jA.prototype.toString = function() {
  var A = this.length | 0;
  return A === 0 ? "" : arguments.length === 0 ? gy(this, 0, A) : y_.apply(this, arguments);
};
jA.prototype.equals = function(A) {
  if (!Y0(A)) throw new TypeError("Argument must be a Buffer");
  return this === A ? !0 : jA.compare(this, A) === 0;
};
jA.prototype.inspect = function() {
  var A = "", t = D_;
  return this.length > 0 && (A = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (A += " ... ")), "<Buffer " + A + ">";
};
jA.prototype.compare = function(A, t, r, n, i) {
  if (!Y0(A))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), r === void 0 && (r = A ? A.length : 0), n === void 0 && (n = 0), i === void 0 && (i = this.length), t < 0 || r > A.length || n < 0 || i > this.length)
    throw new RangeError("out of range index");
  if (n >= i && t >= r)
    return 0;
  if (n >= i)
    return -1;
  if (t >= r)
    return 1;
  if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === A) return 0;
  for (var a = i - n, o = r - t, s = Math.min(a, o), l = this.slice(n, i), u = A.slice(t, r), g = 0; g < s; ++g)
    if (l[g] !== u[g]) {
      a = l[g], o = u[g];
      break;
    }
  return a < o ? -1 : o < a ? 1 : 0;
};
function uy(e, A, t, r, n) {
  if (e.length === 0) return -1;
  if (typeof t == "string" ? (r = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = n ? 0 : e.length - 1), t < 0 && (t = e.length + t), t >= e.length) {
    if (n) return -1;
    t = e.length - 1;
  } else if (t < 0)
    if (n) t = 0;
    else return -1;
  if (typeof A == "string" && (A = jA.from(A, r)), Y0(A))
    return A.length === 0 ? -1 : iD(e, A, t, r, n);
  if (typeof A == "number")
    return A = A & 255, jA.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? n ? Uint8Array.prototype.indexOf.call(e, A, t) : Uint8Array.prototype.lastIndexOf.call(e, A, t) : iD(e, [A], t, r, n);
  throw new TypeError("val must be string, number or Buffer");
}
function iD(e, A, t, r, n) {
  var i = 1, a = e.length, o = A.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (e.length < 2 || A.length < 2)
      return -1;
    i = 2, a /= 2, o /= 2, t /= 2;
  }
  function s(h, C) {
    return i === 1 ? h[C] : h.readUInt16BE(C * i);
  }
  var l;
  if (n) {
    var u = -1;
    for (l = t; l < a; l++)
      if (s(e, l) === s(A, u === -1 ? 0 : l - u)) {
        if (u === -1 && (u = l), l - u + 1 === o) return u * i;
      } else
        u !== -1 && (l -= l - u), u = -1;
  } else
    for (t + o > a && (t = a - o), l = t; l >= 0; l--) {
      for (var g = !0, d = 0; d < o; d++)
        if (s(e, l + d) !== s(A, d)) {
          g = !1;
          break;
        }
      if (g) return l;
    }
  return -1;
}
jA.prototype.includes = function(A, t, r) {
  return this.indexOf(A, t, r) !== -1;
};
jA.prototype.indexOf = function(A, t, r) {
  return uy(this, A, t, r, !0);
};
jA.prototype.lastIndexOf = function(A, t, r) {
  return uy(this, A, t, r, !1);
};
function b_(e, A, t, r) {
  t = Number(t) || 0;
  var n = e.length - t;
  r ? (r = Number(r), r > n && (r = n)) : r = n;
  var i = A.length;
  if (i % 2 !== 0) throw new TypeError("Invalid hex string");
  r > i / 2 && (r = i / 2);
  for (var a = 0; a < r; ++a) {
    var o = parseInt(A.substr(a * 2, 2), 16);
    if (isNaN(o)) return a;
    e[t + a] = o;
  }
  return a;
}
function F_(e, A, t, r) {
  return pB(wg(A, e.length - t), e, t, r);
}
function cy(e, A, t, r) {
  return pB(j_(A), e, t, r);
}
function L_(e, A, t, r) {
  return cy(e, A, t, r);
}
function R_(e, A, t, r) {
  return pB(hy(A), e, t, r);
}
function G_(e, A, t, r) {
  return pB(V_(A, e.length - t), e, t, r);
}
jA.prototype.write = function(A, t, r, n) {
  if (t === void 0)
    n = "utf8", r = this.length, t = 0;
  else if (r === void 0 && typeof t == "string")
    n = t, r = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(r) ? (r = r | 0, n === void 0 && (n = "utf8")) : (n = r, r = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var i = this.length - t;
  if ((r === void 0 || r > i) && (r = i), A.length > 0 && (r < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  n || (n = "utf8");
  for (var a = !1; ; )
    switch (n) {
      case "hex":
        return b_(this, A, t, r);
      case "utf8":
      case "utf-8":
        return F_(this, A, t, r);
      case "ascii":
        return cy(this, A, t, r);
      case "latin1":
      case "binary":
        return L_(this, A, t, r);
      case "base64":
        return R_(this, A, t, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return G_(this, A, t, r);
      default:
        if (a) throw new TypeError("Unknown encoding: " + n);
        n = ("" + n).toLowerCase(), a = !0;
    }
};
jA.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function x_(e, A, t) {
  return A === 0 && t === e.length ? nD(e) : nD(e.slice(A, t));
}
function gy(e, A, t) {
  t = Math.min(e.length, t);
  for (var r = [], n = A; n < t; ) {
    var i = e[n], a = null, o = i > 239 ? 4 : i > 223 ? 3 : i > 191 ? 2 : 1;
    if (n + o <= t) {
      var s, l, u, g;
      switch (o) {
        case 1:
          i < 128 && (a = i);
          break;
        case 2:
          s = e[n + 1], (s & 192) === 128 && (g = (i & 31) << 6 | s & 63, g > 127 && (a = g));
          break;
        case 3:
          s = e[n + 1], l = e[n + 2], (s & 192) === 128 && (l & 192) === 128 && (g = (i & 15) << 12 | (s & 63) << 6 | l & 63, g > 2047 && (g < 55296 || g > 57343) && (a = g));
          break;
        case 4:
          s = e[n + 1], l = e[n + 2], u = e[n + 3], (s & 192) === 128 && (l & 192) === 128 && (u & 192) === 128 && (g = (i & 15) << 18 | (s & 63) << 12 | (l & 63) << 6 | u & 63, g > 65535 && g < 1114112 && (a = g));
      }
    }
    a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r.push(a), n += o;
  }
  return k_(r);
}
var aD = 4096;
function k_(e) {
  var A = e.length;
  if (A <= aD)
    return String.fromCharCode.apply(String, e);
  for (var t = "", r = 0; r < A; )
    t += String.fromCharCode.apply(
      String,
      e.slice(r, r += aD)
    );
  return t;
}
function U_(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n] & 127);
  return r;
}
function Y_(e, A, t) {
  var r = "";
  t = Math.min(e.length, t);
  for (var n = A; n < t; ++n)
    r += String.fromCharCode(e[n]);
  return r;
}
function H_(e, A, t) {
  var r = e.length;
  (!A || A < 0) && (A = 0), (!t || t < 0 || t > r) && (t = r);
  for (var n = "", i = A; i < t; ++i)
    n += z_(e[i]);
  return n;
}
function S_(e, A, t) {
  for (var r = e.slice(A, t), n = "", i = 0; i < r.length; i += 2)
    n += String.fromCharCode(r[i] + r[i + 1] * 256);
  return n;
}
jA.prototype.slice = function(A, t) {
  var r = this.length;
  A = ~~A, t = t === void 0 ? r : ~~t, A < 0 ? (A += r, A < 0 && (A = 0)) : A > r && (A = r), t < 0 ? (t += r, t < 0 && (t = 0)) : t > r && (t = r), t < A && (t = A);
  var n;
  if (jA.TYPED_ARRAY_SUPPORT)
    n = this.subarray(A, t), n.__proto__ = jA.prototype;
  else {
    var i = t - A;
    n = new jA(i, void 0);
    for (var a = 0; a < i; ++a)
      n[a] = this[a + A];
  }
  return n;
};
function hr(e, A, t) {
  if (e % 1 !== 0 || e < 0) throw new RangeError("offset is not uint");
  if (e + A > t) throw new RangeError("Trying to access beyond buffer length");
}
jA.prototype.readUIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || hr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return n;
};
jA.prototype.readUIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || hr(A, t, this.length);
  for (var n = this[A + --t], i = 1; t > 0 && (i *= 256); )
    n += this[A + --t] * i;
  return n;
};
jA.prototype.readUInt8 = function(A, t) {
  return t || hr(A, 1, this.length), this[A];
};
jA.prototype.readUInt16LE = function(A, t) {
  return t || hr(A, 2, this.length), this[A] | this[A + 1] << 8;
};
jA.prototype.readUInt16BE = function(A, t) {
  return t || hr(A, 2, this.length), this[A] << 8 | this[A + 1];
};
jA.prototype.readUInt32LE = function(A, t) {
  return t || hr(A, 4, this.length), (this[A] | this[A + 1] << 8 | this[A + 2] << 16) + this[A + 3] * 16777216;
};
jA.prototype.readUInt32BE = function(A, t) {
  return t || hr(A, 4, this.length), this[A] * 16777216 + (this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3]);
};
jA.prototype.readIntLE = function(A, t, r) {
  A = A | 0, t = t | 0, r || hr(A, t, this.length);
  for (var n = this[A], i = 1, a = 0; ++a < t && (i *= 256); )
    n += this[A + a] * i;
  return i *= 128, n >= i && (n -= Math.pow(2, 8 * t)), n;
};
jA.prototype.readIntBE = function(A, t, r) {
  A = A | 0, t = t | 0, r || hr(A, t, this.length);
  for (var n = t, i = 1, a = this[A + --n]; n > 0 && (i *= 256); )
    a += this[A + --n] * i;
  return i *= 128, a >= i && (a -= Math.pow(2, 8 * t)), a;
};
jA.prototype.readInt8 = function(A, t) {
  return t || hr(A, 1, this.length), this[A] & 128 ? (255 - this[A] + 1) * -1 : this[A];
};
jA.prototype.readInt16LE = function(A, t) {
  t || hr(A, 2, this.length);
  var r = this[A] | this[A + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
jA.prototype.readInt16BE = function(A, t) {
  t || hr(A, 2, this.length);
  var r = this[A + 1] | this[A] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
jA.prototype.readInt32LE = function(A, t) {
  return t || hr(A, 4, this.length), this[A] | this[A + 1] << 8 | this[A + 2] << 16 | this[A + 3] << 24;
};
jA.prototype.readInt32BE = function(A, t) {
  return t || hr(A, 4, this.length), this[A] << 24 | this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3];
};
jA.prototype.readFloatLE = function(A, t) {
  return t || hr(A, 4, this.length), DB(this, A, !0, 23, 4);
};
jA.prototype.readFloatBE = function(A, t) {
  return t || hr(A, 4, this.length), DB(this, A, !1, 23, 4);
};
jA.prototype.readDoubleLE = function(A, t) {
  return t || hr(A, 8, this.length), DB(this, A, !0, 52, 8);
};
jA.prototype.readDoubleBE = function(A, t) {
  return t || hr(A, 8, this.length), DB(this, A, !1, 52, 8);
};
function on(e, A, t, r, n, i) {
  if (!Y0(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (A > n || A < i) throw new RangeError('"value" argument is out of bounds');
  if (t + r > e.length) throw new RangeError("Index out of range");
}
jA.prototype.writeUIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    on(this, A, t, r, i, 0);
  }
  var a = 1, o = 0;
  for (this[t] = A & 255; ++o < r && (a *= 256); )
    this[t + o] = A / a & 255;
  return t + r;
};
jA.prototype.writeUIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, r = r | 0, !n) {
    var i = Math.pow(2, 8 * r) - 1;
    on(this, A, t, r, i, 0);
  }
  var a = r - 1, o = 1;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    this[t + a] = A / o & 255;
  return t + r;
};
jA.prototype.writeUInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 1, 255, 0), jA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), this[t] = A & 255, t + 1;
};
function mB(e, A, t, r) {
  A < 0 && (A = 65535 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 2); n < i; ++n)
    e[t + n] = (A & 255 << 8 * (r ? n : 1 - n)) >>> (r ? n : 1 - n) * 8;
}
jA.prototype.writeUInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 2, 65535, 0), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : mB(this, A, t, !0), t + 2;
};
jA.prototype.writeUInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 2, 65535, 0), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : mB(this, A, t, !1), t + 2;
};
function MB(e, A, t, r) {
  A < 0 && (A = 4294967295 + A + 1);
  for (var n = 0, i = Math.min(e.length - t, 4); n < i; ++n)
    e[t + n] = A >>> (r ? n : 3 - n) * 8 & 255;
}
jA.prototype.writeUInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 4, 4294967295, 0), jA.TYPED_ARRAY_SUPPORT ? (this[t + 3] = A >>> 24, this[t + 2] = A >>> 16, this[t + 1] = A >>> 8, this[t] = A & 255) : MB(this, A, t, !0), t + 4;
};
jA.prototype.writeUInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 4, 4294967295, 0), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : MB(this, A, t, !1), t + 4;
};
jA.prototype.writeIntLE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    on(this, A, t, r, i - 1, -i);
  }
  var a = 0, o = 1, s = 0;
  for (this[t] = A & 255; ++a < r && (o *= 256); )
    A < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
jA.prototype.writeIntBE = function(A, t, r, n) {
  if (A = +A, t = t | 0, !n) {
    var i = Math.pow(2, 8 * r - 1);
    on(this, A, t, r, i - 1, -i);
  }
  var a = r - 1, o = 1, s = 0;
  for (this[t + a] = A & 255; --a >= 0 && (o *= 256); )
    A < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (A / o >> 0) - s & 255;
  return t + r;
};
jA.prototype.writeInt8 = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 1, 127, -128), jA.TYPED_ARRAY_SUPPORT || (A = Math.floor(A)), A < 0 && (A = 255 + A + 1), this[t] = A & 255, t + 1;
};
jA.prototype.writeInt16LE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 2, 32767, -32768), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8) : mB(this, A, t, !0), t + 2;
};
jA.prototype.writeInt16BE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 2, 32767, -32768), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 8, this[t + 1] = A & 255) : mB(this, A, t, !1), t + 2;
};
jA.prototype.writeInt32LE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 4, 2147483647, -2147483648), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A & 255, this[t + 1] = A >>> 8, this[t + 2] = A >>> 16, this[t + 3] = A >>> 24) : MB(this, A, t, !0), t + 4;
};
jA.prototype.writeInt32BE = function(A, t, r) {
  return A = +A, t = t | 0, r || on(this, A, t, 4, 2147483647, -2147483648), A < 0 && (A = 4294967295 + A + 1), jA.TYPED_ARRAY_SUPPORT ? (this[t] = A >>> 24, this[t + 1] = A >>> 16, this[t + 2] = A >>> 8, this[t + 3] = A & 255) : MB(this, A, t, !1), t + 4;
};
function By(e, A, t, r, n, i) {
  if (t + r > e.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function fy(e, A, t, r, n) {
  return n || By(e, A, t, 4), iy(e, A, t, r, 23, 4), t + 4;
}
jA.prototype.writeFloatLE = function(A, t, r) {
  return fy(this, A, t, !0, r);
};
jA.prototype.writeFloatBE = function(A, t, r) {
  return fy(this, A, t, !1, r);
};
function dy(e, A, t, r, n) {
  return n || By(e, A, t, 8), iy(e, A, t, r, 52, 8), t + 8;
}
jA.prototype.writeDoubleLE = function(A, t, r) {
  return dy(this, A, t, !0, r);
};
jA.prototype.writeDoubleBE = function(A, t, r) {
  return dy(this, A, t, !1, r);
};
jA.prototype.copy = function(A, t, r, n) {
  if (r || (r = 0), !n && n !== 0 && (n = this.length), t >= A.length && (t = A.length), t || (t = 0), n > 0 && n < r && (n = r), n === r || A.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
  if (n < 0) throw new RangeError("sourceEnd out of bounds");
  n > this.length && (n = this.length), A.length - t < n - r && (n = A.length - t + r);
  var i = n - r, a;
  if (this === A && r < t && t < n)
    for (a = i - 1; a >= 0; --a)
      A[a + t] = this[a + r];
  else if (i < 1e3 || !jA.TYPED_ARRAY_SUPPORT)
    for (a = 0; a < i; ++a)
      A[a + t] = this[a + r];
  else
    Uint8Array.prototype.set.call(
      A,
      this.subarray(r, r + i),
      t
    );
  return i;
};
jA.prototype.fill = function(A, t, r, n) {
  if (typeof A == "string") {
    if (typeof t == "string" ? (n = t, t = 0, r = this.length) : typeof r == "string" && (n = r, r = this.length), A.length === 1) {
      var i = A.charCodeAt(0);
      i < 256 && (A = i);
    }
    if (n !== void 0 && typeof n != "string")
      throw new TypeError("encoding must be a string");
    if (typeof n == "string" && !jA.isEncoding(n))
      throw new TypeError("Unknown encoding: " + n);
  } else typeof A == "number" && (A = A & 255);
  if (t < 0 || this.length < t || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= t)
    return this;
  t = t >>> 0, r = r === void 0 ? this.length : r >>> 0, A || (A = 0);
  var a;
  if (typeof A == "number")
    for (a = t; a < r; ++a)
      this[a] = A;
  else {
    var o = Y0(A) ? A : wg(new jA(A, n).toString()), s = o.length;
    for (a = 0; a < r - t; ++a)
      this[a + t] = o[a % s];
  }
  return this;
};
var N_ = /[^+\/0-9A-Za-z-_]/g;
function T_(e) {
  if (e = P_(e).replace(N_, ""), e.length < 2) return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function P_(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function z_(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function wg(e, A) {
  A = A || 1 / 0;
  for (var t, r = e.length, n = null, i = [], a = 0; a < r; ++a) {
    if (t = e.charCodeAt(a), t > 55295 && t < 57344) {
      if (!n) {
        if (t > 56319) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        } else if (a + 1 === r) {
          (A -= 3) > -1 && i.push(239, 191, 189);
          continue;
        }
        n = t;
        continue;
      }
      if (t < 56320) {
        (A -= 3) > -1 && i.push(239, 191, 189), n = t;
        continue;
      }
      t = (n - 55296 << 10 | t - 56320) + 65536;
    } else n && (A -= 3) > -1 && i.push(239, 191, 189);
    if (n = null, t < 128) {
      if ((A -= 1) < 0) break;
      i.push(t);
    } else if (t < 2048) {
      if ((A -= 2) < 0) break;
      i.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((A -= 3) < 0) break;
      i.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((A -= 4) < 0) break;
      i.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return i;
}
function j_(e) {
  for (var A = [], t = 0; t < e.length; ++t)
    A.push(e.charCodeAt(t) & 255);
  return A;
}
function V_(e, A) {
  for (var t, r, n, i = [], a = 0; a < e.length && !((A -= 2) < 0); ++a)
    t = e.charCodeAt(a), r = t >> 8, n = t % 256, i.push(n), i.push(r);
  return i;
}
function hy(e) {
  return E_(T_(e));
}
function pB(e, A, t, r) {
  for (var n = 0; n < r && !(n + t >= A.length || n >= e.length); ++n)
    A[n + t] = e[n];
  return n;
}
function O_(e) {
  return e !== e;
}
function J_(e) {
  return e != null && (!!e._isBuffer || Cy(e) || W_(e));
}
function Cy(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function W_(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && Cy(e.slice(0, 0));
}
ml.isValid = function(A) {
  try {
    return !!new ml(A);
  } catch {
    return !1;
  }
};
var NE = function(A) {
  if (this.data = null, this.width = null, this.height = null, this.data = A, A.readUInt16BE(0) !== 65496)
    throw new Error("SOI not found in JPEG");
  for (var t = Nm.decode(this.data), r = 0; r < t.length; r += 1) {
    var n = t[r];
    n.name === "EXIF" && n.entries.orientation && (this.orientation = n.entries.orientation), n.name === "SOF" && (this.width || (this.width = n.width), this.height || (this.height = n.height));
  }
  if (this.orientation > 4) {
    var i = [this.height, this.width];
    this.width = i[0], this.height = i[1];
  }
};
NE.isValid = function(e) {
  return e && jA.isBuffer(e) && e.readUInt16BE(0) === 65496;
};
var Z_ = function(A) {
  var t = A === void 0 ? {} : A, r = t.limit, n = r === void 0 ? 100 : r, i = {}, a = [];
  return {
    get: function(s) {
      return i[s];
    },
    set: function(s, l) {
      a.push(s), a.length > n && delete i[a.shift()], i[s] = l;
    },
    reset: function() {
      i = {}, a = [];
    },
    length: function() {
      return a.length;
    }
  };
}, Zd = Z_({
  limit: 30
}), K_ = /* @__PURE__ */ function() {
  var e = Ui(/* @__PURE__ */ wr().mark(function A(t, r) {
    var n, i;
    return wr().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          return o.next = 2, y4(t, r);
        case 2:
          return n = o.sent, o.next = 5, n.buffer ? n.buffer() : n.arrayBuffer();
        case 5:
          return i = o.sent, o.abrupt("return", i.constructor.name === "Buffer" ? i : jA.from(i));
        case 7:
        case "end":
          return o.stop();
      }
    }, A);
  }));
  return function(t, r) {
    return e.apply(this, arguments);
  };
}(), Ey = function(A) {
  var t = A.toLowerCase();
  return t === "jpg" || t === "jpeg" || t === "png";
}, __ = function(A) {
  var t;
  return NE.isValid(A) ? t = "jpg" : ml.isValid(A) && (t = "png"), t;
}, X_ = function(A) {
  var t = A.uri;
  return /^data:image\/[a-zA-Z]*;base64,[^"]*/g.test(t);
};
function tu(e, A) {
  switch (A.toLowerCase()) {
    case "jpg":
    case "jpeg":
      return new NE(e);
    case "png":
      return new ml(e);
    default:
      return null;
  }
}
var q_ = function(A) {
  var t = A.uri, r = /^data:image\/([a-zA-Z]*);base64,([^"]*)/g.exec(t), n = r[1], i = r[2];
  if (!Ey(n))
    throw new Error("Base64 image invalid format: " + n);
  return new Promise(function(a) {
    return a(tu(jA.from(i, "base64"), n));
  });
}, $_ = function(A) {
  if (A.data && A.format)
    return new Promise(function(t) {
      return t(tu(A.data, A.format));
    });
  throw new Error("Invalid data given for local file: " + JSON.stringify(A));
}, Qy = function(A) {
  var t = __(A);
  return t ? new Promise(function(r) {
    return r(tu(A, t));
  }) : Promise.resolve();
}, AX = /* @__PURE__ */ function() {
  var e = Ui(/* @__PURE__ */ wr().mark(function A(t) {
    var r, n, i, a, o;
    return wr().wrap(function(l) {
      for (; ; ) switch (l.prev = l.next) {
        case 0:
          if (r = t.type, !(!r || r === "application/octet-stream")) {
            l.next = 7;
            break;
          }
          return l.next = 4, t.arrayBuffer();
        case 4:
          return n = l.sent, i = jA.from(n), l.abrupt("return", Qy(i));
        case 7:
          if (r.startsWith("image/")) {
            l.next = 9;
            break;
          }
          throw new Error("Invalid blob type: " + r);
        case 9:
          if (a = r.replace("image/", ""), Ey(a)) {
            l.next = 12;
            break;
          }
          throw new Error("Invalid blob type: " + r);
        case 12:
          return l.next = 14, t.arrayBuffer();
        case 14:
          return o = l.sent, l.abrupt("return", tu(jA.from(o), a));
        case 16:
        case "end":
          return l.stop();
      }
    }, A);
  }));
  return function(t) {
    return e.apply(this, arguments);
  };
}(), eX = function(A) {
  var t = A[0] === 137 && A[1] === 80 && A[2] === 78 && A[3] === 71 && A[4] === 13 && A[5] === 10 && A[6] === 26 && A[7] === 10, r = A[0] === 255 && A[1] === 216 && A[2] === 255, n = "";
  if (t)
    n = "png";
  else if (r)
    n = "jpg";
  else
    throw new Error("Not valid image extension");
  return n;
}, tX = /* @__PURE__ */ function() {
  var e = Ui(/* @__PURE__ */ wr().mark(function A(t) {
    var r, n, i, a, o, s, l, u;
    return wr().wrap(function(d) {
      for (; ; ) switch (d.prev = d.next) {
        case 0:
          r = t.uri, n = t.body, i = t.headers, a = t.method, o = a === void 0 ? "GET" : a, s = t.credentials;
          {
            d.next = 7;
            break;
          }
        case 4:
          d.t0 = d.sent, d.next = 10;
          break;
        case 7:
          return d.next = 9, K_(r, {
            body: n,
            headers: i,
            method: o,
            credentials: s
          });
        case 9:
          d.t0 = d.sent;
        case 10:
          return l = d.t0, u = eX(l), d.abrupt("return", tu(l, u));
        case 13:
        case "end":
          return d.stop();
      }
    }, A);
  }));
  return function(t) {
    return e.apply(this, arguments);
  };
}(), wy = function(A, t) {
  var r = t === void 0 ? {} : t, n = r.cache, i = n === void 0 ? !0 : n, a, o = A.data ? A.data.toString() : A.uri;
  if (typeof Blob < "u" && A instanceof Blob)
    a = AX(A);
  else if (jA.isBuffer(A))
    a = Qy(A);
  else {
    if (i && Zd.get(o))
      return Zd.get(o);
    X_(A) ? a = q_(A) : typeof A == "object" && A.data ? a = $_(A) : a = tX(A);
  }
  if (!a)
    throw new Error("Cannot resolve image");
  return i && Zd.set(o, a), a;
};
const Iy = (e) => {
  let A = 0, t = "";
  const r = [];
  return e.forEach((n) => {
    t += n.string, r.push({
      start: A,
      end: A + n.string.length,
      attributes: n.attributes || {}
    }), A += n.string.length;
  }), {
    string: t,
    runs: r
  };
}, Dy = (e, A) => {
  switch (A) {
    case "uppercase":
      return e.toUpperCase();
    case "lowercase":
      return e.toLowerCase();
    case "capitalize":
      return GS(e);
    case "upperfirst":
      return LC(e);
    default:
      return e;
  }
};
class rX {
  constructor(A) {
    this.name = A, this.src = wB.open(null, A);
  }
  encode(A) {
    return this.src.encode(A);
  }
  layout(A) {
    const [t, r] = this.encode(A);
    return {
      positions: r,
      stringIndices: r.map((n, i) => i),
      glyphs: t.map((n, i) => {
        const a = this.getGlyph(parseInt(n, 16));
        return a.advanceWidth = r[i].advanceWidth, a;
      })
    };
  }
  glyphForCodePoint(A) {
    const t = this.getGlyph(A);
    return t.advanceWidth = 400, t;
  }
  getGlyph(A) {
    return {
      id: A,
      _font: this.src,
      codePoints: [A],
      isLigature: !1,
      name: this.src.font.characterToGlyph(A)
    };
  }
  hasGlyphForCodePoint(A) {
    return this.src.font.characterToGlyph(A) !== ".notdef";
  }
  // Based on empirical observation
  get ascent() {
    return 900;
  }
  // Based on empirical observation
  get capHeight() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return 650;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return 550;
      default:
        return 690;
    }
  }
  // Based on empirical observation
  get xHeight() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return 440;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return 390;
      default:
        return 490;
    }
  }
  // Based on empirical observation
  get descent() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return -220;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return -230;
      default:
        return -200;
    }
  }
  get lineGap() {
    return 0;
  }
  get unitsPerEm() {
    return 1e3;
  }
}
const Kd = {}, nX = [173], oD = (e) => e.attributes.fontSize || 12, my = (e) => {
  if (Kd[e]) return Kd[e];
  const A = new rX(e);
  return Kd[e] = A, A;
}, sD = () => my("Helvetica"), iX = (e, A, t) => {
  const r = [...A, t, sD()];
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    if (!nX.includes(e) && i && i.hasGlyphForCodePoint && i.hasGlyphForCodePoint(e))
      return i;
  }
  return sD();
}, My = () => (e) => {
  let {
    string: A,
    runs: t
  } = e, r = null, n = null, i = 0, a = 0;
  const o = [];
  for (let s = 0; s < t.length; s += 1) {
    const l = t[s], u = l.attributes.font.map((d) => typeof d == "string" ? my(d) : d);
    if (A.length === 0) {
      o.push({
        start: 0,
        end: 0,
        attributes: {
          font: u
        }
      });
      break;
    }
    const g = A.slice(l.start, l.end);
    for (let d = 0; d < g.length; d += 1) {
      const h = g[d], C = h.codePointAt(), E = iX(C, u, r), I = oD(l);
      (E !== r || I !== n || E.unitsPerEm !== r.unitsPerEm) && (r && o.push({
        start: i,
        end: a,
        attributes: {
          font: r,
          scale: n / r.unitsPerEm
        }
      }), r = E, n = I, i = a), a += h.length;
    }
  }
  if (i < A.length) {
    const s = oD(ni(t));
    o.push({
      start: i,
      end: A.length,
      attributes: {
        font: r,
        scale: s / r.unitsPerEm
      }
    });
  }
  return {
    string: A,
    runs: o
  };
}, aX = (e) => e.type === qi, oX = {
  bidi: Zv,
  linebreaker: Kv,
  justification: qv,
  textDecoration: $v,
  scriptItemizer: Ay,
  wordHyphenation: ty,
  fontSubstitution: My
}, sX = Wv(oX), py = (e, A) => {
  if (!A) return [{
    string: ""
  }];
  const t = [], {
    fill: r = "black",
    fontFamily: n = "Helvetica",
    fontWeight: i,
    fontStyle: a,
    fontSize: o = 18,
    textDecorationColor: s,
    textDecorationStyle: l,
    textTransform: u,
    opacity: g
  } = A.props, d = A.props.textDecoration, E = {
    font: (typeof n == "string" ? [n] : [...n || []]).map((I) => {
      if (typeof I != "string") return I;
      const b = {
        fontFamily: I,
        fontWeight: i,
        fontStyle: a
      }, y = e ? e.getFont(b) : null;
      return y ? y.data : I;
    }),
    opacity: g,
    fontSize: o,
    color: r,
    underlineStyle: l,
    underline: d === "underline" || d === "underline line-through" || d === "line-through underline",
    underlineColor: s || r,
    strike: d === "line-through" || d === "underline line-through" || d === "line-through underline",
    strikeStyle: l,
    strikeColor: s || r
  };
  for (let I = 0; I < A.children.length; I += 1) {
    const b = A.children[I];
    aX(b) ? t.push({
      string: Dy(b.value, u),
      attributes: E
    }) : b && t.push(...py(b));
  }
  return t;
}, lX = (e, A) => Iy(py(e, A)), lD = 999999999999, uX = {
  before: -0.5,
  after: -0.5
}, cX = (e) => (A) => {
  var t, r;
  const n = lX(e, A), i = ((t = A.props) === null || t === void 0 ? void 0 : t.x) || 0, a = ((r = A.props) === null || r === void 0 ? void 0 : r.y) || 0, o = {
    x: i,
    y: a,
    width: lD,
    height: lD
  }, l = {
    hyphenationCallback: A.props.hyphenationCallback || (e == null ? void 0 : e.getHyphenationCallback()) || null,
    shrinkWhitespaceFactor: uX
  }, u = sX(n, o, l).flat();
  return Object.assign({}, A, {
    lines: u
  });
}, gX = (e, A) => {
  if (!A.children) return A;
  const t = A.children.map(cX(e));
  return Object.assign({}, A, {
    children: t
  });
}, BX = (e) => e.type === BC, fX = (e) => (((e.children || []).find(BX) || {}).children || []).reduce((n, i) => {
  var a;
  const o = (a = i.props) === null || a === void 0 ? void 0 : a.id;
  return o && (n[o] = i), n;
}, {}), dX = (e) => e.type !== BC, hX = (e) => {
  if (!e.children) return e;
  const A = e.children.filter(dX);
  return Object.assign({}, e, {
    children: A
  });
}, uD = /url\(['"]?#([^'"]+)['"]?\)/, cD = (e, A) => {
  if (!A) return;
  if (!uD.test(A)) return A;
  const t = A.match(uD);
  return e[t[1]];
}, vy = (e) => (A) => {
  var t, r;
  const n = cD(e, (t = A.props) === null || t === void 0 ? void 0 : t.fill), i = cD(e, (r = A.props) === null || r === void 0 ? void 0 : r.clipPath), a = Object.assign({}, A.props, {
    fill: n,
    clipPath: i
  }), o = A.children ? A.children.map(vy(e)) : void 0;
  return Object.assign({}, A, {
    props: a,
    children: o
  });
}, CX = (e) => {
  if (!e.children) return e;
  const A = fX(e), t = e.children.map(vy(A));
  return Object.assign({}, e, {
    children: t
  });
}, EX = (e) => hX(CX(e)), yy = (e) => {
  if (!e) return null;
  const A = e.split(/[,\s]+/).map(parseFloat);
  return A.length !== 4 ? null : {
    minX: A[0],
    minY: A[1],
    maxX: A[2],
    maxY: A[3]
  };
}, QX = (e) => {
  const A = yy(e.props.viewBox);
  return A ? {
    width: A.maxX,
    height: A.maxY
  } : e.props.width && e.props.height ? {
    width: parseFloat(e.props.width),
    height: parseFloat(e.props.height)
  } : {
    width: 0,
    height: 0
  };
}, wX = ["x", "y", "clipPath", "clipRule", "opacity", "fill", "fillOpacity", "fillRule", "stroke", "strokeLinecap", "strokeLinejoin", "strokeOpacity", "strokeWidth", "textAnchor", "dominantBaseline", "color", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "opacity", "textDecoration", "lineHeight", "textAlign", "visibility", "wordSpacing"], IX = (e) => {
  const A = e.props || {};
  return FC(wX, A);
}, by = (e) => {
  if (!e.children) return e;
  const A = IX(e), t = e.children.map((r) => {
    const n = Object.assign({}, A, r.props || {}), i = Object.assign({}, r, {
      props: n
    });
    return by(i);
  });
  return Object.assign({}, e, {
    children: t
  });
}, DX = (e) => {
  const A = e.replace(/[\s\r\t\n]+/gm, " ").replace(/^defer\s/, "").split(" "), t = A[0] || "xMidYMid", r = A[1] || "meet";
  return {
    align: t,
    meetOrSlice: r
  };
}, mX = ["width", "height", "color", "stroke", "strokeWidth", "opacity", "fillOpacity", "strokeOpacity", "fill", "fillRule", "clipPath", "offset", "transform", "strokeLinejoin", "strokeLinecap", "strokeDasharray"], MX = ["y", "y1", "y2", "height", "cy", "ry"], pX = ["x", "x1", "x2", "width", "cx", "rx"], TE = (e) => (A) => A.type === e, vX = TE(oi), Fy = TE(Ue), yX = TE(qi), bX = (e) => (A) => Qm(A, (t, r) => {
  const n = Br(t);
  return n && MX.includes(r) ? n.percent * e.height : n && pX.includes(r) ? n.percent * e.width : t;
}), _d = (e) => {
  const A = Br(e);
  return A ? A.percent : parseFloat(e);
}, FX = (e) => (A) => {
  let t = bX(e)(A.props);
  return t = Jg({
    x: parseFloat,
    x1: parseFloat,
    x2: parseFloat,
    y: parseFloat,
    y1: parseFloat,
    y2: parseFloat,
    r: parseFloat,
    rx: parseFloat,
    ry: parseFloat,
    cx: parseFloat,
    cy: parseFloat,
    width: parseFloat,
    height: parseFloat,
    offset: _d,
    fill: xc,
    opacity: _d,
    stroke: xc,
    stopOpacity: _d,
    stopColor: xc,
    transform: Fv
  }, t), Object.assign({}, A, {
    props: t
  });
}, LX = (e) => {
  const A = e.style || {}, t = Object.assign({}, A, e.props);
  return Object.assign({}, e, {
    props: t
  });
}, RX = (e) => {
  const A = (r) => r === "none" ? null : r, t = Qm(e.props, A);
  return Object.assign({}, e, {
    props: t
  });
}, GX = (e) => {
  const A = e.props || {}, t = FC(mX, A), r = Object.assign({}, t, e.style || {});
  return Object.assign({}, e, {
    style: r
  });
}, xX = (e) => {
  const A = Jg({
    width: parseFloat,
    height: parseFloat,
    viewBox: yy,
    preserveAspectRatio: DX
  }, e.props);
  return Object.assign({}, e, {
    props: A
  });
}, kX = (e) => ({
  type: fC,
  props: {},
  children: [e]
}), UX = (e) => {
  if (!Fy(e) || !e.children) return e;
  const A = (r) => yX(r) ? kX(r) : r, t = e.children.map(A);
  return Object.assign({}, e, {
    children: t
  });
}, Ly = (e) => (A) => {
  if (Fy(A)) return gX(e, A);
  if (!A.children) return A;
  const t = A.children.map(Ly(e));
  return Object.assign({}, A, {
    children: t
  });
}, YX = (e) => en(FX(e), UX, RX, LX), Ry = (e) => (A) => {
  if (!A.children) return A;
  const t = en(Ry(e), YX(e)), r = A.children.map(t);
  return Object.assign({}, A, {
    children: r
  });
}, HX = (e, A) => {
  const t = QX(e);
  return en(EX, Ly(A), xX, GX, by, Ry(t))(e);
}, Gy = (e, A) => {
  if (!e.children) return e;
  const t = (i) => Gy(i, A), r = vX(e) ? HX(e, A) : e, n = r.children.map(t);
  return Object.assign({}, r, {
    children: n
  });
};
let ac;
const SX = async () => {
  ac || (ac = await he.loadYoga());
  const e = ac.Config.create();
  return e.setPointScaleFactor(0), {
    node: {
      create: () => ac.Node.createWithConfig(e)
    }
  };
}, NX = async (e) => {
  const A = await SX();
  return Object.assign({}, e, {
    yoga: A
  });
}, gD = (e) => e.style.zIndex, TX = (e) => e.type !== xg && e.type !== oi, PX = (e, A) => {
  const t = gD(e), r = gD(A);
  return !t && !r ? 0 : t ? r ? r - t : -1 : 1;
}, xy = (e) => {
  if (!e.children) return e;
  const t = (TX(e) ? e.children.sort(PX) : e.children).map(xy);
  return Object.assign({}, e, {
    children: t
  });
}, ki = {}, ky = h_(), zX = (e) => function() {
  return e(...arguments).then((A) => A, (A) => A);
}, jX = () => zX(wy), VX = (e) => e !== "️", BD = (e, A) => Array.from(e).filter(A ? () => !0 : VX).map((t) => t.codePointAt(0).toString(16)).join("-"), OX = (e, A) => {
  const {
    url: t,
    format: r,
    builder: n,
    withVariationSelectors: i
  } = A;
  return typeof n == "function" ? n(BD(e, i)) : "" + t + BD(e, i) + "." + r;
}, fD = (e, A) => {
  if (!A || !A.url && !A.builder) return [];
  const t = [];
  return Array.from(e.matchAll(ky)).forEach((r) => {
    const n = r[0];
    if (!ki[n] || ki[n].loading) {
      const i = OX(n, A);
      ki[n] = {
        loading: !0
      };
      const a = jX();
      t.push(a({
        uri: i
      }).then((o) => {
        ki[n].loading = !1, ki[n].data = o.data;
      }));
    }
  }), t;
}, JX = ["©️", "®", "™"], WX = (e) => {
  const A = [];
  for (let t = 0; t < e.length; t += 1) {
    const r = e[t];
    let n = 0;
    Array.from(r.string.matchAll(ky)).forEach((i) => {
      const {
        index: a
      } = i, o = i[0], s = JX.includes(o), l = r.attributes.fontSize, u = r.string.slice(n, a + i[0].length);
      ki[o] && ki[o].data ? A.push({
        string: u.replace(i, "￼"),
        attributes: {
          ...r.attributes,
          attachment: {
            width: l,
            height: l,
            yOffset: Math.floor(l * 0.1),
            image: ki[o].data
          }
        }
      }) : s ? A.push({
        string: u,
        attributes: r.attributes
      }) : A.push({
        string: u.replace(i, "\0"),
        attributes: r.attributes
      }), n = a + o.length;
    }), n < r.string.length && A.push({
      string: r.string.slice(n),
      attributes: r.attributes
    });
  }
  return A;
}, ZX = (e) => {
  var A, t, r;
  return ((A = e.props) === null || A === void 0 ? void 0 : A.src) || ((t = e.props) === null || t === void 0 ? void 0 : t.source) || ((r = e.props) === null || r === void 0 ? void 0 : r.href);
}, KX = async (e) => {
  const A = typeof e == "function" ? await e() : await e;
  return typeof A == "string" ? {
    uri: A
  } : A;
}, _X = async (e) => {
  const A = ZX(e), {
    cache: t
  } = e.props;
  if (!A) {
    console.warn(!1, 'Image should receive either a "src" or "source" prop');
    return;
  }
  try {
    const r = await KX(A);
    if (!r)
      throw new Error(`Image's "src" or "source" prop returned ` + r);
    e.image = await wy(r, {
      cache: t
    }), e.image.key = r.data ? r.data.toString() : r.uri;
  } catch (r) {
    e.image = {
      width: 0,
      height: 0,
      key: null
    }, console.warn(r.message);
  }
}, XX = (e) => e.type === Xi, qX = (e, A) => {
  var t;
  const r = [], n = ((t = A.children) === null || t === void 0 ? void 0 : t.slice(0)) || [], i = e ? e.getEmojiSource() : null;
  for (; n.length > 0; ) {
    var a;
    const o = n.shift();
    XX(o) && r.push(_X(o)), e && (a = o.style) !== null && a !== void 0 && a.fontFamily && r.push(e.load(o.style)), typeof o == "string" && r.push(...fD(o, i)), typeof o.value == "string" && r.push(...fD(o.value, i)), o.children && o.children.forEach((s) => {
      n.push(s);
    });
  }
  return r;
}, dD = async (e, A) => {
  const t = qX(A, e);
  return await Promise.all(t), e;
}, $X = (e) => e.type === Lg, hD = {
  color: "blue",
  textDecoration: "underline"
}, Aq = (e, A) => {
  let t = A.style;
  return $X(A) && (t = Array.isArray(A.style) ? [hD, ...A.style] : [hD, A.style]), WW(e, t);
}, Uy = (e) => (A) => {
  const t = Aq(e, A);
  if (!A.children) return Object.assign({}, A, {
    style: t
  });
  const r = A.children.map(Uy(e));
  return Object.assign({}, A, {
    style: t,
    children: r
  });
}, Yy = (e) => {
  var A, t, r;
  const i = ((A = e.box) === null || A === void 0 ? void 0 : A.width) || e.style.width, a = ((t = e.box) === null || t === void 0 ? void 0 : t.height) || e.style.height, o = ((r = e.props) === null || r === void 0 ? void 0 : r.orientation) || "portrait";
  return Uy({
    width: i,
    height: a,
    orientation: o,
    dpi: 72
  })(e);
}, eq = (e) => {
  if (!e.children) return e;
  const A = e.children.map(Yy);
  return Object.assign({}, e, {
    children: A
  });
}, CD = (e) => (A) => {
  var t, r;
  return yt((t = A.style) === null || t === void 0 ? void 0 : t[e]) ? "50%" : (r = A.style) === null || r === void 0 ? void 0 : r[e];
}, tq = (e) => {
  if (!e.box) return {};
  const {
    left: A,
    top: t,
    width: r,
    height: n
  } = e.box, i = CD("transformOriginX")(e), a = CD("transformOriginY")(e), o = Br(i), s = Br(a), l = o ? r * o.percent : i, u = s ? n * s.percent : a;
  return {
    left: A + l,
    top: t + u
  };
}, Hy = (e) => {
  const A = tq(e), t = Object.assign({}, e, {
    origin: A
  });
  if (!e.children) return t;
  const r = e.children.map(Hy);
  return Object.assign({}, t, {
    children: r
  });
}, rq = (e) => {
  if (!e.children) return e;
  const A = e.children.map(Hy);
  return Object.assign({}, e, {
    children: A
  });
}, nq = (e) => typeof e == "string" ? {
  title: e,
  fit: !1,
  expanded: !1
} : e, iq = (e) => {
  let A = 0;
  const r = (e.children || []).slice(0).map((a) => ({
    value: a,
    parent: null
  }));
  for (; r.length > 0; ) {
    var n;
    const a = r.shift(), o = a.value;
    let s = a.parent;
    if ((n = o.props) !== null && n !== void 0 && n.bookmark) {
      var i;
      const l = nq(o.props.bookmark), g = {
        ref: A++,
        parent: (i = s) === null || i === void 0 ? void 0 : i.ref,
        ...l
      };
      o.props.bookmark = g, s = g;
    }
    o.children && o.children.forEach((l) => {
      r.push({
        value: l,
        parent: s
      });
    });
  }
  return e;
}, aq = ["portrait", "landscape"], oq = (e) => {
  var A;
  const t = ((A = e.props) === null || A === void 0 ? void 0 : A.orientation) || "portrait";
  return aq.includes(t) ? t : "portrait";
}, sq = (e) => oq(e) === "landscape", lq = {
  "4A0": [4767.87, 6740.79],
  "2A0": [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756],
  FOLIO: [612, 936],
  LEGAL: [612, 1008],
  LETTER: [612, 792],
  TABLOID: [792, 1224],
  ID1: [153, 243]
}, PE = (e) => ({
  width: e[0],
  height: e[1]
}), uq = (e) => ({
  width: e.height,
  height: e.width
}), Xd = (e, A) => ({
  width: e.width ? e.width * (72 / A) : e.width,
  height: e.height ? e.height * (72 / A) : e.height
}), cq = (e) => PE(lq[e.toUpperCase()]), gq = (e) => PE([e]), Bq = (e) => {
  var A, t;
  const r = ((A = e.props) === null || A === void 0 ? void 0 : A.size) || "A4", n = parseFloat(((t = e.props) === null || t === void 0 ? void 0 : t.dpi) || 72), i = typeof r;
  let a;
  return i === "string" ? a = cq(r) : Array.isArray(r) ? (a = PE(r), a = Xd(a, n)) : i === "number" ? (a = gq(r), a = Xd(a, n)) : (a = r, a = Xd(a, n)), sq(e) ? uq(a) : a;
}, fq = (e) => {
  const A = Bq(e), t = FE(e.style || {});
  return {
    ...e,
    style: {
      ...t,
      ...A
    }
  };
}, dq = (e) => {
  if (!e.children) return e;
  const A = e.children.map(fq);
  return Object.assign({}, e, {
    children: A
  });
}, zh = (e) => {
  var A;
  return ((A = e.props) === null || A === void 0 ? void 0 : A.fixed) === !0;
}, hq = (e, A) => {
  let t = 0;
  if (!e.lines) return 0;
  for (let r = 0; r < e.lines.length; r += 1) {
    const n = e.lines[r];
    if (t + n.box.height > A) return r;
    t += n.box.height;
  }
  return e.lines.length;
}, Cq = (e, A) => {
  let t = 0;
  if (!e.lines) return t;
  for (let r = 0; r < A; r += 1) {
    const n = e.lines[r];
    if (!n) break;
    t += n.box.height;
  }
  return t;
}, Eq = (e, A) => {
  const t = kf(e, ["box", "top"], 0), r = kf(e, ["props", "widows"], 2), n = kf(e, ["props", "orphans"], 2), i = e.lines.length, a = hq(e, A - t);
  return a === 0 ? 0 : i < n ? i : a < n || i < n + r ? 0 : i === n + r ? n : i - a < r ? i - r : a;
}, Qq = (e, A) => {
  const t = Eq(e, A), r = Cq(e, t), n = e.box.height - r, i = Object.assign({}, e, {
    box: {
      ...e.box,
      height: r,
      borderBottomWidth: 0
    },
    style: {
      ...e.style,
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    lines: e.lines.slice(0, t)
  }), a = Object.assign({}, e, {
    box: {
      ...e.box,
      top: 0,
      height: n,
      borderTopWidth: 0
    },
    style: {
      ...e.style,
      marginTop: 0,
      paddingTop: 0,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    lines: e.lines.slice(t)
  });
  return [i, a];
}, wq = (e) => {
  var A;
  return ((A = e.box) === null || A === void 0 ? void 0 : A.top) || 0;
}, Iq = (e) => {
  var A;
  return !yt((A = e.style) === null || A === void 0 ? void 0 : A.height);
}, Dq = (e, A) => {
  if (!e) return [null, null];
  const t = wq(e), r = Object.assign({}, e, {
    box: {
      ...e.box,
      borderBottomWidth: 0
    },
    style: {
      ...e.style,
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  });
  r.style.height = A - t;
  const n = Iq(e) ? e.box.height - (A - t) : null, i = Object.assign({}, e, {
    box: {
      ...e.box,
      top: 0,
      borderTopWidth: 0
    },
    style: {
      ...e.style,
      marginTop: 0,
      paddingTop: 0,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }
  });
  return n && (i.style.height = n), [r, i];
}, mq = [oi, Rg, Xi, Gg], Sy = (e) => {
  var A;
  return mq.includes(e.type) ? !1 : yt((A = e.props) === null || A === void 0 ? void 0 : A.wrap) ? !0 : e.props.wrap;
}, oc = (e, A) => {
  const {
    yogaNode: t
  } = e;
  return t ? t.getComputedPadding(A) : null;
}, ru = (e) => {
  const {
    style: A,
    box: t
  } = e, r = oc(e, he.Edge.Top) || (t == null ? void 0 : t.paddingTop) || (A == null ? void 0 : A.paddingTop) || (A == null ? void 0 : A.paddingVertical) || (A == null ? void 0 : A.padding) || 0, n = oc(e, he.Edge.Right) || (t == null ? void 0 : t.paddingRight) || (A == null ? void 0 : A.paddingRight) || (A == null ? void 0 : A.paddingHorizontal) || (A == null ? void 0 : A.padding) || 0, i = oc(e, he.Edge.Bottom) || (t == null ? void 0 : t.paddingBottom) || (A == null ? void 0 : A.paddingBottom) || (A == null ? void 0 : A.paddingVertical) || (A == null ? void 0 : A.padding) || 0, a = oc(e, he.Edge.Left) || (t == null ? void 0 : t.paddingLeft) || (A == null ? void 0 : A.paddingLeft) || (A == null ? void 0 : A.paddingHorizontal) || (A == null ? void 0 : A.padding) || 0;
  return {
    paddingTop: r,
    paddingRight: n,
    paddingBottom: i,
    paddingLeft: a
  };
}, Mq = (e) => {
  var A;
  const {
    paddingBottom: t
  } = ru(e);
  return ((A = e.style) === null || A === void 0 ? void 0 : A.height) - t;
}, pq = (e) => {
  var A;
  const t = (A = e.style) === null || A === void 0 ? void 0 : A.height, {
    paddingTop: r,
    paddingBottom: n
  } = ru(e);
  return t - n - r;
}, ED = (e) => typeof e == "string", vq = (e) => typeof e == "number", yq = (e) => e && e.type === Symbol.for("react.fragment"), Ks = (e) => {
  if (!e) return [];
  if (ED(e) || vq(e))
    return [{
      type: qi,
      value: "" + e
    }];
  if (yq(e))
    return Ks(e.props.children);
  if (Array.isArray(e))
    return e.reduce((a, o) => a.concat(Ks(o)), []);
  if (!ED(e.type))
    return Ks(e.type(e.props));
  const {
    type: A,
    props: {
      style: t = {},
      children: r = [],
      ...n
    }
  } = e, i = Og(r).reduce((a, o) => a.concat(Ks(o)), []);
  return [{
    type: A,
    style: t,
    props: n,
    box: {},
    children: i
  }];
}, bq = (e) => {
  var A;
  return ((A = e.props) === null || A === void 0 ? void 0 : A.break) || !1;
}, Fq = (e) => {
  var A;
  return ((A = e.props) === null || A === void 0 ? void 0 : A.minPresenceAhead) || 0;
}, Lq = (e) => Math.max(...e.map((A) => A.box.top + A.box.height)), Rq = (e) => e.box.top + e.box.height + e.box.marginBottom + Fq(e), Gq = (e, A) => {
  const t = Rq(e), r = Lq(A.filter((n) => {
    var i;
    return !((i = n.props) !== null && i !== void 0 && i.fixed);
  }));
  return Math.min(t, r);
}, xq = (e, A, t) => {
  var r;
  if ((r = e.props) !== null && r !== void 0 && r.fixed) return !1;
  const n = t < e.box.top + e.box.height, i = Sy(e), a = Gq(e, A), o = e.box.top > e.box.marginTop;
  return bq(e) || n && !i || !n && a > t && o;
}, kq = [
  8232,
  // LINE_SEPARATOR
  8233
  // PARAGRAPH_SEPARATOR
], Uq = (e) => kq.reduce((A, t) => e && e.hasGlyphForCodePoint && e.hasGlyphForCodePoint(t) ? A : [...A, String.fromCharCode(t)], []), Yq = (e) => e.map((A) => {
  const t = Uq(A.attributes.font), r = new RegExp(t.join("|"));
  return {
    string: A.string.replace(r, ""),
    attributes: A.attributes
  };
}), QD = [Yq, WX], Hq = (e) => e.type === Xi, Sq = (e) => e.type === qi, Ny = function(e, A, t, r) {
  var n, i;
  if (r === void 0 && (r = 0), !A) return [{
    string: ""
  }];
  let a = [];
  const {
    color: o = "black",
    direction: s = "ltr",
    fontFamily: l = "Helvetica",
    fontWeight: u,
    fontStyle: g,
    fontSize: d = 18,
    textAlign: h,
    lineHeight: C,
    textDecoration: E,
    textDecorationColor: I,
    textDecorationStyle: b,
    textTransform: y,
    letterSpacing: p,
    textIndent: Q,
    opacity: w,
    verticalAlign: Y
  } = A.style, L = (typeof l == "string" ? [l] : [...l || []]).map((Z) => {
    if (typeof Z != "string") return Z;
    const M = {
      fontFamily: Z,
      fontWeight: u,
      fontStyle: g
    }, R = e ? e.getFont(M) : null;
    return R ? R.data : Z;
  }), S = r === 0 ? null : A.style.backgroundColor, P = {
    font: L,
    color: o,
    opacity: w,
    fontSize: d,
    direction: s,
    verticalAlign: Y,
    backgroundColor: S,
    indent: Q,
    characterSpacing: p,
    strikeStyle: b,
    underlineStyle: b,
    underline: E === "underline" || E === "underline line-through" || E === "line-through underline",
    strike: E === "line-through" || E === "underline line-through" || E === "line-through underline",
    strikeColor: I || o,
    underlineColor: I || o,
    link: t || ((n = A.props) === null || n === void 0 ? void 0 : n.src) || ((i = A.props) === null || i === void 0 ? void 0 : i.href),
    lineHeight: C ? C * d : null,
    align: h || (s === "rtl" ? "right" : "left")
  };
  for (let Z = 0; Z < A.children.length; Z += 1) {
    const M = A.children[Z];
    Hq(M) ? a.push({
      string: "￼",
      attributes: {
        ...P,
        attachment: {
          width: M.style.width || d,
          height: M.style.height || d,
          image: M.image.data
        }
      }
    }) : Sq(M) ? a.push({
      string: Dy(M.value, y),
      attributes: P
    }) : M && a.push(...Ny(e, M, P.link, r + 1));
  }
  for (let Z = 0; Z < QD.length; Z += 1) {
    const M = QD[Z];
    a = M(a);
  }
  return a;
}, Nq = (e, A) => {
  const t = Ny(e, A);
  return Iy(t);
}, Tq = {
  bidi: Zv,
  linebreaker: Kv,
  justification: qv,
  textDecoration: $v,
  scriptItemizer: Ay,
  wordHyphenation: ty,
  fontSubstitution: My
}, Pq = Wv(Tq), zq = (e) => {
  var A;
  return (A = e.style) === null || A === void 0 ? void 0 : A.maxLines;
}, jq = (e) => {
  var A;
  return (A = e.style) === null || A === void 0 ? void 0 : A.textOverflow;
}, Vq = (e, A, t) => {
  const r = zq(t), n = jq(t);
  return {
    x: 0,
    y: 0,
    width: e,
    maxLines: r,
    height: A || 1 / 0,
    truncateMode: n
  };
}, Oq = (e, A) => ({
  hyphenationPenalty: A.props.hyphenationPenalty,
  shrinkWhitespaceFactor: {
    before: -0.5,
    after: -0.5
  },
  hyphenationCallback: A.props.hyphenationCallback || (e == null ? void 0 : e.getHyphenationCallback()) || null
}), jh = (e, A, t, r) => {
  const n = Nq(r, e), i = Vq(A, t, e), a = Oq(r, e);
  return Pq(n, i, a).reduce((s, l) => [...s, ...l], []);
}, Ty = (e) => (A) => A.type === e, Jq = Ty(oi), Py = Ty(Ue), Wq = (e) => !Jq(e) && !Py(e), Zq = (e) => Py(e) && !e.lines, zE = (e, A) => {
  if (Zq(e)) {
    const t = e.box.width - (e.box.paddingRight + e.box.paddingLeft), r = e.box.height - (e.box.paddingTop + e.box.paddingBottom);
    e.lines = jh(e, t, r, A);
  }
  if (Wq(e)) {
    if (!e.children) return e;
    const t = (n) => zE(n, A), r = e.children.map(t);
    return Object.assign({}, e, {
      children: r
    });
  }
  return e;
}, zy = ["color", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "opacity", "textDecoration", "textTransform", "lineHeight", "textAlign", "visibility", "wordSpacing"], Kq = [...zy, "backgroundColor"], _q = (e) => e.type === oi, Xq = (e) => e.type === Ue, qq = (e, A, t) => {
  switch (e) {
    case "textDecoration":
      return [t, A].filter((r) => r && r !== "none").join(" ");
    default:
      return A;
  }
}, $q = (e, A) => {
  const t = {
    ...e
  };
  return Object.entries(A).forEach((r) => {
    let [n, i] = r;
    t[n] = qq(n, i, e[n]);
  }), t;
}, A$ = (e) => (A) => {
  const t = $q(e, A.style || {});
  return Object.assign({}, A, {
    style: t
  });
}, jE = (e) => {
  if (_q(e) || !e.children) return e;
  const A = Xq(e) ? Kq : zy, t = FC(A, e.style || {}), r = en(jE, A$(t)), n = e.children.map(r);
  return Object.assign({}, e, {
    children: n
  });
}, sc = (e, A) => {
  const {
    yogaNode: t
  } = e;
  return t ? t.getComputedMargin(A) : null;
}, VE = (e) => {
  const {
    style: A,
    box: t
  } = e, r = sc(e, he.Edge.Top) || (t == null ? void 0 : t.marginTop) || (A == null ? void 0 : A.marginTop) || (A == null ? void 0 : A.marginVertical) || (A == null ? void 0 : A.margin) || 0, n = sc(e, he.Edge.Right) || (t == null ? void 0 : t.marginRight) || (A == null ? void 0 : A.marginRight) || (A == null ? void 0 : A.marginHorizontal) || (A == null ? void 0 : A.margin) || 0, i = sc(e, he.Edge.Bottom) || (t == null ? void 0 : t.marginBottom) || (A == null ? void 0 : A.marginBottom) || (A == null ? void 0 : A.marginVertical) || (A == null ? void 0 : A.margin) || 0, a = sc(e, he.Edge.Left) || (t == null ? void 0 : t.marginLeft) || (A == null ? void 0 : A.marginLeft) || (A == null ? void 0 : A.marginHorizontal) || (A == null ? void 0 : A.margin) || 0;
  return {
    marginTop: r,
    marginRight: n,
    marginBottom: i,
    marginLeft: a
  };
}, e$ = (e) => {
  const {
    yogaNode: A
  } = e;
  return {
    top: (A == null ? void 0 : A.getComputedTop()) || 0,
    right: (A == null ? void 0 : A.getComputedRight()) || 0,
    bottom: (A == null ? void 0 : A.getComputedBottom()) || 0,
    left: (A == null ? void 0 : A.getComputedLeft()) || 0
  };
}, t$ = {
  width: 0,
  height: 0
}, r$ = (e) => {
  const {
    yogaNode: A
  } = e;
  return A ? {
    width: A.getComputedWidth(),
    height: A.getComputedHeight()
  } : t$;
}, lc = (e, A) => e ? e.getComputedBorder(A) : 0, n$ = (e) => {
  const {
    yogaNode: A
  } = e;
  return {
    borderTopWidth: lc(A, he.Edge.Top),
    borderRightWidth: lc(A, he.Edge.Right),
    borderBottomWidth: lc(A, he.Edge.Bottom),
    borderLeftWidth: lc(A, he.Edge.Left)
  };
}, i$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  return t && t.setDisplay(e === "none" ? he.Display.None : he.Display.Flex), A;
}, a$ = {
  hidden: he.Overflow.Hidden,
  scroll: he.Overflow.Scroll
}, o$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  if (!yt(e) && t) {
    const r = a$[e] || he.Overflow.Visible;
    t.setOverflow(r);
  }
  return A;
}, s$ = {
  wrap: he.Wrap.Wrap,
  "wrap-reverse": he.Wrap.WrapReverse
}, l$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  if (t) {
    const r = s$[e] || he.Wrap.NoWrap;
    t.setFlexWrap(r);
  }
  return A;
}, zt = (e, A) => (t) => (r) => {
  const {
    yogaNode: n
  } = r;
  if (!yt(t) && n) {
    const g = !yt(A), d = "set" + LC(e), h = d + "Auto", C = d + "Percent", E = Br(t);
    if (E && !n[C])
      throw new Error("You can't pass percentage values to " + e + " property");
    if (E)
      if (g) {
        var i;
        (i = n[C]) === null || i === void 0 || i.call(n, A, E.value);
      } else {
        var a;
        (a = n[C]) === null || a === void 0 || a.call(n, E.value);
      }
    else if (t === "auto")
      if (g) {
        var o;
        (o = n[h]) === null || o === void 0 || o.call(n, A);
      } else {
        var s;
        (s = n[h]) === null || s === void 0 || s.call(n);
      }
    else if (g) {
      var l;
      (l = n[d]) === null || l === void 0 || l.call(n, A, t);
    } else {
      var u;
      (u = n[d]) === null || u === void 0 || u.call(n, t);
    }
  }
  return r;
}, u$ = (e) => (A) => zt("flexGrow")(e || 0)(A), c$ = zt("flexBasis"), g$ = {
  "flex-start": he.Align.FlexStart,
  center: he.Align.Center,
  "flex-end": he.Align.FlexEnd,
  stretch: he.Align.Stretch,
  baseline: he.Align.Baseline,
  "space-between": he.Align.SpaceBetween,
  "space-around": he.Align.SpaceAround
}, OE = (e) => (A) => (t) => {
  const {
    yogaNode: r
  } = t, n = e === "items" ? he.Align.Stretch : he.Align.Auto;
  if (r) {
    const i = g$[A] || n;
    r["setAlign" + LC(e)](i);
  }
  return t;
}, B$ = OE("self"), f$ = OE("items"), d$ = (e) => (A) => zt("flexShrink")(e || 1)(A), h$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  return !yt(e) && t && t.setAspectRatio(e), A;
}, C$ = OE("content"), E$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  return !yt(e) && t && t.setPositionType(e === "absolute" ? he.PositionType.Absolute : he.PositionType.Relative), A;
}, Q$ = {
  row: he.FlexDirection.Row,
  "row-reverse": he.FlexDirection.RowReverse,
  "column-reverse": he.FlexDirection.ColumnReverse
}, w$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  if (t) {
    const r = Q$[e] || he.FlexDirection.Column;
    t.setFlexDirection(r);
  }
  return A;
}, I$ = {
  center: he.Justify.Center,
  "flex-end": he.Justify.FlexEnd,
  "space-between": he.Justify.SpaceBetween,
  "space-around": he.Justify.SpaceAround,
  "space-evenly": he.Justify.SpaceEvenly
}, D$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  if (!yt(e) && t) {
    const r = I$[e] || he.Justify.FlexStart;
    t.setJustifyContent(r);
  }
  return A;
}, m$ = zt("margin", he.Edge.Top), M$ = zt("margin", he.Edge.Right), p$ = zt("margin", he.Edge.Bottom), v$ = zt("margin", he.Edge.Left), y$ = zt("padding", he.Edge.Top), b$ = zt("padding", he.Edge.Right), F$ = zt("padding", he.Edge.Bottom), L$ = zt("padding", he.Edge.Left), R$ = zt("border", he.Edge.Top), G$ = zt("border", he.Edge.Right), x$ = zt("border", he.Edge.Bottom), k$ = zt("border", he.Edge.Left), U$ = zt("position", he.Edge.Top), Y$ = zt("position", he.Edge.Right), H$ = zt("position", he.Edge.Bottom), S$ = zt("position", he.Edge.Left), N$ = zt("width"), T$ = zt("minWidth"), P$ = zt("maxWidth"), z$ = zt("height"), j$ = zt("minHeight"), V$ = zt("maxHeight"), jy = (e, A) => {
  if (Br(A))
    throw new Error("You can't pass percentage values to " + e + " property");
}, O$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  return !yt(e) && t && (jy("rowGap", e), t.setGap(he.Gutter.Row, e)), A;
}, J$ = (e) => (A) => {
  const {
    yogaNode: t
  } = A;
  return !yt(e) && t && (jy("columnGap", e), t.setGap(he.Gutter.Column, e)), A;
}, W$ = (e) => e ? (e.maxX - e.minX) / (e.maxY - e.minY) : null, Z$ = (e, A) => (t, r, n, i) => {
  const a = W$(A.props.viewBox) || 1;
  return r === he.MeasureMode.Exactly || r === he.MeasureMode.AtMost ? {
    width: t,
    height: t / a
  } : i === he.MeasureMode.Exactly ? {
    width: n * a
  } : {};
}, wD = (e) => e.lines ? Math.max(0, ...e.lines.map((A) => A.xAdvance)) : 0, ID = (e) => e.lines ? e.lines.reduce((A, t) => A + t.box.height, 0) : -1, K$ = {
  center: 0.5,
  right: 1
}, _$ = (e, A, t) => (r, n, i) => {
  if (n === he.MeasureMode.Exactly)
    return A.lines || (A.lines = jh(A, r, i, t)), {
      height: ID(A)
    };
  if (n === he.MeasureMode.AtMost) {
    var a;
    const o = K$[(a = A.style) === null || a === void 0 ? void 0 : a.textAlign] || 0;
    return A.lines || (A.lines = jh(A, r, i, t), A.alignOffset = (r - wD(A)) * o), {
      height: ID(A),
      width: Math.min(r, wD(A))
    };
  }
  return {};
}, X$ = (e) => {
  var A;
  return (A = e.image) !== null && A !== void 0 && A.data ? e.image.width / e.image.height : 1;
}, Vy = (e) => {
  var A;
  return yt((A = e.box) === null || A === void 0 ? void 0 : A.height);
}, q$ = 10, $$ = (e, A) => (t, r, n, i) => {
  const a = X$(A), o = VE(A), s = ru(e), l = Vy(e) ? 1 / 0 : e.box.height - s.paddingTop - s.paddingBottom - o.marginTop - o.marginBottom - q$;
  if (!A.image) return {
    width: 0,
    height: 0
  };
  if (r === he.MeasureMode.Exactly && i === he.MeasureMode.Undefined) {
    const u = t / a;
    return {
      height: Math.min(l, u)
    };
  }
  if (i === he.MeasureMode.Exactly && (r === he.MeasureMode.AtMost || r === he.MeasureMode.Undefined))
    return {
      width: Math.min(n * a, t)
    };
  if (r === he.MeasureMode.Exactly && i === he.MeasureMode.AtMost) {
    const u = t / a;
    return {
      height: Math.min(n, l, u)
    };
  }
  return r === he.MeasureMode.AtMost && i === he.MeasureMode.AtMost ? a > 1 ? {
    width: t,
    height: Math.min(t / a, n)
  } : {
    height: n,
    width: Math.min(n * a, t)
  } : {
    height: n,
    width: t
  };
}, AAA = 10, DD = (e) => Math.max(-1 / 0, ...e), eAA = () => {
  const e = {}, A = [], t = () => e, r = (s, l) => A.push([s, l]), n = function() {
    return r(...arguments), e;
  }, i = (s, l, u, g) => (r(s, l), r(s + u, l), r(s, l + g), r(s + u, l + g), e), a = (s, l, u, g) => (g = g || u, r(s - u, l - g), r(s + u, l - g), r(s + u, l + g), r(s - u, l + g), e), o = function() {
    return A.push(...arguments), e;
  };
  return e.rect = i, e.moveTo = n, e.lineTo = n, e.circle = a, e.polygon = o, e.ellipse = a, e.roundedRect = i, e.text = t, e.path = t, e.lineWidth = t, e.bezierCurveTo = t, e.quadraticCurveTo = t, e.scale = t, e.rotate = t, e.translate = t, e.dash = t, e.clip = t, e.save = t, e.fill = t, e.font = t, e.stroke = t, e.lineCap = t, e.opacity = t, e.restore = t, e.lineJoin = t, e.fontSize = t, e.fillColor = t, e.miterLimit = t, e.strokeColor = t, e.fillOpacity = t, e.strokeOpacity = t, e.linearGradient = t, e.radialGradient = t, e.getWidth = () => DD(A.map((s) => s[0])), e.getHeight = () => DD(A.map((s) => s[1])), e;
}, tAA = (e, A) => () => {
  const t = VE(A), r = ru(e), n = Vy(e) ? 1 / 0 : e.box.height - r.paddingTop - r.paddingBottom - t.marginTop - t.marginBottom - AAA, i = eAA();
  A.props.paint(i);
  const a = i.getWidth(), o = Math.min(n, i.getHeight());
  return {
    width: a,
    height: o
  };
}, so = (e) => (A) => A.type === e, Oy = so(oi), Jy = so(Ue), rAA = so(Rg), nAA = so(os), iAA = so(Xi), aAA = so(Gg), oAA = so(qi), sAA = (e) => {
  const A = nAA(e) ? e.box.height : e.style.height;
  return z$(A);
}, lAA = (e) => {
  en(sAA(e), N$(e.style.width), T$(e.style.minWidth), P$(e.style.maxWidth), j$(e.style.minHeight), V$(e.style.maxHeight), m$(e.style.marginTop), M$(e.style.marginRight), p$(e.style.marginBottom), v$(e.style.marginLeft), y$(e.style.paddingTop), b$(e.style.paddingRight), F$(e.style.paddingBottom), L$(e.style.paddingLeft), E$(e.style.position), U$(e.style.top), Y$(e.style.right), H$(e.style.bottom), S$(e.style.left), R$(e.style.borderTopWidth), G$(e.style.borderRightWidth), x$(e.style.borderBottomWidth), k$(e.style.borderLeftWidth), i$(e.style.display), w$(e.style.flexDirection), B$(e.style.alignSelf), C$(e.style.alignContent), f$(e.style.alignItems), D$(e.style.justifyContent), l$(e.style.flexWrap), o$(e.style.overflow), h$(e.style.aspectRatio), c$(e.style.flexBasis), u$(e.style.flexGrow), d$(e.style.flexShrink), O$(e.style.rowGap), J$(e.style.columnGap))(e);
}, uAA = (e) => (A) => (e.insertChild(A.yogaNode, e.getChildCount()), A), cAA = (e, A, t) => {
  const {
    yogaNode: r
  } = e;
  return Jy(e) && r.setMeasureFunc(_$(A, e, t)), iAA(e) && r.setMeasureFunc($$(A, e)), aAA(e) && r.setMeasureFunc(tAA(A, e)), Oy(e) && r.setMeasureFunc(Z$(A, e)), e;
}, gAA = (e) => !Jy(e) && !rAA(e) && !Oy(e), Wy = (e, A, t) => (r) => {
  const n = t.node.create(), i = Object.assign({}, r, {
    yogaNode: n
  });
  if (lAA(i), gAA(r) && r.children) {
    const a = en(uAA(n), Wy(e, A, t));
    i.children = r.children.map(a);
  }
  return cAA(i, e, A), i;
}, BAA = (e) => (e.yogaNode.calculateLayout(), e), Zy = (e) => {
  if (oAA(e)) return e;
  const A = Object.assign(ru(e), VE(e), n$(e), e$(e), r$(e)), t = Object.assign({}, e, {
    box: A
  });
  if (!e.children) return t;
  const r = e.children.map(Zy);
  return Object.assign({}, t, {
    children: r
  });
}, Ky = (e) => {
  const A = Object.assign({}, e);
  if (delete A.yogaNode, !e.children) return A;
  const t = e.children.map(Ky);
  return Object.assign({}, A, {
    children: t
  });
}, fAA = (e) => (e.yogaNode && e.yogaNode.freeRecursive(), e), _y = (e, A, t) => yt(e) ? null : en(Ky, fAA, Zy, BAA, Wy(e, A, t))(e), dAA = (e, A) => {
  if (!e.children) return e;
  const t = (n) => _y(n, A, e.yoga), r = e.children.map(t);
  return Object.assign({}, e, {
    children: r
  });
}, Xy = (e) => e.type === Ue, hAA = 1e-3, Vh = (e, A) => Object.assign({}, A, {
  children: e
}), qy = (e) => {
  var A;
  return ((A = e.box) === null || A === void 0 ? void 0 : A.top) || 0;
}, CAA = (e) => e.every(zh), $y = (e) => {
  var A;
  return !yt((A = e.props) === null || A === void 0 ? void 0 : A.render);
}, Ab = en(zE, _y, jE, Yy), EAA = (e) => {
  console.warn("Node of type " + e.type + " can't wrap between pages and it's bigger than available page height");
}, eb = (e, A, t) => {
  const r = [], n = [];
  for (let i = 0; i < t.length; i += 1) {
    const a = t[i], o = t.slice(i + 1), s = o.filter(zh), l = qy(a), u = a.box.height, g = e <= l, d = xq(a, o, e), h = e + hAA < l + u, C = Sy(a), E = u <= A;
    if (zh(a)) {
      n.push(a), r.push(a);
      continue;
    }
    if (g) {
      const I = Object.assign({}, a.box, {
        top: a.box.top - e
      }), b = Object.assign({}, a, {
        box: I
      });
      n.push(b);
      continue;
    }
    if (!E && !C) {
      r.push(a), n.push(...o), EAA(a);
      break;
    }
    if (d) {
      const I = Object.assign({}, a.box, {
        top: a.box.top - e
      }), b = Object.assign({}, a.props, {
        wrap: !0,
        break: !1
      }), y = Object.assign({}, a, {
        box: I,
        props: b
      });
      r.push(...s), n.push(y, ...o);
      break;
    }
    if (h) {
      const [I, b] = IAA(a, e, A);
      if (a.children.length > 0 && I.children.length === 0) {
        if (r.length === 0)
          r.push(a, ...s), n.push(...o);
        else {
          const y = Object.assign({}, a.box, {
            top: a.box.top - e
          }), p = Object.assign({}, a, {
            box: y
          });
          r.push(...s), n.push(p, ...o);
        }
        break;
      }
      I && r.push(I), b && n.push(b);
      continue;
    }
    r.push(a);
  }
  return [r, n];
}, QAA = (e, A, t) => {
  const r = t.children || [], n = e - qy(t);
  return eb(n, A, r);
}, wAA = (e, A, t) => {
  const [r, n] = Dq(e, A), [i, a] = QAA(A, t, e);
  return [Vh(i, r), Vh(a, n)];
}, IAA = (e, A, t) => Xy(e) ? Qq(e, A) : wAA(e, A, t), tb = (e) => {
  const A = e.children || [];
  return $y(e) || A.some(tb);
}, Oh = (e, A) => {
  const t = $y(A), r = function(s) {
    if (s === void 0 && (s = []), t) {
      const l = A.props.render(e);
      return Ks(l).filter(Boolean).map((u) => Oh(e, u));
    }
    return s.map((l) => Oh(e, l));
  }, i = t && Xy(A) ? {
    ...A.box,
    height: 0
  } : A.box, a = r(A.children), o = t ? null : A.lines;
  return Object.assign({}, A, {
    box: i,
    lines: o,
    children: a
  });
}, rb = (e, A, t, r) => {
  if (tb(A)) {
    const n = Oh(e, A);
    return Ab(n, t, r);
  }
  return A;
}, mD = (e, A, t, r) => {
  const n = Mq(e), i = pq(e), a = rb({
    pageNumber: A
  }, e, t, r), o = e.style.height, [s, l] = eb(n, i, a.children), u = (I) => Ab(I, t, r), g = {
    ...e.box,
    height: o
  }, d = u(Object.assign({}, e, {
    box: g,
    children: s
  }));
  if (l.length === 0 || CAA(l)) return [d, null];
  const h = Dh("height", e.box), C = Dh("bookmark", e.props), E = u(Object.assign({}, e, {
    props: C,
    box: h,
    children: l
  }));
  return [d, E];
}, DAA = (e, A, t, r, n) => {
  const a = {
    totalPages: n.length,
    pageNumber: r + 1,
    subPageNumber: t.subPageNumber + 1,
    subPageTotalPages: t.subPageTotalPages
  };
  return rb(a, t, e, A);
}, mAA = (e) => e.map((A, t) => ({
  ...A,
  subPageNumber: t,
  subPageTotalPages: e.length
})), MAA = (e) => Dh(["subPageNumber", "subPageTotalPages"], e), pAA = (e, A, t, r) => {
  var n;
  if (!e) return [];
  if (((n = e.props) === null || n === void 0 ? void 0 : n.wrap) === !1) return [e];
  let i = mD(e, A, t, r);
  const a = [i[0]];
  let o = i[1];
  for (; o !== null; )
    i = mD(o, A + a.length, t, r), a.push(i[0]), o = i[1];
  return a;
}, vAA = (e, A) => {
  let t = [], r = 1;
  for (let n = 0; n < e.children.length; n += 1) {
    const i = e.children[n];
    let a = pAA(i, r, A, e.yoga);
    a = mAA(a), r += a.length, t = t.concat(a);
  }
  return t = t.map(function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return MAA(DAA(A, e.yoga, ...i));
  }), Vh(t, e);
}, MD = (e) => (A) => {
  const t = Br(A);
  return t ? t.percent * e.width : A;
}, pD = (e) => (A) => {
  const t = Br(A);
  return t ? t.percent * e.height : A;
}, yAA = (e) => {
  const A = e.style, t = Jg({
    paddingTop: pD(A),
    paddingLeft: MD(A),
    paddingRight: MD(A),
    paddingBottom: pD(A)
  }, e.style);
  return Object.assign({}, e, {
    style: t
  });
}, bAA = (e) => {
  if (!e.children) return e;
  const A = e.children.map(yAA);
  return Object.assign({}, e, {
    children: A
  });
}, uc = (e) => (A) => {
  if (!A) return;
  const t = Br(A);
  return t ? t.percent * Math.min(e.width, e.height) : A;
}, nb = (e) => {
  const A = Jg({
    borderTopLeftRadius: uc(e.box),
    borderTopRightRadius: uc(e.box),
    borderBottomRightRadius: uc(e.box),
    borderBottomLeftRadius: uc(e.box)
  }, e.style || {}), t = Object.assign({}, e, {
    style: A
  });
  if (!e.children) return t;
  const r = e.children.map(nb);
  return Object.assign({}, t, {
    children: r
  });
}, FAA = (e, A) => {
  const t = Br(A);
  return t ? t.percent * e : A;
}, LAA = (e) => {
  var A, t;
  const r = e.style.height, n = ((A = e.style) === null || A === void 0 ? void 0 : A.paddingTop) || 0, i = ((t = e.style) === null || t === void 0 ? void 0 : t.paddingBottom) || 0;
  return r - n - i;
}, RAA = (e, A) => {
  var t, r;
  if (yt((t = e.style) === null || t === void 0 ? void 0 : t.height) || yt((r = A.style) === null || r === void 0 ? void 0 : r.height)) return A;
  const n = LAA(e), i = FAA(n, A.style.height), a = Object.assign({}, A.style, {
    height: i
  });
  return Object.assign({}, A, {
    style: a
  });
}, GAA = (e) => {
  if (!e.children) return e;
  const A = (r) => RAA(e, r), t = e.children.map(A);
  return Object.assign({}, e, {
    children: t
  });
}, xAA = (e) => {
  if (!e.children) return e;
  const A = e.children.map(GAA);
  return Object.assign({}, e, {
    children: A
  });
}, JE = (e) => (A) => A.type === e, kAA = JE(Lg), ib = JE(Ue), ab = JE(qi), UAA = (e) => {
  var A;
  return !!((A = e.props) !== null && A !== void 0 && A.render);
}, YAA = (e) => ib(e) || ab(e), HAA = (e) => {
  const A = e.children || [];
  return A.every(ab) ? !0 : A.every(ib) ? !1 : A.every(YAA);
}, SAA = (e) => {
  const A = {
    type: Ue,
    props: {},
    style: {},
    box: {},
    children: e.children
  };
  return Object.assign({}, e, {
    children: [A]
  });
}, NAA = (e) => kAA(e) ? UAA(e) ? Object.assign({}, e, {
  type: Ue
}) : HAA(e) ? SAA(e) : e : e, ob = (e) => {
  if (!e.children) return e;
  const A = en(NAA, ob), t = e.children.map(A);
  return Object.assign({}, e, {
    children: t
  });
}, TAA = RS(xy, rq, dD, vAA, zE, nb, dAA, Gy, dD, jE, xAA, bAA, eq, ob, iq, dq, NX);
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qd, vD;
function PAA() {
  if (vD) return qd;
  vD = 1;
  var e = Object.getOwnPropertySymbols, A = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, o = 0; o < 10; o++)
        a["_" + String.fromCharCode(o)] = o;
      var s = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qd = n() ? Object.assign : function(i, a) {
    for (var o, s = r(i), l, u = 1; u < arguments.length; u++) {
      o = Object(arguments[u]);
      for (var g in o)
        A.call(o, g) && (s[g] = o[g]);
      if (e) {
        l = e(o);
        for (var d = 0; d < l.length; d++)
          t.call(o, l[d]) && (s[l[d]] = o[l[d]]);
      }
    }
    return s;
  }, qd;
}
var zAA = PAA();
const jAA = /* @__PURE__ */ Ht(zAA);
var cc = { exports: {} }, $d = {};
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yD;
function VAA() {
  return yD || (yD = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var A, t, r, n, i;
    if (typeof window > "u" || typeof MessageChannel != "function") {
      var a = null, o = null, s = function() {
        if (a !== null) try {
          var wA = e.unstable_now();
          a(!0, wA), a = null;
        } catch (DA) {
          throw setTimeout(s, 0), DA;
        }
      }, l = Date.now();
      e.unstable_now = function() {
        return Date.now() - l;
      }, A = function(wA) {
        a !== null ? setTimeout(A, 0, wA) : (a = wA, setTimeout(s, 0));
      }, t = function(wA, DA) {
        o = setTimeout(wA, DA);
      }, r = function() {
        clearTimeout(o);
      }, n = function() {
        return !1;
      }, i = e.unstable_forceFrameRate = function() {
      };
    } else {
      var u = window.performance, g = window.Date, d = window.setTimeout, h = window.clearTimeout, C = window.requestAnimationFrame, E = window.cancelAnimationFrame;
      if (typeof console < "u" && (typeof C != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof E != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")), typeof u == "object" && typeof u.now == "function") e.unstable_now = function() {
        return u.now();
      };
      else {
        var I = g.now();
        e.unstable_now = function() {
          return g.now() - I;
        };
      }
      var b = !1, y = null, p = -1, Q = 5, w = 0;
      n = function() {
        return e.unstable_now() >= w;
      }, i = function() {
      }, e.unstable_forceFrameRate = function(wA) {
        0 > wA || 125 < wA ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : Q = 0 < wA ? Math.floor(1e3 / wA) : 33.33;
      };
      var Y = new MessageChannel(), k = Y.port2;
      Y.port1.onmessage = function() {
        if (y !== null) {
          var wA = e.unstable_now();
          w = wA + Q;
          try {
            y(!0, wA) ? k.postMessage(null) : (b = !1, y = null);
          } catch (DA) {
            throw k.postMessage(null), DA;
          }
        } else b = !1;
      }, A = function(wA) {
        y = wA, b || (b = !0, k.postMessage(null));
      }, t = function(wA, DA) {
        p = d(function() {
          wA(e.unstable_now());
        }, DA);
      }, r = function() {
        h(p), p = -1;
      };
    }
    function L(wA, DA) {
      var HA = wA.length;
      wA.push(DA);
      A: for (; ; ) {
        var sA = Math.floor((HA - 1) / 2), lA = wA[sA];
        if (lA !== void 0 && 0 < Z(lA, DA)) wA[sA] = DA, wA[HA] = lA, HA = sA;
        else break A;
      }
    }
    function S(wA) {
      return wA = wA[0], wA === void 0 ? null : wA;
    }
    function P(wA) {
      var DA = wA[0];
      if (DA !== void 0) {
        var HA = wA.pop();
        if (HA !== DA) {
          wA[0] = HA;
          A: for (var sA = 0, lA = wA.length; sA < lA; ) {
            var tA = 2 * (sA + 1) - 1, nA = wA[tA], GA = tA + 1, ZA = wA[GA];
            if (nA !== void 0 && 0 > Z(nA, HA)) ZA !== void 0 && 0 > Z(ZA, nA) ? (wA[sA] = ZA, wA[GA] = HA, sA = GA) : (wA[sA] = nA, wA[tA] = HA, sA = tA);
            else if (ZA !== void 0 && 0 > Z(ZA, HA)) wA[sA] = ZA, wA[GA] = HA, sA = GA;
            else break A;
          }
        }
        return DA;
      }
      return null;
    }
    function Z(wA, DA) {
      var HA = wA.sortIndex - DA.sortIndex;
      return HA !== 0 ? HA : wA.id - DA.id;
    }
    var M = [], R = [], G = 1, N = null, z = 3, T = !1, O = !1, K = !1;
    function AA(wA) {
      for (var DA = S(R); DA !== null; ) {
        if (DA.callback === null) P(R);
        else if (DA.startTime <= wA) P(R), DA.sortIndex = DA.expirationTime, L(M, DA);
        else break;
        DA = S(R);
      }
    }
    function X(wA) {
      if (K = !1, AA(wA), !O) if (S(M) !== null) O = !0, A(iA);
      else {
        var DA = S(R);
        DA !== null && t(X, DA.startTime - wA);
      }
    }
    function iA(wA, DA) {
      O = !1, K && (K = !1, r()), T = !0;
      var HA = z;
      try {
        for (AA(DA), N = S(M); N !== null && (!(N.expirationTime > DA) || wA && !n()); ) {
          var sA = N.callback;
          if (sA !== null) {
            N.callback = null, z = N.priorityLevel;
            var lA = sA(N.expirationTime <= DA);
            DA = e.unstable_now(), typeof lA == "function" ? N.callback = lA : N === S(M) && P(M), AA(DA);
          } else P(M);
          N = S(M);
        }
        if (N !== null) var tA = !0;
        else {
          var nA = S(R);
          nA !== null && t(X, nA.startTime - DA), tA = !1;
        }
        return tA;
      } finally {
        N = null, z = HA, T = !1;
      }
    }
    function oA(wA) {
      switch (wA) {
        case 1:
          return -1;
        case 2:
          return 250;
        case 5:
          return 1073741823;
        case 4:
          return 1e4;
        default:
          return 5e3;
      }
    }
    var fA = i;
    e.unstable_ImmediatePriority = 1, e.unstable_UserBlockingPriority = 2, e.unstable_NormalPriority = 3, e.unstable_IdlePriority = 5, e.unstable_LowPriority = 4, e.unstable_runWithPriority = function(wA, DA) {
      switch (wA) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          wA = 3;
      }
      var HA = z;
      z = wA;
      try {
        return DA();
      } finally {
        z = HA;
      }
    }, e.unstable_next = function(wA) {
      switch (z) {
        case 1:
        case 2:
        case 3:
          var DA = 3;
          break;
        default:
          DA = z;
      }
      var HA = z;
      z = DA;
      try {
        return wA();
      } finally {
        z = HA;
      }
    }, e.unstable_scheduleCallback = function(wA, DA, HA) {
      var sA = e.unstable_now();
      if (typeof HA == "object" && HA !== null) {
        var lA = HA.delay;
        lA = typeof lA == "number" && 0 < lA ? sA + lA : sA, HA = typeof HA.timeout == "number" ? HA.timeout : oA(wA);
      } else HA = oA(wA), lA = sA;
      return HA = lA + HA, wA = { id: G++, callback: DA, priorityLevel: wA, startTime: lA, expirationTime: HA, sortIndex: -1 }, lA > sA ? (wA.sortIndex = lA, L(R, wA), S(M) === null && wA === S(R) && (K ? r() : K = !0, t(X, lA - sA))) : (wA.sortIndex = HA, L(M, wA), O || T || (O = !0, A(iA))), wA;
    }, e.unstable_cancelCallback = function(wA) {
      wA.callback = null;
    }, e.unstable_wrapCallback = function(wA) {
      var DA = z;
      return function() {
        var HA = z;
        z = DA;
        try {
          return wA.apply(this, arguments);
        } finally {
          z = HA;
        }
      };
    }, e.unstable_getCurrentPriorityLevel = function() {
      return z;
    }, e.unstable_shouldYield = function() {
      var wA = e.unstable_now();
      AA(wA);
      var DA = S(M);
      return DA !== N && N !== null && DA !== null && DA.callback !== null && DA.startTime <= wA && DA.expirationTime < N.expirationTime || n();
    }, e.unstable_requestPaint = fA, e.unstable_continueExecution = function() {
      O || T || (O = !0, A(iA));
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_getFirstCallbackNode = function() {
      return S(M);
    }, e.unstable_Profiling = null;
  }($d)), $d;
}
var Ah = {}, bD;
function OAA() {
  return bD || (bD = 1, function(e) {
    var A = {};
    /** @license React v0.17.0
     * scheduler.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    A.NODE_ENV !== "production" && function() {
      Object.defineProperty(e, "__esModule", { value: !0 });
      var t = !1, r = !0, n, i, a, o, s;
      if (
        // If Scheduler runs in a non-DOM environment, it falls back to a naive
        // implementation using setTimeout.
        typeof window > "u" || // Check if MessageChannel is supported, too.
        typeof MessageChannel != "function"
      ) {
        var l = null, u = null, g = function() {
          if (l !== null)
            try {
              var pA = e.unstable_now(), VA = !0;
              l(VA, pA), l = null;
            } catch (YA) {
              throw setTimeout(g, 0), YA;
            }
        }, d = Date.now();
        e.unstable_now = function() {
          return Date.now() - d;
        }, n = function(pA) {
          l !== null ? setTimeout(n, 0, pA) : (l = pA, setTimeout(g, 0));
        }, i = function(pA, VA) {
          u = setTimeout(pA, VA);
        }, a = function() {
          clearTimeout(u);
        }, o = function() {
          return !1;
        }, s = e.unstable_forceFrameRate = function() {
        };
      } else {
        var h = window.performance, C = window.Date, E = window.setTimeout, I = window.clearTimeout, b = window.requestAnimationFrame, y = window.cancelAnimationFrame;
        if (typeof console < "u" && (typeof b != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof y != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")), typeof h == "object" && typeof h.now == "function")
          e.unstable_now = function() {
            return h.now();
          };
        else {
          var p = C.now();
          e.unstable_now = function() {
            return C.now() - p;
          };
        }
        var Q = !1, w = null, Y = -1, k = (
          // We won't attempt to align with the vsync. Instead we'll yield multiple
          // times per frame, often enough to keep it responsive even at really
          // high frame rates > 120.
          5
        ), L = 0;
        o = function() {
          return e.unstable_now() >= L;
        }, s = function() {
        }, e.unstable_forceFrameRate = function(pA) {
          if (pA < 0 || pA > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
            return;
          }
          pA > 0 ? k = Math.floor(1e3 / pA) : k = 33.33;
        };
        var S = function() {
          if (w !== null) {
            var pA = e.unstable_now();
            L = pA + k;
            var VA = !0;
            try {
              var YA = w(VA, pA);
              YA ? Z.postMessage(null) : (Q = !1, w = null);
            } catch (ze) {
              throw Z.postMessage(null), ze;
            }
          } else
            Q = !1;
        }, P = new MessageChannel(), Z = P.port2;
        P.port1.onmessage = S, n = function(pA) {
          w = pA, Q || (Q = !0, Z.postMessage(null));
        }, i = function(pA, VA) {
          Y = E(function() {
            pA(e.unstable_now());
          }, VA);
        }, a = function() {
          I(Y), Y = -1;
        };
      }
      function M(pA, VA) {
        var YA = pA.length;
        pA.push(VA), N(pA, VA, YA);
      }
      function R(pA) {
        var VA = pA[0];
        return VA === void 0 ? null : VA;
      }
      function G(pA) {
        var VA = pA[0];
        if (VA !== void 0) {
          var YA = pA.pop();
          return YA !== VA && (pA[0] = YA, z(pA, YA, 0)), VA;
        } else
          return null;
      }
      function N(pA, VA, YA) {
        for (var ze = YA; ; ) {
          var Oe = Math.floor((ze - 1) / 2), lt = pA[Oe];
          if (lt !== void 0 && T(lt, VA) > 0)
            pA[Oe] = VA, pA[ze] = lt, ze = Oe;
          else
            return;
        }
      }
      function z(pA, VA, YA) {
        for (var ze = YA, Oe = pA.length; ze < Oe; ) {
          var lt = (ze + 1) * 2 - 1, St = pA[lt], Ar = lt + 1, bt = pA[Ar];
          if (St !== void 0 && T(St, VA) < 0)
            bt !== void 0 && T(bt, St) < 0 ? (pA[ze] = bt, pA[Ar] = VA, ze = Ar) : (pA[ze] = St, pA[lt] = VA, ze = lt);
          else if (bt !== void 0 && T(bt, VA) < 0)
            pA[ze] = bt, pA[Ar] = VA, ze = Ar;
          else
            return;
        }
      }
      function T(pA, VA) {
        var YA = pA.sortIndex - VA.sortIndex;
        return YA !== 0 ? YA : pA.id - VA.id;
      }
      var O = 0, K = 1, AA = 2, X = 3, iA = 4, oA = 5, fA = 0, wA = 0, DA = 4, HA = (
        // $FlowFixMe Flow doesn't know about SharedArrayBuffer
        typeof SharedArrayBuffer == "function" ? new SharedArrayBuffer(DA * Int32Array.BYTES_PER_ELEMENT) : (
          // $FlowFixMe Flow doesn't know about ArrayBuffer
          typeof ArrayBuffer == "function" ? new ArrayBuffer(DA * Int32Array.BYTES_PER_ELEMENT) : null
        )
      ), sA = HA !== null ? new Int32Array(HA) : [], lA = 0, tA = 1, nA = 2, GA = 3;
      sA[lA] = O, sA[GA] = 0, sA[tA] = 0;
      var ZA = 131072, de = 524288, _A = 0, Ce = null, WA = null, gA = 0, ie = 1, Qe = 2, OA = 3, we = 4, se = 5, ue = 6, ge = 7, Pe = 8;
      function le(pA) {
        if (WA !== null) {
          var VA = gA;
          if (gA += pA.length, gA + 1 > _A) {
            if (_A *= 2, _A > de) {
              console.error("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`."), Ze();
              return;
            }
            var YA = new Int32Array(_A * 4);
            YA.set(WA), Ce = YA.buffer, WA = YA;
          }
          WA.set(pA, VA);
        }
      }
      function pe() {
        _A = ZA, Ce = new ArrayBuffer(_A * 4), WA = new Int32Array(Ce), gA = 0;
      }
      function Ze() {
        var pA = Ce;
        return _A = 0, Ce = null, WA = null, gA = 0, pA;
      }
      function je(pA, VA) {
        sA[GA]++, WA !== null && le([ie, VA * 1e3, pA.id, pA.priorityLevel]);
      }
      function W(pA, VA) {
        sA[lA] = O, sA[tA] = 0, sA[GA]--, WA !== null && le([Qe, VA * 1e3, pA.id]);
      }
      function yA(pA, VA) {
        sA[GA]--, WA !== null && le([we, VA * 1e3, pA.id]);
      }
      function xA(pA, VA) {
        sA[lA] = O, sA[tA] = 0, sA[GA]--, WA !== null && le([OA, VA * 1e3, pA.id]);
      }
      function SA(pA, VA) {
        fA++, sA[lA] = pA.priorityLevel, sA[tA] = pA.id, sA[nA] = fA, WA !== null && le([se, VA * 1e3, pA.id, fA]);
      }
      function eA(pA, VA) {
        sA[lA] = O, sA[tA] = 0, sA[nA] = 0, WA !== null && le([ue, VA * 1e3, pA.id, fA]);
      }
      function mA(pA) {
        wA++, WA !== null && le([ge, pA * 1e3, wA]);
      }
      function H(pA) {
        WA !== null && le([Pe, pA * 1e3, wA]);
      }
      var UA = 1073741823, ae = -1, D = 250, CA = 5e3, IA = 1e4, V = UA, $ = [], dA = [], ce = 1, NA = null, XA = X, ke = !1, Ne = !1, Ie = !1;
      function be(pA) {
        for (var VA = R(dA); VA !== null; ) {
          if (VA.callback === null)
            G(dA);
          else if (VA.startTime <= pA)
            G(dA), VA.sortIndex = VA.expirationTime, M($, VA), je(VA, pA), VA.isQueued = !0;
          else
            return;
          VA = R(dA);
        }
      }
      function Ye(pA) {
        if (Ie = !1, be(pA), !Ne)
          if (R($) !== null)
            Ne = !0, n(ye);
          else {
            var VA = R(dA);
            VA !== null && i(Ye, VA.startTime - pA);
          }
      }
      function ye(pA, VA) {
        H(VA), Ne = !1, Ie && (Ie = !1, a()), ke = !0;
        var YA = XA;
        try {
          if (r)
            try {
              return st(pA, VA);
            } catch (lt) {
              if (NA !== null) {
                var ze = e.unstable_now();
                xA(NA, ze), NA.isQueued = !1;
              }
              throw lt;
            }
        } finally {
          NA = null, XA = YA, ke = !1;
          {
            var Oe = e.unstable_now();
            mA(Oe);
          }
        }
      }
      function st(pA, VA) {
        var YA = VA;
        for (be(YA), NA = R($); NA !== null && !t && !(NA.expirationTime > YA && (!pA || o())); ) {
          var ze = NA.callback;
          if (ze !== null) {
            NA.callback = null, XA = NA.priorityLevel;
            var Oe = NA.expirationTime <= YA;
            SA(NA, YA);
            var lt = ze(Oe);
            YA = e.unstable_now(), typeof lt == "function" ? (NA.callback = lt, eA(NA, YA)) : (W(NA, YA), NA.isQueued = !1, NA === R($) && G($)), be(YA);
          } else
            G($);
          NA = R($);
        }
        if (NA !== null)
          return !0;
        var St = R(dA);
        return St !== null && i(Ye, St.startTime - YA), !1;
      }
      function Ut(pA, VA) {
        switch (pA) {
          case K:
          case AA:
          case X:
          case iA:
          case oA:
            break;
          default:
            pA = X;
        }
        var YA = XA;
        XA = pA;
        try {
          return VA();
        } finally {
          XA = YA;
        }
      }
      function gt(pA) {
        var VA;
        switch (XA) {
          case K:
          case AA:
          case X:
            VA = X;
            break;
          default:
            VA = XA;
            break;
        }
        var YA = XA;
        XA = VA;
        try {
          return pA();
        } finally {
          XA = YA;
        }
      }
      function Ke(pA) {
        var VA = XA;
        return function() {
          var YA = XA;
          XA = VA;
          try {
            return pA.apply(this, arguments);
          } finally {
            XA = YA;
          }
        };
      }
      function q(pA) {
        switch (pA) {
          case K:
            return ae;
          case AA:
            return D;
          case oA:
            return V;
          case iA:
            return IA;
          case X:
          default:
            return CA;
        }
      }
      function bA(pA, VA, YA) {
        var ze = e.unstable_now(), Oe, lt;
        if (typeof YA == "object" && YA !== null) {
          var St = YA.delay;
          typeof St == "number" && St > 0 ? Oe = ze + St : Oe = ze, lt = typeof YA.timeout == "number" ? YA.timeout : q(pA);
        } else
          lt = q(pA), Oe = ze;
        var Ar = Oe + lt, bt = {
          id: ce++,
          callback: VA,
          priorityLevel: pA,
          startTime: Oe,
          expirationTime: Ar,
          sortIndex: -1
        };
        return bt.isQueued = !1, Oe > ze ? (bt.sortIndex = Oe, M(dA, bt), R($) === null && bt === R(dA) && (Ie ? a() : Ie = !0, i(Ye, Oe - ze))) : (bt.sortIndex = Ar, M($, bt), je(bt, ze), bt.isQueued = !0, !Ne && !ke && (Ne = !0, n(ye))), bt;
      }
      function $A() {
      }
      function Ee() {
        !Ne && !ke && (Ne = !0, n(ye));
      }
      function Ve() {
        return R($);
      }
      function _e(pA) {
        if (pA.isQueued) {
          var VA = e.unstable_now();
          yA(pA, VA), pA.isQueued = !1;
        }
        pA.callback = null;
      }
      function ve() {
        return XA;
      }
      function Fe() {
        var pA = e.unstable_now();
        be(pA);
        var VA = R($);
        return VA !== NA && NA !== null && VA !== null && VA.callback !== null && VA.startTime <= pA && VA.expirationTime < NA.expirationTime || o();
      }
      var Ct = s, et = {
        startLoggingProfilingEvents: pe,
        stopLoggingProfilingEvents: Ze,
        sharedProfilingBuffer: HA
      };
      e.unstable_ImmediatePriority = K, e.unstable_UserBlockingPriority = AA, e.unstable_NormalPriority = X, e.unstable_IdlePriority = oA, e.unstable_LowPriority = iA, e.unstable_runWithPriority = Ut, e.unstable_next = gt, e.unstable_scheduleCallback = bA, e.unstable_cancelCallback = _e, e.unstable_wrapCallback = Ke, e.unstable_getCurrentPriorityLevel = ve, e.unstable_shouldYield = Fe, e.unstable_requestPaint = Ct, e.unstable_continueExecution = Ee, e.unstable_pauseExecution = $A, e.unstable_getFirstCallbackNode = Ve, e.unstable_Profiling = et;
    }();
  }(Ah)), Ah;
}
var FD;
function JAA() {
  if (FD) return cc.exports;
  FD = 1;
  var e = {};
  return e.NODE_ENV === "production" ? cc.exports = VAA() : cc.exports = OAA(), cc.exports;
}
var Ig = JAA();
const WAA = /* @__PURE__ */ Ht(Ig), ZAA = /* @__PURE__ */ Ob({
  __proto__: null,
  default: WAA
}, [Ig]);
var KAA = {};
function _AA(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function XAA(e) {
  if (e.__esModule) return e;
  var A = e.default;
  if (typeof A == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(A, arguments, this.constructor) : A.apply(this, arguments);
    };
    t.prototype = A.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), t;
}
var sb = { exports: {} }, qAA = /* @__PURE__ */ XAA(ZAA);
/** @license React v0.23.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  e.exports = function A(t) {
    var r = jAA, n = JA, i = qAA;
    function a(B) {
      for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + B, f = 1; f < arguments.length; f++) c += "&args[]=" + encodeURIComponent(arguments[f]);
      return "Minified React error #" + B + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var o = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    o.hasOwnProperty("ReactCurrentDispatcher") || (o.ReactCurrentDispatcher = {
      current: null
    }), o.hasOwnProperty("ReactCurrentBatchConfig") || (o.ReactCurrentBatchConfig = {
      suspense: null
    });
    var s = typeof Symbol == "function" && Symbol.for, l = s ? Symbol.for("react.element") : 60103, u = s ? Symbol.for("react.portal") : 60106, g = s ? Symbol.for("react.fragment") : 60107, d = s ? Symbol.for("react.strict_mode") : 60108, h = s ? Symbol.for("react.profiler") : 60114, C = s ? Symbol.for("react.provider") : 60109, E = s ? Symbol.for("react.context") : 60110, I = s ? Symbol.for("react.concurrent_mode") : 60111, b = s ? Symbol.for("react.forward_ref") : 60112, y = s ? Symbol.for("react.suspense") : 60113, p = s ? Symbol.for("react.suspense_list") : 60120, Q = s ? Symbol.for("react.memo") : 60115, w = s ? Symbol.for("react.lazy") : 60116, Y = typeof Symbol == "function" && Symbol.iterator;
    function k(B) {
      return B === null || typeof B != "object" ? null : (B = Y && B[Y] || B["@@iterator"], typeof B == "function" ? B : null);
    }
    function L(B) {
      if (B._status === -1) {
        B._status = 0;
        var c = B._ctor;
        c = c(), B._result = c, c.then(function(f) {
          B._status === 0 && (f = f.default, B._status = 1, B._result = f);
        }, function(f) {
          B._status === 0 && (B._status = 2, B._result = f);
        });
      }
    }
    function S(B) {
      if (B == null) return null;
      if (typeof B == "function") return B.displayName || B.name || null;
      if (typeof B == "string") return B;
      switch (B) {
        case g:
          return "Fragment";
        case u:
          return "Portal";
        case h:
          return "Profiler";
        case d:
          return "StrictMode";
        case y:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof B == "object") switch (B.$$typeof) {
        case E:
          return "Context.Consumer";
        case C:
          return "Context.Provider";
        case b:
          var c = B.render;
          return c = c.displayName || c.name || "", B.displayName || (c !== "" ? "ForwardRef(" + c + ")" : "ForwardRef");
        case Q:
          return S(B.type);
        case w:
          if (B = B._status === 1 ? B._result : null) return S(B);
      }
      return null;
    }
    function P(B) {
      var c = B, f = B;
      if (B.alternate) for (; c.return; ) c = c.return;
      else {
        B = c;
        do
          c = B, c.effectTag & 1026 && (f = c.return), B = c.return;
        while (B);
      }
      return c.tag === 3 ? f : null;
    }
    function Z(B) {
      if (P(B) !== B) throw Error(a(188));
    }
    function M(B) {
      var c = B.alternate;
      if (!c) {
        if (c = P(B), c === null) throw Error(a(188));
        return c !== B ? null : B;
      }
      for (var f = B, m = c; ; ) {
        var F = f.return;
        if (F === null) break;
        var U = F.alternate;
        if (U === null) {
          if (m = F.return, m !== null) {
            f = m;
            continue;
          }
          break;
        }
        if (F.child === U.child) {
          for (U = F.child; U; ) {
            if (U === f) return Z(F), B;
            if (U === m) return Z(F), c;
            U = U.sibling;
          }
          throw Error(a(188));
        }
        if (f.return !== m.return) f = F, m = U;
        else {
          for (var _ = !1, PA = F.child; PA; ) {
            if (PA === f) {
              _ = !0, f = F, m = U;
              break;
            }
            if (PA === m) {
              _ = !0, m = F, f = U;
              break;
            }
            PA = PA.sibling;
          }
          if (!_) {
            for (PA = U.child; PA; ) {
              if (PA === f) {
                _ = !0, f = U, m = F;
                break;
              }
              if (PA === m) {
                _ = !0, m = U, f = F;
                break;
              }
              PA = PA.sibling;
            }
            if (!_) throw Error(a(189));
          }
        }
        if (f.alternate !== m) throw Error(a(190));
      }
      if (f.tag !== 3) throw Error(a(188));
      return f.stateNode.current === f ? B : c;
    }
    function R(B) {
      if (B = M(B), !B) return null;
      for (var c = B; ; ) {
        if (c.tag === 5 || c.tag === 6) return c;
        if (c.child) c.child.return = c, c = c.child;
        else {
          if (c === B) break;
          for (; !c.sibling; ) {
            if (!c.return || c.return === B) return null;
            c = c.return;
          }
          c.sibling.return = c.return, c = c.sibling;
        }
      }
      return null;
    }
    function G(B) {
      if (B = M(B), !B) return null;
      for (var c = B; ; ) {
        if (c.tag === 5 || c.tag === 6) return c;
        if (c.child && c.tag !== 4) c.child.return = c, c = c.child;
        else {
          if (c === B) break;
          for (; !c.sibling; ) {
            if (!c.return || c.return === B) return null;
            c = c.return;
          }
          c.sibling.return = c.return, c = c.sibling;
        }
      }
      return null;
    }
    var N = t.getPublicInstance, z = t.getRootHostContext, T = t.getChildHostContext, O = t.prepareForCommit, K = t.resetAfterCommit, AA = t.createInstance, X = t.appendInitialChild, iA = t.finalizeInitialChildren, oA = t.prepareUpdate, fA = t.shouldSetTextContent, wA = t.shouldDeprioritizeSubtree, DA = t.createTextInstance, HA = t.setTimeout, sA = t.clearTimeout, lA = t.noTimeout, tA = t.isPrimaryRenderer, nA = t.supportsMutation, GA = t.supportsPersistence, ZA = t.supportsHydration, de = t.appendChild, _A = t.appendChildToContainer, Ce = t.commitTextUpdate, WA = t.commitMount, gA = t.commitUpdate, ie = t.insertBefore, Qe = t.insertInContainerBefore, OA = t.removeChild, we = t.removeChildFromContainer, se = t.resetTextContent, ue = t.hideInstance, ge = t.hideTextInstance, Pe = t.unhideInstance, le = t.unhideTextInstance, pe = t.cloneInstance, Ze = t.createContainerChildSet, je = t.appendChildToContainerChildSet, W = t.finalizeContainerChildren, yA = t.replaceContainerChildren, xA = t.cloneHiddenInstance, SA = t.cloneHiddenTextInstance, eA = t.canHydrateInstance, mA = t.canHydrateTextInstance, H = t.isSuspenseInstancePending, UA = t.isSuspenseInstanceFallback, ae = t.getNextHydratableSibling, D = t.getFirstHydratableChild, CA = t.hydrateInstance, IA = t.hydrateTextInstance, V = t.getNextHydratableInstanceAfterSuspenseInstance, $ = t.commitHydratedContainer, dA = t.commitHydratedSuspenseInstance, ce = /^(.*)[\\\/]/;
    function NA(B) {
      var c = "";
      do {
        A: switch (B.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var f = "";
            break A;
          default:
            var m = B._debugOwner, F = B._debugSource, U = S(B.type);
            f = null, m && (f = S(m.type)), m = U, U = "", F ? U = " (at " + F.fileName.replace(ce, "") + ":" + F.lineNumber + ")" : f && (U = " (created by " + f + ")"), f = `
    in ` + (m || "Unknown") + U;
        }
        c += f, B = B.return;
      } while (B);
      return c;
    }
    var XA = [], ke = -1;
    function Ne(B) {
      0 > ke || (B.current = XA[ke], XA[ke] = null, ke--);
    }
    function Ie(B, c) {
      ke++, XA[ke] = B.current, B.current = c;
    }
    var be = {}, Ye = {
      current: be
    }, ye = {
      current: !1
    }, st = be;
    function Ut(B, c) {
      var f = B.type.contextTypes;
      if (!f) return be;
      var m = B.stateNode;
      if (m && m.__reactInternalMemoizedUnmaskedChildContext === c) return m.__reactInternalMemoizedMaskedChildContext;
      var F = {}, U;
      for (U in f) F[U] = c[U];
      return m && (B = B.stateNode, B.__reactInternalMemoizedUnmaskedChildContext = c, B.__reactInternalMemoizedMaskedChildContext = F), F;
    }
    function gt(B) {
      return B = B.childContextTypes, B != null;
    }
    function Ke(B) {
      Ne(ye), Ne(Ye);
    }
    function q(B) {
      Ne(ye), Ne(Ye);
    }
    function bA(B, c, f) {
      if (Ye.current !== be) throw Error(a(168));
      Ie(Ye, c), Ie(ye, f);
    }
    function $A(B, c, f) {
      var m = B.stateNode;
      if (B = c.childContextTypes, typeof m.getChildContext != "function") return f;
      m = m.getChildContext();
      for (var F in m) if (!(F in B)) throw Error(a(108, S(c) || "Unknown", F));
      return r({}, f, {}, m);
    }
    function Ee(B) {
      var c = B.stateNode;
      return c = c && c.__reactInternalMemoizedMergedChildContext || be, st = Ye.current, Ie(Ye, c), Ie(ye, ye.current), !0;
    }
    function Ve(B, c, f) {
      var m = B.stateNode;
      if (!m) throw Error(a(169));
      f ? (c = $A(B, c, st), m.__reactInternalMemoizedMergedChildContext = c, Ne(ye), Ne(Ye), Ie(Ye, c)) : Ne(ye), Ie(ye, f);
    }
    var _e = i.unstable_runWithPriority, ve = i.unstable_scheduleCallback, Fe = i.unstable_cancelCallback, Ct = i.unstable_shouldYield, et = i.unstable_requestPaint, pA = i.unstable_now, VA = i.unstable_getCurrentPriorityLevel, YA = i.unstable_ImmediatePriority, ze = i.unstable_UserBlockingPriority, Oe = i.unstable_NormalPriority, lt = i.unstable_LowPriority, St = i.unstable_IdlePriority, Ar = {}, bt = et !== void 0 ? et : function() {
    }, ir = null, Gr = null, Pr = !1, Yn = pA(), jt = 1e4 > Yn ? pA : function() {
      return pA() - Yn;
    };
    function In() {
      switch (VA()) {
        case YA:
          return 99;
        case ze:
          return 98;
        case Oe:
          return 97;
        case lt:
          return 96;
        case St:
          return 95;
        default:
          throw Error(a(332));
      }
    }
    function ci(B) {
      switch (B) {
        case 99:
          return YA;
        case 98:
          return ze;
        case 97:
          return Oe;
        case 96:
          return lt;
        case 95:
          return St;
        default:
          throw Error(a(332));
      }
    }
    function j(B, c) {
      return B = ci(B), _e(B, c);
    }
    function J(B, c, f) {
      return B = ci(B), ve(B, c, f);
    }
    function rA(B) {
      return ir === null ? (ir = [B], Gr = ve(YA, EA)) : ir.push(B), Ar;
    }
    function aA() {
      if (Gr !== null) {
        var B = Gr;
        Gr = null, Fe(B);
      }
      EA();
    }
    function EA() {
      if (!Pr && ir !== null) {
        Pr = !0;
        var B = 0;
        try {
          var c = ir;
          j(99, function() {
            for (; B < c.length; B++) {
              var f = c[B];
              do
                f = f(!0);
              while (f !== null);
            }
          }), ir = null;
        } catch (f) {
          throw ir !== null && (ir = ir.slice(B + 1)), ve(YA, aA), f;
        } finally {
          Pr = !1;
        }
      }
    }
    var FA = 3;
    function TA(B, c, f) {
      return f /= 10, 1073741821 - (((1073741821 - B + c / 10) / f | 0) + 1) * f;
    }
    function qA(B, c) {
      return B === c && (B !== 0 || 1 / B === 1 / c) || B !== B && c !== c;
    }
    var te = typeof Object.is == "function" ? Object.is : qA, ee = Object.prototype.hasOwnProperty;
    function Be(B, c) {
      if (te(B, c)) return !0;
      if (typeof B != "object" || B === null || typeof c != "object" || c === null) return !1;
      var f = Object.keys(B), m = Object.keys(c);
      if (f.length !== m.length) return !1;
      for (m = 0; m < f.length; m++) if (!ee.call(c, f[m]) || !te(B[f[m]], c[f[m]])) return !1;
      return !0;
    }
    function De(B, c) {
      if (B && B.defaultProps) {
        c = r({}, c), B = B.defaultProps;
        for (var f in B) c[f] === void 0 && (c[f] = B[f]);
      }
      return c;
    }
    var Xe = {
      current: null
    }, Ft = null, tt = null, er = null;
    function ar() {
      er = tt = Ft = null;
    }
    function zr(B, c) {
      var f = B.type._context;
      tA ? (Ie(Xe, f._currentValue), f._currentValue = c) : (Ie(Xe, f._currentValue2), f._currentValue2 = c);
    }
    function yr(B) {
      var c = Xe.current;
      Ne(Xe), B = B.type._context, tA ? B._currentValue = c : B._currentValue2 = c;
    }
    function o0(B, c) {
      for (; B !== null; ) {
        var f = B.alternate;
        if (B.childExpirationTime < c) B.childExpirationTime = c, f !== null && f.childExpirationTime < c && (f.childExpirationTime = c);
        else if (f !== null && f.childExpirationTime < c) f.childExpirationTime = c;
        else break;
        B = B.return;
      }
    }
    function br(B, c) {
      Ft = B, er = tt = null, B = B.dependencies, B !== null && B.firstContext !== null && (B.expirationTime >= c && (g0 = !0), B.firstContext = null);
    }
    function Cr(B, c) {
      if (er !== B && c !== !1 && c !== 0)
        if ((typeof c != "number" || c === 1073741823) && (er = B, c = 1073741823), c = {
          context: B,
          observedBits: c,
          next: null
        }, tt === null) {
          if (Ft === null) throw Error(a(308));
          tt = c, Ft.dependencies = {
            expirationTime: 0,
            firstContext: c,
            responders: null
          };
        } else tt = tt.next = c;
      return tA ? B._currentValue : B._currentValue2;
    }
    var jr = !1;
    function ta(B) {
      return {
        baseState: B,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function N0(B) {
      return {
        baseState: B.baseState,
        firstUpdate: B.firstUpdate,
        lastUpdate: B.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function Dn(B, c) {
      return {
        expirationTime: B,
        suspenseConfig: c,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
      };
    }
    function gi(B, c) {
      B.lastUpdate === null ? B.firstUpdate = B.lastUpdate = c : (B.lastUpdate.next = c, B.lastUpdate = c);
    }
    function Hn(B, c) {
      var f = B.alternate;
      if (f === null) {
        var m = B.updateQueue, F = null;
        m === null && (m = B.updateQueue = ta(B.memoizedState));
      } else m = B.updateQueue, F = f.updateQueue, m === null ? F === null ? (m = B.updateQueue = ta(B.memoizedState), F = f.updateQueue = ta(f.memoizedState)) : m = B.updateQueue = N0(F) : F === null && (F = f.updateQueue = N0(m));
      F === null || m === F ? gi(m, c) : m.lastUpdate === null || F.lastUpdate === null ? (gi(m, c), gi(F, c)) : (gi(m, c), F.lastUpdate = c);
    }
    function ra(B, c) {
      var f = B.updateQueue;
      f = f === null ? B.updateQueue = ta(B.memoizedState) : lo(B, f), f.lastCapturedUpdate === null ? f.firstCapturedUpdate = f.lastCapturedUpdate = c : (f.lastCapturedUpdate.next = c, f.lastCapturedUpdate = c);
    }
    function lo(B, c) {
      var f = B.alternate;
      return f !== null && c === f.updateQueue && (c = B.updateQueue = N0(c)), c;
    }
    function hs(B, c, f, m, F, U) {
      switch (f.tag) {
        case 1:
          return B = f.payload, typeof B == "function" ? B.call(U, m, F) : B;
        case 3:
          B.effectTag = B.effectTag & -4097 | 64;
        case 0:
          if (B = f.payload, F = typeof B == "function" ? B.call(U, m, F) : B, F == null) break;
          return r({}, m, F);
        case 2:
          jr = !0;
      }
      return m;
    }
    function Er(B, c, f, m, F) {
      jr = !1, c = lo(B, c);
      for (var U = c.baseState, _ = null, PA = 0, vA = c.firstUpdate, ne = U; vA !== null; ) {
        var Le = vA.expirationTime;
        Le < F ? (_ === null && (_ = vA, U = ne), PA < Le && (PA = Le)) : (PQ(Le, vA.suspenseConfig), ne = hs(B, c, vA, ne, f, m), vA.callback !== null && (B.effectTag |= 32, vA.nextEffect = null, c.lastEffect === null ? c.firstEffect = c.lastEffect = vA : (c.lastEffect.nextEffect = vA, c.lastEffect = vA))), vA = vA.next;
      }
      for (Le = null, vA = c.firstCapturedUpdate; vA !== null; ) {
        var Qr = vA.expirationTime;
        Qr < F ? (Le === null && (Le = vA, _ === null && (U = ne)), PA < Qr && (PA = Qr)) : (ne = hs(B, c, vA, ne, f, m), vA.callback !== null && (B.effectTag |= 32, vA.nextEffect = null, c.lastCapturedEffect === null ? c.firstCapturedEffect = c.lastCapturedEffect = vA : (c.lastCapturedEffect.nextEffect = vA, c.lastCapturedEffect = vA))), vA = vA.next;
      }
      _ === null && (c.lastUpdate = null), Le === null ? c.lastCapturedUpdate = null : B.effectTag |= 32, _ === null && Le === null && (U = ne), c.baseState = U, c.firstUpdate = _, c.firstCapturedUpdate = Le, Mu(PA), B.expirationTime = PA, B.memoizedState = ne;
    }
    function uo(B, c, f) {
      c.firstCapturedUpdate !== null && (c.lastUpdate !== null && (c.lastUpdate.next = c.firstCapturedUpdate, c.lastUpdate = c.lastCapturedUpdate), c.firstCapturedUpdate = c.lastCapturedUpdate = null), Cs(c.firstEffect, f), c.firstEffect = c.lastEffect = null, Cs(c.firstCapturedEffect, f), c.firstCapturedEffect = c.lastCapturedEffect = null;
    }
    function Cs(B, c) {
      for (; B !== null; ) {
        var f = B.callback;
        if (f !== null) {
          B.callback = null;
          var m = c;
          if (typeof f != "function") throw Error(a(191, f));
          f.call(m);
        }
        B = B.nextEffect;
      }
    }
    var Bi = o.ReactCurrentBatchConfig, co = new n.Component().refs;
    function na(B, c, f, m) {
      c = B.memoizedState, f = f(m, c), f = f == null ? c : r({}, c, f), B.memoizedState = f, m = B.updateQueue, m !== null && B.expirationTime === 0 && (m.baseState = f);
    }
    var ia = {
      isMounted: function(c) {
        return (c = c._reactInternalFiber) ? P(c) === c : !1;
      },
      enqueueSetState: function(c, f, m) {
        c = c._reactInternalFiber;
        var F = vn(), U = Bi.suspense;
        F = ga(F, c, U), U = Dn(F, U), U.payload = f, m != null && (U.callback = m), Hn(c, U), O0(c, F);
      },
      enqueueReplaceState: function(c, f, m) {
        c = c._reactInternalFiber;
        var F = vn(), U = Bi.suspense;
        F = ga(F, c, U), U = Dn(F, U), U.tag = 1, U.payload = f, m != null && (U.callback = m), Hn(c, U), O0(c, F);
      },
      enqueueForceUpdate: function(c, f) {
        c = c._reactInternalFiber;
        var m = vn(), F = Bi.suspense;
        m = ga(m, c, F), F = Dn(m, F), F.tag = 2, f != null && (F.callback = f), Hn(c, F), O0(c, m);
      }
    };
    function fi(B, c, f, m, F, U, _) {
      return B = B.stateNode, typeof B.shouldComponentUpdate == "function" ? B.shouldComponentUpdate(m, U, _) : c.prototype && c.prototype.isPureReactComponent ? !Be(f, m) || !Be(F, U) : !0;
    }
    function di(B, c, f) {
      var m = !1, F = be, U = c.contextType;
      return typeof U == "object" && U !== null ? U = Cr(U) : (F = gt(c) ? st : Ye.current, m = c.contextTypes, U = (m = m != null) ? Ut(B, F) : be), c = new c(f, U), B.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null, c.updater = ia, B.stateNode = c, c._reactInternalFiber = B, m && (B = B.stateNode, B.__reactInternalMemoizedUnmaskedChildContext = F, B.__reactInternalMemoizedMaskedChildContext = U), c;
    }
    function Sn(B, c, f, m) {
      B = c.state, typeof c.componentWillReceiveProps == "function" && c.componentWillReceiveProps(f, m), typeof c.UNSAFE_componentWillReceiveProps == "function" && c.UNSAFE_componentWillReceiveProps(f, m), c.state !== B && ia.enqueueReplaceState(c, c.state, null);
    }
    function go(B, c, f, m) {
      var F = B.stateNode;
      F.props = f, F.state = B.memoizedState, F.refs = co;
      var U = c.contextType;
      typeof U == "object" && U !== null ? F.context = Cr(U) : (U = gt(c) ? st : Ye.current, F.context = Ut(B, U)), U = B.updateQueue, U !== null && (Er(B, U, f, F, m), F.state = B.memoizedState), U = c.getDerivedStateFromProps, typeof U == "function" && (na(B, c, U, f), F.state = B.memoizedState), typeof c.getDerivedStateFromProps == "function" || typeof F.getSnapshotBeforeUpdate == "function" || typeof F.UNSAFE_componentWillMount != "function" && typeof F.componentWillMount != "function" || (c = F.state, typeof F.componentWillMount == "function" && F.componentWillMount(), typeof F.UNSAFE_componentWillMount == "function" && F.UNSAFE_componentWillMount(), c !== F.state && ia.enqueueReplaceState(F, F.state, null), U = B.updateQueue, U !== null && (Er(B, U, f, F, m), F.state = B.memoizedState)), typeof F.componentDidMount == "function" && (B.effectTag |= 4);
    }
    var hi = Array.isArray;
    function T0(B, c, f) {
      if (B = f.ref, B !== null && typeof B != "function" && typeof B != "object") {
        if (f._owner) {
          if (f = f._owner, f) {
            if (f.tag !== 1) throw Error(a(309));
            var m = f.stateNode;
          }
          if (!m) throw Error(a(147, B));
          var F = "" + B;
          return c !== null && c.ref !== null && typeof c.ref == "function" && c.ref._stringRef === F ? c.ref : (c = function(_) {
            var PA = m.refs;
            PA === co && (PA = m.refs = {}), _ === null ? delete PA[F] : PA[F] = _;
          }, c._stringRef = F, c);
        }
        if (typeof B != "string") throw Error(a(284));
        if (!f._owner) throw Error(a(290, B));
      }
      return B;
    }
    function s0(B, c) {
      if (B.type !== "textarea") throw Error(a(31, Object.prototype.toString.call(c) === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : c, ""));
    }
    function Es(B) {
      function c(MA, hA) {
        if (B) {
          var RA = MA.lastEffect;
          RA !== null ? (RA.nextEffect = hA, MA.lastEffect = hA) : MA.firstEffect = MA.lastEffect = hA, hA.nextEffect = null, hA.effectTag = 8;
        }
      }
      function f(MA, hA) {
        if (!B) return null;
        for (; hA !== null; ) c(MA, hA), hA = hA.sibling;
        return null;
      }
      function m(MA, hA) {
        for (MA = /* @__PURE__ */ new Map(); hA !== null; ) hA.key !== null ? MA.set(hA.key, hA) : MA.set(hA.index, hA), hA = hA.sibling;
        return MA;
      }
      function F(MA, hA, RA) {
        return MA = da(MA, hA), MA.index = 0, MA.sibling = null, MA;
      }
      function U(MA, hA, RA) {
        return MA.index = RA, B ? (RA = MA.alternate, RA !== null ? (RA = RA.index, RA < hA ? (MA.effectTag = 2, hA) : RA) : (MA.effectTag = 2, hA)) : hA;
      }
      function _(MA) {
        return B && MA.alternate === null && (MA.effectTag = 2), MA;
      }
      function PA(MA, hA, RA, me) {
        return hA === null || hA.tag !== 6 ? (hA = Af(RA, MA.mode, me), hA.return = MA, hA) : (hA = F(hA, RA), hA.return = MA, hA);
      }
      function vA(MA, hA, RA, me) {
        return hA !== null && hA.elementType === RA.type ? (me = F(hA, RA.props), me.ref = T0(MA, hA, RA), me.return = MA, me) : (me = pu(RA.type, RA.key, RA.props, null, MA.mode, me), me.ref = T0(MA, hA, RA), me.return = MA, me);
      }
      function ne(MA, hA, RA, me) {
        return hA === null || hA.tag !== 4 || hA.stateNode.containerInfo !== RA.containerInfo || hA.stateNode.implementation !== RA.implementation ? (hA = ef(RA, MA.mode, me), hA.return = MA, hA) : (hA = F(hA, RA.children || []), hA.return = MA, hA);
      }
      function Le(MA, hA, RA, me, Se) {
        return hA === null || hA.tag !== 7 ? (hA = wi(RA, MA.mode, me, Se), hA.return = MA, hA) : (hA = F(hA, RA), hA.return = MA, hA);
      }
      function Qr(MA, hA, RA) {
        if (typeof hA == "string" || typeof hA == "number") return hA = Af("" + hA, MA.mode, RA), hA.return = MA, hA;
        if (typeof hA == "object" && hA !== null) {
          switch (hA.$$typeof) {
            case l:
              return RA = pu(hA.type, hA.key, hA.props, null, MA.mode, RA), RA.ref = T0(MA, null, hA), RA.return = MA, RA;
            case u:
              return hA = ef(hA, MA.mode, RA), hA.return = MA, hA;
          }
          if (hi(hA) || k(hA)) return hA = wi(hA, MA.mode, RA, null), hA.return = MA, hA;
          s0(MA, hA);
        }
        return null;
      }
      function Xt(MA, hA, RA, me) {
        var Se = hA !== null ? hA.key : null;
        if (typeof RA == "string" || typeof RA == "number") return Se !== null ? null : PA(MA, hA, "" + RA, me);
        if (typeof RA == "object" && RA !== null) {
          switch (RA.$$typeof) {
            case l:
              return RA.key === Se ? RA.type === g ? Le(MA, hA, RA.props.children, me, Se) : vA(MA, hA, RA, me) : null;
            case u:
              return RA.key === Se ? ne(MA, hA, RA, me) : null;
          }
          if (hi(RA) || k(RA)) return Se !== null ? null : Le(MA, hA, RA, me, null);
          s0(MA, RA);
        }
        return null;
      }
      function Kr(MA, hA, RA, me, Se) {
        if (typeof me == "string" || typeof me == "number") return MA = MA.get(RA) || null, PA(hA, MA, "" + me, Se);
        if (typeof me == "object" && me !== null) {
          switch (me.$$typeof) {
            case l:
              return MA = MA.get(me.key === null ? RA : me.key) || null, me.type === g ? Le(hA, MA, me.props.children, Se, me.key) : vA(hA, MA, me, Se);
            case u:
              return MA = MA.get(me.key === null ? RA : me.key) || null, ne(hA, MA, me, Se);
          }
          if (hi(me) || k(me)) return MA = MA.get(RA) || null, Le(hA, MA, me, Se, null);
          s0(hA, me);
        }
        return null;
      }
      function Ca(MA, hA, RA, me) {
        for (var Se = null, Lt = null, Je = hA, Rt = hA = 0, Zt = null; Je !== null && Rt < RA.length; Rt++) {
          Je.index > Rt ? (Zt = Je, Je = null) : Zt = Je.sibling;
          var Bt = Xt(MA, Je, RA[Rt], me);
          if (Bt === null) {
            Je === null && (Je = Zt);
            break;
          }
          B && Je && Bt.alternate === null && c(MA, Je), hA = U(Bt, hA, Rt), Lt === null ? Se = Bt : Lt.sibling = Bt, Lt = Bt, Je = Zt;
        }
        if (Rt === RA.length) return f(MA, Je), Se;
        if (Je === null) {
          for (; Rt < RA.length; Rt++) Je = Qr(MA, RA[Rt], me), Je !== null && (hA = U(Je, hA, Rt), Lt === null ? Se = Je : Lt.sibling = Je, Lt = Je);
          return Se;
        }
        for (Je = m(MA, Je); Rt < RA.length; Rt++) Zt = Kr(Je, MA, Rt, RA[Rt], me), Zt !== null && (B && Zt.alternate !== null && Je.delete(Zt.key === null ? Rt : Zt.key), hA = U(Zt, hA, Rt), Lt === null ? Se = Zt : Lt.sibling = Zt, Lt = Zt);
        return B && Je.forEach(function(_r) {
          return c(MA, _r);
        }), Se;
      }
      function gn(MA, hA, RA, me) {
        var Se = k(RA);
        if (typeof Se != "function") throw Error(a(150));
        if (RA = Se.call(RA), RA == null) throw Error(a(151));
        for (var Lt = Se = null, Je = hA, Rt = hA = 0, Zt = null, Bt = RA.next(); Je !== null && !Bt.done; Rt++, Bt = RA.next()) {
          Je.index > Rt ? (Zt = Je, Je = null) : Zt = Je.sibling;
          var _r = Xt(MA, Je, Bt.value, me);
          if (_r === null) {
            Je === null && (Je = Zt);
            break;
          }
          B && Je && _r.alternate === null && c(MA, Je), hA = U(_r, hA, Rt), Lt === null ? Se = _r : Lt.sibling = _r, Lt = _r, Je = Zt;
        }
        if (Bt.done) return f(MA, Je), Se;
        if (Je === null) {
          for (; !Bt.done; Rt++, Bt = RA.next()) Bt = Qr(MA, Bt.value, me), Bt !== null && (hA = U(Bt, hA, Rt), Lt === null ? Se = Bt : Lt.sibling = Bt, Lt = Bt);
          return Se;
        }
        for (Je = m(MA, Je); !Bt.done; Rt++, Bt = RA.next()) Bt = Kr(Je, MA, Rt, Bt.value, me), Bt !== null && (B && Bt.alternate !== null && Je.delete(Bt.key === null ? Rt : Bt.key), hA = U(Bt, hA, Rt), Lt === null ? Se = Bt : Lt.sibling = Bt, Lt = Bt);
        return B && Je.forEach(function(Sb) {
          return c(MA, Sb);
        }), Se;
      }
      return function(MA, hA, RA, me) {
        var Se = typeof RA == "object" && RA !== null && RA.type === g && RA.key === null;
        Se && (RA = RA.props.children);
        var Lt = typeof RA == "object" && RA !== null;
        if (Lt) switch (RA.$$typeof) {
          case l:
            A: {
              for (Lt = RA.key, Se = hA; Se !== null; ) {
                if (Se.key === Lt)
                  if (Se.tag === 7 ? RA.type === g : Se.elementType === RA.type) {
                    f(MA, Se.sibling), hA = F(Se, RA.type === g ? RA.props.children : RA.props), hA.ref = T0(MA, Se, RA), hA.return = MA, MA = hA;
                    break A;
                  } else {
                    f(MA, Se);
                    break;
                  }
                else c(MA, Se);
                Se = Se.sibling;
              }
              RA.type === g ? (hA = wi(RA.props.children, MA.mode, me, RA.key), hA.return = MA, MA = hA) : (me = pu(RA.type, RA.key, RA.props, null, MA.mode, me), me.ref = T0(MA, hA, RA), me.return = MA, MA = me);
            }
            return _(MA);
          case u:
            A: {
              for (Se = RA.key; hA !== null; ) {
                if (hA.key === Se)
                  if (hA.tag === 4 && hA.stateNode.containerInfo === RA.containerInfo && hA.stateNode.implementation === RA.implementation) {
                    f(MA, hA.sibling), hA = F(hA, RA.children || []), hA.return = MA, MA = hA;
                    break A;
                  } else {
                    f(MA, hA);
                    break;
                  }
                else c(MA, hA);
                hA = hA.sibling;
              }
              hA = ef(RA, MA.mode, me), hA.return = MA, MA = hA;
            }
            return _(MA);
        }
        if (typeof RA == "string" || typeof RA == "number") return RA = "" + RA, hA !== null && hA.tag === 6 ? (f(MA, hA.sibling), hA = F(hA, RA), hA.return = MA, MA = hA) : (f(MA, hA), hA = Af(RA, MA.mode, me), hA.return = MA, MA = hA), _(MA);
        if (hi(RA)) return Ca(MA, hA, RA, me);
        if (k(RA)) return gn(MA, hA, RA, me);
        if (Lt && s0(MA, RA), typeof RA > "u" && !Se) switch (MA.tag) {
          case 1:
          case 0:
            throw MA = MA.type, Error(a(152, MA.displayName || MA.name || "Component"));
        }
        return f(MA, hA);
      };
    }
    var mn = Es(!0), aa = Es(!1), or = {}, Vr = {
      current: or
    }, l0 = {
      current: or
    }, Nn = {
      current: or
    };
    function sn(B) {
      if (B === or) throw Error(a(174));
      return B;
    }
    function Qs(B, c) {
      Ie(Nn, c), Ie(l0, B), Ie(Vr, or), c = z(c), Ne(Vr), Ie(Vr, c);
    }
    function tr(B) {
      Ne(Vr), Ne(l0), Ne(Nn);
    }
    function Or(B) {
      var c = sn(Nn.current), f = sn(Vr.current);
      c = T(f, B.type, c), f !== c && (Ie(l0, B), Ie(Vr, c));
    }
    function ur(B) {
      l0.current === B && (Ne(Vr), Ne(l0));
    }
    var Mt = {
      current: 0
    };
    function oa(B) {
      for (var c = B; c !== null; ) {
        if (c.tag === 13) {
          var f = c.memoizedState;
          if (f !== null && (f = f.dehydrated, f === null || H(f) || UA(f))) return c;
        } else if (c.tag === 19 && c.memoizedProps.revealOrder !== void 0) {
          if (c.effectTag & 64) return c;
        } else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === B) break;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === B) return null;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      return null;
    }
    function AQ(B, c) {
      return {
        responder: B,
        props: c
      };
    }
    var nu = o.ReactCurrentDispatcher, Mn = o.ReactCurrentBatchConfig, ws = 0, Ci = null, Fr = null, u0 = null, Bo = null, Jr = null, fo = null, ho = 0, c0 = null, Is = 0, Ds = !1, P0 = null, ms = 0;
    function ln() {
      throw Error(a(321));
    }
    function bB(B, c) {
      if (c === null) return !1;
      for (var f = 0; f < c.length && f < B.length; f++) if (!te(B[f], c[f])) return !1;
      return !0;
    }
    function FB(B, c, f, m, F, U) {
      if (ws = U, Ci = c, u0 = B !== null ? B.memoizedState : null, nu.current = u0 === null ? fb : cQ, c = f(m, F), Ds) {
        do
          Ds = !1, ms += 1, u0 = B !== null ? B.memoizedState : null, fo = Bo, c0 = Jr = Fr = null, nu.current = cQ, c = f(m, F);
        while (Ds);
        P0 = null, ms = 0;
      }
      if (nu.current = iu, B = Ci, B.memoizedState = Bo, B.expirationTime = ho, B.updateQueue = c0, B.effectTag |= Is, B = Fr !== null && Fr.next !== null, ws = 0, fo = Jr = Bo = u0 = Fr = Ci = null, ho = 0, c0 = null, Is = 0, B) throw Error(a(300));
      return c;
    }
    function eQ() {
      nu.current = iu, ws = 0, fo = Jr = Bo = u0 = Fr = Ci = null, ho = 0, c0 = null, Is = 0, Ds = !1, P0 = null, ms = 0;
    }
    function Co() {
      var B = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
      };
      return Jr === null ? Bo = Jr = B : Jr = Jr.next = B, Jr;
    }
    function Ms() {
      if (fo !== null) Jr = fo, fo = Jr.next, Fr = u0, u0 = Fr !== null ? Fr.next : null;
      else {
        if (u0 === null) throw Error(a(310));
        Fr = u0;
        var B = {
          memoizedState: Fr.memoizedState,
          baseState: Fr.baseState,
          queue: Fr.queue,
          baseUpdate: Fr.baseUpdate,
          next: null
        };
        Jr = Jr === null ? Bo = B : Jr.next = B, u0 = Fr.next;
      }
      return Jr;
    }
    function tQ(B, c) {
      return typeof c == "function" ? c(B) : c;
    }
    function rQ(B) {
      var c = Ms(), f = c.queue;
      if (f === null) throw Error(a(311));
      if (f.lastRenderedReducer = B, 0 < ms) {
        var m = f.dispatch;
        if (P0 !== null) {
          var F = P0.get(f);
          if (F !== void 0) {
            P0.delete(f);
            var U = c.memoizedState;
            do
              U = B(U, F.action), F = F.next;
            while (F !== null);
            return te(U, c.memoizedState) || (g0 = !0), c.memoizedState = U, c.baseUpdate === f.last && (c.baseState = U), f.lastRenderedState = U, [U, m];
          }
        }
        return [c.memoizedState, m];
      }
      m = f.last;
      var _ = c.baseUpdate;
      if (U = c.baseState, _ !== null ? (m !== null && (m.next = null), m = _.next) : m = m !== null ? m.next : null, m !== null) {
        var PA = F = null, vA = m, ne = !1;
        do {
          var Le = vA.expirationTime;
          Le < ws ? (ne || (ne = !0, PA = _, F = U), Le > ho && (ho = Le, Mu(ho))) : (PQ(Le, vA.suspenseConfig), U = vA.eagerReducer === B ? vA.eagerState : B(U, vA.action)), _ = vA, vA = vA.next;
        } while (vA !== null && vA !== m);
        ne || (PA = _, F = U), te(U, c.memoizedState) || (g0 = !0), c.memoizedState = U, c.baseUpdate = PA, c.baseState = F, f.lastRenderedState = U;
      }
      return [c.memoizedState, f.dispatch];
    }
    function LB(B) {
      var c = Co();
      return typeof B == "function" && (B = B()), c.memoizedState = c.baseState = B, B = c.queue = {
        last: null,
        dispatch: null,
        lastRenderedReducer: tQ,
        lastRenderedState: B
      }, B = B.dispatch = uQ.bind(null, Ci, B), [c.memoizedState, B];
    }
    function RB(B) {
      return rQ(tQ);
    }
    function GB(B, c, f, m) {
      return B = {
        tag: B,
        create: c,
        destroy: f,
        deps: m,
        next: null
      }, c0 === null ? (c0 = {
        lastEffect: null
      }, c0.lastEffect = B.next = B) : (c = c0.lastEffect, c === null ? c0.lastEffect = B.next = B : (f = c.next, c.next = B, B.next = f, c0.lastEffect = B)), B;
    }
    function xB(B, c, f, m) {
      var F = Co();
      Is |= B, F.memoizedState = GB(c, f, void 0, m === void 0 ? null : m);
    }
    function kB(B, c, f, m) {
      var F = Ms();
      m = m === void 0 ? null : m;
      var U = void 0;
      if (Fr !== null) {
        var _ = Fr.memoizedState;
        if (U = _.destroy, m !== null && bB(m, _.deps)) {
          GB(0, f, U, m);
          return;
        }
      }
      Is |= B, F.memoizedState = GB(c, f, U, m);
    }
    function nQ(B, c) {
      return xB(516, 192, B, c);
    }
    function iQ(B, c) {
      return kB(516, 192, B, c);
    }
    function aQ(B, c) {
      if (typeof c == "function") return B = B(), c(B), function() {
        c(null);
      };
      if (c != null) return B = B(), c.current = B, function() {
        c.current = null;
      };
    }
    function oQ() {
    }
    function sQ(B, c) {
      return Co().memoizedState = [B, c === void 0 ? null : c], B;
    }
    function lQ(B, c) {
      var f = Ms();
      c = c === void 0 ? null : c;
      var m = f.memoizedState;
      return m !== null && c !== null && bB(c, m[1]) ? m[0] : (f.memoizedState = [B, c], B);
    }
    function uQ(B, c, f) {
      if (!(25 > ms)) throw Error(a(301));
      var m = B.alternate;
      if (B === Ci || m !== null && m === Ci)
        if (Ds = !0, B = {
          expirationTime: ws,
          suspenseConfig: null,
          action: f,
          eagerReducer: null,
          eagerState: null,
          next: null
        }, P0 === null && (P0 = /* @__PURE__ */ new Map()), f = P0.get(c), f === void 0) P0.set(c, B);
        else {
          for (c = f; c.next !== null; ) c = c.next;
          c.next = B;
        }
      else {
        var F = vn(), U = Bi.suspense;
        F = ga(F, B, U), U = {
          expirationTime: F,
          suspenseConfig: U,
          action: f,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        var _ = c.last;
        if (_ === null) U.next = U;
        else {
          var PA = _.next;
          PA !== null && (U.next = PA), _.next = U;
        }
        if (c.last = U, B.expirationTime === 0 && (m === null || m.expirationTime === 0) && (m = c.lastRenderedReducer, m !== null)) try {
          var vA = c.lastRenderedState, ne = m(vA, f);
          if (U.eagerReducer = m, U.eagerState = ne, te(ne, vA)) return;
        } catch {
        } finally {
        }
        O0(B, F);
      }
    }
    var iu = {
      readContext: Cr,
      useCallback: ln,
      useContext: ln,
      useEffect: ln,
      useImperativeHandle: ln,
      useLayoutEffect: ln,
      useMemo: ln,
      useReducer: ln,
      useRef: ln,
      useState: ln,
      useDebugValue: ln,
      useResponder: ln,
      useDeferredValue: ln,
      useTransition: ln
    }, fb = {
      readContext: Cr,
      useCallback: sQ,
      useContext: Cr,
      useEffect: nQ,
      useImperativeHandle: function(c, f, m) {
        return m = m != null ? m.concat([c]) : null, xB(4, 36, aQ.bind(null, f, c), m);
      },
      useLayoutEffect: function(c, f) {
        return xB(4, 36, c, f);
      },
      useMemo: function(c, f) {
        var m = Co();
        return f = f === void 0 ? null : f, c = c(), m.memoizedState = [c, f], c;
      },
      useReducer: function(c, f, m) {
        var F = Co();
        return f = m !== void 0 ? m(f) : f, F.memoizedState = F.baseState = f, c = F.queue = {
          last: null,
          dispatch: null,
          lastRenderedReducer: c,
          lastRenderedState: f
        }, c = c.dispatch = uQ.bind(null, Ci, c), [F.memoizedState, c];
      },
      useRef: function(c) {
        var f = Co();
        return c = {
          current: c
        }, f.memoizedState = c;
      },
      useState: LB,
      useDebugValue: oQ,
      useResponder: AQ,
      useDeferredValue: function(c, f) {
        var m = LB(c), F = m[0], U = m[1];
        return nQ(function() {
          i.unstable_next(function() {
            var _ = Mn.suspense;
            Mn.suspense = f === void 0 ? null : f;
            try {
              U(c);
            } finally {
              Mn.suspense = _;
            }
          });
        }, [c, f]), F;
      },
      useTransition: function(c) {
        var f = LB(!1), m = f[0], F = f[1];
        return [sQ(function(U) {
          F(!0), i.unstable_next(function() {
            var _ = Mn.suspense;
            Mn.suspense = c === void 0 ? null : c;
            try {
              F(!1), U();
            } finally {
              Mn.suspense = _;
            }
          });
        }, [c, m]), m];
      }
    }, cQ = {
      readContext: Cr,
      useCallback: lQ,
      useContext: Cr,
      useEffect: iQ,
      useImperativeHandle: function(c, f, m) {
        return m = m != null ? m.concat([c]) : null, kB(4, 36, aQ.bind(null, f, c), m);
      },
      useLayoutEffect: function(c, f) {
        return kB(4, 36, c, f);
      },
      useMemo: function(c, f) {
        var m = Ms();
        f = f === void 0 ? null : f;
        var F = m.memoizedState;
        return F !== null && f !== null && bB(f, F[1]) ? F[0] : (c = c(), m.memoizedState = [c, f], c);
      },
      useReducer: rQ,
      useRef: function() {
        return Ms().memoizedState;
      },
      useState: RB,
      useDebugValue: oQ,
      useResponder: AQ,
      useDeferredValue: function(c, f) {
        var m = RB(), F = m[0], U = m[1];
        return iQ(function() {
          i.unstable_next(function() {
            var _ = Mn.suspense;
            Mn.suspense = f === void 0 ? null : f;
            try {
              U(c);
            } finally {
              Mn.suspense = _;
            }
          });
        }, [c, f]), F;
      },
      useTransition: function(c) {
        var f = RB(), m = f[0], F = f[1];
        return [lQ(function(U) {
          F(!0), i.unstable_next(function() {
            var _ = Mn.suspense;
            Mn.suspense = c === void 0 ? null : c;
            try {
              F(!1), U();
            } finally {
              Mn.suspense = _;
            }
          });
        }, [c, m]), m];
      }
    }, z0 = null, sa = null, la = !1;
    function gQ(B, c) {
      var f = f0(5, null, null, 0);
      f.elementType = "DELETED", f.type = "DELETED", f.stateNode = c, f.return = B, f.effectTag = 8, B.lastEffect !== null ? (B.lastEffect.nextEffect = f, B.lastEffect = f) : B.firstEffect = B.lastEffect = f;
    }
    function BQ(B, c) {
      switch (B.tag) {
        case 5:
          return c = eA(c, B.type, B.pendingProps), c !== null ? (B.stateNode = c, !0) : !1;
        case 6:
          return c = mA(c, B.pendingProps), c !== null ? (B.stateNode = c, !0) : !1;
        case 13:
          return !1;
        default:
          return !1;
      }
    }
    function UB(B) {
      if (la) {
        var c = sa;
        if (c) {
          var f = c;
          if (!BQ(B, c)) {
            if (c = ae(f), !c || !BQ(B, c)) {
              B.effectTag = B.effectTag & -1025 | 2, la = !1, z0 = B;
              return;
            }
            gQ(z0, f);
          }
          z0 = B, sa = D(c);
        } else B.effectTag = B.effectTag & -1025 | 2, la = !1, z0 = B;
      }
    }
    function fQ(B) {
      for (B = B.return; B !== null && B.tag !== 5 && B.tag !== 3 && B.tag !== 13; ) B = B.return;
      z0 = B;
    }
    function au(B) {
      if (!ZA || B !== z0) return !1;
      if (!la) return fQ(B), la = !0, !1;
      var c = B.type;
      if (B.tag !== 5 || c !== "head" && c !== "body" && !fA(c, B.memoizedProps)) for (c = sa; c; ) gQ(B, c), c = ae(c);
      if (fQ(B), B.tag === 13) {
        if (!ZA) throw Error(a(316));
        if (B = B.memoizedState, B = B !== null ? B.dehydrated : null, !B) throw Error(a(317));
        sa = V(B);
      } else sa = z0 ? ae(B.stateNode) : null;
      return !0;
    }
    function YB() {
      ZA && (sa = z0 = null, la = !1);
    }
    var db = o.ReactCurrentOwner, g0 = !1;
    function un(B, c, f, m) {
      c.child = B === null ? aa(c, null, f, m) : mn(c, B.child, f, m);
    }
    function dQ(B, c, f, m, F) {
      f = f.render;
      var U = c.ref;
      return br(c, F), m = FB(B, c, f, m, U, F), B !== null && !g0 ? (c.updateQueue = B.updateQueue, c.effectTag &= -517, B.expirationTime <= F && (B.expirationTime = 0), j0(B, c, F)) : (c.effectTag |= 1, un(B, c, m, F), c.child);
    }
    function hQ(B, c, f, m, F, U) {
      if (B === null) {
        var _ = f.type;
        return typeof _ == "function" && !$B(_) && _.defaultProps === void 0 && f.compare === null && f.defaultProps === void 0 ? (c.tag = 15, c.type = _, CQ(B, c, _, m, F, U)) : (B = pu(f.type, null, m, null, c.mode, U), B.ref = c.ref, B.return = c, c.child = B);
      }
      return _ = B.child, F < U && (F = _.memoizedProps, f = f.compare, f = f !== null ? f : Be, f(F, m) && B.ref === c.ref) ? j0(B, c, U) : (c.effectTag |= 1, B = da(_, m), B.ref = c.ref, B.return = c, c.child = B);
    }
    function CQ(B, c, f, m, F, U) {
      return B !== null && Be(B.memoizedProps, m) && B.ref === c.ref && (g0 = !1, F < U) ? j0(B, c, U) : HB(B, c, f, m, U);
    }
    function EQ(B, c) {
      var f = c.ref;
      (B === null && f !== null || B !== null && B.ref !== f) && (c.effectTag |= 128);
    }
    function HB(B, c, f, m, F) {
      var U = gt(f) ? st : Ye.current;
      return U = Ut(c, U), br(c, F), f = FB(B, c, f, m, U, F), B !== null && !g0 ? (c.updateQueue = B.updateQueue, c.effectTag &= -517, B.expirationTime <= F && (B.expirationTime = 0), j0(B, c, F)) : (c.effectTag |= 1, un(B, c, f, F), c.child);
    }
    function QQ(B, c, f, m, F) {
      if (gt(f)) {
        var U = !0;
        Ee(c);
      } else U = !1;
      if (br(c, F), c.stateNode === null) B !== null && (B.alternate = null, c.alternate = null, c.effectTag |= 2), di(c, f, m), go(c, f, m, F), m = !0;
      else if (B === null) {
        var _ = c.stateNode, PA = c.memoizedProps;
        _.props = PA;
        var vA = _.context, ne = f.contextType;
        typeof ne == "object" && ne !== null ? ne = Cr(ne) : (ne = gt(f) ? st : Ye.current, ne = Ut(c, ne));
        var Le = f.getDerivedStateFromProps, Qr = typeof Le == "function" || typeof _.getSnapshotBeforeUpdate == "function";
        Qr || typeof _.UNSAFE_componentWillReceiveProps != "function" && typeof _.componentWillReceiveProps != "function" || (PA !== m || vA !== ne) && Sn(c, _, m, ne), jr = !1;
        var Xt = c.memoizedState;
        vA = _.state = Xt;
        var Kr = c.updateQueue;
        Kr !== null && (Er(c, Kr, m, _, F), vA = c.memoizedState), PA !== m || Xt !== vA || ye.current || jr ? (typeof Le == "function" && (na(c, f, Le, m), vA = c.memoizedState), (PA = jr || fi(c, f, PA, m, Xt, vA, ne)) ? (Qr || typeof _.UNSAFE_componentWillMount != "function" && typeof _.componentWillMount != "function" || (typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount()), typeof _.componentDidMount == "function" && (c.effectTag |= 4)) : (typeof _.componentDidMount == "function" && (c.effectTag |= 4), c.memoizedProps = m, c.memoizedState = vA), _.props = m, _.state = vA, _.context = ne, m = PA) : (typeof _.componentDidMount == "function" && (c.effectTag |= 4), m = !1);
      } else _ = c.stateNode, PA = c.memoizedProps, _.props = c.type === c.elementType ? PA : De(c.type, PA), vA = _.context, ne = f.contextType, typeof ne == "object" && ne !== null ? ne = Cr(ne) : (ne = gt(f) ? st : Ye.current, ne = Ut(c, ne)), Le = f.getDerivedStateFromProps, (Qr = typeof Le == "function" || typeof _.getSnapshotBeforeUpdate == "function") || typeof _.UNSAFE_componentWillReceiveProps != "function" && typeof _.componentWillReceiveProps != "function" || (PA !== m || vA !== ne) && Sn(c, _, m, ne), jr = !1, vA = c.memoizedState, Xt = _.state = vA, Kr = c.updateQueue, Kr !== null && (Er(c, Kr, m, _, F), Xt = c.memoizedState), PA !== m || vA !== Xt || ye.current || jr ? (typeof Le == "function" && (na(c, f, Le, m), Xt = c.memoizedState), (Le = jr || fi(c, f, PA, m, vA, Xt, ne)) ? (Qr || typeof _.UNSAFE_componentWillUpdate != "function" && typeof _.componentWillUpdate != "function" || (typeof _.componentWillUpdate == "function" && _.componentWillUpdate(m, Xt, ne), typeof _.UNSAFE_componentWillUpdate == "function" && _.UNSAFE_componentWillUpdate(m, Xt, ne)), typeof _.componentDidUpdate == "function" && (c.effectTag |= 4), typeof _.getSnapshotBeforeUpdate == "function" && (c.effectTag |= 256)) : (typeof _.componentDidUpdate != "function" || PA === B.memoizedProps && vA === B.memoizedState || (c.effectTag |= 4), typeof _.getSnapshotBeforeUpdate != "function" || PA === B.memoizedProps && vA === B.memoizedState || (c.effectTag |= 256), c.memoizedProps = m, c.memoizedState = Xt), _.props = m, _.state = Xt, _.context = ne, m = Le) : (typeof _.componentDidUpdate != "function" || PA === B.memoizedProps && vA === B.memoizedState || (c.effectTag |= 4), typeof _.getSnapshotBeforeUpdate != "function" || PA === B.memoizedProps && vA === B.memoizedState || (c.effectTag |= 256), m = !1);
      return SB(B, c, f, m, U, F);
    }
    function SB(B, c, f, m, F, U) {
      EQ(B, c);
      var _ = (c.effectTag & 64) !== 0;
      if (!m && !_) return F && Ve(c, f, !1), j0(B, c, U);
      m = c.stateNode, db.current = c;
      var PA = _ && typeof f.getDerivedStateFromError != "function" ? null : m.render();
      return c.effectTag |= 1, B !== null && _ ? (c.child = mn(c, B.child, null, U), c.child = mn(c, null, PA, U)) : un(B, c, PA, U), c.memoizedState = m.state, F && Ve(c, f, !0), c.child;
    }
    function wQ(B) {
      var c = B.stateNode;
      c.pendingContext ? bA(B, c.pendingContext, c.pendingContext !== c.context) : c.context && bA(B, c.context, !1), Qs(B, c.containerInfo);
    }
    var NB = {
      dehydrated: null,
      retryTime: 0
    };
    function IQ(B, c, f) {
      var m = c.mode, F = c.pendingProps, U = Mt.current, _ = !1, PA;
      if ((PA = (c.effectTag & 64) !== 0) || (PA = (U & 2) !== 0 && (B === null || B.memoizedState !== null)), PA ? (_ = !0, c.effectTag &= -65) : B !== null && B.memoizedState === null || F.fallback === void 0 || F.unstable_avoidThisFallback === !0 || (U |= 1), Ie(Mt, U & 1), B === null) {
        if (F.fallback !== void 0 && UB(c), _) {
          if (_ = F.fallback, F = wi(null, m, 0, null), F.return = c, !(c.mode & 2)) for (B = c.memoizedState !== null ? c.child.child : c.child, F.child = B; B !== null; ) B.return = F, B = B.sibling;
          return f = wi(_, m, f, null), f.return = c, F.sibling = f, c.memoizedState = NB, c.child = F, f;
        }
        return m = F.children, c.memoizedState = null, c.child = aa(c, null, m, f);
      }
      if (B.memoizedState !== null) {
        if (B = B.child, m = B.sibling, _) {
          if (F = F.fallback, f = da(B, B.pendingProps), f.return = c, !(c.mode & 2) && (_ = c.memoizedState !== null ? c.child.child : c.child, _ !== B.child)) for (f.child = _; _ !== null; ) _.return = f, _ = _.sibling;
          return m = da(m, F, m.expirationTime), m.return = c, f.sibling = m, f.childExpirationTime = 0, c.memoizedState = NB, c.child = f, m;
        }
        return f = mn(c, B.child, F.children, f), c.memoizedState = null, c.child = f;
      }
      if (B = B.child, _) {
        if (_ = F.fallback, F = wi(null, m, 0, null), F.return = c, F.child = B, B !== null && (B.return = F), !(c.mode & 2)) for (B = c.memoizedState !== null ? c.child.child : c.child, F.child = B; B !== null; ) B.return = F, B = B.sibling;
        return f = wi(_, m, f, null), f.return = c, F.sibling = f, f.effectTag |= 2, F.childExpirationTime = 0, c.memoizedState = NB, c.child = F, f;
      }
      return c.memoizedState = null, c.child = mn(c, B, F.children, f);
    }
    function DQ(B, c) {
      B.expirationTime < c && (B.expirationTime = c);
      var f = B.alternate;
      f !== null && f.expirationTime < c && (f.expirationTime = c), o0(B.return, c);
    }
    function TB(B, c, f, m, F, U) {
      var _ = B.memoizedState;
      _ === null ? B.memoizedState = {
        isBackwards: c,
        rendering: null,
        last: m,
        tail: f,
        tailExpiration: 0,
        tailMode: F,
        lastEffect: U
      } : (_.isBackwards = c, _.rendering = null, _.last = m, _.tail = f, _.tailExpiration = 0, _.tailMode = F, _.lastEffect = U);
    }
    function mQ(B, c, f) {
      var m = c.pendingProps, F = m.revealOrder, U = m.tail;
      if (un(B, c, m.children, f), m = Mt.current, m & 2) m = m & 1 | 2, c.effectTag |= 64;
      else {
        if (B !== null && B.effectTag & 64) A: for (B = c.child; B !== null; ) {
          if (B.tag === 13) B.memoizedState !== null && DQ(B, f);
          else if (B.tag === 19) DQ(B, f);
          else if (B.child !== null) {
            B.child.return = B, B = B.child;
            continue;
          }
          if (B === c) break A;
          for (; B.sibling === null; ) {
            if (B.return === null || B.return === c) break A;
            B = B.return;
          }
          B.sibling.return = B.return, B = B.sibling;
        }
        m &= 1;
      }
      if (Ie(Mt, m), !(c.mode & 2)) c.memoizedState = null;
      else switch (F) {
        case "forwards":
          for (f = c.child, F = null; f !== null; ) B = f.alternate, B !== null && oa(B) === null && (F = f), f = f.sibling;
          f = F, f === null ? (F = c.child, c.child = null) : (F = f.sibling, f.sibling = null), TB(c, !1, F, f, U, c.lastEffect);
          break;
        case "backwards":
          for (f = null, F = c.child, c.child = null; F !== null; ) {
            if (B = F.alternate, B !== null && oa(B) === null) {
              c.child = F;
              break;
            }
            B = F.sibling, F.sibling = f, f = F, F = B;
          }
          TB(c, !0, f, null, U, c.lastEffect);
          break;
        case "together":
          TB(c, !1, null, null, void 0, c.lastEffect);
          break;
        default:
          c.memoizedState = null;
      }
      return c.child;
    }
    function j0(B, c, f) {
      B !== null && (c.dependencies = B.dependencies);
      var m = c.expirationTime;
      if (m !== 0 && Mu(m), c.childExpirationTime < f) return null;
      if (B !== null && c.child !== B.child) throw Error(a(153));
      if (c.child !== null) {
        for (B = c.child, f = da(B, B.pendingProps, B.expirationTime), c.child = f, f.return = c; B.sibling !== null; ) B = B.sibling, f = f.sibling = da(B, B.pendingProps, B.expirationTime), f.return = c;
        f.sibling = null;
      }
      return c.child;
    }
    function B0(B) {
      B.effectTag |= 4;
    }
    var ps, vs, ou, su;
    if (nA) ps = function(c, f) {
      for (var m = f.child; m !== null; ) {
        if (m.tag === 5 || m.tag === 6) X(c, m.stateNode);
        else if (m.tag !== 4 && m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === f) break;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === f) return;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
    }, vs = function() {
    }, ou = function(c, f, m, F, U) {
      if (c = c.memoizedProps, c !== F) {
        var _ = f.stateNode, PA = sn(Vr.current);
        m = oA(_, m, c, F, U, PA), (f.updateQueue = m) && B0(f);
      }
    }, su = function(c, f, m, F) {
      m !== F && B0(f);
    };
    else if (GA) {
      ps = function(c, f, m, F) {
        for (var U = f.child; U !== null; ) {
          if (U.tag === 5) {
            var _ = U.stateNode;
            m && F && (_ = xA(_, U.type, U.memoizedProps, U)), X(c, _);
          } else if (U.tag === 6) _ = U.stateNode, m && F && (_ = SA(_, U.memoizedProps, U)), X(c, _);
          else if (U.tag !== 4) {
            if (U.tag === 13 && U.effectTag & 4 && (_ = U.memoizedState !== null)) {
              var PA = U.child;
              if (PA !== null && (PA.child !== null && (PA.child.return = PA, ps(c, PA, !0, _)), _ = PA.sibling, _ !== null)) {
                _.return = U, U = _;
                continue;
              }
            }
            if (U.child !== null) {
              U.child.return = U, U = U.child;
              continue;
            }
          }
          if (U === f) break;
          for (; U.sibling === null; ) {
            if (U.return === null || U.return === f) return;
            U = U.return;
          }
          U.sibling.return = U.return, U = U.sibling;
        }
      };
      var hb = function B(c, f, m, F) {
        for (var U = f.child; U !== null; ) {
          if (U.tag === 5) {
            var _ = U.stateNode;
            m && F && (_ = xA(_, U.type, U.memoizedProps, U)), je(c, _);
          } else if (U.tag === 6) _ = U.stateNode, m && F && (_ = SA(_, U.memoizedProps, U)), je(c, _);
          else if (U.tag !== 4) {
            if (U.tag === 13 && U.effectTag & 4 && (_ = U.memoizedState !== null)) {
              var PA = U.child;
              if (PA !== null && (PA.child !== null && (PA.child.return = PA, B(c, PA, !0, _)), _ = PA.sibling, _ !== null)) {
                _.return = U, U = _;
                continue;
              }
            }
            if (U.child !== null) {
              U.child.return = U, U = U.child;
              continue;
            }
          }
          if (U === f) break;
          for (; U.sibling === null; ) {
            if (U.return === null || U.return === f) return;
            U = U.return;
          }
          U.sibling.return = U.return, U = U.sibling;
        }
      };
      vs = function(c) {
        var f = c.stateNode;
        if (c.firstEffect !== null) {
          var m = f.containerInfo, F = Ze(m);
          hb(F, c, !1, !1), f.pendingChildren = F, B0(c), W(m, F);
        }
      }, ou = function(c, f, m, F, U) {
        var _ = c.stateNode, PA = c.memoizedProps;
        if ((c = f.firstEffect === null) && PA === F) f.stateNode = _;
        else {
          var vA = f.stateNode, ne = sn(Vr.current), Le = null;
          PA !== F && (Le = oA(vA, m, PA, F, U, ne)), c && Le === null ? f.stateNode = _ : (_ = pe(_, Le, m, PA, F, f, c, vA), iA(_, m, F, U, ne) && B0(f), f.stateNode = _, c ? B0(f) : ps(_, f, !1, !1));
        }
      }, su = function(c, f, m, F) {
        m !== F && (c = sn(Nn.current), m = sn(Vr.current), f.stateNode = DA(F, c, m, f), B0(f));
      };
    } else vs = function() {
    }, ou = function() {
    }, su = function() {
    };
    function lu(B, c) {
      switch (B.tailMode) {
        case "hidden":
          c = B.tail;
          for (var f = null; c !== null; ) c.alternate !== null && (f = c), c = c.sibling;
          f === null ? B.tail = null : f.sibling = null;
          break;
        case "collapsed":
          f = B.tail;
          for (var m = null; f !== null; ) f.alternate !== null && (m = f), f = f.sibling;
          m === null ? c || B.tail === null ? B.tail = null : B.tail.sibling = null : m.sibling = null;
      }
    }
    function Cb(B) {
      switch (B.tag) {
        case 1:
          gt(B.type) && Ke();
          var c = B.effectTag;
          return c & 4096 ? (B.effectTag = c & -4097 | 64, B) : null;
        case 3:
          if (tr(), q(), c = B.effectTag, c & 64) throw Error(a(285));
          return B.effectTag = c & -4097 | 64, B;
        case 5:
          return ur(B), null;
        case 13:
          return Ne(Mt), c = B.effectTag, c & 4096 ? (B.effectTag = c & -4097 | 64, B) : null;
        case 19:
          return Ne(Mt), null;
        case 4:
          return tr(), null;
        case 10:
          return yr(B), null;
        default:
          return null;
      }
    }
    function PB(B, c) {
      return {
        value: B,
        source: c,
        stack: NA(c)
      };
    }
    var Eb = typeof WeakSet == "function" ? WeakSet : Set;
    function zB(B, c) {
      var f = c.source, m = c.stack;
      m === null && f !== null && (m = NA(f)), f !== null && S(f.type), c = c.value, B !== null && B.tag === 1 && S(B.type);
      try {
        console.error(c);
      } catch (F) {
        setTimeout(function() {
          throw F;
        });
      }
    }
    function Qb(B, c) {
      try {
        c.props = B.memoizedProps, c.state = B.memoizedState, c.componentWillUnmount();
      } catch (f) {
        fa(B, f);
      }
    }
    function MQ(B) {
      var c = B.ref;
      if (c !== null) if (typeof c == "function") try {
        c(null);
      } catch (f) {
        fa(B, f);
      }
      else c.current = null;
    }
    function wb(B, c) {
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
          Eo(2, 0, c);
          break;
        case 1:
          if (c.effectTag & 256 && B !== null) {
            var f = B.memoizedProps, m = B.memoizedState;
            B = c.stateNode, c = B.getSnapshotBeforeUpdate(c.elementType === c.type ? f : De(c.type, f), m), B.__reactInternalSnapshotBeforeUpdate = c;
          }
          break;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(a(163));
      }
    }
    function Eo(B, c, f) {
      if (f = f.updateQueue, f = f !== null ? f.lastEffect : null, f !== null) {
        var m = f = f.next;
        do {
          if (m.tag & B) {
            var F = m.destroy;
            m.destroy = void 0, F !== void 0 && F();
          }
          m.tag & c && (F = m.create, m.destroy = F()), m = m.next;
        } while (m !== f);
      }
    }
    function pQ(B, c, f) {
      switch (typeof qB == "function" && qB(c), c.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (B = c.updateQueue, B !== null && (B = B.lastEffect, B !== null)) {
            var m = B.next;
            j(97 < f ? 97 : f, function() {
              var F = m;
              do {
                var U = F.destroy;
                if (U !== void 0) {
                  var _ = c;
                  try {
                    U();
                  } catch (PA) {
                    fa(_, PA);
                  }
                }
                F = F.next;
              } while (F !== m);
            });
          }
          break;
        case 1:
          MQ(c), f = c.stateNode, typeof f.componentWillUnmount == "function" && Qb(c, f);
          break;
        case 5:
          MQ(c);
          break;
        case 4:
          nA ? LQ(B, c, f) : GA && Ib(c);
      }
    }
    function vQ(B, c, f) {
      for (var m = c; ; ) if (pQ(B, m, f), m.child === null || nA && m.tag === 4) {
        if (m === c) break;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === c) return;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      } else m.child.return = m, m = m.child;
    }
    function yQ(B) {
      var c = B.alternate;
      B.return = null, B.child = null, B.memoizedState = null, B.updateQueue = null, B.dependencies = null, B.alternate = null, B.firstEffect = null, B.lastEffect = null, B.pendingProps = null, B.memoizedProps = null, c !== null && yQ(c);
    }
    function Ib(B) {
      if (GA) {
        B = B.stateNode.containerInfo;
        var c = Ze(B);
        yA(B, c);
      }
    }
    function bQ(B) {
      return B.tag === 5 || B.tag === 3 || B.tag === 4;
    }
    function FQ(B) {
      if (nA) {
        A: {
          for (var c = B.return; c !== null; ) {
            if (bQ(c)) {
              var f = c;
              break A;
            }
            c = c.return;
          }
          throw Error(a(160));
        }
        switch (c = f.stateNode, f.tag) {
          case 5:
            var m = !1;
            break;
          case 3:
            c = c.containerInfo, m = !0;
            break;
          case 4:
            c = c.containerInfo, m = !0;
            break;
          default:
            throw Error(a(161));
        }
        f.effectTag & 16 && (se(c), f.effectTag &= -17);
        A: e: for (f = B; ; ) {
          for (; f.sibling === null; ) {
            if (f.return === null || bQ(f.return)) {
              f = null;
              break A;
            }
            f = f.return;
          }
          for (f.sibling.return = f.return, f = f.sibling; f.tag !== 5 && f.tag !== 6 && f.tag !== 18; ) {
            if (f.effectTag & 2 || f.child === null || f.tag === 4) continue e;
            f.child.return = f, f = f.child;
          }
          if (!(f.effectTag & 2)) {
            f = f.stateNode;
            break A;
          }
        }
        for (var F = B; ; ) {
          var U = F.tag === 5 || F.tag === 6;
          if (U) U = U ? F.stateNode : F.stateNode.instance, f ? m ? Qe(c, U, f) : ie(c, U, f) : m ? _A(c, U) : de(c, U);
          else if (F.tag !== 4 && F.child !== null) {
            F.child.return = F, F = F.child;
            continue;
          }
          if (F === B) break;
          for (; F.sibling === null; ) {
            if (F.return === null || F.return === B) return;
            F = F.return;
          }
          F.sibling.return = F.return, F = F.sibling;
        }
      }
    }
    function LQ(B, c, f) {
      for (var m = c, F = !1, U, _; ; ) {
        if (!F) {
          F = m.return;
          A: for (; ; ) {
            if (F === null) throw Error(a(160));
            switch (U = F.stateNode, F.tag) {
              case 5:
                _ = !1;
                break A;
              case 3:
                U = U.containerInfo, _ = !0;
                break A;
              case 4:
                U = U.containerInfo, _ = !0;
                break A;
            }
            F = F.return;
          }
          F = !0;
        }
        if (m.tag === 5 || m.tag === 6) vQ(B, m, f), _ ? we(U, m.stateNode) : OA(U, m.stateNode);
        else if (m.tag === 4) {
          if (m.child !== null) {
            U = m.stateNode.containerInfo, _ = !0, m.child.return = m, m = m.child;
            continue;
          }
        } else if (pQ(B, m, f), m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === c) break;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === c) return;
          m = m.return, m.tag === 4 && (F = !1);
        }
        m.sibling.return = m.return, m = m.sibling;
      }
    }
    function jB(B, c) {
      if (nA) switch (c.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Eo(4, 8, c);
          break;
        case 1:
          break;
        case 5:
          var f = c.stateNode;
          if (f != null) {
            var m = c.memoizedProps;
            B = B !== null ? B.memoizedProps : m;
            var F = c.type, U = c.updateQueue;
            c.updateQueue = null, U !== null && gA(f, U, F, B, m, c);
          }
          break;
        case 6:
          if (c.stateNode === null) throw Error(a(162));
          f = c.memoizedProps, Ce(c.stateNode, B !== null ? B.memoizedProps : f, f);
          break;
        case 3:
          ZA && (c = c.stateNode, c.hydrate && (c.hydrate = !1, $(c.containerInfo)));
          break;
        case 12:
          break;
        case 13:
          RQ(c), uu(c);
          break;
        case 19:
          uu(c);
          break;
        case 17:
          break;
        case 20:
          break;
        case 21:
          break;
        default:
          throw Error(a(163));
      }
      else {
        switch (c.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            Eo(4, 8, c);
            return;
          case 12:
            return;
          case 13:
            RQ(c), uu(c);
            return;
          case 19:
            uu(c);
            return;
          case 3:
            ZA && (f = c.stateNode, f.hydrate && (f.hydrate = !1, $(f.containerInfo)));
        }
        A: if (GA) switch (c.tag) {
          case 1:
          case 5:
          case 6:
          case 20:
            break A;
          case 3:
          case 4:
            c = c.stateNode, yA(c.containerInfo, c.pendingChildren);
            break A;
          default:
            throw Error(a(163));
        }
      }
    }
    function RQ(B) {
      var c = B;
      if (B.memoizedState === null) var f = !1;
      else f = !0, c = B.child, JB = jt();
      if (nA && c !== null) {
        A: if (B = c, nA) for (c = B; ; ) {
          if (c.tag === 5) {
            var m = c.stateNode;
            f ? ue(m) : Pe(c.stateNode, c.memoizedProps);
          } else if (c.tag === 6) m = c.stateNode, f ? ge(m) : le(m, c.memoizedProps);
          else if (c.tag === 13 && c.memoizedState !== null && c.memoizedState.dehydrated === null) {
            m = c.child.sibling, m.return = c, c = m;
            continue;
          } else if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
          if (c === B) break A;
          for (; c.sibling === null; ) {
            if (c.return === null || c.return === B) break A;
            c = c.return;
          }
          c.sibling.return = c.return, c = c.sibling;
        }
      }
    }
    function uu(B) {
      var c = B.updateQueue;
      if (c !== null) {
        B.updateQueue = null;
        var f = B.stateNode;
        f === null && (f = B.stateNode = new Eb()), c.forEach(function(m) {
          var F = Gb.bind(null, B, m);
          f.has(m) || (f.add(m), m.then(F, F));
        });
      }
    }
    var Db = typeof WeakMap == "function" ? WeakMap : Map;
    function GQ(B, c, f) {
      f = Dn(f, null), f.tag = 3, f.payload = {
        element: null
      };
      var m = c.value;
      return f.callback = function() {
        Eu || (Eu = !0, WB = m), zB(B, c);
      }, f;
    }
    function xQ(B, c, f) {
      f = Dn(f, null), f.tag = 3;
      var m = B.type.getDerivedStateFromError;
      if (typeof m == "function") {
        var F = c.value;
        f.payload = function() {
          return zB(B, c), m(F);
        };
      }
      var U = B.stateNode;
      return U !== null && typeof U.componentDidCatch == "function" && (f.callback = function() {
        typeof m != "function" && (Ei === null ? Ei = /* @__PURE__ */ new Set([this]) : Ei.add(this), zB(B, c));
        var _ = c.stack;
        this.componentDidCatch(c.value, {
          componentStack: _ !== null ? _ : ""
        });
      }), f;
    }
    var mb = Math.ceil, cu = o.ReactCurrentDispatcher, kQ = o.ReactCurrentOwner, nr = 0, VB = 8, pn = 16, Tn = 32, ua = 0, gu = 1, UQ = 2, Bu = 3, fu = 4, OB = 5, Te = nr, cn = null, nt = null, Wr = 0, cr = ua, du = null, V0 = 1073741823, ys = 1073741823, hu = null, bs = 0, Cu = !1, JB = 0, YQ = 500, xe = null, Eu = !1, WB = null, Ei = null, Qu = !1, wu = null, Fs = 90, ca = null, Ls = 0, ZB = null, Iu = 0;
    function vn() {
      return (Te & (pn | Tn)) !== nr ? 1073741821 - (jt() / 10 | 0) : Iu !== 0 ? Iu : Iu = 1073741821 - (jt() / 10 | 0);
    }
    function ga(B, c, f) {
      if (c = c.mode, !(c & 2)) return 1073741823;
      var m = In();
      if (!(c & 4)) return m === 99 ? 1073741823 : 1073741822;
      if ((Te & pn) !== nr) return Wr;
      if (f !== null) B = TA(B, f.timeoutMs | 0 || 5e3, 250);
      else switch (m) {
        case 99:
          B = 1073741823;
          break;
        case 98:
          B = TA(B, 150, 100);
          break;
        case 97:
        case 96:
          B = TA(B, 5e3, 250);
          break;
        case 95:
          B = 2;
          break;
        default:
          throw Error(a(326));
      }
      return cn !== null && B === Wr && --B, B;
    }
    function O0(B, c) {
      if (50 < Ls) throw Ls = 0, ZB = null, Error(a(185));
      if (B = Du(B, c), B !== null) {
        var f = In();
        c === 1073741823 ? (Te & VB) !== nr && (Te & (pn | Tn)) === nr ? KB(B) : (Zr(B), Te === nr && aA()) : Zr(B), (Te & 4) === nr || f !== 98 && f !== 99 || (ca === null ? ca = /* @__PURE__ */ new Map([[B, c]]) : (f = ca.get(B), (f === void 0 || f > c) && ca.set(B, c)));
      }
    }
    function Du(B, c) {
      B.expirationTime < c && (B.expirationTime = c);
      var f = B.alternate;
      f !== null && f.expirationTime < c && (f.expirationTime = c);
      var m = B.return, F = null;
      if (m === null && B.tag === 3) F = B.stateNode;
      else for (; m !== null; ) {
        if (f = m.alternate, m.childExpirationTime < c && (m.childExpirationTime = c), f !== null && f.childExpirationTime < c && (f.childExpirationTime = c), m.return === null && m.tag === 3) {
          F = m.stateNode;
          break;
        }
        m = m.return;
      }
      return F !== null && (cn === F && (Mu(c), cr === fu && ha(F, Wr)), WQ(F, c)), F;
    }
    function mu(B) {
      var c = B.lastExpiredTime;
      return c !== 0 || (c = B.firstPendingTime, !JQ(B, c)) ? c : (c = B.lastPingedTime, B = B.nextKnownPendingLevel, c > B ? c : B);
    }
    function Zr(B) {
      if (B.lastExpiredTime !== 0) B.callbackExpirationTime = 1073741823, B.callbackPriority = 99, B.callbackNode = rA(KB.bind(null, B));
      else {
        var c = mu(B), f = B.callbackNode;
        if (c === 0) f !== null && (B.callbackNode = null, B.callbackExpirationTime = 0, B.callbackPriority = 90);
        else {
          var m = vn();
          if (c === 1073741823 ? m = 99 : c === 1 || c === 2 ? m = 95 : (m = 10 * (1073741821 - c) - 10 * (1073741821 - m), m = 0 >= m ? 99 : 250 >= m ? 98 : 5250 >= m ? 97 : 95), f !== null) {
            var F = B.callbackPriority;
            if (B.callbackExpirationTime === c && F >= m) return;
            f !== Ar && Fe(f);
          }
          B.callbackExpirationTime = c, B.callbackPriority = m, c = c === 1073741823 ? rA(KB.bind(null, B)) : J(m, HQ.bind(null, B), {
            timeout: 10 * (1073741821 - c) - jt()
          }), B.callbackNode = c;
        }
      }
    }
    function HQ(B, c) {
      if (Iu = 0, c) return c = vn(), vu(B, c), Zr(B), null;
      var f = mu(B);
      if (f !== 0) {
        if (c = B.callbackNode, (Te & (pn | Tn)) !== nr) throw Error(a(327));
        if (Qo(), B === cn && f === Wr || Ba(B, f), nt !== null) {
          var m = Te;
          Te |= pn;
          var F = TQ();
          do
            try {
              yb();
              break;
            } catch (PA) {
              NQ(B, PA);
            }
          while (!0);
          if (ar(), Te = m, cu.current = F, cr === gu) throw c = du, Ba(B, f), ha(B, f), Zr(B), c;
          if (nt === null) switch (F = B.finishedWork = B.current.alternate, B.finishedExpirationTime = f, m = cr, cn = null, m) {
            case ua:
            case gu:
              throw Error(a(345));
            case UQ:
              vu(B, 2 < f ? 2 : f);
              break;
            case Bu:
              if (ha(B, f), m = B.lastSuspendedTime, f === m && (B.nextKnownPendingLevel = _B(F)), V0 === 1073741823 && (F = JB + YQ - jt(), 10 < F)) {
                if (Cu) {
                  var U = B.lastPingedTime;
                  if (U === 0 || U >= f) {
                    B.lastPingedTime = f, Ba(B, f);
                    break;
                  }
                }
                if (U = mu(B), U !== 0 && U !== f) break;
                if (m !== 0 && m !== f) {
                  B.lastPingedTime = m;
                  break;
                }
                B.timeoutHandle = HA(Qi.bind(null, B), F);
                break;
              }
              Qi(B);
              break;
            case fu:
              if (ha(B, f), m = B.lastSuspendedTime, f === m && (B.nextKnownPendingLevel = _B(F)), Cu && (F = B.lastPingedTime, F === 0 || F >= f)) {
                B.lastPingedTime = f, Ba(B, f);
                break;
              }
              if (F = mu(B), F !== 0 && F !== f) break;
              if (m !== 0 && m !== f) {
                B.lastPingedTime = m;
                break;
              }
              if (ys !== 1073741823 ? m = 10 * (1073741821 - ys) - jt() : V0 === 1073741823 ? m = 0 : (m = 10 * (1073741821 - V0) - 5e3, F = jt(), f = 10 * (1073741821 - f) - F, m = F - m, 0 > m && (m = 0), m = (120 > m ? 120 : 480 > m ? 480 : 1080 > m ? 1080 : 1920 > m ? 1920 : 3e3 > m ? 3e3 : 4320 > m ? 4320 : 1960 * mb(m / 1960)) - m, f < m && (m = f)), 10 < m) {
                B.timeoutHandle = HA(Qi.bind(null, B), m);
                break;
              }
              Qi(B);
              break;
            case OB:
              if (V0 !== 1073741823 && hu !== null) {
                U = V0;
                var _ = hu;
                if (m = _.busyMinDurationMs | 0, 0 >= m ? m = 0 : (F = _.busyDelayMs | 0, U = jt() - (10 * (1073741821 - U) - (_.timeoutMs | 0 || 5e3)), m = U <= F ? 0 : F + m - U), 10 < m) {
                  ha(B, f), B.timeoutHandle = HA(Qi.bind(null, B), m);
                  break;
                }
              }
              Qi(B);
              break;
            default:
              throw Error(a(329));
          }
          if (Zr(B), B.callbackNode === c) return HQ.bind(null, B);
        }
      }
      return null;
    }
    function KB(B) {
      var c = B.lastExpiredTime;
      if (c = c !== 0 ? c : 1073741823, B.finishedExpirationTime === c) Qi(B);
      else {
        if ((Te & (pn | Tn)) !== nr) throw Error(a(327));
        if (Qo(), B === cn && c === Wr || Ba(B, c), nt !== null) {
          var f = Te;
          Te |= pn;
          var m = TQ();
          do
            try {
              vb();
              break;
            } catch (F) {
              NQ(B, F);
            }
          while (!0);
          if (ar(), Te = f, cu.current = m, cr === gu) throw f = du, Ba(B, c), ha(B, c), Zr(B), f;
          if (nt !== null) throw Error(a(261));
          B.finishedWork = B.current.alternate, B.finishedExpirationTime = c, cn = null, Qi(B), Zr(B);
        }
      }
      return null;
    }
    function Mb(B, c) {
      vu(B, c), Zr(B), (Te & (pn | Tn)) === nr && aA();
    }
    function pb() {
      if (ca !== null) {
        var B = ca;
        ca = null, B.forEach(function(c, f) {
          vu(f, c), Zr(f);
        }), aA();
      }
    }
    function SQ(B, c) {
      if ((Te & (pn | Tn)) !== nr) throw Error(a(187));
      var f = Te;
      Te |= 1;
      try {
        return j(99, B.bind(null, c));
      } finally {
        Te = f, aA();
      }
    }
    function Ba(B, c) {
      B.finishedWork = null, B.finishedExpirationTime = 0;
      var f = B.timeoutHandle;
      if (f !== lA && (B.timeoutHandle = lA, sA(f)), nt !== null) for (f = nt.return; f !== null; ) {
        var m = f;
        switch (m.tag) {
          case 1:
            var F = m.type.childContextTypes;
            F != null && Ke();
            break;
          case 3:
            tr(), q();
            break;
          case 5:
            ur(m);
            break;
          case 4:
            tr();
            break;
          case 13:
            Ne(Mt);
            break;
          case 19:
            Ne(Mt);
            break;
          case 10:
            yr(m);
        }
        f = f.return;
      }
      cn = B, nt = da(B.current, null), Wr = c, cr = ua, du = null, ys = V0 = 1073741823, hu = null, bs = 0, Cu = !1;
    }
    function NQ(B, c) {
      do {
        try {
          if (ar(), eQ(), nt === null || nt.return === null) return cr = gu, du = c, null;
          A: {
            var f = B, m = nt.return, F = nt, U = c;
            if (c = Wr, F.effectTag |= 2048, F.firstEffect = F.lastEffect = null, U !== null && typeof U == "object" && typeof U.then == "function") {
              var _ = U, PA = (Mt.current & 1) !== 0, vA = m;
              do {
                var ne;
                if (ne = vA.tag === 13) {
                  var Le = vA.memoizedState;
                  if (Le !== null) ne = Le.dehydrated !== null;
                  else {
                    var Qr = vA.memoizedProps;
                    ne = Qr.fallback === void 0 ? !1 : Qr.unstable_avoidThisFallback !== !0 ? !0 : !PA;
                  }
                }
                if (ne) {
                  var Xt = vA.updateQueue;
                  if (Xt === null) {
                    var Kr = /* @__PURE__ */ new Set();
                    Kr.add(_), vA.updateQueue = Kr;
                  } else Xt.add(_);
                  if (!(vA.mode & 2)) {
                    if (vA.effectTag |= 64, F.effectTag &= -2981, F.tag === 1) if (F.alternate === null) F.tag = 17;
                    else {
                      var Ca = Dn(1073741823, null);
                      Ca.tag = 2, Hn(F, Ca);
                    }
                    F.expirationTime = 1073741823;
                    break A;
                  }
                  U = void 0, F = c;
                  var gn = f.pingCache;
                  if (gn === null ? (gn = f.pingCache = new Db(), U = /* @__PURE__ */ new Set(), gn.set(_, U)) : (U = gn.get(_), U === void 0 && (U = /* @__PURE__ */ new Set(), gn.set(_, U))), !U.has(F)) {
                    U.add(F);
                    var MA = Rb.bind(null, f, _, F);
                    _.then(MA, MA);
                  }
                  vA.effectTag |= 4096, vA.expirationTime = c;
                  break A;
                }
                vA = vA.return;
              } while (vA !== null);
              U = Error((S(F.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.` + NA(F));
            }
            cr !== OB && (cr = UQ), U = PB(U, F), vA = m;
            do {
              switch (vA.tag) {
                case 3:
                  _ = U, vA.effectTag |= 4096, vA.expirationTime = c;
                  var hA = GQ(vA, _, c);
                  ra(vA, hA);
                  break A;
                case 1:
                  _ = U;
                  var RA = vA.type, me = vA.stateNode;
                  if (!(vA.effectTag & 64) && (typeof RA.getDerivedStateFromError == "function" || me !== null && typeof me.componentDidCatch == "function" && (Ei === null || !Ei.has(me)))) {
                    vA.effectTag |= 4096, vA.expirationTime = c;
                    var Se = xQ(vA, _, c);
                    ra(vA, Se);
                    break A;
                  }
              }
              vA = vA.return;
            } while (vA !== null);
          }
          nt = jQ(nt);
        } catch (Lt) {
          c = Lt;
          continue;
        }
        break;
      } while (!0);
    }
    function TQ() {
      var B = cu.current;
      return cu.current = iu, B === null ? iu : B;
    }
    function PQ(B, c) {
      B < V0 && 2 < B && (V0 = B), c !== null && B < ys && 2 < B && (ys = B, hu = c);
    }
    function Mu(B) {
      B > bs && (bs = B);
    }
    function vb() {
      for (; nt !== null; ) nt = zQ(nt);
    }
    function yb() {
      for (; nt !== null && !Ct(); ) nt = zQ(nt);
    }
    function zQ(B) {
      var c = OQ(B.alternate, B, Wr);
      return B.memoizedProps = B.pendingProps, c === null && (c = jQ(B)), kQ.current = null, c;
    }
    function jQ(B) {
      nt = B;
      do {
        var c = nt.alternate;
        if (B = nt.return, nt.effectTag & 2048) {
          if (c = Cb(nt), c !== null) return c.effectTag &= 2047, c;
          B !== null && (B.firstEffect = B.lastEffect = null, B.effectTag |= 2048);
        } else {
          A: {
            var f = c;
            c = nt;
            var m = Wr, F = c.pendingProps;
            switch (c.tag) {
              case 2:
                break;
              case 16:
                break;
              case 15:
              case 0:
                break;
              case 1:
                gt(c.type) && Ke();
                break;
              case 3:
                tr(), q(), F = c.stateNode, F.pendingContext && (F.context = F.pendingContext, F.pendingContext = null), (f === null || f.child === null) && au(c) && B0(c), vs(c);
                break;
              case 5:
                ur(c);
                var U = sn(Nn.current);
                if (m = c.type, f !== null && c.stateNode != null) ou(f, c, m, F, U), f.ref !== c.ref && (c.effectTag |= 128);
                else if (F) {
                  if (f = sn(Vr.current), au(c)) {
                    if (F = c, !ZA) throw Error(a(175));
                    f = CA(F.stateNode, F.type, F.memoizedProps, U, f, F), F.updateQueue = f, f = f !== null, f && B0(c);
                  } else {
                    var _ = AA(m, F, U, f, c);
                    ps(_, c, !1, !1), c.stateNode = _, iA(_, m, F, U, f) && B0(c);
                  }
                  c.ref !== null && (c.effectTag |= 128);
                } else if (c.stateNode === null) throw Error(a(166));
                break;
              case 6:
                if (f && c.stateNode != null) su(f, c, f.memoizedProps, F);
                else {
                  if (typeof F != "string" && c.stateNode === null) throw Error(a(166));
                  if (f = sn(Nn.current), U = sn(Vr.current), au(c)) {
                    if (f = c, !ZA) throw Error(a(176));
                    (f = IA(f.stateNode, f.memoizedProps, f)) && B0(c);
                  } else c.stateNode = DA(F, f, U, c);
                }
                break;
              case 11:
                break;
              case 13:
                if (Ne(Mt), F = c.memoizedState, c.effectTag & 64) {
                  c.expirationTime = m;
                  break A;
                }
                F = F !== null, U = !1, f === null ? c.memoizedProps.fallback !== void 0 && au(c) : (m = f.memoizedState, U = m !== null, F || m === null || (m = f.child.sibling, m !== null && (_ = c.firstEffect, _ !== null ? (c.firstEffect = m, m.nextEffect = _) : (c.firstEffect = c.lastEffect = m, m.nextEffect = null), m.effectTag = 8))), F && !U && c.mode & 2 && (f === null && c.memoizedProps.unstable_avoidThisFallback !== !0 || Mt.current & 1 ? cr === ua && (cr = Bu) : ((cr === ua || cr === Bu) && (cr = fu), bs !== 0 && cn !== null && (ha(cn, Wr), WQ(cn, bs)))), GA && F && (c.effectTag |= 4), nA && (F || U) && (c.effectTag |= 4);
                break;
              case 7:
                break;
              case 8:
                break;
              case 12:
                break;
              case 4:
                tr(), vs(c);
                break;
              case 10:
                yr(c);
                break;
              case 9:
                break;
              case 14:
                break;
              case 17:
                gt(c.type) && Ke();
                break;
              case 19:
                if (Ne(Mt), F = c.memoizedState, F === null) break;
                if (U = (c.effectTag & 64) !== 0, _ = F.rendering, _ === null) {
                  if (U) lu(F, !1);
                  else if (cr !== ua || f !== null && f.effectTag & 64) for (f = c.child; f !== null; ) {
                    if (_ = oa(f), _ !== null) {
                      for (c.effectTag |= 64, lu(F, !1), f = _.updateQueue, f !== null && (c.updateQueue = f, c.effectTag |= 4), F.lastEffect === null && (c.firstEffect = null), c.lastEffect = F.lastEffect, f = m, F = c.child; F !== null; ) U = F, m = f, U.effectTag &= 2, U.nextEffect = null, U.firstEffect = null, U.lastEffect = null, _ = U.alternate, _ === null ? (U.childExpirationTime = 0, U.expirationTime = m, U.child = null, U.memoizedProps = null, U.memoizedState = null, U.updateQueue = null, U.dependencies = null) : (U.childExpirationTime = _.childExpirationTime, U.expirationTime = _.expirationTime, U.child = _.child, U.memoizedProps = _.memoizedProps, U.memoizedState = _.memoizedState, U.updateQueue = _.updateQueue, m = _.dependencies, U.dependencies = m === null ? null : {
                        expirationTime: m.expirationTime,
                        firstContext: m.firstContext,
                        responders: m.responders
                      }), F = F.sibling;
                      Ie(Mt, Mt.current & 1 | 2), c = c.child;
                      break A;
                    }
                    f = f.sibling;
                  }
                } else {
                  if (!U) if (f = oa(_), f !== null) {
                    if (c.effectTag |= 64, U = !0, f = f.updateQueue, f !== null && (c.updateQueue = f, c.effectTag |= 4), lu(F, !0), F.tail === null && F.tailMode === "hidden") {
                      c = c.lastEffect = F.lastEffect, c !== null && (c.nextEffect = null);
                      break;
                    }
                  } else jt() > F.tailExpiration && 1 < m && (c.effectTag |= 64, U = !0, lu(F, !1), c.expirationTime = c.childExpirationTime = m - 1);
                  F.isBackwards ? (_.sibling = c.child, c.child = _) : (f = F.last, f !== null ? f.sibling = _ : c.child = _, F.last = _);
                }
                if (F.tail !== null) {
                  F.tailExpiration === 0 && (F.tailExpiration = jt() + 500), f = F.tail, F.rendering = f, F.tail = f.sibling, F.lastEffect = c.lastEffect, f.sibling = null, F = Mt.current, F = U ? F & 1 | 2 : F & 1, Ie(Mt, F), c = f;
                  break A;
                }
                break;
              case 20:
                break;
              case 21:
                break;
              default:
                throw Error(a(156, c.tag));
            }
            c = null;
          }
          if (f = nt, Wr === 1 || f.childExpirationTime !== 1) {
            for (F = 0, U = f.child; U !== null; ) m = U.expirationTime, _ = U.childExpirationTime, m > F && (F = m), _ > F && (F = _), U = U.sibling;
            f.childExpirationTime = F;
          }
          if (c !== null) return c;
          B !== null && !(B.effectTag & 2048) && (B.firstEffect === null && (B.firstEffect = nt.firstEffect), nt.lastEffect !== null && (B.lastEffect !== null && (B.lastEffect.nextEffect = nt.firstEffect), B.lastEffect = nt.lastEffect), 1 < nt.effectTag && (B.lastEffect !== null ? B.lastEffect.nextEffect = nt : B.firstEffect = nt, B.lastEffect = nt));
        }
        if (c = nt.sibling, c !== null) return c;
        nt = B;
      } while (nt !== null);
      return cr === ua && (cr = OB), null;
    }
    function _B(B) {
      var c = B.expirationTime;
      return B = B.childExpirationTime, c > B ? c : B;
    }
    function Qi(B) {
      var c = In();
      return j(99, bb.bind(null, B, c)), null;
    }
    function bb(B, c) {
      if (Qo(), (Te & (pn | Tn)) !== nr) throw Error(a(327));
      var f = B.finishedWork, m = B.finishedExpirationTime;
      if (f === null) return null;
      if (B.finishedWork = null, B.finishedExpirationTime = 0, f === B.current) throw Error(a(177));
      B.callbackNode = null, B.callbackExpirationTime = 0, B.callbackPriority = 90, B.nextKnownPendingLevel = 0;
      var F = _B(f);
      if (B.firstPendingTime = F, m <= B.lastSuspendedTime ? B.firstSuspendedTime = B.lastSuspendedTime = B.nextKnownPendingLevel = 0 : m <= B.firstSuspendedTime && (B.firstSuspendedTime = m - 1), m <= B.lastPingedTime && (B.lastPingedTime = 0), m <= B.lastExpiredTime && (B.lastExpiredTime = 0), B === cn && (nt = cn = null, Wr = 0), 1 < f.effectTag ? f.lastEffect !== null ? (f.lastEffect.nextEffect = f, F = f.firstEffect) : F = f : F = f.firstEffect, F !== null) {
        var U = Te;
        Te |= Tn, kQ.current = null, O(B.containerInfo), xe = F;
        do
          try {
            Fb();
          } catch (_r) {
            if (xe === null) throw Error(a(330));
            fa(xe, _r), xe = xe.nextEffect;
          }
        while (xe !== null);
        xe = F;
        do
          try {
            for (var _ = B, PA = c; xe !== null; ) {
              var vA = xe.effectTag;
              if (vA & 16 && nA && se(xe.stateNode), vA & 128) {
                var ne = xe.alternate;
                if (ne !== null) {
                  var Le = ne.ref;
                  Le !== null && (typeof Le == "function" ? Le(null) : Le.current = null);
                }
              }
              switch (vA & 1038) {
                case 2:
                  FQ(xe), xe.effectTag &= -3;
                  break;
                case 6:
                  FQ(xe), xe.effectTag &= -3, jB(xe.alternate, xe);
                  break;
                case 1024:
                  xe.effectTag &= -1025;
                  break;
                case 1028:
                  xe.effectTag &= -1025, jB(xe.alternate, xe);
                  break;
                case 4:
                  jB(xe.alternate, xe);
                  break;
                case 8:
                  var Qr = _, Xt = xe, Kr = PA;
                  nA ? LQ(Qr, Xt, Kr) : vQ(Qr, Xt, Kr), yQ(Xt);
              }
              xe = xe.nextEffect;
            }
          } catch (_r) {
            if (xe === null) throw Error(a(330));
            fa(xe, _r), xe = xe.nextEffect;
          }
        while (xe !== null);
        K(B.containerInfo), B.current = f, xe = F;
        do
          try {
            for (vA = m; xe !== null; ) {
              var Ca = xe.effectTag;
              if (Ca & 36) {
                var gn = xe.alternate;
                switch (ne = xe, Le = vA, ne.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Eo(16, 32, ne);
                    break;
                  case 1:
                    var MA = ne.stateNode;
                    if (ne.effectTag & 4) if (gn === null) MA.componentDidMount();
                    else {
                      var hA = ne.elementType === ne.type ? gn.memoizedProps : De(ne.type, gn.memoizedProps);
                      MA.componentDidUpdate(hA, gn.memoizedState, MA.__reactInternalSnapshotBeforeUpdate);
                    }
                    var RA = ne.updateQueue;
                    RA !== null && uo(ne, RA, MA, Le);
                    break;
                  case 3:
                    var me = ne.updateQueue;
                    if (me !== null) {
                      if (_ = null, ne.child !== null) switch (ne.child.tag) {
                        case 5:
                          _ = N(ne.child.stateNode);
                          break;
                        case 1:
                          _ = ne.child.stateNode;
                      }
                      uo(ne, me, _, Le);
                    }
                    break;
                  case 5:
                    var Se = ne.stateNode;
                    gn === null && ne.effectTag & 4 && WA(Se, ne.type, ne.memoizedProps, ne);
                    break;
                  case 6:
                    break;
                  case 4:
                    break;
                  case 12:
                    break;
                  case 13:
                    if (ZA && ne.memoizedState === null) {
                      var Lt = ne.alternate;
                      if (Lt !== null) {
                        var Je = Lt.memoizedState;
                        if (Je !== null) {
                          var Rt = Je.dehydrated;
                          Rt !== null && dA(Rt);
                        }
                      }
                    }
                    break;
                  case 19:
                  case 17:
                  case 20:
                  case 21:
                    break;
                  default:
                    throw Error(a(163));
                }
              }
              if (Ca & 128) {
                ne = void 0;
                var Zt = xe.ref;
                if (Zt !== null) {
                  var Bt = xe.stateNode;
                  switch (xe.tag) {
                    case 5:
                      ne = N(Bt);
                      break;
                    default:
                      ne = Bt;
                  }
                  typeof Zt == "function" ? Zt(ne) : Zt.current = ne;
                }
              }
              xe = xe.nextEffect;
            }
          } catch (_r) {
            if (xe === null) throw Error(a(330));
            fa(xe, _r), xe = xe.nextEffect;
          }
        while (xe !== null);
        xe = null, bt(), Te = U;
      } else B.current = f;
      if (Qu) Qu = !1, wu = B, Fs = c;
      else for (xe = F; xe !== null; ) c = xe.nextEffect, xe.nextEffect = null, xe = c;
      if (c = B.firstPendingTime, c === 0 && (Ei = null), c === 1073741823 ? B === ZB ? Ls++ : (Ls = 0, ZB = B) : Ls = 0, typeof XB == "function" && XB(f.stateNode, m), Zr(B), Eu) throw Eu = !1, B = WB, WB = null, B;
      return (Te & VB) !== nr || aA(), null;
    }
    function Fb() {
      for (; xe !== null; ) {
        var B = xe.effectTag;
        B & 256 && wb(xe.alternate, xe), !(B & 512) || Qu || (Qu = !0, J(97, function() {
          return Qo(), null;
        })), xe = xe.nextEffect;
      }
    }
    function Qo() {
      if (Fs !== 90) {
        var B = 97 < Fs ? 97 : Fs;
        return Fs = 90, j(B, Lb);
      }
    }
    function Lb() {
      if (wu === null) return !1;
      var B = wu;
      if (wu = null, (Te & (pn | Tn)) !== nr) throw Error(a(331));
      var c = Te;
      for (Te |= Tn, B = B.current.firstEffect; B !== null; ) {
        try {
          var f = B;
          if (f.effectTag & 512) switch (f.tag) {
            case 0:
            case 11:
            case 15:
              Eo(128, 0, f), Eo(0, 64, f);
          }
        } catch (m) {
          if (B === null) throw Error(a(330));
          fa(B, m);
        }
        f = B.nextEffect, B.nextEffect = null, B = f;
      }
      return Te = c, aA(), !0;
    }
    function VQ(B, c, f) {
      c = PB(f, c), c = GQ(B, c, 1073741823), Hn(B, c), B = Du(B, 1073741823), B !== null && Zr(B);
    }
    function fa(B, c) {
      if (B.tag === 3) VQ(B, B, c);
      else for (var f = B.return; f !== null; ) {
        if (f.tag === 3) {
          VQ(f, B, c);
          break;
        } else if (f.tag === 1) {
          var m = f.stateNode;
          if (typeof f.type.getDerivedStateFromError == "function" || typeof m.componentDidCatch == "function" && (Ei === null || !Ei.has(m))) {
            B = PB(c, B), B = xQ(f, B, 1073741823), Hn(f, B), f = Du(f, 1073741823), f !== null && Zr(f);
            break;
          }
        }
        f = f.return;
      }
    }
    function Rb(B, c, f) {
      var m = B.pingCache;
      m !== null && m.delete(c), cn === B && Wr === f ? cr === fu || cr === Bu && V0 === 1073741823 && jt() - JB < YQ ? Ba(B, Wr) : Cu = !0 : JQ(B, f) && (c = B.lastPingedTime, c !== 0 && c < f || (B.lastPingedTime = f, B.finishedExpirationTime === f && (B.finishedExpirationTime = 0, B.finishedWork = null), Zr(B)));
    }
    function Gb(B, c) {
      var f = B.stateNode;
      f !== null && f.delete(c), c = 0, c === 0 && (c = vn(), c = ga(c, B, null)), B = Du(B, c), B !== null && Zr(B);
    }
    var OQ;
    OQ = function(c, f, m) {
      var F = f.expirationTime;
      if (c !== null) {
        var U = f.pendingProps;
        if (c.memoizedProps !== U || ye.current) g0 = !0;
        else {
          if (F < m) {
            switch (g0 = !1, f.tag) {
              case 3:
                wQ(f), YB();
                break;
              case 5:
                if (Or(f), f.mode & 4 && m !== 1 && wA(f.type, U)) return f.expirationTime = f.childExpirationTime = 1, null;
                break;
              case 1:
                gt(f.type) && Ee(f);
                break;
              case 4:
                Qs(f, f.stateNode.containerInfo);
                break;
              case 10:
                zr(f, f.memoizedProps.value);
                break;
              case 13:
                if (f.memoizedState !== null)
                  return F = f.child.childExpirationTime, F !== 0 && F >= m ? IQ(c, f, m) : (Ie(Mt, Mt.current & 1), f = j0(c, f, m), f !== null ? f.sibling : null);
                Ie(Mt, Mt.current & 1);
                break;
              case 19:
                if (F = f.childExpirationTime >= m, c.effectTag & 64) {
                  if (F) return mQ(c, f, m);
                  f.effectTag |= 64;
                }
                if (U = f.memoizedState, U !== null && (U.rendering = null, U.tail = null), Ie(Mt, Mt.current), !F) return null;
            }
            return j0(c, f, m);
          }
          g0 = !1;
        }
      } else g0 = !1;
      switch (f.expirationTime = 0, f.tag) {
        case 2:
          if (F = f.type, c !== null && (c.alternate = null, f.alternate = null, f.effectTag |= 2), c = f.pendingProps, U = Ut(f, Ye.current), br(f, m), U = FB(null, f, F, c, U, m), f.effectTag |= 1, typeof U == "object" && U !== null && typeof U.render == "function" && U.$$typeof === void 0) {
            if (f.tag = 1, eQ(), gt(F)) {
              var _ = !0;
              Ee(f);
            } else _ = !1;
            f.memoizedState = U.state !== null && U.state !== void 0 ? U.state : null;
            var PA = F.getDerivedStateFromProps;
            typeof PA == "function" && na(f, F, PA, c), U.updater = ia, f.stateNode = U, U._reactInternalFiber = f, go(f, F, c, m), f = SB(null, f, F, !0, _, m);
          } else f.tag = 0, un(null, f, U, m), f = f.child;
          return f;
        case 16:
          if (U = f.elementType, c !== null && (c.alternate = null, f.alternate = null, f.effectTag |= 2), c = f.pendingProps, L(U), U._status !== 1) throw U._result;
          switch (U = U._result, f.type = U, _ = f.tag = Ub(U), c = De(U, c), _) {
            case 0:
              f = HB(null, f, U, c, m);
              break;
            case 1:
              f = QQ(null, f, U, c, m);
              break;
            case 11:
              f = dQ(null, f, U, c, m);
              break;
            case 14:
              f = hQ(null, f, U, De(U.type, c), F, m);
              break;
            default:
              throw Error(a(306, U, ""));
          }
          return f;
        case 0:
          return F = f.type, U = f.pendingProps, U = f.elementType === F ? U : De(F, U), HB(c, f, F, U, m);
        case 1:
          return F = f.type, U = f.pendingProps, U = f.elementType === F ? U : De(F, U), QQ(c, f, F, U, m);
        case 3:
          if (wQ(f), F = f.updateQueue, F === null) throw Error(a(282));
          if (U = f.memoizedState, U = U !== null ? U.element : null, Er(f, F, f.pendingProps, null, m), F = f.memoizedState.element, F === U) YB(), f = j0(c, f, m);
          else {
            if ((U = f.stateNode.hydrate) && (ZA ? (sa = D(f.stateNode.containerInfo), z0 = f, U = la = !0) : U = !1), U) for (m = aa(f, null, F, m), f.child = m; m; ) m.effectTag = m.effectTag & -3 | 1024, m = m.sibling;
            else un(c, f, F, m), YB();
            f = f.child;
          }
          return f;
        case 5:
          return Or(f), c === null && UB(f), F = f.type, U = f.pendingProps, _ = c !== null ? c.memoizedProps : null, PA = U.children, fA(F, U) ? PA = null : _ !== null && fA(F, _) && (f.effectTag |= 16), EQ(c, f), f.mode & 4 && m !== 1 && wA(F, U) ? (f.expirationTime = f.childExpirationTime = 1, f = null) : (un(c, f, PA, m), f = f.child), f;
        case 6:
          return c === null && UB(f), null;
        case 13:
          return IQ(c, f, m);
        case 4:
          return Qs(f, f.stateNode.containerInfo), F = f.pendingProps, c === null ? f.child = mn(f, null, F, m) : un(c, f, F, m), f.child;
        case 11:
          return F = f.type, U = f.pendingProps, U = f.elementType === F ? U : De(F, U), dQ(c, f, F, U, m);
        case 7:
          return un(c, f, f.pendingProps, m), f.child;
        case 8:
          return un(c, f, f.pendingProps.children, m), f.child;
        case 12:
          return un(c, f, f.pendingProps.children, m), f.child;
        case 10:
          A: {
            if (F = f.type._context, U = f.pendingProps, PA = f.memoizedProps, _ = U.value, zr(f, _), PA !== null) {
              var vA = PA.value;
              if (_ = te(vA, _) ? 0 : (typeof F._calculateChangedBits == "function" ? F._calculateChangedBits(vA, _) : 1073741823) | 0, _ === 0) {
                if (PA.children === U.children && !ye.current) {
                  f = j0(c, f, m);
                  break A;
                }
              } else for (vA = f.child, vA !== null && (vA.return = f); vA !== null; ) {
                var ne = vA.dependencies;
                if (ne !== null) {
                  PA = vA.child;
                  for (var Le = ne.firstContext; Le !== null; ) {
                    if (Le.context === F && Le.observedBits & _) {
                      vA.tag === 1 && (Le = Dn(m, null), Le.tag = 2, Hn(vA, Le)), vA.expirationTime < m && (vA.expirationTime = m), Le = vA.alternate, Le !== null && Le.expirationTime < m && (Le.expirationTime = m), o0(vA.return, m), ne.expirationTime < m && (ne.expirationTime = m);
                      break;
                    }
                    Le = Le.next;
                  }
                } else PA = vA.tag === 10 && vA.type === f.type ? null : vA.child;
                if (PA !== null) PA.return = vA;
                else for (PA = vA; PA !== null; ) {
                  if (PA === f) {
                    PA = null;
                    break;
                  }
                  if (vA = PA.sibling, vA !== null) {
                    vA.return = PA.return, PA = vA;
                    break;
                  }
                  PA = PA.return;
                }
                vA = PA;
              }
            }
            un(c, f, U.children, m), f = f.child;
          }
          return f;
        case 9:
          return U = f.type, _ = f.pendingProps, F = _.children, br(f, m), U = Cr(U, _.unstable_observedBits), F = F(U), f.effectTag |= 1, un(c, f, F, m), f.child;
        case 14:
          return U = f.type, _ = De(U, f.pendingProps), _ = De(U.type, _), hQ(c, f, U, _, F, m);
        case 15:
          return CQ(c, f, f.type, f.pendingProps, F, m);
        case 17:
          return F = f.type, U = f.pendingProps, U = f.elementType === F ? U : De(F, U), c !== null && (c.alternate = null, f.alternate = null, f.effectTag |= 2), f.tag = 1, gt(F) ? (c = !0, Ee(f)) : c = !1, br(f, m), di(f, F, U), go(f, F, U, m), SB(null, f, F, !0, c, m);
        case 19:
          return mQ(c, f, m);
      }
      throw Error(a(156, f.tag));
    };
    var XB = null, qB = null;
    function xb(B) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var c = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (c.isDisabled || !c.supportsFiber) return !0;
      try {
        var f = c.inject(B);
        XB = function(F) {
          try {
            c.onCommitFiberRoot(f, F, void 0, (F.current.effectTag & 64) === 64);
          } catch {
          }
        }, qB = function(F) {
          try {
            c.onCommitFiberUnmount(f, F);
          } catch {
          }
        };
      } catch {
      }
      return !0;
    }
    function kb(B, c, f, m) {
      this.tag = B, this.key = f, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = c, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = m, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }
    function f0(B, c, f, m) {
      return new kb(B, c, f, m);
    }
    function $B(B) {
      return B = B.prototype, !(!B || !B.isReactComponent);
    }
    function Ub(B) {
      if (typeof B == "function") return $B(B) ? 1 : 0;
      if (B != null) {
        if (B = B.$$typeof, B === b) return 11;
        if (B === Q) return 14;
      }
      return 2;
    }
    function da(B, c) {
      var f = B.alternate;
      return f === null ? (f = f0(B.tag, c, B.key, B.mode), f.elementType = B.elementType, f.type = B.type, f.stateNode = B.stateNode, f.alternate = B, B.alternate = f) : (f.pendingProps = c, f.effectTag = 0, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null), f.childExpirationTime = B.childExpirationTime, f.expirationTime = B.expirationTime, f.child = B.child, f.memoizedProps = B.memoizedProps, f.memoizedState = B.memoizedState, f.updateQueue = B.updateQueue, c = B.dependencies, f.dependencies = c === null ? null : {
        expirationTime: c.expirationTime,
        firstContext: c.firstContext,
        responders: c.responders
      }, f.sibling = B.sibling, f.index = B.index, f.ref = B.ref, f;
    }
    function pu(B, c, f, m, F, U) {
      var _ = 2;
      if (m = B, typeof B == "function") $B(B) && (_ = 1);
      else if (typeof B == "string") _ = 5;
      else A: switch (B) {
        case g:
          return wi(f.children, F, U, c);
        case I:
          _ = 8, F |= 7;
          break;
        case d:
          _ = 8, F |= 1;
          break;
        case h:
          return B = f0(12, f, c, F | 8), B.elementType = h, B.type = h, B.expirationTime = U, B;
        case y:
          return B = f0(13, f, c, F), B.type = y, B.elementType = y, B.expirationTime = U, B;
        case p:
          return B = f0(19, f, c, F), B.elementType = p, B.expirationTime = U, B;
        default:
          if (typeof B == "object" && B !== null) switch (B.$$typeof) {
            case C:
              _ = 10;
              break A;
            case E:
              _ = 9;
              break A;
            case b:
              _ = 11;
              break A;
            case Q:
              _ = 14;
              break A;
            case w:
              _ = 16, m = null;
              break A;
          }
          throw Error(a(130, B == null ? B : typeof B, ""));
      }
      return c = f0(_, f, c, F), c.elementType = B, c.type = m, c.expirationTime = U, c;
    }
    function wi(B, c, f, m) {
      return B = f0(7, B, m, c), B.expirationTime = f, B;
    }
    function Af(B, c, f) {
      return B = f0(6, B, null, c), B.expirationTime = f, B;
    }
    function ef(B, c, f) {
      return c = f0(4, B.children !== null ? B.children : [], B.key, c), c.expirationTime = f, c.stateNode = {
        containerInfo: B.containerInfo,
        pendingChildren: null,
        implementation: B.implementation
      }, c;
    }
    function Yb(B, c, f) {
      this.tag = c, this.current = null, this.containerInfo = B, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = lA, this.pendingContext = this.context = null, this.hydrate = f, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }
    function JQ(B, c) {
      var f = B.firstSuspendedTime;
      return B = B.lastSuspendedTime, f !== 0 && f >= c && B <= c;
    }
    function ha(B, c) {
      var f = B.firstSuspendedTime, m = B.lastSuspendedTime;
      f < c && (B.firstSuspendedTime = c), (m > c || f === 0) && (B.lastSuspendedTime = c), c <= B.lastPingedTime && (B.lastPingedTime = 0), c <= B.lastExpiredTime && (B.lastExpiredTime = 0);
    }
    function WQ(B, c) {
      c > B.firstPendingTime && (B.firstPendingTime = c);
      var f = B.firstSuspendedTime;
      f !== 0 && (c >= f ? B.firstSuspendedTime = B.lastSuspendedTime = B.nextKnownPendingLevel = 0 : c >= B.lastSuspendedTime && (B.lastSuspendedTime = c + 1), c > B.nextKnownPendingLevel && (B.nextKnownPendingLevel = c));
    }
    function vu(B, c) {
      var f = B.lastExpiredTime;
      (f === 0 || f > c) && (B.lastExpiredTime = c);
    }
    function ZQ(B) {
      var c = B._reactInternalFiber;
      if (c === void 0)
        throw typeof B.render == "function" ? Error(a(188)) : Error(a(268, Object.keys(B)));
      return B = R(c), B === null ? null : B.stateNode;
    }
    function KQ(B, c) {
      B = B.memoizedState, B !== null && B.dehydrated !== null && B.retryTime < c && (B.retryTime = c);
    }
    function yu(B, c) {
      KQ(B, c), (B = B.alternate) && KQ(B, c);
    }
    var _Q = {
      createContainer: function(c, f, m) {
        return c = new Yb(c, f, m), f = f0(3, null, null, f === 2 ? 7 : f === 1 ? 3 : 0), c.current = f, f.stateNode = c;
      },
      updateContainer: function(c, f, m, F) {
        var U = f.current, _ = vn(), PA = Bi.suspense;
        _ = ga(_, U, PA);
        A: if (m) {
          m = m._reactInternalFiber;
          e: {
            if (P(m) !== m || m.tag !== 1) throw Error(a(170));
            var vA = m;
            do {
              switch (vA.tag) {
                case 3:
                  vA = vA.stateNode.context;
                  break e;
                case 1:
                  if (gt(vA.type)) {
                    vA = vA.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              vA = vA.return;
            } while (vA !== null);
            throw Error(a(171));
          }
          if (m.tag === 1) {
            var ne = m.type;
            if (gt(ne)) {
              m = $A(m, ne, vA);
              break A;
            }
          }
          m = vA;
        } else m = be;
        return f.context === null ? f.context = m : f.pendingContext = m, f = Dn(_, PA), f.payload = {
          element: c
        }, F = F === void 0 ? null : F, F !== null && (f.callback = F), Hn(U, f), O0(U, _), _;
      },
      batchedEventUpdates: function(c, f) {
        var m = Te;
        Te |= 2;
        try {
          return c(f);
        } finally {
          Te = m, Te === nr && aA();
        }
      },
      batchedUpdates: function(c, f) {
        var m = Te;
        Te |= 1;
        try {
          return c(f);
        } finally {
          Te = m, Te === nr && aA();
        }
      },
      unbatchedUpdates: function(c, f) {
        var m = Te;
        Te &= -2, Te |= VB;
        try {
          return c(f);
        } finally {
          Te = m, Te === nr && aA();
        }
      },
      deferredUpdates: function(c) {
        return j(97, c);
      },
      syncUpdates: function(c, f, m, F) {
        return j(99, c.bind(null, f, m, F));
      },
      discreteUpdates: function(c, f, m, F) {
        var U = Te;
        Te |= 4;
        try {
          return j(98, c.bind(null, f, m, F));
        } finally {
          Te = U, Te === nr && aA();
        }
      },
      flushDiscreteUpdates: function() {
        (Te & (1 | pn | Tn)) === nr && (pb(), Qo());
      },
      flushControlled: function(c) {
        var f = Te;
        Te |= 1;
        try {
          j(99, c);
        } finally {
          Te = f, Te === nr && aA();
        }
      },
      flushSync: SQ,
      flushPassiveEffects: Qo,
      IsThisRendererActing: {
        current: !1
      },
      getPublicRootInstance: function(c) {
        if (c = c.current, !c.child) return null;
        switch (c.child.tag) {
          case 5:
            return N(c.child.stateNode);
          default:
            return c.child.stateNode;
        }
      },
      attemptSynchronousHydration: function(c) {
        switch (c.tag) {
          case 3:
            var f = c.stateNode;
            f.hydrate && Mb(f, f.firstPendingTime);
            break;
          case 13:
            SQ(function() {
              return O0(c, 1073741823);
            }), f = TA(vn(), 150, 100), yu(c, f);
        }
      },
      attemptUserBlockingHydration: function(c) {
        if (c.tag === 13) {
          var f = TA(vn(), 150, 100);
          O0(c, f), yu(c, f);
        }
      },
      attemptContinuousHydration: function(c) {
        if (c.tag === 13) {
          vn();
          var f = FA++;
          O0(c, f), yu(c, f);
        }
      },
      attemptHydrationAtCurrentPriority: function(c) {
        if (c.tag === 13) {
          var f = vn();
          f = ga(f, c, null), O0(c, f), yu(c, f);
        }
      },
      findHostInstance: ZQ,
      findHostInstanceWithWarning: function(c) {
        return ZQ(c);
      },
      findHostInstanceWithNoPortals: function(c) {
        return c = G(c), c === null ? null : c.tag === 20 ? c.stateNode.instance : c.stateNode;
      },
      shouldSuspend: function() {
        return !1;
      },
      injectIntoDevTools: function(c) {
        var f = c.findFiberByHostInstance;
        return xb(r({}, c, {
          overrideHookState: null,
          overrideProps: null,
          setSuspenseHandler: null,
          scheduleUpdate: null,
          currentDispatcherRef: o.ReactCurrentDispatcher,
          findHostInstanceByFiber: function(F) {
            return F = R(F), F === null ? null : F.stateNode;
          },
          findFiberByHostInstance: function(F) {
            return f ? f(F) : null;
          },
          findHostInstancesForRefresh: null,
          scheduleRefresh: null,
          scheduleRoot: null,
          setRefreshHandler: null,
          getCurrentFiber: null
        }));
      }
    };
    e.exports = _Q.default || _Q;
    var Hb = e.exports;
    return e.exports = A, Hb;
  };
})(sb);
var $AA = sb.exports, AeA = /* @__PURE__ */ _AA($AA), eeA = function e(A, t) {
  var r = Object.keys(A), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (var i = 0; i < r.length; i += 1) {
    var a = r[i];
    if (a === "render" && !A[a] != !t[a])
      return !1;
    if (a !== "children" && A[a] !== t[a]) {
      if (typeof A[a] == "object" && typeof t[a] == "object" && e(A[a], t[a]))
        continue;
      return !1;
    }
    if (a === "children" && (typeof A[a] == "string" || typeof t[a] == "string"))
      return A[a] === t[a];
  }
  return !0;
}, teA = ["style", "children"], reA = ["style"], LD = {}, eh = function(A, t) {
  var r = A.type === "TEXT" || A.type === "LINK" || A.type === "TSPAN", n = t.type === "TEXT_INSTANCE", i = n && !r;
  if (i) {
    console.warn("Invalid '" + t.value + "' string child outside <Text> component");
    return;
  }
  A.children.push(t);
}, neA = function(A) {
  var t = A.onChange, r = t === void 0 ? function() {
  } : t;
  return AeA({
    schedulePassiveEffects: Ig.unstable_scheduleCallback,
    cancelPassiveEffects: Ig.unstable_cancelCallback,
    supportsMutation: !0,
    isPrimaryRenderer: !1,
    warnsIfNotActing: !1,
    appendInitialChild: eh,
    createInstance: function(i, a) {
      var o = a.style;
      a.children;
      var s = bl(a, teA);
      return {
        type: i,
        box: {},
        style: o || {},
        props: s || {},
        children: []
      };
    },
    createTextInstance: function(i, a) {
      return {
        type: "TEXT_INSTANCE",
        value: i
      };
    },
    finalizeInitialChildren: function(i, a, o) {
      return !1;
    },
    getPublicInstance: function(i) {
      return i;
    },
    prepareForCommit: function() {
    },
    clearContainer: function() {
    },
    prepareUpdate: function(i, a, o, s) {
      return !eeA(o, s);
    },
    resetAfterCommit: r,
    resetTextContent: function(i) {
    },
    getRootHostContext: function() {
      return LD;
    },
    getChildHostContext: function() {
      return LD;
    },
    shouldSetTextContent: function(i, a) {
      return !1;
    },
    now: Date.now,
    useSyncScheduling: !0,
    appendChild: eh,
    appendChildToContainer: function(i, a) {
      i.type === "ROOT" ? i.document = a : eh(i, a);
    },
    insertBefore: function(i, a, o) {
      var s, l = (s = i.children) === null || s === void 0 ? void 0 : s.indexOf(o);
      l !== void 0 && l !== -1 && a && i.children.splice(l, 0, a);
    },
    removeChild: function(i, a) {
      var o, s = (o = i.children) === null || o === void 0 ? void 0 : o.indexOf(a);
      s !== void 0 && s !== -1 && i.children.splice(s, 1);
    },
    removeChildFromContainer: function(i, a) {
      var o, s = (o = i.children) === null || o === void 0 ? void 0 : o.indexOf(a);
      s !== void 0 && s !== -1 && i.children.splice(s, 1);
    },
    commitTextUpdate: function(i, a, o) {
      i.value = o;
    },
    commitUpdate: function(i, a, o, s, l) {
      var u = l.style, g = bl(l, reA);
      i.props = g, i.style = u;
    }
  });
}, ieA = "@react-pdf/renderer", aeA = "3.4.4", oeA = "MIT", seA = "Create PDF files on the browser and server", leA = "Diego Muracciole <diegomuracciole@gmail.com>", ueA = "https://github.com/diegomura/react-pdf#readme", ceA = "module", geA = "./lib/react-pdf.cjs", BeA = "./lib/react-pdf.js", feA = {
  "./lib/react-pdf.js": "./lib/react-pdf.browser.js",
  "./lib/react-pdf.cjs": "./lib/react-pdf.browser.cjs"
}, deA = {
  ".": {
    import: "./lib/react-pdf.js",
    require: "./lib/react-pdf.cjs",
    default: "./lib/react-pdf.js"
  }
}, heA = {
  type: "git",
  url: "https://github.com/diegomura/react-pdf.git",
  directory: "packages/renderer"
}, CeA = {
  build: "rimraf ./lib && rollup -c",
  watch: "rimraf ./lib && rollup -c -w",
  size: "size-limit",
  lint: "eslint src",
  test: "vitest && vitest --config vitest.browser.config.js"
}, EeA = {
  "@babel/runtime": "^7.20.13",
  "@react-pdf/font": "^2.5.1",
  "@react-pdf/layout": "^3.12.1",
  "@react-pdf/pdfkit": "^3.1.10",
  "@react-pdf/primitives": "^3.1.1",
  "@react-pdf/render": "^3.4.4",
  "@react-pdf/types": "^2.5.0",
  events: "^3.3.0",
  "object-assign": "^4.1.1",
  "prop-types": "^15.6.2",
  queue: "^6.0.1",
  scheduler: "^0.17.0"
}, QeA = {
  react: "^16.8.0 || ^17.0.0 || ^18.0.0"
}, weA = [
  "lib",
  "index.d.ts"
], IeA = {
  type: "opencollective",
  url: "https://opencollective.com/react-pdf",
  logo: "https://opencollective.com/opencollective/logo.txt"
}, DeA = {
  "@size-limit/preset-big-lib": "^11.0.1",
  assert: "^2.0.0",
  "browserify-zlib": "^0.2.0",
  buffer: "^6.0.3",
  process: "^0.11.10",
  "react-reconciler": "0.23.0",
  "size-limit": "^11.0.1",
  util: "^0.12.4"
}, meA = {
  name: ieA,
  version: aeA,
  license: oeA,
  description: seA,
  author: leA,
  homepage: ueA,
  type: ceA,
  main: geA,
  module: BeA,
  browser: feA,
  exports: deA,
  repository: heA,
  scripts: CeA,
  dependencies: EeA,
  peerDependencies: QeA,
  "lint-staged": {
    "*.js": [
      "yarn lint",
      "prettier --write"
    ]
  },
  files: weA,
  collective: IeA,
  devDependencies: DeA
}, MeA = meA.version, lb = new FS(), gc, Ia = {}, ub = function(A) {
  var t = function() {
    for (var C, E = ((C = Ia.change) === null || C === void 0 ? void 0 : C.slice()) || [], I = 0; I < E.length; I += 1) E[I]();
  }, r = {
    type: "ROOT",
    document: null
  };
  gc = gc || neA({
    onChange: t
  });
  var n = gc.createContainer(r), i = function(C, E) {
    gc.updateContainer(C, n, null, E);
  };
  A && i(A);
  var a = /* @__PURE__ */ function() {
    var h = Ui(/* @__PURE__ */ wr().mark(function C(E) {
      var I, b, y, p, Q, w, Y, k;
      return wr().wrap(function(S) {
        for (; ; ) switch (S.prev = S.next) {
          case 0:
            return E === void 0 && (E = !0), I = r.document.props || {}, b = I.pdfVersion, y = I.language, p = I.pageLayout, Q = I.pageMode, w = new bv({
              compress: E,
              pdfVersion: b,
              lang: y,
              displayTitle: !0,
              autoFirstPage: !1,
              pageLayout: p,
              pageMode: Q
            }), S.next = 6, TAA(r.document, lb);
          case 6:
            return Y = S.sent, k = YT(w, Y), S.abrupt("return", {
              layout: Y,
              fileStream: k
            });
          case 9:
          case "end":
            return S.stop();
        }
      }, C);
    }));
    return function(E) {
      return h.apply(this, arguments);
    };
  }(), o = function(C) {
    C === void 0 && (C = {}), r.document.props.onRender && r.document.props.onRender(C);
  }, s = /* @__PURE__ */ function() {
    var h = Ui(/* @__PURE__ */ wr().mark(function C() {
      var E, I, b, y;
      return wr().wrap(function(Q) {
        for (; ; ) switch (Q.prev = Q.next) {
          case 0:
            return E = [], Q.next = 3, a();
          case 3:
            return I = Q.sent, b = I.layout, y = I.fileStream, Q.abrupt("return", new Promise(function(w, Y) {
              y.on("data", function(k) {
                E.push(k instanceof Uint8Array ? k : new Uint8Array(k));
              }), y.on("end", function() {
                try {
                  var k = new Blob(E, {
                    type: "application/pdf"
                  });
                  o({
                    blob: k,
                    _INTERNAL__LAYOUT__DATA_: b
                  }), w(k);
                } catch (L) {
                  Y(L);
                }
              });
            }));
          case 7:
          case "end":
            return Q.stop();
        }
      }, C);
    }));
    return function() {
      return h.apply(this, arguments);
    };
  }(), l = /* @__PURE__ */ function() {
    var h = Ui(/* @__PURE__ */ wr().mark(function C() {
      var E, I, b;
      return wr().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            return p.next = 2, a();
          case 2:
            return E = p.sent, I = E.layout, b = E.fileStream, o({
              _INTERNAL__LAYOUT__DATA_: I
            }), p.abrupt("return", b);
          case 7:
          case "end":
            return p.stop();
        }
      }, C);
    }));
    return function() {
      return h.apply(this, arguments);
    };
  }(), u = /* @__PURE__ */ function() {
    var h = Ui(/* @__PURE__ */ wr().mark(function C() {
      var E, I, b;
      return wr().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            return KAA.NODE_ENV === "development" && console.warn("`toString` is deprecated and will be removed in next major release"), E = "", p.next = 4, a(!1);
          case 4:
            return I = p.sent, b = I.fileStream, p.abrupt("return", new Promise(function(Q, w) {
              try {
                b.on("data", function(Y) {
                  E += Y;
                }), b.on("end", function() {
                  o(), Q(E);
                });
              } catch (Y) {
                w(Y);
              }
            }));
          case 7:
          case "end":
            return p.stop();
        }
      }, C);
    }));
    return function() {
      return h.apply(this, arguments);
    };
  }(), g = function(C, E) {
    Ia[C] || (Ia[C] = []), Ia[C].push(E);
  }, d = function(C, E) {
    if (Ia[C]) {
      var I = Ia[C].indexOf(E);
      I > -1 && Ia[C].splice(I, 1);
    }
  };
  return {
    on: g,
    container: r,
    toBlob: s,
    toBuffer: l,
    toString: u,
    removeListener: d,
    updateContainer: i
  };
}, WE = lb, ZE = {
  create: function(A) {
    return A;
  }
}, vB = function(A) {
  var t = A === void 0 ? {} : A, r = t.document, n = An(null), i = Jt({
    url: null,
    blob: null,
    error: null,
    loading: !!r
  }), a = i[0], o = i[1];
  Wt(function() {
    var l = FR({
      autostart: !0,
      concurrency: 1
    }), u = function() {
      o(function(C) {
        return Yr({}, C, {
          loading: !0
        });
      }), l.splice(0, l.length, function() {
        return a.error ? Promise.resolve() : n.current.toBlob();
      });
    }, g = function(C) {
      console.error(C), o(function(E) {
        return Yr({}, E, {
          loading: !1,
          error: C
        });
      });
    }, d = function(C) {
      o({
        blob: C,
        error: null,
        loading: !1,
        url: URL.createObjectURL(C)
      });
    };
    return n.current = ub(), n.current.on("change", u), r && n.current.updateContainer(r), l.on("error", g), l.on("success", d), function() {
      l.end(), n.current.removeListener("change", u);
    };
  }, []), Wt(function() {
    return function() {
      a.url && URL.revokeObjectURL(a.url);
    };
  }, [a.url]);
  var s = Wh(function(l) {
    n.current.updateContainer(l);
  }, []);
  return [a, s];
}, peA = ["title", "style", "className", "children", "innerRef", "showToolbar"], veA = function(A) {
  var t = A.title, r = A.style, n = A.className, i = A.children, a = A.innerRef, o = A.showToolbar, s = o === void 0 ? !0 : o, l = bl(A, peA), u = vB(), g = u[0], d = u[1];
  Wt(function() {
    return d(i);
  }, [i]);
  var h = g.url ? g.url + "#toolbar=" + (s ? 1 : 0) : null;
  return /* @__PURE__ */ x.jsx("iframe", Yr({
    src: h,
    title: t,
    ref: a,
    style: r,
    className: n
  }, l));
}, yeA = function(A) {
  var t = A.document, r = A.children, n = vB(), i = n[0], a = n[1];
  return Wt(function() {
    return a(t);
  }, [t]), t ? r(i) : (console.warn("You should pass a valid document to BlobProvider"), null);
}, beA = ["fileName", "document", "children", "onClick", "href"], KE = function(A) {
  var t = A.fileName, r = t === void 0 ? "document.pdf" : t, n = A.document, i = A.children, a = A.onClick;
  A.href;
  var o = bl(A, beA), s = vB(), l = s[0], u = s[1];
  if (Wt(function() {
    return u(n);
  }, [n]), !n)
    return console.warn("You should pass a valid document to PDFDownloadLink"), null;
  var g = function() {
    window.navigator.msSaveBlob && window.navigator.msSaveBlob(l.blob, r);
  }, d = function(C) {
    g(), typeof a == "function" && a(C, l);
  };
  return /* @__PURE__ */ x.jsx("a", Yr({
    href: l.url,
    download: r,
    onClick: d
  }, o, {
    children: typeof i == "function" ? i(l) : i
  }));
}, yB = function(A) {
  throw new Error(A + " is a Node specific API. You're either using this method in a browser, or your bundler is not loading react-pdf from the appropriate web build.");
}, FeA = function() {
  yB("renderToStream");
}, LeA = function() {
  yB("renderToString");
}, ReA = function() {
  yB("renderToFile");
}, GeA = function() {
  yB("render");
};
Yr({
  pdf: ub,
  usePDF: vB,
  Font: WE,
  version: MeA,
  StyleSheet: ZE,
  PDFViewer: veA,
  BlobProvider: yeA,
  PDFDownloadLink: KE,
  renderToStream: FeA,
  renderToString: LeA,
  renderToFile: ReA,
  render: GeA
}, MR);
const Ll = (e) => {
  const { isPdf: A } = lC();
  return A ? /* @__PURE__ */ x.jsx(Ue, { children: e.children }) : /* @__PURE__ */ x.jsx(x.Fragment, { children: e.children });
}, _E = () => /* @__PURE__ */ x.jsx(Ll, {}), cb = (e, A) => e.replace("%s", A.toString()), tn = (e) => e.data ? /* @__PURE__ */ x.jsx("span", { className: e.font, children: /* @__PURE__ */ x.jsx(Ll, { children: e.format ? cb(e.format, e.data) : e.data }) }) : /* @__PURE__ */ x.jsx(_E, {}), xeA = (e) => e.replace(/(?=.{5}$)/, " "), Uo = (e) => /* @__PURE__ */ x.jsx(tn, { data: e.arbeidsgiver.type === "Person" ? xeA(e.arbeidsgiver.fnr) : e.arbeidsgiver.orgnavn }), keA = (e) => {
  const { foretak: A, onClick: t } = e, r = (n, i) => n.replace("{id}", i.toString());
  switch (t.type) {
    case "INGEN_ON_CLICK":
      return /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: A.arbeidsgiver });
    case "LENKE":
      return /* @__PURE__ */ x.jsx("a", { href: r(t.href, A.navArbeidsforholdId), children: /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: A.arbeidsgiver }) });
    case "REACT_ROUTER_LENKE":
      return /* @__PURE__ */ x.jsx(t.Component, { to: r(t.to, A.navArbeidsforholdId), children: /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: A.arbeidsgiver }) });
    case "KNAPP":
      return /* @__PURE__ */ x.jsx("button", { className: "af-liste__knapp", onClick: () => t.getId(A.navArbeidsforholdId), children: /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: A.arbeidsgiver }) });
  }
};
var Hc = { exports: {} }, UeA = Hc.exports, RD;
function YeA() {
  return RD || (RD = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(oC());
    })(UeA, function(t) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var n = r(t), i = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(a) {
        return a + ".";
      }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
      return n.default.locale(i, null, !0), i;
    });
  }(Hc)), Hc.exports;
}
YeA();
var Sc = { exports: {} }, HeA = Sc.exports, GD;
function SeA() {
  return GD || (GD = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(oC());
    })(HeA, function(t) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var n = r(t), i = { name: "nn", weekdays: "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"), weekdaysShort: "sun_mån_tys_ons_tor_fre_lau".split("_"), weekdaysMin: "su_må_ty_on_to_fr_la".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"), ordinal: function(a) {
        return a + ".";
      }, weekStart: 1, relativeTime: { future: "om %s", past: "for %s sidan", s: "nokre sekund", m: "eitt minutt", mm: "%d minutt", h: "ein time", hh: "%d timar", d: "ein dag", dd: "%d dagar", M: "ein månad", MM: "%d månadar", y: "eitt år", yy: "%d år" }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] H:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" } };
      return n.default.locale(i, null, !0), i;
    });
  }(Sc)), Sc.exports;
}
SeA();
const e0 = (e) => {
  const { locale: A } = Pt();
  if (!e.data)
    return /* @__PURE__ */ x.jsx(_E, {});
  const t = Wi(e.data).locale(A).format(e.dateFormat ?? "DD.MM.YYYY"), r = e.format ? cb(e.format, t) : t;
  return /* @__PURE__ */ x.jsx("span", { children: e.maskineltAvsluttet ? /* @__PURE__ */ x.jsxs("span", { children: [
    /* @__PURE__ */ x.jsx(Ll, { children: r }),
    /* @__PURE__ */ x.jsx(SL, { id: e.maskineltAvsluttet, className: "af-date__hjelpetekst", children: e.maskineltAvsluttet })
  ] }) : /* @__PURE__ */ x.jsx(Ll, { children: r }) });
}, a0 = (e) => e.data ? /* @__PURE__ */ x.jsxs("span", { children: [
  /* @__PURE__ */ x.jsx(e0, { data: e.data.periodeFra, dateFormat: e.format }),
  /* @__PURE__ */ x.jsx(Ll, { children: " - " }),
  e.twoLines && /* @__PURE__ */ x.jsx("br", {}),
  /* @__PURE__ */ x.jsx(e0, { data: e.data.periodeTil, dateFormat: e.format, maskineltAvsluttet: e.maskineltAvsluttet })
] }) : /* @__PURE__ */ x.jsx(_E, {}), NeA = (e) => {
  const { locale: A } = Pt();
  return /* @__PURE__ */ x.jsx("div", { className: "af-liste__flex-rad", children: /* @__PURE__ */ x.jsxs("div", { className: "af-liste__flex-innhold", children: [
    /* @__PURE__ */ x.jsx("div", { className: "af-liste__tekst", children: /* @__PURE__ */ x.jsx(keA, { foretak: e.foretak, onClick: e.onClick }) }),
    /* @__PURE__ */ x.jsx("div", { className: "af-liste__tekst", children: /* @__PURE__ */ x.jsx(tn, { data: e.foretak.yrke }) }),
    /* @__PURE__ */ x.jsx("div", { className: "af-liste__tekst", children: /* @__PURE__ */ x.jsx(a0, { data: e.foretak.ansettelsesperiode.periode, maskineltAvsluttet: e.foretak.ansettelsesperiode.varslingskode ? re[A][e.foretak.ansettelsesperiode.varslingskode] : null }) })
  ] }) });
}, TeA = (e) => {
  const { locale: A } = Pt();
  return /* @__PURE__ */ x.jsx("button", { className: "af-liste__vis-flere", onClick: e.toggleVisAlle, "aria-expanded": e.visAlle, children: e.visAlle ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    re[A].visfaerrearbeidsforhold,
    " ",
    /* @__PURE__ */ x.jsx(pg, { "aria-hidden": "true" })
  ] }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    re[A].visflerearbeidsforhold,
    " ",
    /* @__PURE__ */ x.jsx(Mg, { "aria-hidden": "true" })
  ] }) });
}, PeA = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAA1CAYAAADfw8w+AAAABmJLR0QA/wD/AP+gvaeTAAAGhklEQVR42u2ce0wcRRzHR+UpVMFoNGoVmhSKCH+IViypCaTWYkJIGkCgiTVKUh9pGhtCRJqWhD+kUotpKGlVGhvTkDTQpGlT09TyKgctBwUKWAhCT14FjjdHed0x/ma7d53bnb2jK3C7i5N8/2BmHzOf+81vXr8FIRenqwj5VCH0ISjjBkK/gipA9aAuXk0gHagYlA1KvInQi+j/9CiVI/Q8ANwPcKpACyD8mFoCtYJyQEHrFqQOoTcBwDnQvAyIjlRVjdBH6wYkNPY1aPR53rLwKqoeLD9KsyAxQk8CzHRoqGmVQQrdwZlrCD2rKZhgKS9Aw/5YQ5BCGeDHjNRKFw+FBvW6EKZVc1CXj9UOMxIaMqoAmFZZQF+rEmYlQmFQ+TEFwbT5VXBBaWqDGQgVv69AmFaZQXGqgFmPkDtUtlbBMK2aApcUrHigUNGfVADTNldtQ8hDyaufd3jHrxagGKz0W0XCPI/QU1DBBjXB5GUiqzcldvUUFcK0WukvSltWPgGVuqNWoGSXC9zV60rynTtVDNNqpT8oqbufUztQUD8ZB1wOk+yyQ2VmNACUaIcS1uuxGoGpjG5PKqEVoDe4hZ7r/WeVhoBaahDydjXQYQ0BxWSXzJUnln5agkkEW3sJqz3HfI+cf9Miu/D8Nt1mVqVq/f3x3cREO90OC+PKGiMiHuYlJOA70dG4buNGycY1hITgtrg43Lx9O9Z5enJ5+sBA0bNZqvXzEz1PHxAguu6v+Hgh0C9ZHMAVPEe1/21ZMMlODDxgiPErRvFnRW+xQPTm5eGlpSU7DZ49y0GZHxqyLzObsbG0FNds2GC7v3nbNjzd2Gh33Vx/P25PTsaGI0dEz2bJcPiwqF7GkhLRdVN1dcK2ZUi4tixqNiDvKAUenswA1kqVRwnLdV5eeMFoZAJtT0mRBDB6+TJ3f0tMDLbMzTGvsSwucvCF+QS2MG+6udmuXjU+PthsMomu60xLE7Yvm3ViC/ndfPmw7C0/PhRG+Avup4CKLLR9zx4mDAJ0vLxc2qosFq5LzvX2OrQ888yMKO+fnBzmtfVBQbZ6ke4tLF+cmMA1vr5OLRTyd1HXHJUFE3zGFkYwwgOQP/WiICHQicpKZuNI1yLQHMHqP3FiWd1ZqPbUVOZ772Vm2uo1XFwsfl9BAWty/wUDaCl1zh8kt7vnM7r7GUejfLW7Ox4oLMTGCxdElZ/p6MADp05xGr9+nQlmYWRElDdeVobvJiXh1thYSeAEKKtnTOn1Nje0ODkpKr8dHs4CulvQxpeomKsyudbpLXH8+y7j1xMNWk1btzK7PH3NyMWLTi2PACYwnN1HgEr5bjIrICO5MH9Sp5NafoYKDOs7yh0ky/WdnzBe1iSx9KyUA1TK79EytbSIGmzIzmYC5WYXx46JyrrT07l3C/M79u5lnoaCRXoJBqMuvsx4BSFPuUB1y/Et/LVH5QA1HDrk3D+CzyXzVbv7GNMmK9D64GCRnybdfmFszN7yR0exztubNamvk9rnhbK8/xKgIHzZNAS2PiMBdJcsoFlZyx50Zg0GDgzRbE+PqPxBVxdXRibzUv6ZVl9+vtRiIlfQ+0qoJWmIXOssYLzoZyf7oabVBEpr5NIlZv54RcXDaRtM/p09oyE0VMp/RlvbRSKjqcGoQm6QwtNw8zjjZRFOtvB+XymgUtMurvs2NHArIOZID6M8B8XDA88PDko+wwqeoT56xx7alEmBTpW7t/k540X6ZVj1jpUASrp2tZsb7jt+nDln7dy3jwmUjO70bKAnN9fhnFUC6Pf0oSP8/TfvO0fogepxu7ue4ajTlnmv7UyezO+EQAZOn7Z7bvfBg6LGdh048OhHiYzE94uKOP9onp3lfCdZ79/LyHC6btdv2sStgkS+trPTtskiDHWEqeIrlGF9QJX96Kqd+yQVH30UKi7QgZ+z3VIhUBI09rJSA8Ui+FBBNW0of6P0qGU1HdrVwoDjpmigpIJQ0WoVwByDugaoIugWKvqqQj5UcBTLtFNVYeHgm95Q2AcLdIz9p0iNiR+khpQUW6+6DxYYmy2bqS0wV2oGYMYjLSTyaSD/faerYLYDzHCkpcSvj7+CadXEGn/odRIGSV+k1UTOaMBafluDBYBOdkCCin1rEX+SupJfH1+DZ8eg9Zp4//oZWO1VmYG7Zn6XLEtRcfJKSCQiA6zrff5fZpwEXQHdBLWBOvj/P/InOc4m3xeRzwvpOAGlpX8BJDzYgsMhl9kAAAAASUVORK5CYII=", KA = ZE.create({
  page: {
    fontFamily: "SourceSansPro",
    display: "flex",
    paddingTop: 40,
    paddingBottom: 100,
    paddingHorizontal: 40
  },
  //Header
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 30
  },
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  name: {
    paddingTop: 10,
    fontWeight: "bold",
    fontSize: 12
  },
  fnr: {
    fontWeight: "normal",
    fontSize: 12
  },
  //Fonts
  h1: {
    fontSize: 16,
    fontWeight: "bold"
  },
  h2: {
    fontSize: 14,
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  h3: {
    fontWeight: "bold",
    fontSize: 12
  },
  normaltekst: {
    paddingTop: 2.5,
    fontSize: 11
  },
  // General
  section: {
    padding: 10
  },
  twoColumns: {
    width: "50%"
  },
  threeColumns: {
    width: "33%"
  },
  pageNumber: {
    fontSize: 11
  },
  //Tables
  flexGrid: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row"
  },
  tableTitle: {
    paddingVertical: 10,
    width: "100%"
  },
  flexSection: {
    paddingTop: 12
  },
  flexRow: {
    flexDirection: "row"
  },
  flexColumn: {
    paddingVertical: 2,
    paddingRight: 10,
    width: "33%"
  },
  //Footer
  footer: {
    position: "absolute",
    bottom: 50,
    left: 50,
    paddingTop: 10,
    fontSize: 11
  },
  //Detaljert
  h2Container: {
    display: "flex",
    flexDirection: "column"
  },
  introRow: {
    display: "flex",
    paddingVertical: 5,
    flexDirection: "row",
    alignItems: "flex-end"
  },
  //Liste
  liste: {
    marginHorizontal: 10,
    borderTop: "1px solid black",
    borderBottom: "1px solid #979797"
  },
  listeRow: {
    paddingVertical: 10,
    borderTop: "1px solid #979797"
  }
}), XE = (e) => {
  const { locale: A } = Pt(), t = ZE.create({
    image: {
      padding: 10,
      width: 75
    }
  });
  return /* @__PURE__ */ x.jsxs(Me, { style: KA.header, fixed: !0, children: [
    /* @__PURE__ */ x.jsx(Me, { style: [KA.section, KA.center, { width: "20%" }], children: /* @__PURE__ */ x.jsx(Xi, { style: t.image, src: PeA }) }),
    /* @__PURE__ */ x.jsxs(Me, { style: [KA.section, KA.center, { width: "60%" }], children: [
      /* @__PURE__ */ x.jsx(Ue, { style: KA.h1, children: re[A].arbeidsforhold }),
      /* @__PURE__ */ x.jsxs(Me, { style: KA.center, children: [
        /* @__PURE__ */ x.jsx(Ue, { style: KA.name, children: e.printName }),
        /* @__PURE__ */ x.jsx(Ue, { style: KA.fnr, children: e.printSSO.replace(/.{5}$/, " $&") })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx(Me, { style: [KA.section, KA.center, { width: "20%" }], children: /* @__PURE__ */ x.jsx(Ue, { fixed: !0, style: KA.pageNumber, render: ({ pageNumber: r, totalPages: n }) => `${re[A].side} ${r} / ${n}` }) })
  ] });
}, qE = () => {
  const { locale: e } = Pt();
  return /* @__PURE__ */ x.jsxs(Me, { style: KA.footer, fixed: !0, children: [
    /* @__PURE__ */ x.jsx(Ue, { children: re[e].pdfFooter1 }),
    /* @__PURE__ */ x.jsx(Ue, { children: re[e].pdfFooter2(Wi().format("DD.MM.YYYY")) })
  ] });
}, zeA = "data:font/ttf;base64,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", jeA = "data:font/ttf;base64,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", VeA = "data:font/ttf;base64,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", gb = {
  family: "SourceSansPro",
  fonts: [{ src: zeA }, { src: jeA, fontStyle: "italic" }, { src: VeA, fontWeight: 700 }]
}, OeA = ({ arbeidsforhold: e, printName: A, printSSO: t }) => (WE.register(gb), /* @__PURE__ */ x.jsx(xg, { children: /* @__PURE__ */ x.jsxs(os, { size: "A4", style: KA.page, children: [
  /* @__PURE__ */ x.jsx(XE, { printName: A, printSSO: t }),
  /* @__PURE__ */ x.jsx(Me, { style: KA.liste, children: e.map((r, n) => /* @__PURE__ */ x.jsxs(Me, { style: KA.listeRow, wrap: !1, children: [
    /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: r.arbeidsgiver }) }),
    /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: r.yrke }),
    /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(a0, { data: r.ansettelsesperiode.periode }) })
  ] }, n)) }),
  /* @__PURE__ */ x.jsx(qE, {})
] }) })), JeA = (e) => {
  const { locale: A, LocaleProvider: t } = Pt(), { IsPdfProvider: r } = lC();
  return /* @__PURE__ */ x.jsx("div", { className: "af-liste__print-button", children: /* @__PURE__ */ x.jsx(KE, { document: /* @__PURE__ */ x.jsx(r, { value: !0, children: /* @__PURE__ */ x.jsx(t, { value: A, children: /* @__PURE__ */ x.jsx(OeA, { arbeidsforhold: e.arbeidsforhold, printName: e.printName, printSSO: e.printSSN }) }) }), fileName: "arbeidsforhold.pdf", children: ({ loading: n }) => n ? null : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(qh, { "aria-hidden": "true" }),
    /* @__PURE__ */ x.jsx("span", { children: re[A].skrivut })
  ] }) }) });
}, WeA = (e) => {
  const { arbeidsforhold: A, onClick: t } = e, [r, n] = Jt(!1), { locale: i } = Pt(), a = A.sort((o, s) => ai(o.ansettelsesperiode.periode, s.ansettelsesperiode.periode)).sort((o, s) => sC(o.ansettelsesperiode.periode, s.ansettelsesperiode.periode));
  return /* @__PURE__ */ x.jsxs("div", { className: "af-liste__container", children: [
    /* @__PURE__ */ x.jsxs("div", { className: "af-liste__table", children: [
      a.length > 0 && a.slice(0, r ? A.length : 5).map((o, s) => /* @__PURE__ */ x.jsx(NeA, { foretak: o, onClick: t }, s)),
      a.length === 0 && /* @__PURE__ */ x.jsx("div", { className: "af-liste__flex-rad", children: /* @__PURE__ */ x.jsx(Zn, { children: re[i].ingenarbeidsforhold }) })
    ] }),
    A.length > 5 && /* @__PURE__ */ x.jsx(TeA, { toggleVisAlle: () => n(!r), visAlle: r }),
    e.printActivated && A.length > 0 && /* @__PURE__ */ x.jsx(JeA, { arbeidsforhold: A, printSSN: e.printSSN, printName: e.printName })
  ] });
};
let xD = { status: "LOADING" };
const ItA = (e) => {
  const [A, t] = Jt(xD), { LocaleProvider: r } = Pt();
  switch (Wt(() => {
    kr.settEnv(e.miljo);
  }, []), Wt(() => (A.status === "LOADING" && ER(e.customApiUrl).then((n) => t({
    status: "RESULT",
    arbeidsforhold: n
  })).catch((n) => t({
    status: "ERROR",
    error: n
  })), () => {
    xD = A;
  }), [A]), A.status) {
    case "LOADING":
      return /* @__PURE__ */ x.jsx(D4, {});
    case "RESULT":
      return /* @__PURE__ */ x.jsx(r, { value: e.locale, children: /* @__PURE__ */ x.jsx(WeA, { arbeidsforhold: A.arbeidsforhold, ...e }) });
    case "ERROR":
      return /* @__PURE__ */ x.jsx(r, { value: e.locale, children: /* @__PURE__ */ x.jsx(w4, { error: A.error }) });
  }
}, fn = (e) => e.data ? /* @__PURE__ */ x.jsxs("div", { className: "af-detaljert__boks", children: [
  /* @__PURE__ */ x.jsx("dt", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: e.title }) }),
  /* @__PURE__ */ x.jsxs("dd", { children: [
    /* @__PURE__ */ x.jsx(Zn, { children: e.date ? /* @__PURE__ */ x.jsx(e0, { data: e.data, format: e.format }) : /* @__PURE__ */ x.jsx(tn, { data: e.data, format: e.format }) }),
    e.children
  ] })
] }) : null, $E = (e) => e.replace(/(?=.{3}$)/, " ").replace(/(?=.{7}$)/, " "), Bb = (e) => {
  const { locale: A } = Pt();
  return /* @__PURE__ */ x.jsxs("dl", { className: "af-detaljert__arbeidsavtaleinnhold", children: [
    e.isUtvidet && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(x.Fragment, { children: e.data.opplysningspliktigarbeidsgiver.type === "Organisasjon" && /* @__PURE__ */ x.jsx(fn, { title: re[A].hovedenhet, data: e.data.opplysningspliktigarbeidsgiver.orgnavn, children: /* @__PURE__ */ x.jsx(Zn, { children: /* @__PURE__ */ x.jsx(tn, { data: $E(e.data.opplysningspliktigarbeidsgiver.orgnr), format: `${re[A].organisasjonsnummer} %s` }) }) }) }),
      /* @__PURE__ */ x.jsx(fn, { title: re[A].yrke, data: e.data.yrke }),
      /* @__PURE__ */ x.jsx(fn, { title: re[A].typearbeidsforhold, data: e.data.type }),
      /* @__PURE__ */ x.jsx(fn, { title: re[A].arbeidsforholdid, data: e.data.eksternArbeidsforholdId })
    ] }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].arbeidstidsordning, data: e.data.arbeidstidsordning }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].ansettelsesform, data: e.data.ansettelsesform }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].sistelonnsendring, data: e.data.sisteLoennsendring, date: !0 }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].stillingsprosent, data: e.data.stillingsprosent, children: /* @__PURE__ */ x.jsx(Zn, { children: /* @__PURE__ */ x.jsx(e0, { data: e.data.sisteStillingsendring, format: `(${re[A].endretstillingsprosent} %s)` }) }) }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].timerperuke, data: e.data.antallTimerPrUke }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].skipsregister, data: e.data.skipsregister }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].skipstype, data: e.data.skipstype }),
    /* @__PURE__ */ x.jsx(fn, { title: re[A].fartsomraade, data: e.data.fartsomraade }),
    e.isUtvidet && /* @__PURE__ */ x.jsx(fn, { title: re[A].sistbekreftet, data: e.data.sistBekreftet, date: !0 })
  ] });
}, ZeA = (e) => {
  const { locale: A } = Pt();
  e.timer.sort((i, a) => ai(i.periode, a.periode));
  const t = {};
  e.timer.forEach((i, a) => {
    const o = Wi(i.rapporteringsperiode).year();
    t[o] ? t[o].timerObjekt.push(i) : t[o] = {
      timerObjekt: [i],
      ekspandert: !a
    };
  });
  const [r, n] = Jt(t);
  return /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__tableWrapper", children: /* @__PURE__ */ x.jsxs("table", { className: "af-detaljert__tabs-innhold af-detaljert__table", children: [
    /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
      /* @__PURE__ */ x.jsx("th", { className: "af-detaljert__rapporteringsperiode", children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].rapporteringsperiode }) }),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].opptjeningsperiode }) }),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].antalltimer }) })
    ] }) }),
    /* @__PURE__ */ x.jsx("tbody", { children: Object.keys(r).reverse().map((i) => {
      const a = r[i], o = () => n({
        ...r,
        [i]: {
          ...r[i],
          ekspandert: !r[i].ekspandert
        }
      });
      return /* @__PURE__ */ x.jsxs(Zh, { children: [
        /* @__PURE__ */ x.jsx("tr", { children: /* @__PURE__ */ x.jsx("td", { colSpan: 3, children: /* @__PURE__ */ x.jsxs("button", { className: "af-liste__ekspander", onClick: o, children: [
          i,
          " ",
          a.ekspandert ? /* @__PURE__ */ x.jsx(pg, { "aria-hidden": "true" }) : /* @__PURE__ */ x.jsx(Mg, { "aria-hidden": "true" })
        ] }) }) }, i),
        a.ekspandert && a.timerObjekt.map((s, l) => /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx("td", { className: " af-liste__month", children: s.periode && /* @__PURE__ */ x.jsx(e0, { data: s.rapporteringsperiode, dateFormat: "MMMM" }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(a0, { data: s.periode }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(tn, { data: s.antallTimer }) })
        ] }, `${l}`))
      ] }, i);
    }) })
  ] }) });
}, KeA = (e) => {
  const { locale: A } = Pt();
  return e.permisjoner.sort((t, r) => ai(t.periode, r.periode)), /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__tableWrapper", children: /* @__PURE__ */ x.jsxs("table", { className: "af-detaljert__tabs-innhold af-detaljert__table", children: [
    /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].type }) }),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].periode }) }),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].prosent }) })
    ] }) }),
    /* @__PURE__ */ x.jsx("tbody", { children: e.permisjoner.map((t, r) => /* @__PURE__ */ x.jsxs("tr", { children: [
      /* @__PURE__ */ x.jsx("td", { children: t.type }),
      /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(a0, { data: t.periode }) }),
      /* @__PURE__ */ x.jsx("td", { children: t.prosent })
    ] }, `${t.permisjonPermitteringId}-${r}`)) })
  ] }) });
}, _eA = (e) => {
  const { locale: A } = Pt();
  e.utenlandsopphold.sort((i, a) => ai(i.periode, a.periode));
  const t = {};
  e.utenlandsopphold.forEach((i, a) => {
    const o = Wi(i.periode.periodeFra).year();
    t[o] ? t[o].opphold.push(i) : t[o] = {
      opphold: [i],
      ekspandert: !a
    };
  });
  const [r, n] = Jt(t);
  return /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__tableWrapper", children: /* @__PURE__ */ x.jsxs("table", { className: "af-detaljert__tabs-innhold af-detaljert__table", children: [
    /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].periode }) }),
      /* @__PURE__ */ x.jsx("th", {}),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].land }) })
    ] }) }),
    /* @__PURE__ */ x.jsx("tbody", { children: Object.keys(r).reverse().map((i) => {
      const a = r[i], o = () => n({
        ...r,
        [i]: {
          ...r[i],
          ekspandert: !r[i].ekspandert
        }
      });
      return /* @__PURE__ */ x.jsxs(Zh, { children: [
        /* @__PURE__ */ x.jsx("tr", { children: /* @__PURE__ */ x.jsx("td", { colSpan: 3, children: /* @__PURE__ */ x.jsxs("button", { className: "af-liste__ekspander", onClick: o, children: [
          i,
          " ",
          a.ekspandert ? /* @__PURE__ */ x.jsx(pg, { "aria-hidden": "true" }) : /* @__PURE__ */ x.jsx(Mg, { "aria-hidden": "true" })
        ] }) }) }, i),
        a.ekspandert && a.opphold.map((s, l) => /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx("td", { className: "af-liste__month", children: /* @__PURE__ */ x.jsx(e0, { data: s.periode.periodeFra, dateFormat: "MMMM" }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(a0, { data: s.periode }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(tn, { data: s.land }) })
        ] }, `${l}`))
      ] }, i);
    }) })
  ] }) });
}, XeA = (e) => {
  const { locale: A } = Pt(), t = e.arbeidsavtaler.sort((i, a) => ai(i.gyldighetsperiode, a.gyldighetsperiode)).sort((i, a) => sC(i.gyldighetsperiode, a.gyldighetsperiode)), [r, n] = Jt(t.map((i) => ({
    arbeidsavtale: i,
    ekspandert: !1
  })));
  return /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__tableWrapper", children: /* @__PURE__ */ x.jsxs("table", { className: "af-detaljert__tabs-innhold af-detaljert__table", children: [
    /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].yrke }) }),
      /* @__PURE__ */ x.jsx("th", { children: /* @__PURE__ */ x.jsx(Lr, { as: "p", size: "xsmall", children: re[A].periode }) }),
      /* @__PURE__ */ x.jsx("th", {})
    ] }) }),
    /* @__PURE__ */ x.jsx("tbody", { children: r.map((i, a) => {
      const { arbeidsavtale: o, ekspandert: s } = i, l = () => n(r.map((u, g) => g === a ? { ...u, ekspandert: !r[g].ekspandert } : u));
      return /* @__PURE__ */ x.jsxs(Zh, { children: [
        /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(tn, { data: o.yrke }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx(a0, { data: o.gyldighetsperiode }) }),
          /* @__PURE__ */ x.jsx("td", { children: /* @__PURE__ */ x.jsx("button", { className: "af-liste__ekspander", onClick: l, children: s ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            re[A].lukke,
            " ",
            /* @__PURE__ */ x.jsx(pg, { "aria-hidden": "true" })
          ] }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            re[A].apne,
            " ",
            /* @__PURE__ */ x.jsx(Mg, { "aria-hidden": "true" })
          ] }) }) })
        ] }, a),
        s && /* @__PURE__ */ x.jsx("tr", { children: /* @__PURE__ */ x.jsx("td", { colSpan: 3, children: /* @__PURE__ */ x.jsx(Bb, { data: o, isUtvidet: !1 }) }) })
      ] }, a);
    }) })
  ] }) });
}, qeA = ({ type: e, arbeidsforhold: A }) => {
  const { antallTimerForTimelonnet: t, permisjonPermittering: r, utenlandsopphold: n, arbeidsavtaler: i } = A;
  switch (e) {
    case "timer":
      return /* @__PURE__ */ x.jsx(ZeA, { timer: t });
    case "permisjon":
      return /* @__PURE__ */ x.jsx(KeA, { permisjoner: r });
    case "utenlandsopphold":
      return /* @__PURE__ */ x.jsx(_eA, { utenlandsopphold: n });
    case "historikk":
      return /* @__PURE__ */ x.jsx(XeA, { arbeidsavtaler: i });
    default:
      return null;
  }
}, $eA = (e, A) => {
  const { antallTimerForTimelonnet: t, permisjonPermittering: r, utenlandsopphold: n, arbeidsavtaler: i } = e, a = [];
  return t && t.length > 0 && a.push({
    label: re[A].tabs.timerfortimelonnet,
    type: "timer"
  }), r && r.length > 0 && a.push({
    label: re[A].tabs.permisjonpermittering,
    type: "permisjon"
  }), n && n.length > 0 && a.push({
    label: re[A].tabs.arbeidiutlandet,
    type: "utenlandsopphold"
  }), i && i.length > 0 && a.push({
    label: re[A].tabs.historikk,
    type: "historikk"
  }), a;
}, AtA = ({ arbeidsforhold: e }) => {
  var i;
  const { locale: A } = Pt(), t = $eA(e, A), [r, n] = Jt((i = t[0]) == null ? void 0 : i.type);
  return t.length === 0 ? null : /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__tabs", children: /* @__PURE__ */ x.jsxs(va, { value: r, onChange: (a) => {
    n(a);
  }, children: [
    /* @__PURE__ */ x.jsx(va.List, { children: t.map((a, o) => /* @__PURE__ */ x.jsx(va.Tab, { value: a.type, label: a.label }, o)) }),
    t.map((a, o) => /* @__PURE__ */ x.jsx(va.Panel, { value: a.type, children: /* @__PURE__ */ x.jsx(qeA, { arbeidsforhold: e, type: a.type }) }, o))
  ] }) });
}, etA = (e) => {
  var r;
  const { arbeidsforhold: A } = e, { locale: t } = Pt();
  return /* @__PURE__ */ x.jsxs("div", { className: "af-detaljert__intro", children: [
    /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__seksjon", children: /* @__PURE__ */ x.jsxs("div", { className: "af-detaljert__arbeidsgiver", children: [
      /* @__PURE__ */ x.jsx(Lr, { level: "2", size: "small", children: /* @__PURE__ */ x.jsx(Uo, { arbeidsgiver: A.arbeidsgiver }) }),
      A.arbeidsgiver.type === "Organisasjon" && /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__orgnr", children: /* @__PURE__ */ x.jsx(Zn, { children: /* @__PURE__ */ x.jsx(tn, { data: $E(A.arbeidsgiver.orgnr), format: `${re[t].organisasjonsnummer} %s` }) }) })
    ] }) }),
    A.ansettelsesperiode && /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__seksjon af-detaljert__periode", children: /* @__PURE__ */ x.jsxs("div", { className: "af-detaljert__arbeidsgiver", children: [
      /* @__PURE__ */ x.jsx(Lr, { level: "2", size: "xsmall", children: re[t].ansettelsesperiode }),
      /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__orgnr", children: /* @__PURE__ */ x.jsxs(Zn, { children: [
        /* @__PURE__ */ x.jsx(a0, { data: A.ansettelsesperiode.periode }),
        /* @__PURE__ */ x.jsx(tn, { data: (r = A.ansettelsesperiode) == null ? void 0 : r.sluttaarsak, format: `(${re[t].sluttaarsak}: %s)` })
      ] }) })
    ] }) })
  ] });
}, ttA = (e) => {
  const { locale: A } = Pt();
  e.timer.sort((r, n) => ai(r.periode, n.periode));
  const t = {};
  return e.timer.forEach((r) => {
    const n = Wi(r.rapporteringsperiode).year();
    t[n] ? t[n].timerObjekt.push(r) : t[n] = {
      timerObjekt: [r]
    };
  }), /* @__PURE__ */ x.jsxs(Me, { children: [
    /* @__PURE__ */ x.jsxs(Me, { children: [
      /* @__PURE__ */ x.jsx(Me, { style: KA.tableTitle, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h2, children: "Timer for timelønnet" }) }),
      /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].rapporteringsperiode }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].opptjeningsperiode }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].antalltimer }) })
      ] })
    ] }),
    Object.keys(t).reverse().map((r) => {
      const n = t[r];
      return /* @__PURE__ */ x.jsxs(Me, { style: KA.flexSection, children: [
        /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: r }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn })
        ] }),
        n.timerObjekt.map((i, a) => /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: i.periode && /* @__PURE__ */ x.jsx(e0, { data: i.rapporteringsperiode, dateFormat: "MMMM" }) }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(a0, { data: i.periode }) }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(tn, { data: i.antallTimer }) }) })
        ] }, `${a}`))
      ] }, r);
    })
  ] });
}, rtA = (e, A) => ai(e.periode, A.periode), ntA = (e) => {
  const { locale: A } = Pt(), t = e.permisjoner.sort(rtA);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Me, { wrap: !1, children: [
      /* @__PURE__ */ x.jsx(Me, { style: KA.tableTitle, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h2, children: "Permisjon/Permittering" }) }),
      /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].type }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].periode }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].prosent }) })
      ] })
    ] }),
    t.map((r, n) => /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, wrap: !1, children: [
      /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: r.type }) }),
      /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(a0, { data: r.periode }) }) }),
      /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: r.prosent }) })
    ] }, `${n}`))
  ] });
}, itA = (e) => {
  const { locale: A } = Pt();
  e.utenlandsopphold.sort((n, i) => ai(n.periode, i.periode));
  const t = {};
  e.utenlandsopphold.forEach((n) => {
    const i = Wi(n.periode.periodeFra).year();
    t[i] ? t[i].opphold.push(n) : t[i] = {
      opphold: [n]
    };
  });
  const r = Object.keys(t).reduce((n, i) => n + i.length, 0) > 14;
  return /* @__PURE__ */ x.jsxs(Me, { wrap: r, children: [
    /* @__PURE__ */ x.jsxs(Me, { children: [
      /* @__PURE__ */ x.jsx(Me, { style: KA.tableTitle, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h2, children: "Arbeid i utlandet" }) }),
      /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].rapporteringsperiode }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].opptjeningsperiode }) }),
        /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: re[A].land }) })
      ] })
    ] }),
    Object.keys(t).reverse().map((n) => {
      const i = t[n];
      return /* @__PURE__ */ x.jsxs(Me, { style: KA.flexSection, wrap: r, children: [
        /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, children: [
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: n }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn })
        ] }),
        i.opphold.map((a, o) => /* @__PURE__ */ x.jsxs(Me, { style: KA.flexRow, wrap: !0, children: [
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(e0, { data: a.periode.periodeFra, dateFormat: "MMMM" }) }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(a0, { data: a.periode }) }) }),
          /* @__PURE__ */ x.jsx(Me, { style: KA.flexColumn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(tn, { data: a.land }) }) })
        ] }, `${o}`))
      ] }, n);
    })
  ] });
}, Ot = (e) => e.data ? /* @__PURE__ */ x.jsxs(Me, { style: [KA.twoColumns, KA.section], children: [
  /* @__PURE__ */ x.jsx(Ue, { style: KA.h3, children: e.title }),
  /* @__PURE__ */ x.jsxs(Ue, { style: KA.normaltekst, children: [
    e.date && /* @__PURE__ */ x.jsx(e0, { data: e.data, format: e.format }),
    e.period && /* @__PURE__ */ x.jsx(a0, { data: e.data, format: e.format }),
    !e.date && !e.period && /* @__PURE__ */ x.jsx(tn, { data: e.data, format: e.format })
  ] }),
  e.children
] }) : null, atA = ({ arbeidsavtaler: e }) => {
  const { locale: A } = Pt(), t = e.sort((r, n) => ai(r.gyldighetsperiode, n.gyldighetsperiode)).sort((r, n) => sC(r.gyldighetsperiode, n.gyldighetsperiode));
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: t.map((r, n) => /* @__PURE__ */ x.jsxs(Me, { wrap: !1, children: [
    !n && /* @__PURE__ */ x.jsx(Me, { style: { ...KA.tableTitle, padding: 10 }, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h2, children: "Historikk" }) }),
    /* @__PURE__ */ x.jsxs(Me, { style: {
      ...KA.flexGrid,
      ...!n && {
        borderTop: "1px solid black"
      },
      borderBottom: "1px solid black"
    }, children: [
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].periode, period: !0, data: r.gyldighetsperiode }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].yrke, data: r.yrke }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].arbeidstidsordning, data: r.arbeidstidsordning }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].ansettelsesform, data: r.ansettelsesform }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].sistelonnsendring, data: r.sisteLoennsendring, date: !0 }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].stillingsprosent, data: r.stillingsprosent, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(e0, { data: r.sisteStillingsendring, format: `(${re[A].endretstillingsprosent} %s)` }) }) }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].timerperuke, data: r.antallTimerPrUke }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].skipsregister, data: r.skipsregister }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].skipstype, data: r.skipstype }),
      /* @__PURE__ */ x.jsx(Ot, { title: re[A].fartsomraade, data: r.fartsomraade })
    ] })
  ] }, n)) });
}, otA = ({ printTimerTimelonnet: e, printPermisjon: A, printUtenlandsopphold: t, printHistorikk: r, printName: n, printSSO: i, arbeidsavtaler: a, permisjonPermittering: o, antallTimerForTimelonnet: s, utenlandsopphold: l }) => /* @__PURE__ */ x.jsxs(os, { size: "A4", style: KA.page, children: [
  /* @__PURE__ */ x.jsx(XE, { printName: n, printSSO: i }),
  e && /* @__PURE__ */ x.jsx(x.Fragment, { children: s && s.length > 0 && /* @__PURE__ */ x.jsx(Me, { style: KA.section, children: /* @__PURE__ */ x.jsx(ttA, { timer: s }) }) }),
  A && /* @__PURE__ */ x.jsx(x.Fragment, { children: o && o.length > 0 && /* @__PURE__ */ x.jsx(Me, { style: KA.section, children: /* @__PURE__ */ x.jsx(ntA, { permisjoner: o }) }) }),
  t && /* @__PURE__ */ x.jsx(x.Fragment, { children: l && l.length > 0 && /* @__PURE__ */ x.jsx(Me, { style: KA.section, children: /* @__PURE__ */ x.jsx(itA, { utenlandsopphold: l }) }) }),
  r && /* @__PURE__ */ x.jsx(x.Fragment, { children: a && a.length > 0 && /* @__PURE__ */ x.jsx(atA, { arbeidsavtaler: a }) }),
  /* @__PURE__ */ x.jsx(qE, {})
] }), stA = ({ arbeidsforhold: e, printName: A, printSSO: t }) => {
  var n, i;
  const { locale: r } = Pt();
  return /* @__PURE__ */ x.jsxs(os, { size: "A4", style: KA.page, children: [
    /* @__PURE__ */ x.jsx(XE, { printName: A, printSSO: t }),
    /* @__PURE__ */ x.jsxs(Me, { children: [
      /* @__PURE__ */ x.jsxs(Me, { style: KA.introRow, children: [
        /* @__PURE__ */ x.jsx(Me, { style: [KA.section, KA.twoColumns], children: e.arbeidsgiver.type === "Organisasjon" ? /* @__PURE__ */ x.jsxs(Me, { style: KA.h2Container, children: [
          /* @__PURE__ */ x.jsx(Me, { children: /* @__PURE__ */ x.jsx(Ue, { style: KA.h2, children: e.arbeidsgiver.orgnavn }) }),
          /* @__PURE__ */ x.jsx(Me, { children: /* @__PURE__ */ x.jsxs(Ue, { style: KA.normaltekst, children: [
            "Organisasjonsnummer ",
            e.arbeidsgiver.orgnr
          ] }) })
        ] }) : /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: e.arbeidsgiver.fnr }) }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].ansettelsesperiode, data: (n = e.ansettelsesperiode) == null ? void 0 : n.periode, period: !0, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(tn, { data: (i = e.ansettelsesperiode) == null ? void 0 : i.sluttaarsak, format: `(${re[r].sluttaarsak}: %s)` }) }) })
      ] }),
      /* @__PURE__ */ x.jsxs(Me, { style: { ...KA.flexGrid }, children: [
        e.opplysningspliktigarbeidsgiver.type === "Organisasjon" && /* @__PURE__ */ x.jsx(Ot, { title: re[r].hovedenhet, data: e.opplysningspliktigarbeidsgiver.orgnavn, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(tn, { data: $E(e.opplysningspliktigarbeidsgiver.orgnr), format: `${re[r].organisasjonsnummer} %s` }) }) }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].yrke, data: e.yrke }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].typearbeidsforhold, data: e.type }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].arbeidsforholdid, data: e.eksternArbeidsforholdId }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].arbeidstidsordning, data: e.arbeidstidsordning }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].ansettelsesform, data: e.ansettelsesform }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].sistelonnsendring, data: e.sisteLoennsendring, date: !0 }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].stillingsprosent, data: e.stillingsprosent, children: /* @__PURE__ */ x.jsx(Ue, { style: KA.normaltekst, children: /* @__PURE__ */ x.jsx(e0, { data: e.sisteStillingsendring, format: `(${re[r].endretstillingsprosent} %s)` }) }) }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].timerperuke, data: e.antallTimerPrUke }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].skipsregister, data: e.skipsregister }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].skipstype, data: e.skipstype }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].fartsomraade, data: e.fartsomraade }),
        /* @__PURE__ */ x.jsx(Ot, { title: re[r].sistbekreftet, data: e.sistBekreftet, date: !0 })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx(qE, {})
  ] });
}, ltA = ({ arbeidsforhold: e, printGenerellOversikt: A, printTimerTimelonnet: t, printPermisjon: r, printUtenlandsopphold: n, printHistorikk: i, printName: a, printSSO: o }) => {
  const { arbeidsavtaler: s, permisjonPermittering: l, antallTimerForTimelonnet: u, utenlandsopphold: g } = e;
  return WE.register(gb), /* @__PURE__ */ x.jsxs(xg, { children: [
    A && /* @__PURE__ */ x.jsx(stA, { arbeidsforhold: e, printName: a, printSSO: o }),
    /* @__PURE__ */ x.jsx(otA, { printTimerTimelonnet: t, printPermisjon: r, printUtenlandsopphold: n, printHistorikk: i, printName: a, printSSO: o, arbeidsavtaler: s, permisjonPermittering: l, antallTimerForTimelonnet: u, utenlandsopphold: g })
  ] });
}, kD = (e) => {
  const { IsPdfProvider: A } = lC(), { locale: t, LocaleProvider: r } = Pt();
  return /* @__PURE__ */ x.jsx(KE, { document: /* @__PURE__ */ x.jsx(A, { value: !0, children: /* @__PURE__ */ x.jsx(r, { value: t, children: /* @__PURE__ */ x.jsx(ltA, { arbeidsforhold: e.arbeidsforhold, printGenerellOversikt: e.printGenerellOversikt, printTimerTimelonnet: e.printTimerTimelonnet, printPermisjon: e.printPermisjon, printUtenlandsopphold: e.printUtenlandsopphold, printHistorikk: e.printHistorikk, printName: e.printName, printSSO: e.printSSO }) }) }), fileName: "arbeidsforhold.pdf", className: "lenke af-detaljert__print-button", children: ({ loading: n }) => n ? /* @__PURE__ */ x.jsx(iC, { size: "xsmall" }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(qh, { "aria-hidden": "true" }),
    /* @__PURE__ */ x.jsx("span", { children: re[t].skrivut })
  ] }) }, Math.random());
}, utA = (e) => {
  const { arbeidsforhold: A } = e, { arbeidsavtaler: t, permisjonPermittering: r } = A, { antallTimerForTimelonnet: n, utenlandsopphold: i } = A, { locale: a } = Pt(), [o, s] = Jt(!1), [l, u] = Jt(!0), [g, d] = Jt(n && n.length > 0), [h, C] = Jt(r && r.length > 0), [E, I] = Jt(i && i.length > 0), [b, y] = Jt(t && t.length > 0);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__print-button-oversikt", children: /* @__PURE__ */ x.jsx(Zn, {
      // Show modal with checkboxes if user has relevant data
      children: n && n.length > 0 || r && r.length > 0 || i && i.length > 0 || t && t.length > 0 ? /* @__PURE__ */ x.jsxs("button", { className: "lenke af-detaljert__print-button", onClick: () => s(!0), children: [
        /* @__PURE__ */ x.jsx(qh, { "aria-hidden": "true" }),
        /* @__PURE__ */ x.jsx("span", { children: re[a].skrivut })
      ] }) : /* @__PURE__ */ x.jsx(kD, { arbeidsforhold: A, printGenerellOversikt: l, printTimerTimelonnet: g, printPermisjon: h, printUtenlandsopphold: E, printHistorikk: b, printName: e.printName, printSSO: e.printSSN })
    }) }),
    /* @__PURE__ */ x.jsxs(No, { open: o, onClose: () => s(!1), "aria-label": re[a].utskriftsvalg, children: [
      /* @__PURE__ */ x.jsx(No.Header, { closeButton: !0, children: /* @__PURE__ */ x.jsx(Lr, { level: "2", size: "small", className: "af-detaljert__header", children: re[a].utskriftsvalg }) }),
      /* @__PURE__ */ x.jsxs(No.Body, { children: [
        /* @__PURE__ */ x.jsx(Ss, { className: "af-detaljert__checkbox", checked: l, onChange: () => u(!l), children: re[a].generelleopplysninger }),
        /* @__PURE__ */ x.jsx(Lr, { level: "2", size: "small", className: "af-detaljert__header", children: re[a].tilleggsopplysninger }),
        n && n.length > 0 && /* @__PURE__ */ x.jsx(Ss, { className: "af-detaljert__checkbox", checked: g, onChange: () => d(!g), children: re[a].tabs.timerfortimelonnet }),
        r && r.length > 0 && /* @__PURE__ */ x.jsx(Ss, { className: "af-detaljert__checkbox", checked: h, onChange: () => C(!h), children: re[a].tabs.permisjonpermittering }),
        i && i.length > 0 && /* @__PURE__ */ x.jsx(Ss, { className: "af-detaljert__checkbox", checked: E, onChange: () => I(!E), children: re[a].tabs.arbeidiutlandet }),
        t && t.length > 0 && /* @__PURE__ */ x.jsx(Ss, { className: "af-detaljert__checkbox", checked: b, onChange: () => y(!b), children: re[a].tabs.historikk }),
        /* @__PURE__ */ x.jsx("div", { className: "af-detaljert__print-button-modal", children: /* @__PURE__ */ x.jsx(kD, { arbeidsforhold: A, printGenerellOversikt: l, printTimerTimelonnet: g, printPermisjon: h, printUtenlandsopphold: E, printHistorikk: b, printName: e.printName, printSSO: e.printSSN }) })
      ] })
    ] })
  ] });
}, ctA = (e) => {
  const { arbeidsforhold: A } = e, { locale: t } = Pt();
  return /* @__PURE__ */ x.jsxs("div", { className: "af-detaljert__container", children: [
    /* @__PURE__ */ x.jsx(etA, { arbeidsforhold: A }),
    /* @__PURE__ */ x.jsx("hr", {}),
    /* @__PURE__ */ x.jsx(Bb, { data: A, isUtvidet: !0 }),
    /* @__PURE__ */ x.jsx(AtA, { arbeidsforhold: A }),
    /* @__PURE__ */ x.jsxs(s4, { variant: "info", children: [
      re[t].hvisfeil1,
      /* @__PURE__ */ x.jsx("br", {}),
      re[t].hvisfeil2
    ] }),
    e.printActivated && /* @__PURE__ */ x.jsx(utA, { arbeidsforhold: A, printName: e.printName, printSSN: e.printSSN })
  ] });
}, DtA = (e) => {
  const [A, t] = Jt({ status: "READY" }), { LocaleProvider: r } = Pt();
  switch (Wt(() => {
    kr.settEnv(e.miljo);
  }, []), Wt(() => {
    e.navArbeidsforholdId && (t({ status: "LOADING" }), QR(e.navArbeidsforholdId, e.customApiUrl).then((n) => t({
      status: "RESULT",
      arbeidsforhold: n
    })).catch((n) => t({
      status: "ERROR",
      error: n
    })));
  }, [e.navArbeidsforholdId]), A.status) {
    case "READY":
      return null;
    case "LOADING":
      return /* @__PURE__ */ x.jsx(D4, {});
    case "RESULT":
      return /* @__PURE__ */ x.jsx(r, { value: e.locale, children: /* @__PURE__ */ x.jsx(ctA, { arbeidsforhold: A.arbeidsforhold, ...e }) });
    case "ERROR":
      return /* @__PURE__ */ x.jsx(r, { value: e.locale, children: /* @__PURE__ */ x.jsx(w4, { error: A.error }) });
  }
}, mtA = () => {
  kr.settEnv("LOCAL"), y3();
};
export {
  DtA as DetaljertArbeidsforhold,
  ItA as ListeMedArbeidsforhold,
  mtA as initLocalMock
};
